export const data = [
        {
            "PostOfficeName": "Connaught Place",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "New Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Constitution House",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Eastern Court",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Election Commission",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Janpath",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Krishi Bhawan",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lady Harding Medical College",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Laxminarain Mandir",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "New Delhi G P O",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "North Avenue",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Parliament House",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "New Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Parliament Street",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "New Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Patiala House",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Pragati Maidan",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rail Bhawan",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sansadiya Soudha",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sectt North",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shastri Bhawan",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Supreme Court",
            "Pincode": "110001",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "A G C R",
            "Pincode": "110002",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ajmeri Gate Extension",
            "Pincode": "110002",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ansari Road",
            "Pincode": "110002",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Darya Ganj",
            "Pincode": "110002",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Gandhi Samarak",
            "Pincode": "110002",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Indian Agriculture",
            "Pincode": "110002",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Indraprastha",
            "Pincode": "110002",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Indraprastha Estate",
            "Pincode": "110002",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Minto Road",
            "Pincode": "110002",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rajghat Power House",
            "Pincode": "110002",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Aliganj",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Delhi High Court",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Golf Links",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jawahar Lal Nehru Stadium",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lodi Colony Market",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lodi House Hostel",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lodi Road",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lok Nagar Bhawan",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Oberei Intercontinental",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Pandara Road",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Pragati Vihar",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Safdarjang Air Port",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Wazir Nagar",
            "Pincode": "110003",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rashtrapati Bhawan",
            "Pincode": "110004",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Anand Nagar",
            "Pincode": "110005",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Anand Parbat",
            "Pincode": "110005",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bank Street",
            "Pincode": "110005",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Desh Bandhu Gupta Road",
            "Pincode": "110005",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Karol Bagh",
            "Pincode": "110005",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lower Camp Anand Parbat",
            "Pincode": "110005",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Model Basti",
            "Pincode": "110005",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sat Nahar",
            "Pincode": "110005",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Than Singh Nagar",
            "Pincode": "110005",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bara Tooti",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Chandni Chowk",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Chawri Bazar",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Dareeba",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Delhi Cloth Mills",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Delhi G P O",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Delhi Sadar Bazar",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Farashkhana",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Fatehpuri",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Hamdard Dawakhana",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Hauz Qazi",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Idgah Road I S B T",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jama Masjid",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mori Gate",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Red Fort",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sadar Thana Road",
            "Pincode": "110006",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Birla Lines",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "C C Institute",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Delhi University",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kamla Nagar",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lancer Road Market",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lok Nayak Bhawan",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Malka Ganj",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Malka Ganj Market",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Partap Nagar",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Patrachar Road",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Patrachar Vidyala",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Pragati Vihar",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rana Pratap Bagh",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rly C A O",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Roop Nagar",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Roshan Area Road",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Safdarjang Air Port",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sewa Sangh",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shakti Nagar",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Subzi Mandi",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Timarpur",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Wazir Nagar",
            "Pincode": "110007",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Dada Ghosh Bhawan",
            "Pincode": "110008",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Patel Nagar",
            "Pincode": "110008",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Patel Nagar East",
            "Pincode": "110008",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Patel Nagar South",
            "Pincode": "110008",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Patel Nagar West",
            "Pincode": "110008",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "A F Palam",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "A P S Colony",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Army Base",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bazar Road",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Central Ordinance",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Central Vehicle",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Delhi Cantt",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Depot",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Dhaula Khuan",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kirby Place",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Work Shop",
            "Pincode": "110010",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Defence Head Qrs",
            "Pincode": "110011",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Gymkhana Club",
            "Pincode": "110011",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nirman Bhawan",
            "Pincode": "110011",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sectt South",
            "Pincode": "110011",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shahjahan Road",
            "Pincode": "110011",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "South Avenue",
            "Pincode": "110011",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "U P S C",
            "Pincode": "110011",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Udyog Bhawan",
            "Pincode": "110011",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Central Tractor",
            "Pincode": "110012",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Inderpuri",
            "Pincode": "110012",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "N P Laboratories",
            "Pincode": "110012",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Organisation",
            "Pincode": "110012",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Research Institute",
            "Pincode": "110012",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Dargah Shareef",
            "Pincode": "110013",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Hazrat Nizamuddin",
            "Pincode": "110013",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Hari Nagar Ashram",
            "Pincode": "110014",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jangpura",
            "Pincode": "110014",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Central Kirti Nagar",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "D I Area",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "E S I Hospital",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Karampura",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kirti Nagar",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mansarover Garden",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Moti Nagar",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "North Industrial Area",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ramesh Nagar",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sudershan Park",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Vishnu Garden",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Zakhira",
            "Pincode": "110015",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ashram",
            "Pincode": "110016",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Green Park",
            "Pincode": "110016",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Green Park Market",
            "Pincode": "110016",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Hauz Khas",
            "Pincode": "110016",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Hauz Khas Market",
            "Pincode": "110016",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "I I T Hauz Khas",
            "Pincode": "110016",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "N I E Compus",
            "Pincode": "110016",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shri Aurobindo",
            "Pincode": "110016",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Yusaf Sarai",
            "Pincode": "110016",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Malviya Nagar",
            "Pincode": "110017",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Panchseel Enclave",
            "Pincode": "110017",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Pushpa Vihar Sector I",
            "Pincode": "110017",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "South Malviya Nagar",
            "Pincode": "110017",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Chand Nagar",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Fateh Nagar",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Khyalla Phase I",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Khyalla Phase II",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mahabir Nagar",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Major Bhupinder Singh Nag",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Tihar",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Tilak Nagar",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Tilak Nagar East",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Vikaspuri",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Vishnu Garden",
            "Pincode": "110018",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Govindpuri",
            "Pincode": "110019",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kalkaji",
            "Pincode": "110019",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nehru Place",
            "Pincode": "110019",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "C R R I",
            "Pincode": "110020",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Flatted Factories Complex",
            "Pincode": "110020",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Okhla Industrial Estate",
            "Pincode": "110020",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Anand Niketan",
            "Pincode": "110021",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ashoka Hotel",
            "Pincode": "110021",
            "City": "New Delhi",
            "District": "New Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Chankyapuri",
            "Pincode": "110021",
            "City": "New Delhi",
            "District": "New Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Malcha Marg",
            "Pincode": "110021",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Moti Bagh",
            "Pincode": "110021",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nanakpura",
            "Pincode": "110021",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Postal Saving Bureau",
            "Pincode": "110022",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram Sector I",
            "Pincode": "110022",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram Sector Ii",
            "Pincode": "110022",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram Sector Iii",
            "Pincode": "110022",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram Sector Iv",
            "Pincode": "110022",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram Sector Ix",
            "Pincode": "110022",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram Sector Vii",
            "Pincode": "110022",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram Sector Viii",
            "Pincode": "110022",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram Sector Xii",
            "Pincode": "110022",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram V",
            "Pincode": "110022",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kidwai Nagar",
            "Pincode": "110023",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kidwai Nagar West",
            "Pincode": "110023",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Laxmi Bai Nagar",
            "Pincode": "110023",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Netaji Nagar",
            "Pincode": "110023",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sarojini Nagar",
            "Pincode": "110023",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Amar Colony",
            "Pincode": "110024",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Defence Colony",
            "Pincode": "110024",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Krishna Market",
            "Pincode": "110024",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lajpat Nagar",
            "Pincode": "110024",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jamia Nagar",
            "Pincode": "110025",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Zakhir Nagar",
            "Pincode": "110025",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Punjabi Bagh",
            "Pincode": "110026",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Punjabi Bagh Sector Iii",
            "Pincode": "110026",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "J 6Block Rajouri Garden",
            "Pincode": "110027",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "J J Colony",
            "Pincode": "110027",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Janta Market",
            "Pincode": "110027",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Najafgarh Road",
            "Pincode": "110027",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rajouri Garden",
            "Pincode": "110027",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rajouri Market",
            "Pincode": "110027",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Subhash Nagar",
            "Pincode": "110027",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Subhash Nagar West",
            "Pincode": "110027",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Tatarpur",
            "Pincode": "110027",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Naraina",
            "Pincode": "110028",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Naraina Industrial Estate",
            "Pincode": "110028",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Naraina Vihar",
            "Pincode": "110028",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Himayunpur Extn",
            "Pincode": "110029",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nauroji Nagar",
            "Pincode": "110029",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Safdarjang Enclave",
            "Pincode": "110029",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "MehrauIi",
            "Pincode": "110030",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "T B Hospital",
            "Pincode": "110030",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "110031",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Gandhi Nagar Bazar",
            "Pincode": "110031",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Geeta Colony",
            "Pincode": "110031",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kailash Nagar",
            "Pincode": "110031",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Raghubarpura",
            "Pincode": "110031",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sahstri Nagar",
            "Pincode": "110031",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Balbir Nagar",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bhola Nath Nagar",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Dilshad Garden",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kabool Nagar",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Loni Road",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mansarover Park",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "New Seemapuri",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "North East",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rohtash Nagar",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Seemapuri Old",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "North East",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shahdara",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "North East",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shahdara Mandi",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "North East",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Teliwara",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Vishwa Karma Nagar",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Vishwan Nagar",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Vivek Vihar",
            "Pincode": "110032",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "A T Mills",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Adarsh Nagar",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bhaiparma Nand Nagar",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "G T S Nagar",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Gujranwala Nagar Part Ii",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Harijan Sewak Sangh",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jahangirpuri Block A",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jahangirpuri Block D",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jahangirpuri Block H",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jaroda Majra",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Model Town A Block",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Model Town Ii",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mukerjee Nagar",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "New Sabzi Mandi",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nirankari Colony",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shalimar Bagh",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Suraj Nagar",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Vijay Nagar",
            "Pincode": "110033",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Anandvas Shakurpur",
            "Pincode": "110034",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Multani Mohalla",
            "Pincode": "110034",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Pitampura",
            "Pincode": "110034",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rani Bagh",
            "Pincode": "110034",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Saraswati Vihar",
            "Pincode": "110034",
            "City": "New Delhi",
            "District": "North West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shakurbasti R S",
            "Pincode": "110034",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shakurpur Block I",
            "Pincode": "110034",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Srinagar Colony",
            "Pincode": "110034",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ganeshpuri",
            "Pincode": "110035",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Inderlok",
            "Pincode": "110035",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lawrence Road",
            "Pincode": "110035",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lekhu Nagar",
            "Pincode": "110035",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Onkar Nagar",
            "Pincode": "110035",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Power House",
            "Pincode": "110035",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sarai Rohila",
            "Pincode": "110035",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Alipur",
            "Pincode": "110036",
            "City": "New Delhi",
            "District": "North West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nangli Poona",
            "Pincode": "110036",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Gurgaon Road",
            "Pincode": "110037",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "A F Rajokari",
            "Pincode": "110038",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bawana",
            "Pincode": "110039",
            "City": "New Delhi",
            "District": "North West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Narela",
            "Pincode": "110040",
            "City": "New Delhi",
            "District": "North West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Narela Town",
            "Pincode": "110040",
            "City": "New Delhi",
            "District": "North West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sanoth",
            "Pincode": "110040",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Budh Nagar",
            "Pincode": "110041",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jawalpuri",
            "Pincode": "110041",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nagloi",
            "Pincode": "110041",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nangloi Phase Iii",
            "Pincode": "110041",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sultanpuri Block C",
            "Pincode": "110041",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sultanpuri Block F",
            "Pincode": "110041",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Suttanpuri Block B",
            "Pincode": "110041",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Badli",
            "Pincode": "110042",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Haiderpur",
            "Pincode": "110042",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sameypur Badli",
            "Pincode": "110042",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Najafgarh",
            "Pincode": "110043",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Badarpur",
            "Pincode": "110044",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Badarpur T P Station",
            "Pincode": "110044",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Tughlakabad",
            "Pincode": "110044",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Tughlakabad A F Station",
            "Pincode": "110044",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ambrohi",
            "Pincode": "110045",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bakrola",
            "Pincode": "110045",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Palam",
            "Pincode": "110045",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Palam Enclave",
            "Pincode": "110045",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nangal Rava",
            "Pincode": "110046",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Arjan Garh",
            "Pincode": "110047",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Greater Kailash",
            "Pincode": "110048",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Greater Kailash Ii",
            "Pincode": "110048",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kailash",
            "Pincode": "110048",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kailash Colony",
            "Pincode": "110048",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Masjidmoth Phase Ii",
            "Pincode": "110048",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "N Block Greater",
            "Pincode": "110048",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Andrews Ganj",
            "Pincode": "110049",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Asian Games Village",
            "Pincode": "110049",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Guatam Nagar",
            "Pincode": "110049",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Gulmohar Park",
            "Pincode": "110049",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Masjid Moth Extn",
            "Pincode": "110049",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sadiq Nagar",
            "Pincode": "110049",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "South Extn Part I",
            "Pincode": "110049",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "South Extn Part Ii",
            "Pincode": "110049",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Anarkali",
            "Pincode": "110051",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Azad Nagar",
            "Pincode": "110051",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Gobindpura",
            "Pincode": "110051",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Krishan Nagar",
            "Pincode": "110051",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Krishan Nagar Bazar",
            "Pincode": "110051",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Lajpat Rai Chowk",
            "Pincode": "110051",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Radheypuri",
            "Pincode": "110051",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ram Nagar",
            "Pincode": "110051",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ashok Vihar",
            "Pincode": "110052",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bharat Nagar",
            "Pincode": "110052",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nimri",
            "Pincode": "110052",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Satyawati Nagar",
            "Pincode": "110052",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shastri Nagar",
            "Pincode": "110052",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Wazirpur Phase Iii",
            "Pincode": "110052",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bhajanpuri",
            "Pincode": "110053",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Brahampuri",
            "Pincode": "110053",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jagjit Nagar",
            "Pincode": "110053",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Maujpur",
            "Pincode": "110053",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Seelampur",
            "Pincode": "110053",
            "City": "New Delhi",
            "District": "North East",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Yamuna Vihar",
            "Pincode": "110053",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Zafrabad",
            "Pincode": "110053",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "C R P F Camp",
            "Pincode": "110054",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Civil Lines",
            "Pincode": "110054",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Distt Courts",
            "Pincode": "110054",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Maidens Hotel",
            "Pincode": "110054",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Amrit Kaur Market",
            "Pincode": "110055",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Multani Dhanda",
            "Pincode": "110055",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "P S B Paharganj",
            "Pincode": "110055",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Paharganj",
            "Pincode": "110055",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Swami Ram Tirath Nagar",
            "Pincode": "110055",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shakurbasti",
            "Pincode": "110056",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Munirka",
            "Pincode": "110057",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Vasant Vihar I",
            "Pincode": "110057",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Vasant Vihar Ii",
            "Pincode": "110057",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Janakpuri",
            "Pincode": "110058",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Janakpuri Block C 4",
            "Pincode": "110058",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Janakpuri Block D 1",
            "Pincode": "110058",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Janakpuri Blockc 2",
            "Pincode": "110058",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Possangipur",
            "Pincode": "110058",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jeewan Park",
            "Pincode": "110059",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Uttam Nagar",
            "Pincode": "110059",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "New Rajinder Nagar",
            "Pincode": "110060",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rajinder Nagar",
            "Pincode": "110060",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ravinder Rangsala",
            "Pincode": "110060",
            "City": "New Delhi",
            "District": "Central Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bijwasan",
            "Pincode": "110061",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ambedkar Nagar",
            "Pincode": "110062",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "B S F Camp Tigri",
            "Pincode": "110062",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Dakshimpuri Phase I",
            "Pincode": "110062",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Dakshinpuri Phase Iii",
            "Pincode": "110062",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Hamdard Nagar",
            "Pincode": "110062",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Khanpur",
            "Pincode": "110062",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Madangir",
            "Pincode": "110062",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Pushpa Bhawan",
            "Pincode": "110062",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Madipur",
            "Pincode": "110063",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Paschim Vihar",
            "Pincode": "110063",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Paschim Vihar Block B",
            "Pincode": "110063",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Qr Madipur",
            "Pincode": "110063",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Hari Nagar Be Block",
            "Pincode": "110064",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Hari Nagar Da & Db Block",
            "Pincode": "110064",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mayapuri",
            "Pincode": "110064",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mayapuri Shopping Centre",
            "Pincode": "110064",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "East Of Kailash",
            "Pincode": "110065",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nehru Nagar",
            "Pincode": "110065",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Sriniwaspuri",
            "Pincode": "110065",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram",
            "Pincode": "110066",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "R K Puram West",
            "Pincode": "110066",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "D D A Munirka",
            "Pincode": "110067",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jawahar Lal Nehru Univers",
            "Pincode": "110067",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Chhawla",
            "Pincode": "110071",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "D D A Salam",
            "Pincode": "110072",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Jharoda Kalan",
            "Pincode": "110072",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "P T S Jharoda Kalan",
            "Pincode": "110072",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Ujwa",
            "Pincode": "110073",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Dwarka",
            "Pincode": "110075",
            "City": "New Delhi",
            "District": "West Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kanjhawala",
            "Pincode": "110081",
            "City": "New Delhi",
            "District": "North West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Khera Kalan",
            "Pincode": "110082",
            "City": "New Delhi",
            "District": "South West",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mangolpuri",
            "Pincode": "110083",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mangolpuri Block 1",
            "Pincode": "110083",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mangolpuri Block A",
            "Pincode": "110083",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Mangolpuri Block S",
            "Pincode": "110083",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kutubgarh",
            "Pincode": "110084",
            "City": "New Delhi",
            "District": "South Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Rohini",
            "Pincode": "110085",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Himmatpuri",
            "Pincode": "110091",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kalyanpuri",
            "Pincode": "110091",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Khichripur",
            "Pincode": "110091",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Trilokpuri",
            "Pincode": "110091",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Kalyan Vas",
            "Pincode": "110092",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Laxmi Nagar Market",
            "Pincode": "110092",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Patper Ganj",
            "Pincode": "110092",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Shakarpur",
            "Pincode": "110092",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nand Nagri",
            "Pincode": "110093",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nand Nagri A Block",
            "Pincode": "110093",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Nathu Colony",
            "Pincode": "110093",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Chilla Villege",
            "Pincode": "110094",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Gokulpuri",
            "Pincode": "110094",
            "City": "New Delhi",
            "District": "East Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Karawal Nagar",
            "Pincode": "110094",
            "City": "New Delhi",
            "District": "North East",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Bhajan Pura",
            "Pincode": "110096",
            "City": "New Delhi",
            "District": "North Delhi",
            "State": "Delhi"
        },
        {
            "PostOfficeName": "Faridabad",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad City",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad Factory Area",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad G B S",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad Industrial Area",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad N I T",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad Neighbour Hood",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad Railway Road",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad Sector 15",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad Sector 16",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ferozepur Gandhi Nagar",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "G T Faridabad Mathura Road",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Neighbour Hood Iii",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Neighbour Hood Iv",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Press Colony",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sector 8 Faridabad",
            "Pincode": "121001",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad",
            "Pincode": "121002",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Amar Nagar",
            "Pincode": "121003",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Balabgarh",
            "Pincode": "121004",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ballabgarh",
            "Pincode": "121004",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chawla Colony",
            "Pincode": "121004",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad Sector 22",
            "Pincode": "121005",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad Sector 7",
            "Pincode": "121006",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "121006",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Faridabad",
            "Pincode": "121007",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Tigaon",
            "Pincode": "121101",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "121102",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "N T Palwal",
            "Pincode": "121102",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Palwal",
            "Pincode": "121102",
            "City": "Palwal",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hathin",
            "Pincode": "121103",
            "City": "Hathin",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Punuhana",
            "Pincode": "121104",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "121105",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hodel",
            "Pincode": "121106",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Housing Colony",
            "Pincode": "121106",
            "City": "Faridabad",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hassanpur",
            "Pincode": "121107",
            "City": "Hassanpur",
            "District": "Faridabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gurgaon",
            "Pincode": "122001",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gurgaon Kutchery",
            "Pincode": "122001",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "New Colony Gurgaon",
            "Pincode": "122001",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Railway Road Gurgaon",
            "Pincode": "122001",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sohna Adda Gurgaon",
            "Pincode": "122001",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Urban Estate Gurgaon",
            "Pincode": "122001",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Air Force Gurgaon",
            "Pincode": "122005",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gurgaon Palampur Road",
            "Pincode": "122015",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dundahera",
            "Pincode": "122016",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Manesar",
            "Pincode": "122050",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Badshahpur",
            "Pincode": "122101",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhudsi",
            "Pincode": "122102",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sohna",
            "Pincode": "122103",
            "City": "Sohna",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ferozepur Jhirka",
            "Pincode": "122104",
            "City": "Ferozepur Jhirka",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Taura",
            "Pincode": "122105",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dharuhera",
            "Pincode": "122106",
            "City": "Dharuhera",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nuh",
            "Pincode": "122107",
            "City": "Nuh",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nagina",
            "Pincode": "122108",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Daulatabad",
            "Pincode": "122109",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Palmar",
            "Pincode": "122211",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Narnaul",
            "Pincode": "123001",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Narnaul City",
            "Pincode": "123001",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Narnaul Kutchery",
            "Pincode": "123001",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sanwar",
            "Pincode": "123020",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mandi Ateli",
            "Pincode": "123021",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chirya",
            "Pincode": "123022",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nangal Chaudhary",
            "Pincode": "123023",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Satnali",
            "Pincode": "123024",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Baund",
            "Pincode": "123025",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Birhi Kalan",
            "Pincode": "123026",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Birla Colony",
            "Pincode": "123026",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kanina",
            "Pincode": "123027",
            "City": "Kanina",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nangal Sirohi",
            "Pincode": "123028",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mohindergarh",
            "Pincode": "123029",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bawania",
            "Pincode": "123034",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pahlawas",
            "Pincode": "123035",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khori",
            "Pincode": "123101",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kund",
            "Pincode": "123102",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khol",
            "Pincode": "123103",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Loharu",
            "Pincode": "123201",
            "City": "Loharu",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Guriani",
            "Pincode": "123301",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kosli",
            "Pincode": "123302",
            "City": "Rewari",
            "District": "Rewari",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kuldip Nagar",
            "Pincode": "123302",
            "City": "Rewari",
            "District": "Rewari",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nahar",
            "Pincode": "123303",
            "City": "Rewari",
            "District": "Rewari",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sahalwas",
            "Pincode": "123304",
            "City": "Rewari",
            "District": "Rewari",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahu",
            "Pincode": "123305",
            "City": "Rewari",
            "District": "Rewari",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Charkhi Dadri",
            "Pincode": "123306",
            "City": "Charkhi Dadri",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Charkhi Dadri City",
            "Pincode": "123306",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Charkhi Dadri Factory",
            "Pincode": "123306",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Achina",
            "Pincode": "123307",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Badhra",
            "Pincode": "123308",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Manheru",
            "Pincode": "123309",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jhoju Kalan",
            "Pincode": "123310",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gokal Bazar Rewari",
            "Pincode": "123401",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Model Town Rewari",
            "Pincode": "123401",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rewari",
            "Pincode": "123401",
            "City": "Rewari",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dahina",
            "Pincode": "123411",
            "City": "Rewari",
            "District": "Rewari",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dharan",
            "Pincode": "123412",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Akheri Madanpur",
            "Pincode": "123413",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahore Kalan",
            "Pincode": "123413",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nanu Kalan",
            "Pincode": "123414",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bawal",
            "Pincode": "123501",
            "City": "Bawal",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khalilpur",
            "Pincode": "123502",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pataudi",
            "Pincode": "123503",
            "City": "Pataudi",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Haily Mandi",
            "Pincode": "123504",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Garhi Harsaru",
            "Pincode": "123505",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Farrukh Nagar",
            "Pincode": "123506",
            "City": "Narnaul",
            "District": "Mohindergarh",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Daulatabad",
            "Pincode": "123507",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jatauli",
            "Pincode": "123508",
            "City": "Gurgaon",
            "District": "Gurgaon",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bus Stand Rohtak",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "D L F Colony Rohtak",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Durga Bhawan Rohtk",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gandhi Camp Rohtak",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kanak Mandi Rohtak",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Medical College",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Model Town Rohtak",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rohtak",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rohtak",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rohtak Mandi",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rohtak Town",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Shivaji Colony Rohtak",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sugar Mill Rohtak",
            "Pincode": "124001",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhagwatipur",
            "Pincode": "124002",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Vaish High Schl Rohtak",
            "Pincode": "124003",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "G K Singhpur",
            "Pincode": "124004",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Titauli",
            "Pincode": "124005",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Makrauli Kalan",
            "Pincode": "124006",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Samargopalpur",
            "Pincode": "124007",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sunari Kalan",
            "Pincode": "124008",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Asthal Bohar",
            "Pincode": "124021",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Morkhra",
            "Pincode": "124022",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bohar",
            "Pincode": "124023",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Lahli",
            "Pincode": "124024",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kharawal",
            "Pincode": "124025",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kharontha",
            "Pincode": "124026",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kheri Sadh",
            "Pincode": "124027",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Basana",
            "Pincode": "124028",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Baland",
            "Pincode": "124029",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gharauthi",
            "Pincode": "124030",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Maina",
            "Pincode": "124031",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Barhana",
            "Pincode": "124101",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dujana",
            "Pincode": "124102",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Arya Nagar Jhajar",
            "Pincode": "124103",
            "City": "Jhajjar",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Arya Nagar Jhajjar",
            "Pincode": "124103",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jhajar",
            "Pincode": "124103",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jhajar HO",
            "Pincode": "124103",
            "City": "Jhajjar",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Silani Gate Jhajar",
            "Pincode": "124103",
            "City": "Jhajjar",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Silani Gate Jhajjar",
            "Pincode": "124103",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jhajjar",
            "Pincode": "124104",
            "City": "Jhajjar",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jhajjar",
            "Pincode": "124104",
            "City": "Jhajjar",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nehru College",
            "Pincode": "124104",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nehru College",
            "Pincode": "124104",
            "City": "Jhajjar",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Badli",
            "Pincode": "124105",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dighal",
            "Pincode": "124107",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Machhrauli",
            "Pincode": "124108",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhakala",
            "Pincode": "124109",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahu Akbarpur",
            "Pincode": "124110",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Madina",
            "Pincode": "124111",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Meham",
            "Pincode": "124112",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kalanaur",
            "Pincode": "124113",
            "City": "Kalanaur",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kharak Kalan",
            "Pincode": "124114",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Subana",
            "Pincode": "124116",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Birohar",
            "Pincode": "124117",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gochhi",
            "Pincode": "124118",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kultana",
            "Pincode": "124119",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahlba",
            "Pincode": "124120",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kharkhera",
            "Pincode": "124121",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Birdhana",
            "Pincode": "124122",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhani Chanderpal",
            "Pincode": "124123",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Katesra",
            "Pincode": "124124",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jhalri",
            "Pincode": "124125",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kalinga",
            "Pincode": "124126",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sisar Khas",
            "Pincode": "124127",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhani Surjan",
            "Pincode": "124128",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Saman",
            "Pincode": "124129",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sawan",
            "Pincode": "124129",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Talao",
            "Pincode": "124130",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jhazgarh",
            "Pincode": "124131",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ritauli",
            "Pincode": "124132",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "M P Majra",
            "Pincode": "124133",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kheri Kumar",
            "Pincode": "124134",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Daura Raja",
            "Pincode": "124135",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chimni",
            "Pincode": "124136",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhadani",
            "Pincode": "124137",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jahangirpur",
            "Pincode": "124138",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mehrana",
            "Pincode": "124139",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Silana",
            "Pincode": "124140",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khudan",
            "Pincode": "124141",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Beri",
            "Pincode": "124201",
            "City": "Beri",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Beri",
            "Pincode": "124201",
            "City": "Jhajjar",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dobaldhan",
            "Pincode": "124202",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Majra",
            "Pincode": "124203",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sewana",
            "Pincode": "124204",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pilana",
            "Pincode": "124205",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gohana",
            "Pincode": "124301",
            "City": "Gohana",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Butana",
            "Pincode": "124302",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sanghi",
            "Pincode": "124303",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Baroda",
            "Pincode": "124304",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khanpur",
            "Pincode": "124305",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mundlana",
            "Pincode": "124306",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mehmoodpur",
            "Pincode": "124307",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ahulana",
            "Pincode": "124308",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Madiana",
            "Pincode": "124309",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bichpari",
            "Pincode": "124310",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Barota",
            "Pincode": "124311",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khidwali",
            "Pincode": "124312",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jassia",
            "Pincode": "124314",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gangana",
            "Pincode": "124315",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Garhwal",
            "Pincode": "124316",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Glwana",
            "Pincode": "124317",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jauli",
            "Pincode": "124318",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kathura",
            "Pincode": "124320",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Lath",
            "Pincode": "124321",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Katwal",
            "Pincode": "124322",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kohla",
            "Pincode": "124323",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rabhra",
            "Pincode": "124324",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bindhana",
            "Pincode": "124325",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhalaut",
            "Pincode": "124401",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kharkauda",
            "Pincode": "124402",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rohat",
            "Pincode": "124403",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hassangarh",
            "Pincode": "124404",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kiloi",
            "Pincode": "124405",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kansala",
            "Pincode": "124406",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sisana",
            "Pincode": "124407",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Farmana",
            "Pincode": "124408",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhainswal Kalan",
            "Pincode": "124409",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bidhal Pinana",
            "Pincode": "124410",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Aval",
            "Pincode": "124411",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kahnaur",
            "Pincode": "124412",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Anaj Mandi Jind",
            "Pincode": "124413",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Anwali",
            "Pincode": "124413",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khanda",
            "Pincode": "124413",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhadlan",
            "Pincode": "124415",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Baliana",
            "Pincode": "124416",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Paksma",
            "Pincode": "124417",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dobh",
            "Pincode": "124418",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kiloi",
            "Pincode": "124419",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhanyani",
            "Pincode": "124420",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Asan",
            "Pincode": "124421",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bholi Anandpur",
            "Pincode": "124422",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hamayunpur",
            "Pincode": "124423",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhamar",
            "Pincode": "124424",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Samchana",
            "Pincode": "124425",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rurki",
            "Pincode": "124426",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chirana",
            "Pincode": "124427",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rukhi",
            "Pincode": "124428",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rithal",
            "Pincode": "124429",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Siwana Mall",
            "Pincode": "124430",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sampla",
            "Pincode": "124501",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rohad",
            "Pincode": "124502",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhaprauda",
            "Pincode": "124503",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chhara",
            "Pincode": "124504",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Assandah",
            "Pincode": "124505",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mandothi",
            "Pincode": "124506",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahadurgar",
            "Pincode": "124507",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahadurgarh",
            "Pincode": "124507",
            "City": "Bahadurgarh",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahadurgarh",
            "Pincode": "124507",
            "City": "Bahadurgarh",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahadurgarh HO",
            "Pincode": "124507",
            "City": "Jhajjar",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahadurgarh Mandi",
            "Pincode": "124507",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahadurgarh Mandi",
            "Pincode": "124507",
            "City": "Jhajjar",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahadurgrh",
            "Pincode": "124507",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "124507",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "124507",
            "City": "Jhajjar",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Main Bazar",
            "Pincode": "124507",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Main Bazar",
            "Pincode": "124507",
            "City": "Jhajjar",
            "District": "Jhajjar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Noona Majra",
            "Pincode": "124508",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Tandaheri",
            "Pincode": "124509",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Matan",
            "Pincode": "124510",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kharhar",
            "Pincode": "124511",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nidana",
            "Pincode": "124513",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Lakhan Majra",
            "Pincode": "124514",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nigana",
            "Pincode": "124515",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rohad",
            "Pincode": "124515",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gorawar",
            "Pincode": "124516",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ismaila",
            "Pincode": "124517",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Barain",
            "Pincode": "124518",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bainsi",
            "Pincode": "124519",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Farmana",
            "Pincode": "124520",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Atail",
            "Pincode": "124521",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ajaib",
            "Pincode": "124522",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chandi",
            "Pincode": "124523",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chiri",
            "Pincode": "124524",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Barahi",
            "Pincode": "124525",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhupani",
            "Pincode": "124526",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chaushala",
            "Pincode": "124527",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chuliana",
            "Pincode": "124527",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dulhera",
            "Pincode": "124528",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Escort Nagar",
            "Pincode": "124528",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gandhra",
            "Pincode": "124529",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kanaunda",
            "Pincode": "124530",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nilauthi",
            "Pincode": "124531",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rohna",
            "Pincode": "124532",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kharainti",
            "Pincode": "124533",
            "City": "Rohtak",
            "District": "Rohtak",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hissar",
            "Pincode": "125001",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hissar City",
            "Pincode": "125001",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hissar Kutchery",
            "Pincode": "125001",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hissar Nai Mandi",
            "Pincode": "125001",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mini Sectt Hissar",
            "Pincode": "125001",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Multani Chowk Hissar",
            "Pincode": "125001",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hissar Textile Mills",
            "Pincode": "125002",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Patel Nagar Hissar",
            "Pincode": "125003",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hissar Agricultural Unive",
            "Pincode": "125004",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Model Town Hissar",
            "Pincode": "125005",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hissar B S F",
            "Pincode": "125011",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Arya Nagar Hissar",
            "Pincode": "125012",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dulat",
            "Pincode": "125012",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhiwan Jain Chowk",
            "Pincode": "125021",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhiwani",
            "Pincode": "125021",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhiwani Bus Stand",
            "Pincode": "125021",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhiwani Halu Bazar",
            "Pincode": "125021",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhiwani Lohar Bazar",
            "Pincode": "125021",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhiwani",
            "Pincode": "125022",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Biron",
            "Pincode": "125023",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dinod",
            "Pincode": "125024",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Devsar",
            "Pincode": "125025",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bapora",
            "Pincode": "125026",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chang",
            "Pincode": "125027",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Behal",
            "Pincode": "125028",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kairu",
            "Pincode": "125029",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jui Khurd",
            "Pincode": "125030",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Tigrana",
            "Pincode": "125031",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bawani Khera",
            "Pincode": "125032",
            "City": "Bawani Khera",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hansi",
            "Pincode": "125033",
            "City": "Hansi",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Tehsil Court Hansi",
            "Pincode": "125033",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Road Hansi",
            "Pincode": "125034",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jamalpur",
            "Pincode": "125035",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Deorala",
            "Pincode": "125036",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nalwa",
            "Pincode": "125037",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khanda Khuri",
            "Pincode": "125038",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Narnaund",
            "Pincode": "125039",
            "City": "Narnaund",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Tosham",
            "Pincode": "125040",
            "City": "Tosham",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mundal Khurd",
            "Pincode": "125041",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bass",
            "Pincode": "125042",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rodhan",
            "Pincode": "125043",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Satrod Khurd",
            "Pincode": "125044",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Barwa",
            "Pincode": "125045",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sewani",
            "Pincode": "125046",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Agroha",
            "Pincode": "125047",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Badopal",
            "Pincode": "125048",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sisai",
            "Pincode": "125049",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Fatehabad",
            "Pincode": "125050",
            "City": "Fatehabad",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Fatehbad",
            "Pincode": "125050",
            "City": "Fatehbad",
            "District": "Fatehabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Fatehbad Kutchery",
            "Pincode": "125050",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Fatehbad Kutchery",
            "Pincode": "125050",
            "City": "Fatehbad",
            "District": "Fatehabad",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nai Mandi Fatehbad",
            "Pincode": "125050",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rattia",
            "Pincode": "125051",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mandi Adampur",
            "Pincode": "125052",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhattu Kalan",
            "Pincode": "125053",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahudin",
            "Pincode": "125054",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nai Mandi Sirsa",
            "Pincode": "125055",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sirsa",
            "Pincode": "125055",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sirsa Courts",
            "Pincode": "125055",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sirsa Town",
            "Pincode": "125055",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sirsa",
            "Pincode": "125056",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khairpur",
            "Pincode": "125057",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ding",
            "Pincode": "125058",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sikanderpur",
            "Pincode": "125060",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bamla",
            "Pincode": "125061",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhanana",
            "Pincode": "125062",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhanana",
            "Pincode": "125062",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhani",
            "Pincode": "125063",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhigwan Jatan",
            "Pincode": "125064",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Lohni",
            "Pincode": "125065",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mehnda",
            "Pincode": "125066",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rewasa",
            "Pincode": "125067",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sorkhi",
            "Pincode": "125068",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bassi",
            "Pincode": "125069",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhatla",
            "Pincode": "125070",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhana Kalan",
            "Pincode": "125071",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kumbha",
            "Pincode": "125072",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mirchpur",
            "Pincode": "125073",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Petwar",
            "Pincode": "125074",
            "City": "Bhiwani",
            "District": "Bhiwani",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sri Jiwan Nagar",
            "Pincode": "125075",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rania",
            "Pincode": "125076",
            "City": "Rania",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Odban",
            "Pincode": "125077",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Baragudah",
            "Pincode": "125078",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Haroli",
            "Pincode": "125079",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bighar",
            "Pincode": "125080",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chanot",
            "Pincode": "125081",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Puthi Mangal Khan",
            "Pincode": "125082",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Umra",
            "Pincode": "125083",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jamauri",
            "Pincode": "125084",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kharar Ailapur",
            "Pincode": "125086",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ladwa",
            "Pincode": "125087",
            "City": "Ladwa",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mohamadpur Rohi",
            "Pincode": "125088",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chautala",
            "Pincode": "125101",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ellenabad",
            "Pincode": "125102",
            "City": "Ellenabad",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Goriwala",
            "Pincode": "125103",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mandi Dabwali",
            "Pincode": "125104",
            "City": "Mandi Dabwali",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mandi Township",
            "Pincode": "125104",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mangali",
            "Pincode": "125105",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dharsul Kalan",
            "Pincode": "125106",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Abushahar",
            "Pincode": "125107",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hazarawan Kalan",
            "Pincode": "125108",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mohbatpur",
            "Pincode": "125109",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Safidon",
            "Pincode": "125112",
            "City": "Safidon",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Safindon City",
            "Pincode": "125112",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kalanwali",
            "Pincode": "125201",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rori",
            "Pincode": "125202",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Amritsar Khan",
            "Pincode": "125203",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Anaj Mandi",
            "Pincode": "125203",
            "City": "Sirsa",
            "District": "Sirsa",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jakhal Mandi",
            "Pincode": "126001",
            "City": "Jakhal Mandi",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Daulatpur",
            "Pincode": "126006",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pabra",
            "Pincode": "126007",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhuna",
            "Pincode": "126008",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Uklana Mandi",
            "Pincode": "126009",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Barwala",
            "Pincode": "126010",
            "City": "Barwala",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Barwala Mandi",
            "Pincode": "126011",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khedar",
            "Pincode": "126013",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rajli",
            "Pincode": "126014",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Prabhuwala",
            "Pincode": "126015",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nehla",
            "Pincode": "126025",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hassangarh",
            "Pincode": "126027",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Julana",
            "Pincode": "126101",
            "City": "Julana",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chaura Kuam Jind",
            "Pincode": "126102",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jind Ho",
            "Pincode": "126102",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jind Railway Station",
            "Pincode": "126102",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Punjabi Bazar Jind",
            "Pincode": "126102",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rohtak Road Jind",
            "Pincode": "126102",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bibipur",
            "Pincode": "126103",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Deorad",
            "Pincode": "126104",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Igrah",
            "Pincode": "126105",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kandela",
            "Pincode": "126106",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kilazafargarh",
            "Pincode": "126107",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Malui",
            "Pincode": "126108",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pauli",
            "Pincode": "126109",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ram Rai",
            "Pincode": "126110",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Shahpur",
            "Pincode": "126111",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pilukhera",
            "Pincode": "126113",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Shamlo Kalan",
            "Pincode": "126114",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Uchana",
            "Pincode": "126115",
            "City": "Uchana",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nangal Fertilizer",
            "Pincode": "126116",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Narwana",
            "Pincode": "126116",
            "City": "Narwana",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kalayar",
            "Pincode": "126117",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhamta Sahib",
            "Pincode": "126118",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Tohana",
            "Pincode": "126119",
            "City": "Tohana",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Tohanamandi",
            "Pincode": "126120",
            "City": "Hissar",
            "District": "Hissar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kalwa",
            "Pincode": "126121",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kanheri",
            "Pincode": "126122",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Samain",
            "Pincode": "126123",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Baroda Jind",
            "Pincode": "126124",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Balerkha",
            "Pincode": "126126",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dablain",
            "Pincode": "126127",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhakal",
            "Pincode": "126128",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Didwara",
            "Pincode": "126129",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gangooli",
            "Pincode": "126130",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Garhwali",
            "Pincode": "126131",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ghatauli",
            "Pincode": "126132",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kalayat Mandi",
            "Pincode": "126133",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kharak Pandwan",
            "Pincode": "126134",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Lawan",
            "Pincode": "126135",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khatkar",
            "Pincode": "126136",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Seemla",
            "Pincode": "126139",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ujhana",
            "Pincode": "126140",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hat",
            "Pincode": "126141",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhigana",
            "Pincode": "126143",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Balu",
            "Pincode": "126145",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhambeva",
            "Pincode": "126146",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Budha Khera",
            "Pincode": "126147",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bithmara",
            "Pincode": "126148",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Singhana",
            "Pincode": "126149",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sewaha",
            "Pincode": "126150",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Badanpur",
            "Pincode": "126151",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhanoda Kalan",
            "Pincode": "126152",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Danoda",
            "Pincode": "126153",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dharaudhi",
            "Pincode": "126154",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Atlas Cycles Sonepat",
            "Pincode": "131001",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhim Nagar Sonepat",
            "Pincode": "131001",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ganj Bazar Sonepat",
            "Pincode": "131001",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gohana Road Sonepat",
            "Pincode": "131001",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Industrial Area Sonepat",
            "Pincode": "131001",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Model Town",
            "Pincode": "131001",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ram Bazar Sonepat",
            "Pincode": "131001",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sonepat",
            "Pincode": "131001",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sonepat Kutchery",
            "Pincode": "131001",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bahalgarh",
            "Pincode": "131021",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhatgaon",
            "Pincode": "131022",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jakhauli",
            "Pincode": "131023",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Juan",
            "Pincode": "131024",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mohana",
            "Pincode": "131025",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jaswarkheri",
            "Pincode": "131026",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Murthal",
            "Pincode": "131027",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kundli",
            "Pincode": "131028",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "P S Rai",
            "Pincode": "131029",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rathdana",
            "Pincode": "131030",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rattan Garh",
            "Pincode": "131031",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pipli Khera",
            "Pincode": "131032",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhagan",
            "Pincode": "131033",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Barabansi",
            "Pincode": "131034",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Harsana Kalan",
            "Pincode": "131035",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Lehrana",
            "Pincode": "131036",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khewra",
            "Pincode": "131037",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pipli",
            "Pincode": "131038",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ganaur",
            "Pincode": "131101",
            "City": "Ganaur",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ganaur City",
            "Pincode": "131101",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Purkhas",
            "Pincode": "131102",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nahri",
            "Pincode": "131103",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Akbarpur Barota",
            "Pincode": "131104",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bega",
            "Pincode": "131105",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhidlan",
            "Pincode": "131106",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khanda",
            "Pincode": "131107",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chhetera Bhadupur",
            "Pincode": "131108",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Datauli",
            "Pincode": "131109",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ghasauli",
            "Pincode": "131110",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kheri Gujar",
            "Pincode": "131111",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kakaroi",
            "Pincode": "131112",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gopalpur",
            "Pincode": "131113",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mehlana",
            "Pincode": "131114",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chulkana",
            "Pincode": "131115",
            "City": "Sonepat",
            "District": "Sonepat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal City",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal G B S",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal Industrial Area",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal Kutchery",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal M T",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal Nai Mandi",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal Ndri",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal Partappura",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal Ramnagar",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Karnal Sadar Bazar",
            "Pincode": "132001",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sanghowa",
            "Pincode": "132002",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhand",
            "Pincode": "132020",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kaul",
            "Pincode": "132021",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kaul",
            "Pincode": "132021",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pharal",
            "Pincode": "132021",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kunjpura",
            "Pincode": "132022",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nilokhery Govt Press",
            "Pincode": "132024",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nissing",
            "Pincode": "132024",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kachhawa",
            "Pincode": "132025",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Fatehpur",
            "Pincode": "132026",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pundri",
            "Pincode": "132026",
            "City": "Pundri",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pundri",
            "Pincode": "132026",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kaithal",
            "Pincode": "132027",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kaithal",
            "Pincode": "132027",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kaithal Mandi",
            "Pincode": "132027",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Siwan",
            "Pincode": "132027",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Siwan Gate Kaithal",
            "Pincode": "132027",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Thana",
            "Pincode": "132029",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Thana",
            "Pincode": "132029",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Keorak",
            "Pincode": "132032",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Keorak",
            "Pincode": "132032",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chika",
            "Pincode": "132034",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Guhla",
            "Pincode": "132035",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gula",
            "Pincode": "132035",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jundla",
            "Pincode": "132036",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Madhuban",
            "Pincode": "132037",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Amin",
            "Pincode": "132038",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Assandh",
            "Pincode": "132039",
            "City": "Assandh",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ballah",
            "Pincode": "132040",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Indri Industrial Area",
            "Pincode": "132041",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Fatehpur",
            "Pincode": "132042",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Fatehpur",
            "Pincode": "132042",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pai",
            "Pincode": "132043",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pai",
            "Pincode": "132043",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rajaund",
            "Pincode": "132044",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mowana",
            "Pincode": "132045",
            "City": "Jind",
            "District": "Jind",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Salwan",
            "Pincode": "132046",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jakoli",
            "Pincode": "132047",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pabnawa",
            "Pincode": "132048",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Manas",
            "Pincode": "132049",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gheer",
            "Pincode": "132050",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Munak",
            "Pincode": "132051",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gonder",
            "Pincode": "132052",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kheri Sherifali",
            "Pincode": "132053",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gondhar",
            "Pincode": "132058",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Samalkha",
            "Pincode": "132101",
            "City": "Samalkha",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Patti Kalan",
            "Pincode": "132102",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat",
            "Pincode": "132103",
            "City": "Panipat",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat Bus Stand",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat City",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat K Nagar",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat Khadi Ashram",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat Krishnapur",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat Mandi",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat Model Town",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat N F L",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat N S M",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat Sugar Mill",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat Town",
            "Pincode": "132103",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat G T Road",
            "Pincode": "132104",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat Thermal",
            "Pincode": "132104",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Project Plan",
            "Pincode": "132105",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Project Panipat",
            "Pincode": "132106",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panipat",
            "Pincode": "132108",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chulkana",
            "Pincode": "132109",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sewah",
            "Pincode": "132110",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Alewa",
            "Pincode": "132111",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Gharaunda",
            "Pincode": "132111",
            "City": "Gharaunda",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhatrat",
            "Pincode": "132112",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Madlanda",
            "Pincode": "132113",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Hathwala",
            "Pincode": "132115",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Tarauri",
            "Pincode": "132116",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Tarauri Mandi",
            "Pincode": "132116",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Nilokheri",
            "Pincode": "132117",
            "City": "Nilokheri",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Engg College Kurukshetra",
            "Pincode": "132118",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kurukshetra",
            "Pincode": "132118",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Thanesar Town",
            "Pincode": "132118",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kurukshetra University",
            "Pincode": "132119",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jyotisar",
            "Pincode": "132120",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jyotisar",
            "Pincode": "132120",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Naguran",
            "Pincode": "132121",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Naguran",
            "Pincode": "132121",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ghiar",
            "Pincode": "132123",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rambha",
            "Pincode": "132123",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rambha",
            "Pincode": "132123",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Tirawari",
            "Pincode": "132123",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Vehana",
            "Pincode": "132124",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Saunkra",
            "Pincode": "132125",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pehowa",
            "Pincode": "132128",
            "City": "Pehowa",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ismailabad",
            "Pincode": "132129",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Byana",
            "Pincode": "132130",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jhansa",
            "Pincode": "132130",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pipli",
            "Pincode": "132131",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ladwa",
            "Pincode": "132132",
            "City": "Ladwa",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Radaur",
            "Pincode": "132133",
            "City": "Radaur",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Daula",
            "Pincode": "132134",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Shahbad G T R",
            "Pincode": "132135",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Shahbad Grain",
            "Pincode": "132135",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Shahbad Markhanda",
            "Pincode": "132135",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Thol",
            "Pincode": "132136",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Umri",
            "Pincode": "132137",
            "City": "Kurukshetra",
            "District": "Kurukshetra",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Habri",
            "Pincode": "132138",
            "City": "Kaithal",
            "District": "Kaithal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Habri",
            "Pincode": "132138",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bursham",
            "Pincode": "132139",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Biholi",
            "Pincode": "132140",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Buana Lakhu",
            "Pincode": "132141",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dahar",
            "Pincode": "132142",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dikadia",
            "Pincode": "132143",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jaurasi",
            "Pincode": "132144",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Naultha",
            "Pincode": "132145",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ahar",
            "Pincode": "132146",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kurar",
            "Pincode": "132147",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kohand",
            "Pincode": "132148",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mahoti",
            "Pincode": "132149",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Naraina",
            "Pincode": "132150",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Noorwala",
            "Pincode": "132151",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rampura",
            "Pincode": "132152",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sonepat Mandi",
            "Pincode": "132153",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Staundi",
            "Pincode": "132153",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Babail",
            "Pincode": "132154",
            "City": "Karnal",
            "District": "Karnal",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kurana",
            "Pincode": "132155",
            "City": "Panipat",
            "District": "Panipat",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala A K Lines",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala Alexendra Road",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala B C Bazar",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala Cantt",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala Hargolal",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala I A F Lines",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala Kacha Bazar",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala Lal Kurti Bzr",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala Mahesh",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala P&T Colony",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala Punjabi",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala Sadar Bazar",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala Topkhana",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Commissioner Court",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mohalla",
            "Pincode": "133001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala Cantt",
            "Pincode": "133004",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Babyal",
            "Pincode": "133005",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Boh",
            "Pincode": "133021",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bihta",
            "Pincode": "133101",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kesri",
            "Pincode": "133102",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mustafabad",
            "Pincode": "133102",
            "City": "Mustafabad",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Saha",
            "Pincode": "133104",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kalawar",
            "Pincode": "133105",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Barara",
            "Pincode": "133201",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dhin",
            "Pincode": "133202",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Mullana",
            "Pincode": "133203",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sadhaura",
            "Pincode": "133204",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Adhoya",
            "Pincode": "133205",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sarawan",
            "Pincode": "133206",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ugala",
            "Pincode": "133207",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Thambar",
            "Pincode": "133208",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "B C W Surajpur",
            "Pincode": "133301",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Beas Project",
            "Pincode": "133301",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kaika Railway Station",
            "Pincode": "133302",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kalka",
            "Pincode": "133302",
            "City": "Kalka",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kalka",
            "Pincode": "133302",
            "City": "Panchkula",
            "District": "Panchkula",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kalka Railway Station",
            "Pincode": "133302",
            "City": "Panchkula",
            "District": "Panchkula",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala City",
            "Pincode": "134002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala City Kuthchery",
            "Pincode": "134002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bazar Basti Ram",
            "Pincode": "134002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Civil Lines",
            "Pincode": "134002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "D A V College",
            "Pincode": "134002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Motor Stand",
            "Pincode": "134002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Patel Nagar",
            "Pincode": "134002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Railway Road",
            "Pincode": "134002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Sabji Mandi",
            "Pincode": "134002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala City",
            "Pincode": "134003",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala City Model Town",
            "Pincode": "134003",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala City Prem",
            "Pincode": "134003",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Ambala City Session",
            "Pincode": "134003",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Baldev Nagar",
            "Pincode": "134007",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panjokhera",
            "Pincode": "134011",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Maneola",
            "Pincode": "134012",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pinjore H M T",
            "Pincode": "134101",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Pinjore",
            "Pincode": "134102",
            "City": "Pinjore",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Crpf Punjore",
            "Pincode": "134104",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chandi Mandir",
            "Pincode": "134107",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panchkula Gurukul",
            "Pincode": "134108",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panchkula",
            "Pincode": "134109",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bhabat",
            "Pincode": "134110",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panchkula Sec 4",
            "Pincode": "134112",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Panchkula Sec 15",
            "Pincode": "134113",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Barwala",
            "Pincode": "134118",
            "City": "Barwala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jatwar",
            "Pincode": "134201",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Shahzadpur",
            "Pincode": "134202",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Naraingarh",
            "Pincode": "134203",
            "City": "Naraingarh",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Raipur Rani",
            "Pincode": "134204",
            "City": "Raipur Rani",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Morni",
            "Pincode": "134205",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Patrehri",
            "Pincode": "134206",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Auto Industries",
            "Pincode": "135001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Yamua Ngr Bhatia Ngr",
            "Pincode": "135001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Yamuna Nagar",
            "Pincode": "135001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Yamuna Nagar Rlwy Rd",
            "Pincode": "135001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Yamuna Nagar Sugar Mls",
            "Pincode": "135001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Yamuna Ngr Rampura Clny",
            "Pincode": "135001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Yamuna Ngr Workshop Rd",
            "Pincode": "135001",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jagadhri Courts",
            "Pincode": "135002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jagadhri Courts",
            "Pincode": "135002",
            "City": "Yamunanagar",
            "District": "Yamunanagar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jagadhri Workshop",
            "Pincode": "135002",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jagadhri Workshop",
            "Pincode": "135002",
            "City": "Yamunanagar",
            "District": "Yamunanagar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jagadhri",
            "Pincode": "135003",
            "City": "Jagadhri",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jagadhri",
            "Pincode": "135003",
            "City": "Yamunanagar",
            "District": "Yamunanagar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jagadhri Town",
            "Pincode": "135003",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Jagadhri Town",
            "Pincode": "135003",
            "City": "Yamunanagar",
            "District": "Yamunanagar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Khizrabad East",
            "Pincode": "135021",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Buriya",
            "Pincode": "135101",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Bilaspur",
            "Pincode": "135102",
            "City": "Bilaspur",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chhachhrauli",
            "Pincode": "135103",
            "City": "Chhachhrauli",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Chhachhrauli",
            "Pincode": "135103",
            "City": "Chhachhrauli",
            "District": "Yamunanagar",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Dadupur",
            "Pincode": "135104",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Kharwan",
            "Pincode": "135105",
            "City": "Ambala",
            "District": "Ambala",
            "State": "Haryana"
        },
        {
            "PostOfficeName": "Rup Nagar College",
            "Pincode": "140001",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rup Ngr Motar Terminus",
            "Pincode": "140001",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rupar H O",
            "Pincode": "140001",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Morinda",
            "Pincode": "140101",
            "City": "Morinda",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lutheri",
            "Pincode": "140102",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kurali",
            "Pincode": "140103",
            "City": "Kurali",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sahauran",
            "Pincode": "140104",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mainpur",
            "Pincode": "140108",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khizrabad West",
            "Pincode": "140109",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sialba Majri",
            "Pincode": "140110",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bela",
            "Pincode": "140111",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chamkaur Sahib",
            "Pincode": "140112",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghanauli",
            "Pincode": "140113",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bharatgarh",
            "Pincode": "140114",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kiratpur Sahib",
            "Pincode": "140115",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kotla Power House",
            "Pincode": "140116",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nurpur Bedi",
            "Pincode": "140117",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Anandpur Sahib",
            "Pincode": "140118",
            "City": "Anandpur Sahib",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Takhatgarh",
            "Pincode": "140119",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ganguwal",
            "Pincode": "140123",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Colony",
            "Pincode": "140124",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nangal Dam",
            "Pincode": "140124",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nangal Labour",
            "Pincode": "140124",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nangal Township",
            "Pincode": "140124",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nangal",
            "Pincode": "140125",
            "City": "Nangal",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "F F Nangal",
            "Pincode": "140126",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nangal Factory Area",
            "Pincode": "140126",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nangal Sector 2",
            "Pincode": "140126",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Naya Nangal",
            "Pincode": "140126",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mubarikpur",
            "Pincode": "140201",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ramgarh",
            "Pincode": "140202",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhankarpur",
            "Pincode": "140203",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kharar",
            "Pincode": "140301",
            "City": "Kharar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kharar Mills Road",
            "Pincode": "140301",
            "City": "Kharar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Manauli",
            "Pincode": "140306",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Landran",
            "Pincode": "140307",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sohana",
            "Pincode": "140308",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "140401",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Industrial Focal Point",
            "Pincode": "140401",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rajpura",
            "Pincode": "140401",
            "City": "Rajpura",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rajpura H O",
            "Pincode": "140401",
            "City": "Rajpura",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rajpura Township",
            "Pincode": "140401",
            "City": "Rajpura",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sangatpursodhian",
            "Pincode": "140405",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hamayunpur",
            "Pincode": "140406",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sirhind",
            "Pincode": "140406",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sirhind City",
            "Pincode": "140407",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bassi",
            "Pincode": "140412",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gharuan",
            "Pincode": "140413",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Shambhu",
            "Pincode": "140417",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lairu",
            "Pincode": "140501",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Handesra",
            "Pincode": "140502",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dappar Ammunition Depot",
            "Pincode": "140506",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Banur",
            "Pincode": "140601",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Manakpur",
            "Pincode": "140602",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kauli",
            "Pincode": "140701",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghanaur",
            "Pincode": "140702",
            "City": "Ghanaur",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khamano Kalan",
            "Pincode": "140801",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sanghol",
            "Pincode": "140802",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mullanpur",
            "Pincode": "140901",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bharat Nagar",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chander Nagar",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Civil Lines",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Durga Puri",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gurdev Nagar",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ludhiana",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ludhiana Bus Stand",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ludhiana H O",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ludhiana Kutchery",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "P & T Colony Ludhiana",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sat Sang Rd Ludhiana",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sidhpeeth Ludhiana",
            "Pincode": "141001",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Colony Ropar",
            "Pincode": "141002",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Abdullapur Basti",
            "Pincode": "141003",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "G T Road Ludhiana",
            "Pincode": "141003",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Industrial Colony Ludhiana",
            "Pincode": "141003",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "141003",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Janta Nagar",
            "Pincode": "141003",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Labour Colony",
            "Pincode": "141003",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ludhiana",
            "Pincode": "141003",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Millerganj",
            "Pincode": "141003",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "P A P Lines",
            "Pincode": "141004",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "P A U Ludhiana",
            "Pincode": "141004",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ludhiana",
            "Pincode": "141005",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Neta Ji Nagar",
            "Pincode": "141005",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Salem Tabri",
            "Pincode": "141005",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Guru Nanak Engineering College",
            "Pincode": "141006",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ludhiana",
            "Pincode": "141007",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bagh Khazanchian",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Baini Ram Street",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Brahampuri Ludhiana",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "C M C Ludhiana",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Girson Knitting Works",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ikbalganj Ludhiana",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jail Rd Ludhiana",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalpat Rai Market",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kidwai Nagar",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ludhiana",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ludhiana Central",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Madhopuri Ludhiana",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Samrala Rd Ludhiana",
            "Pincode": "141008",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mullanpur Mandi",
            "Pincode": "141101",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dakha",
            "Pincode": "141102",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mohie",
            "Pincode": "141103",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "K C G S Sudhar",
            "Pincode": "141104",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Saraba",
            "Pincode": "141105",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Haliwara A D",
            "Pincode": "141106",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Halwara",
            "Pincode": "141107",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Pakhowal",
            "Pincode": "141108",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Raikot",
            "Pincode": "141109",
            "City": "Raikot",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jamalpur Awana",
            "Pincode": "141111",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kohara",
            "Pincode": "141112",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Katni Kalan",
            "Pincode": "141113",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Samrala",
            "Pincode": "141114",
            "City": "Samrala",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Samrala City",
            "Pincode": "141114",
            "City": "Samrala",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Machhiwara",
            "Pincode": "141115",
            "City": "Machhiwara",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gill",
            "Pincode": "141116",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sihar",
            "Pincode": "141117",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Frhlon",
            "Pincode": "141118",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Malaudh",
            "Pincode": "141119",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sanehwal",
            "Pincode": "141120",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bahlolpur",
            "Pincode": "141121",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jaspal Bangar",
            "Pincode": "141122",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghulal",
            "Pincode": "141124",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kila Raipur",
            "Pincode": "141201",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gujarwal",
            "Pincode": "141202",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Narangwal",
            "Pincode": "141203",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghungrana",
            "Pincode": "141204",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Latala",
            "Pincode": "141205",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghawaddi",
            "Pincode": "141206",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Roorka Kalan",
            "Pincode": "141302",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Samrai",
            "Pincode": "141302",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jandiala",
            "Pincode": "141303",
            "City": "Jandiala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Partabpur",
            "Pincode": "141305",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Partap Nagar",
            "Pincode": "141305",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bilga",
            "Pincode": "141306",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Pasla",
            "Pincode": "141307",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Talwan",
            "Pincode": "141308",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nurmahal",
            "Pincode": "141309",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Motor Terminus",
            "Pincode": "141310",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nakodar",
            "Pincode": "141310",
            "City": "Nakodar",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nakodar Mandi",
            "Pincode": "141310",
            "City": "Nakodar",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Railway Road",
            "Pincode": "141310",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhesian Kahna",
            "Pincode": "141311",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mahatpur",
            "Pincode": "141315",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Shanker",
            "Pincode": "141316",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sarih",
            "Pincode": "141317",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sidhwan",
            "Pincode": "141318",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "G M Khanna",
            "Pincode": "141401",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khanna H O",
            "Pincode": "141401",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nai Mandi Khanna",
            "Pincode": "141401",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "A S College Khanna",
            "Pincode": "141402",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhari",
            "Pincode": "141411",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Daheru",
            "Pincode": "141412",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhamot",
            "Pincode": "141413",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Isru",
            "Pincode": "141414",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jarg",
            "Pincode": "141415",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Payal",
            "Pincode": "141416",
            "City": "Payal",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rahawan",
            "Pincode": "141417",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "141418",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghurani Kalan",
            "Pincode": "141419",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Doraha",
            "Pincode": "141421",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Grain Mkt Moga",
            "Pincode": "142001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Industrial Area Moga",
            "Pincode": "142001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Moga H O",
            "Pincode": "142001",
            "City": "Moga",
            "District": "Moga",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Moga Kutchery",
            "Pincode": "142001",
            "City": "Moga",
            "District": "Moga",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Moga Purana",
            "Pincode": "142001",
            "City": "Moga",
            "District": "Moga",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dalla",
            "Pincode": "142011",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Baddowai",
            "Pincode": "142021",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lalton Kalan",
            "Pincode": "142022",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Man",
            "Pincode": "142023",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sidhwan Khurd",
            "Pincode": "142024",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sowaddi",
            "Pincode": "142025",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jagraon City",
            "Pincode": "142026",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jagraon H O",
            "Pincode": "142026",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jagraon Tehsil",
            "Pincode": "142026",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ayali Kalan",
            "Pincode": "142027",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jodhan",
            "Pincode": "142029",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kamalpur",
            "Pincode": "142030",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hathur",
            "Pincode": "142031",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bassian",
            "Pincode": "142032",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sidhwan Bet",
            "Pincode": "142033",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Manoke",
            "Pincode": "142034",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mallah",
            "Pincode": "142035",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Galib Kalan",
            "Pincode": "142036",
            "City": "Ludhiana",
            "District": "Ludhiana",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Badhni Kalan",
            "Pincode": "142037",
            "City": "Badhni Kalan",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bilaspur",
            "Pincode": "142039",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Buttar",
            "Pincode": "142040",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Canal Colony",
            "Pincode": "142040",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhinder",
            "Pincode": "142041",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dharamkot",
            "Pincode": "142042",
            "City": "Dharamkot",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kot Isekhan",
            "Pincode": "142043",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Makhu",
            "Pincode": "142044",
            "City": "Makhu",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Pattohira Singh",
            "Pincode": "142046",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ram Road Zira",
            "Pincode": "142047",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Shahid Gurdas",
            "Pincode": "142047",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Zira",
            "Pincode": "142047",
            "City": "Zira",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghall Kalan",
            "Pincode": "142048",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Guru Tegh Bahadurgarh",
            "Pincode": "142049",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Talwandi",
            "Pincode": "142050",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Talwandi Bhai",
            "Pincode": "142050",
            "City": "Talwandi Bhai",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Fatehgarh Panjtoor",
            "Pincode": "142051",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozshah",
            "Pincode": "142052",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhudike",
            "Pincode": "142053",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kokri Kalan",
            "Pincode": "142054",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nihal Singh Wala",
            "Pincode": "142055",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gholia Khurd",
            "Pincode": "142056",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Samadh Bhal",
            "Pincode": "142057",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kishanpura",
            "Pincode": "142058",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghall Khurd",
            "Pincode": "142059",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mudki",
            "Pincode": "142060",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Manawan",
            "Pincode": "142061",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Amritsar",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Amritsar Bus Stand",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Amritsar H O",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Amritsar Kutchery",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Azad Nagar",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bandho Road",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Basti Ram",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chawal Mandi",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhab",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Durgiana Mandir",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hide Market",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lawrence Road Amritsar",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Medical College Amritsar",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mewa Mandi",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "N R Locomotive Wk Shp",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nawankot",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rani Ka Bagh",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sadar Bazar",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Seth Jagat",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Steno House Agency",
            "Pincode": "143001",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Amritsar",
            "Pincode": "143002",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jawala Fr Mls Amritsar",
            "Pincode": "143003",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khanna Ngr Amritsar",
            "Pincode": "143004",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Amritsar",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chowk Darbar Sahib",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dass Niwas",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gandhi Bazar",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Golden Temple Amritsar",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Guru Ram",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hindu Sabha College",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kangra Colony",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Katra Karam Singh",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Katra Sher Singh",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kot Rallia Ram",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Majitha Mandi",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mohan Nagar",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sultant Wind Gate",
            "Pincode": "143006",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sultanwind",
            "Pincode": "143021",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sultanwind Gate",
            "Pincode": "143021",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Vijay Nagar Amritsar",
            "Pincode": "143036",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Raja Sansi",
            "Pincode": "143101",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ajnala",
            "Pincode": "143102",
            "City": "Ajnala",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chamiari",
            "Pincode": "143103",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Amritsar",
            "Pincode": "143104",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chheharta Railway Station",
            "Pincode": "143105",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Naraingarh",
            "Pincode": "143106",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Distillery Khasa",
            "Pincode": "143107",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Attari",
            "Pincode": "143108",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chogawan",
            "Pincode": "143109",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Preet Nagar",
            "Pincode": "143110",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khilchian",
            "Pincode": "143111",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Raya",
            "Pincode": "143112",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rayon Silk Mills",
            "Pincode": "143112",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Fatehpur Rajputan",
            "Pincode": "143113",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jandiala Guru",
            "Pincode": "143115",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Tarsikka",
            "Pincode": "143116",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Thermal Power",
            "Pincode": "143116",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khadur Sahib",
            "Pincode": "143117",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khalsa College",
            "Pincode": "143117",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Vairowal",
            "Pincode": "143118",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mehta Chowk",
            "Pincode": "143144",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Beas",
            "Pincode": "143201",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Baba Bakala",
            "Pincode": "143202",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Butala",
            "Pincode": "143203",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dera Baba Jaimal Singh",
            "Pincode": "143204",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sathiala",
            "Pincode": "143205",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chabhal",
            "Pincode": "143301",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sur Singh",
            "Pincode": "143302",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhikhiwind",
            "Pincode": "143303",
            "City": "Bhikhiwind",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kacha Pacca",
            "Pincode": "143304",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khalra",
            "Pincode": "143305",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chowk Darbar Sahib",
            "Pincode": "143401",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Tarn Tarn H O",
            "Pincode": "143401",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kang",
            "Pincode": "143406",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Fatehbad",
            "Pincode": "143407",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chohla Sahib",
            "Pincode": "143408",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sarhali",
            "Pincode": "143410",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhotian",
            "Pincode": "143411",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Harike",
            "Pincode": "143412",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bundala Amritsar",
            "Pincode": "143413",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sarai Amanat Khan",
            "Pincode": "143414",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kairon",
            "Pincode": "143415",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Patti",
            "Pincode": "143416",
            "City": "Patti",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sabra",
            "Pincode": "143417",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Voltoha",
            "Pincode": "143418",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khem Karan",
            "Pincode": "143419",
            "City": "Khem Karan",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Masatgarh",
            "Pincode": "143420",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gharyala",
            "Pincode": "143421",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Goindwal",
            "Pincode": "143422",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Verka",
            "Pincode": "143501",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kathu Nangal",
            "Pincode": "143502",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhangali",
            "Pincode": "143503",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chawinda Deviwala",
            "Pincode": "143504",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Anarkali Batala",
            "Pincode": "143505",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Batala City",
            "Pincode": "143505",
            "City": "Batala",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Batala H O",
            "Pincode": "143505",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "G Nanak Ngr Batala",
            "Pincode": "143505",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "G T Rd Batala",
            "Pincode": "143505",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "K Nagar Batala",
            "Pincode": "143505",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "N G Batala",
            "Pincode": "143505",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "R R Batala",
            "Pincode": "143505",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Batala",
            "Pincode": "143506",
            "City": "Batala",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Aliwal",
            "Pincode": "143507",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Fateh Nangal",
            "Pincode": "143508",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Zaffarwal",
            "Pincode": "143510",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhagowal",
            "Pincode": "143511",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kalanaur",
            "Pincode": "143512",
            "City": "Kalanaur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kala Afghana",
            "Pincode": "143513",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghoman",
            "Pincode": "143514",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhumbli",
            "Pincode": "143515",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhariwal",
            "Pincode": "143515",
            "City": "Dhariwal",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sri Hargobindpur",
            "Pincode": "143515",
            "City": "Sri Hargobindpur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Qadian",
            "Pincode": "143516",
            "City": "Qadian",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhattian",
            "Pincode": "143517",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Maja Singh",
            "Pincode": "143518",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sohal",
            "Pincode": "143520",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gurdaspur",
            "Pincode": "143521",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gurdaspur City",
            "Pincode": "143521",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gurdaspur H O",
            "Pincode": "143521",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gurdaspur Kutchery",
            "Pincode": "143521",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gurdaspur Mandi",
            "Pincode": "143521",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gurdaspur Tibri Road",
            "Pincode": "143521",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Trimu Rd",
            "Pincode": "143521",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kaler Kalan",
            "Pincode": "143523",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Villa Teja",
            "Pincode": "143524",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dorangla",
            "Pincode": "143526",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Harchowal",
            "Pincode": "143527",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kahnuwan",
            "Pincode": "143528",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Tiber",
            "Pincode": "143529",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Tibri",
            "Pincode": "143530",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dina Nagar",
            "Pincode": "143531",
            "City": "Dina Nagar",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gandhi Nagar Dina Nagar",
            "Pincode": "143531",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Behrampur",
            "Pincode": "143532",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gharota",
            "Pincode": "143533",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Taragarh",
            "Pincode": "143534",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Marara",
            "Pincode": "143535",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Awankha",
            "Pincode": "143536",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Talibpur Pandoori",
            "Pincode": "143537",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghani Ke Banger",
            "Pincode": "143538",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Majitha",
            "Pincode": "143601",
            "City": "Majitha",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Fatehgarh Churian",
            "Pincode": "143602",
            "City": "Fatehgarh Churian",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ram Dass",
            "Pincode": "143603",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dera Baba Nanak",
            "Pincode": "143604",
            "City": "Dera Baba Nanak",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhianpur",
            "Pincode": "143605",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chetanpur",
            "Pincode": "143606",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dharamkot Randhawa",
            "Pincode": "143607",
            "City": "Amritsar",
            "District": "Amritsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Adarsh Nagar",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bazar Kalan",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bazar Nauhrian",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bazar Shahidan",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhagat Bazar",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bikrampura",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Charanjitpura",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chowk Jain Mandir",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Civil Lines",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Fentoganj",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "General Bus Std",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Guru Ravi Dass Rd",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalandhar City",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalandhar City H O",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lajpat Nagar",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lyallpur Khalsa",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Manjit Nagar",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "New Railway Colony",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Railway Road",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rasta Mohalla",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Session Courts",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Shahib Udham",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Shakti Nagar",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Singh Nagar",
            "Pincode": "144001",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Basti Jodhewal",
            "Pincode": "144002",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Basti Nau",
            "Pincode": "144002",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Basti Sheikh Darvesh",
            "Pincode": "144002",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Civil Secretariat",
            "Pincode": "144002",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalandhar",
            "Pincode": "144002",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhargava Camp",
            "Pincode": "144003",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalandhar",
            "Pincode": "144003",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "M T Jalandhar",
            "Pincode": "144003",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Model House Colony",
            "Pincode": "144003",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mohalla Ramdaspura",
            "Pincode": "144003",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "D A V College",
            "Pincode": "144004",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hoshiarpur Rd",
            "Pincode": "144004",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Industrial Town",
            "Pincode": "144004",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalandhar",
            "Pincode": "144004",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kot Kishan Chand",
            "Pincode": "144004",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Preet Nagar",
            "Pincode": "144004",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sodal Rd",
            "Pincode": "144004",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalandhar",
            "Pincode": "144005",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalandhar Cantt",
            "Pincode": "144005",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalandhar Cantt H O",
            "Pincode": "144005",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Military Hospital",
            "Pincode": "144005",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rama Mandi",
            "Pincode": "144005",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sadar Bazar",
            "Pincode": "144005",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Topkhana Bazar",
            "Pincode": "144005",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalandhar",
            "Pincode": "144006",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Basti Danishmandan",
            "Pincode": "144007",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Basti Gujan",
            "Pincode": "144007",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Grain Market",
            "Pincode": "144008",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chogetti",
            "Pincode": "144009",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhanowali",
            "Pincode": "144010",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Regional Engg College",
            "Pincode": "144011",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jamsher",
            "Pincode": "144020",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalandhar",
            "Pincode": "144021",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Garha",
            "Pincode": "144022",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dakoha",
            "Pincode": "144023",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kukar Pind",
            "Pincode": "144024",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jandu Singha",
            "Pincode": "144025",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lambra",
            "Pincode": "144026",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "O D Suranassi",
            "Pincode": "144027",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chitti",
            "Pincode": "144028",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Patara",
            "Pincode": "144101",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Adampur Doaba",
            "Pincode": "144102",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Adampur A D",
            "Pincode": "144103",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Darauli Kalan",
            "Pincode": "144104",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sham Chaurasi",
            "Pincode": "144105",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Apra",
            "Pincode": "144116",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhog",
            "Pincode": "144201",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Miani",
            "Pincode": "144202",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Tanda",
            "Pincode": "144203",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Urmar",
            "Pincode": "144204",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dasuya H O",
            "Pincode": "144205",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dholbaha",
            "Pincode": "144206",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Garhdiwala",
            "Pincode": "144207",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hariana",
            "Pincode": "144208",
            "City": "Hariana",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Janauri",
            "Pincode": "144209",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhunga",
            "Pincode": "144210",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Budhi Pind",
            "Pincode": "144211",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mukerian",
            "Pincode": "144211",
            "City": "Mukerian",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhanowal",
            "Pincode": "144213",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Tanda Ram Sahai",
            "Pincode": "144214",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Talwara Township",
            "Pincode": "144216",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mehangarwal",
            "Pincode": "144218",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hajipur",
            "Pincode": "144221",
            "City": "Hajipur",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Datarpur",
            "Pincode": "144222",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kamani Devi",
            "Pincode": "144223",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhambootara",
            "Pincode": "144224",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Alawalpur",
            "Pincode": "144301",
            "City": "Alawalpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Beaspind",
            "Pincode": "144302",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kala Bakra",
            "Pincode": "144303",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lakhinder",
            "Pincode": "144304",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khudda",
            "Pincode": "144305",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Banga Rd Phagwara",
            "Pincode": "144401",
            "City": "Banga",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bazar Safran Phagwara",
            "Pincode": "144401",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bus Stand Phagwara",
            "Pincode": "144401",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hoshiarpur Road",
            "Pincode": "144401",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kultham",
            "Pincode": "144401",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Phagwara",
            "Pincode": "144401",
            "City": "Phagwara",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Phagwara H O",
            "Pincode": "144401",
            "City": "Phagwara",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rlwy Road Phagwara",
            "Pincode": "144401",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Satnampura",
            "Pincode": "144402",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ranipur",
            "Pincode": "144403",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ajnoha",
            "Pincode": "144404",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Narur",
            "Pincode": "144405",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Baddon",
            "Pincode": "144406",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Domeli",
            "Pincode": "144407",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Panchhat",
            "Pincode": "144408",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Goraya",
            "Pincode": "144409",
            "City": "Goraya",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Govt Polytechnic",
            "Pincode": "144409",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Industrial Area Phillaur",
            "Pincode": "144410",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "P T S Phillaur",
            "Pincode": "144410",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Phillaur",
            "Pincode": "144410",
            "City": "Phillaur",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lasara",
            "Pincode": "144415",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Aur",
            "Pincode": "144417",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Barapind",
            "Pincode": "144418",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dayalpur",
            "Pincode": "144419",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sahlon",
            "Pincode": "144421",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Uzapur",
            "Pincode": "144422",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chakdana",
            "Pincode": "144423",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dosanjh Kalan",
            "Pincode": "144502",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Pharla",
            "Pincode": "144503",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Behram",
            "Pincode": "144504",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Banga",
            "Pincode": "144505",
            "City": "Banga",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Banga Town",
            "Pincode": "144505",
            "City": "Banga",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nawanshahr Road Banga",
            "Pincode": "144505",
            "City": "Nawanshahr",
            "District": "Nawanshahr",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mahil Gaila",
            "Pincode": "144506",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mukandpur",
            "Pincode": "144507",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Naura",
            "Pincode": "144508",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Naushehra",
            "Pincode": "144508",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khankhana",
            "Pincode": "144509",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ladhana Jhikka",
            "Pincode": "144510",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dosanjh Khurd",
            "Pincode": "144511",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kahma",
            "Pincode": "144512",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Musapur",
            "Pincode": "144513",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "College Nawanshahr",
            "Pincode": "144514",
            "City": "Nawanshahr",
            "District": "Nawanshahr",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nawanshahr",
            "Pincode": "144514",
            "City": "Nawanshahr",
            "District": "Nawanshahr",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nawanshahr Mandi",
            "Pincode": "144514",
            "City": "Nawanshahr",
            "District": "Nawanshahr",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "R K Arya",
            "Pincode": "144514",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jadla",
            "Pincode": "144515",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Langroya",
            "Pincode": "144516",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rahon",
            "Pincode": "144517",
            "City": "Rahon",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Garcha",
            "Pincode": "144518",
            "City": "Jalandhar",
            "District": "Jalandhar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kot Fatuhi",
            "Pincode": "144519",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Binjon",
            "Pincode": "144520",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bala Chaur",
            "Pincode": "144521",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kathgarh",
            "Pincode": "144522",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Binewal",
            "Pincode": "144523",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Saroa",
            "Pincode": "144524",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sahilba",
            "Pincode": "144525",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mehandpur",
            "Pincode": "144526",
            "City": "Rupnagar",
            "District": "Rupnagar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Garh Shankar",
            "Pincode": "144527",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Garhshankar Kutchery",
            "Pincode": "144527",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rampur Bilron",
            "Pincode": "144528",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Saila Khurd",
            "Pincode": "144529",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jaijon",
            "Pincode": "144530",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Moranwali",
            "Pincode": "144531",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Samundra",
            "Pincode": "144532",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kapurthala",
            "Pincode": "144601",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kapurthala Bus Stn",
            "Pincode": "144601",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kapurthala H O",
            "Pincode": "144601",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kapurthala Mandi",
            "Pincode": "144601",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kapurthala Town",
            "Pincode": "144601",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sant Road",
            "Pincode": "144601",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chaudharian",
            "Pincode": "144606",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Raipur Pirbuxwala",
            "Pincode": "144619",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sheikhupura",
            "Pincode": "144620",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Begowal",
            "Pincode": "144621",
            "City": "Begowal",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bholath",
            "Pincode": "144622",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kala Singhian",
            "Pincode": "144623",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nabha",
            "Pincode": "144624",
            "City": "Nabha",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nadala",
            "Pincode": "144624",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "G N O C Sultanpur",
            "Pincode": "144626",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lodhi",
            "Pincode": "144626",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sultanpur Lodhi",
            "Pincode": "144626",
            "City": "Sultanpur Lodhi",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Tharha Jadid",
            "Pincode": "144628",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lohian",
            "Pincode": "144629",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bopa Rai Kalan",
            "Pincode": "144630",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nangal Lubana",
            "Pincode": "144631",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chachoki",
            "Pincode": "144632",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sarhali",
            "Pincode": "144633",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Malsian",
            "Pincode": "144701",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Shahkot",
            "Pincode": "144702",
            "City": "Shahkot",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nangal Ambia",
            "Pincode": "144703",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kartarpur",
            "Pincode": "144801",
            "City": "Kartarpur",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kartarpur Qilla",
            "Pincode": "144801",
            "City": "Kartarpur",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jagatjit Ngr Kapurthala",
            "Pincode": "144802",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dialpur",
            "Pincode": "144803",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhilwan",
            "Pincode": "144804",
            "City": "Dhilwan",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Pattar Kalan",
            "Pincode": "144806",
            "City": "Kapurthala",
            "District": "Kapurthala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Abrol Nagar",
            "Pincode": "145001",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Androon Bazar",
            "Pincode": "145001",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Becon P O Pathankot",
            "Pincode": "145001",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Civil Court Pathankot",
            "Pincode": "145001",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dalhousie Road",
            "Pincode": "145001",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhangu Road",
            "Pincode": "145001",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gurdaspur Road",
            "Pincode": "145001",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mission Road",
            "Pincode": "145001",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Model Colony",
            "Pincode": "145001",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Pathankot",
            "Pincode": "145001",
            "City": "Pathankot",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mamoon",
            "Pincode": "145002",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Siali",
            "Pincode": "145003",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhar Kalan",
            "Pincode": "145021",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dunera",
            "Pincode": "145022",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sujanpur",
            "Pincode": "145023",
            "City": "Sujanpur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Madhopur",
            "Pincode": "145024",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Malikpur",
            "Pincode": "145025",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Narot Jaimal Singh",
            "Pincode": "145026",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Haryal",
            "Pincode": "145027",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Shahpur Kandi",
            "Pincode": "145029",
            "City": "Gurdaspur",
            "District": "Gurdaspur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mirthal",
            "Pincode": "145101",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bahadurpur Chowk",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chowk Surajan",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Guru Nanak Nagar",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hoshiarpur",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hoshiarpur City",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hoshiarpur Gaushala Bazar",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hoshiarpur Govt College",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hoshiarpur H O",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kamalpur Hoshiarpur",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Model Town",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Railway Rd",
            "Pincode": "146001",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sadhu Ashram",
            "Pincode": "146021",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Piplanwala",
            "Pincode": "146022",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bajwara",
            "Pincode": "146023",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Barian Kalan",
            "Pincode": "146101",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bassi Kalan",
            "Pincode": "146102",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Basti Bawa Khel",
            "Pincode": "146102",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bham",
            "Pincode": "146103",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bihala",
            "Pincode": "146104",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mahilpur",
            "Pincode": "146105",
            "City": "Mahilpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mahilpur Bus Stnd",
            "Pincode": "146105",
            "City": "Mahilpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nangal Kalan",
            "Pincode": "146106",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Paldi",
            "Pincode": "146107",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sarhala Kalan",
            "Pincode": "146108",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Toto Mazra",
            "Pincode": "146109",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kot Abdul Khaliq",
            "Pincode": "146110",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Purhiran",
            "Pincode": "146111",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rajpur Bhayan",
            "Pincode": "146112",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bullewal",
            "Pincode": "146113",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nanda Chaur",
            "Pincode": "146114",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Panjjodeota",
            "Pincode": "146115",
            "City": "Hoshiarpur",
            "District": "Hoshiarpur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "B S Press Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bahera Rd Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Civil Lines Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Colony Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dukhniwaran",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Govt Printing",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gurbax Colony",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jaurian Bhatian",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lahori Gate Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Law Courts Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mahendra College",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Medical College",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "New Lal Bagh",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Patiala City",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Patiala H O",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Pepsu Bhakara",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Police Lines Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Press Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ragho Majra Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Road Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Saifabad Gate Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Secretariat Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Shahi Samadhan Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sheranwala Gate Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sirhindi Bazar Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Thappar Engg Institute",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Tripri Patiala",
            "Pincode": "147001",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Univ P O Patiala",
            "Pincode": "147002",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhunerheri",
            "Pincode": "147003",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bahadurgarh",
            "Pincode": "147021",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Samana",
            "Pincode": "147101",
            "City": "Samana",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ghagga",
            "Pincode": "147102",
            "City": "Ghagga",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sanaur",
            "Pincode": "147103",
            "City": "Sanaur",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chinarthal Kalan",
            "Pincode": "147104",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Patran",
            "Pincode": "147105",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Anaj Mandi Nabha",
            "Pincode": "147201",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nabha",
            "Pincode": "147201",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nabha Rly Station",
            "Pincode": "147201",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Patiala Gate",
            "Pincode": "147201",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhadson",
            "Pincode": "147202",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Amloh",
            "Pincode": "147203",
            "City": "Amloh",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Meemsa",
            "Pincode": "147205",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Industrial Town",
            "Pincode": "147301",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mandi Gobindgarh",
            "Pincode": "147301",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mandi Govindgarh",
            "Pincode": "147301",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mandi Govindgarh R/R",
            "Pincode": "147301",
            "City": "Patiala",
            "District": "Patiala",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hospital Road",
            "Pincode": "148001",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "New Grain Mkt",
            "Pincode": "148001",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sangrur",
            "Pincode": "148001",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sangrur City",
            "Pincode": "148001",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sangrur H O",
            "Pincode": "148001",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bahadurpur",
            "Pincode": "148004",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ubhewal",
            "Pincode": "148005",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Badru Khan",
            "Pincode": "148006",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mehlam",
            "Pincode": "148007",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mangwal",
            "Pincode": "148008",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lohat Badi",
            "Pincode": "148009",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sandhaur",
            "Pincode": "148020",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ahmedgarh",
            "Pincode": "148021",
            "City": "Ahmedgarh",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Amargarh",
            "Pincode": "148022",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lal Bazar",
            "Pincode": "148023",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Malerkotla",
            "Pincode": "148023",
            "City": "Malerkotla",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhuri",
            "Pincode": "148024",
            "City": "Dhuri",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sangrur Rd Dhuri",
            "Pincode": "148024",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sherpur",
            "Pincode": "148025",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhawanigarh",
            "Pincode": "148026",
            "City": "Bhawanigarh",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Pakki Khanauri",
            "Pincode": "148027",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sunam",
            "Pincode": "148028",
            "City": "Sunam",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sunam City",
            "Pincode": "148028",
            "City": "Sunam",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Cheema",
            "Pincode": "148029",
            "City": "Cheema",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lehragaga",
            "Pincode": "148031",
            "City": "Lehragaga",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nagra",
            "Pincode": "148032",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Akalgarh",
            "Pincode": "148033",
            "City": "Akalgarh",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ladda",
            "Pincode": "148034",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dirba",
            "Pincode": "148035",
            "City": "Dirba",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rogla",
            "Pincode": "148036",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Fatehgarh Panjjarian",
            "Pincode": "148038",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hamidi",
            "Pincode": "148039",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Janal",
            "Pincode": "148040",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhuthal Kalan",
            "Pincode": "148041",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gujran",
            "Pincode": "148042",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Balram",
            "Pincode": "148043",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kothla",
            "Pincode": "148044",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khanal Kalan",
            "Pincode": "148045",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Banra",
            "Pincode": "148046",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Chhahar",
            "Pincode": "148047",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gharanchon",
            "Pincode": "148048",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mauran",
            "Pincode": "148049",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bathan",
            "Pincode": "148050",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Banbhauran",
            "Pincode": "148051",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Barnala",
            "Pincode": "148101",
            "City": "Barnala",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Barnala Kutchery Clg Rd",
            "Pincode": "148101",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhadaur",
            "Pincode": "148102",
            "City": "Bhadaur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Shaina",
            "Pincode": "148103",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mahilkalan",
            "Pincode": "148104",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dhanaula",
            "Pincode": "148105",
            "City": "Dhanaula",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Longowal",
            "Pincode": "148106",
            "City": "Longowal",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Hadiaya",
            "Pincode": "148107",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Tapa",
            "Pincode": "148108",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Joga",
            "Pincode": "148109",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Pako Kalan",
            "Pincode": "148110",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sheron",
            "Pincode": "148111",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kaleki",
            "Pincode": "148112",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sanghera",
            "Pincode": "148113",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Pharwali",
            "Pincode": "148114",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhutna",
            "Pincode": "148115",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jaioke",
            "Pincode": "148116",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kattu",
            "Pincode": "148117",
            "City": "Sangrur",
            "District": "Sangrur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhatinda",
            "Pincode": "151001",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhatinda H O",
            "Pincode": "151001",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nai Basti",
            "Pincode": "151001",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "G Nanak Thl Plt Bhatinda",
            "Pincode": "151002",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhatinda",
            "Pincode": "151003",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhatinda City",
            "Pincode": "151005",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhuchu",
            "Pincode": "151101",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nathana",
            "Pincode": "151102",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "National Fertilizer",
            "Pincode": "151102",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rampura Phul",
            "Pincode": "151103",
            "City": "Rampura Phul",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Phul",
            "Pincode": "151104",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mehraj",
            "Pincode": "151105",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhai Rupa",
            "Pincode": "151106",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Balanwali",
            "Pincode": "151107",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Salabatpur",
            "Pincode": "151108",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mandi Kalan",
            "Pincode": "151110",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gonina Mandi",
            "Pincode": "151201",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jaitu",
            "Pincode": "151202",
            "City": "Jaitu",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Faridkot H O",
            "Pincode": "151203",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Faridkot Mandi",
            "Pincode": "151203",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Faridkot Secretariat",
            "Pincode": "151203",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kotkapura",
            "Pincode": "151204",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rlwy Bazar",
            "Pincode": "151204",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bajkhana",
            "Pincode": "151205",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhagta Bhai",
            "Pincode": "151206",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Panjgrain Kalan",
            "Pincode": "151207",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bargari",
            "Pincode": "151208",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sandhawan",
            "Pincode": "151209",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Alamwala",
            "Pincode": "151210",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Raman",
            "Pincode": "151301",
            "City": "Raman",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Talwasdi Saboo",
            "Pincode": "151302",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sangat",
            "Pincode": "151401",
            "City": "Sangat",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bareta",
            "Pincode": "151501",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Budhlada",
            "Pincode": "151502",
            "City": "Budhlada",
            "District": "Mansa",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Boha",
            "Pincode": "151503",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhikhi",
            "Pincode": "151504",
            "City": "Bhikhi",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mansa",
            "Pincode": "151505",
            "City": "Mansa",
            "District": "Mansa",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nai Basti Mansa",
            "Pincode": "151505",
            "City": "Mansa",
            "District": "Mansa",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jhunir",
            "Pincode": "151506",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sirki Bazar Bhatinda",
            "Pincode": "151506",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sardulgarh",
            "Pincode": "151507",
            "City": "Sardulgarh",
            "District": "Mansa",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhaini Bagga",
            "Pincode": "151508",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Maur",
            "Pincode": "151509",
            "City": "Maur",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kuttiwal Kalan",
            "Pincode": "151510",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kahangarh",
            "Pincode": "151511",
            "City": "Bhatinda",
            "District": "Bhatinda",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozepur Bazar",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozepur City",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozepur City Arya",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozepur City D B Office",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozepur General Bus Sd",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozepur Sabzi",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozepur Sadar Bazar",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozpur Aliwal Lines",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozpur Cantt",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozpur H O",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Krishna Sudama",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mandi",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Railway Station",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Samaj Chowk",
            "Pincode": "152001",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ferozepur",
            "Pincode": "152003",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Killianwali",
            "Pincode": "152004",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Kandwala Amarkot",
            "Pincode": "152005",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mallanwala",
            "Pincode": "152021",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Guru Shai",
            "Pincode": "152022",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mamdot",
            "Pincode": "152023",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jalalabad",
            "Pincode": "152024",
            "City": "Jalalabad",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bariwala",
            "Pincode": "152025",
            "City": "Bariwala",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Muktsar",
            "Pincode": "152026",
            "City": "Muktsar",
            "District": "Muktsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Muktsar Kutchery",
            "Pincode": "152026",
            "City": "Muktsar",
            "District": "Muktsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Sadar Bazar",
            "Pincode": "152026",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Doba",
            "Pincode": "152031",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Rupana",
            "Pincode": "152032",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mandi Aminganj",
            "Pincode": "152033",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gidderbaha",
            "Pincode": "152101",
            "City": "Gidderbaha",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Gidderbaha C C",
            "Pincode": "152102",
            "City": "Gidderbaha",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jhumba",
            "Pincode": "152103",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Malout",
            "Pincode": "152107",
            "City": "Malout",
            "District": "Muktsar",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ram Nagar",
            "Pincode": "152112",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Lambi",
            "Pincode": "152113",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Tappakhera",
            "Pincode": "152114",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Bhai Ka Khera",
            "Pincode": "152115",
            "City": "Faridkot",
            "District": "Faridkot",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Abohar",
            "Pincode": "152116",
            "City": "Abohar",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Abohar Mandi",
            "Pincode": "152116",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Krishana Nagri",
            "Pincode": "152116",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Shitya Sadan",
            "Pincode": "152116",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Balluna",
            "Pincode": "152117",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Ramsara",
            "Pincode": "152120",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Khuikhera",
            "Pincode": "152121",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Nihal Khera",
            "Pincode": "152122",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Cloth Mkt Fazilka",
            "Pincode": "152123",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Fazika",
            "Pincode": "152123",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Suban",
            "Pincode": "152124",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Dharangwali",
            "Pincode": "152125",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Paterwala",
            "Pincode": "152126",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Churiwala Dhanna",
            "Pincode": "152127",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Haripur",
            "Pincode": "152128",
            "City": "Fatehgarh Sahib",
            "District": "Fatehgarh Sahib",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Panjkosi",
            "Pincode": "152129",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Jhumianwali",
            "Pincode": "152130",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Thumianwali",
            "Pincode": "152130",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mauzam",
            "Pincode": "152131",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "Mauzgarh",
            "Pincode": "152132",
            "City": "Ferozepur",
            "District": "Ferozepur",
            "State": "Punjab"
        },
        {
            "PostOfficeName": "New Secretariate",
            "Pincode": "160001",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Industrial Area Sector 28",
            "Pincode": "160002",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Aerodrome Chandigarh",
            "Pincode": "160003",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 8 Chandigarh",
            "Pincode": "160008",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 9 Chandigarh",
            "Pincode": "160009",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 10 Chandigarh",
            "Pincode": "160010",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 11 Chandigarh",
            "Pincode": "160011",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 12 Chandigarh",
            "Pincode": "160011",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Engg College",
            "Pincode": "160012",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 14 Chandigarh",
            "Pincode": "160014",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 16 Chandigarh",
            "Pincode": "160016",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Chandigarh",
            "Pincode": "160017",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "General Bus Stand",
            "Pincode": "160017",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 17 Chandigarh",
            "Pincode": "160017",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 18 Chandigarh",
            "Pincode": "160018",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 19 Chandigarh",
            "Pincode": "160019",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 27 Chandigarh",
            "Pincode": "160019",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 20 Chandigarh",
            "Pincode": "160020",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 29 Chandigarh",
            "Pincode": "160020",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Bajwara Chandigarh",
            "Pincode": "160022",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 21 Chandigarh",
            "Pincode": "160022",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 22 Chandigarh",
            "Pincode": "160022",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 23 Chandigarh",
            "Pincode": "160023",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 35 Chandigarh",
            "Pincode": "160023",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 26 Chandigarh",
            "Pincode": "160026",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 31 Chandigarh",
            "Pincode": "160031",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 36 Chandigarh",
            "Pincode": "160036",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Mohali Sas Nagar",
            "Pincode": "160055",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 59 Chandigarh",
            "Pincode": "160059",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Sector 61 Chandigarh",
            "Pincode": "160061",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Mani Mazra",
            "Pincode": "160101",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Burail",
            "Pincode": "160106",
            "City": "Chandigarh",
            "District": "Chandigarh",
            "State": "Chandigarh"
        },
        {
            "PostOfficeName": "Bharari",
            "Pincode": "171001",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Combermere",
            "Pincode": "171001",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Elysium",
            "Pincode": "171001",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Shimla",
            "Pincode": "171001",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "H P Sectt",
            "Pincode": "171002",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Simla East",
            "Pincode": "171002",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "A G P O Shimla",
            "Pincode": "171003",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Command H Q",
            "Pincode": "171003",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Command Hq",
            "Pincode": "171003",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Simla Sectt",
            "Pincode": "171003",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chaura Maidan Simla",
            "Pincode": "171004",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nabha Estate",
            "Pincode": "171004",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Botleauganj",
            "Pincode": "171005",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Summer Hill",
            "Pincode": "171005",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sanjauli",
            "Pincode": "171006",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mashobra",
            "Pincode": "171007",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jutogh",
            "Pincode": "171008",
            "City": "Jutogh",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kasumpti",
            "Pincode": "171009",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tara Devi",
            "Pincode": "171010",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Totu",
            "Pincode": "171011",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dhalli Simla",
            "Pincode": "171012",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jubbar Hatti",
            "Pincode": "171013",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Syri",
            "Pincode": "171014",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Munda",
            "Pincode": "171016",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Guma",
            "Pincode": "171017",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kufri",
            "Pincode": "171019",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Madabag",
            "Pincode": "171020",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ghana Ki Hatti",
            "Pincode": "171101",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Daria",
            "Pincode": "171102",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dhami",
            "Pincode": "171103",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Basantpur",
            "Pincode": "171108",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Theog",
            "Pincode": "171201",
            "City": "Theog",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kot Khai",
            "Pincode": "171202",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tikkar",
            "Pincode": "171203",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kiari",
            "Pincode": "171204",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jubbal",
            "Pincode": "171205",
            "City": "Jubbal",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Hatkoti",
            "Pincode": "171206",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rohru",
            "Pincode": "171207",
            "City": "Rohru",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chirgaon",
            "Pincode": "171208",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Fagu",
            "Pincode": "171209",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nerwa",
            "Pincode": "171210",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chopal",
            "Pincode": "171211",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Matiana",
            "Pincode": "171212",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Narkanda",
            "Pincode": "171213",
            "City": "Narkanda",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dehabalson",
            "Pincode": "171214",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rohni",
            "Pincode": "171215",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Shilaroo",
            "Pincode": "171216",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sandhu",
            "Pincode": "171217",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Deori",
            "Pincode": "171218",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Cheog",
            "Pincode": "171219",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tatta Pani",
            "Pincode": "171302",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Churag",
            "Pincode": "171303",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Karsog",
            "Pincode": "171304",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chaila",
            "Pincode": "171305",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Pangna",
            "Pincode": "171306",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bushahr",
            "Pincode": "172001",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gaura",
            "Pincode": "172002",
            "City": "Shimla",
            "District": "Shimla",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nankhari",
            "Pincode": "172021",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nogli",
            "Pincode": "172022",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nirmand",
            "Pincode": "172023",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kingal",
            "Pincode": "172024",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dalash",
            "Pincode": "172025",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ani",
            "Pincode": "172026",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bara Gaon",
            "Pincode": "172027",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kumar Sain",
            "Pincode": "172029",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Thanedar",
            "Pincode": "172030",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kotgarh",
            "Pincode": "172031",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chowai",
            "Pincode": "172032",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nithar",
            "Pincode": "172033",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bonda",
            "Pincode": "172034",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bahli",
            "Pincode": "172035",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Luhri",
            "Pincode": "172036",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jeori",
            "Pincode": "172101",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sarahan Bushehar",
            "Pincode": "172102",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nichar",
            "Pincode": "172103",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tapri",
            "Pincode": "172104",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Karchham",
            "Pincode": "172105",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sangla",
            "Pincode": "172106",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rekong Peo",
            "Pincode": "172107",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kalpa",
            "Pincode": "172108",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Moorang",
            "Pincode": "172109",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Spillo",
            "Pincode": "172110",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Pooh",
            "Pincode": "172111",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Liyo",
            "Pincode": "172112",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tabo",
            "Pincode": "172113",
            "City": "Keylong",
            "District": "Lahul & Spiti",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kaza",
            "Pincode": "172114",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhawangarh",
            "Pincode": "172115",
            "City": "Reckong Peo",
            "District": "Kinnaur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nahan",
            "Pincode": "173001",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nahan",
            "Pincode": "173002",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bagthan",
            "Pincode": "173003",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Trilokpur",
            "Pincode": "173004",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Giri Nagar",
            "Pincode": "173020",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Majra",
            "Pincode": "173021",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dadahu",
            "Pincode": "173022",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sangarh",
            "Pincode": "173023",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sarahan",
            "Pincode": "173024",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Paonta Sahib",
            "Pincode": "173025",
            "City": "Paonta Sahib",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Badri Ngr",
            "Pincode": "173026",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Shillai",
            "Pincode": "173027",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rajban",
            "Pincode": "173028",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sataun",
            "Pincode": "173029",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rajgarh",
            "Pincode": "173101",
            "City": "Rajgarh",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sanaura",
            "Pincode": "173102",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Shayacharbroan",
            "Pincode": "173103",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nohra",
            "Pincode": "173104",
            "City": "Nahan",
            "District": "Sirmour",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Garkhal",
            "Pincode": "173201",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sanawar",
            "Pincode": "173202",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jagjit Nagar",
            "Pincode": "173203",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kasauli",
            "Pincode": "173204",
            "City": "Kasauli",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kasauli Motor",
            "Pincode": "173204",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kasauli Research",
            "Pincode": "173204",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kasauli Sanitorium",
            "Pincode": "173204",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Subathu",
            "Pincode": "173206",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kunihar",
            "Pincode": "173207",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "A U Campus",
            "Pincode": "173208",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Arki",
            "Pincode": "173208",
            "City": "Arki",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dharampur",
            "Pincode": "173209",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dagshai",
            "Pincode": "173210",
            "City": "Dagshai",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Saproon",
            "Pincode": "173211",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mall Solan",
            "Pincode": "173212",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Solan",
            "Pincode": "173212",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chamba Ghat",
            "Pincode": "173213",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Solan Brewery",
            "Pincode": "173214",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kandaghat",
            "Pincode": "173215",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Junga",
            "Pincode": "173216",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chail",
            "Pincode": "173217",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "M S Chail",
            "Pincode": "173218",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Shogi",
            "Pincode": "173219",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Parwanoo",
            "Pincode": "173220",
            "City": "Parwanoo",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Domehar",
            "Pincode": "173221",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Salogra",
            "Pincode": "173222",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ochaghat",
            "Pincode": "173223",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Balera",
            "Pincode": "173224",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jubbar",
            "Pincode": "173225",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kuthai",
            "Pincode": "173226",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mamligh",
            "Pincode": "173227",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kaithlighat",
            "Pincode": "173228",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kumar Hatti",
            "Pincode": "173229",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nauni",
            "Pincode": "173230",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bilaspur Kutchery",
            "Pincode": "174001",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bilaspuri",
            "Pincode": "174001",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "New Bilaspur Township",
            "Pincode": "174001",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kandraur",
            "Pincode": "174004",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sawhan",
            "Pincode": "174010",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sawarghat",
            "Pincode": "174011",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Panjgain",
            "Pincode": "174012",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ghumarwin",
            "Pincode": "174021",
            "City": "Ghumarwin",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Naswal",
            "Pincode": "174022",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kuthera",
            "Pincode": "174026",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Lehri Sarail",
            "Pincode": "174027",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "H G R & T Fctry",
            "Pincode": "174028",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Hatwar",
            "Pincode": "174028",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Berthin",
            "Pincode": "174029",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tallai",
            "Pincode": "174030",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jandutha",
            "Pincode": "174031",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Namhol",
            "Pincode": "174032",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jukhala",
            "Pincode": "174033",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gherwin",
            "Pincode": "174034",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kalol",
            "Pincode": "174035",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nalagarh",
            "Pincode": "174101",
            "City": "Nalagarh",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ram Shahar",
            "Pincode": "174102",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Barotiwala",
            "Pincode": "174103",
            "City": "Solan",
            "District": "Solan",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhakra Dam",
            "Pincode": "174201",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Santokhgarh",
            "Pincode": "174301",
            "City": "Santokhgarh",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dhussara",
            "Pincode": "174302",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Una",
            "Pincode": "174303",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Una S D C",
            "Pincode": "174303",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bani",
            "Pincode": "174304",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Barsar",
            "Pincode": "174305",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dehlan",
            "Pincode": "174306",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bangana",
            "Pincode": "174307",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Lathiana",
            "Pincode": "174308",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bahima",
            "Pincode": "174309",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kacha Tnk Nahan N Devi",
            "Pincode": "174310",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Salauni",
            "Pincode": "174311",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jaura Amb",
            "Pincode": "174312",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mehre",
            "Pincode": "174313",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mehatpur",
            "Pincode": "174315",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sunder Nagar",
            "Pincode": "174401",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sundernagar",
            "Pincode": "174401",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Town Ship",
            "Pincode": "174402",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Slapper",
            "Pincode": "174403",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Puran Nagar",
            "Pincode": "174404",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chambi",
            "Pincode": "174405",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Khaliar",
            "Pincode": "175001",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mandi",
            "Pincode": "175001",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mangwain Mohella Paddal",
            "Pincode": "175001",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhojpur",
            "Pincode": "175002",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kotli",
            "Pincode": "175003",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhambla",
            "Pincode": "175004",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kataula",
            "Pincode": "175005",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tikkar",
            "Pincode": "175006",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Paursa",
            "Pincode": "175007",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhangratu",
            "Pincode": "175021",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gopalpur",
            "Pincode": "175022",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sarkaghat",
            "Pincode": "175024",
            "City": "Sarkaghat",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sajao Piplu",
            "Pincode": "175025",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tihra",
            "Pincode": "175026",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Baggi",
            "Pincode": "175027",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chachiot",
            "Pincode": "175028",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gohar",
            "Pincode": "175029",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dehar",
            "Pincode": "175030",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jai Devi",
            "Pincode": "175031",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chauntra",
            "Pincode": "175032",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Baldwara",
            "Pincode": "175033",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Samaila",
            "Pincode": "175034",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bagsiad",
            "Pincode": "175035",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gurkothu",
            "Pincode": "175036",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chorthala",
            "Pincode": "175037",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nihri",
            "Pincode": "175038",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jachh",
            "Pincode": "175039",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dharampur Mandi",
            "Pincode": "175040",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bir",
            "Pincode": "175041",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rakoh",
            "Pincode": "175042",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "175042",
            "City": "Rampur",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ratti",
            "Pincode": "175043",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ghiri",
            "Pincode": "175044",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chail Chowk",
            "Pincode": "175045",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sukiban",
            "Pincode": "175046",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Janheli",
            "Pincode": "175047",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kanaid",
            "Pincode": "175048",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jamni",
            "Pincode": "175049",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Marhi",
            "Pincode": "175050",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Seoh",
            "Pincode": "175051",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Saigloo",
            "Pincode": "175052",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Arya Bazar Kullu",
            "Pincode": "175101",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kullu",
            "Pincode": "175101",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jangal Bari",
            "Pincode": "175109",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Aut",
            "Pincode": "175121",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Larji",
            "Pincode": "175122",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Banjar",
            "Pincode": "175123",
            "City": "Banjar",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Pandoh",
            "Pincode": "175124",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhuntar",
            "Pincode": "175125",
            "City": "Bhuntar",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bandrol Orchards",
            "Pincode": "175127",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Raison",
            "Pincode": "175128",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Katrain",
            "Pincode": "175129",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nagar",
            "Pincode": "175130",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Manali",
            "Pincode": "175131",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Keylong",
            "Pincode": "175132",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Lote",
            "Pincode": "175133",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sainj",
            "Pincode": "175134",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bajaura",
            "Pincode": "175135",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Haripur",
            "Pincode": "175136",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Haripur",
            "Pincode": "175136",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jagat Sukh",
            "Pincode": "175137",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Babeli",
            "Pincode": "175138",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gondla",
            "Pincode": "175140",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Garsa",
            "Pincode": "175141",
            "City": "Kullu",
            "District": "Kullu",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Udaipur",
            "Pincode": "175142",
            "City": "Keylong",
            "District": "Lahul & Spiti",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kangra",
            "Pincode": "176001",
            "City": "Kangra",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kangra Town",
            "Pincode": "176002",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bharmar",
            "Pincode": "176021",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rehan",
            "Pincode": "176022",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jawali",
            "Pincode": "176023",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Harsar",
            "Pincode": "176024",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dhameta",
            "Pincode": "176025",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Lanj",
            "Pincode": "176026",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nagrota Surian",
            "Pincode": "176027",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Haripur",
            "Pincode": "176028",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ranital",
            "Pincode": "176029",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Khudian",
            "Pincode": "176030",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jawala Mukhi",
            "Pincode": "176031",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tihri",
            "Pincode": "176032",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kothog",
            "Pincode": "176033",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Masroor",
            "Pincode": "176034",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Barial",
            "Pincode": "176035",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kohala",
            "Pincode": "176036",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sunhi",
            "Pincode": "176037",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Daulatpur",
            "Pincode": "176038",
            "City": "Daulatpur",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chakmou",
            "Pincode": "176039",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bijhari",
            "Pincode": "176040",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhota",
            "Pincode": "176041",
            "City": "Bhota",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mair",
            "Pincode": "176042",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ladraur",
            "Pincode": "176043",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mundkhar",
            "Pincode": "176044",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhoranj",
            "Pincode": "176045",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tanda",
            "Pincode": "176046",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nagrota Bagwan",
            "Pincode": "176047",
            "City": "Nagrota Bagwan",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jahu",
            "Pincode": "176048",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Maharai",
            "Pincode": "176049",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Pathiar",
            "Pincode": "176050",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Raja Ka Talab",
            "Pincode": "176051",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Yol Camp",
            "Pincode": "176052",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Fatehpur",
            "Pincode": "176053",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Baroh",
            "Pincode": "176054",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Thill",
            "Pincode": "176055",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dari",
            "Pincode": "176057",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dadh",
            "Pincode": "176058",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chachian",
            "Pincode": "176059",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Darang",
            "Pincode": "176060",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Palampur",
            "Pincode": "176061",
            "City": "Palampur",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Agriculture University Campus",
            "Pincode": "176062",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Palampur",
            "Pincode": "176062",
            "City": "Palampur",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Banuri",
            "Pincode": "176063",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "176064",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rajhoon",
            "Pincode": "176065",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dagoh",
            "Pincode": "176074",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Degoh",
            "Pincode": "176074",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Duhak",
            "Pincode": "176075",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bawana",
            "Pincode": "176076",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Alhilal Taragarh",
            "Pincode": "176081",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bawarna",
            "Pincode": "176083",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Naura",
            "Pincode": "176084",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sullah",
            "Pincode": "176085",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Khera",
            "Pincode": "176086",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Pahra",
            "Pincode": "176087",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chadiar",
            "Pincode": "176088",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Molag",
            "Pincode": "176089",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sandhole",
            "Pincode": "176090",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sanghole",
            "Pincode": "176091",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Daroh",
            "Pincode": "176092",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Malkher",
            "Pincode": "176093",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jailag",
            "Pincode": "176094",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jai Singpur",
            "Pincode": "176095",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Lambagraon",
            "Pincode": "176096",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dheera",
            "Pincode": "176101",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Marenda",
            "Pincode": "176102",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Panchrukhi",
            "Pincode": "176103",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Thurai",
            "Pincode": "176107",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhaleth",
            "Pincode": "176108",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sujanpur Tira",
            "Pincode": "176110",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Patlendar",
            "Pincode": "176111",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Paprola",
            "Pincode": "176115",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Joginder Nagar",
            "Pincode": "176120",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Joginder Ngr",
            "Pincode": "176120",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Shanan Power Hse",
            "Pincode": "176120",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Paddhar",
            "Pincode": "176121",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Barote",
            "Pincode": "176122",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Drubbal",
            "Pincode": "176123",
            "City": "Mandi",
            "District": "Mandi",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Baij Nath",
            "Pincode": "176125",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ladobharol",
            "Pincode": "176126",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Khopa",
            "Pincode": "176127",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chobin",
            "Pincode": "176128",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Pukhri",
            "Pincode": "176139",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jassur",
            "Pincode": "176201",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nurpur",
            "Pincode": "176202",
            "City": "Nurpur",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ladrori",
            "Pincode": "176203",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gangtha",
            "Pincode": "176204",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kotla",
            "Pincode": "176205",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Shahpur",
            "Pincode": "176206",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sihaunta",
            "Pincode": "176207",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rait",
            "Pincode": "176208",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gaggal",
            "Pincode": "176209",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Harchakian",
            "Pincode": "176210",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Saliali",
            "Pincode": "176211",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bagli",
            "Pincode": "176212",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rajol",
            "Pincode": "176213",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Teara",
            "Pincode": "176214",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dharamsala",
            "Pincode": "176215",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "District Cts Dharamsala",
            "Pincode": "176215",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kotwali Bzr Dharamsala",
            "Pincode": "176215",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dharamsala Cantt",
            "Pincode": "176216",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Charri",
            "Pincode": "176217",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Khanyara",
            "Pincode": "176218",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Meclodganj",
            "Pincode": "176219",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ghandwal",
            "Pincode": "176220",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tiara",
            "Pincode": "176221",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rehlu",
            "Pincode": "176222",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Draman",
            "Pincode": "176223",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tilokpur",
            "Pincode": "176225",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bakloh",
            "Pincode": "176301",
            "City": "Bakloh",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chowari",
            "Pincode": "176302",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dalhousie",
            "Pincode": "176304",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dalhousie S B",
            "Pincode": "176304",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dalhousie Cantt",
            "Pincode": "176305",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bathari Bazar",
            "Pincode": "176306",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chamba",
            "Pincode": "176310",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rangmehal",
            "Pincode": "176310",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mehla",
            "Pincode": "176311",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sundla",
            "Pincode": "176312",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kakiru",
            "Pincode": "176313",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sultanpur",
            "Pincode": "176314",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bharmour",
            "Pincode": "176315",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhanjrau Tissa",
            "Pincode": "176316",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Surargni",
            "Pincode": "176317",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Hardaspur",
            "Pincode": "176318",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rukhri",
            "Pincode": "176319",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Salooni",
            "Pincode": "176320",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Khajjar",
            "Pincode": "176321",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kiani",
            "Pincode": "176322",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Killar Pangi",
            "Pincode": "176323",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gehra",
            "Pincode": "176324",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sarol",
            "Pincode": "176325",
            "City": "Chamba",
            "District": "Chamba",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Indora",
            "Pincode": "176401",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kandrori",
            "Pincode": "176402",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Damtal",
            "Pincode": "176403",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dhamtal",
            "Pincode": "176403",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mothli",
            "Pincode": "176404",
            "City": "Dharamasala",
            "District": "Kangra",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sansarpur Terrace",
            "Pincode": "176501",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dulehar",
            "Pincode": "176601",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhali",
            "Pincode": "176626",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Chwk Hamirpur",
            "Pincode": "177001",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Hamirpur",
            "Pincode": "177001",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Govt Degree Clg Hamirpur",
            "Pincode": "177005",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Janiari",
            "Pincode": "177006",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Thaniari",
            "Pincode": "177006",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Behni",
            "Pincode": "177007",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kuthera",
            "Pincode": "177020",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bagwara",
            "Pincode": "177021",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Uhal",
            "Pincode": "177022",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tauni Devi",
            "Pincode": "177023",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhareri",
            "Pincode": "177024",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kanjian",
            "Pincode": "177025",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Galore",
            "Pincode": "177026",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kot",
            "Pincode": "177027",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kakkar",
            "Pincode": "177028",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Lambloo",
            "Pincode": "177029",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mohin",
            "Pincode": "177030",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Raipur",
            "Pincode": "177031",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mandli",
            "Pincode": "177032",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nadaun",
            "Pincode": "177033",
            "City": "Nadaun",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Pirsalohi",
            "Pincode": "177034",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Awahdevi",
            "Pincode": "177035",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sera",
            "Pincode": "177038",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Takoli",
            "Pincode": "177039",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kangoo",
            "Pincode": "177040",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dhaneta",
            "Pincode": "177041",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Jalari",
            "Pincode": "177042",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rakkar",
            "Pincode": "177043",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bara",
            "Pincode": "177044",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Rail",
            "Pincode": "177045",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sadhial",
            "Pincode": "177046",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Deotsidh",
            "Pincode": "177047",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Barmana",
            "Pincode": "177048",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dehra Gopipur",
            "Pincode": "177101",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kiroha",
            "Pincode": "177102",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kohala",
            "Pincode": "177102",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dhaliara",
            "Pincode": "177103",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nehran Pokher",
            "Pincode": "177104",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Thore",
            "Pincode": "177105",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Dada Siba",
            "Pincode": "177106",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Paragpur",
            "Pincode": "177107",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Garli",
            "Pincode": "177108",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bharwain",
            "Pincode": "177109",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chintpurni",
            "Pincode": "177110",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Qasba Kotla",
            "Pincode": "177111",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Tipri",
            "Pincode": "177112",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chanaur",
            "Pincode": "177113",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bankhandi",
            "Pincode": "177114",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gummer",
            "Pincode": "177116",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sunehat",
            "Pincode": "177117",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Chalele",
            "Pincode": "177118",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gagret",
            "Pincode": "177201",
            "City": "Gagret",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Mubarikpur",
            "Pincode": "177202",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Amb",
            "Pincode": "177203",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Daulatpur Chowk",
            "Pincode": "177204",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ambota",
            "Pincode": "177205",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Oel",
            "Pincode": "177206",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Pandoga",
            "Pincode": "177207",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Panjawar",
            "Pincode": "177208",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Saloh",
            "Pincode": "177209",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Nehri Narangan",
            "Pincode": "177210",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Thathal",
            "Pincode": "177211",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ghanauri",
            "Pincode": "177212",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Gondpur Banera",
            "Pincode": "177213",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Lohara",
            "Pincode": "177214",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bansal",
            "Pincode": "177215",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kungret",
            "Pincode": "177216",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Palhwah",
            "Pincode": "177217",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bhadsali",
            "Pincode": "177218",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Sunkalai",
            "Pincode": "177219",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Haroli",
            "Pincode": "177220",
            "City": "Una",
            "District": "Una",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "A G S Office",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bakshinagar",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Campus",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Darbar Garh",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dhounthly Bazar",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "General Bus Stand",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jammu Market",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jammu Motel",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jammu Tawi",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jammu University",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kachi Chawni",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Karan Nagar",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Krishna Nagar",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Link Road",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "New Secretariat",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Old Hospital Rd",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pirmitha",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Raghunath Bazar",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Shaid Chowk",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Shakti Nagar",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Vinayak Bazar",
            "Pincode": "180001",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Talab Tiloo",
            "Pincode": "180002",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "180003",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jammu Cantt",
            "Pincode": "180003",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jammu Tawi",
            "Pincode": "180003",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "180004",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Guru Nanak Nagar",
            "Pincode": "180004",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jammu Tawi",
            "Pincode": "180004",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Transport Yard",
            "Pincode": "180004",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Trikuta Nagarrly Stn",
            "Pincode": "180004",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jammu Motel",
            "Pincode": "180005",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Karan Nagar",
            "Pincode": "180005",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kotle Colono",
            "Pincode": "180005",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Puran Nagar",
            "Pincode": "180005",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Qilla Bahu",
            "Pincode": "180005",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rehadi",
            "Pincode": "180005",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Subhash Nagar",
            "Pincode": "180005",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jamipura",
            "Pincode": "180007",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ghoman Hassan",
            "Pincode": "180008",
            "City": "Samba",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bohr Camp",
            "Pincode": "180009",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Gangyal",
            "Pincode": "180010",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sainik Coloney",
            "Pincode": "180011",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sheri Kashmir Police",
            "Pincode": "180011",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Training Centre",
            "Pincode": "180011",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Udrana",
            "Pincode": "180221",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Miran Sahib",
            "Pincode": "181101",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "R S Pura Bus Stnd",
            "Pincode": "181102",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rambir Singh Pora",
            "Pincode": "181102",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Badyal",
            "Pincode": "181103",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Brahamana",
            "Pincode": "181103",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Simbal Camp",
            "Pincode": "181104",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rattian",
            "Pincode": "181105",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dablehar",
            "Pincode": "181111",
            "City": "Ranbirsinghpora",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rathana",
            "Pincode": "181112",
            "City": "Ranbirsinghpora",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Chakrohi",
            "Pincode": "181113",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Khour Deviani",
            "Pincode": "181114",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Plaura",
            "Pincode": "181121",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bhalwal",
            "Pincode": "181122",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bantalab",
            "Pincode": "181123",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "B S F Camp Palora",
            "Pincode": "181124",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Muthi Camp",
            "Pincode": "181124",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Plaura B S F Camp",
            "Pincode": "181124",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Arnia",
            "Pincode": "181131",
            "City": "Arnia",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bishnah",
            "Pincode": "181132",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bishnah Adda",
            "Pincode": "181132",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bari Brahmana",
            "Pincode": "181133",
            "City": "Bari Brahmana",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Industrial Complex",
            "Pincode": "181133",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jakh",
            "Pincode": "181134",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ramgarh",
            "Pincode": "181141",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Gho Brahamana",
            "Pincode": "181142",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Gurah Salathian",
            "Pincode": "181143",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Nand Pora",
            "Pincode": "181144",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Purmandal",
            "Pincode": "181145",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Raika",
            "Pincode": "181151",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Gandhi Nagar Jt",
            "Pincode": "181152",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Akhnoor Adda",
            "Pincode": "181201",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jourian",
            "Pincode": "181202",
            "City": "Jourian",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Khour",
            "Pincode": "181203",
            "City": "Khour",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pallanwala",
            "Pincode": "181204",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Chhamb",
            "Pincode": "181205",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dumana",
            "Pincode": "181206",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pragwal",
            "Pincode": "181207",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Halqa",
            "Pincode": "181208",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Hamirpur",
            "Pincode": "181209",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sidhar",
            "Pincode": "181209",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kothjhajjar",
            "Pincode": "181212",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Nagarota",
            "Pincode": "181221",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Tikri",
            "Pincode": "181223",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dansal",
            "Pincode": "181224",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mukerji Rd",
            "Pincode": "182101",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Shakti Nagar",
            "Pincode": "182101",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Udhampur",
            "Pincode": "182101",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Udhampur Courts",
            "Pincode": "182101",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "P T S",
            "Pincode": "182103",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Tahab",
            "Pincode": "182104",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Udhampur",
            "Pincode": "182104",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Garhi",
            "Pincode": "182121",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rambal",
            "Pincode": "182121",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ram Nagar",
            "Pincode": "182122",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kirmchi",
            "Pincode": "182123",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jaganoo",
            "Pincode": "182124",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mir",
            "Pincode": "182125",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Roan",
            "Pincode": "182126",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Majouri",
            "Pincode": "182128",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Chenani",
            "Pincode": "182141",
            "City": "Chenani",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kud",
            "Pincode": "182142",
            "City": "Kud",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Batote",
            "Pincode": "182143",
            "City": "Batote",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ramban",
            "Pincode": "182144",
            "City": "Ramban",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ramsu",
            "Pincode": "182145",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Banihal",
            "Pincode": "182146",
            "City": "Banihal",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sudh Mahadev",
            "Pincode": "182160",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mantalai",
            "Pincode": "182161",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Puldoda",
            "Pincode": "182201",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Doda",
            "Pincode": "182202",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jama Masjid",
            "Pincode": "182202",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Thatri",
            "Pincode": "182203",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kishtwar",
            "Pincode": "182204",
            "City": "Kishtwar",
            "District": "Badgam",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Medical College",
            "Pincode": "182205",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ari",
            "Pincode": "182215",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ghat",
            "Pincode": "182220",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bhderwah",
            "Pincode": "182222",
            "City": "Doda",
            "District": "Doda",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Katra",
            "Pincode": "182301",
            "City": "Katra",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Vaishno Devi",
            "Pincode": "182302",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Reasi",
            "Pincode": "182311",
            "City": "Reasi",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jyotipuram",
            "Pincode": "182312",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Arnas",
            "Pincode": "182313",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pavanpuram",
            "Pincode": "182314",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mahore",
            "Pincode": "182315",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Talwara Coloney",
            "Pincode": "182320",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kathua",
            "Pincode": "184101",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Krishen Nagar",
            "Pincode": "184101",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Parlawand",
            "Pincode": "184101",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "184102",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kathua",
            "Pincode": "184102",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Janglot",
            "Pincode": "184103",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kathua",
            "Pincode": "184104",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Vijay Pur",
            "Pincode": "184120",
            "City": "Vijay Pur",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Samba",
            "Pincode": "184121",
            "City": "Samba",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Samba Adda",
            "Pincode": "184121",
            "City": "Jammu",
            "District": "Jammu",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ghagwal",
            "Pincode": "184141",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Hira Nagar",
            "Pincode": "184142",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Barwal",
            "Pincode": "184143",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dialachak",
            "Pincode": "184144",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rajpora",
            "Pincode": "184145",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dingam Amb",
            "Pincode": "184146",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Chhan Rorian",
            "Pincode": "184147",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sanjimore",
            "Pincode": "184148",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Parole",
            "Pincode": "184151",
            "City": "Parole",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Lakhanpur",
            "Pincode": "184152",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Basoli",
            "Pincode": "184201",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mahanpur",
            "Pincode": "184202",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bhaddu",
            "Pincode": "184203",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Billiwar",
            "Pincode": "184204",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ramkot",
            "Pincode": "184205",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bane",
            "Pincode": "184206",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Khog",
            "Pincode": "184207",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bhoond",
            "Pincode": "184208",
            "City": "Kathua",
            "District": "Kathua",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Poonch",
            "Pincode": "185101",
            "City": "Poonch",
            "District": "Poonch",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Poonch Fort",
            "Pincode": "185101",
            "City": "Poonch",
            "District": "Poonch",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kala Kot",
            "Pincode": "185102",
            "City": "Poonch",
            "District": "Poonch",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mandi",
            "Pincode": "185120",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Samote",
            "Pincode": "185121",
            "City": "Poonch",
            "District": "Poonch",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Draba",
            "Pincode": "185122",
            "City": "Poonch",
            "District": "Poonch",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Loran",
            "Pincode": "185123",
            "City": "Poonch",
            "District": "Poonch",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rajouri",
            "Pincode": "185131",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jawahir Nagar",
            "Pincode": "185132",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Budhal",
            "Pincode": "185133",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Chowkichowra",
            "Pincode": "185134",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dologra",
            "Pincode": "185134",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Durhat Malkan",
            "Pincode": "185135",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ketranka",
            "Pincode": "185136",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Naoshehra",
            "Pincode": "185151",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Lamberi",
            "Pincode": "185152",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sunderbani",
            "Pincode": "185153",
            "City": "Sunderbani",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bhawani",
            "Pincode": "185155",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kangri",
            "Pincode": "185156",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Thandapani",
            "Pincode": "185157",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rajouri",
            "Pincode": "185158",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Seeri",
            "Pincode": "185159",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Solki",
            "Pincode": "185201",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Poni",
            "Pincode": "185203",
            "City": "Udhampur",
            "District": "Udhampur",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dharamsal",
            "Pincode": "185211",
            "City": "Poonch",
            "District": "Poonch",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mendhar",
            "Pincode": "185211",
            "City": "Poonch",
            "District": "Poonch",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Thana Mandi",
            "Pincode": "185212",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Barote",
            "Pincode": "185213",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Harni",
            "Pincode": "185214",
            "City": "Rajouri",
            "District": "Rajouri",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Amira Kadal",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Badiyar Bala",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Court Road",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Durganagh",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Habba Kadal",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Lal Chowk",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Nehru Park",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sathoo",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sk Sub Fagn Post",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Srinagar G P O",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "T R Centre",
            "Pincode": "190001",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Fateh Kadal",
            "Pincode": "190002",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Jamia Masjid",
            "Pincode": "190002",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Narwara",
            "Pincode": "190002",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Nawa Bazar",
            "Pincode": "190002",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Safa Kadal",
            "Pincode": "190002",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Shamswari",
            "Pincode": "190002",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sriranbir Gunj",
            "Pincode": "190002",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kathidarwaza",
            "Pincode": "190003",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Khanyar",
            "Pincode": "190003",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rainawari",
            "Pincode": "190003",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Batwara",
            "Pincode": "190004",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Santnagar",
            "Pincode": "190005",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kashmir University",
            "Pincode": "190006",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Naseem Bagh",
            "Pincode": "190006",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Srinagar Airport",
            "Pincode": "190007",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Srinagar",
            "Pincode": "190008",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Adda Batmaloo",
            "Pincode": "190009",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Central Market",
            "Pincode": "190009",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rambagh",
            "Pincode": "190009",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Srinagar Sectt",
            "Pincode": "190009",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Karan Nagar",
            "Pincode": "190010",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kastigarh",
            "Pincode": "190010",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Lal Bazar",
            "Pincode": "190011",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Naoshera",
            "Pincode": "190011",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Zainakot",
            "Pincode": "190012",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Hyderpura",
            "Pincode": "190014",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Natipora",
            "Pincode": "190015",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pandech",
            "Pincode": "190016",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Parimpora",
            "Pincode": "190017",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pandrethan",
            "Pincode": "191101",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Panthachok",
            "Pincode": "191101",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Parole",
            "Pincode": "191101",
            "City": "Parole",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Wuyan",
            "Pincode": "191102",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Khrew",
            "Pincode": "191103",
            "City": "Khrew",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Khunmoh",
            "Pincode": "191104",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Badgam",
            "Pincode": "191111",
            "City": "Badgam",
            "District": "Badgam",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Charari Sharif",
            "Pincode": "191112",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Chadoora",
            "Pincode": "191113",
            "City": "Badgam",
            "District": "Badgam",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kralapora",
            "Pincode": "191114",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kralpora",
            "Pincode": "191114",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Wathora",
            "Pincode": "191115",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ichgam",
            "Pincode": "191116",
            "City": "Badgam",
            "District": "Badgam",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Brein",
            "Pincode": "191121",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Harwan",
            "Pincode": "191123",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Tullmulla",
            "Pincode": "191131",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Palpora",
            "Pincode": "191141",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ganderbal",
            "Pincode": "191201",
            "City": "Ganderbal",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kangan",
            "Pincode": "191202",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sonamarg",
            "Pincode": "191203",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sonawari",
            "Pincode": "191203",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Nuner",
            "Pincode": "191204",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dodar Hama",
            "Pincode": "191205",
            "City": "Srinagar",
            "District": "Srinagar",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Anantnag",
            "Pincode": "192101",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Anantnag City",
            "Pincode": "192101",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Maindi Kadal",
            "Pincode": "192101",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sarnal Janglat Mandi",
            "Pincode": "192101",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Khanabai",
            "Pincode": "192102",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pampora",
            "Pincode": "192121",
            "City": "Pulwana",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Awantipora",
            "Pincode": "192122",
            "City": "Awantipora",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Tral",
            "Pincode": "192123",
            "City": "Tral",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bijbehara",
            "Pincode": "192124",
            "City": "Bijbehara",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Martand",
            "Pincode": "192125",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mini Sectt",
            "Pincode": "192125",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Amarnath Ji Yatra",
            "Pincode": "192126",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Chandanwari",
            "Pincode": "192126",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pahalgam",
            "Pincode": "192126",
            "City": "Pahalgam",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Panchtarni",
            "Pincode": "192126",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ayshmuqam",
            "Pincode": "192127",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Majalta",
            "Pincode": "192127",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Nanil",
            "Pincode": "192128",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Seer Kanilgund",
            "Pincode": "192129",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Batagund",
            "Pincode": "192141",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mandura",
            "Pincode": "192142",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dadsor",
            "Pincode": "192143",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Damhal",
            "Pincode": "192143",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Gairo",
            "Pincode": "192144",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Gouripora",
            "Pincode": "192145",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Achabal",
            "Pincode": "192201",
            "City": "Achabal",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kokar Nag",
            "Pincode": "192202",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sagam",
            "Pincode": "192203",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Akingam",
            "Pincode": "192204",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dailgam",
            "Pincode": "192210",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Doru",
            "Pincode": "192211",
            "City": "Badgam",
            "District": "Badgam",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Varinag",
            "Pincode": "192212",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Larkipora",
            "Pincode": "192213",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Fatehpura",
            "Pincode": "192214",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Qazigund",
            "Pincode": "192221",
            "City": "Qazigund",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Qaimoh",
            "Pincode": "192230",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kulgam",
            "Pincode": "192231",
            "City": "Kulgam",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Yaripora",
            "Pincode": "192232",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Hanjipora",
            "Pincode": "192233",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Hanad Chowlgam",
            "Pincode": "192234",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pulwama",
            "Pincode": "192301",
            "City": "Pulwana",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Shopian",
            "Pincode": "192303",
            "City": "Pulwana",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Karalpora",
            "Pincode": "192304",
            "City": "Pulwana",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Achan",
            "Pincode": "192305",
            "City": "Pulwama",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Malang Pora",
            "Pincode": "192306",
            "City": "Pulwama",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pinglina",
            "Pincode": "192307",
            "City": "Pulwana",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Shadipora",
            "Pincode": "192308",
            "City": "Pulwana",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ratnipora",
            "Pincode": "192309",
            "City": "Pulwana",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Srigofara",
            "Pincode": "192401",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Veeri",
            "Pincode": "192403",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kamilwan",
            "Pincode": "192404",
            "City": "Anantnag",
            "District": "Anantnag",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Baramulla",
            "Pincode": "193101",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rajghat",
            "Pincode": "193101",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Raj Ghat",
            "Pincode": "193102",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Khabaji Bagh",
            "Pincode": "193103",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kheri",
            "Pincode": "193103",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Singh Pora Kalan",
            "Pincode": "193105",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Delina",
            "Pincode": "193106",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ushkara",
            "Pincode": "193107",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Khan Pora",
            "Pincode": "193108",
            "City": "Badgam",
            "District": "Badgam",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Wagoora",
            "Pincode": "193109",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Pattan",
            "Pincode": "193121",
            "City": "Pattan",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mohora",
            "Pincode": "193122",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Uri",
            "Pincode": "193123",
            "City": "Uri",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Buniyar",
            "Pincode": "193124",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Gantamulla",
            "Pincode": "193124",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Nowshera",
            "Pincode": "193125",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Palhalan",
            "Pincode": "193130",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Haigam",
            "Pincode": "193131",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sangrama",
            "Pincode": "193132",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kreri",
            "Pincode": "193198",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Muslim Educational Tst",
            "Pincode": "193201",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sopore",
            "Pincode": "193201",
            "City": "Sopore",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sopore Chowk",
            "Pincode": "193201",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Metsopore",
            "Pincode": "193202",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Hadipora",
            "Pincode": "193208",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Doabgah",
            "Pincode": "193209",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Seer Jagir",
            "Pincode": "193211",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dangerpora",
            "Pincode": "193212",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bomai",
            "Pincode": "193220",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Hanjiwera",
            "Pincode": "193220",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Handwara",
            "Pincode": "193221",
            "City": "Handwara",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kupwara",
            "Pincode": "193222",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sogm",
            "Pincode": "193223",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Trehgam",
            "Pincode": "193224",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Tangdhar",
            "Pincode": "193225",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kralapora",
            "Pincode": "193226",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Zachaldara",
            "Pincode": "193227",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Drugmula",
            "Pincode": "193228",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Magam Handwara",
            "Pincode": "193228",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Maidan Chowgal",
            "Pincode": "193229",
            "City": "Kupwara",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Magam",
            "Pincode": "193230",
            "City": "Magam",
            "District": "Kupwara",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Rohama",
            "Pincode": "193301",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Hawal",
            "Pincode": "193302",
            "City": "Pulwama",
            "District": "Pulwana",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Langet",
            "Pincode": "193302",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Dingiwacha",
            "Pincode": "193303",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Tang Marg",
            "Pincode": "193402",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Gulmarg",
            "Pincode": "193403",
            "City": "Gulmarg",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kunzer",
            "Pincode": "193404",
            "City": "Kunzer",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Beerwah",
            "Pincode": "193411",
            "City": "Beerwah",
            "District": "Badgam",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sumbal",
            "Pincode": "193501",
            "City": "Sumbal",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bandipora",
            "Pincode": "193502",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Bandipur Chowk",
            "Pincode": "193502",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Safapora",
            "Pincode": "193504",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ajas",
            "Pincode": "193505",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kalusa",
            "Pincode": "193506",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kandoli",
            "Pincode": "193506",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Nadihal",
            "Pincode": "193507",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Alusa",
            "Pincode": "193508",
            "City": "Baramulla",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Hajan",
            "Pincode": "193509",
            "City": "Hajan",
            "District": "Baramulla",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Leh",
            "Pincode": "194101",
            "City": "Leh",
            "District": "Leh",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Drass",
            "Pincode": "194102",
            "City": "Kargil",
            "District": "Kargil",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Kargil",
            "Pincode": "194103",
            "City": "Kargil",
            "District": "Kargil",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Choglamsar",
            "Pincode": "194104",
            "City": "Leh",
            "District": "Leh",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Baroo",
            "Pincode": "194105",
            "City": "Kargil",
            "District": "Kargil",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Khaltsi",
            "Pincode": "194106",
            "City": "Leh",
            "District": "Leh",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Mulbith",
            "Pincode": "194109",
            "City": "Kargil",
            "District": "Kargil",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Thiksay",
            "Pincode": "194201",
            "City": "Leh",
            "District": "Leh",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Sankoo",
            "Pincode": "194301",
            "City": "Kargil",
            "District": "Kargil",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Padam Zanskar",
            "Pincode": "194302",
            "City": "Leh",
            "District": "Leh",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Diskit",
            "Pincode": "194401",
            "City": "Leh",
            "District": "Leh",
            "State": "Jammu & Kashmir"
        },
        {
            "PostOfficeName": "Ghaziabad",
            "Pincode": "201001",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kavinagar",
            "Pincode": "201002",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meerut Road",
            "Pincode": "201003",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hindon Air Field",
            "Pincode": "201004",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malaknagar",
            "Pincode": "201005",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chikamberpur",
            "Pincode": "201006",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohan Nagar",
            "Pincode": "201007",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bharat Nagar",
            "Pincode": "201008",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhoor Bharat Nagar",
            "Pincode": "201009",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dasna Gate",
            "Pincode": "201009",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghaziabad City",
            "Pincode": "201009",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Model Town",
            "Pincode": "201009",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mukundnagar",
            "Pincode": "201009",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "201009",
            "City": "Ramnagar",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandra Nagar",
            "Pincode": "201011",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghaziabad",
            "Pincode": "201011",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amrit Nagar",
            "Pincode": "201012",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khaekra",
            "Pincode": "201101",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Loni",
            "Pincode": "201102",
            "City": "Loni",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Govindpur",
            "Pincode": "201201",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harmukhpur",
            "Pincode": "201201",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Modinagar",
            "Pincode": "201204",
            "City": "Modinagar",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karwi R S",
            "Pincode": "201205",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karwl",
            "Pincode": "201205",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohiuddinpur",
            "Pincode": "201205",
            "City": "Mohiuddinpur",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muradnagar",
            "Pincode": "201206",
            "City": "Muradnagar",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muradnagar Town",
            "Pincode": "201206",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Noida Complex",
            "Pincode": "201301",
            "City": "Gautam Buddha Nagar",
            "District": "Gautam Buddha Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hindon Nagar",
            "Pincode": "201302",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Estate",
            "Pincode": "201303",
            "City": "Gautam Buddha Nagar",
            "District": "Gautam Buddha Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jain Indstiral",
            "Pincode": "201303",
            "City": "Gautam Buddha Nagar",
            "District": "Gautam Buddha Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maharishi Nagar",
            "Pincode": "201304",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aligarh",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aligarh",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aligarh City",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aligarh Industrial Estate",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bandhu Subash Road",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Banna Devi",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Civil Courts",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "D S College",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Darwaza",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dodhpur",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Forms Press",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "G E H",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaiganj",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Labaria",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madar",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahabirganj",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manik Chowk",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muslim University",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Naurangabad",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Polytechnic",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramghat Road",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rasalganj",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Khirni",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Kutub",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saraj",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarni Gate",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shikshak",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "T R M M",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Upperkot",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Vishnupuri",
            "Pincode": "202001",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhanjpur",
            "Pincode": "202117",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kalai",
            "Pincode": "202118",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barla",
            "Pincode": "202119",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pilkhana",
            "Pincode": "202120",
            "City": "Pilkhana",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Akradbad",
            "Pincode": "202121",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aligarh Dairy Farm",
            "Pincode": "202122",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gonda",
            "Pincode": "202123",
            "City": "Gonda",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Iglas",
            "Pincode": "202124",
            "City": "Iglas",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jawan",
            "Pincode": "202126",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kasimpur",
            "Pincode": "202127",
            "City": "Chandauli",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalali Aligarh",
            "Pincode": "202128",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kauriaganj",
            "Pincode": "202129",
            "City": "Kauriaganj",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chharra",
            "Pincode": "202130",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandaus",
            "Pincode": "202132",
            "City": "Etah",
            "District": "Etah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dadon",
            "Pincode": "202133",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gangiri",
            "Pincode": "202134",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gomat",
            "Pincode": "202135",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gabhana",
            "Pincode": "202136",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jattari",
            "Pincode": "202137",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khair",
            "Pincode": "202138",
            "City": "Khair",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khairmandi",
            "Pincode": "202138",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "K G Works",
            "Pincode": "202139",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lodha",
            "Pincode": "202140",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dayal Nagar",
            "Pincode": "202141",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Birpura",
            "Pincode": "202142",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Somna",
            "Pincode": "202143",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kasimpur",
            "Pincode": "202144",
            "City": "Chandauli",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New Colony",
            "Pincode": "202144",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baswan",
            "Pincode": "202145",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sathini",
            "Pincode": "202146",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pali Razapur",
            "Pincode": "202150",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bijauli",
            "Pincode": "202151",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Medrak",
            "Pincode": "202151",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pisawah",
            "Pincode": "202155",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tappal",
            "Pincode": "202165",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Luhsan",
            "Pincode": "202171",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Atrauli",
            "Pincode": "202280",
            "City": "Atrauli",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kshatropara",
            "Pincode": "202280",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhoom Singh Joshimath",
            "Pincode": "202281",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jiruli",
            "Pincode": "202281",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malviyanagar",
            "Pincode": "202282",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhoom",
            "Pincode": "202308",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Na P P",
            "Pincode": "202389",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Narora",
            "Pincode": "202389",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Township",
            "Pincode": "202389",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Anupshahr",
            "Pincode": "202390",
            "City": "Anupshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chhattari",
            "Pincode": "202391",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Danpur",
            "Pincode": "202392",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dibai",
            "Pincode": "202393",
            "City": "Dibai",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jahangirabad Bulandshahr",
            "Pincode": "202394",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jahangirabad Mandi",
            "Pincode": "202394",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shikarpur",
            "Pincode": "202395",
            "City": "Shikarpur",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pahasu",
            "Pincode": "202396",
            "City": "Pahasu",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Narora",
            "Pincode": "202397",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Unchagaon",
            "Pincode": "202398",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahjoi",
            "Pincode": "202410",
            "City": "Bahjoi",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bilari",
            "Pincode": "202411",
            "City": "Bilari",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bara Bazar",
            "Pincode": "202412",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandausi",
            "Pincode": "202412",
            "City": "Chandausi",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandousi R S",
            "Pincode": "202412",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kundarki",
            "Pincode": "202413",
            "City": "Kundarki",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Narauli",
            "Pincode": "202414",
            "City": "Narauli",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raja-Ka-Sahaspur",
            "Pincode": "202415",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Majhole",
            "Pincode": "202416",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babrala",
            "Pincode": "202521",
            "City": "Babrala",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gunnaur",
            "Pincode": "202522",
            "City": "Gunnaur",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Islam Nagar",
            "Pincode": "202523",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rudian",
            "Pincode": "202524",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saidpur",
            "Pincode": "202525",
            "City": "Saidpur",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Wazirganj",
            "Pincode": "202526",
            "City": "Wazirganj",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajpura",
            "Pincode": "202527",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chhibramau",
            "Pincode": "202721",
            "City": "Chhibramau",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bulandshahar",
            "Pincode": "203001",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bulandshahar",
            "Pincode": "203001",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deputy Ganj",
            "Pincode": "203001",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Krishna Nagar",
            "Pincode": "203001",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "203001",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tehsil",
            "Pincode": "203001",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Agricultural School Buland",
            "Pincode": "203121",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karora",
            "Pincode": "203129",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "G D Road",
            "Pincode": "203131",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khurja",
            "Pincode": "203131",
            "City": "Khurja",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khurja Chowk",
            "Pincode": "203131",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Subhash Road",
            "Pincode": "203131",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khurja Jn R S",
            "Pincode": "203132",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jewar",
            "Pincode": "203133",
            "City": "Jewar",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jahangirpur",
            "Pincode": "203141",
            "City": "Jahangirpur",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Panninagar",
            "Pincode": "203145",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sakhari Nagar",
            "Pincode": "203150",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Thora",
            "Pincode": "203155",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dankaur",
            "Pincode": "203201",
            "City": "Dankaur",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gurkul Sikandrabad",
            "Pincode": "203202",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kakore",
            "Pincode": "203203",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kayasthwara",
            "Pincode": "203205",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sikandrabad",
            "Pincode": "203205",
            "City": "Sikandrabad",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dadri",
            "Pincode": "203207",
            "City": "Dadri",
            "District": "Gautam Buddha Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hathras",
            "Pincode": "204101",
            "City": "Hathras",
            "District": "Hathras",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hathras City Ind Estate",
            "Pincode": "204101",
            "City": "Hathras",
            "District": "Hathras",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanya Gurkul",
            "Pincode": "204101",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Labour Colony",
            "Pincode": "204101",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandi",
            "Pincode": "204101",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathura",
            "Pincode": "204101",
            "City": "Mathura",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nayaganj",
            "Pincode": "204101",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hathras Jn R S",
            "Pincode": "204102",
            "City": "Hathras",
            "District": "Hathras",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Arjunpur",
            "Pincode": "204103",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanth",
            "Pincode": "204104",
            "City": "Kanth",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meru",
            "Pincode": "204105",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pora",
            "Pincode": "204205",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanau",
            "Pincode": "204206",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jawar",
            "Pincode": "204207",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gadola",
            "Pincode": "204208",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhekuri",
            "Pincode": "204209",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Agsoli",
            "Pincode": "204210",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kachuura",
            "Pincode": "204211",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hasayan",
            "Pincode": "204212",
            "City": "Hasayan",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mursan",
            "Pincode": "204213",
            "City": "Mursan",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Purdilpur",
            "Pincode": "204214",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Najmandi",
            "Pincode": "204215",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sikandrarao",
            "Pincode": "204215",
            "City": "Hathras",
            "District": "Hathras",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "204216",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sasni",
            "Pincode": "204216",
            "City": "Sasni",
            "District": "Hathras",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gola Bazar",
            "Pincode": "205001",
            "City": "Gola Bazar",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karhalgate",
            "Pincode": "205001",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Labour Colony",
            "Pincode": "205001",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mainpuri",
            "Pincode": "205001",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mainpuri City",
            "Pincode": "205001",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajaki Bazaria",
            "Pincode": "205001",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tindauli",
            "Pincode": "205119",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ajitganj",
            "Pincode": "205120",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghiror",
            "Pincode": "205121",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ekka",
            "Pincode": "205122",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jasrana",
            "Pincode": "205125",
            "City": "Jasrana",
            "District": "Firozabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Parham",
            "Pincode": "205130",
            "City": "Aligarh",
            "District": "Aligarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bara Bazar",
            "Pincode": "205135",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shikohabad",
            "Pincode": "205135",
            "City": "Shikohabad",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madhoganj",
            "Pincode": "205141",
            "City": "Madhoganj",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shikohabad R S",
            "Pincode": "205141",
            "City": "Firozabad",
            "District": "Firozabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pariar",
            "Pincode": "205142",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Makhanpur",
            "Pincode": "205145",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Phariha",
            "Pincode": "205147",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sirsaganj",
            "Pincode": "205151",
            "City": "Sirsaganj",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Eatms",
            "Pincode": "205231",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barnahal",
            "Pincode": "205261",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhogaon",
            "Pincode": "205262",
            "City": "Bhogaon",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Town Hall",
            "Pincode": "205262",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jeonti",
            "Pincode": "205263",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karhal",
            "Pincode": "205264",
            "City": "Karhal",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kuraoli",
            "Pincode": "205265",
            "City": "Kuraoli",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nabiganj",
            "Pincode": "205266",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sultanganj",
            "Pincode": "205267",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kurra",
            "Pincode": "205268",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Aghat",
            "Pincode": "205301",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nimkarori",
            "Pincode": "205302",
            "City": "Mainpuri",
            "District": "Mainpuri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bazaria",
            "Pincode": "206001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "College Road",
            "Pincode": "206001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "District Board",
            "Pincode": "206001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Etawah",
            "Pincode": "206001",
            "City": "Etawah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Etawah",
            "Pincode": "206001",
            "City": "Etawah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Etawah City",
            "Pincode": "206001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Etawah New City",
            "Pincode": "206001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "206001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Satyawadi",
            "Pincode": "206001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Etawah",
            "Pincode": "206002",
            "City": "Etawah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Industrial Trainging Institute",
            "Pincode": "206002",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramlila Road",
            "Pincode": "206003",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "H A D Lucknow",
            "Pincode": "206013",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aheripur",
            "Pincode": "206120",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ajitmal",
            "Pincode": "206121",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Auraiya",
            "Pincode": "206122",
            "City": "Auraiya",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tiloknagar",
            "Pincode": "206122",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barlokpur",
            "Pincode": "206123",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bakewar",
            "Pincode": "206124",
            "City": "Bakewar",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chakra Nagar",
            "Pincode": "206125",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ekdil",
            "Pincode": "206126",
            "City": "Ekdil",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lakhna",
            "Pincode": "206127",
            "City": "Lakhna",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandir Mahewa",
            "Pincode": "206128",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muradganj",
            "Pincode": "206129",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malhausi",
            "Pincode": "206130",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Udi",
            "Pincode": "206131",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Achalda",
            "Pincode": "206241",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bharthana",
            "Pincode": "206242",
            "City": "Bharthana",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bidhuna",
            "Pincode": "206243",
            "City": "Bidhuna",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dibiapur",
            "Pincode": "206244",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanchausi Bazar",
            "Pincode": "206246",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Phaphaund",
            "Pincode": "206247",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahar",
            "Pincode": "206248",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ruruganj",
            "Pincode": "206249",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harchandpur",
            "Pincode": "206250",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bela",
            "Pincode": "206251",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Katna",
            "Pincode": "206252",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basrehar",
            "Pincode": "206253",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaswantnagar",
            "Pincode": "206254",
            "City": "Jaswantnagar",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaswantnagar Bazar",
            "Pincode": "206254",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bewar",
            "Pincode": "206301",
            "City": "Bewar",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kishni",
            "Pincode": "206302",
            "City": "Kishni",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kusmara",
            "Pincode": "206303",
            "City": "Kusmara",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohammadabad",
            "Pincode": "206451",
            "City": "Mohammadabad",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Arunanagar",
            "Pincode": "207001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Brahm",
            "Pincode": "207001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Etah",
            "Pincode": "207001",
            "City": "Etah",
            "District": "Etah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Market",
            "Pincode": "207001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sajiwan",
            "Pincode": "207001",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saket",
            "Pincode": "207121",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kalan",
            "Pincode": "207122",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nidhauli",
            "Pincode": "207122",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kasganj",
            "Pincode": "207123",
            "City": "Kasganj",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bilaram",
            "Pincode": "207124",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirechi",
            "Pincode": "207125",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kartala",
            "Pincode": "207126",
            "City": "Etah",
            "District": "Etah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amanpur",
            "Pincode": "207241",
            "City": "Amanpur",
            "District": "Chitrakoot",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ganj",
            "Pincode": "207242",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Patiali",
            "Pincode": "207243",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raja-Ka-Rampur",
            "Pincode": "207244",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahawar",
            "Pincode": "207245",
            "City": "Sahawar",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sirhpura",
            "Pincode": "207246",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aliganj",
            "Pincode": "207247",
            "City": "Aliganj",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhumari",
            "Pincode": "207248",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaithra",
            "Pincode": "207249",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Awagarh",
            "Pincode": "207301",
            "City": "Awagarh",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalesar Town",
            "Pincode": "207302",
            "City": "Etah",
            "District": "Etah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Marehra",
            "Pincode": "207401",
            "City": "Marehra",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Neoli",
            "Pincode": "207402",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Soran",
            "Pincode": "207403",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Badaria",
            "Pincode": "207404",
            "City": "Etwah",
            "District": "Etwah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nawabganj",
            "Pincode": "207501",
            "City": "Nawabganj",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "College Road",
            "Pincode": "207502",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fanga Darwara",
            "Pincode": "207502",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kalmganj",
            "Pincode": "207502",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Railway Road",
            "Pincode": "207502",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shamshabad",
            "Pincode": "207503",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manjhama",
            "Pincode": "207504",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "B N Shula & Sons",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Birhana Road",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Coloneganj",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Cotton Mills",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhankutti",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Elgin Mills",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fahimabad",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Farash Khana",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Filkhana",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gwal Toli",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kallumal Street",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanpur",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Gautam Buddha Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanpur Chowk",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanpur Courts",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanpur West",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muir Mills",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Navin Market",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nayaganj",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pratap Press",
            "Pincode": "208001",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Agricultural College",
            "Pincode": "208002",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Arya Nagar Employment Exch",
            "Pincode": "208002",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gsvm Medical College",
            "Pincode": "208002",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Motijheel",
            "Pincode": "208002",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nawabganj",
            "Pincode": "208002",
            "City": "Nawabganj",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New Civil Lines",
            "Pincode": "208002",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Swaroopnagar",
            "Pincode": "208002",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Anwarganj",
            "Pincode": "208003",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chakeri Ad",
            "Pincode": "208003",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Cotton Mills",
            "Pincode": "208003",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Swadeshi",
            "Pincode": "208003",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Cambridge Road",
            "Pincode": "208004",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanpur Cantt",
            "Pincode": "208004",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khapra Mahal",
            "Pincode": "208004",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirpur Cantt",
            "Pincode": "208004",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Napler Road",
            "Pincode": "208004",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nornhas Exchange",
            "Pincode": "208004",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "H N S Nagar",
            "Pincode": "208005",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarvoday Nagar",
            "Pincode": "208005",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Vijainagar",
            "Pincode": "208005",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Govind Nagari",
            "Pincode": "208006",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Govind Nagari West",
            "Pincode": "208006",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Gram",
            "Pincode": "208007",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harijinder Nagar",
            "Pincode": "208007",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Krishna Nagar",
            "Pincode": "208007",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shewans",
            "Pincode": "208010",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tannery",
            "Pincode": "208010",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babupurwa",
            "Pincode": "208011",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kidwainagar",
            "Pincode": "208011",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Munshipurwa",
            "Pincode": "208011",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ashok Nagar Chauki-Jarib",
            "Pincode": "208012",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chauki Jarib",
            "Pincode": "208012",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "208012",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kaushlapuri",
            "Pincode": "208012",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Oil Mills Industrial Esta",
            "Pincode": "208012",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ram Krishna Nagar",
            "Pincode": "208012",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rambagh",
            "Pincode": "208012",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sisamau",
            "Pincode": "208012",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "C O D Kanpur",
            "Pincode": "208013",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Juhi Colony",
            "Pincode": "208014",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New P A C Lines",
            "Pincode": "208015",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "I I T Kanpur",
            "Pincode": "208016",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "N S I Kanpur",
            "Pincode": "208017",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kalyanpur",
            "Pincode": "208018",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rawatpur",
            "Pincode": "208019",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Panki Power House",
            "Pincode": "208020",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hamirpur Road",
            "Pincode": "208021",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Naubasta",
            "Pincode": "208021",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Udyognagar",
            "Pincode": "208022",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanpur",
            "Pincode": "208023",
            "City": "Kanpur",
            "District": "Gautam Buddha Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Transportnagar",
            "Pincode": "208023",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanpur University",
            "Pincode": "208024",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Railganj",
            "Pincode": "208024",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Navin Nagar",
            "Pincode": "208025",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Armapur",
            "Pincode": "208039",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Armapur Estate",
            "Pincode": "208039",
            "City": "Armapur Estate",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Akbarpur",
            "Pincode": "209101",
            "City": "Akbarpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pukhrayan",
            "Pincode": "209111",
            "City": "Pukhrayan",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amraudha",
            "Pincode": "209112",
            "City": "Amraudha",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "209115",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarwan Khera",
            "Pincode": "209121",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanpur",
            "Pincode": "209125",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bithoor",
            "Pincode": "209201",
            "City": "Bithoor",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bithaur",
            "Pincode": "209202",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chabeypur",
            "Pincode": "209203",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sheoli",
            "Pincode": "209204",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sheorajpur",
            "Pincode": "209205",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghatampur",
            "Pincode": "209206",
            "City": "Ghatampur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadar Bazar",
            "Pincode": "209206",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Majhawan",
            "Pincode": "209207",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Musanagar",
            "Pincode": "209208",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bari",
            "Pincode": "209209",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhitargaon",
            "Pincode": "209209",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Darapur",
            "Pincode": "209301",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rura",
            "Pincode": "209303",
            "City": "Rura",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Schendi",
            "Pincode": "209304",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chakarpur",
            "Pincode": "209305",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rasulabad",
            "Pincode": "209306",
            "City": "Rasulabad",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhorpur",
            "Pincode": "209307",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhinjhak",
            "Pincode": "209320",
            "City": "Jhinjhak",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Narwal",
            "Pincode": "209401",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarsaul",
            "Pincode": "209402",
            "City": "Kanpur",
            "District": "Kanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barhpur",
            "Pincode": "209601",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bazaza Bazar",
            "Pincode": "209601",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Civil Lines",
            "Pincode": "209601",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehegarh",
            "Pincode": "209601",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehgarh",
            "Pincode": "209601",
            "City": "Fatehgarh",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehgarh",
            "Pincode": "209601",
            "City": "Fatehgarh",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehgarh R S",
            "Pincode": "209601",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery R R C",
            "Pincode": "209601",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Central Jail",
            "Pincode": "209602",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehgarh",
            "Pincode": "209602",
            "City": "Fatehgarh",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aligarh Fatehgarh",
            "Pincode": "209621",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amritpur",
            "Pincode": "209622",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Farrukhabad",
            "Pincode": "209625",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Farrukhabad R S",
            "Pincode": "209625",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lal Sarai",
            "Pincode": "209625",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lindsayganj",
            "Pincode": "209625",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathia Devi",
            "Pincode": "209625",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nehru Road",
            "Pincode": "209625",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gursahaiganj",
            "Pincode": "209722",
            "City": "Gursahaiganj",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Indergarh",
            "Pincode": "209723",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kamalganj",
            "Pincode": "209724",
            "City": "Kamalganj",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chipatti",
            "Pincode": "209725",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hari Nagar",
            "Pincode": "209725",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kannauj",
            "Pincode": "209725",
            "City": "Kannauj",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Samachar",
            "Pincode": "209725",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Makrandnagar",
            "Pincode": "209726",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Miran",
            "Pincode": "209727",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saurikh",
            "Pincode": "209728",
            "City": "Saurikh",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sikanderpur",
            "Pincode": "209729",
            "City": "Sikanderpur",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Talgram",
            "Pincode": "209731",
            "City": "Talgram",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tirwa",
            "Pincode": "209732",
            "City": "Kannauj",
            "District": "Kannauj",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalalabad Fategarh",
            "Pincode": "209733",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Thathia",
            "Pincode": "209734",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khairnagar",
            "Pincode": "209736",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Umarda",
            "Pincode": "209738",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jahanganj",
            "Pincode": "209739",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khimsepur",
            "Pincode": "209743",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bisungarh",
            "Pincode": "209770",
            "City": "Farukhabad",
            "District": "Farukhabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "209801",
            "City": "Unnao",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "S N College",
            "Pincode": "209801",
            "City": "Unnao",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Unnao",
            "Pincode": "209801",
            "City": "Unnao",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ajgain",
            "Pincode": "209821",
            "City": "Unnao",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maurawan",
            "Pincode": "209821",
            "City": "Maurawan",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Purwa",
            "Pincode": "209825",
            "City": "Purwa",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hasanganj",
            "Pincode": "209841",
            "City": "Unnao",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohan",
            "Pincode": "209851",
            "City": "Mohan",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nawabganj",
            "Pincode": "209859",
            "City": "Nawabganj",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gangaghat",
            "Pincode": "209861",
            "City": "Gangaghat",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aliganj",
            "Pincode": "210001",
            "City": "Aliganj",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Banda",
            "Pincode": "210001",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Banda",
            "Pincode": "210001",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Banda City",
            "Pincode": "210001",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chhoti Bazar",
            "Pincode": "210001",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ketchery",
            "Pincode": "210001",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Structuralaini",
            "Pincode": "210101",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Triveni",
            "Pincode": "210101",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khurhand R S",
            "Pincode": "210120",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baberu",
            "Pincode": "210121",
            "City": "Baberu",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chillatara",
            "Pincode": "210123",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kamasin",
            "Pincode": "210125",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pailani",
            "Pincode": "210126",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tindwari",
            "Pincode": "210128",
            "City": "Tindwari",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Naraini",
            "Pincode": "210129",
            "City": "Naraini",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Attarra",
            "Pincode": "210201",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Badausa",
            "Pincode": "210202",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bisanda",
            "Pincode": "210203",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chitrakote",
            "Pincode": "210204",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajapur",
            "Pincode": "210205",
            "City": "Rajapur",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pahari",
            "Pincode": "210206",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manikpur",
            "Pincode": "210208",
            "City": "Manikpur",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mauchibu",
            "Pincode": "210209",
            "City": "Banda",
            "District": "Banda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hamirpur",
            "Pincode": "210301",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hamirpur Dist Board",
            "Pincode": "210301",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ingohta",
            "Pincode": "210321",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Charkhari State",
            "Pincode": "210421",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaria",
            "Pincode": "210422",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaitpur",
            "Pincode": "210423",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kabral",
            "Pincode": "210424",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kharela",
            "Pincode": "210425",
            "City": "Kharela",
            "District": "Mahoba",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kulphar",
            "Pincode": "210425",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahoba",
            "Pincode": "210427",
            "City": "Mahoba",
            "District": "Mahoba",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Majhgawan",
            "Pincode": "210428",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Panwari",
            "Pincode": "210429",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rath Kot Bazar",
            "Pincode": "210431",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarila State",
            "Pincode": "210432",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Srinagar",
            "Pincode": "210433",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gohaud",
            "Pincode": "210434",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bewar",
            "Pincode": "210501",
            "City": "Bewar",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barwa",
            "Pincode": "210502",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sumer Pur",
            "Pincode": "210502",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khanna",
            "Pincode": "210504",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kurara",
            "Pincode": "210505",
            "City": "Kurara",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muskira",
            "Pincode": "210506",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ragaul",
            "Pincode": "210507",
            "City": "Hamirpur",
            "District": "Hamirpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahabad",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahabad",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahabad High Court",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahabad New Cantt",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "C D A",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kayasth",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Leader Press",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Leader Road",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "M G Marg",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahila",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malaka",
            "Pincode": "211001",
            "City": "Kaushambi",
            "District": "Kaushambi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pathshala",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Prayag",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Public Service Commission",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Purshotamnagar",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Secretariat",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Subedarganj",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sulemsaraj",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Vidyapith",
            "Pincode": "211001",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahabad",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahabad University",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allenganj",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amitco",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "District Board",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "George Town",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hindi Press",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Indian Press",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Katra",
            "Pincode": "211002",
            "City": "Katra",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Prayag",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Prayag Street",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajapur",
            "Pincode": "211002",
            "City": "Rajapur",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ranipur",
            "Pincode": "211002",
            "City": "Ranipur",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Subhashnagar",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tagore Town",
            "Pincode": "211002",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ahmedganj",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahabad City",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Attarsuiya",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aushadhalaya",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahadurganj Chowk",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Daryabad",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Himkalyan",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hindi Sahitya",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kalyani Devi",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Katghar",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kerela Bagh Colony",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Krishnanagar",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muthiganj",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nehrunagar",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New Bairhana",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sammelan",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sant Ravidas Marg",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tirathraj",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Vivekanand Marg",
            "Pincode": "211003",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Cavalri Lines",
            "Pincode": "211004",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harijan Ashram",
            "Pincode": "211004",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "M L N Engg College",
            "Pincode": "211004",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahabad Fort",
            "Pincode": "211005",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahapur",
            "Pincode": "211006",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Alopi Bagh",
            "Pincode": "211006",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basti Khurd",
            "Pincode": "211006",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Daraganj",
            "Pincode": "211006",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sobatia Bagh",
            "Pincode": "211006",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Agricultural Institue",
            "Pincode": "211007",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Labour Colony",
            "Pincode": "211008",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Naini Industrial",
            "Pincode": "211008",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhoomanganj",
            "Pincode": "211011",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bamrauli",
            "Pincode": "211012",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bamrauli Airport",
            "Pincode": "211012",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Phaphamau",
            "Pincode": "211013",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "C D A",
            "Pincode": "211014",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Began Sarain",
            "Pincode": "211015",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bharatganj",
            "Pincode": "212104",
            "City": "Bharatganj",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chheoki",
            "Pincode": "212105",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jari Bazar",
            "Pincode": "212106",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jasra",
            "Pincode": "212107",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shankargarh",
            "Pincode": "212108",
            "City": "Shankargarh",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sikandra",
            "Pincode": "212109",
            "City": "Sikandra",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bharwari",
            "Pincode": "212201",
            "City": "Bharwari",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chail",
            "Pincode": "212202",
            "City": "Chail",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Charwa",
            "Pincode": "212203",
            "City": "Kaushambi",
            "District": "Kaushambi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dara Nagar",
            "Pincode": "212204",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kara",
            "Pincode": "212205",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karari",
            "Pincode": "212206",
            "City": "Karari",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manjhampur",
            "Pincode": "212207",
            "City": "Kaushambi",
            "District": "Kaushambi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manauri",
            "Pincode": "212208",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manauri Air Force",
            "Pincode": "212212",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahgaon",
            "Pincode": "212213",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pachhim",
            "Pincode": "212214",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarira",
            "Pincode": "212214",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahazadpur",
            "Pincode": "212215",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Akil",
            "Pincode": "212216",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sirathu",
            "Pincode": "212217",
            "City": "Sirathu",
            "District": "Kaushambi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tilhapur",
            "Pincode": "212218",
            "City": "Kaushambi",
            "District": "Kaushambi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karchana",
            "Pincode": "212301",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meja",
            "Pincode": "212302",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meja Road",
            "Pincode": "212303",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nahwal",
            "Pincode": "212304",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarsa",
            "Pincode": "212305",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Koreon",
            "Pincode": "212306",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Janghai Bazar",
            "Pincode": "212401",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Phulpur",
            "Pincode": "212402",
            "City": "Phulpur",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Mawrez",
            "Pincode": "212403",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghiya Nagar",
            "Pincode": "212404",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Keolariya",
            "Pincode": "212410",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mau-Aima",
            "Pincode": "212501",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Soraon",
            "Pincode": "212502",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sewaith",
            "Pincode": "212503",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aboonagar",
            "Pincode": "212601",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandiana",
            "Pincode": "212601",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehpur",
            "Pincode": "212601",
            "City": "Fatehpur",
            "District": "Ambedkar Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehpur City",
            "Pincode": "212601",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehpur Court",
            "Pincode": "212601",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehpur Town",
            "Pincode": "212601",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hariharganj",
            "Pincode": "212601",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghazipur",
            "Pincode": "212621",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahrampur",
            "Pincode": "212622",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amauli",
            "Pincode": "212631",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bindki",
            "Pincode": "212635",
            "City": "Bindki",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhata",
            "Pincode": "212641",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Haswa",
            "Pincode": "212645",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hathgaon",
            "Pincode": "212652",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Erayan",
            "Pincode": "212653",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jamraon",
            "Pincode": "212654",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khaga",
            "Pincode": "212655",
            "City": "Khaga",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khakreru",
            "Pincode": "212656",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khajuha",
            "Pincode": "212657",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kishanpur",
            "Pincode": "212658",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Korajahanabad",
            "Pincode": "212659",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lalauli",
            "Pincode": "212661",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahna",
            "Pincode": "212663",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malwa",
            "Pincode": "212664",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mauhar",
            "Pincode": "212665",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Halipura",
            "Pincode": "213113",
            "City": "Fatehpur",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harduaganj",
            "Pincode": "220325",
            "City": "Harduaganj",
            "District": "Fatehpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "A G Palace",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "221001",
            "City": "Aurangabad",
            "District": "Jyotiba Phule Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "B E L P & Co",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basat College",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bengali Tola",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhelupura",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chaukhamba",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chetganj",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Cpo A-2041",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dasasumedh",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "G D Karyalaya",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaighet",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Garwasi Tola",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hanuman",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hanumangha",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ishwar Gangi",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaitpura",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kabir Chaura",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kamachha",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kashi",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kashi R S",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kedar Ghat",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khojwa Bazar",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Laxa",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madanpura",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahamandal",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandir",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mata Kund",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Naya Chowk",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pathak",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "R B Katra",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramapura",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sanskrit University",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarwa Sewa Sangh",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shivala",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Varanasi",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Varanasi City",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Vishwanath",
            "Pincode": "221001",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ardali Bazar",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhjubir",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Clark Hotel",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Englishia Line",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kashi",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lahartara",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nadesar",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pisnaharia",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sigra",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Varanasi",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Varanasi Cantt",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Vidyapith",
            "Pincode": "221002",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sheopur",
            "Pincode": "221003",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Varanasi",
            "Pincode": "221003",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "D L W Varanasi",
            "Pincode": "221004",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Assi",
            "Pincode": "221005",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Durga Kund",
            "Pincode": "221005",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lanka",
            "Pincode": "221005",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malviya Nagar",
            "Pincode": "221005",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Varanasi Hindu Universiy",
            "Pincode": "221005",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babatpur Aeordrome",
            "Pincode": "221006",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarnath",
            "Pincode": "221007",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "P A C Ramnagar",
            "Pincode": "221008",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "221008",
            "City": "Ramnagar",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahupuri",
            "Pincode": "221009",
            "City": "Chandauli",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahmmorganj",
            "Pincode": "221010",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Cholapur",
            "Pincode": "221101",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kusta Ashram",
            "Pincode": "221102",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandaudih",
            "Pincode": "221103",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chaubeypur",
            "Pincode": "221104",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harhua",
            "Pincode": "221105",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Industrial Est Varanasi",
            "Pincode": "221106",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barla",
            "Pincode": "221107",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Losta",
            "Pincode": "221107",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bullanpur",
            "Pincode": "221108",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "P A C",
            "Pincode": "221108",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bajardhiha",
            "Pincode": "221109",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basant Nagar",
            "Pincode": "221110",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barthara Kalan",
            "Pincode": "221111",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chiraigaow",
            "Pincode": "221112",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhorhara",
            "Pincode": "221113",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mustafabad",
            "Pincode": "221115",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tanda Kalan",
            "Pincode": "221115",
            "City": "Chandauli",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sikrara",
            "Pincode": "221131",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Anai",
            "Pincode": "221201",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babatpur R S",
            "Pincode": "221202",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baragaon",
            "Pincode": "221204",
            "City": "Baragaon",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Phulpur",
            "Pincode": "221205",
            "City": "Phulpur",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pindra",
            "Pincode": "221206",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kathiraon",
            "Pincode": "221207",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sighaura",
            "Pincode": "221208",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Akorha",
            "Pincode": "221209",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Asar",
            "Pincode": "221210",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kawakpur",
            "Pincode": "221211",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aurai",
            "Pincode": "221301",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gangapur",
            "Pincode": "221302",
            "City": "Gangapur",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gopiganj",
            "Pincode": "221303",
            "City": "Gopiganj",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gyanpur",
            "Pincode": "221304",
            "City": "Gyanpur",
            "District": "Sant Ravidas Nagar Bhadohi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jakhni",
            "Pincode": "221305",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khamaria",
            "Pincode": "221306",
            "City": "Khamaria",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirza Murad",
            "Pincode": "221307",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ozh",
            "Pincode": "221308",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Koirana",
            "Pincode": "221309",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jangiganj",
            "Pincode": "221310",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raja Talab",
            "Pincode": "221311",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bichiya",
            "Pincode": "221312",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jagatpur",
            "Pincode": "221314",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maharaj Ganj",
            "Pincode": "221314",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhadohi",
            "Pincode": "221401",
            "City": "Bhadohi",
            "District": "Sant Ravidas Nagar Bhadohi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Parsipur",
            "Pincode": "221402",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sewapuri",
            "Pincode": "221403",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Suriyawan",
            "Pincode": "221404",
            "City": "Suriyawan",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hathi Bazar",
            "Pincode": "221405",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mondh",
            "Pincode": "221406",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barha Bazar",
            "Pincode": "221407",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hathi Bazar",
            "Pincode": "221408",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nai Bazar",
            "Pincode": "221409",
            "City": "Nai Bazar",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kachwa",
            "Pincode": "221501",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baraut",
            "Pincode": "221502",
            "City": "Baraut",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Handia",
            "Pincode": "221503",
            "City": "Handia",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Handia Tech Institute",
            "Pincode": "221504",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hanumanganj",
            "Pincode": "221505",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhusi",
            "Pincode": "221506",
            "City": "Jhusi",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahson",
            "Pincode": "221507",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saidabad",
            "Pincode": "221508",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dubari",
            "Pincode": "221601",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maryadpur",
            "Pincode": "221602",
            "City": "Chitrakoot",
            "District": "Chitrakoot",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madhuban",
            "Pincode": "221603",
            "City": "Chitrakoot",
            "District": "Chitrakoot",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chilkahar",
            "Pincode": "221701",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Haldharpur",
            "Pincode": "221705",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ratanpura",
            "Pincode": "221706",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Garhamalpur",
            "Pincode": "221709",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nagra",
            "Pincode": "221711",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rasra",
            "Pincode": "221712",
            "City": "Rasra",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rasta Town",
            "Pincode": "221712",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chitbaragaon",
            "Pincode": "221713",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karon",
            "Pincode": "221714",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bilthra Road R S",
            "Pincode": "221715",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kidihadapur",
            "Pincode": "221716",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Navanagar",
            "Pincode": "221717",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khandwa",
            "Pincode": "221718",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Thakdewri",
            "Pincode": "221719",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lbrahimpattri",
            "Pincode": "221720",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sanwarh",
            "Pincode": "221721",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kotwari",
            "Pincode": "221722",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "College Colony",
            "Pincode": "222001",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaunpur",
            "Pincode": "222001",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pukhta Sarai",
            "Pincode": "222001",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rasmandal",
            "Pincode": "222001",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "T D College",
            "Pincode": "222001",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Umarpur",
            "Pincode": "222001",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaunpur",
            "Pincode": "222002",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "222002",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Belwai",
            "Pincode": "222101",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baragaon",
            "Pincode": "222102",
            "City": "Baragaon",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Trilochan",
            "Pincode": "222102",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar With Marwa",
            "Pincode": "222103",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kuddupur",
            "Pincode": "222104",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ram Dayalganj",
            "Pincode": "222105",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dharwapur",
            "Pincode": "222107",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baksa",
            "Pincode": "222108",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nau Pawa",
            "Pincode": "222109",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "I I T Siddiqpur",
            "Pincode": "222110",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghanshyampur",
            "Pincode": "222111",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Khwaja",
            "Pincode": "222112",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mani Kalan",
            "Pincode": "222113",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Badiapur",
            "Pincode": "222125",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Banreri",
            "Pincode": "222127",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "222128",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Naurahya",
            "Pincode": "222128",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandwak",
            "Pincode": "222129",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehganj",
            "Pincode": "222132",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaurabadshahpur",
            "Pincode": "222133",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ahorwa",
            "Pincode": "222135",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhawani",
            "Pincode": "222135",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gulzarganj",
            "Pincode": "222135",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalalpur Jaunpur",
            "Pincode": "222136",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jamalpur",
            "Pincode": "222137",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kajgaon",
            "Pincode": "222138",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kherisarai",
            "Pincode": "222139",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Harkhoo",
            "Pincode": "222141",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kirarat",
            "Pincode": "222142",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Machhlishahar",
            "Pincode": "222143",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maharajganj",
            "Pincode": "222145",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutirchakey",
            "Pincode": "222146",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Leorua",
            "Pincode": "222148",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "S R G Degree College Dobh",
            "Pincode": "222149",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mariahu",
            "Pincode": "222161",
            "City": "Mariahu",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barsathi",
            "Pincode": "222162",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirganj",
            "Pincode": "222165",
            "City": "Mirganj",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muftiganj",
            "Pincode": "222170",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pasara",
            "Pincode": "222172",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Singhramau",
            "Pincode": "222175",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Zafrabad",
            "Pincode": "222180",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Balwarganj",
            "Pincode": "222201",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mungrabadshahpur",
            "Pincode": "222202",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "222203",
            "City": "Rampur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pushpnagar",
            "Pincode": "222226",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Koiripur",
            "Pincode": "222301",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lambhua",
            "Pincode": "222302",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maharanj",
            "Pincode": "222303",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pacchim",
            "Pincode": "222303",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bark Ara",
            "Pincode": "222304",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahganj",
            "Pincode": "223101",
            "City": "Shahganj",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahganj S Mill",
            "Pincode": "223101",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Patti Narendra",
            "Pincode": "223102",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohiuddin",
            "Pincode": "223103",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai",
            "Pincode": "223103",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khutahan",
            "Pincode": "223104",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Soetha Kalan",
            "Pincode": "223105",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarpata Bara",
            "Pincode": "223106",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pilkichha",
            "Pincode": "223107",
            "City": "Jaunpur",
            "District": "Jaunpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ahraula",
            "Pincode": "223221",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ambari",
            "Pincode": "223222",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Atraulia",
            "Pincode": "223223",
            "City": "Atraulia",
            "District": "Sant Kabir Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Didarganj",
            "Pincode": "223224",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahul",
            "Pincode": "223225",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sanjarpur",
            "Pincode": "223227",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Faizabad",
            "Pincode": "224001",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Faizabad City",
            "Pincode": "224001",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Faizabad Kutchery",
            "Pincode": "224001",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Faizabad R S",
            "Pincode": "224001",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehganj",
            "Pincode": "224001",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Qandhari Bazar",
            "Pincode": "224001",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Record Cmp",
            "Pincode": "224001",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadar Bazar",
            "Pincode": "224001",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahebganj",
            "Pincode": "224001",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amaniganj",
            "Pincode": "224121",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Akbarpur",
            "Pincode": "224122",
            "City": "Akbarpur",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahzadpur",
            "Pincode": "224122",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ayodhya",
            "Pincode": "224123",
            "City": "Ayodhya",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramkot",
            "Pincode": "224123",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bandipur",
            "Pincode": "224125",
            "City": "Hathras",
            "District": "Hathras",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baragaon",
            "Pincode": "224126",
            "City": "Baragaon",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baru",
            "Pincode": "224127",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baskhari",
            "Pincode": "224129",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhiti",
            "Pincode": "224132",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dabhasomar",
            "Pincode": "224133",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deoria",
            "Pincode": "224137",
            "City": "Deoria",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dulhupur",
            "Pincode": "224139",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Goshaiinganj",
            "Pincode": "224141",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Teleagargh",
            "Pincode": "224141",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hanswar",
            "Pincode": "224143",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Iltifatganj",
            "Pincode": "224145",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jahangirganj",
            "Pincode": "224147",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalalpur",
            "Pincode": "224149",
            "City": "Jalalpur",
            "District": "Ambedkar Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Katehri",
            "Pincode": "224151",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mijhaura",
            "Pincode": "224152",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khandasa",
            "Pincode": "224153",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kichhauchha",
            "Pincode": "224155",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khemapur",
            "Pincode": "224157",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malipur",
            "Pincode": "224159",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maya",
            "Pincode": "224161",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Milkipur",
            "Pincode": "224164",
            "City": "Chandauli",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mittoopur",
            "Pincode": "224166",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meharuagala",
            "Pincode": "224167",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pahitipur",
            "Pincode": "224168",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pura",
            "Pincode": "224171",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rasulabad",
            "Pincode": "224172",
            "City": "Rasulabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajeshultanpur",
            "Pincode": "224175",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "224181",
            "City": "Ramnagar",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raunahi",
            "Pincode": "224182",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deorhi",
            "Pincode": "224183",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahganj",
            "Pincode": "224184",
            "City": "Shahganj",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sikanderpur",
            "Pincode": "224186",
            "City": "Sikanderpur",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shohawal R S",
            "Pincode": "224188",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tanda",
            "Pincode": "224190",
            "City": "Tanda",
            "District": "Ambedkar Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tkari",
            "Pincode": "224195",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Indiapur",
            "Pincode": "224198",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Motinagar",
            "Pincode": "224201",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bharat Kund",
            "Pincode": "224202",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampur Bhagan",
            "Pincode": "224203",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bikapur",
            "Pincode": "224204",
            "City": "Bikapur",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kapradih",
            "Pincode": "224205",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khajurhat",
            "Pincode": "224206",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Majruddinpur",
            "Pincode": "224207",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harringtonganj",
            "Pincode": "224208",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chaurey Bazar",
            "Pincode": "224209",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bariayawan",
            "Pincode": "224210",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Janaura",
            "Pincode": "224211",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bawana",
            "Pincode": "224212",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bazar Bhiyaun",
            "Pincode": "224213",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kidarnagar",
            "Pincode": "224214",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhankabana",
            "Pincode": "224215",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Paikauli Bazar",
            "Pincode": "224216",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhaurauwa",
            "Pincode": "224217",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shivpal",
            "Pincode": "224218",
            "City": "Ambedkar Nagar",
            "District": "Ambedkar Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kareek",
            "Pincode": "224219",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khaspur",
            "Pincode": "224220",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mukhdoom Nagar",
            "Pincode": "224221",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Katari",
            "Pincode": "224222",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Belgrra",
            "Pincode": "224223",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Laroon",
            "Pincode": "224223",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Makrahi",
            "Pincode": "224224",
            "City": "Faizabad",
            "District": "Faizabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Banki",
            "Pincode": "225001",
            "City": "Banki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barabanki",
            "Pincode": "225001",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barabanki Bazar",
            "Pincode": "225001",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barabanki City",
            "Pincode": "225001",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barabanki Collectorate",
            "Pincode": "225001",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barabanki Sugar Mills",
            "Pincode": "225001",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bara Banki Sugar Mills",
            "Pincode": "225002",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kothi",
            "Pincode": "225119",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Usmanpur",
            "Pincode": "225120",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harakh",
            "Pincode": "225121",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Satrikh",
            "Pincode": "225122",
            "City": "Satrikh",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Somaiyanagar",
            "Pincode": "225123",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bharamghat",
            "Pincode": "225201",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Burhwal Sugaj Mills",
            "Pincode": "225202",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jahangirabad Raj",
            "Pincode": "225203",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Masauli",
            "Pincode": "225204",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rambagar",
            "Pincode": "225205",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saadatganj",
            "Pincode": "225206",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dewa",
            "Pincode": "225301",
            "City": "Dewa",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kursi",
            "Pincode": "225302",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Suratganj",
            "Pincode": "225304",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tehsil Fatehpur",
            "Pincode": "225305",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aliabad",
            "Pincode": "225401",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Patranga R S",
            "Pincode": "225401",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhilsar",
            "Pincode": "225402",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Darshan Nagar",
            "Pincode": "225403",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Daryabad",
            "Pincode": "225403",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Daryabad R S",
            "Pincode": "225404",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hathaunda",
            "Pincode": "225405",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mawal",
            "Pincode": "225406",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirmau",
            "Pincode": "225407",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramsanehi Ghat",
            "Pincode": "225409",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Radauh Station Road",
            "Pincode": "225411",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Safdarganj",
            "Pincode": "225412",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sidhaur",
            "Pincode": "225413",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Zaidpur",
            "Pincode": "225414",
            "City": "Zaidpur",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tikaitnagar",
            "Pincode": "225415",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "A P Sabha",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Advacate",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aminabad Park",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Burlington Hotel",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Canal Colony",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Carlton Hotel",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Charbagh",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ganesh Ganj",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gokalemarg",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Golaganj",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gurdwara",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "H C Bench",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lalbagh",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Locomotive",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lucknow",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maulviganj",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "National Herald",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Naya Gaon",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New Ganeshganj",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pandaribad",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Secretariat",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shivaji Marg",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sunderbagh",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Wazirganj",
            "Pincode": "226001",
            "City": "Wazirganj",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Workshop",
            "Pincode": "226001",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Campbell Lines",
            "Pincode": "226002",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dilkusha",
            "Pincode": "226002",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dilkusha S B",
            "Pincode": "226002",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Military Hospital",
            "Pincode": "226002",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Neil Lines",
            "Pincode": "226002",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shia Lines",
            "Pincode": "226002",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Topkhana Bazar",
            "Pincode": "226002",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amberganj",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chaupatain",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dyer Meakin Road",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hasnain Market",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hina",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hussainabad",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lucknow Chowk",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mansoornagar",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Medical Coollege",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Naubasta",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raja Bazar",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saadatganj",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Mali Khan",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Takmil-Ul-Tib",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Thakurganj",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Yahiaganj",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Zarda",
            "Pincode": "226003",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aishbagh",
            "Pincode": "226004",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Arya Nagar",
            "Pincode": "226004",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Birhana Mill Road",
            "Pincode": "226004",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Blunt Square",
            "Pincode": "226004",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nadan Mahal Road",
            "Pincode": "226004",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New Labour Colony",
            "Pincode": "226004",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "S I Area",
            "Pincode": "226004",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarfaraz",
            "Pincode": "226004",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Victoria Ganj",
            "Pincode": "226004",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Adarsh Nagar",
            "Pincode": "226005",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Alambagh",
            "Pincode": "226005",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Anand Nagar",
            "Pincode": "226005",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "C & W Shop",
            "Pincode": "226005",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "C E School",
            "Pincode": "226005",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "District Jail",
            "Pincode": "226005",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "R G Cotton Mills",
            "Pincode": "226005",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "H E School",
            "Pincode": "226006",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahanagar",
            "Pincode": "226006",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New Colony",
            "Pincode": "226006",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "U I C Mills",
            "Pincode": "226006",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandganj",
            "Pincode": "226007",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Daliganj",
            "Pincode": "226007",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nadwa",
            "Pincode": "226007",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New Hyderabad",
            "Pincode": "226007",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Niralanagar",
            "Pincode": "226007",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nishatganj",
            "Pincode": "226007",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "R P Lines",
            "Pincode": "226007",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarojini Nagar",
            "Pincode": "226008",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aerodrome",
            "Pincode": "226009",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amausi",
            "Pincode": "226009",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghazipur",
            "Pincode": "226010",
            "City": "Ghazipur",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manaknagar",
            "Pincode": "226011",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "226012",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nd Bn",
            "Pincode": "226014",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pac Lucknow",
            "Pincode": "226014",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Thiry Second Bn",
            "Pincode": "226014",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarvodainagar Lucknow 15",
            "Pincode": "226015",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Misra",
            "Pincode": "226016",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nagar Lucknow",
            "Pincode": "226016",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ram Sagar",
            "Pincode": "226016",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Awas Vikas Colony",
            "Pincode": "226017",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aminabad",
            "Pincode": "226018",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aliganj Extension",
            "Pincode": "226020",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lucknow",
            "Pincode": "226020",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chaukia",
            "Pincode": "226106",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sheetla",
            "Pincode": "226106",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Banthra",
            "Pincode": "227101",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chinahat",
            "Pincode": "227105",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gomti Nagar",
            "Pincode": "227106",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malihabad",
            "Pincode": "227111",
            "City": "Malihabad",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mall",
            "Pincode": "227115",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rahimbad",
            "Pincode": "227116",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amethi",
            "Pincode": "227120",
            "City": "Amethi",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Goshainganj",
            "Pincode": "227125",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Goshainganj",
            "Pincode": "227125",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Trivediganj",
            "Pincode": "227131",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "U P Govt Camp Post Office",
            "Pincode": "227132",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "F F T C Indaurabagh",
            "Pincode": "227202",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Itauja",
            "Pincode": "227205",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bakshi Ka Talab Airport",
            "Pincode": "227208",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Haidergarh",
            "Pincode": "227301",
            "City": "Haidergarh",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Subeha",
            "Pincode": "227302",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohan Lalganj",
            "Pincode": "227305",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nagram",
            "Pincode": "227308",
            "City": "Nagram",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nigohan",
            "Pincode": "227309",
            "City": "Lucknow",
            "District": "Lucknow",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amethi",
            "Pincode": "227405",
            "City": "Amethi",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhadar",
            "Pincode": "227406",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bisesarganj",
            "Pincode": "227407",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhammaur",
            "Pincode": "227408",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gauriganj",
            "Pincode": "227409",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahgah",
            "Pincode": "227411",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kurwa Hal",
            "Pincode": "227412",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Industrial Estate Muzaffa",
            "Pincode": "227801",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sheoratanganj",
            "Pincode": "227802",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aliganj Bazar",
            "Pincode": "227805",
            "City": "Etah",
            "District": "Etah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bazar Baldi",
            "Pincode": "227806",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rai",
            "Pincode": "227806",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaura Jamon",
            "Pincode": "227807",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hasanpur",
            "Pincode": "227808",
            "City": "Hasanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jagdishpur",
            "Pincode": "227809",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shukul-Ka-Bazar",
            "Pincode": "227811",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Walipur",
            "Pincode": "227812",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Musafirkhana",
            "Pincode": "227813",
            "City": "Musafirkhana",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ataula",
            "Pincode": "227814",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Haliapur",
            "Pincode": "227815",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pindara",
            "Pincode": "227815",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raniganj",
            "Pincode": "227816",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jagdishpur",
            "Pincode": "227817",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bus Station",
            "Pincode": "228001",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Loco Colony",
            "Pincode": "228001",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sultanpur",
            "Pincode": "228001",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sultanpur",
            "Pincode": "228001",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sultanpur City",
            "Pincode": "228001",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sultanpur Civil Lines",
            "Pincode": "228001",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "K N I",
            "Pincode": "228118",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gosaiganj",
            "Pincode": "228119",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Atrasuma",
            "Pincode": "228121",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kamla Nehru Institute",
            "Pincode": "228124",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dwarikaganj",
            "Pincode": "228125",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dostpur",
            "Pincode": "228131",
            "City": "Dostpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deara",
            "Pincode": "228132",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Belhari",
            "Pincode": "228133",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaisinghapur",
            "Pincode": "228141",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahmoodpur",
            "Pincode": "228141",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Suri",
            "Pincode": "228141",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kadipur",
            "Pincode": "228145",
            "City": "Kadipur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kurebhar",
            "Pincode": "228151",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kurwar",
            "Pincode": "228155",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramganj",
            "Pincode": "228159",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tawakalpur Nagar",
            "Pincode": "228161",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Akhand Nagar",
            "Pincode": "228171",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baransa",
            "Pincode": "228820",
            "City": "Sultanpur",
            "District": "Sultanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amritnagar",
            "Pincode": "229001",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "229001",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rae Bareli",
            "Pincode": "229001",
            "City": "Rae Bareli",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rae Bareli",
            "Pincode": "229001",
            "City": "Rae Bareli",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rae Bareli Bus Stand",
            "Pincode": "229001",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Satyanagar",
            "Pincode": "229001",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Town Hall",
            "Pincode": "229001",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "I T I Rae Bareli",
            "Pincode": "229010",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aihar",
            "Pincode": "229121",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gurbuxganj",
            "Pincode": "229122",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hallaur",
            "Pincode": "229123",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karahiakabazar",
            "Pincode": "229124",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kathghat",
            "Pincode": "229125",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Semrauta",
            "Pincode": "229126",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Salon",
            "Pincode": "229127",
            "City": "Salon",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maharajganj",
            "Pincode": "229128",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Majarganj",
            "Pincode": "229128",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mejar Ganj",
            "Pincode": "229128",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Munsiganj",
            "Pincode": "229128",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Parasadipur",
            "Pincode": "229129",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chaubara",
            "Pincode": "229130",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malikma",
            "Pincode": "229130",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Behta",
            "Pincode": "229201",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhojpur",
            "Pincode": "229202",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dalmau",
            "Pincode": "229203",
            "City": "Dalmau",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaura",
            "Pincode": "229204",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khiron",
            "Pincode": "229205",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lalganj",
            "Pincode": "229206",
            "City": "Lalganj",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Murai-Ka-Bagh",
            "Pincode": "229207",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nihasta",
            "Pincode": "229208",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pahu",
            "Pincode": "229209",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Semri",
            "Pincode": "229211",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarent",
            "Pincode": "229212",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Modi Gram",
            "Pincode": "229215",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Purpandey",
            "Pincode": "229215",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chhiolah",
            "Pincode": "229216",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ratapur Chauraha",
            "Pincode": "229216",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bachhrawan",
            "Pincode": "229301",
            "City": "Bachhrawan",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fursatganj",
            "Pincode": "229302",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harchandpur",
            "Pincode": "229303",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harbansganj",
            "Pincode": "229304",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jais",
            "Pincode": "229305",
            "City": "Jais",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nasirabad",
            "Pincode": "229307",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sheogarh",
            "Pincode": "229308",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tiloi",
            "Pincode": "229309",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deeh",
            "Pincode": "229310",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahgon",
            "Pincode": "229311",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Itaura Buzurg",
            "Pincode": "229401",
            "City": "Mahoba",
            "District": "Mahoba",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jagatpur",
            "Pincode": "229402",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sakkardaha",
            "Pincode": "229403",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mustafabad",
            "Pincode": "229404",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muwsi Ganj",
            "Pincode": "229405",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhadri",
            "Pincode": "229406",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kunda",
            "Pincode": "229406",
            "City": "Kunda",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Garhi",
            "Pincode": "229407",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manikpur",
            "Pincode": "229407",
            "City": "Manikpur",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kala Kankar",
            "Pincode": "229408",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kaithola",
            "Pincode": "229410",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Anapur",
            "Pincode": "229411",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Atrampur",
            "Pincode": "229412",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lalgopalganj",
            "Pincode": "229413",
            "City": "Allahabad",
            "District": "Allahabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Agai",
            "Pincode": "229414",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maheshganj",
            "Pincode": "229415",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chhejapur",
            "Pincode": "229416",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mallawan",
            "Pincode": "229416",
            "City": "Mallawan",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mangarh",
            "Pincode": "229417",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barai",
            "Pincode": "229418",
            "City": "Kannauj",
            "District": "Kannauj",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pariyawan",
            "Pincode": "229419",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bara",
            "Pincode": "229501",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhagwant Nagar",
            "Pincode": "229502",
            "City": "Bhagwant Nagar",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bighalpur",
            "Pincode": "229503",
            "City": "Unnao",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bihar",
            "Pincode": "229504",
            "City": "Unnao",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Macandrewganj",
            "Pincode": "230001",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Paltan Bazar",
            "Pincode": "230001",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pratapgarh",
            "Pincode": "230001",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadar Bazar Station Road",
            "Pincode": "230001",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pratapgarh City",
            "Pincode": "230002",
            "City": "Pratapgarh City",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Afim-Ki-Kothi",
            "Pincode": "230122",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deo Daru",
            "Pincode": "230123",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deosasra",
            "Pincode": "230123",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amargarh",
            "Pincode": "230124",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ateha",
            "Pincode": "230125",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babuganj",
            "Pincode": "230126",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dalippur",
            "Pincode": "230127",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Derwa",
            "Pincode": "230128",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jethwara",
            "Pincode": "230129",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Laxmanpur",
            "Pincode": "230130",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Katramednigari",
            "Pincode": "230131",
            "City": "Raibareilly",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lalganj",
            "Pincode": "230132",
            "City": "Lalganj",
            "District": "Raibareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chajepur",
            "Pincode": "230133",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mallanwa",
            "Pincode": "230133",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Oriyadeeh",
            "Pincode": "230134",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Patti",
            "Pincode": "230135",
            "City": "Patti",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sagra",
            "Pincode": "230136",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahebganj",
            "Pincode": "230137",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saifabad",
            "Pincode": "230138",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sangipur",
            "Pincode": "230139",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Paharpur",
            "Pincode": "230140",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sangramgarh",
            "Pincode": "230141",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shitlaganj",
            "Pincode": "230142",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baliaganj",
            "Pincode": "230143",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ajgara",
            "Pincode": "230144",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kushwapur",
            "Pincode": "230145",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaura R S",
            "Pincode": "230301",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jamtali",
            "Pincode": "230302",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Printhiganj",
            "Pincode": "230303",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raniganj",
            "Pincode": "230304",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sansarpur",
            "Pincode": "230305",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Suhksa",
            "Pincode": "230306",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Konhdaur",
            "Pincode": "230401",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandhata",
            "Pincode": "230402",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madhoganj",
            "Pincode": "230403",
            "City": "Madhoganj",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Vishwanathganj",
            "Pincode": "230404",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Darehut",
            "Pincode": "230405",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hamerganj",
            "Pincode": "230406",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hanumanganj",
            "Pincode": "230406",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Antu",
            "Pincode": "230501",
            "City": "Antu",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Garwara",
            "Pincode": "230502",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kishanganj",
            "Pincode": "230503",
            "City": "Pratapgarh",
            "District": "Pratapgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahuwaria",
            "Pincode": "231001",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirzapur",
            "Pincode": "231001",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Welleslyganj",
            "Pincode": "231001",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ganesh Ganj Ind Estate",
            "Pincode": "231002",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Laldigi",
            "Pincode": "231002",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirzapur Chowk",
            "Pincode": "231002",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirzapur City",
            "Pincode": "231002",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muzaffarganj",
            "Pincode": "231002",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Putlighar",
            "Pincode": "231002",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chopan",
            "Pincode": "231205",
            "City": "Chopan",
            "District": "Sonbhadra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Churk",
            "Pincode": "231206",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dalla",
            "Pincode": "231207",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dudhi",
            "Pincode": "231208",
            "City": "Dudhi",
            "District": "Kushinagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gurma",
            "Pincode": "231209",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Markundi",
            "Pincode": "231209",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghorawal",
            "Pincode": "231210",
            "City": "Ghorawal",
            "District": "Sonbhadra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lalganj",
            "Pincode": "231211",
            "City": "Lalganj",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amawar",
            "Pincode": "231212",
            "City": "Sonbhadra",
            "District": "Sonbhadra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramgarh",
            "Pincode": "231213",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bichchi",
            "Pincode": "231214",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "231215",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Roberts Ganj",
            "Pincode": "231216",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Renukot",
            "Pincode": "231217",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Renusara",
            "Pincode": "231218",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Obra",
            "Pincode": "231219",
            "City": "Obra",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Obra Thermal",
            "Pincode": "231219",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bina Project",
            "Pincode": "231220",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Turra",
            "Pincode": "231221",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saktinagar",
            "Pincode": "231222",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bijpure",
            "Pincode": "231223",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "A T P S",
            "Pincode": "231225",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ahraura",
            "Pincode": "231301",
            "City": "Ahraura",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Adalhat",
            "Pincode": "231302",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bijaipur",
            "Pincode": "231303",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chunar",
            "Pincode": "231304",
            "City": "Chunar",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chunar Tehsil",
            "Pincode": "231304",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Narainpur",
            "Pincode": "231305",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sikhar",
            "Pincode": "231306",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kubaripatehra",
            "Pincode": "231309",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Marihana",
            "Pincode": "231310",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chunar Cement",
            "Pincode": "231311",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Factory",
            "Pincode": "231311",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chilh",
            "Pincode": "231312",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jamuwa",
            "Pincode": "231314",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Moghalsarai",
            "Pincode": "232101",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Railway Colony",
            "Pincode": "232101",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baburi",
            "Pincode": "232102",
            "City": "Chandauli",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chakia",
            "Pincode": "232103",
            "City": "Chakia",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandauli",
            "Pincode": "232104",
            "City": "Chandauli",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhanapur",
            "Pincode": "232105",
            "City": "Chandauli",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kamalpur",
            "Pincode": "232106",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramgarh",
            "Pincode": "232107",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sakaldiha",
            "Pincode": "232108",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sakaldiha Bazar",
            "Pincode": "232109",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sayedraja",
            "Pincode": "232110",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nowgarh",
            "Pincode": "232111",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Alinagar",
            "Pincode": "232112",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barhawi",
            "Pincode": "232113",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Balua",
            "Pincode": "232114",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bisauli",
            "Pincode": "232115",
            "City": "Bisauli",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chahaniya",
            "Pincode": "232116",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Niyamatabad",
            "Pincode": "232117",
            "City": "Chandauli",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahab Ganj",
            "Pincode": "232118",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahid Gaon",
            "Pincode": "232119",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadalpura",
            "Pincode": "232120",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Wyndhamganj",
            "Pincode": "232221",
            "City": "Mirzapur",
            "District": "Mirzapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bara",
            "Pincode": "232325",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dildarnagar",
            "Pincode": "232326",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dildarnagar Bazar",
            "Pincode": "232326",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gahmar",
            "Pincode": "232327",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Reotipur",
            "Pincode": "232328",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Zamania",
            "Pincode": "232329",
            "City": "Zamania",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Zamania R S",
            "Pincode": "232331",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tarighat",
            "Pincode": "232332",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Satramganj",
            "Pincode": "232333",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amaura",
            "Pincode": "232334",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhadera",
            "Pincode": "232335",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dharanji",
            "Pincode": "232336",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nauli",
            "Pincode": "232338",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Phuli",
            "Pincode": "232340",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tajpur Manjha",
            "Pincode": "232341",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tiarg",
            "Pincode": "232342",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghaipur R S",
            "Pincode": "233001",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghazipur",
            "Pincode": "233001",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghazipur City",
            "Pincode": "233001",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Markeenganj",
            "Pincode": "233001",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Peernagar",
            "Pincode": "233001",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "B G Pur",
            "Pincode": "233201",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Birno",
            "Pincode": "233208",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aurihar",
            "Pincode": "233221",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gangauli",
            "Pincode": "233222",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "233223",
            "City": "Rampur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karanda",
            "Pincode": "233224",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karimuddinpur",
            "Pincode": "233225",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mardah",
            "Pincode": "233226",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohammadabad",
            "Pincode": "233227",
            "City": "Mohammadabad",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Yusufpur",
            "Pincode": "233227",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tajpur Dehma",
            "Pincode": "233228",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bara Chawar",
            "Pincode": "233229",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ganshadepur",
            "Pincode": "233232",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khardiha",
            "Pincode": "233233",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kundeshwar",
            "Pincode": "233234",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mainpur",
            "Pincode": "233235",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandha",
            "Pincode": "233236",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mubarakh Pur",
            "Pincode": "233301",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nandganj",
            "Pincode": "233302",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nonahara",
            "Pincode": "233303",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sayedpur",
            "Pincode": "233304",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sayedpur Bazar",
            "Pincode": "233304",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Zangipur",
            "Pincode": "233305",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manihar",
            "Pincode": "233309",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malinpura",
            "Pincode": "233310",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "N S Sugar Mills",
            "Pincode": "233311",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pahewa",
            "Pincode": "233312",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kushi",
            "Pincode": "233337",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Talbehat",
            "Pincode": "234126",
            "City": "Talbehat",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bachhubban",
            "Pincode": "236488",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hardoi",
            "Pincode": "241001",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ahirori",
            "Pincode": "241121",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baghauli",
            "Pincode": "241122",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pali",
            "Pincode": "241123",
            "City": "Pali",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahabad",
            "Pincode": "241124",
            "City": "Shahabad",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kachhauna",
            "Pincode": "241126",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahendar",
            "Pincode": "241201",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bharawan",
            "Pincode": "241202",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhikauni",
            "Pincode": "241203",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sandila",
            "Pincode": "241204",
            "City": "Sandila",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bilgram",
            "Pincode": "241301",
            "City": "Bilgram",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madhoganj",
            "Pincode": "241302",
            "City": "Madhoganj",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhagwant Nagar",
            "Pincode": "241303",
            "City": "Bhagwant Nagar",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mallawan",
            "Pincode": "241303",
            "City": "Mallawan",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Beniganj",
            "Pincode": "241304",
            "City": "Beniganj",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gausganj",
            "Pincode": "241305",
            "City": "Gausganj",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barawn",
            "Pincode": "241401",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Burkot",
            "Pincode": "241401",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harpalpur",
            "Pincode": "241402",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sandi",
            "Pincode": "241403",
            "City": "Sandi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gopamau",
            "Pincode": "241404",
            "City": "Gopamau",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hariwan",
            "Pincode": "241405",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kote Kalan",
            "Pincode": "241406",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pihani",
            "Pincode": "241406",
            "City": "Pihani",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saadat Nagar",
            "Pincode": "241407",
            "City": "Hardoi",
            "District": "Hardoi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bangarmau",
            "Pincode": "241501",
            "City": "Bangarmau",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dundwara Ganj",
            "Pincode": "241502",
            "City": "Unnao",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Moradabad",
            "Pincode": "241502",
            "City": "Moradabad",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rasoolabad",
            "Pincode": "241503",
            "City": "Unnao",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Safipur",
            "Pincode": "241504",
            "City": "Safipur",
            "District": "Unnao",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Army Clothing Factory",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahadurganj",
            "Pincode": "242001",
            "City": "Bahadurganj",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Carswanj",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Charkhamba",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dalelganj",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghantaghar",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kattrola",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahjahanpur",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahjahanpur",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahjahanpur Chowk",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahjahanpur City",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahjahanpur R S",
            "Pincode": "242001",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Paina Bujrag",
            "Pincode": "242101",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahbaj Nagar",
            "Pincode": "242102",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sindhauli",
            "Pincode": "242103",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalalabad Shahjahanpur",
            "Pincode": "242221",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahabad",
            "Pincode": "242222",
            "City": "Allahabad",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deoria Jhala",
            "Pincode": "242223",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirzapur",
            "Pincode": "242223",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanskhat",
            "Pincode": "242225",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kant",
            "Pincode": "242225",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mumukhashram",
            "Pincode": "242226",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rafiabad Kalan",
            "Pincode": "242227",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kamal Mainpur",
            "Pincode": "242228",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kursiakalan",
            "Pincode": "242229",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ahmadpur",
            "Pincode": "242230",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pipraula",
            "Pincode": "242230",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramatpur",
            "Pincode": "242231",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barewda",
            "Pincode": "242232",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dadraul",
            "Pincode": "242234",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Miranpur Katra",
            "Pincode": "242301",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaitipur",
            "Pincode": "242302",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bajhera",
            "Pincode": "242303",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khaira",
            "Pincode": "242303",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khudaganj",
            "Pincode": "242305",
            "City": "Khudaganj",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rosa R S",
            "Pincode": "242306",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mauzampur",
            "Pincode": "242307",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tilhar",
            "Pincode": "242307",
            "City": "Tilhar",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Milkipur",
            "Pincode": "242308",
            "City": "Chandauli",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahpur Khitab",
            "Pincode": "242309",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalapur",
            "Pincode": "242310",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Laxmipur",
            "Pincode": "242311",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhawal Khera",
            "Pincode": "242312",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sector 5",
            "Pincode": "242312",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chauhatian",
            "Pincode": "242313",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mauzam Pur",
            "Pincode": "242314",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rudrapur",
            "Pincode": "242315",
            "City": "Rudrapur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pawayan",
            "Pincode": "242401",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Banda",
            "Pincode": "242402",
            "City": "Banda",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jewan",
            "Pincode": "242404",
            "City": "Kannauj",
            "District": "Kannauj",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khutar",
            "Pincode": "242405",
            "City": "Khutar",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rosa",
            "Pincode": "242406",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nigohi",
            "Pincode": "242407",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nigohi",
            "Pincode": "242407",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kugrajpur",
            "Pincode": "242408",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nahil",
            "Pincode": "242409",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sunara Bujurg",
            "Pincode": "242410",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Azmatpur",
            "Pincode": "242411",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Seramau South",
            "Pincode": "242413",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gangsara",
            "Pincode": "242415",
            "City": "Etah",
            "District": "Etah",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirad Pur",
            "Pincode": "242415",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nawtha Hans",
            "Pincode": "242416",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Prasadpur",
            "Pincode": "242417",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raitapur",
            "Pincode": "242418",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Akbaries",
            "Pincode": "242419",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhakhia L Ahia",
            "Pincode": "242420",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Silhuya",
            "Pincode": "242421",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhakha",
            "Pincode": "242473",
            "City": "Ambedkar Nagar",
            "District": "Ambedkar Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghanshyam",
            "Pincode": "242473",
            "City": "Shahjahanpur",
            "District": "Shahjahanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Balgati",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bamanpuri",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bareilly",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bareilly",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bareilly Cantt",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bareilly City",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bareilly R S",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhoor",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chaupla",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gulabnagar",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khangah",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khorapir",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kila",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kunwarpur",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madhi Nath Road",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Malookpur",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mango Road",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Marwariganj",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Masjid Domni",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mission Hospital",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Municipal Board",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nekpur",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New Civil Lines",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Niazia",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Old City",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Premnagar",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "R S Press",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadar Bazar",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahamatganj",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahdana Colony",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shivaji Marg",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shyamganj",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Subhas Market",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Subhashnagar",
            "Pincode": "243001",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "A F Station Bareilly",
            "Pincode": "243002",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Izat Nagar",
            "Pincode": "243002",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Izatnagar",
            "Pincode": "243122",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nakatia Nala",
            "Pincode": "243123",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bareilly",
            "Pincode": "243124",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New Railway Model Colony",
            "Pincode": "243124",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bitnichanpur",
            "Pincode": "243125",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhata",
            "Pincode": "243126",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "T M Icha",
            "Pincode": "243127",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baheri",
            "Pincode": "243201",
            "City": "Baheri",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nadeli",
            "Pincode": "243201",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhojipura",
            "Pincode": "243202",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deorania",
            "Pincode": "243203",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhaunra",
            "Pincode": "243204",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaini",
            "Pincode": "243206",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khaimpur",
            "Pincode": "243208",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aonla",
            "Pincode": "243301",
            "City": "Aonla",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aonla Estate",
            "Pincode": "243301",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "243303",
            "City": "Ramnagar",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Majhgawan",
            "Pincode": "243304",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aliganj",
            "Pincode": "243305",
            "City": "Aliganj",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhamora",
            "Pincode": "243401",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chanchali",
            "Pincode": "243403",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kareli",
            "Pincode": "243404",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhitama",
            "Pincode": "243408",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhetaura Rubber Factory",
            "Pincode": "243501",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Clutterbuckganj",
            "Pincode": "243502",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Faridpur",
            "Pincode": "243503",
            "City": "Faridpur",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirganj",
            "Pincode": "243504",
            "City": "Mirganj",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahi",
            "Pincode": "243505",
            "City": "Shahi",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehganj East",
            "Pincode": "243506",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shargarh",
            "Pincode": "243509",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babu Ram Market",
            "Pincode": "243601",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Budaun",
            "Pincode": "243601",
            "City": "Budaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Budaun",
            "Pincode": "243601",
            "City": "Budaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Budaun City",
            "Pincode": "243601",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chaudhri Saraj",
            "Pincode": "243601",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "243601",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Patiali Saraj",
            "Pincode": "243601",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sotha",
            "Pincode": "243601",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Usawan",
            "Pincode": "243621",
            "City": "Usawan",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Allahpur",
            "Pincode": "243631",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Asafpur",
            "Pincode": "243632",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bilsi",
            "Pincode": "243633",
            "City": "Bilsi",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Binawar",
            "Pincode": "243634",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dataganj",
            "Pincode": "243635",
            "City": "Dataganj",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kachla",
            "Pincode": "243636",
            "City": "Badaun",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kakrala",
            "Pincode": "243637",
            "City": "Kakrala",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahaswan",
            "Pincode": "243638",
            "City": "Sahaswan",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ujhani",
            "Pincode": "243639",
            "City": "Ujhani",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Usehat",
            "Pincode": "243641",
            "City": "Usehat",
            "District": "Badaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Milak",
            "Pincode": "243701",
            "City": "Milak",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Faizaganj Bazar",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Galasaheed",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kathghar",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Moradabad",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Moradabad",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Moradabad City",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Moradabad R S",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nai Basti",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nawabpura",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "P A C",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pachpera",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Police Training Centre",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "R N Area",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Town Hall",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Xxiv B Pac",
            "Pincode": "244001",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pakbara",
            "Pincode": "244102",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amroha",
            "Pincode": "244221",
            "City": "Amroha",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amroha Bazar",
            "Pincode": "244221",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahi Chabutra",
            "Pincode": "244221",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Joya",
            "Pincode": "244222",
            "City": "Joya",
            "District": "Jyotiba Phule Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bachraon",
            "Pincode": "244225",
            "City": "Varanasi",
            "District": "Varanasi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhanawre",
            "Pincode": "244231",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Station Rd",
            "Pincode": "244231",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gajraula",
            "Pincode": "244235",
            "City": "Gajraula",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajjabpur",
            "Pincode": "244236",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hasanpur",
            "Pincode": "244241",
            "City": "Hasanpur",
            "District": "Jyotiba Phule Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ujhari",
            "Pincode": "244242",
            "City": "Ujhari",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kundannagar",
            "Pincode": "244249",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nowgaon",
            "Pincode": "244251",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rahta",
            "Pincode": "244255",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sirsi",
            "Pincode": "244301",
            "City": "Sirsi",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deepasarai",
            "Pincode": "244302",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sambhal",
            "Pincode": "244302",
            "City": "Sambhal",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Tarin",
            "Pincode": "244303",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Asmoli",
            "Pincode": "244304",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dilari",
            "Pincode": "244401",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pipalsana R S",
            "Pincode": "244402",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aghwanpur",
            "Pincode": "244502",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Thakurdwara",
            "Pincode": "244601",
            "City": "Thakurdwara",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maulekhal",
            "Pincode": "244711",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maulekhal",
            "Pincode": "244711",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jaspur",
            "Pincode": "244712",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kashipur",
            "Pincode": "244713",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kila Street",
            "Pincode": "244713",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kashipur",
            "Pincode": "244713",
            "City": "Kashipur",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kashipur",
            "Pincode": "244713",
            "City": "Kashipur",
            "District": "Udham Singh Nagar",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kashipur",
            "Pincode": "244714",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sugar Mill",
            "Pincode": "244714",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sugar Mill Kashipur",
            "Pincode": "244714",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Rambagar",
            "Pincode": "244715",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ram Nagar",
            "Pincode": "244715",
            "City": "Ram Nagar",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "R.T.C. Mempur",
            "Pincode": "244716",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Sugar Factory Nadehi",
            "Pincode": "244717",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "C & M Stores",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Civil Lines",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Distillery",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Islamganj",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jwalanagar",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khusroobagh",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mestonganj",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muncipal Board",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Puranganj",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampur Chowk",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampur City",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampur Sectt",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tehsil Rampur",
            "Pincode": "244901",
            "City": "Rampur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bilaspur",
            "Pincode": "244921",
            "City": "Bilaspur",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahabad",
            "Pincode": "244922",
            "City": "Shahabad",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Suar",
            "Pincode": "244924",
            "City": "Suar",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tanda",
            "Pincode": "244925",
            "City": "Tanda",
            "District": "Rampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mundha",
            "Pincode": "244926",
            "City": "Moradabad",
            "District": "Moradabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hapur",
            "Pincode": "245101",
            "City": "Hapur",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hapur Mandi",
            "Pincode": "245101",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madarsa Sadar",
            "Pincode": "245101",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Industrial Estate Hapur",
            "Pincode": "245102",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babugarh",
            "Pincode": "245201",
            "City": "Babugarh",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Garhmuktehswar",
            "Pincode": "245205",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kharkhauda",
            "Pincode": "245206",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Simbhaoli",
            "Pincode": "245207",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahadurgarh",
            "Pincode": "245208",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhaulana",
            "Pincode": "245301",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pilkhuwa",
            "Pincode": "245304",
            "City": "Pilkhuwa",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pilkhuwa New Market",
            "Pincode": "245304",
            "City": "Ghaziabad",
            "District": "Ghaziabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "245401",
            "City": "Aurangabad",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "B B Bagar",
            "Pincode": "245402",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bugrasi",
            "Pincode": "245403",
            "City": "Bugrasi",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khanpur",
            "Pincode": "245405",
            "City": "Khanpur",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhatona",
            "Pincode": "245406",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lakhaoti",
            "Pincode": "245407",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gulauthi",
            "Pincode": "245408",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai",
            "Pincode": "245409",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saidpur",
            "Pincode": "245411",
            "City": "Saidpur",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Siyana",
            "Pincode": "245412",
            "City": "Bulandshahr",
            "District": "Bulandshahr",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pauri Ho",
            "Pincode": "246001",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kaljikhal",
            "Pincode": "246113",
            "City": "Kaljikhal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhirgukhal",
            "Pincode": "246121",
            "City": "Bhirgukhal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chelusain",
            "Pincode": "246122",
            "City": "Chelusain",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chipalghat",
            "Pincode": "246123",
            "City": "Chipalghat",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehal Chauri",
            "Pincode": "246125",
            "City": "Dehal Chauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dev Rajkhal",
            "Pincode": "246126",
            "City": "Dev Rajkhal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dugadd",
            "Pincode": "246127",
            "City": "Dugadd",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dwarikhal",
            "Pincode": "246128",
            "City": "Dwarikhal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dukharkhal",
            "Pincode": "246129",
            "City": "Dukharkhal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chakisain",
            "Pincode": "246130",
            "City": "Chakisain",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ekeshwar",
            "Pincode": "246131",
            "City": "Ekeshwar",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Rithakhal",
            "Pincode": "246132",
            "City": "Rithakhal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kalagarh",
            "Pincode": "246142",
            "City": "Kalagarh",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kalagarh",
            "Pincode": "246142",
            "City": "Kalagarh",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kanda Khal",
            "Pincode": "246144",
            "City": "Kanda Khal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kanskhet",
            "Pincode": "246146",
            "City": "Kanskhet",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Khirshn",
            "Pincode": "246147",
            "City": "Khirshn",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kot",
            "Pincode": "246148",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kotdwar",
            "Pincode": "246149",
            "City": "Kotdwar",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kotdwara",
            "Pincode": "246149",
            "City": "Kotdwara",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kotdwara Rly St",
            "Pincode": "246149",
            "City": "Kotdwara",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Lawali",
            "Pincode": "246149",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Najibabad Road",
            "Pincode": "246149",
            "City": "Kotdwara",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Lansdowne Ho.",
            "Pincode": "246155",
            "City": "Lansdowne",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Nainidada",
            "Pincode": "246161",
            "City": "Nainidada",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Naugaon Khal",
            "Pincode": "246162",
            "City": "Naugaon Khal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Mawadhar",
            "Pincode": "246163",
            "City": "Mawadhar",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Pabua",
            "Pincode": "246164",
            "City": "Pabua",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Paidul",
            "Pincode": "246165",
            "City": "Paidul",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Parsundakhal",
            "Pincode": "246166",
            "City": "Parsundakhal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Pattisain",
            "Pincode": "246167",
            "City": "Pattisain",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Paukhal",
            "Pincode": "246168",
            "City": "Paukhal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Porhra",
            "Pincode": "246169",
            "City": "Porhra",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Rikhani Khal",
            "Pincode": "246170",
            "City": "Rikhani Khal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Rudra Prayag",
            "Pincode": "246171",
            "City": "Rudra Prayag",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Rudra Prayag",
            "Pincode": "246171",
            "City": "Rudra Prayag",
            "District": "Rudra Prayag",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Satpuri",
            "Pincode": "246172",
            "City": "Satpuri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Sillogl",
            "Pincode": "246173",
            "City": "Sillogl",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Srinagar",
            "Pincode": "246174",
            "City": "Srinagar",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Naithana",
            "Pincode": "246175",
            "City": "Naithana",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Toli",
            "Pincode": "246176",
            "City": "Toli",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Vedikhal",
            "Pincode": "246177",
            "City": "Vedikhal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bughani",
            "Pincode": "246185",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Devprayag",
            "Pincode": "246186",
            "City": "Devprayag",
            "District": "Tehri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Adheriya Khal",
            "Pincode": "246188",
            "City": "Adheriya Khal",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dabri",
            "Pincode": "246189",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Padampur",
            "Pincode": "246191",
            "City": "Kotdwar",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kalaghati",
            "Pincode": "246192",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jailhari Khal",
            "Pincode": "246193",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Baijraq",
            "Pincode": "246275",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bironkhal",
            "Pincode": "246276",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dhumakot",
            "Pincode": "246277",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Syunsi Nagar",
            "Pincode": "246278",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dingoli Khal",
            "Pincode": "246280",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Yamkeshwar",
            "Pincode": "246281",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Thalisain",
            "Pincode": "246285",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gopeswar Ho.",
            "Pincode": "246401",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhiri",
            "Pincode": "246419",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Agustmuni",
            "Pincode": "246421",
            "City": "Agustmuni",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Badrinath",
            "Pincode": "246422",
            "City": "Badrinath",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bampa",
            "Pincode": "246423",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chamoli",
            "Pincode": "246424",
            "City": "Chamoli",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chandrapuri",
            "Pincode": "246425",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chhinka",
            "Pincode": "246426",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Debai",
            "Pincode": "246427",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gairsain",
            "Pincode": "246428",
            "City": "Gairsain",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gauchar",
            "Pincode": "246429",
            "City": "Gauchar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Mehal Chunri",
            "Pincode": "246431",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ghat",
            "Pincode": "246435",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Vidhya Peeth",
            "Pincode": "246437",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gholtir",
            "Pincode": "246438",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Guptakashi",
            "Pincode": "246439",
            "City": "Guptakashi",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Adibadri",
            "Pincode": "246440",
            "City": "Adibadri",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gwaldam",
            "Pincode": "246441",
            "City": "Gwaldam",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jakhani",
            "Pincode": "246442",
            "City": "Jakhani",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Joshimath",
            "Pincode": "246443",
            "City": "Joshimath",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Karan Prayag",
            "Pincode": "246444",
            "City": "Karan Prayag",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Langasu",
            "Pincode": "246446",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Malari",
            "Pincode": "246447",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Maikoti",
            "Pincode": "246448",
            "City": "Rudra Prayag",
            "District": "Rudra Prayag",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Nand Prayag",
            "Pincode": "246449",
            "City": "Nand Prayag",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Sonla",
            "Pincode": "246450",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Nauli",
            "Pincode": "246452",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Nalgaon",
            "Pincode": "246453",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Narain Bazar",
            "Pincode": "246455",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kedar Khal",
            "Pincode": "246456",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Maithana",
            "Pincode": "246458",
            "City": "Maithana",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Okhimath",
            "Pincode": "246469",
            "City": "Okhimath",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Palla Bazar",
            "Pincode": "246470",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Phata",
            "Pincode": "246471",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Pipalkoti",
            "Pincode": "246472",
            "City": "Pipalkoti",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Pokhari Nagnath",
            "Pincode": "246473",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Simli",
            "Pincode": "246474",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Tilwara",
            "Pincode": "246475",
            "City": "Rudra Prayag",
            "District": "Rudra Prayag",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gauri Kund",
            "Pincode": "246476",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Tharali",
            "Pincode": "246481",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Talwari",
            "Pincode": "246482",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Topowan",
            "Pincode": "246485",
            "City": "Topowan",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Nauti",
            "Pincode": "246487",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bachhuwaban",
            "Pincode": "246488",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chopra",
            "Pincode": "246495",
            "City": "Gopeshwar",
            "District": "Chamoli",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bijnor",
            "Pincode": "246701",
            "City": "Bijnor",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bijnor Industrial Estate",
            "Pincode": "246701",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Board Jatan",
            "Pincode": "246701",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Civil Lines District",
            "Pincode": "246701",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khatriyan",
            "Pincode": "246701",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandawar",
            "Pincode": "246721",
            "City": "Mandawar",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Afzalgarh",
            "Pincode": "246722",
            "City": "Afzalgarh",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Balawali",
            "Pincode": "246723",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barhapur",
            "Pincode": "246724",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandpur",
            "Pincode": "246725",
            "City": "Chandpur",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandpur R S",
            "Pincode": "246725",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Haldaur",
            "Pincode": "246726",
            "City": "Haldaur",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hassupura",
            "Pincode": "246727",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhalu",
            "Pincode": "246728",
            "City": "Jhalu",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kiratpur",
            "Pincode": "246731",
            "City": "Kiratpur",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nagal",
            "Pincode": "246732",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nihtaur",
            "Pincode": "246733",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nurpur",
            "Pincode": "246734",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raja-Ka-Tejpur",
            "Pincode": "246735",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahaspur",
            "Pincode": "246745",
            "City": "Sahaspur",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Seohara",
            "Pincode": "246746",
            "City": "Seohara",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Seohara R S",
            "Pincode": "246746",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sherkot",
            "Pincode": "246747",
            "City": "Sherkot",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Asgharipur",
            "Pincode": "246748",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gohawar",
            "Pincode": "246748",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahanpur",
            "Pincode": "246749",
            "City": "Sahanpur",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Qadrabad",
            "Pincode": "246751",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhampur",
            "Pincode": "246761",
            "City": "Dhampur",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandi",
            "Pincode": "246761",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sugar Mills",
            "Pincode": "246761",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ganj Bazar",
            "Pincode": "246762",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nagina",
            "Pincode": "246762",
            "City": "Nagina",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nagina Bazar",
            "Pincode": "246762",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kallooganj",
            "Pincode": "246763",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Najibabad",
            "Pincode": "246763",
            "City": "Najibabad",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Najibabad R S",
            "Pincode": "246763",
            "City": "Bijnore",
            "District": "Bijnore",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bajoria Marg",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chakrata Road",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gatta Mills",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gopal Nagar Ind Estate",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khalapar",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khalasi Line",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kumharanpul",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Labour Colony",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lakhi Gate",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nehur Market",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Paper Mill",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Qutub Sher",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rani Bazar",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saharanpur",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saharanpur",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saharanpur City",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sapar Bazar",
            "Pincode": "247001",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meghchapar",
            "Pincode": "247002",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hassunpur",
            "Pincode": "247111",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lohari",
            "Pincode": "247111",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahail",
            "Pincode": "247120",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Buzurg",
            "Pincode": "247120",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Behat",
            "Pincode": "247121",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Badshahi Bagh",
            "Pincode": "247122",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muzafarabad",
            "Pincode": "247129",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chikhana",
            "Pincode": "247231",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarsawa",
            "Pincode": "247232",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ambehta",
            "Pincode": "247340",
            "City": "Ambehta",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gangoh",
            "Pincode": "247341",
            "City": "Gangoh",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nakur",
            "Pincode": "247342",
            "City": "Nakur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tirron",
            "Pincode": "247343",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampu",
            "Pincode": "247451",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nanauta",
            "Pincode": "247452",
            "City": "Nanauta",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaroda Pandey",
            "Pincode": "247453",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nagal",
            "Pincode": "247551",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Darululloom",
            "Pincode": "247554",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deoband",
            "Pincode": "247554",
            "City": "Deoband",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mangalore Town",
            "Pincode": "247656",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhagwanpur",
            "Pincode": "247661",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chuttmalpur",
            "Pincode": "247662",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lhaksar",
            "Pincode": "247663",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Cantt Town",
            "Pincode": "247664",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Landhaura",
            "Pincode": "247664",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Landhaura Town",
            "Pincode": "247664",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhabrera",
            "Pincode": "247665",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ganesh Vatika",
            "Pincode": "247667",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "247667",
            "City": "Ramnagar",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rookee Cantt",
            "Pincode": "247667",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rookee City",
            "Pincode": "247667",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Roorkee",
            "Pincode": "247667",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shaminagar",
            "Pincode": "247667",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Roorkee",
            "Pincode": "247667",
            "City": "Roorkee",
            "District": "Hardwar",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Roorkee Cantt",
            "Pincode": "247667",
            "City": "Roorkee",
            "District": "Hardwar",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Roorkee City",
            "Pincode": "247667",
            "City": "Roorkee",
            "District": "Hardwar",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Iqbalpur",
            "Pincode": "247668",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gref Centre",
            "Pincode": "247669",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gurukul Narsan",
            "Pincode": "247670",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raise",
            "Pincode": "247671",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Roorkee University",
            "Pincode": "247672",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Melainagar",
            "Pincode": "247673",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ailum",
            "Pincode": "247771",
            "City": "Ailum",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalalabad",
            "Pincode": "247772",
            "City": "Jalalabad",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhinjhana",
            "Pincode": "247773",
            "City": "Jhinjhana",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kairana",
            "Pincode": "247774",
            "City": "Kairana",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kandhala",
            "Pincode": "247775",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bara Bazar",
            "Pincode": "247776",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shamli",
            "Pincode": "247776",
            "City": "Shamli",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shamli Mandi",
            "Pincode": "247776",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shamli Road",
            "Pincode": "247776",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shamli S Mill",
            "Pincode": "247776",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Thana Bhawan",
            "Pincode": "247777",
            "City": "Thana Bhawan",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Un",
            "Pincode": "247778",
            "City": "Un",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Ho.",
            "Pincode": "248001",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Clement Town",
            "Pincode": "248002",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Cantt Ho.",
            "Pincode": "248003",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Cantt Ho.",
            "Pincode": "248003",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Cantt Ho.",
            "Pincode": "248003",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dehradun Cantt Ho.",
            "Pincode": "248003",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "I.I.P. Dehradun",
            "Pincode": "248005",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "New Forest",
            "Pincode": "248006",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Prem Nagar",
            "Pincode": "248007",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Nehrugram",
            "Pincode": "248008",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Raipur Ordinance Factory",
            "Pincode": "248008",
            "City": "Raipur",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "248009",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "248009",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Sahastradhra",
            "Pincode": "248102",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Mahebawalla",
            "Pincode": "248110",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Mathurawala",
            "Pincode": "248115",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ranjhawala",
            "Pincode": "248116",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Korwa",
            "Pincode": "248119",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ajabpur",
            "Pincode": "248121",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bariowganj",
            "Pincode": "248122",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chakrata Kailana",
            "Pincode": "248123",
            "City": "Chakrata",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Barautha",
            "Pincode": "248124",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dakpathar",
            "Pincode": "248125",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Doiwala",
            "Pincode": "248140",
            "City": "Doiwala",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ghanghora",
            "Pincode": "248141",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Herbertpur",
            "Pincode": "248142",
            "City": "Herbertpur",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhogpur",
            "Pincode": "248143",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhaniawala",
            "Pincode": "248144",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Raniphool Devi",
            "Pincode": "248145",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Simadwar",
            "Pincode": "248146",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dhakrani",
            "Pincode": "248147",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kuthal",
            "Pincode": "248148",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jharipani",
            "Pincode": "248152",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kalsi Gate",
            "Pincode": "248159",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Harrawalla",
            "Pincode": "248160",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Balawala",
            "Pincode": "248161",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chibroo",
            "Pincode": "248164",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Koti",
            "Pincode": "248165",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Majra",
            "Pincode": "248171",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Mussoorie",
            "Pincode": "248179",
            "City": "Mussoorie",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Mussoorie",
            "Pincode": "248179",
            "City": "Mussoorie",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Mussoorie",
            "Pincode": "248179",
            "City": "Mussoorie",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Mussoorie",
            "Pincode": "248179",
            "City": "Mussoorie",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Vikas Nagar",
            "Pincode": "248191",
            "City": "Vikas Nagar",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "I.P.E. Dehradun",
            "Pincode": "248195",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Sahiya",
            "Pincode": "248196",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Sahaspur",
            "Pincode": "248197",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Tuini",
            "Pincode": "248199",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kolaghar",
            "Pincode": "248201",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Koragarh",
            "Pincode": "248201",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Koti Punarwas Chhatra",
            "Pincode": "248202",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Pashulok",
            "Pincode": "248203",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kalsi",
            "Pincode": "248528",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chila Colony",
            "Pincode": "249132",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dharasoo",
            "Pincode": "249134",
            "City": "Dharasoo",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dharasu",
            "Pincode": "249134",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Burket",
            "Pincode": "249141",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dunda",
            "Pincode": "249151",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dunda",
            "Pincode": "249151",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Geonla",
            "Pincode": "249152",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Geonla",
            "Pincode": "249152",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chimyali Saur",
            "Pincode": "249156",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Naugaon",
            "Pincode": "249171",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Naugaon",
            "Pincode": "249171",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Purola",
            "Pincode": "249185",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Purola",
            "Pincode": "249185",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Uttarkashi",
            "Pincode": "249193",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Manauri Dam Colony",
            "Pincode": "249194",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Mahidanda",
            "Pincode": "249195",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Rishikesh",
            "Pincode": "249201",
            "City": "Rishikesh",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Virbhadra",
            "Pincode": "249202",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "S.N. Temple",
            "Pincode": "249204",
            "City": "Dehradun",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Raiwala",
            "Pincode": "249205",
            "City": "Raiwala",
            "District": "Dehradun",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Laxman Jhula",
            "Pincode": "249302",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Swargasharm",
            "Pincode": "249304",
            "City": "Pauri",
            "District": "Pauri Garhwal",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bahadurabad",
            "Pincode": "249402",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bharat Heavy Electrical B",
            "Pincode": "249403",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gurukulkangri",
            "Pincode": "249404",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gurukul",
            "Pincode": "249405",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahavidyalaya",
            "Pincode": "249405",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jwalapur",
            "Pincode": "249407",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jwalapur Town",
            "Pincode": "249407",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kankhal",
            "Pincode": "249408",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rishikesh Vidyapith",
            "Pincode": "249409",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhopatwala",
            "Pincode": "249410",
            "City": "Saharanpur",
            "District": "Saharanpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Abupur",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Anajmandi",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "B C Lines",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bankers Street",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Begum Bagh",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Belvedere",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Boundry Road",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandhi Ashram",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chippi Tank",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanker Khera",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kitchner Lines",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lalkurti Bazar",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meerut",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meerut",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meerut Kty",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meerut University",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Patelpuri",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Punjab",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "R A Bazar",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Regiment Centre",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadar Bazar",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saket",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shivpury",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sikh Regiment Centre",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Srdhana Road",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Suraj Kund",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Thapar Nagar",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Victoria Park",
            "Pincode": "250001",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bagpatgate",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Budhana Gate",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kaiserganj",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lisarigate",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meerut City",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meerut Tehsil",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nadirli Co",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Prempuri",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Railway Road",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ram Lila Ground",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "250002",
            "City": "Ramnagar",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sabum Godam",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarafa Bazar",
            "Pincode": "250002",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kishanpura Nagar",
            "Pincode": "250003",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meerut 4",
            "Pincode": "250004",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramlila Ground",
            "Pincode": "250004",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meerut University",
            "Pincode": "250005",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Industrial Est Pratapur",
            "Pincode": "250013",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Medical Coll Meerut",
            "Pincode": "250102",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kithore",
            "Pincode": "250104",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Krishnanagar Hmeerut)",
            "Pincode": "250105",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Machhra",
            "Pincode": "250106",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Modipuram",
            "Pincode": "250110",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Daurala",
            "Pincode": "250221",
            "City": "Daurala",
            "District": "Jyotiba Phule Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lawar",
            "Pincode": "250222",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sakhaoti Tanda",
            "Pincode": "250223",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dabathwa",
            "Pincode": "250341",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sardhana Chowk",
            "Pincode": "250342",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shardhana",
            "Pincode": "250342",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarurpur",
            "Pincode": "250344",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Binauli",
            "Pincode": "250345",
            "City": "Baghpat",
            "District": "Baghpat",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mawana",
            "Pincode": "250401",
            "City": "Mawana",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mawana Mandi",
            "Pincode": "250401",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mawana Factory",
            "Pincode": "250402",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kaseru Khera",
            "Pincode": "250403",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hastinapur",
            "Pincode": "250404",
            "City": "Hastinapur",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Parikshitigarh",
            "Pincode": "250406",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jani",
            "Pincode": "250501",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rasulpur",
            "Pincode": "250502",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Agarwal",
            "Pincode": "250601",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandi",
            "Pincode": "250601",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bamnauli",
            "Pincode": "250602",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aminagar Sarai",
            "Pincode": "250604",
            "City": "Aminagar Sarai",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baghpat",
            "Pincode": "250609",
            "City": "Baghpat",
            "District": "Baghpat",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baraut",
            "Pincode": "250611",
            "City": "Baraut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "250611",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nai Mandi",
            "Pincode": "250611",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nehru Road",
            "Pincode": "250611",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bijrol",
            "Pincode": "250612",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhikauli",
            "Pincode": "250615",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chhaprauli",
            "Pincode": "250617",
            "City": "Chhaprauli",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarurpur Kalan",
            "Pincode": "250619",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baoli",
            "Pincode": "250621",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Do Ghat",
            "Pincode": "250622",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kishanpurbaral",
            "Pincode": "250623",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tikari",
            "Pincode": "250625",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baleni",
            "Pincode": "250626",
            "City": "Baghpat",
            "District": "Baghpat",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Colony",
            "Pincode": "251001",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gangarampura",
            "Pincode": "251001",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khalapar",
            "Pincode": "251001",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "251001",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muzaffarnagar",
            "Pincode": "251001",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muzaffarnagar",
            "Pincode": "251001",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "New Mandi",
            "Pincode": "251001",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Prempuri",
            "Pincode": "251001",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muzaffarnagar City",
            "Pincode": "251002",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khatauli",
            "Pincode": "251201",
            "City": "Khatauli",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rohana Mills",
            "Pincode": "251202",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mansurpur",
            "Pincode": "251203",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Alipur Kheri",
            "Pincode": "251301",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babri",
            "Pincode": "251305",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baghera",
            "Pincode": "251306",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhopa",
            "Pincode": "251308",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Budhana",
            "Pincode": "251309",
            "City": "Budhana",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basara",
            "Pincode": "251310",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Charthawal",
            "Pincode": "251311",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mirnapur",
            "Pincode": "251315",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Morna",
            "Pincode": "251316",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Purkazi",
            "Pincode": "251317",
            "City": "Muzaffarnagar",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahpur",
            "Pincode": "251318",
            "City": "Shahpur",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sisauli",
            "Pincode": "251319",
            "City": "Sisauli",
            "District": "Muzaffarnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Meerut",
            "Pincode": "255006",
            "City": "Meerut",
            "District": "Meerut",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Alamnagar",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Eye Hospital Xi Bn Pac",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jail Road",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchey",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lohar Bagh",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mangrahia Bazar",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nai Basti",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pac",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "R T S Sitapur",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Seventh Bn",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sitapur",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sitapur",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sitapur City",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sitapur Old Town",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Vijai Laxminagar",
            "Pincode": "261001",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hargaon S M",
            "Pincode": "261121",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Husainganj",
            "Pincode": "261125",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hussain Ganj",
            "Pincode": "261125",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khairabad",
            "Pincode": "261131",
            "City": "Khairabad",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Laharpur",
            "Pincode": "261135",
            "City": "Laharpur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Singhnapar",
            "Pincode": "261136",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maholi",
            "Pincode": "261141",
            "City": "Maholi",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manpur",
            "Pincode": "261145",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pisawan",
            "Pincode": "261151",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Biswan",
            "Pincode": "261201",
            "City": "Biswan",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jahangirabad",
            "Pincode": "261202",
            "City": "Jahangirabad",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahmoodabad",
            "Pincode": "261203",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathura",
            "Pincode": "261204",
            "City": "Mathura",
            "District": "Balrampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "261204",
            "City": "Rampur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raja Saheb",
            "Pincode": "261205",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Reosa",
            "Pincode": "261205",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saralyan",
            "Pincode": "261205",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Talgaon",
            "Pincode": "261207",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tambaur",
            "Pincode": "261208",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhandia",
            "Pincode": "261301",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Damalpur",
            "Pincode": "261302",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sidhaul",
            "Pincode": "261303",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Misrikh",
            "Pincode": "261401",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nimsar",
            "Pincode": "261402",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "261403",
            "City": "Aurangabad",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Machrehta",
            "Pincode": "261405",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sittarganj",
            "Pincode": "261405",
            "City": "Bughani",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Behjam",
            "Pincode": "261501",
            "City": "Sitapur",
            "District": "Sitapur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Isangar",
            "Pincode": "261502",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maigalganj",
            "Pincode": "261505",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahewganj",
            "Pincode": "261506",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaudas Buzurg",
            "Pincode": "261606",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "262001",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pilibhit",
            "Pincode": "262001",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pilibhit",
            "Pincode": "262001",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pilibhit Chowk",
            "Pincode": "262001",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pilibhit City",
            "Pincode": "262001",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amaria",
            "Pincode": "262121",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ganesh Ganj",
            "Pincode": "262122",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Puranpur",
            "Pincode": "262122",
            "City": "Puranpur",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jugraipur",
            "Pincode": "262123",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sultanpur",
            "Pincode": "262125",
            "City": "Sultanpur",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sultanpur",
            "Pincode": "262125",
            "City": "Sittarganj",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bisalpur",
            "Pincode": "262201",
            "City": "Bisalpur",
            "District": "Auraiya",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Katra Bazar",
            "Pincode": "262201",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bilsanda",
            "Pincode": "262202",
            "City": "Bilsanda",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barkhera",
            "Pincode": "262203",
            "City": "Barkhera",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lohia Head",
            "Pincode": "262301",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lohia Head",
            "Pincode": "262301",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Majhola",
            "Pincode": "262302",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Neorila",
            "Pincode": "262305",
            "City": "Pilibhit",
            "District": "Pilibhit",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khatima",
            "Pincode": "262308",
            "City": "Khatima",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Khatima",
            "Pincode": "262308",
            "City": "Khatima",
            "District": "Udham Singh Nagar",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Tanakpur",
            "Pincode": "262309",
            "City": "Champawat",
            "District": "Champawat",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chandni",
            "Pincode": "262310",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Nanakmatta",
            "Pincode": "262311",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bazpur",
            "Pincode": "262401",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Lalkua",
            "Pincode": "262402",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Sai Camp",
            "Pincode": "262403",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Nawabganj",
            "Pincode": "262406",
            "City": "Nawabganj",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Senthal",
            "Pincode": "262407",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gular Bhoj",
            "Pincode": "262408",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bapu Nagar",
            "Pincode": "262411",
            "City": "Bareilly",
            "District": "Bareilly",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pithoragarh Ho.",
            "Pincode": "262501",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Pithoragarh Ho.",
            "Pincode": "262501",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Degree College",
            "Pincode": "262502",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Munakote",
            "Pincode": "262519",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bharkatiya",
            "Pincode": "262520",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Wadda",
            "Pincode": "262521",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gangolihat",
            "Pincode": "262522",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Champawat",
            "Pincode": "262523",
            "City": "Champawat",
            "District": "Champawat",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Lohaghat",
            "Pincode": "262524",
            "City": "Lohaghat",
            "District": "Champawat",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Abbot Mount",
            "Pincode": "262525",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jhuaghat",
            "Pincode": "262526",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Barakote",
            "Pincode": "262527",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kheti Khan",
            "Pincode": "262528",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gurna",
            "Pincode": "262529",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Aincholi",
            "Pincode": "262530",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bering",
            "Pincode": "262531",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ganai Gangoli",
            "Pincode": "262532",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Pankhu",
            "Pincode": "262533",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Agar",
            "Pincode": "262534",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dewthal",
            "Pincode": "262542",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Askote",
            "Pincode": "262543",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jaulijibi",
            "Pincode": "262544",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dhar Chula",
            "Pincode": "262545",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Garbyang",
            "Pincode": "262546",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Pangu",
            "Pincode": "262547",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Merthi",
            "Pincode": "262550",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Didihat",
            "Pincode": "262551",
            "City": "Didihat",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Thal",
            "Pincode": "262552",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Tejam",
            "Pincode": "262553",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Munsiari",
            "Pincode": "262554",
            "City": "Munsiari",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bansbazar",
            "Pincode": "262555",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Nakote",
            "Pincode": "262561",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dharamgarh",
            "Pincode": "262571",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Muwani",
            "Pincode": "262572",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dasaithal",
            "Pincode": "262573",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Badabey",
            "Pincode": "262574",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Barabey",
            "Pincode": "262574",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Quitee",
            "Pincode": "262575",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Baluwakote",
            "Pincode": "262576",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Devidhura",
            "Pincode": "262580",
            "City": "Devidhura",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kheri",
            "Pincode": "262701",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lakhimpur Kheri",
            "Pincode": "262701",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maharajnagar",
            "Pincode": "262701",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nai Basti",
            "Pincode": "262701",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajgarh",
            "Pincode": "262701",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sankata Devi",
            "Pincode": "262701",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kheri Town",
            "Pincode": "262702",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Laghucha",
            "Pincode": "262721",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aira Estate",
            "Pincode": "262722",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhauhara",
            "Pincode": "262723",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jatourwa",
            "Pincode": "262724",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Oel",
            "Pincode": "262725",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shardanagar",
            "Pincode": "262726",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mitauli",
            "Pincode": "262727",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "262728",
            "City": "Aurangabad",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bankeyganj",
            "Pincode": "262801",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gola Town",
            "Pincode": "262802",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Golagokarannath",
            "Pincode": "262802",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mailani",
            "Pincode": "262803",
            "City": "Mailani",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohammadi",
            "Pincode": "262804",
            "City": "Mohammadi",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sikandrabad",
            "Pincode": "262805",
            "City": "Sikandrabad",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhira",
            "Pincode": "262901",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pallia",
            "Pincode": "262902",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nighasin",
            "Pincode": "262903",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sampurnanagar",
            "Pincode": "262904",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Singhai",
            "Pincode": "262905",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tikonia",
            "Pincode": "262906",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sewara",
            "Pincode": "262907",
            "City": "Kheri",
            "District": "Kheri",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nainital Ho.",
            "Pincode": "263001",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Tallitul",
            "Pincode": "263002",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Tallitul",
            "Pincode": "263002",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kathiatali",
            "Pincode": "263126",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ghorakhal",
            "Pincode": "263127",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jeolikot",
            "Pincode": "263127",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Patwa Banger",
            "Pincode": "263128",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Manora Peak",
            "Pincode": "263129",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhowali Sanatorium",
            "Pincode": "263131",
            "City": "Bhowali",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhowali",
            "Pincode": "263132",
            "City": "Bhowali",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Betalght",
            "Pincode": "263134",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Garampani",
            "Pincode": "263135",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhimtal",
            "Pincode": "263136",
            "City": "Bhimtal",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ramgarh",
            "Pincode": "263137",
            "City": "Ramgarh",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Mukteswaram",
            "Pincode": "263138",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Haldwani Ho.",
            "Pincode": "263139",
            "City": "Haldwani",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Haldwani Ho.",
            "Pincode": "263139",
            "City": "Haldwani",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Haldwani Ho.",
            "Pincode": "263139",
            "City": "Haldwani",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kaladhungi",
            "Pincode": "263140",
            "City": "Kaladhungi",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhotia Parao",
            "Pincode": "263142",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Pant Nagar",
            "Pincode": "263145",
            "City": "Pant Nagar",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Haldi",
            "Pincode": "263146",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gokulnagar",
            "Pincode": "263147",
            "City": "Gokulnagar",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kichha",
            "Pincode": "263148",
            "City": "Kichha",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dairy Farm",
            "Pincode": "263149",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Shakti Farm",
            "Pincode": "263151",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gadarpur",
            "Pincode": "263152",
            "City": "Gadarpur",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Rudrapur",
            "Pincode": "263153",
            "City": "Rudrapur",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "R.C. Rudarpur",
            "Pincode": "263154",
            "City": "Rudrapur",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Sattal",
            "Pincode": "263155",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Okhul Kanda",
            "Pincode": "263157",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "N.S.Ashram",
            "Pincode": "263158",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kota Bagh",
            "Pincode": "263159",
            "City": "Nainital",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dineshpur",
            "Pincode": "263160",
            "City": "Dineshpur",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Almora Ho.",
            "Pincode": "263601",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Almora Ho.",
            "Pincode": "263601",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Almora Ho.",
            "Pincode": "263601",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ghingartola",
            "Pincode": "263610",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bagwali Pockher",
            "Pincode": "263621",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dania",
            "Pincode": "263622",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Panuvanoula",
            "Pincode": "263623",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Barechhina",
            "Pincode": "263624",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jalna",
            "Pincode": "263625",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jainti",
            "Pincode": "263626",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chanoda",
            "Pincode": "263628",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Takula",
            "Pincode": "263628",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kausani Estate",
            "Pincode": "263629",
            "City": "Kausani",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Billori",
            "Pincode": "263630",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kausani",
            "Pincode": "263630",
            "City": "Kausani",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kanda",
            "Pincode": "263631",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kapkote",
            "Pincode": "263632",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kapkote",
            "Pincode": "263632",
            "City": "Bageshwar",
            "District": "Bageshwar",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Sharma",
            "Pincode": "263633",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dofar",
            "Pincode": "263634",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dangoli",
            "Pincode": "263635",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Hawal Bagh",
            "Pincode": "263636",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Manan",
            "Pincode": "263638",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kameri Devi",
            "Pincode": "263640",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Baijnath",
            "Pincode": "263641",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bageshwar",
            "Pincode": "263642",
            "City": "Bageshwar",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bageshwar",
            "Pincode": "263642",
            "City": "Bageshwar",
            "District": "Bageshwar",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kosi",
            "Pincode": "263643",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ranikhet Ho.",
            "Pincode": "263645",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhatrojkhan",
            "Pincode": "263646",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chilianaula",
            "Pincode": "263647",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ranikhet Sadar Bazar",
            "Pincode": "263648",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chaubaltia",
            "Pincode": "263651",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Majkhali",
            "Pincode": "263652",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dwarahat",
            "Pincode": "263653",
            "City": "Dwarahat",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Asgoli",
            "Pincode": "263654",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ganai",
            "Pincode": "263656",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Masi",
            "Pincode": "263658",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Deghat",
            "Pincode": "263659",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Daula",
            "Pincode": "263660",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Syalde",
            "Pincode": "263661",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jalali",
            "Pincode": "263662",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Tarikhet",
            "Pincode": "263663",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Deoli Khet",
            "Pincode": "263664",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Daulaghat",
            "Pincode": "263665",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Matela",
            "Pincode": "263665",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhikiasain",
            "Pincode": "263667",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Patia",
            "Pincode": "263669",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Lamgara",
            "Pincode": "263670",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Pilkholi",
            "Pincode": "263671",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kafra",
            "Pincode": "263675",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Sinora",
            "Pincode": "263676",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Ganai Deoli",
            "Pincode": "263677",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Shittakhet",
            "Pincode": "263678",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bharari",
            "Pincode": "263679",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Chaunallia",
            "Pincode": "263680",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dhaulchnina",
            "Pincode": "263681",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jageshwar",
            "Pincode": "263682",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dhauladevi",
            "Pincode": "263683",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhainsori",
            "Pincode": "263684",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Dhamus",
            "Pincode": "263685",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Uprani",
            "Pincode": "263686",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhanoli",
            "Pincode": "263687",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Gagri Gode",
            "Pincode": "263688",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bhagtola",
            "Pincode": "263689",
            "City": "Almora",
            "District": "Almora",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Jaspur",
            "Pincode": "264712",
            "City": "Jaspur",
            "District": "Nainital",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Kanali Chhina",
            "Pincode": "265441",
            "City": "Pithoragarh",
            "District": "Pithoragarh",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bankatwa",
            "Pincode": "271001",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bus Station",
            "Pincode": "271001",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gonda",
            "Pincode": "271001",
            "City": "Gonda",
            "District": "Mau",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gonda City",
            "Pincode": "271001",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Utraula Road",
            "Pincode": "271001",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bargaon",
            "Pincode": "271002",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dadua Bazar",
            "Pincode": "271002",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Katra Gules Singh",
            "Pincode": "271122",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kauria",
            "Pincode": "271122",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khorasa",
            "Pincode": "271123",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Wazirganj",
            "Pincode": "271124",
            "City": "Wazirganj",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Balpur",
            "Pincode": "271125",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Haldhar Mau",
            "Pincode": "271125",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bb Singh",
            "Pincode": "271126",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rupradih",
            "Pincode": "271127",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Balrampur",
            "Pincode": "271201",
            "City": "Balrampur",
            "District": "Ambedkar Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Balrampur City",
            "Pincode": "271201",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Balrampur Degree College",
            "Pincode": "271201",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nhagwatiganj",
            "Pincode": "271201",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ityathok",
            "Pincode": "271202",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jarwa",
            "Pincode": "271203",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kharagpur",
            "Pincode": "271204",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pachperwa",
            "Pincode": "271206",
            "City": "Pachperwa",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sheopra",
            "Pincode": "271207",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tulsipur",
            "Pincode": "271208",
            "City": "Tulsipur",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaiprabha Gram",
            "Pincode": "271209",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaisari",
            "Pincode": "271210",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gugauli",
            "Pincode": "271211",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kauwapur",
            "Pincode": "271212",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Srawasti",
            "Pincode": "271213",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Motiganj",
            "Pincode": "271301",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mankapur Bazar",
            "Pincode": "271302",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nawabganj",
            "Pincode": "271303",
            "City": "Nawabganj",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nawabganj Sugar Factory",
            "Pincode": "271304",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maskanwa R S",
            "Pincode": "271305",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rehta Bazar",
            "Pincode": "271306",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadullanagar",
            "Pincode": "271307",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Colonelganj",
            "Pincode": "271308",
            "City": "Colonelganj",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Katrabazar",
            "Pincode": "271309",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Paraspur",
            "Pincode": "271310",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bargadi Kot",
            "Pincode": "271311",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babban Jot",
            "Pincode": "271312",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chauhan Purwa",
            "Pincode": "271313",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dehras",
            "Pincode": "271314",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhanawan",
            "Pincode": "271315",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dubha Bazar",
            "Pincode": "271316",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kotia Madara",
            "Pincode": "271317",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Paska",
            "Pincode": "271318",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pure Shiv Dayal",
            "Pincode": "271319",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chhapia",
            "Pincode": "271320",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Swami Narain",
            "Pincode": "271320",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lorasi",
            "Pincode": "271321",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nelsar",
            "Pincode": "271401",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Begamganj",
            "Pincode": "271402",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tarabganj",
            "Pincode": "271403",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Adampur",
            "Pincode": "271404",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chauhan",
            "Pincode": "271405",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Umrapur",
            "Pincode": "271405",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohammadpur",
            "Pincode": "271407",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sanauli",
            "Pincode": "271407",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dujanpurghat",
            "Pincode": "271408",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bairia",
            "Pincode": "271601",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bisunpur",
            "Pincode": "271601",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhaneypur",
            "Pincode": "271602",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Srinagar",
            "Pincode": "271603",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Utraula",
            "Pincode": "271604",
            "City": "Utraula",
            "District": "Balrampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Itei Rampur",
            "Pincode": "271605",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sri Datta Ganj",
            "Pincode": "271607",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahraich",
            "Pincode": "271801",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahraich City",
            "Pincode": "271801",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chhawani Bazar",
            "Pincode": "271801",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gudari",
            "Pincode": "271801",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nanpara Bazar",
            "Pincode": "271801",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Qanoongopura Station Rd",
            "Pincode": "271801",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barauli",
            "Pincode": "271806",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Biseshwarganj",
            "Pincode": "271821",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sonwa",
            "Pincode": "271822",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chitaura",
            "Pincode": "271823",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahsi",
            "Pincode": "271824",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barnapur",
            "Pincode": "271825",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampurwa",
            "Pincode": "271826",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhaigaha",
            "Pincode": "271827",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hariharpur Ravi",
            "Pincode": "271828",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gangwala",
            "Pincode": "271829",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhinga",
            "Pincode": "271831",
            "City": "Bhinga",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhinga",
            "Pincode": "271831",
            "City": "Bhinga",
            "District": "Shrawasti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sujauli",
            "Pincode": "271832",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Katarniaghat",
            "Pincode": "271833",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Patna",
            "Pincode": "271834",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Charda",
            "Pincode": "271836",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Girjapuri Colony",
            "Pincode": "271841",
            "City": "Barabanki",
            "District": "Barabanki",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ikauna",
            "Pincode": "271845",
            "City": "Ikauna",
            "District": "Shrawasti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kherighat",
            "Pincode": "271851",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mihinpurwa",
            "Pincode": "271855",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathura Bazar",
            "Pincode": "271861",
            "City": "Gonda",
            "District": "Gonda",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kailashpuri",
            "Pincode": "271864",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nanpara",
            "Pincode": "271865",
            "City": "Nanpara",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Payagpur",
            "Pincode": "271871",
            "City": "Shrawasti",
            "District": "Shrawasti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Huzurpur",
            "Pincode": "271872",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Risia",
            "Pincode": "271875",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shivpur",
            "Pincode": "271880",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Matera",
            "Pincode": "271882",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jarwal Road",
            "Pincode": "271901",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fakahrpur",
            "Pincode": "271902",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kaisarganj",
            "Pincode": "271903",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jarwal",
            "Pincode": "271904",
            "City": "Jarwal",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaudara",
            "Pincode": "271905",
            "City": "Bahraich",
            "District": "Bahraich",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basti",
            "Pincode": "272001",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basti",
            "Pincode": "272001",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Civil Lines",
            "Pincode": "272001",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "272001",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "272001",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basti Bus Stand",
            "Pincode": "272002",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khakni Darwaza",
            "Pincode": "272002",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pande Bazar",
            "Pincode": "272002",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Purani Basti",
            "Pincode": "272002",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basti Sugar Factory",
            "Pincode": "272003",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Parasrampur",
            "Pincode": "272120",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahson",
            "Pincode": "272124",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dudhara",
            "Pincode": "272125",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amorha",
            "Pincode": "272127",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Captainganj",
            "Pincode": "272131",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Harraiya",
            "Pincode": "272135",
            "City": "Harraiya",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dubaulia",
            "Pincode": "272141",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rudar Nagar",
            "Pincode": "272151",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Daldala",
            "Pincode": "272152",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bansi",
            "Pincode": "272153",
            "City": "Bansi",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bakhira",
            "Pincode": "272159",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babhnan",
            "Pincode": "272161",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhanghata",
            "Pincode": "272162",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaur R S",
            "Pincode": "272163",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hariharpur",
            "Pincode": "272164",
            "City": "Hariharpur",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hainsar Bazar",
            "Pincode": "272165",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mehdawal",
            "Pincode": "272171",
            "City": "Mehdawal",
            "District": "Sant Kabir Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahuli",
            "Pincode": "272172",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maghar",
            "Pincode": "272173",
            "City": "Maghar",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khalilabad",
            "Pincode": "272175",
            "City": "Khalilabad",
            "District": "Sant Kabir Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Munderwa",
            "Pincode": "272178",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Paikulia",
            "Pincode": "272181",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Walterganj",
            "Pincode": "272182",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Domariaganj",
            "Pincode": "272189",
            "City": "Siddharthnagar",
            "District": "Siddharthnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saltawa",
            "Pincode": "272190",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hallaur",
            "Pincode": "272191",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Itwa",
            "Pincode": "272192",
            "City": "Siddharthnagar",
            "District": "Siddharthnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barhni",
            "Pincode": "272201",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Birdpur",
            "Pincode": "272202",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Naugarh",
            "Pincode": "272203",
            "City": "Siddharthnagar",
            "District": "Siddharthnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Udairajganj",
            "Pincode": "272204",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sohratgarh",
            "Pincode": "272205",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sheipatnagar",
            "Pincode": "272206",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tehri Rani",
            "Pincode": "272207",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tetri Bazar",
            "Pincode": "272207",
            "City": "Tetri Bazar",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Uska Bazar",
            "Pincode": "272208",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahjanwa",
            "Pincode": "272209",
            "City": "Sahjanwa",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhakwa Bazar",
            "Pincode": "272211",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khajni",
            "Pincode": "272212",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kalwari",
            "Pincode": "272301",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nagar Bazar",
            "Pincode": "272302",
            "City": "Basti",
            "District": "Basti",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Alahdadpur",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Alinagar",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bank Road",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baxipur",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dharamshalla Bazar",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Golghar",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gorakhnath Mandir",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gorakhpur",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gorakhpur",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gorakhpur Rly Colony",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jatepur Colony",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kazipur",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Loco Workshop",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohaddipur",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajghat",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahebganj",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sumersagar",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Turkmanpur",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "University",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Urdu Bazar",
            "Pincode": "273001",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gorakhpur Air Force Stn",
            "Pincode": "273002",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Arogya",
            "Pincode": "273003",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandir",
            "Pincode": "273003",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basharatpur",
            "Pincode": "273004",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gita Press",
            "Pincode": "273005",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gita Vatika",
            "Pincode": "273006",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fertilizer Factory",
            "Pincode": "273007",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kunraghat",
            "Pincode": "273008",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Labour Camp",
            "Pincode": "273009",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madan Mohan Engg College",
            "Pincode": "273010",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajahi Camp",
            "Pincode": "273011",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Railway Colony",
            "Pincode": "273012",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bichhia Camp",
            "Pincode": "273013",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Brd Medical College",
            "Pincode": "273013",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gorakhpur",
            "Pincode": "273013",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bodarwar",
            "Pincode": "273149",
            "City": "Kushinagar",
            "District": "Kushinagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghil R S",
            "Pincode": "273151",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Piuraich",
            "Pincode": "273152",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Siswabazar",
            "Pincode": "273153",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Anand Nagar",
            "Pincode": "273155",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bridgemanganj",
            "Pincode": "273157",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Compierganj",
            "Pincode": "273158",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhani",
            "Pincode": "273161",
            "City": "Mahrajganj",
            "District": "Mahrajganj",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nautanwa Bazar",
            "Pincode": "273164",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Peppeganj",
            "Pincode": "273165",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chauri Chaura",
            "Pincode": "273201",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadar Nagar",
            "Pincode": "273202",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Partawal Bazar",
            "Pincode": "273301",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhaitauli",
            "Pincode": "273302",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maharaiganj",
            "Pincode": "273303",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nichlaul",
            "Pincode": "273304",
            "City": "Nichlaul",
            "District": "Mahrajganj",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Thuthibari",
            "Pincode": "273305",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhathat",
            "Pincode": "273306",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Brd Medical College",
            "Pincode": "273308",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhawapar",
            "Pincode": "273401",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barhalganj",
            "Pincode": "273402",
            "City": "Barhalganj",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bansgaon",
            "Pincode": "273403",
            "City": "Bansgaon",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Belgaht",
            "Pincode": "273404",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barhi",
            "Pincode": "273405",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Unwal",
            "Pincode": "273406",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Urwa Bazar",
            "Pincode": "273407",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gola",
            "Pincode": "273408",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deidiha",
            "Pincode": "273409",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gagaha",
            "Pincode": "273411",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shopur",
            "Pincode": "273412",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kauri Ram",
            "Pincode": "273413",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chhitauni",
            "Pincode": "273414",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khadda",
            "Pincode": "273415",
            "City": "Khadda",
            "District": "Kushinagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajabazar",
            "Pincode": "273415",
            "City": "Gorakhpur",
            "District": "Gorakhpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deoria",
            "Pincode": "274001",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deoria",
            "Pincode": "274001",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deoria New Colony",
            "Pincode": "274001",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "274001",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nai Bazar",
            "Pincode": "274001",
            "City": "Nai Bazar",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Suddar R S",
            "Pincode": "274001",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Industrial Estate Deor",
            "Pincode": "274121",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhalwani",
            "Pincode": "274132",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baitalpur",
            "Pincode": "274201",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gauri Bazar",
            "Pincode": "274202",
            "City": "Gauri Bazar",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hata",
            "Pincode": "274203",
            "City": "Hata",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rudrapur",
            "Pincode": "274204",
            "City": "Rudrapur",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madanpur",
            "Pincode": "274205",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hetimpur",
            "Pincode": "274206",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sukrauli",
            "Pincode": "274207",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Captianganj",
            "Pincode": "274301",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dudhai R S",
            "Pincode": "274302",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kath Kulan",
            "Pincode": "274303",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Padrauna",
            "Pincode": "274304",
            "City": "Padrauna",
            "District": "Balrampur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ramkola",
            "Pincode": "274305",
            "City": "Ramkola",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Laxmiganj",
            "Pincode": "274306",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fazil Nagar",
            "Pincode": "274401",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kasia",
            "Pincode": "274402",
            "City": "Kushinagar",
            "District": "Kushinagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kushinagar",
            "Pincode": "274403",
            "City": "Kushinagar",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Patherdewa",
            "Pincode": "274404",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "274405",
            "City": "Rampur",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Seorahi",
            "Pincode": "274406",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tamkohi",
            "Pincode": "274407",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tarkulwa",
            "Pincode": "274408",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Taraiya Sujan",
            "Pincode": "274409",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khukhundu",
            "Pincode": "274501",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lansdowne Cantt",
            "Pincode": "274502",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lar",
            "Pincode": "274502",
            "City": "Lar",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lal Road",
            "Pincode": "274505",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Majhauli Raj",
            "Pincode": "274506",
            "City": "Majhauli Raj",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pindi",
            "Pincode": "274508",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Salempur",
            "Pincode": "274509",
            "City": "Salempur",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barhaj",
            "Pincode": "274601",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhagalpur",
            "Pincode": "274602",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaurajainagar",
            "Pincode": "274603",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Paina",
            "Pincode": "274604",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhatni",
            "Pincode": "274701",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhatparrani",
            "Pincode": "274702",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Partappur",
            "Pincode": "274703",
            "City": "Deoria",
            "District": "Deoria",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bheanjan",
            "Pincode": "275101",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mau Nath",
            "Pincode": "275101",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mau R S",
            "Pincode": "275101",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mau Town",
            "Pincode": "275101",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Indara",
            "Pincode": "275102",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jamalpur Mirzapur",
            "Pincode": "275105",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahadurganj",
            "Pincode": "275201",
            "City": "Bahadurganj",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dullahpur",
            "Pincode": "275202",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jakhania Ghazipur",
            "Pincode": "275203",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadat",
            "Pincode": "275204",
            "City": "Sadat",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadiabad",
            "Pincode": "275205",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadiabad",
            "Pincode": "275205",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhimpura",
            "Pincode": "275206",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalalabad",
            "Pincode": "275207",
            "City": "Jalalabad",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baheriabad",
            "Pincode": "275208",
            "City": "Ghazipur",
            "District": "Ghazipur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amila",
            "Pincode": "275301",
            "City": "Amila",
            "District": "Chitrakoot",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhopura",
            "Pincode": "275302",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dohri Ghat",
            "Pincode": "275303",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ghosi",
            "Pincode": "275304",
            "City": "Ghosi",
            "District": "Chitrakoot",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kopaganj",
            "Pincode": "275305",
            "City": "Kopaganj",
            "District": "Chitrakoot",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Surajpur",
            "Pincode": "275306",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Semri Jamalpur",
            "Pincode": "275307",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Korantadih",
            "Pincode": "275501",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Azamgarh",
            "Pincode": "276001",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Azamgarh",
            "Pincode": "276001",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Azamgarh City",
            "Pincode": "276001",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Azamgarh Kote",
            "Pincode": "276001",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Azamgarh Kutchery",
            "Pincode": "276001",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Azamgarh R S",
            "Pincode": "276001",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shibli Academy",
            "Pincode": "276001",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sidhari",
            "Pincode": "276001",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bilariyaganj",
            "Pincode": "276121",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raunapur",
            "Pincode": "276122",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tarwa",
            "Pincode": "276123",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Azamgarh Estate",
            "Pincode": "276124",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bankat",
            "Pincode": "276125",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bansgaon Azamgargh",
            "Pincode": "276126",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bazar Goshian",
            "Pincode": "276127",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chandesar",
            "Pincode": "276128",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chiraiyakote",
            "Pincode": "276129",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jahangaganj",
            "Pincode": "276131",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kanndhrapur",
            "Pincode": "276135",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lal Ghat",
            "Pincode": "276136",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maharajganj",
            "Pincode": "276137",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sagri",
            "Pincode": "276138",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sardaha",
            "Pincode": "276139",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Terhi",
            "Pincode": "276141",
            "City": "Mahrajganj",
            "District": "Mahrajganj",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Koils",
            "Pincode": "276142",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lalganj",
            "Pincode": "276202",
            "City": "Lalganj",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mehatajpur",
            "Pincode": "276203",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mehnagar",
            "Pincode": "276204",
            "City": "Mehnagar",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khaley",
            "Pincode": "276205",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohammadpur",
            "Pincode": "276205",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nizamabad",
            "Pincode": "276206",
            "City": "Nizamabad",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raniki Sarai",
            "Pincode": "276207",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahadurpur",
            "Pincode": "276208",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deogaon",
            "Pincode": "276208",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bardah",
            "Pincode": "276301",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gambhirpur",
            "Pincode": "276302",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Thekma",
            "Pincode": "276303",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Phulpur",
            "Pincode": "276304",
            "City": "Phulpur",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Phulpur Town",
            "Pincode": "276304",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sarai Mir",
            "Pincode": "276305",
            "City": "Sarai Mir",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amilo",
            "Pincode": "276401",
            "City": "Amilo",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karhan",
            "Pincode": "276402",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gohna",
            "Pincode": "276403",
            "City": "Azamgarh",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mohammadabad",
            "Pincode": "276403",
            "City": "Mohammadabad",
            "District": "Chandauli",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mubarakpur",
            "Pincode": "276404",
            "City": "Mubarakpur",
            "District": "Azamgarh",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Walidpur",
            "Pincode": "276405",
            "City": "Chitrakoot",
            "District": "Chitrakoot",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Asharam",
            "Pincode": "277001",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ballia",
            "Pincode": "277001",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ballia City",
            "Pincode": "277001",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhirgu",
            "Pincode": "277001",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kadori",
            "Pincode": "277107",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Garwar",
            "Pincode": "277121",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kureji",
            "Pincode": "277122",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ratsar",
            "Pincode": "277123",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jai Prakash",
            "Pincode": "277127",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nagar",
            "Pincode": "277127",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bairia",
            "Pincode": "277201",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bansdih",
            "Pincode": "277202",
            "City": "Bansdih",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bansdih Road R S",
            "Pincode": "277203",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dallanchapr",
            "Pincode": "277204",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dubey Chapra",
            "Pincode": "277205",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gaighat",
            "Pincode": "277206",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Manlar",
            "Pincode": "277207",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raniganj Bazar",
            "Pincode": "277208",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Reoti",
            "Pincode": "277209",
            "City": "Reoti",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chauta",
            "Pincode": "277210",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahatwar",
            "Pincode": "277211",
            "City": "Sahatwar",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sonwani",
            "Pincode": "277212",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Narayanpur",
            "Pincode": "277213",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Vidya Bhawan",
            "Pincode": "277213",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Karanchipur",
            "Pincode": "277214",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madhubeni",
            "Pincode": "277215",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lalganj",
            "Pincode": "277216",
            "City": "Lalganj",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "277218",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Basntpur",
            "Pincode": "277301",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kharsara",
            "Pincode": "277302",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sikanderpur",
            "Pincode": "277303",
            "City": "Sikanderpur",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sukhpura",
            "Pincode": "277304",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khajuri",
            "Pincode": "277305",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Beruabar",
            "Pincode": "277306",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pandan",
            "Pincode": "277307",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bharsar",
            "Pincode": "277401",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Majhauwa",
            "Pincode": "277403",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Behamari",
            "Pincode": "277404",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Haldi",
            "Pincode": "277404",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dubahar",
            "Pincode": "277405",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Narhi",
            "Pincode": "277502",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Phephna",
            "Pincode": "277503",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sohaon",
            "Pincode": "277504",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sagarpali",
            "Pincode": "277506",
            "City": "Ballia",
            "District": "Ballia",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pikhi",
            "Pincode": "279181",
            "City": "Uttarkashi",
            "District": "Uttarkashi",
            "State": "Uttaranchal"
        },
        {
            "PostOfficeName": "Bharatpur",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chatta Bazar",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dampier Nagar",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Darwaza",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Deeg Gate",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Drishnapuri",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Janamasthan",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lal Darwaza",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathura",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathura Chowk",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raja Dheraj Bazar",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sancharka",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sankat Mochan",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sukh",
            "Pincode": "281001",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "C O D",
            "Pincode": "281002",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathra Cantt",
            "Pincode": "281002",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathura",
            "Pincode": "281002",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathura Jn R S",
            "Pincode": "281002",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Roberts Line",
            "Pincode": "281002",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadar Bazar",
            "Pincode": "281002",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Veterinary College",
            "Pincode": "281002",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gayatri",
            "Pincode": "281003",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tapo Bhumi",
            "Pincode": "281003",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Krishnanagar",
            "Pincode": "281004",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathura",
            "Pincode": "281005",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Refinary",
            "Pincode": "281005",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mathura",
            "Pincode": "281006",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Refinary Nagar",
            "Pincode": "281006",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Farra",
            "Pincode": "281112",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gopi Nath Bazar",
            "Pincode": "281121",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lol Bazar",
            "Pincode": "281121",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sri Banke Behariji",
            "Pincode": "281121",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Vrindaban",
            "Pincode": "281121",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sonkh",
            "Pincode": "281123",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bajna",
            "Pincode": "281201",
            "City": "Bajna",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mant",
            "Pincode": "281202",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Naujhil",
            "Pincode": "281203",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raya",
            "Pincode": "281204",
            "City": "Raya",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Surir",
            "Pincode": "281205",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sonai",
            "Pincode": "281206",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baldeo",
            "Pincode": "281301",
            "City": "Baldeo",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bisawar",
            "Pincode": "281302",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gokul",
            "Pincode": "281303",
            "City": "Gokul",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalesar R S",
            "Pincode": "281304",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahaban",
            "Pincode": "281305",
            "City": "Mahaban",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadabad",
            "Pincode": "281306",
            "City": "Sadabad",
            "District": "Hathras",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sahpau",
            "Pincode": "281307",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jugsena",
            "Pincode": "281308",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chata",
            "Pincode": "281401",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jait",
            "Pincode": "281402",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kosikalan",
            "Pincode": "281403",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shergarh",
            "Pincode": "281404",
            "City": "Shergarh",
            "District": "Jyotiba Phule Nagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barsana",
            "Pincode": "281405",
            "City": "Barsana",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chaumuha",
            "Pincode": "281406",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Aring",
            "Pincode": "281501",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Goverdahan",
            "Pincode": "281502",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Girraj Bhagh",
            "Pincode": "281503",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Latipura",
            "Pincode": "281503",
            "City": "Mathura",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Radhakund",
            "Pincode": "281504",
            "City": "Radhakund",
            "District": "Mathura",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Agra",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Agra",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barracks",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chhipitola",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Command",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "G L Emporium",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hotel Clark",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Idgah Colony",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Namner",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Parachute",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rakabaganj",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Regimental Centre",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadar Bazar",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shiraz",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sultanpura",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tajganj",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Workshop",
            "Pincode": "282001",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bagh",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Billochpura",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Boileganj",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Civil Courts",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Civil Lines",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "G G Indstris",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gokulpura",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hari Parbat",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kaha Mandi",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khan",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Laipat Kunj",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lali Bari",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Medical College",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Muzaffar",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nai-Ki-Nandi",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nalvia Kunj",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Phullati Bazar",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raja Mandi",
            "Pincode": "282002",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rajapur",
            "Pincode": "282002",
            "City": "Rajapur",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shahganj",
            "Pincode": "282002",
            "City": "Shahganj",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Agra Fort",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "B P Oil Mills",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ch Khan",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chauk Agra",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hospital Road",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Johri Bazar",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Moti Katra",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rawatpara",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sadar Bhatti",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shoe Market",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Wazirpura",
            "Pincode": "282003",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Agra University",
            "Pincode": "282004",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Belanganj",
            "Pincode": "282004",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chiman Lal Road",
            "Pincode": "282004",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Industrial Labour Colony",
            "Pincode": "282004",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Johns Mill",
            "Pincode": "282004",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Yamuna Kinara",
            "Pincode": "282004",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dayalbagh",
            "Pincode": "282005",
            "City": "Dayalbagh",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "N V Colony",
            "Pincode": "282005",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Indi Estate",
            "Pincode": "282006",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Yamuna Bridge",
            "Pincode": "282006",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Udyognagar",
            "Pincode": "282007",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "I A F Kheria",
            "Pincode": "282008",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "C O D Agra",
            "Pincode": "282009",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Achnera",
            "Pincode": "283101",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mandi",
            "Pincode": "283101",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Akola",
            "Pincode": "283102",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "A F D Factory",
            "Pincode": "283103",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hazratpur",
            "Pincode": "283103",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bah",
            "Pincode": "283104",
            "City": "Bah",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bichpuri",
            "Pincode": "283105",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehpur Sikri",
            "Pincode": "283110",
            "City": "Fatehpur Sikri",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Fatehabad",
            "Pincode": "283111",
            "City": "Fatehabad",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Iradat Nagar",
            "Pincode": "283112",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaitpur Agra",
            "Pincode": "283114",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jaganair",
            "Pincode": "283115",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kagarol",
            "Pincode": "283119",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khairagarh",
            "Pincode": "283121",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kitaoli",
            "Pincode": "283122",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pinahat",
            "Pincode": "283123",
            "City": "Pinahat",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Saiyan",
            "Pincode": "283124",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Shamshabad",
            "Pincode": "283125",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barhan",
            "Pincode": "283201",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Etamadpur",
            "Pincode": "283202",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ferozabad",
            "Pincode": "283203",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Firozabad",
            "Pincode": "283203",
            "City": "Firozabad",
            "District": "Firozabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Firozabad Bazar",
            "Pincode": "283203",
            "City": "Firozabad",
            "District": "Firozabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Forozabad",
            "Pincode": "283203",
            "City": "Firozabad",
            "District": "Firozabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Industrial Labour Colony",
            "Pincode": "283203",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mainpuri Gate",
            "Pincode": "283203",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "R R Firozabad",
            "Pincode": "283203",
            "City": "Firozabad",
            "District": "Firozabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Snh Road",
            "Pincode": "283203",
            "City": "Agra",
            "District": "Agra",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Tundla",
            "Pincode": "283204",
            "City": "Tundla",
            "District": "Firozabad",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Abbotganj",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ayrvedic University",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bara Bazar",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baria Bazar",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chauraha",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Darwaza",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Garhis Phatak",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhansi",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhansi",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhansi Cantt",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhansi City",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhansi R S",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Khushipura",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lal Kurti Bazar",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Misra",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Municipal Board",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nai Basti",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Orchha Gate",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pharmacy",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sainyar",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sipri Bazar",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Subhashganj",
            "Pincode": "284001",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jhansi City",
            "Pincode": "284002",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sipri Bazar",
            "Pincode": "284003",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baragaon",
            "Pincode": "284121",
            "City": "Baragaon",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bansi",
            "Pincode": "284122",
            "City": "Bansi",
            "District": "Siddharthnagar",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barh",
            "Pincode": "284123",
            "City": "Lalitpur",
            "District": "Lalitpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jakhaura",
            "Pincode": "284124",
            "City": "Lalitpur",
            "District": "Lalitpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lakeview C P O",
            "Pincode": "284125",
            "City": "Lalitpur",
            "District": "Lalitpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhattagaon",
            "Pincode": "284127",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "M L B College",
            "Pincode": "284128",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bhel",
            "Pincode": "284129",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Barwa Sagar",
            "Pincode": "284201",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Gursarai",
            "Pincode": "284202",
            "City": "Gursarai",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Garautha",
            "Pincode": "284203",
            "City": "Garautha",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mauranipur",
            "Pincode": "284204",
            "City": "Mauranipur",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Soot Bazar",
            "Pincode": "284204",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ranipur",
            "Pincode": "284205",
            "City": "Ranipur",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Erich",
            "Pincode": "284302",
            "City": "Erich",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Moth",
            "Pincode": "284303",
            "City": "Moth",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Samthar",
            "Pincode": "284304",
            "City": "Samthar",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bahina Cantt",
            "Pincode": "284401",
            "City": "Jhansi",
            "District": "Jhansi",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Banpur",
            "Pincode": "284402",
            "City": "Lalitpur",
            "District": "Lalitpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Lalitpur",
            "Pincode": "284403",
            "City": "Lalitpur",
            "District": "Lalitpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Sidhi Sagar",
            "Pincode": "284403",
            "City": "Lalitpur",
            "District": "Lalitpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maraura",
            "Pincode": "284404",
            "City": "Lalitpur",
            "District": "Lalitpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Maharoni",
            "Pincode": "284405",
            "City": "Lalitpur",
            "District": "Lalitpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Narhat",
            "Pincode": "284406",
            "City": "Lalitpur",
            "District": "Lalitpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jakhloaun",
            "Pincode": "284407",
            "City": "Lalitpur",
            "District": "Lalitpur",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "D V College",
            "Pincode": "285001",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Orai",
            "Pincode": "285001",
            "City": "Orai",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Orai Kutcher",
            "Pincode": "285001",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Orai R S",
            "Pincode": "285001",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Orai Town",
            "Pincode": "285001",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bangra",
            "Pincode": "285121",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dakore",
            "Pincode": "285122",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jalaun",
            "Pincode": "285123",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Jagmanpur",
            "Pincode": "285124",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kuthond",
            "Pincode": "285125",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madhogarh",
            "Pincode": "285126",
            "City": "Madhogarh",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Rampura",
            "Pincode": "285127",
            "City": "Rampura",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hardrukh",
            "Pincode": "285128",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Umri",
            "Pincode": "285129",
            "City": "Umri",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Dhantali",
            "Pincode": "285130",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Madaripur",
            "Pincode": "285130",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Hardoi",
            "Pincode": "285131",
            "City": "Hardoi",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chiriya",
            "Pincode": "285132",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Raithur",
            "Pincode": "285133",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Charkheri",
            "Pincode": "285136",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babai",
            "Pincode": "285187",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ait",
            "Pincode": "285201",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Ata",
            "Pincode": "285202",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Baoni State",
            "Pincode": "285203",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kalpi",
            "Pincode": "285204",
            "City": "Kalpi",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Konch",
            "Pincode": "285205",
            "City": "Konch",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Konch Bazariya",
            "Pincode": "285205",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Nadigaon",
            "Pincode": "285206",
            "City": "Nadigaon",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Mahewa",
            "Pincode": "285211",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Bilaya",
            "Pincode": "285221",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Pindari",
            "Pincode": "285222",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kopra",
            "Pincode": "285223",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Satoh",
            "Pincode": "285224",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Piariya",
            "Pincode": "285232",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Usargoan",
            "Pincode": "285233",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Babina",
            "Pincode": "285241",
            "City": "Babina",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Chatala",
            "Pincode": "285242",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Margava",
            "Pincode": "285243",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Kailiya",
            "Pincode": "285251",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Amba",
            "Pincode": "285252",
            "City": "Jalaun",
            "District": "Jalaun",
            "State": "Uttar Pradesh"
        },
        {
            "PostOfficeName": "Alwar",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Adarsh Colony",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Arya Nagar",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Bus Stand",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Delhi Gate",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Hope Circus",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Housing Board",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Jey Paltan",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Lajpat Nagar",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Malakhera Gate",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Manu Marg",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Munshi Bazar",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Naya Bas",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Polotechnic",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar R R College",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Railway Station",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Ramganj",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Sarafa Bazar",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Secretariat",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Tripolia",
            "Pincode": "301001",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhiwari Industrial Area",
            "Pincode": "301019",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barrod",
            "Pincode": "301020",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barodameo",
            "Pincode": "301021",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghazi Ka Thana",
            "Pincode": "301022",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Itarna",
            "Pincode": "301023",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Narainpur",
            "Pincode": "301024",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nowgaon",
            "Pincode": "301025",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramgarh Alwar",
            "Pincode": "301026",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramgarh Bus Stand",
            "Pincode": "301026",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pratabgarh Alwar",
            "Pincode": "301027",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bahadarpur",
            "Pincode": "301028",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dariba Project Alwar",
            "Pincode": "301029",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Akbarpur",
            "Pincode": "301031",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ajabpura",
            "Pincode": "301032",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Umren",
            "Pincode": "301033",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaoli Alwar",
            "Pincode": "301034",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ronija Than",
            "Pincode": "301035",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhonkar",
            "Pincode": "301036",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandoli",
            "Pincode": "301037",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Vijaimandir",
            "Pincode": "301042",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alaoda",
            "Pincode": "301043",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shahdoli",
            "Pincode": "301044",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ajerka",
            "Pincode": "301401",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bansur",
            "Pincode": "301402",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bansur Bus Stand",
            "Pincode": "301402",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harsoli Alwar",
            "Pincode": "301403",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khairthal",
            "Pincode": "301404",
            "City": "Khairthal",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khairthal Mandi",
            "Pincode": "301404",
            "City": "Khairthal",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khairthal Town",
            "Pincode": "301404",
            "City": "Khairthal",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kishangarh Bas",
            "Pincode": "301405",
            "City": "Kishangarh",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malakhera",
            "Pincode": "301406",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandawar Alwar",
            "Pincode": "301407",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajagarh Macheri Chowk",
            "Pincode": "301408",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajgarh Alwar",
            "Pincode": "301408",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajgarh R S",
            "Pincode": "301408",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Reni",
            "Pincode": "301409",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tehla",
            "Pincode": "301410",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tijara",
            "Pincode": "301411",
            "City": "Tijara",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tijara Dehra",
            "Pincode": "301411",
            "City": "Tijara",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harsora",
            "Pincode": "301412",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Garhi Sawairam",
            "Pincode": "301413",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhigawada",
            "Pincode": "301414",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhuda",
            "Pincode": "301415",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Saket",
            "Pincode": "301416",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhupsera",
            "Pincode": "301417",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "301418",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Machheri",
            "Pincode": "301419",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "301420",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ismailpur",
            "Pincode": "301421",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shahbad Alwar",
            "Pincode": "301422",
            "City": "Baran",
            "District": "Baran",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pinan",
            "Pincode": "301423",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tatarpur",
            "Pincode": "301424",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khera Mangalsingh",
            "Pincode": "301425",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hamirpur",
            "Pincode": "301426",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karnikot",
            "Pincode": "301427",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bahror",
            "Pincode": "301701",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bahror Bus Stand",
            "Pincode": "301701",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bahror Jat",
            "Pincode": "301701",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kot Kasim",
            "Pincode": "301702",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Majri Kalan",
            "Pincode": "301703",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandhan",
            "Pincode": "301704",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Neemran",
            "Pincode": "301705",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shahahanpur",
            "Pincode": "301706",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tapukara",
            "Pincode": "301707",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kutina",
            "Pincode": "301708",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gandala",
            "Pincode": "301709",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gandhi Vidya Mandir",
            "Pincode": "301709",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Partapur Alwar",
            "Pincode": "301710",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Joria",
            "Pincode": "301711",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bagheri Kalan",
            "Pincode": "301712",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jakharana",
            "Pincode": "301713",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Assembly Hostel",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhura Tiba",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandpole Bazar",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Indira Bazar",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 1 G P O",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kishanpole Bazar",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "M I Road",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "P M Gs Office",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Parivahan Marg",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Purani Basti",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "R D S Bureau",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajasthan State Hotel",
            "Pincode": "302001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Amer Road",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Brahmpuri",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chowkri Gangapole",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Govind Nagar",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 2 Tripolia Bazar",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jalebi Chowk",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Janta Bazar",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kotwali",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Legislative Assembly",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandi Khatikan",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Moti Katla Bazar",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shivaji Nagar",
            "Pincode": "302002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghat Gate",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Haldiyon Ka Rasta",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 3 Jaipur City",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Johri Bazar",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Krishi Upaj Mandi",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Laxminarain Puri",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Paharganj",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "R A C Jaipur",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramganj Bazar",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "S M S Highway",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sabji Mandi",
            "Pincode": "302003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Arjunlal Sethi Nagar",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Correspondence Studies",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 4 Adarshnagar",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Janta Colony",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Krishna Mandir",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mental Hospital",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Moti Dungri Road",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raja Park Colony",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajasthan University",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "S M S Hospital",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tilaknagar",
            "Pincode": "302004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "A G Office Jaipur",
            "Pincode": "302005",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "High Court",
            "Pincode": "302005",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 5 Rajasecretariat",
            "Pincode": "302005",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "New Central Revenue Bldg",
            "Pincode": "302005",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rambagh Palace",
            "Pincode": "302005",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Vidyut Bhawan",
            "Pincode": "302005",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ajmer Road",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bani Park",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 6",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khatipura Road",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Labour Colony",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nandpuri",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "P W D Office",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Postal Stamps Depot",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raj Bhawan",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sindhi Colony",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "302006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 7 P M Gs Office",
            "Pincode": "302007",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 8 G M Ts Office",
            "Pincode": "302008",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 9 D E Ts Office",
            "Pincode": "302009",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 10 D M Ts Office",
            "Pincode": "302010",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 11 A P Sanganaer",
            "Pincode": "302011",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Amba Bari",
            "Pincode": "302012",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dehar Ka Balaji",
            "Pincode": "302012",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 12 Jhotwara",
            "Pincode": "302012",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhotwara Industrial Area",
            "Pincode": "302012",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 13 Vishwa Karma In",
            "Pincode": "302013",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 14 Ddapostal Jai",
            "Pincode": "302014",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bapu Nagar",
            "Pincode": "302015",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barkat Nagar",
            "Pincode": "302015",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Durgapura",
            "Pincode": "302015",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 15 Gandhinagar",
            "Pincode": "302015",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rampura Roopa",
            "Pincode": "302015",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "S D M Hospital",
            "Pincode": "302015",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dwarka Puri",
            "Pincode": "302016",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 16 Shastri Nagar",
            "Pincode": "302016",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajasthan Police Academy",
            "Pincode": "302016",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shiv Park",
            "Pincode": "302016",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikar House Colony",
            "Pincode": "302016",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Amer Clerk Hotel",
            "Pincode": "302017",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur 17 Bajaj Nagar",
            "Pincode": "302017",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "M R E College",
            "Pincode": "302017",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malviya Industrial Area",
            "Pincode": "302017",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malviya Nagar",
            "Pincode": "302017",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Andhi",
            "Pincode": "303001",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Achrol",
            "Pincode": "303002",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Maid",
            "Pincode": "303003",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lawain",
            "Pincode": "303004",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phagi",
            "Pincode": "303005",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Madhorajpura",
            "Pincode": "303006",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bagru",
            "Pincode": "303007",
            "City": "Bagru",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dudu",
            "Pincode": "303008",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mozamabad",
            "Pincode": "303009",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bichoon",
            "Pincode": "303010",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhankrota",
            "Pincode": "303011",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kanota",
            "Pincode": "303012",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Amer",
            "Pincode": "303101",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bairath",
            "Pincode": "303102",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Viratnagar",
            "Pincode": "303102",
            "City": "Viratnagar",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipur",
            "Pincode": "303103",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Manoharpur",
            "Pincode": "303104",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nareheda",
            "Pincode": "303105",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Paota Jaipur",
            "Pincode": "303106",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pragpura",
            "Pincode": "303107",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kotputli",
            "Pincode": "303108",
            "City": "Kotputli",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kotputli Bazar",
            "Pincode": "303108",
            "City": "Kotputli",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jamwa Ramgarh",
            "Pincode": "303109",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajnota",
            "Pincode": "303110",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Antela",
            "Pincode": "303111",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Saiwad",
            "Pincode": "303112",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandwaji",
            "Pincode": "303113",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kansli Jaipur",
            "Pincode": "303114",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gordhanpura",
            "Pincode": "303115",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalyanpura Khurd",
            "Pincode": "303116",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khori",
            "Pincode": "303117",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaisinghpura Khor",
            "Pincode": "303118",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhabhru",
            "Pincode": "303119",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beelwari",
            "Pincode": "303120",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rabupura",
            "Pincode": "303209",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bassi Jaipur",
            "Pincode": "303301",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tunga",
            "Pincode": "303302",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tyre Factory",
            "Pincode": "303302",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dausa",
            "Pincode": "303303",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dausa Mandi",
            "Pincode": "303303",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dausa Town",
            "Pincode": "303303",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dubbi",
            "Pincode": "303304",
            "City": "Dausa",
            "District": "Dausa",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banskho",
            "Pincode": "303305",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baniyana Dausa",
            "Pincode": "303306",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nangal Bersi",
            "Pincode": "303307",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alooda",
            "Pincode": "303308",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhagariya",
            "Pincode": "303309",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kolwa",
            "Pincode": "303310",
            "City": "Dausa",
            "District": "Dausa",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bandikui",
            "Pincode": "303313",
            "City": "Bandikui",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bandikui Mandi",
            "Pincode": "303313",
            "City": "Bandikui",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sayalawas Kalan",
            "Pincode": "303314",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bewai",
            "Pincode": "303315",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gudha Katla",
            "Pincode": "303323",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gudhlia",
            "Pincode": "303324",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kundal",
            "Pincode": "303325",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikandra",
            "Pincode": "303326",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baswa",
            "Pincode": "303327",
            "City": "Dausa",
            "District": "Dausa",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jobner",
            "Pincode": "303328",
            "City": "Jobner",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "A C Jobner",
            "Pincode": "303329",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Agri College Jobner",
            "Pincode": "303329",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhani Boraj",
            "Pincode": "303330",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Asalpur",
            "Pincode": "303331",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phalera",
            "Pincode": "303338",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phalera Bazar",
            "Pincode": "303338",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phalera Rly Colony",
            "Pincode": "303338",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandha Bhimsingh",
            "Pincode": "303339",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhainslana",
            "Pincode": "303340",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kachroda",
            "Pincode": "303341",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Industrial Area Naraina",
            "Pincode": "303348",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Naraina",
            "Pincode": "303348",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sakhun",
            "Pincode": "303349",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhandarej",
            "Pincode": "303501",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Geejgarh",
            "Pincode": "303502",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lalsot",
            "Pincode": "303503",
            "City": "Lalsot",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandawari",
            "Pincode": "303504",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nangal Rajwatan",
            "Pincode": "303505",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Paparda",
            "Pincode": "303506",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sainthal",
            "Pincode": "303507",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikrai",
            "Pincode": "303508",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Manpur Sikrai",
            "Pincode": "303509",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramgarh Pachwara",
            "Pincode": "303510",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Didwana Dausa",
            "Pincode": "303511",
            "City": "Didwana",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Amarsar",
            "Pincode": "303601",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Badhal",
            "Pincode": "303602",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kishangarh Renwal",
            "Pincode": "303603",
            "City": "Kishangarh Renwal",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Renwal",
            "Pincode": "303603",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salt Colony",
            "Pincode": "303604",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sambhar Lake",
            "Pincode": "303604",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karansar",
            "Pincode": "303606",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Surmalikpur",
            "Pincode": "303607",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Luniyawas",
            "Pincode": "303608",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harsoli Jaipur",
            "Pincode": "303609",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mindha",
            "Pincode": "303610",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Akoda",
            "Pincode": "303611",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jahota",
            "Pincode": "303701",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chomu",
            "Pincode": "303702",
            "City": "Chomu",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chomu Tripolia",
            "Pincode": "303702",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tankarda",
            "Pincode": "303703",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaitpura",
            "Pincode": "303704",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hadota",
            "Pincode": "303705",
            "City": "Baran",
            "District": "Baran",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Govindgarh Malikpur",
            "Pincode": "303712",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kaladera",
            "Pincode": "303801",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khadibag",
            "Pincode": "303802",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kheroli",
            "Pincode": "303803",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Etawa Bhopji",
            "Pincode": "303804",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Moriza",
            "Pincode": "303805",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Samod",
            "Pincode": "303806",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udaipuria",
            "Pincode": "303807",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chaksu",
            "Pincode": "303901",
            "City": "Chaksu",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sanganer Bazar",
            "Pincode": "303902",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sheodaspura",
            "Pincode": "303903",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittora Renwal",
            "Pincode": "303904",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Watika",
            "Pincode": "303905",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bada Padampura",
            "Pincode": "303906",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandlai",
            "Pincode": "303907",
            "City": "Jaipur",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "C T Tonk",
            "Pincode": "304001",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "G C Tonk",
            "Pincode": "304001",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "J M Tonk",
            "Pincode": "304001",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kafla Bazar",
            "Pincode": "304001",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Purani Tonk",
            "Pincode": "304001",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tonk",
            "Pincode": "304001",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Newai R S",
            "Pincode": "304020",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Newai",
            "Pincode": "304021",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banasthali",
            "Pincode": "304022",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Aligarh Tonk",
            "Pincode": "304023",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Uniara",
            "Pincode": "304024",
            "City": "Uniara",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhilai",
            "Pincode": "304025",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Siras Tonk",
            "Pincode": "304026",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Avika Nagar",
            "Pincode": "304501",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malpura",
            "Pincode": "304502",
            "City": "Malpura",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malpura Bazar",
            "Pincode": "304502",
            "City": "Malpura",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lamba Hari Singh",
            "Pincode": "304503",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Diggi",
            "Pincode": "304504",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Toda Raisingh",
            "Pincode": "304505",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lawa",
            "Pincode": "304506",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nasirda",
            "Pincode": "304507",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandsen",
            "Pincode": "304508",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pachewar",
            "Pincode": "304509",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Panwalia",
            "Pincode": "304510",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tordisagar",
            "Pincode": "304511",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Peeplu",
            "Pincode": "304801",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Duni",
            "Pincode": "304802",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Panwar Tonk",
            "Pincode": "304803",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "C R P Lines Deoli",
            "Pincode": "304804",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deoli",
            "Pincode": "304804",
            "City": "Deoli",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deoli Bazar",
            "Pincode": "304804",
            "City": "Deoli",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mehandwas",
            "Pincode": "304805",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhunwa Kallan",
            "Pincode": "304806",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajmahal",
            "Pincode": "304807",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Adarsh Nagar",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alwar Gate",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ashaganj",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhajanganj",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dargah Shareef",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhan Mandi",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhola Bhata",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Diggi Bazar",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ganj Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "General Assurance",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Glo Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gujar Dharti Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "J L N Hospital Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jonesganj Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kaisarganj Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kutcheri Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Loco Workshop Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mayo Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mirshali Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mundri Mohalla Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nagra Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nawab Ka Bera",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Naya Bazar Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Parao Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Purani Mandi Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "R P S C Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raj Education Board Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramganj Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramnagar Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Regimental Bazar Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Session Court Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sunder Vilas Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Topdara Ajmer",
            "Pincode": "305001",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "I E Makhupura Ajmer",
            "Pincode": "305002",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "H M T Ajmer",
            "Pincode": "305003",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Regional College Ajmer",
            "Pincode": "305004",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Crpf Ajmer",
            "Pincode": "305005",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ashok Marg Ajmer",
            "Pincode": "305006",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Christianganj Ajmer",
            "Pincode": "305006",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Police Line Ajmer",
            "Pincode": "305006",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shastrinagar Ajmer",
            "Pincode": "305006",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Vaishalinagar Ajmer",
            "Pincode": "305006",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "G C Road Ajmer",
            "Pincode": "305007",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gulab Bari Ajmer",
            "Pincode": "305007",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Naka Madar Ajmer",
            "Pincode": "305007",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pal Beesla Ajmer",
            "Pincode": "305007",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mss Hatundi Ajmer",
            "Pincode": "305008",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sambhoogarh",
            "Pincode": "305011",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karel",
            "Pincode": "305021",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pushkar",
            "Pincode": "305022",
            "City": "Pushkar",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gagwana",
            "Pincode": "305023",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Madar Ajmer",
            "Pincode": "305024",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Srinagar",
            "Pincode": "305025",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Thanwla",
            "Pincode": "305026",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Govindgarh Ajmer",
            "Pincode": "305201",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kharwa",
            "Pincode": "305202",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mangliawas",
            "Pincode": "305203",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pisangan",
            "Pincode": "305204",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajgarh Ajmer",
            "Pincode": "305205",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Saradhana",
            "Pincode": "305206",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jethana Ajmer",
            "Pincode": "305207",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhawani Khera",
            "Pincode": "305401",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramsar Ajmer",
            "Pincode": "305402",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sarwar",
            "Pincode": "305403",
            "City": "Sarwar",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kekri",
            "Pincode": "305404",
            "City": "Kekri",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kekri Bazar",
            "Pincode": "305404",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kadera",
            "Pincode": "305405",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Junia",
            "Pincode": "305406",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sawar",
            "Pincode": "305407",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalera Krishan Gopal",
            "Pincode": "305408",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jahazpur",
            "Pincode": "305409",
            "City": "Jahazpur",
            "District": "Dausa",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jahazpur Mandi",
            "Pincode": "305409",
            "City": "Jahazpur",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pander",
            "Pincode": "305410",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Piplund",
            "Pincode": "305411",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Fatehgarh",
            "Pincode": "305412",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Paroli",
            "Pincode": "305413",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shakargarh",
            "Pincode": "305414",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baghera",
            "Pincode": "305415",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ropan",
            "Pincode": "305416",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nasirabad",
            "Pincode": "305601",
            "City": "Nasirabad",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nasirabad",
            "Pincode": "305601",
            "City": "Nasirabad",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nasirabad Sadar Bazar",
            "Pincode": "305601",
            "City": "Nasirabad",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Regimental Centre",
            "Pincode": "305601",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bandanwara",
            "Pincode": "305621",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhinai",
            "Pincode": "305622",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Masuda",
            "Pincode": "305623",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Masuda Bus Stand",
            "Pincode": "305623",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Matashya Industrial Area",
            "Pincode": "305623",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bijainagar",
            "Pincode": "305624",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bijainagar Bazar",
            "Pincode": "305624",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bijainagar R S",
            "Pincode": "305624",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jalia",
            "Pincode": "305625",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rupaheli Kalan",
            "Pincode": "305626",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tantoti",
            "Pincode": "305627",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Aditya Mills Madanganj",
            "Pincode": "305801",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhat Mohalla Madanganj",
            "Pincode": "305801",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandra Colony Madanganj",
            "Pincode": "305801",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gandhi Nagar Madanganj",
            "Pincode": "305801",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Madanganj",
            "Pincode": "305801",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Madanganj Bazar",
            "Pincode": "305801",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shivajinagar Madanganj",
            "Pincode": "305801",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhan Mandi Kishangarh",
            "Pincode": "305802",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kishangarh",
            "Pincode": "305802",
            "City": "Kishangarh",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kuchil",
            "Pincode": "305811",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harmara Ajmer",
            "Pincode": "305812",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Arain",
            "Pincode": "305813",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rupnagar",
            "Pincode": "305814",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salembad Ajmer",
            "Pincode": "305815",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tilonia",
            "Pincode": "305816",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ralaota Ajmer",
            "Pincode": "305817",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Babaicha",
            "Pincode": "305818",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karkeri",
            "Pincode": "305819",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sursura",
            "Pincode": "305820",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beawar",
            "Pincode": "305901",
            "City": "Beawar",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beawar Chang Gate",
            "Pincode": "305901",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beawar City",
            "Pincode": "305901",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beawar Industrial Area",
            "Pincode": "305901",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beawar Mewari Bazar",
            "Pincode": "305901",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beawar Mills Area",
            "Pincode": "305901",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beawar Nehru Nagar",
            "Pincode": "305901",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beawar R S",
            "Pincode": "305901",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beawar Sendra Road",
            "Pincode": "305901",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beawar Shahpura Mohallah",
            "Pincode": "305901",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tagatgarh",
            "Pincode": "305912",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhim",
            "Pincode": "305921",
            "City": "Rajsamand",
            "District": "Rajsamand",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jawaja",
            "Pincode": "305922",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lotiyana",
            "Pincode": "305923",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Todgarh",
            "Pincode": "305924",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajiawas",
            "Pincode": "305925",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barakhera",
            "Pincode": "305926",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kabra",
            "Pincode": "305927",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Balijassa Khera",
            "Pincode": "305928",
            "City": "Ajmer",
            "District": "Ajmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kharchi Bazar",
            "Pincode": "306001",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Marwar Jn",
            "Pincode": "306001",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Auwa",
            "Pincode": "306021",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jojawar",
            "Pincode": "306022",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ranawas",
            "Pincode": "306023",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deoli Auwa",
            "Pincode": "306024",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhanla",
            "Pincode": "306025",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Isali",
            "Pincode": "306026",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Siriyari",
            "Pincode": "306027",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramsinghji Ka Guda",
            "Pincode": "306028",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Babra",
            "Pincode": "306101",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sendra",
            "Pincode": "306102",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sojat Road",
            "Pincode": "306103",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sojat",
            "Pincode": "306104",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sojat Industrial Estate",
            "Pincode": "306104",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bar",
            "Pincode": "306105",
            "City": "Rajsamand",
            "District": "Rajsamand",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kantalia",
            "Pincode": "306106",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ras",
            "Pincode": "306107",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sumel",
            "Pincode": "306108",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bagrinagar",
            "Pincode": "306114",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rani",
            "Pincode": "306115",
            "City": "Rani",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rani Sadar Bazar",
            "Pincode": "306115",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Falna",
            "Pincode": "306116",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Falna Industrial Estate",
            "Pincode": "306116",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jawali",
            "Pincode": "306117",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhani",
            "Pincode": "306118",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khod",
            "Pincode": "306119",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jawai Bandh",
            "Pincode": "306126",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bishalpur",
            "Pincode": "306127",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beda",
            "Pincode": "306128",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Anandpur Kalu",
            "Pincode": "306301",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jetaran",
            "Pincode": "306302",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nimaj",
            "Pincode": "306303",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Madhopur",
            "Pincode": "306304",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raipur Marwar",
            "Pincode": "306304",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kushalpura",
            "Pincode": "306305",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandawal",
            "Pincode": "306306",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Piplia Kalan",
            "Pincode": "306307",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baloonda",
            "Pincode": "306308",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deoli Kallan",
            "Pincode": "306309",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhunta",
            "Pincode": "306310",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pali",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pali City",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pali Cloth Market",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pali Durgadas Nagar",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pali Industrial Estate",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pali Kachery",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pali Mahavir",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pali Mandia Road",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pali Railway Station",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pali Surajpole",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udyognagar",
            "Pincode": "306401",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rohat",
            "Pincode": "306421",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khairwa",
            "Pincode": "306501",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khinwara",
            "Pincode": "306502",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Somesar",
            "Pincode": "306503",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nana",
            "Pincode": "306504",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhamli",
            "Pincode": "306505",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bijowa",
            "Pincode": "306601",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chanaud",
            "Pincode": "306602",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nadol",
            "Pincode": "306603",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bali",
            "Pincode": "306701",
            "City": "Bali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bali Kacheri",
            "Pincode": "306701",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sadri",
            "Pincode": "306702",
            "City": "Sadri",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sadri Moti Chowk",
            "Pincode": "306702",
            "City": "Sadri",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Desuri",
            "Pincode": "306703",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghanerao",
            "Pincode": "306704",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mundara",
            "Pincode": "306705",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lunawa",
            "Pincode": "306706",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sewari",
            "Pincode": "306707",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sanderao",
            "Pincode": "306708",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ranakpur",
            "Pincode": "306709",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Koselao",
            "Pincode": "306710",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bankli",
            "Pincode": "306901",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sumerpur",
            "Pincode": "306902",
            "City": "Sumerpur",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sumerpur Krishi",
            "Pincode": "306902",
            "City": "Sumerpur",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Undri Sumerpur",
            "Pincode": "306902",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Upaj Mandi",
            "Pincode": "306902",
            "City": "Pali",
            "District": "Pali",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandrai",
            "Pincode": "306913",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sirohi",
            "Pincode": "307001",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sirohi Bazar",
            "Pincode": "307001",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sirohi Bhatkara",
            "Pincode": "307001",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sirohi Sarup Vilas",
            "Pincode": "307001",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaykaypuram",
            "Pincode": "307019",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ajari",
            "Pincode": "307020",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sirohi Road",
            "Pincode": "307021",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pindwara",
            "Pincode": "307022",
            "City": "Pindwara",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sarupganj",
            "Pincode": "307023",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rohida",
            "Pincode": "307024",
            "City": "Rajsamand",
            "District": "Rajsamand",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kotra",
            "Pincode": "307025",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Abu Road",
            "Pincode": "307026",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Abu Road Bazar",
            "Pincode": "307026",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Abu Road Diesel Shed",
            "Pincode": "307026",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Abu Road Gandhinagar",
            "Pincode": "307026",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Krishi Upaj Mandi",
            "Pincode": "307027",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sabzi Mandi Sheoganj",
            "Pincode": "307027",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sheoganj",
            "Pincode": "307027",
            "City": "Sheoganj",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Posalia",
            "Pincode": "307028",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ahore",
            "Pincode": "307029",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Guda Balotra",
            "Pincode": "307030",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhadrajun",
            "Pincode": "307031",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhainswara",
            "Pincode": "307032",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Padiv",
            "Pincode": "307033",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Akhrabhata",
            "Pincode": "307034",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bharja",
            "Pincode": "307035",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mungthala",
            "Pincode": "307036",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhadoli",
            "Pincode": "307037",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Merpur",
            "Pincode": "307038",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bekaria",
            "Pincode": "307039",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Arathwada",
            "Pincode": "307040",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Arathwada",
            "Pincode": "307040",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhanwari",
            "Pincode": "307041",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhanwari",
            "Pincode": "307041",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nandia",
            "Pincode": "307042",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nandia",
            "Pincode": "307042",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Palri",
            "Pincode": "307043",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Santpur",
            "Pincode": "307044",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harji",
            "Pincode": "307045",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harji",
            "Pincode": "307045",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Abu",
            "Pincode": "307501",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Abu Bazar",
            "Pincode": "307501",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Anadra",
            "Pincode": "307511",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dantrai",
            "Pincode": "307512",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandar",
            "Pincode": "307513",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Reodar",
            "Pincode": "307514",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaswantpura",
            "Pincode": "307515",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jawal",
            "Pincode": "307801",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalandari",
            "Pincode": "307802",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramsen",
            "Pincode": "307803",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barloot",
            "Pincode": "307804",
            "City": "Sirohi",
            "District": "Sirohi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bapu Nagar Bhilwara",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhilwara",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhilwara Bus Stand",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhilwara City",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhilwara Court",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhilwara Dhan Mandi",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhilwara Indra Market",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhilwara Labour Colony",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhilwara R S",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhilwara Subashnagar Bhil",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Junawas Bhilwara",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kashipuri Bhilwara",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Krishi Upaj Mandi",
            "Pincode": "311001",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Suwana",
            "Pincode": "311011",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gurlan",
            "Pincode": "311012",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sanganer Bhilwara",
            "Pincode": "311013",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gulabpura",
            "Pincode": "311021",
            "City": "Gulabpura",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hurda",
            "Pincode": "311022",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kothian",
            "Pincode": "311023",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Railagaon",
            "Pincode": "311024",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hamirgarh",
            "Pincode": "311025",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mor Ka Nimbahera",
            "Pincode": "311026",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barliyas",
            "Pincode": "311027",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mangrop",
            "Pincode": "311028",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Agucha",
            "Pincode": "311029",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhanop",
            "Pincode": "311030",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khamore",
            "Pincode": "311031",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhagwanpura Bhilwara",
            "Pincode": "311032",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Asind",
            "Pincode": "311301",
            "City": "Asind",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Badnore",
            "Pincode": "311302",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Daulatgarh",
            "Pincode": "311303",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banera",
            "Pincode": "311401",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bagore",
            "Pincode": "311402",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandal",
            "Pincode": "311403",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shahpura",
            "Pincode": "311404",
            "City": "Shahpura",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shahpura Bazar",
            "Pincode": "311404",
            "City": "Shahpura",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shahpura Bhilwara",
            "Pincode": "311404",
            "City": "Shahpura",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shahpura Kund Gate",
            "Pincode": "311404",
            "City": "Shahpura",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Amli",
            "Pincode": "311405",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ammunition",
            "Pincode": "311405",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kachan Kalan",
            "Pincode": "311406",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phulia Kalan",
            "Pincode": "311407",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Upreda",
            "Pincode": "311408",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bigod",
            "Pincode": "311601",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bijolian",
            "Pincode": "311602",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kotri Bhilwara",
            "Pincode": "311603",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandalgarh",
            "Pincode": "311604",
            "City": "Mandalgarh",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kachhola",
            "Pincode": "311605",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ladpura Bhilwara",
            "Pincode": "311606",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Akola Bhilwara",
            "Pincode": "311607",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nandrai",
            "Pincode": "311608",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khatwara",
            "Pincode": "311609",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gangapur Bhilwara",
            "Pincode": "311801",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shastrinagar Gangapur",
            "Pincode": "311801",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pur",
            "Pincode": "311802",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raipur Bhilwara",
            "Pincode": "311803",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajaji Ka Karera",
            "Pincode": "311804",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Koshithal",
            "Pincode": "311805",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sahada",
            "Pincode": "311806",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lakhola",
            "Pincode": "311807",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karoi",
            "Pincode": "311808",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bemali",
            "Pincode": "311809",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Potlan",
            "Pincode": "311810",
            "City": "Bhilwara",
            "District": "Bhilwara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittorgarh",
            "Pincode": "312001",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittorgarh Collectorate",
            "Pincode": "312001",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittorgarh Gurukul",
            "Pincode": "312001",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittorgarh Industrial Area",
            "Pincode": "312001",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittorgarh Kumbhanagar",
            "Pincode": "312001",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittorgarh Pratapnagar",
            "Pincode": "312001",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittorgarh Rana",
            "Pincode": "312001",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittorgarh Sadar Bazar",
            "Pincode": "312001",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittorgarh Sainik School",
            "Pincode": "312001",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sanga Bazar",
            "Pincode": "312001",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chittorgarh",
            "Pincode": "312021",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bassi Cor",
            "Pincode": "312022",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Begun",
            "Pincode": "312023",
            "City": "Begun",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhadsaura",
            "Pincode": "312024",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Senthi",
            "Pincode": "312025",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bijaipur",
            "Pincode": "312026",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gosunda",
            "Pincode": "312201",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kapasan",
            "Pincode": "312202",
            "City": "Kapasan",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kapasan R S",
            "Pincode": "312202",
            "City": "Kapasan",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kapasan Town",
            "Pincode": "312202",
            "City": "Kapasan",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rashmi",
            "Pincode": "312203",
            "City": "Rajsamand",
            "District": "Rajsamand",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhupalsagar",
            "Pincode": "312204",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Akola Chittorgarh",
            "Pincode": "312205",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pahuna",
            "Pincode": "312206",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Singhpur",
            "Pincode": "312207",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kankarwa",
            "Pincode": "312208",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bansi",
            "Pincode": "312401",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Doongla",
            "Pincode": "312402",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bari Sadri",
            "Pincode": "312403",
            "City": "Bari Sadri",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bari Sadri R S",
            "Pincode": "312403",
            "City": "Bari Sadri",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bohera",
            "Pincode": "312404",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nimbahera",
            "Pincode": "312601",
            "City": "Nimbahera",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nimbahera R S",
            "Pincode": "312601",
            "City": "Nimbahera",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhadesar",
            "Pincode": "312602",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nikumbh",
            "Pincode": "312603",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhoti Sadri",
            "Pincode": "312604",
            "City": "Chhoti Sadri",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhoti Sadri City",
            "Pincode": "312604",
            "City": "Chhoti Sadri",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pratabgarh",
            "Pincode": "312605",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pratabgarh Kacheri",
            "Pincode": "312605",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pratabgarh Surajpole",
            "Pincode": "312605",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kanera",
            "Pincode": "312606",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Borao",
            "Pincode": "312607",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karunda",
            "Pincode": "312608",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lasdawan",
            "Pincode": "312609",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dholapani",
            "Pincode": "312610",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rani Khera",
            "Pincode": "312611",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shambhupura",
            "Pincode": "312612",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sawa",
            "Pincode": "312613",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Binota",
            "Pincode": "312614",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Arnod",
            "Pincode": "312615",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhamotar",
            "Pincode": "312616",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kailash Nagar",
            "Pincode": "312617",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salamgarh",
            "Pincode": "312618",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dalot",
            "Pincode": "312619",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mangrol Chittorgarh",
            "Pincode": "312620",
            "City": "Baran",
            "District": "Baran",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Anuppura",
            "Pincode": "312621",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gangrar",
            "Pincode": "312901",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gangrar R S",
            "Pincode": "312902",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ayed",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhupalpura",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Boharwari",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandpole",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chetak Circle City",
            "Pincode": "313001",
            "City": "Chechat",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhan Mandi",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Fatehpura",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hiran Magri",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Machhala Magra Colony",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Naya Sarafa Bazar",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Palace Road",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Panchwati",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pratapnagar",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Railway Station",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rani Road",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rural Institute",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shivaji Nagar",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Surajpole",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tekri",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tourist Complex",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udaipur",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udaipur Shastri Circle",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "University Campus",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Vidya Bhawan",
            "Pincode": "313001",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Badgaon",
            "Pincode": "313011",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lakadwas",
            "Pincode": "313012",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Saveena",
            "Pincode": "313013",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kanpur",
            "Pincode": "313014",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhamar Kotra Mines",
            "Pincode": "313015",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bedla",
            "Pincode": "313016",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bajaj Nagar",
            "Pincode": "313021",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Cement Factory",
            "Pincode": "313021",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dabok",
            "Pincode": "313022",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dabok Air Port",
            "Pincode": "313023",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Zink Smelter",
            "Pincode": "313024",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bari T B Sanatorium",
            "Pincode": "313025",
            "City": "Bari Sadri",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Intalikhera",
            "Pincode": "313026",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salumbar",
            "Pincode": "313027",
            "City": "Salumbar",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salumbar Gandhi Chowk",
            "Pincode": "313027",
            "City": "Salumbar",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Seria",
            "Pincode": "313028",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Debari",
            "Pincode": "313029",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhalerana",
            "Pincode": "313030",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nai",
            "Pincode": "313031",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Daroli",
            "Pincode": "313032",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dal",
            "Pincode": "313033",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tokar",
            "Pincode": "313034",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhallara",
            "Pincode": "313038",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khemli",
            "Pincode": "313201",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Delwara",
            "Pincode": "313202",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mavli Jn",
            "Pincode": "313203",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Palana Khurd",
            "Pincode": "313204",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Fatel Nagar",
            "Pincode": "313205",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sanwar",
            "Pincode": "313206",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gilund",
            "Pincode": "313207",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kailashpuri",
            "Pincode": "313209",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghasa",
            "Pincode": "313210",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dariba Udaipur",
            "Pincode": "313211",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sakroda",
            "Pincode": "313212",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nathdwara",
            "Pincode": "313301",
            "City": "Nathdwara",
            "District": "Rajsamand",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nathdwara Chopati",
            "Pincode": "313301",
            "City": "Rajsamand",
            "District": "Rajsamand",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shishoda",
            "Pincode": "313303",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gaon Guda",
            "Pincode": "313321",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khamnore",
            "Pincode": "313322",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kotharia",
            "Pincode": "313323",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kankroli",
            "Pincode": "313324",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kelwara",
            "Pincode": "313325",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajsamand",
            "Pincode": "313326",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Koaria",
            "Pincode": "313327",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kuraj",
            "Pincode": "313328",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Railmagra",
            "Pincode": "313329",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lawa Sardargarh",
            "Pincode": "313330",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deogarh",
            "Pincode": "313331",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deogarh Bazar",
            "Pincode": "313331",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kelwa",
            "Pincode": "313331",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Charbhuja Road Amet",
            "Pincode": "313332",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Charbhuja",
            "Pincode": "313333",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhalon Ki Madar",
            "Pincode": "313336",
            "City": "Rajsamand",
            "District": "Rajsamand",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rinchhed",
            "Pincode": "313337",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mohi",
            "Pincode": "313338",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhaplian",
            "Pincode": "313340",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barar",
            "Pincode": "313341",
            "City": "Rajsamand",
            "District": "Rajsamand",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kankroli",
            "Pincode": "313342",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Vallabhnagar",
            "Pincode": "313601",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kheroda",
            "Pincode": "313602",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhinder",
            "Pincode": "313603",
            "City": "Bhinder",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kanore",
            "Pincode": "313604",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhariawad",
            "Pincode": "313605",
            "City": "Dhariawad",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rundera",
            "Pincode": "313606",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lasadia",
            "Pincode": "313607",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Intali",
            "Pincode": "313608",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khunta",
            "Pincode": "313609",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Keshariawad",
            "Pincode": "313610",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Parsola",
            "Pincode": "313611",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kun",
            "Pincode": "313612",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mehar",
            "Pincode": "313613",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phalasia",
            "Pincode": "313701",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhadol Phalasia",
            "Pincode": "313702",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kurawar",
            "Pincode": "313703",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sayra",
            "Pincode": "313704",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gogunda",
            "Pincode": "313705",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bambora",
            "Pincode": "313706",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaswantgarh Udaipur",
            "Pincode": "313707",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nandeshma",
            "Pincode": "313708",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Koshiwara",
            "Pincode": "313709",
            "City": "Rajsamand",
            "District": "Rajsamand",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Parsad",
            "Pincode": "313801",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rishabhdeo",
            "Pincode": "313802",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kherwara",
            "Pincode": "313803",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhani",
            "Pincode": "313804",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barapal",
            "Pincode": "313805",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bawalwara",
            "Pincode": "313806",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Zawar Mines",
            "Pincode": "313901",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sarara",
            "Pincode": "313902",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Semari",
            "Pincode": "313903",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chawand",
            "Pincode": "313904",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhadol Sarara",
            "Pincode": "313905",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sagtara",
            "Pincode": "313906",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalyanpur Udaipur",
            "Pincode": "313907",
            "City": "Udaipur",
            "District": "Udaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dungarpur",
            "Pincode": "314001",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dungarpur City",
            "Pincode": "314001",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dungarpur Gepsagar",
            "Pincode": "314001",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dungarpur Sabzi Mandi",
            "Pincode": "314001",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Paldewal",
            "Pincode": "314011",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bildi",
            "Pincode": "314012",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mathugamda",
            "Pincode": "314013",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Aspur",
            "Pincode": "314021",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sabla",
            "Pincode": "314022",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bankoda",
            "Pincode": "314023",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Padwa",
            "Pincode": "314024",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Galiakot Colony",
            "Pincode": "314025",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sagwara",
            "Pincode": "314025",
            "City": "Sagwara",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sagwara Bazar",
            "Pincode": "314025",
            "City": "Sagwara",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Galiakot",
            "Pincode": "314026",
            "City": "Galiakot",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khadagda",
            "Pincode": "314027",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Punali",
            "Pincode": "314028",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Thakarda",
            "Pincode": "314029",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chikhli",
            "Pincode": "314030",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhiluda",
            "Pincode": "314031",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Saroda",
            "Pincode": "314032",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jethana Dungarpur",
            "Pincode": "314033",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramgrh Dungarpur",
            "Pincode": "314034",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chitri",
            "Pincode": "314035",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Damdi",
            "Pincode": "314036",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Antri",
            "Pincode": "314037",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Punjpur",
            "Pincode": "314038",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Obri",
            "Pincode": "314401",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhambola",
            "Pincode": "314402",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Simalwara",
            "Pincode": "314403",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Vikasnagar",
            "Pincode": "314404",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Genji",
            "Pincode": "314405",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Peeth",
            "Pincode": "314406",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karawada",
            "Pincode": "314407",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bichhiwara",
            "Pincode": "314801",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bokhla",
            "Pincode": "314802",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Balware",
            "Pincode": "314803",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kanba",
            "Pincode": "314804",
            "City": "Dungarpur",
            "District": "Dungarpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Anaha Gate Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Atal Band Mandi",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Basan Darwaza",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bharatpur Agency",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bharatpur City",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chauburja Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gopalgarh Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Industrial Area Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kanjoli Lines Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kotwali Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Krishna Colony",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kumher Gate Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Laxman Mandir Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mathura Darwaza Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "New Mandi Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ranjeet Nagar Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Wagon Factory Bharatpur",
            "Pincode": "321001",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaghina",
            "Pincode": "321021",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bus Stand Kaman",
            "Pincode": "321022",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gopinath Mohalla",
            "Pincode": "321022",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kaman",
            "Pincode": "321022",
            "City": "Kaman",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jurhera",
            "Pincode": "321023",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikri",
            "Pincode": "321024",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rareh",
            "Pincode": "321025",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Depot",
            "Pincode": "321026",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Marena Bharatpur",
            "Pincode": "321027",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kherli Gadasia",
            "Pincode": "321028",
            "City": "Kherli",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jalalpur",
            "Pincode": "321029",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pinghera",
            "Pincode": "321030",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gulpara",
            "Pincode": "321031",
            "City": "Gulabpura",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kaithwara",
            "Pincode": "321032",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mai",
            "Pincode": "321033",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dehra",
            "Pincode": "321034",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bilond",
            "Pincode": "321035",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Isapur Katara",
            "Pincode": "321035",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barkhera",
            "Pincode": "321036",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bus Stand Kumher",
            "Pincode": "321201",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kumher",
            "Pincode": "321201",
            "City": "Kumher",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Penghore",
            "Pincode": "321202",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deeg",
            "Pincode": "321203",
            "City": "Deeg",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deeg Court",
            "Pincode": "321203",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deeg Laxman Mandir",
            "Pincode": "321203",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Purani Deeg",
            "Pincode": "321203",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pahari",
            "Pincode": "321204",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bus Stand Nagar",
            "Pincode": "321205",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nagar Bharatpur",
            "Pincode": "321205",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khoh",
            "Pincode": "321206",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sawai",
            "Pincode": "321207",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sawai Kheda",
            "Pincode": "321207",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bahaj",
            "Pincode": "321208",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bahtana",
            "Pincode": "321209",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Thoon",
            "Pincode": "321210",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gopalgarh",
            "Pincode": "321211",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pichuna",
            "Pincode": "321301",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Uchain",
            "Pincode": "321302",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sewar",
            "Pincode": "321303",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Milakpur",
            "Pincode": "321304",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ludhawai",
            "Pincode": "321305",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bayana",
            "Pincode": "321401",
            "City": "Bayana",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bayana Bazariya",
            "Pincode": "321401",
            "City": "Bayana",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bayana Jain Gali",
            "Pincode": "321401",
            "City": "Bayana",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bayana Kutchery",
            "Pincode": "321401",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rudawal",
            "Pincode": "321402",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bansi Paharpur",
            "Pincode": "321403",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rupbas",
            "Pincode": "321404",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rupbas Town",
            "Pincode": "321404",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Band Baretha",
            "Pincode": "321405",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhusawar",
            "Pincode": "321406",
            "City": "Bhusawar",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhusawar Town",
            "Pincode": "321406",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahila Vidyapeeth",
            "Pincode": "321406",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhonkerwara Kalan",
            "Pincode": "321407",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Weir",
            "Pincode": "321408",
            "City": "Weir",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Weir Town",
            "Pincode": "321408",
            "City": "Weir",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ballabhgarh",
            "Pincode": "321409",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Brahambad",
            "Pincode": "321410",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khareri",
            "Pincode": "321411",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghatri",
            "Pincode": "321412",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salempur Kalan",
            "Pincode": "321413",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nithar",
            "Pincode": "321414",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Majajpur",
            "Pincode": "321415",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baroli Bharatpur",
            "Pincode": "321416",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Itamda",
            "Pincode": "321417",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Narharpur",
            "Pincode": "321418",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nayagaon Khalsa",
            "Pincode": "321419",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khanwa",
            "Pincode": "321420",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salempur Khurd",
            "Pincode": "321421",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Samraya",
            "Pincode": "321422",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Garhi Bajna",
            "Pincode": "321423",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahalpur Chura",
            "Pincode": "321424",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jeewad",
            "Pincode": "321425",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jagjiwanpur",
            "Pincode": "321426",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhana Kherli",
            "Pincode": "321427",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khan Surajpur",
            "Pincode": "321428",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Siras",
            "Pincode": "321429",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khankhera",
            "Pincode": "321430",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salasar",
            "Pincode": "321506",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Halena",
            "Pincode": "321601",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nadbai",
            "Pincode": "321602",
            "City": "Nadbai",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nadbai Town",
            "Pincode": "321602",
            "City": "Nadbai",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gadoli",
            "Pincode": "321603",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Govindgarh Bharatpur",
            "Pincode": "321604",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kathumar",
            "Pincode": "321605",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kherli",
            "Pincode": "321606",
            "City": "Kherli",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kherli Mandi",
            "Pincode": "321606",
            "City": "Kherli",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Laxmangarh",
            "Pincode": "321607",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahwa",
            "Pincode": "321608",
            "City": "Mahwa",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahwa Road",
            "Pincode": "321609",
            "City": "Mahwa",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghata Balaji",
            "Pincode": "321610",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Toda Bhim",
            "Pincode": "321611",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Paota Bharatpur",
            "Pincode": "321612",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rashidpur",
            "Pincode": "321613",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Akhaigarh",
            "Pincode": "321614",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pathena",
            "Pincode": "321615",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhadira",
            "Pincode": "321616",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alipur",
            "Pincode": "321617",
            "City": "Dausa",
            "District": "Dausa",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karili",
            "Pincode": "321618",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barauli Chhar",
            "Pincode": "321619",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Balaheri",
            "Pincode": "321620",
            "City": "Dausa",
            "District": "Dausa",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rauthadia",
            "Pincode": "321621",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Garh Himmatsingh",
            "Pincode": "321622",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kot",
            "Pincode": "321623",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota 1",
            "Pincode": "321623",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Santha",
            "Pincode": "321625",
            "City": "Dausa",
            "District": "Dausa",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ukrond",
            "Pincode": "321626",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sonkhri",
            "Pincode": "321628",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tasai",
            "Pincode": "321629",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khonkhar",
            "Pincode": "321630",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalwari",
            "Pincode": "321631",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Samuchi",
            "Pincode": "321632",
            "City": "Bharatpur",
            "District": "Bharatpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Maujpur",
            "Pincode": "321633",
            "City": "Dausa",
            "District": "Dausa",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mundia Lalita",
            "Pincode": "321634",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Paharsar",
            "Pincode": "321636",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Paprera",
            "Pincode": "321637",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hantra",
            "Pincode": "321638",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sabora",
            "Pincode": "321639",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dantia",
            "Pincode": "321640",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Garu",
            "Pincode": "321641",
            "City": "Alwar",
            "District": "Alwar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhan",
            "Pincode": "322001",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Madhopur",
            "Pincode": "322001",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sawai Madhopur R S",
            "Pincode": "322001",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sawai Madhopur Town",
            "Pincode": "322021",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sawai Modhopur",
            "Pincode": "322021",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Town Bazar",
            "Pincode": "322021",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sahunagar",
            "Pincode": "322022",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sahunagar Adarshnagar",
            "Pincode": "322022",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bonli",
            "Pincode": "322023",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malarna R S",
            "Pincode": "322023",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khirni",
            "Pincode": "322024",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khandar",
            "Pincode": "322025",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phalodi Quarry",
            "Pincode": "322026",
            "City": "Phalodi",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Soorwal",
            "Pincode": "322027",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malarna Doongar",
            "Pincode": "322028",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kundera",
            "Pincode": "322029",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malarna Chour",
            "Pincode": "322030",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rawanjna Doongar",
            "Pincode": "322031",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bahraonda Khurd",
            "Pincode": "322032",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chakeri",
            "Pincode": "322034",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bharoti",
            "Pincode": "322035",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hadoti",
            "Pincode": "322036",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gangapur Bazar",
            "Pincode": "322201",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gangapur New Mandi",
            "Pincode": "322201",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gangapur R S",
            "Pincode": "322201",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gangapur Rly Colony",
            "Pincode": "322201",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahu Kalan",
            "Pincode": "322202",
            "City": "Mahu Kalan",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Narauli Dang",
            "Pincode": "322203",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sahar",
            "Pincode": "322204",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shahar",
            "Pincode": "322204",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Piloda",
            "Pincode": "322205",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udai Kalan",
            "Pincode": "322206",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sankarwada",
            "Pincode": "322209",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bamanwas",
            "Pincode": "322211",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Garh Moran",
            "Pincode": "322212",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Guda Chanderji",
            "Pincode": "322213",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Piplai",
            "Pincode": "322214",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nadoti",
            "Pincode": "322215",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kemri",
            "Pincode": "322216",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Liwali",
            "Pincode": "322217",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sapotra",
            "Pincode": "322218",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Wazirpur",
            "Pincode": "322219",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Mahavirji",
            "Pincode": "322220",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shantivirnagar",
            "Pincode": "322221",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sewa",
            "Pincode": "322222",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raipur Sawai Madhopur",
            "Pincode": "322223",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mirzapur",
            "Pincode": "322224",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hindaun",
            "Pincode": "322230",
            "City": "Hindaun",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hindaun New Mandi",
            "Pincode": "322230",
            "City": "Hindaun",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Station Road Hindaun",
            "Pincode": "322230",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhareda",
            "Pincode": "322231",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kachroli",
            "Pincode": "322232",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikroda Mina",
            "Pincode": "322233",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kheda",
            "Pincode": "322234",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandawar Bharatpur",
            "Pincode": "322235",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhindora",
            "Pincode": "322236",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kherla",
            "Pincode": "322240",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Court Karauli",
            "Pincode": "322241",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karauli",
            "Pincode": "322241",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phoota Kot Karauli",
            "Pincode": "322241",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Machilpur",
            "Pincode": "322242",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kailadevi",
            "Pincode": "322243",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karanpur",
            "Pincode": "322244",
            "City": "Karanpur",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sunderpura",
            "Pincode": "322245",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Talchiri",
            "Pincode": "322246",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chainpur",
            "Pincode": "322247",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salempur Chowki",
            "Pincode": "322248",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandrail",
            "Pincode": "322251",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Fatehsinghpur",
            "Pincode": "322252",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Suroth",
            "Pincode": "322252",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghonsla",
            "Pincode": "322254",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kurgaon",
            "Pincode": "322255",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jatnagla",
            "Pincode": "322327",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhagwatgarh",
            "Pincode": "322701",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chauth Ka Barwara",
            "Pincode": "322702",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Isharda",
            "Pincode": "322703",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Siwar",
            "Pincode": "322704",
            "City": "Swaimadhopur",
            "District": "Swaimadhopur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Balchandpara Bundi",
            "Pincode": "323001",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bundi",
            "Pincode": "323001",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Collectorate Bundi",
            "Pincode": "323001",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "New Colony Bundi",
            "Pincode": "323001",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Talera",
            "Pincode": "323021",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Namana",
            "Pincode": "323022",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hindoli",
            "Pincode": "323023",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bada Naya Gaon",
            "Pincode": "323024",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Umar",
            "Pincode": "323025",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dablana",
            "Pincode": "323026",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kapren",
            "Pincode": "323301",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jawaharsagar",
            "Pincode": "323302",
            "City": "Tonk",
            "District": "Tonk",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Anushakti",
            "Pincode": "323303",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhensroadgarh",
            "Pincode": "323304",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rawat Bhata",
            "Pincode": "323305",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rawat Bhata Bazar",
            "Pincode": "323305",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Vikramnagar",
            "Pincode": "323306",
            "City": "Chittorgarh",
            "District": "Chittorgarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Keshoraipatan",
            "Pincode": "323601",
            "City": "Keshoraipatan",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Keshoraipatan Sugar Fact",
            "Pincode": "323602",
            "City": "Keshoraipatan",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lakheri",
            "Pincode": "323603",
            "City": "Lakheri",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Indergarh",
            "Pincode": "323613",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sumerganj Mandi",
            "Pincode": "323614",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lakheri Gaon",
            "Pincode": "323615",
            "City": "Lakheri",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nainwan",
            "Pincode": "323801",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Del",
            "Pincode": "323802",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khatkar",
            "Pincode": "323803",
            "City": "Bundi",
            "District": "Bundi",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Government College",
            "Pincode": "324001",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota",
            "Pincode": "324001",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota 2",
            "Pincode": "324001",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kutchery",
            "Pincode": "324001",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nayapura",
            "Pincode": "324001",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Subash Marg",
            "Pincode": "324001",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dadwara Colony",
            "Pincode": "324002",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gurudwara Road",
            "Pincode": "324002",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota 3",
            "Pincode": "324002",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota Jn",
            "Pincode": "324002",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "New Railway Colony",
            "Pincode": "324002",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "W R C Kota",
            "Pincode": "324002",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Industrial Estate Kota",
            "Pincode": "324003",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota 4",
            "Pincode": "324003",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "324004",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota 5",
            "Pincode": "324004",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udyogpuri Indira",
            "Pincode": "324004",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udyogpuri Kota",
            "Pincode": "324004",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota 6",
            "Pincode": "324005",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "P I P Kota",
            "Pincode": "324005",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pi Indraprakash",
            "Pincode": "324005",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pip Vigyan Nagar",
            "Pincode": "324005",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Talwandi",
            "Pincode": "324005",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghantaghar Kota",
            "Pincode": "324006",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kaithoonipole Kota",
            "Pincode": "324006",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota 7",
            "Pincode": "324006",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota City",
            "Pincode": "324006",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "New Grain Mandi",
            "Pincode": "324006",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Patanpole Kota",
            "Pincode": "324006",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Subzi Mandi Kota",
            "Pincode": "324006",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Surajpole Kota",
            "Pincode": "324006",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "C R Pura",
            "Pincode": "324007",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gumanpura Kota",
            "Pincode": "324007",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota",
            "Pincode": "324007",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota 8",
            "Pincode": "324007",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kotri Gordhanpura",
            "Pincode": "324007",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shopping Centre",
            "Pincode": "324007",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Small Industrial Area",
            "Pincode": "324007",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Vallabhnagar",
            "Pincode": "324007",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kota 9",
            "Pincode": "324008",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kunadi",
            "Pincode": "324008",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chambal Vikas",
            "Pincode": "324009",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dada Bari Kota",
            "Pincode": "324009",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kishanpura",
            "Pincode": "324009",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kaithun",
            "Pincode": "325001",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Cablenagar",
            "Pincode": "325003",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Cement Factory Area",
            "Pincode": "325003",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Itawa",
            "Pincode": "325004",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandana",
            "Pincode": "325006",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nanta",
            "Pincode": "325007",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pipalda",
            "Pincode": "325008",
            "City": "Baran",
            "District": "Baran",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khatoli",
            "Pincode": "325009",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Digod",
            "Pincode": "325201",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Anta",
            "Pincode": "325202",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Simalia",
            "Pincode": "325203",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sultanpur",
            "Pincode": "325204",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baran",
            "Pincode": "325205",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baran Krishi Upaj",
            "Pincode": "325205",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chaumukha Baran",
            "Pincode": "325205",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandi",
            "Pincode": "325205",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Siswali",
            "Pincode": "325206",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bapawar",
            "Pincode": "325207",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Fatehpur Kota",
            "Pincode": "325208",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ayana",
            "Pincode": "325214",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mangrol Kota",
            "Pincode": "325215",
            "City": "Baran",
            "District": "Baran",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kishanganj",
            "Pincode": "325216",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shahbad Kota",
            "Pincode": "325217",
            "City": "Baran",
            "District": "Baran",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Atru",
            "Pincode": "325218",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salpura",
            "Pincode": "325219",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Aliganj Chhabra",
            "Pincode": "325220",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhabra",
            "Pincode": "325220",
            "City": "Chhabra",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhipa Barod",
            "Pincode": "325221",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bohat",
            "Pincode": "325222",
            "City": "Baran",
            "District": "Baran",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Atone",
            "Pincode": "325223",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Garda",
            "Pincode": "325224",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harnawda Shahji Ka",
            "Pincode": "325225",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaipla",
            "Pincode": "325226",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Samrania",
            "Pincode": "325227",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sangod",
            "Pincode": "325601",
            "City": "Sangod",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kanwas",
            "Pincode": "325602",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhalawar",
            "Pincode": "326001",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhalawar Collectorate",
            "Pincode": "326001",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mangalpura",
            "Pincode": "326001",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Asnawar",
            "Pincode": "326021",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bakani",
            "Pincode": "326022",
            "City": "Bakani",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhalra Patan City",
            "Pincode": "326023",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ratlai",
            "Pincode": "326024",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Aklera",
            "Pincode": "326033",
            "City": "Aklera",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pirawa",
            "Pincode": "326034",
            "City": "Pirawa",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sarola",
            "Pincode": "326035",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raipur Jhalawar",
            "Pincode": "326036",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Manohar Thana",
            "Pincode": "326037",
            "City": "Manohar Thana",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khanpur",
            "Pincode": "326038",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghatoli",
            "Pincode": "326039",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harigarh",
            "Pincode": "326040",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Panwar Jhalawar",
            "Pincode": "326041",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Chhatarpur",
            "Pincode": "326501",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhawani Mandi",
            "Pincode": "326502",
            "City": "Bhawani Mandi",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhawani Mandi Textile Mil",
            "Pincode": "326502",
            "City": "Bhawani Mandi",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhawani Mandistation Rd",
            "Pincode": "326502",
            "City": "Bhawani Mandi",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ganeshpura",
            "Pincode": "326503",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pachpahar",
            "Pincode": "326512",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sunel",
            "Pincode": "326513",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dag",
            "Pincode": "326514",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chaumehla",
            "Pincode": "326515",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gangdhar",
            "Pincode": "326516",
            "City": "Jhalawar",
            "District": "Jhalawar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Morak",
            "Pincode": "326517",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chechat",
            "Pincode": "326518",
            "City": "Chechat",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramganj Mandi",
            "Pincode": "326519",
            "City": "Ramganj Mandi",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramgnj Mandi Bazar",
            "Pincode": "326519",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shahed Pannalal Chorawa",
            "Pincode": "326519",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Undwa",
            "Pincode": "326520",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salotia",
            "Pincode": "326521",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khairabad",
            "Pincode": "326529",
            "City": "Kota",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Suket",
            "Pincode": "326530",
            "City": "Suket",
            "District": "Kota",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banswara",
            "Pincode": "327001",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banswara City",
            "Pincode": "327001",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banswara Industrial Area",
            "Pincode": "327001",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banswara Mahi Colony",
            "Pincode": "327001",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banswara Prithviganj",
            "Pincode": "327001",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banswara Sect",
            "Pincode": "327001",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ganoda",
            "Pincode": "327021",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Garhi",
            "Pincode": "327022",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghatol",
            "Pincode": "327023",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Partapur Banswara",
            "Pincode": "327024",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Talwara",
            "Pincode": "327025",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahi Dam",
            "Pincode": "327026",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khamera",
            "Pincode": "327027",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Paloda",
            "Pincode": "327028",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pipalkhunt",
            "Pincode": "327029",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Danpur",
            "Pincode": "327030",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhukhia",
            "Pincode": "327031",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Arthuna",
            "Pincode": "327032",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shergarh Banswara",
            "Pincode": "327033",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bagidora",
            "Pincode": "327601",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sajjangarh",
            "Pincode": "327602",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barodia",
            "Pincode": "327604",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Loharia",
            "Pincode": "327605",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalinjara",
            "Pincode": "327606",
            "City": "Banswara",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kushalgarh",
            "Pincode": "327801",
            "City": "Kushalgarh",
            "District": "Banswara",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kushalgarh Bus Stand",
            "Pincode": "327801",
            "City": "Kushalgarh",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dholpur",
            "Pincode": "328001",
            "City": "Baran",
            "District": "Baran",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dholpur Bazariya",
            "Pincode": "328001",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dholpur City",
            "Pincode": "328001",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dholpur Civil Court",
            "Pincode": "328001",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dholpur Ganj",
            "Pincode": "328001",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "New Bus Stand Dholpur",
            "Pincode": "328001",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sabzi Mandi Dholpur",
            "Pincode": "328001",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udaibhanganj Dholpur",
            "Pincode": "328001",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bari",
            "Pincode": "328021",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bari Bazar",
            "Pincode": "328021",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bari Gumat",
            "Pincode": "328021",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bari R S",
            "Pincode": "328021",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baseri",
            "Pincode": "328022",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baseri R S",
            "Pincode": "328022",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Basai Nawab",
            "Pincode": "328023",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mania",
            "Pincode": "328024",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajakhera",
            "Pincode": "328025",
            "City": "Rajakhera",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajakhera Bus Stand",
            "Pincode": "328025",
            "City": "Rajakhera",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajakhera Town",
            "Pincode": "328025",
            "City": "Rajakhera",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sarmathura",
            "Pincode": "328026",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Saipau",
            "Pincode": "328027",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kaisar Bagh Dholpur",
            "Pincode": "328028",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Marena Dholpur",
            "Pincode": "328029",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pachgaon",
            "Pincode": "328030",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barauli Dholpur",
            "Pincode": "328031",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kolari",
            "Pincode": "328032",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Basai Dang",
            "Pincode": "328033",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dholpur",
            "Pincode": "328034",
            "City": "Baran",
            "District": "Baran",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tasimo",
            "Pincode": "328035",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Angai",
            "Pincode": "328036",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Amberpur",
            "Pincode": "328037",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jarga",
            "Pincode": "328038",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salembad Dholpur",
            "Pincode": "328039",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pipron",
            "Pincode": "328040",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kanchanpur",
            "Pincode": "328041",
            "City": "Dholpur",
            "District": "Dholpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bagla School Road",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Churu",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Churu",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Churu Bazar",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Churu City",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Churu Collectorate",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Churu R S",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghantaghar Churu",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Singhi Park Churu",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sitla Temple Road Churu",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Station Road Churu",
            "Pincode": "331001",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khasoli",
            "Pincode": "331020",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ratannagar",
            "Pincode": "331021",
            "City": "Ratannagar",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Adarsh Nagar Ratangarh",
            "Pincode": "331022",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bapu Nagar Ratangarh",
            "Pincode": "331022",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "East Gate Ratangarh",
            "Pincode": "331022",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Power House Ratangarh",
            "Pincode": "331022",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ratangarh",
            "Pincode": "331022",
            "City": "Ratangarh",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ratangarh R S",
            "Pincode": "331022",
            "City": "Ratangarh",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chowk Sadulpur",
            "Pincode": "331023",
            "City": "Churu",
            "District": "Jaipur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Maharana Pratap",
            "Pincode": "331023",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Patel Chowk Sadulpur",
            "Pincode": "331023",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sadulpur",
            "Pincode": "331023",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sadulpur City",
            "Pincode": "331023",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramgarh Bazar",
            "Pincode": "331024",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramgarh Sikar",
            "Pincode": "331024",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bishangarh Tamkore",
            "Pincode": "331026",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bissau",
            "Pincode": "331027",
            "City": "Bissau",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bissau Bazar",
            "Pincode": "331027",
            "City": "Bissau",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malsisar",
            "Pincode": "331028",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dudhwa Khara Village",
            "Pincode": "331029",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahansar",
            "Pincode": "331030",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Satra",
            "Pincode": "331031",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dadrewa",
            "Pincode": "331032",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kayamsar",
            "Pincode": "331033",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dudhwa R S",
            "Pincode": "331034",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhorugram",
            "Pincode": "331035",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rampura Beri",
            "Pincode": "331301",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sahawa",
            "Pincode": "331302",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sankhu Fort",
            "Pincode": "331303",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Taranagar",
            "Pincode": "331304",
            "City": "Taranagar",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Taranagar Bazar",
            "Pincode": "331304",
            "City": "Taranagar",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hamirwas",
            "Pincode": "331305",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hanspur",
            "Pincode": "331305",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Buchawas",
            "Pincode": "331306",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhirwas",
            "Pincode": "331307",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sardarshahar",
            "Pincode": "331401",
            "City": "Sardarshahar",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pulasar",
            "Pincode": "331402",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Moti Chowk",
            "Pincode": "331403",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sabzi Mandi Sardar Shahar",
            "Pincode": "331403",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sardar Shahar",
            "Pincode": "331403",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sardarshahar",
            "Pincode": "331403",
            "City": "Sardarshahar",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhanipura Churu",
            "Pincode": "331411",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bidasar",
            "Pincode": "331501",
            "City": "Bidasar",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhapar",
            "Pincode": "331502",
            "City": "Chhapar",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Charwas",
            "Pincode": "331503",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gogasar",
            "Pincode": "331504",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Parihara",
            "Pincode": "331505",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghantaghar Sujangarh",
            "Pincode": "331507",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hanumandhora",
            "Pincode": "331507",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Naya Bas Sujangarh",
            "Pincode": "331507",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sujangarh",
            "Pincode": "331507",
            "City": "Sujangarh",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sujangarh Gopalpura Road",
            "Pincode": "331507",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sujangarh R S",
            "Pincode": "331507",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhimsar",
            "Pincode": "331508",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sobhasar",
            "Pincode": "331509",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lodsar",
            "Pincode": "331510",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sandwa",
            "Pincode": "331517",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lalgarh Churu",
            "Pincode": "331518",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sidhmukh",
            "Pincode": "331701",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Momasar",
            "Pincode": "331801",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajaldesar",
            "Pincode": "331802",
            "City": "Rajaldesar",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajaldesar Bazar",
            "Pincode": "331802",
            "City": "Rajaldesar",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalubas Sri Dungargarh",
            "Pincode": "331803",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Dungargah",
            "Pincode": "331803",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bigga",
            "Pincode": "331804",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lachharasar",
            "Pincode": "331805",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sudsar",
            "Pincode": "331811",
            "City": "Churu",
            "District": "Churu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Marg",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Siar Mochiwara",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikar",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikar Bajaj Road",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikar Collectorate",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikar Devipura",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikar Fatehpuri Gate",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikar Gandhinagar",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikar Hospital Road",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikar Mahamandir Road",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikar Maulana Azad",
            "Pincode": "332001",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bajajgram Sikar",
            "Pincode": "332021",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhod",
            "Pincode": "332022",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khoor",
            "Pincode": "332023",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Katrathal",
            "Pincode": "332024",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Losal",
            "Pincode": "332025",
            "City": "Losal",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Losal Bazar",
            "Pincode": "332025",
            "City": "Losal",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nechwa",
            "Pincode": "332026",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Piprali",
            "Pincode": "332027",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sihot Badi",
            "Pincode": "332028",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ganeri",
            "Pincode": "332029",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Singrawat",
            "Pincode": "332030",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kudan",
            "Pincode": "332031",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dujod",
            "Pincode": "332032",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sihot Chhoti",
            "Pincode": "332033",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "R C P Colony",
            "Pincode": "332034",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raghunathgarh",
            "Pincode": "332034",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harash",
            "Pincode": "332035",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dadia",
            "Pincode": "332036",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banura",
            "Pincode": "332037",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gungara",
            "Pincode": "332038",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kasli Sikar",
            "Pincode": "332039",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kolida",
            "Pincode": "332040",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phagalwa",
            "Pincode": "332041",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tatonwa",
            "Pincode": "332042",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Garoda",
            "Pincode": "332043",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mangloona",
            "Pincode": "332044",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Beri",
            "Pincode": "332045",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "College Road Fatehpur",
            "Pincode": "332301",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Fatehpur Bazar",
            "Pincode": "332301",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Fatehpur Sekhawati",
            "Pincode": "332301",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sikariya Bazar Fatehpur",
            "Pincode": "332301",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhandhan",
            "Pincode": "332302",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Besawa",
            "Pincode": "332303",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rolsabsar",
            "Pincode": "332304",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sadinsar",
            "Pincode": "332305",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nabipura",
            "Pincode": "332306",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tihawali",
            "Pincode": "332307",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sekhisar",
            "Pincode": "332308",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lachhmangarh Bazar",
            "Pincode": "332311",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lachhmangarh Sekhawati",
            "Pincode": "332311",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nayama Bazar",
            "Pincode": "332311",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Patoda",
            "Pincode": "332312",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khuri Badi Sikar",
            "Pincode": "332313",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhaliawas",
            "Pincode": "332314",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jankipura",
            "Pincode": "332315",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bidarsar",
            "Pincode": "332316",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rorubadi",
            "Pincode": "332317",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jajod Fatehpur",
            "Pincode": "332318",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Balaran",
            "Pincode": "332401",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Palsana",
            "Pincode": "332402",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ranoli",
            "Pincode": "332403",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hospital Road Ringas",
            "Pincode": "332404",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ringas",
            "Pincode": "332404",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ringas Town",
            "Pincode": "332404",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shishu",
            "Pincode": "332405",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kochhor",
            "Pincode": "332406",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jetusar",
            "Pincode": "332407",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malikpur",
            "Pincode": "332408",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lakhni",
            "Pincode": "332409",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhopatpura",
            "Pincode": "332410",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baori",
            "Pincode": "332411",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Churi Miyan",
            "Pincode": "332412",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dadia Rampura",
            "Pincode": "332413",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baya",
            "Pincode": "332601",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khatu Shyamji Ki",
            "Pincode": "332602",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mehrauli",
            "Pincode": "332603",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Abhawas",
            "Pincode": "332604",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chomu Purohitan",
            "Pincode": "332605",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ajitgarh Amarsar",
            "Pincode": "332701",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Danta",
            "Pincode": "332702",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Danta Ramgarh",
            "Pincode": "332703",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deorala",
            "Pincode": "332704",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ganeshwar",
            "Pincode": "332705",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Guhala",
            "Pincode": "332706",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jharli",
            "Pincode": "332707",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kanwat Town",
            "Pincode": "332708",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khandela",
            "Pincode": "332709",
            "City": "Khandela",
            "District": "Baran",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nehru Park Khandela",
            "Pincode": "332709",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khachariawas",
            "Pincode": "332710",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Monda R S",
            "Pincode": "332711",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mundru",
            "Pincode": "332712",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nim Ka Thana",
            "Pincode": "332713",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nim Ka Thana Bazar",
            "Pincode": "332713",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nim Ka Thana Town",
            "Pincode": "332713",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sirohi Sikar",
            "Pincode": "332714",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gaushala Road",
            "Pincode": "332715",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Madhopur",
            "Pincode": "332715",
            "City": "Sri Madhopur",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Madhopur Bazar",
            "Pincode": "332715",
            "City": "Sri Madhopur",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Surana Bazar",
            "Pincode": "332715",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sefraguwar",
            "Pincode": "332716",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tiba Basai",
            "Pincode": "332717",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Patan",
            "Pincode": "332718",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Thoi",
            "Pincode": "332719",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gurara",
            "Pincode": "332721",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jajod Sri Madhopur",
            "Pincode": "332722",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Karad",
            "Pincode": "332723",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ganwari",
            "Pincode": "332724",
            "City": "Karauli",
            "District": "Karauli",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lorwara",
            "Pincode": "332725",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jairampura",
            "Pincode": "332726",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dabla Sikar",
            "Pincode": "332727",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hod",
            "Pincode": "332728",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pachar",
            "Pincode": "332729",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jalpali",
            "Pincode": "332730",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nathusar",
            "Pincode": "332731",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Puranabas",
            "Pincode": "332732",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Purani Chhawni",
            "Pincode": "332732",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chak Gopinathpura",
            "Pincode": "332733",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ralawats Sikar",
            "Pincode": "332734",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mau",
            "Pincode": "332735",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhudoli",
            "Pincode": "332736",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chala",
            "Pincode": "332737",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chaukari",
            "Pincode": "332738",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Govindpura",
            "Pincode": "332739",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kotri Sikar",
            "Pincode": "332740",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandholi",
            "Pincode": "332741",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandha Surera",
            "Pincode": "332742",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hassampur",
            "Pincode": "332743",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jeelo",
            "Pincode": "332744",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pritampuri",
            "Pincode": "332745",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Doodwa",
            "Pincode": "332747",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gorir",
            "Pincode": "332748",
            "City": "Sikar",
            "District": "Sikar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhunjhunu",
            "Pincode": "333001",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhunjhunu Bazar",
            "Pincode": "333001",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhunjhunu City",
            "Pincode": "333001",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhunjhunu Court",
            "Pincode": "333001",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhunjhunu Footla Bazar",
            "Pincode": "333001",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhunjhunu Gandhi Chowk",
            "Pincode": "333001",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rani Sati Mandir",
            "Pincode": "333001",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhanuri",
            "Pincode": "333011",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Titanwar",
            "Pincode": "333012",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bakhtawarpura",
            "Pincode": "333014",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Binjusar",
            "Pincode": "333015",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhawasari",
            "Pincode": "333016",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baragaon",
            "Pincode": "333021",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gudha Gorji Ka",
            "Pincode": "333022",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bagar",
            "Pincode": "333023",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Islampur",
            "Pincode": "333024",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alsisar",
            "Pincode": "333025",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandrella",
            "Pincode": "333025",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chirawa",
            "Pincode": "333026",
            "City": "Chirawa",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chirawa Town",
            "Pincode": "333026",
            "City": "Chirawa",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hospital Road Chirawa",
            "Pincode": "333026",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ardawata",
            "Pincode": "333027",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sultana",
            "Pincode": "333028",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Surajgarh",
            "Pincode": "333029",
            "City": "Surajgarh",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Surajgarh Bazar",
            "Pincode": "333029",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kajara",
            "Pincode": "333030",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ceeri Pilani",
            "Pincode": "333031",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pilani",
            "Pincode": "333031",
            "City": "Pilani",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "V V Pilani",
            "Pincode": "333031",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhorki",
            "Pincode": "333032",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jakhod",
            "Pincode": "333033",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kuharwas",
            "Pincode": "333034",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Narhar",
            "Pincode": "333035",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Budana",
            "Pincode": "333036",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Papurana",
            "Pincode": "333037",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Aduka",
            "Pincode": "333038",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kithana",
            "Pincode": "333039",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ojtu",
            "Pincode": "333040",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nua",
            "Pincode": "333041",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nangal Rajwatan",
            "Pincode": "333042",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nawalgarh",
            "Pincode": "333042",
            "City": "Nawalgarh",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nawalgarh Bazar",
            "Pincode": "333042",
            "City": "Nawalgarh",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Station Road Nawalgarh",
            "Pincode": "333042",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tarpura",
            "Pincode": "333043",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chobdaron Ki Dhani",
            "Pincode": "333044",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barwasi",
            "Pincode": "333045",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gangiasar",
            "Pincode": "333046",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bajawa",
            "Pincode": "333047",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bai",
            "Pincode": "333048",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shimla",
            "Pincode": "333048",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jejusar",
            "Pincode": "333052",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ponkh",
            "Pincode": "333053",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Basawa",
            "Pincode": "333301",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhapoli",
            "Pincode": "333302",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chirana",
            "Pincode": "333303",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhajhar",
            "Pincode": "333304",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jakhal",
            "Pincode": "333305",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khirod",
            "Pincode": "333306",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udaipurwati",
            "Pincode": "333307",
            "City": "Udaipurwati",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Parasrampura",
            "Pincode": "333308",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Naya Parasrampura",
            "Pincode": "333309",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pachlangi",
            "Pincode": "333310",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kari",
            "Pincode": "333311",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bugala",
            "Pincode": "333312",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhamora",
            "Pincode": "333313",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Signore",
            "Pincode": "333314",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Inderpura",
            "Pincode": "333315",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Babai",
            "Pincode": "333501",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Buhana",
            "Pincode": "333502",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khetri",
            "Pincode": "333503",
            "City": "Khetri",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khetri Bazar",
            "Pincode": "333503",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khetri Court",
            "Pincode": "333503",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kolihan Nagar",
            "Pincode": "333503",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "C S F Colony Khetrinagar",
            "Pincode": "333504",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "K C F Township Khetrinaga",
            "Pincode": "333504",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khetrinagar",
            "Pincode": "333504",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jasrapur",
            "Pincode": "333514",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pacheri Badi",
            "Pincode": "333515",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Singhana",
            "Pincode": "333516",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barau",
            "Pincode": "333517",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Churi Ajitgarh",
            "Pincode": "333701",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dundlod",
            "Pincode": "333702",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hanumanpura",
            "Pincode": "333703",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandawa",
            "Pincode": "333704",
            "City": "Mandawa",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandawa Bazar",
            "Pincode": "333704",
            "City": "Mandawa",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "College Road Mukandgarh",
            "Pincode": "333705",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mukandgarh",
            "Pincode": "333705",
            "City": "Mukandgarh",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dundlod Rs",
            "Pincode": "333706",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Doomra",
            "Pincode": "333707",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jetsar Farm",
            "Pincode": "333709",
            "City": "JhunJhunu",
            "District": "JhunJhunu",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bikaner City",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bikaner Dungar College",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bikaner Kutchery",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "D S Office Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Goga Gate Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Goswami Chowk Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Industrial Area Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jail Road Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jassusar Gate Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kote Gate Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lalgarh Palace Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lalgarh Road Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lalkar Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road Bikan",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mohta Chowk Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pabu Bari Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Railway Workshop Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rani Bazar Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rath Khana Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sadul Colony Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sitla Gate Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Station Road Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Subashpura Bikaner",
            "Pincode": "334001",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bikaner",
            "Pincode": "334002",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhatargarh",
            "Pincode": "334021",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udasar",
            "Pincode": "334022",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khajuwala",
            "Pincode": "334023",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Napasar",
            "Pincode": "334201",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sinthal",
            "Pincode": "334202",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gajner Palace",
            "Pincode": "334301",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Kolayatji",
            "Pincode": "334302",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Diatra",
            "Pincode": "334303",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhajhu",
            "Pincode": "334304",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bajju",
            "Pincode": "334305",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gangashahar",
            "Pincode": "334401",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nai Line Gangashahar",
            "Pincode": "334401",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udairmsar",
            "Pincode": "334402",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhinasar",
            "Pincode": "334403",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Palana",
            "Pincode": "334404",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jamsar",
            "Pincode": "334601",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalu",
            "Pincode": "334602",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lunkaransar",
            "Pincode": "334603",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahajan",
            "Pincode": "334604",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deshnok",
            "Pincode": "334801",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Himatsar",
            "Pincode": "334802",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nokha",
            "Pincode": "334803",
            "City": "Nokha",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tehsil Road Nokha",
            "Pincode": "334803",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Panchu",
            "Pincode": "334804",
            "City": "Bikaner",
            "District": "Bikaner",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Block Area Sri",
            "Pincode": "335001",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ganga Nagar",
            "Pincode": "335001",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gaushala Road Sri",
            "Pincode": "335001",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Industrial Estate Sri",
            "Pincode": "335001",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandi Sri Ganganagar",
            "Pincode": "335001",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Purani Abadi Sri",
            "Pincode": "335001",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ravinder Path Sri",
            "Pincode": "335001",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Ganganagar",
            "Pincode": "335001",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Ganganagar R S",
            "Pincode": "335001",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sugar Factory Sri",
            "Pincode": "335001",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bishanpura",
            "Pincode": "335021",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chunawadh",
            "Pincode": "335022",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dalpatsinghpur",
            "Pincode": "335023",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gajsinghpur",
            "Pincode": "335024",
            "City": "Gajsinghpur",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ganeshgarh",
            "Pincode": "335025",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ganguwala",
            "Pincode": "335026",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Keshrisinghpur",
            "Pincode": "335027",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lalgarh Jatan",
            "Pincode": "335037",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mirzawala",
            "Pincode": "335038",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Muk Lawa",
            "Pincode": "335039",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nizampura",
            "Pincode": "335040",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Padampur",
            "Pincode": "335041",
            "City": "Padampur",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dabla Sri Ganganagar",
            "Pincode": "335042",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Matili Rathan",
            "Pincode": "335043",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raisinghangar City",
            "Pincode": "335051",
            "City": "Raisinghnagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raisinghnagar",
            "Pincode": "335051",
            "City": "Raisinghnagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ridmalsar",
            "Pincode": "335061",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sadulshahar",
            "Pincode": "335062",
            "City": "Sadulshahar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sangaria Mandi",
            "Pincode": "335063",
            "City": "Hanumangarh",
            "District": "Hanumangarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sangaria R S",
            "Pincode": "335063",
            "City": "Hanumangarh",
            "District": "Hanumangarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "V P Sangaria",
            "Pincode": "335063",
            "City": "Hanumangarh",
            "District": "Hanumangarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dholipal",
            "Pincode": "335064",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Manaksar",
            "Pincode": "335065",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Karanpur",
            "Pincode": "335073",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Theri Sri Karanpur",
            "Pincode": "335073",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Naggi",
            "Pincode": "335074",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bahadra",
            "Pincode": "335501",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bahadra Bazar",
            "Pincode": "335501",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalana",
            "Pincode": "335502",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dabri",
            "Pincode": "335503",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gogameri",
            "Pincode": "335504",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhani Bari",
            "Pincode": "335511",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Civil Line Hanumangarh Jn",
            "Pincode": "335512",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hanumangarh Jn",
            "Pincode": "335512",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hanumangarh Jn",
            "Pincode": "335512",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hanumangarh Jn Court",
            "Pincode": "335512",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "335512",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hanumangarh Town",
            "Pincode": "335513",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hanumangarh Town Bazar",
            "Pincode": "335513",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hanumangarh Town Nai Mand",
            "Pincode": "335513",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malkhera",
            "Pincode": "335514",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Surewala",
            "Pincode": "335515",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nohar",
            "Pincode": "335523",
            "City": "Nohar",
            "District": "Hanumangarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nohar Bazar",
            "Pincode": "335523",
            "City": "Hanumangarh",
            "District": "Hanumangarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rawatsar Sri Ganganagar",
            "Pincode": "335524",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Talwara Jhil",
            "Pincode": "335525",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tibi",
            "Pincode": "335526",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phephana",
            "Pincode": "335527",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jasana",
            "Pincode": "335528",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Anupgarh",
            "Pincode": "335701",
            "City": "Anupgarh",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jetsar",
            "Pincode": "335702",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramsinghpur",
            "Pincode": "335703",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Bijeynagar",
            "Pincode": "335704",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sardargarh",
            "Pincode": "335705",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mohannagar",
            "Pincode": "335706",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gharsana",
            "Pincode": "335707",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bajuwala",
            "Pincode": "335708",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sardarpura Bika",
            "Pincode": "335710",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dabali Rathan",
            "Pincode": "335801",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Goluwala",
            "Pincode": "335802",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pilibanga",
            "Pincode": "335803",
            "City": "Pilibanga",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "R C P Colony",
            "Pincode": "335804",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Suratgarh",
            "Pincode": "335804",
            "City": "Suratgarh",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Suratgarh City",
            "Pincode": "335804",
            "City": "Suratgarh",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Biradhwal Head",
            "Pincode": "335805",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Panditanwalii",
            "Pincode": "335806",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajiasar",
            "Pincode": "335807",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hindumalkot",
            "Pincode": "335901",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Maderan",
            "Pincode": "335902",
            "City": "Ganganagar",
            "District": "Ganganagar",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nagaur",
            "Pincode": "341001",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nagaur Banshiwala Temple",
            "Pincode": "341001",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nagaur City",
            "Pincode": "341001",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nagaur Loharpura",
            "Pincode": "341001",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nagaur Police Line",
            "Pincode": "341001",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Palanipet",
            "Pincode": "341002",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gogalao",
            "Pincode": "341011",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Alai",
            "Pincode": "341012",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhadwasi",
            "Pincode": "341013",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Basni",
            "Pincode": "341021",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Deh",
            "Pincode": "341022",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jael",
            "Pincode": "341023",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kuchera",
            "Pincode": "341024",
            "City": "Kuchera",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khinwsar",
            "Pincode": "341025",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Marwar Mundwa",
            "Pincode": "341026",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rol",
            "Pincode": "341027",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khajwana",
            "Pincode": "341028",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sri Balaji",
            "Pincode": "341029",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tarnau",
            "Pincode": "341030",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Padu Kallan",
            "Pincode": "341031",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kathoti",
            "Pincode": "341032",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rajod",
            "Pincode": "341033",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Roon",
            "Pincode": "341034",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Padu Khurd",
            "Pincode": "341035",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bari Khatu",
            "Pincode": "341301",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chhoti Khatu",
            "Pincode": "341302",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Didwana",
            "Pincode": "341303",
            "City": "Didwana",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Didwana Dhan Mandi",
            "Pincode": "341303",
            "City": "Didwana",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Didwana Station Road",
            "Pincode": "341303",
            "City": "Didwana",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaswantgarh Nagaur",
            "Pincode": "341304",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandore",
            "Pincode": "341304",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Koliya",
            "Pincode": "341305",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ladnun",
            "Pincode": "341306",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ladnun Pahalipatti",
            "Pincode": "341306",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ladnun Rahugate",
            "Pincode": "341306",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ladnun Railway Station",
            "Pincode": "341306",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malar",
            "Pincode": "341313",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nimbi Jodhan",
            "Pincode": "341316",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ratau",
            "Pincode": "341317",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khunkhuna",
            "Pincode": "341318",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Toshina",
            "Pincode": "341319",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Badu",
            "Pincode": "341501",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Borawar",
            "Pincode": "341502",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Degana",
            "Pincode": "341503",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gachhipura",
            "Pincode": "341504",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Makrana",
            "Pincode": "341505",
            "City": "Makrana",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Makrana Industrial Area",
            "Pincode": "341505",
            "City": "Makrana",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Makrana S B",
            "Pincode": "341505",
            "City": "Makrana",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Maulasar",
            "Pincode": "341506",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Maroth",
            "Pincode": "341507",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kuchaman",
            "Pincode": "341508",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Paltangate Kuchaman",
            "Pincode": "341508",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "341508",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "341509",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kuchaman Road",
            "Pincode": "341509",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Merta City",
            "Pincode": "341510",
            "City": "Merta City",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Merta Kacheri",
            "Pincode": "341510",
            "City": "Merta City",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Merta Rs",
            "Pincode": "341510",
            "City": "Merta City",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Merta Road",
            "Pincode": "341511",
            "City": "Merta City",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Parbatsar",
            "Pincode": "341512",
            "City": "Parbatsar",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pargatsar K C",
            "Pincode": "341512",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Riyan",
            "Pincode": "341513",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ren",
            "Pincode": "341514",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harsore",
            "Pincode": "341515",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhankoli",
            "Pincode": "341516",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ladariya",
            "Pincode": "341517",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jasnagar",
            "Pincode": "341518",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kukanwali",
            "Pincode": "341519",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Besroli",
            "Pincode": "341520",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bidiad",
            "Pincode": "341521",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhakri",
            "Pincode": "341522",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ghatwa",
            "Pincode": "341523",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bajwas",
            "Pincode": "341524",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gudha Salt",
            "Pincode": "341525",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nimod",
            "Pincode": "341526",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Narainpura",
            "Pincode": "341527",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Panchwa",
            "Pincode": "341528",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bagot",
            "Pincode": "341529",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandarun",
            "Pincode": "341530",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rid",
            "Pincode": "341531",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Peelwa Nagaur",
            "Pincode": "341532",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mithki",
            "Pincode": "341533",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jawla",
            "Pincode": "341534",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Manglana",
            "Pincode": "341535",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhagwanpura Nagaur",
            "Pincode": "341536",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chitawa",
            "Pincode": "341537",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lunwa",
            "Pincode": "341538",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bursu",
            "Pincode": "341539",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Manana",
            "Pincode": "341540",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Idwa",
            "Pincode": "341541",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "I E Bidiad",
            "Pincode": "341542",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mokala",
            "Pincode": "341544",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lampolai",
            "Pincode": "341545",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalru",
            "Pincode": "341546",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Katyasani",
            "Pincode": "341547",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalwa",
            "Pincode": "341548",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tilanesh",
            "Pincode": "341549",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barwala",
            "Pincode": "341550",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Aerodrome Agency",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Cloth Market",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Engineering College",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jawahar Chowk",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jodhpur",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jodhpur City",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "K K Chowk",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Katla Bazar",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khanda Falsa",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nagaouriyon Ka Bas",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nagauri Gate",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Railway Office",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Railway Workshop",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ratanada",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ratanada Bazar",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Siwanchi Gate",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sojati Gate",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "University Campus",
            "Pincode": "342001",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jodhpur 2 Girdikot",
            "Pincode": "342002",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhagat Ki Kothi",
            "Pincode": "342003",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gandhi Maidan",
            "Pincode": "342003",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "342003",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jalori Gate",
            "Pincode": "342003",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jodhpur 3 Sardarpura",
            "Pincode": "342003",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Massuria",
            "Pincode": "342003",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shastri Circle",
            "Pincode": "342003",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shastri Nagar",
            "Pincode": "342003",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jodhpur 4",
            "Pincode": "342004",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Partapnagar",
            "Pincode": "342004",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhagat Ki Kothi",
            "Pincode": "342005",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jodhpur 5",
            "Pincode": "342005",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Krishi Upaj Mandi",
            "Pincode": "342005",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jodhpur 6",
            "Pincode": "342006",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jodhpur Kacheri",
            "Pincode": "342006",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahamandir Bazar",
            "Pincode": "342006",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Udai Mandir",
            "Pincode": "342006",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Umed Bhawan",
            "Pincode": "342006",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jodhpur 7",
            "Pincode": "342007",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Krishi Upaj Mandi",
            "Pincode": "342007",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandore Road",
            "Pincode": "342007",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jodhpur 8",
            "Pincode": "342008",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nandanwan",
            "Pincode": "342008",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jhanwar",
            "Pincode": "342021",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shergarh Jodhpur",
            "Pincode": "342022",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Balesar",
            "Pincode": "342023",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Soorsagar Jodhpur",
            "Pincode": "342024",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Setrawa",
            "Pincode": "342025",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "B S F Training Centre Jod",
            "Pincode": "342026",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Banar",
            "Pincode": "342027",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Tena",
            "Pincode": "342028",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chaba",
            "Pincode": "342029",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Denok",
            "Pincode": "342030",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Keru",
            "Pincode": "342031",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Agolai",
            "Pincode": "342032",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Belwa Bagawatan",
            "Pincode": "342033",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sai",
            "Pincode": "342034",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lavera Baori",
            "Pincode": "342037",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phalodi",
            "Pincode": "342301",
            "City": "Phalodi",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phalodi Naya Bazar",
            "Pincode": "342301",
            "City": "Phalodi",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phalodi Sadar Bazar",
            "Pincode": "342301",
            "City": "Phalodi",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lohawat",
            "Pincode": "342302",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Osian",
            "Pincode": "342303",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mathania",
            "Pincode": "342305",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Teori",
            "Pincode": "342306",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bap",
            "Pincode": "342307",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khichan",
            "Pincode": "342308",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Peelwa Jodhpur",
            "Pincode": "342309",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nokh",
            "Pincode": "342310",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Aau",
            "Pincode": "342311",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chadi",
            "Pincode": "342312",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dechu",
            "Pincode": "342314",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pipar",
            "Pincode": "342601",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pipar Chopata Bazar",
            "Pincode": "342601",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bilara",
            "Pincode": "342602",
            "City": "Bilara",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bilara Subashmarg",
            "Pincode": "342602",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hariadhana",
            "Pincode": "342602",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhopalgarh",
            "Pincode": "342603",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Borunda",
            "Pincode": "342604",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhawi",
            "Pincode": "342605",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pipar Road",
            "Pincode": "342606",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kharia Mithapur",
            "Pincode": "342607",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sathin",
            "Pincode": "342608",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kosana",
            "Pincode": "342609",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khejarla",
            "Pincode": "342611",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ransigaon",
            "Pincode": "342612",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dunara",
            "Pincode": "342801",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Luni",
            "Pincode": "342802",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ajit",
            "Pincode": "342803",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Salawas",
            "Pincode": "342804",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Asop",
            "Pincode": "342901",
            "City": "Jodhpur",
            "District": "Jodhpur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gotan",
            "Pincode": "342902",
            "City": "Nagaur",
            "District": "Nagaur",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jalore",
            "Pincode": "343001",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jalore Bus Stand",
            "Pincode": "343001",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jalore Collectorate",
            "Pincode": "343001",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jalore Suraj Pole",
            "Pincode": "343001",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jalore V D C",
            "Pincode": "343001",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Badanwari",
            "Pincode": "343011",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Umedabad",
            "Pincode": "343021",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sayala",
            "Pincode": "343022",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhansa",
            "Pincode": "343023",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Siana",
            "Pincode": "343024",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bagra",
            "Pincode": "343025",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Santhu",
            "Pincode": "343026",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Hadecha",
            "Pincode": "343027",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Modran",
            "Pincode": "343028",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhinmal",
            "Pincode": "343029",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sadar Bazar Bhinmal",
            "Pincode": "343029",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Junjhani",
            "Pincode": "343030",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Daspan",
            "Pincode": "343031",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bagoda",
            "Pincode": "343032",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sarwana",
            "Pincode": "343033",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nasoli",
            "Pincode": "343034",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kagmala",
            "Pincode": "343039",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Malwara",
            "Pincode": "343039",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Raniwara",
            "Pincode": "343040",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sanchore",
            "Pincode": "343041",
            "City": "Sanchore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mandawala",
            "Pincode": "343042",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mokalsar",
            "Pincode": "343043",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Siwana",
            "Pincode": "343044",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Thikhi",
            "Pincode": "343045",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bishangarh Jalore",
            "Pincode": "343046",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramniya",
            "Pincode": "343047",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Vadgaon",
            "Pincode": "343048",
            "City": "Jalore",
            "District": "Jalore",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barmer",
            "Pincode": "344001",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barmer Bsf",
            "Pincode": "344001",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barmer Collectorate",
            "Pincode": "344001",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barmer Dhani Bazar",
            "Pincode": "344001",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Barmer Panghat Road",
            "Pincode": "344001",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bisala",
            "Pincode": "344011",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rani Gaon",
            "Pincode": "344012",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Harsani",
            "Pincode": "344013",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nand",
            "Pincode": "344014",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mahabar",
            "Pincode": "344015",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Samdari",
            "Pincode": "344021",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Balotra",
            "Pincode": "344022",
            "City": "Balotra",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Balotra Bheru Bazar",
            "Pincode": "344022",
            "City": "Balotra",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Balotra Industrial Area",
            "Pincode": "344022",
            "City": "Balotra",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Balotra Sadar Bazar",
            "Pincode": "344022",
            "City": "Balotra",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kanana",
            "Pincode": "344023",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jasol",
            "Pincode": "344024",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Mewanagar",
            "Pincode": "344025",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kalyanpur Barmer",
            "Pincode": "344026",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Parlu",
            "Pincode": "344027",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Asadan",
            "Pincode": "344028",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Majal",
            "Pincode": "344029",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gagaria",
            "Pincode": "344030",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Guda Malani",
            "Pincode": "344031",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pachpadra City",
            "Pincode": "344032",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sindhari",
            "Pincode": "344033",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Baitu",
            "Pincode": "344034",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kavas",
            "Pincode": "344035",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Samdari R S",
            "Pincode": "344036",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sawau Padmsingh",
            "Pincode": "344037",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Patodi",
            "Pincode": "344038",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Asotra",
            "Pincode": "344039",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gadra Road",
            "Pincode": "344501",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramsar Barmer",
            "Pincode": "344502",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Munabao",
            "Pincode": "344503",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Shiv",
            "Pincode": "344701",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chohtan",
            "Pincode": "344702",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Rawatsar Barmer",
            "Pincode": "344703",
            "City": "Hanumangarh",
            "District": "Hanumangarh",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Dhorimana",
            "Pincode": "344704",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Gunga",
            "Pincode": "344705",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sedwa",
            "Pincode": "344706",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sanawada",
            "Pincode": "344708",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Kotra",
            "Pincode": "344709",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Padru",
            "Pincode": "344801",
            "City": "Barmer",
            "District": "Barmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaisalmer",
            "Pincode": "345001",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaisalmer City",
            "Pincode": "345001",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaisalmer Collectorate",
            "Pincode": "345001",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaisalmer Fort",
            "Pincode": "345001",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaisalmer Station Road",
            "Pincode": "345001",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Jaisalmer B S F",
            "Pincode": "345002",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pokaran",
            "Pincode": "345021",
            "City": "Pokaran",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pokaran City",
            "Pincode": "345021",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Pokaran R S",
            "Pincode": "345021",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramgrh Jaisalmer",
            "Pincode": "345022",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Ramdeora",
            "Pincode": "345023",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Bhaniana",
            "Pincode": "345024",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Phalsund",
            "Pincode": "345025",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sankra",
            "Pincode": "345026",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sangad",
            "Pincode": "345027",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Nachna",
            "Pincode": "345028",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Chandan",
            "Pincode": "345029",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Sam",
            "Pincode": "345030",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Lathi",
            "Pincode": "345031",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "Khuhri Jaisalmer",
            "Pincode": "345032",
            "City": "Jaisalmer",
            "District": "Jaisalmer",
            "State": "Rajasthan"
        },
        {
            "PostOfficeName": "City",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dharmendra Sinhji College",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jairaj Plot",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Junction Plot",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalavad Road",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mandvi Chowk",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mochi Bazar",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mu Co Chowk",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "New Jagnath",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Parsi Agiyari Chwok",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Popatpara",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Race Course Road",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajkot",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajputpara",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ramnathpara",
            "Pincode": "360001",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Manhar Plot",
            "Pincode": "360002",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Millpara",
            "Pincode": "360002",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajkot Bhaktinagar",
            "Pincode": "360002",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sorathiawadi",
            "Pincode": "360002",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Udyognagar",
            "Pincode": "360002",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Viveknandnagar",
            "Pincode": "360002",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Aji Industrial Estate",
            "Pincode": "360003",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Marketing Yard",
            "Pincode": "360003",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajkot Bedipura",
            "Pincode": "360003",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Malaviyanagar",
            "Pincode": "360004",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajkot S N Gurukul",
            "Pincode": "360004",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajkot Saurastra",
            "Pincode": "360004",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "University Campus",
            "Pincode": "360005",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajkot Bhomeshwar Plot",
            "Pincode": "360006",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kasturbadham",
            "Pincode": "360020",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sanosra Raj",
            "Pincode": "360022",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ziana",
            "Pincode": "360023",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardhar",
            "Pincode": "360025",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lodhika",
            "Pincode": "360035",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Atkot",
            "Pincode": "360040",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jasdan",
            "Pincode": "360050",
            "City": "Jasdan",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vinchhia",
            "Pincode": "360050",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Virnagar",
            "Pincode": "360060",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mengani",
            "Pincode": "360070",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadla",
            "Pincode": "360080",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Paddhari",
            "Pincode": "360110",
            "City": "Paddhari",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhojraj Para",
            "Pincode": "360311",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhuvneshwari Pith",
            "Pincode": "360311",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "College Chowk",
            "Pincode": "360311",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gondal",
            "Pincode": "360311",
            "City": "Gondal",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Market Yard",
            "Pincode": "360311",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gomta",
            "Pincode": "360320",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Moviya",
            "Pincode": "360320",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shivarajgadh",
            "Pincode": "360335",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jetalsar Jn",
            "Pincode": "360360",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fulwadi",
            "Pincode": "360370",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jetpur",
            "Pincode": "360370",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kapad Bazar",
            "Pincode": "360370",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navagadh",
            "Pincode": "360375",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Virpur",
            "Pincode": "360380",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jam Kandorna",
            "Pincode": "360405",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Darbargadh",
            "Pincode": "360410",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dharoji",
            "Pincode": "360410",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gim Plot",
            "Pincode": "360410",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "360410",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhoraji Sugar Factory",
            "Pincode": "360411",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Moti Murad",
            "Pincode": "360421",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Patanvav",
            "Pincode": "360430",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Supedi",
            "Pincode": "360440",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar Chowk",
            "Pincode": "360450",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhayavadar",
            "Pincode": "360450",
            "City": "Bhayavadar",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chitravad",
            "Pincode": "360452",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhank",
            "Pincode": "360460",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kolki",
            "Pincode": "360470",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Paneli",
            "Pincode": "360480",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lathi Plot",
            "Pincode": "360490",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Panch Hatdi",
            "Pincode": "360490",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Upleta",
            "Pincode": "360490",
            "City": "Upleta",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhanvad",
            "Pincode": "360510",
            "City": "Bhanvad",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranjitpura",
            "Pincode": "360510",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Verad",
            "Pincode": "360515",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhrapha",
            "Pincode": "360520",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Samana",
            "Pincode": "360521",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Darbargadh",
            "Pincode": "360530",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jam Jodhpur",
            "Pincode": "360530",
            "City": "Jam Jodhpur",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vansjalia",
            "Pincode": "360531",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kharedi",
            "Pincode": "360540",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adityana",
            "Pincode": "360545",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranavav",
            "Pincode": "360550",
            "City": "Ranavav",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranavav",
            "Pincode": "360550",
            "City": "Porbandar",
            "District": "Porbandar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranava RS",
            "Pincode": "360560",
            "City": "Porbandar",
            "District": "Porbandar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranavav R S",
            "Pincode": "360560",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranakandorna",
            "Pincode": "360570",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mokal",
            "Pincode": "360571",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vaddla Rana",
            "Pincode": "360572",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhojeshwar Plot",
            "Pincode": "360575",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhaya Plot",
            "Pincode": "360575",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hanumangufa",
            "Pincode": "360575",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "M G Road",
            "Pincode": "360575",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Manek Chowk",
            "Pincode": "360575",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Milpara",
            "Pincode": "360575",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Porbandar",
            "Pincode": "360575",
            "City": "Porbandar",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Porbandhar HO",
            "Pincode": "360575",
            "City": "Porbandar",
            "District": "Porbandar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Port Area",
            "Pincode": "360575",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Porbandar Birlasagar",
            "Pincode": "360576",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Porbandar G Id C",
            "Pincode": "360577",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhaya",
            "Pincode": "360578",
            "City": "Chhaya",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bokhira",
            "Pincode": "360579",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bakharla",
            "Pincode": "360583",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navibundar",
            "Pincode": "360585",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bagvadar",
            "Pincode": "360590",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fatana",
            "Pincode": "360592",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sodhana",
            "Pincode": "360595",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Grain Market",
            "Pincode": "361001",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamnagar",
            "Pincode": "361001",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khambhalia Gate",
            "Pincode": "361001",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lal Bunglow",
            "Pincode": "361001",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mandvi Chowk",
            "Pincode": "361001",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "New Super Market",
            "Pincode": "361001",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pancheshwar Chowk",
            "Pincode": "361001",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "361001",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Subhas Market",
            "Pincode": "361001",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamnagar Bedeshwar",
            "Pincode": "361002",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamnagar Aerodrome",
            "Pincode": "361003",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamnagar Digvijay",
            "Pincode": "361004",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nagar Estate",
            "Pincode": "361004",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khojanaka Road",
            "Pincode": "361005",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pavan Chakli",
            "Pincode": "361005",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Plot",
            "Pincode": "361005",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranjitnagar",
            "Pincode": "361005",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamnagar Khodiyar Colony",
            "Pincode": "361006",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamnagar Gulabnagar",
            "Pincode": "361007",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamnagar Patel Colony",
            "Pincode": "361008",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Medical Campus",
            "Pincode": "361008",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamnagar Bedi",
            "Pincode": "361009",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamnagar Udyog",
            "Pincode": "361009",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadinar",
            "Pincode": "361010",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hadiana",
            "Pincode": "361011",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chela",
            "Pincode": "361012",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khandhera",
            "Pincode": "361013",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Aliabada",
            "Pincode": "361110",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhuvav",
            "Pincode": "361120",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jam Venthli",
            "Pincode": "361130",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Digvijaygram",
            "Pincode": "361140",
            "City": "Digvijaygram",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valsura",
            "Pincode": "361150",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Grain Market",
            "Pincode": "361160",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalavad",
            "Pincode": "361160",
            "City": "Kalavad",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nikava",
            "Pincode": "361162",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lalpur",
            "Pincode": "361170",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhrol",
            "Pincode": "361210",
            "City": "Dhrol",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Latipur",
            "Pincode": "361220",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Balachadi",
            "Pincode": "361230",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Balambha",
            "Pincode": "361240",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jodiya",
            "Pincode": "361250",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kanalus",
            "Pincode": "361280",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kenedi",
            "Pincode": "361285",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhogat",
            "Pincode": "361290",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jam Gadhka",
            "Pincode": "361295",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nadana",
            "Pincode": "361301",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalyan Raiji Mandir",
            "Pincode": "361305",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khambhalia",
            "Pincode": "361305",
            "City": "Khambhalia",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadthar",
            "Pincode": "361306",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Salaya",
            "Pincode": "361310",
            "City": "Salaya",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhatia",
            "Pincode": "361315",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ran",
            "Pincode": "361316",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jam Kalyanpur",
            "Pincode": "361320",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jam Devalia",
            "Pincode": "361321",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lamba",
            "Pincode": "361322",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Raval",
            "Pincode": "361325",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bet",
            "Pincode": "361330",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dwarka",
            "Pincode": "361335",
            "City": "Dwarka",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Town",
            "Pincode": "361335",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dwarka Cement Factory",
            "Pincode": "361336",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mithapur",
            "Pincode": "361345",
            "City": "Mithapur",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Suraj Karadi",
            "Pincode": "361347",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "361350",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Okha",
            "Pincode": "361350",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Agri Campus",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bahauddin College Road",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Diwan Chowk",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Girnar Road",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jagmal Road",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jhalarapa",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Junagadh",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalva Chowk",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mangnath Road",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "P T C",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ramnivas",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardarbaug",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "362001",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Junagadh Joshipura",
            "Pincode": "362002",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Junagadh Udyognagar",
            "Pincode": "362003",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Junagadh Bhavnath",
            "Pincode": "362004",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Majevadi",
            "Pincode": "362011",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chora",
            "Pincode": "362012",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhandhuka Khand",
            "Pincode": "362012",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhandhusar",
            "Pincode": "362012",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khadia",
            "Pincode": "362013",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Makhiala",
            "Pincode": "362014",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Timbavadi",
            "Pincode": "362015",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhesan",
            "Pincode": "362020",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chuda",
            "Pincode": "362021",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranpur Sorath",
            "Pincode": "362030",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhodvadi",
            "Pincode": "362036",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dolatpura",
            "Pincode": "362037",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bilkha",
            "Pincode": "362110",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mangnath Pipli",
            "Pincode": "362111",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarsai",
            "Pincode": "362120",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Visavadar",
            "Pincode": "362130",
            "City": "Visavadar",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalsari",
            "Pincode": "362132",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Moti Monpuri",
            "Pincode": "362133",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sasangir",
            "Pincode": "362135",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Borvav",
            "Pincode": "362136",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Akolwadi",
            "Pincode": "362140",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pavthi",
            "Pincode": "362142",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Talala",
            "Pincode": "362150",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghunsia",
            "Pincode": "362151",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amblas",
            "Pincode": "362152",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chitravad",
            "Pincode": "362155",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Power House",
            "Pincode": "362205",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shahpur Sorath",
            "Pincode": "362205",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lushala",
            "Pincode": "362215",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Thana Pipli",
            "Pincode": "362216",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Aerodramme Road",
            "Pincode": "362220",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Keshod",
            "Pincode": "362220",
            "City": "Keshod",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Limda Chowk",
            "Pincode": "362220",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Balagam",
            "Pincode": "362221",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Agatrai",
            "Pincode": "362222",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Meshvan",
            "Pincode": "362223",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khirasraghed",
            "Pincode": "362224",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "362225",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mangrol",
            "Pincode": "362225",
            "City": "Mangrol",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Loej",
            "Pincode": "362226",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kevadra",
            "Pincode": "362227",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ajab",
            "Pincode": "362228",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Madhavpur Ghed",
            "Pincode": "362230",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mander",
            "Pincode": "362231",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardagram",
            "Pincode": "362235",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shardagram",
            "Pincode": "362235",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shil",
            "Pincode": "362240",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mekhadi",
            "Pincode": "362242",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Maliya Hatina",
            "Pincode": "362245",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amrapur Gir",
            "Pincode": "362246",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Juthal",
            "Pincode": "362247",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhanduri",
            "Pincode": "362248",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shergadh",
            "Pincode": "362249",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chorvad",
            "Pincode": "362250",
            "City": "Chorvad",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sherbaug",
            "Pincode": "362255",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Dodia",
            "Pincode": "362256",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adri",
            "Pincode": "362257",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khorasa Gir",
            "Pincode": "362258",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dari",
            "Pincode": "362259",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Keshod Akshyagadh",
            "Pincode": "362259",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Medarda",
            "Pincode": "362260",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Veraval Udyognagar",
            "Pincode": "362260",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bagdu",
            "Pincode": "362263",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "362265",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bundar",
            "Pincode": "362265",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Krishnagar",
            "Pincode": "362265",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kutiyan",
            "Pincode": "362265",
            "City": "Porbandar",
            "District": "Porbandar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kutiyana",
            "Pincode": "362265",
            "City": "Kutiyana",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Veraval",
            "Pincode": "362265",
            "City": "Veraval",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Verable Rayon Factory",
            "Pincode": "362266",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Veraval Bhidiya Plot",
            "Pincode": "362267",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Prabhas Patan",
            "Pincode": "362268",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lodhava",
            "Pincode": "362271",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sutrapada",
            "Pincode": "362275",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhamlej",
            "Pincode": "362276",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Prasnavada",
            "Pincode": "362278",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadal",
            "Pincode": "362310",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Choki",
            "Pincode": "362315",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Delvada",
            "Pincode": "362510",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navabunder",
            "Pincode": "362515",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Diu",
            "Pincode": "362520",
            "City": "Diu",
            "District": "Daman",
            "State": "Daman & Diu"
        },
        {
            "PostOfficeName": "Div",
            "Pincode": "362520",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Zampu",
            "Pincode": "362520",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gir Gadhda",
            "Pincode": "362530",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Saiyad Rajpura",
            "Pincode": "362530",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghoghla",
            "Pincode": "362540",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sanakhada",
            "Pincode": "362550",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Simar",
            "Pincode": "362551",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sayad Rajpara",
            "Pincode": "362552",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "362560",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Una Sorath",
            "Pincode": "362560",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar Dhokadava",
            "Pincode": "362565",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vanakbara",
            "Pincode": "362570",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhucharvada",
            "Pincode": "362571",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "362610",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vanthali Sorath",
            "Pincode": "362610",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kanjha",
            "Pincode": "362615",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bantwa",
            "Pincode": "362620",
            "City": "Bantwa",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Subhas Road",
            "Pincode": "362620",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Limbuda",
            "Pincode": "362621",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahiari",
            "Pincode": "362623",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pajod",
            "Pincode": "362624",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nanadia",
            "Pincode": "362625",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bamansa",
            "Pincode": "362626",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghed Bamnasa",
            "Pincode": "362626",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Matiyana",
            "Pincode": "362627",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Manavadar",
            "Pincode": "362630",
            "City": "Manavadar",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Plot",
            "Pincode": "362630",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghed Koylana",
            "Pincode": "362633",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Koylana",
            "Pincode": "362633",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sanosra",
            "Pincode": "362634",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardargadh",
            "Pincode": "362640",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Devda",
            "Pincode": "362652",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khageshri",
            "Pincode": "362653",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghantvad",
            "Pincode": "362710",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sindhaj",
            "Pincode": "362715",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kodinar",
            "Pincode": "362720",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Harmadia",
            "Pincode": "362721",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valan",
            "Pincode": "362722",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Velan",
            "Pincode": "362722",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kodinar K U",
            "Pincode": "362725",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Arnej",
            "Pincode": "362726",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadnagar Kodinar",
            "Pincode": "362727",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Timbi",
            "Pincode": "362730",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhara",
            "Pincode": "362733",
            "City": "Junagadh",
            "District": "Junagadh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gate",
            "Pincode": "363001",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "M P Shah College",
            "Pincode": "363001",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "363001",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surendranagar",
            "Pincode": "363001",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Udyognagar",
            "Pincode": "363001",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadipura",
            "Pincode": "363001",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surendra Nagar Stn Road",
            "Pincode": "363002",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Joravarnagar",
            "Pincode": "363020",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kherali",
            "Pincode": "363023",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "363030",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "I E",
            "Pincode": "363030",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Wadhwan City",
            "Pincode": "363030",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Wadwan City Ie",
            "Pincode": "363035",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dudhrej",
            "Pincode": "363040",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khodu",
            "Pincode": "363041",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gujarwadi",
            "Pincode": "363045",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vana",
            "Pincode": "363110",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhanki",
            "Pincode": "363115",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhrangadhra",
            "Pincode": "363310",
            "City": "Dhrangadhra",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Satta Bazar",
            "Pincode": "363310",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kondh",
            "Pincode": "363312",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhrangadhra C W",
            "Pincode": "363315",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajsitapur",
            "Pincode": "363320",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Halvad Bazar",
            "Pincode": "363330",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Charadava",
            "Pincode": "363331",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Devalia",
            "Pincode": "363332",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tikar Rana",
            "Pincode": "363333",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sara",
            "Pincode": "363334",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chuda",
            "Pincode": "363410",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mojidad",
            "Pincode": "363411",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chokdi",
            "Pincode": "363412",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhrughupur",
            "Pincode": "363415",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nagnesh",
            "Pincode": "363416",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bahlapura",
            "Pincode": "363421",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "D B Chowk",
            "Pincode": "363421",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Limbdi",
            "Pincode": "363421",
            "City": "Limbdi",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pansina",
            "Pincode": "363423",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jambu",
            "Pincode": "363424",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hadala Bhal",
            "Pincode": "363425",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhoika",
            "Pincode": "363426",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shiyani",
            "Pincode": "363427",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sayla",
            "Pincode": "363430",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rampura",
            "Pincode": "363435",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sudamada",
            "Pincode": "363440",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Muli",
            "Pincode": "363510",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chotila",
            "Pincode": "363520",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Thangadh",
            "Pincode": "363530",
            "City": "Thangadh",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lunsar",
            "Pincode": "363535",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranpur",
            "Pincode": "363610",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Green Chowk",
            "Pincode": "363621",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Wankaner",
            "Pincode": "363621",
            "City": "Wankaner",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Wankaner Amarpura",
            "Pincode": "363622",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Daldi",
            "Pincode": "363626",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jetpur Morbi",
            "Pincode": "363630",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shri Sardanagar",
            "Pincode": "363636",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Green Chowk",
            "Pincode": "363641",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Morbi",
            "Pincode": "363641",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nani Bazar",
            "Pincode": "363641",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sakti Plot",
            "Pincode": "363641",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Morbi P P Works",
            "Pincode": "363642",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tankara",
            "Pincode": "363650",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amran",
            "Pincode": "363655",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dahisara",
            "Pincode": "363660",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sakatsanala",
            "Pincode": "363665",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kuntasi",
            "Pincode": "363666",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nani Bazar",
            "Pincode": "363667",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vavania",
            "Pincode": "363668",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Panchasar",
            "Pincode": "363669",
            "City": "Jamnagar",
            "District": "Jamnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Maliya Miyana",
            "Pincode": "363670",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhavnagar",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chavdigate",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gogha Circle",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kavikant Road",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khargate",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Krishnagar",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mamakotha Road",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nirmalnagar",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vora Bazar",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Wadava",
            "Pincode": "364001",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "B P T E",
            "Pincode": "364002",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhavnagar Takhteswar",
            "Pincode": "364002",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhavnagar Para",
            "Pincode": "364003",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhavnagar Chitra",
            "Pincode": "364004",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhav Anand Nagar",
            "Pincode": "364005",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhav Station Rd",
            "Pincode": "364006",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kumbharvada",
            "Pincode": "364006",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valukad G",
            "Pincode": "364021",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Budhel",
            "Pincode": "364022",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhandaria",
            "Pincode": "364050",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nari",
            "Pincode": "364055",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vartej",
            "Pincode": "364060",
            "City": "Vartej",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kardej",
            "Pincode": "364061",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Koliyak",
            "Pincode": "364070",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hathab",
            "Pincode": "364071",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gogha",
            "Pincode": "364110",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tansa",
            "Pincode": "364120",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Datha",
            "Pincode": "364130",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalsar Bhav",
            "Pincode": "364131",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pithalpur",
            "Pincode": "364135",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Talaja",
            "Pincode": "364140",
            "City": "Talaja",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Thaliya",
            "Pincode": "364145",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bagdana",
            "Pincode": "364146",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Trapaj",
            "Pincode": "364150",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dihor",
            "Pincode": "364151",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amargadh",
            "Pincode": "364210",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ambala",
            "Pincode": "364215",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Damnagar",
            "Pincode": "364220",
            "City": "Damnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ansodar",
            "Pincode": "364225",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sanosra",
            "Pincode": "364230",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranghola",
            "Pincode": "364231",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "364240",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sihor",
            "Pincode": "364240",
            "City": "Sihor",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghanghli",
            "Pincode": "364241",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Madhada",
            "Pincode": "364245",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Songadh",
            "Pincode": "364250",
            "City": "Songadh",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valukad S",
            "Pincode": "364251",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tana",
            "Pincode": "364260",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Varal",
            "Pincode": "364261",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Devgana",
            "Pincode": "364262",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gheti",
            "Pincode": "364265",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "D B Chowk",
            "Pincode": "364270",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Moti Vavdi",
            "Pincode": "364270",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palitana",
            "Pincode": "364270",
            "City": "Palitana",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "364270",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Parvadi",
            "Pincode": "364275",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vavdimoti",
            "Pincode": "364276",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota Khuntavada",
            "Pincode": "364280",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "364290",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Baug",
            "Pincode": "364290",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahuva",
            "Pincode": "364290",
            "City": "Mahuva",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vasitalav",
            "Pincode": "364290",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Katpur",
            "Pincode": "364292",
            "City": "Patan",
            "District": "Patan",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nana Jadra",
            "Pincode": "364292",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Talgajarda",
            "Pincode": "364293",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadrod",
            "Pincode": "364295",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghundarana",
            "Pincode": "364296",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gundarna",
            "Pincode": "364296",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vaghnagar",
            "Pincode": "364297",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kumbhan",
            "Pincode": "364298",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vallabhipur",
            "Pincode": "364310",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Patna Bhal",
            "Pincode": "364311",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pachhegam",
            "Pincode": "364312",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ratanpur Bhal",
            "Pincode": "364313",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chamardi",
            "Pincode": "364315",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhola",
            "Pincode": "364320",
            "City": "Dhola",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umrala",
            "Pincode": "364330",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chogath",
            "Pincode": "364335",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dolvan",
            "Pincode": "364365",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chamardi",
            "Pincode": "364410",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Babra",
            "Pincode": "364421",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lathi",
            "Pincode": "364430",
            "City": "Lathi",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Akala",
            "Pincode": "364431",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shedubhar",
            "Pincode": "364432",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chavand",
            "Pincode": "364435",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shekh Pipalia",
            "Pincode": "364436",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "364440",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hamapur",
            "Pincode": "364445",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kunkavav",
            "Pincode": "364450",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota Ankadia",
            "Pincode": "364455",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vaghania",
            "Pincode": "364456",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amrapur",
            "Pincode": "364457",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mavjinjva",
            "Pincode": "364458",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lunidhar",
            "Pincode": "364460",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Derdikumbhaji",
            "Pincode": "364465",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sultanpur",
            "Pincode": "364470",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadia",
            "Pincode": "364480",
            "City": "Vadia",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tori",
            "Pincode": "364481",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amar Nagar",
            "Pincode": "364485",
            "City": "Rajkot",
            "District": "Rajkot",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vasavad",
            "Pincode": "364490",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gariyadhar",
            "Pincode": "364505",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Velavadar",
            "Pincode": "364506",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nonghanvadar",
            "Pincode": "364507",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota Charodia",
            "Pincode": "364508",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jesar",
            "Pincode": "364510",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Savar City",
            "Pincode": "364515",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Savarkundla",
            "Pincode": "364515",
            "City": "Savarkundla",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota Bhamodra",
            "Pincode": "364517",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nesdi",
            "Pincode": "364518",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Motazinjhuvada",
            "Pincode": "364519",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jira",
            "Pincode": "364521",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Badhada",
            "Pincode": "364522",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bagasra",
            "Pincode": "364522",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pithawadi",
            "Pincode": "364523",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ambardi",
            "Pincode": "364524",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vanda",
            "Pincode": "364525",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Piava",
            "Pincode": "364526",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vijpadi",
            "Pincode": "364530",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Liliya",
            "Pincode": "364535",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Saldi",
            "Pincode": "364536",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amba",
            "Pincode": "364537",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jafrabad",
            "Pincode": "364540",
            "City": "Jafrabad",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nageshri",
            "Pincode": "364545",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dedan",
            "Pincode": "364550",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dungar",
            "Pincode": "364555",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajula",
            "Pincode": "364560",
            "City": "Rajula",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bherai",
            "Pincode": "364561",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Krankach",
            "Pincode": "364565",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vavera",
            "Pincode": "364570",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amreli",
            "Pincode": "364601",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Baharpura",
            "Pincode": "364601",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jesingpura",
            "Pincode": "364601",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Manekpura",
            "Pincode": "364601",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "364601",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tower Road",
            "Pincode": "364601",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Babapur",
            "Pincode": "364610",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vankia",
            "Pincode": "364615",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jalia Amreli",
            "Pincode": "364616",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chital",
            "Pincode": "364620",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Monpur",
            "Pincode": "364622",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chalala",
            "Pincode": "364630",
            "City": "Chalala",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gopalgram",
            "Pincode": "364632",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarambhada",
            "Pincode": "364633",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota Samadhiala",
            "Pincode": "364635",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhari",
            "Pincode": "364640",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "364640",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dalkhania",
            "Pincode": "364641",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhader",
            "Pincode": "364645",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khambha",
            "Pincode": "364650",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarasia",
            "Pincode": "364660",
            "City": "Amreli",
            "District": "Amreli",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Botad",
            "Pincode": "364710",
            "City": "Botad",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "364710",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Town",
            "Pincode": "364710",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lathidad",
            "Pincode": "364712",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhimdad",
            "Pincode": "364713",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Turkha",
            "Pincode": "364714",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Paliyad",
            "Pincode": "364720",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhasagam",
            "Pincode": "364730",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhasa Jn",
            "Pincode": "364740",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jalalpur",
            "Pincode": "364741",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gadhda S N",
            "Pincode": "364750",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ningala",
            "Pincode": "364760",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ugamedi",
            "Pincode": "364765",
            "City": "Bhavnagar",
            "District": "Bhavnagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhid Bazar",
            "Pincode": "370001",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhuj",
            "Pincode": "370001",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "City",
            "Pincode": "370001",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "College Road",
            "Pincode": "370001",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Darbargadh Chowk",
            "Pincode": "370001",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khatri Chakla",
            "Pincode": "370001",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sumrasar",
            "Pincode": "370006",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Loria",
            "Pincode": "370007",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "B S F Bhuj",
            "Pincode": "370015",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Madhavpur Kachchh",
            "Pincode": "370020",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mankuva",
            "Pincode": "370030",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sukhpar",
            "Pincode": "370040",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nirona",
            "Pincode": "370061",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kukma",
            "Pincode": "370105",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Anjar",
            "Pincode": "370110",
            "City": "Anjar",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ganga Bazar",
            "Pincode": "370110",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khedoi",
            "Pincode": "370130",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nagalpur K",
            "Pincode": "370132",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adhoi",
            "Pincode": "370135",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhachau",
            "Pincode": "370140",
            "City": "Bhachau",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chobari",
            "Pincode": "370141",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lakadia",
            "Pincode": "370145",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gagodar",
            "Pincode": "370146",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kidianagar",
            "Pincode": "370147",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Samakhiali",
            "Pincode": "370150",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adesar",
            "Pincode": "370155",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fatehgadh",
            "Pincode": "370156",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palansva",
            "Pincode": "370157",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhimasar B",
            "Pincode": "370160",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R Bazar",
            "Pincode": "370165",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rahpar",
            "Pincode": "370165",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rav",
            "Pincode": "370168",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gedi",
            "Pincode": "370169",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gadhda Khadir",
            "Pincode": "370170",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Udayanagar",
            "Pincode": "370203",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adipur",
            "Pincode": "370205",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kandla Port Harbour",
            "Pincode": "370210",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kandla F T Z",
            "Pincode": "370230",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gopalpuri",
            "Pincode": "370240",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhujpur",
            "Pincode": "370405",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Zarpara",
            "Pincode": "370406",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gundala",
            "Pincode": "370410",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadreswar",
            "Pincode": "370411",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kapaya",
            "Pincode": "370415",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mundra",
            "Pincode": "370421",
            "City": "Mundra",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Patri",
            "Pincode": "370425",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Baladia",
            "Pincode": "370427",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naranpur",
            "Pincode": "370429",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kera Kachchh",
            "Pincode": "370430",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bidada",
            "Pincode": "370435",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Durgapur",
            "Pincode": "370440",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gadhsisa",
            "Pincode": "370445",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Godhra Kachchh",
            "Pincode": "370450",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gundiali",
            "Pincode": "370455",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Koday",
            "Pincode": "370460",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mandvi",
            "Pincode": "370465",
            "City": "Mandvi",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navapura",
            "Pincode": "370465",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sanjipadi",
            "Pincode": "370465",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Maska",
            "Pincode": "370471",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kandagara",
            "Pincode": "370472",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Laija",
            "Pincode": "370475",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dahisara",
            "Pincode": "370485",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dumra",
            "Pincode": "370490",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khavda",
            "Pincode": "370510",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khavda B S F",
            "Pincode": "370515",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kotda N",
            "Pincode": "370605",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Manjal",
            "Pincode": "370610",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nakhtrana",
            "Pincode": "370615",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Netra",
            "Pincode": "370620",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ravapar",
            "Pincode": "370625",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gaduli",
            "Pincode": "370627",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lakhpat",
            "Pincode": "370630",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bitta",
            "Pincode": "370635",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jakhau",
            "Pincode": "370640",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kothara",
            "Pincode": "370645",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mothara",
            "Pincode": "370650",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naliya",
            "Pincode": "370655",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tera",
            "Pincode": "370660",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Virani",
            "Pincode": "370665",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khombhadi",
            "Pincode": "370670",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vithon",
            "Pincode": "370675",
            "City": "Bhuj",
            "District": "Kuchchh",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad G P O",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dariapur",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Delhi Gala",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Distrcit Court",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Road",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gheekanta Road",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamalpur",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamalpur Chakla",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalupur Chakla",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khadia",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khanpur",
            "Pincode": "380001",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lal Darwaja",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Manek Chowk",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Municipal Corporation",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Raikhad",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Raipur",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shahpur",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sub Foreign",
            "Pincode": "380001",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "N C Market",
            "Pincode": "380002",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Railwaypura",
            "Pincode": "380002",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Revdi Bazar",
            "Pincode": "380002",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Cantonment",
            "Pincode": "380003",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Civil",
            "Pincode": "380003",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Circle Stamp Depot",
            "Pincode": "380003",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Sahibag",
            "Pincode": "380004",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Shah",
            "Pincode": "380004",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dudheswar",
            "Pincode": "380004",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Madhupura Market",
            "Pincode": "380004",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tavdipura",
            "Pincode": "380004",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kabirchowk",
            "Pincode": "380005",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "O N G C",
            "Pincode": "380005",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sabarmati",
            "Pincode": "380005",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ambawadi",
            "Pincode": "380006",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ellisbridge",
            "Pincode": "380006",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gujarat College Ahmedabad",
            "Pincode": "380006",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Paldi",
            "Pincode": "380007",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Anand Nagar",
            "Pincode": "380007",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Narayannagar",
            "Pincode": "380007",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarkhej Road",
            "Pincode": "380007",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shardanagar",
            "Pincode": "380007",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Daxini Society",
            "Pincode": "380008",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Maninagar",
            "Pincode": "380008",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ashram Road",
            "Pincode": "380009",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gujarat High Court",
            "Pincode": "380009",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gujarat University",
            "Pincode": "380009",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navrangpura",
            "Pincode": "380009",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Asarwa",
            "Pincode": "380010",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Girdharnagar",
            "Pincode": "380010",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rly Crossing Ahmedabad",
            "Pincode": "380010",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Air Port",
            "Pincode": "380012",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naranpura",
            "Pincode": "380013",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naranpura Vistar",
            "Pincode": "380013",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navavadaj",
            "Pincode": "380013",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shastrinagar",
            "Pincode": "380013",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Stadium Marg",
            "Pincode": "380013",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadaj Ahmedabad",
            "Pincode": "380013",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gujarat Vidhyapith Ahmeda",
            "Pincode": "380014",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navjivan",
            "Pincode": "380014",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Azad Society",
            "Pincode": "380015",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Indian Institute Of Management",
            "Pincode": "380015",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Polytechnic",
            "Pincode": "380015",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Asarwa Chakla",
            "Pincode": "380016",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hospital",
            "Pincode": "380016",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "New Chamanpura",
            "Pincode": "380016",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Public Offices Ahmedabad",
            "Pincode": "380016",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Saraspur",
            "Pincode": "380018",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Railway Colony",
            "Pincode": "380019",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Rajpur Gomtipur",
            "Pincode": "380021",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gomtipur",
            "Pincode": "380021",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rakhial",
            "Pincode": "380021",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sonaria Block",
            "Pincode": "380021",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Behrampura",
            "Pincode": "380022",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Calico Mills",
            "Pincode": "380022",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gita Mandir Road",
            "Pincode": "380022",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kankaria Road",
            "Pincode": "380022",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Rakhialudyog Vi",
            "Pincode": "380023",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sukhrampura Ahmedabad",
            "Pincode": "380023",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Asarwa Ex South Ahmedabad",
            "Pincode": "380024",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bapu Nagar",
            "Pincode": "380024",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bapu Nagar I E",
            "Pincode": "380024",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad",
            "Pincode": "380025",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Anil Marg",
            "Pincode": "380025",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "N C Mills",
            "Pincode": "380025",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naroda Road",
            "Pincode": "380025",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Amraiwadi",
            "Pincode": "380026",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Ashram Ahmedabad",
            "Pincode": "380027",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Space",
            "Pincode": "380028",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Alam Roza",
            "Pincode": "380028",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhairavnath Road",
            "Pincode": "380028",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghodasar",
            "Pincode": "380050",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jawahar Chowk",
            "Pincode": "380050",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khokhra",
            "Pincode": "380050",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "L G Hospital Road",
            "Pincode": "380050",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mehmadabad",
            "Pincode": "380050",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "S A Mills",
            "Pincode": "380050",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sant Punit Marg",
            "Pincode": "380050",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vasisthanagar Ahmedabad",
            "Pincode": "380050",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Jivrajpark",
            "Pincode": "380051",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Memnagar Ahmedabad",
            "Pincode": "380052",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Application Centre",
            "Pincode": "380053",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Thaltej Road",
            "Pincode": "380054",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahmedabad Juhapura",
            "Pincode": "380055",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghatlodia Ahmedabad",
            "Pincode": "380061",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 9",
            "Pincode": "382009",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "382010",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Vidhansabha",
            "Pincode": "382010",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghandhinagar Sector 16",
            "Pincode": "382016",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 17",
            "Pincode": "382017",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 19",
            "Pincode": "382019",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 20",
            "Pincode": "382020",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 21",
            "Pincode": "382021",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 22",
            "Pincode": "382022",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 23",
            "Pincode": "382023",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 24",
            "Pincode": "382023",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 28",
            "Pincode": "382028",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 29",
            "Pincode": "382029",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sector 30",
            "Pincode": "382030",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar T P S",
            "Pincode": "382041",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar C R P F Camp",
            "Pincode": "382042",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Nagar G M S",
            "Pincode": "382043",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "382043",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "K P T",
            "Pincode": "382043",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kolavada",
            "Pincode": "382051",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sanand",
            "Pincode": "382110",
            "City": "Sanand",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sanand Society Area",
            "Pincode": "382110",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Godhavi",
            "Pincode": "382115",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Detroj",
            "Pincode": "382120",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mandal",
            "Pincode": "382130",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rampura Bhankoda",
            "Pincode": "382140",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Katosan Road",
            "Pincode": "382145",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Viramgam",
            "Pincode": "382150",
            "City": "Viramgam",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Viramgam Choksi Bazar",
            "Pincode": "382150",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhojva",
            "Pincode": "382155",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jholapur",
            "Pincode": "382160",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalyanpura",
            "Pincode": "382165",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Agol",
            "Pincode": "382166",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Virochannagar",
            "Pincode": "382170",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarkhej",
            "Pincode": "382213",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bavla",
            "Pincode": "382220",
            "City": "Bavla",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bavla Market Yard",
            "Pincode": "382220",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lothal Bhurkhi R S",
            "Pincode": "382230",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Koth Gangad",
            "Pincode": "382240",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Polarpur",
            "Pincode": "382250",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jalila",
            "Pincode": "382255",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chaloda",
            "Pincode": "382260",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kauka",
            "Pincode": "382265",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Badarkha",
            "Pincode": "382270",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dahegam",
            "Pincode": "382305",
            "City": "Dahegam",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dahegam Jawahar",
            "Pincode": "382305",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Market",
            "Pincode": "382305",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bahiyal",
            "Pincode": "382308",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nandol",
            "Pincode": "382310",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rakhial R S",
            "Pincode": "382315",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ujedia",
            "Pincode": "382316",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sadra",
            "Pincode": "382320",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhala",
            "Pincode": "382321",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Area",
            "Pincode": "382325",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naroda",
            "Pincode": "382325",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naroda Society",
            "Pincode": "382325",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kharna",
            "Pincode": "382327",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naroda I E",
            "Pincode": "382330",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardarnagar",
            "Pincode": "382340",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardarnagar Kubernagar",
            "Pincode": "382340",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Saijpur Bogha",
            "Pincode": "382345",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Krishnanagar",
            "Pincode": "382346",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Thakkar Bapanagar",
            "Pincode": "382350",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khodiyarnagar",
            "Pincode": "382352",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabhoda",
            "Pincode": "382355",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valad",
            "Pincode": "382360",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Narol",
            "Pincode": "382405",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Odhav",
            "Pincode": "382410",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Odhav G V M M Nd",
            "Pincode": "382410",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Odhav I E",
            "Pincode": "382415",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vastral",
            "Pincode": "382418",
            "City": "Vastral",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vastrel",
            "Pincode": "382418",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adalaj",
            "Pincode": "382421",
            "City": "Adalaj",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Uvarsad",
            "Pincode": "382422",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kasturinagar Sertha",
            "Pincode": "382423",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Area",
            "Pincode": "382424",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chand Kheda",
            "Pincode": "382424",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bareja",
            "Pincode": "382425",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jetalpur",
            "Pincode": "382426",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kathwada M P",
            "Pincode": "382430",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kuha",
            "Pincode": "382433",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nandej",
            "Pincode": "382435",
            "City": "Nandej",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vatva",
            "Pincode": "382440",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Isanpur",
            "Pincode": "382443",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vatva I E",
            "Pincode": "382445",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vatva Jasodanagar",
            "Pincode": "382445",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Janta Nagar",
            "Pincode": "382449",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Barwala Ghelasa",
            "Pincode": "382450",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Salangpur Hanuman",
            "Pincode": "382451",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dholera",
            "Pincode": "382455",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhandhuka",
            "Pincode": "382460",
            "City": "Dhandhuka",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadiad",
            "Pincode": "382463",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fedra Fertilizemagar",
            "Pincode": "382465",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Digvijagar",
            "Pincode": "382470",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sindhi Ambawadi",
            "Pincode": "382475",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sindhi Colony",
            "Pincode": "382475",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranip",
            "Pincode": "382480",
            "City": "Ranip",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chandlodia",
            "Pincode": "382481",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pethapur",
            "Pincode": "382610",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Randheja",
            "Pincode": "382620",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rupal",
            "Pincode": "382630",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardhev",
            "Pincode": "382640",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Unava Balva",
            "Pincode": "382650",
            "City": "Gandhinagar",
            "District": "Gandhi Nagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Balva",
            "Pincode": "382655",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Charadu",
            "Pincode": "382704",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dangarva",
            "Pincode": "382705",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Meu",
            "Pincode": "382706",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nandasan",
            "Pincode": "382706",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karjisan",
            "Pincode": "382707",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadasma",
            "Pincode": "382708",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadu Mahesana",
            "Pincode": "382709",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jagidan",
            "Pincode": "382710",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kherva Jagudam",
            "Pincode": "382711",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Boriavi",
            "Pincode": "382712",
            "City": "Boriavi",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Akhaj",
            "Pincode": "382713",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kadi",
            "Pincode": "382715",
            "City": "Kadi",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Market Yard",
            "Pincode": "382715",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Serisa",
            "Pincode": "382716",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Suraj",
            "Pincode": "382717",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghumansan",
            "Pincode": "382718",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jornaj",
            "Pincode": "382719",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Desaiwada",
            "Pincode": "382721",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dr Ambedkar Road",
            "Pincode": "382721",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Road",
            "Pincode": "382721",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "382721",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalol",
            "Pincode": "382721",
            "City": "Kalol",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pamol",
            "Pincode": "382721",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Society Area",
            "Pincode": "382721",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kaloli E",
            "Pincode": "382725",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adraj Merda",
            "Pincode": "382726",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karannagar",
            "Pincode": "382727",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Thol",
            "Pincode": "382728",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhatral",
            "Pincode": "382729",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Cimatral",
            "Pincode": "382729",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Langhnej",
            "Pincode": "382730",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Veda Paliad",
            "Pincode": "382731",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ambaliayasan",
            "Pincode": "382732",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Saij",
            "Pincode": "382733",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vamaj",
            "Pincode": "382734",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Wamaj",
            "Pincode": "382734",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nardipur",
            "Pincode": "382735",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jamla",
            "Pincode": "382736",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Paliad Veda",
            "Pincode": "382737",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Limbodara",
            "Pincode": "382739",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pansar",
            "Pincode": "382740",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jhulasan",
            "Pincode": "382741",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dingucha",
            "Pincode": "382742",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Isand",
            "Pincode": "382743",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bajana",
            "Pincode": "382745",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dasada",
            "Pincode": "382750",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Zinzuwada",
            "Pincode": "382755",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kharaghoda",
            "Pincode": "382760",
            "City": "Kharaghoda",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "382760",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Patdi",
            "Pincode": "382765",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vanod",
            "Pincode": "382770",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lakhtar",
            "Pincode": "382775",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adariyana",
            "Pincode": "382780",
            "City": "Surendranagar",
            "District": "Surendranagar",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Aglod",
            "Pincode": "382805",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Falu",
            "Pincode": "382806",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Charada",
            "Pincode": "382810",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Delvada",
            "Pincode": "382812",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gavada",
            "Pincode": "382815",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Malosan",
            "Pincode": "382816",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gerita Kolvada R S",
            "Pincode": "382820",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Samau",
            "Pincode": "382823",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gozaria",
            "Pincode": "382825",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Boru",
            "Pincode": "382826",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bilodara",
            "Pincode": "382831",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kukarvada",
            "Pincode": "382831",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vihar",
            "Pincode": "382832",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadasan",
            "Pincode": "382833",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lodra",
            "Pincode": "382835",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rindrol",
            "Pincode": "382836",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ladol",
            "Pincode": "382840",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mansa Bazar",
            "Pincode": "382845",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pilval",
            "Pincode": "382850",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Veda Pilwai",
            "Pincode": "382851",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pundhra",
            "Pincode": "382855",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Anodia",
            "Pincode": "382856",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahudi",
            "Pincode": "382857",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardarpur",
            "Pincode": "382860",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jantral",
            "Pincode": "382861",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sundarpur",
            "Pincode": "382862",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fudeda",
            "Pincode": "382863",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vasai Dabhla",
            "Pincode": "382865",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabhla",
            "Pincode": "382867",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tintodan",
            "Pincode": "382868",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "382870",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vijapur",
            "Pincode": "382870",
            "City": "Vijapur",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghantu Dhanpura",
            "Pincode": "382871",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nava Sangpur",
            "Pincode": "382875",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranasan",
            "Pincode": "382880",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hajipura",
            "Pincode": "383001",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Himatnagar",
            "Pincode": "383001",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahavirnagar",
            "Pincode": "383001",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "383001",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gidc Ankleshwar",
            "Pincode": "383002",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vaktapur",
            "Pincode": "383010",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gambhoi",
            "Pincode": "383030",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jadar",
            "Pincode": "383110",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Salal",
            "Pincode": "383120",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nani Bhaghol",
            "Pincode": "383205",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Prantij",
            "Pincode": "383205",
            "City": "Prantij",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "383205",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sonasan",
            "Pincode": "383210",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Market Yard",
            "Pincode": "383215",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Takhatgadh",
            "Pincode": "383215",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Talod",
            "Pincode": "383215",
            "City": "Talod",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Illol",
            "Pincode": "383220",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Davad",
            "Pincode": "383225",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umedgadh",
            "Pincode": "383230",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "383235",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadali",
            "Pincode": "383235",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bamna",
            "Pincode": "383240",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "383245",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhiloda",
            "Pincode": "383245",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Takatuka",
            "Pincode": "383246",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tintoi",
            "Pincode": "383250",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lusadia",
            "Pincode": "383251",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khedbrahma",
            "Pincode": "383255",
            "City": "Khedbrahma",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "383255",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Akrund",
            "Pincode": "383260",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Radhivad",
            "Pincode": "383270",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Laxmipura",
            "Pincode": "383275",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Raigadh",
            "Pincode": "383276",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Harsol",
            "Pincode": "383305",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadagam Sk",
            "Pincode": "383307",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhansura",
            "Pincode": "383310",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "383315",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "College Area",
            "Pincode": "383315",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Modasa",
            "Pincode": "383315",
            "City": "Modasa",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Society Area",
            "Pincode": "383315",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardoi",
            "Pincode": "383320",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bayad",
            "Pincode": "383325",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vantda Bayad",
            "Pincode": "383326",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Choila",
            "Pincode": "383327",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Demai",
            "Pincode": "383330",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amodara",
            "Pincode": "383331",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Deroli",
            "Pincode": "383332",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gabat",
            "Pincode": "383335",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sathamba",
            "Pincode": "383340",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Malpur",
            "Pincode": "383345",
            "City": "Malpur",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Meghraj",
            "Pincode": "383350",
            "City": "Meghraj",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shamlaji",
            "Pincode": "383355",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Badoli",
            "Pincode": "383410",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chithoda",
            "Pincode": "383421",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Poshina",
            "Pincode": "383422",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Idar",
            "Pincode": "383430",
            "City": "Idar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Market Yard",
            "Pincode": "383430",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shrinagar",
            "Pincode": "383430",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Verabar",
            "Pincode": "383434",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kadiadra",
            "Pincode": "383440",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vasai",
            "Pincode": "383450",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vijaynagar",
            "Pincode": "383460",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kadiawada",
            "Pincode": "383462",
            "City": "Himatnagar",
            "District": "Sabarkantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fatepur",
            "Pincode": "383781",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "384001",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Janatha Super Market",
            "Pincode": "384001",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahesana",
            "Pincode": "384001",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Talavgate Road",
            "Pincode": "384001",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mehesana Ind Estate",
            "Pincode": "384002",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Railway Colony",
            "Pincode": "384002",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gambhu",
            "Pincode": "384011",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Balisana",
            "Pincode": "384110",
            "City": "Patan",
            "District": "Patan",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ambasan",
            "Pincode": "384111",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Der",
            "Pincode": "384112",
            "City": "Patan",
            "District": "Patan",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhandu",
            "Pincode": "384120",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Daumoti",
            "Pincode": "384121",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jetalvasna",
            "Pincode": "384122",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kahoda",
            "Pincode": "384130",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhunav",
            "Pincode": "384131",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lunva",
            "Pincode": "384132",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mandali",
            "Pincode": "384133",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kamli",
            "Pincode": "384140",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bindu Sarovar Road",
            "Pincode": "384151",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jam Chakla",
            "Pincode": "384151",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Market Yard",
            "Pincode": "384151",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sidhpur",
            "Pincode": "384151",
            "City": "Sidhpur",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Zampli Pole",
            "Pincode": "384151",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dethli",
            "Pincode": "384152",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Meloj",
            "Pincode": "384153",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bilia",
            "Pincode": "384154",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Unava",
            "Pincode": "384160",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tundav",
            "Pincode": "384165",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kotkuva",
            "Pincode": "384170",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pharmacy",
            "Pincode": "384170",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umiyamataji",
            "Pincode": "384170",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Unjha",
            "Pincode": "384170",
            "City": "Unjha",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karli",
            "Pincode": "384171",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dasaj",
            "Pincode": "384172",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhankher",
            "Pincode": "384174",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Aithor",
            "Pincode": "384175",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sihi",
            "Pincode": "384176",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Upera",
            "Pincode": "384177",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Maktupur",
            "Pincode": "384178",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Panchot",
            "Pincode": "384205",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palodar",
            "Pincode": "384206",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhatiarda",
            "Pincode": "384207",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bechraji",
            "Pincode": "384210",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sankhalpur",
            "Pincode": "384211",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Modhera",
            "Pincode": "384212",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalri",
            "Pincode": "384213",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Brahmanwada",
            "Pincode": "384215",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chanasma",
            "Pincode": "384220",
            "City": "Chanasma",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadavli",
            "Pincode": "384221",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Brahmanwada",
            "Pincode": "384222",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhinoj",
            "Pincode": "384225",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pindharpura",
            "Pincode": "384226",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sunsar",
            "Pincode": "384227",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gorad",
            "Pincode": "384228",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lanva",
            "Pincode": "384229",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kamboi",
            "Pincode": "384230",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalyana",
            "Pincode": "384231",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palasar",
            "Pincode": "384235",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Harij",
            "Pincode": "384240",
            "City": "Harij",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mujpur Harji",
            "Pincode": "384241",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lolada",
            "Pincode": "384242",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sami",
            "Pincode": "384245",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sankheswar",
            "Pincode": "384246",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dudkha",
            "Pincode": "384247",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kansa",
            "Pincode": "384250",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kungher",
            "Pincode": "384255",
            "City": "Patan",
            "District": "Patan",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chandrumana",
            "Pincode": "384256",
            "City": "Patan",
            "District": "Patan",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adia",
            "Pincode": "384257",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Manund",
            "Pincode": "384260",
            "City": "Patan",
            "District": "Patan",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Muderda",
            "Pincode": "384261",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "City",
            "Pincode": "384265",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Marketyard",
            "Pincode": "384265",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Patan",
            "Pincode": "384265",
            "City": "Patan",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajkawada",
            "Pincode": "384265",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sidhraj Road",
            "Pincode": "384265",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Three Gate",
            "Pincode": "384265",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kuvara",
            "Pincode": "384270",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Aghar",
            "Pincode": "384271",
            "City": "Patan",
            "District": "Patan",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sariad",
            "Pincode": "384272",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mesar",
            "Pincode": "384273",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Wamaiya",
            "Pincode": "384274",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranuj",
            "Pincode": "384275",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sander",
            "Pincode": "384276",
            "City": "Patan",
            "District": "Patan",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sankhari",
            "Pincode": "384277",
            "City": "Patan",
            "District": "Patan",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nayta",
            "Pincode": "384278",
            "City": "Patan",
            "District": "Patan",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kantharavi",
            "Pincode": "384280",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Wagrod",
            "Pincode": "384285",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kakoshi",
            "Pincode": "384290",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dindroi",
            "Pincode": "384291",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Methan",
            "Pincode": "384292",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kada",
            "Pincode": "384305",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valam",
            "Pincode": "384310",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khandosan",
            "Pincode": "384311",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tarabh",
            "Pincode": "384312",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Market Yard",
            "Pincode": "384315",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "384315",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Visnagar",
            "Pincode": "384315",
            "City": "Visnagar",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gothva",
            "Pincode": "384318",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhalak",
            "Pincode": "384319",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umta",
            "Pincode": "384320",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jaska",
            "Pincode": "384321",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Denap",
            "Pincode": "384323",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kheralu",
            "Pincode": "384325",
            "City": "Kheralu",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabhad",
            "Pincode": "384327",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabhoda",
            "Pincode": "384328",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabhoi",
            "Pincode": "384328",
            "City": "Dabhoi",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "No Delivery",
            "Pincode": "384328",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kodram",
            "Pincode": "384329",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Satlasana",
            "Pincode": "384330",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sipor",
            "Pincode": "384335",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sudasana",
            "Pincode": "384340",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sundhia",
            "Pincode": "384345",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Taranga Hill R S",
            "Pincode": "384350",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vagnagar Bazar",
            "Pincode": "384355",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dharoi D S C",
            "Pincode": "384360",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhablia",
            "Pincode": "384365",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kahipur",
            "Pincode": "384370",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kamana",
            "Pincode": "384375",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Piludra",
            "Pincode": "384380",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gunja",
            "Pincode": "384385",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Balol",
            "Pincode": "384410",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Maguna",
            "Pincode": "384411",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jhotana",
            "Pincode": "384421",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Santhal",
            "Pincode": "384430",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Linch",
            "Pincode": "384435",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lakhvad",
            "Pincode": "384440",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabhi",
            "Pincode": "384513",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Delhigate",
            "Pincode": "385001",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kamalpura",
            "Pincode": "385001",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kirtistambh",
            "Pincode": "385001",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palanpur",
            "Pincode": "385001",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palanpur Joravar",
            "Pincode": "385001",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajgadhi",
            "Pincode": "385001",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palace",
            "Pincode": "385002",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chitrasani",
            "Pincode": "385010",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jagana",
            "Pincode": "385011",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Virampur",
            "Pincode": "385012",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ambaji",
            "Pincode": "385110",
            "City": "Ambaji",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chadotar",
            "Pincode": "385111",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Malan",
            "Pincode": "385112",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Danta Bhavangadh",
            "Pincode": "385120",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shri Amirgadh",
            "Pincode": "385130",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Iqbalgadh",
            "Pincode": "385135",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhapi",
            "Pincode": "385210",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Majadar",
            "Pincode": "385215",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhanera",
            "Pincode": "385310",
            "City": "Dhanera",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ramsan",
            "Pincode": "385315",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhabhar",
            "Pincode": "385320",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tervada",
            "Pincode": "385325",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Morvada",
            "Pincode": "385326",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Diyodar",
            "Pincode": "385330",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Radhanpur",
            "Pincode": "385340",
            "City": "Radhanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rangadhi",
            "Pincode": "385340",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Santalpur",
            "Pincode": "385350",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Varahi",
            "Pincode": "385360",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadgam",
            "Pincode": "385410",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mamadpur",
            "Pincode": "385421",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dantiwada Colony",
            "Pincode": "385505",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardar Krishinagar",
            "Pincode": "385506",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chandisar",
            "Pincode": "385510",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gadh",
            "Pincode": "385515",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Samdhi Ranajivas",
            "Pincode": "385516",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sasam",
            "Pincode": "385517",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kumbhasan",
            "Pincode": "385518",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Madana",
            "Pincode": "385519",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kanodar",
            "Pincode": "385520",
            "City": "Kanodar",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vedancha",
            "Pincode": "385521",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Raner",
            "Pincode": "385522",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Meta",
            "Pincode": "385525",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Basu",
            "Pincode": "385526",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhildi",
            "Pincode": "385530",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Madetha",
            "Pincode": "385531",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Muletha",
            "Pincode": "385531",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kamboi Bk",
            "Pincode": "385533",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "385535",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Disa",
            "Pincode": "385535",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Juna Disa",
            "Pincode": "385540",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lakhani",
            "Pincode": "385541",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhuva",
            "Pincode": "385542",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadath",
            "Pincode": "385543",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khimat",
            "Pincode": "385545",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Panthavada",
            "Pincode": "385546",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sihori",
            "Pincode": "385550",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umbari",
            "Pincode": "385551",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khimana",
            "Pincode": "385554",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Thara",
            "Pincode": "385555",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Un",
            "Pincode": "385560",
            "City": "Un",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tharad",
            "Pincode": "385565",
            "City": "Tharad",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhima",
            "Pincode": "385566",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surgam",
            "Pincode": "385570",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Benap",
            "Pincode": "385571",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vav",
            "Pincode": "385575",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jherda",
            "Pincode": "385580",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Malgadh",
            "Pincode": "385585",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Agathala",
            "Pincode": "385586",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vada",
            "Pincode": "385590",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chekhla",
            "Pincode": "385595",
            "City": "Palanpur",
            "District": "Banaskantha",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ashram Road",
            "Pincode": "387001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "College Road",
            "Pincode": "387001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Desaivago",
            "Pincode": "387001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dumrul Bazar",
            "Pincode": "387001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "387001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Methodist Hospital",
            "Pincode": "387001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nadiad",
            "Pincode": "387001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Srp Group Area",
            "Pincode": "387001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "387001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Patel Society Area",
            "Pincode": "387002",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghodasar",
            "Pincode": "387110",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jaravat",
            "Pincode": "387111",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kailash Hindu Lodge",
            "Pincode": "387113",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Alindra",
            "Pincode": "387115",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kanij",
            "Pincode": "387120",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khatrajgate",
            "Pincode": "387130",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Marketyard",
            "Pincode": "387130",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mehmedabad",
            "Pincode": "387130",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Modaj",
            "Pincode": "387135",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Haldarwas",
            "Pincode": "387140",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabhow",
            "Pincode": "387210",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Malataj",
            "Pincode": "387220",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pij",
            "Pincode": "387230",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota Bazar",
            "Pincode": "387240",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sojitra",
            "Pincode": "387240",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Alina",
            "Pincode": "387305",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Boriavi",
            "Pincode": "387310",
            "City": "Boriavi",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chaklasi",
            "Pincode": "387315",
            "City": "Chaklasi",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabhan",
            "Pincode": "387320",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kanjri",
            "Pincode": "387325",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mohlel",
            "Pincode": "387330",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sodpur",
            "Pincode": "387331",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahudha",
            "Pincode": "387335",
            "City": "Mahudha",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahisa",
            "Pincode": "387340",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Narsanda",
            "Pincode": "387345",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palana",
            "Pincode": "387350",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Piplag",
            "Pincode": "387355",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Salun",
            "Pincode": "387360",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Torna",
            "Pincode": "387365",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Antroli",
            "Pincode": "387366",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Uttarsanda",
            "Pincode": "387370",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadtal",
            "Pincode": "387375",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vaso",
            "Pincode": "387380",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Deva",
            "Pincode": "387382",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rudan",
            "Pincode": "387385",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kheda",
            "Pincode": "387411",
            "City": "Kheda",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kheda Camp",
            "Pincode": "387421",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sinhuj",
            "Pincode": "387430",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vanthvali",
            "Pincode": "387435",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Alindra",
            "Pincode": "387510",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vansol",
            "Pincode": "387515",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Limbasi",
            "Pincode": "387520",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Matar",
            "Pincode": "387530",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Traj",
            "Pincode": "387531",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navagam",
            "Pincode": "387540",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nayka",
            "Pincode": "387550",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Radhu",
            "Pincode": "387560",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ratanpur",
            "Pincode": "387570",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Attarsumba",
            "Pincode": "387610",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Antisargate",
            "Pincode": "387620",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "387620",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kapadwanj",
            "Pincode": "387620",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kathlal",
            "Pincode": "387630",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhipadi",
            "Pincode": "387635",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lasundra",
            "Pincode": "387640",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nirmali",
            "Pincode": "387650",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jher",
            "Pincode": "387651",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Antisar",
            "Pincode": "387655",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Betwada",
            "Pincode": "387660",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ramol",
            "Pincode": "387710",
            "City": "Ramol",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dholka",
            "Pincode": "387810",
            "City": "Dholka",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dholka Kharakuva",
            "Pincode": "387810",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khokhar Chakla",
            "Pincode": "387810",
            "City": "Ahmedabad",
            "District": "Ahmedabad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amul Dairy",
            "Pincode": "388001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Anand",
            "Pincode": "388001",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Anand R S",
            "Pincode": "388001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Loteswar Bhagol",
            "Pincode": "388001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardarganj",
            "Pincode": "388001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Town",
            "Pincode": "388001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "V T College",
            "Pincode": "388001",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Porda",
            "Pincode": "388105",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Agri Inst Anand",
            "Pincode": "388110",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "V V Nagar",
            "Pincode": "388120",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vithal Udyognagar",
            "Pincode": "388121",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gamdi",
            "Pincode": "388122",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Boria",
            "Pincode": "388130",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhundakuva",
            "Pincode": "388131",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sandesar",
            "Pincode": "388132",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bochasan R S",
            "Pincode": "388140",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nar",
            "Pincode": "388150",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pandoli",
            "Pincode": "388160",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sayma",
            "Pincode": "388170",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tarapur",
            "Pincode": "388180",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhalej",
            "Pincode": "388205",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ode",
            "Pincode": "388210",
            "City": "Ode",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bharoda",
            "Pincode": "388211",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sundalpura",
            "Pincode": "388212",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shili",
            "Pincode": "388213",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Thamna",
            "Pincode": "388215",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khankuva",
            "Pincode": "388216",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Padal",
            "Pincode": "388217",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Panchvati",
            "Pincode": "388220",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umreth",
            "Pincode": "388220",
            "City": "Umreth",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dakor",
            "Pincode": "388225",
            "City": "Dakor",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Town",
            "Pincode": "388225",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valasan",
            "Pincode": "388226",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalsar",
            "Pincode": "388230",
            "City": "Mahesana",
            "District": "Mahesana",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Menpura",
            "Pincode": "388235",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Wanakbori",
            "Pincode": "388236",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Wanghroli",
            "Pincode": "388238",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "T P S",
            "Pincode": "388239",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Savalia C W",
            "Pincode": "388240",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sevalia R S",
            "Pincode": "388245",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Thasra",
            "Pincode": "388250",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tower Road",
            "Pincode": "388250",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nepalpura",
            "Pincode": "388254",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Town",
            "Pincode": "388255",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadasinor",
            "Pincode": "388255",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Saliawadi",
            "Pincode": "388256",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Othwad",
            "Pincode": "388257",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vaddla Vadasinor",
            "Pincode": "388258",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhanthla",
            "Pincode": "388259",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Birpur",
            "Pincode": "388260",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Debhari",
            "Pincode": "388261",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Saradia",
            "Pincode": "388262",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pandva",
            "Pincode": "388265",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jetholi",
            "Pincode": "388266",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bar",
            "Pincode": "388267",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vardhari",
            "Pincode": "388270",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adas",
            "Pincode": "388305",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vasad",
            "Pincode": "388306",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kantharia",
            "Pincode": "388307",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ratanpur Anand",
            "Pincode": "388307",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Asodar",
            "Pincode": "388308",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ajarpura",
            "Pincode": "388310",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bakrol",
            "Pincode": "388315",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chikhodra",
            "Pincode": "388320",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karamsad",
            "Pincode": "388325",
            "City": "Karamsad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khambholaj",
            "Pincode": "388330",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kunjeav",
            "Pincode": "388335",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rasnol",
            "Pincode": "388336",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mogar",
            "Pincode": "388340",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Napad",
            "Pincode": "388350",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navli",
            "Pincode": "388355",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Samarkha",
            "Pincode": "388360",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarsa",
            "Pincode": "388365",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadod",
            "Pincode": "388370",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jharola",
            "Pincode": "388390",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bandhani",
            "Pincode": "388410",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Changa",
            "Pincode": "388421",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gambhira",
            "Pincode": "388425",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dharmaji",
            "Pincode": "388430",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadadla",
            "Pincode": "388435",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mehlav",
            "Pincode": "388440",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mogri",
            "Pincode": "388445",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Petlad",
            "Pincode": "388450",
            "City": "Petlad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "388450",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Zanda Bazar",
            "Pincode": "388450",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Piplav",
            "Pincode": "388460",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kasor",
            "Pincode": "388461",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palaj",
            "Pincode": "388465",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Charotar",
            "Pincode": "388466",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sunav",
            "Pincode": "388470",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sundarna",
            "Pincode": "388480",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Simarda",
            "Pincode": "388485",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Anklave",
            "Pincode": "388510",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umeta",
            "Pincode": "388515",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bamangam",
            "Pincode": "388520",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadran",
            "Pincode": "388530",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarol",
            "Pincode": "388531",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Borsad",
            "Pincode": "388540",
            "City": "Borsad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandhi Ganj",
            "Pincode": "388540",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kashipura",
            "Pincode": "388540",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Market Yard",
            "Pincode": "388540",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Alarsa",
            "Pincode": "388543",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Davol",
            "Pincode": "388544",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kavitha",
            "Pincode": "388545",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kathana R S",
            "Pincode": "388550",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalamsar",
            "Pincode": "388555",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dehvan",
            "Pincode": "388556",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Napa",
            "Pincode": "388560",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ras",
            "Pincode": "388570",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Virsad",
            "Pincode": "388580",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vatadra",
            "Pincode": "388585",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhuvaran R S",
            "Pincode": "388610",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chitari Bazar",
            "Pincode": "388620",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "College Area",
            "Pincode": "388620",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghasgawara",
            "Pincode": "388620",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khambhat",
            "Pincode": "388620",
            "City": "Khambhat",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pith Bazar",
            "Pincode": "388620",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tran Darwaja",
            "Pincode": "388620",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gudel",
            "Pincode": "388625",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kansari",
            "Pincode": "388630",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Undel",
            "Pincode": "388640",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kanisa",
            "Pincode": "388641",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Timba Road",
            "Pincode": "388710",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Timba",
            "Pincode": "388711",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nadisar",
            "Pincode": "388712",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kakanpur",
            "Pincode": "388713",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Morva Rena",
            "Pincode": "388714",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ratanpur Kantdi",
            "Pincode": "388715",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Moti Kantdi",
            "Pincode": "388716",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "City Civil Lines",
            "Pincode": "389001",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Godhra",
            "Pincode": "389001",
            "City": "Godhra",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "389001",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Power House",
            "Pincode": "389001",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "389001",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shroff Bazar",
            "Pincode": "389001",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vorvad",
            "Pincode": "389001",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mora",
            "Pincode": "389110",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Limdi Doli",
            "Pincode": "389111",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sant Road",
            "Pincode": "389120",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Natapur",
            "Pincode": "389121",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Orvada",
            "Pincode": "389122",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mojri",
            "Pincode": "389123",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Piplod",
            "Pincode": "389130",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Moti Zari",
            "Pincode": "389135",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Limkheda",
            "Pincode": "389140",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kadwal",
            "Pincode": "389145",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chakalia Road",
            "Pincode": "389151",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dahod",
            "Pincode": "389151",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Godhra Road",
            "Pincode": "389151",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Padav Bazar",
            "Pincode": "389151",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pani Gate",
            "Pincode": "389151",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "389151",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Garbada",
            "Pincode": "389155",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Abhlod",
            "Pincode": "389156",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bavka",
            "Pincode": "389157",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Moti Kharaj",
            "Pincode": "389158",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Freeland Ganj Dahod",
            "Pincode": "389160",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jhalod",
            "Pincode": "389170",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fatepura",
            "Pincode": "389172",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sanjeli",
            "Pincode": "389175",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Limdi Pm",
            "Pincode": "389180",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sukhsar",
            "Pincode": "389190",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shehera",
            "Pincode": "389210",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kothamba",
            "Pincode": "389220",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lunawada",
            "Pincode": "389230",
            "City": "Lunawada",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mandvi",
            "Pincode": "389230",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vorwad",
            "Pincode": "389230",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bakor",
            "Pincode": "389232",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kadana",
            "Pincode": "389240",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Diwada Colony",
            "Pincode": "389250",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Santrampur",
            "Pincode": "389260",
            "City": "Santrampur",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Deiol",
            "Pincode": "389310",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Derol R S",
            "Pincode": "389320",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Derol",
            "Pincode": "389322",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jantral Pm",
            "Pincode": "389325",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "389330",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalol P M",
            "Pincode": "389330",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahalaxmi Road",
            "Pincode": "389330",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vejalpur",
            "Pincode": "389340",
            "City": "Vejalpur",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Adadra",
            "Pincode": "389341",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Eral",
            "Pincode": "389342",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mehlol",
            "Pincode": "389343",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karoli",
            "Pincode": "389344",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Boru Bakrol",
            "Pincode": "389345",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vyasda",
            "Pincode": "389346",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sureli Vejalpur",
            "Pincode": "389347",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ambali",
            "Pincode": "389348",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "389350",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Halol",
            "Pincode": "389350",
            "City": "Halol",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kanjri Pm",
            "Pincode": "389351",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Baska",
            "Pincode": "389352",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranjitnagar",
            "Pincode": "389355",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pavagadh",
            "Pincode": "389360",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghogamba",
            "Pincode": "389365",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shivrajpur Mines",
            "Pincode": "389370",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "389380",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Devgadh Bariya",
            "Pincode": "389380",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dhanpur",
            "Pincode": "389382",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jambughoda",
            "Pincode": "389390",
            "City": "Godhara",
            "District": "Panchmahal",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Baranpura",
            "Pincode": "390001",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dandia Bazar",
            "Pincode": "390001",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jubilee Garden",
            "Pincode": "390001",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khanderao Market",
            "Pincode": "390001",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Madanzampa",
            "Pincode": "390001",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mandvi",
            "Pincode": "390001",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nagarwada",
            "Pincode": "390001",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Padmavati Chaugan",
            "Pincode": "390001",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara",
            "Pincode": "390001",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara",
            "Pincode": "390001",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhani Road",
            "Pincode": "390002",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fateganj",
            "Pincode": "390002",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pratapganj",
            "Pincode": "390002",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardarnagar Society",
            "Pincode": "390002",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Chemical Industr",
            "Pincode": "390003",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pratapnagar R S",
            "Pincode": "390004",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Pratapnagar",
            "Pincode": "390004",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Akota",
            "Pincode": "390005",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Alkapuri",
            "Pincode": "390005",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Sayajiganj",
            "Pincode": "390005",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Harni Aerodrame",
            "Pincode": "390006",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Santkanvar Colony",
            "Pincode": "390006",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Fetepura",
            "Pincode": "390006",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Subhanpura",
            "Pincode": "390007",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Race Course",
            "Pincode": "390007",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara E M E School",
            "Pincode": "390008",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sharadnagar",
            "Pincode": "390009",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara O N G C Colony",
            "Pincode": "390009",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Makarpura I E",
            "Pincode": "390010",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Manjalpur",
            "Pincode": "390011",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Atlardra",
            "Pincode": "390012",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Maneja",
            "Pincode": "390013",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Makarpura",
            "Pincode": "390014",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Vidyutnagar Colo",
            "Pincode": "390015",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gorva",
            "Pincode": "390016",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Ind Estate",
            "Pincode": "390016",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gendigate",
            "Pincode": "390017",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Panigate",
            "Pincode": "390017",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "S N Road",
            "Pincode": "390017",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Wadi",
            "Pincode": "390017",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "I D Hospital Road",
            "Pincode": "390018",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Kareli Bag",
            "Pincode": "390018",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodara Ajwa Road",
            "Pincode": "390019",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vaghodia Road",
            "Pincode": "390019",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sewasi",
            "Pincode": "391101",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chandkheda Society",
            "Pincode": "391105",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chandod",
            "Pincode": "391105",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Thuvavi",
            "Pincode": "391107",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Furtikui",
            "Pincode": "391108",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabhoi R S",
            "Pincode": "391110",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kaumudi Society",
            "Pincode": "391110",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadodari Bhaghol",
            "Pincode": "391110",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sathod",
            "Pincode": "391111",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sinor",
            "Pincode": "391115",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sisodra",
            "Pincode": "391116",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tilakwada",
            "Pincode": "391120",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadarpur",
            "Pincode": "391125",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mankni",
            "Pincode": "391126",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhatpur",
            "Pincode": "391130",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bodeli",
            "Pincode": "391135",
            "City": "Bodeli",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karali",
            "Pincode": "391136",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nana Amodra",
            "Pincode": "391137",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kosindra",
            "Pincode": "391140",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chalamali",
            "Pincode": "391141",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kadachhala",
            "Pincode": "391142",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sankheda",
            "Pincode": "391145",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Parvata",
            "Pincode": "391146",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naswadi",
            "Pincode": "391150",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tanakhala",
            "Pincode": "391151",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gad Boriad",
            "Pincode": "391152",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jabugam",
            "Pincode": "391155",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tejgadh",
            "Pincode": "391156",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Moti Amroli",
            "Pincode": "391157",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pavijetpur",
            "Pincode": "391160",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhota Udepur",
            "Pincode": "391165",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "391165",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Panvad",
            "Pincode": "391168",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rangpur Z",
            "Pincode": "391169",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kawant",
            "Pincode": "391170",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kadipani",
            "Pincode": "391175",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kandari",
            "Pincode": "391210",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kayavarohan",
            "Pincode": "391220",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mandala",
            "Pincode": "391230",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Miyagam Karjan",
            "Pincode": "391240",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarar",
            "Pincode": "391241",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Varnama",
            "Pincode": "391242",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Por",
            "Pincode": "391243",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Choranda",
            "Pincode": "391244",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Miyagam",
            "Pincode": "391245",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sadhli",
            "Pincode": "391250",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bajwa",
            "Pincode": "391310",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "391320",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Southern Township",
            "Pincode": "391320",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Koyli",
            "Pincode": "391330",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nandesari I E",
            "Pincode": "391340",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Township",
            "Pincode": "391345",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Petrochemical",
            "Pincode": "391346",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Petrofils",
            "Pincode": "391347",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranoli",
            "Pincode": "391350",
            "City": "Ranoli",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhaili",
            "Pincode": "391410",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Masar Road",
            "Pincode": "391421",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mobhu Road",
            "Pincode": "391430",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Padra",
            "Pincode": "391440",
            "City": "Padra",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabka",
            "Pincode": "391441",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mujpur Padra",
            "Pincode": "391442",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chokari",
            "Pincode": "391443",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ranu",
            "Pincode": "391445",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karakhadi",
            "Pincode": "391450",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadu",
            "Pincode": "391460",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jarod",
            "Pincode": "391510",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Samlaya R S",
            "Pincode": "391520",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sandasal",
            "Pincode": "391530",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vejpur",
            "Pincode": "391535",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhani",
            "Pincode": "391740",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sokhada",
            "Pincode": "391745",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Colony",
            "Pincode": "391750",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vagholia",
            "Pincode": "391760",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Savli Town",
            "Pincode": "391770",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gothda",
            "Pincode": "391773",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Desar",
            "Pincode": "391774",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tundav Savli",
            "Pincode": "391775",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadarwa",
            "Pincode": "391780",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gajera",
            "Pincode": "391810",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kahanva",
            "Pincode": "391815",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Piludra Gajera",
            "Pincode": "391816",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadach",
            "Pincode": "391817",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kareli",
            "Pincode": "391818",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bharuch",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "City",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Civil Lines",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gayatri Nagar",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hajikhana Bazar",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Katopore Bazar",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lallubhai Chakla",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mohmadpura",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Panch Fanas",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sindhvai",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Super Market",
            "Pincode": "392001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bharuch Society Area",
            "Pincode": "392002",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jhadeshvar",
            "Pincode": "392011",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Zadeshwar",
            "Pincode": "392011",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Muktampur",
            "Pincode": "392012",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tavra",
            "Pincode": "392013",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jhanor",
            "Pincode": "392014",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Narmadanagar",
            "Pincode": "392015",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dayadra",
            "Pincode": "392020",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pariej",
            "Pincode": "392021",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Samni",
            "Pincode": "392025",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Buva",
            "Pincode": "392026",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Shukaltirth",
            "Pincode": "392030",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nikora",
            "Pincode": "392031",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarbhan",
            "Pincode": "392035",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tankan",
            "Pincode": "392040",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amod",
            "Pincode": "392110",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Achhod",
            "Pincode": "392111",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mia Matar",
            "Pincode": "392115",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dahej",
            "Pincode": "392130",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vagra",
            "Pincode": "392140",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jambusar Bazar",
            "Pincode": "392150",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Uber",
            "Pincode": "392153",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kora",
            "Pincode": "392155",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karmad",
            "Pincode": "392160",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Manubar",
            "Pincode": "392161",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kantharia Bharuch",
            "Pincode": "392162",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tham",
            "Pincode": "392163",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pakhajan",
            "Pincode": "392165",
            "City": "Nadiad",
            "District": "Kheda",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kavi",
            "Pincode": "392170",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarod",
            "Pincode": "392180",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nabipur",
            "Pincode": "392210",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palej",
            "Pincode": "392220",
            "City": "Palej",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ikhar",
            "Pincode": "392230",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tankaria",
            "Pincode": "392240",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valan",
            "Pincode": "392310",
            "City": "Vadodara",
            "District": "Vadodara",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ankleshwar R S",
            "Pincode": "393001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Goya Bazar",
            "Pincode": "393001",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ankleshwar I E",
            "Pincode": "393002",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "O N G C Ankleshwar",
            "Pincode": "393010",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Andada",
            "Pincode": "393016",
            "City": "Andada",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Avidha",
            "Pincode": "393017",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Diva",
            "Pincode": "393018",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sajod",
            "Pincode": "393020",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Matied",
            "Pincode": "393021",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Selamba",
            "Pincode": "393025",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hansot",
            "Pincode": "393030",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dediapada",
            "Pincode": "393040",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sagbara",
            "Pincode": "393050",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhalod",
            "Pincode": "393105",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sayar",
            "Pincode": "393107",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jhagadia",
            "Pincode": "393110",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dharoli",
            "Pincode": "393111",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajpardi",
            "Pincode": "393115",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umalla",
            "Pincode": "393120",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Deheli",
            "Pincode": "393125",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Netrang",
            "Pincode": "393130",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valia",
            "Pincode": "393135",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pratapnagar Nandod",
            "Pincode": "393140",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palace Road",
            "Pincode": "393145",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rajpipla",
            "Pincode": "393145",
            "City": "Rajpipla",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "393145",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vadia Colony",
            "Pincode": "393145",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lachhras",
            "Pincode": "393150",
            "City": "Rajpipla",
            "District": "Narmada",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kevadia Colony",
            "Pincode": "393151",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gora Colony",
            "Pincode": "393155",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota Varachchha",
            "Pincode": "394101",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Utran P H C",
            "Pincode": "394105",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kim",
            "Pincode": "394110",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nani Naroli",
            "Pincode": "394114",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Panol",
            "Pincode": "394115",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kosamba R S Bazar",
            "Pincode": "394120",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tarsadi",
            "Pincode": "394120",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hathuran",
            "Pincode": "394125",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sayan",
            "Pincode": "394130",
            "City": "Sayan",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bodhan",
            "Pincode": "394140",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kathor",
            "Pincode": "394150",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sonifalia",
            "Pincode": "394150",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ghala",
            "Pincode": "394155",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mandvi Surat",
            "Pincode": "394160",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Godsamba",
            "Pincode": "394163",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tadkeshwar",
            "Pincode": "394170",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kamrej",
            "Pincode": "394180",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kamrej Char Rasta",
            "Pincode": "394185",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kholvad",
            "Pincode": "394190",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Udhna",
            "Pincode": "394210",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Udhnagam",
            "Pincode": "394210",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Baroda Rayon",
            "Pincode": "394220",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pandesara I E",
            "Pincode": "394221",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sachin",
            "Pincode": "394230",
            "City": "Sachin",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Lajpor",
            "Pincode": "394235",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karchelia",
            "Pincode": "394240",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naldhara",
            "Pincode": "394241",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vaheval",
            "Pincode": "394242",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umra",
            "Pincode": "394243",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahuvaria",
            "Pincode": "394244",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Zervavra",
            "Pincode": "394245",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahuva N",
            "Pincode": "394250",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hajira",
            "Pincode": "394270",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chalthan",
            "Pincode": "394305",
            "City": "Chalthan",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gangadhra R S",
            "Pincode": "394310",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Palsana",
            "Pincode": "394315",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Baleshwar",
            "Pincode": "394317",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sevni",
            "Pincode": "394320",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umbhel",
            "Pincode": "394325",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vav Kathodra",
            "Pincode": "394326",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kadodara",
            "Pincode": "394327",
            "City": "Kadodara",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Orna",
            "Pincode": "394330",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kadod",
            "Pincode": "394335",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Madhi",
            "Pincode": "394340",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota",
            "Pincode": "394345",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarbhon",
            "Pincode": "394350",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Puni",
            "Pincode": "394352",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Varad",
            "Pincode": "394355",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kakrapar",
            "Pincode": "394360",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bedkuvadoor",
            "Pincode": "394363",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Unchamala",
            "Pincode": "394364",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Raniamba",
            "Pincode": "394365",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nijhar",
            "Pincode": "394370",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Uchhal",
            "Pincode": "394375",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadbhuja",
            "Pincode": "394378",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kukarmunda",
            "Pincode": "394380",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Velachha",
            "Pincode": "394405",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota Miya Mangrol",
            "Pincode": "394410",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mosali",
            "Pincode": "394421",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vankal",
            "Pincode": "394430",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Zankhavav",
            "Pincode": "394440",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umarpada",
            "Pincode": "394445",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhatha",
            "Pincode": "394510",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fertilizernagar Tribhco S",
            "Pincode": "394515",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Variav",
            "Pincode": "394520",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mor",
            "Pincode": "394530",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Olpad",
            "Pincode": "394540",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dumas",
            "Pincode": "394550",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bardoli H Q",
            "Pincode": "394601",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sardar Bag",
            "Pincode": "394601",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sugar Factory",
            "Pincode": "394601",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vankaner Bardoli",
            "Pincode": "394620",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Buhari",
            "Pincode": "394630",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gadat",
            "Pincode": "394631",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pati",
            "Pincode": "394632",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valod",
            "Pincode": "394640",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vedachhi",
            "Pincode": "394641",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kanpura",
            "Pincode": "394650",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "394650",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vyara",
            "Pincode": "394650",
            "City": "Vyara",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kapura",
            "Pincode": "394655",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Central Pulp Mills",
            "Pincode": "394660",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fort Songadh",
            "Pincode": "394670",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Cenral Colony",
            "Pincode": "394680",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ukaidam",
            "Pincode": "394680",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "W C Colony",
            "Pincode": "394680",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bajipura",
            "Pincode": "394690",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kos",
            "Pincode": "394690",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ahwa Dangs",
            "Pincode": "394710",
            "City": "The Dangs",
            "District": "The Dangs",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Subir",
            "Pincode": "394716",
            "City": "The Dangs",
            "District": "The Dangs",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Saputara",
            "Pincode": "394720",
            "City": "The Dangs",
            "District": "The Dangs",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Waghai",
            "Pincode": "394730",
            "City": "The Dangs",
            "District": "The Dangs",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Illav",
            "Pincode": "394810",
            "City": "Bharuch",
            "District": "Bharuch",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Athwalines",
            "Pincode": "395001",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gopipura",
            "Pincode": "395001",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Govt Medical College",
            "Pincode": "395001",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surat Nanpura",
            "Pincode": "395001",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surat Sagrampura",
            "Pincode": "395001",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Inderpura",
            "Pincode": "395002",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khatodra",
            "Pincode": "395002",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Putli",
            "Pincode": "395002",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rustompura",
            "Pincode": "395002",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sagrampura",
            "Pincode": "395002",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surat Textiles Market",
            "Pincode": "395002",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Agnovad",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhagal",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhavanivad",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bombay Market",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "City",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jhampa",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mahidharpura",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Muglisara",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navabwada",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pegampura",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Saiyedpura",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Salabatpura",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surat",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Variavi Bhaghol",
            "Pincode": "395003",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surat Katargam",
            "Pincode": "395004",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "395005",
            "City": "Anand",
            "District": "Anand",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surat Rander",
            "Pincode": "395005",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surat Varachha Road",
            "Pincode": "395006",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Athwa",
            "Pincode": "395007",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Goddod",
            "Pincode": "395007",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surat S V R College",
            "Pincode": "395007",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surat A K Road",
            "Pincode": "395008",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vastadevdi",
            "Pincode": "395008",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Surat Navyug College",
            "Pincode": "395009",
            "City": "Surat",
            "District": "Surat",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Azad Chowk",
            "Pincode": "396001",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chhipwad",
            "Pincode": "396001",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota Bazar",
            "Pincode": "396001",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Railway Station",
            "Pincode": "396001",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valsad",
            "Pincode": "396001",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tithal",
            "Pincode": "396006",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valsad Sugar Factory",
            "Pincode": "396007",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Atul",
            "Pincode": "396020",
            "City": "Atul",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bamti",
            "Pincode": "396020",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tiskari",
            "Pincode": "396025",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Hanuman Bhagda",
            "Pincode": "396030",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhadeli Jagalala",
            "Pincode": "396031",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Valsad I E",
            "Pincode": "396035",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khergam",
            "Pincode": "396040",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Achhavani",
            "Pincode": "396041",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vad",
            "Pincode": "396042",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Atgam",
            "Pincode": "396045",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dharampur",
            "Pincode": "396050",
            "City": "Dharampur",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ambatalat",
            "Pincode": "396051",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ronvel",
            "Pincode": "396055",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rumla",
            "Pincode": "396060",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nani Vahial",
            "Pincode": "396065",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bilpudi",
            "Pincode": "396068",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bhilad",
            "Pincode": "396105",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bigri",
            "Pincode": "396110",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Zaroli",
            "Pincode": "396112",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kolak",
            "Pincode": "396115",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khatalwada",
            "Pincode": "396120",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Damnizumpa",
            "Pincode": "396125",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Killapardi",
            "Pincode": "396125",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nana Pondha",
            "Pincode": "396126",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mroli Sanjan",
            "Pincode": "396130",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Nargol",
            "Pincode": "396135",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Phansa",
            "Pincode": "396140",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kalgam",
            "Pincode": "396142",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Pardi Paria",
            "Pincode": "396145",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Snjan",
            "Pincode": "396150",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sarigam",
            "Pincode": "396155",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Manda",
            "Pincode": "396156",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Solsumba",
            "Pincode": "396165",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umargam",
            "Pincode": "396170",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umargam I E",
            "Pincode": "396171",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Umarsadi",
            "Pincode": "396175",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Udvada",
            "Pincode": "396180",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Udvada R S",
            "Pincode": "396185",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vapi",
            "Pincode": "396191",
            "City": "Vapi",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vapi I E",
            "Pincode": "396195",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Mota Pondha",
            "Pincode": "396201",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ambheti",
            "Pincode": "396202",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Daman",
            "Pincode": "396210",
            "City": "Daman",
            "District": "Daman",
            "State": "Daman & Diu"
        },
        {
            "PostOfficeName": "Daman",
            "Pincode": "396210",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Varkund",
            "Pincode": "396217",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Moti Daman",
            "Pincode": "396220",
            "City": "Daman",
            "District": "Daman",
            "State": "Daman & Diu"
        },
        {
            "PostOfficeName": "Moti Daman",
            "Pincode": "396220",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Magarwada",
            "Pincode": "396223",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Silvasa",
            "Pincode": "396230",
            "City": "Silvasa",
            "District": "Dadra & Nagar Haveli",
            "State": "Dadra & Nagar Haveli"
        },
        {
            "PostOfficeName": "Silvassa",
            "Pincode": "396230",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Naroli",
            "Pincode": "396235",
            "City": "Silvasa",
            "District": "Dadra & Nagar Haveli",
            "State": "Dadra & Nagar Haveli"
        },
        {
            "PostOfficeName": "Naroli",
            "Pincode": "396235",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Anklas",
            "Pincode": "396236",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karad",
            "Pincode": "396240",
            "City": "Silvasa",
            "District": "Dadra & Nagar Haveli",
            "State": "Dadra & Nagar Haveli"
        },
        {
            "PostOfficeName": "Karad D G P",
            "Pincode": "396240",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amli",
            "Pincode": "396245",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Amalsad",
            "Pincode": "396310",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Bilmora",
            "Pincode": "396321",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Desra",
            "Pincode": "396321",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "R S",
            "Pincode": "396321",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Antalia",
            "Pincode": "396325",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Endhal",
            "Pincode": "396340",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gadat",
            "Pincode": "396350",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gandevi",
            "Pincode": "396360",
            "City": "Gandevi",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kachchha",
            "Pincode": "396370",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kachholi",
            "Pincode": "396370",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dungri",
            "Pincode": "396375",
            "City": "Dohad",
            "District": "Dohad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Devsar",
            "Pincode": "396380",
            "City": "Devsar",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Untdi",
            "Pincode": "396385",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Aat",
            "Pincode": "396403",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Abrama",
            "Pincode": "396406",
            "City": "Abrama",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Alipur",
            "Pincode": "396409",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Borifalia",
            "Pincode": "396412",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Dabhel",
            "Pincode": "396415",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Gurukulsupa",
            "Pincode": "396418",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Jalalpore",
            "Pincode": "396421",
            "City": "Jalalpore",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kabilpore",
            "Pincode": "396424",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navsari Ih",
            "Pincode": "396424",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kaliavadi",
            "Pincode": "396427",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Kharee",
            "Pincode": "396430",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Maroli Bazar",
            "Pincode": "396436",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Matwad",
            "Pincode": "396439",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Karadi",
            "Pincode": "396440",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Khadsupa Boarding",
            "Pincode": "396443",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Malesar Navsari",
            "Pincode": "396445",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navasari",
            "Pincode": "396445",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Navsari Junathan",
            "Pincode": "396445",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Tarota Bazar R S",
            "Pincode": "396445",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Udyognagar",
            "Pincode": "396445",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Eru Agri College",
            "Pincode": "396450",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sadadvel",
            "Pincode": "396452",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Panar",
            "Pincode": "396460",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Sisodra Navsari",
            "Pincode": "396463",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Satem",
            "Pincode": "396466",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Ugat",
            "Pincode": "396469",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vedachha",
            "Pincode": "396472",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vesma",
            "Pincode": "396475",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Anaval",
            "Pincode": "396510",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Chikhli",
            "Pincode": "396521",
            "City": "Chikhli",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Degam",
            "Pincode": "396530",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Fadvel",
            "Pincode": "396540",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Rankuva",
            "Pincode": "396560",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Digendra Nagar",
            "Pincode": "396570",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vansada",
            "Pincode": "396580",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Vansola",
            "Pincode": "396580",
            "City": "Valsad",
            "District": "Valsad",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "Unai",
            "Pincode": "396590",
            "City": "Navsari",
            "District": "Navsari",
            "State": "Gujarat"
        },
        {
            "PostOfficeName": "A S D Mello Road Fuller Marg",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adam Stores",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adem Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amrut Keslav Naik Marg",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Maidan",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Banaji Cross Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Banaji Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhaucha Dhakka Ferry",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bohara Masjid Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bomani Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bori Bunder Bombay V T",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bread Market Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "British Hotel Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Butcher Island",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C R Path",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Campbell Park",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cannon Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Carnac Bridge",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Carnac Bunder",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Carnesy Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cawasji Patel Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chana Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dady Sheth Agiary",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Dadabhoy Nawroji Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dudh Gally",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dwarkadas Cross Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dwarkadas Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "E.N.T.Municipal Hospital",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Elphanta Island",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fort Market",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fort Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G T Hospital",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghoga Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gola Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gymnasium Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji S Musafarkhana",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hazarimanal Somani Marg",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hemji Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Henry Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hospital Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahapalika Marg C S Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangesh Shenoy Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manordas Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Market Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marutri Lane Street Galli",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Milk Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mint Back Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mody Cross Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mody Khana",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mody Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mole Station",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai Bazar Gate",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai Gpo",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai Ins Angre",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai Municipal Coro",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai National",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai New India Ins",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai Rustom",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai Vivesewwaraya W T",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murzaban Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Musafarklhana Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nadirsha Sukhia Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagar Chowk",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Napier Road Fort",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Modi Khana",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Modi Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Police Court Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P T M",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palton Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Perin Nariman Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pitha Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pitha Street Crpss Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Police Court Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prescott Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raghunath Dadaji Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rang Bhawan",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ravelin Street",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rustom Sidhaw Marg",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sabu Siddik Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saving Bureau",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sayed Abdulla Brelvi Rd",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shak Galli",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Share Bazar Old/New",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhwa Marg",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sir Phirozeshah Mehta Rd",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sprort Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Georges Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Store Lane",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Syed Abdulla Brelviroad",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tabake Pole",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tulloch Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "University Road",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Victoria Terminus",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "West End Watch Company",
            "Pincode": "400001",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adamji Pccibhoy Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agiari Lane 1St 29 To 35",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahrikant Pilekar Marg Son",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Alsi Patia",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anand Vihar Housing Soc",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anandilai Podar Mg 2To116",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anandwadi",
            "Pincode": "400002",
            "City": "Ashti",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anantwadi",
            "Pincode": "400002",
            "City": "Deoni",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Angre Wada",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Assembly Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Babu Genu Road Hanu. Kane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bada Mandir",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badamwadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bamanji Master Rd Sild Br",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Behram Baug",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagwan Kalyan Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhai Jivanji Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhang Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhaskar Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatia Co-Op Hsing Socety",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatia Mahaian Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhoiwada I Ii And Iii",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhuleshwar Road Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhuleswar Road",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bihari Baug",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bohara Masjid Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bomani Master Road",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cause Court",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cavel Cross Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cawasji Harmasji Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Champagalli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandan Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandan Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandra Chawk Lane 1To 8",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chapra Chawl",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chewool Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chhipi Chawl",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikhalwadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chira Bazar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chira Bazar Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Choksi Bazar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cutlery Bazar 226 Onwards",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D Galli Panchayat Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D S Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dabholkar Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadar Gully",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadv Sheth Agiary Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dady Santok Lane Chinabaz",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dagina Bazar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devkaran Nanji Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhus Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhus Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Doka Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Atmaram Merchant Road",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Babasaheb Jaykar Marg",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Cawasji Hormusji Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr M.B.Velkar Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Nagindas Shah Marg",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Vigas Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dubash Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dukkar Bazar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dwarkesh Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fish Market Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ful Galley",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaiwadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Wadi 1St & 2Nd",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaumukh Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gauraksha Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavli Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavli Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavraj Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gazdar Park",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gazdar Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Geeta Nagar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghadiyal Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gngaram Khatriwadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gopal Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gora Ram Mandir",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govandhan Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govind Chowk",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govind Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govind Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Green Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hamal Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Cross Lanes-Old",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Lanes",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hargovind Desai Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hemraj Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Herta Baixa",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "K M S St New Lohar Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "K S Marg Lohar Chawl",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kaivalyadham",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi Bharat Chamber",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi H O",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi Hindustan Cham",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi Jumna",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi Mumbadevi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi Paltan Rd",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi Phule Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi Ramwadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi Shroff",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi Small",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalbadevi Thakurdwar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapreshwar Mg T Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karel Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karim Park",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kavi Nirar Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Keerwadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kela Lane J Masjid",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Keshavbaug",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khan Estate",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khanderrao Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khansaheb Abdul K Chowk",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khara Kuwa",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khattar Ali No 1",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khattar Ali No 2",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khattar Ali1&2 Cross Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Drive No 80To100A N S R",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M J Market Cross Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M J Market Lane C G C L",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Narayanrao Koli Marg",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madam Cama Northern Side",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhav Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhavji Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhavraj Galli M J Marke",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahadev Shankar Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahadevbhai Desai Chawl",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahajan",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahajan Gully Mutter Gull",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharshi Karve Road Q R",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malharrao Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangaldas Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangaldas Road",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mani Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maniar Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marine Line Rly Station",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marine Lines",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Market Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maruti Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maruti Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marwari Bazar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matka Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mirchi Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mirchi Market Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mota Mandir Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Moti Bazar Sk Memon St",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mugbhat Cross Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mulji Jetha Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbadevi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbadevi Road",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai Cycle",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murarji Gokuldas Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nana Shankar Seth Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Chowk M J Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narottam Narayan Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawi Gally M J Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawi Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nemani Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Bhatia Mahajan Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Cutlery Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Phulgalli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Silk Bazat",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Sonapur Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Swadeshi Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Hanuman 1St & 2Nd Cro",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Phulgalli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Police Office Lane Ka",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oval Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oval Wadi Kalbadevi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parmanand Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patak Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patak Wadi Road",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patwa Chawls",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Popat Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pragraj Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R C Mama Path No2To28",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R S Sapre Marg",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ravji Jetha Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ropa Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S Gandhi Marg",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S K Patil Gardens",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sancha Galli M J Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Santtok Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saraf Bazar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satta Bazar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shami Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shamshet Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shankar Bari Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sheikh Menon Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sheikh Mistri Daragh",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shekhade Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sheth Moti Pachan R S Mar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shrivardham Chowk",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sir Vithaldas Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sitaram Poddar Road Fanas",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonapur Cross Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonapur Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonapur St Cross Lane 1&2",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonapur Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sorbji Santok Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sri Krishna Calli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Francis Xavier Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunder Chowk",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sutar Chawl",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swadeshi Market Mg Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tad Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tak Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tel Gali",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tel Galli",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tel Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Trikamji Ghila Marg Old K",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Trimbak Vaidya Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Trinity Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vankka Mohalla",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vasant Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vijaywadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Violim Market",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithaldas Road",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalwadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithoba Lane",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wagh Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wellington Street",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zaoba Wadi",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zaveri Bazar",
            "Pincode": "400002",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abdul Rehman St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abheechand D. Gandhi Marg",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agiari Cross Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agiari Lane 1St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agiari Lane 2Nd 31 To 33",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agiari Lane 3Rd",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Attar Gulli",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bangdi Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bapty Road South",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bapu Hajam Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bapu Khote Cross Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bapu Khote Street Jamli",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bara Imam Road",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barbhai Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bardangalli",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bengalipura",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhajipala Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandari Cross Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bibijan Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bohara Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Brigadiar Usman Marg E R",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chakla Street Cross Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chhas Mohalla Kambekarstr",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chimna Butcher Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chindi Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chor Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cooper Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cutchi Memon Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cutlery Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Daryastan Galli",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ds S",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dsouza Street Cross Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Duncan Cross Road 2Nd",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ebrahim Mohmed Merchant Road",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ebrahim Rahimutulla Road",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Essaji Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ful Galli",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Furniture Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Garibdas Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavli Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghatigalli",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghogari Baug",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghogari M C Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghogari Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gora Mohall Khambekar St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gujar Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "H H A Baar Corss Lane No1",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "H H A Baar Corss Lane No2",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "H H A Baar Marg-Ghogari",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hajai Mohall",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ibrahim Mohmed Merchant",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ibrahim Rahimattalla Road",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Isaji Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ismail Katre Cross Road",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ismail Katre Road",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kariana Bazar Samuel St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasai Mohalla Chinma B St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasai Mohalla Nagdevi St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kavit Galli Memon Wada Rd",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kazi Savad Street 26-223",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kazi Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khalasichakla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khand Bazar Kazi Sayed St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khara Kuwa 1 Agiary Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khara Tank Raod 12-103",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khoja Steet Bara Imam Rd",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khoja Street Corss Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khokha Bazar Sarang Stree",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Shaukat Ali Rd 1To137",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Machhi Bazar Abdul R S",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahakali Chawl",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandvi B P Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandvi H O",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandvi Masjid",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandvi Noorbag",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandvi Null Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandvi Vadgadi",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mapla Market",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid St X Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matka Galli",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Memon Mohala Kambekar St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Memonwada Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Memonwada Rd",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Memonwada X Lane 13To92",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mewa Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mewawala Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Milk Bazar Ali Umar St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mirchi Street 11To87",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mirza Street Mandvi",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mistry Mohalla Ali U St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mochigalli Bhendi Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohmed Ali Rd 1-111/2-102",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mudi Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbadevi Rd",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murga Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mutton Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nabi Ulla Road",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagdevi Cross Lane 1To102",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagdevi Street Nos 1To305",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nakhuda Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nakhuda Street Nos 1To9",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Namda Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Dhuru Cross Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Dhuru St 1 To 163",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayanrao Koli Marg Bhan",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Bardan Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Bengali Pura No 134",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Kasai Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Kazi St Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nizam Street Cross Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nizam Street Parsi Galli",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Null Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Bengalipura 1 To 57",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Kasai Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pakmodia Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsee Gally",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsee Panchayat Rd J M M",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pinjara Gali",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pydhonie",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raghunath Maharaj Strrt",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rangari Mohalla",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadaia Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saifee Jubille Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saifi Jubilee Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samuel Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarang Street Khokha Baza",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sardar Vallabhbhai Patel",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sattar Koliwada Bhandari",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sheriff Devji St Chaka St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sir Ibrahim Rahimtulla Rd",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sukhlaji Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Surti Mohalla Cross Lane",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sutar Bazar",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tamba Kanta",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tawa Lanea",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Vithaldas Chardan St",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vijay Vallabh Chowk",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithaldas Chandan Street",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yacoob Coachman Galli Mem",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yakoob Galli",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yusuf Meher Ali Road Masj",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zanda Galli Old Nagpada",
            "Pincode": "400003",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akkolkot Lane 1 To 3",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Alankar Cinema",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amar Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambawadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amroli Church",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amrutwadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Angrewadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Annasaheh Shinde Marg",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aradhana Hotel",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ardeshir Dady Cr. Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Awantikabai Gokhale St.",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bachani Nagar",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badam Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandu Gokhale Marg Cow Le",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bangad Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Benham Hall Cross Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandari Cross Le Girgaon",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandarwada",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhangi Galli",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatwadedar Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatwadi Lane 1St&2Nd",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhuleshwar Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Carpenter Street 1St&2Nd",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cattle Pound",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandewadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chatni Mohalla",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chaubal Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Congress House",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cooper Compound",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Darabshow Road Old Dubhas",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Diwadkarwadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Don Hatti",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Bhajekar Street",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Bhalerao Marg",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Bhatarvdekar Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr D.D.Sathe Marg",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Dadasaheb Bhadkamkar M",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Deshmukh Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Mitrasen G. Mahimture",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Subash Cross Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Wilsen Street",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Wilson Street",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dubash Lane 1St & 2Nd",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Duncan Rd Cross Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Durgadevi Street",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Durgadevi Udyan",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G V D P Chowk",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaigali",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaiwadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girgaon Ambewadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girgaon Chanpati",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girgaon Charni Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girgaon H O",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girgaon Housing Society",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girgaon Madhavbag",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girgaon Opera House",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girgaon S V Press",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Golpitha",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaonkar Building",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaonkar Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Government Central Press",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gulal Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hansraj Damodar Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hira Baug",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Islampura",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Islampura Cross Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapad Galli",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasar Galli Girgaon",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasturba Gandhi Chowk",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kennedy Bridge Gorgaon",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khadilkar Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khambata Lane Girgaon",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khatau Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khattar Ali Lane 1To52",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khemraj S K Das Mg",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khetwadi 12Th Cross Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khetwadi Main Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Shaukat Ali Rd 141To159",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhav Baug",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Magan Baug",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharshi Karve Marg",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mama Parmanand Marg",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangaldas Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mathew Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maulana A K A Rd Duncan R",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Morar Baug",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mudi Bazar",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mudi Bazar",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Multani Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N S Rd Taraporwala Acquar",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N S Road Govt Printing",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naaz Compound",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanubhai Desai Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nath Madhav Cross Patit",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nath Madhav Path Khattar",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navi Bhar Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawalkar Cross Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Bhatwadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Charni Rd R R Marg",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "North Brock Garden",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Post Office Lane Dr D",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oval Wadi Girgaon",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P Rd Even No56To64Oddno65",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P S No122",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padamsi Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padmgi Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panchayat Wadi Dawooji Cr",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandit B Buwa Bakhale Pat",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandurang Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandurang Wadi J S Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panjarpole Compound",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panjarpole Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panjarpole Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panjarpole Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paper Mill Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parekh Street",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parekh Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsee Wada Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parshuram Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pawwala Street",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pendse Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phadke Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimphalwadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Play House Corner",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Powwala Street/Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prarthana Samaj",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raja Ram Mohan Roy Marg",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rambaug",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramji Bhagwandas Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ranchoddas Kanji Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Round Temple",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Royal Opera House",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S V Sahani Path",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadaia Bazar",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadanand Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadashiv Street",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadashiv Street Cross Lan",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saidham Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samuntanand Anant H G C",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Sena Maharaj Marg",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Sena Marg Kumbharw S",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sardar Vallabhbhai Patel",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarkar Tabela Kranti Naga",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarvodaya Nagar",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Second Avenue",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shapur Bagh",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shapurji Bharuchla Girgao",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shenvi Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shree Sai Dhan Wadi Bapty",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Girijasankar Shankal",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Sadguru Kadam Baba L",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Sai Dhamwadi Duarts",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri V L Padnekar Marg",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sicca Nagar",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sind Merchantile Syndicat",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Galli Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sukhanand Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Suraj Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swadeshimills Estate Comp",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swami Narayan Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swami Samarth Nagar",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tara Bag Estate",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Gharpure Path",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Nagar",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Topiwala Wadi Lane",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tribhuvan Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Trimbak Parshuram Street",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Two Tanks",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Urankar Wadi",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "V P Road Police Station",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadilal A Patel Marg Proc",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalbhai Patel Road",
            "Pincode": "400004",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Afgan Church",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arthur Bandar Raod",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Nagar",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baghad Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bakery Lane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhora Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhutelo Camp",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bradys Flat",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Budhwar Park R O Colony",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cawasji Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Colaba",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Colaba Ashwini",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Colaba Bazar",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Colaba Cross Lane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Colaba Dandi Rd Crosslane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Colaba Dandi Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Colaba Dandi Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Colaba Holiday Camp",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Colaba South",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Coly 1St To 5Th Lane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Coly 5Th Cross Lane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Connaught Barracks",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cplaba",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cpt Prakash Pethe Marg",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dalmal Park",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dandi Colaba",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Homi Bhabha Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dubash Estate Lane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dumayne Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Duxbury Lane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Eqphrates Avenue",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fazal Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G D Somani Marg",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Lane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gun Carriage Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hamal Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Henekers Drive",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Holiday Camp",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Holiday Camp P O",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hormusjee Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khalashi Lines",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khatau Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Machhi Bundar",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Magdalla Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahadeo Churiwadi",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Major Vetri Nathan Cross",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Major Vetri Nathan Marg",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mande Lines",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maneckji Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manekji Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Middle Colaba Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Military Off Maha&Guj Are",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Minoo Desai Marg",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mogra Lane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mosque Lane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mukesh Mills Compound",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N A Sawant Marg",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanabhoy Moose Marg",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Napier Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Napier Road Colaba",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nathlal Parekh Mg No 48 1",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navroji Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navy Nagar",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawaroji Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Mala",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nowroji Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Observation Post",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandharinath L Patkar Rd",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandmanath Pail Marg",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pasta Lane 1 To 4",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pestonji Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prakash Pethe Marg",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R C Church",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raja Wadkar Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajmadhkar Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Robert Rd",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadhu Vaswani Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sasoon Dock",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahid Bhagat Singh Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Rambhau Salgaonkar M",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shroff Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Smt Indu Sakrikar Path",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Smt Indumatis Patel Marg",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sobani Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Solan Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sorab Bharucha Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sri Gawasji Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Summar Band",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunder Nagari",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Telway Line",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thomas Street",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tigris Road",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vanjar Galli",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Windy Hall Lane",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wodehouse Road 48 To 138",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Women Graduate Hostel Rd",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Women Graduates Union Rd",
            "Pincode": "400005",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Alexander Graham Bell Mag",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambewadi",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.G. Kher Marg Ridge Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bal Gangadhar Kher Marg",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Band Quarters",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Banganga Cross Lane",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Banganga Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagwandas Indrajit Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhau Saheb Hife Marg Mrpr",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bramhanacharya Akhada",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadv Sheth Agiary Lane",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dongarsi Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Bhagwanlal Indraji Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Vikram Sarabhai Bridge",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dusk Lane",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gibbs Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanging Gardens",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hill Park",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malbar Hill",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malbar Walkeshwar Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manav Mandir Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Dabholkar Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narsu Khatu Wadi",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nepean Sea Road L J Marg",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panchan Dhobighat",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pawai Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Petit Hall",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phirozshah Mehta Garden",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Powai Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rattilal R Thakkar Marg",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ridge Rd K",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rockey Hill",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rungta Lane",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sasoon Estates",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantaram Narayan Lane",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siri Road",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamichi Wadi",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Teen Batti",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thuthi Agiari",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tower Of Silence",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walkeshwar Cross Lane",
            "Pincode": "400006",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adenwalabaug",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Alibhai Premji Marg",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anandashram",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "August Kranti Mrg 8 To 19",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Awabai Petit Street",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Babulnath Cr. Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Babulnath Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badar Baug",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bai Awabai Petit Street",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bai Dinabai Petiti Street",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balaram Street",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balaram Wadi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bawan Khani",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhaji Galli",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bharat Nagar",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhaskar Bhau Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhau Bhaskar Wadi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhendi Galli",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bori Compound",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C B V Marg",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C P S Compound Proctor R",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C V Patel Marg",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chaupati Market",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chaupati Sea Face",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chunam Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Corner Of Grant Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadv Sheth Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dady Sheth Cross Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dady Sheth Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dambar Cross Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dambar Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dinbhai Petit Street",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Atmaram Ramachandra Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Dadasaheb Bhadkamkar M",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Gajanan D. Purandare M",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr N.A.Purandare Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr P.G.Solanki Path",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Erukshaw Hakim Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "French Bridge Low Level",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Frerc Bridge",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gamadia Colony",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gamdevi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gamdevi Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganga Das Wadi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gilder Tank Bldg",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Compound",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokuldas Tejpal Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaonkar Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaonkar Wadi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Grant Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Grant Road Bharatnagar",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Grant Road Nyayamurthi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Grant Road Shamrao V Marg",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hakim Wadi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harichandra Goregaonkar Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Holly Cross Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kavivarya B R Tumbe Chowk",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khan Bahadur A M I Bridge",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khar Shetji Rana Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M M Market",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maganlal Nagar",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahila Patel Agiary Stree",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mallam Market",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mama Varerkar Bridge S B",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maulana A C Marg-Chunam S",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Morvi Galli",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Motlabai St Lane Grant Rd",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Motlabai Street Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Muzafarabad Hall",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N S Patkar Mg 11To79",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nana Chowk",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasarwanjee Petit Street",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naushir Bharucha Marg",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naushir Bharucha Road S R",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ness Baug",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Netaji Subhash Rd No 12",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Chikhalwadi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Foras Rd S R Nimkar M",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Khareghat Colony",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nowroji Vakil Street",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Owendan Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P N Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandita Ramabai Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pannalal Terace",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patel Esate",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patharc K Samaj Chowk",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pawwala Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Play Hou Corner",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Proctor Cross Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raghav Wadi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sardar Vallabhbhai Patel",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Seaface Cross Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shakti Hall",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shamrao V Marg Old Kiln L",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shankar Seth Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sitaram Patkar Marg",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sleater Cross Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Small Nusserwangi Street",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonawalla Estate",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talmaki Wadi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tara Temple Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tejpal Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Teli Galli",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Telwadi",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Topiwala Lane",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tukaram Javaji Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Uandreya Street",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Uranwala Street",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vachha Gandhi Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wachha Gandhi Road",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zorostrain Colony",
            "Pincode": "400007",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adam Siddique Lane",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aga Khan Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmed Oomer Lane",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ali Umar St",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Allarkha Ibrahim Patel Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arab Tabela",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Awachitpada",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badlu Rangari Street",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barkat Ali Virahi Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bellasis Chawls Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Berkley Place",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bharat Lokhand Bazar",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhik Bazar",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhusari Mohalla",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bohari Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Maulana Azad Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Navjivan",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay New Nag Pada",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Byculla Club Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Byculla District Jail",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Calcuttawala Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Railway Staff Co",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chhota Sonapur",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikhalpada",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "China Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Choksi Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chouki Mohalla",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Christ Church Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chuna Bhatti",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dalal Estate",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Daruwalla Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dawood Baug",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dimtikar Rd Belhasisrdpar",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Anand Rao L.Nair Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Bhalerao Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Jawale Wadi",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr K.A.Hamid Chowk",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Kashibai Navrange Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Mohamed Iqbal Chowk",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Duncan Cross Road 1St",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Faruk Omar Palk Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fatoo Sheth Tabela",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fitwalia Chawl",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghelabhai Street",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghosh Bazar",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gilder Lane",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Habib Flats",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Habib Park",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji Kasam Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hariyali Village",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hasrat Mohani Chowk",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hirji Govindji Estate",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Husseinee Baug",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Huzuria Mohalla",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapadwanj Wadi",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapidas Patra Chawls",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kazipura",
            "Pincode": "400008",
            "City": "Chopda",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kazipura Chowls",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khada Parsee",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khambata Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khanda Mohalla Mutton St",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandia Mohalla",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandia Street",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandia Street Cross Line",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Industrial Estate",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Mandir Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Mandir X Marg-Club X Rd",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Shaukat Ali Rd 92To138",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Macbeth Lane",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madanpura Byculla",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manaji Rajuji Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marzabad Colony",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mastan Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mastan Talao",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mastan Tank Cross Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mastan Tank Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maulana A K A Rd 1-122",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maulana A K A Rd 113-263",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maulana A X Road Ist",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Meghraj Sethi Rd",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhd U K Marg 2Nd X St Ii",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhd U K Marg Ist X St I",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhd U R Rd Mohmedean St",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhmd Taber A Rd Arab Lane",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mirza Galib Marg Clare Rd",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mody Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohd Ibra S Rd Old Nagpad",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohmd Shahid Rd Morland R",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Motibai St Buculla 24-34",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumsa Estate Marlan Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Municipal Block A B C",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murga Gnan Tabela",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagoo Savaji Wadi",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpada Police Station",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpada Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagri Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navjivan Co-Op Hsg Soc",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Dhobighat",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ojji Haines Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Nagpada",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P B Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P B Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandu Mali Adda",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parshuram P Cross Lane",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parshuram P Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsi Statue",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patel Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Peerkhan Street",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Play Hou Corner",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R S Nimbalkar Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rebseh Street",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Reserve Bank Quarters",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Reynolds Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rusi Mehta Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rusi Mehta Industrial Est",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sabrabadi Galli",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadi Bazar",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saeikh H Marg Sanklist",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Safia Zubair Rd",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sajan Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sankli Street Cross Lane",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sankli Tank Street",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shankar Puppala Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shcikh Bhuram Kamurdin St",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shepherd Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sir Jamshedji Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sofia Zubber Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sophia Zulhair Road Old S",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Spence Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Suleman Chowki",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Taher Ansari Marg",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Street",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Teli Moholla",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Temkar Moholla",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Temkar Street",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Trafalgar Square",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Two Tanks",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umar Rajali Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umer Jamal Compound",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umer Rajah Road",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Undria Street",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Undria Street Cross Lane",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Versova Street",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "West Bapty Road 153-593",
            "Pincode": "400008",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmedabad Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambedkar Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ardeshir Dady Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Argyle Cr. Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Babula Tank Cross Lane",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baburao Bobade Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bachoo Ali Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balu Changu Patil Marg",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baroda Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandari Bridge Latif Bld",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandup Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhat Bazar",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhau Saheb Surve Marg",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavnagari Mohalla81To120",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhimanji Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhimpora Dongri Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhisil Mohalla",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhuddha Temple Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhujwadi Mohalla Z M S",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Casac Siding Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinch Bunder H O",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Clive Cross Lane",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Clive Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D M Nishaanpada Rdno1To69",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dabda Galli Khadakstreet",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Damber Gulli",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dana Bunder",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devji Ratansi Marg Baorch",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dongri Cross Lane",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dongri Market",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dontad Cross Lane",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dontad Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Maheshwari Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dungri Muncipal Market",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ebrahim Mohmed Merchant Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Elphinstone Bridge Cross",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gamadia Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavani Galli",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gerulane",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Husenbhai Allibhai Veljee",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Immwada Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ismail Mohalla",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Itela Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapus Galli Tantanpura St",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Katha Bazar Narsi Nath St",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kazi Savad Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kesarbaug 2Nd Flank Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Keshavji Naik Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khadak Pydhoni Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharek Bazar N N Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khoja Mohalla",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhavrao Raokade Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahalaxmi Street Wadi B",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malet Bunder Chambhar Gdi",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malet Bunder Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mansion Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Market Bunder Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid Bridge Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid Bunder Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid Siding Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mavji Rathod Rd Valpakhdi",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Memonwada Road 1To8",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mirza Ali Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mochigalli Israel Mohalla",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Musafrkhana",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Najam Baug",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandalal Jani Road 1To131",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narsi Nath Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Bengali Pura N P Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Chinch Bunder Rd K N",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Dongari Market",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Ferry Wharf",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Noorbaug",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nowroji Hill Rd 1To12 11T",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oos Galli Sayyad Mukri St",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P D Mello Road 1To146",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P S K J H M 11",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P S K J H M-1",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pala Galli Sameul St",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palkhi Mohalla",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Poona Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Princess Dock",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pydhoknie Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raichur Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramchandra Bhatt Marg",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Russel Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S V P Rd",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahab Gally",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samantbhai Nanji Marg",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samrat Ashok Nagar",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samuel Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sandhurst Road Rly Statio",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Tukaram Road Argyl R",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sardar Vallabhbhai Patel",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sayed Mukri Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shak Galli",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shayada Marg Dongri St",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shelapur Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sherial Baug Babala Rank",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siddi Mehalla Tandal St",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Surat Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tantan Pura Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thana Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umerkhadi Cross Street",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umerkhadi Lane",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umerkhadi Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Valpakhandi Road",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vectoria Dock",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yusuf Meher Ali Road Masj",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zakeria Masjit Street 1-1",
            "Pincode": "400009",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aba Govind Marg Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aga Hall Compound",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Alcock Ashdownvard",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambewadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andhargalli",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Angir Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Atlas Mill Compound",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.I.T. Blocks 1 To 16",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.I.T. Chawls - Mazgaon",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.P.T. Chawls Reay Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.P.T. Chawls W.Br. 1 To6",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baker Lane",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balwant Sing Dodi Marg",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barister Nath Pai Marg",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandarwada Reservoir",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Boat Hard Road Mazgaon",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Brahman Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C B Road Rose Cottage Rd",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Carpenter Street 1St&2Nd",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Ralway Chawls",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chimnaji Ranoji Lane",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chuna Bander",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chunarethi Bunder",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Church Street",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Clarke Bunder Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Coal Bunder",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Copper Smith Street",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Darukhana Lanes",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dawood Ismail Compound",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devidayal Compound",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhosabhai",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dlima Street",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dockyard Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dockyard Road Cross Lane",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dolkar Street",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Leela Melville Marg",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Mascarenhas Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr N.Singh Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganga Bawdi Police Line",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganga Bawdi Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gun Powder Rd Cross Lane",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gun Powder Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Han Cock Bridge",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harish A Palay Marg",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hasnabad",
            "Pincode": "400010",
            "City": "Jamkhed",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hilal Building",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hospital Lane",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Husain Patel Marg",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hutatma Dattarambhau Marg",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irani Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasala Street 1 To 4",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasam Mistry Compound",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasar Galli C M Street",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasara Basin Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasara Bundar",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasara Gate",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasara Street 1 To 4",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharwa Galli",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Machhiwala Compound",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Magazine Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharana Pratap Chowk",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mankeshwar Temple",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maoji Rathod Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mapla Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maruti Lane",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mascarnes Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matar Pakhady",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Match Factory Lane",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matharpakhady Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matharpakhady X Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mazagaon",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mazgaon Dock",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mazgaon Docks",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mazgaon Pier",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mazgaon Rd 1To99 S C Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mazgaon Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mazgaon Terrace",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mazgaon Vikrikar Bhavan",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mazgaon-Dockyard",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mody Compound",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mustafa Bazar",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Muzavar Pekhadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Muzavarpakhady Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nariel Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nashbit Hall",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nathani Street Yard",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navanagar",
            "Pincode": "400010",
            "City": "Guhagar",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawab Tank Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naya Nagar",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Darukhana",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Irani Chawals Compoun",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Reay Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Tank Bunder Rd Old 52",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nowland Street",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Sita Path Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P D Mello Road Frere Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padmani Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Power Works Street",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prem Estate",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Quarry Street",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Railway Siding Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rambhau Bhogale Marg",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rangwala Galli",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Reti Bunder",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rose Cottage Lane",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakar Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakar Wadiound",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sand Bunder",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Savta Marg Low Level",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saradar Balvant Singh D M",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Savlya Tandel Chowk",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sethna Hall Compound",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shamji Moraiji Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivdas Champsey Marg M R",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shroff Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Singal Hill Avenue Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sitaphal Wadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonapur Galli",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Annes Church",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Mary Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Surya Kunj",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sutar Gally",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Synat Hill Avenue Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tadwadi Wadi B It Chwls",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Bunder Road",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tara Bag",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tik Bunder",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Timber Market",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tukaram Bhisaji Koyande M",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tukaram Bhogale Marg",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tulsiwadi",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Tanaji Malusare Marg",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Victoria Cross Lane 1St",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadi Bunder Shed",
            "Pincode": "400010",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agripada",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agripada Jacob Circle",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arthur Road Prison",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balamiya Lane",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bapurao Jagtap Coly. Road",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bazar Galli",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C G Ganacharya Chowk",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinchpokli",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinchpokli West",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chor Wadi",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Anandao Nair Road",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr E.Mozes Road",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Farook Oomerbhoy Path",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh H P Marg",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gell Street",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghas Bazar",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gulabrao Ganacharya Chowk",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hainse Road",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hukmill Galli",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jacob Circle",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Keshavrao Khadye Clerk Rd",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madanpura J Circle",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhavrao Gangan Path",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahalaxmi Bridge",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maruti Galli",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid Galli",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Milk Street",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Moosa Killedar Street",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Municipal G Ward Office",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Musa Killcdar Street",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N M Joshi Marg",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N M Joshi Mg 280 To 569",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pais Street",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Red Cross Street",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S Amar Shaikh Marg",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sane Guruji Marg",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Gadge Maharaj Chowk",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Ganganath Maharaj Ch",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shakti Mils",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shakti Mils Lane",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shakti Nagar",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantinagar",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shastri Nagar",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Souter Street No 6;8&10",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhashnagar Jacob Circle",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunder Lane",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunderdas Milk Compound",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Pakhadi Street",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Pase Village",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tatya Saheb Ghodke Chowk",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Water Street",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Y M C A Road",
            "Pincode": "400011",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adam Mistry Lane",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adenwala Compound",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aimai Merwanji Street",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambedkar Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anant Malvankar Path",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anantwadi",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arunodaya Colony",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Babasaheb Abdr. Rd. Cr.Ln",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baliwala Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Batliwala Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bawla Wadi",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagwantrao Parelkar Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhalekars Adda",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhoiwada Parel",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhoiwada Road 7 To 60",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Buddha Temple",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C Rly Workshop",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Railway New Block",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chamar Bang",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chamar Baug",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Char Lane",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chor Lane",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadabhoy Chamarbagwala Rd",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Damodar Thakersey Hall",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dattaram Lad Marg Hindmat",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Babasaheb Ambedkar Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Batliwala Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Compound",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr S.S.Rao Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Shirodkar Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Elphistone Market",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G D Ambekar Marg",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Galli",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganpat M N Marg",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Garam Khada",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gas Company Lane",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghogachi Wadi",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghokhale Cross Lane",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Park",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Soc Cross Lane",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Soc Lane",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govindji Kenird",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Islam Mill Compu4Ound",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Katradevi Ayashat Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M V Donde Marg",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madke Bawa Chowk P Circle",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahadeo Wadi",
            "Pincode": "400012",
            "City": "Ambegaon",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahadev Palav Marag C R",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahadev Palav Marg",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manji Shet Wadi",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Meghwadi",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naigaum Road No 16",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naigaum Road No 9",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nare Park",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "National Library Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navroj Baug",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Back Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Best Staff Qrt",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Chamarbag",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Haffkin Institute",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Lalbaug",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Naka",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Raoli Camp",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Rly Workshop",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Station Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Village",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parel Village Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parmanand Wadi",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patel Esate Marg",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathan Adda",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ratan Tata Trust Colony",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sane Guruji Marg",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sanitory Hill Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Santaji Maharaj J C",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shapurji Palonji Compound",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirodkar High School",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Parmar Gurji Orad Ch",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sitaram Adda",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Xavier Street",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Colony",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tauri Pada",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Turner Hill Road",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vaishali Nagar",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wagheshwar Wadi",
            "Pincode": "400012",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adhyuru Industrial Estate",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balshet Madurkar Mg",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bara Chawls",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Delisle Ephinstone Road",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Delisle Road",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fitwalia Road 1 To 8",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G I P Store Lane",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Nagar Zopadpatti",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gangaram Kamathi Chawls",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji Kasam Chawls Compoun",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Lane",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Nagar",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hari Baug",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ideal Industrial Estate",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indu Baug",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kashinath Dhuru Wadi",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kawali Compound",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khimji Nagji Compound",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhav Bhavan",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhavrao Palav Marg",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahalaxmi Industrial Est",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mathurdas Mill Compound",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Municipal G Ward Office",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N M Joshi Marg",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N M Joshi Marg Bdd No16",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N M Joshi Mg B D D Chawls",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N M Joshi Mg Delisle Rd",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nehru Nagar Delisle Road",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakhubi Mohite Marg",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sambaji Nagar",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Senapati Bapat Marg",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shambang",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar Zopadpatti",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivram Sheth Amritwar Ma",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Daji Tykaram Raut Ma",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sitaram Jadhav Coss Lane",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sitaram Jadhav Marg",
            "Pincode": "400013",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aimai Wadi",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arab Bunglow 95 Nm Cr Rd",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.D.D. Chawls No 1 To 23",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.J. Devrukhkar Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhoiwada Road 1 To 6",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Railway Quarters",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadar Colony",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadar Dadasaheb",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadar H O",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadasaheb P Rd Dadar Main",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahiwalkar Wadi",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dinshaw Master Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Babasaheb Ambedkar Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Dinshaw Dastur Wadi",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Dinshaw Master Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Ghanti Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Firdoshi Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Five Gardens",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokuldas Pasta Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govindji Keni Rd",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hindu Colony Lane",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hirajee Khetsi Wadi",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kery Patil Wadi Naigaum",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khareghat Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khetwadi Lanes 1To14",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khodad Circle",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M M G Sangrahalaya Marg",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhav Wadi",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madmadhavdas Pasta Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Jyotiba Phule Mar",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mancherji Joshi Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mathurdas Pasta Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Morachi Wadi",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naigaum",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naigaum Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naigaum Village",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Post Office Wadi",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsi Colony",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsi Colony Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsi Colony Scheme 60 61",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phalke Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Police Head Quarter",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S S Wagh Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shankar Abaji Palav Marg",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sir Bhalchandra Cross Rd",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sir Bhalchandra Road No 6",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sohrab Palau Kete Road Da",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Paul Church Street",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Road",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umrigan Wadi",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vakharia Wadi",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vincent Square Streets 1",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wakharia Wadi",
            "Pincode": "400014",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Acharya Donde Marg K.E.Rd",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agriwada",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Nagar",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.D.D. Chawls No. 5 To 16",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.P.T. Rly. Quarters",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Babachi Wadi",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhoiwada Hindu C",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bunder Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Burmah Shell Yard",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D G M P Sewri Wadala Esta",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fosbery Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gadi Adda",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji Bachooali Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji Bundar Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji M Muslim Cemetry",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hirji Baug",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hirji Govindji Estate",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M V Donde Marg",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Messent Road 1 To 4",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nakhawachi Wadi",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oil Depot Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P Thakre Kridangan Marg",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raoji Shojpal Chawals",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakharam Klanjekar Path",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Shiieshtha Cora K C",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Scheme 57 Siwri Wadala Rd",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sewri",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sewri Naka",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siwri B D D Chawls 5To16",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siwri Bunder",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siwri Cross Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siwri Fort Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siwri Koliwad Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siwri Station Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tambdi Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tokersay Wadi",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tokersey Jivaraj Road",
            "Pincode": "400015",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bai Padmabai Thakkar Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bal Govinddas Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bal Govinddas Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bapat Marg",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barafwala Lane",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhaganari Coop Housing Society",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagat Galli",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagoji Deer Marg P C Rd",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagwansing Coop.Hsg Society",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagwati Co-Op.Housing Society",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagya Nagar Co-Op Hsg Society",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhaskar Patil Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatia Co-Op Hsing Socety",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhivandkar Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bidiye Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bunder Lane",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Causeway Mahim",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chuma Bhatti",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Citizen Co Op Housing Society",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D M C",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dargah Mohalla",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dargah Street",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Darya Mohalla",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Dsilva Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Gajanan Dharmaji Dande",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Vaigas Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Vasant J.Rath Marg",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Feet Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fort Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghabraoo Paraira Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girgaonkarwada",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gopi Tank Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haldankar Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hirijee Assoo Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapad Bazar",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kataria Colony",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kedarmal Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kelwadi L J Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Keni Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Machhimar Nagar",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahalaxmi Co Op Hsg Socty",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim Bazar",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim Bazar Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim Cansway",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim East",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim East Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim Fort Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim H O",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim Hardinge",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim Kapad Bazar",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim Mobile P O No 3",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim Mori Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahim Senapati",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manmala Tank Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mary Nagar",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maynak Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mint Colony",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Miya Mohd Chotani Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohmed Chotani Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohmed Chotani X Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohmedawadi Panchpir Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mori Nagar",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Moti Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nathani Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nathushet Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nausherwan Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navjivan Co-Op Hsg Soc M",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nazir Ahmed Street",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Girgaonkar Wadi Trava",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P R",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padmabai Thakkar Rd Mahim",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palm Lands",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panchipirachi Wadi Mohd W",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandit Gunidas Marg",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandit J Buwa P Mg Harvey",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandit Satvalekar Mg M La",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parvati Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pendurkar Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pitale Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pitamber Lane",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pitamber Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Poonawala Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prakash Kotnis Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Ganesh Gadkari Chowk",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raut Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Reserve Bank Quarters",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadanand Kawli Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadanand Parulekar Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakharam Keer Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sanraswat Co Op Hsg Socty",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saraswat Hitwardhak Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarmalkar Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Senapati Bapat Marg",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Park",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Park 138-171-188",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Park Cross Rd No3",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Park Road No 5",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shyamnarayan Dubet Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sitadevi Temple Road",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Soonawalla Agiary Marg",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamigyan Jivandas Marg",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swatantrya Veersavarkar",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tadeshwar Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Taikal Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Takandas H Kataria Marg",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ultra Co-Operative Hsg So",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Unich Co Op Hsg Soc",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Savarkar Mrg",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Waity Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wanja Wadi",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Woolen Mills Lane",
            "Pincode": "400016",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agaswadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akli Pilli Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bangal Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chamda Bazar",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chiniwadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chuna Bhatti",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dharavi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dharavi Koliwada",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dharavi Road",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhorwadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Ambedkar Cross Road",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghas Bazar",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Illi Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Katta Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kattiwadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khambadevi Road",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharana Pratapnagar",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangalal Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manji Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohmmed Labbay Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mukund Nagar",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pal Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajashree Shahu Nagar",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramar Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samrat Ashok Marg",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Val Miki Mandir Marg",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sattar Happa Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Seth Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Social Nagar",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonapur Road",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Takiya Ward",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Transit Camp Ambedkar Nag",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Transit Camp Nehru Nagar",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Transit Camp Ramabai Naga",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Transit Camp Saibaba Naga",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Transit Camp Sambhaji Nag",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "V K Krishna Menon Road",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Valakatta Wadi",
            "Pincode": "400017",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Acharya Arre Chowk",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Acharya P.K.A.Road Warli",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aluminium Quarters",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambedkar Nagar",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.D.D.Chawl C.Rd.1 To 121",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.D.D.Chawl Road",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.G. Kher Road",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baba Saheb Worlikar Chowk",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagoji Waglunare Marg",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhau Saheb Desai Wadi",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr A.B.Road",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Anne Besant Roadd",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr E.Mozes Road",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr G.M.Bhosle Marg",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Film Nagar",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "400018",
            "City": "Desaiganj (Vadasa)",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganpat J Marg",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganpatrao K Marg",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hornby Vellard Road 5To13",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khan Abdul Gafar Road",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Parade",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maulana A G Rd M Parade",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Worli Road",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Police Camp Rd",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S Balawant Mehta Marg",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S L Matkar Marg",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sardar Vallabhbhai Patel",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivram Amritwar Marg Old",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sidharth Nagar Zopadpatti",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sudam Kalu Ahir Marg",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli B D D Chawls",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Colony",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Hill Estate",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Jail Road",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Naka",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Point",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Road",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Road No 10 To 11",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Sea Face Road",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Sluice Road",
            "Pincode": "400018",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adenwala Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akola Wadi",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.N. Maheshwari Udyan",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandarkar Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhau Daji Cross Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhau Daji Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavanji Arjun Khimiji M",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Brahman Wada",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C Rly Workshop",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandawakar Cross Lane",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandawakar Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Custom Quarters",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cutchi Lohanwadi",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D V Pradhan Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deodhar Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Babasaheb Ambedkar Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G V Scheme",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Baug",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gujar Wadi",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "H R Mahajani Marg Matunga",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hira Buva Gawde Marg",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indian Gymkhana Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahilashram Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matunga",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matunga Bazar Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matunga Rd Arrora Cinema",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matunga Rly Workshop",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Napoo Gadens",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Napoo Gardens Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P U U B",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patiwala Chawls",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R P Masani Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rafi Ahmed Kidwai Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saraswat Colony Matunga",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Seth Bhawandas Narott. Rd",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharddhanand Cross Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharddhanand Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sir Bhalchandra Rd Plot",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "South Indian Gyir Khana R",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Telang Crosds Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Telang Road",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vachharaj Lane",
            "Pincode": "400019",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ayakar Bhavan",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barrack Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Church Gate",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Church Gate Central Buildings",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Church Gate Reclamation",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cinema Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cross Madian",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cross Madian Cross Rd No3",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cross Madian Cross Rd No4",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devi Ahilyabai Holkarchow",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dinshaw Mulla Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dinshaw Wachha Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "E.Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "F.Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road W S",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marine Lines",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marine Lines 1St X Lane",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marine Lines X Rd No 1&2",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N C C Barracks",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N S Rd 103 To 159 M Drive",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narube Street",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nathibhai Thakersey Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oval Maidan Ground",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S N D T Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sir Dineshaw Mulla Road",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sir Vithaldas Thackarsey",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunderbai Hall",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Nariman Rd",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithaldas Thakarsy Marg",
            "Pincode": "400020",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Advent",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ameeta",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Areadia",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Atlanta",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bajaj Bhavan",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bajaj Road",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Band Stand",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Becon",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhaktawar",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bonv Vista",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bora Bazar Street",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cooperage Football Ground",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cooperage Telephone Excha",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Earnest House",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Embassy Centre",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Express Towers",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Firozara",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Bhavan",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hoeshest House",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "I N S Saliars House",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ivanhone",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karmveer Bhaurao Patil Mg",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra Pradesh C C",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra State Lawns",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharshi Karve Road Q R",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Phule Bakward C",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Raj Guru Marg",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mittal Chamber",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mittal Court",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mittal Tower",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N C P A",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nariman Bhavan",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nariman Oberoi",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nariman Point",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Council Hall",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nirmal",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oberoi Hotel Towers",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P V M Gymkhana",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pay & Accounts",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prerma Premises",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Queens Barracks",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Recent Chamber",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Reheja Centre",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Reheja Chambers",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarang",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shakala",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sheraton",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shimpoli Corpn Of India",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Kunj",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Stusa Premises",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunite",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Suruchi",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Union Bank Bhavan",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidhan Chowk",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wood House Road",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yogakshema P O",
            "Pincode": "400021",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adivasi Janata Colony",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agra Road",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambika Nagar",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anand Nagar",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arar Wada",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandarwada",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhoslewadi",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Co Op Housing Soty",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Causeway Road",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Labour Institute",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Training Institute",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Comrade Harbanslal Marg",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D S High School",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Eastern Express Highway Road",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Cloth Market",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govt Quarters",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gujrat Hsg Society",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Guru C Dardi Marg Loop Road",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hindu Cemetry Road",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharani Lamibai Chowk",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra Govt Hsg Sty",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road S C",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Citizen Bank Colony",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Owners Colony",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pardeshi Co Opp Hou Socie",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R Q K R/B/Iii 3To7",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raoli Camp",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raoli Hill",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samrat Ashok Bridge",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar Zopadpatti",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sien",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sien R S",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sien Transit Camp",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sind Seva Samiti Nagar",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Colony",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sion Bridge",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sion Causeway",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sion Circle",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sion Fort",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sion Housing Society",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sion Matunga Estate",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sion Railway Quarters",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sion Rd Uptoto King Circl",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sion Station Road",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Soubhani Co Op Hsg Soc",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Co-Operative Hsg Sty",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Nagar",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Transit Camp 1 2 & 3",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vishram Wadi",
            "Pincode": "400022",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambalal Doshi Marg H. St.",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ash Lane",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bank Street",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bell Lane",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Cycle",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Samachar Marg",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Burjorji Bharucha Marg",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dalal Street",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr V.B.Gandhi Marg",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Green Street",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gungate",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Homi Modi Cross Street",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Homi Modi Cross Street N1",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Homi Modi Cross Street N2",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Homi Modi Street",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Horniman Circle",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hutatma Chowk",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indian Naval Dockyard",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road E R",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marine Street",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Museum",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagiadas Master Rd",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagindas Master Road",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagindas Master Road",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanabhoy Lane",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Homi Modi St Bruce St",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oak Lane",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Custom House",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ropewlk Street",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rutherfield Road",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Stock Exchange",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tamrind Street",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Town Hall",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Nariman Rd",
            "Pincode": "400023",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Air India Building",
            "Pincode": "400024",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nehrunagar",
            "Pincode": "400024",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nehrunagar Kurla",
            "Pincode": "400024",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adarsha Nagar",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amar Nagar",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Appasaheb Marathe Marg",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aspali Colony",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.K. Dhuru Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.P.T Colony",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandu Baug",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barkat Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bawan Chawls",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Beach House Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Beach Road",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagwandas Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhajipala Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhat Nagar",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Centuary Mills New Chawls",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Champawadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chapsi Dharsiwadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chimnabaiwadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devji Dharshiwadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhun Mill Naka",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr N.B.Parulekar Marg",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dsilva Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fakir Shet Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G Chavan Chowk",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganpat Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaonkar Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavhankar Wadi Prabhadivi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Rd South",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gopal Nagar",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harmon Mohata Compound",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hathishar Bang",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hirve Guruji Marg",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapidas Compound",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kashinath Dhuru Khar Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kawli Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khajurbhat Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khatau Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Labour Camp",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahakali Nagar Zopadpatti",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahalaxmi Nagar Zopadpati",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manker Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Modern Mill Estate",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Municipal Labour Cairp",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Municipal New Colony",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murari Ghag Marg",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagoo Sajee Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagwekar Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Churi Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Khari Zopadpatti",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nardulla Tank Road No 18",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nariman Road Prabhadevi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nariyal Wadi Prabhadevi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Neighbourhood Area U A An",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Govt Hsg Coly Shivaji",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Municipal Chawls",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Prabhadevi No 7 179",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nnariman Bhat Nagar",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Prabhadevi Rd 65&Onwa",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P Baloo Marg Sayani Road",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padri Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palkhi Wadi Galli",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandurang B Mg Globe Mill",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parampujaya J Maharaj Rd",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsi Bakery Compound",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pasco Louis Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patil Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pawaskar Zopadaptti",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pednekar Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phalke Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pochkhanwala Road",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Police Camp",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Police Camp A To Z",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhadevi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhadevi Century Mills",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhadevi Cross Lane",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhadevi New",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhadevi Road",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhadevi Road 1 To 130",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhadevi Worli",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhadevi Worli Sea Face",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ragho Muley Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramade Wadi Prabladevi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S V Mhatre Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadanand Khada",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sanira Marg Cleaveland R",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satya Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shapurji Palonji Compound",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar Worli",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shroff Market",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shroff Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Colony Prabhadevi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Nagar",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sluice Road Clearland Rd",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Standard Mill Lane",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swatantrya Marg",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swatantrya Veersavarkar",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Todankar Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "V B Worlikar Marg",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vasudeorao B Worlikar Mar",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Savarkar Mrg384-502)",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithoba Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadachi Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Waigankar Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walbhat Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Koliwada Village Rd",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Worli Village",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yadhav Patel Wadi",
            "Pincode": "400025",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baba Saheb Dahanukar Marg",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhhnnagar",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhulabhai Desai Road",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Byramji Gamadia Road",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cumballa Hill Road",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cumbatta Hill",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Gilder Compound",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Gopalrac Deshmukh Marg",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Gopalrao Deshmukh Marg",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr M.S.Prabhu Chowk",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Rajabali Patel Road",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Shahir Gali",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gamadia Road",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghas Galli",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji Ali Darga",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hermitage Road",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Income Tax Colony",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasam Ali Jivarajwadi",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kashmir Galli",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khari Bavdi",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M L Dahanukar Marg C R",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mafatlal Park",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahalaxmi Temple Lane",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mount Petit",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nowroji Gamadi Cross Lane",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nowroji Gamadi Road",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padam Takri",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajabjai Patel Road",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahar Gally",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satebhoy Karimji Barodawa",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Silver Oak Estate",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sofia College Road",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Somerset Lane",
            "Pincode": "400026",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "A G Pawar X Lane No 1&2",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abdul Hamid Ansari Chowk",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baburao Jagtap Marg",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatia Nagar",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandi Bazar",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cork Road",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D K C M Sussex Rd Towards",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D K C Rd Aister Road",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D K Marg",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Babasaheb Ambedkar Road",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr E.Mozes Road",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "E.S.Patanwala Marg",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Garden Bridge Road",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gloria Church",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gold Mohur Market",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gold Mohur Mills",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gujar Bazar Lane",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gujari Bazar Lane",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hansraj Lane",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harish Palay Lane",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indu Sakrikar Rath",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khambata Lane Gardens",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khambata Lane V Gardens",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maratha Plague Hosp Compo",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maruti Lane",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Meherpada Chawl Street",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Moti Shah Rd 121To199",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N M Joshi Marg",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N M Joshi Marg 1St & 2Nd",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N M Joshi Mg 570 To 699",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N Umaji Bhalinge Marg",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawab Wadi",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New 52 Chawls V Gardens",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rustom Baug",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Savatha Path",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Savatha Path Cross L",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Savta Marg Victoriar",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Seth Motisha Lane",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tukaram Bhisaji Kadam Mar",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ulster Road",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Byculla Bhaji Bazar",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Jija Mata Bhosley Ud",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Mata Jijabai Bhonsle",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Victoria Cross Road",
            "Pincode": "400027",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abrawadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adarsha Co-Op Housing Society",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agar Bazar",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agar Bazar Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akshikar Street",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambikawadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anant Patil Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anantwadi",
            "Pincode": "400028",
            "City": "Deoni",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Apte Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arjun Khot Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashok Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Atmaram Kawilwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baburao Parulekar Marg",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bai Padmabai Thakkar Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bai Padmabai Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bal Govind Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bale Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandarwada Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandarwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatachi Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatwadikar Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Gokhale Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani N S Bureau",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Ranade Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Sawarkar Marg",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Shankar",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Shankar Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Shankar Roadnorth",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Shivaji Park",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhha Baiwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhikoba Waman Pathare M",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhujpujria Plot",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bolewadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borkar Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Britto Beni Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Buddha Chritianwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bude Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C W",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Co Op Hsg Society",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandhari Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandrakant Dhuru Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandrawadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chhabildas Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chonkar Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Churi Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "College Lane",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "College Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D D Thakarwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D L Vaidya Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D S B M Ash Lane Dadar Jo",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D Vachanalaya M Library Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadaji Haraji Street",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadar Cross Rd Compound",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadar Sorting Lane",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadasaheb Parulekar Marg",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dagdi Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Damodai Karanwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Damodar Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datta Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Denkavliwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devkulewadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhuru Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dias Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dnyan Mandir Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dnyaneshwar Mandir Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dongre Baug",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dpenna Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Dsilva Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr M.B.Raut Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr M.C.Javle Marg",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dsilva Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Eknath Balaji Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Express Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fernandez Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaiwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gajananpuri",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Peth Lane",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Wadi T P Lane",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaonkar Nagar",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gardinagar",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gharwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Cross Road 1 & 2",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gomeshwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaonkar Prem",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gulmodiwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji Abubakai Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji Aroon Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hamraj Bhaiya Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harbans Eadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harichandra Chauri Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harichandra Kawili Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harichandra M Patil Marg",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hedavkar Wadi No 1",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hedavkar Wadi No 2",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hetkari Mahajan Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hukumat Nagar",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasar Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kashinath Dhuru Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasturchand Mill Compound",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kavli Galli",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Keluskar Rd North & South",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kenniwadi S K Bole Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kewalram College",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khaja Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khoja Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M B Raut Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M C Javle Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M L Dhuru Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M N Kale Marg",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M R Dhuru Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhukar Kavli Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manoharbhaskar Kavli Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Margues Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marwari Chawls",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid Galli",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mayekarwadi N C Kelkar Rd",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhatre Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Miranda Wadi Vs Rd&Nck Rd",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mistry Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohan Dhuru Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Muizele Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mukarwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Municipal Cross Compound",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Municipal G Ward Office",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N B Kavlwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N C Kelkar Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanaji Dudha Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Jiwa Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Manik Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nardulla Tank Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narsikhoda Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawalkar Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Market",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nikam Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nunes Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Market",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Prabhadevi Rd 1To64",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P T C",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padhye Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padmabai Thakkar Rd",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palonji Sojpal Chawls",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parshuram Kavil Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pateil Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pawashar Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Popat Lal Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pragati Housing Ksociety",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Principal R S N M Kale Ma",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prof V S Agashe Path",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Purandare Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Puroshattam Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R D Davliwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R D Kavliwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R K Vaidya Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raghnath Jashi Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raichand Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajaram Dhuru Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajaram Keshav Vaidya Mar",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Krishna Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Maruti Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramade Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramchandra Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramdas Dharnamdas Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramu Shet Adda",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rao Bahadur G K Bole Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rath Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raut Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ray Murzcllo Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Reserve Bank Quarters",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rodrique Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rozaria Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ruby Mills Lane",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rukmini Baug",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ruzaru Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S K Bole Road",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadanand Churi Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadanand Thakur Rd",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahakar Nivas",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sanzgiri Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarpachi Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sate Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Savitribai Chowk",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Senapati Bapat Marg",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sham Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shankar Chanckar Marg",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantikunji Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharma Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Park",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Park Road No 122",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Park Telephone Ex",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Simichi Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Standard Gardens",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Steny Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Suleman Maniyar Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunder Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Surve Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Suryavanshi Kshatriya Mrg",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swatantrya Veersavarkar",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thakar Mistri Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thatte Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Bridge",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Upendra Nagar",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Usha Housing Society",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "V S Agashepath",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vaidyawadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vajreshwari Wadi Only Dat",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Savarkar Mrg238-383)",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithal Raklumaichi Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalwadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walbhat Wadi",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Western Rly Bridge Dadar",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Western Rly Station Dadar",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Woolen Mills Lane",
            "Pincode": "400028",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Air India Staff Colony",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Air Workers India",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arvindnagar",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bijli Co Op Housing Society",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bomani Baug",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Salset Trunk Road",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinch Pada",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Collavery Village Road",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Firdosh Building",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govind Nagar",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govt Quarters Kalina",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hiralal Shroff Wadi",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indian Airlines Quarters",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Nagar",
            "Pincode": "400029",
            "City": "Chandvad",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Military Camp Road",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Military Camp Santa Cruz",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbai Aerodrum",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P & T Colony Vakola.Oad",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Park Bay",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajendra Singhji Road",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantiniketan",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shastri Nagar",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yogiraj Ashram",
            "Pincode": "400029",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pgms Office",
            "Pincode": "400030",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Antop Hill",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Nagar",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.G. Mahajani Path",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fort Road",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Futka Talav",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G Dambekar Road",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govari Village",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Katrak Road",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khada Matunga",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matunga Cross Road",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naigaum Cross Rd",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nathlal M Paresh Mg Matun",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pratap Nagar",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R A K R No 11To44",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Scheme 57 Siwri Wadala Rd",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sewari Wadala Scheme Rd",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siwri Cross Road Part",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siwri Wadala Road",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Road",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadala",
            "Pincode": "400031",
            "City": "Arvi",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadala Best Bus Depot",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadala Katrak Rd",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadala Kidwainagar",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadala Road",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadala Village",
            "Pincode": "400031",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Elphinstone College",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "High Court Buildings",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M L A Hostel",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madam Cama Road",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahamahopadhyaya Dr K M",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mantralaya",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mantralya Secretariate",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N C C Buliding",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Administrative Bldg",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Secretariate",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Secretariate Bldg",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P W D Building",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sachivalaya Gym",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "University",
            "Pincode": "400032",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abhvudaya Nagar",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambewadi Popat Shets Chaw",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Avenue Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barister Nath Pai Mg R.Rd",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Boat Hard Road Tank Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Conon Mill Estate",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Brick Bunder",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chuna Bhatti",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Coal Bunder",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cotton Exchange",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cotton Green",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dattaram Lad Path Kalecho",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dinshaw Petit Marg",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dock Labour Board Colony",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Babasaheb Ambedkar Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "E.S.Patanwala Cross Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "E.S.Patanwala Marg",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fer Bundar Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "First Avenue",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Forsbery Road West",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Framji Avenue",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G D Ambedkar Marg",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haybundar Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hutatma Shrikant Hedkar",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ibrahim Patanwalla",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Keshavrao Laxman Borkarmg",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharastra Hsg Board Buld",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Messent Road Tank Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New 52 Chawls Tank Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pappaiva Adda",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Quarr Street",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R K Buldings",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rambhau Bhogale Marg",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raoji Shojpal Chawals",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samarth Hanuman Path",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sanas Wadi",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sewri Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shyam Yeswany Chowk",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Singal Hill Avenue",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sir Purushootadas Thakurd",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Siwri Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Bose Gally",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Lane",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Bunder Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Cotton Exchange",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Kala Chowki",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Lalbahadur Shastri",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Reay Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Road",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Third Avenue",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tukaram Bhisaji Kadam Mar",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Tanaji Malusare Path",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadi Bang Colony",
            "Pincode": "400033",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Approach Road",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arya Nagar",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Awabai Kashinath Road",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Banjibhai Rathod Road",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bapurao Jagtap Marg M.Brg",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Body Guard Lines",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chhaktewadi",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Commerce Centre",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Falkand Bridge",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Film Centre",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gamadia Comp",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hestic Road",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kashinath Road",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahalaxmi Race Course",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Main Avenue",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manekji Petit Mills Comp",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Body Gaurd Lines",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathe Baboorao M",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ratan Tata Road",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Royal Western India Turf",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahakar Nagar",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sane Guruji Marg",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tarde0 Road",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Colony",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tatan Tata Road",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tulsiwadi",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tulsiwadi Haji Ali",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tulsiwadi Road",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vatsalabai Desai Chowk",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vellard View",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadia Street",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wellington Sports Club",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Western Rly Cement Chawls",
            "Pincode": "400034",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raj Bhavan",
            "Pincode": "400035",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raj Bjavan Compound",
            "Pincode": "400035",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "A K Marg",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "August Kranti Maidan",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "August Kranti Marg Rest",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ben Nevis Compound",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhulabhai Desai Road",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bomani Park Road",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cumballa Sea Face",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dady Sheth Hill",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Darabshow Road",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dinshaw Compound",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Gopalrao Deshmukh Marg",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dungarwadi",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Forject Hill Cross Lane",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Forjeet Hill Road",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govalia Tank",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kemps Corner",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N S Patkar Mg Huges Rd",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P Road",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Papanas Wadi",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raghaji Road",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Setalwad Road",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shankar Rao Naran Path",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sheri Bawdi",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sitaram Patkar Marg 1-8-9",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Taj Building Compound",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Warden Road",
            "Pincode": "400036",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Acharya Atre Nagar",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adinath Co-Op Housing Society",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anand Nagar",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Antop Hill",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Antop Hill B P T Colony",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Antop Hill Road",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Atlas Mills",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barkat Ali Darga Salt Pan",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhimwadi",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Govt Staff Colony",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Govt Ware House",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandani N",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Nagar Zopadpatti",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govt Quarters",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Himmat Nagar Zopadpatti",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hindustan Nagar Zopadpatt",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Major Hemant Manjrekar M",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mukundrao Ambedkar Marg",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nadkarni Marg",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Punjabi Camp",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangam Nagar Zopadpatti",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sanjay Hutments",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sardar Nagar Sion Koli Wa",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sheikh Mistri Road",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivshankar Zopadpatti",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Trombay Road",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vijay Nagar Zopadpatti",
            "Pincode": "400037",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ballard Estate",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ballard Pier",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Calicut Street",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cochin Street",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Currimbhoy Road",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fattar Bandar",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gamadia Road",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goa Street",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hughes Dry Dock",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Dock",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Dock Blue Gate",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Dock Red Gate",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Dock White Gate",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Dock Yellow Gate",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karimbhai Road",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kelkar Wadi",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manglore Street",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mody Bunder",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narottam Murarji Marg Dou",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nowroji Furdunji Road",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Custom House Rd S B R",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P D Mello Road",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahid Bhagat Singh Road",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shoorji Vallabhdas Marg",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Surj Vallabhdas Marg",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Viju Kotak Marg",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walchand Hirachand Marg",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Water Police Line",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Western Rly Goods Depot",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Western Rly Workers Colon",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "White Gate",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wilson Road",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yellow Gate",
            "Pincode": "400038",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Accomodation Road",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Apollo Reclamation",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barrow Road",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Battery Street",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C S M Road",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Causeway Colaba",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Convent Street",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cooperage",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Council Hall",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cusrow Baug",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Shamprasad Mukarji Cho",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G J Bhosle Marg",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Garden Road",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gate Way Of India",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahakavi Bhushan Marg",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahapalika Sabagriha Marg",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandlik Road",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mereweather Road",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nathlal Parekh Marg Old W",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oliver Road",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ormiston Road",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Chandani Marg",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samuel Street",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Stevens Street",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tajmahal",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walton Road",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wellington Gardens",
            "Pincode": "400039",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navjivan",
            "Pincode": "400040",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar",
            "Pincode": "400043",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "V P Road",
            "Pincode": "400046",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vivekanandnagar",
            "Pincode": "400046",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vileparle R S",
            "Pincode": "400047",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irla",
            "Pincode": "400048",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "A B Nair Marg",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adiabad Estate",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Asha Colony",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "400049",
            "City": "Dhamangaon Railway",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bal Mandir Marg",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barfuwala Marg Juhu Lane",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinoy Colony",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Coelho Wadi",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Gram",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaothan",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaothan Lanes 1St & 2Nd",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gulmohar Rd",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Juhu",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangal Wadi",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nair Wadi",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nazir Wadi Jahu",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nehru Nagar",
            "Pincode": "400049",
            "City": "Kankavli",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "North South Road 7 To 13",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandya Lanes",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rising Son Co-Opp Society",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Royal Turner Road",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangeeta Apartments",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tara Village",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Theosphical Colony",
            "Pincode": "400049",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anthoney Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anxilium Convent Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Housing Society",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badam Wadi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Band Stand",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Band Stand",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandar Wadi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandra Bazar",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandra Hill",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandra Roads",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Behram Nagar",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhabha Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Boran Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bullock Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Byramji Jijibhoy Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cane Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Carmi Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Carter Cross Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Carter Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandrabala Estate",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chapel Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chimbai",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinch Wadi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Church Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Convent Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dabholkar Wadi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhondopant Ramji Vavaskar",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dmonte Park Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dmonte Street",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Domnic Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Dmonte Wadi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr V.Raghunath Marg",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Francis Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Godabavdi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gonsalves Wadi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Guru Nanak Udyan",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji Mohined Noor Lane",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hill Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hill Road Cross Lane",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ice Factory Lane",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irani Estate",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Itethaka Nagar",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kantwadi Old & New",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khilkhite Wadi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madam Wadi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhavrao Savant Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mala",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mala Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malapakhadi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mang Lane",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maulana Baba Lane",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohmed Noora Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mora Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Moth Mawli St Mary Church",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Motiram Patel Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mount Carmel Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mount Mary Cross Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mount Mary Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "National Library Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawapada Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Kant Wadi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Turner Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P P Dies Compound",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Bandra Road Bandra",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Hill",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Hill Cross Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Hill Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Market Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Mela Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Pathar",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Village",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pareiva Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathar Blocks",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pereira Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Perry Cross Rd/Lane",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Perry Rd",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Peter Dias Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Princess Avenue Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prof Almeda Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prof Almeda Udyan",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R V Patkar Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajan Village/Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Mandir Marg",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramchandra Drishnaji P Mr",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ranwar",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rao Bahadur V B Marg",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rebello Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rock Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadhu Vaswani Park",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sai Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sajana Lane",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samant Chowk",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarkar Bawdi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sebastine Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sherly",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sherly Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sherly Village Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shree Kadeshwari Mandir M",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Gurunak Road Turner",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Krishna Chandra Marg",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Narayan Daji Samant",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Narayandas Dayabhai",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shrisadashiv Ganesh Joshi",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Slaughter House",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Somnath Lane",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Andrews Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Anthony Road Bandra",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Cyril Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Domenic Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Francis Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St John Baptista Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St John Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Leos Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Martin Cross Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Martin Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Mount Carmel Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Mourica Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Paul Cross Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Paul Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Peter Dias Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Peter Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Roque Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Sebastian Colony",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Sebastian Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Tyrit Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road Bandra",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamivivekanda Rd",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Blocks",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Town Planning Scheme No3",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Transit Camp",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vasudevarao Bambardekar M",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veronica Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalbhai Patel Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Waroda Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zigzag Road",
            "Pincode": "400050",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abmedabad Exp Highway Bandra",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amrut Nagar",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badra East",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandra Stn Road",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Behram Pada",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Behram Pada Road",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavisha Nidhi Bhavan",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dalit Hitavardak Hsg Society",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dipak Wadi",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Eksar Madian",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Golibar Road",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govt Colony",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Road",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Husani Tekdi",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khernagar",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kherwadi",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kherwadi Raod",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M I G Colony",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra Housing Baord",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandhar Compound",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marshalling Yard",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Middle Income Group Colo",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasim Baug",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Prem Baug",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nirmalnagar",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nirmalnagar Road",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P W D Quarters Colony",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patrakar Nagar",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pipe Line",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Mandir Road",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahakar Marg",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saibaba Road",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saibaba Tekadi",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantaram Bhat Chawls",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantilal Compound",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sidharth Colony Pandra E",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sidharth Nagar",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Francis Avenue",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Nagar",
            "Pincode": "400051",
            "City": "Kankavli",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Road",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Teachers Colony",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Three Bunglows",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tin Bunglow",
            "Pincode": "400051",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agripada Khar",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amar Gull Pathan Chowk",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambedkar Housing Colony",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambedkar Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amrut Co-Op. Housing Soc",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Carter Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chak Sahebachi Wadi",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chavri Galli",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinch Wadi",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chitrakar Dhurandhar Marg",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chuim Village",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dabul",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Danda Koliwada",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Danda Kotpada",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Danda Madhlapada",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Danda Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Danda Varinapda",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Danda Village",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dandapada Village",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datta Apte Bldg 1 To 4",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Babasaheb Ambedkar Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Forman Nagar",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Garden Homes",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govindji Patel Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govt Hsg Colony",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gujrat Hsg Society",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gujrat Research Society",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gujrathi Harijan Hsg Soc",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gulab Nagar",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Nagar",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khar",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khar Colony",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khar Danda",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khar Gaothan",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khar Market",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khar Pali Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khar Road 1 To 22",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhla Pada",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhu Park",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahadeo Bawa Dandekar M",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mari Aai Temple Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maru Aaidevi Mr Dandapada",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Monkey Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Municipal Colony",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Pali",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Sherlay",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Khar",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Bandra Road Khar",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Hill Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parmanand Co Opp Hou Soci",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parmanand D H Rd",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patel Pada",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathare Prabhu S Hou Soci",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pitale Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Drishna Mission Marg",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Krishna Mission Ashra",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Mandir Road Khar",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Road No 1To 35 Khar",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Nirmaladas Gurbaxani",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Housing Society",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Smt Maherbanu Jhabuwall",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamivivekanda Rd",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "T.P.S. Road No 16To913",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "U P Nagar",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Union Park",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalbhai Patel Road",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zhabwala Chowk",
            "Pincode": "400052",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "State Bank Colony",
            "Pincode": "400053",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andrews Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anjir Shopping Centre",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arun Bazar",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bajaj Wadi",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Beasant Street",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bindu Shopping Center",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Birlawadi Juhu",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Collage Co Op Soty",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Flying Club",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Avenue",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chapel Lane",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chuna Bhatti",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Church Avenue",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Convent Avenue",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cottage Lane",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Croft Lane",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadabhoy Cross Lane",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dattatraya Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "East Gross Lane",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fabrican Industrial Estat",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Francis Avenue",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Gram Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gazdar Scheme",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghatkopar Colony",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gujar Lane",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hansraj Wadi",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Nagar",
            "Pincode": "400054",
            "City": "Chandvad",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indranarayan Street",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irish Park",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kerala Nagar",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Main Avenue",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Meerabaug",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N V Marg Azad Rd Koliwada",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navjivan Co-Op Hsg Soc",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "North Avenue",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Police Lane",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phirozshah Mehta Garden",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phirozshah Road /Street",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Railway Quaraters Scruz",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Reserve Bank Quarters",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rose Lands",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ruia Park",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saibaba Lane",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sanraswat Co Op Hsg Socty",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Santacruz West",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saraswat Colony Santacruz",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saraswati Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarojini Naidu Road S Cru",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Senipuri Market",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahaji Raje Marg",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharadchandra Chatarji Ma",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharatchandra Chatterjee",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shastri Nagar",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shopping Centre Sai Bazar",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shree Industrial Estate",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Smt Hiraben V Desai Marg",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Alosous Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Andrews Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Joseph Avenue",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road Santacruz",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Supper Bazar",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamivivekanda Rd",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tagore Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talmaki Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Upasana Lane",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vaikunthbhai Mehta Marg",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vallabhbhai Patel Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Baji Prabhu Deshpand",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalbhai Patel Road",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithaldasnagar",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wellington Colony",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "West Avenue",
            "Pincode": "400054",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmedabad Exp Hwy S.Cruz",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Air View Building",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ajagarali Compound",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anandnagm",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aram Co-Op Housing Soc",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Augustin Wadi",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.E.S.T. Quarters",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatia Glass Coumpound",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bimlesh Compound",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bulsory Road",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bulsory Wadi Colony",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datta Mandir Road Vakola",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dauri Nagar",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhuru Nagar",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dmello Compound",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaodevi",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Golibar",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Golibar Road",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govt Quarters",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hasnabad Lane 1 & 2",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Nagar",
            "Pincode": "400055",
            "City": "Chandvad",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandwala Compound",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madras Zopadpatti",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masjid Road",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumabai Wadi",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nariel Waid S C East",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nehru Road Santacruz East",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nehrunagar S Cruz East",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Agripada",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Railway Quarters",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Philip Wadi",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pipe Line",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhat Colony",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pratiraksha Nagar",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Private Road",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pusalkar Wadi",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rd No 1 To 12",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Santacruz East",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Santacruz Rly Statiom Col",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Santacruz Road No 1 To 12",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Santacruz Vakola",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sen Nagar Rly Colony",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Senapati Bapat Marg",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sevasadan Road",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantinagar",
            "Pincode": "400055",
            "City": "Chamorshi",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shastri Nagar Santacruz E",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sidharth Nagar",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tobela Road",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vaishali Camp",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vakola Bridge",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vakola Pipe Line",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vakola Road",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vijay Nagar",
            "Pincode": "400055",
            "City": "Miraj",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vinsilva Nagar",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vivekarandnagar",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Waghri Wada Vakola",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeshwant Nagar",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yoga Institute",
            "Pincode": "400055",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ansari Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bajaj Cross Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bajaj Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bajaj Road Co-Op. Hg. Society",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baptista Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Beasant Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagat Singh Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Church Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadabhoy Cross Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadabhoy Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dashrathlal Joshi Road Juhu",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavthan Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gowalia Tank Cross Lane",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gulmohar Rd",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irla Gavthan Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irla Lane",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irla Passage Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irla Village",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandubhai Desai Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narsi Monji Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Juhu Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "North South Road 1 To 6",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Police Station Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P R",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pond Gavthan Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rashtriya Shala Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarojini Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Society Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "South Anthony Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "South Pond Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Anthony Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Brana Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Francis Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St John Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Mary Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Xavier Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Xavier School Raod",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swami Vivekananda Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vallabhbhai Patel Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vileparle Irla",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vileparle West",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalbhai Patel Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "West Gavthan Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Xavier High School Road",
            "Pincode": "400056",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agashe Lane",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ajamal Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anandibai Keskar M. Park",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andheri Sahar Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagwati Wadi",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhansali Wadi",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C P W D Quarters",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chemburkarwadi",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chhatrapati Shivaji Mrj M",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chittaranjan",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Church Pakhadi",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D P Co Operative Hous Soc",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dabholkar Wadi",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dayaldas Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dixit Cross Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dixit Extension Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dixit Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Domestic Quarters Airport",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "East Gavthan",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fernandez Street",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G I Marg",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Rd",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gomantak Co Op Hsg Soc",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gonsalve Street",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govind Co Op Hsg Society",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gulab Compound",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Cross Rd 1St&2Nd",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hira Baug",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Colony",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indolkar Marg",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ishwarlal Park",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karandikar Wadi",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karnik Wadi",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kartiki Co Op Hou Society",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahant Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malaviya Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandrekar Wadi",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Meterogical Office",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Misquitto Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mongibai Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanda Patkar Street",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narimnan Road Vileparle E",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navsamaj Co-Op Hsg Socy",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nehru Road Vileparle",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Netaji Subhash Nagar",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paranjape A S Rd No1Rcm",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paranjape A S Rd No1To3",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paranjape B S Rd No1To4",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Park Cross Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Park Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parle Colony",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parle Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parleshwar Co Opp Hou Soc",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phirozshah Mehta Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pitale Wadi",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Play Ground Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prarthana Samaj Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Mandir Road Vileparle",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramanand Co Opp Hou Socit",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rashmi Baug",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S Co Opp Hou Society",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahakar Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samant Wadi",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharddhanand Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shree Co Op H S C Soc",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Gangarambuva Indulka",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Nagar Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunderban",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swami Nityananda Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tejpal Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tejpal Scheme Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thanawala Lane",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Mandir Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Vidyalaya Road",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Usha Colony",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Makarand Ghanekar Ma",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidyanagari Marg",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vile Parle East",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vir Baji-Prabhu Deshpande",
            "Pincode": "400057",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abubakkar Zopadpati",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Albert Society",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amboli Hill Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amnoli Pada Hill",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andhar Society",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andheri Azad Nagar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andheri H M P School",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andheri Market",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andheri Plot",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andheri Rly Station",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andheri Rs",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andheri West",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andhonchiwadi",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ansari Moholla",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aradhana Society",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Asha Wadi",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Avinash Housing Society",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Lane",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Nagar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Road Andheri Wast",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.M.C. Compound",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bakul Co-Op. Housing Society",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baliwala Hill",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bank Of India Colony",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barbiwala Marg",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhadra Wadi Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bharada Wadi",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavsa Wadi",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cama Road Andheri",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ceaser Road 1To40",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chacha Nagar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Char Banglow",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chunawala",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadabhoy Navrojinagar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadabhoy Navrojinagar Rd",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadabhoy Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dawood Baug",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dawood Baug Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fidar Baug",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Four Bungalow",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Frank Dmello Compound",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Garden Colony Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavdevi",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavdevi",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavdevi Zopadpatti",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavthan Lane",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gazdar Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gilbert Hill Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaonkar Wadi",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gurunagar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haroonkar Lengari Chawl",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indian Oil Nagar A To P",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Nagar",
            "Pincode": "400058",
            "City": "Chandvad",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irla Gavthan",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irla Masajid",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Isic Nagar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapsa Village",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kevni Gavthan",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kevni Pada 1-55",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandesh Mohalla",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandeshi Mohalla",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khoja Jamatkhana",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Machhi Mar Camp",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madh Island",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhav Narar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhavdas Amarsey Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maneck Ashram",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marzabad Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masalawala Colony",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mehra Pada",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhatrewadi Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mudrani Kangan Nagar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mukund Patil Lane",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawalkar Street",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New India Staff Colony",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Saurashtra Colony",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "North South Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Post Office Lane Andh",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P W L",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali Rama Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandu Patil Road/Lane",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parival Society",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phulwadi",
            "Pincode": "400058",
            "City": "Ghansawangi",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pratap Co-Opp Housing Soc",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Quarry Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Wadi",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rane Wadi",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Salsette Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarvottom Colony",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shah Industrial Estate",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shalt Industrial Estate",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shanta Wadi",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shapurji Bharuchla Baug",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Society Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonapur Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sriram Nagar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road Andheri",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunil Shopping Centre",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Supreme Ind Estate",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Supreme Shopping Centre",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamivivekandard",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "T.P.S. Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Colony",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Compound",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thakar Compound",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umer Park",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Universal Industrial Esta",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Desai Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalbhai Patel Road",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zalawad Nagar",
            "Pincode": "400058",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bagdka Marg Bamanpuri Rd",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bamanpuri Village",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagat Singh Colony",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandarwada",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Boadhawadi",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bohara Colony",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chimatpada",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chimatpada Lane",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chin Atpatpada Road",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Church Road",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Five Bunglow",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "J B Nagar",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marol Bazar",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marol Bazar Peth Lane",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marol Bazar Road",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marol Bhawan Lane",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marol Bhawan Road",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marol Road",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marol Village",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maroshi Road",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Military Road",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pipe Line Zopadpatti",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajastan Hou Society Lane",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharddhanand Road &Extens",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Takpad Road",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Takpadarapapets",
            "Pincode": "400059",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abmedabad Exp Highway Jogeshw",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agadi Industrial Estate",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agasli Lane",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambika Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anand Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.R. Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandra Plot",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandrekar Wadi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagwan Raja Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhan Park",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Shankar Vara Road",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Caves Road",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chacha Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Colaba Plot",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "College Road Jogeshwari",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datta Tekdi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dias Compound",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dunga Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Francis Wadi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Friends Society Road",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi N Zopadpati",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Wadi Jogeshwari",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaushala",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghaswala Estate",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gumfa Road",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hardevi Co-Op Society Road",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hari Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harijan Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hindu F S Road 1 To 5",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "I Block",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Idgah Maidan",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ismail Collage Road",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jogeshwari",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jogeshwari Oshiwara",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasam Estate",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kashmiri Compound",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasnipada",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kevni Pada",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Majas Road",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Majas Road Rekdei",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Majas Wadi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Makrani Mohalla",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Meghwadi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mehar Bangla",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Memon Colony",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Natwar Road 1 To 5",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naupada Jogeshwari",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naupada Oshiwara",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawalkar Wadi Jogeshwari",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandav Wadi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pascar Wadi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pratap Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prem Nagare",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Premnagar Janata Colony",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pustikar Co Op Hou Societ",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Q-Block",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R R Road",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramdeo Singh R Thakur Mar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rane Wadi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadhana Estate",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahyadri Cottage",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samarth Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saraswat Colony",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saraswati Bag Raod",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shani Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shankar Wadi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shiv Tekdi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Housing Colony",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Society",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sita Nagar",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Smashan Tekdi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Squarters Colony Road 1-7",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Nagar",
            "Pincode": "400060",
            "City": "Kankavli",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Nagar Road",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilakwadi",
            "Pincode": "400060",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aram Nagar",
            "Pincode": "400061",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhaskar Bhopi Marg",
            "Pincode": "400061",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Herman Sukhari Road",
            "Pincode": "400061",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Machhali Mar Colony",
            "Pincode": "400061",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maneklal C Chinai Marg",
            "Pincode": "400061",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phurwadi",
            "Pincode": "400061",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Varsova",
            "Pincode": "400061",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Varsova Kakori Camp",
            "Pincode": "400061",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Versova",
            "Pincode": "400061",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Versova Village",
            "Pincode": "400061",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aarey Road",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahastri Nagar Goregaon",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ajay Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashirwad Ind. Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bagpti Road",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balkrishna Tawde Marg",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandu Alias Keshav Gore",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belwalkar Wadi",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagapati Wadi",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagat Singh Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhangur Wadi",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhimrao Wadi",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cawasji Dhanti Baug",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Churu Wadi",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D J Industrial Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dindoshi Road",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Excel Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gajanan Building",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gajanan Colony",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gazdar Street",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghaswala Compound",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gopal Baug",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaon",
            "Pincode": "400062",
            "City": "Goregaon",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaon R S",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaon Siddharthnagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaon West",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govt Hsg Colony Gore West",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govt Industrial Colony",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gram Panchayat Road",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Industrial Worker Govt Co",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kashikar Wadi",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road Gore",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahendranaghar S V Road",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marwadi Compound",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Misquittawadi",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Motilal Nagar 1To 3",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandwana Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawapada Goregaon",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P J M Path Kparas Compoun",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patel Industrial Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "People Own Housing Colony",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pirmal Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pragatinagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Mandir Road",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rambaug",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sane Guruji Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Savita Estates",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantabai Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantilal Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Shrirang Marg",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sidapura Ind Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sidharth Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sidharth Nagar Roads 1-17",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Industrial Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Somanigram",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Srinagar Society",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamivivekanda Rd",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tiwari Industrial Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Topiwala Compound",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Topiwala Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Udyognagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Udyognagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Udyognagar Road",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Unnal Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Upadhya Estate",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vakharia Industrial Estat",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vishweshwar Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeshwant Nagar",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeshwant Nagar Road 1To4",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zanjeria Colony Goregaon",
            "Pincode": "400062",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dalvi Wadi",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavhankar Wadi",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gogtewadi",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gogtewadi Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaon",
            "Pincode": "400063",
            "City": "Goregaon",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gram Panchayat Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ishwarbhai Patel Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naik Wadi",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nehru Road Goregaon",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pahadi Municipal Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pan Gulli Only Suryakiran",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandurang Wadi",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandurang Wadi Rd 1 To 6",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandurang Wadi Road 1To6",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pednekar Wadi",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Peru Baug",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Peru Baug Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phatal Wadi",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Mandir Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahakar Lane",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samant Wadi",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirodkar Wadi",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shreyas Colony",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Krishan Saraswati Ma",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonawalla",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonawalla Cross Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonawalla Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Valbhat Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walbhat Cross Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walbhat Road",
            "Pincode": "400063",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adarsha Housing Society Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmedabad Exp Hwy Malad",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aksa Village",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amand Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amarsi Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambawadi",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anandilal Podar Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anant Ganpat Pawar Lane",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandongri",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhadram Nagar",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandarwada",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bunder Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chincholi",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chunilal Giridharlal Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Collectors Compound",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadishet Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Daftary Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Daruwalla Compound",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datta Mandir Road Malad",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dayabhai Compound",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devchand Nagar",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Domnic Colony",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavthan Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Wadi",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goras Wadi",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goshala Lane",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govind Nagar",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gupta Market",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji Bapu Nagar",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haji Bapu Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanumanpada",
            "Pincode": "400064",
            "City": "Pen",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haroonkar Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hickson Dadaji Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Himansu Roy Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ishwarlal Parekh Marg",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ismail Bagh",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasturba Road Malad",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharodi Village",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahant Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahendranaghar Kailaspuri",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Makrani Pada",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malad",
            "Pincode": "400064",
            "City": "Shahapur",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malad East",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malad Liberty Gardern",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malavani Muni Colony",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malavani Village",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manchubhai Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manori Village",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marve Beach",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marwari Chawls",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Municipal Colony",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Municipal Market",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N B Rd At Chinchali Malad",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nadiadwala Colony",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nadiadwala Market",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narsing Lane",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Orlem Or Valani",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padma Nagar",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pannalal Ghosh Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathan Wadi",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pawan Baug",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phailal Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Poddar Estate",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pushapa Park",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Quarry Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rambaug",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rani Satinagar",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rani Satti Marg",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ratedi Village",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saidham Wadi",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sainath Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakeria Compound",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "School Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantaram Tekdi",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharamadham Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Colony Mala",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhashbose Lane Malad",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamivivekanda Rd",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swatantrya Marg",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swatantrya Udayam",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swatantrya Udayan",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Colony",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Turel Pakhadi Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Undrai Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yamunabhai Pada",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zakeria Road",
            "Pincode": "400064",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "A M Colony",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aarey Colony Road",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aarey Milk Colony",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aarey Road",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aarey Road",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adivasi Quarters",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Calf Farm",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Check Naka",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dairy Hill Road",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dinkarbhai Desai Road",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malinagar",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandav Road",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pawai Check Naka",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Picnic Spot",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tractor Workshop",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Unit Quarters",
            "Pincode": "400065",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abhinavnagar",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adarsha Nagar",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borival Rajendra Nagar",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borival Shirikrishnanagar",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borivali East",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borivli Daulatnagar",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadasaheb R Nagar",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datta Pada",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dattapada Road",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deval Pada",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devlpada",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "I C I Colony",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasturba Road Borivli",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khatau Wadi",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Magathani",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahadevbhai Desai Road",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road Boriv",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nancy Road",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "National High Way Borival",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Om Shivababanagar",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajendranagar",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Appasa Heb Sidhaye R",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Krishna Nagar",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sukarwadi",
            "Pincode": "400066",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmedabad Exp Hwy Kandiva",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amrut Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bajaj Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balika Vidyalaya Marg",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandar Pakhadi Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandongri Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatia Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatt Lane",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhogilal Falia Marg",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhud Colony Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhulabhai Desai Road Kvli",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borsa Padi",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bunder Pakhadi",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C O D Kandivli",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Char Coap",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Char Coap Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chhabri Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahanukar Colony",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahanukar Wadi",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Damodar Mhatre Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datta Temple Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devji Bhirji Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Dalvi Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Futch Baug",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaodevi Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghanashyam Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gowshala Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanbow Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haz Band Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hunbow Street",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "I I T Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Irani Wadi",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kandivali",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasturba Road Kandivli",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khajuria Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khajuria Tank Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Visanji Rd Andheri Rd",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahadevbhai Desai Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road Kandi",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahavinagar Gokhale Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahavinagar Shankar Lane",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Majithia Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manthan Pada",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mareen Lane",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mathurdas Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayandas Joshi Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narsi Pada",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P S Rd",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parekh Lane/Galli",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parekh Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Poddar Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Poddar Street",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Poisar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prem Nagare",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Radha Dalvi Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajaram Dube Compound",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Lane",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Roopnagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S V Patel Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahyadri Nagar Charkope",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saibag",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sainagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sardar Vallabhbhai Patel",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarojini Naidu Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarojini Naidu Road S Cru",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satya Maruti Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shankar Lune/Galli",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sitabai Patil Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Anthony Road Kandivali",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhashbose Lane Kandivli",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Suman Apptts",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sumati Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamivivekanda Rd",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Street",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Trikamdas Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tulaskar Wadi",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vallabhbhai Patel Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vasanji Lalji Lane",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Hemookalani Rd 1-4",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Village Road",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vimal Nagar",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zaveri Baug",
            "Pincode": "400067",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agarwal Estate",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aliyavar Jung Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Allali Bohra Kalasathan",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anur Plastics",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Atmaram Mhatre Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Stores",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bapusaheb Bagwe Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Beduk Bawdi Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagli Pada",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandarkar Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandarkar Wadi",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bharucha Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhau Saheb Parab Marg",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhikaji Lad Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Check Naka",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chhatrapati Shivaji Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chuna Bhatti",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadi Industrial Estate",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahisar",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dalvi Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deep Narayan Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dsilva Wadi",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dudhna Industrial Estate",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Ghat",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gangaram Parab Marg",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganpat Patil Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaothan",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavthan Pada",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghavtam Pada",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Godavari Mhatre Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gomant Nagar",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govind Mali Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gumla Telsi",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Haran Textile",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hari Shankar Joshi Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasam Baug Kashi Village",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kathipada",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ketakipada",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra Housing Colon",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra Stones",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangeshrao S Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maratha Colony",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mechanical Packing",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Moreshwar Patel Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murabali Talao",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Mhatgre Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "National Dying & Printing",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "National Highway Dahisai",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawa Gauthan",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oripada",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padmakar Jawle Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandurang Govind Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patel Colony",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patel Industrial Estate",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pereira Wadi",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhat Roller Flour",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Radhabhai Mhatra Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajaram Tawade Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Kuvar Rd Thakur",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ranchoddas Kanji Wadi",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ranchoddas Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rane Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rangnath Keskar Rd",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rangnath Mhatre Rd",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raut Galli",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rawalpada",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakharam Keer Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakharam Tare Rd",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shiv Vallabh Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shyamsunder Wadi",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sitabai Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonapur Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunder Nagar",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamivivekanda Rd",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thomas Dsilva Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "V H Desai Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Waman Sawant Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wamanrao Bhoir Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeshwant Tawade Road",
            "Pincode": "400068",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abmedabad Exp Highway Andheri",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andheri East Marol Bazar",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashirwadi",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Road Andheri East",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Ahmedabad Road",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chakala Rd",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikkuwadi",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Coal Dongri",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D S K A M Koldongri Rdno2",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gondavli Gavthan",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kol Dongri Galli No 3",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Deshpande Marg",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhavrao Peshva Marg",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mogra Pada",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mogra Road",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N Cross Road",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naagardas Park",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naagardas Road",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Nagardas Road",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nityanand Nagar",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Nagardas Rd Dr Radhak",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patel Wadi",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhatnagar",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahar Lanes 1 2 & 3",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahar Road",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Schindya Colony",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Suren Road",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swami Nityananda Road",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Teli Galli",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vajayanagar Society",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vasudeo Nagar",
            "Pincode": "400069",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "A H Wadia Marg",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Acharya Vinoba Bhave Marg",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adenwala Lane",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Afuwala Lane",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agra Rd Plot No 16 To 304",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akash Lane",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambedkar Chowk",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "400070",
            "City": "Dhamangaon Railway",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bail Bazar",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balaji Mandir Marg",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belgram Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhangi Wada",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhoiwada Kurla",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Brahmanwadi Pipe Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C S T Road 297To Surve 14",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chafegalli",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chankhamba",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chembur Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chuna Bhatti",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Church Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dongre Lane",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fitwalia Compound Pipe Rd",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gafurkhan Estate",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh B Lane",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hall Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hall Village Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hallow Pul",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Lane Takyaward",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Wadi",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hill Village Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hutatma Prabhakar Marg",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "K U Bazar",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasai Wada",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khadi Masjid New Agra Rd",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khajuri Bhatti",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khatrav Lane Takiyaward",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurla",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurla North",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurla-Chunabhatti",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Magan Nathuaram Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Makka Wadi",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masrani Estate",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masrani Lane",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Moreshwar P Marg Pipe Rd",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Muktadevi Wadi",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naupada Lane",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naupada Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Netajinagar M H B C S T R",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Mills Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Old Agra Rd S M Marg",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patel Galli",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patel Wadi",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Premier Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prernicr Colonyr",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Qureshi Nagar",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Mandir Road Kurla",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rangari Wadi",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rangari Wadi Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S G Barve Marg",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sainath Chowk",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarveswar Mandir Marg",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonapur Lane",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sundersang Estate",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swadeshi Mills Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Takiya Ward",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Nagar",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veer Nariman Rd",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Village Road",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Village Ward",
            "Pincode": "400070",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.A.R.C. Quarters",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Beggrs Home",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhaktakavi Shivaji Bhai D",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhikaji Damji Patil Marg",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borla Village",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C R P Comp",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Catholic Colony Road",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Railway Quarters",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Charai",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chembur",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chembur Municipal Colony",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chembur Road",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chenduphali Wadi",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Christian Colony",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dattaraya Krishna Sandu",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Choitram P Gidwani Rd",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavthan Road",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghatala Village",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govandi Village",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govt Hsg Society Road",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hindu Cemetry Road",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Dayanand Saraswati Marg",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra Housing Socit",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N B Patil Marg",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Postal Colony Chembur",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pragati Housing Society",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Quarter Road",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Krishna Chemburkar Mr",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rao Bahadur S D Marg",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Republic Housing Society",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S G Barve Marg East Kurla",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahakar Bhawan",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sandu Wadi",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantinagar",
            "Pincode": "400071",
            "City": "Chamorshi",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shapur Bagh",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shell Colony",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shell Colony Road",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sidharth Colony Chembur",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Society",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Avenue Road",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Colony",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Nagar",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunder Nagar",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Housing Colony",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thakkar Bapa Colony",
            "Pincode": "400071",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amar Hills",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anna Ind. Estate",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "400072",
            "City": "Dhamangaon Railway",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baji Paslkar Marg S.V.Rd.",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandivli Road",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandivli Village",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kherani Raod",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Visanji Rd",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohili Village",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nairwadi",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padma Hsg Society",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Park Klane",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pawai Park",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pipe Lane",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prakash Sadar",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saki Vihar",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakinaka",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakinaka Road",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tungwa Village",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vihar Road",
            "Pincode": "400072",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anik Village",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashok Nagar Society",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aziz Baug",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.S.R. Colony",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borla Koliwada Road",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Excise Quarters",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chembur Camp",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chembur Colony Buildings",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chitra Camp A & B",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Collectors Colony",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Custom Quarters",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devnar Muncipal Chawls",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devnar Village",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Esso Nagar East & West",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "F C I Bombay",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "F C I Mahul Road",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "F.C.I.Colony",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Galliakotwala Lane",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gawanpada Village",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahul Road Village",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandala Village",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mankhurd Agarwadi",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mankhurd Village",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maroli Village",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mysore Colony",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagabada Society",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navjivan Co-Op Hsg Soc",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Netaji Subhash Market",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nityanand Baug",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paili Village",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pir Pau",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Tekdi",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rambaug",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S P D C Quarters",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Stanvae Nagar East",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Power House Colony",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Telecome Factory Colony",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Trombay Village",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadi Gaothan",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vashi Naka",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vashi Village",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadavi Road",
            "Pincode": "400074",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gauri Shankar Wadi",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kassam Hussain P Chawls",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pantnagar",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pantnagar Colony Road",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panunagar",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Railway Colony",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Narayan Narkar Marg",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramabai Sahakar Nagar",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Township Colony",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Upasraya Lane",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Upasraya Road",
            "Pincode": "400075",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "400076",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harianwala Lane",
            "Pincode": "400076",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "I I T Bombay",
            "Pincode": "400076",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pawai Andheri Road",
            "Pincode": "400076",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saigal Road",
            "Pincode": "400076",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Teer Andan Nagar",
            "Pincode": "400076",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ananaji Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhanushali Wadi",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chittaranjan Nagar",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chittaranjan Nagar",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devashar Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devnar Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Dhamaji Plors",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Manubhai P.Vaidya Marg",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G B Pant Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Garodia Nagar",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gawdia Nagar",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gawdia Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Golibar Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govari Passage Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gurukul Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hansoti Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harbhinji Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hingwala Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Home Ground Camp Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khimji Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khokhuni Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahadev Parmeshwar Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nowraji Cross Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nowraji Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "O W G C Colony",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oghadbhai Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panjarpole Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pesram Nagar",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Peston Sagar",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Praneshwar Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R B Mehta Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raja Wadi Road 1To 7",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajawadi",
            "Pincode": "400077",
            "City": "Basmath",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramabai Sahkar Nagar",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramji Ashar Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ratilal B Mehta Marg",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadanand Rd",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shrimat Raichandra Marg",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindhi Baug/Wadi",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road Rajawadi",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Road",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Upasana Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vallabh Bag Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vallabha Bag Cross Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Velji Narsi Bhanushali Ma",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wagji Lane",
            "Pincode": "400077",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adi Shankaracharya Marg",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agra Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambawadi",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baba Shet Wadi",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandup",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandup Complex",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandup Industrial Estate",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandup Jangal",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandup Pawai",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandup Usha Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandup Village",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandup Village Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatti Pada Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Buddha Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Burjori Baug",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandra Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Darakhi Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datar Colony Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datta Mandir Road Bhandup",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Faridnagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Friends Colony",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaodevi",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaodevi Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Mandir Lane",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Housing Colony",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indian Naval Dockyard",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ishwar Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karia Wadi",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M E S Camp",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangal Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manghatram Compound",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maroda Hill",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhatre Wadi",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nardas Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nath Pai Road Bombay",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Netajinagar",
            "Pincode": "400078",
            "City": "Chamorshi",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandav Kund",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paranjape Colony",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsi Wadi",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathar Compound",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pratap Nagar",
            "Pincode": "400078",
            "City": "Kalwan",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pratap Nagar Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ranjit Rathar Compound",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadan Wadi",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sai Hills",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakhore Wadi",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakhubi Mohite Marg",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sardar Pratap Singh Marg",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarvodaya Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road Bhandup",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Nagar Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tank Street",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tata Power House Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tembipada Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Usha Nagar",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Utkarshanagar Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Village Road",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vishal Industrial Estate",
            "Pincode": "400078",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambedkar Nagar",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Asha Usha Mills Compound",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fire Bridgade",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fire Brigade",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fire Brigade Bus Termin",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Godrej Colony",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Nagar",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Park-Side Municipal Colon",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parkside Road",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Hajare Marg",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shri Paresh Parkar Marg",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vikroli",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vikroli Parkside Mun Cly",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vikroli Village Road",
            "Pincode": "400079",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agra Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambedkar Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anupam Industrial Estate",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bava Pradyumna Singh Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhanosi Pada",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhodkewadi",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Brahmadeshwar Mandir Marg",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "D Gopalkrishna Gokhale Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devidayal Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "District Local Board",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Ambedkar Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Rajendra Prasad Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gala Industrial Estate",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Gawde Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gautam Nagar",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavandipada",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gawan Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gawde Wadi",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gopalkrishna Gokhale Rd",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hansraj Meghjiwadi",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "K B Class Co Op Hou Soc",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karmveer D G Gaikwad Marg",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasturba Road Mulund",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandelwalla Udyognagar",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahakavi Kalidas Marg",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharshi Arvind Chawk P R",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road Mulun",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Meghji Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Meghal Serv Indu.Al Estat",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Milan Shoping Centre",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Minerva Indu.Al Estate",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mirani Nagar",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Moti Baug",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mulund Devidayal Rd",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mulund H O",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mulund Nahur",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mulund Nehru Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mulund Subhash Bose Rd",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murar Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nahur East",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nahur Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naik Wadi",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narmada Devi Pada",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nathuram Gaushala",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Netaji Subhash Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P & T Colony Mulund",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P K Industrial Estate",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P S Manduk Bridge S Bridg",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panch Sheela Nagar",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandit D U Marg Mulund",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prem Nagare",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajendra Prasad Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Ratan Trivedi Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Wadi",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramdas Wadi",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ratansi Hirji Bhojraj Rd",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S Mangal Pande Marg",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samarth Ramdas Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sardar Vallabhbhai Patel",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarojini Naidu Road Mulun",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satyadham Vidhyapeeth M",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sevaram Lalwani Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirodkar Gaikawad Wadi",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Nagar Pach Pakhad",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road Mulund",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Subhash Bose Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Valaji Ladha Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vallabhbhai Patel Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vishwakarma Marg",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalbhai Patel Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalnagar",
            "Pincode": "400080",
            "City": "Wani",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vyas Wadi",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walji Ladhabhai Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Waman Wadi",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zaver Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zulelal Mandir Marg",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zulilal Mandir Cross Road",
            "Pincode": "400080",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deshmukhwadi",
            "Pincode": "400081",
            "City": "Chalisgaon",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G V Scheme Road",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganesh Baug",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavade Vinze Scheme",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavanpada",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhale Road",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hema Kalani Marg 27/C S",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Horse Shoe Valley",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kesarbaug Lokmanya T Road",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Phule Road Mulund",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mithagar Road",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mulund East",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanepada",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nauhe Pade",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navghar Pada East Mulund",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navghar Road",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navghar Village",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palm Aeres",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R P F Kcolony",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Salvi Wadi",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sane Wadi",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Dnyaneshwar Road",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Tukaram Road",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahani Trust Colony",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road Mulund East",
            "Pincode": "400081",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vijaywadi",
            "Pincode": "400081",
            "City": "Malshiras",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agra Road",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B.E.S.T. Nagar",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bazar Road Mulund Colony",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandup Complex",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G G S Marg Mulund Colony",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hindustan Chowk",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malabar Hill Road Mulund",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mulund Colony",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Neo Shastri Nagar",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Netaji Road",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pawai Chowk",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Chowk",
            "Pincode": "400082",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agra Road",
            "Pincode": "400083",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hariali Vliiage",
            "Pincode": "400083",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phirozshah Godrej Marg",
            "Pincode": "400083",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Powai Telephone Exchange",
            "Pincode": "400083",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramakant Deshmukh Marg",
            "Pincode": "400083",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road Tagore Nagar",
            "Pincode": "400083",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tagore Nagar",
            "Pincode": "400083",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tagore Nagar Colony",
            "Pincode": "400083",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vikroli Rly Station",
            "Pincode": "400083",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Asalpha Village",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barvenagar",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barvenagar Colony",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barvenagar Road 1 To 6",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatwadi",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Captains Colony",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govind N Col Barvenagar",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govind Nagar",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Himalaya Society",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nati Seva Sadan Rd N P Rd",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "R B Kadam Cross Road",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sainath Wadi",
            "Pincode": "400084",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B A R C Bombay",
            "Pincode": "400085",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indian Rare Earths",
            "Pincode": "400085",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amrut Nagar",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Nagar Ghatkopar West",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavan",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C S D Estate",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cama Cross Lane",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cama Lane",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Govt Staff Colony",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cinema Rd 4Th&5Th Rajawad",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dattaraya Nagar",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Doshi Wadi",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaibansha Durgah",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "400086",
            "City": "Desaiganj (Vadasa)",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gangawadi",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaodevi",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghatkopar M G Road",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghatkopar Sahkar",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghatkopar West H O",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girdhar Nagar",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gopal Lane",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hirachand Desai Road",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Nagar",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karani Corss Lane",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karani Lane",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manekji Padmsi Wadi",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayan Nagar",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nathani Street Yard",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naval Stores Depot",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navroj Lane",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Netaji Palkar Mg N S S Rd",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nityanand Nagar",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "O N G C Colony",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P P Marg",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pankai Sonal Dargah",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsi Wadi",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rafil Range Road",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sanitorium Road Lane",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarvodaya Hospital",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharddhanand Road",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sidapura Ind Estate",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vrindavan",
            "Pincode": "400086",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N I T I E Bombay",
            "Pincode": "400087",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N I T J E Campus Road",
            "Pincode": "400087",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saki Vihar Road",
            "Pincode": "400087",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vihar Lake Road",
            "Pincode": "400087",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agar Wadi Man Khurd",
            "Pincode": "400088",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Payali Pada",
            "Pincode": "400088",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samrat Ashok Nagar",
            "Pincode": "400088",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Telecom Factory",
            "Pincode": "400088",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Telecom Municipal Col",
            "Pincode": "400088",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithal Narayan Purao Marg",
            "Pincode": "400088",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Waman Tukaram Patel Marg",
            "Pincode": "400088",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amar Mahal",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amirbang",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bharatiya Nagar",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Clieda Nagar",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghatkopar M Road",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gulshan Baug",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M Labour Camp",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malekar Wadi",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Munjal Nagar",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilak Nagar Colony",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilaknagar",
            "Pincode": "400089",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bangmnagar",
            "Pincode": "400090",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bangur Nagar",
            "Pincode": "400090",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivajinagar",
            "Pincode": "400091",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Babhai",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bharat Baug",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borivali",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandwarkar Lane",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dathi Narayan Mhatre Road",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devipada",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Eksar Road",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Factory Lane",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganjawalla Lane",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gorai",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govind Nagar",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kastur Park Borivli",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khanderao Dolgri",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra Nagar",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandapewshwar Road V P R",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mathurdas Road",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Monitory Station",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Motinagar",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mount Poiser",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Natak Wala Lane",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "National Park",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pai Nagar",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prem Nagare",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Punjabi Wadi",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ram Mabdir Lane",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rambaug",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Riyani Gram Borivali",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rokadia Lane",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saibaba Nagar",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sardar Vallabhbhai Patel",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharda Estate",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shimpoli Road",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shimpoli Village",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sodwala Lane",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "St Paul Nagar",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamivivekanda Rd",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vallabh Nagar",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vazira",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vishalnagar",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yoginagar Borivli",
            "Pincode": "400092",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abmedabad Exp Highway M.I.D.C",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amrut Nagar",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Azad Road Chakala M.I.D.C",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Ahmedabad Road",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chakala Midc",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "400093",
            "City": "Desaiganj (Vadasa)",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M I D C Plots",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahakali Mandir Road",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahakali Road",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahakali Zopadpatti",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mallappa Hill",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prakash Wadi",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rambaug",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satam Estate",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantinagar",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sharan Singh Colony",
            "Pincode": "400093",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anushakti Nagar",
            "Pincode": "400094",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharodi",
            "Pincode": "400095",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharodi Ins Hamla",
            "Pincode": "400095",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Seepz",
            "Pincode": "400096",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malad East",
            "Pincode": "400097",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay University Campus",
            "Pincode": "400098",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra Housing Baord",
            "Pincode": "400098",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manipada",
            "Pincode": "400098",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mathurdas Colony",
            "Pincode": "400098",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S G Barve Marg East Kurla",
            "Pincode": "400098",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S G Barve Marg West Kurla",
            "Pincode": "400098",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sunder Nagar",
            "Pincode": "400098",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vakola Village Road",
            "Pincode": "400098",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidyanagari",
            "Pincode": "400098",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidyanagari Marg",
            "Pincode": "400098",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Air Port Bombay",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Air Port New Quarters",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambedkar Nagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambewadi",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baman Wada",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baman Wada Hill",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Band Of Baroda Staff Qts",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chackala Village",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chakala Rd",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Collectors Chawl",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadoji Kondadeo Nagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Delima Colony",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Karanjia Road",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gulab Joshi Nagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Guru Nanak Wadi",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hayat Nagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Islampura",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra Housing Baord",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Kabirnagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Phule Nagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nehru Road Sahar Delv",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Airport Colony",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Terminal Bldg",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "P & T Colony Sahar Road",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parle Colony No 2",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parsee Wada",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Police Station Rd",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Posts & Telegraphs Q",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajaram Wadi",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahar Church Pakhadi",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahar Parivartan",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahar Talav Pakhadi",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahar Village",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahar Village Road",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sambaji Nagar V P East",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samrat Ashok Nagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sanjay Gandhi Nagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Santoshi Matanagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shantinagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji Colony",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sony Baug",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sutar Pakhadi",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Syndicate Bank Quarters",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tony Compound",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walmikinagar",
            "Pincode": "400099",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akurli Cross Road",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akurli Road",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arya Chanakya Nagar",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "400101",
            "City": "Dhamangaon Railway",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bombay Drug House",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bonanza Industrial Estate",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chakravarti Road",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chhitabhai Patel Road",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Damu Pada",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dipty Society",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "E.S.I.Corporation Hospita",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gajanan D Joshi H School",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gkul Nagar",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Nagar",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "International Tractors",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kandivali East",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahendra And Mahendra",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Polydan Of India",
            "Pincode": "400101",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Duxbury Ward",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G Ward",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Nagar Marg",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "H Ward",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jogeshwari",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kevni Gavthan",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malcum Bang",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawashakti Nagar",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oshiwara Marg",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prabhatnagar",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahakar Road",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Road Jogeshwari",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Suresh Samant Marg",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swamivivekanda Rd",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Swatantrya Sanik Nagar",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yadhavnagar",
            "Pincode": "400102",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devidas Lane",
            "Pincode": "400103",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Eksar Village",
            "Pincode": "400103",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokul Dham",
            "Pincode": "400103",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandapeshwar",
            "Pincode": "400103",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Medana Colony",
            "Pincode": "400103",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panch Sheela Zopadpatti",
            "Pincode": "400103",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Motilal Nagar",
            "Pincode": "400104",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Air Complex",
            "Pincode": "400105",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sant Santaji Maharaj J C",
            "Pincode": "400125",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saksena Wadi Juhu",
            "Pincode": "400547",
            "City": "Mumbai",
            "District": "Mumbai",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thane Dr Ambedkar Marg",
            "Pincode": "400601",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thane East",
            "Pincode": "400601",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thane Gokhale Rd",
            "Pincode": "400601",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thane H O",
            "Pincode": "400601",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thane R S",
            "Pincode": "400601",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thane Shantinagar",
            "Pincode": "400601",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanpada",
            "Pincode": "400602",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balkum",
            "Pincode": "400603",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kopri Colony",
            "Pincode": "400603",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wagle Indl Estate",
            "Pincode": "400604",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wagle Modelagram",
            "Pincode": "400604",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalwa",
            "Pincode": "400605",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "J K Gram",
            "Pincode": "400606",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sandozbaug",
            "Pincode": "400607",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saneguruji Vasahat",
            "Pincode": "400607",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Majiwada",
            "Pincode": "400609",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belapur",
            "Pincode": "400611",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mumbra",
            "Pincode": "400612",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Turbhe",
            "Pincode": "400613",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kokan Bhavan",
            "Pincode": "400614",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belapur Node Sectot Iii",
            "Pincode": "400615",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belganga Sahakari",
            "Pincode": "400615",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghansoli",
            "Pincode": "400701",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Uran",
            "Pincode": "400702",
            "City": "Uran",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vashi",
            "Pincode": "400703",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N A D Karanja",
            "Pincode": "400704",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vangaon",
            "Pincode": "401103",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mira",
            "Pincode": "401104",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhayandar East",
            "Pincode": "401105",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Uttan",
            "Pincode": "401106",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bassein",
            "Pincode": "401201",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bassein Road",
            "Pincode": "401202",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sopara",
            "Pincode": "401203",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vajreshwari",
            "Pincode": "401204",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gokhivare",
            "Pincode": "401205",
            "City": "Gokhivare",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganeshpuri",
            "Pincode": "401206",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Papdi",
            "Pincode": "401207",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agashi",
            "Pincode": "401301",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arnala",
            "Pincode": "401302",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Virar",
            "Pincode": "401303",
            "City": "Virar",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nirmal",
            "Pincode": "401304",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kelwa",
            "Pincode": "401401",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kelwa Mahim",
            "Pincode": "401402",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manor",
            "Pincode": "401403",
            "City": "Manor",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palghar H O",
            "Pincode": "401404",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satpati",
            "Pincode": "401405",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gorhe",
            "Pincode": "401406",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirgaon",
            "Pincode": "401407",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tarapur",
            "Pincode": "401502",
            "City": "Tarapur",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinchani",
            "Pincode": "401503",
            "City": "Chinchani",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tarapur A P P",
            "Pincode": "401504",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akarpatti",
            "Pincode": "401505",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tarapur I A",
            "Pincode": "401506",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahanu",
            "Pincode": "401601",
            "City": "Dahanu",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahanu Road",
            "Pincode": "401602",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jawhar",
            "Pincode": "401603",
            "City": "Jawhar",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mokhada",
            "Pincode": "401604",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talasari",
            "Pincode": "401606",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasa",
            "Pincode": "401607",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganjad",
            "Pincode": "401608",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Suryanagar",
            "Pincode": "401609",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dapcheri",
            "Pincode": "401610",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bordi",
            "Pincode": "401701",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gholvad",
            "Pincode": "401702",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kosbad Hill",
            "Pincode": "401703",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambat",
            "Pincode": "402101",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dasgaon",
            "Pincode": "402102",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaon",
            "Pincode": "402103",
            "City": "Goregaon",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangaon",
            "Pincode": "402104",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhasla",
            "Pincode": "402105",
            "City": "Mhasla",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Roha",
            "Pincode": "402105",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagothana",
            "Pincode": "402106",
            "City": "Nagothana",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pen",
            "Pincode": "402107",
            "City": "Pen",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Poynad",
            "Pincode": "402108",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shrivardhan",
            "Pincode": "402110",
            "City": "Shrivardhan",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tale",
            "Pincode": "402111",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talashet",
            "Pincode": "402112",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walwati",
            "Pincode": "402113",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bagmandla",
            "Pincode": "402114",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tudi",
            "Pincode": "402115",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Upper Tudil",
            "Pincode": "402115",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Roha A V",
            "Pincode": "402116",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Morba",
            "Pincode": "402117",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Washi",
            "Pincode": "402118",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nizampur",
            "Pincode": "402120",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pabhane",
            "Pincode": "402121",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Johe",
            "Pincode": "402122",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rave",
            "Pincode": "402123",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadar",
            "Pincode": "402124",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Alibag H O",
            "Pincode": "402201",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Revdanda",
            "Pincode": "402202",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chaul",
            "Pincode": "402203",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagaon",
            "Pincode": "402204",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Avas",
            "Pincode": "402205",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kihim",
            "Pincode": "402206",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thal",
            "Pincode": "402207",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahad",
            "Pincode": "402301",
            "City": "Mahad",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahad Naripeth",
            "Pincode": "402301",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Poladpur",
            "Pincode": "402303",
            "City": "Poladpur",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolad",
            "Pincode": "402304",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nata",
            "Pincode": "402305",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Varandh",
            "Pincode": "402306",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Janjira Murud",
            "Pincode": "402401",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borlai Panchayatan",
            "Pincode": "402403",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Diveagal",
            "Pincode": "402404",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dr Ambedkar Marg",
            "Pincode": "402404",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajpuri",
            "Pincode": "402405",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandgaon",
            "Pincode": "402406",
            "City": "Nandgaon",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panaji",
            "Pincode": "403001",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Panaji Altime",
            "Pincode": "403001",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Panaji Fontainhas",
            "Pincode": "403001",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Panaji Santainez",
            "Pincode": "403001",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Panaji Secretariat",
            "Pincode": "403001",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Caranzalem",
            "Pincode": "403002",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Panaji",
            "Pincode": "403004",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Rabindar Panaji",
            "Pincode": "403006",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Betim",
            "Pincode": "403101",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Chorao",
            "Pincode": "403102",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Sisoda",
            "Pincode": "403103",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Neura",
            "Pincode": "403104",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Pale",
            "Pincode": "403105",
            "City": "Pale",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Santa Estevam",
            "Pincode": "403106",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Mareela",
            "Pincode": "403107",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Goa Velha",
            "Pincode": "403108",
            "City": "Goa Velha",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Corlim Industrial Estate",
            "Pincode": "403110",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Sirdae",
            "Pincode": "403111",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Altc Betim",
            "Pincode": "403112",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Pilar",
            "Pincode": "403203",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "S Louranco",
            "Pincode": "403204",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Ponda",
            "Pincode": "403401",
            "City": "Ponda",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Velhagao",
            "Pincode": "403402",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Piedade",
            "Pincode": "403403",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Mardol",
            "Pincode": "403404",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Tisea",
            "Pincode": "403406",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Usgaon",
            "Pincode": "403407",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Queula",
            "Pincode": "403408",
            "City": "Queula",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Porvorim",
            "Pincode": "403501",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Tivim",
            "Pincode": "403502",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Assonera",
            "Pincode": "403503",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Sanquelim",
            "Pincode": "403505",
            "City": "Sanquelim",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Santacruz Central",
            "Pincode": "403505",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Valpoi",
            "Pincode": "403506",
            "City": "Valpoi",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Mapuca",
            "Pincode": "403507",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Aldana",
            "Pincode": "403508",
            "City": "Aldana",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Anjuna",
            "Pincode": "403509",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Parra",
            "Pincode": "403510",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Saligao",
            "Pincode": "403511",
            "City": "Saligao",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Pernem",
            "Pincode": "403512",
            "City": "Pernem",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Colvale",
            "Pincode": "403513",
            "City": "Colvale",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Candolim",
            "Pincode": "403515",
            "City": "Candolim",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Calangute",
            "Pincode": "403516",
            "City": "Calangute",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Siolim",
            "Pincode": "403517",
            "City": "Siolim",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Avpara",
            "Pincode": "403518",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Sinquerim",
            "Pincode": "403519",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Alto Provirim",
            "Pincode": "403521",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Carona",
            "Pincode": "403523",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Tirim Indl Estate",
            "Pincode": "403526",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Mandrem",
            "Pincode": "403527",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Corlin",
            "Pincode": "403529",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Aquem",
            "Pincode": "403601",
            "City": "Aquem",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Margaon",
            "Pincode": "403601",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Fatorda",
            "Pincode": "403602",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Belui",
            "Pincode": "403603",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Nuvem",
            "Pincode": "403604",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Assolna",
            "Pincode": "403701",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Canacona",
            "Pincode": "403702",
            "City": "Canacona",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Cuncolim",
            "Pincode": "403703",
            "City": "Cuncolim",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Sanquem",
            "Pincode": "403704",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Qupem",
            "Pincode": "403705",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Curchorem",
            "Pincode": "403706",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Navelim",
            "Pincode": "403707",
            "City": "Navelim",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Colva",
            "Pincode": "403708",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Curotorim",
            "Pincode": "403709",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Cortalim",
            "Pincode": "403710",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Chicalim",
            "Pincode": "403711",
            "City": "Chicalim",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Can Sanlim",
            "Pincode": "403712",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Majorda",
            "Pincode": "403713",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Chandor",
            "Pincode": "403714",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Benavlim",
            "Pincode": "403716",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Carmona",
            "Pincode": "403717",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Loutulim",
            "Pincode": "403718",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Sem Rachol",
            "Pincode": "403719",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Raja",
            "Pincode": "403720",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Varea",
            "Pincode": "403721",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Verna",
            "Pincode": "403722",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Velim",
            "Pincode": "403723",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Ordinance Factory",
            "Pincode": "403724",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Orelm",
            "Pincode": "403724",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Drampur",
            "Pincode": "403725",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Sanvoedem",
            "Pincode": "403727",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Lolien",
            "Pincode": "403728",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Navelim Camp",
            "Pincode": "403729",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "St Josede Azeal",
            "Pincode": "403730",
            "City": "Panaji",
            "District": "North Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Air Port Dabolim",
            "Pincode": "403801",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Vasco Baina",
            "Pincode": "403802",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Vasco Vadem",
            "Pincode": "403802",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Vasco-Da-Gama Town",
            "Pincode": "403802",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Marmugao",
            "Pincode": "403803",
            "City": "Margao",
            "District": "South Goa",
            "State": "Goa"
        },
        {
            "PostOfficeName": "Neral",
            "Pincode": "410101",
            "City": "Neral",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Matheran",
            "Pincode": "410102",
            "City": "Matheran",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karjat",
            "Pincode": "410201",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khalapur",
            "Pincode": "410202",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khopoli",
            "Pincode": "410203",
            "City": "Khopoli",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shillphate",
            "Pincode": "410203",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shillphate Shivaji Peth",
            "Pincode": "410203",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khopoli Power House",
            "Pincode": "410204",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali",
            "Pincode": "410205",
            "City": "Pali",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panvel City",
            "Pincode": "410206",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panvel H O",
            "Pincode": "410206",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rasayani",
            "Pincode": "410207",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M I D C Taloja",
            "Pincode": "410208",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vasahat",
            "Pincode": "410208",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "J C I E Kamothe",
            "Pincode": "410209",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chirner",
            "Pincode": "410210",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandala",
            "Pincode": "410301",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rpts Khandala",
            "Pincode": "410302",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lonavala",
            "Pincode": "410401",
            "City": "Lonavala",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lonavala Bazar",
            "Pincode": "410401",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ins Shivajinagar",
            "Pincode": "410402",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kaiwalyadham",
            "Pincode": "410403",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kamshet",
            "Pincode": "410405",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vategaon",
            "Pincode": "410410",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chakan",
            "Pincode": "410501",
            "City": "Chakan",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Junnar",
            "Pincode": "410502",
            "City": "Junnar",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manchar",
            "Pincode": "410503",
            "City": "Manchar",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narayangaon",
            "Pincode": "410504",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raj Guru Nagar",
            "Pincode": "410505",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talegaon Dabhada",
            "Pincode": "410506",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talegaon Ord Factory",
            "Pincode": "410506",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talegaon Gen Hospital",
            "Pincode": "410507",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhamni",
            "Pincode": "410508",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dimbhe Colony",
            "Pincode": "410509",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sizali",
            "Pincode": "410511",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vafgaon",
            "Pincode": "410514",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalamb",
            "Pincode": "410515",
            "City": "Kalamb",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Cantt East",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Cda",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Dr B Ambedkar Chowk",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Ghor Bazar",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Ghorpuri",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune H O",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Middle Road",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune New Bazar",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune New College",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune R S N P O",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Sachhapir St",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Salisbury Park",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Southern Command",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Vanowrie",
            "Pincode": "411001",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune City H O",
            "Pincode": "411002",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune City Nanapeth",
            "Pincode": "411002",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Garpade Peth",
            "Pincode": "411002",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Guruwar Peth",
            "Pincode": "411002",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Phule Mkt",
            "Pincode": "411002",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Rasta Peth",
            "Pincode": "411002",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Sukrawarpeth",
            "Pincode": "411002",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune Swar Gate",
            "Pincode": "411002",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khadki",
            "Pincode": "411003",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khadki Arshal",
            "Pincode": "411003",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khadki Bazar",
            "Pincode": "411003",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khadki East",
            "Pincode": "411003",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khadki H Factory",
            "Pincode": "411003",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khadki Laxmanrao",
            "Pincode": "411003",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kirloskar Path",
            "Pincode": "411003",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Decca Film Institute",
            "Pincode": "411004",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deccan Ex-Service Men Col",
            "Pincode": "411004",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deccan Gymkhana",
            "Pincode": "411004",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivajinagar Eng College",
            "Pincode": "411005",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivajinagar H O",
            "Pincode": "411005",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivajinagar Weather Atic",
            "Pincode": "411005",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yerwada",
            "Pincode": "411006",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yerwada Town",
            "Pincode": "411006",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganeshkhind",
            "Pincode": "411007",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "National Chem Laboratory",
            "Pincode": "411008",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parvati",
            "Pincode": "411009",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parvati Tilak V Nagar",
            "Pincode": "411009",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pune",
            "Pincode": "411010",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasbapeth",
            "Pincode": "411011",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasbapeth Mangalwar Peth",
            "Pincode": "411011",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dapodi",
            "Pincode": "411012",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hadapsar I F",
            "Pincode": "411013",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dunkirk Line",
            "Pincode": "411014",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dighi Camp",
            "Pincode": "411015",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dighi Vishrantwadi",
            "Pincode": "411015",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Model Colony",
            "Pincode": "411016",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Model Poly Technic",
            "Pincode": "411016",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpri Colony",
            "Pincode": "411017",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpri P F",
            "Pincode": "411018",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinchwad East",
            "Pincode": "411019",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Range Hills",
            "Pincode": "411020",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Armament",
            "Pincode": "411021",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S B P Pune",
            "Pincode": "411022",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S S C Exam Board",
            "Pincode": "411022",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khadakwasala Nc",
            "Pincode": "411023",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khada Kwasla R S",
            "Pincode": "411024",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "I A T Pune",
            "Pincode": "411025",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhosari I E",
            "Pincode": "411026",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aundh Camp",
            "Pincode": "411027",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hadapsar",
            "Pincode": "411028",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kothrud",
            "Pincode": "411029",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S P College",
            "Pincode": "411030",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S P College Lokuranya Nag",
            "Pincode": "411030",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S P Narayanpeth",
            "Pincode": "411030",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S P Rashtra Bhasha Bhavan",
            "Pincode": "411030",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S P Sadashiv Peth",
            "Pincode": "411030",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "S P Saniwar Peth",
            "Pincode": "411030",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "C M E Pune",
            "Pincode": "411031",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "I A F Station Pune",
            "Pincode": "411032",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinchwadagaon",
            "Pincode": "411033",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinchwadngaon",
            "Pincode": "411033",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasarvadi",
            "Pincode": "411034",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akurdi",
            "Pincode": "411035",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mundwa A V",
            "Pincode": "411036",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ex Serviceman",
            "Pincode": "411038",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhosarigaon",
            "Pincode": "411039",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wanowire",
            "Pincode": "411040",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadgaon Bk",
            "Pincode": "411041",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vithalwadi Rd",
            "Pincode": "411042",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhank Wadi",
            "Pincode": "411043",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "New Town Ship",
            "Pincode": "411044",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pashan",
            "Pincode": "411045",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Katraj",
            "Pincode": "411046",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anand Nagar",
            "Pincode": "411051",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonai",
            "Pincode": "411105",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belpukur",
            "Pincode": "411125",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mundhri",
            "Pincode": "411925",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dehu Road Cantt",
            "Pincode": "412101",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nira R S",
            "Pincode": "412102",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nimabalkar",
            "Pincode": "412103",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajewadi",
            "Pincode": "412104",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Alandi Devachi",
            "Pincode": "412105",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadgaon",
            "Pincode": "412106",
            "City": "Vadgaon",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadgaon Pune",
            "Pincode": "412106",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panshet",
            "Pincode": "412107",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paud",
            "Pincode": "412108",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dehu Road",
            "Pincode": "412109",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Theur",
            "Pincode": "412110",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pirangut",
            "Pincode": "412111",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Charkoli B K",
            "Pincode": "412112",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dehu Road",
            "Pincode": "412113",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rupee Nagar",
            "Pincode": "412114",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Loni Kalbhor",
            "Pincode": "412201",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Uruli Kanchan",
            "Pincode": "412202",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kedgaon",
            "Pincode": "412203",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Supa",
            "Pincode": "412204",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khed Shivapur",
            "Pincode": "412205",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhor",
            "Pincode": "412206",
            "City": "Bhor",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vagholi",
            "Pincode": "412207",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talegaon Dhamdhera",
            "Pincode": "412208",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ranjangaon Ganapati",
            "Pincode": "412209",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghodnadi",
            "Pincode": "412210",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nhavara",
            "Pincode": "412211",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Velhe",
            "Pincode": "412212",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narsarapur",
            "Pincode": "412213",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yawat",
            "Pincode": "412214",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Varvand",
            "Pincode": "412215",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kikvi",
            "Pincode": "412217",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malthan",
            "Pincode": "412218",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saswad",
            "Pincode": "412301",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Purandhar",
            "Pincode": "412302",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jejuri",
            "Pincode": "412303",
            "City": "Jejuri",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Morgaon",
            "Pincode": "412304",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Valhe",
            "Pincode": "412305",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Someshwarnagar",
            "Pincode": "412306",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manjari Farm",
            "Pincode": "412307",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phurasangi",
            "Pincode": "412308",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karanja",
            "Pincode": "412309",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lone Bhapkar",
            "Pincode": "412310",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parinche",
            "Pincode": "412311",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arvi",
            "Pincode": "412401",
            "City": "Arvi",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vada",
            "Pincode": "412402",
            "City": "Vada",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pabai",
            "Pincode": "412403",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kadur",
            "Pincode": "412404",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Avsari Budruk",
            "Pincode": "412405",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambegaon Manchar",
            "Pincode": "412407",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Godegaon",
            "Pincode": "412408",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Otur",
            "Pincode": "412409",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belha",
            "Pincode": "412410",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ala",
            "Pincode": "412411",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpalwadi",
            "Pincode": "412412",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kendne",
            "Pincode": "412413",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Earth Stn",
            "Pincode": "412415",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirval",
            "Pincode": "412801",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandala",
            "Pincode": "412802",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wai",
            "Pincode": "412803",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bavdhan",
            "Pincode": "412804",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panchagani",
            "Pincode": "412805",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahabaleshwar",
            "Pincode": "412806",
            "City": "Mahabaleshwar",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Ashok Chowk",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Bharni Peth",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur City",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Dayanand College",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Jodbhavi Peth",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Mangalwar Peth",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Medical College",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Navi Peth",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Sahakar Peth",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Shaniwar Peth",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Shukrawar Peth",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur Sidheshwar Peth",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Solapur H O",
            "Pincode": "413001",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Solapur Market",
            "Pincode": "413002",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zilla Nayalaya",
            "Pincode": "413003",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indira Nagar",
            "Pincode": "413004",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dajipeth",
            "Pincode": "413005",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M I D C Sholapur",
            "Pincode": "413006",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sholapur City",
            "Pincode": "413007",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akluj",
            "Pincode": "413101",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akluj Azad Chowk",
            "Pincode": "413101",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baramati",
            "Pincode": "413102",
            "City": "Baramati",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baramati Bazar",
            "Pincode": "413102",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baramati Kasba",
            "Pincode": "413102",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Baramati West",
            "Pincode": "413102",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bavada",
            "Pincode": "413103",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Nagar Hpune)",
            "Pincode": "413104",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhigwan R S",
            "Pincode": "413105",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Indapur",
            "Pincode": "413106",
            "City": "Indapur",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malsiras",
            "Pincode": "413107",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malinagar",
            "Pincode": "413108",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Natepute",
            "Pincode": "413109",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandara",
            "Pincode": "413110",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadashivaangai",
            "Pincode": "413111",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shreepur",
            "Pincode": "413112",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Velapur",
            "Pincode": "413113",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walchandnagar",
            "Pincode": "413114",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malegaon B K",
            "Pincode": "413115",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivnapar",
            "Pincode": "413116",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lasurna",
            "Pincode": "413117",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeshwantnagar Pandharpur",
            "Pincode": "413118",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nimbgaon Ketki",
            "Pincode": "413120",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phondsiras",
            "Pincode": "413121",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahigaon",
            "Pincode": "413122",
            "City": "Solapur",
            "District": "Solapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shelgaon",
            "Pincode": "413124",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangvi",
            "Pincode": "413125",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parandavade",
            "Pincode": "413128",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhigwan",
            "Pincode": "413130",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palasdeo",
            "Pincode": "413132",
            "City": "Pune",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jamkhed",
            "Pincode": "413201",
            "City": "Jamkhed",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jeur",
            "Pincode": "413202",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karmala",
            "Pincode": "413203",
            "City": "Karmala",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karmala Town",
            "Pincode": "413203",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharda",
            "Pincode": "413204",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanaj",
            "Pincode": "413205",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pomalwadi",
            "Pincode": "413206",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amalner",
            "Pincode": "413207",
            "City": "Amalner",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurundwadi",
            "Pincode": "413208",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurundwadi Rly Colony",
            "Pincode": "413208",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madha",
            "Pincode": "413209",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madha Mangalwar Peth",
            "Pincode": "413209",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpalner",
            "Pincode": "413210",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tembhurni",
            "Pincode": "413211",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhimanagar",
            "Pincode": "413212",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohol",
            "Pincode": "413213",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohol Bazarpeth",
            "Pincode": "413213",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Angar",
            "Pincode": "413214",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hotgi",
            "Pincode": "413215",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akkalkot",
            "Pincode": "413216",
            "City": "Akkalkot",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghodeshwar",
            "Pincode": "413217",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maindargi",
            "Pincode": "413217",
            "City": "Maindargi",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadhadari",
            "Pincode": "413218",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karajgi",
            "Pincode": "413219",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dudhani",
            "Pincode": "413220",
            "City": "Dudhani",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandrup",
            "Pincode": "413221",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanaj",
            "Pincode": "413222",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kem",
            "Pincode": "413223",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivashahi",
            "Pincode": "413224",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tikekarwadi",
            "Pincode": "413225",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chapalgaon",
            "Pincode": "413226",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagamsur",
            "Pincode": "413227",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Valsang",
            "Pincode": "413228",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpalwandi",
            "Pincode": "413229",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurdu",
            "Pincode": "413230",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Salgar",
            "Pincode": "413231",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangrul",
            "Pincode": "413232",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patkul",
            "Pincode": "413233",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Uplai B K",
            "Pincode": "413234",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jeur",
            "Pincode": "413235",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kumbhari",
            "Pincode": "413237",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Niranarsingpur",
            "Pincode": "413240",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tungat",
            "Pincode": "413241",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pakni",
            "Pincode": "413242",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deogaon",
            "Pincode": "413243",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hiraj",
            "Pincode": "413244",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurul",
            "Pincode": "413245",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadala",
            "Pincode": "413246",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pennal",
            "Pincode": "413248",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirur",
            "Pincode": "413249",
            "City": "Shirur",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahisgaon",
            "Pincode": "413250",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sada",
            "Pincode": "413251",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Modnimb",
            "Pincode": "413301",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karkamb",
            "Pincode": "413302",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashti",
            "Pincode": "413303",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandharpur Bhaji Mkt",
            "Pincode": "413304",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandharpur H O",
            "Pincode": "413304",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandharpur Mahadwar",
            "Pincode": "413304",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandharpur St Road",
            "Pincode": "413304",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maharashtra E R I",
            "Pincode": "413306",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahud",
            "Pincode": "413306",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangole",
            "Pincode": "413307",
            "City": "Sangole",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nazane",
            "Pincode": "413308",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Javala",
            "Pincode": "413309",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pilav",
            "Pincode": "413310",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasegaon",
            "Pincode": "413311",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tandulwadi",
            "Pincode": "413312",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ropla",
            "Pincode": "413313",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kole",
            "Pincode": "413314",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandishegaon",
            "Pincode": "413316",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khardi",
            "Pincode": "413317",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagaj",
            "Pincode": "413318",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marwade",
            "Pincode": "413319",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shetphul",
            "Pincode": "413324",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barshi",
            "Pincode": "413401",
            "City": "Barshi",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barshi Ada Bazar",
            "Pincode": "413401",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barshi Market Yard",
            "Pincode": "413401",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vairag",
            "Pincode": "413402",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pangaon",
            "Pincode": "413403",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pangri",
            "Pincode": "413404",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yedshi",
            "Pincode": "413405",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandgaon",
            "Pincode": "413406",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavdgaon",
            "Pincode": "413406",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Agalgaon",
            "Pincode": "413409",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manegaon",
            "Pincode": "413410",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tulsidasnagar",
            "Pincode": "413412",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madh",
            "Pincode": "413416",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Osmanabad H O",
            "Pincode": "413501",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Osmanabad Town",
            "Pincode": "413501",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paranda",
            "Pincode": "413502",
            "City": "Paranda",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vasi",
            "Pincode": "413503",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhoom",
            "Pincode": "413504",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonari",
            "Pincode": "413505",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bembli",
            "Pincode": "413506",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalamb",
            "Pincode": "413507",
            "City": "Kalamb",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhoki",
            "Pincode": "413508",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ter",
            "Pincode": "413509",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murud",
            "Pincode": "413510",
            "City": "Murud",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borgaon",
            "Pincode": "413511",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Latur H O",
            "Pincode": "413512",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Latur Labour Colony",
            "Pincode": "413512",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Latur Patel Road",
            "Pincode": "413512",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chakur",
            "Pincode": "413513",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sizpur Tajband",
            "Pincode": "413514",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmedpur",
            "Pincode": "413515",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Udgir",
            "Pincode": "413517",
            "City": "Udgir",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Udgir Eng",
            "Pincode": "413517",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadhona",
            "Pincode": "413518",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deoni",
            "Pincode": "413519",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Awsa",
            "Pincode": "413520",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nilanja",
            "Pincode": "413521",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aurad Shahajani",
            "Pincode": "413522",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kingaon",
            "Pincode": "413523",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nalegaon",
            "Pincode": "413524",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yermala",
            "Pincode": "413525",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pargaon",
            "Pincode": "413526",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rainapur",
            "Pincode": "413527",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shiradhon",
            "Pincode": "413528",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadala Nagnath",
            "Pincode": "413529",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nittur",
            "Pincode": "413530",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilaknagar",
            "Pincode": "413531",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Leet",
            "Pincode": "413534",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirala",
            "Pincode": "413536",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khamsa Wadi",
            "Pincode": "413539",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Itkur",
            "Pincode": "413540",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Moha",
            "Pincode": "413541",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jewali",
            "Pincode": "413542",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bori",
            "Pincode": "413543",
            "City": "Gadchiroli",
            "District": "Gadchiroli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sizur Anantpal",
            "Pincode": "413544",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalkol",
            "Pincode": "413546",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lohara",
            "Pincode": "413547",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shelgaon",
            "Pincode": "413554",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gategaon",
            "Pincode": "413558",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharosa",
            "Pincode": "413560",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tondon",
            "Pincode": "413563",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chincholi",
            "Pincode": "413569",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bavi",
            "Pincode": "413571",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Boral",
            "Pincode": "413575",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ulpoop",
            "Pincode": "413576",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wagholi",
            "Pincode": "413577",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ternanagar",
            "Pincode": "413580",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tuljapur",
            "Pincode": "413601",
            "City": "Tuljapur",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naldurg",
            "Pincode": "413602",
            "City": "Naldurg",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andora",
            "Pincode": "413603",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maram",
            "Pincode": "413605",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dalimb",
            "Pincode": "413606",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Omerga",
            "Pincode": "413606",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasar Sirsi",
            "Pincode": "413607",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lohara",
            "Pincode": "413608",
            "City": "Gadchiroli",
            "District": "Gadchiroli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jewali",
            "Pincode": "413612",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Turori",
            "Pincode": "413615",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangrul",
            "Pincode": "413616",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malumbra",
            "Pincode": "413623",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kati",
            "Pincode": "413624",
            "City": "Osmanabad",
            "District": "Osmanabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shrigonda",
            "Pincode": "413701",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belvandi",
            "Pincode": "413702",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Visapur",
            "Pincode": "413703",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vambori",
            "Pincode": "413704",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rahuri",
            "Pincode": "413705",
            "City": "Rahuri",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rahuri Factory",
            "Pincode": "413706",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Puntambha",
            "Pincode": "413707",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakharwadi",
            "Pincode": "413708",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shrirampur H O",
            "Pincode": "413709",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhar",
            "Pincode": "413710",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Songaon",
            "Pincode": "413711",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pravaranagar",
            "Pincode": "413712",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Loni Khurd",
            "Pincode": "413713",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashvi",
            "Pincode": "413714",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belapur",
            "Pincode": "413715",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devlai Pravara",
            "Pincode": "413716",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karegaon Factory",
            "Pincode": "413717",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harigaon",
            "Pincode": "413718",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramjamgaon Khurd",
            "Pincode": "413719",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilaknagar",
            "Pincode": "413720",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padhegaon",
            "Pincode": "413721",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahatma Phule Bazar",
            "Pincode": "413722",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rahuri M P K Vidyapith",
            "Pincode": "413722",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidyapith Rahuri",
            "Pincode": "413722",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Changdev Nagar",
            "Pincode": "413723",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpalgaon Pisa",
            "Pincode": "413724",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Takli Bhor",
            "Pincode": "413725",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shrigonda S K",
            "Pincode": "413726",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalgaon",
            "Pincode": "413728",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nipani Vadgaon",
            "Pincode": "413732",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Loni B K",
            "Pincode": "413736",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Babhaleshwer",
            "Pincode": "413737",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadala Mahadeo",
            "Pincode": "413739",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Daund",
            "Pincode": "413801",
            "City": "Daund",
            "District": "Pune",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sugaon",
            "Pincode": "413901",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmednagar",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmednagar Camp",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmednagar City",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmednagar Estate",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmednagar H O",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmednagar Maliwada",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmednagar R S",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anandi Bazar",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhingar Ves",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M G Udyan",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Minto Lines",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ridge",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarjepura",
            "Pincode": "414001",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmednagar Camp",
            "Pincode": "414002",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmednagar R S",
            "Pincode": "414005",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandavgan",
            "Pincode": "414101",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandavgan Farata",
            "Pincode": "414101",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathardi",
            "Pincode": "414102",
            "City": "Pathardi",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jamgaon",
            "Pincode": "414103",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tisgaon",
            "Pincode": "414106",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kedgaon",
            "Pincode": "414108",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ahmednagar M I D C",
            "Pincode": "414111",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharwandi Kasar",
            "Pincode": "414113",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chichondi Patil",
            "Pincode": "414201",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kada",
            "Pincode": "414202",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashti",
            "Pincode": "414203",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patoda",
            "Pincode": "414204",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajori",
            "Pincode": "414205",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Katkhana",
            "Pincode": "414208",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aapdhup",
            "Pincode": "414301",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Supa",
            "Pincode": "414301",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parner",
            "Pincode": "414302",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kanhur",
            "Pincode": "414303",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Takli Dhokeshwar",
            "Pincode": "414304",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Alkuti",
            "Pincode": "414305",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nighoj",
            "Pincode": "414306",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mirajgaon",
            "Pincode": "414401",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karjat",
            "Pincode": "414402",
            "City": "Karjat",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rasin",
            "Pincode": "414403",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Koregaon",
            "Pincode": "414404",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jagdamba S K",
            "Pincode": "414405",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M I R C Ahmednagar",
            "Pincode": "414410",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Miri",
            "Pincode": "414501",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shevgaon",
            "Pincode": "414502",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balam Takli",
            "Pincode": "414504",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Virdhyeshwar S K",
            "Pincode": "414505",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jeur",
            "Pincode": "414601",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadala Mission",
            "Pincode": "414602",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nevasa",
            "Pincode": "414603",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kukane",
            "Pincode": "414604",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhende S K",
            "Pincode": "414605",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chanda",
            "Pincode": "414606",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghodegaon",
            "Pincode": "414607",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kashti",
            "Pincode": "414701",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chimbharle",
            "Pincode": "414702",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satara Budhwar Peth",
            "Pincode": "415001",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satara H O",
            "Pincode": "415001",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satara Malhar Peth",
            "Pincode": "415001",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satara Sangamnagar",
            "Pincode": "415001",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satara Yadogopal Peth",
            "Pincode": "415001",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satara City",
            "Pincode": "415002",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M I D C Satara",
            "Pincode": "415004",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satara Road",
            "Pincode": "415010",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vaduth",
            "Pincode": "415011",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Medha",
            "Pincode": "415012",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parali",
            "Pincode": "415013",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tarala",
            "Pincode": "415014",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Limbgave",
            "Pincode": "415015",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Limgare",
            "Pincode": "415015",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kelgh-Ar",
            "Pincode": "415017",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Angapur",
            "Pincode": "415019",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kinhai",
            "Pincode": "415021",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vernanagar",
            "Pincode": "415022",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malkapur",
            "Pincode": "415101",
            "City": "Malkapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mayani",
            "Pincode": "415102",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kole",
            "Pincode": "415103",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kale",
            "Pincode": "415104",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oglewadi",
            "Pincode": "415105",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masur",
            "Pincode": "415106",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Targaon",
            "Pincode": "415107",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivnagar",
            "Pincode": "415108",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karad City",
            "Pincode": "415110",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karad H O",
            "Pincode": "415110",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karad Mangalwar Peth",
            "Pincode": "415110",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karad Market Yard",
            "Pincode": "415110",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karad Tilak Peth",
            "Pincode": "415110",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karad Vidyanagar",
            "Pincode": "415110",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ond",
            "Pincode": "415111",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhebewadi",
            "Pincode": "415112",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Supne",
            "Pincode": "415114",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeshwantnagar",
            "Pincode": "415115",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vathar Kizdi",
            "Pincode": "415116",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Undale",
            "Pincode": "415118",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Charigaon",
            "Pincode": "415120",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bankot",
            "Pincode": "415201",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Latwan",
            "Pincode": "415202",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandangad",
            "Pincode": "415203",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mharpral",
            "Pincode": "415204",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malharpeth Karad",
            "Pincode": "415205",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patan",
            "Pincode": "415206",
            "City": "Patan",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Koyna",
            "Pincode": "415207",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Veshvi",
            "Pincode": "415208",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bahule",
            "Pincode": "415209",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Morgiri",
            "Pincode": "415210",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Daulat Nagar",
            "Pincode": "415211",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Maralhareli",
            "Pincode": "415212",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chimbhare",
            "Pincode": "415213",
            "City": "Alibag",
            "District": "Raigarh",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Atpadi",
            "Pincode": "415301",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhavani Nagar",
            "Pincode": "415302",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devrashtra",
            "Pincode": "415303",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kadegaon",
            "Pincode": "415304",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kadepur",
            "Pincode": "415305",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khanapur",
            "Pincode": "415307",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharsundi",
            "Pincode": "415308",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Langane",
            "Pincode": "415309",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahuli",
            "Pincode": "415310",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vite",
            "Pincode": "415311",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vite City",
            "Pincode": "415311",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kaledhon",
            "Pincode": "415312",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Takari",
            "Pincode": "415313",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dighanchi",
            "Pincode": "415315",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aitwade Budruk",
            "Pincode": "415401",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bilashi",
            "Pincode": "415402",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kameri",
            "Pincode": "415403",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasegaon",
            "Pincode": "415404",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kokrud",
            "Pincode": "415405",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nerla",
            "Pincode": "415406",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Peth",
            "Pincode": "415407",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirala",
            "Pincode": "415408",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Uran Islampur",
            "Pincode": "415409",
            "City": "Uran Islampur",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Uran Shivaji Chowk",
            "Pincode": "415409",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Uran Tilak Peth",
            "Pincode": "415409",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikurde",
            "Pincode": "415412",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bargaon",
            "Pincode": "415413",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Warna Vati Vasahat",
            "Pincode": "415415",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kande",
            "Pincode": "415416",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurtap",
            "Pincode": "415417",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangle",
            "Pincode": "415418",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Koregaon",
            "Pincode": "415501",
            "City": "Gadchiroli",
            "District": "Gadchiroli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pusegaon",
            "Pincode": "415502",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Budh",
            "Pincode": "415503",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Diksal Mol",
            "Pincode": "415504",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khatar",
            "Pincode": "415505",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vaduj",
            "Pincode": "415506",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Katar Khatav",
            "Pincode": "415507",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahiwadi",
            "Pincode": "415508",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhasvad",
            "Pincode": "415509",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aundh",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aurangabad City",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aurangabad R S",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Begum Bazar",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Bldg",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kotwalpura",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nizamgunj",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Osmanpura",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarawati Colony",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahgani",
            "Pincode": "415510",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rahimatpur",
            "Pincode": "415511",
            "City": "Rahimatpur",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pusesavali",
            "Pincode": "415512",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pachvad",
            "Pincode": "415513",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kudal",
            "Pincode": "415514",
            "City": "Kudal",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhuinj",
            "Pincode": "415515",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kavathe",
            "Pincode": "415516",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Surur",
            "Pincode": "415517",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Apshinge",
            "Pincode": "415518",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aatit",
            "Pincode": "415519",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagthana",
            "Pincode": "415519",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chaphal",
            "Pincode": "415520",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lonand",
            "Pincode": "415521",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakharwadi",
            "Pincode": "415522",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phaltan",
            "Pincode": "415523",
            "City": "Phaltan",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vathar",
            "Pincode": "415524",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpede",
            "Pincode": "415525",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpode",
            "Pincode": "415525",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vathar",
            "Pincode": "415526",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurulisidheshwar",
            "Pincode": "415527",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Taradgaon",
            "Pincode": "415528",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kisan Veer Nagar",
            "Pincode": "415530",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gunavare",
            "Pincode": "415531",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nimblak",
            "Pincode": "415532",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kenjal",
            "Pincode": "415536",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "415570",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aurangabad Sarafa",
            "Pincode": "415570",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samathangar",
            "Pincode": "415570",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidyanagar",
            "Pincode": "415570",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pophali",
            "Pincode": "415601",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirgaon",
            "Pincode": "415602",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Alore",
            "Pincode": "415603",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kherdi",
            "Pincode": "415604",
            "City": "Kherdi",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chiplun Bazar",
            "Pincode": "415605",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chiplun H O",
            "Pincode": "415605",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sawarda",
            "Pincode": "415606",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandgaon",
            "Pincode": "415607",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Makhjan",
            "Pincode": "415608",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kadwai",
            "Pincode": "415609",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasba",
            "Pincode": "415610",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangameshwar",
            "Pincode": "415611",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ratnagiri H O",
            "Pincode": "415612",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saitvada",
            "Pincode": "415613",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jaigad",
            "Pincode": "415614",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malgund",
            "Pincode": "415615",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kothavade",
            "Pincode": "415617",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalusta",
            "Pincode": "415618",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khalgaon",
            "Pincode": "415620",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bharne",
            "Pincode": "415621",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganapatipule",
            "Pincode": "415622",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gavkhadi",
            "Pincode": "415626",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nevere",
            "Pincode": "415627",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shiral",
            "Pincode": "415628",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirgaon",
            "Pincode": "415629",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karle",
            "Pincode": "415630",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nachne",
            "Pincode": "415631",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padhambe",
            "Pincode": "415633",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambedebadrak",
            "Pincode": "415637",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Niwali",
            "Pincode": "415641",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "415701",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marg Tambhane",
            "Pincode": "415702",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Guhagar",
            "Pincode": "415703",
            "City": "Guhagar",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palshet",
            "Pincode": "415704",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adur",
            "Pincode": "415705",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dabhol",
            "Pincode": "415706",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parshuram",
            "Pincode": "415707",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lavel",
            "Pincode": "415708",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khed",
            "Pincode": "415709",
            "City": "Khed",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Furus",
            "Pincode": "415710",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vakavli",
            "Pincode": "415711",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dapoli",
            "Pincode": "415712",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harnai",
            "Pincode": "415713",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anjarla",
            "Pincode": "415714",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khopi",
            "Pincode": "415715",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palgad",
            "Pincode": "415716",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kelshi",
            "Pincode": "415717",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhamanand",
            "Pincode": "415718",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talavali",
            "Pincode": "415719",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Burondi",
            "Pincode": "415720",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murud",
            "Pincode": "415721",
            "City": "Murud",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lota",
            "Pincode": "415722",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shrinagar Tali",
            "Pincode": "415724",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abldi",
            "Pincode": "415726",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karji",
            "Pincode": "415727",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hedvi",
            "Pincode": "415728",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakharpa",
            "Pincode": "415801",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shiposhi",
            "Pincode": "415802",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pali",
            "Pincode": "415803",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devrukh",
            "Pincode": "415804",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jaithapur",
            "Pincode": "415805",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nata",
            "Pincode": "415806",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deole",
            "Pincode": "415807",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur Pratibhanagar",
            "Pincode": "416001",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur R S H O",
            "Pincode": "416001",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur R S Rankala",
            "Pincode": "416001",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur Shivaji",
            "Pincode": "416001",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur Udyannagar",
            "Pincode": "416001",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidyapith Marg",
            "Pincode": "416001",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur Babujamat",
            "Pincode": "416002",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur Bhendegalli",
            "Pincode": "416002",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur City H O",
            "Pincode": "416002",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur Juna Rajwada",
            "Pincode": "416002",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur Shivaji Peth",
            "Pincode": "416002",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur Shukra Peth",
            "Pincode": "416002",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shukravarpeth",
            "Pincode": "416002",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur New Palace",
            "Pincode": "416003",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivaji University",
            "Pincode": "416004",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gur Market Yard",
            "Pincode": "416005",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasva Bavda",
            "Pincode": "416006",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalamba",
            "Pincode": "416007",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajarampuri",
            "Pincode": "416008",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phalenwadi",
            "Pincode": "416010",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolhapur",
            "Pincode": "416011",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jaysingpur",
            "Pincode": "416101",
            "City": "Jaysingpur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lanja",
            "Pincode": "416101",
            "City": "Lanja",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandani",
            "Pincode": "416102",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirol",
            "Pincode": "416103",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narsobavadi",
            "Pincode": "416104",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganeshwadi",
            "Pincode": "416105",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurundvad",
            "Pincode": "416106",
            "City": "Kurundvad",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dattawad",
            "Pincode": "416107",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Takli",
            "Pincode": "416108",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hatkanangala",
            "Pincode": "416109",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badhubali",
            "Pincode": "416110",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bahubali",
            "Pincode": "416110",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kumbhaj",
            "Pincode": "416111",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadgaon",
            "Pincode": "416112",
            "City": "Vadgaon",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Warnanagar",
            "Pincode": "416113",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kodoli",
            "Pincode": "416114",
            "City": "Kodoli",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ichalkaranji",
            "Pincode": "416115",
            "City": "Ichalkaranji",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ichalkaranji H O",
            "Pincode": "416115",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ichalkaranji Kalanagar",
            "Pincode": "416115",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ichalkaranji Laxmi Market",
            "Pincode": "416115",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ichalkaranji Nadives",
            "Pincode": "416115",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ichalkaranji Rui Naka",
            "Pincode": "416115",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ichalkaranji Town",
            "Pincode": "416115",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ichalkaranji Udyognagar",
            "Pincode": "416115",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganga Nagar",
            "Pincode": "416116",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ichalkaranji",
            "Pincode": "416116",
            "City": "Ichalkaranji",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "416117",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "416119",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rukadi",
            "Pincode": "416119",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datta Nagar",
            "Pincode": "416120",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ratnpakumbhar Nagar",
            "Pincode": "416121",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M I D C Kolhapur",
            "Pincode": "416122",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pulachi Shiroli",
            "Pincode": "416122",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lat",
            "Pincode": "416130",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Top",
            "Pincode": "416132",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Udgaon",
            "Pincode": "416134",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pargaon",
            "Pincode": "416137",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panhala",
            "Pincode": "416201",
            "City": "Panhala",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patan Kodoli",
            "Pincode": "416202",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hupri",
            "Pincode": "416203",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hutatma Chowk",
            "Pincode": "416203",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kuditre",
            "Pincode": "416204",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kale",
            "Pincode": "416205",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ganga Bawada",
            "Pincode": "416206",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ispurli",
            "Pincode": "416207",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bidri",
            "Pincode": "416208",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gargoti",
            "Pincode": "416209",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kadagaon",
            "Pincode": "416210",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parite",
            "Pincode": "416211",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Radhanagari",
            "Pincode": "416212",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bambavade",
            "Pincode": "416213",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarud",
            "Pincode": "416214",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahuwadi",
            "Pincode": "416215",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kagal",
            "Pincode": "416216",
            "City": "Kagal",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangaon",
            "Pincode": "416217",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapshi",
            "Pincode": "416218",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murgud",
            "Pincode": "416219",
            "City": "Murgud",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Uttur",
            "Pincode": "416220",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Valva B K",
            "Pincode": "416221",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikhali",
            "Pincode": "416222",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhasue",
            "Pincode": "416223",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rashivade",
            "Pincode": "416224",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambewadi",
            "Pincode": "416227",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thikpurli",
            "Pincode": "416227",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kotodi",
            "Pincode": "416230",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dudhganga Nagar",
            "Pincode": "416231",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sidhnerli",
            "Pincode": "416232",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashte",
            "Pincode": "416301",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bagni",
            "Pincode": "416302",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhilwadi",
            "Pincode": "416303",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Budhgaon",
            "Pincode": "416304",
            "City": "Budhgaon",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Digraj Kasba",
            "Pincode": "416305",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kavalapur",
            "Pincode": "416306",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kavathe Ekhand",
            "Pincode": "416307",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kirloskarwadi",
            "Pincode": "416308",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kundal",
            "Pincode": "416309",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palus",
            "Pincode": "416310",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Savlaj",
            "Pincode": "416311",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tasgaon",
            "Pincode": "416312",
            "City": "Tasgaon",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tasgaon Gurwar Peth",
            "Pincode": "416312",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tasgaon Somwar Peth",
            "Pincode": "416312",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tasgoan Varchegalli",
            "Pincode": "416312",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Valva",
            "Pincode": "416313",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Visapur",
            "Pincode": "416314",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dudhgaon",
            "Pincode": "416315",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ankalkhop",
            "Pincode": "416316",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manjarda",
            "Pincode": "416317",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yelava",
            "Pincode": "416319",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adumba",
            "Pincode": "416320",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ped",
            "Pincode": "416321",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tung",
            "Pincode": "416322",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arag",
            "Pincode": "416401",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dadhalpur",
            "Pincode": "416402",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhalgaon",
            "Pincode": "416403",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jat",
            "Pincode": "416404",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kavathe Mahankal",
            "Pincode": "416405",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhvnagar",
            "Pincode": "416406",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malgaon",
            "Pincode": "416407",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manerajuri",
            "Pincode": "416408",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhaisal",
            "Pincode": "416409",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Miraj Aydyogik Vasahat",
            "Pincode": "416410",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Miraj Bramhanpuri",
            "Pincode": "416410",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Miraj H O",
            "Pincode": "416410",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Miraj Mangalwarpeth",
            "Pincode": "416410",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Miraj Shaniwar Peth",
            "Pincode": "416410",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Miraj Station Road",
            "Pincode": "416410",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ranjani",
            "Pincode": "416411",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sankh",
            "Pincode": "416412",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wanlesswadi",
            "Pincode": "416414",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Willington College",
            "Pincode": "416415",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangli Factory Area",
            "Pincode": "416416",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangli Gajanan Mills",
            "Pincode": "416416",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangli Ganpati Peth",
            "Pincode": "416416",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangli H O",
            "Pincode": "416416",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangli Market Yard",
            "Pincode": "416416",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangli Old",
            "Pincode": "416416",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangli Radha Krishna Extn",
            "Pincode": "416416",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangli Sakhar Karkhana",
            "Pincode": "416416",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangli Vakharbag",
            "Pincode": "416416",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kavathe Piran",
            "Pincode": "416417",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Salagare",
            "Pincode": "416418",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirdon",
            "Pincode": "416419",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Soni",
            "Pincode": "416420",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhose",
            "Pincode": "416422",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandre",
            "Pincode": "416423",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandve",
            "Pincode": "416423",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kupwada",
            "Pincode": "416425",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khande-Rajuri",
            "Pincode": "416426",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belanki",
            "Pincode": "416428",
            "City": "Sangli",
            "District": "Sangli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dundge",
            "Pincode": "416501",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhinglaj",
            "Pincode": "416502",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahagaon",
            "Pincode": "416503",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nesari",
            "Pincode": "416504",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ajra",
            "Pincode": "416505",
            "City": "Ajra",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Halkarni",
            "Pincode": "416506",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karve",
            "Pincode": "416507",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kowad",
            "Pincode": "416508",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandgad",
            "Pincode": "416509",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sawantwadi H O",
            "Pincode": "416510",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dada Marg",
            "Pincode": "416512",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aronda",
            "Pincode": "416513",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madhukar Sahakari",
            "Pincode": "416514",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madura",
            "Pincode": "416514",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tulas",
            "Pincode": "416515",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vengurla",
            "Pincode": "416516",
            "City": "Vengurla",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Redi",
            "Pincode": "416517",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shiroda",
            "Pincode": "416518",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangaon",
            "Pincode": "416519",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kudal",
            "Pincode": "416520",
            "City": "Kudal",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kadasahkari Sakher",
            "Pincode": "416521",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kadawal",
            "Pincode": "416521",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pat",
            "Pincode": "416522",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Salgaon",
            "Pincode": "416522",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parula",
            "Pincode": "416523",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Valaval",
            "Pincode": "416524",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deulwada Nerur",
            "Pincode": "416525",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Koulge",
            "Pincode": "416526",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilari Nagar",
            "Pincode": "416527",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "I A Pinguli",
            "Pincode": "416528",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talavde",
            "Pincode": "416529",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhedshi",
            "Pincode": "416530",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalmi Street",
            "Pincode": "416531",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amboli",
            "Pincode": "416532",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sukalwadi",
            "Pincode": "416534",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kadgaon",
            "Pincode": "416536",
            "City": "Kolhapur",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aravti",
            "Pincode": "416537",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ajgaon",
            "Pincode": "416538",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Math",
            "Pincode": "416539",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malgaon",
            "Pincode": "416540",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Majgaon",
            "Pincode": "416541",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarambal",
            "Pincode": "416542",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thane",
            "Pincode": "416544",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalmist",
            "Pincode": "416550",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phondaghat",
            "Pincode": "416601",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kankavli",
            "Pincode": "416602",
            "City": "Kankavli",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kankavli Bazar",
            "Pincode": "416602",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasal",
            "Pincode": "416603",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Katta",
            "Pincode": "416604",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chonke",
            "Pincode": "416605",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malvan City",
            "Pincode": "416606",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malvan H O",
            "Pincode": "416606",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kandalgaon",
            "Pincode": "416607",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Masura",
            "Pincode": "416608",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangve",
            "Pincode": "416609",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirgaon Devgad",
            "Pincode": "416610",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jamsande",
            "Pincode": "416612",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devgad",
            "Pincode": "416613",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mithbav",
            "Pincode": "416615",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramgad",
            "Pincode": "416616",
            "City": "Gadchiroli",
            "District": "Gadchiroli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandgaon",
            "Pincode": "416618",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalsuli",
            "Pincode": "416620",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tarkarli",
            "Pincode": "416621",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Peip",
            "Pincode": "416622",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mond",
            "Pincode": "416623",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harkul B K",
            "Pincode": "416624",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harkul K L",
            "Pincode": "416625",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hadi",
            "Pincode": "416626",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambrad",
            "Pincode": "416628",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naringne",
            "Pincode": "416630",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajapur",
            "Pincode": "416702",
            "City": "Rajapur",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharepaten",
            "Pincode": "416703",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pachal",
            "Pincode": "416704",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Oni",
            "Pincode": "416705",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adivri",
            "Pincode": "416707",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sagave",
            "Pincode": "416709",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devache Gothane",
            "Pincode": "416710",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deodhe",
            "Pincode": "416712",
            "City": "Ratnagiri",
            "District": "Ratnagiri",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talera",
            "Pincode": "416801",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kokisra",
            "Pincode": "416802",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mutat",
            "Pincode": "416803",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padel",
            "Pincode": "416804",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vada",
            "Pincode": "416805",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tirlot",
            "Pincode": "416807",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pural",
            "Pincode": "416809",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vaibhavwadi",
            "Pincode": "416810",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vorava Kallu",
            "Pincode": "418010",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ulhasnagar",
            "Pincode": "421001",
            "City": "Ulhasnagar",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Station Rd Ulhas Nagar",
            "Pincode": "421003",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padagha",
            "Pincode": "421101",
            "City": "Padagha",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohane",
            "Pincode": "421102",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahad",
            "Pincode": "421103",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tilaknagar",
            "Pincode": "421201",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vishnunagar",
            "Pincode": "421202",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dombivali Industrial Estate",
            "Pincode": "421203",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manpada",
            "Pincode": "421204",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "421205",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thakurli",
            "Pincode": "421206",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalyan Bandar Rd",
            "Pincode": "421301",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalyan City H O",
            "Pincode": "421301",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalyan Subhash Road",
            "Pincode": "421301",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhiwandi",
            "Pincode": "421302",
            "City": "Bhiwandi",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vada",
            "Pincode": "421303",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalyan S O",
            "Pincode": "421304",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidyashram",
            "Pincode": "421305",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kate Mani Vali",
            "Pincode": "421306",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarawali",
            "Pincode": "421311",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murbad",
            "Pincode": "421401",
            "City": "Murbad",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhasai",
            "Pincode": "421402",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kinholi",
            "Pincode": "421403",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambernath",
            "Pincode": "421501",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambernath South",
            "Pincode": "421501",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "O E Ambarnath",
            "Pincode": "421502",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kulgaon",
            "Pincode": "421503",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badlapur",
            "Pincode": "421504",
            "City": "Badlapur",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Netaji Bazar",
            "Pincode": "421505",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahapur",
            "Pincode": "421601",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kaspara",
            "Pincode": "421602",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatsa Nagar",
            "Pincode": "421603",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Washind",
            "Pincode": "421604",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manda",
            "Pincode": "421605",
            "City": "Thane",
            "District": "Thane",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik Budwar Peth",
            "Pincode": "422001",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik H O",
            "Pincode": "422001",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik Main Rd",
            "Pincode": "422001",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik Ravivarpeth",
            "Pincode": "422001",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik Goley Colony",
            "Pincode": "422002",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik Panchavati",
            "Pincode": "422003",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik",
            "Pincode": "422004",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik H P T College",
            "Pincode": "422005",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik Gandhinagar",
            "Pincode": "422006",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik Ind Estate",
            "Pincode": "422007",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satpur Township",
            "Pincode": "422008",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambad Ind Complex",
            "Pincode": "422010",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bapatla H O",
            "Pincode": "422101",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik Road H O",
            "Pincode": "422101",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik Road I S P",
            "Pincode": "422101",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nasik Road Camp",
            "Pincode": "422102",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sinnar",
            "Pincode": "422103",
            "City": "Sinnar",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wavi",
            "Pincode": "422104",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thermal Power Station",
            "Pincode": "422105",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohadi",
            "Pincode": "422107",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adgaon",
            "Pincode": "422108",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dindori",
            "Pincode": "422202",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girnara",
            "Pincode": "422203",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harsul",
            "Pincode": "422204",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khedgaon",
            "Pincode": "422205",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ozar",
            "Pincode": "422206",
            "City": "Ozar",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ozar Township",
            "Pincode": "422207",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Peint",
            "Pincode": "422208",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpalgaon",
            "Pincode": "422209",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saykheda",
            "Pincode": "422210",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Surgana",
            "Pincode": "422211",
            "City": "Surgana",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Trimbak",
            "Pincode": "422212",
            "City": "Trimbak",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Trimbak Vidya Mandir",
            "Pincode": "422213",
            "City": "Oras",
            "District": "Sindhudurg",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vaitarnanagar",
            "Pincode": "422214",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vani",
            "Pincode": "422215",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palkhed",
            "Pincode": "422216",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhausahed Nagar",
            "Pincode": "422301",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sukena",
            "Pincode": "422302",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Niphad",
            "Pincode": "422303",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vinchur",
            "Pincode": "422305",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lasalgaon",
            "Pincode": "422306",
            "City": "Lasalgaon",
            "District": "Kolhapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deogaon",
            "Pincode": "422307",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deolali",
            "Pincode": "422401",
            "City": "Deolali",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghoti",
            "Pincode": "422402",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Igatpuri",
            "Pincode": "422403",
            "City": "Igatpuri",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandgaon B K",
            "Pincode": "422405",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deolali Air Force",
            "Pincode": "422501",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deolali Bazar",
            "Pincode": "422501",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deolali School Artilary",
            "Pincode": "422501",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhagur",
            "Pincode": "422502",
            "City": "Bhagur",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nashik",
            "Pincode": "422503",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akola",
            "Pincode": "422601",
            "City": "Akola",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhandalphal",
            "Pincode": "422603",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajur",
            "Pincode": "422604",
            "City": "Rajur",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandur Shingota",
            "Pincode": "422605",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangamner",
            "Pincode": "422605",
            "City": "Sangamner",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talegaon Dighe",
            "Pincode": "422607",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangamner Sakar Karkhana",
            "Pincode": "422608",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kotul",
            "Pincode": "422610",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanaj Dumala",
            "Pincode": "422611",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nimon",
            "Pincode": "422615",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jowe",
            "Pincode": "422617",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakur",
            "Pincode": "422619",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghargaon",
            "Pincode": "422620",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandrapur Ordinance",
            "Pincode": "423101",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandwad",
            "Pincode": "423101",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devla",
            "Pincode": "423102",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Laxmiwadi",
            "Pincode": "423103",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manmad",
            "Pincode": "423104",
            "City": "Manmad",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malegaon Camp",
            "Pincode": "423105",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandgaon",
            "Pincode": "423106",
            "City": "Nandgaon",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandgaon Bazar",
            "Pincode": "423106",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rahata",
            "Pincode": "423107",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ravalgaon",
            "Pincode": "423108",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirdi",
            "Pincode": "423109",
            "City": "Shirdi",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadner",
            "Pincode": "423111",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakoze",
            "Pincode": "423114",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahiwad",
            "Pincode": "423116",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadalibhoi",
            "Pincode": "423117",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dabhadi",
            "Pincode": "423201",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girna S S K Dabhadi",
            "Pincode": "423202",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malegaon Market Yard",
            "Pincode": "423203",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malegaon Navapur Ward",
            "Pincode": "423203",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malegaon Sangameshwar",
            "Pincode": "423203",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malegaon Town H O",
            "Pincode": "423203",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nampur",
            "Pincode": "423204",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadnee",
            "Pincode": "423206",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saudane",
            "Pincode": "423208",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bramhangaon",
            "Pincode": "423209",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadel",
            "Pincode": "423210",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aghar B K",
            "Pincode": "423211",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nimbgaon",
            "Pincode": "423212",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lakhampur",
            "Pincode": "423213",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satana",
            "Pincode": "423301",
            "City": "Satana",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Taharabad",
            "Pincode": "423302",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jaikheda",
            "Pincode": "423303",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lohoner",
            "Pincode": "423304",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mulher",
            "Pincode": "423305",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeola",
            "Pincode": "423401",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andarsal",
            "Pincode": "423402",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalvan",
            "Pincode": "423501",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Abhona",
            "Pincode": "423502",
            "City": "Nashik",
            "District": "Nashik",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kopargaon",
            "Pincode": "423601",
            "City": "Kopargaon",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kopargaon Town",
            "Pincode": "423601",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kolpewadi",
            "Pincode": "423602",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shingnapur",
            "Pincode": "423603",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chasnali",
            "Pincode": "423604",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pohegaon",
            "Pincode": "423605",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhamari",
            "Pincode": "423607",
            "City": "Ahmednagar",
            "District": "Ahmednagar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vaijapur",
            "Pincode": "423701",
            "City": "Vaijapur",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lasur Stn",
            "Pincode": "423702",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandaly",
            "Pincode": "423704",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhule Chaini Road",
            "Pincode": "424001",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhule City",
            "Pincode": "424001",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhule Collectorate",
            "Pincode": "424001",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhule H O",
            "Pincode": "424001",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhule N P Mills",
            "Pincode": "424001",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhule Station Roa",
            "Pincode": "424001",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhule Devpur",
            "Pincode": "424002",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhule Jaihind Colony",
            "Pincode": "424002",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhule Station Road",
            "Pincode": "424003",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhule",
            "Pincode": "424004",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidarbha Maha",
            "Pincode": "424005",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidyanagari",
            "Pincode": "424005",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chalisgaon Bazar",
            "Pincode": "424101",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chalisgaon H O",
            "Pincode": "424101",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patonda",
            "Pincode": "424102",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kaigaon",
            "Pincode": "424103",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagou Deda",
            "Pincode": "424104",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhadgaon",
            "Pincode": "424105",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mehunbara",
            "Pincode": "424106",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khedgaon",
            "Pincode": "424107",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hirapur",
            "Pincode": "424108",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karkhana",
            "Pincode": "424116",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chalisgaon Town",
            "Pincode": "424117",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pachora",
            "Pincode": "424201",
            "City": "Pachora",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Varkhedi",
            "Pincode": "424202",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpalgaon B K",
            "Pincode": "424203",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pahur",
            "Pincode": "424205",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jamner",
            "Pincode": "424206",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vakadi",
            "Pincode": "424207",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fattepur",
            "Pincode": "424208",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lohare",
            "Pincode": "424209",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahapur",
            "Pincode": "424210",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fagna",
            "Pincode": "424301",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kusumba",
            "Pincode": "424302",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ner",
            "Pincode": "424303",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nizampur",
            "Pincode": "424304",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakri",
            "Pincode": "424304",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpalner",
            "Pincode": "424306",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapadna",
            "Pincode": "424307",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirud",
            "Pincode": "424308",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Songir",
            "Pincode": "424309",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasara",
            "Pincode": "424310",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohadi Laling",
            "Pincode": "424311",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bozis",
            "Pincode": "424313",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mukti",
            "Pincode": "424315",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalgaon Bazar",
            "Pincode": "425001",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalgaon Collectorate",
            "Pincode": "425001",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalgaon H O",
            "Pincode": "425001",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalgaon Navipeth",
            "Pincode": "425001",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalgaon Peth",
            "Pincode": "425001",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalgaon Poona File",
            "Pincode": "425001",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalgaon Rampeth",
            "Pincode": "425001",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalgaon Industrial Estate",
            "Pincode": "425002",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Asoda",
            "Pincode": "425101",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhadli",
            "Pincode": "425102",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paldhi",
            "Pincode": "425103",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpri Khurd",
            "Pincode": "425104",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dharangaon",
            "Pincode": "425105",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanded",
            "Pincode": "425106",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chopada",
            "Pincode": "425107",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akulkheda",
            "Pincode": "425108",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Erandol",
            "Pincode": "425109",
            "City": "Erandol",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kasoda",
            "Pincode": "425110",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parola",
            "Pincode": "425111",
            "City": "Parola",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Devgaon",
            "Pincode": "425112",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bahadarpur",
            "Pincode": "425113",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Neri Budruk",
            "Pincode": "425114",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandra Pachora",
            "Pincode": "425115",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhasvad",
            "Pincode": "425116",
            "City": "Satara",
            "District": "Satara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paldhi Pahur",
            "Pincode": "425119",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kanalda",
            "Pincode": "425120",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Salve",
            "Pincode": "425121",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Savkheda",
            "Pincode": "425122",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hated",
            "Pincode": "425124",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kadgaon",
            "Pincode": "425125",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirjoli",
            "Pincode": "425126",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adgaon Jalgaon",
            "Pincode": "425127",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Virawada",
            "Pincode": "425130",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghadgaon",
            "Pincode": "425133",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhusawal Ath Awale Bazar",
            "Pincode": "425201",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhusawal H O",
            "Pincode": "425201",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhusawal Kutchery",
            "Pincode": "425201",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhusawal Shivaijinagar",
            "Pincode": "425201",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shendurdi",
            "Pincode": "425204",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tondapur",
            "Pincode": "425211",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yaval",
            "Pincode": "425301",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakli",
            "Pincode": "425302",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Advad",
            "Pincode": "425303",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhalod",
            "Pincode": "425304",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Varangaon",
            "Pincode": "425305",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Edalabad",
            "Pincode": "425306",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deep Nagar",
            "Pincode": "425307",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Varangaon Ordnance Fact",
            "Pincode": "425308",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nashirabad",
            "Pincode": "425309",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurha",
            "Pincode": "425311",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurla",
            "Pincode": "425311",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Changdeo",
            "Pincode": "425315",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kirgaon",
            "Pincode": "425318",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Salsingi",
            "Pincode": "425320",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahigaon",
            "Pincode": "425323",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangvi",
            "Pincode": "425326",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amalner",
            "Pincode": "425401",
            "City": "Amalner",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandana",
            "Pincode": "425404",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirpur",
            "Pincode": "425405",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sinkheda",
            "Pincode": "425406",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chimthan",
            "Pincode": "425407",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dondalicha R S",
            "Pincode": "425408",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahade",
            "Pincode": "425409",
            "City": "Shahade",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahde",
            "Pincode": "425409",
            "City": "Nandurbar",
            "District": "Nandurbar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sarankheda",
            "Pincode": "425410",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ranala",
            "Pincode": "425411",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandurbar",
            "Pincode": "425412",
            "City": "Nandurbar",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandurbar",
            "Pincode": "425412",
            "City": "Nandurbar",
            "District": "Nandurbar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandurbar Kutchery",
            "Pincode": "425412",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandurbar Kutchery",
            "Pincode": "425412",
            "City": "Nandurbar",
            "District": "Nandurbar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talode",
            "Pincode": "425413",
            "City": "Talode",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talode",
            "Pincode": "425413",
            "City": "Nandurbar",
            "District": "Nandurbar",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akka Lkuwa",
            "Pincode": "425415",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinchpada",
            "Pincode": "425417",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navapur",
            "Pincode": "425418",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khapar",
            "Pincode": "425419",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amalgaon",
            "Pincode": "425420",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thalner",
            "Pincode": "425421",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Prakasha",
            "Pincode": "425422",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadali",
            "Pincode": "425423",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Purushottam Nagar Shahada",
            "Pincode": "425424",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Visarwadi",
            "Pincode": "425426",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mhasvad",
            "Pincode": "425432",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chahardi",
            "Pincode": "425434",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Juhave",
            "Pincode": "425435",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patroda",
            "Pincode": "425436",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangrul",
            "Pincode": "425437",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahiwadi",
            "Pincode": "425438",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandal",
            "Pincode": "425439",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barad",
            "Pincode": "425442",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mondane",
            "Pincode": "425444",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Boradi",
            "Pincode": "425448",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhanara",
            "Pincode": "425450",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Thargavan",
            "Pincode": "425501",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Savda",
            "Pincode": "425502",
            "City": "Savda",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Faizpur",
            "Pincode": "425503",
            "City": "Faizpur",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khireda",
            "Pincode": "425504",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chinaval",
            "Pincode": "425505",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nimbhara",
            "Pincode": "425506",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khirdi",
            "Pincode": "425507",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raver",
            "Pincode": "425508",
            "City": "Raver",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ainpur",
            "Pincode": "425509",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nisavi",
            "Pincode": "425511",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pal",
            "Pincode": "425512",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hingona",
            "Pincode": "425515",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padalsa",
            "Pincode": "425519",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khanapur",
            "Pincode": "425521",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amode",
            "Pincode": "425522",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vivra",
            "Pincode": "425523",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakhar Karkhana",
            "Pincode": "425524",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aurangabad H O",
            "Pincode": "431001",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aurangabad Cantt",
            "Pincode": "431002",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marathwada Vidyapeeth",
            "Pincode": "431004",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kranti Chowk",
            "Pincode": "431005",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khuldabad",
            "Pincode": "431101",
            "City": "Khuldabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ellova",
            "Pincode": "431102",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Engineering College",
            "Pincode": "431102",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Velur",
            "Pincode": "431102",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kannad",
            "Pincode": "431103",
            "City": "Kannad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pishore",
            "Pincode": "431104",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bid Kingaon",
            "Pincode": "431105",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paithan",
            "Pincode": "431107",
            "City": "Paithan",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nathnagar South",
            "Pincode": "431108",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gangapur",
            "Pincode": "431109",
            "City": "Gangapur",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raghunathnagar",
            "Pincode": "431110",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phulamrai",
            "Pincode": "431111",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sillod",
            "Pincode": "431112",
            "City": "Sillod",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhanadi",
            "Pincode": "431113",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhokardan",
            "Pincode": "431114",
            "City": "Bhokardan",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deogaon Ranian",
            "Pincode": "431115",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shiver",
            "Pincode": "431116",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ajintha",
            "Pincode": "431117",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phardapur",
            "Pincode": "431118",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Harsool",
            "Pincode": "431119",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pachod",
            "Pincode": "431121",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhir",
            "Pincode": "431122",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhir H O",
            "Pincode": "431122",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhir Market Yard",
            "Pincode": "431122",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhir Mehboobgunj",
            "Pincode": "431122",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhir Rajuri Ves",
            "Pincode": "431122",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhandipura",
            "Pincode": "431122",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kaij",
            "Pincode": "431123",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Fateha Bad",
            "Pincode": "431124",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naiknoor",
            "Pincode": "431125",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chansala",
            "Pincode": "431126",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gevarai",
            "Pincode": "431127",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gevarai Mondha",
            "Pincode": "431127",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dindroad",
            "Pincode": "431128",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talkhed",
            "Pincode": "431129",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manjlalegaon",
            "Pincode": "431131",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivna",
            "Pincode": "431132",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Waluj",
            "Pincode": "431133",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badod Bazar",
            "Pincode": "431134",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sillod Sakhar Karkhana",
            "Pincode": "431135",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bihmanwa",
            "Pincode": "431137",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ajanta Caves",
            "Pincode": "431138",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikha Thana",
            "Pincode": "431139",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandala",
            "Pincode": "431140",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kesapuri Camp",
            "Pincode": "431142",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathrud",
            "Pincode": "431144",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yellam Ghat",
            "Pincode": "431145",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagad",
            "Pincode": "431146",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chincholi Limbaji",
            "Pincode": "431147",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paithan Sugar Factory",
            "Pincode": "431148",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Banoti",
            "Pincode": "431150",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andhari",
            "Pincode": "431151",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikhalthana",
            "Pincode": "431201",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikhalthana Indl",
            "Pincode": "431201",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badnapur",
            "Pincode": "431202",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalan R S",
            "Pincode": "431203",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalna Ambika Bazar",
            "Pincode": "431203",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalna H O",
            "Pincode": "431203",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalna Ind Estate",
            "Pincode": "431203",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalna Mondha",
            "Pincode": "431203",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalna Old",
            "Pincode": "431203",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalna Rakhiv Police",
            "Pincode": "431203",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambad",
            "Pincode": "431204",
            "City": "Ambad",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambad Bazar",
            "Pincode": "431204",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadigodri",
            "Pincode": "431205",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jaffarabad",
            "Pincode": "431206",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ranjani",
            "Pincode": "431207",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tembhurni",
            "Pincode": "431208",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikhalthana I A",
            "Pincode": "431210",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karmad",
            "Pincode": "431212",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpri",
            "Pincode": "431213",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpri Chinchwad",
            "Pincode": "431213",
            "City": "Pimpri Chinchwad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parbhani H O",
            "Pincode": "431401",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parbhani Kranti Chowk",
            "Pincode": "431401",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parbhani Mangalwadi",
            "Pincode": "431401",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parbhani Naya Mondha",
            "Pincode": "431401",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Marathwada A Uni Parbhani",
            "Pincode": "431402",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parbhani Station",
            "Pincode": "431402",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Partur",
            "Pincode": "431501",
            "City": "Partur",
            "District": "Aurangabad",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satona",
            "Pincode": "431502",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sailu",
            "Pincode": "431503",
            "City": "Sailu",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mantha",
            "Pincode": "431504",
            "City": "Jalgaon",
            "District": "Jalgaon",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manwath",
            "Pincode": "431505",
            "City": "Manwath",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathri",
            "Pincode": "431506",
            "City": "Pathri",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashti",
            "Pincode": "431507",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bori",
            "Pincode": "431508",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jintur",
            "Pincode": "431509",
            "City": "Jintur",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeldari",
            "Pincode": "431510",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Purna",
            "Pincode": "431511",
            "City": "Purna",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Basmata Nagar",
            "Pincode": "431512",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hingoli",
            "Pincode": "431513",
            "City": "Hingoli",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gangakhed",
            "Pincode": "431514",
            "City": "Gangakhed",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parli Vaijanath",
            "Pincode": "431515",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonpeth",
            "Pincode": "431516",
            "City": "Sonpeth",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambejogai",
            "Pincode": "431517",
            "City": "Ambejogai",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambejogai Mandi Bazar",
            "Pincode": "431517",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghatnandur",
            "Pincode": "431519",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parli Thermal Power Stati",
            "Pincode": "431520",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pangaon",
            "Pincode": "431522",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amba Sakhar",
            "Pincode": "431523",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patoda B K",
            "Pincode": "431524",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ballur",
            "Pincode": "431526",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kousadi",
            "Pincode": "431527",
            "City": "Latur",
            "District": "Latur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bavdapur",
            "Pincode": "431528",
            "City": "Beed",
            "District": "Beed",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanded",
            "Pincode": "431531",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pedgaon",
            "Pincode": "431537",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Zari",
            "Pincode": "431540",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rampuri B K",
            "Pincode": "431541",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanded H O",
            "Pincode": "431601",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanded J P Marg",
            "Pincode": "431601",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanded Naya Mondha",
            "Pincode": "431601",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanded Sarafa",
            "Pincode": "431601",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanded Snehnagar",
            "Pincode": "431601",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nanded Town",
            "Pincode": "431601",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivajinagar",
            "Pincode": "431602",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Itwara",
            "Pincode": "431604",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akhada Balapur",
            "Pincode": "431701",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaon",
            "Pincode": "431703",
            "City": "Goregaon",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ardhapur",
            "Pincode": "431704",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aundha Nagnath",
            "Pincode": "431705",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "431706",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Osmannagar",
            "Pincode": "431707",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Loha",
            "Pincode": "431708",
            "City": "Loha",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naigaon",
            "Pincode": "431709",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kundalwadi",
            "Pincode": "431711",
            "City": "Kundalwadi",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hadgaon",
            "Pincode": "431712",
            "City": "Hadgaon",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tamsa",
            "Pincode": "431713",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mukhed",
            "Pincode": "431715",
            "City": "Mukhed",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Degloor",
            "Pincode": "431717",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karadkhed",
            "Pincode": "431718",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mukramabad",
            "Pincode": "431719",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palam",
            "Pincode": "431720",
            "City": "Parbhani",
            "District": "Parbhani",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahore",
            "Pincode": "431721",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gadga",
            "Pincode": "431722",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahapur",
            "Pincode": "431723",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonkhed",
            "Pincode": "431725",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kuttur",
            "Pincode": "431726",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sagroli",
            "Pincode": "431731",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lohgaon",
            "Pincode": "431732",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badba Da",
            "Pincode": "431733",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wai",
            "Pincode": "431734",
            "City": "Wai",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Limbgaon",
            "Pincode": "431735",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirad Sholapur",
            "Pincode": "431737",
            "City": "Sholapur",
            "District": "Sholapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hatta",
            "Pincode": "431738",
            "City": "Hingoli",
            "District": "Hingoli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Raher",
            "Pincode": "431740",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanegaon",
            "Pincode": "431741",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurla",
            "Pincode": "431742",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Niwgha",
            "Pincode": "431743",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pethwadaj",
            "Pincode": "431744",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barad",
            "Pincode": "431745",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barul",
            "Pincode": "431746",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhokar",
            "Pincode": "431801",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Himayat Nagar",
            "Pincode": "431802",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Islampur",
            "Pincode": "431803",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karkheli",
            "Pincode": "431803",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kinwat",
            "Pincode": "431804",
            "City": "Kinwat",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandvi",
            "Pincode": "431805",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mudkhed Stn",
            "Pincode": "431806",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umri",
            "Pincode": "431807",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dharmabad",
            "Pincode": "431809",
            "City": "Dharmabad",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umri",
            "Pincode": "431811",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mugal",
            "Pincode": "431812",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sind Khep",
            "Pincode": "431814",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivani",
            "Pincode": "431815",
            "City": "Nanded",
            "District": "Nanded",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Abhyankar Nagar",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Bhantali",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Bureau Of Mines",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Congress Nagar",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Gandhinagar",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Giripeth",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Gokulpeth",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Gpo",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Hit Wada",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Kasturchand Park",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Khare Town",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Medical College",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Model Mills",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Mohannagar",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Netaji Market",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur New Colony",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur New Mla Hostel",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Ramdss Peth",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Ravinagar",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Sadar Bazar",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Shradhanand Peth",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Sitabuldi",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Times",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Vishvakarma Nagar",
            "Pincode": "440001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Ayachit Mandir",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Chitnispura",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur City H O",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Ganjakhet",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Ganjipeth",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Imambada",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Mahul",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Maska Suth",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Mehdi Bag Rd",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Momimpura",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Nayapura",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Panchsheel Nagar",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Raje Raghuji Nagar",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Shanichara",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur Tilak Statue",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpure Tin Nal",
            "Pincode": "440002",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ajni",
            "Pincode": "440003",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bezonabaugh",
            "Pincode": "440004",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Air Port Nagpur",
            "Pincode": "440005",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Seminary Hills",
            "Pincode": "440006",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vayusenanagar",
            "Pincode": "440007",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bagadgani",
            "Pincode": "440008",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bagladganj",
            "Pincode": "440008",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Nagar",
            "Pincode": "440009",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shankar Nagar",
            "Pincode": "440010",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Engineering College Nag",
            "Pincode": "440011",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patwardhan Ground",
            "Pincode": "440012",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Katol Road",
            "Pincode": "440013",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jari Patka",
            "Pincode": "440014",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur",
            "Pincode": "440015",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "440016",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur",
            "Pincode": "440016",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagpur",
            "Pincode": "440017",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Central Avenue Road",
            "Pincode": "440018",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N E E R I",
            "Pincode": "440020",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "A D Project",
            "Pincode": "440021",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ambazari Deb Project",
            "Pincode": "440021",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Laxminagar",
            "Pincode": "440022",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadi",
            "Pincode": "440023",
            "City": "Wadi",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ayodhya Nagar",
            "Pincode": "440024",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khamla",
            "Pincode": "440025",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Industrial Estate Nagpur",
            "Pincode": "440026",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parvati Nagar",
            "Pincode": "440027",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N A D T",
            "Pincode": "440029",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "N I O Donapaula",
            "Pincode": "440029",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kamptee Camp",
            "Pincode": "441001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kamptee Guards Trg Centre",
            "Pincode": "441001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kamptee Gujri Bazar",
            "Pincode": "441001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kamptee H O",
            "Pincode": "441001",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khapa",
            "Pincode": "441101",
            "City": "Khapa",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khapar Khed",
            "Pincode": "441102",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Buti Bari",
            "Pincode": "441103",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cidco Colony",
            "Pincode": "441103",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kondhali",
            "Pincode": "441103",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manda",
            "Pincode": "441104",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parseoni",
            "Pincode": "441105",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ramtek",
            "Pincode": "441106",
            "City": "Ramtek",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Savner",
            "Pincode": "441107",
            "City": "Savner",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sillewarg",
            "Pincode": "441109",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hingna",
            "Pincode": "441110",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karodi",
            "Pincode": "441111",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Koradi",
            "Pincode": "441111",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kelavad",
            "Pincode": "441112",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gumgaon",
            "Pincode": "441114",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bela",
            "Pincode": "441115",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gaimuch Nande",
            "Pincode": "441116",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umri",
            "Pincode": "441117",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhiwapur",
            "Pincode": "441201",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kuhi",
            "Pincode": "441202",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umred",
            "Pincode": "441203",
            "City": "Umred",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umred Bazar",
            "Pincode": "441203",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umred Project",
            "Pincode": "441204",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagbhir",
            "Pincode": "441205",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "B S K Madhukarnagar Patas",
            "Pincode": "441206",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Brahampuri",
            "Pincode": "441206",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Desaigunj",
            "Pincode": "441207",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Armori",
            "Pincode": "441208",
            "City": "Gadchiroli",
            "District": "Gadchiroli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurkhoda",
            "Pincode": "441209",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mandhal",
            "Pincode": "441210",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajoli",
            "Pincode": "441213",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathri",
            "Pincode": "441215",
            "City": "Pathri",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nand",
            "Pincode": "441216",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talodhi Balapur",
            "Pincode": "441221",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Taloje Audyogik",
            "Pincode": "441221",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sinde Wahi",
            "Pincode": "441222",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Navargaon",
            "Pincode": "441223",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mul",
            "Pincode": "441224",
            "City": "Mul",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saoli",
            "Pincode": "441225",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalalkheda",
            "Pincode": "441301",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Katol",
            "Pincode": "441302",
            "City": "Katol",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mowad",
            "Pincode": "441303",
            "City": "Mowad",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Narkher",
            "Pincode": "441304",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paradsinga",
            "Pincode": "441305",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sawargaon",
            "Pincode": "441306",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kanan Pipri",
            "Pincode": "441401",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandelwal Nagar",
            "Pincode": "441402",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Totladoh",
            "Pincode": "441403",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kamthi Colliery",
            "Pincode": "441404",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khat R S",
            "Pincode": "441405",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mansar",
            "Pincode": "441406",
            "City": "Mansar",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deolapur",
            "Pincode": "441408",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Panni",
            "Pincode": "441409",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalmeshwar",
            "Pincode": "441501",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohpa",
            "Pincode": "441502",
            "City": "Mohpa",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhapewada",
            "Pincode": "441503",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gondia Bazar",
            "Pincode": "441601",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gondia City",
            "Pincode": "441601",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gondia Civil Lines H O",
            "Pincode": "441601",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gondia Sindhi Colony",
            "Pincode": "441601",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Komatha",
            "Pincode": "441602",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Davaniwada",
            "Pincode": "441604",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mundikota R S",
            "Pincode": "441605",
            "City": "Bhandara",
            "District": "Gondia",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yekodi",
            "Pincode": "441606",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arjuni Moregaon",
            "Pincode": "441701",
            "City": "Bhandara",
            "District": "Gondia",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nawegaon Bandh",
            "Pincode": "441702",
            "City": "Bhandara",
            "District": "Gondia",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Goregaon",
            "Pincode": "441801",
            "City": "Goregaon",
            "District": "Gondia",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lakhandul",
            "Pincode": "441803",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lakhani",
            "Pincode": "441804",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dighori",
            "Pincode": "441805",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Saundur",
            "Pincode": "441806",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sondur",
            "Pincode": "441806",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadakarjuni",
            "Pincode": "441807",
            "City": "Nagpur",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangadi",
            "Pincode": "441808",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Phra",
            "Pincode": "441809",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Palandur",
            "Pincode": "441811",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deori",
            "Pincode": "441901",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amgaon",
            "Pincode": "441902",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adyar",
            "Pincode": "441903",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandara H O",
            "Pincode": "441904",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandara Town",
            "Pincode": "441904",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandara Ordinance Fact",
            "Pincode": "441905",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhandara Road",
            "Pincode": "441905",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gobarwahi",
            "Pincode": "441907",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kondha Kosra",
            "Pincode": "441908",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohadi",
            "Pincode": "441909",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pavani",
            "Pincode": "441910",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tirora",
            "Pincode": "441911",
            "City": "Tirora",
            "District": "Nagpur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tumsar",
            "Pincode": "441912",
            "City": "Tumsar",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tumsar Road",
            "Pincode": "441913",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Andhalgaon",
            "Pincode": "441914",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sehaza",
            "Pincode": "441915",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Salekasa",
            "Pincode": "441916",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kardi",
            "Pincode": "441917",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Naka Dongri",
            "Pincode": "441918",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Asgaon",
            "Pincode": "441919",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadegaon",
            "Pincode": "441919",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kattipar",
            "Pincode": "441920",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shahpur",
            "Pincode": "441920",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikhda",
            "Pincode": "441921",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Satgaon",
            "Pincode": "441921",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amgaon Dighori",
            "Pincode": "441922",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghangla",
            "Pincode": "441923",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pahela",
            "Pincode": "441924",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lohara",
            "Pincode": "441930",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wardha H O",
            "Pincode": "442001",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wardha Mkt",
            "Pincode": "442001",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wardha R Tagorenagar",
            "Pincode": "442001",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wardha Ramnagar",
            "Pincode": "442001",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hindi Nagar",
            "Pincode": "442003",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manas Mandir Wardha",
            "Pincode": "442005",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "M I D C Wardha",
            "Pincode": "442006",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deoli",
            "Pincode": "442101",
            "City": "Deoli",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sevagram",
            "Pincode": "442102",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anji",
            "Pincode": "442103",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindi",
            "Pincode": "442105",
            "City": "Sindi",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kharangana",
            "Pincode": "442106",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahegaon Gosavi",
            "Pincode": "442110",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paunar",
            "Pincode": "442111",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arvi",
            "Pincode": "442201",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandori",
            "Pincode": "442201",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashti",
            "Pincode": "442202",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karanja",
            "Pincode": "442203",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Selu",
            "Pincode": "442204",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talegaon",
            "Pincode": "442204",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wardha Maneri",
            "Pincode": "442205",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadhona",
            "Pincode": "442207",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hinganghat",
            "Pincode": "442301",
            "City": "Hinganghat",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pulgaon",
            "Pincode": "442302",
            "City": "Pulgaon",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pulgaon Camp",
            "Pincode": "442303",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Allipur",
            "Pincode": "442304",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Samudrapur",
            "Pincode": "442305",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nachangaon",
            "Pincode": "442306",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadner",
            "Pincode": "442307",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wagholi",
            "Pincode": "442308",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Girad",
            "Pincode": "442310",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandarpur",
            "Pincode": "442401",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandrapur",
            "Pincode": "442401",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandrapur Civil Lines",
            "Pincode": "442401",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandrapur H O",
            "Pincode": "442401",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathanpura",
            "Pincode": "442401",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shastrinagar",
            "Pincode": "442401",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandrapur City",
            "Pincode": "442402",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bapupeth",
            "Pincode": "442403",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandrapur Bapu Peth",
            "Pincode": "442403",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Cement Nagar",
            "Pincode": "442502",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivajinagar",
            "Pincode": "442503",
            "City": "Shivajinagar",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sironcha",
            "Pincode": "442504",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pambhurna",
            "Pincode": "442506",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chamorshi",
            "Pincode": "442603",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghot",
            "Pincode": "442604",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gadchiroli",
            "Pincode": "442605",
            "City": "Gadchiroli",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ballarpur",
            "Pincode": "442701",
            "City": "Ballarpur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gondpipri",
            "Pincode": "442702",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Allapalli",
            "Pincode": "442703",
            "City": "Gadchiroli",
            "District": "Gadchiroli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aderi",
            "Pincode": "442705",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sasti",
            "Pincode": "442706",
            "City": "Sasti",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ballarpur Paper Mills",
            "Pincode": "442901",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhadravati",
            "Pincode": "442902",
            "City": "Bhadravati",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chimpur",
            "Pincode": "442903",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Neri",
            "Pincode": "442904",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajura Manik Garh",
            "Pincode": "442905",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Segaon",
            "Pincode": "442906",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Waroda",
            "Pincode": "442907",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandur",
            "Pincode": "442908",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madheli",
            "Pincode": "442910",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nagri",
            "Pincode": "442912",
            "City": "Gadchiroli",
            "District": "Gadchiroli",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhisi",
            "Pincode": "442913",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anandwan",
            "Pincode": "442914",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Warsadi",
            "Pincode": "442916",
            "City": "Chandrapur",
            "District": "Chandrapur",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Buldana H O",
            "Pincode": "443001",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malkapur",
            "Pincode": "443101",
            "City": "Malkapur",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malkapur City",
            "Pincode": "443101",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Datala",
            "Pincode": "443102",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mothala",
            "Pincode": "443103",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhamangaon Bada",
            "Pincode": "443104",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deul Gaon Ghai",
            "Pincode": "443105",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhad",
            "Pincode": "443106",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Padli",
            "Pincode": "443107",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakli",
            "Pincode": "443108",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirpur",
            "Pincode": "443110",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dharangaon",
            "Pincode": "443112",
            "City": "Dharangaon",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikhli Buldana",
            "Pincode": "443201",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sakhar Kherda",
            "Pincode": "443202",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindkhed Raja",
            "Pincode": "443203",
            "City": "Sindkhed Raja",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deolgaon Raja",
            "Pincode": "443204",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deul Gaon Mahi",
            "Pincode": "443206",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sawana",
            "Pincode": "443207",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bibi",
            "Pincode": "443209",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mehekar",
            "Pincode": "443301",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bisharatganj",
            "Pincode": "443302",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lonar",
            "Pincode": "443302",
            "City": "Lonar",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dongaon",
            "Pincode": "443303",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Janephal",
            "Pincode": "443304",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amraoti Shivaji Nagar",
            "Pincode": "443305",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amraoti Takhatmal Estate",
            "Pincode": "443305",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amraoti Walgaon Road",
            "Pincode": "443305",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anjani B K",
            "Pincode": "443305",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ded Gaon",
            "Pincode": "443306",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Deulgaon Mali",
            "Pincode": "443306",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sultanpur",
            "Pincode": "443307",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dusarbid",
            "Pincode": "443308",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandur Biswa",
            "Pincode": "443401",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalgaon Buldana",
            "Pincode": "443402",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpalgaon Kale",
            "Pincode": "443403",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandura",
            "Pincode": "443404",
            "City": "Nandura",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadner Bholaji",
            "Pincode": "443405",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jamod",
            "Pincode": "443406",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Madakhed",
            "Pincode": "443407",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akola Bazar",
            "Pincode": "444001",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akola H O",
            "Pincode": "444001",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akola Ramdas Peth",
            "Pincode": "444001",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akola Tajna Peth",
            "Pincode": "444001",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akola Tilak Rd",
            "Pincode": "444001",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akola City",
            "Pincode": "444002",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "444003",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "444004",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vanasada",
            "Pincode": "444005",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akot",
            "Pincode": "444101",
            "City": "Akot",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akot Kutchery",
            "Pincode": "444101",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Borgaon Manju",
            "Pincode": "444102",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hiwarkhed Ruprao",
            "Pincode": "444103",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Krishnagar",
            "Pincode": "444104",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karanja",
            "Pincode": "444105",
            "City": "Karanja",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mana",
            "Pincode": "444106",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murtizapur",
            "Pincode": "444107",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Murtizapur City",
            "Pincode": "444107",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Telhara",
            "Pincode": "444108",
            "City": "Telhara",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Akola Bazar",
            "Pincode": "444109",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kamargaon",
            "Pincode": "444110",
            "City": "Washim",
            "District": "Washim",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dahihanda",
            "Pincode": "444111",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Durgwada",
            "Pincode": "444112",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kuvum",
            "Pincode": "444115",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mundgaon",
            "Pincode": "444117",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nimbhaza",
            "Pincode": "444118",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangvi Kr",
            "Pincode": "444120",
            "City": "Dhule",
            "District": "Dhule",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umra",
            "Pincode": "444121",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umbarda Bazar",
            "Pincode": "444122",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapshi",
            "Pincode": "444123",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Savara",
            "Pincode": "444124",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chohotta",
            "Pincode": "444125",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Adgaon B K",
            "Pincode": "444126",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paturda",
            "Pincode": "444201",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sangrampur",
            "Pincode": "444202",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shegaon",
            "Pincode": "444203",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sonala",
            "Pincode": "444204",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amrapur",
            "Pincode": "444301",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balapur",
            "Pincode": "444302",
            "City": "Balapur",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Balpur",
            "Pincode": "444302",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khamgaon H O",
            "Pincode": "444303",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khamgaon Kalanagar",
            "Pincode": "444303",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khamgaon Lakadgunj",
            "Pincode": "444303",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khamgaon Saraba",
            "Pincode": "444303",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pimpalgaon Raja",
            "Pincode": "444306",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Undri",
            "Pincode": "444307",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jalamb",
            "Pincode": "444308",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nimba",
            "Pincode": "444311",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "G S College Khamgaon",
            "Pincode": "444312",
            "City": "Buldhana",
            "District": "Buldhana",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Barsi Takli",
            "Pincode": "444401",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shelu Bazar",
            "Pincode": "444402",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangrukpir",
            "Pincode": "444403",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manora",
            "Pincode": "444404",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahan",
            "Pincode": "444405",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pinjar",
            "Pincode": "444407",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Asegaon",
            "Pincode": "444409",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patur",
            "Pincode": "444501",
            "City": "Patur",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vadegaon",
            "Pincode": "444502",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Malegaon",
            "Pincode": "444503",
            "City": "Malegaon",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sizpur",
            "Pincode": "444504",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Washim",
            "Pincode": "444505",
            "City": "Washim",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Washim City",
            "Pincode": "444505",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Washim Mkt Yard",
            "Pincode": "444505",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Risod",
            "Pincode": "444506",
            "City": "Risod",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ansing",
            "Pincode": "444507",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jaulka",
            "Pincode": "444508",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rithad",
            "Pincode": "444510",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Alegaon",
            "Pincode": "444511",
            "City": "Akola",
            "District": "Akola",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Aamraoti Rukhmininagar",
            "Pincode": "444601",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amraoti Ambapeth",
            "Pincode": "444601",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amraoti Bhajibazar",
            "Pincode": "444601",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amraoti Cotton Market",
            "Pincode": "444601",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amraoti H O",
            "Pincode": "444601",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amraoti New Cotton Mkt",
            "Pincode": "444601",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amraoti Rajapeth",
            "Pincode": "444601",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Amraoti Camp",
            "Pincode": "444602",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shivajinagar Hamraoti)",
            "Pincode": "444603",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Vidyalata",
            "Pincode": "444604",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hanuman Vyayam Nagar",
            "Pincode": "444605",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Badnera",
            "Pincode": "444701",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bandnera",
            "Pincode": "444701",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dharni",
            "Pincode": "444702",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tapovan",
            "Pincode": "444703",
            "City": "Jalna",
            "District": "Jalna",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandur Bazar",
            "Pincode": "444704",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anjangaon",
            "Pincode": "444705",
            "City": "Anjangaon",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeoda",
            "Pincode": "444706",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nerpinglli",
            "Pincode": "444707",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandgaon Kazi",
            "Pincode": "444708",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhamangaon R S",
            "Pincode": "444709",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gadhi",
            "Pincode": "444709",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Talegaon Dashasar",
            "Pincode": "444710",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mangrul Dastagir",
            "Pincode": "444711",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dangaon",
            "Pincode": "444712",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kapustalani",
            "Pincode": "444713",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rithapur",
            "Pincode": "444716",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhamangaon",
            "Pincode": "444717",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Belora",
            "Pincode": "444718",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bhatkuli",
            "Pincode": "444721",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sizasgaon Band",
            "Pincode": "444723",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Anjangaon Bari",
            "Pincode": "444727",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Walgaon",
            "Pincode": "444801",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kholapur",
            "Pincode": "444802",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Daryapur",
            "Pincode": "444803",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dayapur Town",
            "Pincode": "444803",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Purnanagar",
            "Pincode": "444804",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Paratwada H O",
            "Pincode": "444805",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Achalpur Cotton Market",
            "Pincode": "444806",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chikhaldara",
            "Pincode": "444807",
            "City": "Chikhaldara",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pathaot",
            "Pincode": "444808",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Karaigaon",
            "Pincode": "444809",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirasgaon Kasaba",
            "Pincode": "444810",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khallar",
            "Pincode": "444811",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Behoda",
            "Pincode": "444812",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Darapur",
            "Pincode": "444814",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wathoda Sukleshwar",
            "Pincode": "444815",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sayal",
            "Pincode": "444816",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kokarda",
            "Pincode": "444818",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadher Gandhi",
            "Pincode": "444819",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shirala",
            "Pincode": "444821",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Takarkheda",
            "Pincode": "444826",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Asegaon",
            "Pincode": "444827",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nandgaon Peth",
            "Pincode": "444901",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gurukunj Ashram",
            "Pincode": "444902",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Tlosa",
            "Pincode": "444903",
            "City": "Bhandara",
            "District": "Bhandara",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Chandur Vattikodu",
            "Pincode": "444904",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Morshi",
            "Pincode": "444905",
            "City": "Morshi",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Warud",
            "Pincode": "444906",
            "City": "Warud",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Warud Mkt",
            "Pincode": "444906",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Shendurjanaghat",
            "Pincode": "444907",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jarud",
            "Pincode": "444908",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kurha",
            "Pincode": "444909",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Hiwarkhed",
            "Pincode": "444914",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yavali",
            "Pincode": "444915",
            "City": "Amraoti",
            "District": "Amraoti",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeotmal Awdhutwadi",
            "Pincode": "445001",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeotmal H O",
            "Pincode": "445001",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeotmal Tilakwadi",
            "Pincode": "445001",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Yeotmal Toron",
            "Pincode": "445001",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Govt Polytechnic Yeotmal",
            "Pincode": "445003",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Babhuigaon",
            "Pincode": "445101",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Nerparsopant",
            "Pincode": "445102",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Arni",
            "Pincode": "445103",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Jawala",
            "Pincode": "445105",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sadi Sadoba",
            "Pincode": "445106",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahagaon Kasba",
            "Pincode": "445110",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Bori Arab",
            "Pincode": "445201",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Darwha",
            "Pincode": "445202",
            "City": "Darwha",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Digras",
            "Pincode": "445203",
            "City": "Digras",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pusad",
            "Pincode": "445204",
            "City": "Pusad",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mahagaon",
            "Pincode": "445205",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Dhanki",
            "Pincode": "445207",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ladkhed",
            "Pincode": "445208",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ispur",
            "Pincode": "445209",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Lohi",
            "Pincode": "445210",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mulawa",
            "Pincode": "445211",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Gahuli",
            "Pincode": "445212",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pophali",
            "Pincode": "445213",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sahakari Smt Girani",
            "Pincode": "445215",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ful Singh Naik",
            "Pincode": "445216",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandala",
            "Pincode": "445217",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ghatnaji",
            "Pincode": "445301",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Pandhar Kawda",
            "Pincode": "445302",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Manegaon Road",
            "Pincode": "445303",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wani",
            "Pincode": "445304",
            "City": "Wani",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wani Bazar",
            "Pincode": "445304",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Patanbor",
            "Pincode": "445305",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Parwa",
            "Pincode": "445306",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Sindola Mines",
            "Pincode": "445307",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Wadki",
            "Pincode": "445308",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Rajur",
            "Pincode": "445309",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Umri",
            "Pincode": "445311",
            "City": "Wardha",
            "District": "Wardha",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Mohada",
            "Pincode": "445323",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Kalamb",
            "Pincode": "445401",
            "City": "Kalamb",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Ralegaon",
            "Pincode": "445402",
            "City": "Yeotamal",
            "District": "Yeotamal",
            "State": "Maharashtra"
        },
        {
            "PostOfficeName": "Khandwa",
            "Pincode": "450001",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khandwa Anand Nagar",
            "Pincode": "450001",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khandwa Ganesh Talai",
            "Pincode": "450001",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khandwa Ghaspura",
            "Pincode": "450001",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khandwa Padwa",
            "Pincode": "450001",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khandwa Tegor Colony",
            "Pincode": "450001",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khandwa Vidhya Nagar",
            "Pincode": "450001",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khandwa Ratagarh",
            "Pincode": "450006",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kharkalan",
            "Pincode": "450051",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Badagaon",
            "Pincode": "450052",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bagmar",
            "Pincode": "450053",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bir",
            "Pincode": "450110",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Borkheda",
            "Pincode": "450111",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mundi",
            "Pincode": "450112",
            "City": "Mundi",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Punasa",
            "Pincode": "450114",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhangaon",
            "Pincode": "450115",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Harsud",
            "Pincode": "450116",
            "City": "Harsud",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khalwa",
            "Pincode": "450117",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Baldi",
            "Pincode": "450118",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ashapur",
            "Pincode": "450124",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kohadar",
            "Pincode": "450220",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nepanagar",
            "Pincode": "450221",
            "City": "Nepanagar",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nepanagar L C Lines",
            "Pincode": "450221",
            "City": "Nepanagar",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nimbola",
            "Pincode": "450223",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tukaithed",
            "Pincode": "450327",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Burhanpur",
            "Pincode": "450331",
            "City": "Burhanpur",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Burhanpur City",
            "Pincode": "450331",
            "City": "Burhanpur",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Burhanpur Itwara",
            "Pincode": "450331",
            "City": "Burhanpur",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Burhanpur Mana",
            "Pincode": "450331",
            "City": "Burhanpur",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Burhanpur R S",
            "Pincode": "450331",
            "City": "Burhanpur",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Burhanpur Rajpura",
            "Pincode": "450331",
            "City": "Burhanpur",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Burhanpura",
            "Pincode": "450331",
            "City": "Burhanpur",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mahajan Peth",
            "Pincode": "450331",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sanowara",
            "Pincode": "450331",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shah Bazar Peth",
            "Pincode": "450331",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khakhar",
            "Pincode": "450332",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bahadurpur",
            "Pincode": "450333",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Loni",
            "Pincode": "450334",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Burhanpur R S",
            "Pincode": "450335",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rustampur",
            "Pincode": "450337",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ichhapur",
            "Pincode": "450441",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nimarkhedi",
            "Pincode": "450551",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandhata",
            "Pincode": "450554",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pandhana",
            "Pincode": "450661",
            "City": "Pandhana",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhegaon Makhan",
            "Pincode": "450771",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaswadi",
            "Pincode": "450881",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jawar",
            "Pincode": "450991",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khargaone",
            "Pincode": "451001",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khargone Collectorate",
            "Pincode": "451001",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khargone Municipal Colony",
            "Pincode": "451001",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khargone Pahad Singhpura",
            "Pincode": "451001",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khargone Town Hall",
            "Pincode": "451001",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhakalgaon",
            "Pincode": "451110",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sanavad",
            "Pincode": "451111",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sanavad Sadar Bazar",
            "Pincode": "451111",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bodud",
            "Pincode": "451112",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bedia",
            "Pincode": "451113",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barawaha Jawahar",
            "Pincode": "451115",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barwaha",
            "Pincode": "451115",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jhanda Chowk",
            "Pincode": "451115",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balwada",
            "Pincode": "451117",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Karhi",
            "Pincode": "451220",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandleshwar",
            "Pincode": "451221",
            "City": "Mandleshwar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhargaon",
            "Pincode": "451222",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Choli",
            "Pincode": "451223",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Meheshwar",
            "Pincode": "451224",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kasrawod",
            "Pincode": "451228",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balsamund",
            "Pincode": "451229",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pathrot Kalan",
            "Pincode": "451239",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Birul",
            "Pincode": "451327",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhikhangaon",
            "Pincode": "451331",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jhirniya",
            "Pincode": "451332",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gogawan",
            "Pincode": "451335",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bamnala",
            "Pincode": "451337",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Palsud",
            "Pincode": "451435",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Un",
            "Pincode": "451440",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Segaon",
            "Pincode": "451442",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barud",
            "Pincode": "451443",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhagwanpura",
            "Pincode": "451444",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "451447",
            "City": "Rajpur",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barufatak",
            "Pincode": "451448",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Julwania",
            "Pincode": "451449",
            "City": "Khandwa",
            "District": "East Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nagalwadi",
            "Pincode": "451451",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barwani",
            "Pincode": "451551",
            "City": "Barwani",
            "District": "Barwani",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Silawad",
            "Pincode": "451552",
            "City": "Barwani",
            "District": "Barwani",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandwada",
            "Pincode": "451555",
            "City": "Barwani",
            "District": "Barwani",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Anjaoi",
            "Pincode": "451556",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Talwada Buzurg",
            "Pincode": "451557",
            "City": "Barwani",
            "District": "Barwani",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dawana",
            "Pincode": "451558",
            "City": "Barwani",
            "District": "Barwani",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balkuan",
            "Pincode": "451559",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Thibgaon",
            "Pincode": "451563",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nimrani",
            "Pincode": "451659",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Thikri",
            "Pincode": "451660",
            "City": "Barwani",
            "District": "Barwani",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pati",
            "Pincode": "451661",
            "City": "Katni",
            "District": "Katni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khurrampur",
            "Pincode": "451663",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Zopali",
            "Pincode": "451664",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balwadi",
            "Pincode": "451665",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sendhwa",
            "Pincode": "451666",
            "City": "Sendhwa",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Niwali",
            "Pincode": "451667",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chatli",
            "Pincode": "451669",
            "City": "Barwani",
            "District": "Barwani",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Moyda",
            "Pincode": "451695",
            "City": "Barwani",
            "District": "Barwani",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pansemal",
            "Pincode": "451770",
            "City": "Pansemal",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khetia",
            "Pincode": "451881",
            "City": "Khetia",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Agrawal Nagar",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore B K Colony",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Cantt",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Govt College",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Jail Road",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Javeribagh",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Juni Indore",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Manoramaganj",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Mills",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore New Palasia",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Siyaganj",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Sringar Colony",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Topkhana",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Tukoganj",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tilaknagar",
            "Pincode": "452001",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore City",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Cloth Market",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Collectorate",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Industrial Area",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Industrial Estate",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Kumarkhadi",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Lokmanyanagar",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Malharganj",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Malwa Mills",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Nandagar",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Pardesipura",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Rajmehalla",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Rambagh",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore V S Market",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Vallabhnagar",
            "Pincode": "452002",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Yeshwant Road",
            "Pincode": "452004",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Bijasen Road",
            "Pincode": "452005",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Biyavani",
            "Pincode": "452005",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Army H Q",
            "Pincode": "452006",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Bada Sarafa",
            "Pincode": "452006",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Barwali Chowk",
            "Pincode": "452006",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Ravishankar Shukla",
            "Pincode": "452008",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Sadar Bazar",
            "Pincode": "452008",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Sudamanagar",
            "Pincode": "452009",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Rajendranagar",
            "Pincode": "452012",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore Kasturba Nagar",
            "Pincode": "452020",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kasturbagram",
            "Pincode": "452020",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indore",
            "Pincode": "452056",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Betma",
            "Pincode": "453001",
            "City": "Betma",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Depalpur",
            "Pincode": "453115",
            "City": "Depalpur",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gautampura",
            "Pincode": "453220",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Fatahabad Chandrawantigan",
            "Pincode": "453235",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rao",
            "Pincode": "453331",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mhow",
            "Pincode": "453441",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mhow Barrackes",
            "Pincode": "453441",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mhow Bazar",
            "Pincode": "453441",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mhow Cantt",
            "Pincode": "453441",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mhow Is",
            "Pincode": "453441",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mhow R S",
            "Pincode": "453441",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rasalpura",
            "Pincode": "453446",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Harsola",
            "Pincode": "453463",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sawer",
            "Pincode": "453551",
            "City": "Sawer",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Solsinda",
            "Pincode": "453562",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khudel",
            "Pincode": "453576",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jamly",
            "Pincode": "453643",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dakacha",
            "Pincode": "453652",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Manpur",
            "Pincode": "453661",
            "City": "Manpur",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandu",
            "Pincode": "454010",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sardarpur",
            "Pincode": "454111",
            "City": "Sardarpur",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rajgarh",
            "Pincode": "454116",
            "City": "Rajgarh",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tirla",
            "Pincode": "454129",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bagh",
            "Pincode": "454221",
            "City": "Bagh",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tanda",
            "Pincode": "454276",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kukshi",
            "Pincode": "454331",
            "City": "Kukshi",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Susari",
            "Pincode": "454333",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chikhalda",
            "Pincode": "454341",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Singhana",
            "Pincode": "454345",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gandhwani",
            "Pincode": "454350",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dahi",
            "Pincode": "454365",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amjhera",
            "Pincode": "454441",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Manawar",
            "Pincode": "454446",
            "City": "Manawar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bakner",
            "Pincode": "454448",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dharampuri",
            "Pincode": "454449",
            "City": "Dharampuri",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhamnod",
            "Pincode": "454552",
            "City": "Dhamnod",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sundrel",
            "Pincode": "454554",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gujri",
            "Pincode": "454571",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rajod",
            "Pincode": "454648",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Badnawar",
            "Pincode": "454660",
            "City": "Badnawar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kanwan",
            "Pincode": "454665",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sadalpur",
            "Pincode": "454666",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kesuri",
            "Pincode": "454667",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bakhatgarh",
            "Pincode": "454668",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kod",
            "Pincode": "454669",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Digthan",
            "Pincode": "454729",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gunawad",
            "Pincode": "454730",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bagdi",
            "Pincode": "454749",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dehrighatga Billod",
            "Pincode": "454773",
            "City": "Dhar",
            "District": "Dhar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dewas",
            "Pincode": "455001",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dewas Bada Bazar",
            "Pincode": "455001",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dewas Bhawani Sagar",
            "Pincode": "455001",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dewas Industril Estate",
            "Pincode": "455001",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dewas Radhaganj",
            "Pincode": "455001",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dewas Bank Note",
            "Pincode": "455003",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shipra",
            "Pincode": "455048",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dewas Balgarh",
            "Pincode": "455111",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barotha",
            "Pincode": "455112",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhonrasa Neori",
            "Pincode": "455115",
            "City": "Indore",
            "District": "Indore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tonk Khurd",
            "Pincode": "455116",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tonk Kalan",
            "Pincode": "455117",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sonketch",
            "Pincode": "455118",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gandharvpuri",
            "Pincode": "455119",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dewas",
            "Pincode": "455178",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dewas",
            "Pincode": "455178",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Karnawad",
            "Pincode": "455221",
            "City": "Karnawad",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hat Pipalia",
            "Pincode": "455223",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bagli",
            "Pincode": "455227",
            "City": "Bagli",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kamlapur",
            "Pincode": "455302",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kannod",
            "Pincode": "455332",
            "City": "Kannod",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khategaon",
            "Pincode": "455336",
            "City": "Khategaon",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nemawar",
            "Pincode": "455339",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kantaphore",
            "Pincode": "455440",
            "City": "Dewas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Satwas",
            "Pincode": "455459",
            "City": "Satwas",
            "District": "Dewas",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain",
            "Pincode": "456001",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Bined Mills",
            "Pincode": "456001",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Daulatganj",
            "Pincode": "456001",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Desainagar",
            "Pincode": "456001",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Industrial Area",
            "Pincode": "456001",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Madhonagar",
            "Pincode": "456001",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjan Bherongarh",
            "Pincode": "456003",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Begampura",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Budhwaria",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Chhota Sarafa",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain City",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Danigate",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Factory",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Gujarati Samaj",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Nayapura",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Pandanba",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Qamari Marg",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Shri Mahakal",
            "Pincode": "456006",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Rishinagar",
            "Pincode": "456008",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Govt Engineering C",
            "Pincode": "456009",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain",
            "Pincode": "456010",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Gaughat Railway Co",
            "Pincode": "456010",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Kothi",
            "Pincode": "456010",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Kothi Road",
            "Pincode": "456010",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Moti Lal Nehru Nag",
            "Pincode": "456010",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Nagjhiri",
            "Pincode": "456010",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ujjain Sindhi Colony",
            "Pincode": "456010",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "University",
            "Pincode": "456010",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Unhel",
            "Pincode": "456221",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Baledi",
            "Pincode": "456222",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khachrod",
            "Pincode": "456224",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khachrod R S",
            "Pincode": "456224",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khachrod Town",
            "Pincode": "456224",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Birlagram Nagda",
            "Pincode": "456331",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nagda",
            "Pincode": "456335",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nagda Town",
            "Pincode": "456335",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Piploda Bagla",
            "Pincode": "456337",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mehidpur Road",
            "Pincode": "456440",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jharda",
            "Pincode": "456441",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mahidpur",
            "Pincode": "456443",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mahidpur Bazar",
            "Pincode": "456443",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dongargaon",
            "Pincode": "456450",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ghattia",
            "Pincode": "456550",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ghosla",
            "Pincode": "456551",
            "City": "Khargone",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pat",
            "Pincode": "456552",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tajpur",
            "Pincode": "456661",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kaytha",
            "Pincode": "456663",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Narwar",
            "Pincode": "456664",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tarana",
            "Pincode": "456665",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tarana Town",
            "Pincode": "456665",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Vijaiganj Mandi",
            "Pincode": "456666",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Makdone",
            "Pincode": "456668",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sumerkheda",
            "Pincode": "456673",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barnagar",
            "Pincode": "456771",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barnagar Bunglow",
            "Pincode": "456771",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barnagar Town",
            "Pincode": "456771",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Runija",
            "Pincode": "456776",
            "City": "Ujjain",
            "District": "Ujjain",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam Bajajkha",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam Choumukni",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam City",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam Collectorate",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam Dhanmandi",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam Ghatla Colony",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam Hat Ki Chouki",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam Kase Babazar",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam Nahapura",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam New Road",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam Rly Colony",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam Stand Road",
            "Pincode": "457001",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bangrod",
            "Pincode": "457111",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Alete",
            "Pincode": "457114",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Alete Naya Bazar",
            "Pincode": "457114",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Alete R S",
            "Pincode": "457114",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tal",
            "Pincode": "457118",
            "City": "Tal",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Namli",
            "Pincode": "457222",
            "City": "Namli",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaora Chaupati",
            "Pincode": "457226",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaora Katchery",
            "Pincode": "457226",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaora Neem Chowk",
            "Pincode": "457226",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaora Ratlam",
            "Pincode": "457226",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaora Tower",
            "Pincode": "457226",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Boroda",
            "Pincode": "457227",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sukheda",
            "Pincode": "457333",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ringnod",
            "Pincode": "457336",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhodhar",
            "Pincode": "457339",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bilpank",
            "Pincode": "457441",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sailana",
            "Pincode": "457550",
            "City": "Sailana",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sarwan",
            "Pincode": "457551",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratlam",
            "Pincode": "457552",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bajana",
            "Pincode": "457555",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jhabua",
            "Pincode": "457661",
            "City": "Jhabua",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jhabua Bazar",
            "Pincode": "457661",
            "City": "Jhabua",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jhabua Collectorate",
            "Pincode": "457661",
            "City": "Jhabua",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Raoti",
            "Pincode": "457769",
            "City": "Ratlam",
            "District": "Ratlam",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bamni Bazar",
            "Pincode": "457770",
            "City": "Jhabua",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bamnia",
            "Pincode": "457770",
            "City": "Jhabua",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Raipur",
            "Pincode": "457775",
            "City": "Jhabua",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Thandla",
            "Pincode": "457777",
            "City": "Thandla",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Meghnagar",
            "Pincode": "457779",
            "City": "Meghnagar",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhabra",
            "Pincode": "457882",
            "City": "Jhabua",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khathiwada",
            "Pincode": "457885",
            "City": "Jhabua",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Alirajpur",
            "Pincode": "457887",
            "City": "Alirajpur",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Alirajpur Bazar",
            "Pincode": "457887",
            "City": "Alirajpur",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jobat",
            "Pincode": "457990",
            "City": "Jobat",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ranapur",
            "Pincode": "457993",
            "City": "Ranapur",
            "District": "Jhabua",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandaun S R Tekri",
            "Pincode": "458001",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandsaur",
            "Pincode": "458001",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandsaur Dharmashala",
            "Pincode": "458001",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandsaur Nai Abadi",
            "Pincode": "458001",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandsaur City",
            "Pincode": "458002",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandsaur Fort",
            "Pincode": "458002",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandsaur Jankipura",
            "Pincode": "458002",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandsaur Kilchipura",
            "Pincode": "458002",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandsaur Sarafa",
            "Pincode": "458002",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Manasa",
            "Pincode": "458110",
            "City": "Manasa",
            "District": "Neemuch",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Manasa Bazar",
            "Pincode": "458110",
            "City": "Manasa",
            "District": "Neemuch",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Malgarh",
            "Pincode": "458113",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kukreshwar",
            "Pincode": "458116",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rampura Bara Bazar",
            "Pincode": "458118",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rampure",
            "Pincode": "458118",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sarwana",
            "Pincode": "458220",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Deeken",
            "Pincode": "458224",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ratangarh",
            "Pincode": "458226",
            "City": "Ratangarh",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Singali",
            "Pincode": "458228",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandasur",
            "Pincode": "458272",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandasur",
            "Pincode": "458330",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Neemuch",
            "Pincode": "458441",
            "City": "Neemuch",
            "District": "Neemuch",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Neemuch Baghana",
            "Pincode": "458441",
            "City": "Neemuch",
            "District": "Neemuch",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Neemuch City",
            "Pincode": "458441",
            "City": "Neemuch",
            "District": "Neemuch",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Neemuch Ghataghar",
            "Pincode": "458441",
            "City": "Neemuch",
            "District": "Neemuch",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Neemuch Jawabarnagar",
            "Pincode": "458441",
            "City": "Neemuch",
            "District": "Neemuch",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Neemuch Mandi",
            "Pincode": "458442",
            "City": "Neemuch",
            "District": "Neemuch",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nayagaon Cement Factory N",
            "Pincode": "458468",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Athana",
            "Pincode": "458474",
            "City": "Neemuch",
            "District": "Neemuch",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Narayangarh",
            "Pincode": "458553",
            "City": "Narayangarh",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nahargarh",
            "Pincode": "458558",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sandhara",
            "Pincode": "458588",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhensoda Town",
            "Pincode": "458595",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandasur",
            "Pincode": "458676",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandasur",
            "Pincode": "458990",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Beful Kothi Bazar",
            "Pincode": "460001",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Betul",
            "Pincode": "460001",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Betulganj",
            "Pincode": "460002",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Betul Bazar",
            "Pincode": "460004",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Betulnimpani",
            "Pincode": "460005",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhaindehi",
            "Pincode": "460220",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khedi Saoligarh",
            "Pincode": "460225",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chicholi",
            "Pincode": "460330",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahpura",
            "Pincode": "460440",
            "City": "Shahpura",
            "District": "Dindori",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ghoradongri",
            "Pincode": "460443",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Betul",
            "Pincode": "460444",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sarni",
            "Pincode": "460447",
            "City": "Sarni",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Patharkheda",
            "Pincode": "460449",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amla",
            "Pincode": "460551",
            "City": "Amla",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amla Town",
            "Pincode": "460551",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amla Depot",
            "Pincode": "460553",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bordehi",
            "Pincode": "460554",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Saikheda",
            "Pincode": "460557",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Multai",
            "Pincode": "460661",
            "City": "Multai",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Multai Bazar",
            "Pincode": "460661",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dunawa",
            "Pincode": "460663",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Prabhat Pattan",
            "Pincode": "460665",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rai Amla",
            "Pincode": "460666",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Masod",
            "Pincode": "460668",
            "City": "Betul",
            "District": "Betul",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hoshangabad",
            "Pincode": "461001",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hoshangabad City",
            "Pincode": "461001",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hoshangabad R S",
            "Pincode": "461001",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hoshangabad Security Pape",
            "Pincode": "461005",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Powarkheda",
            "Pincode": "461110",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Itarsi",
            "Pincode": "461111",
            "City": "Itarsi",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Itarsi Purani Basti",
            "Pincode": "461111",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Itarsi Suraj Ganj",
            "Pincode": "461111",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Itarsi Central Project",
            "Pincode": "461114",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Itarsi New Yar Colony",
            "Pincode": "461115",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dolaria",
            "Pincode": "461116",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Banapura",
            "Pincode": "461221",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Seoni Malwa",
            "Pincode": "461223",
            "City": "Seoni Malwa",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hoshangabad",
            "Pincode": "461224",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hoshangabad",
            "Pincode": "461225",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rahatgaon",
            "Pincode": "461251",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Harda",
            "Pincode": "461331",
            "City": "Harda",
            "District": "Harda",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Harda Khedipura Ptc",
            "Pincode": "461331",
            "City": "Harda",
            "District": "Harda",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Harda R S",
            "Pincode": "461331",
            "City": "Harda",
            "District": "Harda",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sivali",
            "Pincode": "461335",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hoshangabad",
            "Pincode": "461427",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Charuwa",
            "Pincode": "461444",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hoshangabad",
            "Pincode": "461446",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tawa Nagar",
            "Pincode": "461551",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hoshangabad",
            "Pincode": "461555",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sohagpur",
            "Pincode": "461771",
            "City": "Sohagpur",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sohagpur R S",
            "Pincode": "461771",
            "City": "Sohagpur",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shobhapur",
            "Pincode": "461772",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pachmarhi",
            "Pincode": "461881",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pachmarhi Bazar",
            "Pincode": "461881",
            "City": "Hoshangabad",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pachmarhi Cantt",
            "Pincode": "461881",
            "City": "Pachmarhi Cantt",
            "District": "Hoshangabad",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Bazara",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Budhwara",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Chauk",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Chhaoni",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Durga Chauk",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Ginnori",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Gpo",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Hamidia Road",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Itwara",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Jumerati",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Kamla Park",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Medical College",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Old Sectt",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Shahjahanabad",
            "Pincode": "462001",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Vidyavihar",
            "Pincode": "462002",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal",
            "Pincode": "462003",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal C T T Nagar",
            "Pincode": "462003",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Kamla Nagar",
            "Pincode": "462003",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal North T T",
            "Pincode": "462003",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Roshanpura",
            "Pincode": "462003",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal South T T",
            "Pincode": "462003",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sabha",
            "Pincode": "462003",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Satpuda",
            "Pincode": "462004",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Vallabha Bhawan",
            "Pincode": "462004",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal V V Grah",
            "Pincode": "462006",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Mact College",
            "Pincode": "462007",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Barkheri",
            "Pincode": "462008",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Jahagirabad",
            "Pincode": "462008",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Jinsi",
            "Pincode": "462008",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Sikandri Sarai",
            "Pincode": "462010",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Sikandrisariai",
            "Pincode": "462010",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Siksha Mandal",
            "Pincode": "462011",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Pm G Office",
            "Pincode": "462012",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Regional College",
            "Pincode": "462013",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Gmt",
            "Pincode": "462015",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhoal R S Market",
            "Pincode": "462016",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal 1100Qrs",
            "Pincode": "462016",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Char Imli",
            "Pincode": "462016",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal E-2 Sector",
            "Pincode": "462016",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Mahavir Nagar",
            "Pincode": "462016",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Ravishankar Nagar",
            "Pincode": "462016",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Greenpark Cly",
            "Pincode": "462018",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal S I Lines",
            "Pincode": "462018",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Anand Nagar",
            "Pincode": "462021",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Barkhedo",
            "Pincode": "462021",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Poplani",
            "Pincode": "462021",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Sonagiri",
            "Pincode": "462021",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal C Sector",
            "Pincode": "462023",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Govindpura",
            "Pincode": "462023",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Govindpura Ind Est",
            "Pincode": "462023",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Sub Nagar",
            "Pincode": "462023",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal He Hospital",
            "Pincode": "462024",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Shastri Nagar",
            "Pincode": "462026",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Univercity",
            "Pincode": "462026",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Vidhayak",
            "Pincode": "462026",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Baigagarh",
            "Pincode": "462030",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Air Port",
            "Pincode": "462030",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Bairagarh",
            "Pincode": "462030",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Bhel S B",
            "Pincode": "462030",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Bus Stand",
            "Pincode": "462030",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Eme Centre",
            "Pincode": "462031",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Nayapura",
            "Pincode": "462032",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhopal Gandhi Nagar",
            "Pincode": "462036",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandideep",
            "Pincode": "462046",
            "City": "Mandideep",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Lalaria",
            "Pincode": "463111",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nazirabad",
            "Pincode": "463120",
            "City": "Bhopal",
            "District": "Bhopal",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Vidisha",
            "Pincode": "464001",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Vidisha Bazaria",
            "Pincode": "464001",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Vidisha Collectorate",
            "Pincode": "464001",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Vidisha Fort",
            "Pincode": "464001",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Upaj Mandi",
            "Pincode": "464002",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Vidisha Krishi",
            "Pincode": "464002",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Vidisha Mandi",
            "Pincode": "464002",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Vidisha Sati",
            "Pincode": "464002",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Vidisha Station",
            "Pincode": "464002",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shamshabad",
            "Pincode": "464111",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Anandpur",
            "Pincode": "464112",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Lateri",
            "Pincode": "464114",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gulabganj",
            "Pincode": "464220",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ganj Basoda",
            "Pincode": "464221",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ganj Basoda City",
            "Pincode": "464221",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ganj Basoda Station",
            "Pincode": "464221",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kurwai State",
            "Pincode": "464224",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khamkheda",
            "Pincode": "464226",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sironj",
            "Pincode": "464228",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sironj City",
            "Pincode": "464228",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gyaraspur",
            "Pincode": "464331",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pathari",
            "Pincode": "464337",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Raisen",
            "Pincode": "464551",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Arjun Nagar",
            "Pincode": "464556",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Raisen Arjun Nagar",
            "Pincode": "464556",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dehgaon",
            "Pincode": "464573",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Salamatpur Mandi",
            "Pincode": "464651",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sanchi",
            "Pincode": "464661",
            "City": "Sanchi",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ankulpur",
            "Pincode": "464665",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bari",
            "Pincode": "464665",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bareli",
            "Pincode": "464668",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bareli Civil Lines",
            "Pincode": "464668",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Magardha",
            "Pincode": "464670",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khargaon",
            "Pincode": "464671",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Vidisha",
            "Pincode": "464676",
            "City": "Vidisha",
            "District": "Vidisha",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Udaipura",
            "Pincode": "464770",
            "City": "Udaipura",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Deori",
            "Pincode": "464774",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Panjra",
            "Pincode": "464776",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gairatganj",
            "Pincode": "464884",
            "City": "Gairatganj",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sultanpur",
            "Pincode": "464986",
            "City": "Sultanpur",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Goharganj",
            "Pincode": "464990",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Obaidullaganj",
            "Pincode": "464993",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barkhera R S",
            "Pincode": "464995",
            "City": "Raisen",
            "District": "Raisen",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shajapur",
            "Pincode": "465001",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shajapur",
            "Pincode": "465001",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shajapur Kutcheri",
            "Pincode": "465001",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shajapur Town",
            "Pincode": "465001",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "465001",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Maksi",
            "Pincode": "465106",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Berccha Town",
            "Pincode": "465110",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Berchha",
            "Pincode": "465110",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sundersi",
            "Pincode": "465113",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Polai Kalan",
            "Pincode": "465116",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Awantipur Bardia",
            "Pincode": "465118",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kalisingh",
            "Pincode": "465220",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Salslai",
            "Pincode": "465221",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Akodia",
            "Pincode": "465223",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kanad",
            "Pincode": "465230",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mohana",
            "Pincode": "465231",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shajapur City",
            "Pincode": "465331",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shujalpur City",
            "Pincode": "465331",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shujalpur Mandi",
            "Pincode": "465333",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shujalpur Station Rd",
            "Pincode": "465333",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jamner",
            "Pincode": "465335",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Arnia Kalan",
            "Pincode": "465336",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kala Pipal",
            "Pincode": "465337",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shajapur",
            "Pincode": "465418",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Agar Bazar",
            "Pincode": "465441",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Agar Malwa",
            "Pincode": "465441",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nalkheda",
            "Pincode": "465445",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Suaner",
            "Pincode": "465447",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Soyat Kalan",
            "Pincode": "465449",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barode",
            "Pincode": "465550",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rajgarh",
            "Pincode": "465661",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kurawar",
            "Pincode": "465667",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raigarh",
            "Pincode": "465670",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shajapur",
            "Pincode": "465672",
            "City": "Shajapur",
            "District": "Shajapur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Biaora",
            "Pincode": "465674",
            "City": "Biaora",
            "District": "Raigarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Suthalia",
            "Pincode": "465677",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khilchipur",
            "Pincode": "465679",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pachore",
            "Pincode": "465683",
            "City": "Pachore",
            "District": "Raigarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Boda",
            "Pincode": "465685",
            "City": "Boda",
            "District": "Raigarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barodia Kumaria",
            "Pincode": "465686",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Khujner",
            "Pincode": "465687",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chhapiheda",
            "Pincode": "465689",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sarangpur",
            "Pincode": "465697",
            "City": "Sarangpur",
            "District": "Katni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sarangpur Mandi",
            "Pincode": "465697",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sehore",
            "Pincode": "466001",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sehore",
            "Pincode": "466002",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sehore",
            "Pincode": "466003",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bikisganj",
            "Pincode": "466111",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Borkheda",
            "Pincode": "466112",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kotri",
            "Pincode": "466114",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ichawar",
            "Pincode": "466115",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ashta Budhwas",
            "Pincode": "466116",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Asta Bada Bazar",
            "Pincode": "466116",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kachraud",
            "Pincode": "466117",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Metwara",
            "Pincode": "466118",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khadi",
            "Pincode": "466119",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Maina",
            "Pincode": "466125",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Javer",
            "Pincode": "466221",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Narsurlaganj Sudhama Puri",
            "Pincode": "466331",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nasurlaganj",
            "Pincode": "466331",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Budni Tracta Nagar",
            "Pincode": "466445",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rehti",
            "Pincode": "466446",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Baktara",
            "Pincode": "466448",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahganj",
            "Pincode": "466554",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shyampur",
            "Pincode": "466651",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Doraha",
            "Pincode": "466661",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ahmedpur",
            "Pincode": "466665",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar B I Bazar",
            "Pincode": "470001",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar Cantt",
            "Pincode": "470001",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar Cavalary Hills",
            "Pincode": "470001",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar Collectorate",
            "Pincode": "470001",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar Gopalganj",
            "Pincode": "470001",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar Bada Bazar",
            "Pincode": "470002",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar City",
            "Pincode": "470002",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar Galla Mandi",
            "Pincode": "470002",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar Purbiau Tori",
            "Pincode": "470002",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar Sadar Bazar",
            "Pincode": "470002",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar Sanichari",
            "Pincode": "470002",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sangar Laxmipura",
            "Pincode": "470002",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar University",
            "Pincode": "470003",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar Tilli",
            "Pincode": "470005",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bilhera Raja",
            "Pincode": "470051",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bamora R S",
            "Pincode": "470111",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bina",
            "Pincode": "470113",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bina Bajaria",
            "Pincode": "470113",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bina Etawah",
            "Pincode": "470113",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaruakehda",
            "Pincode": "470115",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khurai",
            "Pincode": "470117",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khurai City",
            "Pincode": "470117",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khimlasa",
            "Pincode": "470118",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rahatgarh",
            "Pincode": "470119",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sihora",
            "Pincode": "470120",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Naryaoli",
            "Pincode": "470122",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaisingh Nagar",
            "Pincode": "470125",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sukhi",
            "Pincode": "470221",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Garu Jhamar",
            "Pincode": "470223",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Deori",
            "Pincode": "470226",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rehli",
            "Pincode": "470227",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dnana",
            "Pincode": "470228",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Garahkota",
            "Pincode": "470229",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagar",
            "Pincode": "470230",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kesli",
            "Pincode": "470235",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Banda Belai",
            "Pincode": "470335",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Karrapur",
            "Pincode": "470337",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahgarh",
            "Pincode": "470339",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Malthone",
            "Pincode": "470441",
            "City": "Mandasur",
            "District": "Mandasur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bandri",
            "Pincode": "470442",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Damoh",
            "Pincode": "470661",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Damoh Bazaria",
            "Pincode": "470661",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Damoh City",
            "Pincode": "470661",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Damoh Civil Yard",
            "Pincode": "470661",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Damoh Phutera Yard",
            "Pincode": "470661",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Damoh R S",
            "Pincode": "470661",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Abhana",
            "Pincode": "470662",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bandakpur",
            "Pincode": "470664",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Patharia",
            "Pincode": "470666",
            "City": "Patharia",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahpura Magrone",
            "Pincode": "470669",
            "City": "Sagar",
            "District": "Sagar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bansatar Kheda",
            "Pincode": "470672",
            "City": "Bansatar Kheda",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Narsinghgarh",
            "Pincode": "470675",
            "City": "Narsinghgarh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hindoria",
            "Pincode": "470771",
            "City": "Hindoria",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Patera",
            "Pincode": "470772",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hatta",
            "Pincode": "470775",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tendukheda",
            "Pincode": "470880",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabera",
            "Pincode": "470881",
            "City": "Damoh",
            "District": "Damoh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhatarpur",
            "Pincode": "471001",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhatarpur Chowk Bazar",
            "Pincode": "471001",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhatarpur Collectorate",
            "Pincode": "471001",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhatarpur College Road",
            "Pincode": "471001",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhatrpur City",
            "Pincode": "471001",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chandra Nagar",
            "Pincode": "471101",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bamitha",
            "Pincode": "471105",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Harpalpur",
            "Pincode": "471111",
            "City": "Harpalpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nowganj",
            "Pincode": "471201",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nowganj Polytechic Colleg",
            "Pincode": "471201",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mausahaniya",
            "Pincode": "471202",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gulganj",
            "Pincode": "471301",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Malhera",
            "Pincode": "471311",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ghaura",
            "Pincode": "471313",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Buxwaha",
            "Pincode": "471318",
            "City": "Buxwaha",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhatarpur",
            "Pincode": "471401",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Satia",
            "Pincode": "471408",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Garhi Malhera",
            "Pincode": "471411",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Maharajpur",
            "Pincode": "471501",
            "City": "Maharajpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhatarpur",
            "Pincode": "471505",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jujhar Nagar",
            "Pincode": "471510",
            "City": "Chhatarpur",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Laundi",
            "Pincode": "471515",
            "City": "Laundi",
            "District": "West Nimar",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chandla",
            "Pincode": "471525",
            "City": "Chandla",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rajnagar",
            "Pincode": "471625",
            "City": "Rajnagar",
            "District": "Chhatarpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tikamgagh Collectorate",
            "Pincode": "472001",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tikamgarh",
            "Pincode": "472001",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tikamgarh City",
            "Pincode": "472001",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tikamgarh Civil Lines",
            "Pincode": "472001",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kundleshwar",
            "Pincode": "472005",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Badagaon",
            "Pincode": "472010",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mohangarh",
            "Pincode": "472101",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Baldeogarh",
            "Pincode": "472111",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kharagapur",
            "Pincode": "472115",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jatara",
            "Pincode": "472118",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Palera",
            "Pincode": "472221",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Orchha",
            "Pincode": "472246",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Prithvipur",
            "Pincode": "472336",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jeran",
            "Pincode": "472337",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Niwari",
            "Pincode": "472442",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tarichor Kalan",
            "Pincode": "472445",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sendri",
            "Pincode": "472446",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Teharaka",
            "Pincode": "472447",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sihuda",
            "Pincode": "472567",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Guna",
            "Pincode": "473001",
            "City": "Katni",
            "District": "Katni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Guna A B Road",
            "Pincode": "473001",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Guna Bazar",
            "Pincode": "473001",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Guna City",
            "Pincode": "473001",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Guna Collectorate",
            "Pincode": "473001",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Arone",
            "Pincode": "473101",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bamori",
            "Pincode": "473105",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ruthiyari",
            "Pincode": "473110",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chachaura",
            "Pincode": "473118",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Raghogarh",
            "Pincode": "473226",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Guna",
            "Pincode": "473229",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bajarangapur",
            "Pincode": "473249",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Maksoodangarh",
            "Pincode": "473287",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Malawar",
            "Pincode": "473287",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sadhora",
            "Pincode": "473330",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "473331",
            "City": "Ashok Nagar",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Guna",
            "Pincode": "473333",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Esagarh",
            "Pincode": "473335",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shivpur Anandpur",
            "Pincode": "473338",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Piprai",
            "Pincode": "473440",
            "City": "Guna",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mungaoli",
            "Pincode": "473443",
            "City": "Mungaoli",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mungeli Bazar",
            "Pincode": "473443",
            "City": "Mungaoli",
            "District": "Guna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shivpur Kamlaganj",
            "Pincode": "473551",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shivpuri",
            "Pincode": "473551",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shivpuri C B",
            "Pincode": "473551",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shivpuri City",
            "Pincode": "473551",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shivpuri Collectorate",
            "Pincode": "473551",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shivpuri Itbp College",
            "Pincode": "473551",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shivpuri P B",
            "Pincode": "473551",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shivpuri V R Colony",
            "Pincode": "473551",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khatora",
            "Pincode": "473583",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Karera",
            "Pincode": "473660",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Karera Training Centre",
            "Pincode": "473662",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sehore",
            "Pincode": "473664",
            "City": "Sehore",
            "District": "Sehore",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rohtas",
            "Pincode": "473665",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manpura",
            "Pincode": "473670",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kolaras",
            "Pincode": "473770",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jogalpur",
            "Pincode": "473774",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pohri",
            "Pincode": "473775",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rannod",
            "Pincode": "473781",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhatnawara",
            "Pincode": "473785",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Berad",
            "Pincode": "473793",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Magroni",
            "Pincode": "473865",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Narwar",
            "Pincode": "473880",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Badarwas",
            "Pincode": "473885",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khaniadhana",
            "Pincode": "473990",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhonti",
            "Pincode": "473993",
            "City": "Shivpuri",
            "District": "Shivpuri",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Collectorate Gwr",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Daulatganj",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jacob Parade",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Janakganj",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jiwajiganj",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kampoo",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Lala Ka Bazar",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Lashkar",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Laxmiganj",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Madhoganj",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Naya Sarafa",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Phalka Bazar",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sikandar Kampoo",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tilaknagar",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "V N Marg",
            "Pincode": "474001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior R S",
            "Pincode": "474002",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jiwaji University",
            "Pincode": "474002",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "K P Colony",
            "Pincode": "474002",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "R B Colony",
            "Pincode": "474002",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shaktingar",
            "Pincode": "474002",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior City",
            "Pincode": "474003",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hazira Chauk",
            "Pincode": "474003",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior Birlanagar",
            "Pincode": "474004",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Darpan Colony",
            "Pincode": "474005",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior Residency",
            "Pincode": "474005",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior Morar",
            "Pincode": "474006",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morar",
            "Pincode": "474006",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morar Military Camp",
            "Pincode": "474006",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morar Town",
            "Pincode": "474006",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "R K Puri",
            "Pincode": "474006",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior Motimahal",
            "Pincode": "474007",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior Fort",
            "Pincode": "474008",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior Laskhar City",
            "Pincode": "474009",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "J A Hospital",
            "Pincode": "474009",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Naya Bazar",
            "Pincode": "474009",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "S K Chhaoni",
            "Pincode": "474009",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Usha Colony",
            "Pincode": "474009",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior Motijheel",
            "Pincode": "474010",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior Maharajpur A F",
            "Pincode": "474020",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior",
            "Pincode": "474040",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior",
            "Pincode": "474042",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gwalior",
            "Pincode": "474055",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Antri",
            "Pincode": "475001",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Behat",
            "Pincode": "475002",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tekanpur",
            "Pincode": "475005",
            "City": "Tekanpur",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dabra",
            "Pincode": "475110",
            "City": "Dabra",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dabra Jwalaganj",
            "Pincode": "475110",
            "City": "Dabra",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dabra Tehsil",
            "Pincode": "475110",
            "City": "Dabra",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhitarwar",
            "Pincode": "475220",
            "City": "Bhitarwar",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhander",
            "Pincode": "475335",
            "City": "Bhander",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Salon B",
            "Pincode": "475336",
            "City": "Gwalior",
            "District": "Gwalior",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Datia",
            "Pincode": "475661",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Datia Bada Bazar",
            "Pincode": "475661",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Datia R S",
            "Pincode": "475661",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Datia Rajgarh",
            "Pincode": "475661",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Baroni Kalan",
            "Pincode": "475668",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Unnao",
            "Pincode": "475671",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tharet",
            "Pincode": "475673",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Indargarh",
            "Pincode": "475675",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Semai",
            "Pincode": "475677",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Datia",
            "Pincode": "475684",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Baroni",
            "Pincode": "475686",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sitapur",
            "Pincode": "475693",
            "City": "Datia",
            "District": "Datia",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morena",
            "Pincode": "476001",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morena Ambah Road",
            "Pincode": "476001",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morena City",
            "Pincode": "476001",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morena Gopalpura",
            "Pincode": "476001",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morena Mandi",
            "Pincode": "476001",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ambah",
            "Pincode": "476111",
            "City": "Ambah",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ambah Road",
            "Pincode": "476111",
            "City": "Ambah",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Porsa",
            "Pincode": "476115",
            "City": "Porsa",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tikamgarh",
            "Pincode": "476133",
            "City": "Tikamgarh",
            "District": "Tikamgarh",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Joura",
            "Pincode": "476221",
            "City": "Joura",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Joura City",
            "Pincode": "476221",
            "City": "Joura",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morena",
            "Pincode": "476224",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pahargarh",
            "Pincode": "476228",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sabalgarh",
            "Pincode": "476229",
            "City": "Sabalgarh",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sabalgarh Mandi",
            "Pincode": "476229",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rampur Kalan",
            "Pincode": "476235",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morena",
            "Pincode": "476337",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morena",
            "Pincode": "476339",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Morena",
            "Pincode": "476345",
            "City": "Morena",
            "District": "Morena",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhind",
            "Pincode": "477001",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhind Housing Colony",
            "Pincode": "477001",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhind Kacheri",
            "Pincode": "477001",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhind Mandi",
            "Pincode": "477001",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhind Usha Nagar",
            "Pincode": "477001",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Naizamin",
            "Pincode": "477105",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Attair",
            "Pincode": "477111",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Attar",
            "Pincode": "477111",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gohad",
            "Pincode": "477116",
            "City": "Gohad",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mau",
            "Pincode": "477222",
            "City": "Mau",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amayan",
            "Pincode": "477227",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ambagarh",
            "Pincode": "477227",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Umri",
            "Pincode": "477331",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Akoda",
            "Pincode": "477332",
            "City": "Akoda",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sagra",
            "Pincode": "477333",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rawn",
            "Pincode": "477335",
            "City": "Bhind",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mihona",
            "Pincode": "477441",
            "City": "Mihona",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Lahar",
            "Pincode": "477445",
            "City": "Lahar",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Daboh",
            "Pincode": "477447",
            "City": "Daboh",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barhi",
            "Pincode": "477556",
            "City": "Barhi",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mehgaon",
            "Pincode": "477557",
            "City": "Mehgaon",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gormi",
            "Pincode": "477660",
            "City": "Gormi",
            "District": "Bhind",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhindwara",
            "Pincode": "480001",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhindwara City",
            "Pincode": "480001",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhar",
            "Pincode": "480001",
            "City": "Dhar",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhar Bzar",
            "Pincode": "480001",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhar Collectorate",
            "Pincode": "480001",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhar Dhan Mandi",
            "Pincode": "480001",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhar Motor Stand",
            "Pincode": "480001",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhindwara Chitnavisganj",
            "Pincode": "480002",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhindwara Gulabra",
            "Pincode": "480002",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhindwara Lalbaugh",
            "Pincode": "480002",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhindwara T B Sanotorium",
            "Pincode": "480002",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mohgaon",
            "Pincode": "480105",
            "City": "Mohgaon",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sausar",
            "Pincode": "480106",
            "City": "Sausar",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Umarnala",
            "Pincode": "480107",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chand",
            "Pincode": "480110",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bichhua",
            "Pincode": "480111",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chaurani",
            "Pincode": "480115",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhindwara",
            "Pincode": "480116",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhindwara",
            "Pincode": "480116",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amarwara",
            "Pincode": "480221",
            "City": "Amarwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Singodi",
            "Pincode": "480223",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Harria",
            "Pincode": "480224",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mokhed",
            "Pincode": "480228",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Saori Bazar",
            "Pincode": "480331",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pandurna",
            "Pincode": "480334",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Pandurna Gujri",
            "Pincode": "480334",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Seoni Sausar",
            "Pincode": "480337",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Teegaon",
            "Pincode": "480338",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Deeghowani",
            "Pincode": "480443",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chand Meta",
            "Pincode": "480447",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Eklehra",
            "Pincode": "480449",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Junnardeo",
            "Pincode": "480551",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dungaria",
            "Pincode": "480553",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nandan",
            "Pincode": "480554",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Newton Chikli",
            "Pincode": "480557",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tamia",
            "Pincode": "480559",
            "City": "Chhindwara",
            "District": "Chhindwara",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Seoni",
            "Pincode": "480661",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Seoni Barapathar",
            "Pincode": "480661",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Seoni Bharoganj",
            "Pincode": "480661",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Seoni Budhwan Bazar",
            "Pincode": "480661",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Seoni City",
            "Pincode": "480661",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Seponi Mathward",
            "Pincode": "480661",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gopalganj",
            "Pincode": "480664",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barghat",
            "Pincode": "480667",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhamrna",
            "Pincode": "480669",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ari",
            "Pincode": "480771",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Korai",
            "Pincode": "480880",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khawasa",
            "Pincode": "480881",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bandol",
            "Pincode": "480882",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chhapara",
            "Pincode": "480884",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Adelgaon",
            "Pincode": "480887",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kanhiwara",
            "Pincode": "480990",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Keolari",
            "Pincode": "480994",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ugli",
            "Pincode": "480996",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ghansore",
            "Pincode": "480997",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kahani",
            "Pincode": "480999",
            "City": "Seoni",
            "District": "Seoni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balaghat",
            "Pincode": "481001",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balaghat City",
            "Pincode": "481001",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balaghat R S",
            "Pincode": "481001",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balaghat Surekha",
            "Pincode": "481001",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balaghat",
            "Pincode": "481022",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Birsa",
            "Pincode": "481051",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bharveli",
            "Pincode": "481102",
            "City": "Bharveli",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ukwa",
            "Pincode": "481105",
            "City": "Ukwa",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Baihar",
            "Pincode": "481111",
            "City": "Baihar",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kirnapur",
            "Pincode": "481115",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Malanjkhand",
            "Pincode": "481116",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Garhi",
            "Pincode": "481117",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balaghat",
            "Pincode": "481125",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Balaghat",
            "Pincode": "481125",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Lanji",
            "Pincode": "481222",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Hatta",
            "Pincode": "481226",
            "City": "Hatta",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Budbuda",
            "Pincode": "481332",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rampaili",
            "Pincode": "481335",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Lalburra",
            "Pincode": "481441",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Katangi",
            "Pincode": "481445",
            "City": "Katangi",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tirodi",
            "Pincode": "481449",
            "City": "Tirodi",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Lamta",
            "Pincode": "481551",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nagarwada",
            "Pincode": "481554",
            "City": "Balaghat",
            "District": "Balaghat",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Paraswara",
            "Pincode": "481556",
            "City": "Katni",
            "District": "Katni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gorakhpur",
            "Pincode": "481584",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandla",
            "Pincode": "481661",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandla City",
            "Pincode": "481661",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandla Padae",
            "Pincode": "481661",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Padaria Narayanganj",
            "Pincode": "481662",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mohgaon",
            "Pincode": "481663",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Maharajpur",
            "Pincode": "481665",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandla Maharajpur",
            "Pincode": "481665",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bamni",
            "Pincode": "481771",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nainpur",
            "Pincode": "481776",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Naisarai",
            "Pincode": "481776",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Samnapur",
            "Pincode": "481778",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandla",
            "Pincode": "481879",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Niwas",
            "Pincode": "481885",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mandla",
            "Pincode": "481980",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahpura",
            "Pincode": "481990",
            "City": "Dindori",
            "District": "Dindori",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Anjania",
            "Pincode": "481993",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhuabichhiya",
            "Pincode": "481995",
            "City": "Mandla",
            "District": "Mandla",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Baika Bagicha",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Cantt",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Civil Lines",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Dixitpura",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Ganad Bazar",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur H R Lines",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Hathital",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Howbagh",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Iac Lines",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Jiwan Bima Nigam",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Jonesganj",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Kasturba Nagar",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Napier Lines",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Napier Town",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Premnagar",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Regt Bazar",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Ridge",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Robert Lines",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Sarasvati Vihar",
            "Pincode": "482001",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur City",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Ganjipura",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Gohalpur",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Gorahaphatak",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Gupteshwar",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Gurandi Bazar",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Hanumantal",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur I T I",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Jonesganj",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Kamla Nehru Naga",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Lordganj",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Meloniganj",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Motinalax",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Nagar Nigam",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Telegraph Workshop",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Wright Town",
            "Pincode": "482002",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Garha",
            "Pincode": "482003",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Garth Bazar",
            "Pincode": "482003",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Medical College",
            "Pincode": "482003",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Adhartal",
            "Pincode": "482004",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Anand Nagar",
            "Pincode": "482004",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Kanchanpur",
            "Pincode": "482004",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Gun Shop",
            "Pincode": "482005",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Khamaria Market",
            "Pincode": "482005",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Khameria",
            "Pincode": "482005",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur",
            "Pincode": "482006",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur High Court",
            "Pincode": "482007",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Kutchery",
            "Pincode": "482007",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Vehicle Factory",
            "Pincode": "482009",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur",
            "Pincode": "482010",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Factory",
            "Pincode": "482011",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Gokulpur",
            "Pincode": "482011",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Kasturbanagar",
            "Pincode": "482011",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Bilheri",
            "Pincode": "482020",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Bargi Irrigation",
            "Pincode": "482050",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur",
            "Pincode": "482051",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhedaghat",
            "Pincode": "482053",
            "City": "Bhedaghat",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Bhedaghat",
            "Pincode": "482053",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur Bargi Nagar",
            "Pincode": "482056",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barela",
            "Pincode": "483001",
            "City": "Barela",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Katangi",
            "Pincode": "483105",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kundam",
            "Pincode": "483110",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Patan",
            "Pincode": "483113",
            "City": "Patan",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahpura",
            "Pincode": "483119",
            "City": "Shahpura",
            "District": "Dindori",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur",
            "Pincode": "483220",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur",
            "Pincode": "483220",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gosalpur",
            "Pincode": "483222",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sihora",
            "Pincode": "483225",
            "City": "Sihora",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sihora Khitola Bazar",
            "Pincode": "483225",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bahoriband",
            "Pincode": "483330",
            "City": "Katni",
            "District": "Katni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bakal",
            "Pincode": "483331",
            "City": "Katni",
            "District": "Katni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Umariapan",
            "Pincode": "483332",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Saroli Majhgawan",
            "Pincode": "483334",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sleemnabad",
            "Pincode": "483440",
            "City": "Katni",
            "District": "Katni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Niwar",
            "Pincode": "483442",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur",
            "Pincode": "483445",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Katni",
            "Pincode": "483501",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Katni Bazar",
            "Pincode": "483501",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Katni New Yard",
            "Pincode": "483501",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Katni Purani Basti",
            "Pincode": "483501",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Katni R S",
            "Pincode": "483501",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Katni Rubber",
            "Pincode": "483501",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Katni Cement Factory",
            "Pincode": "483504",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barwara",
            "Pincode": "483773",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bijeraghoghar",
            "Pincode": "483775",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jabalpur",
            "Pincode": "483880",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rithi",
            "Pincode": "483990",
            "City": "Jabalpur",
            "District": "Jabalpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shadol",
            "Pincode": "484001",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahdol B S",
            "Pincode": "484001",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahdol Charolla",
            "Pincode": "484001",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahdol G G",
            "Pincode": "484001",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahdol P B",
            "Pincode": "484001",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Shahdol R S",
            "Pincode": "484001",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Burhar",
            "Pincode": "484110",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Venkatnagar",
            "Pincode": "484113",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhanpuri",
            "Pincode": "484114",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhanpuri Colly",
            "Pincode": "484114",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amlai Colliery",
            "Pincode": "484116",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amlai Paper Mill",
            "Pincode": "484117",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chachai",
            "Pincode": "484220",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Annuppur",
            "Pincode": "484224",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaithari",
            "Pincode": "484330",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kotma",
            "Pincode": "484334",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kotma Colliery",
            "Pincode": "484336",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bijuri",
            "Pincode": "484440",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Beeda",
            "Pincode": "484446",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Birshinhpur Pali",
            "Pincode": "484551",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nowrozabad",
            "Pincode": "484555",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chandia",
            "Pincode": "484660",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Umaria",
            "Pincode": "484661",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Manpur",
            "Pincode": "484665",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gohaparu",
            "Pincode": "484770",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaisingh Nagar Shahdol",
            "Pincode": "484771",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bansagar",
            "Pincode": "484776",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rajendragram",
            "Pincode": "484881",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amarkantak",
            "Pincode": "484886",
            "City": "Shahdol",
            "District": "Shahdol",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Santa",
            "Pincode": "485001",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Satna City",
            "Pincode": "485001",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Satna Civil Lines",
            "Pincode": "485001",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Satna Malivanagar",
            "Pincode": "485001",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Satna Mukhtiarganj",
            "Pincode": "485001",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Satna Semana Chowk",
            "Pincode": "485001",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Satna Jawahar Nagar",
            "Pincode": "485002",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Satna Birla Colony",
            "Pincode": "485005",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ramvan",
            "Pincode": "485111",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Segamaniya",
            "Pincode": "485114",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rampur Baghelan",
            "Pincode": "485115",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bela",
            "Pincode": "485116",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaitwara",
            "Pincode": "485221",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Birsinghpur",
            "Pincode": "485226",
            "City": "Umaria",
            "District": "Umaria",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Majghawan",
            "Pincode": "485331",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nayagaon",
            "Pincode": "485344",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sohawal",
            "Pincode": "485441",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nagod",
            "Pincode": "485446",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Singhpur",
            "Pincode": "485447",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jaso",
            "Pincode": "485551",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Unchehra",
            "Pincode": "485661",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kothi",
            "Pincode": "485666",
            "City": "Katni",
            "District": "Katni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Maihar",
            "Pincode": "485771",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amdara",
            "Pincode": "485773",
            "City": "Umaria",
            "District": "Umaria",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Nadan",
            "Pincode": "485774",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amarpatan",
            "Pincode": "485775",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kathaha",
            "Pincode": "485778",
            "City": "Satna",
            "District": "Satna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "485881",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rewa",
            "Pincode": "486001",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rewa Bichhia Road",
            "Pincode": "486001",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rewa Sagar Colony",
            "Pincode": "486001",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rewa Engineering College",
            "Pincode": "486002",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rewa",
            "Pincode": "486004",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rewa",
            "Pincode": "486006",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mangawan",
            "Pincode": "486111",
            "City": "Mangawan",
            "District": "Katni",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Teoni",
            "Pincode": "486112",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amlaha",
            "Pincode": "486113",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gangeo",
            "Pincode": "486113",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Raipur Karchulian",
            "Pincode": "486114",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Garh",
            "Pincode": "486115",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Manikwar",
            "Pincode": "486123",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Teonthar",
            "Pincode": "486220",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jawa",
            "Pincode": "486223",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chak",
            "Pincode": "486226",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sahagi",
            "Pincode": "486228",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mauganj",
            "Pincode": "486331",
            "City": "Mauganj",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Dhera",
            "Pincode": "486333",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Raghunathganj",
            "Pincode": "486338",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Naigarh",
            "Pincode": "486340",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Deetalb",
            "Pincode": "486341",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rewa",
            "Pincode": "486342",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khat Khari",
            "Pincode": "486343",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Baikunthpur",
            "Pincode": "486441",
            "City": "Baikunthpur",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Tilkhan",
            "Pincode": "486442",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Majghawan",
            "Pincode": "486444",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Semaria",
            "Pincode": "486445",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sirmaur",
            "Pincode": "486448",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rewa",
            "Pincode": "486449",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Mahason",
            "Pincode": "486536",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Govindgarh",
            "Pincode": "486550",
            "City": "Govindgarh",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Khajuhakalan",
            "Pincode": "486552",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gurh",
            "Pincode": "486553",
            "City": "Gurh",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rewa",
            "Pincode": "486556",
            "City": "Rewa",
            "District": "Rewa",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Siddi",
            "Pincode": "486661",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sidhi Bus Stand",
            "Pincode": "486661",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sidhi Collectorate",
            "Pincode": "486661",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Majholi",
            "Pincode": "486666",
            "City": "Majholi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Madwas",
            "Pincode": "486669",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Churhat",
            "Pincode": "486771",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Rampur Naikin",
            "Pincode": "486775",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jiawan",
            "Pincode": "486881",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Waidhan",
            "Pincode": "486886",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Singraoli Collery",
            "Pincode": "486889",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Jayant Project Colliery",
            "Pincode": "486890",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gorbi",
            "Pincode": "486892",
            "City": "Sidhi",
            "District": "Sidhi",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Narsinghpur",
            "Pincode": "487001",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Narsinghpur Basti",
            "Pincode": "487001",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Narsinghpur Itwara Bazar",
            "Pincode": "487001",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Narsinghpur Kandoli",
            "Pincode": "487001",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Narsinghpur R S",
            "Pincode": "487001",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Singhpur",
            "Pincode": "487110",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Karakbel",
            "Pincode": "487114",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gotegaon",
            "Pincode": "487118",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kareli",
            "Pincode": "487221",
            "City": "Kareli",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amgaon Bada",
            "Pincode": "487225",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Sihora",
            "Pincode": "487441",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gadarwara",
            "Pincode": "487551",
            "City": "Gadarwara",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Gadarwara Jawahar Ganj",
            "Pincode": "487551",
            "City": "Gadarwara",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kaudia",
            "Pincode": "487555",
            "City": "Umaria",
            "District": "Umaria",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Chichli",
            "Pincode": "487770",
            "City": "Chichli",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Salichauka Road",
            "Pincode": "487881",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barahbada",
            "Pincode": "487885",
            "City": "Narasinghpur",
            "District": "Narasinghpur",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Panna",
            "Pincode": "488001",
            "City": "Panna",
            "District": "Panna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Panna Bada Bazar",
            "Pincode": "488001",
            "City": "Panna",
            "District": "Panna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Panna Baldeo Bazar",
            "Pincode": "488001",
            "City": "Panna",
            "District": "Panna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Panna Collectorate",
            "Pincode": "488001",
            "City": "Panna",
            "District": "Panna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Panna Gandhi Chowk",
            "Pincode": "488001",
            "City": "Panna",
            "District": "Panna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Kakrahti",
            "Pincode": "488050",
            "City": "Panna",
            "District": "Panna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Barachh",
            "Pincode": "488051",
            "City": "Panna",
            "District": "Panna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Ajaigarh",
            "Pincode": "488220",
            "City": "Ajaigarh",
            "District": "Panna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Amanganj",
            "Pincode": "488441",
            "City": "Amanganj",
            "District": "Panna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Simariya",
            "Pincode": "488442",
            "City": "Panna",
            "District": "Panna",
            "State": "Madhya Pradesh"
        },
        {
            "PostOfficeName": "Bhilai Sector-1 Sbso",
            "Pincode": "490001",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Sector-1 Sbso",
            "Pincode": "490001",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Sector-1 Sbso",
            "Pincode": "490001",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Sector-1 Sbso",
            "Pincode": "490001",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Sector-1 Sbso",
            "Pincode": "490001",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Sector-1 Sbso",
            "Pincode": "490001",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Sector-1 Sbso",
            "Pincode": "490001",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Civic Centre",
            "Pincode": "490006",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Civic Centre",
            "Pincode": "490006",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Civic Centre",
            "Pincode": "490006",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Civic Centre",
            "Pincode": "490006",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg",
            "Pincode": "490008",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg",
            "Pincode": "490009",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Nawa Gaon",
            "Pincode": "490010",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Khursipur",
            "Pincode": "490011",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg",
            "Pincode": "490012",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai East",
            "Pincode": "490021",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai S.A.F. Line",
            "Pincode": "490022",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Supela",
            "Pincode": "490023",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Supela",
            "Pincode": "490023",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Jamul Cement Factory",
            "Pincode": "490024",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Marshalling Yard",
            "Pincode": "490025",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Industrial Estate",
            "Pincode": "490026",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Nandini Mines",
            "Pincode": "490036",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhilai Kumhari",
            "Pincode": "490042",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg Ho.",
            "Pincode": "491001",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg Ho.",
            "Pincode": "491001",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg Ho.",
            "Pincode": "491001",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg Mohan Nagar",
            "Pincode": "491002",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg Mohan Nagar",
            "Pincode": "491002",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg Kasardih",
            "Pincode": "491003",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg",
            "Pincode": "491004",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Patan",
            "Pincode": "491111",
            "City": "Patan",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Nandkathi",
            "Pincode": "491113",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Anda",
            "Pincode": "491221",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sikosa",
            "Pincode": "491222",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Gunderdehi",
            "Pincode": "491223",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Arjunda",
            "Pincode": "491225",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg",
            "Pincode": "491226",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg",
            "Pincode": "491226",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Gurur",
            "Pincode": "491227",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dalirajhara",
            "Pincode": "491228",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dalirajhara",
            "Pincode": "491228",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Manpur",
            "Pincode": "491229",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dondiawari",
            "Pincode": "491230",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dhamdah",
            "Pincode": "491331",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Berta",
            "Pincode": "491332",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bemetara",
            "Pincode": "491335",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dashrangpur",
            "Pincode": "491336",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Nawanagar",
            "Pincode": "491337",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Khamaria",
            "Pincode": "491338",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Nandghat",
            "Pincode": "491340",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Rajnandgaon Ho.",
            "Pincode": "491441",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Rajnandgaon Ho.",
            "Pincode": "491441",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Rajnandgaon Ho.",
            "Pincode": "491441",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Rajnandgaon Ho.",
            "Pincode": "491441",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bajrangpur",
            "Pincode": "491443",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Ghumka",
            "Pincode": "491444",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dongargarh",
            "Pincode": "491445",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chichola",
            "Pincode": "491557",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chhuria",
            "Pincode": "491558",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dongargaon",
            "Pincode": "491661",
            "City": "Dongargaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Ambagarh Chowki",
            "Pincode": "491665",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bandha Bazar",
            "Pincode": "491668",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dondilohara",
            "Pincode": "491771",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Khairagarh",
            "Pincode": "491881",
            "City": "Khairagarh",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chhui Khadan",
            "Pincode": "491885",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Gandai Paderia",
            "Pincode": "491888",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sahaspur",
            "Pincode": "491991",
            "City": "Rajnandgaon",
            "District": "Rajnandgaon",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Saja",
            "Pincode": "491993",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kawardha",
            "Pincode": "491995",
            "City": "Kawardha",
            "District": "Kawardha",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ho.",
            "Pincode": "492001",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Rajkumar College",
            "Pincode": "492003",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Pandri",
            "Pincode": "492004",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Kapa",
            "Pincode": "492005",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Shankar Nagar",
            "Pincode": "492007",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur W.R.S. Colony",
            "Pincode": "492008",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Ganj",
            "Pincode": "492009",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Krishak Nagar",
            "Pincode": "492012",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raipur Mana Camp",
            "Pincode": "492015",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Panduka",
            "Pincode": "492109",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sankara",
            "Pincode": "492112",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Simga",
            "Pincode": "493101",
            "City": "Simga",
            "District": "Korba",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Madhar Cement Factory",
            "Pincode": "493111",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Hatband",
            "Pincode": "493113",
            "City": "Dhamtari",
            "District": "Dhamtari",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Neora",
            "Pincode": "493114",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Baikunth",
            "Pincode": "493116",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhatapara",
            "Pincode": "493118",
            "City": "Bhatapara",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Birgaon",
            "Pincode": "493221",
            "City": "Birgaon",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhatgaon",
            "Pincode": "493222",
            "City": "Bhatgaon",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kharoa",
            "Pincode": "493225",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pallari",
            "Pincode": "493228",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Arjuni",
            "Pincode": "493330",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Baloda Bazar",
            "Pincode": "493332",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kasdol",
            "Pincode": "493335",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilai Garh",
            "Pincode": "493338",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Katgi",
            "Pincode": "493344",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Basana",
            "Pincode": "493354",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Arang",
            "Pincode": "493441",
            "City": "Arang",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Mahasamund",
            "Pincode": "493445",
            "City": "Mahasamund",
            "District": "Mahasamund",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bagbahra",
            "Pincode": "493449",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pithoa",
            "Pincode": "493551",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jagdishpur",
            "Pincode": "493555",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Saraipali",
            "Pincode": "493558",
            "City": "Saraipali",
            "District": "Janjgir - Champa",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sarsiwa",
            "Pincode": "493559",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Banskot",
            "Pincode": "493562",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Abhanpur",
            "Pincode": "493661",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kurud",
            "Pincode": "493663",
            "City": "Kurud",
            "District": "Dhamtari",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dhamtari",
            "Pincode": "493773",
            "City": "Dhamtari",
            "District": "Dhamtari",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dhamtari",
            "Pincode": "493773",
            "City": "Dhamtari",
            "District": "Dhamtari",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Rudri",
            "Pincode": "493776",
            "City": "Dhamtari",
            "District": "Dhamtari",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Nagri",
            "Pincode": "493778",
            "City": "Dhamtari",
            "District": "Dhamtari",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Nayapararajim",
            "Pincode": "493881",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Rajim",
            "Pincode": "493885",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Gariaband",
            "Pincode": "493889",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Deobhog",
            "Pincode": "493890",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Mainpur",
            "Pincode": "493895",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Phingeshwar",
            "Pincode": "493992",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chhura",
            "Pincode": "493996",
            "City": "Raipur",
            "District": "Raipur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jagdalpur Ho.",
            "Pincode": "494001",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jagdalpur Ho.",
            "Pincode": "494001",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jagdalpur Rs",
            "Pincode": "494002",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dharampura",
            "Pincode": "494005",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Lohandiguda",
            "Pincode": "494010",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sukma",
            "Pincode": "494111",
            "City": "Jashpur",
            "District": "Jashpur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Konta",
            "Pincode": "494114",
            "City": "Dantewada",
            "District": "Dantewada",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Tongapal",
            "Pincode": "494115",
            "City": "Jashpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dornapal",
            "Pincode": "494122",
            "City": "Jashpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Asna",
            "Pincode": "494221",
            "City": "Jashpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bakawan",
            "Pincode": "494222",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bastar",
            "Pincode": "494223",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhanpuri",
            "Pincode": "494224",
            "City": "Bhanpuri",
            "District": "Kanker",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sonarpal",
            "Pincode": "494225",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kondagaon",
            "Pincode": "494226",
            "City": "Kondagaon",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Baniyagam",
            "Pincode": "494227",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pharasgaon",
            "Pincode": "494228",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pharasgaon Camp",
            "Pincode": "494229",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pipra Bahigaon",
            "Pincode": "494230",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Keshkal",
            "Pincode": "494331",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Singrapur",
            "Pincode": "494332",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Narharpur",
            "Pincode": "494333",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kanker Ho.",
            "Pincode": "494334",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kanker Ho.",
            "Pincode": "494334",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sarona",
            "Pincode": "494335",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Lakhanpuri",
            "Pincode": "494336",
            "City": "Kanker",
            "District": "Kanker",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Charama",
            "Pincode": "494337",
            "City": "Kanker",
            "District": "Kanker",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bastanar",
            "Pincode": "494435",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Geedam",
            "Pincode": "494441",
            "City": "Geedam",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Tokapal",
            "Pincode": "494442",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bijaipur",
            "Pincode": "494444",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Badekllepal",
            "Pincode": "494445",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhopalpatnam",
            "Pincode": "494446",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Awapalli",
            "Pincode": "494447",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Madded",
            "Pincode": "494448",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Danta Ramgarh",
            "Pincode": "494449",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dantewada",
            "Pincode": "494449",
            "City": "Dantewada",
            "District": "Dantewada",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhansi",
            "Pincode": "494551",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Nakulnar",
            "Pincode": "494552",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bacheli",
            "Pincode": "494553",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Akash Nagar",
            "Pincode": "494554",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kirandul",
            "Pincode": "494556",
            "City": "Kirandul",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Gadiras",
            "Pincode": "494572",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sambalpur",
            "Pincode": "494635",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Narainpur",
            "Pincode": "494661",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Antagarh",
            "Pincode": "494665",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhanu Pratap Nagar",
            "Pincode": "494669",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Korar",
            "Pincode": "494670",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chhote Kapasi",
            "Pincode": "494771",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Durg",
            "Pincode": "494775",
            "City": "Durg",
            "District": "Durg",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pakhanjor Camp",
            "Pincode": "494776",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bande Colony",
            "Pincode": "494777",
            "City": "Jagdalpur",
            "District": "Bastar",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Ho.",
            "Pincode": "495001",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Ho.",
            "Pincode": "495001",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Ho.",
            "Pincode": "495001",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Ho.",
            "Pincode": "495001",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Ho.",
            "Pincode": "495001",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Ho.",
            "Pincode": "495001",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Rs",
            "Pincode": "495004",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Rs",
            "Pincode": "495004",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Rs",
            "Pincode": "495004",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Rs",
            "Pincode": "495004",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Spinning Mills",
            "Pincode": "495007",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Koni",
            "Pincode": "495009",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur",
            "Pincode": "495012",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Ganiyari",
            "Pincode": "495112",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kargi Road",
            "Pincode": "495113",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Belghana",
            "Pincode": "495116",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pendra R.S.",
            "Pincode": "495117",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Marwahi",
            "Pincode": "495118",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pendra",
            "Pincode": "495119",
            "City": "Pendra",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chakrabhata Camp",
            "Pincode": "495220",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Hirr Mines",
            "Pincode": "495222",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur Industrial Estate",
            "Pincode": "495223",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilha",
            "Pincode": "495224",
            "City": "Bilha",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Takhatpur",
            "Pincode": "495330",
            "City": "Takhatpur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Mungeli",
            "Pincode": "495334",
            "City": "Mungeli",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Patharia",
            "Pincode": "495335",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur",
            "Pincode": "495336",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Pandaria",
            "Pincode": "495337",
            "City": "Kawardha",
            "District": "Kawardha",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Ratanpur",
            "Pincode": "495422",
            "City": "Ratanpur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Katghora",
            "Pincode": "495445",
            "City": "Katghora",
            "District": "Korba",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Hardi Bazar",
            "Pincode": "495446",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Banki Mongra",
            "Pincode": "495447",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pali",
            "Pincode": "495449",
            "City": "Korba",
            "District": "Korba",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jamnipali",
            "Pincode": "495450",
            "City": "Korba",
            "District": "Korba",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "West Chirimiri Colliery",
            "Pincode": "495452",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Machadoli",
            "Pincode": "495453",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jairam Nagar",
            "Pincode": "495550",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Masturi",
            "Pincode": "495551",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Akaltara",
            "Pincode": "495552",
            "City": "Akaltara",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Nariyara",
            "Pincode": "495553",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bilaspur",
            "Pincode": "495554",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Bilaspur",
            "Pincode": "495554",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        },
        {
            "PostOfficeName": "Kharod",
            "Pincode": "495556",
            "City": "Kharod",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Seori Narajam",
            "Pincode": "495557",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Baloda",
            "Pincode": "495559",
            "City": "Baloda",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bamni Bazar",
            "Pincode": "495660",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Birra",
            "Pincode": "495661",
            "City": "Janjgir - Champa",
            "District": "Janjgir - Champa",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Gopal Nagar",
            "Pincode": "495663",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Janjigir",
            "Pincode": "495668",
            "City": "Janjgir - Champa",
            "District": "Janjgir - Champa",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Champa",
            "Pincode": "495671",
            "City": "Champa",
            "District": "Janjgir - Champa",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhaisma",
            "Pincode": "495674",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Korba Ho.",
            "Pincode": "495677",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Korba Collierry",
            "Pincode": "495679",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Korba Pragati Nagar",
            "Pincode": "495680",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Korba Thermal Station",
            "Pincode": "495681",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Manikpur Collierry",
            "Pincode": "495682",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Rajgamar Colliery",
            "Pincode": "495683",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Balco Nagar Kobra",
            "Pincode": "495684",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Balco Nagar Kobra",
            "Pincode": "495684",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Baraduar",
            "Pincode": "495687",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dabhara",
            "Pincode": "495688",
            "City": "Janjgir - Champa",
            "District": "Janjgir - Champa",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sakti",
            "Pincode": "495689",
            "City": "Sakti",
            "District": "Janjgir - Champa",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jaijaipur",
            "Pincode": "495690",
            "City": "Janjgir - Champa",
            "District": "Janjgir - Champa",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Malkharoda",
            "Pincode": "495691",
            "City": "Janjgir - Champa",
            "District": "Janjgir - Champa",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chandrapur",
            "Pincode": "495692",
            "City": "Janjgir - Champa",
            "District": "Janjgir - Champa",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Adbhar",
            "Pincode": "495695",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raigarh Ho.",
            "Pincode": "496001",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raigarh Ho.",
            "Pincode": "496001",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Raigarh Jute Mills",
            "Pincode": "496004",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kondatarai",
            "Pincode": "496100",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Tamnar",
            "Pincode": "496107",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Gharghoda",
            "Pincode": "496111",
            "City": "Gharghoda",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Lailunga",
            "Pincode": "496113",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "496115",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Dharam Jaigarh",
            "Pincode": "496116",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pathal Gaon",
            "Pincode": "496118",
            "City": "Jashpur",
            "District": "Jashpur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kansabel",
            "Pincode": "496223",
            "City": "Jashpur",
            "District": "Jashpur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bagicha",
            "Pincode": "496224",
            "City": "Jashpur",
            "District": "Jashpur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kunkruai",
            "Pincode": "496225",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Tapkara",
            "Pincode": "496227",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Manora",
            "Pincode": "496330",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jaspur Nagar",
            "Pincode": "496331",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jaspur Nagar",
            "Pincode": "496331",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Duldula",
            "Pincode": "496334",
            "City": "Kawardha",
            "District": "Kawardha",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sanna",
            "Pincode": "496336",
            "City": "Jashpur",
            "District": "Jashpur",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Gholeng",
            "Pincode": "496338",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pussore",
            "Pincode": "496440",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sarangarh",
            "Pincode": "496445",
            "City": "Sarangarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Hardi",
            "Pincode": "496450",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kosir",
            "Pincode": "496460",
            "City": "Janjgir - Champa",
            "District": "Janjgir - Champa",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Baramkela",
            "Pincode": "496551",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Saria",
            "Pincode": "496554",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kharsia",
            "Pincode": "496661",
            "City": "Kharsia",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chhal",
            "Pincode": "496665",
            "City": "Raigarh",
            "District": "Raigarh",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Ambikapur Ho.",
            "Pincode": "497001",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Ambikapur Ho.",
            "Pincode": "497001",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bastauli",
            "Pincode": "497101",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sitapur",
            "Pincode": "497111",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pratapgarh",
            "Pincode": "497114",
            "City": "Kawardha",
            "District": "Kawardha",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Lakhanpur",
            "Pincode": "497116",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "497118",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Balrampur",
            "Pincode": "497119",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Shankargarh",
            "Pincode": "497210",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Ramanuj Ganj",
            "Pincode": "497220",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kusmi",
            "Pincode": "497222",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Pratappur",
            "Pincode": "497223",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Wadraf Nagar",
            "Pincode": "497225",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Surajpur",
            "Pincode": "497229",
            "City": "Surajpur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhaiyathan",
            "Pincode": "497231",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Bhatgaon Collierry",
            "Pincode": "497235",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Patna",
            "Pincode": "497331",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Ramanuj Nagar",
            "Pincode": "497333",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Baikunthpur",
            "Pincode": "497335",
            "City": "Baikunthpur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Baikunthpur",
            "Pincode": "497335",
            "City": "Baikunthpur",
            "District": "Koriya",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Churcha Collierry",
            "Pincode": "497339",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Surguja",
            "Pincode": "497437",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Manendragarh",
            "Pincode": "497442",
            "City": "Manendragarh",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Manendragarh",
            "Pincode": "497442",
            "City": "Manendragarh",
            "District": "Koriya",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jhagrakhand Colliery",
            "Pincode": "497446",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jhagrakhand Colliery West",
            "Pincode": "497447",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Jhagrakhand Colliery South",
            "Pincode": "497448",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chirimiri",
            "Pincode": "497449",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Haldibadi",
            "Pincode": "497451",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Kurasia Colliery",
            "Pincode": "497553",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Godri Para",
            "Pincode": "497555",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Sonawani Collierry",
            "Pincode": "497557",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Koria Collierry",
            "Pincode": "497559",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Chirimiri Collierry",
            "Pincode": "497773",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Janakpur",
            "Pincode": "497778",
            "City": "Ambikapur",
            "District": "Surguja",
            "State": "Chhattisgarh"
        },
        {
            "PostOfficeName": "Basheer Bagh",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Bhawan",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gun Foundry",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hindi Bhavan",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hyderabad",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hyderabad G P O",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hyderabad R S",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandaswamy Bagh",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "King Koti Complex",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mozampura",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mozamzahi Market",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Putlii Bowli",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramkote",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sitaram Pet",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "State Bank Of Hyd",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "State Bank Of India",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wallaee Street",
            "Pincode": "500001",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhawani Nagar",
            "Pincode": "500002",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jubilee",
            "Pincode": "500002",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mandi Mir Alam Motigalli",
            "Pincode": "500002",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mogalpura",
            "Pincode": "500002",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tagarikanaka",
            "Pincode": "500002",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Begumpet Police Lines",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhoiguda",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bholakpur",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bus Station",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Hospital",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Housing Board Colony",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kavadiguda",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kingsway",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "M G Rd",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Market",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mud Fort",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Napier Lines",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "P G Road",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Picket",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Secunderabad",
            "Pincode": "500003",
            "City": "Secunderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "St Marrys Road",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yellammagutta",
            "Pincode": "500003",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ac Guards",
            "Pincode": "500004",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anand Nagar",
            "Pincode": "500004",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bazar Ghat",
            "Pincode": "500004",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Erram Manzil Colony",
            "Pincode": "500004",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G M Telephones",
            "Pincode": "500004",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khairatabad",
            "Pincode": "500004",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Crp Camp",
            "Pincode": "500005",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Keshorigi",
            "Pincode": "500005",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mamidi Palli",
            "Pincode": "500005",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dhoolpet",
            "Pincode": "500006",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jiaguda",
            "Pincode": "500006",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karwan Sahu",
            "Pincode": "500006",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mangalhat",
            "Pincode": "500006",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Subjimandi",
            "Pincode": "500006",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Administrative Building",
            "Pincode": "500007",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Advanced Training Institute",
            "Pincode": "500007",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Engineering College",
            "Pincode": "500007",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jama I Osmania Hyderabad",
            "Pincode": "500007",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "N G R I",
            "Pincode": "500007",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "R R Labs",
            "Pincode": "500007",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golconda",
            "Pincode": "500008",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Langar House",
            "Pincode": "500008",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mohammedi Lines",
            "Pincode": "500008",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bolarum",
            "Pincode": "500010",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Haig Lines",
            "Pincode": "500010",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mahidpur Lines Alwal",
            "Pincode": "500010",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Alwal Bolaram Bazar",
            "Pincode": "500010",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Risala Bazar",
            "Pincode": "500010",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bowin Palle",
            "Pincode": "500011",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Air Port Hyd",
            "Pincode": "500011",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Afzal Gunj",
            "Pincode": "500012",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Begum Bazar",
            "Pincode": "500012",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hyderabad City Bus Station",
            "Pincode": "500012",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Osmania General Hospital",
            "Pincode": "500012",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amberpet",
            "Pincode": "500013",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Central Police Lines",
            "Pincode": "500013",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hyderabad Public School",
            "Pincode": "500013",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Zinda Tilasmath",
            "Pincode": "500013",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hankimpet",
            "Pincode": "500014",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jagamguda",
            "Pincode": "500014",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kottur",
            "Pincode": "500014",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Samirpet",
            "Pincode": "500014",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gough Lines",
            "Pincode": "500015",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "M C Eme",
            "Pincode": "500015",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sriramnagar Colony",
            "Pincode": "500015",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Trimulcherry",
            "Pincode": "500015",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatapuram",
            "Pincode": "500015",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ameerpet",
            "Pincode": "500016",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Begumpet",
            "Pincode": "500016",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Begumpet",
            "Pincode": "500016",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parkasham Nagar",
            "Pincode": "500016",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "I R I S E T",
            "Pincode": "500017",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lallaguda",
            "Pincode": "500017",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lallapet",
            "Pincode": "500017",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mettuguda",
            "Pincode": "500017",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sainagar",
            "Pincode": "500017",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tarnaka",
            "Pincode": "500017",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Erragadda",
            "Pincode": "500018",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fatehnagar",
            "Pincode": "500018",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rahamatnagar Colony",
            "Pincode": "500018",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanathnagar",
            "Pincode": "500018",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanathnagar Coly",
            "Pincode": "500018",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanatnagar I E",
            "Pincode": "500018",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "500020",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chikkadapalli Market",
            "Pincode": "500020",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golconda Chowrasta",
            "Pincode": "500020",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mushirabad",
            "Pincode": "500020",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eme Records",
            "Pincode": "500021",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Central Secretariat",
            "Pincode": "500022",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dabirpura",
            "Pincode": "500023",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Edi Bazar",
            "Pincode": "500023",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Reinbazar",
            "Pincode": "500023",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yakutpura",
            "Pincode": "500023",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chanchalguda",
            "Pincode": "500024",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Darju Sahifa",
            "Pincode": "500024",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kattal Guda",
            "Pincode": "500024",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Noorkhan Bazar",
            "Pincode": "500024",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sahifa",
            "Pincode": "500024",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chilkalguda",
            "Pincode": "500025",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Padmarao Nagar",
            "Pincode": "500025",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Secunderabad",
            "Pincode": "500025",
            "City": "Secunderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Secunderabad R S",
            "Pincode": "500025",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "East Maredpalli",
            "Pincode": "500026",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nehrunagar",
            "Pincode": "500026",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "West Maredpalli",
            "Pincode": "500026",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Barkatpura",
            "Pincode": "500027",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Esamia Bazar",
            "Pincode": "500027",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nimboliadda",
            "Pincode": "500027",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Stn Kacheguda",
            "Pincode": "500027",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Stone Hosue",
            "Pincode": "500027",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veer Savarkar Marg",
            "Pincode": "500027",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ahmed Nagar",
            "Pincode": "500028",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Asif Nagar",
            "Pincode": "500028",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Datta Treya Colony",
            "Pincode": "500028",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Humayun Nagar",
            "Pincode": "500028",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "J N T U Hyd",
            "Pincode": "500028",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mehdipatnam",
            "Pincode": "500028",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muradnagar",
            "Pincode": "500028",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shantinagar",
            "Pincode": "500028",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shyamnagar",
            "Pincode": "500028",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gaganmahal",
            "Pincode": "500029",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hamayatnagar",
            "Pincode": "500029",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Himayat Nagar East",
            "Pincode": "500029",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Himmat Nagar",
            "Pincode": "500029",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narayanguda",
            "Pincode": "500029",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parisrama Bhavan",
            "Pincode": "500029",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramakrishnamath",
            "Pincode": "500029",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A P E R L",
            "Pincode": "500030",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Agricultural College Jubilee",
            "Pincode": "500030",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishi Raksha",
            "Pincode": "500030",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajendranagar",
            "Pincode": "500030",
            "City": "Rajendranagar",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ibrahim Bagh Lines Hyderabad",
            "Pincode": "500031",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Administrative Building",
            "Pincode": "500032",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gachibowli",
            "Pincode": "500032",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gachibowli",
            "Pincode": "500032",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rama Chandra Puram H E",
            "Pincode": "500032",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Banjara Hills Hyderabad",
            "Pincode": "500034",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Injapur",
            "Pincode": "500035",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Saroornagar",
            "Pincode": "500035",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chaitanyapuri Colony",
            "Pincode": "500036",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dilsukhanagarcoly",
            "Pincode": "500036",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hyderabad Race Club",
            "Pincode": "500036",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malakpet Colony",
            "Pincode": "500036",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Moosaram Bagh",
            "Pincode": "500036",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Malakpet",
            "Pincode": "500036",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Osman Nagar",
            "Pincode": "500036",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sripuram Colony",
            "Pincode": "500036",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cooperative Ind Est",
            "Pincode": "500037",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "T I E Balanagar",
            "Pincode": "500037",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Township",
            "Pincode": "500037",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "B K Guda",
            "Pincode": "500038",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanjeevareddy Nagar",
            "Pincode": "500038",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Beerappagadda",
            "Pincode": "500039",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Survey Of India",
            "Pincode": "500039",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uppal",
            "Pincode": "500039",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Industrial Estate Moulali",
            "Pincode": "500040",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raj Bhavan",
            "Pincode": "500041",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hindustan Aeronautics Hyd",
            "Pincode": "500042",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raju Colony",
            "Pincode": "500042",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Air Force Academy",
            "Pincode": "500043",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Andhra Mahila Sabha",
            "Pincode": "500044",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lali-Thanagar Colony",
            "Pincode": "500044",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nallakunta",
            "Pincode": "500044",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "New Nallakunta",
            "Pincode": "500044",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vidyanagar",
            "Pincode": "500044",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Padmavatinagar",
            "Pincode": "500045",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yousufguda",
            "Pincode": "500045",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malkajgiri",
            "Pincode": "500047",
            "City": "Malkajgiri",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Radhakrishnagar",
            "Pincode": "500047",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Safilguda",
            "Pincode": "500047",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bakaram",
            "Pincode": "500048",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Zamistanpur",
            "Pincode": "500048",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A P S E Board",
            "Pincode": "500049",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Apsp Camp",
            "Pincode": "500049",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bellavista",
            "Pincode": "500049",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hindustan Cables",
            "Pincode": "500051",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hindustan Machine",
            "Pincode": "500051",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lingam Palli",
            "Pincode": "500133",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Central University Campus",
            "Pincode": "500134",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chaitanya Bharati",
            "Pincode": "500171",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Academy",
            "Pincode": "500252",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Katedhan Ie",
            "Pincode": "500252",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Falaknuma Hyd",
            "Pincode": "500253",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shamsheer Ganj",
            "Pincode": "500253",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uppuguda",
            "Pincode": "500253",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanchan Bagh",
            "Pincode": "500258",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bahadur Purra",
            "Pincode": "500264",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandulal Baradari",
            "Pincode": "500264",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hussaini Alam",
            "Pincode": "500264",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadbun",
            "Pincode": "500264",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fateh Darwaza",
            "Pincode": "500265",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guazi Pura",
            "Pincode": "500265",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shali Banda",
            "Pincode": "500265",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sultan Shahi",
            "Pincode": "500265",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "High Court Hyderabad",
            "Pincode": "500266",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kulsumpura",
            "Pincode": "500267",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kumara Bomma Raju",
            "Pincode": "500267",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Boudha Nagar",
            "Pincode": "500361",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sitaphalamandi",
            "Pincode": "500361",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srinivasanagar",
            "Pincode": "500361",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "500380",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vijayanagar Colony",
            "Pincode": "500457",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A GS Office",
            "Pincode": "500463",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adarsh Nagar",
            "Pincode": "500463",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "L I C Dn Hyd",
            "Pincode": "500463",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Somaji Guda",
            "Pincode": "500482",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "New Mla Quarters",
            "Pincode": "500484",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vidhana S-Bha",
            "Pincode": "500486",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rama Krishnapuram",
            "Pincode": "500556",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jai Jawahar Nagar",
            "Pincode": "500587",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vikasnagar",
            "Pincode": "500593",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sainikpuri",
            "Pincode": "500594",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Saidabad",
            "Pincode": "500659",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Saidabad Colony",
            "Pincode": "500659",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Santoshnagar Colony",
            "Pincode": "500659",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "State Bank Colony",
            "Pincode": "500659",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "P & T Colony",
            "Pincode": "500660",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vivekanandnagar",
            "Pincode": "500660",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vamasthli Puram",
            "Pincode": "500661",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vanavolu",
            "Pincode": "500661",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dr A S Raonagar Colony",
            "Pincode": "500762",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ecil Hyderabad",
            "Pincode": "500762",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Central Training Institute",
            "Pincode": "500768",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ind Dev Are Jeed Hyd",
            "Pincode": "500855",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kukatpalli",
            "Pincode": "500872",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srinagar Colony",
            "Pincode": "500873",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A G S Office Staff",
            "Pincode": "500890",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Quarters",
            "Pincode": "500890",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vengalra0 Nagar Hyd",
            "Pincode": "500890",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lal Bahadur Nagar",
            "Pincode": "500963",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vikarabad",
            "Pincode": "501101",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Godamguda",
            "Pincode": "501102",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ekmamidi",
            "Pincode": "501103",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Porur",
            "Pincode": "501104",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pothaka Palli",
            "Pincode": "501104",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantha Giripalle",
            "Pincode": "501105",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalkoda",
            "Pincode": "501106",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kesaram",
            "Pincode": "501106",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotpalli",
            "Pincode": "501106",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramapur",
            "Pincode": "501106",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ravulapalli",
            "Pincode": "501106",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rompalli",
            "Pincode": "501106",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Salbathapur",
            "Pincode": "501106",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Somapam",
            "Pincode": "501106",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yenkaram",
            "Pincode": "501106",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yenkepalli",
            "Pincode": "501106",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothagadi",
            "Pincode": "501108",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manneguda",
            "Pincode": "501109",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velchal",
            "Pincode": "501110",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nawabpet",
            "Pincode": "501111",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Phulamamdi",
            "Pincode": "501112",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chitti Gadda",
            "Pincode": "501113",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madireddi Palli",
            "Pincode": "501114",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gangaram",
            "Pincode": "501115",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramnadgudpalli",
            "Pincode": "501115",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharur",
            "Pincode": "501121",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karan Kot",
            "Pincode": "501141",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Tandur",
            "Pincode": "501141",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tandur",
            "Pincode": "501141",
            "City": "Tandur",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jangaon",
            "Pincode": "501142",
            "City": "Jangaon",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddimal",
            "Pincode": "501142",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Basheerabad",
            "Pincode": "501143",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "China Gottiga",
            "Pincode": "501143",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yalal",
            "Pincode": "501144",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Navalga",
            "Pincode": "501145",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Agnoor",
            "Pincode": "501146",
            "City": "Agnoor",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandanhalli",
            "Pincode": "501147",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mailwar",
            "Pincode": "501148",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manthangod",
            "Pincode": "501149",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yekmai",
            "Pincode": "501150",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gingurthi",
            "Pincode": "501151",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indoor",
            "Pincode": "501152",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mumbapur",
            "Pincode": "501153",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Junta Palli",
            "Pincode": "501154",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pagdial",
            "Pincode": "501155",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Turmamidi",
            "Pincode": "501156",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malkapur",
            "Pincode": "501157",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "C C I",
            "Pincode": "501158",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anata Giri",
            "Pincode": "501201",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothulapur",
            "Pincode": "501201",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buchampalle",
            "Pincode": "501202",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotmarpalli",
            "Pincode": "501202",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mominpet",
            "Pincode": "501202",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sirpura",
            "Pincode": "501202",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marpallikalan",
            "Pincode": "501203",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patlur",
            "Pincode": "501204",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tekulapalli",
            "Pincode": "501205",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yenkatla",
            "Pincode": "501206",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ghatkesar",
            "Pincode": "501301",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medchal",
            "Pincode": "501401",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nuthankkal",
            "Pincode": "501401",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gowda Valli",
            "Pincode": "501403",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Purgi",
            "Pincode": "501501",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bompally",
            "Pincode": "501502",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chevela",
            "Pincode": "501503",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amadapur",
            "Pincode": "501504",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aziz Nagar",
            "Pincode": "501504",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Himayat Nagar",
            "Pincode": "501504",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanakamamdi",
            "Pincode": "501504",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hayatnagar",
            "Pincode": "501505",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pasmamla",
            "Pincode": "501505",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ibrahimpatnam",
            "Pincode": "501506",
            "City": "Ibrahimpatnam",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Japal",
            "Pincode": "501508",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polkam Palli",
            "Pincode": "501508",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rai Pole",
            "Pincode": "501508",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yacharam",
            "Pincode": "501509",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kongara Raviryal",
            "Pincode": "501510",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mangalpalli",
            "Pincode": "501510",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuntloor",
            "Pincode": "501511",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "China Mangalaram",
            "Pincode": "501512",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Mangalaram",
            "Pincode": "501513",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aloor",
            "Pincode": "501514",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gundal",
            "Pincode": "501515",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chelkur",
            "Pincode": "501516",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Moinabad",
            "Pincode": "501518",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Seri Guda",
            "Pincode": "501520",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gungal",
            "Pincode": "501521",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ainapur",
            "Pincode": "501522",
            "City": "Ainapur",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Surangal",
            "Pincode": "501523",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Doma",
            "Pincode": "501525",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Regad Ghanpur",
            "Pincode": "501526",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tati Parthy",
            "Pincode": "501527",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Batasingaram",
            "Pincode": "501528",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandi Vanaparthi",
            "Pincode": "501531",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medpalli",
            "Pincode": "501533",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mailaram",
            "Pincode": "501534",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatapur",
            "Pincode": "501535",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kawad Palli",
            "Pincode": "501536",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Turkayamjal",
            "Pincode": "501537",
            "City": "Ranga Reddy",
            "District": "Ranga Reddy",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hanuman Nagar",
            "Pincode": "502001",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalva Kunta",
            "Pincode": "502001",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nalsabgadda",
            "Pincode": "502001",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prasantinagar",
            "Pincode": "502001",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajampet Colony",
            "Pincode": "502001",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S Reddy Bus Stand",
            "Pincode": "502001",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S Reddy Collectorate",
            "Pincode": "502001",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sangareddy",
            "Pincode": "502001",
            "City": "Sangareddy",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanjeevanagar",
            "Pincode": "502001",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rahimkhanpot",
            "Pincode": "502101",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramayampet",
            "Pincode": "502101",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramyanpet Town",
            "Pincode": "502101",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nizampat",
            "Pincode": "502102",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ambedkar Nagar",
            "Pincode": "502103",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bara E Imam",
            "Pincode": "502103",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bharat Nagar",
            "Pincode": "502103",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indira Nagar Colony",
            "Pincode": "502103",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Komaticherru",
            "Pincode": "502103",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nehru Road",
            "Pincode": "502103",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prasanti Nagar",
            "Pincode": "502103",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Siddipet",
            "Pincode": "502103",
            "City": "Siddipet",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Siddipet Bus Stand",
            "Pincode": "502103",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Togatta",
            "Pincode": "502104",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pullur",
            "Pincode": "502107",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dubbak",
            "Pincode": "502108",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Machavaram",
            "Pincode": "502109",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bus Stand",
            "Pincode": "502110",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fatehnagar",
            "Pincode": "502110",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fort",
            "Pincode": "502110",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "M G Road",
            "Pincode": "502110",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medak",
            "Pincode": "502110",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sub Collectorate",
            "Pincode": "502110",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Town",
            "Pincode": "502110",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Havoli Ghanapur",
            "Pincode": "502113",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Irkode",
            "Pincode": "502114",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajpalli",
            "Pincode": "502117",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuchanpally",
            "Pincode": "502130",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shankar Palli",
            "Pincode": "502201",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kohir",
            "Pincode": "502210",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kohir Town",
            "Pincode": "502210",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gurazawada",
            "Pincode": "502211",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pichargad",
            "Pincode": "502212",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maniar Palli",
            "Pincode": "502213",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arya Nagar",
            "Pincode": "502220",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chira Mohalla",
            "Pincode": "502220",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Zahirabad",
            "Pincode": "502220",
            "City": "Zahirabad",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Zahirabad Bazar",
            "Pincode": "502220",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Zahirabad Gadi",
            "Pincode": "502220",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Zahirabvad Ganj",
            "Pincode": "502220",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Charak Palli",
            "Pincode": "502221",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madhu Nagar",
            "Pincode": "502228",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Zarasangam",
            "Pincode": "502246",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Makkarajpet",
            "Pincode": "502247",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsingee",
            "Pincode": "502248",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mirzapur",
            "Pincode": "502249",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Handnoor",
            "Pincode": "502251",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chegunta",
            "Pincode": "502255",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nyalkal",
            "Pincode": "502256",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rai Kode",
            "Pincode": "502257",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ibrahim Nagar",
            "Pincode": "502267",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alla Durg",
            "Pincode": "502269",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jogipet",
            "Pincode": "502270",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jogipet Clock Tower",
            "Pincode": "502270",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jogipet Town",
            "Pincode": "502270",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shankarampet",
            "Pincode": "502271",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shankarampet Bzr",
            "Pincode": "502271",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Andole",
            "Pincode": "502273",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodur Khurd",
            "Pincode": "502276",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dudheda",
            "Pincode": "502277",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gujvail",
            "Pincode": "502278",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gujvail Bus Stand",
            "Pincode": "502278",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gujvail Old Town",
            "Pincode": "502278",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pamalparthi",
            "Pincode": "502279",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Negnoor",
            "Pincode": "502280",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jagadevpur",
            "Pincode": "502281",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raj Gopal Pet",
            "Pincode": "502284",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandi",
            "Pincode": "502285",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mangalpet",
            "Pincode": "502286",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narayankhed",
            "Pincode": "502286",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sirgapur",
            "Pincode": "502287",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Togarpalli",
            "Pincode": "502288",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondapur",
            "Pincode": "502289",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Regode",
            "Pincode": "502290",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sadashivpet",
            "Pincode": "502291",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sadashivpet Bazar",
            "Pincode": "502291",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sudashivppet Bus Stand",
            "Pincode": "502291",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atmakur",
            "Pincode": "502292",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Singur Project",
            "Pincode": "502293",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manjeera Barriage",
            "Pincode": "502294",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ismail Khan Pet",
            "Pincode": "502296",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hatnura",
            "Pincode": "502297",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chintalcheru",
            "Pincode": "502299",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuknoorpalli",
            "Pincode": "502301",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tekmal",
            "Pincode": "502302",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Papannapet",
            "Pincode": "502303",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapalli",
            "Pincode": "502304",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dhanora",
            "Pincode": "502305",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandi Kandi",
            "Pincode": "502306",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Idapasham",
            "Pincode": "502307",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uthloor",
            "Pincode": "502307",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagi Reddi Pet",
            "Pincode": "502308",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Allipur",
            "Pincode": "502310",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pragnapur",
            "Pincode": "502311",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodakandla",
            "Pincode": "502312",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsapur",
            "Pincode": "502313",
            "City": "Narsapur",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Siripura",
            "Pincode": "502314",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ranjhol",
            "Pincode": "502318",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patancheruvu I E",
            "Pincode": "502319",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pattan Cheruvu",
            "Pincode": "502319",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pattancheruvu",
            "Pincode": "502319",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Phase Ii",
            "Pincode": "502319",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramachandrapuram Bazar",
            "Pincode": "502319",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Digwal",
            "Pincode": "502321",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishnapur",
            "Pincode": "502322",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yelmakanna",
            "Pincode": "502323",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Icrisat",
            "Pincode": "502324",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mutrajpalli",
            "Pincode": "502325",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rudraram",
            "Pincode": "502329",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indrakannu",
            "Pincode": "502330",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yousufpet",
            "Pincode": "502331",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Donthi",
            "Pincode": "502334",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Toopran",
            "Pincode": "502334",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Toopran Bus Stand",
            "Pincode": "502334",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nizampet",
            "Pincode": "502371",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondapak",
            "Pincode": "502372",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chikul",
            "Pincode": "502374",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palamkole",
            "Pincode": "502375",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palmukula",
            "Pincode": "502375",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rangam Pet",
            "Pincode": "502381",
            "City": "Medak",
            "District": "Medak",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gajul Pet",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Gunj",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Giriraj College",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gurbabadi",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jawahar Road",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jummerat Bazar",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotgalli",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nizamabad",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Phulong",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shivajinagar",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shraddamandgunj",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Valmikinagar",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vinaiknagar",
            "Pincode": "503001",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanteshwar",
            "Pincode": "503002",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Municipal House Coly",
            "Pincode": "503002",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Namdewada",
            "Pincode": "503002",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Subhashnagar",
            "Pincode": "503002",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nizamabad R S",
            "Pincode": "503003",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhiknoor",
            "Pincode": "503101",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jangampalli",
            "Pincode": "503102",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malla Reddi Kalan",
            "Pincode": "503103",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pondurthi",
            "Pincode": "503103",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rameshwarapalli",
            "Pincode": "503103",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Talmadla",
            "Pincode": "503103",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tippapur",
            "Pincode": "503103",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajampet",
            "Pincode": "503110",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bus Stand Complex",
            "Pincode": "503111",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indira Nagar",
            "Pincode": "503111",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Islampura",
            "Pincode": "503111",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jagajivan Ramnagar",
            "Pincode": "503111",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamaeddy Arts & Scie Coll",
            "Pincode": "503111",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamareddy",
            "Pincode": "503111",
            "City": "Kamareddy",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamareddy Gunj",
            "Pincode": "503111",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamereddy Rs",
            "Pincode": "503111",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Subhash Road",
            "Pincode": "503111",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhari",
            "Pincode": "503114",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhawanpet",
            "Pincode": "503115",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palwancha",
            "Pincode": "503116",
            "City": "Palwancha",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerra Pahad",
            "Pincode": "503120",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Y R Old Town",
            "Pincode": "503122",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yella Reddy",
            "Pincode": "503122",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Domakonda",
            "Pincode": "503123",
            "City": "Domakonda",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palugadda",
            "Pincode": "503123",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Demi",
            "Pincode": "503124",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lingampet",
            "Pincode": "503124",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bibipet",
            "Pincode": "503125",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rama Reddy",
            "Pincode": "503144",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharamraopet",
            "Pincode": "503145",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sadsivnagar",
            "Pincode": "503145",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indalwai R S",
            "Pincode": "503164",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Darpalli",
            "Pincode": "503165",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Toompalli",
            "Pincode": "503166",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nizamabad",
            "Pincode": "503174",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dichpalli",
            "Pincode": "503175",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nadepalli",
            "Pincode": "503176",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mullangi",
            "Pincode": "503177",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Padkal",
            "Pincode": "503178",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Camp Ootpalli",
            "Pincode": "503180",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shakarnagar",
            "Pincode": "503180",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bodhan",
            "Pincode": "503185",
            "City": "Bodhan",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bodhan R S",
            "Pincode": "503185",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rakasipet",
            "Pincode": "503185",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sarangapur",
            "Pincode": "503186",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Banswada",
            "Pincode": "503187",
            "City": "Banswada",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Banswada Bazar",
            "Pincode": "503187",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rudrur",
            "Pincode": "503188",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penta Khurd",
            "Pincode": "503192",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jankampet R S",
            "Pincode": "503193",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jakora",
            "Pincode": "503201",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Varni",
            "Pincode": "503201",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Edpalli",
            "Pincode": "503202",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurnapalli",
            "Pincode": "503202",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thankalam",
            "Pincode": "503203",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mosra",
            "Pincode": "503206",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotgir",
            "Pincode": "503207",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandi Pet",
            "Pincode": "503212",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Makloor",
            "Pincode": "503213",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Allor",
            "Pincode": "503214",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Andhra Nagar",
            "Pincode": "503215",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Balkonda",
            "Pincode": "503217",
            "City": "Balkonda",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kissan Nagar",
            "Pincode": "503218",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ranjarla",
            "Pincode": "503218",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pochampad Project",
            "Pincode": "503219",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fathepur",
            "Pincode": "503220",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Subriyal",
            "Pincode": "503221",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mupkal",
            "Pincode": "503222",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Armoor",
            "Pincode": "503224",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Armoor Bus Station",
            "Pincode": "503224",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Armoor Old Town",
            "Pincode": "503224",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ziryatnagar",
            "Pincode": "503224",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Modtad",
            "Pincode": "503225",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palem",
            "Pincode": "503225",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manthani",
            "Pincode": "503226",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Timmapur",
            "Pincode": "503227",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chepur",
            "Pincode": "503228",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharamaram",
            "Pincode": "503230",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bardipur",
            "Pincode": "503231",
            "City": "Bardipur",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ambam",
            "Pincode": "503235",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ranjal",
            "Pincode": "503236",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Navipet",
            "Pincode": "503245",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jannepalli",
            "Pincode": "503246",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mirzapur",
            "Pincode": "503301",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nizamsagar",
            "Pincode": "503302",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jukal",
            "Pincode": "503305",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bichukonda",
            "Pincode": "503306",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhimagal",
            "Pincode": "503307",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhimgal Bus Stand",
            "Pincode": "503307",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsapur",
            "Pincode": "503307",
            "City": "Narsapur",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kumar Palli",
            "Pincode": "503308",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madnoor",
            "Pincode": "503309",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pitlam",
            "Pincode": "503310",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vailpur",
            "Pincode": "503311",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vannel B",
            "Pincode": "503313",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Donkal",
            "Pincode": "503314",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Padgal",
            "Pincode": "503315",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Birkur",
            "Pincode": "503321",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adarsh Nagar",
            "Pincode": "504001",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adilabad",
            "Pincode": "504001",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhagya Nagar",
            "Pincode": "504001",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhuktapur",
            "Pincode": "504001",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "College Campus",
            "Pincode": "504001",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cotton Market",
            "Pincode": "504001",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "504001",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "504001",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirpalli",
            "Pincode": "504001",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adilabad Collecotorate",
            "Pincode": "504002",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Township",
            "Pincode": "504003",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Basar",
            "Pincode": "504101",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mudhole",
            "Pincode": "504102",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mudhole Bus Stand",
            "Pincode": "504102",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhainsa",
            "Pincode": "504103",
            "City": "Bhainsa",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Purana Bazar",
            "Pincode": "504103",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsapur",
            "Pincode": "504104",
            "City": "Narsapur",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Soan",
            "Pincode": "504105",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Budwarpet",
            "Pincode": "504106",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bungalpet",
            "Pincode": "504106",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eidgaon",
            "Pincode": "504106",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indra Nagar",
            "Pincode": "504106",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kasba",
            "Pincode": "504106",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nirmal",
            "Pincode": "504106",
            "City": "Nirmal",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nirmal Bus Stand",
            "Pincode": "504106",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sofinagar",
            "Pincode": "504106",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuntala",
            "Pincode": "504109",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chincholi",
            "Pincode": "504110",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinnoor",
            "Pincode": "504201",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddur",
            "Pincode": "504202",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khanapur",
            "Pincode": "504203",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bheemaran",
            "Pincode": "504204",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jannaram",
            "Pincode": "504205",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dandepalli",
            "Pincode": "504206",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dona Banda",
            "Pincode": "504207",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Grain Market",
            "Pincode": "504208",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mancherial Bus Stand",
            "Pincode": "504208",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mancherial Bzr",
            "Pincode": "504208",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mancherial Civil Hospital",
            "Pincode": "504208",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manchiriyal",
            "Pincode": "504208",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patha Mancherial",
            "Pincode": "504208",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cement Works",
            "Pincode": "504209",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotapalli",
            "Pincode": "504214",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Laxshotti Pet",
            "Pincode": "504215",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jaipur Adilabad",
            "Pincode": "504216",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shet Palli",
            "Pincode": "504217",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Devapur",
            "Pincode": "504218",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madaram Town Shop",
            "Pincode": "504220",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalyani Khani",
            "Pincode": "504231",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mandamarri Bus Stand",
            "Pincode": "504231",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mandamarri Coll",
            "Pincode": "504231",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Subashnagar",
            "Pincode": "504231",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kasipet",
            "Pincode": "504232",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A G M Colony",
            "Pincode": "504251",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bellam Palli",
            "Pincode": "504251",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bellampalli Basti",
            "Pincode": "504251",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bellampalli R S",
            "Pincode": "504251",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tandur",
            "Pincode": "504272",
            "City": "Tandur",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rechini",
            "Pincode": "504273",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rebbena",
            "Pincode": "504292",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Asifabad",
            "Pincode": "504293",
            "City": "Asifabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chirra Kunta",
            "Pincode": "504294",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wakndi",
            "Pincode": "504295",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Industrial Area",
            "Pincode": "504296",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "M G Road",
            "Pincode": "504296",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Market Vard",
            "Pincode": "504296",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Town",
            "Pincode": "504296",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "R P Colony",
            "Pincode": "504296",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sir Silk Colony",
            "Pincode": "504296",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sirpur Kaghaznagar",
            "Pincode": "504296",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sirpur",
            "Pincode": "504299",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sirpur Town Bus Std",
            "Pincode": "504299",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rama Krishnpuram",
            "Pincode": "504301",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Boath",
            "Pincode": "504304",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hatnoor",
            "Pincode": "504305",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dilwarpur",
            "Pincode": "504306",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Echoda",
            "Pincode": "504307",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudihatnur",
            "Pincode": "504308",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gumma",
            "Pincode": "504309",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mamda",
            "Pincode": "504310",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ootnur",
            "Pincode": "504311",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tamsi",
            "Pincode": "504312",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jainur",
            "Pincode": "504313",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khodad",
            "Pincode": "504318",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ponnari",
            "Pincode": "504319",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wankdi",
            "Pincode": "504321",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guraj Mannur",
            "Pincode": "504322",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Naredigonda",
            "Pincode": "504323",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Neredi Gonda",
            "Pincode": "504323",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bela",
            "Pincode": "504324",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jainad",
            "Pincode": "504325",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sunkidi",
            "Pincode": "504327",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pipri",
            "Pincode": "504330",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nachan Yellapur",
            "Pincode": "504340",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indarpalli",
            "Pincode": "504342",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manidi Palli",
            "Pincode": "504343",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hajipur",
            "Pincode": "504344",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indervalli",
            "Pincode": "504346",
            "City": "Adilabad",
            "District": "Adilabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Road",
            "Pincode": "505001",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jubilee Kaman",
            "Pincode": "505001",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "K Nagar Bus Stand",
            "Pincode": "505001",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karimnagar",
            "Pincode": "505001",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dist Court Bldgs",
            "Pincode": "505002",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "505002",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mukarampura",
            "Pincode": "505002",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "505002",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhimpalli",
            "Pincode": "505101",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kannur",
            "Pincode": "505101",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uppal",
            "Pincode": "505101",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buthareddigudem",
            "Pincode": "505102",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamalapur",
            "Pincode": "505102",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kesavapur",
            "Pincode": "505102",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shanigaram",
            "Pincode": "505102",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vagapalli",
            "Pincode": "505102",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jammikunta",
            "Pincode": "505122",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khadeemabadi",
            "Pincode": "505122",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Korapalli",
            "Pincode": "505122",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanagarthi",
            "Pincode": "505152",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madka",
            "Pincode": "505152",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Odela",
            "Pincode": "505152",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rampuram",
            "Pincode": "505153",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rathpalli",
            "Pincode": "505153",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kolanur",
            "Pincode": "505162",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Palli",
            "Pincode": "505172",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Asappannapet",
            "Pincode": "505173",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Palli R S",
            "Pincode": "505173",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raghavapur",
            "Pincode": "505173",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Turkalamaddikunta",
            "Pincode": "505173",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pocham Pad Colony",
            "Pincode": "505174",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rampalli",
            "Pincode": "505174",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cunjapadugu",
            "Pincode": "505184",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jallaram",
            "Pincode": "505184",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kammampalli",
            "Pincode": "505184",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kannal",
            "Pincode": "505184",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manthani",
            "Pincode": "505184",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagaram",
            "Pincode": "505184",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Puttapak",
            "Pincode": "505184",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Suddala",
            "Pincode": "505185",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sultanabad",
            "Pincode": "505185",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Garre Palli",
            "Pincode": "505186",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Basant Nagar",
            "Pincode": "505187",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Isala Takkalapalli",
            "Pincode": "505187",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adivarampet",
            "Pincode": "505188",
            "City": "Adivarampet",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Begampet",
            "Pincode": "505188",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Elkalapalli",
            "Pincode": "505188",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Julapalli",
            "Pincode": "505188",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalvacherla",
            "Pincode": "505188",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamanpur",
            "Pincode": "505188",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ladnapur",
            "Pincode": "505188",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parepalli",
            "Pincode": "505188",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ratnapur",
            "Pincode": "505188",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Abadi Ramagundam",
            "Pincode": "505208",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rama Gundam",
            "Pincode": "505208",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramagundam R S",
            "Pincode": "505208",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Godavari Khani",
            "Pincode": "505209",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madpalli",
            "Pincode": "505209",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Singareni Collories Admn",
            "Pincode": "505209",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fertilizer City",
            "Pincode": "505210",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Subhashnagar",
            "Pincode": "505211",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vittal Nagar",
            "Pincode": "505214",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ntpc Jyotinagar",
            "Pincode": "505215",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "505301",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sirsilla",
            "Pincode": "505301",
            "City": "Sirsilla",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vemula Vada Sankepalli",
            "Pincode": "505302",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kishandaspet",
            "Pincode": "505303",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gumbhirao Pet",
            "Pincode": "505304",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Racharla Boppapur",
            "Pincode": "505305",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ambaripet",
            "Pincode": "505306",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rudrangi",
            "Pincode": "505307",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Konarao Pet",
            "Pincode": "505309",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Metpalli",
            "Pincode": "505325",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Metpalli Bazar",
            "Pincode": "505325",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koratla",
            "Pincode": "505326",
            "City": "Koratla",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koratlabazar",
            "Pincode": "505326",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jagtial",
            "Pincode": "505327",
            "City": "Jagtial",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kila Jagtial",
            "Pincode": "505327",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "New Abadi",
            "Pincode": "505327",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alipur",
            "Pincode": "505330",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muthyampet",
            "Pincode": "505331",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Elgandal",
            "Pincode": "505401",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodurpak",
            "Pincode": "505402",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marrepalle",
            "Pincode": "505403",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mustabad",
            "Pincode": "505404",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadoor",
            "Pincode": "505405",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bandankal",
            "Pincode": "505407",
            "City": "Bandankal",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pothugal",
            "Pincode": "505408",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jillella",
            "Pincode": "505410",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cheerlavancha",
            "Pincode": "505412",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vablapur",
            "Pincode": "505413",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Choppa Dandi",
            "Pincode": "505415",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mydaram",
            "Pincode": "505416",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagnoor",
            "Pincode": "505417",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharamapuri",
            "Pincode": "505425",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gangadhara",
            "Pincode": "505445",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ibrahimpathnam",
            "Pincode": "505450",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapalli",
            "Pincode": "505451",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mallial",
            "Pincode": "505452",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medpalli",
            "Pincode": "505453",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nerella",
            "Pincode": "505454",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pochampad Cly",
            "Pincode": "505455",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vendira",
            "Pincode": "505459",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raikal",
            "Pincode": "505460",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sir Konda",
            "Pincode": "505462",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anthakpet",
            "Pincode": "505466",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Potharam",
            "Pincode": "505466",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Husnabad",
            "Pincode": "505467",
            "City": "Husnabad",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chelpur",
            "Pincode": "505468",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hyderabad",
            "Pincode": "505468",
            "City": "Hyderabad",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Metpalli",
            "Pincode": "505468",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mana Kondur",
            "Pincode": "505469",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kachapur",
            "Pincode": "505470",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Molangur",
            "Pincode": "505470",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhemadeverapalli",
            "Pincode": "505471",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gatla Narsingapur",
            "Pincode": "505471",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothakonda",
            "Pincode": "505471",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muluknur",
            "Pincode": "505471",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bommanapalli",
            "Pincode": "505472",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Saidapur",
            "Pincode": "505472",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shanigram",
            "Pincode": "505473",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gangipalli",
            "Pincode": "505474",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondapalkala",
            "Pincode": "505474",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadikal",
            "Pincode": "505474",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bijgirishareef",
            "Pincode": "505475",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bijnur",
            "Pincode": "505475",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rachapalli",
            "Pincode": "505475",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vavilal",
            "Pincode": "505475",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Damera",
            "Pincode": "505476",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yelkadurthi",
            "Pincode": "505476",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bommakal",
            "Pincode": "505480",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raikal",
            "Pincode": "505480",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vangara",
            "Pincode": "505480",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nustulapur",
            "Pincode": "505481",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kesavapatnam",
            "Pincode": "505490",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jeelgula",
            "Pincode": "505498",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "K C Campus",
            "Pincode": "505498",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "505498",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodmial",
            "Pincode": "505501",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondapak",
            "Pincode": "505502",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veena Vanka",
            "Pincode": "505502",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kataram",
            "Pincode": "505503",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mahadeopur",
            "Pincode": "505504",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Challore",
            "Pincode": "505505",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chanmukla",
            "Pincode": "505505",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ootur",
            "Pincode": "505505",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anthergaon Textiles",
            "Pincode": "505514",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bopenpalli",
            "Pincode": "505524",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Elgaid",
            "Pincode": "505525",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Endapalli",
            "Pincode": "505526",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lower Manair Dam Colony",
            "Pincode": "505527",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bejjanki",
            "Pincode": "505528",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polas",
            "Pincode": "505529",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indurthi",
            "Pincode": "505530",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thota Palli",
            "Pincode": "505530",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramadugu",
            "Pincode": "505531",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golla Palli",
            "Pincode": "505532",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Algunur",
            "Pincode": "505533",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nawabpet",
            "Pincode": "505545",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jangaon",
            "Pincode": "505547",
            "City": "Jangaon",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mallam Palli",
            "Pincode": "505548",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pandilla",
            "Pincode": "505567",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hanamkonda",
            "Pincode": "506001",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lashkar Bazar",
            "Pincode": "506001",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Reddi Colony",
            "Pincode": "506001",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Beat Bazar",
            "Pincode": "506002",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Grain Market",
            "Pincode": "506002",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karimabad",
            "Pincode": "506002",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kasibugga",
            "Pincode": "506002",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Matwada",
            "Pincode": "506002",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Railway Gate",
            "Pincode": "506002",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S V N Road",
            "Pincode": "506002",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Warangal",
            "Pincode": "506002",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bapuji Nagar",
            "Pincode": "506003",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fatimanagar",
            "Pincode": "506003",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kazipet",
            "Pincode": "506003",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "R E College",
            "Pincode": "506004",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ranga Shai Pet",
            "Pincode": "506005",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Deshaipet",
            "Pincode": "506006",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "506007",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kakatiya Medical College",
            "Pincode": "506007",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mgm Hospital",
            "Pincode": "506007",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fort Warangal",
            "Pincode": "506008",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vidyaranya Puri",
            "Pincode": "506009",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Subedari",
            "Pincode": "506010",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Deval Hazar Sutoon",
            "Pincode": "506011",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hanamkonda Bus Stn",
            "Pincode": "506011",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "M G Road",
            "Pincode": "506012",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mandi Bazar",
            "Pincode": "506012",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Laxmipur",
            "Pincode": "506013",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pragati Industrial Estate",
            "Pincode": "506013",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kakatiya Canal Colony Wgl",
            "Pincode": "506015",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mahabubabad",
            "Pincode": "506101",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "New Abadi",
            "Pincode": "506101",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nerada",
            "Pincode": "506104",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurvi",
            "Pincode": "506105",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kesamudram",
            "Pincode": "506112",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nekkonda",
            "Pincode": "506122",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsampet",
            "Pincode": "506132",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "506133",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudur",
            "Pincode": "506134",
            "City": "Gudur",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madikonda",
            "Pincode": "506142",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ghanpur R S",
            "Pincode": "506143",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Abadi Ghanpur",
            "Pincode": "506144",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pallagutta",
            "Pincode": "506144",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malkapur",
            "Pincode": "506145",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Pendyal",
            "Pincode": "506151",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Torrur",
            "Pincode": "506163",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parkal",
            "Pincode": "506164",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Temple Street",
            "Pincode": "506164",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eturnagaram",
            "Pincode": "506165",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mamnoor",
            "Pincode": "506166",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jangaon",
            "Pincode": "506167",
            "City": "Jangaon",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jangaon Bazar",
            "Pincode": "506167",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chelpur",
            "Pincode": "506168",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Town Shop",
            "Pincode": "506172",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pembarti",
            "Pincode": "506201",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buchinnapet",
            "Pincode": "506221",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodakondla",
            "Pincode": "506222",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chiryal",
            "Pincode": "506223",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsal Palle",
            "Pincode": "506223",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ladnoor",
            "Pincode": "506224",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mustial",
            "Pincode": "506224",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gobbeta",
            "Pincode": "506244",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanchanapalli",
            "Pincode": "506244",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Komadla",
            "Pincode": "506244",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nidigonda",
            "Pincode": "506244",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Quilashapur",
            "Pincode": "506244",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raghunath Palli",
            "Pincode": "506244",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ippaguda",
            "Pincode": "506252",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chagal",
            "Pincode": "506301",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Devaruppala",
            "Pincode": "506302",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mondrai",
            "Pincode": "506302",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kundaram",
            "Pincode": "506303",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Waddicherla Nawabpet",
            "Pincode": "506303",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wagon Work Shop",
            "Pincode": "506303",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Panthini",
            "Pincode": "506310",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wardhannapet",
            "Pincode": "506313",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rai Parthi",
            "Pincode": "506314",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dathala Palli",
            "Pincode": "506315",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marripeda",
            "Pincode": "506315",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Zaffargadh",
            "Pincode": "506316",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Vangara",
            "Pincode": "506317",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Waddekothapalle",
            "Pincode": "506318",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shyampet",
            "Pincode": "506319",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sangam",
            "Pincode": "506329",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharma Rao Cheruvu",
            "Pincode": "506330",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharmaram",
            "Pincode": "506330",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Togarrai",
            "Pincode": "506331",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chennarao Peta",
            "Pincode": "506332",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chennarayuni",
            "Pincode": "506332",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atmakur",
            "Pincode": "506342",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mulug",
            "Pincode": "506343",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Govinda Rao Pet",
            "Pincode": "506344",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ghanpur",
            "Pincode": "506345",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pasara",
            "Pincode": "506347",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Regonda",
            "Pincode": "506348",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mallampalli",
            "Pincode": "506349",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jangalapalli",
            "Pincode": "506352",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marrimuchal",
            "Pincode": "506355",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chityal",
            "Pincode": "506356",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mogallapalli",
            "Pincode": "506366",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muddur",
            "Pincode": "506367",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mallikaddur",
            "Pincode": "506368",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Redla Vada",
            "Pincode": "506369",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Waddepalli",
            "Pincode": "506370",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hasanparthi",
            "Pincode": "506371",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cathedral Compound",
            "Pincode": "506381",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dornakal",
            "Pincode": "506381",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nadikuda",
            "Pincode": "506391",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Burhanpuram Bus Stn",
            "Pincode": "507001",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Church Road",
            "Pincode": "507001",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khammam",
            "Pincode": "507001",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khammam Fort",
            "Pincode": "507001",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nizampet",
            "Pincode": "507001",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Recob Bazar",
            "Pincode": "507001",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khammam",
            "Pincode": "507002",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koya Chelka",
            "Pincode": "507002",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yellandu Cross Rd",
            "Pincode": "507002",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dabala Bazar",
            "Pincode": "507003",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "507003",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guttala Bazar",
            "Pincode": "507003",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Trunk Road",
            "Pincode": "507003",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Zehera Pura",
            "Pincode": "507003",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nsc Campus",
            "Pincode": "507004",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adm Bldgs",
            "Pincode": "507101",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhajana Mandir",
            "Pincode": "507101",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothagudem Bazar",
            "Pincode": "507101",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothagudem Bus Station",
            "Pincode": "507101",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothagudem Colleries",
            "Pincode": "507101",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nargandakar Nagar",
            "Pincode": "507101",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Singareni Colleries",
            "Pincode": "507101",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatesh Khani",
            "Pincode": "507103",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkateswrapuram",
            "Pincode": "507103",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Laxmidevi Palli",
            "Pincode": "507106",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhadrachalam",
            "Pincode": "507111",
            "City": "Bhadrachalam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalyanamantapam",
            "Pincode": "507111",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramalayam",
            "Pincode": "507111",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhupathirao Colony",
            "Pincode": "507112",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mothugudem",
            "Pincode": "507113",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Burgampahad",
            "Pincode": "507114",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagaram",
            "Pincode": "507115",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Paloncha",
            "Pincode": "507115",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ashwapur",
            "Pincode": "507116",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondaigudem",
            "Pincode": "507117",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manguru",
            "Pincode": "507117",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramavaram",
            "Pincode": "507118",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rudrampur",
            "Pincode": "507119",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shujatnagar",
            "Pincode": "507120",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kunavaram",
            "Pincode": "507121",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karepalli",
            "Pincode": "507122",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tekulapalli",
            "Pincode": "507123",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yellandu",
            "Pincode": "507123",
            "City": "Yellandu",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yellaandu Colleries",
            "Pincode": "507124",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prakasavana Colony",
            "Pincode": "507125",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinturu",
            "Pincode": "507126",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bayaram",
            "Pincode": "507127",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sarapaka",
            "Pincode": "507128",
            "City": "Sarapaka",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nelli Paka",
            "Pincode": "507129",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Morampalli",
            "Pincode": "507130",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kinnerasani Project",
            "Pincode": "507131",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Singabhupalem",
            "Pincode": "507132",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Charla",
            "Pincode": "507133",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gouri Devi Peta",
            "Pincode": "507134",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandrapuram",
            "Pincode": "507135",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatapuram",
            "Pincode": "507136",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dummagudem",
            "Pincode": "507137",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gowtampur",
            "Pincode": "507138",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parnasala",
            "Pincode": "507139",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satyanarayanapuram",
            "Pincode": "507140",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velair Padu",
            "Pincode": "507141",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mallaram",
            "Pincode": "507151",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Janampet",
            "Pincode": "507152",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nelli Paka",
            "Pincode": "507153",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Campus",
            "Pincode": "507154",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsapuram",
            "Pincode": "507156",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palair",
            "Pincode": "507157",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gokanapalle",
            "Pincode": "507158",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kushmanchi",
            "Pincode": "507159",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nelakonda Palli",
            "Pincode": "507160",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sublaid",
            "Pincode": "507161",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mudigonda",
            "Pincode": "507162",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirumalayapalem",
            "Pincode": "507163",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vemsur",
            "Pincode": "507164",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wyra",
            "Pincode": "507165",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Somavaram",
            "Pincode": "507166",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tallada",
            "Pincode": "507167",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Enkur",
            "Pincode": "507168",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cheruvu Mundara",
            "Pincode": "507169",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cheruvuumadharam",
            "Pincode": "507169",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tallam Pahad",
            "Pincode": "507170",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Noothankal",
            "Pincode": "507172",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rebbavaram",
            "Pincode": "507173",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golla Pudi",
            "Pincode": "507174",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muthugudem",
            "Pincode": "507175",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatapuram",
            "Pincode": "507176",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jeela Cheruvu",
            "Pincode": "507177",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Komminapalli",
            "Pincode": "507182",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pindi Pole",
            "Pincode": "507183",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerrupalem",
            "Pincode": "507201",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Banigandla Pahad",
            "Pincode": "507202",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madhira",
            "Pincode": "507203",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madhira Bazar",
            "Pincode": "507203",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bommakal",
            "Pincode": "507204",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dendukur",
            "Pincode": "507206",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Meenavolu",
            "Pincode": "507207",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chintakani",
            "Pincode": "507208",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kallur",
            "Pincode": "507209",
            "City": "Kallur",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Garla",
            "Pincode": "507210",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bayyaram",
            "Pincode": "507211",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pandilla Palli",
            "Pincode": "507212",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagula Vancha",
            "Pincode": "507213",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gopathi",
            "Pincode": "507214",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Timmineni Palem",
            "Pincode": "507216",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aswaraopet",
            "Pincode": "507301",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penu Balli",
            "Pincode": "507302",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sattupalli",
            "Pincode": "507303",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sattupalli Bus Station",
            "Pincode": "507303",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Siripuram",
            "Pincode": "507304",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tanikella",
            "Pincode": "507305",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dammapeta",
            "Pincode": "507306",
            "City": "Dammapeta",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Paladugu",
            "Pincode": "507311",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Konjerla",
            "Pincode": "507312",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kala Kota",
            "Pincode": "507313",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddi Reddi Gudem",
            "Pincode": "507316",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatayapalem",
            "Pincode": "507318",
            "City": "Khammam",
            "District": "Khammam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buttuguda",
            "Pincode": "508001",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manyam Chalka",
            "Pincode": "508001",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nalgonda",
            "Pincode": "508001",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Abadi",
            "Pincode": "508001",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Clock Tower",
            "Pincode": "508002",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanagal",
            "Pincode": "508002",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramagiri",
            "Pincode": "508002",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cherla Palli",
            "Pincode": "508013",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alir",
            "Pincode": "508101",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kollur",
            "Pincode": "508101",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sharajpet",
            "Pincode": "508101",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tangutoor",
            "Pincode": "508101",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kolanpaka",
            "Pincode": "508102",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bondugula",
            "Pincode": "508105",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raghunathapuram",
            "Pincode": "508105",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atmakur",
            "Pincode": "508111",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chada",
            "Pincode": "508111",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khapraipalli",
            "Pincode": "508111",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurella",
            "Pincode": "508111",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parupalli",
            "Pincode": "508111",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arror",
            "Pincode": "508112",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vali Gonda",
            "Pincode": "508112",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramannapet",
            "Pincode": "508113",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chityal",
            "Pincode": "508114",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kacharam",
            "Pincode": "508115",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yadgar Palli",
            "Pincode": "508115",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhogir R S",
            "Pincode": "508116",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhongir",
            "Pincode": "508116",
            "City": "Bhongir",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhongir Ganj",
            "Pincode": "508116",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandupatla",
            "Pincode": "508116",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chimala Kondur",
            "Pincode": "508116",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hanamakur",
            "Pincode": "508116",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madhapur",
            "Pincode": "508116",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rusthapur",
            "Pincode": "508116",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Town Bhongir",
            "Pincode": "508116",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Turkapalli",
            "Pincode": "508116",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wanaparthi",
            "Pincode": "508116",
            "City": "Wanaparthi",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maryala",
            "Pincode": "508121",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raigiri",
            "Pincode": "508123",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Kaparthy",
            "Pincode": "508125",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bibinagar",
            "Pincode": "508126",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bommalaramaram",
            "Pincode": "508126",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hazipur",
            "Pincode": "508126",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jalapur",
            "Pincode": "508126",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudur",
            "Pincode": "508127",
            "City": "Gudur",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tummala Guda",
            "Pincode": "508142",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Garedepalli",
            "Pincode": "508201",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Canal Campus",
            "Pincode": "508202",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hill Colony",
            "Pincode": "508202",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vijayapuri North",
            "Pincode": "508203",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Huzurnagar",
            "Pincode": "508204",
            "City": "Huzurnagar",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nscanals",
            "Pincode": "508204",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kattangur",
            "Pincode": "508205",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Balaji Nagar",
            "Pincode": "508206",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodad",
            "Pincode": "508206",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "X Road Kodad",
            "Pincode": "508206",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A C Palli",
            "Pincode": "508207",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Miralaguda",
            "Pincode": "508207",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Miryalguda Bazar",
            "Pincode": "508207",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanjaya Nagar",
            "Pincode": "508207",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Musi Project",
            "Pincode": "508210",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nakrekal",
            "Pincode": "508211",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Siri Konda",
            "Pincode": "508212",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bank Street",
            "Pincode": "508213",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Psr Centre",
            "Pincode": "508213",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Suryapet",
            "Pincode": "508213",
            "City": "Suryapet",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nacharam Industrial Estat",
            "Pincode": "508214",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nomula",
            "Pincode": "508215",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aitipamula",
            "Pincode": "508216",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vemula Palli",
            "Pincode": "508217",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Neredi Cherla",
            "Pincode": "508218",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amrut Nagar",
            "Pincode": "508219",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kudakuda Road",
            "Pincode": "508220",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Noothankal",
            "Pincode": "508221",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Timmapur",
            "Pincode": "508222",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirumalagiri",
            "Pincode": "508223",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhrugu Gadda",
            "Pincode": "508224",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mettampalli",
            "Pincode": "508225",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Annanta Giri",
            "Pincode": "508227",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shanti Nagar",
            "Pincode": "508229",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chilkoor",
            "Pincode": "508230",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Munagala",
            "Pincode": "508233",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nadigudem",
            "Pincode": "508234",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudi Banda",
            "Pincode": "508238",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondamalle Palle",
            "Pincode": "508243",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pendlipakala",
            "Pincode": "508243",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mungode",
            "Pincode": "508244",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marriguda",
            "Pincode": "508245",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marrikal",
            "Pincode": "508245",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polepalli Ramnagar",
            "Pincode": "508245",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medlacheruvu",
            "Pincode": "508246",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tipparthi",
            "Pincode": "508247",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Devar Konda",
            "Pincode": "508248",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "508248",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "K Bheemunipalle",
            "Pincode": "508248",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinta Palli",
            "Pincode": "508250",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkateshwaranagar",
            "Pincode": "508250",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chout Uppal",
            "Pincode": "508252",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narayanpur",
            "Pincode": "508253",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narket Palli",
            "Pincode": "508254",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandur Vattikodu",
            "Pincode": "508255",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koppole",
            "Pincode": "508256",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudi Palli",
            "Pincode": "508257",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gummadavalli",
            "Pincode": "508257",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cherukupalli",
            "Pincode": "508258",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dindi Project",
            "Pincode": "508258",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandampet",
            "Pincode": "508259",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Junuthala",
            "Pincode": "508262",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandi Banda",
            "Pincode": "508265",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Voora",
            "Pincode": "508266",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kokkireni",
            "Pincode": "508268",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dona Podu",
            "Pincode": "508272",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mothcore",
            "Pincode": "508277",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nadavanore",
            "Pincode": "508278",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Panigiri",
            "Pincode": "508279",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thunga Thurthi",
            "Pincode": "508280",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanchan Pally",
            "Pincode": "508281",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondagadapa",
            "Pincode": "508282",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patimantla",
            "Pincode": "508283",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pochampalli",
            "Pincode": "508284",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tekulasomaram",
            "Pincode": "508285",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golankonda",
            "Pincode": "508286",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Matoor",
            "Pincode": "508286",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Motakondur",
            "Pincode": "508286",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vartur",
            "Pincode": "508286",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wangopalli",
            "Pincode": "508286",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "China Kandukuru",
            "Pincode": "508287",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Inkriyala",
            "Pincode": "508288",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Julur",
            "Pincode": "508289",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anajpur",
            "Pincode": "508290",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anjapur",
            "Pincode": "508290",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kunoor",
            "Pincode": "508293",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raghavapuram",
            "Pincode": "508296",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parsai Palli",
            "Pincode": "508301",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palakaveedu",
            "Pincode": "508332",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dirsih Cherla",
            "Pincode": "508333",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penchikal Dinne",
            "Pincode": "508336",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mothe",
            "Pincode": "508337",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indloor",
            "Pincode": "508346",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalmal Cheruvu",
            "Pincode": "508347",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedu Veedu",
            "Pincode": "508349",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chalakurthi",
            "Pincode": "508350",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Togarrai",
            "Pincode": "508351",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kapugal",
            "Pincode": "508352",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nallabanda Gudem",
            "Pincode": "508353",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Janpahad",
            "Pincode": "508355",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wadapally",
            "Pincode": "508355",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondrapole",
            "Pincode": "508357",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marrur",
            "Pincode": "508364",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tatipamula",
            "Pincode": "508365",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adsarla Pally",
            "Pincode": "508367",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nampalli",
            "Pincode": "508373",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madugulapalli",
            "Pincode": "508374",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Damarcherla",
            "Pincode": "508375",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rekumatla",
            "Pincode": "508376",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gondrial",
            "Pincode": "508381",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thunga Pahad",
            "Pincode": "508383",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pillamarri",
            "Pincode": "508385",
            "City": "Nalgonda",
            "District": "Nalgonda",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hanmanpura",
            "Pincode": "509001",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "M B N R R S",
            "Pincode": "509001",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mahabubnagar",
            "Pincode": "509001",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "New Gunj",
            "Pincode": "509001",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Osmangunj",
            "Pincode": "509001",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pallaburju",
            "Pincode": "509001",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pathapalmoor",
            "Pincode": "509001",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirmaldev Gutta",
            "Pincode": "509001",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veerannapeta",
            "Pincode": "509001",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Industrial Estate Mbn",
            "Pincode": "509002",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kollapur",
            "Pincode": "509102",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kollapur Bazar",
            "Pincode": "509102",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "509103",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "New Ganj",
            "Pincode": "509103",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wanaparthy",
            "Pincode": "509103",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pebbair",
            "Pincode": "509104",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penta Valli",
            "Pincode": "509105",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rangapur",
            "Pincode": "509106",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Singotam",
            "Pincode": "509107",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kudikilla",
            "Pincode": "509108",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chityala",
            "Pincode": "509109",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madanapuram",
            "Pincode": "509110",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chintakunta Khurd",
            "Pincode": "509111",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pangal",
            "Pincode": "509112",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Varna",
            "Pincode": "509113",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandapur",
            "Pincode": "509115",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajapet",
            "Pincode": "509116",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalwakole",
            "Pincode": "509117",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gadwal",
            "Pincode": "509125",
            "City": "Gadwal",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishna Nagar",
            "Pincode": "509125",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajoli",
            "Pincode": "509126",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Leeja",
            "Pincode": "509127",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manopad",
            "Pincode": "509128",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Macherla",
            "Pincode": "509129",
            "City": "Macherla",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amarchinta",
            "Pincode": "509130",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atmakur Amarchinta",
            "Pincode": "509131",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mudakal",
            "Pincode": "509132",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharur",
            "Pincode": "509133",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Poodur",
            "Pincode": "509134",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Poram",
            "Pincode": "509134",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uppal Camp",
            "Pincode": "509135",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Dinne",
            "Pincode": "509136",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Utnoor",
            "Pincode": "509137",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tatikunta",
            "Pincode": "509138",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandinne",
            "Pincode": "509139",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Julaikal",
            "Pincode": "509140",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinna Tipa",
            "Pincode": "509141",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Padu",
            "Pincode": "509141",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amarvoi",
            "Pincode": "509142",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yelkur",
            "Pincode": "509143",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Waddepalli",
            "Pincode": "509144",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bijwar",
            "Pincode": "509145",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mulamalle",
            "Pincode": "509146",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palavoi",
            "Pincode": "509147",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alwal Pahad",
            "Pincode": "509149",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alluru",
            "Pincode": "509150",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vallur",
            "Pincode": "509151",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alampur",
            "Pincode": "509152",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Undevally",
            "Pincode": "509153",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kyathur",
            "Pincode": "509154",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Taksila",
            "Pincode": "509155",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tangal",
            "Pincode": "509171",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pathapalem",
            "Pincode": "509172",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ghatt",
            "Pincode": "509173",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amarabad",
            "Pincode": "509201",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bala Nagar",
            "Pincode": "509202",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bijna Palle",
            "Pincode": "509203",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Devara Kadra",
            "Pincode": "509204",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dhanwada",
            "Pincode": "509205",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gopal Pet",
            "Pincode": "509206",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondurg",
            "Pincode": "509207",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Makthal",
            "Pincode": "509208",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagar Kurnool",
            "Pincode": "509209",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narayanpet",
            "Pincode": "509210",
            "City": "Narayanpet",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narayanpet Bazar",
            "Pincode": "509210",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jajapur",
            "Pincode": "509211",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tati Parti",
            "Pincode": "509212",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Budharam",
            "Pincode": "509213",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ranga Reddi Guda",
            "Pincode": "509214",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palem",
            "Pincode": "509215",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shadnagar",
            "Pincode": "509216",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shahabad",
            "Pincode": "509217",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "China Golconda",
            "Pincode": "509218",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagaram",
            "Pincode": "509218",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nanajpur",
            "Pincode": "509218",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narkoda",
            "Pincode": "509218",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sham Shabad",
            "Pincode": "509218",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kaukuntla",
            "Pincode": "509219",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Perur",
            "Pincode": "509220",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudla Nerva",
            "Pincode": "509221",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sardarnagar",
            "Pincode": "509222",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandigaon",
            "Pincode": "509223",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kollam Pally",
            "Pincode": "509224",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kota Konda",
            "Pincode": "509225",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indrakal",
            "Pincode": "509226",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadia Pally",
            "Pincode": "509227",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothur",
            "Pincode": "509228",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mannanur",
            "Pincode": "509241",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajapur",
            "Pincode": "509242",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "China Jatram",
            "Pincode": "509243",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Stn Jadcherla Ho",
            "Pincode": "509301",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Townjadcherla",
            "Pincode": "509302",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golla Palli",
            "Pincode": "509303",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodgal",
            "Pincode": "509305",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gangapur",
            "Pincode": "509306",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Edganpalli",
            "Pincode": "509307",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Utkur",
            "Pincode": "509311",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manchal",
            "Pincode": "509320",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amangal",
            "Pincode": "509321",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gagan Pahad",
            "Pincode": "509323",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalwa Kurthy",
            "Pincode": "509324",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palmakole",
            "Pincode": "509325",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Sailam Dam West",
            "Pincode": "509326",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madgul",
            "Pincode": "509327",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tala Konda Palli",
            "Pincode": "509328",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddapur",
            "Pincode": "509329",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amerpeta",
            "Pincode": "509330",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shahapur",
            "Pincode": "509331",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chekur",
            "Pincode": "509332",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chegur",
            "Pincode": "509333",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hunwada",
            "Pincode": "509334",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kulak Cherla",
            "Pincode": "509335",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rawala Palli",
            "Pincode": "509336",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mohammadabad",
            "Pincode": "509337",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodangal",
            "Pincode": "509338",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kosgi",
            "Pincode": "509339",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nawabpeta",
            "Pincode": "509340",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gundveed",
            "Pincode": "509341",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gundmal",
            "Pincode": "509342",
            "City": "Gundmal",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A Raichur",
            "Pincode": "509343",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nancherla",
            "Pincode": "509344",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bomraspet",
            "Pincode": "509345",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tumki Metla",
            "Pincode": "509346",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ibrahimbad",
            "Pincode": "509347",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kommireddi Palli",
            "Pincode": "509348",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vangoor",
            "Pincode": "509349",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Husnabad",
            "Pincode": "509350",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marrikal",
            "Pincode": "509351",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishna",
            "Pincode": "509352",
            "City": "Krishna",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jaklair",
            "Pincode": "509353",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Midjil",
            "Pincode": "509357",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kadthal",
            "Pincode": "509358",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandukur",
            "Pincode": "509359",
            "City": "Kandukur",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mankhal",
            "Pincode": "509359",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nedunur",
            "Pincode": "509359",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thummakur",
            "Pincode": "509359",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veldanda",
            "Pincode": "509360",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karkal Pahad",
            "Pincode": "509361",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Akuthotapally",
            "Pincode": "509362",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aura Palli",
            "Pincode": "509363",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mudhivin",
            "Pincode": "509364",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maisaram",
            "Pincode": "509365",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koil Konda",
            "Pincode": "509371",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Achampet",
            "Pincode": "509375",
            "City": "Lingotam",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uppnunthala",
            "Pincode": "509376",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Musapet",
            "Pincode": "509380",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothakota",
            "Pincode": "509381",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhutpur",
            "Pincode": "509382",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kadu Kuntla",
            "Pincode": "509383",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shakapur",
            "Pincode": "509384",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thelakapally",
            "Pincode": "509385",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amada Bakula",
            "Pincode": "509388",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rayanpet",
            "Pincode": "509389",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mirasi Palli",
            "Pincode": "509390",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lingal",
            "Pincode": "509401",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Timmaji Pet",
            "Pincode": "509406",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Damar Gidda",
            "Pincode": "509407",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Keshampet",
            "Pincode": "509408",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lalkota",
            "Pincode": "509409",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mogalgidda",
            "Pincode": "509410",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muddur",
            "Pincode": "509411",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddakothapally",
            "Pincode": "509412",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Padkal",
            "Pincode": "509413",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raviched",
            "Pincode": "509414",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "V Markal",
            "Pincode": "509416",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yellikal",
            "Pincode": "509431",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kulkulpally",
            "Pincode": "509432",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veerlapalli",
            "Pincode": "509433",
            "City": "Mahboobnagar",
            "District": "Mahboobnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A T P Collectorate",
            "Pincode": "515001",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantapur",
            "Pincode": "515001",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aravind Nagar",
            "Pincode": "515001",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Clock Tower",
            "Pincode": "515001",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Bazar",
            "Pincode": "515001",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamalanagar",
            "Pincode": "515001",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S B Mahaveer Road",
            "Pincode": "515001",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sainagar",
            "Pincode": "515001",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Subahsh Road",
            "Pincode": "515001",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantapur Engineering College",
            "Pincode": "515002",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sree Venkateswara Puram",
            "Pincode": "515003",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Clock Tower",
            "Pincode": "515004",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "George Pet",
            "Pincode": "515004",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Motilal St",
            "Pincode": "515004",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patel Rd",
            "Pincode": "515004",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramchandranagar",
            "Pincode": "515004",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "515004",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Mla Quarters",
            "Pincode": "515005",
            "City": "Hyderabad",
            "District": "Hyderabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Town Anantapur",
            "Pincode": "515005",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chenna Kotha Palli",
            "Pincode": "515101",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuntimaddi",
            "Pincode": "515102",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penu Konda",
            "Pincode": "515110",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penukonda Exten",
            "Pincode": "515110",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Somande Palli",
            "Pincode": "515122",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Roddam",
            "Pincode": "515123",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Mantur",
            "Pincode": "515124",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotha Cheruvu",
            "Pincode": "515133",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prasanti Nilayam",
            "Pincode": "515134",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bukkapatnam",
            "Pincode": "515144",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bukkaraya",
            "Pincode": "515144",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pamudurthi",
            "Pincode": "515154",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishnapuram",
            "Pincode": "515159",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marala",
            "Pincode": "515161",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guttur",
            "Pincode": "515164",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hindupur",
            "Pincode": "515201",
            "City": "Hindupur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hindupur Extension",
            "Pincode": "515202",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kirekera",
            "Pincode": "515211",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hindupur Sevamandir",
            "Pincode": "515212",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotnur",
            "Pincode": "515213",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muddi Reddi Palli",
            "Pincode": "515214",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gorantla",
            "Pincode": "515231",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vanavolu",
            "Pincode": "515232",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gownivari Palli",
            "Pincode": "515233",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Budili",
            "Pincode": "515241",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parigi",
            "Pincode": "515261",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudi Banda",
            "Pincode": "515271",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amarapuram",
            "Pincode": "515281",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Halakur",
            "Pincode": "515282",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hemavathi",
            "Pincode": "515286",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Neela Kanta Puram",
            "Pincode": "515291",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Govinda Puram",
            "Pincode": "515292",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madakasira",
            "Pincode": "515301",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madakasira Bazar",
            "Pincode": "515301",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Melavoy",
            "Pincode": "515302",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kallu Marri",
            "Pincode": "515303",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ralla Halli",
            "Pincode": "515305",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Basavanahalli",
            "Pincode": "515306",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sankara Gallu",
            "Pincode": "515307",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Agali",
            "Pincode": "515311",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rolla",
            "Pincode": "515321",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ratnagiri",
            "Pincode": "515322",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lepakshi",
            "Pincode": "515331",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dema Kethe Palli",
            "Pincode": "515332",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chilamathur",
            "Pincode": "515341",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gooty",
            "Pincode": "515401",
            "City": "Gooty",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gooty Bazar",
            "Pincode": "515401",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gooty Extn",
            "Pincode": "515401",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gooty R S",
            "Pincode": "515402",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagasamudram",
            "Pincode": "515404",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Vadugur",
            "Pincode": "515405",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yadiki",
            "Pincode": "515408",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nittur",
            "Pincode": "515409",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "R V Palem",
            "Pincode": "515411",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadapatri",
            "Pincode": "515411",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadpatri Bazar",
            "Pincode": "515411",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadpatri Bus Stand",
            "Pincode": "515411",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadpatri Extn",
            "Pincode": "515411",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tagarampudi Sitha",
            "Pincode": "515411",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerrangunta Palli",
            "Pincode": "515412",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Putlur",
            "Pincode": "515414",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chukkalur",
            "Pincode": "515415",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sengala Gudur",
            "Pincode": "515416",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Challavari Palli",
            "Pincode": "515419",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Polamada",
            "Pincode": "515421",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinna Pola Mada",
            "Pincode": "515422",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narpala",
            "Pincode": "515425",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kesepalli",
            "Pincode": "515426",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bondalawada",
            "Pincode": "515427",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Singanamala",
            "Pincode": "515435",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amalla Dinne",
            "Pincode": "515445",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muchukota",
            "Pincode": "515446",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Appecherla",
            "Pincode": "515455",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rayalcheruvu",
            "Pincode": "515455",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagaruru",
            "Pincode": "515456",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kristipadu",
            "Pincode": "515457",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandana",
            "Pincode": "515458",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yellanur",
            "Pincode": "515465",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venapursa Palli",
            "Pincode": "515466",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patnam",
            "Pincode": "515501",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malaka Vemula",
            "Pincode": "515502",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mudigubba",
            "Pincode": "515511",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandla Penta",
            "Pincode": "515521",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondakamerla",
            "Pincode": "515531",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kutugulla",
            "Pincode": "515541",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nallacheruvu",
            "Pincode": "515551",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Obuladevarachervu",
            "Pincode": "515561",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amadagur",
            "Pincode": "515566",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tanakallu",
            "Pincode": "515571",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kokkanti",
            "Pincode": "515572",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Talupula",
            "Pincode": "515581",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddanna Vari Palli",
            "Pincode": "515583",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kadiri",
            "Pincode": "515591",
            "City": "Kadiri",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodikonda",
            "Pincode": "515601",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tarimela",
            "Pincode": "515611",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Perur",
            "Pincode": "515621",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadi Marri",
            "Pincode": "515631",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanagana Palle",
            "Pincode": "515641",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medapuram",
            "Pincode": "515651",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bathala Palle",
            "Pincode": "515661",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malyanvantham",
            "Pincode": "515662",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharmavaram",
            "Pincode": "515671",
            "City": "Dharmavaram",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharmavaram Bazar",
            "Pincode": "515671",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharmavaram Bazar",
            "Pincode": "515672",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Samudram",
            "Pincode": "515701",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuderu",
            "Pincode": "515711",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jalli Palli",
            "Pincode": "515712",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandukur",
            "Pincode": "515721",
            "City": "Kandukur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rapthadu",
            "Pincode": "515722",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Garla Dinne",
            "Pincode": "515731",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mpr Site",
            "Pincode": "515736",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Belu Guppa",
            "Pincode": "515741",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atmakur",
            "Pincode": "515751",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Matiyaleru",
            "Pincode": "515752",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalyan Durg",
            "Pincode": "515761",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalyandrug Bazar",
            "Pincode": "515761",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pala Voyi",
            "Pincode": "515762",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bommagani Palle",
            "Pincode": "515763",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kambadur",
            "Pincode": "515765",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kundurpi",
            "Pincode": "515766",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shettur",
            "Pincode": "515767",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalluru R S",
            "Pincode": "515774",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pamidi",
            "Pincode": "515775",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pamidi Bus Stand",
            "Pincode": "515775",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nuthimadugu",
            "Pincode": "515787",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gtl Market",
            "Pincode": "515801",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guntakal",
            "Pincode": "515801",
            "City": "Guntakal",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hanumes Nagar",
            "Pincode": "515801",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Modinabad",
            "Pincode": "515801",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Railway Colony",
            "Pincode": "515801",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajendranagar",
            "Pincode": "515801",
            "City": "Rajendranagar",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satyanarayanapeta",
            "Pincode": "515801",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Timmanacherla",
            "Pincode": "515801",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Guntakal",
            "Pincode": "515803",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "515812",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Urvakonda",
            "Pincode": "515812",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chabala",
            "Pincode": "515813",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kottala",
            "Pincode": "515814",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amidyala Mopidi",
            "Pincode": "515822",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Kow Kuntla",
            "Pincode": "515823",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nimbagallu",
            "Pincode": "515824",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vajrakarur",
            "Pincode": "515832",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Chinnapeapalli",
            "Pincode": "515833",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ragula Padu",
            "Pincode": "515834",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamala Padu",
            "Pincode": "515835",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Konakondla",
            "Pincode": "515842",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chayapuram",
            "Pincode": "515843",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gadde Kallu",
            "Pincode": "515844",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "B T Project",
            "Pincode": "515862",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gummaghatta",
            "Pincode": "515863",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pulicherla",
            "Pincode": "515865",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rayadrug Bazar",
            "Pincode": "515865",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rayadurg",
            "Pincode": "515865",
            "City": "Rayadurg",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golla Palli",
            "Pincode": "515866",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Udegolam",
            "Pincode": "515867",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vidapanakallu Gowinda Wa",
            "Pincode": "515870",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Harial",
            "Pincode": "515872",
            "City": "Anantapur",
            "District": "Anantapur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cdp Almaspet",
            "Pincode": "516001",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cdp Co-Op Colony",
            "Pincode": "516001",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cdp Mandi Bazar",
            "Pincode": "516001",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cdp Maruthi Nagar",
            "Pincode": "516001",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cdp Masapet",
            "Pincode": "516001",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cdp Mochampet",
            "Pincode": "516001",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cdp Nagarjupet",
            "Pincode": "516001",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cdp Sunnapurallapally",
            "Pincode": "516001",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cuddapah",
            "Pincode": "516001",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sankarapuram Jayanagar",
            "Pincode": "516002",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ravindranagar",
            "Pincode": "516003",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cuddapah R S",
            "Pincode": "516004",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerra Mukkapalli Cuddapah",
            "Pincode": "516004",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Machupalli",
            "Pincode": "516005",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodur",
            "Pincode": "516101",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodur R S",
            "Pincode": "516101",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Seeti Gunta",
            "Pincode": "516102",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Konetiraju Kondriga",
            "Pincode": "516103",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chitvel",
            "Pincode": "516104",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantarajupeta",
            "Pincode": "516105",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mangampet",
            "Pincode": "516106",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pullam Pet",
            "Pincode": "516107",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Obulavari Palle",
            "Pincode": "516108",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinaoram Padu",
            "Pincode": "516109",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Racha Palle",
            "Pincode": "516110",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatraju Palle",
            "Pincode": "516111",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mukkavari Palle",
            "Pincode": "516112",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "T Kamma Palle",
            "Pincode": "516113",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yarraguntla Kota",
            "Pincode": "516114",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerraguntla Kota",
            "Pincode": "516114",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajampet",
            "Pincode": "516115",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajampet R S",
            "Pincode": "516115",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ananthaiahgiri Pally",
            "Pincode": "516116",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narrayana Nellore",
            "Pincode": "516117",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palle",
            "Pincode": "516118",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Utukuru",
            "Pincode": "516119",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Galivari Palle",
            "Pincode": "516120",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mannur",
            "Pincode": "516126",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penagalur",
            "Pincode": "516127",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nayunipet",
            "Pincode": "516128",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rayavaram",
            "Pincode": "516129",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "T Sundupalle",
            "Pincode": "516130",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thimmayyagari Palle",
            "Pincode": "516131",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Akepadu",
            "Pincode": "516132",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madithadu",
            "Pincode": "516133",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tallapaka",
            "Pincode": "516134",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandalur",
            "Pincode": "516150",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandalur Bazar",
            "Pincode": "516150",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tangutur",
            "Pincode": "516151",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mantapam Palle",
            "Pincode": "516152",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manda Palle",
            "Pincode": "516153",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patur",
            "Pincode": "516155",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chennur",
            "Pincode": "516162",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cuddapah Co-Op Sugars",
            "Pincode": "516163",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bayanapalle",
            "Pincode": "516164",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinna Machupalle",
            "Pincode": "516165",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pushpagiri",
            "Pincode": "516166",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mydekur",
            "Pincode": "516172",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Onipenta",
            "Pincode": "516173",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Duwur",
            "Pincode": "516175",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Poruma Milla",
            "Pincode": "516193",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khaji Peta",
            "Pincode": "516203",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vonti Mitta",
            "Pincode": "516213",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinna Mandem",
            "Pincode": "516214",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sambe Palli",
            "Pincode": "516215",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pendi Marri",
            "Pincode": "516216",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalas Pad",
            "Pincode": "516217",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandimandalam",
            "Pincode": "516218",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vellatur",
            "Pincode": "516219",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Badvel",
            "Pincode": "516227",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Badvel Bus Stand",
            "Pincode": "516227",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantarajupuram",
            "Pincode": "516228",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gopavaram Project Site",
            "Pincode": "516233",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Siddavatam",
            "Pincode": "516237",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Palle",
            "Pincode": "516238",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madhavaram",
            "Pincode": "516247",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondamachupalle",
            "Pincode": "516248",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lakki Reddi Palle",
            "Pincode": "516257",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palle",
            "Pincode": "516259",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chakrayapeta",
            "Pincode": "516260",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Galivedu",
            "Pincode": "516267",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veera Balle",
            "Pincode": "516268",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raya Choti",
            "Pincode": "516269",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rayachoti East",
            "Pincode": "516269",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanjeevanagar",
            "Pincode": "516269",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Masapet Bazar",
            "Pincode": "516270",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eguvagottiveedu",
            "Pincode": "516271",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nulivedu",
            "Pincode": "516272",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamalapuram",
            "Pincode": "516289",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "T Sadipiralla",
            "Pincode": "516290",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pandilla Palle",
            "Pincode": "516291",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddachapallo",
            "Pincode": "516292",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Valluru",
            "Pincode": "516293",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerraguntla West",
            "Pincode": "516309",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerrangutla",
            "Pincode": "516309",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chilamakur",
            "Pincode": "516310",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Urutur",
            "Pincode": "516311",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gangi Reddy Palle",
            "Pincode": "516319",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veerappanayuni Palle",
            "Pincode": "516321",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vaim Palle",
            "Pincode": "516329",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veeranna Cattupalle",
            "Pincode": "516330",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Payas Ampalle",
            "Pincode": "516339",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vemula",
            "Pincode": "516349",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Talla Palle",
            "Pincode": "516350",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nakkala Dinne",
            "Pincode": "516356",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantapuram",
            "Pincode": "516357",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Korra Padu",
            "Pincode": "516359",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bollavaram",
            "Pincode": "516360",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Proddatur",
            "Pincode": "516360",
            "City": "Proddatur",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Proddatur Bazar",
            "Pincode": "516360",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Proddatur Fort",
            "Pincode": "516360",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Holmespet",
            "Pincode": "516361",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Modameedipalle",
            "Pincode": "516361",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khaderabad",
            "Pincode": "516362",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raju Palem",
            "Pincode": "516363",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Potladurthi",
            "Pincode": "516364",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Upparapalle",
            "Pincode": "516365",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pallavolu",
            "Pincode": "516366",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muddanur",
            "Pincode": "516380",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pulevendla",
            "Pincode": "516390",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pulvendla Bus Stand",
            "Pincode": "516390",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pulvendla North",
            "Pincode": "516390",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bokkudu Palli",
            "Pincode": "516392",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lingala",
            "Pincode": "516396",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tondur",
            "Pincode": "516401",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Pasupula",
            "Pincode": "516411",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Mudiyam",
            "Pincode": "516412",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palur",
            "Pincode": "516413",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Agadur",
            "Pincode": "516421",
            "City": "Agadur",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dommara Nandyala",
            "Pincode": "516431",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vaddi Rala",
            "Pincode": "516432",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinna Komarla",
            "Pincode": "516433",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jammalamudugu East",
            "Pincode": "516434",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jammalamudugu North",
            "Pincode": "516434",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S Uppala Padu",
            "Pincode": "516437",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gundlagunta",
            "Pincode": "516438",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mylavaram",
            "Pincode": "516439",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veparala",
            "Pincode": "516440",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Devagudi",
            "Pincode": "516441",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondapauram",
            "Pincode": "516444",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Simhadri Puram",
            "Pincode": "516454",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lavanur",
            "Pincode": "516464",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Talla Proddatur",
            "Pincode": "516474",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Balapanur",
            "Pincode": "516484",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Balathimmaya Gari",
            "Pincode": "516484",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koragunta Palle",
            "Pincode": "516486",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atlur",
            "Pincode": "516501",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chennam Palle",
            "Pincode": "516502",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandimallayapalle",
            "Pincode": "516503",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Neelakanta Rao Pet",
            "Pincode": "516504",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tekurpet",
            "Pincode": "516505",
            "City": "Cuddapah",
            "District": "Cuddapah",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Akkalareddy Palle",
            "Pincode": "516506",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "C T R Bazar",
            "Pincode": "517001",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "C T R Court Buildings",
            "Pincode": "517001",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "C T R Market",
            "Pincode": "517001",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chittoor",
            "Pincode": "517001",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kattamanchi",
            "Pincode": "517001",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lalugardens",
            "Pincode": "517001",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marratipalem",
            "Pincode": "517001",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mittoor",
            "Pincode": "517001",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Readspeta",
            "Pincode": "517001",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "C T R South",
            "Pincode": "517002",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chittoor Collectorate",
            "Pincode": "517002",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kajoor",
            "Pincode": "517002",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vinayakapuram",
            "Pincode": "517002",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chittoor Sugar Factory",
            "Pincode": "517003",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chittoor North",
            "Pincode": "517004",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandragiri",
            "Pincode": "517101",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandragiri Fort",
            "Pincode": "517101",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsingapuram",
            "Pincode": "517102",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Panapakam",
            "Pincode": "517103",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rangampet",
            "Pincode": "517104",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotala",
            "Pincode": "517105",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhimavaram",
            "Pincode": "517106",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mungili Pattu",
            "Pincode": "517107",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bopparaju Palle",
            "Pincode": "517108",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ayithe Palle",
            "Pincode": "517109",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dornakambala",
            "Pincode": "517110",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buchinaidu Palle",
            "Pincode": "517111",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pakala",
            "Pincode": "517112",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pakala Bazar",
            "Pincode": "517112",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kallur",
            "Pincode": "517113",
            "City": "Kallur",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muthuku Vari Palle",
            "Pincode": "517114",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maddinavani Palle",
            "Pincode": "517115",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddagorapadu",
            "Pincode": "517116",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venuthana Palli",
            "Pincode": "517117",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nendragunta",
            "Pincode": "517118",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sodam",
            "Pincode": "517123",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Puthala Pattu",
            "Pincode": "517124",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gangadhara Nellore",
            "Pincode": "517125",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penumur",
            "Pincode": "517126",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Murakambattu",
            "Pincode": "517127",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Iruvaram",
            "Pincode": "517128",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arugonda",
            "Pincode": "517129",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Iral",
            "Pincode": "517130",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanipakam",
            "Pincode": "517131",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nangamangalam",
            "Pincode": "517132",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thavanampalle",
            "Pincode": "517133",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bomma Samudram",
            "Pincode": "517134",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pallur",
            "Pincode": "517135",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narahari Pet",
            "Pincode": "517136",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polavaram",
            "Pincode": "517137",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velkur",
            "Pincode": "517138",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sami Reddi Palle",
            "Pincode": "517139",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mahasamudran",
            "Pincode": "517140",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gajula Palli",
            "Pincode": "517141",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patnam",
            "Pincode": "517142",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thalambedu",
            "Pincode": "517143",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polakala",
            "Pincode": "517144",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thatigunta Palem",
            "Pincode": "517145",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Booragammanda",
            "Pincode": "517146",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golla Palle",
            "Pincode": "517147",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Iiavaripalle",
            "Pincode": "517148",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotrakona",
            "Pincode": "517149",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Matyam",
            "Pincode": "517150",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalva Gunta",
            "Pincode": "517151",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Damal Cheruvu",
            "Pincode": "517152",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishnapuram",
            "Pincode": "517153",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mogarala",
            "Pincode": "517154",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Odde Palle",
            "Pincode": "517160",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudyanam Palle",
            "Pincode": "517161",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mudigolam",
            "Pincode": "517162",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palakur",
            "Pincode": "517163",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Reddi Vari Palle",
            "Pincode": "517164",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yellampalle Santha Gate",
            "Pincode": "517165",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamagutta Palle",
            "Pincode": "517166",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapalli",
            "Pincode": "517167",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mangalam Pet",
            "Pincode": "517172",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Puli Cherla",
            "Pincode": "517173",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rompi Cherla",
            "Pincode": "517192",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinna Gottigallu",
            "Pincode": "517193",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bakarapet",
            "Pincode": "517194",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nerabailu",
            "Pincode": "517195",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palle",
            "Pincode": "517196",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerravaripalem",
            "Pincode": "517197",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chitticherla",
            "Pincode": "517198",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tettu Palle",
            "Pincode": "517199",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gyaranpalle Kothapalle",
            "Pincode": "517213",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nehru Bazar",
            "Pincode": "517214",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Piler",
            "Pincode": "517214",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Talupula",
            "Pincode": "517215",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kambham Vari Palle",
            "Pincode": "517216",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jandla",
            "Pincode": "517217",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sorakayalapet",
            "Pincode": "517218",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalikiri",
            "Pincode": "517234",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mahal",
            "Pincode": "517235",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalakada",
            "Pincode": "517236",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medikurti",
            "Pincode": "517237",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kona",
            "Pincode": "517238",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palamanda",
            "Pincode": "517239",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Erra Kota Palle",
            "Pincode": "517240",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanduru",
            "Pincode": "517241",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Regallu",
            "Pincode": "517242",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nanasahebpet",
            "Pincode": "517247",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Runganur",
            "Pincode": "517247",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muthukur",
            "Pincode": "517248",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pudi Patla",
            "Pincode": "517249",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vanamaladinne",
            "Pincode": "517250",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chowdepalle",
            "Pincode": "517257",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Somala",
            "Pincode": "517258",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Surayyagari Palli",
            "Pincode": "517259",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Charala",
            "Pincode": "517260",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinta Parti",
            "Pincode": "517277",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ayyavaripalle",
            "Pincode": "517278",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nimmana Palle",
            "Pincode": "517280",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tari Gonda",
            "Pincode": "517291",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marripadu",
            "Pincode": "517292",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gurram Konda",
            "Pincode": "517297",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veli Gallu",
            "Pincode": "517298",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vayalpad",
            "Pincode": "517299",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kali Cherla",
            "Pincode": "517301",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddamandem",
            "Pincode": "517302",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cherlo Palle",
            "Pincode": "517305",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cheruku Ganuma",
            "Pincode": "517305",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Samudram",
            "Pincode": "517319",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Apparao St",
            "Pincode": "517325",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Road",
            "Pincode": "517325",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "517325",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madanapalle",
            "Pincode": "517325",
            "City": "Madanapalle",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madanapalle Bazar",
            "Pincode": "517325",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Society Colony",
            "Pincode": "517326",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Spinnina Mills",
            "Pincode": "517326",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madanapalle",
            "Pincode": "517327",
            "City": "Madanapalle",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madanapalle College",
            "Pincode": "517327",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madanapalli Bus Station",
            "Pincode": "517327",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arogyavaram",
            "Pincode": "517330",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurabalakota",
            "Pincode": "517350",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Burakayala Kota",
            "Pincode": "517351",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rushi Vally",
            "Pincode": "517352",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kota",
            "Pincode": "517370",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cheruru R S",
            "Pincode": "517390",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Tippa Samudram",
            "Pincode": "517391",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rama Kuppam",
            "Pincode": "517401",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rama Puram",
            "Pincode": "517403",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Market Yard",
            "Pincode": "517408",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palamner",
            "Pincode": "517408",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patapet",
            "Pincode": "517408",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Royal Pet",
            "Pincode": "517414",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Baireddi Palle",
            "Pincode": "517415",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bangaru Palem",
            "Pincode": "517416",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chembakur",
            "Pincode": "517417",
            "City": "Chembakur",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chendra Sekhara",
            "Pincode": "517417",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thamballapalle",
            "Pincode": "517418",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narasingaraya Pettah",
            "Pincode": "517419",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thungundram",
            "Pincode": "517421",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yadammarri",
            "Pincode": "517422",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rallabadugur",
            "Pincode": "517423",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatagiri Kota",
            "Pincode": "517424",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuppam",
            "Pincode": "517425",
            "City": "Kuppam",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pathapet",
            "Pincode": "517425",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mogili Venkatagiri",
            "Pincode": "517429",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Theertham",
            "Pincode": "517431",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kolamasana Palle",
            "Pincode": "517432",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhaninagar Court Road",
            "Pincode": "517501",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jagannathapuram",
            "Pincode": "517501",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kapila Theertham Road",
            "Pincode": "517501",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Korlagunta",
            "Pincode": "517501",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirupati",
            "Pincode": "517501",
            "City": "Tirupati",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirupati Bazar",
            "Pincode": "517501",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirupati East",
            "Pincode": "517501",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirupati Market",
            "Pincode": "517501",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirupati South",
            "Pincode": "517501",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirupati West",
            "Pincode": "517501",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S V Agri College",
            "Pincode": "517502",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S V Nagar",
            "Pincode": "517502",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S V University",
            "Pincode": "517502",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Padi",
            "Pincode": "517503",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Panakam",
            "Pincode": "517503",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thandlam",
            "Pincode": "517503",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tiruchanoor",
            "Pincode": "517503",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirumala",
            "Pincode": "517504",
            "City": "Tirumala",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirumala North",
            "Pincode": "517504",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirumala West",
            "Pincode": "517504",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peru Malla Palle",
            "Pincode": "517505",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Setti Palli",
            "Pincode": "517506",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "R S Gardens",
            "Pincode": "517507",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S V Medical College",
            "Pincode": "517507",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tirupati North",
            "Pincode": "517507",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pudi Patla",
            "Pincode": "517514",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thondavada",
            "Pincode": "517515",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanam Batla",
            "Pincode": "517516",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chiguruvada",
            "Pincode": "517517",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Railway Colony",
            "Pincode": "517520",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Papanaidupet",
            "Pincode": "517526",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mungala Palem",
            "Pincode": "517527",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Akkurti",
            "Pincode": "517536",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Varadia Palem",
            "Pincode": "517541",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Balijapalle",
            "Pincode": "517561",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kattakinda Venkatapuram",
            "Pincode": "517561",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nennur",
            "Pincode": "517562",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gangi Reddy Palle",
            "Pincode": "517564",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kammapali",
            "Pincode": "517565",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuppam Badur",
            "Pincode": "517566",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nadavalur",
            "Pincode": "517567",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pachikapallam",
            "Pincode": "517569",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Bomma Raja Puram",
            "Pincode": "517571",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narayana Varam",
            "Pincode": "517581",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Durga Samudram",
            "Pincode": "517583",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Puttur",
            "Pincode": "517583",
            "City": "Puttur",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Puttur South",
            "Pincode": "517583",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vepagunta",
            "Pincode": "517584",
            "City": "Vepagunta",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vepakuntala",
            "Pincode": "517584",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pannur",
            "Pincode": "517586",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pisattur",
            "Pincode": "517587",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sattivedu",
            "Pincode": "517588",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagalapuram",
            "Pincode": "517589",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagari",
            "Pincode": "517590",
            "City": "Nagari",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pudupet",
            "Pincode": "517590",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nindra",
            "Pincode": "517591",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ekambara Kuppam",
            "Pincode": "517592",
            "City": "Ekambara kuppam",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vemgal Raja Kuppam",
            "Pincode": "517599",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerpedu",
            "Pincode": "517619",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pallam",
            "Pincode": "517620",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vyasasramam",
            "Pincode": "517621",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Panagal",
            "Pincode": "517640",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thondamanadu",
            "Pincode": "517641",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddakannali",
            "Pincode": "517642",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kovanur",
            "Pincode": "517643",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "517644",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Kalahashthi",
            "Pincode": "517644",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srikalahasthi North",
            "Pincode": "517644",
            "City": "Chittoor",
            "District": "Chittoor",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Knl Bazar",
            "Pincode": "518001",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Knl Chowk",
            "Pincode": "518001",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Knl Dist Court",
            "Pincode": "518001",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Knl Fort",
            "Pincode": "518001",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Knl Osmania College",
            "Pincode": "518001",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurnool",
            "Pincode": "518001",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurnool Narsasimharaopet",
            "Pincode": "518001",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurnool Camp B",
            "Pincode": "518002",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurnool Medical College",
            "Pincode": "518002",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maddurnagar",
            "Pincode": "518002",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Krishna Nagar",
            "Pincode": "518002",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurnool Sap Camp",
            "Pincode": "518003",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhagya Nagar",
            "Pincode": "518004",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta Knl",
            "Pincode": "518004",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nehru Nagar",
            "Pincode": "518004",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prakash Nagar",
            "Pincode": "518004",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "518005",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hussain Puram",
            "Pincode": "518011",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Padu",
            "Pincode": "518015",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Johrapuram",
            "Pincode": "518016",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Edururu",
            "Pincode": "518017",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ulchal",
            "Pincode": "518018",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Niduzuru",
            "Pincode": "518019",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mamidala Padu",
            "Pincode": "518020",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dinne Devara Padu",
            "Pincode": "518021",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Meedivemula",
            "Pincode": "518022",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narnur",
            "Pincode": "518023",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Sailam",
            "Pincode": "518101",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Sailam Dam East",
            "Pincode": "518102",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Panem",
            "Pincode": "518112",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurnool",
            "Pincode": "518115",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Owk",
            "Pincode": "518122",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kolimi Gundla",
            "Pincode": "518123",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Banagana Palle",
            "Pincode": "518124",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Banaganapalle",
            "Pincode": "518124",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "South Kondapeta",
            "Pincode": "518124",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koil Kuntla",
            "Pincode": "518134",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koilkuntla Bus Stand",
            "Pincode": "518134",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dorni Padu",
            "Pincode": "518135",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Revanur",
            "Pincode": "518137",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golladurthy",
            "Pincode": "518138",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nossam",
            "Pincode": "518145",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bodemmanur",
            "Pincode": "518146",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gundupapala",
            "Pincode": "518150",
            "City": "Gundupapala",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vuyyalawada",
            "Pincode": "518155",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Injedu",
            "Pincode": "518157",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sudda Malla",
            "Pincode": "518158",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanjamala",
            "Pincode": "518165",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Perusomala",
            "Pincode": "518166",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandi Vargam",
            "Pincode": "518176",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Illuri Kothapeta",
            "Pincode": "518186",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Akumalla",
            "Pincode": "518196",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cnanapuram",
            "Pincode": "518202",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandyal R S",
            "Pincode": "518202",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cement Nagar",
            "Pincode": "518206",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veldurthi",
            "Pincode": "518216",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramalla Kota",
            "Pincode": "518217",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurnool",
            "Pincode": "518219",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jaladurgan",
            "Pincode": "518220",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peapully",
            "Pincode": "518221",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dhone",
            "Pincode": "518222",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dhone Bazar",
            "Pincode": "518222",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri K V S Colony",
            "Pincode": "518222",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerukala Cheruvu",
            "Pincode": "518225",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adoni",
            "Pincode": "518301",
            "City": "Adoni",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adoni Cotton Market",
            "Pincode": "518301",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adoni Town",
            "Pincode": "518301",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bharpet",
            "Pincode": "518301",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rayanagar",
            "Pincode": "518301",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rtc Complex",
            "Pincode": "518301",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srikrishna",
            "Pincode": "518301",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Adoni Arts College",
            "Pincode": "518302",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Kadubur",
            "Pincode": "518323",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Halvi",
            "Pincode": "518333",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kautalam",
            "Pincode": "518344",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mantralaya",
            "Pincode": "518345",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Holala Gondi",
            "Pincode": "518346",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aspari",
            "Pincode": "518347",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hala Harvi",
            "Pincode": "518348",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madhavaram",
            "Pincode": "518349",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kadivella",
            "Pincode": "518350",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yemmiganur",
            "Pincode": "518360",
            "City": "Yemmiganur",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yemmiganur Bazar",
            "Pincode": "518360",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sirvel",
            "Pincode": "518363",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hosur",
            "Pincode": "518382",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maddikere",
            "Pincode": "518385",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tuggali",
            "Pincode": "518390",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alur",
            "Pincode": "518395",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nemakallu",
            "Pincode": "518396",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thunga Bhadra",
            "Pincode": "518397",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Molagavalli",
            "Pincode": "518398",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerur",
            "Pincode": "518399",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandi Kotkur",
            "Pincode": "518401",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandikotkur Bazar",
            "Pincode": "518401",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurnool",
            "Pincode": "518402",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Midthur",
            "Pincode": "518405",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koni Dela",
            "Pincode": "518411",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prathakota",
            "Pincode": "518412",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atmakur",
            "Pincode": "518422",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guwala Kunta",
            "Pincode": "518426",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Brahmana Kotkur",
            "Pincode": "518432",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pamula Padu",
            "Pincode": "518442",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gargeyapuram",
            "Pincode": "518452",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Belalgal",
            "Pincode": "518462",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gone Gondla",
            "Pincode": "518463",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodumuru",
            "Pincode": "518464",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Devanakonda",
            "Pincode": "518465",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudur",
            "Pincode": "518466",
            "City": "Gudur",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuruvangala Puram",
            "Pincode": "518467",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pendekallu",
            "Pincode": "518468",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Handri Khairwadi",
            "Pincode": "518470",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandyal",
            "Pincode": "518501",
            "City": "Nandyal",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandyal Bazar",
            "Pincode": "518501",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandyal Fort",
            "Pincode": "518501",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanjeevnagar",
            "Pincode": "518501",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sreenivasanagar",
            "Pincode": "518501",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "State Bank Of India Colon",
            "Pincode": "518501",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tekke",
            "Pincode": "518501",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Noonepalli",
            "Pincode": "518503",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yerraguntla",
            "Pincode": "518510",
            "City": "Yerraguntla",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Poluru",
            "Pincode": "518511",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Poluru Vengannagari",
            "Pincode": "518511",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thimmapuram",
            "Pincode": "518512",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Santha Jutur",
            "Pincode": "518513",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kottala",
            "Pincode": "518515",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bollavaram",
            "Pincode": "518517",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bandi Atmakur",
            "Pincode": "518523",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velgode",
            "Pincode": "518533",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aallagadda",
            "Pincode": "518543",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Allagadda North",
            "Pincode": "518543",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mallareddy Vedanagar",
            "Pincode": "518543",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotakandukuru",
            "Pincode": "518550",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chagalamarri",
            "Pincode": "518553",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mutyalapad",
            "Pincode": "518555",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yallur",
            "Pincode": "518573",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gajula Palle",
            "Pincode": "518583",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Padu",
            "Pincode": "518583",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanala",
            "Pincode": "518593",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rudravaram",
            "Pincode": "518594",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jule Palli",
            "Pincode": "518596",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rangapuram",
            "Pincode": "518598",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Betamcherla",
            "Pincode": "518599",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddakambalur",
            "Pincode": "518607",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Deebaguntla",
            "Pincode": "518669",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chapi Revula",
            "Pincode": "518675",
            "City": "Kurnool",
            "District": "Kurnool",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Divisional Office",
            "Pincode": "520001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "520001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sivalayam Street",
            "Pincode": "520001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venugopalaswamy Chowk",
            "Pincode": "520001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vijayada Railway",
            "Pincode": "520001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vijayawada",
            "Pincode": "520001",
            "City": "Vijayawada",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vijayawada Railway Statio",
            "Pincode": "520001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wynchipeta",
            "Pincode": "520001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arundal Pet",
            "Pincode": "520002",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Besent Road Civil Court",
            "Pincode": "520002",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buckinghampet",
            "Pincode": "520002",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Durga Agraharam",
            "Pincode": "520002",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Suryaraopeta",
            "Pincode": "520002",
            "City": "Suryaraopeta",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vijayawada Bus Stand",
            "Pincode": "520002",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ayodyanagar",
            "Pincode": "520003",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Durgapuram",
            "Pincode": "520003",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagar Centre",
            "Pincode": "520003",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagaram",
            "Pincode": "520003",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hanumanulapeta",
            "Pincode": "520003",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kedhareswaripeta",
            "Pincode": "520003",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Machavaram",
            "Pincode": "520004",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maruthinagar",
            "Pincode": "520004",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sitaramapuram",
            "Pincode": "520004",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Christurajapuram",
            "Pincode": "520005",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gunadala",
            "Pincode": "520005",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "P & T Colony",
            "Pincode": "520006",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patamata",
            "Pincode": "520006",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Suryapet Industrial Estat",
            "Pincode": "520007",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polytechnic",
            "Pincode": "520008",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chittinagar",
            "Pincode": "520009",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Milk Project",
            "Pincode": "520009",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandramoulipuram Punnam",
            "Pincode": "520010",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lakshminagar",
            "Pincode": "520011",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muthyalampadu",
            "Pincode": "520011",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satyanarayanapuram",
            "Pincode": "520011",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamakoti Nagar",
            "Pincode": "520012",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishnalanka",
            "Pincode": "520013",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nehrunagar",
            "Pincode": "520013",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patamata Lanka",
            "Pincode": "520014",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ajit Nagar",
            "Pincode": "520015",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Purnandam Pot",
            "Pincode": "520016",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dep Vijayawada",
            "Pincode": "520050",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Balaramunipeta",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Batchupeta",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhaskarapuram Bus Stand",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buttaipet",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chintauntapalem",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Circlepet",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Desaipet",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Englishpalem",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Godugupet",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Inugudurpet",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Machilipatnam",
            "Pincode": "521001",
            "City": "Machilipatnam",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Machilipatnam Bazar",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malakapatnam",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajupet",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uma Gold Covering Works",
            "Pincode": "521001",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chilakala Pudi",
            "Pincode": "521002",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "District Court",
            "Pincode": "521002",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Keerpandharpur",
            "Pincode": "521002",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velandapalem",
            "Pincode": "521002",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Machilipatnam Port",
            "Pincode": "521003",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G Varam Centre",
            "Pincode": "521101",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G Varam College Centre",
            "Pincode": "521101",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gannavaram",
            "Pincode": "521101",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Roya Nagar",
            "Pincode": "521101",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bacon Factory",
            "Pincode": "521102",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nadamanuru",
            "Pincode": "521104",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hanuman Jn",
            "Pincode": "521105",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanumolu",
            "Pincode": "521106",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mustabada",
            "Pincode": "521107",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramavarappadu",
            "Pincode": "521108",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gali Gopuram",
            "Pincode": "521109",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Telaprolu",
            "Pincode": "521109",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veera Valli",
            "Pincode": "521110",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golla Palle",
            "Pincode": "521111",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medicherla",
            "Pincode": "521112",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mirzapuram",
            "Pincode": "521113",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arugolanu",
            "Pincode": "521114",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nangigadda",
            "Pincode": "521116",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Choda Varam",
            "Pincode": "521117",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhavadevara Palle",
            "Pincode": "521118",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagayalanka",
            "Pincode": "521120",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagayalanka East",
            "Pincode": "521120",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagi Reddi Palli",
            "Pincode": "521120",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Avanigadda",
            "Pincode": "521121",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Avanigadda Bazar",
            "Pincode": "521121",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nerellapalem",
            "Pincode": "521121",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Visawanadha Palli",
            "Pincode": "521122",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Keshtram",
            "Pincode": "521123",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "V Kothapalem",
            "Pincode": "521124",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mopidevi",
            "Pincode": "521125",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Challa Palli",
            "Pincode": "521126",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chiruvolu Lanka",
            "Pincode": "521128",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Majeru",
            "Pincode": "521129",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Kalle Palli",
            "Pincode": "521130",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Laxmipuram",
            "Pincode": "521131",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodali",
            "Pincode": "521132",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ghantasala",
            "Pincode": "521133",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srikakulam",
            "Pincode": "521134",
            "City": "Srikakulam",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mowa",
            "Pincode": "521135",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuchipudi Centre",
            "Pincode": "521136",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Poranki",
            "Pincode": "521137",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedasanagallu",
            "Pincode": "521138",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penamaluru",
            "Pincode": "521139",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhatla Penu Marru",
            "Pincode": "521140",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Edupugallu",
            "Pincode": "521144",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Elammarru",
            "Pincode": "521148",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishna",
            "Pincode": "521149",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kaza",
            "Pincode": "521150",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanki Padu",
            "Pincode": "521151",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kolavennu",
            "Pincode": "521153",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vanukuru",
            "Pincode": "521155",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nidumolu",
            "Pincode": "521156",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pamarru",
            "Pincode": "521157",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pamarru Bazar",
            "Pincode": "521157",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polavaram",
            "Pincode": "521162",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thotla Vallur",
            "Pincode": "521163",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Katur",
            "Pincode": "521164",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vuyyuru",
            "Pincode": "521165",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vuyyuru Bazar",
            "Pincode": "521165",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vuyyuru College",
            "Pincode": "521165",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vuyyuru East",
            "Pincode": "521165",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Irellpadu",
            "Pincode": "521170",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jayanthi",
            "Pincode": "521171",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jayanthi",
            "Pincode": "521171",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jaggayapeth",
            "Pincode": "521175",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jgp Bazar",
            "Pincode": "521175",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jgp Bus Stand",
            "Pincode": "521175",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "N S Colony",
            "Pincode": "521175",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Netaji Chowk",
            "Pincode": "521175",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sitarampuram",
            "Pincode": "521175",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anumanchipalli",
            "Pincode": "521176",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Balusupadu",
            "Pincode": "521177",
            "City": "Balusupadu",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chilla Kallu",
            "Pincode": "521178",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bandi Palem",
            "Pincode": "521179",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Juzzuru",
            "Pincode": "521181",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandarla Padu",
            "Pincode": "521182",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mupalla",
            "Pincode": "521183",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muktyala",
            "Pincode": "521184",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mulakala",
            "Pincode": "521184",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandigama",
            "Pincode": "521185",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandigama Bazar",
            "Pincode": "521185",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penu Ganchi Prolu",
            "Pincode": "521190",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandi Nagaram",
            "Pincode": "521201",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nsc Colony",
            "Pincode": "521201",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nuzvid",
            "Pincode": "521201",
            "City": "Nuzvid",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nuzvidu Bazar",
            "Pincode": "521201",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dumdum Garden",
            "Pincode": "521202",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagaram",
            "Pincode": "521202",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nizamabad",
            "Pincode": "521206",
            "City": "Nizamabad",
            "District": "Nizamabad",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Musunuru",
            "Pincode": "521207",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aukiripalli",
            "Pincode": "521211",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nunna",
            "Pincode": "521212",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramanakkapet",
            "Pincode": "521213",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "T Sanubanda",
            "Pincode": "521214",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vissannapet",
            "Pincode": "521215",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ibrahimpatnam",
            "Pincode": "521226",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kambampadu",
            "Pincode": "521227",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Konda Palli",
            "Pincode": "521228",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Konduru",
            "Pincode": "521229",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mylavaram",
            "Pincode": "521230",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhawan Puram",
            "Pincode": "521231",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tiruvuru",
            "Pincode": "521235",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tiruvuru Bazar",
            "Pincode": "521235",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tiruvuru Factory Centre",
            "Pincode": "521235",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Akunuru",
            "Pincode": "521245",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kapileswara Puram",
            "Pincode": "521246",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veeranki Lock",
            "Pincode": "521250",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Choragudi",
            "Pincode": "521251",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penumatcha",
            "Pincode": "521255",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mantada",
            "Pincode": "521256",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manikonda",
            "Pincode": "521260",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mudunuru",
            "Pincode": "521261",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatraprageda",
            "Pincode": "521263",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manthena",
            "Pincode": "521265",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedauta Palli",
            "Pincode": "521286",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bethavolu",
            "Pincode": "521301",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudivada",
            "Pincode": "521301",
            "City": "Gudivada",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudivada Bazar",
            "Pincode": "521301",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudivada Old Town",
            "Pincode": "521301",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "I E Gudivada",
            "Pincode": "521301",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jagannadapuram",
            "Pincode": "521301",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajendranagar Colony",
            "Pincode": "521301",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satyanarayanapuram",
            "Pincode": "521301",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tenneru",
            "Pincode": "521301",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indupalli",
            "Pincode": "521311",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vungutur",
            "Pincode": "521312",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Janardhanapuram",
            "Pincode": "521321",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedavirivada",
            "Pincode": "521321",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golve Palli",
            "Pincode": "521322",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Moturu",
            "Pincode": "521323",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mudine Palle",
            "Pincode": "521325",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satyanarayanapuram",
            "Pincode": "521325",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rudra Paka",
            "Pincode": "521326",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tamrisa",
            "Pincode": "521327",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedagonnur",
            "Pincode": "521329",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Angalur",
            "Pincode": "521330",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kavutaram",
            "Pincode": "521331",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Doki Parru",
            "Pincode": "521332",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kallklur",
            "Pincode": "521333",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "521333",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Santha Mkt",
            "Pincode": "521333",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizianagaram",
            "Pincode": "521338",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pallevada",
            "Pincode": "521340",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Korukollu",
            "Pincode": "521343",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kali Dindi",
            "Pincode": "521344",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manda Valli Station Road",
            "Pincode": "521345",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudlavalleru",
            "Pincode": "521356",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedana",
            "Pincode": "521366",
            "City": "Pedana",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedana Bazar",
            "Pincode": "521366",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Munjuluru",
            "Pincode": "521369",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Brahma Puram",
            "Pincode": "521370",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishna",
            "Pincode": "521372",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedamaddali",
            "Pincode": "521390",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malaparru",
            "Pincode": "521391",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mulaparru",
            "Pincode": "521391",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penu Golanu",
            "Pincode": "521401",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vatsavai",
            "Pincode": "521402",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gampalagudem",
            "Pincode": "521403",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondur",
            "Pincode": "521421",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramachandra Puram",
            "Pincode": "521424",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sivapuram",
            "Pincode": "521429",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rami Reddi Palli",
            "Pincode": "521436",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vijayawada Thermal Statio",
            "Pincode": "521456",
            "City": "Krishna",
            "District": "Krishna",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G T R College Road",
            "Pincode": "522001",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G T R Govt General Hospital",
            "Pincode": "522001",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G T R Kothapet",
            "Pincode": "522001",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G T R Nehrunagar",
            "Pincode": "522001",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G T R Railpet",
            "Pincode": "522001",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G T R Tabacco Colony",
            "Pincode": "522001",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guntur",
            "Pincode": "522001",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arundalpet",
            "Pincode": "522002",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Brodipet",
            "Pincode": "522002",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Donka Board",
            "Pincode": "522002",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Donka Road",
            "Pincode": "522002",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vallurivari Road",
            "Pincode": "522002",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anandapeta",
            "Pincode": "522003",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Choutra Guntur",
            "Pincode": "522003",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Etukuru Road",
            "Pincode": "522003",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Factories Ward",
            "Pincode": "522003",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guntur Bazar",
            "Pincode": "522003",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Municipal Office",
            "Pincode": "522003",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S K P Temple",
            "Pincode": "522003",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A T Agraharam",
            "Pincode": "522004",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Agri Market Yard",
            "Pincode": "522004",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guntur Collectorate",
            "Pincode": "522004",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guntur Medical College",
            "Pincode": "522004",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kannavari Thota",
            "Pincode": "522004",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sampathnagar",
            "Pincode": "522004",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Trunk Road",
            "Pincode": "522004",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nallapadu",
            "Pincode": "522005",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Choudaripet",
            "Pincode": "522006",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pattabhipuram",
            "Pincode": "522006",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srikrishnanagar",
            "Pincode": "522006",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srinivasanagar Colony",
            "Pincode": "522006",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amaravati Road",
            "Pincode": "522007",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandra Mouli Nagar",
            "Pincode": "522007",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Korite Padu",
            "Pincode": "522007",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Laxmipuram Water Works",
            "Pincode": "522007",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pandaripuram",
            "Pincode": "522007",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lam",
            "Pincode": "522008",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lankala Koderu",
            "Pincode": "522008",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Perecherla",
            "Pincode": "522009",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bus Stand Guntur",
            "Pincode": "522010",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Guntur",
            "Pincode": "522010",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Budam Padu",
            "Pincode": "522013",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantavarappadu Guntur",
            "Pincode": "522014",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Abbinenigunta Palem",
            "Pincode": "522015",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lemalle",
            "Pincode": "522016",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Etkur",
            "Pincode": "522017",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ponnekallu",
            "Pincode": "522018",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prathi Padu",
            "Pincode": "522019",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amaravathi Guntur",
            "Pincode": "522020",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bandarupalle",
            "Pincode": "522021",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Korene Padu",
            "Pincode": "522022",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guntur",
            "Pincode": "522024",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guntur",
            "Pincode": "522026",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Industrial Estate Gtr",
            "Pincode": "522034",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Guntur",
            "Pincode": "522036",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Det Guntur",
            "Pincode": "522050",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Railpeta",
            "Pincode": "522101",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rangarauthota",
            "Pincode": "522101",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satyanarayanpuragraharam",
            "Pincode": "522101",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Taluka Office",
            "Pincode": "522101",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vijayalakshmipuram",
            "Pincode": "522101",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karla Palem",
            "Pincode": "522111",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kakumanu",
            "Pincode": "522112",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narasayapalem",
            "Pincode": "522116",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nidubrolu",
            "Pincode": "522123",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "522123",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ponnur",
            "Pincode": "522124",
            "City": "Ponnur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ponnur Bazar",
            "Pincode": "522124",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vallabharao Palem",
            "Pincode": "522125",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanchika Cherla",
            "Pincode": "522180",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanchikacherla Bazar",
            "Pincode": "522180",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bus Stand",
            "Pincode": "522201",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinaravuru",
            "Pincode": "522201",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "522201",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapet",
            "Pincode": "522201",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lthanagar Appadu",
            "Pincode": "522201",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nazeerpet",
            "Pincode": "522201",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tenali",
            "Pincode": "522201",
            "City": "Tenali",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tenali Bazar",
            "Pincode": "522201",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wahab Chowk",
            "Pincode": "522201",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Balaji Nagar",
            "Pincode": "522202",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Morrispet",
            "Pincode": "522202",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pinapadu",
            "Pincode": "522202",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satyanarayanapuram",
            "Pincode": "522202",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Angala Kuduru",
            "Pincode": "522211",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chebrole",
            "Pincode": "522212",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sangam Jagarlamudi",
            "Pincode": "522213",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Brahmana Kodur",
            "Pincode": "522214",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mutluru",
            "Pincode": "522215",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narakoduru",
            "Pincode": "522222",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Edla Padu",
            "Pincode": "522233",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nadendla",
            "Pincode": "522234",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedanandi Padu",
            "Pincode": "522235",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadikonda",
            "Pincode": "522236",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thulluru",
            "Pincode": "522237",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tubadu",
            "Pincode": "522238",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhatti Prolu",
            "Pincode": "522256",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vellatur",
            "Pincode": "522257",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dhulipudi",
            "Pincode": "522258",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanagala",
            "Pincode": "522259",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pallapatla",
            "Pincode": "522260",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vemur",
            "Pincode": "522261",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuchinapudi",
            "Pincode": "522262",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Advula Divi",
            "Pincode": "522263",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chodaya Palem",
            "Pincode": "522264",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Isukapalli",
            "Pincode": "522265",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Railpet",
            "Pincode": "522265",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Repalle",
            "Pincode": "522265",
            "City": "Repalle",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Repalle Bazar",
            "Pincode": "522265",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jampani",
            "Pincode": "522266",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peteru",
            "Pincode": "522267",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagaram",
            "Pincode": "522268",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Singupalem",
            "Pincode": "522269",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Agraharam",
            "Pincode": "522270",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gangadi Palem",
            "Pincode": "522271",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pothu Meraka",
            "Pincode": "522272",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kaite Palle",
            "Pincode": "522273",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chatragadda",
            "Pincode": "522274",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thota Palle",
            "Pincode": "522275",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dindi",
            "Pincode": "522276",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chavali",
            "Pincode": "522277",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vulli Palem",
            "Pincode": "522278",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bethapudi",
            "Pincode": "522279",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nalluru Palem",
            "Pincode": "522280",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gurunadhar Nagar",
            "Pincode": "522281",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Voleru",
            "Pincode": "522282",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vallabhapuram",
            "Pincode": "522290",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Revendra Padu",
            "Pincode": "522291",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tummuluru",
            "Pincode": "522292",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pida Parru",
            "Pincode": "522293",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Munnangi",
            "Pincode": "522294",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kathevaram",
            "Pincode": "522295",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ipur",
            "Pincode": "522296",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dantalur",
            "Pincode": "522297",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chivalur",
            "Pincode": "522298",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinapalem",
            "Pincode": "522299",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantavaram",
            "Pincode": "522301",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Vadla Pudi",
            "Pincode": "522302",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nutakki",
            "Pincode": "522303",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kollipara",
            "Pincode": "522304",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Palem",
            "Pincode": "522305",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandi Velugu",
            "Pincode": "522306",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kolakalur",
            "Pincode": "522307",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Emani",
            "Pincode": "522308",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cheruku Palle",
            "Pincode": "522309",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Appi Katla",
            "Pincode": "522310",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chandole",
            "Pincode": "522311",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Turimela",
            "Pincode": "522312",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kuchipudi",
            "Pincode": "522313",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nizampatnam",
            "Pincode": "522314",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Machavaram",
            "Pincode": "522315",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patchala Tadi Parru",
            "Pincode": "522316",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Stuartpuram",
            "Pincode": "522317",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "T Sunduru",
            "Pincode": "522318",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Modukuru",
            "Pincode": "522321",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kolluru",
            "Pincode": "522324",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amrutalur",
            "Pincode": "522325",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manchikalapudi",
            "Pincode": "522329",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Duggirala",
            "Pincode": "522330",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chiluvur",
            "Pincode": "522332",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Edla Palli",
            "Pincode": "522340",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bodi Palem",
            "Pincode": "522354",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bodugullam",
            "Pincode": "522354",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Siripuram",
            "Pincode": "522401",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedakurapadu",
            "Pincode": "522402",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Abburu",
            "Pincode": "522403",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Clock Tower",
            "Pincode": "522403",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "522403",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sattenapalle",
            "Pincode": "522403",
            "City": "Sattenapalle",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sattenapalle Bazar",
            "Pincode": "522403",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sattenapalle Bus Stand",
            "Pincode": "522403",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vaddavalli",
            "Pincode": "522403",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lingamguntla",
            "Pincode": "522407",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Linganguntla",
            "Pincode": "522407",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muppalla",
            "Pincode": "522408",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atchampeta",
            "Pincode": "522409",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krosur",
            "Pincode": "522410",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bellam Konda",
            "Pincode": "522411",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raju Palem",
            "Pincode": "522412",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "P R Bazar",
            "Pincode": "522413",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pidugu Ralla",
            "Pincode": "522413",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rentachinala",
            "Pincode": "522421",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Macherla",
            "Pincode": "522426",
            "City": "Macherla",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Macherla R S",
            "Pincode": "522426",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nehrunagar",
            "Pincode": "522426",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Park Centre",
            "Pincode": "522426",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pwd Colony",
            "Pincode": "522426",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shanti Nagar",
            "Pincode": "522426",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parastyallur",
            "Pincode": "522436",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vijayapuri South",
            "Pincode": "522439",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadepalle",
            "Pincode": "522501",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishna Cement Works",
            "Pincode": "522502",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Apsp Colony",
            "Pincode": "522503",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Donboscu Premiias",
            "Pincode": "522503",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "522503",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mangalagiri",
            "Pincode": "522503",
            "City": "Mangalagiri",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mangalgiri Bus Stand",
            "Pincode": "522503",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Weavers Colony",
            "Pincode": "522503",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Namburu",
            "Pincode": "522508",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pathur",
            "Pincode": "522509",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Kakani",
            "Pincode": "522509",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagarjunanagar",
            "Pincode": "522510",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mangalagiri Bazar",
            "Pincode": "522511",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Mangala Giri",
            "Pincode": "522511",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polakampadu Ind Area",
            "Pincode": "522515",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Phirangi Puram",
            "Pincode": "522529",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satuluru",
            "Pincode": "522549",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arundalpet",
            "Pincode": "522601",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Burnpet",
            "Pincode": "522601",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "N Raopet Bazar",
            "Pincode": "522601",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "N S Colony",
            "Pincode": "522601",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narasarao Pet",
            "Pincode": "522601",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ravi Padu",
            "Pincode": "522603",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizianagaram",
            "Pincode": "522608",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kavur",
            "Pincode": "522611",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Durgi",
            "Pincode": "522612",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karempudi",
            "Pincode": "522614",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karempudi Nsc Colony",
            "Pincode": "522614",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nakarikallu",
            "Pincode": "522615",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinta Palli",
            "Pincode": "522620",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Murikipudi",
            "Pincode": "522626",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raju Palem",
            "Pincode": "522630",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Konidena",
            "Pincode": "522631",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Savalyapuram",
            "Pincode": "522646",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Kancherla",
            "Pincode": "522649",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedapuli Parru",
            "Pincode": "522655",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vellatur Vkd",
            "Pincode": "522657",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ipur",
            "Pincode": "522658",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ainavolu",
            "Pincode": "522659",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nuzendla",
            "Pincode": "522660",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muppalla",
            "Pincode": "522661",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bandla Mottu",
            "Pincode": "522663",
            "City": "Guntur",
            "District": "Guntur",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Addanki Gate",
            "Pincode": "523001",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Clough Peta",
            "Pincode": "523001",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gopal Nagar",
            "Pincode": "523001",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nsc Colony",
            "Pincode": "523001",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ongole",
            "Pincode": "523001",
            "City": "Ongole",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prakashambhavan",
            "Pincode": "523001",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "523001",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Santhapeta",
            "Pincode": "523001",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Seetarampuram",
            "Pincode": "523001",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thurupupalem",
            "Pincode": "523001",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Trunk Road",
            "Pincode": "523001",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dt Court Premises",
            "Pincode": "523002",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "523002",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurnool Road",
            "Pincode": "523002",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lawyerpeta",
            "Pincode": "523002",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mangamur Donka",
            "Pincode": "523002",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ongole Bazar",
            "Pincode": "523002",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Singaraya Konda",
            "Pincode": "523101",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srk North",
            "Pincode": "523101",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Woolapalem",
            "Pincode": "523104",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandukur Cutchery",
            "Pincode": "523105",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandukur South",
            "Pincode": "523105",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandukuru",
            "Pincode": "523105",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kandukuru Bazar",
            "Pincode": "523105",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bingine Palle",
            "Pincode": "523106",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pamuru",
            "Pincode": "523108",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ponnalore",
            "Pincode": "523109",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Botla Gudur",
            "Pincode": "523110",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Alavalle Padu",
            "Pincode": "523111",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Puram",
            "Pincode": "523112",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pokuru",
            "Pincode": "523113",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lingasamudram",
            "Pincode": "523114",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Pavani",
            "Pincode": "523115",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandanavaram",
            "Pincode": "523121",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chirikura Padu",
            "Pincode": "523124",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palukur",
            "Pincode": "523125",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "China Ganjam",
            "Pincode": "523135",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ahmed Nagar",
            "Pincode": "523155",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bosenagar",
            "Pincode": "523155",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chirala",
            "Pincode": "523155",
            "City": "Chirala",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chirala Bazar",
            "Pincode": "523155",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Paparaju Thota",
            "Pincode": "523155",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramakrishnapuram",
            "Pincode": "523155",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Santha Bazar",
            "Pincode": "523155",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Cloth Mkt",
            "Pincode": "523156",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Perala",
            "Pincode": "523157",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prasad Nagar",
            "Pincode": "523157",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramanagar",
            "Pincode": "523157",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vittalnagar",
            "Pincode": "523157",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jandrapet",
            "Pincode": "523165",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ipurupalem",
            "Pincode": "523166",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karam Chedu",
            "Pincode": "523168",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parchuru",
            "Pincode": "523169",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Swarna",
            "Pincode": "523170",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ammana Brolu Raparla",
            "Pincode": "523180",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kadava Kuduru",
            "Pincode": "523181",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karavadi",
            "Pincode": "523182",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagula Palle Padu",
            "Pincode": "523183",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prasangula Padu",
            "Pincode": "523183",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pandilla Palle",
            "Pincode": "523184",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Santharavur",
            "Pincode": "523185",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uppaugundur",
            "Pincode": "523186",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raurr Peta",
            "Pincode": "523187",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veta Palem",
            "Pincode": "523187",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chavata Palem",
            "Pincode": "523188",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thimmasamdram",
            "Pincode": "523189",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Idupulapadu",
            "Pincode": "523190",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Idumudi",
            "Pincode": "523194",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanuparthi",
            "Pincode": "523195",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Addanki",
            "Pincode": "523201",
            "City": "Addanki",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "North Addanki",
            "Pincode": "523201",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "523201",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maddi Padu",
            "Pincode": "523211",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medara Metla",
            "Pincode": "523212",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medarametla Trunk Rd",
            "Pincode": "523212",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ravinuthala",
            "Pincode": "523213",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Paidipadu",
            "Pincode": "523216",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vellampalli",
            "Pincode": "523219",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mogallur",
            "Pincode": "523223",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veli Gandla",
            "Pincode": "523224",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Santhanuthala Padu",
            "Pincode": "523225",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bandlamudi",
            "Pincode": "523226",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chima Kurthi",
            "Pincode": "523226",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "N S C Colony",
            "Pincode": "523226",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hanumanthuni Padu",
            "Pincode": "523227",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Golla Palli",
            "Pincode": "523228",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kangiri",
            "Pincode": "523230",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanigiri Bazar",
            "Pincode": "523230",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanipakam",
            "Pincode": "523230",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "523230",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gundla Samudram",
            "Pincode": "523240",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothuru",
            "Pincode": "523240",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pidili",
            "Pincode": "523240",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Konakana Metla",
            "Pincode": "523241",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gundla Samudram",
            "Pincode": "523243",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedarikatla",
            "Pincode": "523245",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gotla Gattu",
            "Pincode": "523246",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Darsi Nsc Colony",
            "Pincode": "523247",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pothakamur",
            "Pincode": "523252",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uppalapadu",
            "Pincode": "523253",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sankhavaram",
            "Pincode": "523254",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Valaparla",
            "Pincode": "523260",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muppavaram",
            "Pincode": "523261",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Throvagunta",
            "Pincode": "523262",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Llapavulur",
            "Pincode": "523263",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tella Padu",
            "Pincode": "523263",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tellapadu",
            "Pincode": "523263",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Talluru",
            "Pincode": "523264",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manduvari Palem",
            "Pincode": "523265",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Darsi Agraharam",
            "Pincode": "523267",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yedugundla Padu",
            "Pincode": "523269",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kami Palli",
            "Pincode": "523271",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Valluru",
            "Pincode": "523272",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peridepi",
            "Pincode": "523273",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tanguturu",
            "Pincode": "523274",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tanguturu Bus Stand",
            "Pincode": "523274",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Devagudur",
            "Pincode": "523277",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uppalapadu",
            "Pincode": "523279",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eta Mukkala",
            "Pincode": "523280",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madanur",
            "Pincode": "523280",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudluru",
            "Pincode": "523281",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chodavaram",
            "Pincode": "523285",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapatnam",
            "Pincode": "523286",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Paleti Padu",
            "Pincode": "523290",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rama Patnam",
            "Pincode": "523291",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ualavapadu",
            "Pincode": "523292",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jayavaram",
            "Pincode": "523297",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maruturu",
            "Pincode": "523301",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Santha Magalur",
            "Pincode": "523302",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kammala Padu",
            "Pincode": "523303",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurichedu",
            "Pincode": "523304",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nsc Colony",
            "Pincode": "523304",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dona Konda R S",
            "Pincode": "523305",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gajjala Konda",
            "Pincode": "523315",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Markapur",
            "Pincode": "523316",
            "City": "Markapur",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Markapur Bazar",
            "Pincode": "523316",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Markapur East",
            "Pincode": "523316",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Markapur South",
            "Pincode": "523316",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tokapalli",
            "Pincode": "523320",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tripurantakam",
            "Pincode": "523326",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Erragonda Palem",
            "Pincode": "523327",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pullala Cheruvu",
            "Pincode": "523328",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vemula Kota",
            "Pincode": "523329",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dupadu",
            "Pincode": "523330",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Dornal",
            "Pincode": "523331",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tarlapadu",
            "Pincode": "523332",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cumbum",
            "Pincode": "523333",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cumbum East",
            "Pincode": "523333",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nehru Nagar",
            "Pincode": "523333",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arthavidu",
            "Pincode": "523335",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mohiddin Puram",
            "Pincode": "523338",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishnam Shettipalle",
            "Pincode": "523345",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Petikaya Gulla",
            "Pincode": "523346",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Edavalli",
            "Pincode": "523356",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Giddalur",
            "Pincode": "523357",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Giddalur Bazar",
            "Pincode": "523357",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Giddalur West",
            "Pincode": "523357",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mundlapadu",
            "Pincode": "523367",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Racherla",
            "Pincode": "523368",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raju Palem",
            "Pincode": "523369",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ravi Padu",
            "Pincode": "523370",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tummala Cheruvu",
            "Pincode": "523371",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Turmella",
            "Pincode": "523372",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Komarole",
            "Pincode": "523373",
            "City": "Prakasam",
            "District": "Prakasam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Brundavanam",
            "Pincode": "524001",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nellore",
            "Pincode": "524001",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nellore Bazar",
            "Pincode": "524001",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nellore R S",
            "Pincode": "524001",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nellore Zilla Parishad",
            "Pincode": "524001",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Poga Thota",
            "Pincode": "524001",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ranganayakulu Peta",
            "Pincode": "524001",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Santhapeta",
            "Pincode": "524001",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Trunk Road",
            "Pincode": "524001",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vedamvari Agraharam",
            "Pincode": "524001",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A C Nagar",
            "Pincode": "524002",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Balaji Nagar",
            "Pincode": "524002",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lakshmipuram",
            "Pincode": "524002",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nawabpet",
            "Pincode": "524002",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pet",
            "Pincode": "524002",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buildings Compound",
            "Pincode": "524003",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Darga Mitta",
            "Pincode": "524003",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fatherkhanpet",
            "Pincode": "524003",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lake View Colony",
            "Pincode": "524003",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mulapeta",
            "Pincode": "524003",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nellore Dt Court",
            "Pincode": "524003",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramalingapuram",
            "Pincode": "524003",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Andhra Kesari Nagar",
            "Pincode": "524004",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polytechnic",
            "Pincode": "524005",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G D R Chowk",
            "Pincode": "524101",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G D R East",
            "Pincode": "524101",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gudur",
            "Pincode": "524101",
            "City": "Gudur",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dudur Polytechnic",
            "Pincode": "524102",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malavyanagar",
            "Pincode": "524102",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsingarooet",
            "Pincode": "524102",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aremanipadu",
            "Pincode": "524119",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sulurpet",
            "Pincode": "524121",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sulurpet Bazar",
            "Pincode": "524121",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotapolur",
            "Pincode": "524123",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Hari Kota Range",
            "Pincode": "524124",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Beripet",
            "Pincode": "524126",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nayudupet",
            "Pincode": "524126",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yella Siri",
            "Pincode": "524127",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Balaya Palli",
            "Pincode": "524129",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jayampu",
            "Pincode": "524131",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pigilam",
            "Pincode": "524131",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patha Kota",
            "Pincode": "524132",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "V G T Bazar",
            "Pincode": "524132",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatagiri Town",
            "Pincode": "524132",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kovur",
            "Pincode": "524137",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kovur Cutchery",
            "Pincode": "524137",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bitragunta",
            "Pincode": "524142",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bitragunta Locoshed",
            "Pincode": "524142",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bogavalu",
            "Pincode": "524142",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Damavaram",
            "Pincode": "524152",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Co Op Colony",
            "Pincode": "524201",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kavali",
            "Pincode": "524201",
            "City": "Kavali",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kvl Bazar",
            "Pincode": "524201",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kvl Cutcherry",
            "Pincode": "524201",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Janathapet",
            "Pincode": "524202",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anemadugu",
            "Pincode": "524203",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chakalakonda",
            "Pincode": "524221",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Duthalur",
            "Pincode": "524222",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jaladanki",
            "Pincode": "524223",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kaligiri",
            "Pincode": "524224",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srddana Konduru",
            "Pincode": "524225",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Udayagiri",
            "Pincode": "524226",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vari Kunta Padu",
            "Pincode": "524227",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vinjamur",
            "Pincode": "524228",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandi Padu",
            "Pincode": "524230",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gumperla Padu",
            "Pincode": "524234",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandi Palem",
            "Pincode": "524236",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Somasila Project",
            "Pincode": "524301",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantasagaram",
            "Pincode": "524302",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Revuru",
            "Pincode": "524303",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Annuma Samudrmpeta",
            "Pincode": "524304",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buchireddy Palem",
            "Pincode": "524305",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bus Stand",
            "Pincode": "524305",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Duwur",
            "Pincode": "524306",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karatampadu",
            "Pincode": "524307",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sangam",
            "Pincode": "524308",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Virur",
            "Pincode": "524309",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sitarampuram",
            "Pincode": "524310",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thotapalli Gudur",
            "Pincode": "524311",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marri Padu",
            "Pincode": "524312",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mypadu",
            "Pincode": "524313",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indukurpet",
            "Pincode": "524314",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Allur",
            "Pincode": "524315",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Allurpet",
            "Pincode": "524315",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodavlur",
            "Pincode": "524316",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandavaram",
            "Pincode": "524317",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vidavalur",
            "Pincode": "524318",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yellaya Palem",
            "Pincode": "524319",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satram",
            "Pincode": "524320",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Survepalle",
            "Pincode": "524321",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atmakur",
            "Pincode": "524322",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Laxmanraopalle",
            "Pincode": "524322",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nidigunta Palem",
            "Pincode": "524323",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Iskapalle",
            "Pincode": "524324",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palli",
            "Pincode": "524329",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kolagatla",
            "Pincode": "524333",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalu Voya",
            "Pincode": "524343",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muthukuru",
            "Pincode": "524344",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Brahma Devam",
            "Pincode": "524346",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "North Raju Palem",
            "Pincode": "524366",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tada",
            "Pincode": "524401",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vogilli",
            "Pincode": "524402",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mallam",
            "Pincode": "524403",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bangaraopet",
            "Pincode": "524404",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manu Bolu",
            "Pincode": "524405",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chennur",
            "Pincode": "524406",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gulimcherla",
            "Pincode": "524407",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palur",
            "Pincode": "524407",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Syadapuram",
            "Pincode": "524407",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thokalapudi",
            "Pincode": "524407",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rapur",
            "Pincode": "524408",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kali Chedu",
            "Pincode": "524409",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kadivedu",
            "Pincode": "524410",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kota",
            "Pincode": "524411",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chillakur",
            "Pincode": "524412",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vidyanagar",
            "Pincode": "524413",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gunda Volu",
            "Pincode": "524414",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vakadu",
            "Pincode": "524415",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Santhaveluru",
            "Pincode": "524416",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Menakur",
            "Pincode": "524421",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalluru",
            "Pincode": "524441",
            "City": "Nellore",
            "District": "Nellore",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Avn College Road",
            "Pincode": "530001",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chengalrao Pet",
            "Pincode": "530001",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fort Ward",
            "Pincode": "530001",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurupam Market",
            "Pincode": "530001",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Visakhapatnam",
            "Pincode": "530001",
            "City": "Visakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dist Court Bldgs",
            "Pincode": "530002",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "King George Hospital",
            "Pincode": "530002",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maharanipeta",
            "Pincode": "530002",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muppidi Colony",
            "Pincode": "530002",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Official Colony",
            "Pincode": "530002",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Turners Choultry",
            "Pincode": "530002",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Andhra University",
            "Pincode": "530003",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Place",
            "Pincode": "530003",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pandurangapuram",
            "Pincode": "530003",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pitapuram Colony",
            "Pincode": "530003",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vidya Bhavan",
            "Pincode": "530003",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Allipuram",
            "Pincode": "530004",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dondapathi Railway Colony",
            "Pincode": "530004",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gynanpuram",
            "Pincode": "530004",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lic Bldg",
            "Pincode": "530004",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Visakha",
            "Pincode": "530004",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Waltair Rs",
            "Pincode": "530004",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Gram",
            "Pincode": "530005",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nausenabaugh",
            "Pincode": "530005",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Butchi Raju Palem Visakha",
            "Pincode": "530006",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "530007",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanchara Palem Visakha",
            "Pincode": "530008",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Depot",
            "Pincode": "530009",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Isakathota Visakha",
            "Pincode": "530010",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malkapuram Visakhal",
            "Pincode": "530011",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Malki Mohammad",
            "Pincode": "530011",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sriharipuram",
            "Pincode": "530011",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Autonagar",
            "Pincode": "530012",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bharat Heavy Plates And V",
            "Pincode": "530012",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "P & T Colony",
            "Pincode": "530013",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Resapupalem",
            "Pincode": "530013",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ins Satavahana",
            "Pincode": "530014",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Naval Dock Yard",
            "Pincode": "530014",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Visakhapatnam Naval Base",
            "Pincode": "530014",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Visakhapatnam Zinc",
            "Pincode": "530015",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Akkayyapelem",
            "Pincode": "530016",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dwarakanagar",
            "Pincode": "530016",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lalithanagaram",
            "Pincode": "530016",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "New Colony",
            "Pincode": "530016",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lawsons Bay Colony Visakh",
            "Pincode": "530017",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muvvalavanipalem",
            "Pincode": "530017",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedda Waltair",
            "Pincode": "530017",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Marri Palem",
            "Pincode": "530018",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vishakhapatnam",
            "Pincode": "530019",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Daba Gardens",
            "Pincode": "530020",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lalitha Colony",
            "Pincode": "530020",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Visakhapatnam Bus Station",
            "Pincode": "530020",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nehru Nagar",
            "Pincode": "530021",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Housing Board Colony",
            "Pincode": "530022",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "China Waltair",
            "Pincode": "530023",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kailasapuram",
            "Pincode": "530024",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Salagramapuram",
            "Pincode": "530024",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanithi Visakha",
            "Pincode": "530025",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gajuvaka",
            "Pincode": "530026",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nellimukku",
            "Pincode": "530026",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gopala Patnam",
            "Pincode": "530027",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yellapuvanipalem",
            "Pincode": "530027",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Simhachalam",
            "Pincode": "530028",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Puram",
            "Pincode": "530029",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizianagaram",
            "Pincode": "530030",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Visakhapatnam Steel Proje",
            "Pincode": "530031",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Visakhapatnam Port",
            "Pincode": "530035",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vishakhapatnam",
            "Pincode": "530039",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Govt Diary Farm",
            "Pincode": "530040",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Govt General Hospital Kda",
            "Pincode": "530040",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anandapuram",
            "Pincode": "530042",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mindhi",
            "Pincode": "530042",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "A M A L College",
            "Pincode": "531001",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anakapalle",
            "Pincode": "531001",
            "City": "Anakapalle",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anakapalle Bazar",
            "Pincode": "531001",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anakapalle Bus Stand",
            "Pincode": "531001",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anakapalle R S",
            "Pincode": "531001",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Market",
            "Pincode": "531001",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagaram",
            "Pincode": "531001",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nadanam Doddi",
            "Pincode": "531002",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Achutapuram",
            "Pincode": "531011",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atchutapuram",
            "Pincode": "531011",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parvada",
            "Pincode": "531021",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koduru",
            "Pincode": "531022",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Govada",
            "Pincode": "531023",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Paderoo",
            "Pincode": "531024",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Medivada",
            "Pincode": "531025",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ravikamatam",
            "Pincode": "531025",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vaddadi",
            "Pincode": "531026",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madugula",
            "Pincode": "531027",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kaspajagannadhapuram",
            "Pincode": "531028",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gangaraj Madugula",
            "Pincode": "531029",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Devara Palle",
            "Pincode": "531030",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kasimkota",
            "Pincode": "531031",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tumma Pala",
            "Pincode": "531032",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Managapaka",
            "Pincode": "531033",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kintada Kota Padu",
            "Pincode": "531034",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Subbavaram",
            "Pincode": "531035",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chodavaram",
            "Pincode": "531036",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothuru",
            "Pincode": "531036",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Bayulu",
            "Pincode": "531040",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yellamanchili",
            "Pincode": "531055",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S Rayavaram",
            "Pincode": "531060",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dimli",
            "Pincode": "531061",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gavaravaram",
            "Pincode": "531075",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lakkavaram",
            "Pincode": "531075",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kukumpet",
            "Pincode": "531077",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nakkapalli",
            "Pincode": "531081",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Etikoppaka",
            "Pincode": "531082",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedagummuluru",
            "Pincode": "531083",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishnadevi Peta",
            "Pincode": "531084",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotavratla",
            "Pincode": "531085",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koyyuru",
            "Pincode": "531087",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizianagaram",
            "Pincode": "531091",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sileru Project",
            "Pincode": "531105",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Donka Rayi",
            "Pincode": "531110",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinta Palli",
            "Pincode": "531111",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Makavarapalem",
            "Pincode": "531113",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotha Kota",
            "Pincode": "531114",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Natavaram",
            "Pincode": "531115",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "National Police",
            "Pincode": "531115",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishna Bazar",
            "Pincode": "531116",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsipatnam",
            "Pincode": "531116",
            "City": "Narsipatnam",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedaboode Palle",
            "Pincode": "531116",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vemula Pudi",
            "Pincode": "531117",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Payakaraopet",
            "Pincode": "531126",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satyavaram",
            "Pincode": "531127",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raghavendranagar",
            "Pincode": "531133",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dondapudi",
            "Pincode": "531135",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srungavarapu Kota",
            "Pincode": "531145",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srungavarapu Kota Bus Sd",
            "Pincode": "531145",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharmavaram",
            "Pincode": "531148",
            "City": "Dharmavaram",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Araku Colony",
            "Pincode": "531149",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Araku R S",
            "Pincode": "531151",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sunkari Metta",
            "Pincode": "531152",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bonangi",
            "Pincode": "531160",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lakkavarapu Kota",
            "Pincode": "531161",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chitti Valasa",
            "Pincode": "531162",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bheemanipatnam",
            "Pincode": "531163",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "China Bazar",
            "Pincode": "531163",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Revidi",
            "Pincode": "531172",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pendurthi",
            "Pincode": "531173",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotha Valasa",
            "Pincode": "531183",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gajula Rega",
            "Pincode": "531201",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kotha Ahraharam",
            "Pincode": "531201",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizianagaram City",
            "Pincode": "531201",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vzm Market",
            "Pincode": "531201",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dasannapeta",
            "Pincode": "531202",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "531202",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Phulbagh Road",
            "Pincode": "531202",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rewarani Pate",
            "Pincode": "531202",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizianagaram",
            "Pincode": "531202",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vzm Bazar",
            "Pincode": "531202",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vzm Fort",
            "Pincode": "531202",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizanagaram Cantt",
            "Pincode": "531203",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vzm Bus Stand",
            "Pincode": "531203",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vzm Collectorate",
            "Pincode": "531203",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vzm R S",
            "Pincode": "531203",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pusapati Rega",
            "Pincode": "531204",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "531211",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ingala Palli",
            "Pincode": "531211",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Konada",
            "Pincode": "531213",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sainik School",
            "Pincode": "531214",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gantyada",
            "Pincode": "531215",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhogapuram",
            "Pincode": "531216",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nelli Marla",
            "Pincode": "531217",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramathirtham",
            "Pincode": "531218",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Reddi Pall Agraharam",
            "Pincode": "531219",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kota Gandredu",
            "Pincode": "531220",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedamajjipalem",
            "Pincode": "531221",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Apsp Quarters",
            "Pincode": "531230",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alamanda R S",
            "Pincode": "531240",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhee Mali",
            "Pincode": "531241",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kantaka Palli",
            "Pincode": "531242",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jami",
            "Pincode": "531250",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bondapalle",
            "Pincode": "531260",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gajapati Nagaram",
            "Pincode": "531270",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mentada",
            "Pincode": "531273",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Moida",
            "Pincode": "531280",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vepada",
            "Pincode": "531281",
            "City": "Vishakhapatnam",
            "District": "Vishakhapatnam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gurla",
            "Pincode": "531303",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "China Bazar",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dr Court",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karpagam",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kosapet V L R",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Krishna Nagar",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Market",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "New Colony",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Official Colony",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Dt Board Building",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Old Town",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sainnathapuram",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sankaranpalayam",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srikakulam",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sullivanpet",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Town",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velapadi",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vellore",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vellore South",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Voorhees College",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Zilla Parishat",
            "Pincode": "532001",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gujratipeta",
            "Pincode": "532005",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ampole",
            "Pincode": "532015",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "S R Nagar I E Colony",
            "Pincode": "532101",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sreeram Nagar",
            "Pincode": "532101",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Garbham",
            "Pincode": "532102",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vunukuru",
            "Pincode": "532122",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Seetharam Puram",
            "Pincode": "532123",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uttarvalli",
            "Pincode": "532124",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Metta Palli",
            "Pincode": "532125",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Therlam",
            "Pincode": "532126",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajam",
            "Pincode": "532127",
            "City": "Rajam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chipuru Palli",
            "Pincode": "532128",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vadada",
            "Pincode": "532137",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Singadam",
            "Pincode": "532148",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ponduru",
            "Pincode": "532168",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amadala Valasa",
            "Pincode": "532185",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amadalavalasa Gate",
            "Pincode": "532185",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Korla Kota",
            "Pincode": "532189",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Purushotta Puram",
            "Pincode": "532190",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kota Bommali",
            "Pincode": "532195",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tekkali",
            "Pincode": "532201",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandigam",
            "Pincode": "532206",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nandigam",
            "Pincode": "532206",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Temburu",
            "Pincode": "532208",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapalli",
            "Pincode": "532209",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Naupada",
            "Pincode": "532211",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Naupada R S",
            "Pincode": "532212",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Naval Arammament",
            "Pincode": "532212",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Patha Patnam",
            "Pincode": "532213",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Korasawada",
            "Pincode": "532214",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mellaputti",
            "Pincode": "532215",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chapara",
            "Pincode": "532216",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pundi",
            "Pincode": "532217",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pundi R S",
            "Pincode": "532218",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Akkupalle",
            "Pincode": "532219",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Brahmantarla",
            "Pincode": "532220",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palasa",
            "Pincode": "532221",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kasi Bugga",
            "Pincode": "532222",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mandasa",
            "Pincode": "532242",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hari Puram",
            "Pincode": "532243",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sondi Pudi",
            "Pincode": "532244",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Baruva",
            "Pincode": "532263",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Baruva R S",
            "Pincode": "532264",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palavalasa",
            "Pincode": "532265",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondapi",
            "Pincode": "532270",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Courtpeta",
            "Pincode": "532284",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sompeta",
            "Pincode": "532284",
            "City": "Sompeta",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanchili",
            "Pincode": "532290",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mattam Sari Palli",
            "Pincode": "532291",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manikyapuram",
            "Pincode": "532292",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srikakulam",
            "Pincode": "532293",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bus Stand",
            "Pincode": "532312",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ichapuram",
            "Pincode": "532312",
            "City": "Ichapuram",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kaviti",
            "Pincode": "532322",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Purushottapur",
            "Pincode": "532323",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arasa Villi",
            "Pincode": "532401",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sher Mohammad Puram",
            "Pincode": "532402",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Murapaka",
            "Pincode": "532403",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Kurmam",
            "Pincode": "532404",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gara",
            "Pincode": "532405",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Calingapatnam",
            "Pincode": "532406",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cci",
            "Pincode": "532406",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jagannaickpur",
            "Pincode": "532407",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raja Puram",
            "Pincode": "532407",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bonthala Koduru",
            "Pincode": "532408",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pydi Bhimavaram",
            "Pincode": "532409",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buravilli",
            "Pincode": "532417",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narasannapeta",
            "Pincode": "532421",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narasannapeta Market",
            "Pincode": "532421",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Urlam",
            "Pincode": "532425",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sarvakota",
            "Pincode": "532426",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Budithi",
            "Pincode": "532427",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mukhalingam",
            "Pincode": "532428",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polaki",
            "Pincode": "532429",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Priya Agraharam",
            "Pincode": "532430",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jalum Uru",
            "Pincode": "532432",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palakonda",
            "Pincode": "532440",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Seethampeta",
            "Pincode": "532443",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Burja",
            "Pincode": "532445",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Battilli",
            "Pincode": "532456",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nivgam",
            "Pincode": "532457",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Laxminarasupeta",
            "Pincode": "532458",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hiramandalam",
            "Pincode": "532459",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veeraghattam",
            "Pincode": "532460",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Seetharampuram Inam",
            "Pincode": "532461",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Neelanagaram",
            "Pincode": "532462",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Garugu Billi",
            "Pincode": "532463",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rushingi",
            "Pincode": "532470",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tilaru R S",
            "Pincode": "532474",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dusi R S",
            "Pincode": "532484",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanugula Valasa",
            "Pincode": "532485",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kottabelagam",
            "Pincode": "532501",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parvathi Puram",
            "Pincode": "532501",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bus Stand Jagannadapuram",
            "Pincode": "532502",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Parvathipuram Town",
            "Pincode": "532502",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kommarada",
            "Pincode": "532521",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mrutyunjayanagaram",
            "Pincode": "532522",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gummalaxmipuram",
            "Pincode": "532523",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kurupam",
            "Pincode": "532524",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ravi Valasa",
            "Pincode": "532525",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Merangi",
            "Pincode": "532526",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Bonda Palli",
            "Pincode": "532527",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mondemkhallu",
            "Pincode": "532534",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Seethanagaram",
            "Pincode": "532546",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Makkuva",
            "Pincode": "532547",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Haridivalasa",
            "Pincode": "532550",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Burja",
            "Pincode": "532551",
            "City": "Srikakulam",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ajjada",
            "Pincode": "532552",
            "City": "Ajjada",
            "District": "Srikakulam",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Baliji Peta",
            "Pincode": "532557",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bobbili R S College Road",
            "Pincode": "532558",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bobbilli Govt Hospital Rd",
            "Pincode": "532558",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bobblli",
            "Pincode": "532558",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Piridi",
            "Pincode": "532568",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bobbili Bazar",
            "Pincode": "532573",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bobbili Church Road",
            "Pincode": "532573",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Donkina Valasa",
            "Pincode": "532578",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kottakki",
            "Pincode": "532579",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rama Bhadra Puram",
            "Pincode": "532579",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedamana Puram",
            "Pincode": "532580",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Challapeta",
            "Pincode": "532581",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Saluru",
            "Pincode": "532591",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Saluru Fort",
            "Pincode": "532591",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pachipenta",
            "Pincode": "532592",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mamidi Palli",
            "Pincode": "532593",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizianagaram",
            "Pincode": "532599",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizianagaram",
            "Pincode": "532612",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizianagaram",
            "Pincode": "532617",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vizianagaram",
            "Pincode": "532663",
            "City": "Vizianagaram",
            "District": "Vizianagaram",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kakinada",
            "Pincode": "533001",
            "City": "Kakinada",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kakinada Bazar",
            "Pincode": "533001",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kda Collectorate",
            "Pincode": "533001",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kda Kutturu",
            "Pincode": "533001",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kda Suryarao Peta",
            "Pincode": "533001",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Church Squrare",
            "Pincode": "533002",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "M S N Charities",
            "Pincode": "533002",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhaskar Nagar",
            "Pincode": "533003",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Engineering College",
            "Pincode": "533003",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mehar Nagar",
            "Pincode": "533003",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sriram Nagar",
            "Pincode": "533003",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "533004",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pratap Nagar",
            "Pincode": "533004",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramarao Peta",
            "Pincode": "533004",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Apsp Camp",
            "Pincode": "533005",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Indrapalem",
            "Pincode": "533006",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kakinada Port",
            "Pincode": "533007",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kakula",
            "Pincode": "533007",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Suryanarayanapuram",
            "Pincode": "533007",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gurzanapalli",
            "Pincode": "533014",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Turangi",
            "Pincode": "533016",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alcot Gardens",
            "Pincode": "533101",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Fort Gate",
            "Pincode": "533101",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gurukulam Road",
            "Pincode": "533101",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajahmundry",
            "Pincode": "533101",
            "City": "Rajahmundry",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rly Bazar",
            "Pincode": "533101",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rly Old Town",
            "Pincode": "533101",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Shyamalamba Temple",
            "Pincode": "533101",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Stadium Road",
            "Pincode": "533101",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Swarajyanagar",
            "Pincode": "533101",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ulli Thota",
            "Pincode": "533101",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Danavaipeta",
            "Pincode": "533103",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Puram",
            "Pincode": "533103",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prakashamnagar",
            "Pincode": "533103",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rtc Bus Complex Centre",
            "Pincode": "533103",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Syamala Nagar",
            "Pincode": "533103",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Trunk Road Junction",
            "Pincode": "533103",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aryapuram",
            "Pincode": "533104",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Seethampeta",
            "Pincode": "533104",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Govt College",
            "Pincode": "533105",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Ramnagar",
            "Pincode": "533105",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Strangadhara Metta",
            "Pincode": "533105",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Veerbhadra Puram",
            "Pincode": "533105",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Weavers Colony",
            "Pincode": "533105",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Spinning Mills Centre",
            "Pincode": "533106",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sponge Iron India Ltd",
            "Pincode": "533106",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ind Estate D W E G Dt",
            "Pincode": "533124",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dowliswaram",
            "Pincode": "533125",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kadium",
            "Pincode": "533126",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Muramanda",
            "Pincode": "533133",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amalapuram",
            "Pincode": "533201",
            "City": "Amalapuram",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Amalapuram Bus Complex",
            "Pincode": "533201",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Bazar",
            "Pincode": "533201",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "New Colony",
            "Pincode": "533201",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Moberlypeta",
            "Pincode": "533202",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "R D Office Roaod",
            "Pincode": "533202",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "College",
            "Pincode": "533203",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bendamur Lanka",
            "Pincode": "533210",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mudteswaram",
            "Pincode": "533211",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Katrenikona",
            "Pincode": "533212",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Samanasa",
            "Pincode": "533213",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ambajipeta",
            "Pincode": "533214",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bodasakurru",
            "Pincode": "533215",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mummidivaram",
            "Pincode": "533216",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Taluk Office Road",
            "Pincode": "533216",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Allavaram",
            "Pincode": "533217",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peruru",
            "Pincode": "533218",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Island Polvaram",
            "Pincode": "533219",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kesanakurru Palem",
            "Pincode": "533220",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bandar Lanka",
            "Pincode": "533221",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantavaram",
            "Pincode": "533222",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "533223",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Munganda",
            "Pincode": "533224",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Cheyyeru",
            "Pincode": "533225",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "N Kotha Palli",
            "Pincode": "533226",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uppalaguptam",
            "Pincode": "533227",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vanapalli",
            "Pincode": "533228",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Avidi",
            "Pincode": "533230",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chintaluru",
            "Pincode": "533232",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alamuru",
            "Pincode": "533233",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yeditha",
            "Pincode": "533234",
            "City": "Yeditha",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Atreyapuram",
            "Pincode": "533235",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ryali",
            "Pincode": "533236",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vubalanka",
            "Pincode": "533237",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ravula Palem",
            "Pincode": "533238",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pulleti Kurru",
            "Pincode": "533239",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Delta Gannavaram",
            "Pincode": "533240",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mukkamala",
            "Pincode": "533241",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bazole",
            "Pincode": "533242",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Razole Old Town",
            "Pincode": "533242",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nedunuru",
            "Pincode": "533243",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Siva Kodu",
            "Pincode": "533244",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nagaram",
            "Pincode": "533247",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ponnamanda",
            "Pincode": "533248",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tatipaka",
            "Pincode": "533249",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mori",
            "Pincode": "533250",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sakhineti Palli",
            "Pincode": "533251",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Antarvedipalem",
            "Pincode": "533252",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mallikipuram",
            "Pincode": "533253",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "R C Puram Bazar",
            "Pincode": "533255",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rama Chandra Puram",
            "Pincode": "533255",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Katkreni Padu",
            "Pincode": "533258",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velangi",
            "Pincode": "533260",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chelluru",
            "Pincode": "533261",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Draksha Ramam",
            "Pincode": "533262",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vellapalem",
            "Pincode": "533262",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dangeru",
            "Pincode": "533263",
            "City": "Dangeru",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kutukuluru",
            "Pincode": "533264",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pasala Pudi",
            "Pincode": "533271",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gopala Puram",
            "Pincode": "533274",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "North Gopala Puram",
            "Pincode": "533275",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vudumudi",
            "Pincode": "533277",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "G Kothapalli",
            "Pincode": "533285",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gokaram",
            "Pincode": "533286",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Seethanagaram",
            "Pincode": "533287",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rampa Choda Varam",
            "Pincode": "533288",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Korukonda",
            "Pincode": "533289",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Rangapatnam",
            "Pincode": "533289",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koti Kesavaram",
            "Pincode": "533290",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rangampeta",
            "Pincode": "533291",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dosakayala Palli",
            "Pincode": "533292",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Torredu",
            "Pincode": "533293",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rajanagaram",
            "Pincode": "533294",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maredumilli",
            "Pincode": "533295",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pammarru",
            "Pincode": "533305",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koti Palli",
            "Pincode": "533306",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Angara",
            "Pincode": "533307",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manda Peta",
            "Pincode": "533308",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mandapeta Bazar",
            "Pincode": "533308",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kapileswara Puram",
            "Pincode": "533309",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raghudevapuram",
            "Pincode": "533333",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Devipatnam",
            "Pincode": "533339",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tapeswaram",
            "Pincode": "533340",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dwara Pudi",
            "Pincode": "533341",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anaparthi",
            "Pincode": "533342",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anaparthi Old Town",
            "Pincode": "533342",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Biccavolu",
            "Pincode": "533343",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gollala Mamidada",
            "Pincode": "533344",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pandala Paka",
            "Pincode": "533345",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rayavaram",
            "Pincode": "533346",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Annavaram",
            "Pincode": "533406",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kota Nanduru",
            "Pincode": "533407",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thondangi",
            "Pincode": "533408",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Benda Pudi",
            "Pincode": "533409",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhimavarapu Kota",
            "Pincode": "533410",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Addatigala",
            "Pincode": "533428",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yelesraram",
            "Pincode": "533429",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharmavaram",
            "Pincode": "533430",
            "City": "Dharmavaram",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kirlampudi",
            "Pincode": "533431",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prathi Padu",
            "Pincode": "533432",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mallam",
            "Pincode": "533433",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vetla Palem",
            "Pincode": "533434",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jaggampeta",
            "Pincode": "533435",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raja Vommangi",
            "Pincode": "533436",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddapuram",
            "Pincode": "533437",
            "City": "Peddapuram",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peddapuram Town",
            "Pincode": "533437",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mallepalli",
            "Pincode": "533439",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pension Lines",
            "Pincode": "533440",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Samalkot",
            "Pincode": "533440",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Samalkot R S",
            "Pincode": "533440",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Satyanarayanapuram",
            "Pincode": "533440",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Golla Prolu",
            "Pincode": "533445",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sankhavaram",
            "Pincode": "533446",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapalli",
            "Pincode": "533447",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Uppada",
            "Pincode": "533448",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chebrole",
            "Pincode": "533449",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Govt Hospital",
            "Pincode": "533450",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapet",
            "Pincode": "533450",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pithapuram",
            "Pincode": "533450",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pithapuram Town",
            "Pincode": "533450",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Choringa",
            "Pincode": "533461",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Karapa",
            "Pincode": "533462",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Talla Revu",
            "Pincode": "533463",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yanam",
            "Pincode": "533464",
            "City": "Yanam",
            "District": "Yanam",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Yanam Bazar",
            "Pincode": "533464",
            "City": "Yanam",
            "District": "Yanam",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Golla Palem",
            "Pincode": "533468",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Challa Palli",
            "Pincode": "533503",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bheemana Palle",
            "Pincode": "533514",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lakkavaram",
            "Pincode": "533541",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manepalli",
            "Pincode": "533551",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vilasavilli",
            "Pincode": "533554",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Appannapalle",
            "Pincode": "533557",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Patnam",
            "Pincode": "533566",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vilasa",
            "Pincode": "533577",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Y Ramavaram",
            "Pincode": "533583",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Benarjipeta",
            "Pincode": "534001",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eastern Street",
            "Pincode": "534001",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eluru",
            "Pincode": "534001",
            "City": "Eluru",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eluru Bazar",
            "Pincode": "534001",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vengayagudem",
            "Pincode": "534001",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Western Street",
            "Pincode": "534001",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gandhi Nagaram",
            "Pincode": "534002",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pathebada",
            "Pincode": "534002",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramachanderraopeta",
            "Pincode": "534002",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramchanderraopeta",
            "Pincode": "534002",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkata Rao Peta Eluru",
            "Pincode": "534002",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sanivarapu Peta",
            "Pincode": "534003",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velupucherla",
            "Pincode": "534003",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chata Parru",
            "Pincode": "534004",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eluru R S",
            "Pincode": "534005",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tangellamudi",
            "Pincode": "534005",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eluru Bus Station",
            "Pincode": "534006",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eluru Collectorate",
            "Pincode": "534006",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eluru Industrial Estate",
            "Pincode": "534006",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eluru P&T Colony",
            "Pincode": "534006",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Eluru State Bank Colony",
            "Pincode": "534006",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narasimharao Peta",
            "Pincode": "534006",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "West Godavari",
            "Pincode": "534015",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prakasam Municipal Market",
            "Pincode": "534101",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Subbaraopeta",
            "Pincode": "534101",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "T P Gudem Town",
            "Pincode": "534101",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadepalligudem",
            "Pincode": "534101",
            "City": "Tadepalligudem",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramachandraraopeta",
            "Pincode": "534102",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Savitrupeta",
            "Pincode": "534102",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadepalligudem Bazar",
            "Pincode": "534102",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkata Ramanna Gudem",
            "Pincode": "534108",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Anantapalli",
            "Pincode": "534111",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nallajerla",
            "Pincode": "534112",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gunde Palli",
            "Pincode": "534116",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Maruteru",
            "Pincode": "534122",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Achanta",
            "Pincode": "534123",
            "City": "Achanta",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penumantra",
            "Pincode": "534124",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Alamuru",
            "Pincode": "534126",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mulaparru",
            "Pincode": "534127",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nelamuru",
            "Pincode": "534129",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Attili",
            "Pincode": "534134",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Attili Bazar",
            "Pincode": "534134",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vendodu",
            "Pincode": "534134",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pali",
            "Pincode": "534136",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manchili",
            "Pincode": "534137",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manchiriyal",
            "Pincode": "534137",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Madhavaram",
            "Pincode": "534145",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Prathi Padu",
            "Pincode": "534146",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Arugolanu",
            "Pincode": "534152",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nanda Muru",
            "Pincode": "534154",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Duwa",
            "Pincode": "534156",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondru Prole",
            "Pincode": "534160",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penta Padu",
            "Pincode": "534166",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Potha Varam",
            "Pincode": "534176",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yendagandi",
            "Pincode": "534186",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pedanindre Kolanu",
            "Pincode": "534195",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Agraharam",
            "Pincode": "534196",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ch Agraharam",
            "Pincode": "534196",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pippara",
            "Pincode": "534197",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ganapavaram",
            "Pincode": "534198",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Undi",
            "Pincode": "534199",
            "City": "East Godavari",
            "District": "East Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhimavaram",
            "Pincode": "534201",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dnr College",
            "Pincode": "534202",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sivaraopeta",
            "Pincode": "534202",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sri Ramapuram",
            "Pincode": "534202",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Suryanarayanapuram",
            "Pincode": "534202",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhimavaram Railway",
            "Pincode": "534203",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velaga Palli",
            "Pincode": "534206",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bondada",
            "Pincode": "534207",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rayalam",
            "Pincode": "534208",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mogallu",
            "Pincode": "534209",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Coop Colony",
            "Pincode": "534211",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Hanumantharaopet",
            "Pincode": "534211",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Paidiparru",
            "Pincode": "534211",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rtc Bus Complex",
            "Pincode": "534211",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Suryalayam St",
            "Pincode": "534211",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tanuku",
            "Pincode": "534211",
            "City": "Tanuku",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tanuku Bazar",
            "Pincode": "534211",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tanuku Old Town",
            "Pincode": "534211",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Venkatraya Puram",
            "Pincode": "534215",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vundrajavaram",
            "Pincode": "534216",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Iragavaram",
            "Pincode": "534217",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Manda Paka",
            "Pincode": "534218",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velpuru",
            "Pincode": "534222",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Relangi",
            "Pincode": "534225",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mortha",
            "Pincode": "534227",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Aravalli",
            "Pincode": "534230",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Akividu",
            "Pincode": "534235",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Akividu Bazar",
            "Pincode": "534235",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Yeluru Padu",
            "Pincode": "534236",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kalla",
            "Pincode": "534237",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Polamuru",
            "Pincode": "534238",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dirusu Marru",
            "Pincode": "534239",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Konitiwada",
            "Pincode": "534240",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Srunga Vruksham",
            "Pincode": "534243",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Viss Koderu",
            "Pincode": "534244",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Raya Kuduru",
            "Pincode": "534247",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lankala Koderu",
            "Pincode": "534250",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhageswaram",
            "Pincode": "534251",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gopuram Street",
            "Pincode": "534260",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kothapeta",
            "Pincode": "534260",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palakole",
            "Pincode": "534260",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Palakole Bazar",
            "Pincode": "534260",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lajpathi Roy Peta",
            "Pincode": "534261",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jinnuru",
            "Pincode": "534265",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Doddi Patla",
            "Pincode": "534266",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gummaluru",
            "Pincode": "534267",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ellamanchili",
            "Pincode": "534268",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kodamanchili",
            "Pincode": "534269",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rustumbada",
            "Pincode": "534271",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vemavaram",
            "Pincode": "534272",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "College Street",
            "Pincode": "534275",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ferry Road",
            "Pincode": "534275",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narsapur Bazar",
            "Pincode": "534275",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sivalayan Street",
            "Pincode": "534275",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sita Ram Puram",
            "Pincode": "534280",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Mogalthur",
            "Pincode": "534281",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "L B Cherla",
            "Pincode": "534291",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhimavaram Bazar",
            "Pincode": "534301",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bhimeswarlayam",
            "Pincode": "534301",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ndvl Old Town",
            "Pincode": "534301",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Nidadavole",
            "Pincode": "534301",
            "City": "Nidadavole",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "534301",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rest House Road",
            "Pincode": "534301",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Someswaralayam",
            "Pincode": "534301",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Wednesday Market",
            "Pincode": "534301",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Samsra Gudem",
            "Pincode": "534302",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "534303",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Tadimalla",
            "Pincode": "534305",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kannapuram",
            "Pincode": "534311",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Koyyala Gudem",
            "Pincode": "534312",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Devara Palli",
            "Pincode": "534313",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dippakayalapudu",
            "Pincode": "534314",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pola Varam",
            "Pincode": "534315",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gopala Puram",
            "Pincode": "534316",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penu Gonda",
            "Pincode": "534320",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Penugonda Bazar",
            "Pincode": "534320",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Sidhantam",
            "Pincode": "534326",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Poduru",
            "Pincode": "534327",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peravali",
            "Pincode": "534328",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kanuru",
            "Pincode": "534329",
            "City": "Kanuru",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Khanda Valli",
            "Pincode": "534330",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kakara Parru",
            "Pincode": "534331",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Ajjaram",
            "Pincode": "534339",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vegeswara Puram",
            "Pincode": "534340",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Talla Pudi",
            "Pincode": "534341",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chagallu",
            "Pincode": "534342",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gutala",
            "Pincode": "534343",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gowtami Nagar",
            "Pincode": "534350",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kovvur",
            "Pincode": "534350",
            "City": "Kovvur",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kovvur Old Town",
            "Pincode": "534350",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Rtc Bus Stand",
            "Pincode": "534350",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dommeru",
            "Pincode": "534351",
            "City": "Dommeru",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kumaradevam",
            "Pincode": "534352",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gollavani Tippa",
            "Pincode": "534362",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "D Muppavaram Dronamraju",
            "Pincode": "534390",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Purshothapalli",
            "Pincode": "534392",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pulla",
            "Pincode": "534401",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Narayana Puram",
            "Pincode": "534407",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Vungutur",
            "Pincode": "534411",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kaikaram",
            "Pincode": "534416",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dwaraka Tirumala",
            "Pincode": "534426",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gundugolanu",
            "Pincode": "534427",
            "City": "Gundugolanu",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "M Nagula Palli",
            "Pincode": "534429",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Naidugudem",
            "Pincode": "534437",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Peda Padu",
            "Pincode": "534437",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Janga Reddi Gudem",
            "Pincode": "534447",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jangareddi Gudem Bazar",
            "Pincode": "534447",
            "City": "Karimnagar",
            "District": "Karimnagar",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Buttayagudem",
            "Pincode": "534448",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kamavarapu Kota",
            "Pincode": "534449",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Gopanna Palem",
            "Pincode": "534450",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Lakkavaram",
            "Pincode": "534451",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Thadi Kala Pudi",
            "Pincode": "534452",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Jeelugu Milli",
            "Pincode": "534456",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Velagalapalli",
            "Pincode": "534459",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chintala Pudi",
            "Pincode": "534460",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Pragada Varam",
            "Pincode": "534461",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Dharmaji Gudem",
            "Pincode": "534462",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Kondrukota",
            "Pincode": "534483",
            "City": "Warangal",
            "District": "Warangal",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Chinnava Gudem",
            "Pincode": "534486",
            "City": "West Godavari",
            "District": "West Godavari",
            "State": "Andhra Pradesh"
        },
        {
            "PostOfficeName": "Bangalore Bazar",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bangalore G P O",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Brigade Road",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cubbon Road",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "High Court",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Legalators Home",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madhavanagar",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mahatma Gandhi Road",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mueseum Road",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narayanapillai Street",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Plain Street",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Quadrant Square",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajbhavan",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Seppings Road",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vidhana Soudha",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vidhana Veedhi",
            "Pincode": "560001",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Avenue Road",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bangalore",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bangalore City H.O",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bangalore Fort",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banglore Corporation Buildings",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basavaraja Market",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamarajendrapeta",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "H Siddiah Road",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalasipalyam",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Market",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagrtharpet",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narsimharaja Road",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "New Tharagpet",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajendra Road",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sri Jayachama",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sri Krishnarajendra",
            "Pincode": "560002",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aranya Bhavan",
            "Pincode": "560003",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Eng College",
            "Pincode": "560003",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Extension",
            "Pincode": "560003",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malleswaram",
            "Pincode": "560003",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malleswaram Circle",
            "Pincode": "560003",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pipe Line Extension",
            "Pincode": "560003",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Swimming Pool",
            "Pincode": "560003",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Venkatarangapura",
            "Pincode": "560003",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vyalikaval Extn",
            "Pincode": "560003",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basavanagudi H.O.",
            "Pincode": "560004",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basavanaguid East",
            "Pincode": "560004",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bull Temple Road",
            "Pincode": "560004",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lalbagh West",
            "Pincode": "560004",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mavalli",
            "Pincode": "560004",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pampamahakavi Road",
            "Pincode": "560004",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shankarapura",
            "Pincode": "560004",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "South Public Square",
            "Pincode": "560004",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sri Krisharajendra Road",
            "Pincode": "560004",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Visweswarapuram",
            "Pincode": "560004",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cox Town",
            "Pincode": "560005",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Fraser Town",
            "Pincode": "560005",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jeevanahalli",
            "Pincode": "560005",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pillanna Gardens",
            "Pincode": "560005",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Munireddy Palya",
            "Pincode": "560006",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mysore Lancers Lines",
            "Pincode": "560006",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Trg Command I A F",
            "Pincode": "560006",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "A F Hospital",
            "Pincode": "560007",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agaram",
            "Pincode": "560007",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Artillery Road",
            "Pincode": "560008",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Someshwarapura",
            "Pincode": "560008",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ulsoor",
            "Pincode": "560008",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ulsoor Bazar",
            "Pincode": "560008",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bangalore Dist Office Bui",
            "Pincode": "560009",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Krishi",
            "Pincode": "560009",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "560009",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kempegowda Road",
            "Pincode": "560009",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "N S Bureau",
            "Pincode": "560009",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Subashnagar",
            "Pincode": "560009",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Circle",
            "Pincode": "560010",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Industrial Suburb",
            "Pincode": "560010",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "North Zone",
            "Pincode": "560010",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajajinagar",
            "Pincode": "560010",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajajinagar Bhashyam",
            "Pincode": "560010",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajajinagar I Block",
            "Pincode": "560010",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajajinagar Iv Block",
            "Pincode": "560010",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajajinagar North",
            "Pincode": "560010",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajajinagar Vi Block",
            "Pincode": "560010",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajajinagar West",
            "Pincode": "560010",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byasandra",
            "Pincode": "560011",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayanagar",
            "Pincode": "560011",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madhavanpark",
            "Pincode": "560011",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Science Institute",
            "Pincode": "560012",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jalahalli",
            "Pincode": "560013",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jalahalli Villageso",
            "Pincode": "560013",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jalahalli East",
            "Pincode": "560014",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jalahalli West",
            "Pincode": "560015",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kamagondanahalli",
            "Pincode": "560015",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doorvaninagar",
            "Pincode": "560016",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dorrvaninagar East",
            "Pincode": "560016",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Krishnarajapura R S",
            "Pincode": "560016",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramamurthynagar",
            "Pincode": "560016",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bangalore Airport H A L",
            "Pincode": "560017",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vimanapura",
            "Pincode": "560017",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamarajpet Bazar",
            "Pincode": "560018",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamrapet West",
            "Pincode": "560018",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vittalnagar",
            "Pincode": "560018",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gavipurm Extn",
            "Pincode": "560019",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gavipurm Guttaballi",
            "Pincode": "560019",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narasimbaraja Colony",
            "Pincode": "560019",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumara Park West Extn",
            "Pincode": "560020",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Palace Guttahalli",
            "Pincode": "560020",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Seshadri Puram",
            "Pincode": "560020",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gayatri Nagar",
            "Pincode": "560021",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Okalipuram",
            "Pincode": "560021",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Prakash Nagar",
            "Pincode": "560021",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramachandra Puram",
            "Pincode": "560021",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srirampuram",
            "Pincode": "560021",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Goreguntapalya",
            "Pincode": "560022",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanteeravanagar",
            "Pincode": "560022",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yeshwantpur",
            "Pincode": "560022",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yeshwantpur Bazar",
            "Pincode": "560022",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kempapura Agrahara",
            "Pincode": "560023",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Magadi Road",
            "Pincode": "560023",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anand Nagar",
            "Pincode": "560024",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Extn Iistage",
            "Pincode": "560024",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebbal Agricultural Farm",
            "Pincode": "560024",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajmahalvilas",
            "Pincode": "560024",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "C M P Centre & School",
            "Pincode": "560025",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Langford Town",
            "Pincode": "560025",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Residency Road",
            "Pincode": "560025",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Richmond Town",
            "Pincode": "560025",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bapuji Nagar",
            "Pincode": "560026",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Deepanjal Nagar",
            "Pincode": "560026",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Goripalya",
            "Pincode": "560026",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Govt Electric Factory",
            "Pincode": "560026",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sampangiramnagar",
            "Pincode": "560027",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shanthinagar",
            "Pincode": "560027",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sudhamnagar",
            "Pincode": "560027",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Wilson Garden",
            "Pincode": "560027",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tyagarajanagar",
            "Pincode": "560028",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharmaram College",
            "Pincode": "560029",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "S D S Sanitorim",
            "Pincode": "560029",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adugodi",
            "Pincode": "560030",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosur Road",
            "Pincode": "560030",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hmt Bangalore",
            "Pincode": "560031",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hmt Watch Factory",
            "Pincode": "560031",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gangenahalli Extn",
            "Pincode": "560032",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kaval Byrasandra",
            "Pincode": "560032",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "P&T Colony",
            "Pincode": "560032",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ravindranath Tagore",
            "Pincode": "560032",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malkand Lines",
            "Pincode": "560033",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandalay Lines",
            "Pincode": "560033",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Marutisevanagar",
            "Pincode": "560033",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koramangala",
            "Pincode": "560034",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koramangala I Block",
            "Pincode": "560034",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koramangala V Block",
            "Pincode": "560034",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koramangala Vii Block",
            "Pincode": "560034",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "St Johns Medical College",
            "Pincode": "560034",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Carmelaram",
            "Pincode": "560035",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Krisnarajapuram",
            "Pincode": "560036",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Marathahalli Colony",
            "Pincode": "560037",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramesh Nagar",
            "Pincode": "560037",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Binnamangala Ii",
            "Pincode": "560038",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byappanahalli",
            "Pincode": "560038",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Commercial Complex",
            "Pincode": "560038",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hal Ii Stage",
            "Pincode": "560038",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Indira Nagar",
            "Pincode": "560038",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Indira Nagar",
            "Pincode": "560038",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nayandahalli",
            "Pincode": "560039",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "R P C Layout North",
            "Pincode": "560040",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vijayanagar",
            "Pincode": "560040",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vijayanagar East",
            "Pincode": "560040",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayanagar South",
            "Pincode": "560041",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayanagar T Block",
            "Pincode": "560041",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tilak Nagar",
            "Pincode": "560041",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "K Kamraj Road",
            "Pincode": "560042",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Meanee Lines",
            "Pincode": "560042",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sivanchetty Garden",
            "Pincode": "560042",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banaswadi",
            "Pincode": "560043",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalyana Nagar",
            "Pincode": "560043",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalyana Nagar",
            "Pincode": "560043",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bangalore",
            "Pincode": "560044",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arabic College",
            "Pincode": "560045",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devarjeevanalli",
            "Pincode": "560045",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Venkateshpura",
            "Pincode": "560045",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Benson Town",
            "Pincode": "560046",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chinnappa Gardens",
            "Pincode": "560046",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayamahal Extn",
            "Pincode": "560046",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Williams Towm",
            "Pincode": "560046",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Austin Town",
            "Pincode": "560047",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Neelasandra",
            "Pincode": "560047",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ookadapalyam",
            "Pincode": "560047",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Viveknagar",
            "Pincode": "560047",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mahadevapura",
            "Pincode": "560048",
            "City": "Mahadevapura",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Virgonagar",
            "Pincode": "560049",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "560050",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banashankari",
            "Pincode": "560050",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dasarahalli",
            "Pincode": "560050",
            "City": "Dasarahalli",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "State Bank Of Mysore",
            "Pincode": "560050",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arunachalam Mudaliar Street",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balappa A Street",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balappa A Street",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Broadway Road Cross",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Butachens Street",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Charminar Mosquee Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cockburn Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Colonel Hill Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Curva Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jain Temple Street",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lalmasjid Street",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Meenakshi Koil Street",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Milkmans Street",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "New Market Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Noronha Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Old Cemetry Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Old Poor House Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Park Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pension Mohalla Street",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivaji Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sultaji Gunta Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thimmaiah Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Venkatappa Road",
            "Pincode": "560051",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cunningham Road",
            "Pincode": "560052",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vasantanagar",
            "Pincode": "560052",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balepet",
            "Pincode": "560053",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belimutt Road",
            "Pincode": "560053",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chickpet",
            "Pincode": "560053",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cottonpet",
            "Pincode": "560053",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokula",
            "Pincode": "560054",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokula Extn",
            "Pincode": "560054",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mathikere",
            "Pincode": "560054",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malleswaram West",
            "Pincode": "560055",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Milk Colony",
            "Pincode": "560055",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vishwavidyalaya",
            "Pincode": "560056",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dasarahalli",
            "Pincode": "560057",
            "City": "Dasarahalli",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madivala",
            "Pincode": "560058",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Peenya",
            "Pincode": "560058",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Peenya Ii Stage",
            "Pincode": "560058",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Peenya Small Scale Indust",
            "Pincode": "560058",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "R V Niketan",
            "Pincode": "560059",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kengeri",
            "Pincode": "560060",
            "City": "Kengeri",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Subramanyapura",
            "Pincode": "560061",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doddakallasandra",
            "Pincode": "560062",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bsf Campus Yelahanka",
            "Pincode": "560063",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelahanka",
            "Pincode": "560063",
            "City": "Yelahanka",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelabanka",
            "Pincode": "560064",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelahanka Bazar",
            "Pincode": "560064",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelahanka Satellite Town",
            "Pincode": "560064",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vigyana Kendra",
            "Pincode": "560065",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "White Field",
            "Pincode": "560066",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadugodi",
            "Pincode": "560067",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bommanahalli",
            "Pincode": "560068",
            "City": "Bommanahalli",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayanagar East",
            "Pincode": "560069",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banashankari Llst",
            "Pincode": "560070",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Padmanabhanagar",
            "Pincode": "560070",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Domlur",
            "Pincode": "560071",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagarbhavi",
            "Pincode": "560072",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikkabiadarekal",
            "Pincode": "560073",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagasandra",
            "Pincode": "560073",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumbalagodu",
            "Pincode": "560074",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jeevanbheemanagar",
            "Pincode": "560075",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "New Thippasandra",
            "Pincode": "560075",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bannerghata Road",
            "Pincode": "560076",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kothanur",
            "Pincode": "560077",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayaprakash Naryan Nagar",
            "Pincode": "560078",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelachenahalli",
            "Pincode": "560078",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agrahara Dasarahalli",
            "Pincode": "560079",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saneguruvanahalli",
            "Pincode": "560079",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vijayanagar North",
            "Pincode": "560079",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Palace Orchards",
            "Pincode": "560080",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sadashivnagar",
            "Pincode": "560080",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tavarekere",
            "Pincode": "560081",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayanagar Vii Block",
            "Pincode": "560082",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayanagar West",
            "Pincode": "560082",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yediyur",
            "Pincode": "560082",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bannerghatta",
            "Pincode": "560083",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lingarajapuram",
            "Pincode": "560084",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "St Thomas Town",
            "Pincode": "560084",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banashankjari Iiist",
            "Pincode": "560085",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Avani Sringeri Mutt",
            "Pincode": "560086",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basaveshwar Nagar Ii Stage",
            "Pincode": "560086",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basaveshwar Nagar Iii Stag",
            "Pincode": "560086",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mahalakshmipuram Layout",
            "Pincode": "560086",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Varthur",
            "Pincode": "560087",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hessarghatta",
            "Pincode": "560088",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hessarghattalake",
            "Pincode": "560089",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikkabanavara",
            "Pincode": "560090",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bapagram",
            "Pincode": "560091",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Viswaneedam",
            "Pincode": "560091",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byatarayanapura",
            "Pincode": "560092",
            "City": "Byatarayanapura",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vidyaranyapura",
            "Pincode": "560097",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudur",
            "Pincode": "561101",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "V G Doddi",
            "Pincode": "561201",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pavagada",
            "Pincode": "561202",
            "City": "Pavagada",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pavagada Fort",
            "Pincode": "561202",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dodaballapur Bazar",
            "Pincode": "561203",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dodballapur",
            "Pincode": "561203",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kongadiappa Road",
            "Pincode": "561203",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doddabelavangala",
            "Pincode": "561204",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Melekote",
            "Pincode": "561205",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Darinayakanapalya",
            "Pincode": "561206",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagepalli",
            "Pincode": "561207",
            "City": "Bagepalli",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gauribidanur",
            "Pincode": "561208",
            "City": "Gauribidanur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gauribidanur Bazar",
            "Pincode": "561208",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hossur",
            "Pincode": "561210",
            "City": "Chitapur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manchenathalli",
            "Pincode": "561211",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pathapalya",
            "Pincode": "561212",
            "City": "Bagepalli",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thondebhavi",
            "Pincode": "561213",
            "City": "Gauribidanur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byadanur",
            "Pincode": "561214",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kotagudda",
            "Pincode": "561215",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Venkatapura",
            "Pincode": "561216",
            "City": "Venkatapura",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Viduraswatha",
            "Pincode": "561217",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulur Kolar",
            "Pincode": "561218",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalludi",
            "Pincode": "561219",
            "City": "Gauribidanur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tholapalli",
            "Pincode": "561221",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balareddipalli",
            "Pincode": "561222",
            "City": "Bagepalli",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Somanathapura",
            "Pincode": "561223",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alipura",
            "Pincode": "561224",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "S S Ghati",
            "Pincode": "561225",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tubagere",
            "Pincode": "561226",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sailapura",
            "Pincode": "561227",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikballapur",
            "Pincode": "562101",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikballapur",
            "Pincode": "562101",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandy Bazar",
            "Pincode": "562101",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Subrayanpet Chikballarpu",
            "Pincode": "562101",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Town Hall Square",
            "Pincode": "562101",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mellur",
            "Pincode": "562102",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nandi",
            "Pincode": "562103",
            "City": "Belgaum",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Peresandra",
            "Pincode": "562104",
            "City": "Chik Ballapur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sidlaghatta",
            "Pincode": "562105",
            "City": "Sidlaghatta",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sidlaghatta Bazar",
            "Pincode": "562105",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anekal",
            "Pincode": "562106",
            "City": "Anekal",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Attibele",
            "Pincode": "562107",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Abbur",
            "Pincode": "562108",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bevuar",
            "Pincode": "562108",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidadi",
            "Pincode": "562109",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devanahalli",
            "Pincode": "562110",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devanalli Fort",
            "Pincode": "562110",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dobespet",
            "Pincode": "562111",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harohalli Channapatna",
            "Pincode": "562112",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hoskote",
            "Pincode": "562114",
            "City": "Hoskote",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dibburahalli",
            "Pincode": "562115",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mallur",
            "Pincode": "562116",
            "City": "Dharwad",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanakapura",
            "Pincode": "562117",
            "City": "Kanakapura",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanakapura Bazar",
            "Pincode": "562117",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nandi Hills",
            "Pincode": "562118",
            "City": "Chik Ballapur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodihalli",
            "Pincode": "562119",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Magadi",
            "Pincode": "562120",
            "City": "Magadi",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maralavadi",
            "Pincode": "562121",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nandagudi",
            "Pincode": "562122",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nelamangala",
            "Pincode": "562123",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Akkur",
            "Pincode": "562124",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sarjapura",
            "Pincode": "562125",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sathanur",
            "Pincode": "562126",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Solur",
            "Pincode": "562127",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sugganahalli",
            "Pincode": "562128",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sulebele",
            "Pincode": "562129",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tavarekere",
            "Pincode": "562130",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thippasandra",
            "Pincode": "562131",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tyamagondlu",
            "Pincode": "562132",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vidyanagar",
            "Pincode": "562134",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vijayapura",
            "Pincode": "562135",
            "City": "Vijayapura",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Avathi",
            "Pincode": "562136",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cpt",
            "Pincode": "562137",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honganur Channapatna",
            "Pincode": "562138",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivagange",
            "Pincode": "562139",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodamballi",
            "Pincode": "562140",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jodidasalrahalli",
            "Pincode": "562141",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byramagala",
            "Pincode": "562142",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikkmuduvadi",
            "Pincode": "562143",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jangamkote",
            "Pincode": "562144",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chandpura",
            "Pincode": "562145",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dibburahalli",
            "Pincode": "562147",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dommasandra",
            "Pincode": "562148",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagal",
            "Pincode": "562149",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanva",
            "Pincode": "562150",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamarajasagar",
            "Pincode": "562151",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikkajala",
            "Pincode": "562152",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gudemaranahalli",
            "Pincode": "562153",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jadigenahalli",
            "Pincode": "562154",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bettahalsur",
            "Pincode": "562157",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bommasandra Industrial Estate",
            "Pincode": "562158",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolar",
            "Pincode": "563101",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolar Bazar",
            "Pincode": "563101",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolar Dodpet",
            "Pincode": "563101",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolar Extension",
            "Pincode": "563101",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolar Gandhinagar",
            "Pincode": "563101",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolar Gulpet",
            "Pincode": "563101",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolar Hospital Circle",
            "Pincode": "563101",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anersonpet",
            "Pincode": "563113",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bangarpet",
            "Pincode": "563114",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bangarpet Bazar",
            "Pincode": "563114",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "B E M L Nagar",
            "Pincode": "563115",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bemlnagar Colony",
            "Pincode": "563115",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bethamangala",
            "Pincode": "563116",
            "City": "Bangarapet",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Champion Reefs",
            "Pincode": "563117",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Coromandel",
            "Pincode": "563118",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Marikuppam",
            "Pincode": "563119",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "V O C Nagar",
            "Pincode": "563119",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Oorgaum",
            "Pincode": "563120",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Oorgaum East",
            "Pincode": "563120",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Oorgaumpet",
            "Pincode": "563121",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Robertsonapet Vi Cross",
            "Pincode": "563122",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Robertsonpet",
            "Pincode": "563122",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Batlahalli",
            "Pincode": "563123",
            "City": "Chintamani",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chelur",
            "Pincode": "563124",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chintamani",
            "Pincode": "563125",
            "City": "Chintamani",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chintamani Bazar",
            "Pincode": "563125",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chintamani Market",
            "Pincode": "563125",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dalasnur",
            "Pincode": "563126",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devarayasumudra",
            "Pincode": "563127",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kaiwara",
            "Pincode": "563128",
            "City": "Chintamani",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kamasamudram",
            "Pincode": "563129",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malur",
            "Pincode": "563130",
            "City": "Malur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malur Bazar",
            "Pincode": "563130",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mulbagal",
            "Pincode": "563131",
            "City": "Mulbagal",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mulbagal Bazar",
            "Pincode": "563131",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mulbagal Someshwara",
            "Pincode": "563131",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Palya",
            "Pincode": "563131",
            "City": "Alur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nangli",
            "Pincode": "563132",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Naraspura",
            "Pincode": "563133",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rayalpadu",
            "Pincode": "563134",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srinivasapura",
            "Pincode": "563135",
            "City": "Bagepalli",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srinivasapura Bazar",
            "Pincode": "563135",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tayalur",
            "Pincode": "563136",
            "City": "Mulbagal",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tekal",
            "Pincode": "563137",
            "City": "Malur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yeldur",
            "Pincode": "563138",
            "City": "Srinivaspur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Masthi",
            "Pincode": "563139",
            "City": "Malur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alangur",
            "Pincode": "563140",
            "City": "Mulbagal",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Avani",
            "Pincode": "563141",
            "City": "Mulbagal",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulkur",
            "Pincode": "563142",
            "City": "Malur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mindigal",
            "Pincode": "563143",
            "City": "Chintamani",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Someshwarapalya",
            "Pincode": "563144",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Amblical",
            "Pincode": "563145",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Murugamala",
            "Pincode": "563146",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Budikote",
            "Pincode": "563147",
            "City": "Bangarapet",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mallanaikanahalli",
            "Pincode": "563148",
            "City": "Dod Ballapur",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byrakur",
            "Pincode": "563149",
            "City": "Mulbagal",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kencharlahalli",
            "Pincode": "563150",
            "City": "Chintamani",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kyalanur",
            "Pincode": "563151",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurudamale",
            "Pincode": "563152",
            "City": "Mulbagal",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chilakalanerpu",
            "Pincode": "563153",
            "City": "Chintamani",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebbani",
            "Pincode": "563154",
            "City": "Malavalli",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yenugadale",
            "Pincode": "563156",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vemgal",
            "Pincode": "563157",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikkatirupathi",
            "Pincode": "563158",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Burudugunte",
            "Pincode": "563159",
            "City": "Chintamani",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pahwadi",
            "Pincode": "565277",
            "City": "Kolar",
            "District": "Kolar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devaraja Mohall",
            "Pincode": "570001",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Iringere",
            "Pincode": "570001",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "K R Circle",
            "Pincode": "570001",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "K R Mohalla",
            "Pincode": "570001",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kabir Road",
            "Pincode": "570001",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mysore",
            "Pincode": "570001",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mysore Jayalakshmi",
            "Pincode": "570001",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokula Extn",
            "Pincode": "570002",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sri Krishnarajendra Mills",
            "Pincode": "570002",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamaraja Puram",
            "Pincode": "570004",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamundi Extn",
            "Pincode": "570004",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Krishnamurthy Puram",
            "Pincode": "570004",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lakshmipuram",
            "Pincode": "570004",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mysore Fort",
            "Pincode": "570004",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nanjundal Circle",
            "Pincode": "570004",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramanuja Road",
            "Pincode": "570004",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vanivilas Market",
            "Pincode": "570004",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mysore Law Courts",
            "Pincode": "570005",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mysore University",
            "Pincode": "570005",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mysore Vani Vilas Mohalla",
            "Pincode": "570005",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manasagangotri",
            "Pincode": "570006",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "University Campus",
            "Pincode": "570006",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "N R Mohalla",
            "Pincode": "570007",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajendranagar",
            "Pincode": "570007",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Asokapuram",
            "Pincode": "570008",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Industrial Suburb I Stage",
            "Pincode": "570008",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mysore South",
            "Pincode": "570008",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vidyaranya Puram",
            "Pincode": "570008",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Visweswaranagar",
            "Pincode": "570008",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayanagar",
            "Pincode": "570009",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kantharaje Urs Road",
            "Pincode": "570009",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saraswathipuram",
            "Pincode": "570009",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Toachikoppal Extn",
            "Pincode": "570009",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tonachikoppal",
            "Pincode": "570009",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ittigegud",
            "Pincode": "570010",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nazarbad Mohalla",
            "Pincode": "570010",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "P T C Campus",
            "Pincode": "570010",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Administrative Trg Institute",
            "Pincode": "570011",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jyothinagar",
            "Pincode": "570011",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddarthanagar",
            "Pincode": "570011",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Puram Extension",
            "Pincode": "570012",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Food Technology",
            "Pincode": "570013",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayanagar Extn",
            "Pincode": "570014",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayanagar Extn",
            "Pincode": "570014",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "New Banimantap Extn",
            "Pincode": "570015",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Second Ediga Extn",
            "Pincode": "570015",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Metagalli",
            "Pincode": "570016",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Metgalli Extn",
            "Pincode": "570016",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hinkal",
            "Pincode": "570017",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chaimundi Betta",
            "Pincode": "570018",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamundi Betta",
            "Pincode": "570018",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Udayagiri Extn",
            "Pincode": "570019",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Brindavan Extn",
            "Pincode": "570020",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "570020",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramakrishna Vidya Shala",
            "Pincode": "570020",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yadavagiri",
            "Pincode": "570020",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandi Mohalla",
            "Pincode": "570021",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tilak Nagar",
            "Pincode": "570021",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "M.R.Mohalla",
            "Pincode": "570024",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bannur",
            "Pincode": "571101",
            "City": "Bannur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bettadapura",
            "Pincode": "571102",
            "City": "Arsikere",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bilikere",
            "Pincode": "571103",
            "City": "Channarayapatna",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byalakuppe",
            "Pincode": "571104",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hunsur",
            "Pincode": "571105",
            "City": "Hunsur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hunsur Bridge",
            "Pincode": "571105",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Periyapatna",
            "Pincode": "571107",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ravandur",
            "Pincode": "571108",
            "City": "Piriyapatna",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Begur",
            "Pincode": "571109",
            "City": "Bangalore North",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gargeshwari",
            "Pincode": "571110",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aldur",
            "Pincode": "571111",
            "City": "Chamarajanagar",
            "District": "Chamarajanagar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gundlupet",
            "Pincode": "571111",
            "City": "Gundlupet",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gundlupet Bazar",
            "Pincode": "571111",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "H D Kote",
            "Pincode": "571114",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Santemarahalli",
            "Pincode": "571115",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kagalyadi",
            "Pincode": "571117",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalale",
            "Pincode": "571118",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tagadur",
            "Pincode": "571119",
            "City": "Channarayapatna",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Old Sosale",
            "Pincode": "571120",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saragur",
            "Pincode": "571121",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Talkod",
            "Pincode": "571122",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tirukanambi",
            "Pincode": "571123",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "T Narsipur",
            "Pincode": "571124",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hamapapura",
            "Pincode": "571125",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hangala",
            "Pincode": "571126",
            "City": "Bangarapet",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hardanahalli",
            "Pincode": "571127",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harve",
            "Pincode": "571128",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelwal",
            "Pincode": "571130",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rangapura",
            "Pincode": "571131",
            "City": "Arkalgud",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bannikuppe",
            "Pincode": "571132",
            "City": "Chik Ballapur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chilakunda",
            "Pincode": "571133",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kattemalavadi",
            "Pincode": "571134",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Murkal",
            "Pincode": "571135",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kampla Pura",
            "Pincode": "571136",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Turaganur",
            "Pincode": "571137",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Makode",
            "Pincode": "571138",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kittoor",
            "Pincode": "571139",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhanagalli",
            "Pincode": "571140",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kotekere",
            "Pincode": "571141",
            "City": "Gundlupet",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thondavadi",
            "Pincode": "571142",
            "City": "Gundlupet",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Varakodu",
            "Pincode": "571143",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivapura",
            "Pincode": "571144",
            "City": "Arsikere",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Amachavadi",
            "Pincode": "571145",
            "City": "Chamarajanagar",
            "District": "Chamarajanagar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bisalavadi",
            "Pincode": "571146",
            "City": "Chamarajanagar",
            "District": "Chamarajanagar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Venkatainachatra",
            "Pincode": "571147",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebbalaguppe",
            "Pincode": "571148",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Naganahalli",
            "Pincode": "571149",
            "City": "Arkalgud",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thumbasoge",
            "Pincode": "571150",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alur",
            "Pincode": "571151",
            "City": "Aland",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebbasuru",
            "Pincode": "571152",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jothigowdanapura",
            "Pincode": "571153",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudlur",
            "Pincode": "571154",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagavalli",
            "Pincode": "571155",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honganur Nanjangud",
            "Pincode": "571156",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kottalavadi",
            "Pincode": "571157",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bilugali",
            "Pincode": "571158",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Suttur",
            "Pincode": "571159",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Binakanahalli",
            "Pincode": "571160",
            "City": "Tirumakudal Narsipur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doddahibhagllu",
            "Pincode": "571161",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Horalahalli",
            "Pincode": "571162",
            "City": "Tirumakudal Narsipur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hundi",
            "Pincode": "571163",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Somanathapura",
            "Pincode": "571164",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangala",
            "Pincode": "571165",
            "City": "Chamarajanagar",
            "District": "Chamarajanagar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kabini Colony",
            "Pincode": "571166",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kestur",
            "Pincode": "571166",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devanur",
            "Pincode": "571167",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosa Alagodu",
            "Pincode": "571168",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muguru",
            "Pincode": "571169",
            "City": "Sorab",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kempanapura",
            "Pincode": "571170",
            "City": "Chamarajanagar",
            "District": "Chamarajanagar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saragur",
            "Pincode": "571171",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramanahalli",
            "Pincode": "571172",
            "City": "Alur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodagalli",
            "Pincode": "571173",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ganaganur",
            "Pincode": "571174",
            "City": "Chamarajanagar",
            "District": "Chamarajanagar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kestur",
            "Pincode": "571175",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Seehalli",
            "Pincode": "571176",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bheemnabeedu",
            "Pincode": "571177",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chandakavadi",
            "Pincode": "571178",
            "City": "Chamarajanagar",
            "District": "Chamarajanagar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Heggur",
            "Pincode": "571180",
            "City": "Bilgi",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balanahalli",
            "Pincode": "571181",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Coimbatore Colony",
            "Pincode": "571182",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harohalli",
            "Pincode": "571183",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kaveripura",
            "Pincode": "571184",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byrapura",
            "Pincode": "571185",
            "City": "Alur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanagal",
            "Pincode": "571187",
            "City": "Hunsur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gurupupura",
            "Pincode": "571188",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ratnapuri Colony",
            "Pincode": "571189",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madikeri",
            "Pincode": "571201",
            "City": "Madikeri",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madikeri Fort",
            "Pincode": "571201",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ammathi",
            "Pincode": "571211",
            "City": "Virajpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cheyandane",
            "Pincode": "571212",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gonikoppal",
            "Pincode": "571213",
            "City": "Gonikoppal",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Napoklu",
            "Pincode": "571214",
            "City": "Madikeri",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pollibetta",
            "Pincode": "571215",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ponampet",
            "Pincode": "571216",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srimangala",
            "Pincode": "571217",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Virajpet",
            "Pincode": "571218",
            "City": "Virajpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balele",
            "Pincode": "571219",
            "City": "Virajpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devarapura",
            "Pincode": "571220",
            "City": "Alur",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Makut",
            "Pincode": "571221",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kaikeri",
            "Pincode": "571222",
            "City": "Virajpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harangi Project",
            "Pincode": "571223",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodipet",
            "Pincode": "571231",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudige",
            "Pincode": "571232",
            "City": "Somvarpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kushalnagar",
            "Pincode": "571234",
            "City": "Kushalnagar",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shanivarsarthe",
            "Pincode": "571235",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Somwarpet",
            "Pincode": "571236",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Suntikoppa",
            "Pincode": "571237",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Attur Nallur",
            "Pincode": "571238",
            "City": "Somvarpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hardur",
            "Pincode": "571239",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebbale",
            "Pincode": "571240",
            "City": "Arkalgud",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosur",
            "Pincode": "571241",
            "City": "Krishnarajpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanbile",
            "Pincode": "571242",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodagarahalli",
            "Pincode": "571243",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirangala",
            "Pincode": "571244",
            "City": "Somvarpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Guddehosur",
            "Pincode": "571245",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nanjaraja Patna",
            "Pincode": "571246",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagamandala",
            "Pincode": "571247",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chettalli",
            "Pincode": "571248",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hudikere",
            "Pincode": "571249",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kutta",
            "Pincode": "571250",
            "City": "Virajpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madapura",
            "Pincode": "571251",
            "City": "Arkalgud",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Murnad",
            "Pincode": "571252",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sidapur",
            "Pincode": "571253",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chendiye",
            "Pincode": "571254",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thirthimathi",
            "Pincode": "571254",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bettageri",
            "Pincode": "571255",
            "City": "Madikeri",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Boikere",
            "Pincode": "571256",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chermbane",
            "Pincode": "571257",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagarhole",
            "Pincode": "571258",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudumangalore",
            "Pincode": "571259",
            "City": "Somvarpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koynad",
            "Pincode": "571260",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maragodu",
            "Pincode": "571261",
            "City": "Madikeri",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Birunani",
            "Pincode": "571262",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balagunda",
            "Pincode": "571263",
            "City": "Somvarpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belagula R S",
            "Pincode": "571263",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karadigodu",
            "Pincode": "571264",
            "City": "Virajpet",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Benbalur",
            "Pincode": "571265",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Badaga",
            "Pincode": "571266",
            "City": "Heggadadevankote",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosur",
            "Pincode": "571267",
            "City": "Krishnarajpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nokya",
            "Pincode": "571268",
            "City": "Virajpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uluguli",
            "Pincode": "571269",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Andagove",
            "Pincode": "571270",
            "City": "Somvarpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mekur Hoskeri",
            "Pincode": "571271",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channarayapatna",
            "Pincode": "571272",
            "City": "Devanahalli",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channayanakote",
            "Pincode": "571272",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Badagabanangala",
            "Pincode": "571273",
            "City": "Virajpet",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nanjangud",
            "Pincode": "571301",
            "City": "Nanjangud",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sujatha Puram",
            "Pincode": "571301",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nanjangud Bazar",
            "Pincode": "571302",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadakola",
            "Pincode": "571311",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kavalande",
            "Pincode": "571312",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamaraj Nagar Extn",
            "Pincode": "571313",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamaraja Nagar",
            "Pincode": "571313",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramasamudra",
            "Pincode": "571313",
            "City": "Yadgir",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hullahalli",
            "Pincode": "571314",
            "City": "Alur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hura",
            "Pincode": "571315",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hutti",
            "Pincode": "571315",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuderu",
            "Pincode": "571316",
            "City": "Chamarajanagar",
            "District": "Chamarajanagar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hills",
            "Pincode": "571317",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bandipura",
            "Pincode": "571318",
            "City": "Gundlupet",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kabbahali",
            "Pincode": "571319",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cowdalli",
            "Pincode": "571320",
            "City": "Kollegal",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Udbur",
            "Pincode": "571321",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doora",
            "Pincode": "571322",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kempisiddanahundi",
            "Pincode": "571323",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sarvamanyahosakote",
            "Pincode": "571324",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tandavapura",
            "Pincode": "571325",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vidya Peetha",
            "Pincode": "571326",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Badanaguppe",
            "Pincode": "571327",
            "City": "Chamarajanagar",
            "District": "Chamarajanagar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Somwarpet",
            "Pincode": "571328",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Udigala",
            "Pincode": "571329",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rangasamudra",
            "Pincode": "571330",
            "City": "Pavagada",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hedathale",
            "Pincode": "571331",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nerale",
            "Pincode": "571332",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ummattur",
            "Pincode": "571333",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hadinaru",
            "Pincode": "571334",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yedakola",
            "Pincode": "571335",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Heggadahalli",
            "Pincode": "571336",
            "City": "Gundlupet",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hemmaragala",
            "Pincode": "571337",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramapura",
            "Pincode": "571339",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kotegeyedathore",
            "Pincode": "571340",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doddarayapete",
            "Pincode": "571341",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Agrahara",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Ashoknagar",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Azadnagar",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Bazar",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Bus Stand",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya District Office",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Gandhinagar",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya M C Road",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Old Town",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Shankara Nagara",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Subhash Nagara",
            "Pincode": "571401",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Sugar Town",
            "Pincode": "571402",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Guttalu",
            "Pincode": "571403",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandya Guttal Colony",
            "Pincode": "571403",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Acetate Town",
            "Pincode": "571404",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "V C Farm",
            "Pincode": "571405",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thaggahalli",
            "Pincode": "571406",
            "City": "Maddur",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arakere",
            "Pincode": "571415",
            "City": "Arsikere",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basaralu",
            "Pincode": "571416",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belakavadi",
            "Pincode": "571417",
            "City": "Malavalli",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellur",
            "Pincode": "571418",
            "City": "Alur",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Besgerahalli",
            "Pincode": "571419",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halagur",
            "Pincode": "571421",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalamuddana Doddi",
            "Pincode": "571422",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kikkeri",
            "Pincode": "571423",
            "City": "Krishnarajpet",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kirugavalu",
            "Pincode": "571424",
            "City": "Malavalli",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koppa",
            "Pincode": "571425",
            "City": "Koppa",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosahalu",
            "Pincode": "571426",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Krishnarajapete",
            "Pincode": "571426",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Krishnarajindrapete",
            "Pincode": "571426",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Old Town",
            "Pincode": "571426",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kyatarhalli",
            "Pincode": "571427",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maddur",
            "Pincode": "571428",
            "City": "Maddur",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maddur Extension",
            "Pincode": "571428",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maddur R S",
            "Pincode": "571429",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivapura Maddur",
            "Pincode": "571429",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malavalli",
            "Pincode": "571430",
            "City": "Malavalli",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malavalli Town",
            "Pincode": "571430",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Melkote",
            "Pincode": "571431",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagamangala",
            "Pincode": "571432",
            "City": "Nagamangala",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagamangala T B Exgn",
            "Pincode": "571432",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nidighatta",
            "Pincode": "571433",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Beerasettihalli",
            "Pincode": "571434",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pandavapura",
            "Pincode": "571434",
            "City": "Pandavapura",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pandavapura R S",
            "Pincode": "571435",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Santebachahalli",
            "Pincode": "571436",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivasamudram",
            "Pincode": "571437",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srirangapatna",
            "Pincode": "571438",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srirangapatna",
            "Pincode": "571438",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srirangpatna Fort",
            "Pincode": "571438",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanur",
            "Pincode": "571439",
            "City": "Kollegal",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kollegal",
            "Pincode": "571440",
            "City": "Kollegal",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kollegal Devangapet",
            "Pincode": "571440",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kollegal Mudikundam",
            "Pincode": "571440",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kollegal Southern Extn",
            "Pincode": "571440",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelandur",
            "Pincode": "571441",
            "City": "Yelandur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mamballi",
            "Pincode": "571442",
            "City": "Yelandur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kamakerai",
            "Pincode": "571443",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramapuram Ghat",
            "Pincode": "571444",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devalapura",
            "Pincode": "571445",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Keragodu",
            "Pincode": "571446",
            "City": "Arkalgud",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Keelara",
            "Pincode": "571450",
            "City": "Kunigal",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Budanuru",
            "Pincode": "571451",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodiyala",
            "Pincode": "571452",
            "City": "Gubbi",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalkuni",
            "Pincode": "571453",
            "City": "Malavalli",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Seelenre",
            "Pincode": "571454",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chinkurli",
            "Pincode": "571455",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagarakere",
            "Pincode": "571456",
            "City": "Maddur",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tibetian Settlement",
            "Pincode": "571457",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ragibommanhalli",
            "Pincode": "571458",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivaragudda Vidyapeetha",
            "Pincode": "571459",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thaggahalli",
            "Pincode": "571460",
            "City": "Maddur",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agasanpura",
            "Pincode": "571461",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhangur",
            "Pincode": "571462",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Purigale",
            "Pincode": "571463",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sathanur",
            "Pincode": "571464",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sindhaghatta",
            "Pincode": "571465",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chottanahalli",
            "Pincode": "571466",
            "City": "Heggadadevankote",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandagere",
            "Pincode": "571467",
            "City": "Krishnarajpet",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivalli",
            "Pincode": "571468",
            "City": "Dharwad",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulikere",
            "Pincode": "571469",
            "City": "Belur",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gopalapura",
            "Pincode": "571470",
            "City": "Bangalore North",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kottatti",
            "Pincode": "571471",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhal",
            "Pincode": "571472",
            "City": "Devadurga",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ummadahalli",
            "Pincode": "571473",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yeliyur",
            "Pincode": "571474",
            "City": "Channarayapatna",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bandalli",
            "Pincode": "571476",
            "City": "Kollegal",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sagglam",
            "Pincode": "571477",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doddainduvadi",
            "Pincode": "571478",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lokkanahalli",
            "Pincode": "571479",
            "City": "Kollegal",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siganellur",
            "Pincode": "571480",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kaliyur",
            "Pincode": "571481",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mullur",
            "Pincode": "571483",
            "City": "Heggadadevankote",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Beersettihalli",
            "Pincode": "571484",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Palaiyam",
            "Pincode": "571484",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pandavapura",
            "Pincode": "571484",
            "City": "Pandavapura",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agara",
            "Pincode": "571485",
            "City": "Bangalore South",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kinkanahalli",
            "Pincode": "571487",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kunagalli",
            "Pincode": "571488",
            "City": "Kollegal",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tellanur",
            "Pincode": "571488",
            "City": "Kollegal",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuntur",
            "Pincode": "571489",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mahadeshwara Betta",
            "Pincode": "571490",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Marthavi",
            "Pincode": "571491",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honnur",
            "Pincode": "571493",
            "City": "Davanagere",
            "District": "Davanagere",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kestur",
            "Pincode": "571494",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maddur",
            "Pincode": "571495",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yeriyur",
            "Pincode": "571496",
            "City": "Gundlupet",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yeragamballi",
            "Pincode": "571497",
            "City": "Yelandur",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sathegala",
            "Pincode": "571498",
            "City": "Kollegal",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddainapura",
            "Pincode": "571499",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channapatna",
            "Pincode": "571501",
            "City": "Channapatna",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channapatna Bazar",
            "Pincode": "571501",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channapatna Govt",
            "Pincode": "571501",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Silkfarm",
            "Pincode": "571502",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agrahara",
            "Pincode": "571511",
            "City": "Arkalgud",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ijur Ramanagaram",
            "Pincode": "571511",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramanagaram",
            "Pincode": "571511",
            "City": "Ramanagaram",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malur",
            "Pincode": "571512",
            "City": "Malur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hampapura",
            "Pincode": "571601",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basaveswara Block",
            "Pincode": "571602",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosur",
            "Pincode": "571602",
            "City": "Krishnarajpet",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Krishnarajnagar",
            "Pincode": "571602",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mirle",
            "Pincode": "571603",
            "City": "Krishnarajanagara",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saligram",
            "Pincode": "571604",
            "City": "Saligram",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Akkihebbal",
            "Pincode": "571605",
            "City": "Krishnarajpet",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Krishnarajasagara",
            "Pincode": "571607",
            "City": "Krishnarajasagara",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bheriya",
            "Pincode": "571608",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosagrahara",
            "Pincode": "571609",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gavadagere",
            "Pincode": "571610",
            "City": "Hunsur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hoskote",
            "Pincode": "571611",
            "City": "Hoskote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tippur",
            "Pincode": "571613",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haleyur",
            "Pincode": "571614",
            "City": "Piriyapatna",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byadarahalli",
            "Pincode": "571615",
            "City": "Arsikere",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebbalu",
            "Pincode": "571616",
            "City": "Hebbalu",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chunchanakatte",
            "Pincode": "571617",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madhuvanahalli",
            "Pincode": "571801",
            "City": "Kollegal",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bindiganavale",
            "Pincode": "571802",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Parasegowdana Palya",
            "Pincode": "571803",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kannur",
            "Pincode": "571804",
            "City": "Kannur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagoonahalli",
            "Pincode": "571805",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumararpura",
            "Pincode": "571806",
            "City": "Mandya",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kirangoor",
            "Pincode": "571807",
            "City": "Piriyapatna",
            "District": "Mandya",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hoogiam",
            "Pincode": "571808",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mahadevapura",
            "Pincode": "571809",
            "City": "Challakere",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chunchanahalli",
            "Pincode": "571811",
            "City": "Belur",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bukkinakere",
            "Pincode": "571812",
            "City": "Mysore",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Barline Tumkur",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Extension Tumkur",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Nagar Tumkur",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandipet Tumkur",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Poorhouse Colony",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Regulated Market",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "S I T Campus Tumkur",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddaganga Extn",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Someshwarapuram",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tumkur",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tumkur",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tumkur City",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vinchanagar Tumkur",
            "Pincode": "572101",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devaraya Patna",
            "Pincode": "572103",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuvemputhegar",
            "Pincode": "572103",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kyatasandra",
            "Pincode": "572104",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddaganga Mutt",
            "Pincode": "572104",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maralur",
            "Pincode": "572105",
            "City": "Gauribidanur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Northern Extension",
            "Pincode": "572106",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Amruthur",
            "Pincode": "572111",
            "City": "Kunigal",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Badavanahalli",
            "Pincode": "572112",
            "City": "Madhugiri",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Baragur",
            "Pincode": "572113",
            "City": "Arkalgud",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Biligere",
            "Pincode": "572114",
            "City": "Gubbi",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Biligiri Rangaswamy",
            "Pincode": "572114",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bukkapatna",
            "Pincode": "572115",
            "City": "Koratagere",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channakesavapuda",
            "Pincode": "572116",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chelur",
            "Pincode": "572117",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulur Tumkur",
            "Pincode": "572118",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Handanakere",
            "Pincode": "572119",
            "City": "Chiknayakanhalli",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebbur",
            "Pincode": "572120",
            "City": "Tarikere",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holavanahalli",
            "Pincode": "572121",
            "City": "Koratagere",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honnudike",
            "Pincode": "572122",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hullyurdurga",
            "Pincode": "572123",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Itakadibbanahalli",
            "Pincode": "572124",
            "City": "Madhugiri",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kallambella",
            "Pincode": "572125",
            "City": "Sira",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kempanahalli",
            "Pincode": "572126",
            "City": "Bangalore North",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodigenahalli",
            "Pincode": "572127",
            "City": "Kodigenahalli",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kora",
            "Pincode": "572128",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokula Extn",
            "Pincode": "572129",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koratagere",
            "Pincode": "572129",
            "City": "Koratagere",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "K R S Agrahara Extn",
            "Pincode": "572130",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kunigal",
            "Pincode": "572130",
            "City": "Kunigal",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madhugiri",
            "Pincode": "572132",
            "City": "Madhugiri",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "P W D Colony",
            "Pincode": "572132",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagasandra",
            "Pincode": "572134",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pattanaikanahalli",
            "Pincode": "572135",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Palavalli",
            "Pincode": "572136",
            "City": "Pavagada",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sira",
            "Pincode": "572137",
            "City": "Sira",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sira Bazar",
            "Pincode": "572137",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sira Santhepet",
            "Pincode": "572137",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tovinkere",
            "Pincode": "572138",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tavarekere",
            "Pincode": "572139",
            "City": "Bangalore South",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Urdigere",
            "Pincode": "572140",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Y N Koskote",
            "Pincode": "572141",
            "City": "Chikamangalur",
            "District": "Chikamangalur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yediyur",
            "Pincode": "572142",
            "City": "Kunigal",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiriyur",
            "Pincode": "572143",
            "City": "Hiriyur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiriyur Bazar",
            "Pincode": "572143",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Huliyar Road Hiriyur",
            "Pincode": "572143",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiriyur Sugar Factory",
            "Pincode": "572144",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagavalli",
            "Pincode": "572145",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devarayanadurga",
            "Pincode": "572146",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thumbadi",
            "Pincode": "572147",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kothuru",
            "Pincode": "572148",
            "City": "Mulbagal",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadagathur",
            "Pincode": "572149",
            "City": "Madhugiri",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halenahalli",
            "Pincode": "572150",
            "City": "Dod Ballapur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikkanahalli",
            "Pincode": "572151",
            "City": "Anekal",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madalur",
            "Pincode": "572152",
            "City": "Sira",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellavi",
            "Pincode": "572153",
            "City": "Malur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Teetha",
            "Pincode": "572154",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Markonahalli",
            "Pincode": "572155",
            "City": "Kunigal",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kondethimmanahalli",
            "Pincode": "572156",
            "City": "Pavagada",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kothegala",
            "Pincode": "572157",
            "City": "Heggadadevankote",
            "District": "Mysore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Biravalu",
            "Pincode": "572158",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Baddur Farm",
            "Pincode": "572159",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitradurga",
            "Pincode": "572160",
            "City": "Chitradurga",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelanadu",
            "Pincode": "572160",
            "City": "Hiriyur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vanivilasapura",
            "Pincode": "572161",
            "City": "Hiriyur",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yedavanne",
            "Pincode": "572162",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byalya",
            "Pincode": "572163",
            "City": "Madhugiri",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rampura",
            "Pincode": "572164",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidare",
            "Pincode": "572165",
            "City": "Channarayapatna",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kotta",
            "Pincode": "572166",
            "City": "Shikarpur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nidasale",
            "Pincode": "572167",
            "City": "Kunigal",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirehali",
            "Pincode": "572168",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nadur",
            "Pincode": "572169",
            "City": "Sira",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hemdore",
            "Pincode": "572170",
            "City": "Sira",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ujjine",
            "Pincode": "572171",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tirumani",
            "Pincode": "572172",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Iirkasandra",
            "Pincode": "572173",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kotegarihalli",
            "Pincode": "572174",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Puravara",
            "Pincode": "572175",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Nagar Tiptur",
            "Pincode": "572201",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tiptur",
            "Pincode": "572201",
            "City": "Tiptur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tiptur Bazar",
            "Pincode": "572201",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "K R Extn Tiptur",
            "Pincode": "572202",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ammasandra",
            "Pincode": "572211",
            "City": "Turuvekere",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banasandra",
            "Pincode": "572212",
            "City": "Turuvekere",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chandrasekharapura",
            "Pincode": "572213",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikkanayakanahalli",
            "Pincode": "572214",
            "City": "Bangalore South",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dandinashivara",
            "Pincode": "572215",
            "City": "Turuvekere",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gubbi",
            "Pincode": "572216",
            "City": "Gubbi",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gubbi Bazar",
            "Pincode": "572216",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honnavalli",
            "Pincode": "572217",
            "City": "Alur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Huliyar",
            "Pincode": "572218",
            "City": "Chiknayakanhalli",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kabada",
            "Pincode": "572219",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kallur",
            "Pincode": "572220",
            "City": "Jevargi",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mayasandra",
            "Pincode": "572221",
            "City": "Anekal",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muganayakanakote",
            "Pincode": "572222",
            "City": "Gubbi",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nittur",
            "Pincode": "572223",
            "City": "Aurad",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nonavinakere",
            "Pincode": "572224",
            "City": "Tiptur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sampige",
            "Pincode": "572225",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Settikere",
            "Pincode": "572226",
            "City": "Chiknayakanhalli",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Subramanyanagar",
            "Pincode": "572227",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Turuvekere",
            "Pincode": "572227",
            "City": "Turuvekere",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kandikere",
            "Pincode": "572228",
            "City": "Chiknayakanhalli",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hullekere",
            "Pincode": "572229",
            "City": "Arsikere",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aralguppe",
            "Pincode": "572230",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kenkere",
            "Pincode": "572231",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelanadu",
            "Pincode": "572232",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thimmanhalli",
            "Pincode": "572233",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Echanur",
            "Pincode": "572234",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gurugadahalli",
            "Pincode": "572235",
            "City": "Tiptur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hagalvadi",
            "Pincode": "572239",
            "City": "Tumkur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halepalya",
            "Pincode": "572240",
            "City": "Malur",
            "District": "Tumkur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arehalli",
            "Pincode": "573101",
            "City": "Anekal",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arkalgud",
            "Pincode": "573102",
            "City": "Arkalgud",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arsikere",
            "Pincode": "573103",
            "City": "Arsikere",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arsikere Bazar",
            "Pincode": "573103",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arsikere Court",
            "Pincode": "573103",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arsikere East",
            "Pincode": "573103",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagur",
            "Pincode": "573111",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banavara",
            "Pincode": "573112",
            "City": "Arsikere",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basavapatna",
            "Pincode": "573113",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belagur",
            "Pincode": "573114",
            "City": "Hosadurga",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belur Hassan",
            "Pincode": "573115",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channarayapatna",
            "Pincode": "573116",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doddametikurke",
            "Pincode": "573117",
            "City": "Arsikere",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dudda R S",
            "Pincode": "573118",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandasi",
            "Pincode": "573119",
            "City": "Arsikere",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gorur",
            "Pincode": "573120",
            "City": "Belur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halebeedu",
            "Pincode": "573121",
            "City": "Belur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haranahalli",
            "Pincode": "573122",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hethur",
            "Pincode": "573123",
            "City": "Sakleshpur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirisave",
            "Pincode": "573124",
            "City": "Channarayapatna",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Javagal",
            "Pincode": "573125",
            "City": "Arsikere",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayachmrajpura",
            "Pincode": "573126",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadamane",
            "Pincode": "573127",
            "City": "Bangalore",
            "District": "Bangalore",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kattaya",
            "Pincode": "573128",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "K Hoskote",
            "Pincode": "573129",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Konanur",
            "Pincode": "573130",
            "City": "Chitradurga",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nuggihalli",
            "Pincode": "573131",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Panchanahalli",
            "Pincode": "573132",
            "City": "Kadur",
            "District": "Chikamangalur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramnathapura",
            "Pincode": "573133",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saklashpur",
            "Pincode": "573134",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saraswati Puram",
            "Pincode": "573134",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shravanabelagola",
            "Pincode": "573135",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Keralapura",
            "Pincode": "573136",
            "City": "Arkalgud",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelsur",
            "Pincode": "573137",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cheekanahalli",
            "Pincode": "573138",
            "City": "Alur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rayarakoppal",
            "Pincode": "573139",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agrahara Belaguli",
            "Pincode": "573140",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Didaga",
            "Pincode": "573141",
            "City": "Channarayapatna",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dooda Magge",
            "Pincode": "573142",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gendahalli",
            "Pincode": "573143",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kamakatte",
            "Pincode": "573144",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanakatte",
            "Pincode": "573144",
            "City": "Arsikere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Heggadde",
            "Pincode": "573145",
            "City": "Belur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Magge",
            "Pincode": "573146",
            "City": "Alur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mallipatna",
            "Pincode": "573147",
            "City": "Arkalgud",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mulasavara",
            "Pincode": "573148",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Norway",
            "Pincode": "573149",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rundrapatna",
            "Pincode": "573150",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jambur",
            "Pincode": "573151",
            "City": "Channarayapatna",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajansiriyur",
            "Pincode": "573152",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jodihandinakere",
            "Pincode": "573153",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kattepura",
            "Pincode": "573154",
            "City": "Arkalgud",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sundekere",
            "Pincode": "573155",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thumbedevanahalli",
            "Pincode": "573156",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Udavara",
            "Pincode": "573157",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Udevara",
            "Pincode": "573157",
            "City": "Sakleshpur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kenkere",
            "Pincode": "573158",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kantharajapura",
            "Pincode": "573159",
            "City": "Channarayapatna",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aggunda",
            "Pincode": "573160",
            "City": "Arsikere",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sukravarsanthe",
            "Pincode": "573161",
            "City": "Koduru",
            "District": "Koduru",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bageshapura",
            "Pincode": "573162",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banavara R S",
            "Pincode": "573163",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagaderkoppalu",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Eastern Extn",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Bazar",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hassan",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hassan Dist Office",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosaline Road",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "K R Puram Extn",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pension Mohalla",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rakshanapura",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Santhepet",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shankaripuram",
            "Pincode": "573201",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halli Mysore",
            "Pincode": "573210",
            "City": "Hole Narsipur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holenarasipur",
            "Pincode": "573211",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holenarasipur R S",
            "Pincode": "573211",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mosalehosahalli",
            "Pincode": "573212",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alur",
            "Pincode": "573213",
            "City": "Aland",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ballupet",
            "Pincode": "573214",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bikkodu",
            "Pincode": "573215",
            "City": "Belur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hagare",
            "Pincode": "573216",
            "City": "Belur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kandali",
            "Pincode": "573217",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Palya",
            "Pincode": "573218",
            "City": "Alur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Salagame",
            "Pincode": "573219",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shanthigrama",
            "Pincode": "573220",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bage",
            "Pincode": "573221",
            "City": "Sakleshpur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belagodu",
            "Pincode": "573222",
            "City": "Hagaribommanahalli",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kowsika",
            "Pincode": "573223",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kesagodu",
            "Pincode": "573224",
            "City": "Belur",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ajekar",
            "Pincode": "574101",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bailur",
            "Pincode": "574102",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hejamadi",
            "Pincode": "574103",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karkala",
            "Pincode": "574104",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karkala Bazar",
            "Pincode": "574104",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karkala West",
            "Pincode": "574104",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Katapadi",
            "Pincode": "574105",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kaup",
            "Pincode": "574106",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mallur",
            "Pincode": "574106",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uliargoli",
            "Pincode": "574106",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Miyar",
            "Pincode": "574107",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muniyal",
            "Pincode": "574108",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Naravi",
            "Pincode": "574109",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nitte",
            "Pincode": "574110",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Padubidri",
            "Pincode": "574111",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Palimar",
            "Pincode": "574112",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pilar",
            "Pincode": "574113",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Senwi",
            "Pincode": "574114",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shankarapura",
            "Pincode": "574115",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ullargoli",
            "Pincode": "574115",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirva",
            "Pincode": "574116",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uchila",
            "Pincode": "574117",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uchila Bada",
            "Pincode": "574117",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Udyavara",
            "Pincode": "574118",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yermal",
            "Pincode": "574119",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Attur",
            "Pincode": "574120",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Durga",
            "Pincode": "574121",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kushtagi",
            "Pincode": "574121",
            "City": "Kushtagi",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kushtagi Kutchery",
            "Pincode": "574121",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bajegoli",
            "Pincode": "574122",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mala",
            "Pincode": "574123",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nellikar",
            "Pincode": "574124",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bola",
            "Pincode": "574125",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kallya",
            "Pincode": "574126",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Irvathur",
            "Pincode": "574128",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanthavara",
            "Pincode": "574129",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Renjala",
            "Pincode": "574130",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Admar",
            "Pincode": "574131",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yellur",
            "Pincode": "574132",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alevur",
            "Pincode": "574133",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuthpadi",
            "Pincode": "574134",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Akunjargiri",
            "Pincode": "574136",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Subashnagar",
            "Pincode": "574137",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nandikur",
            "Pincode": "574138",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Santur",
            "Pincode": "574139",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Paniyur",
            "Pincode": "574140",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aikala",
            "Pincode": "574141",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bajpe",
            "Pincode": "574142",
            "City": "Bajpe",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Farangipet",
            "Pincode": "574143",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ganjimutt",
            "Pincode": "574144",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gurupur",
            "Pincode": "574145",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haleangady",
            "Pincode": "574146",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jokatte",
            "Pincode": "574147",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kateel",
            "Pincode": "574148",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Katipalla",
            "Pincode": "574149",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kinnigoli",
            "Pincode": "574150",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kinnikambla",
            "Pincode": "574151",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kotekar",
            "Pincode": "574152",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurnad",
            "Pincode": "574153",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karnad",
            "Pincode": "574154",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mulki",
            "Pincode": "574154",
            "City": "Mulki",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mulki Bazar",
            "Pincode": "574154",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Someshwar Uchil",
            "Pincode": "574156",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srinivasanagar",
            "Pincode": "574157",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Suranthkal",
            "Pincode": "574158",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ullal",
            "Pincode": "574159",
            "City": "Ullal",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Derlakatte",
            "Pincode": "574160",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Konaje",
            "Pincode": "574161",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuppepadavu",
            "Pincode": "574162",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Neerude",
            "Pincode": "574163",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sibrikere",
            "Pincode": "574164",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malalipanchayat",
            "Pincode": "574165",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muduperar",
            "Pincode": "574166",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangalanthi",
            "Pincode": "574167",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Naringana",
            "Pincode": "574168",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pudu",
            "Pincode": "574169",
            "City": "Pudu",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thumbe",
            "Pincode": "574170",
            "City": "Thumbe",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Athikaribettu",
            "Pincode": "574171",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balkunje",
            "Pincode": "574172",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jokatte",
            "Pincode": "574173",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalavara",
            "Pincode": "574174",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pejavara",
            "Pincode": "574175",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kulai Hosabettu",
            "Pincode": "574176",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mukka",
            "Pincode": "574177",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nadugallu",
            "Pincode": "574178",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Punarur",
            "Pincode": "574179",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sasihithlu",
            "Pincode": "574180",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harekala",
            "Pincode": "574181",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pavur",
            "Pincode": "574182",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Peramannur",
            "Pincode": "574183",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Talapady",
            "Pincode": "574184",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Amblamogaru",
            "Pincode": "574185",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Boliyar",
            "Pincode": "574186",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mermajal",
            "Pincode": "574187",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Phajiru",
            "Pincode": "574188",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolambe",
            "Pincode": "574189",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuthethur",
            "Pincode": "574190",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bondanthila",
            "Pincode": "574191",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jeepinamogru",
            "Pincode": "574192",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kannur",
            "Pincode": "574193",
            "City": "Kannur",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kavur",
            "Pincode": "574194",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Panjinadka",
            "Pincode": "574195",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kulai",
            "Pincode": "574196",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodangallu",
            "Pincode": "574197",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kokkada",
            "Pincode": "574198",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Puttur",
            "Pincode": "574201",
            "City": "Puttur",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Puttur Bazaar",
            "Pincode": "574201",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Puttur Court Hill",
            "Pincode": "574201",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Darbe",
            "Pincode": "574202",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kemminje",
            "Pincode": "574202",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nehrunagar",
            "Pincode": "574203",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koynad",
            "Pincode": "574208",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aryapu",
            "Pincode": "574210",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bantwal",
            "Pincode": "574211",
            "City": "Bantwal",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellare",
            "Pincode": "574212",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belvai",
            "Pincode": "574213",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belthangady",
            "Pincode": "574214",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belthangady Bazar",
            "Pincode": "574214",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharmasthala",
            "Pincode": "574216",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gururayankere",
            "Pincode": "574217",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Guthigar",
            "Pincode": "574218",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jodumarga",
            "Pincode": "574219",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kabaka",
            "Pincode": "574220",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadaba",
            "Pincode": "574221",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalladaka",
            "Pincode": "574222",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kav",
            "Pincode": "574223",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madanthyar",
            "Pincode": "574224",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mijar",
            "Pincode": "574225",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mithabail",
            "Pincode": "574226",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Moodbidri",
            "Pincode": "574227",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mundaje",
            "Pincode": "574228",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mardla",
            "Pincode": "574230",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nettana",
            "Pincode": "574230",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pane Mangalore",
            "Pincode": "574231",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Panja",
            "Pincode": "574232",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sampaje",
            "Pincode": "574234",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sathya Saivihar",
            "Pincode": "574235",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirady",
            "Pincode": "574236",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddakatte",
            "Pincode": "574237",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Subramanya",
            "Pincode": "574238",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sullia",
            "Pincode": "574239",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sullia Gadhinagar",
            "Pincode": "574239",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "S D M College",
            "Pincode": "574240",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ujire",
            "Pincode": "574240",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uppinangady",
            "Pincode": "574241",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uppinbetgere",
            "Pincode": "574241",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Venur",
            "Pincode": "574242",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vittal",
            "Pincode": "574243",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Palli",
            "Pincode": "574244",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aiyarnad",
            "Pincode": "574245",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ajjavara",
            "Pincode": "574246",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aletty",
            "Pincode": "574247",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doddathota",
            "Pincode": "574248",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sonangeri",
            "Pincode": "574249",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ananthady",
            "Pincode": "574250",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Borimaru",
            "Pincode": "574251",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Idikiku",
            "Pincode": "574252",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Goonadka",
            "Pincode": "574254",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jalsur",
            "Pincode": "574255",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandekolu",
            "Pincode": "574256",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalmadka",
            "Pincode": "574257",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumbra",
            "Pincode": "574258",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Panjee",
            "Pincode": "574259",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adyandka",
            "Pincode": "574260",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vittalmudnur",
            "Pincode": "574261",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Amtady",
            "Pincode": "574262",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Navaru",
            "Pincode": "574263",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sarapady",
            "Pincode": "574264",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vogga",
            "Pincode": "574265",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aswathapura",
            "Pincode": "574266",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balthila",
            "Pincode": "574268",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodapadavu",
            "Pincode": "574269",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolnadu",
            "Pincode": "574270",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banangady",
            "Pincode": "574272",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kallabettu",
            "Pincode": "574273",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kallamundkur",
            "Pincode": "574274",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sampige",
            "Pincode": "574275",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Veerakamba",
            "Pincode": "574276",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadandale",
            "Pincode": "574277",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Palaoka",
            "Pincode": "574278",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanyana",
            "Pincode": "574279",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karopady",
            "Pincode": "574280",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narikombu",
            "Pincode": "574282",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saji Pamunnur",
            "Pincode": "574283",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Polalipanchayath",
            "Pincode": "574284",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alankar",
            "Pincode": "574285",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bajathur",
            "Pincode": "574286",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodimbady",
            "Pincode": "574287",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koilacattle Farm",
            "Pincode": "574288",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Paramogru",
            "Pincode": "574289",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Charmadi",
            "Pincode": "574290",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kakkinje",
            "Pincode": "574291",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nellyadi",
            "Pincode": "574292",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Neria",
            "Pincode": "574292",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gerukatte",
            "Pincode": "574293",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Laila",
            "Pincode": "574294",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Machina",
            "Pincode": "574295",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Panakaje",
            "Pincode": "574296",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kallige",
            "Pincode": "574297",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maninalkur",
            "Pincode": "574298",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ammunje",
            "Pincode": "574299",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ira",
            "Pincode": "574301",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadeshwalya",
            "Pincode": "574302",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belal",
            "Pincode": "574303",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Iianthila",
            "Pincode": "574304",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koyyur",
            "Pincode": "574305",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirebadady",
            "Pincode": "574306",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodimbala",
            "Pincode": "574307",
            "City": "Puttur",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kedila",
            "Pincode": "574309",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bettampady",
            "Pincode": "574310",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manikar",
            "Pincode": "574311",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narimogru",
            "Pincode": "574312",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nettanige Mudnur",
            "Pincode": "574313",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aranthodu",
            "Pincode": "574314",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nadugallu",
            "Pincode": "574315",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Somangiri",
            "Pincode": "574316",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gundyadka",
            "Pincode": "574317",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madavu",
            "Pincode": "574318",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sajipamudu",
            "Pincode": "574319",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Borkatte",
            "Pincode": "574320",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balnad",
            "Pincode": "574321",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manchi",
            "Pincode": "574323",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shibaje",
            "Pincode": "574333",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Badagannur",
            "Pincode": "574334",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kavalkutte",
            "Pincode": "574335",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bolila",
            "Pincode": "574336",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikamudnur",
            "Pincode": "574337",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manchi",
            "Pincode": "574371",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Idu",
            "Pincode": "574501",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nallur",
            "Pincode": "574502",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yerlapadi",
            "Pincode": "574503",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuthyar",
            "Pincode": "574504",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Korangrapdi",
            "Pincode": "574505",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bajal",
            "Pincode": "574507",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vamanjoor",
            "Pincode": "574508",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balmatta",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhavanthi Street",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bolar",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Car Street",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Falnir",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hampankatta",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hogie Bazar",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Leewell",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangalore",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangalore",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangalore Bunder",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangalore Milagres",
            "Pincode": "575001",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Fisheries College",
            "Pincode": "575002",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jeppoo",
            "Pincode": "575002",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kankanady",
            "Pincode": "575002",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mercara Hills",
            "Pincode": "575002",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagori",
            "Pincode": "575002",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bockapatna",
            "Pincode": "575003",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "District Courts",
            "Pincode": "575003",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "575003",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodialball",
            "Pincode": "575003",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lore",
            "Pincode": "575003",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijal",
            "Pincode": "575004",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadrihills",
            "Pincode": "575004",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bikkernakatta",
            "Pincode": "575005",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kulshekar",
            "Pincode": "575005",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "575006",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Padil",
            "Pincode": "575007",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Konchady",
            "Pincode": "575008",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adyar",
            "Pincode": "575009",
            "City": "Adyar",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Panambur",
            "Pincode": "575010",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Baikampady",
            "Pincode": "575011",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nirmarga",
            "Pincode": "575012",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kulur",
            "Pincode": "575013",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shaktinagar",
            "Pincode": "575016",
            "City": "Shaktinagar",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mani",
            "Pincode": "575253",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bannanje",
            "Pincode": "576101",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Car Street",
            "Pincode": "576101",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mission Compound",
            "Pincode": "576101",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Udupi",
            "Pincode": "576101",
            "City": "Udupi",
            "District": "Udupi",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Udupi Courts",
            "Pincode": "576101",
            "City": "Udupi",
            "District": "Udupi",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalsanka",
            "Pincode": "576102",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kunjibettu",
            "Pincode": "576102",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adi Udupi",
            "Pincode": "576103",
            "City": "Udupi",
            "District": "Udupi",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ambalpadi",
            "Pincode": "576103",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Amblapadi",
            "Pincode": "576103",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadekar",
            "Pincode": "576104",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodikar",
            "Pincode": "576104",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belmannu",
            "Pincode": "576111",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebri",
            "Pincode": "576112",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiradka",
            "Pincode": "576113",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kallianpur",
            "Pincode": "576114",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kemmannu",
            "Pincode": "576115",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Krodhashram",
            "Pincode": "576116",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kukkundur",
            "Pincode": "576117",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malpe",
            "Pincode": "576118",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manipal",
            "Pincode": "576119",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manipal East",
            "Pincode": "576119",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manipal Press Corner",
            "Pincode": "576119",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Moodubelle",
            "Pincode": "576120",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mundukur",
            "Pincode": "576121",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pangala",
            "Pincode": "576122",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Parkala",
            "Pincode": "576123",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Perdur",
            "Pincode": "576124",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nandalike",
            "Pincode": "576126",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sooda",
            "Pincode": "576127",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sacherigudde",
            "Pincode": "576128",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Someshwara",
            "Pincode": "576129",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arekandige",
            "Pincode": "576130",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Havanje",
            "Pincode": "576131",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kujalli",
            "Pincode": "576132",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kukkehalli",
            "Pincode": "576132",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Athradi",
            "Pincode": "576133",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Herga",
            "Pincode": "576134",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalasapura",
            "Pincode": "576135",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalathur South",
            "Pincode": "576135",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Patla",
            "Pincode": "576135",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Badaga Bettu",
            "Pincode": "576136",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hoode",
            "Pincode": "576137",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Innanje",
            "Pincode": "576138",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mattu",
            "Pincode": "576139",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Permankila",
            "Pincode": "576141",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tenkabettu",
            "Pincode": "576142",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thottam",
            "Pincode": "576143",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Varanga",
            "Pincode": "576144",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudradi",
            "Pincode": "576145",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Inna",
            "Pincode": "576146",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kidiyur",
            "Pincode": "576148",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chara",
            "Pincode": "576150",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirebettu",
            "Pincode": "576153",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Maidan",
            "Pincode": "576201",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuandapura Market",
            "Pincode": "576201",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kundapur",
            "Pincode": "576201",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Barkur",
            "Pincode": "576210",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basrur",
            "Pincode": "576211",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belve",
            "Pincode": "576212",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Branhmavar",
            "Pincode": "576213",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byndoor",
            "Pincode": "576214",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yedthara",
            "Pincode": "576214",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yedthari",
            "Pincode": "576214",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cherkadi",
            "Pincode": "576215",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ganguli",
            "Pincode": "576216",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ganguli Bunder",
            "Pincode": "576216",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanglur",
            "Pincode": "576217",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hungarcutta",
            "Pincode": "576218",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Khambadakone",
            "Pincode": "576219",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kollur",
            "Pincode": "576220",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kota",
            "Pincode": "576221",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koteshwar",
            "Pincode": "576222",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandarthi",
            "Pincode": "576223",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Navunda",
            "Pincode": "576224",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saligrama",
            "Pincode": "576225",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sastan",
            "Pincode": "576226",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shankaranarayana",
            "Pincode": "576227",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shankaranayana",
            "Pincode": "576227",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirur",
            "Pincode": "576228",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddapura",
            "Pincode": "576229",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tallur",
            "Pincode": "576230",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tallur",
            "Pincode": "576230",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Takkatte",
            "Pincode": "576231",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tekkatte",
            "Pincode": "576231",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uppunda",
            "Pincode": "576232",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vandse",
            "Pincode": "576233",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kokkarne",
            "Pincode": "576234",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Trasi",
            "Pincode": "576235",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Airody",
            "Pincode": "576236",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gundmi",
            "Pincode": "576237",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ampar",
            "Pincode": "576238",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulvadi",
            "Pincode": "576239",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kandlur",
            "Pincode": "576240",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karkunje",
            "Pincode": "576241",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bannadi",
            "Pincode": "576242",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bannikodu",
            "Pincode": "576242",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Parampalli",
            "Pincode": "576243",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijur",
            "Pincode": "576244",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ardi",
            "Pincode": "576245",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiliyana",
            "Pincode": "576246",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gujjadi",
            "Pincode": "576247",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hakladi",
            "Pincode": "576248",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hemmadi",
            "Pincode": "576249",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haladi",
            "Pincode": "576250",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Krodabailur",
            "Pincode": "576251",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hallihole",
            "Pincode": "576252",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kirimanjeshwar",
            "Pincode": "576253",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodi",
            "Pincode": "576255",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koni",
            "Pincode": "576255",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodibengre",
            "Pincode": "576256",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumbhasi",
            "Pincode": "576257",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumbra",
            "Pincode": "576257",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kunjal",
            "Pincode": "576258",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Neelavara",
            "Pincode": "576259",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Salikere",
            "Pincode": "576260",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Marvanthe",
            "Pincode": "576261",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nada",
            "Pincode": "576262",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Naikur",
            "Pincode": "576263",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Santhekatte",
            "Pincode": "576264",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manwi",
            "Pincode": "576265",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saibrakatte",
            "Pincode": "576266",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kotathattu",
            "Pincode": "576267",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aroor",
            "Pincode": "576269",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haradi",
            "Pincode": "576270",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Baidabettu",
            "Pincode": "576271",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Beejady",
            "Pincode": "576272",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kavradi",
            "Pincode": "576273",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Molahalli",
            "Pincode": "576274",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Paduvari",
            "Pincode": "576275",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Achlady",
            "Pincode": "576276",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kangal",
            "Pincode": "576277",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanehalli",
            "Pincode": "576278",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hardalli Mandall",
            "Pincode": "576279",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalthod",
            "Pincode": "576280",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karkod",
            "Pincode": "576281",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosangadi",
            "Pincode": "576282",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamrajpet",
            "Pincode": "577001",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Davanagere",
            "Pincode": "577001",
            "City": "Davanagere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Davanagere",
            "Pincode": "577001",
            "City": "Davanagere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Davanere",
            "Pincode": "577001",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Davangere",
            "Pincode": "577001",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Durgamba Temple",
            "Pincode": "577001",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Krishnarajendra Road",
            "Pincode": "577001",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Davangere City",
            "Pincode": "577002",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Davangere Jayadeva Circle",
            "Pincode": "577002",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Davangere K B Extn",
            "Pincode": "577002",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayachamarajendra Extn",
            "Pincode": "577002",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "K T J Nagar",
            "Pincode": "577002",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Davangere Mills",
            "Pincode": "577003",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Regulated Market",
            "Pincode": "577003",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yard Davangere",
            "Pincode": "577003",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chigateri Hospital",
            "Pincode": "577004",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Davanere",
            "Pincode": "577004",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Davangere Southern Extn",
            "Pincode": "577004",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kasturba Extn",
            "Pincode": "577004",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Modi Circle",
            "Pincode": "577004",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bapuji Vidyanagar",
            "Pincode": "577005",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikamaglur Bazar",
            "Pincode": "577101",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikamaglur Fort",
            "Pincode": "577101",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikmagalur Dist Office",
            "Pincode": "577101",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikmagalure",
            "Pincode": "577101",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikmgalur",
            "Pincode": "577101",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jyothinagar",
            "Pincode": "577102",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balehonnur",
            "Pincode": "577112",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banakal",
            "Pincode": "577113",
            "City": "Mudigere",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chilakundi",
            "Pincode": "577113",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basarikatte",
            "Pincode": "577114",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "B R Project",
            "Pincode": "577115",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhadra Reservior Project",
            "Pincode": "577115",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Birur",
            "Pincode": "577116",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Birur Town",
            "Pincode": "577116",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "C R Station",
            "Pincode": "577117",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Durgadabetta",
            "Pincode": "577118",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanbalu",
            "Pincode": "577119",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hariharapura",
            "Pincode": "577120",
            "City": "Arsikere",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirebile",
            "Pincode": "577121",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Javali",
            "Pincode": "577122",
            "City": "Mudigere",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayapura",
            "Pincode": "577123",
            "City": "Koppa",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalasa",
            "Pincode": "577124",
            "City": "Mudigere",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kammradi",
            "Pincode": "577125",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balagady",
            "Pincode": "577126",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koppa",
            "Pincode": "577126",
            "City": "Koppa",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudregundi",
            "Pincode": "577127",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudremukh",
            "Pincode": "577127",
            "City": "Kudremukh",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lakkavalli",
            "Pincode": "577128",
            "City": "Sagar",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mallandur",
            "Pincode": "577130",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mallenahalli",
            "Pincode": "577131",
            "City": "Alur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudigere",
            "Pincode": "577132",
            "City": "Mudigere",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mugtihalli",
            "Pincode": "577133",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agrahara Narasimha Rajpur",
            "Pincode": "577134",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narasimharajapura",
            "Pincode": "577134",
            "City": "Narasimharajapura",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sakrepatna",
            "Pincode": "577135",
            "City": "Kadur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sangameshwarpet",
            "Pincode": "577136",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Santaveri",
            "Pincode": "577137",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Singatagere",
            "Pincode": "577138",
            "City": "Arsikere",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sringeri",
            "Pincode": "577139",
            "City": "Sringeri",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yadgati",
            "Pincode": "577140",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kemmannugundi",
            "Pincode": "577141",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rangenahalli",
            "Pincode": "577144",
            "City": "Alur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bukkambudhi",
            "Pincode": "577145",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devaladakere",
            "Pincode": "577147",
            "City": "Sakleshpur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alageswara",
            "Pincode": "577148",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Avathi",
            "Pincode": "577149",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhandigodi",
            "Pincode": "577150",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gonibeed",
            "Pincode": "577151",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Guddethota",
            "Pincode": "577152",
            "City": "Koppa",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosakoppa",
            "Pincode": "577153",
            "City": "Honnali",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jannapura",
            "Pincode": "577154",
            "City": "Alur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "K Bidre",
            "Pincode": "577155",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kaimara",
            "Pincode": "577156",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudlur",
            "Pincode": "577157",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuduvalli",
            "Pincode": "577158",
            "City": "Tirthahalli",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lokanathapura",
            "Pincode": "577159",
            "City": "Koppa",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Magundi",
            "Pincode": "577160",
            "City": "Narasimharajapura",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Melpal",
            "Pincode": "577161",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shanthigrama",
            "Pincode": "577162",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Togarihankal",
            "Pincode": "577163",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "K B Halu",
            "Pincode": "577164",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurubarabudihalu",
            "Pincode": "577164",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basoor",
            "Pincode": "577165",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pilenahalli",
            "Pincode": "577167",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uddeboranahalli",
            "Pincode": "577168",
            "City": "Chikmagalur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sampige Khan",
            "Pincode": "577169",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anur",
            "Pincode": "577170",
            "City": "Afzalpur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kottigehara",
            "Pincode": "577171",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bisalare",
            "Pincode": "577172",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanthur",
            "Pincode": "577173",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vastara",
            "Pincode": "577174",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devanur",
            "Pincode": "577175",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Addagadde",
            "Pincode": "577177",
            "City": "Sringeri",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gullanpet",
            "Pincode": "577178",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balehole",
            "Pincode": "577179",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Choulihiriyur",
            "Pincode": "577180",
            "City": "Chikamaglur",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ambedkar Nagar",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Market Yard Apmc",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ravindranagar",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga Bus Stand",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga District",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga Market",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga Office",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga Railway",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vinobanagar Shimoga",
            "Pincode": "577201",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajendrapete",
            "Pincode": "577202",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga Doddapet",
            "Pincode": "577202",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga Kote",
            "Pincode": "577202",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga Krishna",
            "Pincode": "577202",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shimoga Vidyanagar",
            "Pincode": "577202",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ayanur",
            "Pincode": "577211",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belagutti",
            "Pincode": "577212",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channageri",
            "Pincode": "577213",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channageri Town",
            "Pincode": "577213",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hithla",
            "Pincode": "577214",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hodikere",
            "Pincode": "577215",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holalur",
            "Pincode": "577216",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honnali",
            "Pincode": "577217",
            "City": "Honnali",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kerebilichi",
            "Pincode": "577218",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kundur",
            "Pincode": "577219",
            "City": "Alur",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandagadde",
            "Pincode": "577220",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nallur",
            "Pincode": "577221",
            "City": "Bangarapet",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nidige",
            "Pincode": "577222",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nyamati",
            "Pincode": "577223",
            "City": "Honnali",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sasvehalli",
            "Pincode": "577224",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saulanga",
            "Pincode": "577225",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tudur",
            "Pincode": "577226",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holehonnur",
            "Pincode": "577227",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tarikere",
            "Pincode": "577228",
            "City": "Tarikere",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kavalgundi",
            "Pincode": "577229",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chilur",
            "Pincode": "577230",
            "City": "Honnali",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanivebilichi",
            "Pincode": "577231",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bejjavalli",
            "Pincode": "577232",
            "City": "Tirthahalli",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuddigere",
            "Pincode": "577233",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devarahalli",
            "Pincode": "577234",
            "City": "Arkalgud",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mathur",
            "Pincode": "577235",
            "City": "Hosadurga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Issur",
            "Pincode": "577236",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudli",
            "Pincode": "577237",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumblur",
            "Pincode": "577238",
            "City": "Honnali",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kulambi",
            "Pincode": "577239",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malur",
            "Pincode": "577240",
            "City": "Malur",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pillangere",
            "Pincode": "577241",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sugur",
            "Pincode": "577242",
            "City": "Hiriyur",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anaveri",
            "Pincode": "577243",
            "City": "Bhadravati",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harige",
            "Pincode": "577244",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Barandur",
            "Pincode": "577245",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yedur",
            "Pincode": "577246",
            "City": "Somvarpet",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bandigudde",
            "Pincode": "577247",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhadravathi",
            "Pincode": "577301",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhadravathi",
            "Pincode": "577301",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhadravathi New Town",
            "Pincode": "577301",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jannapura",
            "Pincode": "577301",
            "City": "Alur",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhadravathi",
            "Pincode": "577303",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhadravathi New Model College",
            "Pincode": "577303",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhadravathi R S",
            "Pincode": "577303",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hutha Colony",
            "Pincode": "577303",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Old Town",
            "Pincode": "577303",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arbilichi",
            "Pincode": "577321",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Nagar Sagar",
            "Pincode": "577401",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sagar",
            "Pincode": "577401",
            "City": "Shahpur",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sagar Bazar",
            "Pincode": "577401",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sagar Market Road",
            "Pincode": "577401",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agumbe",
            "Pincode": "577411",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anandapuram",
            "Pincode": "577412",
            "City": "Sagar",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anavatti",
            "Pincode": "577413",
            "City": "Sorab",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arga",
            "Pincode": "577414",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devangi",
            "Pincode": "577415",
            "City": "Tirthahalli",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Havnahalli",
            "Pincode": "577416",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honnesara",
            "Pincode": "577417",
            "City": "Sagar",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosa Nagar",
            "Pincode": "577418",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jade",
            "Pincode": "577419",
            "City": "Sorab",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kargal Colony",
            "Pincode": "577421",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Konandur",
            "Pincode": "577422",
            "City": "Tirthahalli",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumsi",
            "Pincode": "577423",
            "City": "Gulbarga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Megaravalli",
            "Pincode": "577424",
            "City": "Tirthahalli",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagar",
            "Pincode": "577425",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ripponpete",
            "Pincode": "577426",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shikaripur",
            "Pincode": "577427",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shikaripur Bazar",
            "Pincode": "577427",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shiralkoppa",
            "Pincode": "577428",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sorab",
            "Pincode": "577429",
            "City": "Sorab",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sorabtown",
            "Pincode": "577429",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thirthahalli Town",
            "Pincode": "577432",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thirthalli",
            "Pincode": "577432",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Togarsi",
            "Pincode": "577433",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ulabi",
            "Pincode": "577434",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jog Falls",
            "Pincode": "577435",
            "City": "Jog Falls",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "S V P Colony",
            "Pincode": "577435",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Humcha",
            "Pincode": "577436",
            "City": "Hosanagara",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chakra Nagar",
            "Pincode": "577437",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arasalu",
            "Pincode": "577438",
            "City": "Hosanagara",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Avinahlli",
            "Pincode": "577439",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basavani",
            "Pincode": "577440",
            "City": "Tirthahalli",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirejambur",
            "Pincode": "577441",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirekodige",
            "Pincode": "577442",
            "City": "Koppa",
            "District": "Chikamaglur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Keladi",
            "Pincode": "577443",
            "City": "Sagar",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lingadahalli",
            "Pincode": "577444",
            "City": "Arkalgud",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Linganamakki",
            "Pincode": "577444",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodur",
            "Pincode": "577445",
            "City": "Hosanagara",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuppadagdde",
            "Pincode": "577446",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Udagani",
            "Pincode": "577447",
            "City": "Mangalore",
            "District": "Dak. Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mastikatte",
            "Pincode": "577448",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Moody",
            "Pincode": "577449",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belagaavi",
            "Pincode": "577450",
            "City": "Shimoga",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitradurga",
            "Pincode": "577501",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitradurga",
            "Pincode": "577501",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitradurga Chickpet",
            "Pincode": "577501",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitradurga Collage Road",
            "Pincode": "577501",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitradurga District Offi",
            "Pincode": "577501",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitradurga Fort",
            "Pincode": "577501",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitrdurga Horapet",
            "Pincode": "577501",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jayachanrajendra Extn",
            "Pincode": "577501",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Venkateshpur Extn",
            "Pincode": "577501",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitradurga Stn Road",
            "Pincode": "577502",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Regulated Market Yard",
            "Pincode": "577502",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holalkere Road",
            "Pincode": "577503",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adivala",
            "Pincode": "577511",
            "City": "Hiriyur",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anaji",
            "Pincode": "577512",
            "City": "Davanagere",
            "District": "Davanagere",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Asagodu",
            "Pincode": "577513",
            "City": "Jagalur",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bada",
            "Pincode": "577514",
            "City": "Davanagere",
            "District": "Davanagere",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagur",
            "Pincode": "577515",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhanuvalli",
            "Pincode": "577516",
            "City": "Harihar",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Turuvanur",
            "Pincode": "577517",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bharamanayakana Durga",
            "Pincode": "577518",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bharama Sagar",
            "Pincode": "577519",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bheemasamudra",
            "Pincode": "577520",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidarekere",
            "Pincode": "577521",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Challakere",
            "Pincode": "577522",
            "City": "Challakere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Challakere Bazar",
            "Pincode": "577522",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Challakere Regulated",
            "Pincode": "577522",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Market",
            "Pincode": "577522",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikjapur",
            "Pincode": "577523",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doddasiddavanahalli",
            "Pincode": "577524",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hadadi",
            "Pincode": "577525",
            "City": "Davanagere",
            "District": "Davanagere",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holalkere",
            "Pincode": "577526",
            "City": "Holalkere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holalkere Old Town",
            "Pincode": "577526",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosadurga",
            "Pincode": "577527",
            "City": "Pavagada",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosadurga Fort",
            "Pincode": "577527",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jagalur",
            "Pincode": "577528",
            "City": "Jagalur",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jagalur Nehru Road",
            "Pincode": "577528",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kondiahalli",
            "Pincode": "577529",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malebennur",
            "Pincode": "577530",
            "City": "Harihar",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malladihalli",
            "Pincode": "577531",
            "City": "Holalkere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maradihalli",
            "Pincode": "577532",
            "City": "Channarayapatna",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mavadihalli",
            "Pincode": "577532",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mathodu",
            "Pincode": "577533",
            "City": "Hosadurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mayakonda",
            "Pincode": "577534",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mokalmuru",
            "Pincode": "577535",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nayakanahatti",
            "Pincode": "577536",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Obala Pura",
            "Pincode": "577537",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Parqasurampura",
            "Pincode": "577538",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramagiri",
            "Pincode": "577539",
            "City": "Holalkere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramapura",
            "Pincode": "577540",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirigere",
            "Pincode": "577541",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srirampura",
            "Pincode": "577542",
            "City": "Turuvekere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tallak",
            "Pincode": "577543",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thyavanige",
            "Pincode": "577544",
            "City": "Channagiri",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yeraballi",
            "Pincode": "577545",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hariabbe",
            "Pincode": "577546",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ajjampura",
            "Pincode": "577547",
            "City": "Tarikere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ajjampura Bazar",
            "Pincode": "577547",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadur",
            "Pincode": "577548",
            "City": "Kadur",
            "District": "Chikamangalur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadur R S",
            "Pincode": "577548",
            "City": "Chikamangalur",
            "District": "Chikamangalur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadur Town",
            "Pincode": "577548",
            "City": "Chikamangalur",
            "District": "Chikamangalur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sivane",
            "Pincode": "577549",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sollapura",
            "Pincode": "577550",
            "City": "Chikamangalur",
            "District": "Chikamangalur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basavapatna",
            "Pincode": "577551",
            "City": "Arkalgud",
            "District": "Shimoga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Santabennur",
            "Pincode": "577552",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bilichodu",
            "Pincode": "577553",
            "City": "Jagalur",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosadurga R S",
            "Pincode": "577554",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bodabanhal",
            "Pincode": "577555",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Godabanahal",
            "Pincode": "577555",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Horakere Devarapura",
            "Pincode": "577557",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aimangala",
            "Pincode": "577558",
            "City": "Hiriyur",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yeilambalase",
            "Pincode": "577560",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Giriapura",
            "Pincode": "577561",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirenallur",
            "Pincode": "577562",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikkanallur",
            "Pincode": "577563",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kariganur",
            "Pincode": "577564",
            "City": "Channagiri",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nalkudre",
            "Pincode": "577565",
            "City": "Channagiri",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anagodu",
            "Pincode": "577566",
            "City": "Davanagere",
            "District": "Davanagere",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhadra Sugar Factory",
            "Pincode": "577566",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Laxmisagara",
            "Pincode": "577567",
            "City": "Channagiri",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belghatta",
            "Pincode": "577568",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ranajogihalli",
            "Pincode": "577569",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Meersabidhalli",
            "Pincode": "577570",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "N Mahadevapura",
            "Pincode": "577571",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagasamudra",
            "Pincode": "577572",
            "City": "Arsikere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alur",
            "Pincode": "577573",
            "City": "Alur",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Attigere",
            "Pincode": "577574",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vasana",
            "Pincode": "577575",
            "City": "Harihar",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gopanahalu",
            "Pincode": "577576",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jigali",
            "Pincode": "577577",
            "City": "Harihar",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kukkuvada",
            "Pincode": "577579",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malalkere",
            "Pincode": "577580",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muttugudur",
            "Pincode": "577581",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narayanagondanahalli",
            "Pincode": "577582",
            "City": "Holalkere",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebballi",
            "Pincode": "577583",
            "City": "Badami",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maskal",
            "Pincode": "577584",
            "City": "Aurad",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Abbinahole",
            "Pincode": "577585",
            "City": "Hiriyur",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harthikote",
            "Pincode": "577586",
            "City": "Hiriyur",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gannaikanahalli",
            "Pincode": "577587",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belludi",
            "Pincode": "577588",
            "City": "Harihar",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kondajji",
            "Pincode": "577589",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nanditavare",
            "Pincode": "577590",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanagawadi",
            "Pincode": "577591",
            "City": "Harihar",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirgeri",
            "Pincode": "577592",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadrinayakanahalli",
            "Pincode": "577593",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bommagonakere",
            "Pincode": "577595",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arasankatte",
            "Pincode": "577596",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harihar",
            "Pincode": "577601",
            "City": "Harihar",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harihar Apmc Yard",
            "Pincode": "577601",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajarama Colony",
            "Pincode": "577601",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yantrapura",
            "Pincode": "577602",
            "City": "Chitradurga",
            "District": "Chitradurga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad",
            "Pincode": "580001",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad",
            "Pincode": "580001",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad City",
            "Pincode": "580001",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad Kutchery",
            "Pincode": "580001",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad Line Bazar",
            "Pincode": "580001",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad Market",
            "Pincode": "580001",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad Spatapur",
            "Pincode": "580001",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosayellapur",
            "Pincode": "580001",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saraswathpur",
            "Pincode": "580001",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tejaswinagar",
            "Pincode": "580001",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad K V V",
            "Pincode": "580003",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad Vidyagiri",
            "Pincode": "580004",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad",
            "Pincode": "580005",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad Agricultural College",
            "Pincode": "580005",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mrutyanjayanagar",
            "Pincode": "580006",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad",
            "Pincode": "580007",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad Rly Station",
            "Pincode": "580007",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalyannagar",
            "Pincode": "580007",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basaveshwara Nagar",
            "Pincode": "580008",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharwad K C Park",
            "Pincode": "580008",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "G T C",
            "Pincode": "580008",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mahatma",
            "Pincode": "580008",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mrutyunjayamarket",
            "Pincode": "580008",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narayanpur",
            "Pincode": "580008",
            "City": "Aurad",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Navalur",
            "Pincode": "580009",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sattur",
            "Pincode": "580010",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ganeshpet",
            "Pincode": "580020",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli",
            "Pincode": "580020",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli City",
            "Pincode": "580020",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangalwarpeth",
            "Pincode": "580020",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shroff Katta",
            "Pincode": "580020",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tabibland",
            "Pincode": "580020",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vinobanagar",
            "Pincode": "580020",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Vidya Nagar",
            "Pincode": "580021",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Medical College",
            "Pincode": "580022",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Bengeri",
            "Pincode": "580023",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Keshavapur",
            "Pincode": "580023",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Bharat Mills",
            "Pincode": "580024",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Krishapur",
            "Pincode": "580024",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Old Hubli",
            "Pincode": "580024",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Amargol",
            "Pincode": "580025",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Nava Nagar",
            "Pincode": "580025",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Bankapur Chowk",
            "Pincode": "580028",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Mahaveeragalli",
            "Pincode": "580028",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Moorusabir Mutt",
            "Pincode": "580028",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Karnataka",
            "Pincode": "580029",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Motor Stand",
            "Pincode": "580029",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli New Cotton Market",
            "Pincode": "580029",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Traffic Island",
            "Pincode": "580029",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Udyam Nagar",
            "Pincode": "580030",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Engg College",
            "Pincode": "580031",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Unkal",
            "Pincode": "580031",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Ashok Nagar",
            "Pincode": "580032",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hubli Vijay Nagar",
            "Pincode": "580032",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kelgeri",
            "Pincode": "580110",
            "City": "Dharwad",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Morab",
            "Pincode": "580112",
            "City": "Khanapur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narendra",
            "Pincode": "580113",
            "City": "Dharwad",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhumwad",
            "Pincode": "580114",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangundi",
            "Pincode": "580115",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mugad",
            "Pincode": "580116",
            "City": "Dharwad",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebli",
            "Pincode": "580117",
            "City": "Aland",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulkoppa",
            "Pincode": "580118",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hallihal",
            "Pincode": "580211",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adargunchi",
            "Pincode": "580212",
            "City": "Hubli",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mantur",
            "Pincode": "580213",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nulvi",
            "Pincode": "580214",
            "City": "Hubli",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yarguppi",
            "Pincode": "580215",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sulla",
            "Pincode": "580216",
            "City": "Badami",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adur",
            "Pincode": "581101",
            "City": "Anekal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Akki Alur",
            "Pincode": "581102",
            "City": "Hangal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Akki Alur Bazar",
            "Pincode": "581102",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alnavar",
            "Pincode": "581103",
            "City": "Alnavar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hangal",
            "Pincode": "581104",
            "City": "Hangal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Garag",
            "Pincode": "581105",
            "City": "Dharwad",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byadgi",
            "Pincode": "581106",
            "City": "Byadgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byadgi Nehrunagar",
            "Pincode": "581106",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gudgeri",
            "Pincode": "581107",
            "City": "Kundgol",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Guttal",
            "Pincode": "581108",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haunsbhavi",
            "Pincode": "581108",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haveri",
            "Pincode": "581110",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haveri Bazar",
            "Pincode": "581110",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haveri Bus Stand",
            "Pincode": "581110",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haveri Rajendranagar",
            "Pincode": "581110",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hazrath Kambal",
            "Pincode": "581110",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Posh Road",
            "Pincode": "581110",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirekerur",
            "Pincode": "581111",
            "City": "Hirekerur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karajgi",
            "Pincode": "581112",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kundargi",
            "Pincode": "581113",
            "City": "Bilgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kundghat",
            "Pincode": "581113",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ranebennur",
            "Pincode": "581115",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ranebennur Bazar",
            "Pincode": "581115",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ranebennur Extension",
            "Pincode": "581115",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rattihalli",
            "Pincode": "581116",
            "City": "Hirekerur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saunshi",
            "Pincode": "581117",
            "City": "Kundgol",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Savanur",
            "Pincode": "581118",
            "City": "Savanur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tumminkatti",
            "Pincode": "581119",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tilvalli",
            "Pincode": "581120",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Supa",
            "Pincode": "581122",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumarapatnam",
            "Pincode": "581123",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Byahatti",
            "Pincode": "581124",
            "City": "Hubli",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikkerur",
            "Pincode": "581125",
            "City": "Hirekerur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulgur",
            "Pincode": "581126",
            "City": "Shiggaon",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgalbeth",
            "Pincode": "581127",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgalpeth",
            "Pincode": "581127",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agadi",
            "Pincode": "581128",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jagabet",
            "Pincode": "581129",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kod",
            "Pincode": "581130",
            "City": "Hirekerur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devargudda",
            "Pincode": "581131",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devagiri",
            "Pincode": "581132",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Havanur",
            "Pincode": "581133",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kabbur",
            "Pincode": "581134",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanumanmatti",
            "Pincode": "581135",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Motebennur",
            "Pincode": "581136",
            "City": "Byadgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelgach",
            "Pincode": "581137",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sheshangeri",
            "Pincode": "581138",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kelgeri",
            "Pincode": "581139",
            "City": "Dharwad",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kusugal",
            "Pincode": "581140",
            "City": "Hubli",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honnatti",
            "Pincode": "581141",
            "City": "Ranibennur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Itagi Rbn",
            "Pincode": "581142",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karur",
            "Pincode": "581143",
            "City": "Indi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuppelur",
            "Pincode": "581144",
            "City": "Ranibennur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chalgeri",
            "Pincode": "581145",
            "City": "Mundgod",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadur",
            "Pincode": "581146",
            "City": "Kadur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudupalli",
            "Pincode": "581147",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sangur",
            "Pincode": "581148",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kusnur",
            "Pincode": "581149",
            "City": "Hangal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Araleshwar",
            "Pincode": "581150",
            "City": "Hangal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aladkatti",
            "Pincode": "581151",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devi Hosur",
            "Pincode": "581152",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kaginelli",
            "Pincode": "581153",
            "City": "Byadgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurubgonda",
            "Pincode": "581154",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Negalur",
            "Pincode": "581155",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadarmandalgi",
            "Pincode": "581156",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saidenur",
            "Pincode": "581157",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirguppi",
            "Pincode": "581158",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hattimattur",
            "Pincode": "581159",
            "City": "Savanur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yalivigi",
            "Pincode": "581160",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalas",
            "Pincode": "581161",
            "City": "Badami",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yerebudihal",
            "Pincode": "581162",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maknur",
            "Pincode": "581163",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karadgi",
            "Pincode": "581164",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Naregal",
            "Pincode": "581165",
            "City": "Naregal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kargudri",
            "Pincode": "581166",
            "City": "Hangal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kopparshikoppa",
            "Pincode": "581167",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hidigona",
            "Pincode": "581168",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chinmulgund",
            "Pincode": "581169",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mallur",
            "Pincode": "581170",
            "City": "Dharwad",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Attigere",
            "Pincode": "581171",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanavalli",
            "Pincode": "581172",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Katenhalli",
            "Pincode": "581173",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadkol",
            "Pincode": "581174",
            "City": "Jevargi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tadkod",
            "Pincode": "581175",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gondi",
            "Pincode": "581176",
            "City": "Hangal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Asundi",
            "Pincode": "581177",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kakol",
            "Pincode": "581178",
            "City": "Ranibennur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kajjari",
            "Pincode": "581179",
            "City": "Ranibennur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kamdolli",
            "Pincode": "581180",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hurlikupi",
            "Pincode": "581181",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kallihal",
            "Pincode": "581182",
            "City": "Bhadravati",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ijarilakhamapur",
            "Pincode": "581183",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bori",
            "Pincode": "581184",
            "City": "Supa",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Marukeri",
            "Pincode": "581185",
            "City": "Bhatkal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Joida",
            "Pincode": "581186",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumbarwadi",
            "Pincode": "581187",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basanal",
            "Pincode": "581188",
            "City": "Indi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanchinegalur",
            "Pincode": "581189",
            "City": "Hangal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Makari",
            "Pincode": "581190",
            "City": "Hirekerur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hireharkuni",
            "Pincode": "581191",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirgod",
            "Pincode": "581192",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhundsi",
            "Pincode": "581193",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aminbhavi",
            "Pincode": "581201",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bankapur",
            "Pincode": "581202",
            "City": "Gangawati",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalaghatgi",
            "Pincode": "581204",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shiggaon",
            "Pincode": "581205",
            "City": "Shiggaon",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uppinbetgeri",
            "Pincode": "581206",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aralikatti",
            "Pincode": "581207",
            "City": "Belgaum",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halgeri",
            "Pincode": "581208",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebsur",
            "Pincode": "581209",
            "City": "Hubli",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Masur",
            "Pincode": "581210",
            "City": "Hirekerur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Medleri",
            "Pincode": "581211",
            "City": "Ranibennur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tadas",
            "Pincode": "581212",
            "City": "Byadgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosaritti",
            "Pincode": "581213",
            "City": "Haveri",
            "District": "Haveri",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tavaremellihalli",
            "Pincode": "581214",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harobelvadi",
            "Pincode": "581215",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Medur",
            "Pincode": "581217",
            "City": "Hirekerur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirechennihatti",
            "Pincode": "581218",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yeliwal",
            "Pincode": "581219",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Benakankonda",
            "Pincode": "581221",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sunkalbidri",
            "Pincode": "581222",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bammigatti",
            "Pincode": "581223",
            "City": "Kalghatgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devikoppa",
            "Pincode": "581224",
            "City": "Kalghatgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirehonnihalli",
            "Pincode": "581225",
            "City": "Kalghatgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mishrikoti",
            "Pincode": "581226",
            "City": "Kalghatgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Baichaballi",
            "Pincode": "581227",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ingalgi",
            "Pincode": "581228",
            "City": "Chitapur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aremallapur",
            "Pincode": "581229",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ganjigatti",
            "Pincode": "581230",
            "City": "Kalghatgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ingalhalli",
            "Pincode": "581231",
            "City": "Hubli",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tabakadhonithalli",
            "Pincode": "581232",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chabbi",
            "Pincode": "581233",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Varur",
            "Pincode": "581234",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Waruri",
            "Pincode": "581234",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Guddadhulikatti",
            "Pincode": "581236",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karwar",
            "Pincode": "581301",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karwar Kajubagh",
            "Pincode": "581301",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karwar Kutcherry",
            "Pincode": "581301",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karwar Market",
            "Pincode": "581301",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Baitkhol",
            "Pincode": "581302",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodibag",
            "Pincode": "581303",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nandangadda",
            "Pincode": "581304",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kathinkon",
            "Pincode": "581305",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Habbuvada",
            "Pincode": "581306",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ankola",
            "Pincode": "581314",
            "City": "Ankola",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ankola Bunder Road",
            "Pincode": "581314",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bobruwada",
            "Pincode": "581314",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aminalli",
            "Pincode": "581315",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aversa",
            "Pincode": "581316",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Asnoti",
            "Pincode": "581317",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banarasi",
            "Pincode": "581318",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bankikodla",
            "Pincode": "581319",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhatkal",
            "Pincode": "581320",
            "City": "Bhatkal",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhatkal Bazar",
            "Pincode": "581320",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belekeri",
            "Pincode": "581321",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bilgi",
            "Pincode": "581322",
            "City": "Bilgi",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chandavar",
            "Pincode": "581323",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channamma Circle",
            "Pincode": "581325",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dandeli",
            "Pincode": "581325",
            "City": "Dandeli",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dandeli Bazar",
            "Pincode": "581325",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dandeli Plywood Colony",
            "Pincode": "581325",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokarn",
            "Pincode": "581326",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokarn Car Street",
            "Pincode": "581326",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haldipur",
            "Pincode": "581327",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halge",
            "Pincode": "581328",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haliyal",
            "Pincode": "581329",
            "City": "Haliyal",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haliyal Bazar",
            "Pincode": "581329",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hegde",
            "Pincode": "581330",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Heggarni",
            "Pincode": "581331",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Herwatta",
            "Pincode": "581332",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiragutti",
            "Pincode": "581333",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honavar",
            "Pincode": "581334",
            "City": "Honavar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honavar Bank Road",
            "Pincode": "581334",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honavar Bazar",
            "Pincode": "581334",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honavar Durgakeri",
            "Pincode": "581334",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Prabhatnagar",
            "Pincode": "581334",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosad",
            "Pincode": "581335",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulekal",
            "Pincode": "581336",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Idgundi",
            "Pincode": "581337",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodtoka",
            "Pincode": "581338",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kansur",
            "Pincode": "581340",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karki",
            "Pincode": "581341",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kasarod",
            "Pincode": "581342",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumta",
            "Pincode": "581343",
            "City": "Kumta",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumta Kutcherry",
            "Pincode": "581343",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumta Town",
            "Pincode": "581343",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madangere",
            "Pincode": "581344",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Majali",
            "Pincode": "581345",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malgi",
            "Pincode": "581346",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manchikere",
            "Pincode": "581347",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manki",
            "Pincode": "581348",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mundgod",
            "Pincode": "581349",
            "City": "Mundgod",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Murdeshwar",
            "Pincode": "581350",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gudeangadi",
            "Pincode": "581351",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sadashivgad",
            "Pincode": "581352",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tergaon",
            "Pincode": "581352",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shetgeri",
            "Pincode": "581353",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirali",
            "Pincode": "581354",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirali Bazar",
            "Pincode": "581354",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddapur",
            "Pincode": "581355",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vandige",
            "Pincode": "581357",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yekkambi",
            "Pincode": "581358",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yellapur",
            "Pincode": "581359",
            "City": "Yellapur",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yellapur Bazar",
            "Pincode": "581359",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Angadi",
            "Pincode": "581360",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Katinkar",
            "Pincode": "581361",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dandeli Paper Mills",
            "Pincode": "581362",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ambika Nagar",
            "Pincode": "581363",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Binga",
            "Pincode": "581364",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ganeshgudi",
            "Pincode": "581365",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kangad",
            "Pincode": "581367",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Salgol",
            "Pincode": "581368",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bengre",
            "Pincode": "581369",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mundalli",
            "Pincode": "581370",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalbag",
            "Pincode": "581371",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Magod Colony",
            "Pincode": "581372",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Margod Colony",
            "Pincode": "581372",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhagavathi",
            "Pincode": "581373",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Nagar Kumta",
            "Pincode": "581374",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pavinkurve",
            "Pincode": "581375",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halgeri",
            "Pincode": "581376",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madgeri",
            "Pincode": "581377",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudgeri",
            "Pincode": "581377",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhaskeri",
            "Pincode": "581378",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yadaga",
            "Pincode": "581379",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Angod",
            "Pincode": "581380",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bachanki",
            "Pincode": "581381",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangalvaad",
            "Pincode": "581382",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ambewadi",
            "Pincode": "581383",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gersoppa",
            "Pincode": "581384",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muttoli",
            "Pincode": "581388",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ajjibal",
            "Pincode": "581389",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vandur",
            "Pincode": "581390",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagre",
            "Pincode": "581393",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Valgalli",
            "Pincode": "581394",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honavar Port",
            "Pincode": "581395",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Channapattan Bazar",
            "Pincode": "581401",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Marikamba Temple Street",
            "Pincode": "581401",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sahyadri Colony",
            "Pincode": "581401",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirsi",
            "Pincode": "581401",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirsi Courts",
            "Pincode": "581401",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirsi Market",
            "Pincode": "581402",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nilekani",
            "Pincode": "581403",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhairumbe",
            "Pincode": "581405",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tibetian Colony",
            "Pincode": "581411",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kirwatti",
            "Pincode": "581412",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agsur",
            "Pincode": "581413",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belambar",
            "Pincode": "581414",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Amballi",
            "Pincode": "581416",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kinnar",
            "Pincode": "581417",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhavikeri",
            "Pincode": "581418",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alvekodi",
            "Pincode": "581419",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Heble",
            "Pincode": "581420",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kaikini",
            "Pincode": "581421",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bailur",
            "Pincode": "581422",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Melinidgunji",
            "Pincode": "581423",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karva",
            "Pincode": "581424",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Navilagaon",
            "Pincode": "581425",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kundargi",
            "Pincode": "581426",
            "City": "Bilgi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Isloor",
            "Pincode": "581428",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dasankop",
            "Pincode": "581429",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Areangadi",
            "Pincode": "581430",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balkur",
            "Pincode": "581431",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mavinkurve",
            "Pincode": "581432",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mugbe",
            "Pincode": "581433",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosakuli",
            "Pincode": "581434",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gullapur",
            "Pincode": "581435",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vajralli",
            "Pincode": "581436",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tadri",
            "Pincode": "581437",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodkani",
            "Pincode": "581439",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mirjan",
            "Pincode": "581440",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Baad",
            "Pincode": "581441",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kagal",
            "Pincode": "581443",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Katgal",
            "Pincode": "581444",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Martur",
            "Pincode": "581445",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Marur",
            "Pincode": "581445",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Murur",
            "Pincode": "581445",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sugavi",
            "Pincode": "581446",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sonda",
            "Pincode": "581447",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Janmane",
            "Pincode": "581448",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Indoor",
            "Pincode": "581449",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Indusrial Estate",
            "Pincode": "581449",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Neggar",
            "Pincode": "581450",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gadag",
            "Pincode": "582101",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gadag Bazar",
            "Pincode": "582101",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gadag City",
            "Pincode": "582101",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gadag Cotton Market",
            "Pincode": "582101",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gadag Extension",
            "Pincode": "582101",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gadag Mulgund Naka",
            "Pincode": "582101",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Betgeri",
            "Pincode": "582102",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gadag Betgeri",
            "Pincode": "582102",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gadag Health Camp",
            "Pincode": "582102",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Abbigere",
            "Pincode": "582111",
            "City": "Bangalore North",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellatti",
            "Pincode": "582112",
            "City": "Shirhatti",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dambal",
            "Pincode": "582113",
            "City": "Mundargi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gajendragad",
            "Pincode": "582114",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lakkundi",
            "Pincode": "582115",
            "City": "Gadag",
            "District": "Gadag",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lakshmeshwar",
            "Pincode": "582116",
            "City": "Lakshmeshwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mulgund",
            "Pincode": "582117",
            "City": "Mulgund",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mundargi",
            "Pincode": "582118",
            "City": "Mundargi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Naregal",
            "Pincode": "582119",
            "City": "Naregal",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirahatti",
            "Pincode": "582120",
            "City": "Shirhatti",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doni",
            "Pincode": "582121",
            "City": "Mundargi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belavanki",
            "Pincode": "582122",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harti",
            "Pincode": "582123",
            "City": "Gadag",
            "District": "Gadag",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Neelgund",
            "Pincode": "582125",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hariapur",
            "Pincode": "582126",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jakkali",
            "Pincode": "582127",
            "City": "Channagiri",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halkeri",
            "Pincode": "582128",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanaginhal",
            "Pincode": "582131",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Marasanbasri",
            "Pincode": "582132",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tirlapur",
            "Pincode": "582135",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bannikoppa",
            "Pincode": "582136",
            "City": "Shiggaon",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebbal",
            "Pincode": "582137",
            "City": "Shorapur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ranatur",
            "Pincode": "582139",
            "City": "Shirhatti",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chinchli",
            "Pincode": "582140",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalkeri",
            "Pincode": "582141",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chabbi",
            "Pincode": "582142",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Magadi",
            "Pincode": "582143",
            "City": "Magadi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vadavi",
            "Pincode": "582146",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Annigeri",
            "Pincode": "582201",
            "City": "Annigeri",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holealur",
            "Pincode": "582203",
            "City": "Ron",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hombal",
            "Pincode": "582204",
            "City": "Gadag",
            "District": "Gadag",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulkoti",
            "Pincode": "582205",
            "City": "Gadag",
            "District": "Gadag",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Konnur",
            "Pincode": "582206",
            "City": "Konnur",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "N H T Mills",
            "Pincode": "582207",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagrund",
            "Pincode": "582207",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Navalgund",
            "Pincode": "582208",
            "City": "Navalgund",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Navalgund Bazaar",
            "Pincode": "582208",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ron",
            "Pincode": "582209",
            "City": "Ron",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rontalukakutcherry",
            "Pincode": "582209",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shigli",
            "Pincode": "582210",
            "City": "Shirhatti",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sudi",
            "Pincode": "582211",
            "City": "Ron",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirol",
            "Pincode": "582212",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sortur",
            "Pincode": "582213",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurthkoti",
            "Pincode": "582214",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Surangi",
            "Pincode": "582215",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yavgal",
            "Pincode": "582216",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirehal",
            "Pincode": "582217",
            "City": "Ron",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mallapur",
            "Pincode": "582218",
            "City": "Badami",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Savadi",
            "Pincode": "582219",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hullur",
            "Pincode": "582220",
            "City": "Chitradurga",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tirlapur",
            "Pincode": "582221",
            "City": "Navalgund",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirewaddatti",
            "Pincode": "582222",
            "City": "Mundargi",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurdikoppa",
            "Pincode": "582223",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pethalur",
            "Pincode": "582223",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balehosur",
            "Pincode": "582224",
            "City": "Shirhatti",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhadrapura",
            "Pincode": "582225",
            "City": "Bhadravati",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koliwad",
            "Pincode": "582226",
            "City": "Hubli",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hallikeri",
            "Pincode": "582227",
            "City": "Harapanahalli",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hadli",
            "Pincode": "582228",
            "City": "Malavalli",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koujageri",
            "Pincode": "582229",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajur",
            "Pincode": "582230",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balaganur",
            "Pincode": "582231",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Menasgi",
            "Pincode": "582232",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodikoppa",
            "Pincode": "582233",
            "City": "Honnali",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhairanhatti",
            "Pincode": "582234",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chiknargund",
            "Pincode": "582235",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jigalur",
            "Pincode": "582236",
            "City": "Kundgol",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alagawadi",
            "Pincode": "582237",
            "City": "Navalgund",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shalavadi",
            "Pincode": "582238",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Asuti",
            "Pincode": "582239",
            "City": "Ron",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikmannur",
            "Pincode": "582240",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Itagi Nargund",
            "Pincode": "582241",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jaknur",
            "Pincode": "582243",
            "City": "Dharwar",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary",
            "Pincode": "583101",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Brucepettah",
            "Pincode": "583101",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary City",
            "Pincode": "583101",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Herialkkadam",
            "Pincode": "583101",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Jain Cloth Market",
            "Pincode": "583101",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Kalammma",
            "Pincode": "583101",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Krishnamachari Co",
            "Pincode": "583101",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Millerpet",
            "Pincode": "583101",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Patel Nagar",
            "Pincode": "583101",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Temple Street",
            "Pincode": "583101",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Contonment",
            "Pincode": "583102",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Cowl Bazar",
            "Pincode": "583102",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary District Board",
            "Pincode": "583102",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Ganesh",
            "Pincode": "583102",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Temple Street",
            "Pincode": "583102",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Gandhinagar",
            "Pincode": "583103",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Nehru Colony",
            "Pincode": "583103",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Parvathi Nagar",
            "Pincode": "583103",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Satyanaranapet",
            "Pincode": "583103",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellary Contonment",
            "Pincode": "583104",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Challakurki",
            "Pincode": "583111",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Deogeri",
            "Pincode": "583112",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Emmiganur",
            "Pincode": "583113",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hatcholli",
            "Pincode": "583114",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudithini",
            "Pincode": "583115",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurugodu",
            "Pincode": "583116",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Moka",
            "Pincode": "583117",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Doniomalai Township",
            "Pincode": "583118",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lakshmi Puram Sandur",
            "Pincode": "583119",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sandur",
            "Pincode": "583119",
            "City": "Sandur",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sandur Bazar",
            "Pincode": "583119",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirigeri",
            "Pincode": "583120",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muddebihal Bazar",
            "Pincode": "583121",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sadasivanagar",
            "Pincode": "583121",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirugupaa",
            "Pincode": "583121",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siruguppa",
            "Pincode": "583121",
            "City": "Siruguppa",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siruguppa Bazar",
            "Pincode": "583121",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tekkalakota",
            "Pincode": "583122",
            "City": "Tekkalakota",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tornagallu",
            "Pincode": "583123",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yeshwant Nagar",
            "Pincode": "583124",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arasikere",
            "Pincode": "583125",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikjogihalli",
            "Pincode": "583126",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chigateri",
            "Pincode": "583127",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Choranur",
            "Pincode": "583128",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devalapura",
            "Pincode": "583129",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Guddekote",
            "Pincode": "583130",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harapanahalli",
            "Pincode": "583131",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harapanahalli",
            "Pincode": "583131",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harapanahalli Joshi Stree",
            "Pincode": "583131",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harapanahalli Town",
            "Pincode": "583131",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Megalpet",
            "Pincode": "583131",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kampli",
            "Pincode": "583132",
            "City": "Kampli",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kampli Bazar",
            "Pincode": "583132",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kampli Sugar Factory",
            "Pincode": "583133",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kotturu",
            "Pincode": "583134",
            "City": "Kotturu",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kotturu Bazar",
            "Pincode": "583134",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kotturu Temple Street",
            "Pincode": "583134",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Babujinagar Kudligi",
            "Pincode": "583135",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudligi",
            "Pincode": "583135",
            "City": "Kudligi",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuldigi Bazar",
            "Pincode": "583135",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Oojein",
            "Pincode": "583136",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Telgi",
            "Pincode": "583137",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hagarir S",
            "Pincode": "583138",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karur",
            "Pincode": "583139",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Desnur Sugar Factory",
            "Pincode": "583140",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhujanga Nagar",
            "Pincode": "583141",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhairadevanahalli",
            "Pincode": "583142",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurekuppa",
            "Pincode": "583143",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bukkasagara",
            "Pincode": "583144",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiremyagalagere",
            "Pincode": "583145",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uchangidurga",
            "Pincode": "583146",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramassagara",
            "Pincode": "583147",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagali",
            "Pincode": "583148",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddammanahalli",
            "Pincode": "583149",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Joshi Street",
            "Pincode": "583150",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "New Daroji",
            "Pincode": "583151",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hospet",
            "Pincode": "583201",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hospet Bazar",
            "Pincode": "583201",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hospet Co-Operative Colony",
            "Pincode": "583201",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hospet Jayaprakash Nagar",
            "Pincode": "583201",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hospet Mutt Road",
            "Pincode": "583201",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hospet Nehru Colony",
            "Pincode": "583201",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hospet Ranipet",
            "Pincode": "583201",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hospet Patel Nagar",
            "Pincode": "583202",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hospet Nehru Co-Op College",
            "Pincode": "583203",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitwadgi",
            "Pincode": "583211",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hagari Bommanahalli Town",
            "Pincode": "583212",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hagri Bommanahalli",
            "Pincode": "583212",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halavagalu",
            "Pincode": "583213",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hampasagara",
            "Pincode": "583214",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hampi Power House",
            "Pincode": "583215",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirehadagalli",
            "Pincode": "583216",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holalu",
            "Pincode": "583217",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosahalli",
            "Pincode": "583218",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Huvinahadgali",
            "Pincode": "583219",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ittigi",
            "Pincode": "583220",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kamalapura",
            "Pincode": "583221",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mariammanahalli",
            "Pincode": "583222",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Papinayakanahalli",
            "Pincode": "583223",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thambrahalli",
            "Pincode": "583224",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tungabhadra Dam",
            "Pincode": "583225",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alwandi",
            "Pincode": "583226",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gangavati",
            "Pincode": "583227",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gangavati Mv Circle",
            "Pincode": "583227",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gangavti Bazar",
            "Pincode": "583227",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gangavti C B S Gunj",
            "Pincode": "583227",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gangavti Julynagar",
            "Pincode": "583227",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirejantakal",
            "Pincode": "583227",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ginigera",
            "Pincode": "583228",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karatgi",
            "Pincode": "583229",
            "City": "Gangawati",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kinhal",
            "Pincode": "583230",
            "City": "Koppal",
            "District": "Koppal",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ganj",
            "Pincode": "583231",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koppal",
            "Pincode": "583231",
            "City": "Koppal",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koppal R S",
            "Pincode": "583231",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koppalbazar",
            "Pincode": "583231",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koppalgavi Siddeswar",
            "Pincode": "583231",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kuknoor",
            "Pincode": "583232",
            "City": "Jevargi",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Munirabad",
            "Pincode": "583233",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Munirabad R S",
            "Pincode": "583234",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Raichur",
            "Pincode": "583235",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelbruga",
            "Pincode": "583236",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bewoor",
            "Pincode": "583237",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bachigondanahalli",
            "Pincode": "583238",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hampi",
            "Pincode": "583239",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hampapatna",
            "Pincode": "583240",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holagundi",
            "Pincode": "583241",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malvi",
            "Pincode": "583242",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Morigere",
            "Pincode": "583243",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Movigere",
            "Pincode": "583243",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sogi",
            "Pincode": "583244",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gadiganur",
            "Pincode": "583245",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gudiganur",
            "Pincode": "583245",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anegundi",
            "Pincode": "583246",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Heroor",
            "Pincode": "583247",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhanapur",
            "Pincode": "583249",
            "City": "Yelbarga",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhagya Nagar",
            "Pincode": "583250",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halgera",
            "Pincode": "583251",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basapattan",
            "Pincode": "583252",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Betgera",
            "Pincode": "583253",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kawloor",
            "Pincode": "583254",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hitnal",
            "Pincode": "583255",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tadkal",
            "Pincode": "583256",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangalore Koppal",
            "Pincode": "583257",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajoor",
            "Pincode": "583258",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudhol",
            "Pincode": "583259",
            "City": "Mudhol",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agalkera",
            "Pincode": "583260",
            "City": "Koppal",
            "District": "Koppal",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiremyageri",
            "Pincode": "583262",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiresindogi",
            "Pincode": "583263",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosahalli",
            "Pincode": "583264",
            "City": "Chintamani",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Itagi Koppal",
            "Pincode": "583265",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nowli",
            "Pincode": "583266",
            "City": "Hadagalli",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sangannhal",
            "Pincode": "583267",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dasmpur",
            "Pincode": "583269",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Budugumpa",
            "Pincode": "583270",
            "City": "Gangawati",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chickjantakal",
            "Pincode": "583271",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebbal",
            "Pincode": "583272",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hospet",
            "Pincode": "583273",
            "City": "Hospet",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yerdona",
            "Pincode": "583273",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nanvapura",
            "Pincode": "583274",
            "City": "Bellary",
            "District": "Bellary",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gajgarpet Raichur",
            "Pincode": "584101",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gottharia",
            "Pincode": "584101",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "584101",
            "City": "Sedam",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Naya Bazar",
            "Pincode": "584101",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nijalingappanagar",
            "Pincode": "584101",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Patilroad",
            "Pincode": "584101",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Raichur Ho",
            "Pincode": "584101",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Raichur R S",
            "Pincode": "584101",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Salem Road",
            "Pincode": "584101",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sathkucherry",
            "Pincode": "584101",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandipet Raichur",
            "Pincode": "584102",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Raichur Mukkaramganj",
            "Pincode": "584102",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maliabad",
            "Pincode": "584110",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Deodurg",
            "Pincode": "584111",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Deodurg Town",
            "Pincode": "584111",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dotihal",
            "Pincode": "584112",
            "City": "Kushtagi",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gabbur",
            "Pincode": "584113",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanamsagar",
            "Pincode": "584114",
            "City": "Kushtagi",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jalahlli Raichur",
            "Pincode": "584116",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jawalgere",
            "Pincode": "584117",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kallur",
            "Pincode": "584118",
            "City": "Jevargi",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanakagiri",
            "Pincode": "584119",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kowthal",
            "Pincode": "584120",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lingasugur",
            "Pincode": "584122",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lingasugur Kutchery",
            "Pincode": "584122",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manvi",
            "Pincode": "584123",
            "City": "Manvi",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maski",
            "Pincode": "584124",
            "City": "Lingsugur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudgal",
            "Pincode": "584125",
            "City": "Mudgal",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mosarkal",
            "Pincode": "584126",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rodalbanda",
            "Pincode": "584127",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sindhnur",
            "Pincode": "584128",
            "City": "Sindhnur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sindhnur Bus Stand",
            "Pincode": "584128",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sindhnur Camp",
            "Pincode": "584128",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirwar",
            "Pincode": "584129",
            "City": "Gangawati",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tavargira",
            "Pincode": "584131",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Turvihal",
            "Pincode": "584132",
            "City": "Sindhnur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yergira",
            "Pincode": "584133",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yermaras",
            "Pincode": "584134",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yermaras Camp",
            "Pincode": "584135",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalmala",
            "Pincode": "584136",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belaganur",
            "Pincode": "584138",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gurgunta",
            "Pincode": "584139",
            "City": "Lingsugur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gunjahalli",
            "Pincode": "584140",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gorebal",
            "Pincode": "584141",
            "City": "Lingsugur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirekottankal",
            "Pincode": "584142",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Javalgere",
            "Pincode": "584143",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rabbankal",
            "Pincode": "584144",
            "City": "Manvi",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koppuru",
            "Pincode": "584145",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mattur",
            "Pincode": "584146",
            "City": "Koppal",
            "District": "Koppal",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Neermanvi",
            "Pincode": "584147",
            "City": "Manvi",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramdurga",
            "Pincode": "584148",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddapur",
            "Pincode": "584149",
            "City": "Siddapur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yerdona",
            "Pincode": "584150",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ane Hosur",
            "Pincode": "584151",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arkera",
            "Pincode": "584153",
            "City": "Devadurga",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagalwad",
            "Pincode": "584154",
            "City": "Manvi",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chalgere",
            "Pincode": "584155",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Galag",
            "Pincode": "584156",
            "City": "Devadurga",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulagera",
            "Pincode": "584158",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosakere",
            "Pincode": "584159",
            "City": "Channagiri",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Idapnur",
            "Pincode": "584160",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kasbalingsugur",
            "Pincode": "584161",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rodkonda",
            "Pincode": "584164",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Salgunda",
            "Pincode": "584165",
            "City": "Sindhnur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanumanhal",
            "Pincode": "584166",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhadesugar",
            "Pincode": "584167",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulyhyder",
            "Pincode": "584169",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shaktinagar",
            "Pincode": "584170",
            "City": "Shaktinagar",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Deosugur",
            "Pincode": "584201",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Matmari",
            "Pincode": "584202",
            "City": "Raichur",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurdi",
            "Pincode": "584203",
            "City": "Manvi",
            "District": "Raichur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulabarag",
            "Pincode": "585101",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga",
            "Pincode": "585101",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Fort Road",
            "Pincode": "585101",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Jagat",
            "Pincode": "585101",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Kutchery",
            "Pincode": "585101",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Shahabazar",
            "Pincode": "585101",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muktamphra",
            "Pincode": "585101",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbara Khubaplot",
            "Pincode": "585102",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarg J R College",
            "Pincode": "585102",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Court",
            "Pincode": "585102",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Eng College",
            "Pincode": "585102",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga R S",
            "Pincode": "585102",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bahamanipura",
            "Pincode": "585103",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bus Stand",
            "Pincode": "585103",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga",
            "Pincode": "585103",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Central",
            "Pincode": "585103",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Govt",
            "Pincode": "585103",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Msk Mills",
            "Pincode": "585103",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sharnnagar",
            "Pincode": "585103",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga",
            "Pincode": "585104",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Darga",
            "Pincode": "585104",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Mominpura",
            "Pincode": "585104",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga Nehruganj",
            "Pincode": "585104",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nayamohalla",
            "Pincode": "585104",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nehruganj",
            "Pincode": "585104",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivajinagar",
            "Pincode": "585104",
            "City": "Afzalpur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga",
            "Pincode": "585105",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gyanaganga",
            "Pincode": "585106",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "General Hospital",
            "Pincode": "585109",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbarga",
            "Pincode": "585152",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirapur",
            "Pincode": "585154",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yadgiri",
            "Pincode": "585201",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yadgiri Town",
            "Pincode": "585201",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yadgiri Station",
            "Pincode": "585202",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurkunta Cement Factory",
            "Pincode": "585210",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chittapur",
            "Pincode": "585211",
            "City": "Lingsugur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gangapur",
            "Pincode": "585212",
            "City": "Hirekerur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ghangapur",
            "Pincode": "585212",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Station Ganagapur",
            "Pincode": "585213",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gurmitkal",
            "Pincode": "585214",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hunsgi",
            "Pincode": "585215",
            "City": "Shorapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kembhavi",
            "Pincode": "585216",
            "City": "Shorapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mashal",
            "Pincode": "585217",
            "City": "Afzalpur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nalwar",
            "Pincode": "585218",
            "City": "Chitapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narayanapur",
            "Pincode": "585219",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rangampeth",
            "Pincode": "585220",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saidapur",
            "Pincode": "585221",
            "City": "Basavakalyan",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sedam",
            "Pincode": "585222",
            "City": "Sedam",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sedam Town",
            "Pincode": "585222",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shahapur",
            "Pincode": "585223",
            "City": "Chikodi",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shahapur Market Yard",
            "Pincode": "585223",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shorapur",
            "Pincode": "585224",
            "City": "Shorapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shorapur Town",
            "Pincode": "585224",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Wadi",
            "Pincode": "585225",
            "City": "Wadi",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kamthana",
            "Pincode": "585226",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hongunta",
            "Pincode": "585227",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manakheli",
            "Pincode": "585227",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shahabad",
            "Pincode": "585228",
            "City": "Shahabad",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shahabad A C C",
            "Pincode": "585229",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nimbala",
            "Pincode": "585236",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodekal",
            "Pincode": "585237",
            "City": "Shorapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurkunta",
            "Pincode": "585238",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagewadi",
            "Pincode": "585239",
            "City": "Belgaum",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhagodi",
            "Pincode": "585239",
            "City": "Chitapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Degaon",
            "Pincode": "585240",
            "City": "Aland",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Margol",
            "Pincode": "585241",
            "City": "Chitapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhairamadgi",
            "Pincode": "585242",
            "City": "Afzalpur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Niloor",
            "Pincode": "585243",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nimbarga",
            "Pincode": "585244",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karajgi",
            "Pincode": "585245",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mannur",
            "Pincode": "585246",
            "City": "Afzalpur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kollur",
            "Pincode": "585247",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yegol",
            "Pincode": "585248",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadachur",
            "Pincode": "585249",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adk",
            "Pincode": "585250",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodla",
            "Pincode": "585251",
            "City": "Sedam",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dornahalli",
            "Pincode": "585252",
            "City": "Hassan",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rukmapur",
            "Pincode": "585253",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yalgi",
            "Pincode": "585253",
            "City": "Shorapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belwadgi",
            "Pincode": "585254",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halkatta",
            "Pincode": "585255",
            "City": "Chitapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bevoor",
            "Pincode": "585256",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manhalli",
            "Pincode": "585257",
            "City": "Basavakalyan",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirsi",
            "Pincode": "585258",
            "City": "Sirsi",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aurad",
            "Pincode": "585259",
            "City": "Aurad",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagada",
            "Pincode": "585260",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bemalkheda",
            "Pincode": "585261",
            "City": "Homnabad",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Morkonda",
            "Pincode": "585262",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nirna",
            "Pincode": "585263",
            "City": "Homnabad",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rakulgi",
            "Pincode": "585264",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rekulgi",
            "Pincode": "585264",
            "City": "Bidar",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bankur",
            "Pincode": "585265",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gabbur",
            "Pincode": "585265",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirenandur",
            "Pincode": "585266",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhoosnooru",
            "Pincode": "585268",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hattikunj",
            "Pincode": "585269",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudnal",
            "Pincode": "585270",
            "City": "Homnabad",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelasingi",
            "Pincode": "585271",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhankur",
            "Pincode": "585272",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hallisagar",
            "Pincode": "585273",
            "City": "Shahpur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madiyal",
            "Pincode": "585274",
            "City": "Aland",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bilicharkar",
            "Pincode": "585275",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bilicharkar",
            "Pincode": "585275",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chandarki",
            "Pincode": "585276",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Udachan",
            "Pincode": "585278",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Putpak",
            "Pincode": "585279",
            "City": "Yadgir",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Itkal",
            "Pincode": "585280",
            "City": "Sedam",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bheemanahalli",
            "Pincode": "585281",
            "City": "Heggadadevankote",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hipparga",
            "Pincode": "585282",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madanhipparga",
            "Pincode": "585282",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gajarkot",
            "Pincode": "585284",
            "City": "Yadgir",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kakkera",
            "Pincode": "585285",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srinivasa Saradi",
            "Pincode": "585286",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhemmarayangudi",
            "Pincode": "585287",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiremudnur",
            "Pincode": "585288",
            "City": "Hassan",
            "District": "Hassan",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Srinivas Saradgi",
            "Pincode": "585289",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kumbarpeth",
            "Pincode": "585290",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajankollur",
            "Pincode": "585291",
            "City": "Shorapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malkhed Road",
            "Pincode": "585292",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Afzalpur",
            "Pincode": "585301",
            "City": "Afzalpur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alund",
            "Pincode": "585302",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alund Bazar",
            "Pincode": "585302",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Andola",
            "Pincode": "585303",
            "City": "Jevargi",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijaspur",
            "Pincode": "585304",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chandapur",
            "Pincode": "585305",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chimmanchode",
            "Pincode": "585306",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chincholi",
            "Pincode": "585307",
            "City": "Chincholi",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Farhatabad",
            "Pincode": "585308",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gogi",
            "Pincode": "585309",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jewargi",
            "Pincode": "585310",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadganchi",
            "Pincode": "585311",
            "City": "Aland",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadgunchi",
            "Pincode": "585311",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalgi",
            "Pincode": "585312",
            "City": "Chitapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kamalapur",
            "Pincode": "585313",
            "City": "Dharwad",
            "District": "Dharwar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Khajuri",
            "Pincode": "585314",
            "City": "Aland",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madhugiri",
            "Pincode": "585315",
            "City": "Madhugiri",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madhwar",
            "Pincode": "585315",
            "City": "Sedam",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Modhugiri Doddapet",
            "Pincode": "585315",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mahagaon",
            "Pincode": "585316",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malkhed",
            "Pincode": "585317",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudhol",
            "Pincode": "585318",
            "City": "Mudhol",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Naikal",
            "Pincode": "585319",
            "City": "Shahpur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nidagunda",
            "Pincode": "585320",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramasamudra",
            "Pincode": "585321",
            "City": "Yadgir",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ratkal",
            "Pincode": "585322",
            "City": "Chincholi",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sagar",
            "Pincode": "585323",
            "City": "Sagar",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sulahpet",
            "Pincode": "585324",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yedrami",
            "Pincode": "585325",
            "City": "Jevargi",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aurd Barahalli",
            "Pincode": "585326",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basavakalyana",
            "Pincode": "585327",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basavakalyana Bazar",
            "Pincode": "585327",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhalki",
            "Pincode": "585328",
            "City": "Bhalki",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hoodgi",
            "Pincode": "585329",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Humnabad",
            "Pincode": "585330",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Humnabad Bazar",
            "Pincode": "585330",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajeshwar",
            "Pincode": "585331",
            "City": "Basavakalyan",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Atnoor",
            "Pincode": "585332",
            "City": "Afzalpur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Revoor",
            "Pincode": "585333",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koralli",
            "Pincode": "585334",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ganwar",
            "Pincode": "585335",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Enoli",
            "Pincode": "585336",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Firozabad",
            "Pincode": "585337",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kirni",
            "Pincode": "585338",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nilogi",
            "Pincode": "585339",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhuttargaon",
            "Pincode": "585340",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gola",
            "Pincode": "585341",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Narayanpur",
            "Pincode": "585341",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Norona",
            "Pincode": "585342",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tadkal",
            "Pincode": "585343",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dandoti",
            "Pincode": "585344",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tengli",
            "Pincode": "585345",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belura",
            "Pincode": "585346",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muchalam",
            "Pincode": "585347",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Partapur",
            "Pincode": "585349",
            "City": "Basavakalyan",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sastapur",
            "Pincode": "585350",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ranjolkheni",
            "Pincode": "585351",
            "City": "Bidar",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hallikhed",
            "Pincode": "585352",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Maniknagar",
            "Pincode": "585353",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rajola",
            "Pincode": "585354",
            "City": "Basavakalyan",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodli",
            "Pincode": "585356",
            "City": "Bhalki",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Baddal",
            "Pincode": "585358",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sonth",
            "Pincode": "585359",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hipparg",
            "Pincode": "585360",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sarsamba",
            "Pincode": "585361",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mandewal",
            "Pincode": "585362",
            "City": "Jevargi",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Padasvali",
            "Pincode": "585363",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudhol",
            "Pincode": "585364",
            "City": "Mudhol",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolkunda",
            "Pincode": "585365",
            "City": "Chitapur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ajjeri",
            "Pincode": "585366",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malli",
            "Pincode": "585369",
            "City": "Jevargi",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelhar",
            "Pincode": "585370",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yevoor",
            "Pincode": "585371",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagnur",
            "Pincode": "585372",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirali",
            "Pincode": "585373",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Salgera",
            "Pincode": "585374",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Konkal",
            "Pincode": "585375",
            "City": "Shahpur",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Talmadgi",
            "Pincode": "585375",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chandankera",
            "Pincode": "585377",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pattan",
            "Pincode": "585378",
            "City": "Gulbarga",
            "District": "Gulbarga",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidar",
            "Pincode": "585401",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidar Bazar",
            "Pincode": "585401",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidar Iaf Stn",
            "Pincode": "585401",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidar Mangalpet",
            "Pincode": "585401",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidar Shahganj",
            "Pincode": "585401",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidarosman Ganj",
            "Pincode": "585401",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidargurunanakjhira",
            "Pincode": "585402",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidar Gandhiganj",
            "Pincode": "585403",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Ganj",
            "Pincode": "585403",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhatambra",
            "Pincode": "585411",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitguppa",
            "Pincode": "585412",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ahmaedabad",
            "Pincode": "585413",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halbarga",
            "Pincode": "585413",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hallikhed",
            "Pincode": "585414",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hallikhed S F",
            "Pincode": "585415",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulsur",
            "Pincode": "585416",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kamalnagar",
            "Pincode": "585417",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karimabad",
            "Pincode": "585418",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Matala",
            "Pincode": "585419",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Santpur",
            "Pincode": "585421",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Andura",
            "Pincode": "585422",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Janwada",
            "Pincode": "585423",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodambal",
            "Pincode": "585424",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mustari",
            "Pincode": "585425",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhanura",
            "Pincode": "585426",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanji",
            "Pincode": "585427",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nittur",
            "Pincode": "585428",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Katachincholi",
            "Pincode": "585429",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saigaon",
            "Pincode": "585431",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holasamunder",
            "Pincode": "585432",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulsurkhed",
            "Pincode": "585433",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ghatboral",
            "Pincode": "585434",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kankatta",
            "Pincode": "585435",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thanakushnoor",
            "Pincode": "585436",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudbi",
            "Pincode": "585437",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mirkhal",
            "Pincode": "585438",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Murki",
            "Pincode": "585439",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Torna",
            "Pincode": "585440",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halsitugaon",
            "Pincode": "585441",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lakhangaon",
            "Pincode": "585442",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudhol",
            "Pincode": "585443",
            "City": "Bidar",
            "District": "Bidar",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Basavanagar",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Bazar",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Darbargalli",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Jorapurpeth",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Jummamasjid",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Kabraji Bazar",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Kutchery",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Railway Stn",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Tajabavadi",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijaur Market Yard",
            "Pincode": "586101",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Sainik School",
            "Pincode": "586102",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sainik School",
            "Pincode": "586102",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Vijaya College",
            "Pincode": "586103",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Jainapur",
            "Pincode": "586104",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Mamadpur",
            "Pincode": "586105",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Torvi",
            "Pincode": "586106",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijapur Darga",
            "Pincode": "586107",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Agarkhed",
            "Pincode": "586111",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Atharga",
            "Pincode": "586112",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bableshwar",
            "Pincode": "586113",
            "City": "Aland",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bijjargi",
            "Pincode": "586114",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devarhippargi",
            "Pincode": "586115",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhavalgi",
            "Pincode": "586116",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Horti",
            "Pincode": "586117",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalkeri",
            "Pincode": "586118",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kannur",
            "Pincode": "586119",
            "City": "Kannur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Korvar",
            "Pincode": "586120",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudgi",
            "Pincode": "586121",
            "City": "Basavana Bagevadi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangoli",
            "Pincode": "586122",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Moratgi",
            "Pincode": "586123",
            "City": "Sindgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nalatwad",
            "Pincode": "586124",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sarwad",
            "Pincode": "586125",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Savalgi",
            "Pincode": "586126",
            "City": "Gulbarga",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivangi",
            "Pincode": "586127",
            "City": "Devadurga",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sindgi",
            "Pincode": "586128",
            "City": "Sindgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tangadgi",
            "Pincode": "586129",
            "City": "Shahpur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arjungi",
            "Pincode": "586131",
            "City": "Afzalpur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kakhandhi",
            "Pincode": "586132",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nidoni",
            "Pincode": "586133",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagral",
            "Pincode": "586134",
            "City": "Bhalki",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arkeri",
            "Pincode": "586135",
            "City": "Yelbarga",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddapura",
            "Pincode": "586136",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bana Nagar",
            "Pincode": "586137",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanamadi",
            "Pincode": "586138",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanmadi",
            "Pincode": "586138",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidari",
            "Pincode": "586140",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halagani",
            "Pincode": "586141",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balaganur",
            "Pincode": "586142",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chandkavthe",
            "Pincode": "586143",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yankanchi",
            "Pincode": "586144",
            "City": "Badami",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gothe",
            "Pincode": "586145",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tungal",
            "Pincode": "586146",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirebevanur",
            "Pincode": "586147",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honagonahalli",
            "Pincode": "586148",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhairanje",
            "Pincode": "586149",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mulwad",
            "Pincode": "586149",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Masuti",
            "Pincode": "586150",
            "City": "Basavana Bagevadi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hittinahalli",
            "Pincode": "586151",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ukli",
            "Pincode": "586152",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hadagali",
            "Pincode": "586153",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madabhavi",
            "Pincode": "586154",
            "City": "Chikodi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mulsavalgi",
            "Pincode": "586155",
            "City": "Sindgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honvad",
            "Pincode": "586156",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kakkalmeli",
            "Pincode": "586157",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yargal",
            "Pincode": "586158",
            "City": "Sindgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kannolli",
            "Pincode": "586159",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolur",
            "Pincode": "586160",
            "City": "Bangalore South",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagthan",
            "Pincode": "586161",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tadvalga",
            "Pincode": "586162",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jalwad",
            "Pincode": "586163",
            "City": "Sindgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yalwar",
            "Pincode": "586164",
            "City": "Basavana Bagevadi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tilgul",
            "Pincode": "586165",
            "City": "Gulbarga",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aski",
            "Pincode": "586166",
            "City": "Sindgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bekinal",
            "Pincode": "586168",
            "City": "Sindgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sindgi Town",
            "Pincode": "586169",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Almatti Dam Site",
            "Pincode": "586201",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Almel",
            "Pincode": "586202",
            "City": "Sindgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basavan Bagewadi",
            "Pincode": "586203",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bardol",
            "Pincode": "586204",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chandchar",
            "Pincode": "586205",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devangaon",
            "Pincode": "586206",
            "City": "Sindgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halasangi",
            "Pincode": "586207",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Huvinhippargi",
            "Pincode": "586208",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Indi",
            "Pincode": "586209",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Indi Bazar",
            "Pincode": "586209",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kolhar",
            "Pincode": "586210",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lachyan",
            "Pincode": "586211",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muddebihal",
            "Pincode": "586212",
            "City": "Muddebihal",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nidgundi",
            "Pincode": "586213",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tallikoti",
            "Pincode": "586214",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tallikoti Bazar",
            "Pincode": "586214",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tamba",
            "Pincode": "586215",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Salotgi",
            "Pincode": "586217",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Almatti",
            "Pincode": "586218",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chimmalgi",
            "Pincode": "586219",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vandal",
            "Pincode": "586220",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Asangi Khurd",
            "Pincode": "586221",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ahirsang",
            "Pincode": "586222",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanjagi",
            "Pincode": "586223",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anjutgi",
            "Pincode": "586224",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chickbevanur",
            "Pincode": "586225",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rugi",
            "Pincode": "586226",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhatgunki",
            "Pincode": "586227",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Babur",
            "Pincode": "586228",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kavadimatti",
            "Pincode": "586229",
            "City": "Muddebihal",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bandappansalwedgi",
            "Pincode": "586230",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Golsangi",
            "Pincode": "586231",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muttagi",
            "Pincode": "586232",
            "City": "Basavana Bagevadi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muttsalavadikebe",
            "Pincode": "586232",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hiremasali",
            "Pincode": "586233",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hunishyal",
            "Pincode": "586234",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ingleshwar",
            "Pincode": "586235",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jagjivan",
            "Pincode": "586236",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lonibudruk",
            "Pincode": "586237",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nimbargi",
            "Pincode": "586238",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudresalwadgi",
            "Pincode": "586239",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Masbinal",
            "Pincode": "586241",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nivargi",
            "Pincode": "586242",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirshyad",
            "Pincode": "586243",
            "City": "Indi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muddebihal Fort",
            "Pincode": "586245",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jamdaddi",
            "Pincode": "586247",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagalkot Bazar",
            "Pincode": "587101",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagalkot H.O.",
            "Pincode": "587101",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagalkot Station Road",
            "Pincode": "587101",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balakot B H School",
            "Pincode": "587101",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagalkot Grbc Colony",
            "Pincode": "587102",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bagalkot Housing Colony",
            "Pincode": "587103",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alok Udyog",
            "Pincode": "587111",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Amingod",
            "Pincode": "587112",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belur Bagalkot",
            "Pincode": "587114",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bevur",
            "Pincode": "587115",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bilgi",
            "Pincode": "587116",
            "City": "Bilgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Galgali",
            "Pincode": "587117",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hungund",
            "Pincode": "587118",
            "City": "Hungund",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hungund Bazar",
            "Pincode": "587118",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hunnur",
            "Pincode": "587119",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kamatgi",
            "Pincode": "587120",
            "City": "Hungund",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Konur",
            "Pincode": "587121",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Lokapur",
            "Pincode": "587122",
            "City": "Mudhol",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nilgund",
            "Pincode": "587123",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sulibhavi",
            "Pincode": "587124",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Iikal Town",
            "Pincode": "587125",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Iikalgandhi Chowk",
            "Pincode": "587125",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Likal",
            "Pincode": "587125",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anagwadi",
            "Pincode": "587126",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Girisagar",
            "Pincode": "587127",
            "City": "Bilgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sunag",
            "Pincode": "587128",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sonna",
            "Pincode": "587129",
            "City": "Bilgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Amarawati",
            "Pincode": "587130",
            "City": "Hungund",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhannur",
            "Pincode": "587131",
            "City": "Aland",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chitawadgi",
            "Pincode": "587132",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arkera",
            "Pincode": "587133",
            "City": "Devadurga",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halagali",
            "Pincode": "587134",
            "City": "Mudhol",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hylyal",
            "Pincode": "587135",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mantur",
            "Pincode": "587136",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Melligere",
            "Pincode": "587137",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aihole",
            "Pincode": "587138",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kelur",
            "Pincode": "587139",
            "City": "Hungund",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhagawati",
            "Pincode": "587140",
            "City": "Supa",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sangam",
            "Pincode": "587141",
            "City": "Aurad",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosur",
            "Pincode": "587142",
            "City": "Krishnarajpet",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hallur",
            "Pincode": "587143",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jalihal",
            "Pincode": "587144",
            "City": "Badami",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kandgal",
            "Pincode": "587145",
            "City": "Hungund",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karadi",
            "Pincode": "587146",
            "City": "Hungund",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodihal",
            "Pincode": "587147",
            "City": "Hungund",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nandawadgi",
            "Pincode": "587148",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kakanur",
            "Pincode": "587149",
            "City": "Badami",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Siddapur",
            "Pincode": "587151",
            "City": "Siddapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirur",
            "Pincode": "587152",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sirur",
            "Pincode": "587152",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Benkatti",
            "Pincode": "587153",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Alampurpeth",
            "Pincode": "587154",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kulgeri Cross",
            "Pincode": "587155",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kulgod",
            "Pincode": "587155",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Badami Extension",
            "Pincode": "587201",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Badami H.O.",
            "Pincode": "587201",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gudur",
            "Pincode": "587202",
            "City": "Afzalpur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Guledgudd",
            "Pincode": "587203",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Guledgudd East",
            "Pincode": "587203",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kaladgi",
            "Pincode": "587204",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Katageri",
            "Pincode": "587205",
            "City": "Badami",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kerur",
            "Pincode": "587206",
            "City": "Kerur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sitimani R S",
            "Pincode": "587207",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Cholachgudd",
            "Pincode": "587208",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muttalgere",
            "Pincode": "587209",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nandikeshwar",
            "Pincode": "587210",
            "City": "Badami",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pattadakal",
            "Pincode": "587211",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Khajjidoni",
            "Pincode": "587213",
            "City": "Bagalkot",
            "District": "Bagalkot",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kundargi",
            "Pincode": "587214",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tulsigere",
            "Pincode": "587215",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivayoga Mandir",
            "Pincode": "587242",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jamkhandi",
            "Pincode": "587301",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jamkhandi B S Road",
            "Pincode": "587301",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jamkhandi Giri Shnagar",
            "Pincode": "587302",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Banahatti Somwarpet",
            "Pincode": "587311",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bankikodia",
            "Pincode": "587311",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Apmcyard",
            "Pincode": "587312",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mahalingapur",
            "Pincode": "587312",
            "City": "Mudhol",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudhol",
            "Pincode": "587313",
            "City": "Mudhol",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudhol Bazar",
            "Pincode": "587313",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Rabkhavi",
            "Pincode": "587314",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Terdal",
            "Pincode": "587315",
            "City": "Terdal",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sameerwadi",
            "Pincode": "587316",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Asangi",
            "Pincode": "587317",
            "City": "Badami",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hippargi",
            "Pincode": "587318",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kulhalli",
            "Pincode": "587319",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Navalgi",
            "Pincode": "587320",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Algur",
            "Pincode": "587321",
            "City": "Sindgi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Todalbagi",
            "Pincode": "587322",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Togalbagi",
            "Pincode": "587322",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirepadsalgi",
            "Pincode": "587323",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirupadsalgi",
            "Pincode": "587323",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chimmad",
            "Pincode": "587324",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saidapur",
            "Pincode": "587325",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halingali",
            "Pincode": "587326",
            "City": "Jamkhandi",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sasalatti",
            "Pincode": "587327",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirol",
            "Pincode": "587328",
            "City": "Bijapur",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yadhalli",
            "Pincode": "587329",
            "City": "Sedam",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum",
            "Pincode": "590001",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum",
            "Pincode": "590001",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Camp",
            "Pincode": "590001",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum College Road",
            "Pincode": "590001",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Fort Road",
            "Pincode": "590001",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Kapileshwar Road",
            "Pincode": "590001",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Visweswaraya Nagar",
            "Pincode": "590001",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum",
            "Pincode": "590002",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum City",
            "Pincode": "590002",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Khadi Bazar",
            "Pincode": "590002",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Kutchery",
            "Pincode": "590002",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Tilak Chowk",
            "Pincode": "590002",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadolkargalli Corner",
            "Pincode": "590002",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodolkargalli",
            "Pincode": "590002",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Bharat Nagar",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Dharwad Road",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Fort",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Goavesh",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Malmurti",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Shahapur",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Shahapur Bazar",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Tilakwadi",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Extn",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shivajinagar",
            "Pincode": "590003",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Khas Bag",
            "Pincode": "590004",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum",
            "Pincode": "590005",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madhavapur",
            "Pincode": "590005",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vadagaon June",
            "Pincode": "590005",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum",
            "Pincode": "590006",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Ganesh Chowk",
            "Pincode": "590006",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Vaccine Institute",
            "Pincode": "590006",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhagya Nagar",
            "Pincode": "590006",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "East",
            "Pincode": "590006",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgum Angol",
            "Pincode": "590007",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Udyambag",
            "Pincode": "590008",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Record Mli",
            "Pincode": "590009",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Aluminium Factor",
            "Pincode": "590010",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nehrunagar",
            "Pincode": "590010",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Hindwadi",
            "Pincode": "590011",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Basavankudchi",
            "Pincode": "590012",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balgaum Majgaon",
            "Pincode": "590013",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum",
            "Pincode": "590013",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Peeranwadi",
            "Pincode": "590014",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum Kanbargi",
            "Pincode": "590015",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karali Jn",
            "Pincode": "590543",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ankalgi",
            "Pincode": "591101",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bailhongal Bazar",
            "Pincode": "591102",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bailhongal H.O.",
            "Pincode": "591102",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bailhongal S R Chowk",
            "Pincode": "591102",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balekundi",
            "Pincode": "591103",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Balekundrikshetra",
            "Pincode": "591103",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belvadi",
            "Pincode": "591104",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bidi",
            "Pincode": "591106",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hidkal Dam",
            "Pincode": "591107",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hindalga",
            "Pincode": "591108",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vijayanagar",
            "Pincode": "591108",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirebagewadi",
            "Pincode": "591109",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirekumbi",
            "Pincode": "591110",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hosur",
            "Pincode": "591111",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Itgi",
            "Pincode": "591112",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kakti",
            "Pincode": "591113",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Katkol",
            "Pincode": "591114",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kittur",
            "Pincode": "591115",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kittur Somwarpeth",
            "Pincode": "591115",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Malaprabha Dam Site",
            "Pincode": "591116",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mugutkhanhubli",
            "Pincode": "591118",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Murgod",
            "Pincode": "591119",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nandgad",
            "Pincode": "591120",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nesargi",
            "Pincode": "591121",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Fachhapur",
            "Pincode": "591122",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramdurg",
            "Pincode": "591123",
            "City": "Ramdurg",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ramdurg Town",
            "Pincode": "591123",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sambra",
            "Pincode": "591124",
            "City": "Belgaum",
            "District": "Bijapur",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sampgaon",
            "Pincode": "591125",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saundatti",
            "Pincode": "591126",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saundatti Apmc",
            "Pincode": "591126",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saundatti Bazar",
            "Pincode": "591126",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saundatti Chidambarnagar",
            "Pincode": "591126",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sureban",
            "Pincode": "591127",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Uchgaon",
            "Pincode": "591128",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yargatti",
            "Pincode": "591129",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Salahalli",
            "Pincode": "591130",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Parishwad",
            "Pincode": "591131",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhendigeri",
            "Pincode": "591132",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sulebhavi",
            "Pincode": "591134",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Honge",
            "Pincode": "591135",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yadwad",
            "Pincode": "591136",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ambadgatti",
            "Pincode": "591137",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anakalgi",
            "Pincode": "591138",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belagunda",
            "Pincode": "591139",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgundi",
            "Pincode": "591139",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devalapur",
            "Pincode": "591140",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gandhi Gwad",
            "Pincode": "591141",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halashi",
            "Pincode": "591142",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadoli",
            "Pincode": "591143",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kakkeri",
            "Pincode": "591144",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanvikarvinkop",
            "Pincode": "591145",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yallur",
            "Pincode": "591146",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Deshnur",
            "Pincode": "591147",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hudi",
            "Pincode": "591148",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bailur",
            "Pincode": "591149",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bastwad",
            "Pincode": "591150",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Batkurki",
            "Pincode": "591151",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Budakatti",
            "Pincode": "591152",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Devalatti",
            "Pincode": "591154",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halgatti",
            "Pincode": "591155",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanchinal",
            "Pincode": "591157",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Holehosur",
            "Pincode": "591158",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hooli",
            "Pincode": "591159",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulkund",
            "Pincode": "591160",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hunshikatti",
            "Pincode": "591161",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Inamhangal",
            "Pincode": "591162",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Inchal",
            "Pincode": "591163",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadroli",
            "Pincode": "591164",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Marihal",
            "Pincode": "591167",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudkavi",
            "Pincode": "591168",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum",
            "Pincode": "591169",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tigadi",
            "Pincode": "591171",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yellamma Hills",
            "Pincode": "591173",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhamne",
            "Pincode": "591175",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Halga",
            "Pincode": "591176",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Avaradi",
            "Pincode": "591177",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Akkatangerhal",
            "Pincode": "591178",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Asund I",
            "Pincode": "591180",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Machhe",
            "Pincode": "591181",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ambewadi",
            "Pincode": "591182",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Betsur",
            "Pincode": "591183",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dodwad",
            "Pincode": "591184",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hanabaratti",
            "Pincode": "591185",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hannikeri",
            "Pincode": "591186",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hoskoti",
            "Pincode": "591187",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karikatti",
            "Pincode": "591188",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mutge",
            "Pincode": "591189",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Neginhal",
            "Pincode": "591190",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sangolli",
            "Pincode": "591191",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sattigere",
            "Pincode": "591192",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sopadia",
            "Pincode": "591193",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Tigadolli",
            "Pincode": "591194",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Turmari",
            "Pincode": "591195",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ugargol",
            "Pincode": "591196",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kangralikhurd",
            "Pincode": "591197",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Muchandi",
            "Pincode": "591198",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikodi",
            "Pincode": "591201",
            "City": "Chikodi",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikodi Bazar",
            "Pincode": "591201",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikodi College Road",
            "Pincode": "591201",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikodi Extn",
            "Pincode": "591201",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Akol",
            "Pincode": "591211",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Anantpur",
            "Pincode": "591212",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ankli",
            "Pincode": "591213",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bedakihal",
            "Pincode": "591214",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Benadi",
            "Pincode": "591215",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Borgaon",
            "Pincode": "591216",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belgaum",
            "Pincode": "591217",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dhupdal",
            "Pincode": "591218",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Galataga",
            "Pincode": "591219",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Harugere",
            "Pincode": "591220",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hebbal",
            "Pincode": "591221",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kabbur",
            "Pincode": "591222",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kalloli",
            "Pincode": "591224",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kanagale",
            "Pincode": "591225",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karoshi",
            "Pincode": "591226",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Koujalgi",
            "Pincode": "591227",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manoli",
            "Pincode": "591227",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Khadaklat",
            "Pincode": "591228",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kognoli",
            "Pincode": "591229",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kokatnur",
            "Pincode": "591230",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Konnur",
            "Pincode": "591231",
            "City": "Konnur",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Madbhavi",
            "Pincode": "591232",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mamadapur",
            "Pincode": "591233",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangasulli",
            "Pincode": "591234",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mugalkhed",
            "Pincode": "591235",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nidsoshi",
            "Pincode": "591236",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nipani",
            "Pincode": "591237",
            "City": "Nipani",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nipani C R D",
            "Pincode": "591237",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nipani N C",
            "Pincode": "591237",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Pattankudi",
            "Pincode": "591238",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sadalga",
            "Pincode": "591239",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Satti",
            "Pincode": "591240",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saundalga",
            "Pincode": "591241",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Soundalaga",
            "Pincode": "591241",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirguppi",
            "Pincode": "591242",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thagarthi",
            "Pincode": "591243",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Thanahattargi",
            "Pincode": "591243",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yaksamba",
            "Pincode": "591244",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yamakanmardi",
            "Pincode": "591245",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karadga",
            "Pincode": "591246",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chikodi Sugar Factory",
            "Pincode": "591247",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Aigali",
            "Pincode": "591248",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ingalgoan",
            "Pincode": "591249",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kulgod",
            "Pincode": "591250",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ghoderi",
            "Pincode": "591251",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jugai",
            "Pincode": "591252",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yadgud",
            "Pincode": "591253",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Daddi",
            "Pincode": "591254",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hidkal",
            "Pincode": "591255",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chamakere",
            "Pincode": "591256",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kohalli",
            "Pincode": "591257",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kempwad",
            "Pincode": "591258",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Murgundi",
            "Pincode": "591259",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Savadi",
            "Pincode": "591260",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Darur",
            "Pincode": "591261",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gundewadi",
            "Pincode": "591262",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhoj",
            "Pincode": "591263",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manjari",
            "Pincode": "591264",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Telsang",
            "Pincode": "591265",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adahalli",
            "Pincode": "591266",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adhalli",
            "Pincode": "591266",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Adi",
            "Pincode": "591267",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ammangi",
            "Pincode": "591268",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arjun Nagar",
            "Pincode": "591269",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Belkad",
            "Pincode": "591270",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bhirdi",
            "Pincode": "591271",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chinchani",
            "Pincode": "591272",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chandur",
            "Pincode": "591273",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hirekudi",
            "Pincode": "591274",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hunnargi",
            "Pincode": "591275",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hunshyal",
            "Pincode": "591276",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Janwad",
            "Pincode": "591279",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Jatrat",
            "Pincode": "591280",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadapur",
            "Pincode": "591281",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kallol",
            "Pincode": "591282",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kollol",
            "Pincode": "591282",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kerur",
            "Pincode": "591283",
            "City": "Kerur",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kodni",
            "Pincode": "591284",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurli",
            "Pincode": "591285",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurnad",
            "Pincode": "591285",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kurni",
            "Pincode": "591286",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kothali",
            "Pincode": "591287",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kunnur",
            "Pincode": "591288",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mallikwad",
            "Pincode": "591289",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangur",
            "Pincode": "591290",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mangutti",
            "Pincode": "591291",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Masaguppi",
            "Pincode": "591292",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagar Munoli",
            "Pincode": "591293",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nanadi",
            "Pincode": "591295",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nej",
            "Pincode": "591296",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "New Diggewadi",
            "Pincode": "591297",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nilagi",
            "Pincode": "591298",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nasalapur",
            "Pincode": "591299",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Londa",
            "Pincode": "591301",
            "City": "Londa",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Khanapur",
            "Pincode": "591302",
            "City": "Khanapur",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Khanapur Town",
            "Pincode": "591302",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ainapura",
            "Pincode": "591303",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Air Force Station",
            "Pincode": "591303",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Athni",
            "Pincode": "591304",
            "City": "Athni",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Athni Bazar",
            "Pincode": "591304",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Athni Bus Stand",
            "Pincode": "591304",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bellad Bagewadi",
            "Pincode": "591305",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ghataprabha R S",
            "Pincode": "591306",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokak",
            "Pincode": "591307",
            "City": "Gokak",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokak College Road",
            "Pincode": "591307",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokak Fort",
            "Pincode": "591307",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokak Guruwarpeth",
            "Pincode": "591307",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokak Raviwarpet",
            "Pincode": "591307",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gokak Falis",
            "Pincode": "591308",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hukeri",
            "Pincode": "591309",
            "City": "Hukeri",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hukeri Bazar",
            "Pincode": "591309",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Karnatak Health Institute",
            "Pincode": "591310",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kudchi",
            "Pincode": "591311",
            "City": "Kudchi",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mudalagi",
            "Pincode": "591312",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sankeshwar",
            "Pincode": "591313",
            "City": "Sankeshwar",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sankeshwar Subhash Crcl",
            "Pincode": "591313",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sankeshwar Sugar Factory",
            "Pincode": "591314",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shedbai",
            "Pincode": "591315",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ugarkhurd",
            "Pincode": "591316",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Raibag",
            "Pincode": "591317",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Arbhaviamath",
            "Pincode": "591318",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nagnur",
            "Pincode": "591319",
            "City": "Karwar",
            "District": "Uttar Kannada",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ugarbudruk",
            "Pincode": "591320",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Gulbalgud",
            "Pincode": "591321",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mole",
            "Pincode": "591322",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulagbabi",
            "Pincode": "591323",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kakamari",
            "Pincode": "591324",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Parthanahalli",
            "Pincode": "591327",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shegunshi",
            "Pincode": "591328",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Paramanandawadi",
            "Pincode": "591329",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shirgur",
            "Pincode": "591330",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Garlgungji",
            "Pincode": "591331",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Bekkere",
            "Pincode": "591332",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Dharmatti",
            "Pincode": "591333",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Hulloli",
            "Pincode": "591334",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Melavanki",
            "Pincode": "591337",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nandi Kurli",
            "Pincode": "591339",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nerli",
            "Pincode": "591340",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yelimanoli",
            "Pincode": "591343",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Khanagaon",
            "Pincode": "591344",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sambargi",
            "Pincode": "591501",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saunbuddi",
            "Pincode": "591502",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saptasagar",
            "Pincode": "591503",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Saundatti",
            "Pincode": "591504",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shamnewadi",
            "Pincode": "591505",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Shindikurbet",
            "Pincode": "591506",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Solapur",
            "Pincode": "591507",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Sundhadi",
            "Pincode": "591508",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Talakatnal",
            "Pincode": "591509",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Ullagaddi",
            "Pincode": "591510",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Walki",
            "Pincode": "591511",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yadur",
            "Pincode": "591512",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yedur",
            "Pincode": "591512",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Waderhatti",
            "Pincode": "591513",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Haragapur",
            "Pincode": "591514",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kankanwadi",
            "Pincode": "591515",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yabaratti",
            "Pincode": "591516",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Yebaratti",
            "Pincode": "591516",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Manakapura",
            "Pincode": "591517",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Mankapur",
            "Pincode": "591517",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Vakkund",
            "Pincode": "591701",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadbi",
            "Pincode": "591702",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Kadoloi",
            "Pincode": "591702",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chunchanur",
            "Pincode": "591703",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Chidambarnagar",
            "Pincode": "591802",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Nekarpet Ramdurg",
            "Pincode": "591812",
            "City": "Belgaum",
            "District": "Belgaum",
            "State": "Karnataka"
        },
        {
            "PostOfficeName": "Angappanaicken Street",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Flower Bazar",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Govt Stanely Hospital",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kothwal Market",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "M P T Admn Office",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madras Gpo",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannady",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mint Buildings",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Monegar Choultry",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muthialpet",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sembier Street",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seven Wells",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Wal Tax Road",
            "Pincode": "600001",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anna Road H O",
            "Pincode": "600002",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annaroad Sourth",
            "Pincode": "600002",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chintadripeta",
            "Pincode": "600002",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Government Estate",
            "Pincode": "600002",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madras Electricity System",
            "Pincode": "600002",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupet",
            "Pincode": "600002",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Central Station",
            "Pincode": "600003",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dr Ambedkarnagar",
            "Pincode": "600003",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Edapalayam",
            "Pincode": "600003",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madras Medical College",
            "Pincode": "600003",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Park Town",
            "Pincode": "600003",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ripon Buildings",
            "Pincode": "600003",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Luz Church Road",
            "Pincode": "600004",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mandavalli",
            "Pincode": "600004",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ms Vivekanands College",
            "Pincode": "600004",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mylopore",
            "Pincode": "600004",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nochikuppam Colony",
            "Pincode": "600004",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Police Head Quarters",
            "Pincode": "600004",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Royapettah High Road",
            "Pincode": "600004",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Santhome",
            "Pincode": "600004",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chepauk",
            "Pincode": "600005",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnampet",
            "Pincode": "600005",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madras Presidency College",
            "Pincode": "600005",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madras University",
            "Pincode": "600005",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Parthasarathy Koil",
            "Pincode": "600005",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvellikeni",
            "Pincode": "600005",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cathedral",
            "Pincode": "600006",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Greams Road",
            "Pincode": "600006",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Old College Buildings",
            "Pincode": "600006",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shastri Bhavan",
            "Pincode": "600006",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Teynampet West",
            "Pincode": "600006",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vepery",
            "Pincode": "600007",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Egmore",
            "Pincode": "600008",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Egmore High Road",
            "Pincode": "600008",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Fort St George",
            "Pincode": "600009",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilpauk",
            "Pincode": "600010",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilpauk Garden Colony",
            "Pincode": "600010",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilpauk Medical College",
            "Pincode": "600010",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilpauk West",
            "Pincode": "600010",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Medavakkam Tank Road",
            "Pincode": "600010",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "New Avadi Road",
            "Pincode": "600010",
            "City": "Avadi",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnaiah Mudali Colony",
            "Pincode": "600011",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perambur",
            "Pincode": "600011",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perambur North",
            "Pincode": "600011",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sembiam",
            "Pincode": "600011",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Decoster Road",
            "Pincode": "600012",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kosapet",
            "Pincode": "600012",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perambur Barracks",
            "Pincode": "600012",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perambur High Road",
            "Pincode": "600012",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pulianthope",
            "Pincode": "600012",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Syrahans Road",
            "Pincode": "600012",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Venkatesapuram",
            "Pincode": "600012",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalmandapam",
            "Pincode": "600013",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kasimode",
            "Pincode": "600013",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rayapuram Madras",
            "Pincode": "600013",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rayapuram Market",
            "Pincode": "600013",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Goudiyamath Road",
            "Pincode": "600014",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jam Bazaar",
            "Pincode": "600014",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ligods Estate",
            "Pincode": "600014",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ligods Road",
            "Pincode": "600014",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupakkam",
            "Pincode": "600014",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Royapettah",
            "Pincode": "600014",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Triplicane South",
            "Pincode": "600014",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gunidy North",
            "Pincode": "600015",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saidapet Madras",
            "Pincode": "600015",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saidapet West",
            "Pincode": "600015",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saidhapet North",
            "Pincode": "600015",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alandur",
            "Pincode": "600016",
            "City": "Alandur",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Butt Road",
            "Pincode": "600016",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "St Thomas Mount H O",
            "Pincode": "600016",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvaluvar Nagar",
            "Pincode": "600016",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Habibullah Road",
            "Pincode": "600017",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hindi Prachar Sabha",
            "Pincode": "600017",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "North Thyagarayanagar",
            "Pincode": "600017",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panagal Park",
            "Pincode": "600017",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thayagaranagar H O",
            "Pincode": "600017",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thyagarayanagar South",
            "Pincode": "600017",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Usman Road",
            "Pincode": "600017",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Abiramapuram",
            "Pincode": "600018",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chamiers Road",
            "Pincode": "600018",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eldams Road",
            "Pincode": "600018",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ms Accountant General",
            "Pincode": "600018",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Teynampet",
            "Pincode": "600018",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Teynampet South",
            "Pincode": "600018",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaladipet",
            "Pincode": "600019",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shanmugapuram",
            "Pincode": "600019",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvottiur Central",
            "Pincode": "600019",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvottiyur",
            "Pincode": "600019",
            "City": "Tiruvottiyur",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvottiyur North",
            "Pincode": "600019",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvottiyur West",
            "Pincode": "600019",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Wimconagar",
            "Pincode": "600019",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adyar",
            "Pincode": "600020",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Central Institute Of Tech",
            "Pincode": "600020",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Central Leather Research",
            "Pincode": "600020",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "600020",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Indra Nagar",
            "Pincode": "600020",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kasturbanagar",
            "Pincode": "600020",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sastrinagar",
            "Pincode": "600020",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Technical Teachers Trg In",
            "Pincode": "600020",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Theosophical Society",
            "Pincode": "600020",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cemetry Road",
            "Pincode": "600021",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gollawar Agraharam Road",
            "Pincode": "600021",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Harinarayanapuram",
            "Pincode": "600021",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Korukkupet",
            "Pincode": "600021",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Washermanpeta East",
            "Pincode": "600021",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Washermanpetta",
            "Pincode": "600021",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Raj Bhavan Madras Raja",
            "Pincode": "600022",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayanavaram",
            "Pincode": "600023",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayanavaram Rly Colony",
            "Pincode": "600023",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Solai Street",
            "Pincode": "600023",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arcot Road",
            "Pincode": "600024",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodambakkam",
            "Pincode": "600024",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodambakkam West",
            "Pincode": "600024",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rengarajapuram",
            "Pincode": "600024",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Engineering College Directorat",
            "Pincode": "600025",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadapalani",
            "Pincode": "600026",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madras Air Port",
            "Pincode": "600027",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Minambakkam",
            "Pincode": "600027",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annamalaipuram",
            "Pincode": "600028",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Fore Shore Estate",
            "Pincode": "600028",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "R A Puram Colony",
            "Pincode": "600028",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramakrishnanagar",
            "Pincode": "600028",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aminijikarai",
            "Pincode": "600029",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panchiappas College Hoste",
            "Pincode": "600030",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shenoynagar",
            "Pincode": "600030",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chetput H O",
            "Pincode": "600031",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Harrington Road",
            "Pincode": "600031",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Service Centre",
            "Pincode": "600031",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "World University",
            "Pincode": "600031",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alandur North",
            "Pincode": "600032",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Guindy Ind Estate",
            "Pincode": "600032",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hindustan Teleprinters",
            "Pincode": "600032",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madras Race Course",
            "Pincode": "600032",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumaran Nagar",
            "Pincode": "600033",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mambalam East",
            "Pincode": "600033",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mambalam R S",
            "Pincode": "600033",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettupalayam",
            "Pincode": "600033",
            "City": "Mettupalayam",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "West Mambalam",
            "Pincode": "600033",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Loyla College",
            "Pincode": "600034",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nungambakkam",
            "Pincode": "600034",
            "City": "Thiruvallur",
            "District": "Thiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nungambakkam Bazaar",
            "Pincode": "600034",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nungambakkam High Road",
            "Pincode": "600034",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nandanam",
            "Pincode": "600035",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nandanam Bazaar",
            "Pincode": "600035",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Indian Inst Of Technology",
            "Pincode": "600036",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Offiers Trg School",
            "Pincode": "600037",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "I C F Colony",
            "Pincode": "600038",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vyasarpady",
            "Pincode": "600039",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vysarnagar Colony",
            "Pincode": "600039",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vysarpady Coop Ind Estate",
            "Pincode": "600039",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annanagar",
            "Pincode": "600040",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvanmiyur",
            "Pincode": "600041",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velacheri",
            "Pincode": "600042",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallavaram",
            "Pincode": "600043",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallavaram North",
            "Pincode": "600043",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallavaram South",
            "Pincode": "600043",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajainagar",
            "Pincode": "600043",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bharathipuram",
            "Pincode": "600044",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chromepet",
            "Pincode": "600044",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Negelkeni",
            "Pincode": "600044",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Radhanagar",
            "Pincode": "600044",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tambaram H O",
            "Pincode": "600045",
            "City": "Tambaram",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tambaram West",
            "Pincode": "600045",
            "City": "Tambaram",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ground Training School",
            "Pincode": "600046",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tambaram I A F",
            "Pincode": "600046",
            "City": "Tambaram",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tambaram Sanitorium",
            "Pincode": "600047",
            "City": "Tambaram",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vandalur",
            "Pincode": "600048",
            "City": "Vandalur",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumangalam Road",
            "Pincode": "600049",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villivakkam",
            "Pincode": "600049",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villivakkam North",
            "Pincode": "600049",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villivakkam South",
            "Pincode": "600049",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannurpettai",
            "Pincode": "600050",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padi",
            "Pincode": "600050",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padi South",
            "Pincode": "600050",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madhavaram Milk Colony",
            "Pincode": "600051",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padianallur",
            "Pincode": "600052",
            "City": "Padianallur",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Red Hills",
            "Pincode": "600052",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Red Hills Bazaar",
            "Pincode": "600052",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Regional Engg College",
            "Pincode": "600052",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambattur Bazaar",
            "Pincode": "600053",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambattur H O",
            "Pincode": "600053",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambattur West",
            "Pincode": "600053",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mednambedu",
            "Pincode": "600053",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Orgadam",
            "Pincode": "600053",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Prithivipakkam",
            "Pincode": "600053",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vijayalakshmipuram",
            "Pincode": "600053",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avadi",
            "Pincode": "600054",
            "City": "Avadi",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avadi Camp H O",
            "Pincode": "600054",
            "City": "Avadi",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Central Vehicle Research",
            "Pincode": "600054",
            "City": "Avadi",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avadi Air Force Quarters",
            "Pincode": "600055",
            "City": "Avadi",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avadi Iaf",
            "Pincode": "600055",
            "City": "Avadi",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Central Vehicle Depot",
            "Pincode": "600055",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poonamallee",
            "Pincode": "600056",
            "City": "Poonamallee",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poonamallee East",
            "Pincode": "600056",
            "City": "Poonamallee",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ennur R S",
            "Pincode": "600057",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ennur Thermal Station",
            "Pincode": "600057",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ernavur",
            "Pincode": "600057",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambattur Industrial Estat",
            "Pincode": "600058",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Christian College",
            "Pincode": "600059",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ganapathipuram",
            "Pincode": "600059",
            "City": "Ganapathipuram",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lic Colony Tambaram",
            "Pincode": "600059",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Railway Colony",
            "Pincode": "600059",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tambaram East",
            "Pincode": "600059",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madhavaram",
            "Pincode": "600060",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madhavaram East",
            "Pincode": "600060",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Moolakadai",
            "Pincode": "600060",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pozhal",
            "Pincode": "600060",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naganallur",
            "Pincode": "600061",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naganallur South",
            "Pincode": "600061",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nanganallur Bazaar",
            "Pincode": "600061",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palvanthangal",
            "Pincode": "600061",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thillaiganganagar",
            "Pincode": "600061",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sathyamurthinagar",
            "Pincode": "600062",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Srinivasanagar",
            "Pincode": "600063",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chitlapakkam",
            "Pincode": "600064",
            "City": "Chitlapakkam",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Crp Camp",
            "Pincode": "600065",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadirvedu",
            "Pincode": "600066",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaladipet",
            "Pincode": "600066",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Solavaram",
            "Pincode": "600067",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manali Madras",
            "Pincode": "600068",
            "City": "Manali",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kunnathur Kanchipuram",
            "Pincode": "600069",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anakaputhur",
            "Pincode": "600070",
            "City": "Anakaputhur",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamarajanagar",
            "Pincode": "600071",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattabiram",
            "Pincode": "600072",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattabiram East",
            "Pincode": "600072",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thandarai",
            "Pincode": "600072",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Selaiyur",
            "Pincode": "600073",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Polichalur",
            "Pincode": "600074",
            "City": "Polichalur",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sithathur",
            "Pincode": "600074",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pammal",
            "Pincode": "600075",
            "City": "Pammal",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Korattur R S",
            "Pincode": "600076",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruverkadu",
            "Pincode": "600077",
            "City": "Tiruverkadu",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "K K Nagar",
            "Pincode": "600078",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalignar Karunanidhinagar",
            "Pincode": "600078",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalinga Colony",
            "Pincode": "600078",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bullion Market",
            "Pincode": "600079",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sowcarpet",
            "Pincode": "600079",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Korattur",
            "Pincode": "600080",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mpt Staff Colony",
            "Pincode": "600081",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tondikarpet",
            "Pincode": "600081",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Agaram",
            "Pincode": "600082",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "600082",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajah Thottam",
            "Pincode": "600082",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "600083",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Flowers Road",
            "Pincode": "600084",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gaugadeeswaran Koil",
            "Pincode": "600084",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Purasawakkam",
            "Pincode": "600084",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottur Gram",
            "Pincode": "600085",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottur Madras",
            "Pincode": "600085",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gopalapuram",
            "Pincode": "600086",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alwar Tirunagar",
            "Pincode": "600087",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adambakkam",
            "Pincode": "600088",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ganesh Nagar",
            "Pincode": "600088",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kudlyiruppur",
            "Pincode": "600089",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Besant Nagar",
            "Pincode": "600090",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Besantnagat South",
            "Pincode": "600090",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madipakkam",
            "Pincode": "600091",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virugambakkam",
            "Pincode": "600092",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virugambakkam Bazar",
            "Pincode": "600092",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virugambakkam North",
            "Pincode": "600092",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saligramam",
            "Pincode": "600093",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saligramam South",
            "Pincode": "600093",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Choolaimedu",
            "Pincode": "600094",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Choolaimedu Mdo",
            "Pincode": "600094",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jaffarkhanpet",
            "Pincode": "600095",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perungudi",
            "Pincode": "600096",
            "City": "Perungudi",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Defence Officers Colony",
            "Pincode": "600097",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ekkaduthangal",
            "Pincode": "600097",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sidco Estate",
            "Pincode": "600098",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kolathur-Cpt",
            "Pincode": "600099",
            "City": "Kolathur",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annanagar Western Extn",
            "Pincode": "600101",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annanagar East",
            "Pincode": "600102",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manali New Town",
            "Pincode": "600103",
            "City": "Manali",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "High Court Buildings",
            "Pincode": "600104",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "C-In-C Road",
            "Pincode": "600105",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arumbakkam",
            "Pincode": "600106",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "D G Vaishnav College",
            "Pincode": "600106",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koyambedu",
            "Pincode": "600107",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Broadway",
            "Pincode": "600108",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Railway Car Shed Complex",
            "Pincode": "600109",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponniammanmedu",
            "Pincode": "600110",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sri Ayyappanagar",
            "Pincode": "600111",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ashtabujam Road",
            "Pincode": "600112",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Choolai",
            "Pincode": "600112",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Taramani",
            "Pincode": "600113",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Treaning Institute",
            "Pincode": "600113",
            "City": "Chennai",
            "District": "Chennai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arni Cpt",
            "Pincode": "601101",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periapoliam",
            "Pincode": "601102",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vengal C P T",
            "Pincode": "601103",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannigaipair",
            "Pincode": "601104",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tambaram",
            "Pincode": "601105",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadamadurai",
            "Pincode": "601105",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gummidipundi",
            "Pincode": "601201",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madarpakkam",
            "Pincode": "601202",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Minjur",
            "Pincode": "601203",
            "City": "Minjur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponneri",
            "Pincode": "601204",
            "City": "Ponneri",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponneri Public Offices",
            "Pincode": "601204",
            "City": "Ponneri",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pulicat",
            "Pincode": "601205",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kavarapettai",
            "Pincode": "601206",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arambakkam R S",
            "Pincode": "601207",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupalaivanam",
            "Pincode": "601208",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvellavoyal",
            "Pincode": "601209",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumbedu",
            "Pincode": "601210",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elavur",
            "Pincode": "601211",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Iguvarpalayam",
            "Pincode": "601212",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jothinagar",
            "Pincode": "601213",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devampattu",
            "Pincode": "601214",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padappai",
            "Pincode": "601301",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gowrivakkam",
            "Pincode": "601302",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Old Pallavaram",
            "Pincode": "601303",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manimangalam",
            "Pincode": "601304",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvallur Bazar",
            "Pincode": "602001",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvallur H O",
            "Pincode": "602001",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvallur Netaji Road",
            "Pincode": "602001",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvallur R S",
            "Pincode": "602001",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvallur Sannadhi Stree",
            "Pincode": "602001",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kakalur Ind Estate",
            "Pincode": "602003",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melnallathur",
            "Pincode": "602004",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ikkadu",
            "Pincode": "602021",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pennalurpet",
            "Pincode": "602022",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poondi Tiruvallur",
            "Pincode": "602023",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lakshmipuram",
            "Pincode": "602024",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruninravur",
            "Pincode": "602024",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruninravur R S",
            "Pincode": "602024",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruninrvur",
            "Pincode": "602024",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirur Cpt",
            "Pincode": "602025",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uttukottai",
            "Pincode": "602026",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velliyur",
            "Pincode": "602027",
            "City": "Thiruvallur",
            "District": "Thiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palavakkam",
            "Pincode": "602028",
            "City": "Palavakkam",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seethanjeri",
            "Pincode": "602029",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Polivakkam",
            "Pincode": "602030",
            "City": "Thiruvallur",
            "District": "Thiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalambakkam",
            "Pincode": "602031",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangadu",
            "Pincode": "602101",
            "City": "Mangadu",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maduravoyal",
            "Pincode": "602102",
            "City": "Maduravoyal",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nazarethpettai",
            "Pincode": "602103",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Porur",
            "Pincode": "602104",
            "City": "Porur",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Postal Training Centre",
            "Pincode": "602104",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattunoolchatram",
            "Pincode": "602105",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sriperumbudur",
            "Pincode": "602105",
            "City": "Sriperumbudur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sundekuppan",
            "Pincode": "602106",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumuzhi",
            "Pincode": "602107",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pannur",
            "Pincode": "602108",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Somangalam",
            "Pincode": "602109",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vavalur",
            "Pincode": "602111",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mathur Kanchipuram",
            "Pincode": "602112",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valarpuram",
            "Pincode": "602113",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maduramangalam",
            "Pincode": "602114",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kandoor",
            "Pincode": "602115",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sendamangalam Kanchipuram",
            "Pincode": "602116",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alagesa Nagar",
            "Pincode": "603001",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chengalpattu H O",
            "Pincode": "603001",
            "City": "Chengalpattu",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chengalpattu Medical College",
            "Pincode": "603001",
            "City": "Chengalpattu",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chengalpattu R S",
            "Pincode": "603001",
            "City": "Chengalpattu",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melamaiyur Cpt",
            "Pincode": "603001",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chengalpattu Bazaar",
            "Pincode": "603002",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chengalpattu Bus Stand",
            "Pincode": "603002",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chengalpattu Cutcherry",
            "Pincode": "603002",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gundur Cpt",
            "Pincode": "603002",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Natham-Cpt",
            "Pincode": "603002",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pulipakkam",
            "Pincode": "603011",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athur Cpt",
            "Pincode": "603101",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalpakkam",
            "Pincode": "603102",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupattinam Colony",
            "Pincode": "603102",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rrc Kalpakkam",
            "Pincode": "603102",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sadras",
            "Pincode": "603102",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilambakkam",
            "Pincode": "603103",
            "City": "Thiruvallur",
            "District": "Thiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mamallapuram",
            "Pincode": "603104",
            "City": "Mamallapuram",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manambathi",
            "Pincode": "603105",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Orakkatupettai",
            "Pincode": "603106",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salavakkam",
            "Pincode": "603107",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sembakkam",
            "Pincode": "603108",
            "City": "Sembakkam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukalikundaram",
            "Pincode": "603109",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukalikundaram Bazar",
            "Pincode": "603109",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruporur",
            "Pincode": "603110",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vembakkam",
            "Pincode": "603111",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovalam",
            "Pincode": "603112",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuzhipanthandalam",
            "Pincode": "603113",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nemeli",
            "Pincode": "603114",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nelvoy",
            "Pincode": "603115",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bukkathurai",
            "Pincode": "603116",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thimmavaram",
            "Pincode": "603117",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palur",
            "Pincode": "603118",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chengalpattu",
            "Pincode": "603119",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ozhalur",
            "Pincode": "603120",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Meyyur",
            "Pincode": "603121",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anambakkam",
            "Pincode": "603122",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elapakkam",
            "Pincode": "603201",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Guduvancheri",
            "Pincode": "603202",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kattankolathur",
            "Pincode": "603203",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Singaperumal Koil",
            "Pincode": "603204",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maraimalainagar",
            "Pincode": "603209",
            "City": "Maraimalainagar",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Acharapakkam",
            "Pincode": "603301",
            "City": "Acharapakkam",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Acharapakkam West",
            "Pincode": "603301",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cheyur Cpt",
            "Pincode": "603302",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karunguli",
            "Pincode": "603303",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuddapakkam",
            "Pincode": "603304",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuvathur",
            "Pincode": "603305",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurantakam",
            "Pincode": "603306",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurantakam East",
            "Pincode": "603306",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Senguntharpettai",
            "Pincode": "603306",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Orathi",
            "Pincode": "603307",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padalam",
            "Pincode": "603308",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Polambakkam",
            "Pincode": "603309",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thozhupedu",
            "Pincode": "603310",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Zamin Endathur",
            "Pincode": "603311",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pavunjur",
            "Pincode": "603312",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chithamur",
            "Pincode": "603313",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vedanthangal",
            "Pincode": "603314",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koyapakkam",
            "Pincode": "603315",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Murugambakkam",
            "Pincode": "603316",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilambur",
            "Pincode": "603317",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seevadi",
            "Pincode": "603318",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veeranakunnam",
            "Pincode": "603319",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ananthamangalam",
            "Pincode": "603320",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chunampet",
            "Pincode": "603401",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaliyampundi",
            "Pincode": "603402",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manampathy",
            "Pincode": "603403",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perunagar",
            "Pincode": "603404",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponvilianhakalathur",
            "Pincode": "603405",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uthiramerur",
            "Pincode": "603406",
            "City": "Uthiramerur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kammalampoondi",
            "Pincode": "603407",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "L Endathur",
            "Pincode": "603408",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avarakkam",
            "Pincode": "604001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tindivanam Bazar",
            "Pincode": "604001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tindivanam H O",
            "Pincode": "604001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tindivanam West",
            "Pincode": "604001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tindivanam East",
            "Pincode": "604002",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Akshipakkam",
            "Pincode": "604101",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kiliyanur S A",
            "Pincode": "604102",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thailapuram",
            "Pincode": "604103",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alampoondi",
            "Pincode": "604151",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nallanpillaipetral",
            "Pincode": "604152",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Satyamangalam Sa",
            "Pincode": "604153",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velur S A",
            "Pincode": "604154",
            "City": "Velur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanakkankuppam",
            "Pincode": "604155",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avalurpet",
            "Pincode": "604201",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bazar",
            "Pincode": "604202",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melolakkur",
            "Pincode": "604203",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melmalaiyanur",
            "Pincode": "604204",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Minambur",
            "Pincode": "604205",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallimedupettai",
            "Pincode": "604207",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valathi",
            "Pincode": "604208",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Illodu",
            "Pincode": "604210",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Modaiyur",
            "Pincode": "604212",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naganur",
            "Pincode": "604213",
            "City": "Karur",
            "District": "Karur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Brahmadesam",
            "Pincode": "604301",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kutteripattu",
            "Pincode": "604302",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Markanam",
            "Pincode": "604303",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mailam",
            "Pincode": "604304",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Olakkur",
            "Pincode": "604305",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rettanai",
            "Pincode": "604306",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saram",
            "Pincode": "604307",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anukkavur",
            "Pincode": "604401",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hasanamapettai",
            "Pincode": "604402",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilkodungalur",
            "Pincode": "604403",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilkovalavedu",
            "Pincode": "604404",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marudadu",
            "Pincode": "604405",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tellar",
            "Pincode": "604406",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cutcherry",
            "Pincode": "604407",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvetipuram",
            "Pincode": "604407",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vandavasi",
            "Pincode": "604408",
            "City": "Vandavasi",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vandavasi",
            "Pincode": "604408",
            "City": "Tiruvannamalai",
            "District": "Tiruvannamalai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vandavasi Cutcherry",
            "Pincode": "604408",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vandavasi Cutcherry",
            "Pincode": "604408",
            "City": "Tiruvannamalai",
            "District": "Tiruvannamalai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valikadai",
            "Pincode": "604409",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vembakkam",
            "Pincode": "604410",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilnarma",
            "Pincode": "604412",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Korakkai",
            "Pincode": "604413",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponnur",
            "Pincode": "604414",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elankadu",
            "Pincode": "604415",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Desur",
            "Pincode": "604501",
            "City": "Desur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pernamallur",
            "Pincode": "604503",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumani Arni",
            "Pincode": "604504",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallam Arni",
            "Pincode": "604505",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilpennathur",
            "Pincode": "604601",
            "City": "Kilpennathur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pondicherry Bazaar",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry Courts",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry H O",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry North",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry R S",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry Ho.",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry Ho.",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry Ho.",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry Ho.",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry Ho.",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry Ho.",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry Ho.",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry Ho.",
            "Pincode": "605001",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Sri Arabindo Ashram",
            "Pincode": "605002",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Muthialpet",
            "Pincode": "605003",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Mudaliarpet",
            "Pincode": "605004",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Nellithope",
            "Pincode": "605005",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Dhanvantri Nagar",
            "Pincode": "605006",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Ariyankuppam",
            "Pincode": "605007",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Lawspet",
            "Pincode": "605008",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Thattanchavadi",
            "Pincode": "605009",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Tattanchavadi",
            "Pincode": "605009",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Reddiarpalayam",
            "Pincode": "605010",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Venkata Nagar",
            "Pincode": "605011",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Padmini Nagar",
            "Pincode": "605012",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Padmininagar",
            "Pincode": "605012",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saram",
            "Pincode": "605013",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pondicherry University",
            "Pincode": "605014",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Olugarai",
            "Pincode": "605051",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aroville",
            "Pincode": "605101",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kandamangalam",
            "Pincode": "605102",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koliyanur",
            "Pincode": "605103",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottakuppam",
            "Pincode": "605104",
            "City": "Kottakuppam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mokshakulam",
            "Pincode": "605105",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nettapakkam",
            "Pincode": "605106",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Pallineliyanur",
            "Pincode": "605107",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vanur",
            "Pincode": "605109",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villyanpur",
            "Pincode": "605110",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Kariyamanickam",
            "Pincode": "605113",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "V Mathur",
            "Pincode": "605118",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anantapuram",
            "Pincode": "605201",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anniyur",
            "Pincode": "605202",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanjanur",
            "Pincode": "605203",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanai",
            "Pincode": "605301",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mambalapattu",
            "Pincode": "605302",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kandamanadi",
            "Pincode": "605401",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kedar",
            "Pincode": "605402",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukkanur",
            "Pincode": "605501",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Valudavur",
            "Pincode": "605502",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mundiyambakkam",
            "Pincode": "605601",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamalanagar",
            "Pincode": "605602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maharajapuram",
            "Pincode": "605602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Santhanagopalapuram",
            "Pincode": "605602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "V Marudur",
            "Pincode": "605602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villupuram East",
            "Pincode": "605602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villupuram H O",
            "Pincode": "605602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villupuram West",
            "Pincode": "605602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villupuram South",
            "Pincode": "605604",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "South Arcot",
            "Pincode": "605605",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "South Arcot",
            "Pincode": "605605",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peria Thatchur",
            "Pincode": "605651",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vikravandi",
            "Pincode": "605652",
            "City": "Vikravandi",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pombur",
            "Pincode": "605655",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kandachipuram",
            "Pincode": "605701",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Moongilthuraipattu",
            "Pincode": "605702",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ariyur",
            "Pincode": "605751",
            "City": "Ariyur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arakandanallur",
            "Pincode": "605752",
            "City": "Arakandanallur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilayur S A",
            "Pincode": "605753",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manalurpet",
            "Pincode": "605754",
            "City": "Manalurpet",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Megaiyur",
            "Pincode": "605755",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thapovanam",
            "Pincode": "605756",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Santhapettai",
            "Pincode": "605757",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukkoyilur Bus Stand",
            "Pincode": "605757",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukkoyiylur H O",
            "Pincode": "605757",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukoyilur Bazar",
            "Pincode": "605757",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virapandi S A",
            "Pincode": "605758",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manampoondi",
            "Pincode": "605759",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ariyalur",
            "Pincode": "605801",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadambur S A",
            "Pincode": "605802",
            "City": "Kadambur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sithalingamadam",
            "Pincode": "605803",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvarangam",
            "Pincode": "605805",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vridhachalam",
            "Pincode": "605809",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cutcherry",
            "Pincode": "606001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vriddhachalam Bazar",
            "Pincode": "606001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vriddhachalam H O",
            "Pincode": "606001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vriddhalchalam",
            "Pincode": "606001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vridhachalam West",
            "Pincode": "606001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vridhachalam R S",
            "Pincode": "606002",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Budamur",
            "Pincode": "606003",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalamarudur",
            "Pincode": "606102",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kammapuram",
            "Pincode": "606103",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangalam S A",
            "Pincode": "606104",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pennadam",
            "Pincode": "606105",
            "City": "Pennadam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tittagudi",
            "Pincode": "606106",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ullunderpet",
            "Pincode": "606107",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ulunderpet Bus Stand",
            "Pincode": "606107",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karuveppilankurichi",
            "Pincode": "606110",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pannadam R S",
            "Pincode": "606111",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avinangudi",
            "Pincode": "606112",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padur",
            "Pincode": "606115",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mukhasaparur",
            "Pincode": "606120",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sirupakkam",
            "Pincode": "606123",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnasalem",
            "Pincode": "606201",
            "City": "Chinnasalem",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Emapper",
            "Pincode": "606202",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallakurichi Bazaar",
            "Pincode": "606202",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallakurichi H O",
            "Pincode": "606202",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallakurichi South",
            "Pincode": "606202",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagalur S A",
            "Pincode": "606203",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pukkiravari",
            "Pincode": "606204",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rishivandiyam",
            "Pincode": "606205",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiyagadrug",
            "Pincode": "606206",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakkanendal",
            "Pincode": "606207",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Murarbad",
            "Pincode": "606208",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cholampattu",
            "Pincode": "606221",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilambur",
            "Pincode": "606223",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nainarpalayam",
            "Pincode": "606301",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nallur S A",
            "Pincode": "606302",
            "City": "Nallur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Toludur",
            "Pincode": "606303",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veppur S A",
            "Pincode": "606304",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Asanur",
            "Pincode": "606305",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koothakudi",
            "Pincode": "606307",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kothakudi",
            "Pincode": "606307",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankarapuram",
            "Pincode": "606401",
            "City": "Sankarapuram",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pandalam",
            "Pincode": "606402",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvannamalai Bazar",
            "Pincode": "606601",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvannamalai H O",
            "Pincode": "606601",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilnathur",
            "Pincode": "606602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvannamalai R S",
            "Pincode": "606602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sri Ramanashraman",
            "Pincode": "606603",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vengikal",
            "Pincode": "606604",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Somasopadi",
            "Pincode": "606611",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chengam",
            "Pincode": "606701",
            "City": "Chengam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanji",
            "Pincode": "606702",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melpallipattu",
            "Pincode": "606703",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupalayam Na",
            "Pincode": "606705",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sathanur Dam",
            "Pincode": "606706",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tandarampattu",
            "Pincode": "606707",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tanipadi",
            "Pincode": "606708",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thukkapettai",
            "Pincode": "606709",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paramandal",
            "Pincode": "606710",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melchengam",
            "Pincode": "606711",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilsirupakkam",
            "Pincode": "606712",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melvanakkambadi",
            "Pincode": "606713",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thenmudiyanur",
            "Pincode": "606714",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "S I Sorpanandal",
            "Pincode": "606715",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Taradapattu",
            "Pincode": "606716",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilvanakkambadi",
            "Pincode": "606717",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sathanur",
            "Pincode": "606718",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalasapakkam",
            "Pincode": "606751",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangalam N A",
            "Pincode": "606752",
            "City": "Mangalam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vanapuram",
            "Pincode": "606753",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vettavalam",
            "Pincode": "606754",
            "City": "Vettavalam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chettupattu Polur",
            "Pincode": "606801",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nayudumangalam",
            "Pincode": "606802",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Polur",
            "Pincode": "606803",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Polur",
            "Pincode": "606803",
            "City": "Polur",
            "District": "Tiruvannamalai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Polur Town",
            "Pincode": "606803",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Polur Town",
            "Pincode": "606803",
            "City": "Tiruvannamalai",
            "District": "Tiruvannamalai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tandarai",
            "Pincode": "606804",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Turinjapuram",
            "Pincode": "606805",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pavitram",
            "Pincode": "606806",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nedungunam",
            "Pincode": "606807",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narthampoondi",
            "Pincode": "606809",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Andampallam",
            "Pincode": "606810",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adamangalam",
            "Pincode": "606901",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devikapuram",
            "Pincode": "606902",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalambur",
            "Pincode": "606903",
            "City": "Kalambur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mandakolathur",
            "Pincode": "606904",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Santhavasai",
            "Pincode": "606905",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilvarani",
            "Pincode": "606906",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadamathimangalam",
            "Pincode": "606907",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadaladi N A",
            "Pincode": "606908",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kasthampadi",
            "Pincode": "606909",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kettavarampalayam",
            "Pincode": "606910",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gangavaram",
            "Pincode": "606911",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mansurabad",
            "Pincode": "606912",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellur",
            "Pincode": "606914",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bharathi Road",
            "Pincode": "607001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cuddalore Court Building",
            "Pincode": "607001",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cuddalore H O",
            "Pincode": "607001",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cuddalore Public Offices",
            "Pincode": "607001",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Fort Saint David",
            "Pincode": "607001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manjakuppam",
            "Pincode": "607001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marisusainagar",
            "Pincode": "607001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupalayam",
            "Pincode": "607001",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seemandalam",
            "Pincode": "607001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veenugopalapuram",
            "Pincode": "607001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilvarayanatham",
            "Pincode": "607001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruppadiraipuliyur",
            "Pincode": "607002",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruppadiraipuliyur Bazar",
            "Pincode": "607002",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cuddalore O T",
            "Pincode": "607003",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cuddalore Ot Bazaar",
            "Pincode": "607003",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cuddalore Port",
            "Pincode": "607003",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seemanthottam",
            "Pincode": "607003",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vandipaliyam",
            "Pincode": "607004",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pachayankuppam",
            "Pincode": "607051",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anathur",
            "Pincode": "607101",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnappanaickenpalayam",
            "Pincode": "607102",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadambuliyur",
            "Pincode": "607103",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melpattambakkam",
            "Pincode": "607104",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nellikuppam",
            "Pincode": "607105",
            "City": "Nellikuppam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nellikuppam Bazaar",
            "Pincode": "607105",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panruti",
            "Pincode": "607106",
            "City": "Panruti",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panruti Bazar",
            "Pincode": "607106",
            "City": "Panruti",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panruti East",
            "Pincode": "607106",
            "City": "Panruti",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panruti West",
            "Pincode": "607106",
            "City": "Panruti",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perangiyur",
            "Pincode": "607107",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthupet",
            "Pincode": "607108",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Varkalpattu",
            "Pincode": "607109",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elaiyapuram",
            "Pincode": "607111",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eruvelipattu",
            "Pincode": "607111",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Iruvelipattu",
            "Pincode": "607111",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palur",
            "Pincode": "607113",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Oraiyur",
            "Pincode": "607116",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eraiyur",
            "Pincode": "607201",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elavanasur",
            "Pincode": "607202",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvennainallur",
            "Pincode": "607203",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunallur",
            "Pincode": "607204",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madapattu",
            "Pincode": "607207",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kullanchavadi",
            "Pincode": "607301",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurinjipadi",
            "Pincode": "607302",
            "City": "Kurinjipadi",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurinjipadi Bazaar",
            "Pincode": "607302",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thondamanatham",
            "Pincode": "607305",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vahakollai",
            "Pincode": "607307",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvendipuram",
            "Pincode": "607401",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bahoor",
            "Pincode": "607402",
            "City": "Pondicherry",
            "District": "Pondicherry",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Neyveli Block 1",
            "Pincode": "607801",
            "City": "Neyveli",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli Block 10",
            "Pincode": "607801",
            "City": "Neyveli",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli Block 24",
            "Pincode": "607801",
            "City": "Neyveli",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli Block 3",
            "Pincode": "607801",
            "City": "Neyveli",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli Town Ship",
            "Pincode": "607801",
            "City": "Neyveli",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli",
            "Pincode": "607802",
            "City": "Neyveli",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli R S",
            "Pincode": "607802",
            "City": "Neyveli",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thandavankuppam",
            "Pincode": "607802",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli Block 19",
            "Pincode": "607803",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli Block 27",
            "Pincode": "607803",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli General Hospital",
            "Pincode": "607803",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli Thermal Bus Stand",
            "Pincode": "607803",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aziz Nagar",
            "Pincode": "607804",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Oomangalam",
            "Pincode": "607804",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perperiyankuppam",
            "Pincode": "607805",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyveli Block 29",
            "Pincode": "607807",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chidambaram",
            "Pincode": "608001",
            "City": "Chidambaram",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chidambaram East",
            "Pincode": "608001",
            "City": "Chidambaram",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chidambaram H O",
            "Pincode": "608001",
            "City": "Chidambaram",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chidambaram R S",
            "Pincode": "608001",
            "City": "Chidambaram",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chidambaram South",
            "Pincode": "608001",
            "City": "Chidambaram",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chidambaram West",
            "Pincode": "608001",
            "City": "Chidambaram",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cutcherry",
            "Pincode": "608001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanagasabainagar",
            "Pincode": "608001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annamalai University",
            "Pincode": "608002",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annamalainagar",
            "Pincode": "608002",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Killai",
            "Pincode": "608102",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Orathur",
            "Pincode": "608201",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kattumannarkoil",
            "Pincode": "608301",
            "City": "Kattumannarkoil",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Komaratchi",
            "Pincode": "608302",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lalpet",
            "Pincode": "608303",
            "City": "Lalpet",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Reddiyur",
            "Pincode": "608304",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Nedunjeri",
            "Pincode": "608305",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallampadugai",
            "Pincode": "608401",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "B Mutlur",
            "Pincode": "608501",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Parangipettai",
            "Pincode": "608502",
            "City": "Parangipettai",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Small Bazaar",
            "Pincode": "608502",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bhuvanagiri",
            "Pincode": "608601",
            "City": "Bhuvanagiri",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Keerapalayam",
            "Pincode": "608602",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palayamkottai S A",
            "Pincode": "608701",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Settiatope",
            "Pincode": "608702",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Srimushnam",
            "Pincode": "608703",
            "City": "Srimushnam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pinnalur",
            "Pincode": "608704",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alapakkam",
            "Pincode": "608801",
            "City": "Alapakkam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thaigavalli",
            "Pincode": "608803",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kavarapalayam",
            "Pincode": "608901",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lalbahadur Nagar",
            "Pincode": "609001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mayiladuthrai Bazaar",
            "Pincode": "609001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mayiladuthurai Cutcherry",
            "Pincode": "609001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mayiladuthurai H O",
            "Pincode": "609001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mayiladuthurai South",
            "Pincode": "609001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattamangulam",
            "Pincode": "609001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tharamapuram",
            "Pincode": "609001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koranad",
            "Pincode": "609002",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chittakadu",
            "Pincode": "609003",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koothanur",
            "Pincode": "609003",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mayiladuthurai R S",
            "Pincode": "609003",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Achalpuram",
            "Pincode": "609101",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anaikaranchatram",
            "Pincode": "609102",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kiliyanur Thanjavur",
            "Pincode": "609102",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anandatandavapuram",
            "Pincode": "609103",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mayiladuthurcai",
            "Pincode": "609103",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadavasal",
            "Pincode": "609104",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaveripattinam Thanjavur",
            "Pincode": "609105",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangamadam",
            "Pincode": "609106",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melaiyur",
            "Pincode": "609107",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sattanathapuram",
            "Pincode": "609109",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sirkali East",
            "Pincode": "609110",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sirkali H O",
            "Pincode": "609110",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thenpathi",
            "Pincode": "609111",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupangur",
            "Pincode": "609112",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumullavasal",
            "Pincode": "609113",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvengadu",
            "Pincode": "609114",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Varsaipattu Vadagal",
            "Pincode": "609115",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valluvakudi",
            "Pincode": "609116",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vaitheeswaran Koil",
            "Pincode": "609117",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Solasakkaranallur",
            "Pincode": "609118",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kunnam Mayiladutwai",
            "Pincode": "609119",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pagasalai",
            "Pincode": "609120",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madanam",
            "Pincode": "609121",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunagari",
            "Pincode": "609122",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vanagiri",
            "Pincode": "609123",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaimedu",
            "Pincode": "609124",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annaperumal Koil",
            "Pincode": "609125",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vettangudi",
            "Pincode": "609126",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madervelur",
            "Pincode": "609127",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arapallam",
            "Pincode": "609128",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alakudi",
            "Pincode": "609129",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palayapalayam",
            "Pincode": "609130",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Edamanal",
            "Pincode": "609131",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ilanthope",
            "Pincode": "609201",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manalmedu",
            "Pincode": "609202",
            "City": "Manalmedu",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nidur",
            "Pincode": "609203",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumenir Koil",
            "Pincode": "609204",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Akkur",
            "Pincode": "609301",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arangakudi",
            "Pincode": "609302",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thovala",
            "Pincode": "609302",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayappadi",
            "Pincode": "609303",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilaiyur Mayiladuthuai",
            "Pincode": "609304",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannampandal",
            "Pincode": "609305",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nalladai",
            "Pincode": "609306",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Porayar",
            "Pincode": "609307",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankaranpandal",
            "Pincode": "609308",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sembanarkoil",
            "Pincode": "609309",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thillayadi",
            "Pincode": "609310",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirucadaiyur",
            "Pincode": "609311",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukkalacheri",
            "Pincode": "609312",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tranuebar",
            "Pincode": "609313",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakarai",
            "Pincode": "609314",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elanthangudi",
            "Pincode": "609401",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kollumangudi",
            "Pincode": "609403",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manganallur Bazaar",
            "Pincode": "609404",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peralam",
            "Pincode": "609405",
            "City": "Peralam",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perambur Mayiladuthurai",
            "Pincode": "609406",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eravancheri",
            "Pincode": "609501",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mudikondan",
            "Pincode": "609502",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Punthottam",
            "Pincode": "609503",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sannanallur",
            "Pincode": "609504",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvizhimazhalai",
            "Pincode": "609505",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vishnupuram",
            "Pincode": "609506",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manandakudi",
            "Pincode": "609507",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marudavancheri",
            "Pincode": "609508",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambagarathur",
            "Pincode": "609601",
            "City": "Karaikal",
            "District": "Karaikal",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Ambagarathur",
            "Pincode": "609601",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaikal",
            "Pincode": "609602",
            "City": "Karaikal",
            "District": "Karaikal",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Karikal",
            "Pincode": "609602",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karikal Bazaar",
            "Pincode": "609602",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karikal Bus Stand",
            "Pincode": "609602",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karikal South",
            "Pincode": "609602",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chittakadu",
            "Pincode": "609603",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nedungadu",
            "Pincode": "609603",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neravy",
            "Pincode": "609604",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thalatheru",
            "Pincode": "609605",
            "City": "Karaikal",
            "District": "Karaikal",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Thalatheru",
            "Pincode": "609605",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumalarayanpattanam",
            "Pincode": "609606",
            "City": "Karaikal",
            "District": "Karaikal",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Tirumalrayanpattinam",
            "Pincode": "609606",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunallar",
            "Pincode": "609607",
            "City": "Karaikal",
            "District": "Karaikal",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Kollapuram",
            "Pincode": "609608",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottucherry",
            "Pincode": "609609",
            "City": "Karaikal",
            "District": "Karaikal",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Kottucherry",
            "Pincode": "609609",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Varichikudi",
            "Pincode": "609610",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Enanguddi",
            "Pincode": "609701",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumarugal",
            "Pincode": "609702",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tittacherry",
            "Pincode": "609703",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukannapuram",
            "Pincode": "609704",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seshamoolai",
            "Pincode": "609705",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuttalam",
            "Pincode": "609801",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuttalam East",
            "Pincode": "609801",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narasingamettai",
            "Pincode": "609802",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvaduthurai",
            "Pincode": "609803",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tuhili",
            "Pincode": "609804",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Komal",
            "Pincode": "609805",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Malliam",
            "Pincode": "609806",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pandanallur",
            "Pincode": "609807",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Teizhandur",
            "Pincode": "609808",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamakshipuram",
            "Pincode": "609809",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvalgadu",
            "Pincode": "609810",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kali",
            "Pincode": "609811",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vandahirajapuram",
            "Pincode": "609812",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumancheri",
            "Pincode": "609813",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Konulampallam",
            "Pincode": "609814",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiruvarur H O",
            "Pincode": "610001",
            "City": "Thiruvarur",
            "District": "Thiruvarur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiruvarur R S",
            "Pincode": "610001",
            "City": "Thiruvarur",
            "District": "Thiruvarur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dakshinamurthy Mutt",
            "Pincode": "610002",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiruvarur Cutcherry",
            "Pincode": "610002",
            "City": "Thiruvarur",
            "District": "Thiruvarur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiruvarur North",
            "Pincode": "610002",
            "City": "Thiruvarur",
            "District": "Thiruvarur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elavangarkudi",
            "Pincode": "610051",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kangalancheri",
            "Pincode": "610101",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamalapuram",
            "Pincode": "610102",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangudi",
            "Pincode": "610103",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manakkal Ayyampet",
            "Pincode": "610104",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nannilam",
            "Pincode": "610105",
            "City": "Nannilam",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nannilam Cutchery",
            "Pincode": "610105",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tappalampuliyur",
            "Pincode": "610106",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvidacherry",
            "Pincode": "610107",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pulivalam Thanjavur",
            "Pincode": "610109",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Srivanjiam",
            "Pincode": "610110",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Suranur",
            "Pincode": "610111",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thirukkannamangai",
            "Pincode": "610112",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kankoduthavanitham",
            "Pincode": "610113",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Budamangalam",
            "Pincode": "610114",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anaikuppam",
            "Pincode": "610115",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadagudi",
            "Pincode": "610116",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kachanam",
            "Pincode": "610201",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mavoor",
            "Pincode": "610202",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponnirai",
            "Pincode": "610203",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukuvalai",
            "Pincode": "610204",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunellikaval",
            "Pincode": "610205",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruneveli",
            "Pincode": "610205",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadapathimangalam",
            "Pincode": "610206",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valivalam",
            "Pincode": "610207",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kolapadu",
            "Pincode": "610208",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pullamangalam",
            "Pincode": "610209",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manali Ttp",
            "Pincode": "610210",
            "City": "Manali",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alathampadi",
            "Pincode": "610211",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ettukudi",
            "Pincode": "610212",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melakottaivasal",
            "Pincode": "611001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagapattinam Bazaar",
            "Pincode": "611001",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagapattinam Beach",
            "Pincode": "611001",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagapattinam City",
            "Pincode": "611001",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagapattinam H O",
            "Pincode": "611001",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagapattinam North",
            "Pincode": "611001",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagapattinam Public Offic",
            "Pincode": "611001",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velipalayam",
            "Pincode": "611001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Durga Sheriff",
            "Pincode": "611002",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagore South",
            "Pincode": "611002",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagore-Tnj",
            "Pincode": "611002",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadagudi Chatram",
            "Pincode": "611002",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adaikkamangalam",
            "Pincode": "611101",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Andanapettai",
            "Pincode": "611102",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilayur Nagapattinam",
            "Pincode": "611103",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilvelur",
            "Pincode": "611104",
            "City": "Kilvelur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuthur",
            "Pincode": "611105",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manjakollai",
            "Pincode": "611106",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paravachary",
            "Pincode": "611108",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sikkal Thanjavur",
            "Pincode": "611108",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thevur Thanjavur",
            "Pincode": "611109",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupandi",
            "Pincode": "611110",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vailankanni",
            "Pincode": "611111",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vailankanni West",
            "Pincode": "611111",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vettaikaraniruppu",
            "Pincode": "611112",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Prathaparamapuram",
            "Pincode": "611113",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Therku Pogainallur",
            "Pincode": "611114",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakku",
            "Pincode": "611115",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakku Poigainallur",
            "Pincode": "611115",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athipuliyur",
            "Pincode": "611116",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aliyur",
            "Pincode": "611117",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilundamvadi",
            "Pincode": "611119",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Banadurai",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cutcherry",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kombakonam",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumbakonam Bazar",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumbakonam City",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumbakonam East",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumbakonam H O",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumbakonam Market",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumbakonam R S",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumbakonam South",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumbakonam West",
            "Pincode": "612001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melakaveri H O",
            "Pincode": "612002",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aduthurai",
            "Pincode": "612101",
            "City": "Perambalur",
            "District": "Perambalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumangalakudi",
            "Pincode": "612102",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur",
            "Pincode": "612103",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvidaimarudur",
            "Pincode": "612104",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veppathur",
            "Pincode": "612105",
            "City": "Veppathur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadiramangalam",
            "Pincode": "612106",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avaniapuram",
            "Pincode": "612107",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunilakudi",
            "Pincode": "612108",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palakudi",
            "Pincode": "612109",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvesaloor",
            "Pincode": "612110",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Konerirajapuram",
            "Pincode": "612201",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadamattam",
            "Pincode": "612201",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Murugangudi",
            "Pincode": "612202",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palaiyur",
            "Pincode": "612203",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunageswaram",
            "Pincode": "612204",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sengaramkudipudur",
            "Pincode": "612205",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tepperumanallur",
            "Pincode": "612206",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pullabudangudi",
            "Pincode": "612301",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Swammimalai",
            "Pincode": "612302",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruppirambiyur",
            "Pincode": "612303",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvaikavur",
            "Pincode": "612304",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sakkottai",
            "Pincode": "612401",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tippirajapuram",
            "Pincode": "612402",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koranattukaruppur",
            "Pincode": "612501",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lower Anaicut",
            "Pincode": "612502",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sholapuram",
            "Pincode": "612503",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupanandal",
            "Pincode": "612504",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devanacheri",
            "Pincode": "612505",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Niraihanallur",
            "Pincode": "612506",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodavasal",
            "Pincode": "612601",
            "City": "Kodavasal",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nachiarkoil",
            "Pincode": "612602",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sembangudi",
            "Pincode": "612603",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sengalipuram",
            "Pincode": "612604",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchirai",
            "Pincode": "612605",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vidayal Karuppur",
            "Pincode": "612606",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadaver",
            "Pincode": "612607",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudukudi",
            "Pincode": "612608",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kandramanickam",
            "Pincode": "612609",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avoor",
            "Pincode": "612701",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Darasuram",
            "Pincode": "612702",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Patteeswaram",
            "Pincode": "612703",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Govindakudi",
            "Pincode": "612704",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alangudi",
            "Pincode": "612801",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Haridwaramangalam",
            "Pincode": "612802",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puvanur",
            "Pincode": "612803",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valangaman",
            "Pincode": "612804",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valangaman West",
            "Pincode": "612804",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chandrasekarapuram",
            "Pincode": "612805",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Odayalur",
            "Pincode": "612806",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rayapuram Tnj",
            "Pincode": "612807",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gangaikondapuram",
            "Pincode": "612901",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodalikaruppur",
            "Pincode": "612902",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Minsurutti",
            "Pincode": "612903",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thattanpettaipalur",
            "Pincode": "612904",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ulkottai",
            "Pincode": "612905",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Irudhayapuram",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manambu Chavadi",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjauvur South",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur Bazar",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur Bus Stand",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur City",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur Collectorate",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur East",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur East Gate",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur H O",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur Irwin Bridge",
            "Pincode": "613001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karunthattangudi",
            "Pincode": "613002",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vannar Bank",
            "Pincode": "613003",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur Medical College",
            "Pincode": "613004",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Raja Serfoji Govt College",
            "Pincode": "613005",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur P&T Colony",
            "Pincode": "613006",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajappanagar",
            "Pincode": "613007",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur Coop Hsg Colony",
            "Pincode": "613007",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "V O C Nagar",
            "Pincode": "613007",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur North Gate",
            "Pincode": "613008",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Co Operative Buildings",
            "Pincode": "613009",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur",
            "Pincode": "613009",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur North",
            "Pincode": "613009",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur West",
            "Pincode": "613009",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanathapuram Tnj",
            "Pincode": "613051",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilar",
            "Pincode": "613052",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palliagraharam",
            "Pincode": "613053",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Inayuthukkanpatti",
            "Pincode": "613054",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nadukaveri",
            "Pincode": "613101",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thogur",
            "Pincode": "613102",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupanthuruthi",
            "Pincode": "613103",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukattupalli",
            "Pincode": "613104",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukattupalli East",
            "Pincode": "613104",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poondi Tirukattupalli",
            "Pincode": "613105",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koviladi",
            "Pincode": "613106",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Renganathapuram",
            "Pincode": "613107",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Konerirajapuram",
            "Pincode": "613108",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Varagur",
            "Pincode": "613109",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kachamangalam",
            "Pincode": "613110",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalyanapuram",
            "Pincode": "613201",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kandiyur",
            "Pincode": "613202",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thillaisthanam",
            "Pincode": "613203",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvaiyaru",
            "Pincode": "613204",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvaiyura North",
            "Pincode": "613204",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vediapuram",
            "Pincode": "613205",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maharajapuram",
            "Pincode": "613206",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponavasal",
            "Pincode": "613207",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandharvakottai",
            "Pincode": "613301",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilur Thanjavur",
            "Pincode": "613302",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karungalpalayam",
            "Pincode": "613303",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karungulammelpatti",
            "Pincode": "613303",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurungulam Melpathi",
            "Pincode": "613303",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Raghunathapuram Tnj",
            "Pincode": "613304",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadampatti",
            "Pincode": "613305",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukanur Patti",
            "Pincode": "613307",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "M G M Sanatorium",
            "Pincode": "613401",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sengipatti",
            "Pincode": "613402",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallam Bazar",
            "Pincode": "613403",
            "City": "Vallam",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallam Thanjavur",
            "Pincode": "613403",
            "City": "Vallam",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mariammankoil",
            "Pincode": "613501",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pundi Thanjavur",
            "Pincode": "613502",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sir Pushpam College",
            "Pincode": "613503",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salimangalam",
            "Pincode": "613504",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Irumburthalai",
            "Pincode": "613505",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalancheri",
            "Pincode": "613506",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alakudi",
            "Pincode": "613601",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Budalur",
            "Pincode": "613602",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallaperambur",
            "Pincode": "613603",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammayappan",
            "Pincode": "613701",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athikadai",
            "Pincode": "613702",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koradacheri",
            "Pincode": "613703",
            "City": "Koradacheri",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulikarai",
            "Pincode": "613704",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sellur",
            "Pincode": "613705",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Abiviethiswaram",
            "Pincode": "613706",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Barakadabad",
            "Pincode": "613707",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannaraguid H O",
            "Pincode": "614001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannargudi Bazaar",
            "Pincode": "614001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannarguid Cutcherry",
            "Pincode": "614001",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Handranadi",
            "Pincode": "614012",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idangankottai Melaiyur",
            "Pincode": "614013",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pamani",
            "Pincode": "614014",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pamani",
            "Pincode": "614014",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paravakottai",
            "Pincode": "614015",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Serangoiam",
            "Pincode": "614016",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumakkottai",
            "Pincode": "614017",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadavur",
            "Pincode": "614019",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Painganadu",
            "Pincode": "614020",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karuvakurichi",
            "Pincode": "614021",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koopachikottai",
            "Pincode": "614022",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mukkulam Sathanur",
            "Pincode": "614023",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Serimangalam",
            "Pincode": "614024",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Solapandi",
            "Pincode": "614025",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vandayaniruppu",
            "Pincode": "614026",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peraiyur",
            "Pincode": "614027",
            "City": "Peraiyur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupalakudi",
            "Pincode": "614028",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mahadevapattinam",
            "Pincode": "614029",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilakurichi",
            "Pincode": "614030",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallur",
            "Pincode": "614031",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koothanallur",
            "Pincode": "614101",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lakshmangudi",
            "Pincode": "614102",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Podakudi",
            "Pincode": "614103",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayyampet",
            "Pincode": "614201",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayyampet Bazaar",
            "Pincode": "614201",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kabisthalam",
            "Pincode": "614203",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pandaravadai",
            "Pincode": "614204",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Papanasam Bazar",
            "Pincode": "614205",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Papanasam H O",
            "Pincode": "614205",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Papanasam North",
            "Pincode": "614205",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Papanasam Public Offices",
            "Pincode": "614205",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pasupathikoil",
            "Pincode": "614206",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajaghiri",
            "Pincode": "614207",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sunderaperumalkoil",
            "Pincode": "614208",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Umayalpuram",
            "Pincode": "614209",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valoothoor T J",
            "Pincode": "614210",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chakrapalli",
            "Pincode": "614211",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ullikadai",
            "Pincode": "614212",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uthamadanapuram",
            "Pincode": "614213",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melattur",
            "Pincode": "614301",
            "City": "Melattur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukaragavur",
            "Pincode": "614302",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakku Mangudi",
            "Pincode": "614303",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammapet",
            "Pincode": "614401",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kokkeri",
            "Pincode": "614402",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilvenni",
            "Pincode": "614403",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nidamangalam",
            "Pincode": "614404",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arundavapuram",
            "Pincode": "614405",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peramburnidamangalam",
            "Pincode": "614406",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Munnavalkollai",
            "Pincode": "614407",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattukottai Bazar",
            "Pincode": "614601",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattukottai H O",
            "Pincode": "614601",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattukottai West",
            "Pincode": "614601",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thangavelnagar",
            "Pincode": "614601",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nadimuthunagar",
            "Pincode": "614602",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Srinivasapuram",
            "Pincode": "614602",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaikottai",
            "Pincode": "614612",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perimagalur",
            "Pincode": "614612",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tamarankottai",
            "Pincode": "614613",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvonam",
            "Pincode": "614614",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aladikumulai",
            "Pincode": "614615",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arantagi",
            "Pincode": "614616",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammapattinam",
            "Pincode": "614617",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avadayarkoil",
            "Pincode": "614618",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottaipattinam",
            "Pincode": "614619",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manamelkudi",
            "Pincode": "614620",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mimisal",
            "Pincode": "614621",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Silathur",
            "Pincode": "614622",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avanam",
            "Pincode": "614623",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mukthambal Chatram",
            "Pincode": "614625",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Orathanad",
            "Pincode": "614625",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Orattanad South",
            "Pincode": "614625",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Keeramangalam",
            "Pincode": "614626",
            "City": "Keeramangalam",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pappanad",
            "Pincode": "614626",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumangalakottai",
            "Pincode": "614627",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchitrambalam",
            "Pincode": "614628",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponbethi",
            "Pincode": "614629",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Attani",
            "Pincode": "614630",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uranipuram",
            "Pincode": "614631",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Okkanad Kilaiyur",
            "Pincode": "614632",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chidambaraviduthi",
            "Pincode": "614633",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Edayathimangalam",
            "Pincode": "614634",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jagadapattinam",
            "Pincode": "614635",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Venkarai East",
            "Pincode": "614636",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallakottai",
            "Pincode": "614637",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattukottai",
            "Pincode": "614638",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adambai",
            "Pincode": "614639",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnarajipattinam",
            "Pincode": "614640",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Brahmanavayal",
            "Pincode": "614641",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupunavasal",
            "Pincode": "614642",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Singavanam",
            "Pincode": "614643",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumarudur",
            "Pincode": "614644",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiyathur",
            "Pincode": "614645",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arantangi Fort",
            "Pincode": "614647",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adirampattinam",
            "Pincode": "614701",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adirampattinam Town",
            "Pincode": "614701",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idaiyur",
            "Pincode": "614702",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kunnalur",
            "Pincode": "614703",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Movilur-Mtu",
            "Pincode": "614704",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muttupet-Town",
            "Pincode": "614704",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mutupet",
            "Pincode": "614704",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rettai-Mtu",
            "Pincode": "614704",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peruvazhandan",
            "Pincode": "614705",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udayamarthandapuram",
            "Pincode": "614706",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sethi",
            "Pincode": "614707",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottur",
            "Pincode": "614708",
            "City": "Kottur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manakudi",
            "Pincode": "614709",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naduvakalappal",
            "Pincode": "614710",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruturaipoondi",
            "Pincode": "614711",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Talanagar Agraharam",
            "Pincode": "614712",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruthuraipundi Bazar",
            "Pincode": "614713",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruthuraipundi H O",
            "Pincode": "614713",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruthuraipundi West",
            "Pincode": "614713",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruthuraipunndi R S",
            "Pincode": "614713",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Takattur",
            "Pincode": "614714",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilakudi",
            "Pincode": "614715",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kattimodu",
            "Pincode": "614716",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adichapuram",
            "Pincode": "614717",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannaragudi",
            "Pincode": "614719",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukalar",
            "Pincode": "614720",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maravakadu",
            "Pincode": "614721",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajamadam",
            "Pincode": "614722",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mallipattinam",
            "Pincode": "614723",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velur T T Pundi",
            "Pincode": "614724",
            "City": "Velur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadinavayal",
            "Pincode": "614725",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodinavayal",
            "Pincode": "614725",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vaduvanchery",
            "Pincode": "614726",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thulajapattinam",
            "Pincode": "614727",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sithamalli",
            "Pincode": "614728",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thillai Vilagam",
            "Pincode": "614729",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Nelakadu",
            "Pincode": "614730",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tambikottai Melakadu",
            "Pincode": "614730",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilakadu",
            "Pincode": "614731",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karuppanpulam",
            "Pincode": "614732",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Korukkai",
            "Pincode": "614733",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adanur Pattukkottai",
            "Pincode": "614734",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idumbavanam",
            "Pincode": "614735",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Keerakalur",
            "Pincode": "614736",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tambikottai",
            "Pincode": "614737",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jambavanodai",
            "Pincode": "614738",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arasarkulam",
            "Pincode": "614801",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuruvikarambai",
            "Pincode": "614802",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ottangadu",
            "Pincode": "614803",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peravurni",
            "Pincode": "614804",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peravurni Bazaar",
            "Pincode": "614804",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Subramaniapuram Tnj",
            "Pincode": "614805",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kariyapattinam",
            "Pincode": "614806",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodikarai",
            "Pincode": "614807",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuruvapulam",
            "Pincode": "614808",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Topputhurai",
            "Pincode": "614809",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vedaraniyam",
            "Pincode": "614810",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vedarniyam East",
            "Pincode": "614810",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sethi",
            "Pincode": "614811",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thethakudi Vadakku",
            "Pincode": "614811",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Katirpulam",
            "Pincode": "614812",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arkattuthurai",
            "Pincode": "614813",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poonaikuthikadu",
            "Pincode": "614814",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chettipulam",
            "Pincode": "614815",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalathur",
            "Pincode": "614816",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sethi",
            "Pincode": "614817",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sembagarayanallur",
            "Pincode": "614818",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjavur",
            "Pincode": "614820",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodiyakadu",
            "Pincode": "614821",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kudiakkadu",
            "Pincode": "614821",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pushpavanam",
            "Pincode": "614822",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alathur",
            "Pincode": "614901",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottaitheru",
            "Pincode": "614902",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madukkur",
            "Pincode": "614903",
            "City": "Madukkur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madukkur Bazar",
            "Pincode": "614903",
            "City": "Madukkur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melaulur",
            "Pincode": "614904",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadasseri",
            "Pincode": "614905",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nattuchalai",
            "Pincode": "614906",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilaiyur",
            "Pincode": "614908",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Kilaiyur",
            "Pincode": "614908",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannanagadu",
            "Pincode": "614909",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kasankadu",
            "Pincode": "614910",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kasanadupudur",
            "Pincode": "614911",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poyyandankottai",
            "Pincode": "614912",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pinnaiyur",
            "Pincode": "614913",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalyanaodai",
            "Pincode": "614914",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Siramelkudi",
            "Pincode": "614915",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bheema Nagar",
            "Pincode": "620001",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "620001",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponnagar",
            "Pincode": "620001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponniah School Building",
            "Pincode": "620001",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pushpa Nagar",
            "Pincode": "620001",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchirappalli",
            "Pincode": "620001",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchirappalli Cantt",
            "Pincode": "620001",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchirappalli H O",
            "Pincode": "620001",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchirappalli R S",
            "Pincode": "620001",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnakadai Street",
            "Pincode": "620002",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramaswamy College",
            "Pincode": "620002",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rock Fort",
            "Pincode": "620002",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seethalakshmi",
            "Pincode": "620002",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Teppakulam",
            "Pincode": "620002",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchirapalli Town Hall",
            "Pincode": "620002",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "West Chintamani",
            "Pincode": "620002",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salainagar",
            "Pincode": "620003",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Woriyur",
            "Pincode": "620003",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Woriyur Bazar",
            "Pincode": "620003",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Golden Rock",
            "Pincode": "620004",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Golden Rock Market",
            "Pincode": "620004",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Golden Rock North",
            "Pincode": "620004",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kondayanpatti",
            "Pincode": "620005",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Srinivasa Nagar",
            "Pincode": "620005",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiruvanaikoil",
            "Pincode": "620005",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annamandapam",
            "Pincode": "620006",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ranganagar",
            "Pincode": "620006",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Srirangam H O",
            "Pincode": "620006",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Srirangam North",
            "Pincode": "620006",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Srirangam West",
            "Pincode": "620006",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchi Air Port",
            "Pincode": "620007",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Clock Tower",
            "Pincode": "620008",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Senkulam",
            "Pincode": "620008",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchi East",
            "Pincode": "620008",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchi Fort",
            "Pincode": "620008",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Varaganeri",
            "Pincode": "620008",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramjeenagar",
            "Pincode": "620009",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Industrial Colony Trichy",
            "Pincode": "620010",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melakalkandarkottai",
            "Pincode": "620011",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Crawford Colony",
            "Pincode": "620012",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Edamalaipattipudur",
            "Pincode": "620012",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruverambur",
            "Pincode": "620013",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Administrative Office Bhel",
            "Pincode": "620014",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bhel",
            "Pincode": "620014",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Boiler Project",
            "Pincode": "620014",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Trichy",
            "Pincode": "620015",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Oradance Estate",
            "Pincode": "620016",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tennur",
            "Pincode": "620017",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tennur East",
            "Pincode": "620017",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thillainagar",
            "Pincode": "620018",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pappakurichi Kattur",
            "Pincode": "620019",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jamal Mohamed College",
            "Pincode": "620020",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Khajamalai Colony",
            "Pincode": "620020",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Khajanagar",
            "Pincode": "620020",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannarpuram",
            "Pincode": "620020",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Subramaniapuram",
            "Pincode": "620020",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "K K Nagar Metre Factory R",
            "Pincode": "620021",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thuvagudimalai",
            "Pincode": "620022",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manikandam",
            "Pincode": "620051",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Asoor",
            "Pincode": "620052",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mutharasanallur",
            "Pincode": "620101",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Somarasampettai",
            "Pincode": "620102",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Erakudi",
            "Pincode": "621001",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kirambur",
            "Pincode": "621002",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottapalayam",
            "Pincode": "621003",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottatur",
            "Pincode": "621004",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manachanallur",
            "Pincode": "621005",
            "City": "Manachanallur",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manachanallur North",
            "Pincode": "621005",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pulivalam",
            "Pincode": "621006",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthanampatti",
            "Pincode": "621007",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sikkal Thambur",
            "Pincode": "621008",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiruvellari",
            "Pincode": "621009",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Turaiyur Bazar",
            "Pincode": "621010",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Turaiyur Bus Stand",
            "Pincode": "621010",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Turaiyur Extension",
            "Pincode": "621010",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Turaiyur H O Trichy",
            "Pincode": "621010",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uppidamangalam",
            "Pincode": "621011",
            "City": "Uppidamangalam",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vyrichettipalayam",
            "Pincode": "621012",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pagalavadi",
            "Pincode": "621014",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panchaperumalpatti",
            "Pincode": "621015",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumalpalayam",
            "Pincode": "621016",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chenguttupatti",
            "Pincode": "621017",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sengattapatti",
            "Pincode": "621017",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sobanapuram",
            "Pincode": "621018",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Pudupalayam",
            "Pincode": "621019",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Ranganathapuram",
            "Pincode": "621019",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Murungaipatti",
            "Pincode": "621020",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thinnanur",
            "Pincode": "621021",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Okkarai",
            "Pincode": "621022",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagalapuram",
            "Pincode": "621023",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammapalayam",
            "Pincode": "621101",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annamangalam",
            "Pincode": "621102",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arumbavur",
            "Pincode": "621103",
            "City": "Arumbavur",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chettikulam",
            "Pincode": "621104",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Irungalur",
            "Pincode": "621105",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kolakalnatham",
            "Pincode": "621106",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurumbalur",
            "Pincode": "621107",
            "City": "Kurumbalur",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Labbaikudikadu",
            "Pincode": "621108",
            "City": "Labbaikudikadu",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padalur",
            "Pincode": "621109",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poolambadi",
            "Pincode": "621110",
            "City": "Poolambadi",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Purathagudi",
            "Pincode": "621111",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Samayapuram",
            "Pincode": "621112",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Siruvachur",
            "Pincode": "621113",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Kalathur",
            "Pincode": "621114",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valikondapuram",
            "Pincode": "621115",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veppanthatti",
            "Pincode": "621116",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "V Kalathur",
            "Pincode": "621117",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nakkalalem",
            "Pincode": "621118",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bommanapadi",
            "Pincode": "621120",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ladapuram",
            "Pincode": "621121",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naranmangalam",
            "Pincode": "621126",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilapuliyur",
            "Pincode": "621127",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Natham Balasmudram",
            "Pincode": "621127",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karai",
            "Pincode": "621128",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thevaiyur",
            "Pincode": "621129",
            "City": "Perambalur",
            "District": "Perambalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Konalai",
            "Pincode": "621132",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arts College",
            "Pincode": "621201",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayyampalayam",
            "Pincode": "621202",
            "City": "Ayyampalayam",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Balasamudram",
            "Pincode": "621203",
            "City": "Balasamudram",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jambunathapuram",
            "Pincode": "621205",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannanur",
            "Pincode": "621206",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kolakudi Manmedu",
            "Pincode": "621208",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manamedu",
            "Pincode": "621209",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettupalayam Trichy",
            "Pincode": "621210",
            "City": "Mettupalayam",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madanagopalapuram",
            "Pincode": "621212",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perambalur",
            "Pincode": "621212",
            "City": "Perambalur",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sirugambur",
            "Pincode": "621213",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thathiengarpet",
            "Pincode": "621214",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thottayam",
            "Pincode": "621215",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bikshandarkoil",
            "Pincode": "621216",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thandalaiputtur",
            "Pincode": "621217",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valady",
            "Pincode": "621218",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Yesanai",
            "Pincode": "621219",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thoramangalam",
            "Pincode": "621220",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Amur",
            "Pincode": "621221",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Urakkarai",
            "Pincode": "621224",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Natham",
            "Pincode": "621229",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elangakurichi",
            "Pincode": "621302",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Inamkolathur R S",
            "Pincode": "621303",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallupatti Murungapuri",
            "Pincode": "621304",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilpatti Trichy",
            "Pincode": "621305",
            "City": "Kovilpatti",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manaparai",
            "Pincode": "621306",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manaparai R S",
            "Pincode": "621306",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manjampatti",
            "Pincode": "621307",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puludipatti",
            "Pincode": "621309",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tharangampatti",
            "Pincode": "621311",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thaigesar Alai",
            "Pincode": "621312",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thogamalai",
            "Pincode": "621313",
            "City": "Karur",
            "District": "Karur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thuvarankurichi",
            "Pincode": "621314",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vaiyampatti",
            "Pincode": "621315",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viralimalai",
            "Pincode": "621316",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valandu",
            "Pincode": "621317",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lalgudi H O",
            "Pincode": "621601",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallakudi",
            "Pincode": "621651",
            "City": "Kallakudi",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallakudi Noth",
            "Pincode": "621652",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambapur",
            "Pincode": "621701",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambil",
            "Pincode": "621702",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Angarai",
            "Pincode": "621703",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ariyalur Bazar",
            "Pincode": "621704",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ariyalur Cement Factory",
            "Pincode": "621704",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ariyalur Trichy",
            "Pincode": "621704",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallankurichi",
            "Pincode": "621705",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilapaluvur",
            "Pincode": "621707",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kunnam Trichy",
            "Pincode": "621708",
            "City": "Perambalur",
            "District": "Perambalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mathur-Trichy",
            "Pincode": "621709",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponparappi",
            "Pincode": "621710",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pullambadi",
            "Pincode": "621711",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puvalur",
            "Pincode": "621712",
            "City": "Puvalur",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajajinagar Tiruchy",
            "Pincode": "621713",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sendurai",
            "Pincode": "621714",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumanur",
            "Pincode": "621715",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tungapuram",
            "Pincode": "621716",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veppur Trichur",
            "Pincode": "621717",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rayambaram",
            "Pincode": "621718",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Asaveerankudikadu",
            "Pincode": "621719",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viragalur",
            "Pincode": "621722",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lalgudi",
            "Pincode": "621729",
            "City": "Lalgudi",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Andimadam",
            "Pincode": "621801",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jayankondacholapuram",
            "Pincode": "621802",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jayankondacholapuram West",
            "Pincode": "621802",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallathur Thandalai",
            "Pincode": "621803",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vardajampettai",
            "Pincode": "621805",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Variyankaval",
            "Pincode": "621806",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumalaivadi",
            "Pincode": "621851",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ilandaikudam",
            "Pincode": "621853",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambalpuram",
            "Pincode": "622001",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bhuvaneswari Nagar",
            "Pincode": "622001",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "622001",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ganesh Nagar",
            "Pincode": "622001",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Machuvadi",
            "Pincode": "622001",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pillithannerpandal",
            "Pincode": "622001",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Podukottai",
            "Pincode": "622001",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudukkottai",
            "Pincode": "622001",
            "City": "Pudukkottai",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudukkottai East",
            "Pincode": "622001",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudukkottai Public Office",
            "Pincode": "622001",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Santhanathapuram",
            "Pincode": "622001",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirugokarnam",
            "Pincode": "622002",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajagopalapuram",
            "Pincode": "622003",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvappur",
            "Pincode": "622003",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudukkottai Ind Estate",
            "Pincode": "622004",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "622005",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanjur",
            "Pincode": "622009",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumayanur",
            "Pincode": "622009",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadavalam",
            "Pincode": "622052",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Namanasamudram",
            "Pincode": "622053",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaiyur",
            "Pincode": "622054",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maravamadurai",
            "Pincode": "622055",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melathanjair",
            "Pincode": "622056",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annavasal",
            "Pincode": "622101",
            "City": "Annavasal",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Illupur",
            "Pincode": "622102",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muckanamalaipatti",
            "Pincode": "622103",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vayalogam",
            "Pincode": "622104",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narthamalai",
            "Pincode": "622105",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kudimiamalai",
            "Pincode": "622106",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perambur",
            "Pincode": "622107",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virapatti",
            "Pincode": "622108",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arimalam",
            "Pincode": "622201",
            "City": "Arimalam",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilanilai",
            "Pincode": "622202",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perungalur",
            "Pincode": "622203",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Yembal",
            "Pincode": "622204",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vennavalkudi",
            "Pincode": "622205",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Odayalipatti",
            "Pincode": "622206",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Andakulam",
            "Pincode": "622207",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kummangudi",
            "Pincode": "622208",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Addanakottai",
            "Pincode": "622210",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Okkur Perundamarai",
            "Pincode": "622211",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulavaipatti",
            "Pincode": "622212",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chokkanathapatti",
            "Pincode": "622213",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sokknathapatti",
            "Pincode": "622213",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alangudi",
            "Pincode": "622301",
            "City": "Alangudi",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karambakudi",
            "Pincode": "622302",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvarankulam",
            "Pincode": "622303",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakadu",
            "Pincode": "622304",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallathirkottai",
            "Pincode": "622305",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Malaiyur",
            "Pincode": "622306",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponnanviduthi",
            "Pincode": "622307",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vambam Colony",
            "Pincode": "622309",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Venkatakulam",
            "Pincode": "622310",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kothakottai",
            "Pincode": "622311",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vamban",
            "Pincode": "622312",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangottai",
            "Pincode": "622313",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallavarampatti",
            "Pincode": "622314",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sooranviduthi",
            "Pincode": "622315",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puvarasakudi",
            "Pincode": "622316",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaikurichi",
            "Pincode": "622317",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koppanapatti",
            "Pincode": "622401",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulipirai",
            "Pincode": "622402",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melasivapuri",
            "Pincode": "622403",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nachandupatti",
            "Pincode": "622404",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nerkuppai",
            "Pincode": "622405",
            "City": "Nerkuppai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panayapatti",
            "Pincode": "622406",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponnamaravath",
            "Pincode": "622407",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupatti Pudukkottai",
            "Pincode": "622408",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rangiem",
            "Pincode": "622409",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ulagampatti",
            "Pincode": "622410",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valayapatti Pdk",
            "Pincode": "622411",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virachilai",
            "Pincode": "622412",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pulankurichi",
            "Pincode": "622413",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukalambur",
            "Pincode": "622414",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuruvikondanpatti",
            "Pincode": "622415",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "V Pudur",
            "Pincode": "622416",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Varapurpudur",
            "Pincode": "622416",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sevvur",
            "Pincode": "622417",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vendanpatti",
            "Pincode": "622419",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melapanaiyur",
            "Pincode": "622420",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lambalakudi",
            "Pincode": "622421",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cauverynagar",
            "Pincode": "622501",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Keeranur Pudukottai",
            "Pincode": "622502",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Konapet",
            "Pincode": "622503",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulathur Pudukkottai",
            "Pincode": "622504",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramachandrapuram",
            "Pincode": "622505",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rayavaram",
            "Pincode": "622506",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumayam",
            "Pincode": "622507",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kunnandarkoil",
            "Pincode": "622508",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tekkattur",
            "Pincode": "622509",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thekkattur",
            "Pincode": "622509",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mathur Keeranur",
            "Pincode": "622510",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthambur",
            "Pincode": "622511",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellanur",
            "Pincode": "622512",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mandaiyur",
            "Pincode": "622513",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hiradayapuram",
            "Pincode": "622514",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mathur Ind Est Pudukkotta",
            "Pincode": "622515",
            "City": "Pudukottai",
            "District": "Pudukottai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallukatti",
            "Pincode": "623001",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muthupattinam",
            "Pincode": "623001",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Senjai",
            "Pincode": "623001",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sekkalai",
            "Pincode": "623002",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alagappapuram H O",
            "Pincode": "623003",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alagappa Engg College",
            "Pincode": "623004",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devakottai Road",
            "Pincode": "623005",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cecri Campus",
            "Pincode": "623006",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athangudi",
            "Pincode": "623101",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chettinad",
            "Pincode": "623102",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanadukathan",
            "Pincode": "623103",
            "City": "Kanadukathan",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadanur",
            "Pincode": "623104",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kandanur",
            "Pincode": "623104",
            "City": "Kandanur",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kothamangalam",
            "Pincode": "623105",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottaiyur",
            "Pincode": "623106",
            "City": "Kottaiyur",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallathur",
            "Pincode": "623107",
            "City": "Pallathur",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poduvayal",
            "Pincode": "623108",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peerkalaikadu",
            "Pincode": "623109",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mitravayal",
            "Pincode": "623110",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nemthanpatti",
            "Pincode": "623111",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athikadu Thekkur",
            "Pincode": "623201",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ariyakudi",
            "Pincode": "623202",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kandavarayanpatti",
            "Pincode": "623203",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kandramanickam",
            "Pincode": "623204",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilasevalpatti",
            "Pincode": "623205",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kunnakudi",
            "Pincode": "623206",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nachiapuram",
            "Pincode": "623207",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "O Siruvayal",
            "Pincode": "623208",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "S M Hospital",
            "Pincode": "623209",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukkoshiyur",
            "Pincode": "623210",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arumuga Nagar",
            "Pincode": "623211",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupattur Bus Stand",
            "Pincode": "623211",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruppattur Ramnad",
            "Pincode": "623211",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viramathi",
            "Pincode": "623212",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sathurusankarakottai",
            "Pincode": "623213",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Siravayal",
            "Pincode": "623214",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sirukundalpatti",
            "Pincode": "623215",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottaiyiruppu",
            "Pincode": "623216",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mahibalanpatti",
            "Pincode": "623217",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Amaravathi Pudur",
            "Pincode": "623301",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devakkottai Palace",
            "Pincode": "623302",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devakottai H O",
            "Pincode": "623302",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devakottai South",
            "Pincode": "623302",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devakottai West",
            "Pincode": "623302",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karudavoorani",
            "Pincode": "623302",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Silambani",
            "Pincode": "623302",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devakottai Extn",
            "Pincode": "623303",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eriyur",
            "Pincode": "623304",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallal",
            "Pincode": "623305",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallupatti",
            "Pincode": "623306",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Managiri",
            "Pincode": "623307",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangalakudi",
            "Pincode": "623308",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Oriyur",
            "Pincode": "623309",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattamangalam R",
            "Pincode": "623310",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periuakarai",
            "Pincode": "623311",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puliyal",
            "Pincode": "623312",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sambanur",
            "Pincode": "623313",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shanmuganathapuram",
            "Pincode": "623314",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellayapuram",
            "Pincode": "623315",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hanumanthakuddi",
            "Pincode": "623317",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannangudi",
            "Pincode": "623318",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilur",
            "Pincode": "623319",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuthalur",
            "Pincode": "623320",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nesal",
            "Pincode": "623321",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anandur",
            "Pincode": "623401",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnakeeramangalam",
            "Pincode": "623402",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nadambakkam",
            "Pincode": "623403",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nambuthalai",
            "Pincode": "623403",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pandugudi",
            "Pincode": "623404",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panickanadar",
            "Pincode": "623404",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panickanadar",
            "Pincode": "623404",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sarakeni",
            "Pincode": "623405",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sundarapandiapatinam Rmd",
            "Pincode": "623406",
            "City": "Sundarapandiam",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvadanai",
            "Pincode": "623407",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvegampet",
            "Pincode": "623408",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tondi",
            "Pincode": "623409",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anjukottai",
            "Pincode": "623410",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanathapuram Bazaar",
            "Pincode": "623501",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanathapuram H O",
            "Pincode": "623501",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanathapuram Public Off",
            "Pincode": "623501",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanathapuram West",
            "Pincode": "623501",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Achunthanvayal",
            "Pincode": "623502",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alangankulam",
            "Pincode": "623512",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chittarkottai",
            "Pincode": "623513",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eruvadi Ramnad",
            "Pincode": "623515",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Irumeni",
            "Pincode": "623516",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilakarai",
            "Pincode": "623517",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilakarai West",
            "Pincode": "623517",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mandapam",
            "Pincode": "623518",
            "City": "Mandapam",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mandapam Camp",
            "Pincode": "623519",
            "City": "Mandapam",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marine Fisheries",
            "Pincode": "623520",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pamban",
            "Pincode": "623521",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panaikulam",
            "Pincode": "623522",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudumadam",
            "Pincode": "623524",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajasingamangalam",
            "Pincode": "623525",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rameswaram",
            "Pincode": "623526",
            "City": "Rameswaram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rameswaram R S",
            "Pincode": "623526",
            "City": "Rameswaram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chattirakudi",
            "Pincode": "623527",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sikkal Ramnad",
            "Pincode": "623528",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thangachimadam",
            "Pincode": "623529",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Toruvalur",
            "Pincode": "623530",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupalakudi",
            "Pincode": "623531",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruppapullani",
            "Pincode": "623532",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruttarakosamangai",
            "Pincode": "623533",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uchipulli",
            "Pincode": "623534",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kenikarai",
            "Pincode": "623535",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanathapuram Bus Stand",
            "Pincode": "623535",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velipatnam",
            "Pincode": "623535",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perungulam",
            "Pincode": "623536",
            "City": "Perungulam",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pottagavayal",
            "Pincode": "623537",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sanaveli",
            "Pincode": "623538",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athiyuthu",
            "Pincode": "623539",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valantharavai",
            "Pincode": "623543",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rettaiyurani",
            "Pincode": "623544",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Therku Tharavai",
            "Pincode": "623545",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Soorankottai",
            "Pincode": "623546",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaliyarkoil",
            "Pincode": "623551",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilapungudi",
            "Pincode": "623552",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madagupattu",
            "Pincode": "623553",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangalam-Ramnad",
            "Pincode": "623554",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Natarajapuram",
            "Pincode": "623555",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nattarasankottai",
            "Pincode": "623556",
            "City": "Nattarasankottai",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Okkur",
            "Pincode": "623557",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paganeri",
            "Pincode": "623558",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyakottai",
            "Pincode": "623559",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jawahar Bazaar",
            "Pincode": "623560",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivaganga",
            "Pincode": "623560",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivaganga Courts",
            "Pincode": "623560",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivaganga North",
            "Pincode": "623560",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bosenagar",
            "Pincode": "623561",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tamarakki",
            "Pincode": "623562",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vembarpatti",
            "Pincode": "623565",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ervadi Durga",
            "Pincode": "623566",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Abiramam",
            "Pincode": "623601",
            "City": "Abiramam",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idaikaatur",
            "Pincode": "623602",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamudi",
            "Pincode": "623603",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottaimedu",
            "Pincode": "623604",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mandalamanickam",
            "Pincode": "623605",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannar Street",
            "Pincode": "623606",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manamadurai Town",
            "Pincode": "623606",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manamadural H O",
            "Pincode": "623606",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narikudi",
            "Pincode": "623607",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Parthibanur",
            "Pincode": "623608",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajagambiram",
            "Pincode": "623609",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruppachetty",
            "Pincode": "623610",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupuvanam",
            "Pincode": "623611",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viracholam",
            "Pincode": "623612",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manamadurai R S",
            "Pincode": "623613",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilaperungarai",
            "Pincode": "623617",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Emaneswaram",
            "Pincode": "623701",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadaladi",
            "Pincode": "623703",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mudukulathur",
            "Pincode": "623704",
            "City": "Mudukulathur",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mudumalai",
            "Pincode": "623704",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakkur",
            "Pincode": "623704",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nainarkoil",
            "Pincode": "623705",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pambur",
            "Pincode": "623706",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bharathi Nagar",
            "Pincode": "623707",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnakadai",
            "Pincode": "623707",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kattuparamakudi",
            "Pincode": "623707",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paramakudi Bazar",
            "Pincode": "623707",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paramakudi H O",
            "Pincode": "623707",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paramakudi R S",
            "Pincode": "623707",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peraiyur Ramnad",
            "Pincode": "623708",
            "City": "Peraiyur",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudur Ramnad",
            "Pincode": "623709",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salaigramam",
            "Pincode": "623710",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Teriruveli",
            "Pincode": "623711",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramnad",
            "Pincode": "623712",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Suranam",
            "Pincode": "623713",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melasirupodu",
            "Pincode": "623716",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Keelatheoval",
            "Pincode": "623718",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilathooval",
            "Pincode": "623718",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamudakudi",
            "Pincode": "623719",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karunchutti",
            "Pincode": "623721",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadalai",
            "Pincode": "623804",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sathak Salai",
            "Pincode": "623806",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dindigul Bazar",
            "Pincode": "624001",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dindigul Fort Bus Stand",
            "Pincode": "624001",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dindigul H O",
            "Pincode": "624001",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dindigul South",
            "Pincode": "624001",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dindigul West",
            "Pincode": "624001",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangles Road",
            "Pincode": "624001",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Begampur",
            "Pincode": "624002",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bharathipuram",
            "Pincode": "624003",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dindigul Rs",
            "Pincode": "624003",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dindigul Santhapettai",
            "Pincode": "624003",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagalnagar",
            "Pincode": "624003",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Beschi College",
            "Pincode": "624004",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Balakrishnapurampudur",
            "Pincode": "624005",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dindigul East",
            "Pincode": "624006",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pandianagar",
            "Pincode": "624007",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Angu Nagar",
            "Pincode": "624008",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "N G O Colony Dindigul",
            "Pincode": "624009",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dindigul Fort",
            "Pincode": "624010",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pambarpuram",
            "Pincode": "624010",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koovanuthu",
            "Pincode": "624051",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padiyur",
            "Pincode": "624052",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulathur Dindigul",
            "Pincode": "624053",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hanumantharayankottai",
            "Pincode": "624054",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodaikanal",
            "Pincode": "624101",
            "City": "Kodaikanal",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodaikanal Lak View",
            "Pincode": "624101",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anandagiri",
            "Pincode": "624102",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodaikanal Observatory",
            "Pincode": "624103",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shenbaganur",
            "Pincode": "624104",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilpatti",
            "Pincode": "624107",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumalmalai",
            "Pincode": "624108",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammayanayakkanur",
            "Pincode": "624201",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Batlagundu",
            "Pincode": "624202",
            "City": "Batlagundu",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Batlagundu Bazaar",
            "Pincode": "624202",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Genguvarpatti",
            "Pincode": "624203",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Iyyampalayam",
            "Pincode": "624204",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karupatti",
            "Pincode": "624205",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mullipallam",
            "Pincode": "624207",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nilakottai",
            "Pincode": "624208",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nilakottai Bazaar",
            "Pincode": "624208",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pandiarajapuram",
            "Pincode": "624209",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pannaikadu",
            "Pincode": "624210",
            "City": "Pannaikadu",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattiveerampatti",
            "Pincode": "624211",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumbarai",
            "Pincode": "624212",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramarajapuram",
            "Pincode": "624213",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sholabvandan South",
            "Pincode": "624214",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sholavandan Bazaar",
            "Pincode": "624214",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sholavandan H O",
            "Pincode": "624214",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Siukuvarpatti",
            "Pincode": "624215",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tandigudi",
            "Pincode": "624216",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvedagam West",
            "Pincode": "624217",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadipatti",
            "Pincode": "624218",
            "City": "Vadipatti",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilampatti",
            "Pincode": "624219",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viruvedu",
            "Pincode": "624220",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tanichiyam",
            "Pincode": "624221",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thuvariman",
            "Pincode": "624222",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannadimangalam",
            "Pincode": "624223",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sevugampatti",
            "Pincode": "624224",
            "City": "Sevugampatti",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Andipatti",
            "Pincode": "624225",
            "City": "Theni",
            "District": "Theni",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tenkarai",
            "Pincode": "624226",
            "City": "Nagapattinam",
            "District": "Nagapattinam",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nachikulam",
            "Pincode": "624227",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sitharevu",
            "Pincode": "624228",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "K C Patti",
            "Pincode": "624230",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kullalagundu",
            "Pincode": "624231",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vikramangalam",
            "Pincode": "624232",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallapatti",
            "Pincode": "624233",
            "City": "Pallapatti",
            "District": "Karur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvedagam",
            "Pincode": "624234",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuppammalpatti",
            "Pincode": "624235",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnalapatti",
            "Pincode": "624301",
            "City": "Chinnalapatti",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Gram",
            "Pincode": "624302",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "N Panjampatti",
            "Pincode": "624303",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sanarpatti",
            "Pincode": "624304",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Settinayakkanpatti",
            "Pincode": "624305",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Siluvathur",
            "Pincode": "624306",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellodu",
            "Pincode": "624307",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vembarpatti",
            "Pincode": "624308",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambathurai R S",
            "Pincode": "624309",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Silaipadi",
            "Pincode": "624310",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambathurai",
            "Pincode": "624311",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Samiyarpatti",
            "Pincode": "624312",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kambilianpatti",
            "Pincode": "624313",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chettiapatti",
            "Pincode": "624314",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumalkovilpatti",
            "Pincode": "624315",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajakkapatti",
            "Pincode": "624316",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyakottai",
            "Pincode": "624317",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ragalapuram",
            "Pincode": "624318",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nattam East",
            "Pincode": "624401",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nattam-Madurai",
            "Pincode": "624401",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Samudrapatti",
            "Pincode": "624402",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sendurai",
            "Pincode": "624403",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sirugudi",
            "Pincode": "624404",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chaturvedamangalam",
            "Pincode": "624501",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Singampuneri",
            "Pincode": "624502",
            "City": "Singampuneri",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Prianmalai",
            "Pincode": "624503",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kirungakottai",
            "Pincode": "624504",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muraiyur",
            "Pincode": "624505",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Suraikudi",
            "Pincode": "624506",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallappur",
            "Pincode": "624507",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palani Adviaram",
            "Pincode": "624601",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palani Bazaar",
            "Pincode": "624601",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palani Devasthanam",
            "Pincode": "624601",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palani East",
            "Pincode": "624601",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palani H O",
            "Pincode": "624601",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palani North",
            "Pincode": "624601",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palani West",
            "Pincode": "624601",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Balasamudram",
            "Pincode": "624610",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thoppampatti",
            "Pincode": "624611",
            "City": "Erode",
            "District": "Erode",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambilikai",
            "Pincode": "624612",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayakudi",
            "Pincode": "624613",
            "City": "Ayakudi",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chatrapatti Palani",
            "Pincode": "624614",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalayamputhur",
            "Pincode": "624615",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallimandiyam",
            "Pincode": "624616",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Keeranur Madurai",
            "Pincode": "624617",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narikalpatti",
            "Pincode": "624618",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Oddanchatram",
            "Pincode": "624619",
            "City": "Oddanchatram",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Oddanchatram North",
            "Pincode": "624619",
            "City": "Oddanchatram",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palayam-Palani",
            "Pincode": "624620",
            "City": "Palayam",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pappampatti",
            "Pincode": "624621",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Reddiarchatram",
            "Pincode": "624622",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manjanaickenpatti",
            "Pincode": "624623",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palakkanuthu",
            "Pincode": "624624",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "K Keeranur",
            "Pincode": "624625",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perichipalayam",
            "Pincode": "624626",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Amarapundi",
            "Pincode": "624627",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virupatchi",
            "Pincode": "624628",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ahtoor",
            "Pincode": "624701",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eriyodu",
            "Pincode": "624702",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Guziliamparai",
            "Pincode": "624703",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idayakottai",
            "Pincode": "624704",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannivadi",
            "Pincode": "624705",
            "City": "Kannivadi",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilur Madurai",
            "Pincode": "624706",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sembatti",
            "Pincode": "624707",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sithayankottai",
            "Pincode": "624708",
            "City": "Sithayankottai",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tadicombu",
            "Pincode": "624709",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vedasandur",
            "Pincode": "624710",
            "City": "Vedasandur",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kasipalayam Madurai",
            "Pincode": "624711",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Markampatti",
            "Pincode": "624712",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tettupatti",
            "Pincode": "624713",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharmathupatti",
            "Pincode": "624714",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayyalur",
            "Pincode": "624801",
            "City": "Ayyalur",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadamadurai",
            "Pincode": "624802",
            "City": "Vadamadurai",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadamadurai D G L",
            "Pincode": "624802",
            "City": "Vadamadurai",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sengurichi",
            "Pincode": "624804",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Keerathurai",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lakshmipuram",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Bazaar",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Central Bus Stand",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai City",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Ezhukadal",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai H O",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai North",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Palace",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai West",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai West Masi Street",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padithurai",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panthadi Street",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumal Teppakulam",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pitchaiamman",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Simmakkal",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "South Gate",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "South Masi Street",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "South Veli L Street",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Town Hall Road",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilakkathoon",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Yanaikkal",
            "Pincode": "625001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnasokkikulam",
            "Pincode": "625002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jambropuram",
            "Pincode": "625002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalpalam Road",
            "Pincode": "625002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Bibikulam",
            "Pincode": "625002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Corporation Bldgs",
            "Pincode": "625002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Race Course",
            "Pincode": "625002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narimedu",
            "Pincode": "625002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sellur",
            "Pincode": "625002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sokkikulam",
            "Pincode": "625002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tallakulam H O",
            "Pincode": "625002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alagappa Nagar",
            "Pincode": "625003",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palanganatham",
            "Pincode": "625003",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tvs Nagar",
            "Pincode": "625003",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pasumalai",
            "Pincode": "625004",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruparankundram",
            "Pincode": "625005",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunagar",
            "Pincode": "625006",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kosakulampudur",
            "Pincode": "625007",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudur Bazaar",
            "Pincode": "625007",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "De Nobili Press",
            "Pincode": "625008",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Balarangapuram",
            "Pincode": "625009",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamarajar Chalai",
            "Pincode": "625009",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai East",
            "Pincode": "625009",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Munichalai Road",
            "Pincode": "625009",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiagarajar College",
            "Pincode": "625009",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gnana Olivupuram",
            "Pincode": "625010",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Railway Colony",
            "Pincode": "625010",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Rly Dvl Office",
            "Pincode": "625010",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponnagaram",
            "Pincode": "625010",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthuthope",
            "Pincode": "625010",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "West Ponnagaram",
            "Pincode": "625010",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jaihindpuram",
            "Pincode": "625011",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avaniapuram",
            "Pincode": "625012",
            "City": "Avaniapuram",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villapuram",
            "Pincode": "625012",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnapuram Colony",
            "Pincode": "625014",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Reserve Lines",
            "Pincode": "625014",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thaigarajar Engg College",
            "Pincode": "625015",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arasaradi H O",
            "Pincode": "625016",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chockalinga Nagar",
            "Pincode": "625016",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Somasundaram Colony",
            "Pincode": "625016",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "State Bank Colony",
            "Pincode": "625016",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shanti Nagar",
            "Pincode": "625018",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thathaneri",
            "Pincode": "625018",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arignaranna Nagar",
            "Pincode": "625020",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "625020",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar Madurai",
            "Pincode": "625020",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madichiyam",
            "Pincode": "625020",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Collectorate",
            "Pincode": "625020",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Courts",
            "Pincode": "625020",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Erskine Hospital",
            "Pincode": "625020",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Municipal Colony",
            "Pincode": "625020",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tallakulam Housing Board",
            "Pincode": "625020",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palkalainagar",
            "Pincode": "625021",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Training Centre",
            "Pincode": "625022",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pothumbu",
            "Pincode": "625051",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chatrapatti Mdu",
            "Pincode": "625052",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karungalakudi",
            "Pincode": "625101",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilavalavu",
            "Pincode": "625102",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottampatti",
            "Pincode": "625103",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Agricultural College",
            "Pincode": "625104",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melavaluvu",
            "Pincode": "625105",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melur Courts",
            "Pincode": "625106",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melur East",
            "Pincode": "625106",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melur H O",
            "Pincode": "625106",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melur South",
            "Pincode": "625106",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Othakadai",
            "Pincode": "625107",
            "City": "Othakadai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thumbapatti",
            "Pincode": "625108",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chittampatt",
            "Pincode": "625111",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narasingampatti",
            "Pincode": "625112",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Navinpatti",
            "Pincode": "625113",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kambur",
            "Pincode": "625114",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chockalingapuram",
            "Pincode": "625115",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vanjnagaram",
            "Pincode": "625116",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallapatti",
            "Pincode": "625117",
            "City": "Pallapatti",
            "District": "Karur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilayur Madurai",
            "Pincode": "625118",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uranganpatti",
            "Pincode": "625119",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sarugu Valayapatti",
            "Pincode": "625120",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Taniyamangalam",
            "Pincode": "625121",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Therkutheru",
            "Pincode": "625122",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambalakaranpatti",
            "Pincode": "625123",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottagudi",
            "Pincode": "625124",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pottapatti",
            "Pincode": "625125",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kachirayanpatti",
            "Pincode": "625126",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattur",
            "Pincode": "625127",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Silaiman",
            "Pincode": "625201",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodai Road R S",
            "Pincode": "625206",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alagarkoil",
            "Pincode": "625301",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangulam",
            "Pincode": "625302",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellalapatti",
            "Pincode": "625303",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kidaripatti",
            "Pincode": "625304",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallandiri",
            "Pincode": "625305",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Visalakshinagar",
            "Pincode": "625401",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Samayanallur",
            "Pincode": "625402",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thenur",
            "Pincode": "625403",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paravai",
            "Pincode": "625404",
            "City": "Paravai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alanganallur",
            "Pincode": "625501",
            "City": "Alanganallur",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettupatti Madurai",
            "Pincode": "625502",
            "City": "Dindigul",
            "District": "Dindigul",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vavimarudur",
            "Pincode": "625504",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seelayampatti",
            "Pincode": "625577",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palani R S",
            "Pincode": "625602",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamarajanagar",
            "Pincode": "626001",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudhunagar Bazar",
            "Pincode": "626001",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudhunagar Bus Stand",
            "Pincode": "626001",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudhunagar Extension",
            "Pincode": "626001",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudhunagar H O",
            "Pincode": "626001",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudhunagar North",
            "Pincode": "626001",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudhunagar Rs",
            "Pincode": "626001",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudhunagar Town",
            "Pincode": "626001",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudhunagar West",
            "Pincode": "626001",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudhunagar Ind Estate",
            "Pincode": "626003",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palavanatham",
            "Pincode": "626004",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Amathur",
            "Pincode": "626005",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mullipatti",
            "Pincode": "626051",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattambudur",
            "Pincode": "626052",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kullursandai",
            "Pincode": "626053",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Malaipatti",
            "Pincode": "626054",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodkalancheri",
            "Pincode": "626055",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alagianallur",
            "Pincode": "626056",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellur",
            "Pincode": "626057",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Messalur",
            "Pincode": "626058",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avalsurampatti",
            "Pincode": "626059",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aruppukkottai H O",
            "Pincode": "626101",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aruppukottai Bazaar",
            "Pincode": "626101",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aruppukottai East",
            "Pincode": "626101",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aruppukottai Nehru Maidan",
            "Pincode": "626101",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aruppukottai West",
            "Pincode": "626101",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aruvankadu",
            "Pincode": "626101",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chatrapatti Virudhunagar",
            "Pincode": "626102",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Erichinatham",
            "Pincode": "626103",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalkurchi",
            "Pincode": "626104",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallurani",
            "Pincode": "626105",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanapatti",
            "Pincode": "626106",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilangulam",
            "Pincode": "626107",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumarasamirajanagar",
            "Pincode": "626108",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mallanginar",
            "Pincode": "626109",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellaur Mdu",
            "Pincode": "626109",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sahibpuram",
            "Pincode": "626110",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muhavur",
            "Pincode": "626111",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palayampatti",
            "Pincode": "626112",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panthalkudi",
            "Pincode": "626113",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paralachi",
            "Pincode": "626114",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perunali",
            "Pincode": "626115",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupatti Watrap",
            "Pincode": "626116",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambalapuli Bazaar",
            "Pincode": "626117",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupalayam",
            "Pincode": "626117",
            "City": "Pudupalayam",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajapalayam",
            "Pincode": "626117",
            "City": "Rajapalayam",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajapalayam Bus Stand",
            "Pincode": "626117",
            "City": "Rajapalayam",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajapalayam Cotton Market",
            "Pincode": "626117",
            "City": "Rajapalayam",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajapalaym H O",
            "Pincode": "626117",
            "City": "Rajapalayam",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Reddiarpatti",
            "Pincode": "626118",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankarlingapuram",
            "Pincode": "626119",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sayalgudi",
            "Pincode": "626120",
            "City": "Sayalgudi",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seithur",
            "Pincode": "626121",
            "City": "Seithur",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Settiyarpatti",
            "Pincode": "626122",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammankoilpatti",
            "Pincode": "626123",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivakasi Bazaar",
            "Pincode": "626123",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivakasi Bus Stand",
            "Pincode": "626123",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivakasi Coronation Cly",
            "Pincode": "626123",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivakasi H O",
            "Pincode": "626123",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivakasi R S",
            "Pincode": "626123",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivakasi South",
            "Pincode": "626123",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivakasi West",
            "Pincode": "626124",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Medavar Vilagam",
            "Pincode": "626125",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pennington Market",
            "Pincode": "626125",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Srivalliputtur H O",
            "Pincode": "626125",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Srivilliputtur North",
            "Pincode": "626125",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sundarapandiam",
            "Pincode": "626126",
            "City": "Sundarapandiam",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tamilnadu Cements",
            "Pincode": "626127",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thayilpatti",
            "Pincode": "626128",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchuli",
            "Pincode": "626129",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruthangal",
            "Pincode": "626130",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vembakottai",
            "Pincode": "626131",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Watrap",
            "Pincode": "626132",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kummapatti",
            "Pincode": "626133",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chettikurichi",
            "Pincode": "626134",
            "City": "Thoothukkudi",
            "District": "Thoothukkudi",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannirajapuram",
            "Pincode": "626135",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilarajakularaman",
            "Pincode": "626136",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pillayarkulam",
            "Pincode": "626137",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kunnur",
            "Pincode": "626138",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cholapuram South",
            "Pincode": "626139",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sevalpatti",
            "Pincode": "626140",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Malli",
            "Pincode": "626141",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sundaranchiapuram",
            "Pincode": "626142",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alangulam",
            "Pincode": "626144",
            "City": "Alangulam",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devadanam",
            "Pincode": "626145",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ilandaikulam",
            "Pincode": "626146",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melpattamkarisalkulam",
            "Pincode": "626147",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Meenkashipuram",
            "Pincode": "626148",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maharajapuram",
            "Pincode": "626149",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nachiarkoil",
            "Pincode": "626150",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nattampatti",
            "Pincode": "626151",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koppusithampatti",
            "Pincode": "626152",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivalaingapuram",
            "Pincode": "626153",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vaithilingapuram",
            "Pincode": "626154",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neeravikarisalkulam",
            "Pincode": "626155",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "S Tharaikudi",
            "Pincode": "626156",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellayapuram",
            "Pincode": "626157",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ethilodu",
            "Pincode": "626158",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilampatti",
            "Pincode": "626158",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramasaminagar",
            "Pincode": "626159",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aviyur",
            "Pincode": "626160",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puliyuram",
            "Pincode": "626161",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naripaiyur",
            "Pincode": "626162",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Zamin Kollangondan",
            "Pincode": "626163",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sethunarayanapuram",
            "Pincode": "626164",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anuppankulam",
            "Pincode": "626165",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Varaganur",
            "Pincode": "626166",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottaiyur",
            "Pincode": "626167",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottaiyur Guruswamy",
            "Pincode": "626167",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Terku Venganallur",
            "Pincode": "626168",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthur",
            "Pincode": "626169",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kansapuram",
            "Pincode": "626170",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "M Pudupatti",
            "Pincode": "626171",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mudalipatti",
            "Pincode": "626172",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vetrilaiyurani",
            "Pincode": "626173",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nallamanaickenpatti",
            "Pincode": "626175",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viswanatham",
            "Pincode": "626176",
            "City": "Viswanatham",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eluppaiyur",
            "Pincode": "626177",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Illuppaiyur",
            "Pincode": "626177",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karisalkulam",
            "Pincode": "626178",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maraneri",
            "Pincode": "626179",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anaiyur",
            "Pincode": "626180",
            "City": "Anaiyur",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Injar",
            "Pincode": "626180",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sengundapuram",
            "Pincode": "626181",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudukkottai Vnr",
            "Pincode": "626182",
            "City": "Pudukkottai",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadhuvarpatti",
            "Pincode": "626183",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naranapuram",
            "Pincode": "626184",
            "City": "Naranapuram",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villuppanur",
            "Pincode": "626186",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idivilagi",
            "Pincode": "626187",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dalavaipuram",
            "Pincode": "626188",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Musittakurichi",
            "Pincode": "626195",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elayirampannai",
            "Pincode": "626201",
            "City": "Elayirampannai",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nenmeni",
            "Pincode": "626202",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sattur",
            "Pincode": "626203",
            "City": "Sattur",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sattur Bus Stand",
            "Pincode": "626203",
            "City": "Sattur",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sattur West",
            "Pincode": "626203",
            "City": "Sattur",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramasamyrajanagar",
            "Pincode": "626204",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uppathur",
            "Pincode": "626205",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Irukkangudi",
            "Pincode": "626206",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koil",
            "Pincode": "626207",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thulakkapatti R S",
            "Pincode": "626208",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avadayapuram",
            "Pincode": "626209",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Sedapatti",
            "Pincode": "626210",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Surangudi",
            "Pincode": "626211",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panayadipatti",
            "Pincode": "626212",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Appanayakkanpatti",
            "Pincode": "626213",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyakulam East",
            "Pincode": "626501",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyakulam H O",
            "Pincode": "626501",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyakulam Public Office",
            "Pincode": "626501",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peryakulambazaar",
            "Pincode": "626501",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadagarai",
            "Pincode": "626501",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aundipatti",
            "Pincode": "626512",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jakkampatti",
            "Pincode": "626512",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bodinayakkanur H O",
            "Pincode": "626513",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Checkanurani",
            "Pincode": "626514",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnamanur",
            "Pincode": "626515",
            "City": "Chinnamanur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnamanur Bazaar",
            "Pincode": "626515",
            "City": "Chinnamanur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnamanur East",
            "Pincode": "626515",
            "City": "Chinnamanur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cumbum Madurai Bus Stand",
            "Pincode": "626516",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cumbum South",
            "Pincode": "626516",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cumbum West",
            "Pincode": "626516",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar Cumbum",
            "Pincode": "626516",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandamanayakanur",
            "Pincode": "626517",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gudalur Madurai",
            "Pincode": "626518",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Highways",
            "Pincode": "626519",
            "City": "Highways",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamachipuram",
            "Pincode": "626520",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamayagoundanpatti",
            "Pincode": "626521",
            "City": "Kamayagoundanpatti",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kombai",
            "Pincode": "626522",
            "City": "Kombai",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periakulam",
            "Pincode": "626523",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pannaipuram",
            "Pincode": "626524",
            "City": "Pannaipuram",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyar Project",
            "Pincode": "626525",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Royappanpatthi",
            "Pincode": "626526",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sedapatti",
            "Pincode": "626527",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Silamarathupatti",
            "Pincode": "626528",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sindupatti",
            "Pincode": "626529",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thavaram",
            "Pincode": "626530",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alliagaram",
            "Pincode": "626531",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bangalamedu",
            "Pincode": "626531",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Theni",
            "Pincode": "626531",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Theni South",
            "Pincode": "626531",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiagaraja Nagar Theni",
            "Pincode": "626531",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uslampatti",
            "Pincode": "626532",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uslampatti Pettai",
            "Pincode": "626532",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uthamapalayam",
            "Pincode": "626533",
            "City": "Uthamapalayam",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uthamapalayam Bazar",
            "Pincode": "626533",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyakulam",
            "Pincode": "626534",
            "City": "Periyakulam",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Yelumalai",
            "Pincode": "626535",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T B Sanatorium",
            "Pincode": "626536",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Subbalapuram",
            "Pincode": "626536",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uthappanayakanur",
            "Pincode": "626537",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Venniar Estate",
            "Pincode": "626538",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Suruliar Lower Camp",
            "Pincode": "626539",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Odiapatti",
            "Pincode": "626540",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammapatti",
            "Pincode": "626541",
            "City": "Karur",
            "District": "Karur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "U Ammapatti",
            "Pincode": "626541",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnaovalapuram",
            "Pincode": "626544",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodangipattu",
            "Pincode": "626547",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilpatti",
            "Pincode": "626549",
            "City": "Kovilpatti",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palanichettipatti",
            "Pincode": "626553",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pottipuram",
            "Pincode": "626555",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupatti",
            "Pincode": "626556",
            "City": "Pudupatti",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tamaraikulam",
            "Pincode": "626562",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellayammalpuram",
            "Pincode": "626565",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chellanpatti",
            "Pincode": "626566",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottur",
            "Pincode": "626569",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uppukottai",
            "Pincode": "626571",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Venkatachalapuram",
            "Pincode": "626572",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narasingapuram",
            "Pincode": "626579",
            "City": "Narasingapuram",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Subbaraja Nagar C P A Co",
            "Pincode": "626582",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devadanapatti",
            "Pincode": "626601",
            "City": "Devadanapatti",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalligudi",
            "Pincode": "626701",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallupatti",
            "Pincode": "626702",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai",
            "Pincode": "626703",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Pudupatti",
            "Pincode": "626704",
            "City": "Pudupatti",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saptur",
            "Pincode": "626705",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumangalam",
            "Pincode": "626706",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumangalam South",
            "Pincode": "626706",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumani",
            "Pincode": "626706",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudunagar",
            "Pincode": "626709",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirali",
            "Pincode": "626712",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "M Puliyangulam",
            "Pincode": "626716",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sengapadi",
            "Pincode": "626717",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sathangudi",
            "Pincode": "626719",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kailasapuram Tvl",
            "Pincode": "627001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madurai Road",
            "Pincode": "627001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mandram",
            "Pincode": "627001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Minatchipuram",
            "Pincode": "627001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunelveli Ind H O",
            "Pincode": "627001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunelveli Nagar",
            "Pincode": "627001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viraghavapuram",
            "Pincode": "627001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulavanikarpuram",
            "Pincode": "627002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Murugankurichi",
            "Pincode": "627002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palayankottai H O",
            "Pincode": "627002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palayankottai Kori",
            "Pincode": "627002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palayankottai Vadakku",
            "Pincode": "627002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Samadanapuram",
            "Pincode": "627002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vannarpettai Tvl",
            "Pincode": "627003",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vannerpettai Bazar",
            "Pincode": "627003",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunelveli Pettai",
            "Pincode": "627004",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunelveli Pettai East",
            "Pincode": "627004",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melapalayam",
            "Pincode": "627005",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melapalayam Bazaar",
            "Pincode": "627005",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunelveli East",
            "Pincode": "627006",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunelveli Morku",
            "Pincode": "627006",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunelveli Therku",
            "Pincode": "627006",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunelveli Town",
            "Pincode": "627006",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruneveli Bazar",
            "Pincode": "627006",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tondar Bazar",
            "Pincode": "627006",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "627007",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumalpurm",
            "Pincode": "627007",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar Tirunelveli",
            "Pincode": "627008",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "627009",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Industrial Colony Pettai",
            "Pincode": "627010",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maharajanagar",
            "Pincode": "627011",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Reddiarpattti",
            "Pincode": "627051",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dhalapathisamudram",
            "Pincode": "627101",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dohnavur",
            "Pincode": "627102",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eruvadi Tirunelveli",
            "Pincode": "627103",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idinthakarai",
            "Pincode": "627104",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kavalkinar",
            "Pincode": "627105",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kundankulam",
            "Pincode": "627106",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mavadi",
            "Pincode": "627107",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nambinagar",
            "Pincode": "627108",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nanguneri",
            "Pincode": "627108",
            "City": "Nanguneri",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panagudi",
            "Pincode": "627109",
            "City": "Panagudi",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Parappadi",
            "Pincode": "627110",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Radhapuram",
            "Pincode": "627111",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Samugarengapuram",
            "Pincode": "627112",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Terku Kallikulam",
            "Pincode": "627113",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Terku Karungulam",
            "Pincode": "627114",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukarangudi",
            "Pincode": "627115",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakkankulam",
            "Pincode": "627116",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallioor",
            "Pincode": "627117",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallioor Perundu Nilayam",
            "Pincode": "627117",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vijayarayanam",
            "Pincode": "627118",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koliyankulam",
            "Pincode": "627120",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palavoor",
            "Pincode": "627121",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vijayapathi",
            "Pincode": "627122",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottaikarungulam",
            "Pincode": "627123",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Settikulam",
            "Pincode": "627124",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anaikulam",
            "Pincode": "627125",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannanallur",
            "Pincode": "627126",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuttapuli",
            "Pincode": "627127",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajakkamangalam",
            "Pincode": "627128",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramakrishnapuram",
            "Pincode": "627129",
            "City": "Theni",
            "District": "Theni",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvamblapuram",
            "Pincode": "627130",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veppilankulam",
            "Pincode": "627131",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koothankul",
            "Pincode": "627132",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maruthakulam",
            "Pincode": "627151",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Munradaippu",
            "Pincode": "627152",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karandaneri",
            "Pincode": "627153",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panankulam",
            "Pincode": "627154",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manur Tiruneveli",
            "Pincode": "627201",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ukkiramkottai",
            "Pincode": "627202",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ellanaickenpatti",
            "Pincode": "627251",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallanad",
            "Pincode": "627252",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaliavoor",
            "Pincode": "627253",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Murappanad",
            "Pincode": "627254",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Singathakurichi",
            "Pincode": "627255",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seydunganallur",
            "Pincode": "627301",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anavaradanallur",
            "Pincode": "627302",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vasavappapuram",
            "Pincode": "627303",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kittilapuram",
            "Pincode": "627304",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vittilapuram",
            "Pincode": "627304",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivandipatti",
            "Pincode": "627305",
            "City": "Thoothukkudi",
            "District": "Thoothukkudi",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Burkitmanagaram",
            "Pincode": "627351",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gangaikondan",
            "Pincode": "627352",
            "City": "Gangaikondan",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kizhanatham",
            "Pincode": "627353",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mulakaripatti",
            "Pincode": "627354",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Munanjipatti",
            "Pincode": "627355",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Munnirpallam",
            "Pincode": "627356",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Snkarnagar",
            "Pincode": "627357",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tachanallur",
            "Pincode": "627358",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajavallipuram",
            "Pincode": "627359",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Taruvai",
            "Pincode": "627360",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivalaperi",
            "Pincode": "627361",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambasamudram",
            "Pincode": "627401",
            "City": "Ambasamudram",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambasamudram East",
            "Pincode": "627401",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambasamudram H O",
            "Pincode": "627401",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Angadi",
            "Pincode": "627401",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alwar Kurichi",
            "Pincode": "627412",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Brahmadesam",
            "Pincode": "627413",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cheranmahadevi",
            "Pincode": "627414",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadayam",
            "Pincode": "627415",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalladaikurichi Market",
            "Pincode": "627416",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallidaikurichi",
            "Pincode": "627416",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaikurichi",
            "Pincode": "627417",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilambur",
            "Pincode": "627418",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodayar Melthangal",
            "Pincode": "627419",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manjolai",
            "Pincode": "627420",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manimuthar Project",
            "Pincode": "627421",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Papavinasam Mills",
            "Pincode": "627422",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pottalpudur",
            "Pincode": "627423",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ravanasamudram",
            "Pincode": "627424",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambalavanapuram",
            "Pincode": "627425",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vikramasingapuram",
            "Pincode": "627425",
            "City": "Vikramasingapuram",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viravanallur",
            "Pincode": "627426",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nalumukku",
            "Pincode": "627427",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivasailam",
            "Pincode": "627428",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellankuli",
            "Pincode": "627430",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avudayanur",
            "Pincode": "627431",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayakkarambalam Ii",
            "Pincode": "627431",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pappankulam",
            "Pincode": "627432",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivandipuram",
            "Pincode": "627433",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aladiyur",
            "Pincode": "627434",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Podukudu",
            "Pincode": "627435",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettur",
            "Pincode": "627436",
            "City": "Mettur",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Goapalasamudram",
            "Pincode": "627451",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melaseval",
            "Pincode": "627452",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattumadai",
            "Pincode": "627453",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalakad",
            "Pincode": "627501",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devanallur",
            "Pincode": "627502",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Papanasam Project",
            "Pincode": "627551",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Papanasam Pykara Colony",
            "Pincode": "627551",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mukkudal",
            "Pincode": "627601",
            "City": "Mukkudal",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Papagudi",
            "Pincode": "627602",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ariyanayagipuram Pettai",
            "Pincode": "627603",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakku",
            "Pincode": "627603",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakku Ariyanayagipuramp",
            "Pincode": "627603",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Suttamally",
            "Pincode": "627604",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilpatti H O",
            "Pincode": "627701",
            "City": "Kovilpatti",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilpatti Loyal Mills",
            "Pincode": "627701",
            "City": "Kovilpatti",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilpatti Town",
            "Pincode": "627701",
            "City": "Kovilpatti",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilpatti Veedhi",
            "Pincode": "627701",
            "City": "Kovilpatti",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilpatti",
            "Pincode": "627702",
            "City": "Kovilpatti",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lakshmipuram",
            "Pincode": "627702",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lakshmipuram Kovilpatti",
            "Pincode": "627702",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perundunilayam",
            "Pincode": "627702",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kathur Puvalur",
            "Pincode": "627706",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eppodumvendran",
            "Pincode": "627712",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ilayasasanendal",
            "Pincode": "627713",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadambur",
            "Pincode": "627714",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nallatinputhur",
            "Pincode": "627716",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Parivallikottai",
            "Pincode": "627717",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pasuvanthanai",
            "Pincode": "627718",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvengadam",
            "Pincode": "627719",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Turaiyur Koitpatti",
            "Pincode": "627720",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vanarmutti",
            "Pincode": "627721",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurukkuchalai",
            "Pincode": "627722",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ilavengal",
            "Pincode": "627723",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalingapatti",
            "Pincode": "627724",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadalai",
            "Pincode": "627725",
            "City": "Ramanathapuram",
            "District": "Ramanathapuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivagnanapuram",
            "Pincode": "627726",
            "City": "Thoothukkudi",
            "District": "Thoothukkudi",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "East Pandavarmangalam",
            "Pincode": "627727",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadayanallur",
            "Pincode": "627751",
            "City": "Kadayanallur",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadayanallur Bazaar",
            "Pincode": "627751",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadayanallur Pettai",
            "Pincode": "627751",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalugumalai",
            "Pincode": "627752",
            "City": "Kalugumalai",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karivalam Vandanallur",
            "Pincode": "627753",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuruvikulam",
            "Pincode": "627754",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mullikulam",
            "Pincode": "627755",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chockamppatti",
            "Pincode": "627756",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankarankoil Bazaar",
            "Pincode": "627756",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankarankoil East",
            "Pincode": "627756",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankarankoil H O",
            "Pincode": "627756",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivagiri",
            "Pincode": "627757",
            "City": "Sivagiri",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vasudevanallur",
            "Pincode": "627758",
            "City": "Vasudevanallur",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnapuram",
            "Pincode": "627759",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnapuram Tirunelveli",
            "Pincode": "627759",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mavadikkal",
            "Pincode": "627759",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melakadayanallur",
            "Pincode": "627759",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muthukrishnapuram",
            "Pincode": "627759",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panaiyur",
            "Pincode": "627761",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pannaiyur",
            "Pincode": "627761",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadamalaipuram",
            "Pincode": "627762",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viswanathapuri",
            "Pincode": "627763",
            "City": "Karur",
            "District": "Karur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Royagiri",
            "Pincode": "627764",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chokkampatti",
            "Pincode": "627765",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perungottur",
            "Pincode": "627766",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sokkanathampudur",
            "Pincode": "627767",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nellakattumseval",
            "Pincode": "627768",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumbattur",
            "Pincode": "627769",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tenmalalai",
            "Pincode": "627770",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manalur",
            "Pincode": "627771",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thaiaivankottai",
            "Pincode": "627773",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sayamalai",
            "Pincode": "627774",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Achanputhur",
            "Pincode": "627801",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Courtallam",
            "Pincode": "627802",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Courtallam Bus Stand",
            "Pincode": "627802",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kasimajorpuram",
            "Pincode": "627802",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elathur",
            "Pincode": "627803",
            "City": "Elathur",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idaikal",
            "Pincode": "627804",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ilanji",
            "Pincode": "627805",
            "City": "Ilanji",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilapavur",
            "Pincode": "627806",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shencottah",
            "Pincode": "627809",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shencottah Bus Stand",
            "Pincode": "627809",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shencottoh Cutchery",
            "Pincode": "627809",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shencottah R S",
            "Pincode": "627810",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melapuliyur",
            "Pincode": "627811",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tenkasi Bus Stand",
            "Pincode": "627811",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tenkasi East",
            "Pincode": "627811",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tenkasi H O",
            "Pincode": "627811",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tenkasi R S",
            "Pincode": "627811",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakarai Koilpatti",
            "Pincode": "627812",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puliyara",
            "Pincode": "627813",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kizhapuliyur",
            "Pincode": "627814",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivanadanur",
            "Pincode": "627815",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanakkapillaivalasi",
            "Pincode": "627816",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallam",
            "Pincode": "627817",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melagaram",
            "Pincode": "627818",
            "City": "Melagaram",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peddanadarpatti",
            "Pincode": "627819",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nainaragaram",
            "Pincode": "627820",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idaikal Ambasamudram",
            "Pincode": "627821",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajapandi",
            "Pincode": "627822",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellakkal",
            "Pincode": "627823",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alangulam",
            "Pincode": "627851",
            "City": "Alangulam",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayikudi",
            "Pincode": "627852",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nallur Tenkasi",
            "Pincode": "627853",
            "City": "Nallur",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nettur",
            "Pincode": "627854",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chintamani",
            "Pincode": "627855",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudhukudi",
            "Pincode": "627855",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puliangudi",
            "Pincode": "627855",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thirumalanayakkan",
            "Pincode": "627855",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Samburvadakarai",
            "Pincode": "627856",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Serndamangalam",
            "Pincode": "627857",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sundarapandiapuram",
            "Pincode": "627858",
            "City": "Sundarapandiam",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Surandai",
            "Pincode": "627859",
            "City": "Surandai",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uthumalai",
            "Pincode": "627860",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virrkeralampudur",
            "Pincode": "627861",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virasigamani",
            "Pincode": "627862",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pambakovil Shandy",
            "Pincode": "627863",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Punniahpuram",
            "Pincode": "627864",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veeranam",
            "Pincode": "627866",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veerapandi",
            "Pincode": "627866",
            "City": "Veerapandi",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Venkateswarapuram",
            "Pincode": "627867",
            "City": "Thiruvarur",
            "District": "Thiruvarur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ariyanayagipuram",
            "Pincode": "627901",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naduvisipatli",
            "Pincode": "627902",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulathur Tirunelveli",
            "Pincode": "627903",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagalapuram",
            "Pincode": "627904",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudur Tirunelveli",
            "Pincode": "627905",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vembathur",
            "Pincode": "627906",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilathikulam",
            "Pincode": "627907",
            "City": "Vilathikulam",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kila Iral",
            "Pincode": "627908",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veppalodai",
            "Pincode": "627909",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pillayaranatham",
            "Pincode": "627910",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perilovanpatti",
            "Pincode": "627911",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramachandrapuram",
            "Pincode": "627912",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devarkulam",
            "Pincode": "627951",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kayatar",
            "Pincode": "627952",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melanilidanallur",
            "Pincode": "627953",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vannikonendal",
            "Pincode": "627954",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karukkalpatti",
            "Pincode": "627955",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurukkalpatti",
            "Pincode": "627955",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panavadalichatram",
            "Pincode": "627956",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilnilidanallur",
            "Pincode": "627957",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Turicorin H O",
            "Pincode": "628001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tuticorin Harbour",
            "Pincode": "628001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tuticorin Kelur",
            "Pincode": "628001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vedakkur Tuticorin",
            "Pincode": "628001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vetrivelpuram",
            "Pincode": "628001",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alagesapuram",
            "Pincode": "628002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gibbsonpuram",
            "Pincode": "628002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Great Cotton Road",
            "Pincode": "628002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilashanmugapuram",
            "Pincode": "628002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melur Tuticorin",
            "Pincode": "628002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Polenaickenpettai",
            "Pincode": "628002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Victoria Extn Road",
            "Pincode": "628002",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Central Govt Servants Cly",
            "Pincode": "628003",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chidambaranagar",
            "Pincode": "628003",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Millerpuram",
            "Pincode": "628003",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "New Colony",
            "Pincode": "628003",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Estate",
            "Pincode": "628004",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Power Plant",
            "Pincode": "628004",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tuticorin Thermal",
            "Pincode": "628004",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muthiahpuram",
            "Pincode": "628005",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thermalngar",
            "Pincode": "628006",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thethakudi Therku",
            "Pincode": "628006",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Heavy Water Project Colony",
            "Pincode": "628007",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chidambaranagar",
            "Pincode": "628008",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athimarathupatti",
            "Pincode": "628051",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Korampallam",
            "Pincode": "628101",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mudittanendal",
            "Pincode": "628102",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudukkottai Tvl",
            "Pincode": "628103",
            "City": "Pudukkottai",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seekarakudi",
            "Pincode": "628104",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Taruvaikulam",
            "Pincode": "628105",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Autoor",
            "Pincode": "628151",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pazhayakayal",
            "Pincode": "628152",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melautoor",
            "Pincode": "628153",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mukkani",
            "Pincode": "628154",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Punnakayal",
            "Pincode": "628155",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammanpuram",
            "Pincode": "628201",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arumuganeri",
            "Pincode": "628202",
            "City": "Arumuganeri",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Christianagaram",
            "Pincode": "628203",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kayalpatnam",
            "Pincode": "628204",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kayamoli",
            "Pincode": "628205",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulasekharapatnam",
            "Pincode": "628206",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurumbur",
            "Pincode": "628207",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manadu Thandupattu",
            "Pincode": "628208",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manappad",
            "Pincode": "628209",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Megnanapuram",
            "Pincode": "628210",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nalumavadi",
            "Pincode": "628211",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paramankurichi",
            "Pincode": "628213",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puraiyur",
            "Pincode": "628214",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devasthanam",
            "Pincode": "628215",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchendur",
            "Pincode": "628215",
            "City": "Tiruchendur",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchendur Bus Stand",
            "Pincode": "628215",
            "City": "Tiruchendur",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchendur H O",
            "Pincode": "628215",
            "City": "Tiruchendur",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virapandianpattinam",
            "Pincode": "628216",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adaikalapuram",
            "Pincode": "628217",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannanvilai",
            "Pincode": "628218",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellalanvilai",
            "Pincode": "628219",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nathankinar",
            "Pincode": "628220",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alantalai",
            "Pincode": "628221",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melatiruchendur",
            "Pincode": "628222",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peyanvilai",
            "Pincode": "628223",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sonaganvilai",
            "Pincode": "628224",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanam",
            "Pincode": "628225",
            "City": "Kanam",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallipattu",
            "Pincode": "628226",
            "City": "Pallipattu",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viramanickam",
            "Pincode": "628227",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Theri Kudiyiruppu",
            "Pincode": "628228",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sawyerpuram",
            "Pincode": "628251",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Subramaniapuram Tvl",
            "Pincode": "628252",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalisapuram",
            "Pincode": "628301",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ottanatham",
            "Pincode": "628302",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naraikinar",
            "Pincode": "628303",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tattaparai",
            "Pincode": "628304",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maniyachi R S",
            "Pincode": "628305",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puliampatti",
            "Pincode": "628306",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marudanvalavoo",
            "Pincode": "628307",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puvani",
            "Pincode": "628308",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Akkanaickenpatti",
            "Pincode": "628309",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ottapidaram",
            "Pincode": "628401",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudiyamputhur",
            "Pincode": "628402",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthiamputhur",
            "Pincode": "628402",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Murli",
            "Pincode": "628513",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shrivaikuntam H O",
            "Pincode": "628601",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alwar Tinunagari",
            "Pincode": "628612",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Asirvadhapuram",
            "Pincode": "628613",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Campellabad",
            "Pincode": "628614",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karunkulam",
            "Pincode": "628615",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mukuperi",
            "Pincode": "628616",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nazareth",
            "Pincode": "628617",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neivilai",
            "Pincode": "628618",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padmanabhamangalam",
            "Pincode": "628619",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Patemangaram",
            "Pincode": "628620",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthukudi",
            "Pincode": "628621",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ththankulam",
            "Pincode": "628622",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thenthiruperai",
            "Pincode": "628623",
            "City": "Thenthiruperai",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kongarayakurichi",
            "Pincode": "628624",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arampannai",
            "Pincode": "628625",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kachanvilai",
            "Pincode": "628626",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Katchanvilai",
            "Pincode": "628626",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cherakulam",
            "Pincode": "628627",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattakarai",
            "Pincode": "628628",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karunkadal",
            "Pincode": "628629",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mirankulam",
            "Pincode": "628630",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallakulam",
            "Pincode": "628631",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idaiyankudi",
            "Pincode": "628651",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ittamozhi",
            "Pincode": "628652",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kommadikottai",
            "Pincode": "628653",
            "City": "Thoothukkudi",
            "District": "Thoothukkudi",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pettaikulam",
            "Pincode": "628654",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puchikadu",
            "Pincode": "628655",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthanharuvai",
            "Pincode": "628656",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tisaiyanvilai",
            "Pincode": "628657",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uvari",
            "Pincode": "628658",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaichittupudur",
            "Pincode": "628659",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuttam",
            "Pincode": "628660",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Polayarpuram",
            "Pincode": "628661",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thattarmadam",
            "Pincode": "628662",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naduvakurichi",
            "Pincode": "628663",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anandapuram",
            "Pincode": "628701",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mudalur",
            "Pincode": "628702",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padukapattu",
            "Pincode": "628703",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sattankulam",
            "Pincode": "628704",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peroua Thalai",
            "Pincode": "628705",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kattarimangalam",
            "Pincode": "628706",
            "City": "Thoothukkudi",
            "District": "Thoothukkudi",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambinagaram",
            "Pincode": "628707",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pannaivilai",
            "Pincode": "628751",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perungulam",
            "Pincode": "628752",
            "City": "Perungulam",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivagalali",
            "Pincode": "628753",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eral",
            "Pincode": "628801",
            "City": "Eral",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Siruthondanallur",
            "Pincode": "628802",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valavallam",
            "Pincode": "628803",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "C B Hospital",
            "Pincode": "629001",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnancoil",
            "Pincode": "629001",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lagancherry",
            "Pincode": "629001",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagercoil Bazaar",
            "Pincode": "629001",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagercoil Collectorate",
            "Pincode": "629001",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagercoil H O",
            "Pincode": "629001",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagercoil Town",
            "Pincode": "629001",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagercoil West",
            "Pincode": "629001",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nesamany Nagar",
            "Pincode": "629001",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadaserry",
            "Pincode": "629001",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Irulappapuram",
            "Pincode": "629002",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottar",
            "Pincode": "629002",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maravankudiyiruppu",
            "Pincode": "629002",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagercoil Ind Estate",
            "Pincode": "629002",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadiveeswaram",
            "Pincode": "629002",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vetturanimadam",
            "Pincode": "629003",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagercoil Ind Estate",
            "Pincode": "629004",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Edalakudi",
            "Pincode": "629051",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaliyal",
            "Pincode": "629101",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodayar Kilthangal",
            "Pincode": "629102",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alancholai",
            "Pincode": "629103",
            "City": "Tirunelveli",
            "District": "Tirunelveli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arumana",
            "Pincode": "629151",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idaikode",
            "Pincode": "629152",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaliakkavilai",
            "Pincode": "629153",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanjampuram",
            "Pincode": "629154",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanjiracode",
            "Pincode": "629155",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kappiyara",
            "Pincode": "629156",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karinkal",
            "Pincode": "629157",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kattathurai",
            "Pincode": "629158",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kizihmidalam",
            "Pincode": "629159",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palapallam",
            "Pincode": "629159",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kollengodu",
            "Pincode": "629160",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulasekharam",
            "Pincode": "629161",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kunnathur Nagercoil",
            "Pincode": "629162",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuzhithura",
            "Pincode": "629163",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manalikara",
            "Pincode": "629164",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marthanadam",
            "Pincode": "629165",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marthandam Bridge",
            "Pincode": "629165",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nallur",
            "Pincode": "629165",
            "City": "Nallur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mekkamandapam",
            "Pincode": "629166",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alagimandapuram",
            "Pincode": "629167",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mulagumoodu",
            "Pincode": "629167",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gnanamvilai",
            "Pincode": "629168",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pacode",
            "Pincode": "629168",
            "City": "Pacode",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palliyadi",
            "Pincode": "629169",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palukal",
            "Pincode": "629170",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Munichiraj",
            "Pincode": "629171",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudukada",
            "Pincode": "629171",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "S T Mangad",
            "Pincode": "629172",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thengapattinam",
            "Pincode": "629173",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvithamcode",
            "Pincode": "629174",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Fort",
            "Pincode": "629175",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Methukadai",
            "Pincode": "629175",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mulachel",
            "Pincode": "629175",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padmanabhapuram",
            "Pincode": "629175",
            "City": "Padmanabhapuram",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thuckalay H O",
            "Pincode": "629175",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thuthur",
            "Pincode": "629176",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvattor",
            "Pincode": "629177",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udayamarthandam",
            "Pincode": "629178",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Unnamalaikada",
            "Pincode": "629179",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Villukuri",
            "Pincode": "629180",
            "City": "Villukuri",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kirathur",
            "Pincode": "629181",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponmana",
            "Pincode": "629182",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiruvarambu",
            "Pincode": "629183",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Killiyur",
            "Pincode": "629187",
            "City": "Killiyur",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Painkulam",
            "Pincode": "629188",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumarapuram",
            "Pincode": "629189",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sooriacode",
            "Pincode": "629190",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Atur",
            "Pincode": "629191",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vallavilai",
            "Pincode": "629192",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kizhkullam",
            "Pincode": "629193",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nattalam",
            "Pincode": "629195",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangarai",
            "Pincode": "629196",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Irenipuram",
            "Pincode": "629197",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Asaripallam",
            "Pincode": "629201",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mottom",
            "Pincode": "629202",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Friday Market",
            "Pincode": "629203",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammandivilai",
            "Pincode": "629204",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Santhapuram",
            "Pincode": "629205",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Colachal",
            "Pincode": "629251",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Colachal Port",
            "Pincode": "629251",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manavalakurichi",
            "Pincode": "629252",
            "City": "Manavalakurichi",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadiyapattinam",
            "Pincode": "629253",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aramboly",
            "Pincode": "629301",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramapuram",
            "Pincode": "629303",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chenbagaramanpudur",
            "Pincode": "629304",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellamadam",
            "Pincode": "629305",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Azhagappapuram",
            "Pincode": "629401",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marunkur",
            "Pincode": "629402",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mylady",
            "Pincode": "629403",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellaram",
            "Pincode": "629403",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Variyur",
            "Pincode": "629404",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulasekarapuram",
            "Pincode": "629406",
            "City": "Kulasekarapuram",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eathamozhi",
            "Pincode": "629501",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ganapathipuram Nagercoil",
            "Pincode": "629502",
            "City": "Ganapathipuram",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajakkamangalam",
            "Pincode": "629503",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "James Town",
            "Pincode": "629504",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kesavaputhanthurai",
            "Pincode": "629509",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Parakkai",
            "Pincode": "629601",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthalam",
            "Pincode": "629602",
            "City": "Puthalam",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thengamputhur",
            "Pincode": "629603",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idaivchivalai",
            "Pincode": "629664",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Agasteeswaram",
            "Pincode": "629701",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanyakumari",
            "Pincode": "629702",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vivekanandapuram",
            "Pincode": "629702",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottaram",
            "Pincode": "629703",
            "City": "Kottaram",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Suchindram",
            "Pincode": "629704",
            "City": "Suchindram",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sugarcane Breeding",
            "Pincode": "629704",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valakkamparai",
            "Pincode": "629704",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mahadanapuram K K",
            "Pincode": "629706",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thamaraikulam",
            "Pincode": "629707",
            "City": "Theni",
            "District": "Theni",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "South Thamaraikulam",
            "Pincode": "629708",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aloor",
            "Pincode": "629801",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyyoor",
            "Pincode": "629802",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neyyoor West",
            "Pincode": "629803",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thikkanamcode",
            "Pincode": "629804",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurunthencode",
            "Pincode": "629805",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuttimangode",
            "Pincode": "629806",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chunkankadai",
            "Pincode": "629807",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallukettam",
            "Pincode": "629808",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karankad",
            "Pincode": "629809",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Azhakiapandiapuram Darsan",
            "Pincode": "629851",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bhoothapandy",
            "Pincode": "629852",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kiriparai",
            "Pincode": "629854",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadukkarai",
            "Pincode": "629855",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thazhakudi",
            "Pincode": "629901",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Erachakulam",
            "Pincode": "629902",
            "City": "Kanyakumari",
            "District": "Kanyakumari",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaikudi Angodi",
            "Pincode": "630001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaikudi Bus Stand",
            "Pincode": "630001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaikudi H O",
            "Pincode": "630001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaikudi South Street",
            "Pincode": "630001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arakkonam Bazaar",
            "Pincode": "631001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arakkonam H O",
            "Pincode": "631001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "631001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rajijinagar",
            "Pincode": "631001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jothinagar",
            "Pincode": "631003",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ekhunagar",
            "Pincode": "631004",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Namali",
            "Pincode": "631051",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panapakkam",
            "Pincode": "631052",
            "City": "Panapakkam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumalpur",
            "Pincode": "631053",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valaikulam",
            "Pincode": "631057",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ichiputhur",
            "Pincode": "631060",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanigaipolur",
            "Pincode": "631061",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Guruvarajupettai",
            "Pincode": "631101",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sholinghur",
            "Pincode": "631102",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sholinghur Bazaar",
            "Pincode": "631102",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jambukulam",
            "Pincode": "631104",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodakkal",
            "Pincode": "631105",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Takkolam",
            "Pincode": "631151",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arungolam",
            "Pincode": "631201",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanchipuram Collectorate",
            "Pincode": "631201",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athimanjeeripet",
            "Pincode": "631202",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadambathur",
            "Pincode": "631203",
            "City": "Thiruvallur",
            "District": "Thiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Podaturpet",
            "Pincode": "631203",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanakammachatram",
            "Pincode": "631204",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "K G Kandigai",
            "Pincode": "631205",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madduru",
            "Pincode": "631206",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallipat",
            "Pincode": "631207",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallipat Bazaar",
            "Pincode": "631207",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruthani West",
            "Pincode": "631209",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruttani",
            "Pincode": "631209",
            "City": "Tiruttani",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruttani East",
            "Pincode": "631209",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruttani North",
            "Pincode": "631209",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruttani South",
            "Pincode": "631209",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvelangadu",
            "Pincode": "631210",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saraswathinagar",
            "Pincode": "631211",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponpadi R S",
            "Pincode": "631213",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammavarikuppam",
            "Pincode": "631301",
            "City": "Ammavarikuppam",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Erumbi",
            "Pincode": "631302",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramakrishnarajupeta",
            "Pincode": "631303",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vanganur",
            "Pincode": "631304",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilacheri",
            "Pincode": "631401",
            "City": "Thiruvallur",
            "District": "Thiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perambakkam",
            "Pincode": "631402",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ulandai",
            "Pincode": "631404",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanchipuram Cutcherry",
            "Pincode": "631501",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanchipuram H O",
            "Pincode": "631501",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pillayarpalayam",
            "Pincode": "631501",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thoopul",
            "Pincode": "631501",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Big Kanchipuram",
            "Pincode": "631502",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanchipuram Bus Stand",
            "Pincode": "631502",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanchpuram R S",
            "Pincode": "631502",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivakanchi",
            "Pincode": "631502",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Little Kanchipuram",
            "Pincode": "631503",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirukatchinambistreet",
            "Pincode": "631503",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vishnukanchi",
            "Pincode": "631503",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Balchettichatram",
            "Pincode": "631551",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Edayarpakkam",
            "Pincode": "631553",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayyampettai",
            "Pincode": "631601",
            "City": "Ayyampettai",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Damal",
            "Pincode": "631602",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Magaral",
            "Pincode": "631603",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thenneri",
            "Pincode": "631604",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Masilamani Nagar",
            "Pincode": "631605",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Walajabad",
            "Pincode": "631605",
            "City": "Walajabad",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palayaseevaram",
            "Pincode": "631606",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arpakkam",
            "Pincode": "631609",
            "City": "Tiruvallur",
            "District": "Tiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Akkur N A",
            "Pincode": "631701",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mamandur-Kcm",
            "Pincode": "631702",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dusi",
            "Pincode": "631703",
            "City": "Dusi",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kosapet",
            "Pincode": "632001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishna Nagar",
            "Pincode": "632001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Old District Brd Building",
            "Pincode": "632001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Old Town Vlr",
            "Pincode": "632001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sainathapuram Vlr",
            "Pincode": "632001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankaranpalayam",
            "Pincode": "632001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sullivananpet",
            "Pincode": "632001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Voorhees College",
            "Pincode": "632001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bagayam",
            "Pincode": "632002",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Christian Medical College",
            "Pincode": "632002",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thorapadi",
            "Pincode": "632002",
            "City": "Thorapadi",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thorapalli",
            "Pincode": "632002",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellore Kasba",
            "Pincode": "632003",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bakiyath",
            "Pincode": "632004",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bye Pass Road",
            "Pincode": "632004",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Christian Medical College",
            "Pincode": "632004",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Road",
            "Pincode": "632004",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellore Bazar",
            "Pincode": "632004",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellore Cantoment",
            "Pincode": "632004",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellore Fort",
            "Pincode": "632004",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellore Market",
            "Pincode": "632004",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellore Collectorate",
            "Pincode": "632005",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar East",
            "Pincode": "632006",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar Vellore",
            "Pincode": "632006",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar West",
            "Pincode": "632006",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudhampet",
            "Pincode": "632006",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Katpadi",
            "Pincode": "632007",
            "City": "Katpadi",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shenbakkam",
            "Pincode": "632008",
            "City": "Shenbakkam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sathavachari",
            "Pincode": "632009",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sathuvachari Extension",
            "Pincode": "632009",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Abdullapuram",
            "Pincode": "632010",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pennathur",
            "Pincode": "632011",
            "City": "Pennathur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kakothapattarai Vellore",
            "Pincode": "632012",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saidapet Vellore",
            "Pincode": "632012",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Konavattam",
            "Pincode": "632013",
            "City": "Konavattam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palamathi",
            "Pincode": "632051",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Edayansathu",
            "Pincode": "632052",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Brahmapuram",
            "Pincode": "632053",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumugai",
            "Pincode": "632054",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ariyur",
            "Pincode": "632055",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Munjurupattu",
            "Pincode": "632057",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anaikattu",
            "Pincode": "632101",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaniyambadi",
            "Pincode": "632102",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Odukkathur",
            "Pincode": "632103",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virnjipuram",
            "Pincode": "632104",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ussoor",
            "Pincode": "632105",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "S L R Sanitorium",
            "Pincode": "632106",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Guruvarajapalayam",
            "Pincode": "632107",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sevur",
            "Pincode": "632108",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veppankuppam",
            "Pincode": "632109",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pinnathurai",
            "Pincode": "632110",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eripudur",
            "Pincode": "632112",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilvaithinankuppam",
            "Pincode": "632201",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Latteri",
            "Pincode": "632202",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melmayil",
            "Pincode": "632203",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vaduganthangal",
            "Pincode": "632204",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadugapatti",
            "Pincode": "632204",
            "City": "Vadugapatti",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Machanur",
            "Pincode": "632205",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanguppam",
            "Pincode": "632206",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melkavanur",
            "Pincode": "632207",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramalai",
            "Pincode": "632208",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ruhsa Campus",
            "Pincode": "632209",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilkothur",
            "Pincode": "632211",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arni Bazaar",
            "Pincode": "632301",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arni Fort",
            "Pincode": "632301",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arni H O",
            "Pincode": "632301",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arunagirichatram",
            "Pincode": "632301",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saidapettai Arni",
            "Pincode": "632301",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannamangalam",
            "Pincode": "632311",
            "City": "Kannamangalam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kattukanur",
            "Pincode": "632312",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kolappalur N A",
            "Pincode": "632313",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kunnathur Arni",
            "Pincode": "632314",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Onnupuram",
            "Pincode": "632315",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chevur",
            "Pincode": "632316",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Satyavizhianagaram",
            "Pincode": "632317",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valapandal",
            "Pincode": "632318",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kammavanpettai",
            "Pincode": "632319",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sedarampatti",
            "Pincode": "632320",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Munugapattu",
            "Pincode": "632322",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melsishamangalam",
            "Pincode": "632323",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nanjukondapuram",
            "Pincode": "632324",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sirumur",
            "Pincode": "632325",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ranipet Bazaar",
            "Pincode": "632401",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ranipet East",
            "Pincode": "632401",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ranipet H O",
            "Pincode": "632401",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Navalpur",
            "Pincode": "632402",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ranipet Ind Estate",
            "Pincode": "632403",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karai N A",
            "Pincode": "632404",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mukundarayapuram",
            "Pincode": "632405",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammoor",
            "Pincode": "632501",
            "City": "Ammoor",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anavardhikhanpettai",
            "Pincode": "632502",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arcot Bazaar",
            "Pincode": "632503",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arcot H O",
            "Pincode": "632503",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arcot West",
            "Pincode": "632503",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arignar Anna Govt",
            "Pincode": "632503",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thoppukana",
            "Pincode": "632503",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Damarapakkam",
            "Pincode": "632504",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Banavaram",
            "Pincode": "632505",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalavai",
            "Pincode": "632506",
            "City": "Kalavai",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kavanur",
            "Pincode": "632507",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaveripauk",
            "Pincode": "632508",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melvishram",
            "Pincode": "632509",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Minnal",
            "Pincode": "632510",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sakkaramallur",
            "Pincode": "632511",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Timiri",
            "Pincode": "632512",
            "City": "Timiri",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Walajapet",
            "Pincode": "632513",
            "City": "Walajapet",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Walajapet Bazar",
            "Pincode": "632513",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponnai",
            "Pincode": "632514",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruvalam",
            "Pincode": "632515",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vennampalle",
            "Pincode": "632516",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ratnagiri Kilminnal",
            "Pincode": "632517",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pennagar",
            "Pincode": "632518",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellore Sugar Mills",
            "Pincode": "632519",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vilapakkam",
            "Pincode": "632521",
            "City": "Vilapakkam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ozhugur",
            "Pincode": "632522",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sattur Vellore",
            "Pincode": "632523",
            "City": "Sattur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valluvambakkam",
            "Pincode": "632524",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Moranam",
            "Pincode": "632525",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadaperi",
            "Pincode": "632526",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chennasamudram",
            "Pincode": "632527",
            "City": "Chennasamudram",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Brahmadesam",
            "Pincode": "632528",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Keerasathu",
            "Pincode": "632529",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puttuthakku",
            "Pincode": "632530",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ocheri",
            "Pincode": "632531",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharnampet",
            "Pincode": "632601",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pichanur Gudiyattam",
            "Pincode": "632601",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gudiyattam Cutcherry",
            "Pincode": "632602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gudiyattam H O",
            "Pincode": "632602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gudiyattam South",
            "Pincode": "632602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paradarami",
            "Pincode": "632603",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar Gudiyatham",
            "Pincode": "632604",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sempalli",
            "Pincode": "632605",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallapadi",
            "Pincode": "632606",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veerisettipall",
            "Pincode": "632607",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kizhalathur",
            "Pincode": "632608",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dowlatabad",
            "Pincode": "635001",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kathinayanapalli",
            "Pincode": "635001",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnagiri Bus Stand",
            "Pincode": "635001",
            "City": "Krishnagiri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnagiri Courts",
            "Pincode": "635001",
            "City": "Krishnagiri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnagiri H O",
            "Pincode": "635001",
            "City": "Krishnagiri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnagiri Ind Estate",
            "Pincode": "635001",
            "City": "Krishnagiri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lakshmipuram Krp",
            "Pincode": "635001",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnagiri Oldpet",
            "Pincode": "635002",
            "City": "Krishnagiri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnagiri Project",
            "Pincode": "635101",
            "City": "Krishnagiri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anchetty",
            "Pincode": "635102",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bagalur",
            "Pincode": "635103",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Barugur",
            "Pincode": "635104",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Berigai",
            "Pincode": "635105",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chaparthi",
            "Pincode": "635106",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Denkanikota",
            "Pincode": "635107",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elathagiri",
            "Pincode": "635108",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hosur",
            "Pincode": "635109",
            "City": "Hosur",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kothapeta Hosur",
            "Pincode": "635109",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hosur Cattle Farm",
            "Pincode": "635110",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karimangalam",
            "Pincode": "635111",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaveripattinam Bazaar",
            "Pincode": "635112",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaveripattinam Dharmapuri",
            "Pincode": "635112",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kelamanglam",
            "Pincode": "635113",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mathakondapalli",
            "Pincode": "635114",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramapuram",
            "Pincode": "635115",
            "City": "Ramapuram",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shoolagiri",
            "Pincode": "635117",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thally",
            "Pincode": "635118",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uddanpalli",
            "Pincode": "635119",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Varattanpalli",
            "Pincode": "635120",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veppanapalli",
            "Pincode": "635121",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alappatti",
            "Pincode": "635122",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pannandur",
            "Pincode": "635123",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hosur East",
            "Pincode": "635125",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hosur Industrial Complex",
            "Pincode": "635126",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maharajakadai",
            "Pincode": "635127",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mekalachinnampalli",
            "Pincode": "635128",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Agraharam",
            "Pincode": "635129",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thorapalli",
            "Pincode": "635129",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sundekuppan",
            "Pincode": "635130",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kammampalli",
            "Pincode": "635131",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athimugam",
            "Pincode": "635132",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chigarlapalli",
            "Pincode": "635133",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamandoddi",
            "Pincode": "635134",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jagadab",
            "Pincode": "635135",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Damodarahalli",
            "Pincode": "635136",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perandapalli",
            "Pincode": "635137",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Andevanapalli",
            "Pincode": "635138",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Erudukottai",
            "Pincode": "635139",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sandanahalli",
            "Pincode": "635140",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salivaram",
            "Pincode": "635141",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Barur",
            "Pincode": "635201",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kambainallur",
            "Pincode": "635202",
            "City": "Kambainallur",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mathur-Dhamapuri",
            "Pincode": "635203",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagarasampatti",
            "Pincode": "635204",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyanahalli",
            "Pincode": "635205",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pochampalli",
            "Pincode": "635206",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uttangarai",
            "Pincode": "635207",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arasampatti",
            "Pincode": "635208",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saithur",
            "Pincode": "635209",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jagadevi",
            "Pincode": "635210",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannadahalli",
            "Pincode": "635211",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Irumathur",
            "Pincode": "635212",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bommidi",
            "Pincode": "635301",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Buddireddipatti",
            "Pincode": "635302",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadathur",
            "Pincode": "635303",
            "City": "Kadathur",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallavi",
            "Pincode": "635304",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Morappur",
            "Pincode": "635305",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Samalpatti R S",
            "Pincode": "635306",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Singarapettai",
            "Pincode": "635307",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bairanatham Pallipatti",
            "Pincode": "635308",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periathallapadi",
            "Pincode": "635309",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thalanatham",
            "Pincode": "635310",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanahalli",
            "Pincode": "635311",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mottankurichi",
            "Pincode": "635312",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chintalapadi",
            "Pincode": "635313",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cutcherrustreet",
            "Pincode": "635601",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhipet",
            "Pincode": "635601",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupattur Extension",
            "Pincode": "635601",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruppattur H O N A",
            "Pincode": "635601",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruppatur Bazar",
            "Pincode": "635602",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Korathi",
            "Pincode": "635611",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupettai",
            "Pincode": "635651",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vishamangalam",
            "Pincode": "635652",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vengalapurm",
            "Pincode": "635653",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sundarampalli",
            "Pincode": "635654",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Adiyur",
            "Pincode": "635655",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paniyandapalli",
            "Pincode": "635656",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jayapuram",
            "Pincode": "635657",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthugaram",
            "Pincode": "635659",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bommikuppam",
            "Pincode": "635660",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurumberi",
            "Pincode": "635661",
            "City": "Thiruvarur",
            "District": "Thiruvarur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sevathur",
            "Pincode": "635662",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alangayam",
            "Pincode": "635701",
            "City": "Alangayam",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Andiappanur",
            "Pincode": "635702",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jamanamarathur",
            "Pincode": "635703",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kavalur",
            "Pincode": "635704",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Irunapattu",
            "Pincode": "635705",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurusilapattu",
            "Pincode": "635706",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poongulam",
            "Pincode": "635707",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nachiarkuppam",
            "Pincode": "635708",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumapattu",
            "Pincode": "635709",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Govindapuram",
            "Pincode": "635751",
            "City": "Erode",
            "District": "Erode",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudur",
            "Pincode": "635751",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vanimbadi",
            "Pincode": "635751",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vanimbadi Cutcherry",
            "Pincode": "635751",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vaniyambadi",
            "Pincode": "635752",
            "City": "Vaniyambadi",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Khaderpet",
            "Pincode": "635753",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jaffarabad",
            "Pincode": "635754",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udayandiram",
            "Pincode": "635755",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellakuttai",
            "Pincode": "635756",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kothakottai",
            "Pincode": "635757",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalendra",
            "Pincode": "635758",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambalur",
            "Pincode": "635801",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambur",
            "Pincode": "635802",
            "City": "Ambur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambur Bazaar",
            "Pincode": "635802",
            "City": "Ambur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambur R S",
            "Pincode": "635802",
            "City": "Ambur",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gudiyattam R S",
            "Pincode": "635803",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madanur",
            "Pincode": "635804",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mailpatti",
            "Pincode": "635805",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melalathur",
            "Pincode": "635806",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Minnur",
            "Pincode": "635807",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Oomarabad",
            "Pincode": "635808",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallikonda",
            "Pincode": "635809",
            "City": "Pallikonda",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perambur",
            "Pincode": "635810",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thuthipattu",
            "Pincode": "635811",
            "City": "Thuthipattu",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadapudpet",
            "Pincode": "635812",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valathoor",
            "Pincode": "635813",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shanakuppam",
            "Pincode": "635814",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kethandapatti Sugar Mills",
            "Pincode": "635815",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Agaram",
            "Pincode": "635816",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valayakarapatti",
            "Pincode": "635817",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kottur",
            "Pincode": "635818",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nariyambattu",
            "Pincode": "635819",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kethandapatti",
            "Pincode": "635820",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vinnamangalam",
            "Pincode": "635821",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakkupattu Na",
            "Pincode": "635822",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alasandapuram",
            "Pincode": "635823",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanaickenpettai",
            "Pincode": "635824",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilmurungai",
            "Pincode": "635825",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Agaramcherry",
            "Pincode": "635826",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jolarpettai",
            "Pincode": "635851",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pakkirthakka",
            "Pincode": "635853",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pachur",
            "Pincode": "635854",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Yelagiri Hills",
            "Pincode": "635855",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mandalavadi",
            "Pincode": "635856",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athurukuppam",
            "Pincode": "635857",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kandili",
            "Pincode": "635901",
            "City": "Sivaganga",
            "District": "Sivaganga",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Agraharam",
            "Pincode": "636001",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dadubaikuttai",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devendrapuram",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kitchipalayam",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettu Street",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narayananagar",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponnamapettai",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem Bazaar",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem Collectorate",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem District Board Bldg",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem East",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem Fort",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem H O",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem Second",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thillainagar",
            "Pincode": "636001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anandanapatti",
            "Pincode": "636002",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marakkadai",
            "Pincode": "636002",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nethimedu",
            "Pincode": "636002",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shevapet",
            "Pincode": "636002",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shevapet Bazaar",
            "Pincode": "636002",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammapettai Bazaar",
            "Pincode": "636003",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammapettai Salem",
            "Pincode": "636003",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alagapuram",
            "Pincode": "636004",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Fair Lands",
            "Pincode": "636004",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Meyyanur",
            "Pincode": "636004",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gugi Salem",
            "Pincode": "636006",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem Pension Lines",
            "Pincode": "636006",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem South",
            "Pincode": "636006",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sanjeevarayanpettai",
            "Pincode": "636006",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hastampatti",
            "Pincode": "636007",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maravaneri",
            "Pincode": "636007",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peramanur",
            "Pincode": "636007",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem A R Lines",
            "Pincode": "636007",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem Extn",
            "Pincode": "636007",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem North",
            "Pincode": "636007",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salen Dr Court Building",
            "Pincode": "636007",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayyanthirumaligai",
            "Pincode": "636008",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannankurichi",
            "Pincode": "636008",
            "City": "Kannankurichi",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arisipalayam",
            "Pincode": "636009",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Leigh Bazaar",
            "Pincode": "636009",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallapatti Salem",
            "Pincode": "636009",
            "City": "Pallapatti",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kondalampatti",
            "Pincode": "636010",
            "City": "Kondalampatti",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Govt College Of Engg Salem",
            "Pincode": "636011",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karuppur",
            "Pincode": "636012",
            "City": "Karuppur",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem Steel Plant",
            "Pincode": "636013",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kamarajar Colony",
            "Pincode": "636014",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Fairlands",
            "Pincode": "636016",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aragalur",
            "Pincode": "636101",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Attur Salem",
            "Pincode": "636102",
            "City": "Attur",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Atur Bazaar",
            "Pincode": "636102",
            "City": "Attur",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "636102",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupet Attur",
            "Pincode": "636102",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udayarpalayam",
            "Pincode": "636102",
            "City": "Udayarpalayam",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ayodhyapattinam",
            "Pincode": "636103",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Belur Salem",
            "Pincode": "636104",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gangavalli",
            "Pincode": "636105",
            "City": "Gangavalli",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karipatti",
            "Pincode": "636106",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mallikarai",
            "Pincode": "636107",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narasingapuram",
            "Pincode": "636108",
            "City": "Narasingapuram",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pethanmickenpalayam",
            "Pincode": "636109",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sendarapatti",
            "Pincode": "636110",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seshanchavadi",
            "Pincode": "636111",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seshasayee Paper",
            "Pincode": "636111",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Talaivasal",
            "Pincode": "636112",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thammampatti",
            "Pincode": "636113",
            "City": "Thammampatti",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thumbai",
            "Pincode": "636114",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valapady",
            "Pincode": "636115",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Viragalur",
            "Pincode": "636116",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Yethapur",
            "Pincode": "636117",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ulipuram",
            "Pincode": "636118",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puthiragoundenpalayam",
            "Pincode": "636119",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadachennimalai",
            "Pincode": "636121",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sukkampatti",
            "Pincode": "636122",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadambur",
            "Pincode": "636124",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kondayampalli",
            "Pincode": "636130",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thadavur",
            "Pincode": "636137",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karumanthurai",
            "Pincode": "636138",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koottathupatti",
            "Pincode": "636139",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem H O",
            "Pincode": "636139",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Odayapatti",
            "Pincode": "636140",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupet",
            "Pincode": "636141",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangalapuram",
            "Pincode": "636202",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mullur-Salem",
            "Pincode": "636203",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panamarathupatti",
            "Pincode": "636204",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athanur",
            "Pincode": "636301",
            "City": "Athanur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jagir Ammapalayam",
            "Pincode": "636302",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kolathur-Salem",
            "Pincode": "636303",
            "City": "Kolathur",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muthunaickenpatti",
            "Pincode": "636304",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pannapatti",
            "Pincode": "636305",
            "City": "Karur",
            "District": "Karur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivathapuram",
            "Pincode": "636307",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virapandi Slm",
            "Pincode": "636308",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thenalpalayam",
            "Pincode": "636318",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karavalli",
            "Pincode": "636319",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadyampatti",
            "Pincode": "636351",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Toppur",
            "Pincode": "636352",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem",
            "Pincode": "636354",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettur Dam H O",
            "Pincode": "636401",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettur Dam North",
            "Pincode": "636401",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettur Dam South",
            "Pincode": "636401",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettur Dam R S",
            "Pincode": "636402",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thangamapuripattinam",
            "Pincode": "636402",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramannagar",
            "Pincode": "636403",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gonur",
            "Pincode": "636404",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chamarajpet",
            "Pincode": "636451",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madayankuttai",
            "Pincode": "636452",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mecheri",
            "Pincode": "636453",
            "City": "Mecheri",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nangavalli",
            "Pincode": "636454",
            "City": "Nangavalli",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Omalur",
            "Pincode": "636455",
            "City": "Omalur",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Omalur Cutcherry",
            "Pincode": "636455",
            "City": "Omalur",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Salem",
            "Pincode": "636456",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vanavasi Slm",
            "Pincode": "636457",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mallikundam",
            "Pincode": "636458",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Navapatti",
            "Pincode": "636462",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virudasampatti",
            "Pincode": "636463",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jalakantapuram",
            "Pincode": "636501",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tharamangalam",
            "Pincode": "636502",
            "City": "Tharamangalam",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tholasampatti",
            "Pincode": "636503",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Yercaud",
            "Pincode": "636601",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ondikadai",
            "Pincode": "636602",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagalur-Salem",
            "Pincode": "636604",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Appavoo Nagar",
            "Pincode": "636701",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharmapuri Bus Stand",
            "Pincode": "636701",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharmapuri H O",
            "Pincode": "636701",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharmapuri Public Office",
            "Pincode": "636701",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharmapuri R S",
            "Pincode": "636701",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharmapuri Bazaar",
            "Pincode": "636702",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharmapuri Fort",
            "Pincode": "636702",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharmapuri South",
            "Pincode": "636702",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Komarasamipatti",
            "Pincode": "636703",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annasagaram",
            "Pincode": "636704",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharmapuri Collectorate",
            "Pincode": "636705",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Venkatanahalli",
            "Pincode": "636751",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hanumanthapuram",
            "Pincode": "636802",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Harur",
            "Pincode": "636803",
            "City": "Harur",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Indur",
            "Pincode": "636803",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Laligam",
            "Pincode": "636804",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mallupatti",
            "Pincode": "636805",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marandahalli",
            "Pincode": "636806",
            "City": "Marandahalli",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nallampalli",
            "Pincode": "636807",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palacode",
            "Pincode": "636808",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pauparapatti",
            "Pincode": "636809",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pennagaram",
            "Pincode": "636810",
            "City": "Pennagaram",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumbalai",
            "Pincode": "636811",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panjapalli",
            "Pincode": "636812",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Biliyanur Agraharam",
            "Pincode": "636813",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nagamalai",
            "Pincode": "636815",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sunchalnatham",
            "Pincode": "636816",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manyadahalli",
            "Pincode": "636821",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mappedu",
            "Pincode": "636821",
            "City": "Thiruvallur",
            "District": "Thiruvallur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Echambadi",
            "Pincode": "636902",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Menisi",
            "Pincode": "636904",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pappireddipatti",
            "Pincode": "636905",
            "City": "Pappireddipatti",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirthamalai",
            "Pincode": "636906",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Harur Bazaar",
            "Pincode": "636908",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thenkarai Kottar",
            "Pincode": "636915",
            "City": "Dharmapuri",
            "District": "Dharmapuri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Namakkal Bazaar",
            "Pincode": "637001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Namakkal Fort",
            "Pincode": "637001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Namakkal H O",
            "Pincode": "637001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Natarajapuram",
            "Pincode": "637001",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramapurampdur",
            "Pincode": "637001",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ganesapuram",
            "Pincode": "637002",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Santhiapettipudur",
            "Pincode": "637002",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thillaipuram",
            "Pincode": "637002",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nallipalayam",
            "Pincode": "637003",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eranipatti",
            "Pincode": "637013",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karakurichi",
            "Pincode": "637014",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mohanur",
            "Pincode": "637015",
            "City": "Mohanur",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mohanur North",
            "Pincode": "637015",
            "City": "Mohanur",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palalpatti",
            "Pincode": "637017",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puduchatram",
            "Pincode": "637018",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sellappampatti",
            "Pincode": "637019",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valayapatti Slem",
            "Pincode": "637020",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Varagur",
            "Pincode": "637021",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pachal",
            "Pincode": "637023",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pottireddipatti",
            "Pincode": "637024",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "N Pundupatti",
            "Pincode": "637026",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idappadi",
            "Pincode": "637101",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idappadi Bazaar",
            "Pincode": "637101",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Konganapuram",
            "Pincode": "637102",
            "City": "Konganapuram",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mc Donalds Choultry",
            "Pincode": "637103",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thevur Salem",
            "Pincode": "637104",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poolampatti",
            "Pincode": "637107",
            "City": "Poolampatti",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chittoor",
            "Pincode": "637109",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chittalandur",
            "Pincode": "637201",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elachipalayam",
            "Pincode": "637202",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadampalayam",
            "Pincode": "637203",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kapilamalai",
            "Pincode": "637204",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumaramangalam",
            "Pincode": "637205",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nadandai",
            "Pincode": "637206",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paramathi",
            "Pincode": "637207",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paundamangalam",
            "Pincode": "637208",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seetharamapalayam",
            "Pincode": "637209",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Solasitamani",
            "Pincode": "637210",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchengodu H O",
            "Pincode": "637211",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchengodu North",
            "Pincode": "637211",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruchengodu West",
            "Pincode": "637211",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velagoundanpatti",
            "Pincode": "637212",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jadarpalayam",
            "Pincode": "637213",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vattur",
            "Pincode": "637217",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankaridurg",
            "Pincode": "637301",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankaridurg East",
            "Pincode": "637301",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankaridrug R S",
            "Pincode": "637302",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankaridurg West",
            "Pincode": "637303",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thannirpandalpayalam",
            "Pincode": "637304",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padaiveedu",
            "Pincode": "637306",
            "City": "Padaiveedu",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Andagalur",
            "Pincode": "637401",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Belukurichi",
            "Pincode": "637402",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Guruswamipalayam",
            "Pincode": "637403",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalappanaickenpatti",
            "Pincode": "637404",
            "City": "Kalappanaickenpatti",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muthugapatti",
            "Pincode": "637405",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Namagiribettai",
            "Pincode": "637406",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rashipuram",
            "Pincode": "637408",
            "City": "Namakkal",
            "District": "Namakkal",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rashipuram Bazar",
            "Pincode": "637408",
            "City": "Namakkal",
            "District": "Namakkal",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rashipuram East",
            "Pincode": "637408",
            "City": "Namakkal",
            "District": "Namakkal",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rasipuram",
            "Pincode": "637408",
            "City": "Rasipuram",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rasipuram Bazaar",
            "Pincode": "637408",
            "City": "Rasipuram",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rasipuram East",
            "Pincode": "637408",
            "City": "Rasipuram",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sendamangalam",
            "Pincode": "637409",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vaiyampatti",
            "Pincode": "637410",
            "City": "Virudhunagar",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Semmedu",
            "Pincode": "637411",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Singalandapuram",
            "Pincode": "637412",
            "City": "Tiruchirappalli",
            "District": "Tiruchirappalli",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pattanam",
            "Pincode": "637413",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thirumalaipatti",
            "Pincode": "637416",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumalaipatti",
            "Pincode": "637416",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peria Manali",
            "Pincode": "637418",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Jedarpalayam",
            "Pincode": "637420",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Attayampatti",
            "Pincode": "637501",
            "City": "Attayampatti",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Elampillai",
            "Pincode": "637502",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mallasamudram",
            "Pincode": "637503",
            "City": "Mallasamudram",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vembadithalam",
            "Pincode": "637504",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vennandur",
            "Pincode": "637505",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Edangansalai",
            "Pincode": "637508",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyar",
            "Pincode": "638001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Erode Railway Colony",
            "Pincode": "638002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirunagar Colony",
            "Pincode": "638003",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chikkiah Naicker College",
            "Pincode": "638004",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veerappanchattam",
            "Pincode": "638004",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peria Agraharam",
            "Pincode": "638005",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cuvvery R S",
            "Pincode": "638007",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Agraharam",
            "Pincode": "638008",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Edayankattu Valasu",
            "Pincode": "638009",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Surampatti",
            "Pincode": "638009",
            "City": "Surampatti",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Boards Colony",
            "Pincode": "638010",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Erode Collectorate",
            "Pincode": "638011",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chennimalai",
            "Pincode": "638051",
            "City": "Chennimalai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melapalayam",
            "Pincode": "638051",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perundurai",
            "Pincode": "638052",
            "City": "Perundurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perundurai West",
            "Pincode": "638052",
            "City": "Perundurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sanatorium",
            "Pincode": "638053",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Siruvalur",
            "Pincode": "638054",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tingalur",
            "Pincode": "638055",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vijayamangalam",
            "Pincode": "638056",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tudipathi",
            "Pincode": "638057",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ingur",
            "Pincode": "638058",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellankoil",
            "Pincode": "638059",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chittode",
            "Pincode": "638102",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mambadi",
            "Pincode": "638102",
            "City": "Erode",
            "District": "Erode",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kunnathur Erode",
            "Pincode": "638103",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Modakurichi",
            "Pincode": "638104",
            "City": "Modakurichi",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muthur",
            "Pincode": "638105",
            "City": "Muthur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mulanur",
            "Pincode": "638106",
            "City": "Mulanur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nasiyanur",
            "Pincode": "638107",
            "City": "Nasiyanur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nathakadayur",
            "Pincode": "638108",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sivagiri",
            "Pincode": "638109",
            "City": "Sivagiri",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Getticheyur",
            "Pincode": "638110",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gingee",
            "Pincode": "638110",
            "City": "Gingee",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellakoil",
            "Pincode": "638111",
            "City": "Vellakoil",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadamugam Vellodu",
            "Pincode": "638112",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avalpundurai",
            "Pincode": "638115",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanjikoil",
            "Pincode": "638116",
            "City": "Kanjikoil",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanagapuram",
            "Pincode": "638117",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thandampalayam",
            "Pincode": "638118",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyar",
            "Pincode": "638129",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnamarudur",
            "Pincode": "638130",
            "City": "Erode",
            "District": "Erode",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karuppur",
            "Pincode": "638148",
            "City": "Kancheepuram",
            "District": "Kancheepuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodumudi",
            "Pincode": "638151",
            "City": "Kodumudi",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Unjalur",
            "Pincode": "638152",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ganapathipalayam",
            "Pincode": "638153",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pasur",
            "Pincode": "638154",
            "City": "Pasur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pothanur Salem",
            "Pincode": "638181",
            "City": "Salem",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velur Salem",
            "Pincode": "638182",
            "City": "Velur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velur Slm Bazar",
            "Pincode": "638182",
            "City": "Velur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gudimangalam",
            "Pincode": "638201",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jakkarpalayam",
            "Pincode": "638202",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kaniyur",
            "Pincode": "638203",
            "City": "Kaniyur",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Komaralingam",
            "Pincode": "638204",
            "City": "Komaralingam",
            "District": "Salem",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peddappampatti",
            "Pincode": "638205",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pulavadi",
            "Pincode": "638206",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pungamuthur",
            "Pincode": "638207",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devanurpudur",
            "Pincode": "638211",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bhavani H O",
            "Pincode": "638301",
            "City": "Erode",
            "District": "Erode",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bhavanikudal",
            "Pincode": "638301",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bhavani Cutchery",
            "Pincode": "638302",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ammapettai Bhavani",
            "Pincode": "638311",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jambai",
            "Pincode": "638312",
            "City": "Jambai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palayam",
            "Pincode": "638312",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kugalur",
            "Pincode": "638313",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Olagadam",
            "Pincode": "638314",
            "City": "Olagadam",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sakthinagar",
            "Pincode": "638315",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vasavi College",
            "Pincode": "638316",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyar",
            "Pincode": "638319",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Singampettai",
            "Pincode": "638324",
            "City": "Erode",
            "District": "Erode",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dalavoipettai",
            "Pincode": "638327",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnapallam",
            "Pincode": "638328",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Satyamangalam Bazaar",
            "Pincode": "638401",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Satyamangalam Cbe",
            "Pincode": "638401",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Rangasamudram",
            "Pincode": "638402",
            "City": "Vellore",
            "District": "Vellore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Yavilipalayam",
            "Pincode": "638403",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ukkaram",
            "Pincode": "638404",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chikkarasampalayam",
            "Pincode": "638406",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bharatiyar University",
            "Pincode": "638451",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bhavanisagar",
            "Pincode": "638451",
            "City": "Bhavanisagar",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gobichettipalayam East",
            "Pincode": "638452",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gobichettipalayam H O",
            "Pincode": "638452",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Modachur",
            "Pincode": "638452",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pudupalayam",
            "Pincode": "638452",
            "City": "Ariyalur",
            "District": "Ariyalur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karattadipalayam",
            "Pincode": "638453",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kasipalayam",
            "Pincode": "638454",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kolappalure Cbe",
            "Pincode": "638456",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurumandur",
            "Pincode": "638457",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nambiyur",
            "Pincode": "638458",
            "City": "Nambiyur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pulimpatti",
            "Pincode": "638459",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Savakattupalayam",
            "Pincode": "638460",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Talavadi",
            "Pincode": "638461",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vemandanpalayam",
            "Pincode": "638462",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadathur Gobi",
            "Pincode": "638466",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pariyur Vellapalayam",
            "Pincode": "638469",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periapuliyur",
            "Pincode": "638470",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Selangapalayam",
            "Pincode": "638471",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gobiohetti Palayam South",
            "Pincode": "638476",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anthiyur",
            "Pincode": "638501",
            "City": "Anthiyur",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thavittupalayam",
            "Pincode": "638501",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athani",
            "Pincode": "638502",
            "City": "Athani",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dasappagoundanpudur",
            "Pincode": "638503",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Guruvareddiyur",
            "Pincode": "638504",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kallipatti",
            "Pincode": "638505",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thuckaickanpalayam",
            "Pincode": "638506",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Brahmadesam",
            "Pincode": "638511",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupur Bazar",
            "Pincode": "638601",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupur H O",
            "Pincode": "638601",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumanallur Road",
            "Pincode": "638602",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupur North",
            "Pincode": "638602",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupuvanam",
            "Pincode": "638602",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar Tirupur",
            "Pincode": "638603",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kumaranagar",
            "Pincode": "638603",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Veerapandi Tirupur",
            "Pincode": "638605",
            "City": "Veerapandi",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vijayapuram",
            "Pincode": "638606",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupur East",
            "Pincode": "638607",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anuppapalayam",
            "Pincode": "638652",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Annur",
            "Pincode": "638653",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avanashi",
            "Pincode": "638654",
            "City": "Avanashi",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Renganathapuram",
            "Pincode": "638654",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cheyur",
            "Pincode": "638655",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cholakadai Street",
            "Pincode": "638656",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dharapuram H O",
            "Pincode": "638656",
            "City": "Erode",
            "District": "Erode",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ellisnagar",
            "Pincode": "638657",
            "City": "Erode",
            "District": "Erode",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karadipavi",
            "Pincode": "638658",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Koduvoi",
            "Pincode": "638660",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kolathupalayam",
            "Pincode": "638661",
            "City": "Kolathupalayam",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuppuswamynaidupuram",
            "Pincode": "638662",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mangalam-Cbe",
            "Pincode": "638663",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Palladam",
            "Pincode": "638664",
            "City": "Palladam",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallikalipalayam",
            "Pincode": "638665",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumanallur",
            "Pincode": "638666",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pongalur",
            "Pincode": "638667",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Somanur",
            "Pincode": "638668",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Suleswaranpatti",
            "Pincode": "638669",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karavalur",
            "Pincode": "638670",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kettanur",
            "Pincode": "638671",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dalvoipatnam",
            "Pincode": "638672",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kolinjivadi",
            "Pincode": "638673",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jalakarisal",
            "Pincode": "638675",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Virajimangalam",
            "Pincode": "638683",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karaipudur",
            "Pincode": "638684",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Iduvampalayam",
            "Pincode": "638687",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thoppanpatti",
            "Pincode": "638696",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pogalur",
            "Pincode": "638697",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanagayam North",
            "Pincode": "638701",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kangayam",
            "Pincode": "638701",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kundadam",
            "Pincode": "638702",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udiyur",
            "Pincode": "638703",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sankarandampalayam",
            "Pincode": "638706",
            "City": "Erode",
            "District": "Erode",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tayampalayam",
            "Pincode": "638710",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Technical Teachers",
            "Pincode": "638710",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uttukuli",
            "Pincode": "638751",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uttukuli R S",
            "Pincode": "638752",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Moperipalayam",
            "Pincode": "638802",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muperipalayam",
            "Pincode": "638802",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadambacheri",
            "Pincode": "638806",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellavaripudur",
            "Pincode": "638807",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chengapalli",
            "Pincode": "638812",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karur Bazaar",
            "Pincode": "639001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karur H O",
            "Pincode": "639001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karur R S",
            "Pincode": "639001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karur West",
            "Pincode": "639001",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramakrishnapuram",
            "Pincode": "639001",
            "City": "Theni",
            "District": "Theni",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sengundapuram",
            "Pincode": "639002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vaiapurinagar",
            "Pincode": "639002",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirumanilayur",
            "Pincode": "639003",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pasupathipalayam",
            "Pincode": "639004",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thanthonimalal",
            "Pincode": "639005",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vengamedue",
            "Pincode": "639006",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Andanallur",
            "Pincode": "639101",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnarayapuram",
            "Pincode": "639102",
            "City": "Krishnarayapuram",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulumani",
            "Pincode": "639103",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulittalai Bazaar",
            "Pincode": "639104",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kulittalai H O",
            "Pincode": "639104",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lalapet",
            "Pincode": "639105",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mahadanapuram Karur",
            "Pincode": "639106",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marudur",
            "Pincode": "639107",
            "City": "Marudur",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mayanur",
            "Pincode": "639108",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Moolapatti",
            "Pincode": "639109",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nungavaram",
            "Pincode": "639110",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Paramathi",
            "Pincode": "639111",
            "City": "Paramathi",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pettaivaithalai",
            "Pincode": "639112",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pugalur Sugar Factory",
            "Pincode": "639113",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tirupparaithurai",
            "Pincode": "639115",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vangal",
            "Pincode": "639116",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velayuthanpalayam",
            "Pincode": "639117",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velliyanai",
            "Pincode": "639118",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Panjapatti",
            "Pincode": "639119",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vaigallur",
            "Pincode": "639120",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vangal East",
            "Pincode": "639121",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nanjaipugalur",
            "Pincode": "639144",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Timmachipuram",
            "Pincode": "639147",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aravakurichi",
            "Pincode": "639201",
            "City": "Aravakurichi",
            "District": "Karur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnadharapuram",
            "Pincode": "639202",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Isanatham",
            "Pincode": "639203",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nanjaithalaiyur",
            "Pincode": "639204",
            "City": "Erode",
            "District": "Erode",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallapatti Karur",
            "Pincode": "639205",
            "City": "Pallapatti",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tennilai",
            "Pincode": "639206",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallapatti Bazaar",
            "Pincode": "639207",
            "City": "Pallapatti",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyar",
            "Pincode": "639210",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periyar",
            "Pincode": "639212",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore",
            "Pincode": "641001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore Bazaar",
            "Pincode": "641001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore H O",
            "Pincode": "641001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore South",
            "Pincode": "641001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore Ukadam",
            "Pincode": "641001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore West",
            "Pincode": "641001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devangapet",
            "Pincode": "641001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ponnaiya Rajapuram",
            "Pincode": "641001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Selvapuram",
            "Pincode": "641001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sukravarpettai",
            "Pincode": "641001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore North",
            "Pincode": "641002",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "R S Puram East",
            "Pincode": "641002",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "R S Puram H O",
            "Pincode": "641002",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "R S Puram South",
            "Pincode": "641002",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "R S Puram West",
            "Pincode": "641002",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lalwley Road",
            "Pincode": "641003",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peelamedu",
            "Pincode": "641004",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Peelamedu East",
            "Pincode": "641004",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nandanagar",
            "Pincode": "641005",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Singanallur",
            "Pincode": "641005",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ganapathi",
            "Pincode": "641006",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muthugoundenpudur",
            "Pincode": "641006",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Institute",
            "Pincode": "641007",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuniyamuthur",
            "Pincode": "641008",
            "City": "Kuniyamuthur",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anupparpalayam",
            "Pincode": "641009",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore",
            "Pincode": "641009",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "641009",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ranganathapuram",
            "Pincode": "641009",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perur",
            "Pincode": "641010",
            "City": "Perur",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saibaba Mission",
            "Pincode": "641011",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Saibaba Mission East",
            "Pincode": "641011",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tatabad",
            "Pincode": "641012",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tatabad East",
            "Pincode": "641012",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Govt College Of Technology",
            "Pincode": "641013",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore Aerodrome",
            "Pincode": "641014",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uppilpalayam",
            "Pincode": "641015",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ondipudur",
            "Pincode": "641016",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurudampalayam",
            "Pincode": "641017",
            "City": "Kurudampalayam",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore Central",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore Central Bus St",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore Collectorate",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore Courts",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore R S",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore Race Course",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Commercial Tax Office Bld",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnaswamynagar",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Puliyakulam",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanathapuram Cbt",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Red Fields",
            "Pincode": "641018",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore Press Colony",
            "Pincode": "641019",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perianaickenpalayam",
            "Pincode": "641020",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sri Ramakrishna Vidyalaya",
            "Pincode": "641020",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coimbatore Ind Estate",
            "Pincode": "641021",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nggo Colony Cbe",
            "Pincode": "641022",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Konavaikalpalayam",
            "Pincode": "641023",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padanur",
            "Pincode": "641023",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Podanur New Town",
            "Pincode": "641023",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sundarapuram",
            "Pincode": "641024",
            "City": "Thanjavur",
            "District": "Thanjavur",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Velandipalayam",
            "Pincode": "641025",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Komarapalayam-Cbe",
            "Pincode": "641026",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ratnapuri",
            "Pincode": "641027",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sowripalayam",
            "Pincode": "641028",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gnanambika Mills",
            "Pincode": "641029",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kavindampalavam Colony",
            "Pincode": "641030",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Narasimhanaickenpalyam",
            "Pincode": "641031",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Othakalmandapam",
            "Pincode": "641032",
            "City": "Othakalmandapam",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Neelikonampalayam",
            "Pincode": "641033",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tadiyalur",
            "Pincode": "641034",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nanjundapuram",
            "Pincode": "641036",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pappanaickenpalayam",
            "Pincode": "641037",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pappanaickenpalayam West",
            "Pincode": "641037",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kuppakonanpudur",
            "Pincode": "641038",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Telungapalayam",
            "Pincode": "641039",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Subramaniapuram Cbe",
            "Pincode": "641040",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Subramaniapuram Madurai",
            "Pincode": "641040",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pappanaickenpudur",
            "Pincode": "641041",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovaipudur",
            "Pincode": "641042",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Siddapudur",
            "Pincode": "641044",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanthapuram Cbe",
            "Pincode": "641045",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Maruthamalai",
            "Pincode": "641046",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jothipuram",
            "Pincode": "641047",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalapatti",
            "Pincode": "641061",
            "City": "Kalapatti",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sinnimpalayam",
            "Pincode": "641062",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sundakamuthur",
            "Pincode": "641064",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nilambur",
            "Pincode": "641065",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Alandurai",
            "Pincode": "641101",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Athikadavu",
            "Pincode": "641102",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Irugur",
            "Pincode": "641103",
            "City": "Irugur",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karamadai",
            "Pincode": "641104",
            "City": "Karamadai",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madukkarai",
            "Pincode": "641105",
            "City": "Madukkarai",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madukkarai Casba",
            "Pincode": "641105",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pillur Dam",
            "Pincode": "641106",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sarkar Samakulam",
            "Pincode": "641107",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tadagam",
            "Pincode": "641108",
            "City": "Viluppuram",
            "District": "Viluppuram",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thodamuthur",
            "Pincode": "641109",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vaiyampalayam",
            "Pincode": "641110",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vellalur C B E",
            "Pincode": "641111",
            "City": "Vellalur",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Parli Power House",
            "Pincode": "641112",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seelaiyur",
            "Pincode": "641113",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tholampalayam",
            "Pincode": "641114",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valliamkadu",
            "Pincode": "641115",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bhujanganur",
            "Pincode": "641116",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marudur",
            "Pincode": "641117",
            "City": "Cuddalore",
            "District": "Cuddalore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thekkampatti",
            "Pincode": "641118",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Negamam",
            "Pincode": "641120",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chettipalayam",
            "Pincode": "641201",
            "City": "Chettipalayam",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ganapathi Agraharam",
            "Pincode": "641202",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadasittur",
            "Pincode": "641202",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Katoor Mtp",
            "Pincode": "641301",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mahadevapuram",
            "Pincode": "641301",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettupalayam Bazaar",
            "Pincode": "641301",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettupalayam East",
            "Pincode": "641301",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettupalayam H O",
            "Pincode": "641301",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sirumugai",
            "Pincode": "641302",
            "City": "Sirumugai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nellithurai",
            "Pincode": "641303",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Akkaraisengapalli",
            "Pincode": "641304",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mahadevapuram",
            "Pincode": "641305",
            "City": "Madurai",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kangayampalayam",
            "Pincode": "641401",
            "City": "Kangayampalayam",
            "District": "Madurai",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Slur",
            "Pincode": "641402",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalingal",
            "Pincode": "641404",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannampalayam",
            "Pincode": "641405",
            "City": "Kannampalayam",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Arasur",
            "Pincode": "641407",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Appanaickenpatti",
            "Pincode": "641408",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Perumanallur Road",
            "Pincode": "641602",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tiruppur Bazar",
            "Pincode": "641604",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Market",
            "Pincode": "642001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marapettai",
            "Pincode": "642001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "N G M College",
            "Pincode": "642001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Polachi R S",
            "Pincode": "642001",
            "City": "Pollachi",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pollachi Bazaar",
            "Pincode": "642001",
            "City": "Pollachi",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pollachi H O",
            "Pincode": "642001",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mahalingapuram",
            "Pincode": "642002",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T Kottampatti",
            "Pincode": "642002",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Makkinaickenpatti",
            "Pincode": "642003",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uttukuli Zamin",
            "Pincode": "642004",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Zamin Mathur",
            "Pincode": "642005",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Angalakurichi",
            "Pincode": "642007",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jallipatti",
            "Pincode": "642051",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Akilandapuram",
            "Pincode": "642052",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramapattinam",
            "Pincode": "642053",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanjampatti",
            "Pincode": "642054",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mannur",
            "Pincode": "642055",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aliyarnagar",
            "Pincode": "642101",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Amaravathi Nagar",
            "Pincode": "642102",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ambarampalayam",
            "Pincode": "642103",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Anamalai",
            "Pincode": "642104",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Waterfalls Estate",
            "Pincode": "642105",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinchona",
            "Pincode": "642106",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gomangalam",
            "Pincode": "642107",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Iyerpadi",
            "Pincode": "642108",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kinathukadavu",
            "Pincode": "642109",
            "City": "Kinathukadavu",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kovilpalayam",
            "Pincode": "642110",
            "City": "Kovilpalayam",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Krishnapuram Cbe",
            "Pincode": "642111",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kurichikottai",
            "Pincode": "642112",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Madathukulam",
            "Pincode": "642113",
            "City": "Madathukulam",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Malayandipattinam",
            "Pincode": "642114",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manamboli",
            "Pincode": "642115",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Minparai",
            "Pincode": "642116",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mudis",
            "Pincode": "642117",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Murugali Bazaar",
            "Pincode": "642118",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Navamalai Camp",
            "Pincode": "642119",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pulankinar",
            "Pincode": "642122",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Samathur",
            "Pincode": "642123",
            "City": "Samathur",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sholayar",
            "Pincode": "642124",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sholayarnagar",
            "Pincode": "642125",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Eripalayam",
            "Pincode": "642126",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "642126",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udamalpet Bazar",
            "Pincode": "642126",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udamalpet H O",
            "Pincode": "642126",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udamalpet South",
            "Pincode": "642126",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valparai",
            "Pincode": "642127",
            "City": "Valparai",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vazhaithottam",
            "Pincode": "642127",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Venkatesa Mills",
            "Pincode": "642128",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vettaikaranpudur",
            "Pincode": "642129",
            "City": "Vettaikaranpudur",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Karamalai Bazaar",
            "Pincode": "642130",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pannimade",
            "Pincode": "642131",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Valavadi",
            "Pincode": "642132",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sethurmadai",
            "Pincode": "642133",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Somandurai",
            "Pincode": "642134",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadamparai Dam",
            "Pincode": "642135",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ramanamudalipudur",
            "Pincode": "642136",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chinnanegamam",
            "Pincode": "642137",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dhully",
            "Pincode": "642138",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thirumurthinagar",
            "Pincode": "642139",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Odayakulam",
            "Pincode": "642140",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Topslip",
            "Pincode": "642141",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vadakkipalayam",
            "Pincode": "642142",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sulakkal",
            "Pincode": "642143",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Poravipalayam",
            "Pincode": "642144",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sokkanur",
            "Pincode": "642145",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pollachi",
            "Pincode": "642146",
            "City": "Pollachi",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thamaraikulam",
            "Pincode": "642146",
            "City": "Thamaraikulam",
            "District": "Virudhunagar",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mettupalayam",
            "Pincode": "642147",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Divansapudur",
            "Pincode": "642148",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periapodu",
            "Pincode": "642149",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kadamparai Power House",
            "Pincode": "642152",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sirukundra",
            "Pincode": "642153",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udamalpet",
            "Pincode": "642154",
            "City": "Coimbatore",
            "District": "Coimbatore",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Charing Cross",
            "Pincode": "643001",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Race Course",
            "Pincode": "643001",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "St Marys Hill",
            "Pincode": "643001",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udagamandalam H O",
            "Pincode": "643001",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udagamandalam Market",
            "Pincode": "643001",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Udgamandalam",
            "Pincode": "643001",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Willow Bund",
            "Pincode": "643001",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Stone House Hill",
            "Pincode": "643002",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Lovedale",
            "Pincode": "643003",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Fern Hill",
            "Pincode": "643004",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Indu Nagar",
            "Pincode": "643005",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Fingerpost",
            "Pincode": "643006",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dr Basuvaiah Nagar",
            "Pincode": "643007",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thuneri",
            "Pincode": "643051",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hullathi",
            "Pincode": "643052",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Muthorai",
            "Pincode": "643053",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "M Palada",
            "Pincode": "643054",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Idupatti",
            "Pincode": "643055",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coonoor H O",
            "Pincode": "643101",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Coonoor R S",
            "Pincode": "643102",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pasteur Institute",
            "Pincode": "643103",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Springfield",
            "Pincode": "643104",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ottupattarai",
            "Pincode": "643105",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Burliar",
            "Pincode": "643106",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Aravenu",
            "Pincode": "643201",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cordite Factory",
            "Pincode": "643202",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bolacola",
            "Pincode": "643203",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Chamraj Estate",
            "Pincode": "643204",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cherambadi",
            "Pincode": "643205",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Denadcombai",
            "Pincode": "643206",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devarshola",
            "Pincode": "643207",
            "City": "Devarshola",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Emarald",
            "Pincode": "643209",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Glenmorgan",
            "Pincode": "643210",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gudalur Nilgiris",
            "Pincode": "643211",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Gudalur Bazaar",
            "Pincode": "643212",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Katary",
            "Pincode": "643213",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kattabettu",
            "Pincode": "643214",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ketti Santhur",
            "Pincode": "643215",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kikotagiri",
            "Pincode": "643216",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Donington",
            "Pincode": "643217",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Down Hills",
            "Pincode": "643217",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kotagiri",
            "Pincode": "643217",
            "City": "Kotagiri",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kullakumby",
            "Pincode": "643218",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kundah Bridge",
            "Pincode": "643219",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Manjoor",
            "Pincode": "643219",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Mango Range",
            "Pincode": "643220",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Melur Nilgiris",
            "Pincode": "643221",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Moyar Camp",
            "Pincode": "643222",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Musinagudi",
            "Pincode": "643223",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Naduvattam",
            "Pincode": "643224",
            "City": "Naduvattam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nellakotta",
            "Pincode": "643225",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "New Hope",
            "Pincode": "643226",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "New Town",
            "Pincode": "643226",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Seaforth",
            "Pincode": "643228",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Singara",
            "Pincode": "643229",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thiashola",
            "Pincode": "643230",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Defence Service Staff College",
            "Pincode": "643231",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Wellington",
            "Pincode": "643231",
            "City": "Wellington",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Wellington Bazar",
            "Pincode": "643232",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pandalur",
            "Pincode": "643233",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Hulical",
            "Pincode": "643234",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pegumbahalla Camp",
            "Pincode": "643235",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kotada Estate",
            "Pincode": "643236",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sndyanallah",
            "Pincode": "643237",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nonsuch",
            "Pincode": "643238",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Konachal",
            "Pincode": "643239",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bitherkad",
            "Pincode": "643240",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Uppatti",
            "Pincode": "643241",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Tuttapalam",
            "Pincode": "643242",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Needle Industries",
            "Pincode": "643243",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Jagathala",
            "Pincode": "643244",
            "City": "Jagathala",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannerimookku",
            "Pincode": "643245",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kanagarai",
            "Pincode": "643246",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kengarai",
            "Pincode": "643246",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nihung",
            "Pincode": "643247",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Bikkatty",
            "Pincode": "643248",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kagguchi",
            "Pincode": "643249",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Marthomanagar",
            "Pincode": "643250",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Padanthorai",
            "Pincode": "643251",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "K Palada",
            "Pincode": "643252",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kolapalli",
            "Pincode": "643253",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "T R Bazar",
            "Pincode": "643254",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Periashola",
            "Pincode": "643255",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ithalur",
            "Pincode": "643256",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nanjanad",
            "Pincode": "643257",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kalhatti",
            "Pincode": "643258",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sholur",
            "Pincode": "643259",
            "City": "Sholur",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thummanathy",
            "Pincode": "643260",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Dhavani",
            "Pincode": "643261",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Cherangode",
            "Pincode": "643263",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kodanad",
            "Pincode": "643264",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nedugula",
            "Pincode": "643265",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Billicombai",
            "Pincode": "643266",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Sanctuary",
            "Pincode": "643267",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Korakundah",
            "Pincode": "643268",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Shanthur",
            "Pincode": "643269",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Devala",
            "Pincode": "643270",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kilkotagiri Bazaar",
            "Pincode": "643271",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thoraihatti",
            "Pincode": "643272",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Ebbanad",
            "Pincode": "643273",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Konavakarai",
            "Pincode": "643276",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Nunthala",
            "Pincode": "643277",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Yedappalli",
            "Pincode": "643278",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Thalakundah",
            "Pincode": "643279",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Avalanchi Power House",
            "Pincode": "643280",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Yedakkad",
            "Pincode": "643282",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Vatayam",
            "Pincode": "643518",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Pallagachery",
            "Pincode": "666213",
            "City": "Uthagamandalam",
            "District": "The Nilgiri",
            "State": "Tamil Nadu"
        },
        {
            "PostOfficeName": "Kannur",
            "Pincode": "670001",
            "City": "Kannur",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannur Civil Station",
            "Pincode": "670002",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannur City",
            "Pincode": "670003",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallikunnu",
            "Pincode": "670004",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkat",
            "Pincode": "670005",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Atttadappa",
            "Pincode": "670006",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chovva",
            "Pincode": "670006",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kappad Chovva",
            "Pincode": "670006",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Katalayi",
            "Pincode": "670007",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhunna",
            "Pincode": "670007",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottada",
            "Pincode": "670007",
            "City": "Thottada",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottada",
            "Pincode": "670007",
            "City": "Thottada",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azhikkal",
            "Pincode": "670009",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azhikode South",
            "Pincode": "670009",
            "City": "Azhikode South",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valapattanam",
            "Pincode": "670010",
            "City": "Valapattanam",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chirakkal",
            "Pincode": "670011",
            "City": "Chirakkal",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chirakkal R.S.B.O",
            "Pincode": "670011",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannookara Kannur",
            "Pincode": "670012",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannur Thana",
            "Pincode": "670012",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Burnacherry",
            "Pincode": "670013",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chalad",
            "Pincode": "670014",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattampally",
            "Pincode": "670015",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottali",
            "Pincode": "670016",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannur Dist.Hospital",
            "Pincode": "670017",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thazhe Chovva",
            "Pincode": "670018",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalassery",
            "Pincode": "670101",
            "City": "Thalassery",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurichiyil",
            "Pincode": "670102",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnol",
            "Pincode": "670102",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Temple Gate",
            "Pincode": "670102",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayalalam",
            "Pincode": "670102",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Triuvangad",
            "Pincode": "670103",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherakara",
            "Pincode": "670104",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nettur",
            "Pincode": "670105",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Dharmadom",
            "Pincode": "670106",
            "City": "Dharmadom",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eranholi",
            "Pincode": "670107",
            "City": "Eranholi",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perundatti",
            "Pincode": "670107",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkumbad Edso",
            "Pincode": "670109",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavumbhagom Edso",
            "Pincode": "670110",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moozhikara Edso",
            "Pincode": "670111",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttikol",
            "Pincode": "670141",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttiyeri",
            "Pincode": "670141",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Taliparamba",
            "Pincode": "670141",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrivatoor",
            "Pincode": "670141",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trichambaram",
            "Pincode": "670141",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimbam",
            "Pincode": "670142",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koyyam",
            "Pincode": "670142",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumathur",
            "Pincode": "670142",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muyyam",
            "Pincode": "670142",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallivayal",
            "Pincode": "670142",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panniyur",
            "Pincode": "670142",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aril",
            "Pincode": "670143",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattuvam",
            "Pincode": "670143",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuppam Taliparamba Edso",
            "Pincode": "670144",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukunnu",
            "Pincode": "670301",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezhara",
            "Pincode": "670301",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Othayammadam",
            "Pincode": "670301",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkumbad",
            "Pincode": "670301",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattul",
            "Pincode": "670302",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payangadi",
            "Pincode": "670303",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sreetha",
            "Pincode": "670303",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madayi",
            "Pincode": "670304",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakkod",
            "Pincode": "670305",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengara Cnr",
            "Pincode": "670305",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkara",
            "Pincode": "670306",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanayi",
            "Pincode": "670306",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttur",
            "Pincode": "670306",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathamangalam",
            "Pincode": "670306",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathamangalam Bazar",
            "Pincode": "670306",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olayambadi",
            "Pincode": "670306",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panapuzha",
            "Pincode": "670306",
            "City": "Kannur",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Porakunnu",
            "Pincode": "670306",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellora",
            "Pincode": "670306",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aravanchal",
            "Pincode": "670307",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chalakkod",
            "Pincode": "670307",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eramam Desom",
            "Pincode": "670307",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kandoth",
            "Pincode": "670307",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Korom",
            "Pincode": "670307",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nhekkly",
            "Pincode": "670307",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padiotchal Edso",
            "Pincode": "670307",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payyannur",
            "Pincode": "670307",
            "City": "Payyannur",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payyannur R.S.B.O",
            "Pincode": "670307",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karanthat",
            "Pincode": "670308",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramantali",
            "Pincode": "670308",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kovvapuram",
            "Pincode": "670309",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunhimangalam",
            "Pincode": "670309",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattul North",
            "Pincode": "670325",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edat",
            "Pincode": "670327",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkumbad-Ramanthali",
            "Pincode": "670330",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anchampeedika",
            "Pincode": "670331",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Morazha",
            "Pincode": "670331",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mottammal",
            "Pincode": "670331",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Annur Edso",
            "Pincode": "670332",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kandankali Edso",
            "Pincode": "670333",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottila",
            "Pincode": "670334",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kankol Edso",
            "Pincode": "670337",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palachode P.O",
            "Pincode": "670338",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavvayi Edso",
            "Pincode": "670339",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathil",
            "Pincode": "670343",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellur Edso",
            "Pincode": "670346",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringome Edso",
            "Pincode": "670354",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payangadi R.S",
            "Pincode": "670358",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadannapally",
            "Pincode": "670501",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mandur Cnr",
            "Pincode": "670501",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nareekamvalli",
            "Pincode": "670501",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pilathara",
            "Pincode": "670501",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilayancode",
            "Pincode": "670501",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chithapilapoyil",
            "Pincode": "670502",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pariyaram Kannur",
            "Pincode": "670502",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherupuzha",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chunda",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edavaramba",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Josegiri Cherupuzha",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadumeni",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kamballore",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanamvayal",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannivayal",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozhichal",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palavayal",
            "Pincode": "670511",
            "City": "Hosdurg",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Prapoyil",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thabore",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattummal",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thayyenni",
            "Pincode": "670511",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirumeni",
            "Pincode": "670511",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karivellur",
            "Pincode": "670521",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozhummal Edso",
            "Pincode": "670522",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pappinisseri",
            "Pincode": "670561",
            "City": "Pappinisseri",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalliasseri",
            "Pincode": "670562",
            "City": "Kalliasseri",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nanicheri",
            "Pincode": "670563",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parassinikadavu",
            "Pincode": "670563",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanul Edso",
            "Pincode": "670564",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pappinisseri West",
            "Pincode": "670565",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aroli Edso",
            "Pincode": "670566",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alakode",
            "Pincode": "670571",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alakode Kuttaramba",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arivilanjapoil",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittodi",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karthikapuram Edso",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvanchal Edso",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottayad",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manakadavu",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellipara",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ottathai",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathampara",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rayarom",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Therthally",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udayagiri",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellad",
            "Pincode": "670571",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vijayagiri",
            "Pincode": "670571",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chepparapadava",
            "Pincode": "670581",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karipal",
            "Pincode": "670581",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kooveri",
            "Pincode": "670581",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padappangad",
            "Pincode": "670581",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thadikadavu",
            "Pincode": "670581",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thimiri",
            "Pincode": "670581",
            "City": "Hosdurg",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arang",
            "Pincode": "670582",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Areekamala",
            "Pincode": "670582",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudiyanmala",
            "Pincode": "670582",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mandalam",
            "Pincode": "670582",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naduvil",
            "Pincode": "670582",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pottampilavu",
            "Pincode": "670582",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulkurumba",
            "Pincode": "670582",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayattuparamba",
            "Pincode": "670582",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eachur",
            "Pincode": "670591",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Munderi Eachur",
            "Pincode": "670591",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chattuvapara",
            "Pincode": "670592",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chekkikulam",
            "Pincode": "670592",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhirode",
            "Pincode": "670592",
            "City": "Kanhirode",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannimari",
            "Pincode": "670592",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koodali",
            "Pincode": "670592",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irukkur",
            "Pincode": "670593",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalliad",
            "Pincode": "670593",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kusavanvayal",
            "Pincode": "670593",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peruvalathparamba",
            "Pincode": "670593",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varam",
            "Pincode": "670594",
            "City": "Varam",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edayannur",
            "Pincode": "670595",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elampara",
            "Pincode": "670595",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattanur",
            "Pincode": "670595",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundayad",
            "Pincode": "670597",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherupazhasi",
            "Pincode": "670601",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolacherry",
            "Pincode": "670601",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellalasseri",
            "Pincode": "670601",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayaralam",
            "Pincode": "670602",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttiyattur",
            "Pincode": "670602",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mayyil",
            "Pincode": "670602",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mullakodi",
            "Pincode": "670602",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pavannur Motta",
            "Pincode": "670602",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narath Edso",
            "Pincode": "670603",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheleri",
            "Pincode": "670604",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannadiparamba",
            "Pincode": "670604",
            "City": "Kannadiparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mamba",
            "Pincode": "670611",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muzhappala",
            "Pincode": "670611",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anjarakandy",
            "Pincode": "670612",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezhallur",
            "Pincode": "670612",
            "City": "Thalassery",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muringeri",
            "Pincode": "670612",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengad",
            "Pincode": "670612",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mowancherri",
            "Pincode": "670613",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iriveri Edso",
            "Pincode": "670614",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chala East",
            "Pincode": "670621",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadachira",
            "Pincode": "670621",
            "City": "Kadachira",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koyyode",
            "Pincode": "670621",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poduvacheri",
            "Pincode": "670621",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bavode.",
            "Pincode": "670622",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Makreri",
            "Pincode": "670622",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mavilayil Edso",
            "Pincode": "670622",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundalur",
            "Pincode": "670622",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chempanthotty",
            "Pincode": "670631",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengalayil",
            "Pincode": "670631",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherikode",
            "Pincode": "670631",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chulali Edso",
            "Pincode": "670631",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaithapram",
            "Pincode": "670631",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koottumugham",
            "Pincode": "670631",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malapattam",
            "Pincode": "670631",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nediyanga",
            "Pincode": "670631",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedungome",
            "Pincode": "670631",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sreekandapuram",
            "Pincode": "670631",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemperi",
            "Pincode": "670632",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayalampara",
            "Pincode": "670632",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuniyampuzha",
            "Pincode": "670632",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellikutty",
            "Pincode": "670632",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chandanakampara",
            "Pincode": "670633",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhirakolly",
            "Pincode": "670633",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payyavur",
            "Pincode": "670633",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhassikkari",
            "Pincode": "670633",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponniam West",
            "Pincode": "670641",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayithara Mambram",
            "Pincode": "670643",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottayam Malabar",
            "Pincode": "670643",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuthuparamba",
            "Pincode": "670643",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manantheri",
            "Pincode": "670643",
            "City": "Thalassery",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mangatti Dam",
            "Pincode": "670643",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mooriyad",
            "Pincode": "670643",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pachapoika",
            "Pincode": "670643",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sankaranellur",
            "Pincode": "670643",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherakara Wynad",
            "Pincode": "670644",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kampatti",
            "Pincode": "670644",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kappathumala",
            "Pincode": "670644",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Periya",
            "Pincode": "670644",
            "City": "Hosdurg",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Porur Wynad",
            "Pincode": "670644",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tavinhal",
            "Pincode": "670644",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalapuzha",
            "Pincode": "670644",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallat",
            "Pincode": "670644",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varayal",
            "Pincode": "670644",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anjukunnu",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arattuthara",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edavaka",
            "Pincode": "670645",
            "City": "Mananthavady",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ellumannam",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kammana",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karakkamala",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kellur",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnamangalam Wynad",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mananthavady",
            "Pincode": "670645",
            "City": "#N/A",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundakutty",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nallurnad",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pilakkavu",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudusserikadavu",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudussery",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valery",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vemom",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vimalanagar",
            "Pincode": "670645",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bavali",
            "Pincode": "670646",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kartikulam",
            "Pincode": "670646",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panavally",
            "Pincode": "670646",
            "City": "Cherthala",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payyampally",
            "Pincode": "670646",
            "City": "Mananthavady",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirunelli Temple",
            "Pincode": "670646",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tholpetty",
            "Pincode": "670646",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrissileri",
            "Pincode": "670646",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirunelli",
            "Pincode": "670646",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vavali",
            "Pincode": "670646",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ummanchira",
            "Pincode": "670649",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alacherry",
            "Pincode": "670650",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruvancheri",
            "Pincode": "670650",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittariparamba",
            "Pincode": "670650",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannavam Colony",
            "Pincode": "670650",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannoth",
            "Pincode": "670650",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolayad",
            "Pincode": "670650",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumpoil",
            "Pincode": "670650",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peruva",
            "Pincode": "670650",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poolakutty",
            "Pincode": "670650",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varayannur",
            "Pincode": "670650",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melur Tellichery",
            "Pincode": "670661",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palayad",
            "Pincode": "670661",
            "City": "Palayad",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulappilangd",
            "Pincode": "670662",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadambur Ward Ii",
            "Pincode": "670663",
            "City": "Kadambur",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paral",
            "Pincode": "670671",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aniyaram",
            "Pincode": "670672",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chokli",
            "Pincode": "670672",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aralam Farm",
            "Pincode": "670673",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolakkad",
            "Pincode": "670673",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melmuringodi",
            "Pincode": "670673",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muzhakunnu",
            "Pincode": "670673",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muzhakunnu Bazar",
            "Pincode": "670673",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peravoor",
            "Pincode": "670673",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumpunna",
            "Pincode": "670673",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thondiyil",
            "Pincode": "670673",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tolambra",
            "Pincode": "670673",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellarvelly",
            "Pincode": "670673",
            "City": "Thalassery",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adakkathodu",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambayathode",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Atakkathode",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chettiamparamba",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chungakunnu",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kelakoam",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanichar",
            "Pincode": "670674",
            "City": "Thalassery",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kelakom",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottiyur",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malayampadi",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Santhgiri",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellunni",
            "Pincode": "670674",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kidanhi",
            "Pincode": "670675",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mekkunnu",
            "Pincode": "670675",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringathur",
            "Pincode": "670675",
            "City": "Peringathur",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puliyanambram",
            "Pincode": "670675",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadavathur",
            "Pincode": "670676",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manathana Edso",
            "Pincode": "670677",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullokkara Edso",
            "Pincode": "670678",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panniyannur Edso",
            "Pincode": "670679",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottayampoil",
            "Pincode": "670691",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudiyanga",
            "Pincode": "670691",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathayakunnu",
            "Pincode": "670691",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pukkot Kuthuparamba",
            "Pincode": "670691",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chendayad",
            "Pincode": "670692",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elangot",
            "Pincode": "670692",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pannoor",
            "Pincode": "670692",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthur Panoor",
            "Pincode": "670692",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruparamba",
            "Pincode": "670693",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallickandy",
            "Pincode": "670693",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narikodemala",
            "Pincode": "670693",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poyilur",
            "Pincode": "670693",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuvakunnu",
            "Pincode": "670693",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilakottur",
            "Pincode": "670693",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Champad",
            "Pincode": "670694",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koorara",
            "Pincode": "670694",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mallannur",
            "Pincode": "670701",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neerveli",
            "Pincode": "670701",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nirmalagiri",
            "Pincode": "670701",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palaparamba",
            "Pincode": "670701",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chavasseri",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhilari",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kara Peravoor",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayani",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolari",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malur",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattanur",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattanur College",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhassi Raja Nagar",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Porora",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sivapuram",
            "Pincode": "670702",
            "City": "Quilandy",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thilenkeri",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uliyil",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uruvachal",
            "Pincode": "670702",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iritty",
            "Pincode": "670703",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalluvayal",
            "Pincode": "670703",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezhur Iritty",
            "Pincode": "670703",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madathil",
            "Pincode": "670703",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padiyur Cannanore",
            "Pincode": "670703",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnad",
            "Pincode": "670703",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilakode",
            "Pincode": "670703",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aralam",
            "Pincode": "670704",
            "City": "Thalassery",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edapuzha",
            "Pincode": "670704",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezhpally",
            "Pincode": "670704",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koomanthode",
            "Pincode": "670704",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Munduparamba",
            "Pincode": "670704",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payam",
            "Pincode": "670704",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payam East",
            "Pincode": "670704",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veerpad",
            "Pincode": "670704",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velimanam",
            "Pincode": "670704",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arabi",
            "Pincode": "670705",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalanki",
            "Pincode": "670705",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manikkadavu",
            "Pincode": "670705",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manipara",
            "Pincode": "670705",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nuchiyad",
            "Pincode": "670705",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parikkalam",
            "Pincode": "670705",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ulikkal",
            "Pincode": "670705",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattiamthode",
            "Pincode": "670705",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angadikadavu",
            "Pincode": "670706",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kacherikkadavu",
            "Pincode": "670706",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kiliyanthara",
            "Pincode": "670706",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolithattu",
            "Pincode": "670706",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koottupuzha",
            "Pincode": "670706",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perinkeri",
            "Pincode": "670706",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramdaakadavu",
            "Pincode": "670706",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arinjerumal",
            "Pincode": "670721",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukattoor",
            "Pincode": "670721",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Echchame",
            "Pincode": "670721",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayakunnu",
            "Pincode": "670721",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nadavayal",
            "Pincode": "670721",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nirvanam",
            "Pincode": "670721",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panamaram",
            "Pincode": "670721",
            "City": "#N/A",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattayad",
            "Pincode": "670731",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottarakunnu",
            "Pincode": "670731",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuhome",
            "Pincode": "670731",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Makkaid",
            "Pincode": "670731",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattilayam",
            "Pincode": "670731",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thettamala",
            "Pincode": "670731",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thondemad",
            "Pincode": "670731",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vannode",
            "Pincode": "670731",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellamunda",
            "Pincode": "670731",
            "City": "#N/A",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tharuvna Edso",
            "Pincode": "670732",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mambram",
            "Pincode": "670741",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parapram",
            "Pincode": "670741",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pinarai",
            "Pincode": "670741",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adakathbail",
            "Pincode": "671121",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kasaragod",
            "Pincode": "671121",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Talangara",
            "Pincode": "671122",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alampadi",
            "Pincode": "671123",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheroor",
            "Pincode": "671123",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Hidayatanagar",
            "Pincode": "671123",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallakatta",
            "Pincode": "671123",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttathodi",
            "Pincode": "671123",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vidhyanagar",
            "Pincode": "671123",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Badradka",
            "Pincode": "671124",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudlu",
            "Pincode": "671124",
            "City": "Kudlu",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madhur",
            "Pincode": "671124",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mayipady",
            "Pincode": "671124",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Shribagily",
            "Pincode": "671124",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramdas Nagar",
            "Pincode": "671125",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mogral Puthur Edso",
            "Pincode": "671128",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maniyat",
            "Pincode": "671310",
            "City": "Hosdurg",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pilicode Edso",
            "Pincode": "671310",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikaripur",
            "Pincode": "671310",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikarpur Kadapuram",
            "Pincode": "671310",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellap",
            "Pincode": "671310",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikarpur South",
            "Pincode": "671311",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padne",
            "Pincode": "671312",
            "City": "#N/A",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiaparamba",
            "Pincode": "671312",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruvathur",
            "Pincode": "671313",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chimeni",
            "Pincode": "671313",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaithakkad",
            "Pincode": "671313",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayyur",
            "Pincode": "671313",
            "City": "Hosdurg",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilakote",
            "Pincode": "671313",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pettikundu",
            "Pincode": "671313",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Podavur",
            "Pincode": "671313",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Timiri-Cheruvathur",
            "Pincode": "671313",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiapoil",
            "Pincode": "671313",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bangalam",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bheemanady",
            "Pincode": "671314",
            "City": "Hosdurg",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chayoth",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalichanadukam",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karindala",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattipoll",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kollampara",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottamala Estate",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madikai",
            "Pincode": "671314",
            "City": "Hosdurg",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nileshwar",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ozhinha Valappu",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Periyanganam",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumbatta",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudukai",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthariadukkam",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thaikadapuram",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uppilakal",
            "Pincode": "671314",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "West Eleri",
            "Pincode": "671314",
            "City": "Hosdurg",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhangad",
            "Pincode": "671315",
            "City": "Kanhangad",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhangad South Edso",
            "Pincode": "671315",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keekan",
            "Pincode": "671316",
            "City": "Hosdurg",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Movval",
            "Pincode": "671316",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pakkom",
            "Pincode": "671316",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallikere",
            "Pincode": "671316",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Periye",
            "Pincode": "671316",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ravaneswaram",
            "Pincode": "671316",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chandragiri Edso",
            "Pincode": "671317",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalanad",
            "Pincode": "671317",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paravanadkam",
            "Pincode": "671317",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perambale",
            "Pincode": "671317",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bekal",
            "Pincode": "671318",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paniyal",
            "Pincode": "671318",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mylatty",
            "Pincode": "671319",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udam-Padinhare",
            "Pincode": "671319",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udma",
            "Pincode": "671319",
            "City": "Udma",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chamnad",
            "Pincode": "671320",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angadimogaru",
            "Pincode": "671321",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Badur",
            "Pincode": "671321",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bela",
            "Pincode": "671321",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bombrana",
            "Pincode": "671321",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Dharmathadka",
            "Pincode": "671321",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Echalampady",
            "Pincode": "671321",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ednad",
            "Pincode": "671321",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ichalampady",
            "Pincode": "671321",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannur",
            "Pincode": "671321",
            "City": "Kannur",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kidoor",
            "Pincode": "671321",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodiamme",
            "Pincode": "671321",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudalmerkala",
            "Pincode": "671321",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mogral",
            "Pincode": "671321",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mokeri",
            "Pincode": "671321",
            "City": "Thalassery",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mugu",
            "Pincode": "671321",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nirachal",
            "Pincode": "671321",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumude",
            "Pincode": "671321",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthige",
            "Pincode": "671321",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Shiriya",
            "Pincode": "671321",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ullody",
            "Pincode": "671321",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ammeri",
            "Pincode": "671322",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bakur",
            "Pincode": "671322",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bayar.",
            "Pincode": "671322",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Beripadavu",
            "Pincode": "671322",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chippar",
            "Pincode": "671322",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayyar",
            "Pincode": "671322",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurudapadavu",
            "Pincode": "671322",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uppala",
            "Pincode": "671322",
            "City": "#N/A",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uppala Gate",
            "Pincode": "671322",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakallu",
            "Pincode": "671323",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakallu",
            "Pincode": "671323",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadambar",
            "Pincode": "671323",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodlamogaru",
            "Pincode": "671323",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koliyur",
            "Pincode": "671323",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunjathur",
            "Pincode": "671323",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Majaibail",
            "Pincode": "671323",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjeshwar",
            "Pincode": "671323",
            "City": "Manjeshwar",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Miyapadavu",
            "Pincode": "671323",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moodambail",
            "Pincode": "671323",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathoor",
            "Pincode": "671323",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Patla",
            "Pincode": "671323",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pavoor",
            "Pincode": "671323",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udayavara",
            "Pincode": "671323",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vorkadi",
            "Pincode": "671323",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Heroor",
            "Pincode": "671324",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ichilangode",
            "Pincode": "671324",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mangalpady",
            "Pincode": "671324",
            "City": "#N/A",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittarikkal",
            "Pincode": "671326",
            "City": "#N/A",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mandapam",
            "Pincode": "671326",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padnnakkad Edso",
            "Pincode": "671328",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manikoth Edso",
            "Pincode": "671329",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottapuram Kanhangad",
            "Pincode": "671341",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mavilakadapuram Edso",
            "Pincode": "671344",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padne Kadapuram Edso",
            "Pincode": "671345",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paivalike",
            "Pincode": "671348",
            "City": "#N/A",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udinur",
            "Pincode": "671349",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udumbanthala",
            "Pincode": "671350",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Achanthuruthy",
            "Pincode": "671351",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuruthi",
            "Pincode": "671351",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edachakai",
            "Pincode": "671357",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottakkat Edso",
            "Pincode": "671357",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Achikanam",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ajanur",
            "Pincode": "671531",
            "City": "Hosdurg",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anandasrama",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Attenganam",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Balla",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittari",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Haripuram",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iriya",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhiradakam",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhirangad",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodoth",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolavayal",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padimaaruth",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parakalai",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullur",
            "Pincode": "671531",
            "City": "Hosdurg",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thayannor",
            "Pincode": "671531",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Balanthode",
            "Pincode": "671532",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chamundikunnu",
            "Pincode": "671532",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaliapally",
            "Pincode": "671532",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottody",
            "Pincode": "671532",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malakallu",
            "Pincode": "671532",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panathur",
            "Pincode": "671532",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panthady",
            "Pincode": "671532",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rajapuram",
            "Pincode": "671532",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ranipuram",
            "Pincode": "671532",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Balal",
            "Pincode": "671533",
            "City": "Hosdurg",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chully Parappa",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Darkas",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanakapally",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kinanur",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konnakkad",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttom Kadavil",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Natakkal",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paramba",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parappa",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Plachikara",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallikadavu",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellarikundu",
            "Pincode": "671533",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnakunnu",
            "Pincode": "671535",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bandadka",
            "Pincode": "671541",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bedadka",
            "Pincode": "671541",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edneer",
            "Pincode": "671541",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karivadkom",
            "Pincode": "671541",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolathuri",
            "Pincode": "671541",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kundankuzhy",
            "Pincode": "671541",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttikolu",
            "Pincode": "671541",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manadka",
            "Pincode": "671541",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manimoola",
            "Pincode": "671541",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Munnad",
            "Pincode": "671541",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Samekochi",
            "Pincode": "671541",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sankaranpady",
            "Pincode": "671541",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkil",
            "Pincode": "671541",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iriyanni",
            "Pincode": "671542",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanathur",
            "Pincode": "671542",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karadaka",
            "Pincode": "671542",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kotoor",
            "Pincode": "671542",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malla",
            "Pincode": "671542",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muliyar",
            "Pincode": "671542",
            "City": "#N/A",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattamthatta",
            "Pincode": "671542",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adur",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Belluru",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Delampady",
            "Pincode": "671543",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkebettu Mulleria",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kinningar",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuntar",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Movvar",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulleria",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nettanige",
            "Pincode": "671543",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandi",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panjikkal",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parappa Delampady",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Urdur",
            "Pincode": "671543",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nekraje Edso",
            "Pincode": "671544",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkil Ferry",
            "Pincode": "671545",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ariyapady",
            "Pincode": "671551",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbla",
            "Pincode": "671551",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuntikana",
            "Pincode": "671551",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallathadka",
            "Pincode": "671551",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perdala",
            "Pincode": "671551",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Balemoola",
            "Pincode": "671552",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattukukke",
            "Pincode": "671552",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marie",
            "Pincode": "671552",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padre",
            "Pincode": "671552",
            "City": "Kasaragod",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perla",
            "Pincode": "671552",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ukkinada",
            "Pincode": "671552",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaninagar",
            "Pincode": "671552",
            "City": "Kasargode",
            "District": "Kasargode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Calicut",
            "Pincode": "673001",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chalapuram",
            "Pincode": "673002",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallai Kozhikode",
            "Pincode": "673003",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kundungal Edso",
            "Pincode": "673003",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthiyara",
            "Pincode": "673004",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruthiyad",
            "Pincode": "673004",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "West Hill",
            "Pincode": "673005",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "West Hill Chungam",
            "Pincode": "673005",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eranhipalam",
            "Pincode": "673006",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "St. Vincent Colony",
            "Pincode": "673006",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kololomb",
            "Pincode": "673007",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankavu",
            "Pincode": "673007",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankavu East",
            "Pincode": "673007",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Calicut Medical College",
            "Pincode": "673008",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Devagiri College Calicut",
            "Pincode": "673008",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottamparamba",
            "Pincode": "673008",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttikattur",
            "Pincode": "673008",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mayanad",
            "Pincode": "673008",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puvathaparamba",
            "Pincode": "673008",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velliparamba",
            "Pincode": "673008",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malaparamba",
            "Pincode": "673009",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karaparamba",
            "Pincode": "673010",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvaseri",
            "Pincode": "673010",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengeri",
            "Pincode": "673010",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nadakavu",
            "Pincode": "673011",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parambil",
            "Pincode": "673012",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paropadi",
            "Pincode": "673012",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pokkunnu Edso",
            "Pincode": "673013",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Guruvayurappan College",
            "Pincode": "673014",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Beypore",
            "Pincode": "673015",
            "City": "Beypore",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Beypore North",
            "Pincode": "673015",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Govindapuram Kuthiravattom",
            "Pincode": "673016",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuthiravattom",
            "Pincode": "673016",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellicode",
            "Pincode": "673016",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chevarambalam",
            "Pincode": "673017",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chevayur",
            "Pincode": "673017",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Calicut Art & Science College",
            "Pincode": "673018",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pantheerkavu",
            "Pincode": "673019",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellayicode",
            "Pincode": "673019",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Calicut Civil Station",
            "Pincode": "673020",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthiyangadi",
            "Pincode": "673021",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kythapoil Edso",
            "Pincode": "673023",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peruvayal Edso",
            "Pincode": "673024",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olavanna",
            "Pincode": "673025",
            "City": "Olavanna",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumanna Edso",
            "Pincode": "673026",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nallalam",
            "Pincode": "673027",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arakkinar",
            "Pincode": "673028",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvannur",
            "Pincode": "673029",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvannurnada",
            "Pincode": "673029",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Calicut Beach",
            "Pincode": "673032",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakara",
            "Pincode": "673101",
            "City": "Vadakara",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannookara",
            "Pincode": "673102",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madappally College",
            "Pincode": "673102",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rayarangoth",
            "Pincode": "673102",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakara Beach",
            "Pincode": "673103",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemmaruthur",
            "Pincode": "673104",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezhil",
            "Pincode": "673104",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurikkilad",
            "Pincode": "673104",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Memunda",
            "Pincode": "673104",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nut Street",
            "Pincode": "673104",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Putuhur-Vadagara",
            "Pincode": "673104",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sidha Smaj",
            "Pincode": "673104",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayikkillasseri",
            "Pincode": "673104",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mandarathur",
            "Pincode": "673105",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puduppanam",
            "Pincode": "673105",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chorode",
            "Pincode": "673106",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chorode East",
            "Pincode": "673106",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottuli",
            "Pincode": "673106",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttungal West",
            "Pincode": "673106",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mayyannur Edso",
            "Pincode": "673107",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Todanur Edso",
            "Pincode": "673108",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meppayil Edso",
            "Pincode": "673109",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttungal",
            "Pincode": "673110",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nadakkuthala Edso",
            "Pincode": "673112",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chennalode",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalpetta",
            "Pincode": "673121",
            "City": "Kalpetta",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kambalakkad",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karinkutty",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavumannam",
            "Pincode": "673121",
            "City": "Vythiri",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottathara Kalpetta",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madakkimala",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madakkunnu",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallikunnu Wyanad",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthoor Vayal",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puzhamutti",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkumthara",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengapally",
            "Pincode": "673121",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkavayal",
            "Pincode": "673122",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalpetta North",
            "Pincode": "673122",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maniyangode",
            "Pincode": "673122",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttil",
            "Pincode": "673122",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pariyaram Wynad",
            "Pincode": "673122",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhavatta",
            "Pincode": "673122",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chundale",
            "Pincode": "673123",
            "City": "#N/A",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnambetta",
            "Pincode": "673123",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varadoor",
            "Pincode": "673123",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaniyambetta Edso",
            "Pincode": "673124",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chaliyam",
            "Pincode": "673301",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadalundi",
            "Pincode": "673302",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elathur",
            "Pincode": "673303",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eranhikkal",
            "Pincode": "673303",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthiyanirathuruthu",
            "Pincode": "673303",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengalam",
            "Pincode": "673303",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemancheri",
            "Pincode": "673304",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kappad",
            "Pincode": "673304",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuvakkode",
            "Pincode": "673304",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Quilandy",
            "Pincode": "673305",
            "City": "Quilandy",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheliya",
            "Pincode": "673306",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kollam Qdy",
            "Pincode": "673307",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muchukunnu",
            "Pincode": "673307",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudadi North",
            "Pincode": "673307",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chombala",
            "Pincode": "673308",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnummakara",
            "Pincode": "673308",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Onchiyam",
            "Pincode": "673308",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aliyur",
            "Pincode": "673309",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koroth Road",
            "Pincode": "673309",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandakkal",
            "Pincode": "673310",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mahe",
            "Pincode": "673310",
            "City": "Mahe",
            "District": "Mahe",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "New Mahe",
            "Pincode": "673311",
            "City": "Mahe",
            "District": "Mahe",
            "State": "Pondicherry"
        },
        {
            "PostOfficeName": "Peringadi",
            "Pincode": "673312",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olavilam",
            "Pincode": "673313",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadalundi Nagaram",
            "Pincode": "673314",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallikunnu",
            "Pincode": "673314",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallikunnu North",
            "Pincode": "673314",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Atholi",
            "Pincode": "673315",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheekilode",
            "Pincode": "673315",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolakkad Atholi",
            "Pincode": "673315",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolathur",
            "Pincode": "673315",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kongannur",
            "Pincode": "673315",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kariyad South",
            "Pincode": "673316",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Annasseri",
            "Pincode": "673317",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Talakadathur",
            "Pincode": "673317",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvangoor",
            "Pincode": "673318",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melur Quilandy",
            "Pincode": "673319",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naluthara",
            "Pincode": "673320",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Modakallur",
            "Pincode": "673321",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arikulam Edso",
            "Pincode": "673322",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ulliyeri Edso",
            "Pincode": "673323",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezhariyur Edso",
            "Pincode": "673324",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudadi",
            "Pincode": "673325",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naderi",
            "Pincode": "673326",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnathara Edso",
            "Pincode": "673327",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannur",
            "Pincode": "673328",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naduvathur",
            "Pincode": "673330",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallor Edso",
            "Pincode": "673333",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eramala",
            "Pincode": "673501",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Orkatteri",
            "Pincode": "673501",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kachcheri",
            "Pincode": "673502",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kotancherri",
            "Pincode": "673503",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuningad",
            "Pincode": "673503",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthuvadathur",
            "Pincode": "673503",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peleri",
            "Pincode": "673503",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Purameri",
            "Pincode": "673503",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iyyangode",
            "Pincode": "673504",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nadapuram",
            "Pincode": "673504",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perode",
            "Pincode": "673504",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayappanichi",
            "Pincode": "673505",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudavantheri",
            "Pincode": "673505",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tuneri",
            "Pincode": "673505",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelakkad",
            "Pincode": "673506",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Indira Nagar",
            "Pincode": "673506",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallachi",
            "Pincode": "673506",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naripetta",
            "Pincode": "673506",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumparamba",
            "Pincode": "673506",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vanimal",
            "Pincode": "673506",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varikoli",
            "Pincode": "673506",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velliyode",
            "Pincode": "673506",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vishnumangalam",
            "Pincode": "673506",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arur",
            "Pincode": "673507",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheekunnummal West",
            "Pincode": "673507",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkattil",
            "Pincode": "673507",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mullambath",
            "Pincode": "673507",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nittur",
            "Pincode": "673507",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nitumannur",
            "Pincode": "673507",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padiripeetta",
            "Pincode": "673507",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathiriyad",
            "Pincode": "673507",
            "City": "Pathiriyad",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poolakul",
            "Pincode": "673507",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thinur",
            "Pincode": "673507",
            "City": "Cannanore (Kannur)",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adukkath",
            "Pincode": "673508",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karandode",
            "Pincode": "673508",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurichagam",
            "Pincode": "673508",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttiadi",
            "Pincode": "673508",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthuvannacha",
            "Pincode": "673508",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paleri Town",
            "Pincode": "673508",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Taliyil",
            "Pincode": "673508",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velom",
            "Pincode": "673508",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velom Peruvayal",
            "Pincode": "673508",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chekkiad",
            "Pincode": "673509",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parakkadavu",
            "Pincode": "673509",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puliyavil",
            "Pincode": "673509",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thankottur",
            "Pincode": "673509",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattoli Edso",
            "Pincode": "673510",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheekunnummal Edso",
            "Pincode": "673511",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherapuram",
            "Pincode": "673512",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Akkal",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karingad",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavilumpara",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunduthode",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuringad",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marudonkara",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mokeri Nadapuram Edso",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moyilothara",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pasukkadavu",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poothampara",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vannathichira",
            "Pincode": "673513",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iringannur Edso",
            "Pincode": "673514",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodiyura Edso",
            "Pincode": "673515",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Abhayagiri",
            "Pincode": "673517",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bhoomivathukkal",
            "Pincode": "673517",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherumoth",
            "Pincode": "673517",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chuzhali",
            "Pincode": "673517",
            "City": "Taliparamba",
            "District": "Kannur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallunira",
            "Pincode": "673517",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valayam",
            "Pincode": "673517",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vatayam Edso",
            "Pincode": "673518",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayakkodi Edso",
            "Pincode": "673519",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuruvangad",
            "Pincode": "673520",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayinikkad",
            "Pincode": "673521",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iringal",
            "Pincode": "673521",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottakkal Iringal",
            "Pincode": "673521",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilur Meladi",
            "Pincode": "673522",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meladi",
            "Pincode": "673522",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallickara",
            "Pincode": "673522",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Purakad",
            "Pincode": "673522",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iringath",
            "Pincode": "673523",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maniyar Edso",
            "Pincode": "673523",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muduvana",
            "Pincode": "673523",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payyoli",
            "Pincode": "673523",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avala",
            "Pincode": "673524",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruvannur Meladi",
            "Pincode": "673524",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalpathur",
            "Pincode": "673524",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karayad",
            "Pincode": "673524",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhpayur",
            "Pincode": "673524",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozhukallur",
            "Pincode": "673524",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttoth",
            "Pincode": "673524",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meppayur",
            "Pincode": "673524",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muyipoth",
            "Pincode": "673524",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chenoli",
            "Pincode": "673525",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edavarad",
            "Pincode": "673525",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadiyangad",
            "Pincode": "673525",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayanna Bazar",
            "Pincode": "673525",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilinnanyam",
            "Pincode": "673525",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mennaniam",
            "Pincode": "673525",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perampra",
            "Pincode": "673525",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chakkittapara",
            "Pincode": "673526",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayanna",
            "Pincode": "673526",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thandorappara",
            "Pincode": "673526",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athiyodi",
            "Pincode": "673527",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukkad",
            "Pincode": "673527",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattanode",
            "Pincode": "673527",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avadukka",
            "Pincode": "673528",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengaroth",
            "Pincode": "673528",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthukad",
            "Pincode": "673528",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poozhithode",
            "Pincode": "673528",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chingapuram",
            "Pincode": "673529",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tikkoti",
            "Pincode": "673529",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palayadnada",
            "Pincode": "673530",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Katalur Edso",
            "Pincode": "673531",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koothali",
            "Pincode": "673532",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manipuram",
            "Pincode": "673534",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherandathur",
            "Pincode": "673541",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponmeri",
            "Pincode": "673541",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tharopyil",
            "Pincode": "673541",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karthikapally",
            "Pincode": "673542",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Katameri",
            "Pincode": "673542",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottapali",
            "Pincode": "673542",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurinhaliyode",
            "Pincode": "673542",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponmeri Parambil",
            "Pincode": "673542",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valliyad",
            "Pincode": "673542",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Villiapalli",
            "Pincode": "673542",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayancheri Edso",
            "Pincode": "673544",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelavur",
            "Pincode": "673571",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karanthur",
            "Pincode": "673571",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konott",
            "Pincode": "673571",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnamanagalam Calicut",
            "Pincode": "673571",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnamangalam Mini Ie",
            "Pincode": "673571",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padanilam",
            "Pincode": "673571",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payimbra",
            "Pincode": "673571",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pilasseri",
            "Pincode": "673571",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avilora",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elenttil",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvampoil",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilakkoth",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kotuvally",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neeleswaram",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Omasseri",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pannikottur",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthur Kotuvalli",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiaparamba",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vavad",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venappara",
            "Pincode": "673572",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattipara",
            "Pincode": "673573",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudathai",
            "Pincode": "673573",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudathayi Bazar",
            "Pincode": "673573",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maikavu",
            "Pincode": "673573",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mayilellampara",
            "Pincode": "673573",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parappanpoil",
            "Pincode": "673573",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Santhinagar",
            "Pincode": "673573",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tachmpoil",
            "Pincode": "673573",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tamaracherry",
            "Pincode": "673573",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velimanna",
            "Pincode": "673573",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ekarool",
            "Pincode": "673574",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Emmamparamba",
            "Pincode": "673574",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mangad",
            "Pincode": "673574",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Talayad",
            "Pincode": "673574",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Unnikulam",
            "Pincode": "673574",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayalada",
            "Pincode": "673574",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Achooranam",
            "Pincode": "673575",
            "City": "Vythiri",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arambattukunnu",
            "Pincode": "673575",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bibleland",
            "Pincode": "673575",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjoora",
            "Pincode": "673575",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padinjarethara",
            "Pincode": "673575",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pozhuthana",
            "Pincode": "673575",
            "City": "#N/A",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thariote North",
            "Pincode": "673575",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varambatta",
            "Pincode": "673575",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lakkidi",
            "Pincode": "673576",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sugandhagiri",
            "Pincode": "673576",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vythiri",
            "Pincode": "673576",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chembra Meppadi",
            "Pincode": "673577",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cottanad",
            "Pincode": "673577",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundakai",
            "Pincode": "673577",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nathamkuni",
            "Pincode": "673577",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthumala",
            "Pincode": "673577",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikkaipetta",
            "Pincode": "673577",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellarmala Edso",
            "Pincode": "673578",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amarakuni",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheeyambalam",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chettapalam",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kabanigiri",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalanadikolli",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manalvayal",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marakadavu",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mullankolli",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padichira",
            "Pincode": "673579",
            "City": "Sulthanbathery",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pakkom Pallikere",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakolli",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perikkallur",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulpalli",
            "Pincode": "673579",
            "City": "#N/A",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sasimala",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Seethamount - Pulpali",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliyambalam",
            "Pincode": "673579",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chembukadavu",
            "Pincode": "673580",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannoth Kotancherri",
            "Pincode": "673580",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kotencherri Tamaracherri",
            "Pincode": "673580",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuppayakode",
            "Pincode": "673580",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meemutty",
            "Pincode": "673580",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundoor Kozhikode",
            "Pincode": "673580",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Murampahty",
            "Pincode": "673580",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Theyyappara",
            "Pincode": "673580",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velancode",
            "Pincode": "673580",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chellancode",
            "Pincode": "673581",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadalmat",
            "Pincode": "673581",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vatuvanchal",
            "Pincode": "673581",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madavur Edso",
            "Pincode": "673583",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttancherri",
            "Pincode": "673585",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narikunni",
            "Pincode": "673585",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parannur",
            "Pincode": "673585",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnasseri",
            "Pincode": "673585",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnur Cherupala",
            "Pincode": "673585",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adivaram Puthupadi",
            "Pincode": "673586",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkad Puthupadi",
            "Pincode": "673586",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nooramthole",
            "Pincode": "673586",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudupadi",
            "Pincode": "673586",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iyyad Edso",
            "Pincode": "673587",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thariote Edso",
            "Pincode": "673589",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karani",
            "Pincode": "673591",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kariyambadi",
            "Pincode": "673591",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolagappara",
            "Pincode": "673591",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Krachal",
            "Pincode": "673591",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbaleri",
            "Pincode": "673591",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meenangadi",
            "Pincode": "673591",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mylambadi",
            "Pincode": "673591",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nalketty",
            "Pincode": "673591",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Beenachi",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chadalath",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chulliote",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kidanganad",
            "Pincode": "673592",
            "City": "Sulthanbathery",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuppadi",
            "Pincode": "673592",
            "City": "Sulthanbathery",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Modakolly",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthanga",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nenmeni",
            "Pincode": "673592",
            "City": "Sulthanbathery",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nulpuzha",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pambra",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhupathur",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poomulla",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sultan S Bathery",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thovarimala",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vakeri",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valluvady",
            "Pincode": "673592",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambalavayal",
            "Pincode": "673593",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheengeri",
            "Pincode": "673593",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalathuvayal",
            "Pincode": "673593",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karadipara Ambalavayal",
            "Pincode": "673593",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nallarchal",
            "Pincode": "673593",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narikundu",
            "Pincode": "673593",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheeral",
            "Pincode": "673595",
            "City": "#N/A",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mookuthikunnu",
            "Pincode": "673595",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nambiarkunnu",
            "Pincode": "673595",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nenmenikunnu",
            "Pincode": "673595",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenkunnu",
            "Pincode": "673595",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thazhathoor",
            "Pincode": "673595",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athirattukunnu",
            "Pincode": "673596",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Choothupara",
            "Pincode": "673596",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kenichira",
            "Pincode": "673596",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koleri",
            "Pincode": "673596",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poothadi",
            "Pincode": "673596",
            "City": "Sulthanbathery",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thazhmunda",
            "Pincode": "673596",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valavayal",
            "Pincode": "673596",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Calicut Reg Engg College",
            "Pincode": "673601",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chulur Calicut",
            "Pincode": "673601",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malayamma",
            "Pincode": "673601",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nayarkuzhi",
            "Pincode": "673601",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alli",
            "Pincode": "673602",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chendamangalur",
            "Pincode": "673602",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karasseri",
            "Pincode": "673602",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodiyathur",
            "Pincode": "673602",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumaranallur",
            "Pincode": "673602",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manasseri",
            "Pincode": "673602",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mokkam",
            "Pincode": "673602",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mysoremala",
            "Pincode": "673602",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellikaparamba",
            "Pincode": "673602",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pannicode",
            "Pincode": "673602",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakampoyil",
            "Pincode": "673603",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallurutty",
            "Pincode": "673603",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthuppanpuzha",
            "Pincode": "673603",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponnakayam",
            "Pincode": "673603",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulluramapara",
            "Pincode": "673603",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnakkal",
            "Pincode": "673603",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thambalamanna",
            "Pincode": "673603",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvambadi",
            "Pincode": "673603",
            "City": "Wayanad",
            "District": "Wayanad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkatam Poil",
            "Pincode": "673604",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koombara Bazar",
            "Pincode": "673604",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuliramutty",
            "Pincode": "673604",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kutaranni",
            "Pincode": "673604",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manhakadavu",
            "Pincode": "673604",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovaranthodu",
            "Pincode": "673604",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkotti",
            "Pincode": "673611",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvatur",
            "Pincode": "673611",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhakkumuri Kakkoti",
            "Pincode": "673611",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuruvattur",
            "Pincode": "673611",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Morikkara",
            "Pincode": "673611",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Balusseri",
            "Pincode": "673612",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eramangalam Balussery",
            "Pincode": "673612",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannadipoyil",
            "Pincode": "673612",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kariyathannavu",
            "Pincode": "673612",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karumala",
            "Pincode": "673612",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kokkallur",
            "Pincode": "673612",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panangad Quilandy",
            "Pincode": "673612",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thurutiyad",
            "Pincode": "673612",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nanminda",
            "Pincode": "673613",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pavandur",
            "Pincode": "673613",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvannur",
            "Pincode": "673614",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavil",
            "Pincode": "673614",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottur",
            "Pincode": "673614",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannankavu",
            "Pincode": "673614",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moolad",
            "Pincode": "673614",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naduvannur",
            "Pincode": "673614",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Oravil",
            "Pincode": "673614",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punath",
            "Pincode": "673614",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvode",
            "Pincode": "673614",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vakayad",
            "Pincode": "673614",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkayam",
            "Pincode": "673615",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallanode",
            "Pincode": "673615",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelannur",
            "Pincode": "673616",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irivallur",
            "Pincode": "673616",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannankara Chelannur",
            "Pincode": "673616",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Makkada Edso",
            "Pincode": "673617",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avitanallur Edso",
            "Pincode": "673618",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkur",
            "Pincode": "673619",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkancheri",
            "Pincode": "673620",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peruvannamuzhi",
            "Pincode": "673620",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Quilandy Bazar",
            "Pincode": "673620",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Urallur",
            "Pincode": "673620",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kinalur Edso",
            "Pincode": "673621",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattoli Bazar Edso",
            "Pincode": "673623",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nochat Edso",
            "Pincode": "673624",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Faroke",
            "Pincode": "673631",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumukham",
            "Pincode": "673631",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Farook College",
            "Pincode": "673632",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karadparamba",
            "Pincode": "673632",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puducode Feroke",
            "Pincode": "673633",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramanattukara",
            "Pincode": "673633",
            "City": "Ramanattukara",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaidyarangadi",
            "Pincode": "673633",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhayur",
            "Pincode": "673633",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhayur East",
            "Pincode": "673633",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelambra",
            "Pincode": "673634",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolakkatchali",
            "Pincode": "673634",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullikanam",
            "Pincode": "673634",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Calicut University",
            "Pincode": "673635",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chenakkalanangadi",
            "Pincode": "673636",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthur Pallikkal",
            "Pincode": "673636",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tenhipalam",
            "Pincode": "673636",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Andiyoorkunnu.",
            "Pincode": "673637",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayikarapadi",
            "Pincode": "673637",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannamvettikavu",
            "Pincode": "673637",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulikkal Malapuram",
            "Pincode": "673637",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiyaparambu",
            "Pincode": "673637",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arimbra",
            "Pincode": "673638",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chirayil",
            "Pincode": "673638",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kondotti",
            "Pincode": "673638",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuminiparamba",
            "Pincode": "673638",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthuparamba",
            "Pincode": "673638",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthuvallur",
            "Pincode": "673638",
            "City": "Ernad",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nediyirippu",
            "Pincode": "673638",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olavattur",
            "Pincode": "673638",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thurakkal",
            "Pincode": "673638",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Areacode",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chembrakkottur",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemrakattur",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iruvatty",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhuparamba",
            "Pincode": "673639",
            "City": "Ernad",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maithara",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panampilvau",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumparamb Ugrapuram",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovathikkal",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottilangady",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottilangady",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottumukkam",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottumukkam",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Urangattiri",
            "Pincode": "673639",
            "City": "Ernad",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valillapuzha",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettilapara",
            "Pincode": "673639",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheikkod",
            "Pincode": "673640",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karumarakkad",
            "Pincode": "673640",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundakkal Vazhakkad",
            "Pincode": "673640",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Omanur",
            "Pincode": "673640",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhkkad",
            "Pincode": "673640",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Akkaparamba",
            "Pincode": "673641",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuzhimanna",
            "Pincode": "673641",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakkad Malappuram",
            "Pincode": "673641",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puliyakode",
            "Pincode": "673641",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tavanur Feroke",
            "Pincode": "673641",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tripanachi",
            "Pincode": "673641",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mongam",
            "Pincode": "673642",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olamathi",
            "Pincode": "673642",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olukkur",
            "Pincode": "673642",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvanthuruthy Edso",
            "Pincode": "673643",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavanur Edso",
            "Pincode": "673644",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruvayur",
            "Pincode": "673645",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karippur Air Port",
            "Pincode": "673647",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melangadi Edso",
            "Pincode": "673648",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Morayur Edso",
            "Pincode": "673649",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilayil Edso",
            "Pincode": "673652",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azhinilam",
            "Pincode": "673654",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolathara",
            "Pincode": "673655",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherooppa",
            "Pincode": "673661",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruvadi",
            "Pincode": "673661",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayal",
            "Pincode": "673661",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mavoor",
            "Pincode": "673661",
            "City": "Mavoor",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palath",
            "Pincode": "673661",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirur",
            "Pincode": "676101",
            "City": "Tirur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alathiyur",
            "Pincode": "676102",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bettathu Pudiyangadi",
            "Pincode": "676102",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poyilisseri",
            "Pincode": "676102",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudupalli",
            "Pincode": "676102",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Purathur",
            "Pincode": "676102",
            "City": "Tirur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengalur",
            "Pincode": "676102",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettom",
            "Pincode": "676102",
            "City": "Tirur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettom Pallipuram",
            "Pincode": "676102",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iringavu",
            "Pincode": "676103",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikandiyur",
            "Pincode": "676104",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pachattiri",
            "Pincode": "676105",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkummuri",
            "Pincode": "676105",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athrisseri",
            "Pincode": "676106",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponmundam",
            "Pincode": "676106",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pookayil Bazar",
            "Pincode": "676107",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Codacal",
            "Pincode": "676108",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Triprangode",
            "Pincode": "676108",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Niramarudur",
            "Pincode": "676109",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheriyamundam Edso",
            "Pincode": "676111",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadambode Edso",
            "Pincode": "676121",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjeri",
            "Pincode": "676121",
            "City": "Manjeri",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vakkethody",
            "Pincode": "676121",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elankur",
            "Pincode": "676122",
            "City": "Ernad",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjeri College",
            "Pincode": "676122",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mariyad",
            "Pincode": "676122",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narukara",
            "Pincode": "676122",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellikuthu",
            "Pincode": "676122",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pappinipara",
            "Pincode": "676122",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payyanad",
            "Pincode": "676122",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullancheri",
            "Pincode": "676122",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amayur Mlp",
            "Pincode": "676123",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karakunnu",
            "Pincode": "676123",
            "City": "Ernad",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvambram",
            "Pincode": "676123",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvambram West",
            "Pincode": "676123",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koomankulam",
            "Pincode": "676123",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manhapatta",
            "Pincode": "676123",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathapiriyam",
            "Pincode": "676123",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathiriyal",
            "Pincode": "676123",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulpetta Edso",
            "Pincode": "676126",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikkalangode Edso",
            "Pincode": "676127",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anantavur",
            "Pincode": "676301",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumbathur",
            "Pincode": "676301",
            "City": "Tirur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirunavaya",
            "Pincode": "676301",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vyrancode",
            "Pincode": "676301",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vysambhagom",
            "Pincode": "676301",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panagattoor",
            "Pincode": "676302",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pariyapuram Tanur",
            "Pincode": "676302",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthiyakadapuram",
            "Pincode": "676302",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tanur Malabar",
            "Pincode": "676302",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anjapura",
            "Pincode": "676303",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neduva",
            "Pincode": "676303",
            "City": "Tirurangadi",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parappanangadi",
            "Pincode": "676303",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ullanam",
            "Pincode": "676303",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ullanam North",
            "Pincode": "676303",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Achanambalam",
            "Pincode": "676304",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iringallur Kottakkal",
            "Pincode": "676304",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannattipadi",
            "Pincode": "676304",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengara Malappuram",
            "Pincode": "676304",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Abdulrahman Nagar",
            "Pincode": "676305",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannamangalam West",
            "Pincode": "676305",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttur North",
            "Pincode": "676305",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherumukku",
            "Pincode": "676306",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuriyad",
            "Pincode": "676306",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mampuram",
            "Pincode": "676306",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olalakkara",
            "Pincode": "676306",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandarangadi",
            "Pincode": "676306",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirurangadi",
            "Pincode": "676306",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keeraladweeswarapuram",
            "Pincode": "676307",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meenadathur",
            "Pincode": "676307",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tanalur",
            "Pincode": "676307",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallyora Edso",
            "Pincode": "676308",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodinhi",
            "Pincode": "676309",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athavanad Edso",
            "Pincode": "676310",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mooniyur",
            "Pincode": "676311",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ariyallur Mbr",
            "Pincode": "676312",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ozhur",
            "Pincode": "676313",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherur Edso",
            "Pincode": "676314",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moonniyur South",
            "Pincode": "676314",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parambilpeedika",
            "Pincode": "676317",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velimukku",
            "Pincode": "676317",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velimukku South",
            "Pincode": "676317",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannamangalam Edso",
            "Pincode": "676318",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chettipadi",
            "Pincode": "676319",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottakkad",
            "Pincode": "676319",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nannambra",
            "Pincode": "676320",
            "City": "Tirurangadi",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Omachapuzha",
            "Pincode": "676320",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tayyalingal",
            "Pincode": "676320",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edarikode",
            "Pincode": "676501",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Klari",
            "Pincode": "676501",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttipala",
            "Pincode": "676501",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthuparamba",
            "Pincode": "676501",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paravanna",
            "Pincode": "676502",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vakkadu",
            "Pincode": "676502",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengottur",
            "Pincode": "676503",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Indianur",
            "Pincode": "676503",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottakkal",
            "Pincode": "676503",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttipuram",
            "Pincode": "676503",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandamangalam",
            "Pincode": "676503",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parappur Kottakkal",
            "Pincode": "676503",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthur Kottakkal",
            "Pincode": "676503",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chattiparamba",
            "Pincode": "676504",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodur",
            "Pincode": "676504",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malappuram",
            "Pincode": "676505",
            "City": "Malappuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koottilangadi",
            "Pincode": "676506",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padinhattumuri",
            "Pincode": "676506",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhamallur",
            "Pincode": "676506",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Makkaraparamba",
            "Pincode": "676507",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perinthatiri",
            "Pincode": "676507",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattallur",
            "Pincode": "676507",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chullipara",
            "Pincode": "676508",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valakolam",
            "Pincode": "676508",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venniyur",
            "Pincode": "676508",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakkayam",
            "Pincode": "676509",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Munduparamba",
            "Pincode": "676509",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perimabalm",
            "Pincode": "676509",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherushola",
            "Pincode": "676510",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallarmangalam",
            "Pincode": "676510",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Randathani",
            "Pincode": "676510",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thennala Edso",
            "Pincode": "676511",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irimbuzhi Edso",
            "Pincode": "676513",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melmuri Edso",
            "Pincode": "676514",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Oorakam Keezhmuri Edso",
            "Pincode": "676515",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panayi",
            "Pincode": "676516",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pookkottur",
            "Pincode": "676517",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellur",
            "Pincode": "676517",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marakara Edso",
            "Pincode": "676518",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Down Hill",
            "Pincode": "676519",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Hajiarpalli",
            "Pincode": "676519",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Oorakam Melmuri",
            "Pincode": "676519",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattarkadavu",
            "Pincode": "676519",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chembarasseri",
            "Pincode": "676521",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandalur",
            "Pincode": "676521",
            "City": "Ernad",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandikkad",
            "Pincode": "676521",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valluvangad",
            "Pincode": "676521",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valluvangad South",
            "Pincode": "676521",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edayur North",
            "Pincode": "676522",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolaparamba",
            "Pincode": "676522",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iringatteri",
            "Pincode": "676523",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalkundu",
            "Pincode": "676523",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvarakundu",
            "Pincode": "676523",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttathy",
            "Pincode": "676523",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulvetta",
            "Pincode": "676523",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tharis",
            "Pincode": "676523",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambalakadavu",
            "Pincode": "676525",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anchachavadi",
            "Pincode": "676525",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arimanal",
            "Pincode": "676525",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ezhupathekkar",
            "Pincode": "676525",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalikavu",
            "Pincode": "676525",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kerala Estate",
            "Pincode": "676525",
            "City": "Nilambur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neelancheri",
            "Pincode": "676525",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullengode Estate",
            "Pincode": "676525",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattathur",
            "Pincode": "676528",
            "City": "Mukundapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Othukungal",
            "Pincode": "676528",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponmala",
            "Pincode": "676528",
            "City": "Tirur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edavanna",
            "Pincode": "676541",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eranhikode",
            "Pincode": "676541",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pannipara",
            "Pincode": "676541",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perakamanna",
            "Pincode": "676541",
            "City": "Ernad",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mampad",
            "Pincode": "676542",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mampad College",
            "Pincode": "676542",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meppadam",
            "Pincode": "676542",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullipadam",
            "Pincode": "676542",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadapuram",
            "Pincode": "676542",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalpakancherri",
            "Pincode": "676551",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanmanam Thekkumuri",
            "Pincode": "676551",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuruga",
            "Pincode": "676551",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paramalangadi",
            "Pincode": "676551",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkankuttur",
            "Pincode": "676551",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valavannur",
            "Pincode": "676551",
            "City": "Tirur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karipol",
            "Pincode": "676552",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnathala",
            "Pincode": "676552",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puramannur",
            "Pincode": "676552",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkumbram",
            "Pincode": "676552",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valancherri",
            "Pincode": "676552",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiakunnu",
            "Pincode": "676552",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadampuzha",
            "Pincode": "676553",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karekad",
            "Pincode": "676553",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edayur",
            "Pincode": "676554",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tolavannur Edso",
            "Pincode": "676557",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chennara",
            "Pincode": "676561",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavancheri",
            "Pincode": "676561",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mangalam Mbr",
            "Pincode": "676561",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattanur",
            "Pincode": "676561",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttanur",
            "Pincode": "676561",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttayi",
            "Pincode": "676562",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padinjarekara Kutayi",
            "Pincode": "676562",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakkad",
            "Pincode": "678001",
            "City": "Palakkad",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olavakot",
            "Pincode": "678002",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalpathi",
            "Pincode": "678003",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "New Kalpathi",
            "Pincode": "678003",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodunthirapulli",
            "Pincode": "678004",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nurani",
            "Pincode": "678004",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nurani Agraharam",
            "Pincode": "678004",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chokkanathapuram",
            "Pincode": "678005",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadukkaakunnu",
            "Pincode": "678005",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthur-Palakkad",
            "Pincode": "678005",
            "City": "Palghat",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallipuram Palakkad",
            "Pincode": "678006",
            "City": "Palghat",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marudarode",
            "Pincode": "678007",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallathieri",
            "Pincode": "678007",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudusseri",
            "Pincode": "678007",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakkad Engg.College",
            "Pincode": "678008",
            "City": "Palghat",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakkad Industrial Estate",
            "Pincode": "678008",
            "City": "Palghat",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Dhoni",
            "Pincode": "678009",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallekulangara",
            "Pincode": "678009",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sekahripuram",
            "Pincode": "678010",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambikapuram",
            "Pincode": "678011",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moothanthara",
            "Pincode": "678012",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkanthara",
            "Pincode": "678012",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnathutmedu",
            "Pincode": "678013",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakkad City",
            "Pincode": "678014",
            "City": "Palghat",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallekad",
            "Pincode": "678015",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavalpad",
            "Pincode": "678017",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallepully Edso",
            "Pincode": "678018",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pirayiri Edso",
            "Pincode": "678019",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirunilayi",
            "Pincode": "678020",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittur Pgt",
            "Pincode": "678101",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttipalam",
            "Pincode": "678101",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tattamangalam",
            "Pincode": "678102",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilayodi",
            "Pincode": "678103",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittur College",
            "Pincode": "678104",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koduvayur",
            "Pincode": "678501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathankulam",
            "Pincode": "678501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thannisserri",
            "Pincode": "678501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vembalur",
            "Pincode": "678502",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karipode",
            "Pincode": "678503",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudunagaram",
            "Pincode": "678503",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadavanur",
            "Pincode": "678504",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallassana",
            "Pincode": "678505",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anamari",
            "Pincode": "678506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kollengode",
            "Pincode": "678506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nenmeni Kollengode",
            "Pincode": "678506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panangattiri",
            "Pincode": "678506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payyalur",
            "Pincode": "678506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattekad",
            "Pincode": "678506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Govindapuram",
            "Pincode": "678507",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meenkara Dam",
            "Pincode": "678507",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthalamada",
            "Pincode": "678507",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elavancheri Edso Nemmara",
            "Pincode": "678508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhakkumuri",
            "Pincode": "678508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nemmara",
            "Pincode": "678508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nemmara College",
            "Pincode": "678508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nemmara Old Village",
            "Pincode": "678508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pothundy Dam",
            "Pincode": "678508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallanghy",
            "Pincode": "678508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padagiri",
            "Pincode": "678509",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayalur",
            "Pincode": "678510",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kairadi",
            "Pincode": "678510",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvaliyad",
            "Pincode": "678510",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nelliampathy",
            "Pincode": "678511",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sitharkunda",
            "Pincode": "678511",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkyur",
            "Pincode": "678512",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannalur Edso",
            "Pincode": "678513",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peruvamba",
            "Pincode": "678531",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karippali",
            "Pincode": "678532",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattancherry",
            "Pincode": "678532",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meenakshipuram",
            "Pincode": "678533",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nanniyode",
            "Pincode": "678534",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vandithavalam",
            "Pincode": "678534",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alathur Mbr",
            "Pincode": "678541",
            "City": "Palghat",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perinkulam",
            "Pincode": "678542",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavasseri",
            "Pincode": "678543",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vavulliapuram",
            "Pincode": "678543",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athipotta",
            "Pincode": "678544",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nechur",
            "Pincode": "678544",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palambalakode",
            "Pincode": "678544",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudiyankam",
            "Pincode": "678545",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullode",
            "Pincode": "678545",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tarur Edso",
            "Pincode": "678547",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padur Kavassery Edso",
            "Pincode": "678548",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kotambu",
            "Pincode": "678551",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olasseri",
            "Pincode": "678551",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvalathur",
            "Pincode": "678551",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panayur",
            "Pincode": "678552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Polpully",
            "Pincode": "678552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Verkoli",
            "Pincode": "678552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nallepilly",
            "Pincode": "678553",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekke Desam",
            "Pincode": "678553",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekke Gramam",
            "Pincode": "678553",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athicode",
            "Pincode": "678554",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nattukal Chittur",
            "Pincode": "678554",
            "City": "Palghat",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozhinjampara",
            "Pincode": "678555",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palaniyara Palayam",
            "Pincode": "678555",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramavarmapuram Pudur.",
            "Pincode": "678555",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vannamada",
            "Pincode": "678555",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Attempathy",
            "Pincode": "678556",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eduppukulam",
            "Pincode": "678556",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Menonpara",
            "Pincode": "678556",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parassikal",
            "Pincode": "678556",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozhipara",
            "Pincode": "678557",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olalapadi",
            "Pincode": "678557",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velanthavalam",
            "Pincode": "678557",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karingarapully Edso",
            "Pincode": "678559",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathur Agraharam",
            "Pincode": "678571",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathur Palghat",
            "Pincode": "678571",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tachangad",
            "Pincode": "678571",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukulam Kottayi",
            "Pincode": "678572",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kariyancode",
            "Pincode": "678572",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottayi",
            "Pincode": "678572",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulinelli",
            "Pincode": "678572",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varode Kottayi Edso",
            "Pincode": "678572",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chennangad",
            "Pincode": "678573",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paruthipulli",
            "Pincode": "678573",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chulanur Edso",
            "Pincode": "678574",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naduvathupara",
            "Pincode": "678574",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringottukurissi",
            "Pincode": "678574",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nannamukku",
            "Pincode": "678575",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallanchathannur Edso",
            "Pincode": "678575",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amparanirapel",
            "Pincode": "678578",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Agali",
            "Pincode": "678581",
            "City": "#N/A",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chavadiyoor",
            "Pincode": "678581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittoot Agali",
            "Pincode": "678581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karara",
            "Pincode": "678581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavundikal",
            "Pincode": "678581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottathara",
            "Pincode": "678581",
            "City": "Mannarkad",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattathukad",
            "Pincode": "678581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudur",
            "Pincode": "678581",
            "City": "Mannarkad",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sholayur-Palakkad",
            "Pincode": "678581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chendakki",
            "Pincode": "678582",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Jellipara",
            "Pincode": "678582",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaithachira Mannarkad",
            "Pincode": "678582",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalkandy",
            "Pincode": "678582",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallamala",
            "Pincode": "678582",
            "City": "Mannarkad",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannarkad",
            "Pincode": "678582",
            "City": "#N/A",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukkali",
            "Pincode": "678582",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paloor",
            "Pincode": "678582",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullisseri",
            "Pincode": "678582",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ariyur",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kandamangalam",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodakkad",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottoppadam",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumaranputhur",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kundurkunnu",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannarkad College",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nattukal",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallikunnu Mgt",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palode",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payyanadam",
            "Pincode": "678583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irumbakachola",
            "Pincode": "678591",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhirapuzha",
            "Pincode": "678591",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhirapuzha Dam",
            "Pincode": "678591",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakayam",
            "Pincode": "678591",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundur Palakkad",
            "Pincode": "678592",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nambullipara",
            "Pincode": "678592",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nochchipulli",
            "Pincode": "678592",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudanur",
            "Pincode": "678592",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velikkad",
            "Pincode": "678592",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudukurissi",
            "Pincode": "678593",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallikurup",
            "Pincode": "678593",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tachampara",
            "Pincode": "678593",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikkalur",
            "Pincode": "678593",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Viyyakurissi",
            "Pincode": "678593",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttikulangara",
            "Pincode": "678594",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallikode",
            "Pincode": "678594",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karakurissi",
            "Pincode": "678595",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pombra",
            "Pincode": "678595",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vakkadapuram",
            "Pincode": "678595",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhumbram",
            "Pincode": "678595",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalladikode",
            "Pincode": "678596",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimba",
            "Pincode": "678597",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moonekarb.O",
            "Pincode": "678597",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pottasseri",
            "Pincode": "678598",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elakkad Edso",
            "Pincode": "678600",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alanallur",
            "Pincode": "678601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bhimanad",
            "Pincode": "678601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edathanattukara",
            "Pincode": "678601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kacheriparambu",
            "Pincode": "678601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvalamkunnu",
            "Pincode": "678601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uppukulam",
            "Pincode": "678601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattamannapuram",
            "Pincode": "678601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikitamkunnu Edso",
            "Pincode": "678605",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chethallur Edso",
            "Pincode": "678609",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edathara",
            "Pincode": "678611",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parli Palghat",
            "Pincode": "678612",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankarai",
            "Pincode": "678613",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankurissi",
            "Pincode": "678613",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankarai R.S.Edso",
            "Pincode": "678614",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kinavallur Edso",
            "Pincode": "678615",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tenur Edso",
            "Pincode": "678616",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjikode",
            "Pincode": "678621",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pampampallam",
            "Pincode": "678621",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elappuly",
            "Pincode": "678622",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Erattukulam",
            "Pincode": "678622",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramasseri",
            "Pincode": "678622",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tenari",
            "Pincode": "678622",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengodi",
            "Pincode": "678622",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjikode West",
            "Pincode": "678623",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Walayar Dam",
            "Pincode": "678624",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kongad",
            "Pincode": "678631",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manikkasseri",
            "Pincode": "678631",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mucheer",
            "Pincode": "678631",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parasseri",
            "Pincode": "678631",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konikkazhi",
            "Pincode": "678632",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulapatta",
            "Pincode": "678632",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ummanazhi",
            "Pincode": "678632",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azhiyannur",
            "Pincode": "678633",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Katambazhipuram",
            "Pincode": "678633",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunduvampadam Peringode",
            "Pincode": "678633",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettekara",
            "Pincode": "678633",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punchapadam",
            "Pincode": "678634",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheraya Edso",
            "Pincode": "678635",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alangad Edso",
            "Pincode": "678637",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallur Opm",
            "Pincode": "678641",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keralasseri",
            "Pincode": "678641",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kundalasseri",
            "Pincode": "678641",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thadukkasseri",
            "Pincode": "678641",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadassery",
            "Pincode": "678641",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilakkumbram",
            "Pincode": "678642",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannur",
            "Pincode": "678642",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannur West",
            "Pincode": "678642",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nagaripuram",
            "Pincode": "678642",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakkal Malampuzha",
            "Pincode": "678651",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malampuzha Dam",
            "Pincode": "678651",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parambikulam",
            "Pincode": "678661",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tunakadavu",
            "Pincode": "678661",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thenkurissi",
            "Pincode": "678671",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilayannur",
            "Pincode": "678671",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koottala Kunisseri",
            "Pincode": "678681",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunisseri",
            "Pincode": "678681",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anjumoorthy",
            "Pincode": "678682",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Erattakulam Alatur",
            "Pincode": "678682",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thannilapuram",
            "Pincode": "678682",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayakkad",
            "Pincode": "678683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanakkanthuruthy",
            "Pincode": "678683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panniankara Vadakancherry",
            "Pincode": "678683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilakkancherri",
            "Pincode": "678684",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koranchira",
            "Pincode": "678684",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulangot",
            "Pincode": "678684",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannapra",
            "Pincode": "678685",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannambra",
            "Pincode": "678686",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paruvasseri",
            "Pincode": "678686",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthucode Palghat",
            "Pincode": "678687",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkepotta",
            "Pincode": "678687",
            "City": "Kozhikode",
            "District": "Kozhikode",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudallur",
            "Pincode": "678688",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallavur",
            "Pincode": "678688",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manapadam Edso",
            "Pincode": "678689",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannadi",
            "Pincode": "678701",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chithali",
            "Pincode": "678702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Coyalmana",
            "Pincode": "678702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalapatti",
            "Pincode": "678702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannanur",
            "Pincode": "678702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nochully",
            "Pincode": "678702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olive Mount",
            "Pincode": "678702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perinkunnu",
            "Pincode": "678702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheramangalam",
            "Pincode": "678703",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melarcode",
            "Pincode": "678703",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittalanchery",
            "Pincode": "678704",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudappalur",
            "Pincode": "678705",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittadi Vandali",
            "Pincode": "678706",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karinkayam",
            "Pincode": "678706",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mangalam Dam",
            "Pincode": "678706",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olinkadavu",
            "Pincode": "678706",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vandali",
            "Pincode": "678706",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kinasseri Edso",
            "Pincode": "678707",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elavampadam Edso",
            "Pincode": "678709",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttanur",
            "Pincode": "678721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tolanur",
            "Pincode": "678722",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottekad",
            "Pincode": "678732",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthupariyaram",
            "Pincode": "678733",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thengara Edso",
            "Pincode": "678761",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perimbadari Edso",
            "Pincode": "678762",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ottapalam",
            "Pincode": "679101",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakara",
            "Pincode": "679102",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakara",
            "Pincode": "679102",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varode",
            "Pincode": "679102",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palappuram",
            "Pincode": "679103",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanniyampuram",
            "Pincode": "679104",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mayannur",
            "Pincode": "679105",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kondazhi",
            "Pincode": "679106",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "South Kondazhi",
            "Pincode": "679106",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paruthipara",
            "Pincode": "679121",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Shornaur",
            "Pincode": "679121",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallipadam",
            "Pincode": "679122",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayilad",
            "Pincode": "679122",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulapully",
            "Pincode": "679122",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundakkottukurissi",
            "Pincode": "679122",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Shoranur Govt.Press",
            "Pincode": "679122",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ganeshgiri",
            "Pincode": "679123",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadanamkurissi Edso",
            "Pincode": "679124",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanayam Edso",
            "Pincode": "679125",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lakkidi",
            "Pincode": "679301",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mangalam Ottapalam",
            "Pincode": "679301",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Akalur",
            "Pincode": "679302",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Gandhi Seva Sadan",
            "Pincode": "679302",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perur Ottappalam",
            "Pincode": "679302",
            "City": "Palghat",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhayyur",
            "Pincode": "679303",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodumunda",
            "Pincode": "679303",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolikkottusseri",
            "Pincode": "679303",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kondurkara",
            "Pincode": "679303",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattambi",
            "Pincode": "679303",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumudiyur",
            "Pincode": "679303",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sankaramangalam",
            "Pincode": "679303",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chembra",
            "Pincode": "679304",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvegapura",
            "Pincode": "679304",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilathur",
            "Pincode": "679304",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukutangad",
            "Pincode": "679305",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karambathur",
            "Pincode": "679305",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallipuram Pattambi",
            "Pincode": "679305",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maruthur",
            "Pincode": "679306",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melepattambi",
            "Pincode": "679306",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilmuri",
            "Pincode": "679307",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannengode",
            "Pincode": "679307",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melmuri",
            "Pincode": "679307",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulasseri",
            "Pincode": "679307",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edapalam",
            "Pincode": "679308",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaipuram",
            "Pincode": "679308",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naduvattom",
            "Pincode": "679308",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedungottur",
            "Pincode": "679308",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chundambatta",
            "Pincode": "679309",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thathanapully",
            "Pincode": "679309",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilayur",
            "Pincode": "679309",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilayur West",
            "Pincode": "679309",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amayur Edso",
            "Pincode": "679310",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nhangattiri Edso",
            "Pincode": "679311",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parudur Edso",
            "Pincode": "679312",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalladipetta",
            "Pincode": "679313",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muduthala Edso",
            "Pincode": "679314",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angadipuram",
            "Pincode": "679321",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aripra",
            "Pincode": "679321",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherakkaparamba",
            "Pincode": "679321",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pariyapuram",
            "Pincode": "679321",
            "City": "Tirur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthanangadi",
            "Pincode": "679321",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puzhakkattri",
            "Pincode": "679321",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amminikkad",
            "Pincode": "679322",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arakkuparamba",
            "Pincode": "679322",
            "City": "Perinthalmanna",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattarakkal",
            "Pincode": "679322",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panniyakurissi",
            "Pincode": "679322",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathaikara",
            "Pincode": "679322",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perintalmanna",
            "Pincode": "679322",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponniyamkuirssi",
            "Pincode": "679322",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Talekode",
            "Pincode": "679322",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelakkad",
            "Pincode": "679323",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemmalasseri",
            "Pincode": "679323",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulamanthole",
            "Pincode": "679323",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valapuram",
            "Pincode": "679323",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadannamanna",
            "Pincode": "679324",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koottil",
            "Pincode": "679324",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankada",
            "Pincode": "679324",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankada Pallipuram",
            "Pincode": "679324",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallikkapetta",
            "Pincode": "679324",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellila",
            "Pincode": "679324",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemmaniyod",
            "Pincode": "679325",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhattur",
            "Pincode": "679325",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannarmala",
            "Pincode": "679325",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakkalvetta",
            "Pincode": "679325",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattikad Malapuram",
            "Pincode": "679325",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovathanam",
            "Pincode": "679325",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tachingandam",
            "Pincode": "679325",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thelakkad",
            "Pincode": "679325",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valambur",
            "Pincode": "679325",
            "City": "Perinthalmanna",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengoor",
            "Pincode": "679325",
            "City": "Kunnathunad",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edapatta",
            "Pincode": "679326",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edayattur",
            "Pincode": "679326",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melattur Malapuram",
            "Pincode": "679326",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padirikod",
            "Pincode": "679326",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velliyancheri",
            "Pincode": "679326",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettathur",
            "Pincode": "679326",
            "City": "Perinthalmanna",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chembrasseri East",
            "Pincode": "679327",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poolamanna",
            "Pincode": "679327",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poonchola",
            "Pincode": "679327",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tuvvur",
            "Pincode": "679327",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellayur",
            "Pincode": "679327",
            "City": "Nilambur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kappil",
            "Pincode": "679328",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naduvath",
            "Pincode": "679328",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnapala",
            "Pincode": "679328",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Wandoor",
            "Pincode": "679328",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edavanna",
            "Pincode": "679329",
            "City": "Ernad",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nilambur",
            "Pincode": "679329",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nallanthani",
            "Pincode": "679330",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nilambur R.S",
            "Pincode": "679330",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palengara",
            "Pincode": "679330",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramankuth",
            "Pincode": "679330",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karapuram",
            "Pincode": "679331",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnummalpotti",
            "Pincode": "679331",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Modapoika",
            "Pincode": "679331",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moothedom",
            "Pincode": "679331",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Munda",
            "Pincode": "679331",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palemad",
            "Pincode": "679331",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Theyyathompadam",
            "Pincode": "679331",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amarambalam",
            "Pincode": "679332",
            "City": "Nilambur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chettipadam",
            "Pincode": "679332",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chulliyode",
            "Pincode": "679332",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavallamukatta",
            "Pincode": "679332",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mampattumoola",
            "Pincode": "679332",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannthipoyil",
            "Pincode": "679332",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pookkotumpadam",
            "Pincode": "679332",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thulappan Colony",
            "Pincode": "679332",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kambalakallu",
            "Pincode": "679333",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karacode",
            "Pincode": "679333",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manimooly",
            "Pincode": "679333",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marutha",
            "Pincode": "679333",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nambooripotti",
            "Pincode": "679333",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhikadavu",
            "Pincode": "679333",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bhoodan Colony",
            "Pincode": "679334",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumbalangode",
            "Pincode": "679334",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Munderi",
            "Pincode": "679334",
            "City": "Munderi",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padiripadam",
            "Pincode": "679334",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallikuth",
            "Pincode": "679334",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathar",
            "Pincode": "679334",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pookkootumanna",
            "Pincode": "679334",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ezhuvanthala",
            "Pincode": "679335",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irimbalasseri",
            "Pincode": "679335",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marayamangalam South",
            "Pincode": "679335",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellaya",
            "Pincode": "679335",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pombilaya",
            "Pincode": "679335",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukode",
            "Pincode": "679336",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Choorakode",
            "Pincode": "679336",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuruvattur",
            "Pincode": "679336",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallapuzha",
            "Pincode": "679336",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulukkallur",
            "Pincode": "679337",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulayankavu",
            "Pincode": "679337",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvambalam",
            "Pincode": "679338",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolathur",
            "Pincode": "679338",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moorkand",
            "Pincode": "679338",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panaga",
            "Pincode": "679338",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panga Chendy",
            "Pincode": "679338",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panga South",
            "Pincode": "679338",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengad",
            "Pincode": "679338",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amarambalam South",
            "Pincode": "679339",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karad",
            "Pincode": "679339",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koorad",
            "Pincode": "679339",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Porur",
            "Pincode": "679339",
            "City": "Nilambur",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkumpadam",
            "Pincode": "679339",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaniyambalm",
            "Pincode": "679339",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukara",
            "Pincode": "679340",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elad",
            "Pincode": "679340",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnakav",
            "Pincode": "679340",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnapilly",
            "Pincode": "679340",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palathole",
            "Pincode": "679340",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chandakunnu Edso",
            "Pincode": "679342",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eranhimangad Edso",
            "Pincode": "679343",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karulai Edso",
            "Pincode": "679344",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvali Edso",
            "Pincode": "679348",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramapuram Edso",
            "Pincode": "679350",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirukad Edso",
            "Pincode": "679351",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Talekode West Edso",
            "Pincode": "679352",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uppada Edso",
            "Pincode": "679354",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chokkad Edso",
            "Pincode": "679355",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marayamangalam Edso",
            "Pincode": "679356",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aliparamba",
            "Pincode": "679357",
            "City": "Perinthalmanna",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anamangad",
            "Pincode": "679357",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manalaya",
            "Pincode": "679357",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thootha",
            "Pincode": "679357",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhenkada",
            "Pincode": "679357",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambalavattom",
            "Pincode": "679501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherambattakavu",
            "Pincode": "679501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhur",
            "Pincode": "679501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melur",
            "Pincode": "679501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panamanna",
            "Pincode": "679501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panamanna South",
            "Pincode": "679501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Taruvakoanam",
            "Pincode": "679501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Munnurkode",
            "Pincode": "679502",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikatiri",
            "Pincode": "679502",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veeramangalam",
            "Pincode": "679502",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adakkaputhur",
            "Pincode": "679503",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherpalcheri",
            "Pincode": "679503",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karattukurissi",
            "Pincode": "679503",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulakkad",
            "Pincode": "679503",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mangode",
            "Pincode": "679503",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panniyamkurissi",
            "Pincode": "679503",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karumanakurissi",
            "Pincode": "679504",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellinali",
            "Pincode": "679504",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chalavara",
            "Pincode": "679505",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puliyamkunnu",
            "Pincode": "679505",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karalmanna",
            "Pincode": "679506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkummuri",
            "Pincode": "679506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chunangad",
            "Pincode": "679511",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulannur",
            "Pincode": "679511",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherumundasseri",
            "Pincode": "679512",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Attasseri",
            "Pincode": "679513",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimpuzha",
            "Pincode": "679513",
            "City": "Ottappalam",
            "District": "Palakkad",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Srikrishnapuram",
            "Pincode": "679513",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valambilimangalam",
            "Pincode": "679513",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalluvazhi",
            "Pincode": "679514",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattukulam",
            "Pincode": "679514",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttansseri",
            "Pincode": "679514",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvazhiyode",
            "Pincode": "679514",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirunarayanapuram",
            "Pincode": "679514",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadambur Pgt",
            "Pincode": "679515",
            "City": "Kadambur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengasseri",
            "Pincode": "679516",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannampetta Edso",
            "Pincode": "679517",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottapuram Edso",
            "Pincode": "679518",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherottur",
            "Pincode": "679521",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manisseri",
            "Pincode": "679521",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukattupulam",
            "Pincode": "679522",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panayur Ottapalam",
            "Pincode": "679522",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaniamkulam",
            "Pincode": "679522",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavalapara",
            "Pincode": "679523",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koonathara",
            "Pincode": "679523",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannanur R.S.B.O",
            "Pincode": "679523",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruthuruthy",
            "Pincode": "679531",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumpura",
            "Pincode": "679531",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Painkulam",
            "Pincode": "679531",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panjal",
            "Pincode": "679531",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettikattiri",
            "Pincode": "679531",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Desamangalam",
            "Pincode": "679532",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallani Kottambathoor",
            "Pincode": "679532",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallur",
            "Pincode": "679532",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalassery",
            "Pincode": "679532",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttanad",
            "Pincode": "679533",
            "City": "Palghat",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nagalasseri",
            "Pincode": "679533",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellikkatiri",
            "Pincode": "679533",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkevavanur",
            "Pincode": "679533",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirumittakode Edso",
            "Pincode": "679533",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottoppadam Trithala",
            "Pincode": "679534",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mala Palaghat",
            "Pincode": "679534",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mezhathur",
            "Pincode": "679534",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Otalur",
            "Pincode": "679534",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattithara Edso",
            "Pincode": "679534",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trithala",
            "Pincode": "679534",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chaliyattiri",
            "Pincode": "679535",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kothachira",
            "Pincode": "679535",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringannur",
            "Pincode": "679535",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringode Palghat",
            "Pincode": "679535",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chalisseri",
            "Pincode": "679536",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavukode",
            "Pincode": "679536",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumannur",
            "Pincode": "679536",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chathannur Edso",
            "Pincode": "679537",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalakkasserri Edso",
            "Pincode": "679538",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakkara",
            "Pincode": "679551",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angadi",
            "Pincode": "679552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumranallur",
            "Pincode": "679552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kappur",
            "Pincode": "679552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumaranallur",
            "Pincode": "679552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbidi",
            "Pincode": "679553",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malamalkavu",
            "Pincode": "679553",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudallur",
            "Pincode": "679554",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malmakavu",
            "Pincode": "679554",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanmanam Edso",
            "Pincode": "679556",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnayurkulam",
            "Pincode": "679561",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallur",
            "Pincode": "679562",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochannur",
            "Pincode": "679562",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnayur",
            "Pincode": "679562",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkekad",
            "Pincode": "679562",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nhamanghat",
            "Pincode": "679563",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayilathur",
            "Pincode": "679563",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Andathode",
            "Pincode": "679564",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karthala",
            "Pincode": "679571",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttipuram",
            "Pincode": "679571",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhur",
            "Pincode": "679571",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irimbiliyam",
            "Pincode": "679572",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athaloor",
            "Pincode": "679573",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iswaramangalam",
            "Pincode": "679573",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nariparamba",
            "Pincode": "679573",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tavanur",
            "Pincode": "679573",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikkanapuram",
            "Pincode": "679573",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pidavannur",
            "Pincode": "679574",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruvallur",
            "Pincode": "679575",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nannamukku South",
            "Pincode": "679575",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayilakkad",
            "Pincode": "679576",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumparamba Edso",
            "Pincode": "679576",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Polpakkara",
            "Pincode": "679576",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sugapuram",
            "Pincode": "679576",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponani",
            "Pincode": "679577",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudur",
            "Pincode": "679578",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattamkulam",
            "Pincode": "679578",
            "City": "#N/A",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Gramam",
            "Pincode": "679579",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palpetty",
            "Pincode": "679579",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhanji Malappuram",
            "Pincode": "679579",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliyancode",
            "Pincode": "679579",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayirur",
            "Pincode": "679580",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumabadappu",
            "Pincode": "679580",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marancherri",
            "Pincode": "679581",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadancherri Edso",
            "Pincode": "679582",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponani Nagaram",
            "Pincode": "679583",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhiramukku",
            "Pincode": "679584",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puranga",
            "Pincode": "679584",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alankode",
            "Pincode": "679585",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadavanad",
            "Pincode": "679586",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaladi Mpm",
            "Pincode": "679586",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponani South",
            "Pincode": "679586",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eramangalam",
            "Pincode": "679587",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perasannur Edso",
            "Pincode": "679588",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Biyyam Edso",
            "Pincode": "679589",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payinkanniyur Edso",
            "Pincode": "679590",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kokkur Malappurm",
            "Pincode": "679591",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Othalur West",
            "Pincode": "679591",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moolankav",
            "Pincode": "679592",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naduvattom Edso",
            "Pincode": "679592",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayankalam",
            "Pincode": "679594",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mookuthala",
            "Pincode": "679594",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chammannur",
            "Pincode": "679633",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrissur",
            "Pincode": "680001",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punkunnu",
            "Pincode": "680002",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayyanthole",
            "Pincode": "680003",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poothole",
            "Pincode": "680004",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "West Fort",
            "Pincode": "680004",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellikunnu",
            "Pincode": "680005",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrissur East",
            "Pincode": "680005",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ancheri",
            "Pincode": "680006",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kriachira",
            "Pincode": "680006",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuriachira",
            "Pincode": "680006",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nehru Nagar",
            "Pincode": "680006",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurkancherri",
            "Pincode": "680007",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadukara",
            "Pincode": "680007",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherur",
            "Pincode": "680008",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrissur Engg.College",
            "Pincode": "680009",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolazhi",
            "Pincode": "680010",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Viyyur",
            "Pincode": "680010",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanattukara",
            "Pincode": "680011",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullazhi",
            "Pincode": "680012",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirumukkulam",
            "Pincode": "680012",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttur",
            "Pincode": "680013",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttanallur",
            "Pincode": "680014",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannamangalam",
            "Pincode": "680014",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marottichal",
            "Pincode": "680014",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponnukkara",
            "Pincode": "680014",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthur-Trichur",
            "Pincode": "680014",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettukad",
            "Pincode": "680014",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedupuzha",
            "Pincode": "680015",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veluthur",
            "Pincode": "680016",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manakodi",
            "Pincode": "680017",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringavu Edso",
            "Pincode": "680018",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrissur City",
            "Pincode": "680020",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrissur R.S",
            "Pincode": "680021",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chiyyaram",
            "Pincode": "680026",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chovur",
            "Pincode": "680027",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanimangalam",
            "Pincode": "680027",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palisseri",
            "Pincode": "680027",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurichikkara.",
            "Pincode": "680028",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Guruvayur",
            "Pincode": "680101",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvenkitam",
            "Pincode": "680101",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aruyannur",
            "Pincode": "680102",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kandanaseeri",
            "Pincode": "680102",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iringapuram",
            "Pincode": "680103",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenpalli",
            "Pincode": "680103",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Brahmakulam",
            "Pincode": "680104",
            "City": "Brahmakulam",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nemmini",
            "Pincode": "680104",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thaikkad",
            "Pincode": "680104",
            "City": "Thaikkad",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irinjalakuda",
            "Pincode": "680121",
            "City": "Irinjalakuda",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edathirinji",
            "Pincode": "680122",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karumathara",
            "Pincode": "680123",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konathukunnu",
            "Pincode": "680123",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallivattam Edso",
            "Pincode": "680124",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irinjalakuda North",
            "Pincode": "680125",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittisseri",
            "Pincode": "680301",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nandikkara",
            "Pincode": "680301",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nemminikara",
            "Pincode": "680301",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhayi",
            "Pincode": "680301",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudukad",
            "Pincode": "680301",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alagappa Nagar",
            "Pincode": "680302",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattanathara",
            "Pincode": "680302",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varandarapplly",
            "Pincode": "680303",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velupadam",
            "Pincode": "680303",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chimoni Dam",
            "Pincode": "680304",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palapilly",
            "Pincode": "680304",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellai-Trichur",
            "Pincode": "680305",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konikara",
            "Pincode": "680306",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ollur",
            "Pincode": "680306",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perincherry",
            "Pincode": "680306",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalore",
            "Pincode": "680306",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Annallur",
            "Pincode": "680307",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chalakudi",
            "Pincode": "680307",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottat",
            "Pincode": "680307",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Potta",
            "Pincode": "680307",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vijayaraghavapuram",
            "Pincode": "680307",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kathikutam",
            "Pincode": "680308",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koratti",
            "Pincode": "680308",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koratti Kizhakkummuri",
            "Pincode": "680308",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koratti South",
            "Pincode": "680308",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mambra",
            "Pincode": "680308",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nalukettu",
            "Pincode": "680308",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Khanna Nagar Koratty",
            "Pincode": "680309",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parappukara",
            "Pincode": "680310",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottippal",
            "Pincode": "680310",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottippal",
            "Pincode": "680310",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koovakattukunnu",
            "Pincode": "680311",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnapilly",
            "Pincode": "680311",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melur",
            "Pincode": "680311",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengallur",
            "Pincode": "680312",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Inchakundu",
            "Pincode": "680312",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Inchamudi",
            "Pincode": "680312",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muppliyam",
            "Pincode": "680312",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avinisseri",
            "Pincode": "680313",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikkur",
            "Pincode": "680314",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadukutty Edso",
            "Pincode": "680315",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muringur Vadakkummuri Edso",
            "Pincode": "680316",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallur",
            "Pincode": "680317",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttithadi",
            "Pincode": "680317",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nandipulam Edso",
            "Pincode": "680319",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marathakara",
            "Pincode": "680320",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruvaloor Edso",
            "Pincode": "680321",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anandhapuram Edso",
            "Pincode": "680323",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Annanad Edso",
            "Pincode": "680324",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varakara Edso",
            "Pincode": "680325",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemmanthara",
            "Pincode": "680501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chiranallur",
            "Pincode": "680501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eranallur",
            "Pincode": "680501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kecheri",
            "Pincode": "680501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalakottukara",
            "Pincode": "680501",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Choondal",
            "Pincode": "680502",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Akathiyoor Edso",
            "Pincode": "680503",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chowwannur Edso",
            "Pincode": "680503",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnamkulam",
            "Pincode": "680503",
            "City": "Kunnamkulam",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koonamoochi",
            "Pincode": "680504",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavida",
            "Pincode": "680505",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottapadi",
            "Pincode": "680505",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thamarayoor",
            "Pincode": "680505",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Blangad",
            "Pincode": "680506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chavakkad",
            "Pincode": "680506",
            "City": "Chavakkad",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuraniyur",
            "Pincode": "680506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muduvattur",
            "Pincode": "680506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perakom",
            "Pincode": "680506",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maruthadi",
            "Pincode": "680507",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parvarattil",
            "Pincode": "680507",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vemmanad",
            "Pincode": "680507",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Annakara",
            "Pincode": "680508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peruvallur",
            "Pincode": "680508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puvathur",
            "Pincode": "680508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirunellur",
            "Pincode": "680508",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mullasseri",
            "Pincode": "680509",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Enamakkal",
            "Pincode": "680510",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannoth Venkitangu",
            "Pincode": "680510",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venkitangu",
            "Pincode": "680510",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittattukara",
            "Pincode": "680511",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elavally",
            "Pincode": "680511",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elavally South",
            "Pincode": "680511",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkasseri",
            "Pincode": "680511",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madu",
            "Pincode": "680512",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Orumanayur",
            "Pincode": "680512",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattekad",
            "Pincode": "680512",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Toyakavu",
            "Pincode": "680513",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadappuram",
            "Pincode": "680514",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvatra",
            "Pincode": "680516",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemmannur",
            "Pincode": "680517",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanippayyur",
            "Pincode": "680517",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Porkolangad",
            "Pincode": "680517",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Agalad",
            "Pincode": "680518",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannalamkunnu",
            "Pincode": "680518",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Akkikavu",
            "Pincode": "680519",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikkad",
            "Pincode": "680519",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumpilavu",
            "Pincode": "680519",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thippillisseri",
            "Pincode": "680519",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thozhiyur Tolur",
            "Pincode": "680520",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arthat",
            "Pincode": "680521",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chakkumkandam",
            "Pincode": "680522",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paluvai",
            "Pincode": "680522",
            "City": "Paluvai",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anjoor Kunnamkulam",
            "Pincode": "680523",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittanjur",
            "Pincode": "680523",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhur",
            "Pincode": "680523",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnamkulam City",
            "Pincode": "680523",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padoor Chavakkad",
            "Pincode": "680524",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Choolissery",
            "Pincode": "680541",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundur Trichur",
            "Pincode": "680541",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mangad",
            "Pincode": "680542",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhanji",
            "Pincode": "680542",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumthuruthy",
            "Pincode": "680542",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Porkulam",
            "Pincode": "680542",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadavallur",
            "Pincode": "680543",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Korattikara",
            "Pincode": "680543",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattagampala",
            "Pincode": "680544",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pengamukku",
            "Pincode": "680544",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peramangalam",
            "Pincode": "680545",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaiparamba",
            "Pincode": "680546",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avanur Edso",
            "Pincode": "680547",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anjur Mundur Edso",
            "Pincode": "680549",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittilappilly",
            "Pincode": "680551",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puranattukara",
            "Pincode": "680551",
            "City": "Puranattukara",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parappur",
            "Pincode": "680552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathiyakulangara",
            "Pincode": "680552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponnore",
            "Pincode": "680552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tholur",
            "Pincode": "680552",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amalanagar.",
            "Pincode": "680553",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puzhakkal",
            "Pincode": "680553",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adat",
            "Pincode": "680554",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherpu",
            "Pincode": "680561",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pootharakkal",
            "Pincode": "680561",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arattupuzha Urakom",
            "Pincode": "680562",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Urakam",
            "Pincode": "680562",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallachira",
            "Pincode": "680562",
            "City": "Vallachira",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ammadam",
            "Pincode": "680563",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumpilavu",
            "Pincode": "680564",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhuvil",
            "Pincode": "680564",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhuvil West",
            "Pincode": "680564",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringottukara",
            "Pincode": "680565",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirannikavu",
            "Pincode": "680565",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nattakam",
            "Pincode": "680566",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nattika",
            "Pincode": "680566",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chulur",
            "Pincode": "680567",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karayamvattom",
            "Pincode": "680567",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Triprayar",
            "Pincode": "680567",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valapad",
            "Pincode": "680567",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valapad Beach",
            "Pincode": "680567",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalimbram",
            "Pincode": "680568",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edasseri",
            "Pincode": "680569",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Talikulam",
            "Pincode": "680569",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thambankadavu",
            "Pincode": "680569",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkumuri",
            "Pincode": "680570",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chazhur",
            "Pincode": "680571",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilakkummuri",
            "Pincode": "680571",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nattika Beach Edso",
            "Pincode": "680572",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherpu Pandinjattummuri",
            "Pincode": "680573",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodannur",
            "Pincode": "680574",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paralam",
            "Pincode": "680575",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chottupara",
            "Pincode": "680581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Minalur",
            "Pincode": "680581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulagunnathucavu",
            "Pincode": "680581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringandur Edso",
            "Pincode": "680581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poomala",
            "Pincode": "680581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pottore",
            "Pincode": "680581",
            "City": "Pottore",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thangallu",
            "Pincode": "680581",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakancherry",
            "Pincode": "680582",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irunilamcode",
            "Pincode": "680583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mullurkara",
            "Pincode": "680583",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Katungode",
            "Pincode": "680584",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottapuram Vadakancherry",
            "Pincode": "680584",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttancherry",
            "Pincode": "680584",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nelluvaya",
            "Pincode": "680584",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thayyur",
            "Pincode": "680584",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellarakad",
            "Pincode": "680584",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumarapanal",
            "Pincode": "680585",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulakkad",
            "Pincode": "680585",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tali",
            "Pincode": "680585",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varavur",
            "Pincode": "680585",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelakara",
            "Pincode": "680586",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elanad",
            "Pincode": "680586",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaliya Rode",
            "Pincode": "680586",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumala",
            "Pincode": "680586",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pangarapally",
            "Pincode": "680586",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulacode",
            "Pincode": "680586",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thozhupadam",
            "Pincode": "680586",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venganallur",
            "Pincode": "680586",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelakode",
            "Pincode": "680587",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallepadam",
            "Pincode": "680587",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbalakode",
            "Pincode": "680587",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhayannur",
            "Pincode": "680587",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakethara",
            "Pincode": "680587",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vennur",
            "Pincode": "680587",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malavattom",
            "Pincode": "680588",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malesamangalam",
            "Pincode": "680588",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pampady East",
            "Pincode": "680588",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattiparamba",
            "Pincode": "680588",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvilwamala",
            "Pincode": "680588",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Enkakad",
            "Pincode": "680589",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karumathara Enkakad",
            "Pincode": "680589",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manalithara",
            "Pincode": "680589",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhani",
            "Pincode": "680589",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanhirakode",
            "Pincode": "680590",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumaranallur Tcr",
            "Pincode": "680590",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kundannur",
            "Pincode": "680590",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Killimangalam",
            "Pincode": "680591",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Attur",
            "Pincode": "680592",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arangottukara Edso",
            "Pincode": "680593",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaniyarkode",
            "Pincode": "680594",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kutthanpalli",
            "Pincode": "680594",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundathicode Edso",
            "Pincode": "680595",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velappaya",
            "Pincode": "680596",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pampady West Edso",
            "Pincode": "680597",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kiralur",
            "Pincode": "680601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumal",
            "Pincode": "680601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellattanjoor",
            "Pincode": "680601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velur Bazar",
            "Pincode": "680601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velur Tcr",
            "Pincode": "680601",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattom",
            "Pincode": "680602",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nambazhikad",
            "Pincode": "680602",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaka",
            "Pincode": "680602",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alurmattom Edso",
            "Pincode": "680603",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chiramanganad",
            "Pincode": "680604",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maruthancode",
            "Pincode": "680604",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkumkara",
            "Pincode": "680608",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thichur Edso",
            "Pincode": "680609",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thonnurkara Edso",
            "Pincode": "680610",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elthuruth",
            "Pincode": "680611",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjany",
            "Pincode": "680612",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kandasankadavu",
            "Pincode": "680613",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naduvilkara",
            "Pincode": "680614",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vatanapally",
            "Pincode": "680614",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vatanapally Beach",
            "Pincode": "680614",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Engandiyoor",
            "Pincode": "680615",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kundaliyur",
            "Pincode": "680616",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manalur",
            "Pincode": "680617",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aranattukara",
            "Pincode": "680618",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trithallur",
            "Pincode": "680619",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trithallur West",
            "Pincode": "680619",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arimpur",
            "Pincode": "680620",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chettupuzha",
            "Pincode": "680621",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundathicode West P.O",
            "Pincode": "680623",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panangauttakara",
            "Pincode": "680623",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parlikad",
            "Pincode": "680623",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthuruthy",
            "Pincode": "680623",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakancherry R.S",
            "Pincode": "680623",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vyasagiri",
            "Pincode": "680623",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattilapoovam",
            "Pincode": "680631",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kundukad",
            "Pincode": "680631",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramavarmapuram",
            "Pincode": "680631",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alapad",
            "Pincode": "680641",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anthikad",
            "Pincode": "680641",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenpeediaka",
            "Pincode": "680642",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madakkathara",
            "Pincode": "680651",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannuthi",
            "Pincode": "680651",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chuvannamannu",
            "Pincode": "680652",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannara",
            "Pincode": "680652",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koottala",
            "Pincode": "680652",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattikad",
            "Pincode": "680652",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovanchira",
            "Pincode": "680652",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaniyampara",
            "Pincode": "680652",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chennayapara",
            "Pincode": "680653",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peechi",
            "Pincode": "680653",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellanikara",
            "Pincode": "680654",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ollukara",
            "Pincode": "680655",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ollur Thaikkattusseri",
            "Pincode": "680655",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kerala Agri University",
            "Pincode": "680656",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kerala Agri University",
            "Pincode": "680656",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nadavaramba",
            "Pincode": "680661",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thumbur",
            "Pincode": "680662",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellangallur",
            "Pincode": "680662",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullut",
            "Pincode": "680663",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullut North",
            "Pincode": "680663",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodungallur",
            "Pincode": "680664",
            "City": "Kodungallur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvanchikulam",
            "Pincode": "680664",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panangad",
            "Pincode": "680665",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azhikode Jetty",
            "Pincode": "680666",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madavana",
            "Pincode": "680666",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anapuzha",
            "Pincode": "680667",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottapuram Kdglr",
            "Pincode": "680667",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thurithipuram",
            "Pincode": "680667",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kothaparamba",
            "Pincode": "680668",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Santhipuram",
            "Pincode": "680668",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kandankulam",
            "Pincode": "680669",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Methala",
            "Pincode": "680669",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karupadanna",
            "Pincode": "680670",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edavilangu",
            "Pincode": "680671",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kara",
            "Pincode": "680671",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padinjare Vemballur",
            "Pincode": "680671",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottanallur",
            "Pincode": "680672",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azhikode Trichur Edso",
            "Pincode": "680673",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chalingad",
            "Pincode": "680681",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaippamangalam Beach",
            "Pincode": "680681",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaippamanglam",
            "Pincode": "680681",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koorikuzhy",
            "Pincode": "680681",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannikulangara",
            "Pincode": "680682",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenchira",
            "Pincode": "680682",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenchira-Kizhakkumuni",
            "Pincode": "680682",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenchira-Thekkumuri B.",
            "Pincode": "680682",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alur.",
            "Pincode": "680683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avittathur",
            "Pincode": "680683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaduppassery South",
            "Pincode": "680683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallettumkara",
            "Pincode": "680683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karur",
            "Pincode": "680683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuzhikattusseri",
            "Pincode": "680683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullur",
            "Pincode": "680683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellanchira",
            "Pincode": "680683",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chembuchira",
            "Pincode": "680684",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodakara",
            "Pincode": "680684",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manakulangara",
            "Pincode": "680684",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattathurkunnu",
            "Pincode": "680684",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathilakam",
            "Pincode": "680685",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chakkarapadam",
            "Pincode": "680686",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perinjanam",
            "Pincode": "680686",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perinjanam West",
            "Pincode": "680686",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perinjanam West",
            "Pincode": "680686",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chamakkala",
            "Pincode": "680687",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chentrappinni",
            "Pincode": "680687",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chentrappinni East",
            "Pincode": "680687",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannampullipuram",
            "Pincode": "680687",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aripalam",
            "Pincode": "680688",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanakamala",
            "Pincode": "680689",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perambra Tcr",
            "Pincode": "680689",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koolimuttam",
            "Pincode": "680691",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattathur Trichur Edso",
            "Pincode": "680692",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellikulangara Edso",
            "Pincode": "680693",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muriyad Edso",
            "Pincode": "680694",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padiyam",
            "Pincode": "680695",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padiyur Edso",
            "Pincode": "680695",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaduppasserry Edso",
            "Pincode": "680698",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chokkana",
            "Pincode": "680699",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Murikkungal",
            "Pincode": "680699",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pady",
            "Pincode": "680699",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thanisserry",
            "Pincode": "680701",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellani",
            "Pincode": "680701",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karanchira",
            "Pincode": "680702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattoor",
            "Pincode": "680702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponjanam",
            "Pincode": "680702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponjanam",
            "Pincode": "680702",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edathuruthi",
            "Pincode": "680703",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhupillikkara Edso",
            "Pincode": "680704",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karalam",
            "Pincode": "680711",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvannur",
            "Pincode": "680711",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Murkanad",
            "Pincode": "680711",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madayikkonam",
            "Pincode": "680712",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chattikulam",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chayippankuzhi",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elinjipra",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjirapilly Trichur",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konnakuzhy",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttichira",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttikkad",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mothirakanni",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pariyaram Trichur",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poringalkuthu",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettilapara",
            "Pincode": "680721",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambalapara Tcr",
            "Pincode": "680723",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malakkappara",
            "Pincode": "680724",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodasseri Edso",
            "Pincode": "680725",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ashtamichira",
            "Pincode": "680731",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottamuri",
            "Pincode": "680732",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mala Thrisur",
            "Pincode": "680732",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallipuram Trichur",
            "Pincode": "680732",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Krishnagiri",
            "Pincode": "680733",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madathumpady",
            "Pincode": "680733",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poopathy",
            "Pincode": "680733",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poyya",
            "Pincode": "680733",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iranikulam",
            "Pincode": "680734",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuzhur",
            "Pincode": "680734",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuruvilassery Edso",
            "Pincode": "680735",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadama Edso",
            "Pincode": "680736",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alathur Trichur",
            "Pincode": "680741",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Annamanada",
            "Pincode": "680741",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palayamparambu",
            "Pincode": "680741",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovathusseri",
            "Pincode": "680741",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Asarikad",
            "Pincode": "680751",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayyappankavu",
            "Pincode": "680751",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulayam",
            "Pincode": "680751",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nadathara",
            "Pincode": "680751",
            "City": "Nadathara",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozhukully",
            "Pincode": "680752",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athani Trichur Edso",
            "Pincode": "680771",
            "City": "Thrissur",
            "District": "Thrissur",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochi",
            "Pincode": "682001",
            "City": "Kochi",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattancheri",
            "Pincode": "682002",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nazareth",
            "Pincode": "682002",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochi Naval Base",
            "Pincode": "682004",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palluruthy",
            "Pincode": "682005",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palluruthy Industrial Estate",
            "Pincode": "682006",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbalanghi",
            "Pincode": "682007",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbalanghi South",
            "Pincode": "682007",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Andikadavu.",
            "Pincode": "682008",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chellanam",
            "Pincode": "682008",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannamali",
            "Pincode": "682008",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sotuh Chellanam",
            "Pincode": "682008",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "North End",
            "Pincode": "682009",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Banerji Road",
            "Pincode": "682011",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ekm Hindi Prachar Sabha",
            "Pincode": "682011",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ernakulam Bazar",
            "Pincode": "682011",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ernakulam High Court",
            "Pincode": "682011",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pachalam",
            "Pincode": "682012",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thevara",
            "Pincode": "682013",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tatapuram",
            "Pincode": "682014",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumannur",
            "Pincode": "682015",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochi M G Road",
            "Pincode": "682016",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaloor",
            "Pincode": "682017",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vythila",
            "Pincode": "682019",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadavanthara",
            "Pincode": "682020",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bharatha Matha College",
            "Pincode": "682021",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thengode",
            "Pincode": "682021",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakode",
            "Pincode": "682021",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakode-Kailas Col",
            "Pincode": "682021",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochi University",
            "Pincode": "682022",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaduthala",
            "Pincode": "682023",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edapally",
            "Pincode": "682024",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edapally North",
            "Pincode": "682024",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palarivattom",
            "Pincode": "682025",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elamakkara",
            "Pincode": "682026",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittoor Eranakulam",
            "Pincode": "682027",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadamakudi",
            "Pincode": "682027",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kothad",
            "Pincode": "682027",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pizhala",
            "Pincode": "682027",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrikakara",
            "Pincode": "682028",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vennala",
            "Pincode": "682028",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Matsyapuri",
            "Pincode": "682029",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkanad",
            "Pincode": "682030",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkanad West",
            "Pincode": "682030",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kusumagiri",
            "Pincode": "682030",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Shanmughom Road",
            "Pincode": "682031",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallarpadam",
            "Pincode": "682031",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thammanam",
            "Pincode": "682032",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheranallur",
            "Pincode": "682034",
            "City": "Cheranallur",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ernakulam College",
            "Pincode": "682035",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panampilly Nagar",
            "Pincode": "682036",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochi Palace",
            "Pincode": "682301",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkumbhaghom",
            "Pincode": "682301",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tripunithura",
            "Pincode": "682301",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambalamukal",
            "Pincode": "682302",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambalamedu",
            "Pincode": "682303",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Brahmapuram",
            "Pincode": "682303",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maradu",
            "Pincode": "682304",
            "City": "Maradu",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Netttur",
            "Pincode": "682304",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadungamangalam",
            "Pincode": "682305",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kandanad",
            "Pincode": "682305",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kokkappilly",
            "Pincode": "682305",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kureekad",
            "Pincode": "682305",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mamala",
            "Pincode": "682305",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvankulam",
            "Pincode": "682305",
            "City": "Thiruvankulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eroor",
            "Pincode": "682306",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nadakav",
            "Pincode": "682307",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pothotta",
            "Pincode": "682307",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udayamperoor",
            "Pincode": "682307",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bhakthanadapuram",
            "Pincode": "682308",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meempara",
            "Pincode": "682308",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poothrika",
            "Pincode": "682308",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthencruz",
            "Pincode": "682308",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thruvaniyur",
            "Pincode": "682308",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadayampadi",
            "Pincode": "682308",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varikoli",
            "Pincode": "682308",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irmpanam",
            "Pincode": "682309",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaninad",
            "Pincode": "682310",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pancode",
            "Pincode": "682310",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadavucode",
            "Pincode": "682310",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadackanad",
            "Pincode": "682311",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadamattam",
            "Pincode": "682311",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadayirippu",
            "Pincode": "682311",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karukapally",
            "Pincode": "682311",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kinginimattom",
            "Pincode": "682311",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolencherry",
            "Pincode": "682311",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuzhiyara",
            "Pincode": "682312",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arakunnam",
            "Pincode": "682313",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirumarayoor",
            "Pincode": "682313",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulanthuruthy",
            "Pincode": "682314",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paingarapally",
            "Pincode": "682314",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumpilly",
            "Pincode": "682314",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulikamaly",
            "Pincode": "682314",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalcode",
            "Pincode": "682314",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettikkal",
            "Pincode": "682314",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amballoor",
            "Pincode": "682315",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chethicode",
            "Pincode": "682315",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjiramatoom",
            "Pincode": "682315",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulayettikkara",
            "Pincode": "682315",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marika",
            "Pincode": "682315",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnackal",
            "Pincode": "682316",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mekkadampu",
            "Pincode": "682316",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poonithura",
            "Pincode": "682317",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliyanadu Edso",
            "Pincode": "682319",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "South Paravoor Edso",
            "Pincode": "682320",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayyampilly",
            "Pincode": "682501",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edavanakad",
            "Pincode": "682502",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elamkunnapuzha",
            "Pincode": "682503",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulavukad",
            "Pincode": "682504",
            "City": "Mulavukad",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narakkal",
            "Pincode": "682505",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbalam",
            "Pincode": "682506",
            "City": "Kanayannur",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panagad Thevara",
            "Pincode": "682506",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundenveli",
            "Pincode": "682507",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ochanathuruthu",
            "Pincode": "682508",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthuvype",
            "Pincode": "682508",
            "City": "Kochi",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nayarambalam",
            "Pincode": "682509",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumangad",
            "Pincode": "682509",
            "City": "Nedumangad",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azhikkal",
            "Pincode": "682510",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malipuram",
            "Pincode": "682511",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Androth",
            "Pincode": "682551",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amini",
            "Pincode": "682552",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadamat",
            "Pincode": "682552",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Agathi",
            "Pincode": "682553",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chetlat",
            "Pincode": "682554",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bitra",
            "Pincode": "682555",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavaratti",
            "Pincode": "682555",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lakshdweep",
            "Pincode": "682555",
            "City": "Lakshdweep",
            "District": "Kavarathy",
            "State": "Lakshdweep"
        },
        {
            "PostOfficeName": "Lakshdweep",
            "Pincode": "682556",
            "City": "Lakshdweep",
            "District": "Kadarmath",
            "State": "Lakshdweep"
        },
        {
            "PostOfficeName": "Kalpeni",
            "Pincode": "682557",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lakshdweep",
            "Pincode": "682557",
            "City": "Lakshdweep",
            "District": "Kalpenthi",
            "State": "Lakshdweep"
        },
        {
            "PostOfficeName": "Kiltan",
            "Pincode": "682558",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lakshdweep",
            "Pincode": "682558",
            "City": "Lakshdweep",
            "District": "Kiltan",
            "State": "Lakshdweep"
        },
        {
            "PostOfficeName": "Minicoy",
            "Pincode": "682559",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lakshdweep",
            "Pincode": "682559",
            "City": "Lakshdweep",
            "District": "Minicoy",
            "State": "Lakshdweep"
        },
        {
            "PostOfficeName": "Aluva",
            "Pincode": "683101",
            "City": "Aluva",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Union Christian College",
            "Pincode": "683102",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "West Kadungallur",
            "Pincode": "683102",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aluva North",
            "Pincode": "683103",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Desom",
            "Pincode": "683103",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalamasseri",
            "Pincode": "683104",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rajagiri Edso",
            "Pincode": "683104",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "South Vazhakulam",
            "Pincode": "683105",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottumughom",
            "Pincode": "683105",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottumughom",
            "Pincode": "683105",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thaikkattukara",
            "Pincode": "683106",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marampally Edso",
            "Pincode": "683107",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakkattukara",
            "Pincode": "683108",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakkattukara",
            "Pincode": "683108",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uliyannur",
            "Pincode": "683108",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalamesseri Development",
            "Pincode": "683109",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muppathadam",
            "Pincode": "683110",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochi Air Port",
            "Pincode": "683111",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochi Airport",
            "Pincode": "683111",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjummel",
            "Pincode": "683501",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udyogamandal",
            "Pincode": "683501",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Binanipuram",
            "Pincode": "683502",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "H M T Colony",
            "Pincode": "683503",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttikattukara",
            "Pincode": "683504",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alangad",
            "Pincode": "683511",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karumallur",
            "Pincode": "683511",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neerikode",
            "Pincode": "683511",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panailkulam",
            "Pincode": "683511",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chendamangalam",
            "Pincode": "683512",
            "City": "Chendamangalam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elanthikara",
            "Pincode": "683512",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuthiathode Ekm",
            "Pincode": "683512",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenvelikara",
            "Pincode": "683512",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nanthiattukunnam",
            "Pincode": "683513",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parur",
            "Pincode": "683513",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherai",
            "Pincode": "683514",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palliport",
            "Pincode": "683515",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maliyankara",
            "Pincode": "683516",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moothakunnam",
            "Pincode": "683516",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varapuzha",
            "Pincode": "683517",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varapuzha Landing",
            "Pincode": "683517",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koonammavu",
            "Pincode": "683518",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaitharam",
            "Pincode": "683519",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannam Parur",
            "Pincode": "683520",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thathappilly",
            "Pincode": "683520",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkumpuram",
            "Pincode": "683521",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunjithai",
            "Pincode": "683522",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkekara",
            "Pincode": "683522",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Gothuruthy Edso",
            "Pincode": "683523",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnukara Edso",
            "Pincode": "683524",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kongorpilly Edso",
            "Pincode": "683525",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Airapuram",
            "Pincode": "683541",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezhilam",
            "Pincode": "683541",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulluvazhi",
            "Pincode": "683541",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumbavoor",
            "Pincode": "683542",
            "City": "Perumbavoor",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rayonpuram",
            "Pincode": "683543",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aimurikara",
            "Pincode": "683544",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alattil",
            "Pincode": "683544",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheranalloor",
            "Pincode": "683544",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edavoor",
            "Pincode": "683544",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ilambakapally",
            "Pincode": "683544",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodanad",
            "Pincode": "683544",
            "City": "Kunnathunad",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koovappady",
            "Pincode": "683544",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aruvappara",
            "Pincode": "683545",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuruppampady",
            "Pincode": "683545",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Methala",
            "Pincode": "683545",
            "City": "Methala",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedungapra",
            "Pincode": "683545",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rayamangalam",
            "Pincode": "683545",
            "City": "Kunnathunad",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuruthi Ekm",
            "Pincode": "683545",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Choondakuzhy",
            "Pincode": "683546",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudakuzha",
            "Pincode": "683546",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paniely",
            "Pincode": "683546",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengoor",
            "Pincode": "683546",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudickal",
            "Pincode": "683547",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponjassery",
            "Pincode": "683547",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iringole",
            "Pincode": "683548",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Asamannur",
            "Pincode": "683549",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaikara",
            "Pincode": "683549",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Okkal",
            "Pincode": "683550",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Allapra Edso",
            "Pincode": "683553",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengola",
            "Pincode": "683554",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valayanchirangara",
            "Pincode": "683556",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengola West",
            "Pincode": "683556",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikalathur Edso",
            "Pincode": "683557",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edathala",
            "Pincode": "683561",
            "City": "Edathala",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malayidamthuruth",
            "Pincode": "683561",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilangu",
            "Pincode": "683561",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhakkampalam",
            "Pincode": "683562",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattimattom",
            "Pincode": "683562",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naval Armament Depot.",
            "Pincode": "683563",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edathala North",
            "Pincode": "683564",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumarapuram",
            "Pincode": "683565",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhamthottam",
            "Pincode": "683565",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringala",
            "Pincode": "683565",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vempilly",
            "Pincode": "683565",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chowwera",
            "Pincode": "683571",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angamally",
            "Pincode": "683572",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elavoor",
            "Pincode": "683572",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kidangoor",
            "Pincode": "683572",
            "City": "Meenachil",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nayathode",
            "Pincode": "683572",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puliyanam",
            "Pincode": "683572",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vappalassery",
            "Pincode": "683572",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angamally South",
            "Pincode": "683573",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaladi",
            "Pincode": "683574",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manickamangalam",
            "Pincode": "683574",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattoor",
            "Pincode": "683574",
            "City": "Aluva",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Piraroor",
            "Pincode": "683574",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjoor",
            "Pincode": "683575",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuravankara",
            "Pincode": "683575",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karukutty",
            "Pincode": "683576",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azhakam",
            "Pincode": "683577",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mookkannur",
            "Pincode": "683577",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thabore",
            "Pincode": "683577",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengamanad",
            "Pincode": "683578",
            "City": "Chengamanad",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "South Advassey",
            "Pincode": "683578",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Airoor",
            "Pincode": "683579",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumasseri",
            "Pincode": "683579",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parakadavu",
            "Pincode": "683579",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattaparampu",
            "Pincode": "683579",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sreemoolanagaram",
            "Pincode": "683580",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellarappilly South",
            "Pincode": "683580",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anappara Kaladi",
            "Pincode": "683581",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayyampuzha",
            "Pincode": "683581",
            "City": "Aluva",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chully",
            "Pincode": "683581",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjappara",
            "Pincode": "683581",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paduvapuram",
            "Pincode": "683582",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaladi Plantation",
            "Pincode": "683583",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neeleshwaram Edso",
            "Pincode": "683584",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athani",
            "Pincode": "683585",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumbasseri",
            "Pincode": "683585",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuravoor",
            "Pincode": "683586",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malayattoor",
            "Pincode": "683587",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malayattoor",
            "Pincode": "683587",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malayattur Edso",
            "Pincode": "683587",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mekkad Edso",
            "Pincode": "683589",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parapuram Edso",
            "Pincode": "683593",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenveli",
            "Pincode": "683594",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenveli Edso",
            "Pincode": "683594",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thazhathangadi",
            "Pincode": "685005",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chinnar",
            "Pincode": "685501",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elappara",
            "Pincode": "685501",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Hailey Buria",
            "Pincode": "685501",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochu Karintharuvi",
            "Pincode": "685501",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheenthalar",
            "Pincode": "685502",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pasupara",
            "Pincode": "685502",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottamala",
            "Pincode": "685503",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vagamon",
            "Pincode": "685503",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Fairfield",
            "Pincode": "685504",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolahalamedu",
            "Pincode": "685504",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lonetree",
            "Pincode": "685505",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathaipara",
            "Pincode": "685505",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattuthavalam",
            "Pincode": "685505",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Upputhara",
            "Pincode": "685505",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimkulam Chapath",
            "Pincode": "685506",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayyappancoil",
            "Pincode": "685507",
            "City": "#N/A",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalthotty",
            "Pincode": "685507",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattapana",
            "Pincode": "685508",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amaravathy",
            "Pincode": "685509",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Attappallam",
            "Pincode": "685509",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chakkuppallam",
            "Pincode": "685509",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chellarcoil",
            "Pincode": "685509",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumily",
            "Pincode": "685509",
            "City": "#N/A",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Spring Valley",
            "Pincode": "685509",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bethel",
            "Pincode": "685510",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chempakapara",
            "Pincode": "685510",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Erattayar North",
            "Pincode": "685510",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Idinjamala",
            "Pincode": "685510",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochuthovala",
            "Pincode": "685510",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melekumppachampady",
            "Pincode": "685510",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Santhigram",
            "Pincode": "685510",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uppukandam",
            "Pincode": "685510",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiyathovala",
            "Pincode": "685510",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanchiyar",
            "Pincode": "685511",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nariyampara",
            "Pincode": "685511",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thoppipals",
            "Pincode": "685511",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thovarayar",
            "Pincode": "685511",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thovarayar",
            "Pincode": "685511",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakkara Edso",
            "Pincode": "685512",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anniyartholu",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Calvary Mount",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadamakuzhi",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kamakshy",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattapana South",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konnackamali",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marygiri",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulakaramedu",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellipara",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padamugham",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandipara",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumthotty",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Prakash",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puliyanmala",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thankamony",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thopramgudy",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thopramgudy",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhavara",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellayamkudy",
            "Pincode": "685515",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Glenmary",
            "Pincode": "685531",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karadikuzhi",
            "Pincode": "685531",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttikanam",
            "Pincode": "685531",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lakshmicoil",
            "Pincode": "685531",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallikunnu",
            "Pincode": "685531",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peermade",
            "Pincode": "685531",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanayankavayal",
            "Pincode": "685532",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meloram",
            "Pincode": "685532",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Murinjapuzha",
            "Pincode": "685532",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paloorkave",
            "Pincode": "685532",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paloorkave Central",
            "Pincode": "685532",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peruvanthanam",
            "Pincode": "685532",
            "City": "#N/A",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arnakal",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chottupara Vandiperiyar",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Dymock",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Gavi",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Gramby",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keerikara",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mavadi",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moongalar",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mount",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pachakanam",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pampa Dam",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallakkadavoo",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vandiperiyar",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Wallardie",
            "Pincode": "685533",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anavilasam",
            "Pincode": "685535",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Murukady",
            "Pincode": "685535",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sasthanoda",
            "Pincode": "685535",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellaramkunnu",
            "Pincode": "685535",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Periyar Dam",
            "Pincode": "685536",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkady",
            "Pincode": "685536",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pambanar Edso",
            "Pincode": "685537",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thengakal Edso",
            "Pincode": "685538",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chenkara Edso",
            "Pincode": "685539",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cumbumettu",
            "Pincode": "685551",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochara",
            "Pincode": "685551",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuzhithozhu",
            "Pincode": "685551",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mali",
            "Pincode": "685551",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nettithozhu",
            "Pincode": "685551",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pampupara",
            "Pincode": "685551",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puttady",
            "Pincode": "685551",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rajakandam",
            "Pincode": "685551",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vandanmettu",
            "Pincode": "685551",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Balagram",
            "Pincode": "685552",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chottupara Kallar",
            "Pincode": "685552",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Combayar",
            "Pincode": "685552",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallar",
            "Pincode": "685552",
            "City": "#N/A",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karunapuram",
            "Pincode": "685552",
            "City": "Udumbanchola",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pushpakadnom",
            "Pincode": "685552",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramakkalmettu",
            "Pincode": "685552",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sanniasioda",
            "Pincode": "685552",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chembalam",
            "Pincode": "685553",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ezhukumavayal",
            "Pincode": "685553",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kailasanadu",
            "Pincode": "685553",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjappara",
            "Pincode": "685553",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumkandam",
            "Pincode": "685553",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pachady",
            "Pincode": "685553",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chathurangapara",
            "Pincode": "685554",
            "City": "Udumbanchola",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemmannar",
            "Pincode": "685554",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukkudi",
            "Pincode": "685554",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udumbanchola",
            "Pincode": "685554",
            "City": "#N/A",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pampadumpara Edso",
            "Pincode": "685556",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koottar",
            "Pincode": "685557",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adimaly",
            "Pincode": "685561",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anaveratty",
            "Pincode": "685561",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koompanpara",
            "Pincode": "685561",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Korangatty",
            "Pincode": "685561",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Machiplavu",
            "Pincode": "685561",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannamkandam",
            "Pincode": "685561",
            "City": "Devikulam",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padicap",
            "Pincode": "685561",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valara",
            "Pincode": "685561",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallarkutty",
            "Pincode": "685562",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankuva",
            "Pincode": "685562",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perinchankutty",
            "Pincode": "685562",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "South Kathipara",
            "Pincode": "685562",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheepunkal",
            "Pincode": "685563",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konnathady",
            "Pincode": "685563",
            "City": "Udumbanchola",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Seliampara",
            "Pincode": "685563",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellathooval",
            "Pincode": "685563",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muriyara",
            "Pincode": "685564",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panickankudy",
            "Pincode": "685564",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponmudi",
            "Pincode": "685564",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakulam",
            "Pincode": "685565",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bison Valley",
            "Pincode": "685565",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chithirapuram",
            "Pincode": "685565",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ellackal",
            "Pincode": "685565",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Josegiri",
            "Pincode": "685565",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunhitanni",
            "Pincode": "685565",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankulam",
            "Pincode": "685565",
            "City": "Devikulam",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meencut",
            "Pincode": "685565",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallivasal",
            "Pincode": "685565",
            "City": "Devikulam",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallivasal",
            "Pincode": "685565",
            "City": "Devikulam",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sengulam",
            "Pincode": "685565",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thokkupara",
            "Pincode": "685565",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemmannar Kuthumkal",
            "Pincode": "685566",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mammattikanam",
            "Pincode": "685566",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "N.R.City",
            "Pincode": "685566",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rajakad",
            "Pincode": "685566",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pottenkad Edso",
            "Pincode": "685569",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parathode Idukky Edso",
            "Pincode": "685571",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheenikuzhi",
            "Pincode": "685581",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheppukulam",
            "Pincode": "685581",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimannur",
            "Pincode": "685581",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malayinchi",
            "Pincode": "685581",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moolakad",
            "Pincode": "685581",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulappuram",
            "Pincode": "685581",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neyyasseri",
            "Pincode": "685581",
            "City": "Thodupuzha",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pannor",
            "Pincode": "685581",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringasseri",
            "Pincode": "685581",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattakuzha",
            "Pincode": "685581",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thommankuthu",
            "Pincode": "685581",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaliyar",
            "Pincode": "685582",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodikulam",
            "Pincode": "685582",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koduvely",
            "Pincode": "685582",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mullaringad",
            "Pincode": "685582",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundanmudi",
            "Pincode": "685582",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parapuzha",
            "Pincode": "685582",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulickathotty",
            "Pincode": "685582",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vandamattam",
            "Pincode": "685582",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vannapuram",
            "Pincode": "685582",
            "City": "Thodupuzha",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "West Kodikulam",
            "Pincode": "685582",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuninji",
            "Pincode": "685583",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Purapuzha",
            "Pincode": "685583",
            "City": "Thodupuzha",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhithala",
            "Pincode": "685583",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arikuzha",
            "Pincode": "685584",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaloor East",
            "Pincode": "685584",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolani",
            "Pincode": "685584",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mailacombu",
            "Pincode": "685584",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manakad",
            "Pincode": "685584",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nediyassala",
            "Pincode": "685584",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thodupuzha Puthupariyaram",
            "Pincode": "685584",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengallur",
            "Pincode": "685584",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anchiri",
            "Pincode": "685585",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkumbhaghom",
            "Pincode": "685585",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thodupuzha East",
            "Pincode": "685585",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimkunnam",
            "Pincode": "685586",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ottalloor",
            "Pincode": "685586",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattarathatta",
            "Pincode": "685586",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkumuri",
            "Pincode": "685586",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ellumpuram",
            "Pincode": "685587",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mrala",
            "Pincode": "685587",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttom Ek",
            "Pincode": "685587",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thudanganad",
            "Pincode": "685587",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alakode",
            "Pincode": "685588",
            "City": "Taliparamba",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chilavu",
            "Pincode": "685588",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Devarupara",
            "Pincode": "685588",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edavatty",
            "Pincode": "685588",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elambulasseri",
            "Pincode": "685588",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalayanthani",
            "Pincode": "685588",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koovakandam",
            "Pincode": "685588",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pannimattom",
            "Pincode": "685588",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ilapilly",
            "Pincode": "685589",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannickal",
            "Pincode": "685589",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moolamattom",
            "Pincode": "685589",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moolamattom East",
            "Pincode": "685589",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathipally",
            "Pincode": "685589",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adoormala",
            "Pincode": "685590",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koovapally Kudayathur",
            "Pincode": "685590",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arakulam",
            "Pincode": "685591",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjar Edso",
            "Pincode": "685592",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udumbannur Edso",
            "Pincode": "685595",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumaramangalam Edso",
            "Pincode": "685597",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kariplangadu",
            "Pincode": "685601",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulamavu",
            "Pincode": "685601",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alpara",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelachuvadu",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Idukki Colony",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjikuzhi Idukky",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keerithode",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manippara",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maniyarangudi",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mariyapuram",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narakakkanam",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nayarupara",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhayarikandam",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rajamudi",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rajapuram",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thadiyampad",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattekanni",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Upputhode",
            "Pincode": "685602",
            "City": "Udumbanchola",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venmony Idukki",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vimalagiri",
            "Pincode": "685602",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Idukki Painavu",
            "Pincode": "685603",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Murikkassery",
            "Pincode": "685604",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ezhumuttom",
            "Pincode": "685605",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthalakodam",
            "Pincode": "685605",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumpilliche",
            "Pincode": "685605",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattiar Edso",
            "Pincode": "685611",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Gudarale",
            "Pincode": "685612",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Munnar Kerala",
            "Pincode": "685612",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallivasal Estate",
            "Pincode": "685612",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anayirankal",
            "Pincode": "685613",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Devicolam",
            "Pincode": "685613",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chattamannar",
            "Pincode": "685614",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Talliar",
            "Pincode": "685614",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ellapatti",
            "Pincode": "685615",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottakamboor",
            "Pincode": "685615",
            "City": "Devikulam",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koviloor",
            "Pincode": "685615",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattupatti Indo Swiss Project",
            "Pincode": "685616",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sethuparvathipuram",
            "Pincode": "685617",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chinnakanal",
            "Pincode": "685618",
            "City": "Udumbanchola",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Surianalle",
            "Pincode": "685618",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aruvulanchal",
            "Pincode": "685619",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjanapara",
            "Pincode": "685619",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulaparachal",
            "Pincode": "685619",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pethotty",
            "Pincode": "685619",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poopara",
            "Pincode": "685619",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthady",
            "Pincode": "685619",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rajakumari",
            "Pincode": "685619",
            "City": "Udumbanchola",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rajakumari South",
            "Pincode": "685619",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Santhanpara",
            "Pincode": "685619",
            "City": "#N/A",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Senapathy",
            "Pincode": "685619",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattapara Udumbanchola",
            "Pincode": "685619",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanthallur",
            "Pincode": "685620",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maraiyur",
            "Pincode": "685620",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Michelgiri",
            "Pincode": "685620",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pius Nagar",
            "Pincode": "685620",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sahayagiri",
            "Pincode": "685620",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panniar Estate Edso",
            "Pincode": "685621",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottayam",
            "Pincode": "686001",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottayam Collectorate",
            "Pincode": "686002",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottayam West",
            "Pincode": "686003",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttambalam",
            "Pincode": "686004",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nattassery S.H.Mount",
            "Pincode": "686006",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallom",
            "Pincode": "686007",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arpookaara East",
            "Pincode": "686008",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arpookara",
            "Pincode": "686008",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Gandhi Nagar Kottayam",
            "Pincode": "686008",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Villoonni",
            "Pincode": "686008",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rubber Board",
            "Pincode": "686009",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadavathoor",
            "Pincode": "686010",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthupally",
            "Pincode": "686011",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrikothamangalam",
            "Pincode": "686011",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pakkil",
            "Pincode": "686012",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovanthuruthu Edso",
            "Pincode": "686012",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olassa",
            "Pincode": "686014",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aymanam",
            "Pincode": "686015",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulikuttisseri",
            "Pincode": "686015",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumaranallur",
            "Pincode": "686016",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thellakam",
            "Pincode": "686016",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudamaloor",
            "Pincode": "686017",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manganam",
            "Pincode": "686018",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manarcaud",
            "Pincode": "686019",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kiliroor North",
            "Pincode": "686020",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pariyaram",
            "Pincode": "686021",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengalam South",
            "Pincode": "686022",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mariapally",
            "Pincode": "686023",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parippu",
            "Pincode": "686024",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amayannur Edso",
            "Pincode": "686025",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moolavattom",
            "Pincode": "686026",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumbaikad",
            "Pincode": "686028",
            "City": "Perumbaikad",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kollad",
            "Pincode": "686029",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjiram",
            "Pincode": "686030",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parampuzha",
            "Pincode": "686032",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvarpu",
            "Pincode": "686033",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payyapady Edso",
            "Pincode": "686034",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kummanam",
            "Pincode": "686035",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amalagiri Edso",
            "Pincode": "686036",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvanchoor",
            "Pincode": "686037",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Devalokom Edso",
            "Pincode": "686038",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malloosery",
            "Pincode": "686041",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnamkeri",
            "Pincode": "686102",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panachikavu",
            "Pincode": "686102",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perunna",
            "Pincode": "686102",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumarankary",
            "Pincode": "686103",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ruby Nagar",
            "Pincode": "686103",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhapally West",
            "Pincode": "686103",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurisummood",
            "Pincode": "686104",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veroor",
            "Pincode": "686104",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottamurickal",
            "Pincode": "686105",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrikodithanam",
            "Pincode": "686105",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheeranchira Ind. Nagar",
            "Pincode": "686106",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aruvithura",
            "Pincode": "686122",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thidanad",
            "Pincode": "686123",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nadackal",
            "Pincode": "686124",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaikom",
            "Pincode": "686141",
            "City": "Vaikom",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaikaprayar",
            "Pincode": "686142",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaikom Thekkenada",
            "Pincode": "686142",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Akkarapadam",
            "Pincode": "686143",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Udayanapuram",
            "Pincode": "686143",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambika Market",
            "Pincode": "686144",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudavechoor",
            "Pincode": "686144",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vechoor",
            "Pincode": "686144",
            "City": "Vaikom",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakom Edso",
            "Pincode": "686145",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakom Edso",
            "Pincode": "686145",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Areeparambu Edso",
            "Pincode": "686501",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velloor",
            "Pincode": "686501",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kooropada Edso",
            "Pincode": "686502",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kothala",
            "Pincode": "686502",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lakkattoor",
            "Pincode": "686502",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pampady",
            "Pincode": "686502",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pangada",
            "Pincode": "686502",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pothenpuram",
            "Pincode": "686502",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Surianarayanapuram",
            "Pincode": "686502",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anickad",
            "Pincode": "686503",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anickad East",
            "Pincode": "686503",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anickad West",
            "Pincode": "686503",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aruvikuzhi",
            "Pincode": "686503",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elampally",
            "Pincode": "686503",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalloorkulam",
            "Pincode": "686503",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manalumkal",
            "Pincode": "686503",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mozhoor",
            "Pincode": "686503",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhoor",
            "Pincode": "686504",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhoor East",
            "Pincode": "686504",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Theerthapadapuram",
            "Pincode": "686505",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nariyanani",
            "Pincode": "686506",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponkunnam Courts",
            "Pincode": "686506",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponkunnam Kottayam",
            "Pincode": "686506",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thambalakad",
            "Pincode": "686506",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakkal",
            "Pincode": "686507",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjirapally",
            "Pincode": "686507",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kidangara",
            "Pincode": "686507",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannarkayam",
            "Pincode": "686507",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chettuthode",
            "Pincode": "686508",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalaketty",
            "Pincode": "686508",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kappadu",
            "Pincode": "686508",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vanchimala",
            "Pincode": "686508",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanakapalam",
            "Pincode": "686509",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannimala",
            "Pincode": "686509",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuruvamoozhy",
            "Pincode": "686509",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Propose",
            "Pincode": "686509",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chathanthara",
            "Pincode": "686510",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanamala",
            "Pincode": "686510",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukkottuthara",
            "Pincode": "686510",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttappally",
            "Pincode": "686510",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pampa Valley North",
            "Pincode": "686510",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thulapally",
            "Pincode": "686510",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venkurinji",
            "Pincode": "686510",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnam Veechoochira",
            "Pincode": "686511",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannadissala",
            "Pincode": "686511",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Inchiyani",
            "Pincode": "686512",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parathode",
            "Pincode": "686512",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Urakanadu",
            "Pincode": "686512",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vengathanam",
            "Pincode": "686512",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karinilam",
            "Pincode": "686513",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koruthode",
            "Pincode": "686513",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuppakayam",
            "Pincode": "686513",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madukka",
            "Pincode": "686513",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundakayam",
            "Pincode": "686513",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundakayam East Edso",
            "Pincode": "686513",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punchvayal",
            "Pincode": "686513",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rajendraprasad Colony",
            "Pincode": "686513",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elankad",
            "Pincode": "686514",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Erattayar Edso",
            "Pincode": "686514",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koottickal",
            "Pincode": "686514",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukkulam",
            "Pincode": "686514",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parathanam",
            "Pincode": "686514",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalunkal",
            "Pincode": "686514",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velanilam",
            "Pincode": "686514",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Wembly",
            "Pincode": "686514",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanam",
            "Pincode": "686515",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulikkakavala",
            "Pincode": "686515",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meenadom",
            "Pincode": "686516",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattakunnu",
            "Pincode": "686516",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chakompathai",
            "Pincode": "686517",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koovapally",
            "Pincode": "686518",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palampra",
            "Pincode": "686518",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panachappally",
            "Pincode": "686518",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chirakadavu Centre",
            "Pincode": "686519",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavumbagam",
            "Pincode": "686519",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkethukavala",
            "Pincode": "686519",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chenapadi",
            "Pincode": "686520",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chirakadavu",
            "Pincode": "686520",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chirakadavu East",
            "Pincode": "686520",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhayadom",
            "Pincode": "686520",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pampady South",
            "Pincode": "686521",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poothakuzhy",
            "Pincode": "686521",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koorali",
            "Pincode": "686522",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panamattom",
            "Pincode": "686522",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panamkutty",
            "Pincode": "686522",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozhuvanal",
            "Pincode": "686523",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittadi Edso",
            "Pincode": "686524",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vizhikkithode Edso",
            "Pincode": "686527",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemmalamattom Edso",
            "Pincode": "686529",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengavanam",
            "Pincode": "686531",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathamuttom",
            "Pincode": "686532",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sachivothamapuram",
            "Pincode": "686532",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuzhimattom",
            "Pincode": "686533",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eara North",
            "Pincode": "686534",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Era North",
            "Pincode": "686534",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Erathuvadakara",
            "Pincode": "686534",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kainady",
            "Pincode": "686534",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neelamperoor",
            "Pincode": "686534",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ithithanam",
            "Pincode": "686535",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuruthy",
            "Pincode": "686535",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumbanadom",
            "Pincode": "686536",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumpanachy",
            "Pincode": "686536",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallickachirakvala",
            "Pincode": "686537",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nalumnakkal",
            "Pincode": "686538",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pongathanam",
            "Pincode": "686538",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenchantha",
            "Pincode": "686538",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vakathanam",
            "Pincode": "686538",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakkad",
            "Pincode": "686539",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakkad",
            "Pincode": "686539",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakkad West",
            "Pincode": "686539",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakkad West",
            "Pincode": "686539",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Umbidi",
            "Pincode": "686539",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Champakara",
            "Pincode": "686540",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelacombu",
            "Pincode": "686540",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karukachal",
            "Pincode": "686540",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koothrappally",
            "Pincode": "686540",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edayirkkapuzha",
            "Pincode": "686541",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kangazha",
            "Pincode": "686541",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulathuprayar",
            "Pincode": "686541",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundathanam",
            "Pincode": "686541",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thazhatthuvadkara",
            "Pincode": "686541",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellavoor",
            "Pincode": "686541",
            "City": "Changanassery",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manthuruthy",
            "Pincode": "686542",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumanny",
            "Pincode": "686542",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumkunnam",
            "Pincode": "686542",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruvally",
            "Pincode": "686543",
            "City": "Kanjirappally",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manimala",
            "Pincode": "686543",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alapra",
            "Pincode": "686544",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikkattur",
            "Pincode": "686544",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikkattur Centre",
            "Pincode": "686544",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukkada",
            "Pincode": "686544",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponthampuzha",
            "Pincode": "686544",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovathode",
            "Pincode": "686544",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulikallu",
            "Pincode": "686544",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedungadapally",
            "Pincode": "686545",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Santhipuram",
            "Pincode": "686545",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amara.",
            "Pincode": "686546",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madappally",
            "Pincode": "686546",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chungapara",
            "Pincode": "686547",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottangal",
            "Pincode": "686547",
            "City": "Mallappally",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nalukody",
            "Pincode": "686548",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurichi Edso",
            "Pincode": "686549",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadayanikad Edso",
            "Pincode": "686550",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malakunnam Esdo",
            "Pincode": "686552",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malam",
            "Pincode": "686552",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mammoodu Edso",
            "Pincode": "686553",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Devagiri",
            "Pincode": "686555",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjirapara",
            "Pincode": "686555",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Priyadarshini Hills",
            "Pincode": "686560",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannam",
            "Pincode": "686561",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athirampuzha",
            "Pincode": "686562",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukkudam",
            "Pincode": "686562",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sreekantamangalam",
            "Pincode": "686562",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumarakom",
            "Pincode": "686563",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumarakom East",
            "Pincode": "686563",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumarakom South",
            "Pincode": "686563",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayarkunnam",
            "Pincode": "686564",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimpani",
            "Pincode": "686564",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kongandoor",
            "Pincode": "686564",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattakara",
            "Pincode": "686564",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mullarikudy",
            "Pincode": "686564",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neerikad",
            "Pincode": "686564",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paduva",
            "Pincode": "686564",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumarakom North Edso",
            "Pincode": "686566",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arumanur Edso",
            "Pincode": "686568",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadaplamattom",
            "Pincode": "686571",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padinjattinkara",
            "Pincode": "686571",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattachira",
            "Pincode": "686572",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kidangoor",
            "Pincode": "686572",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puliyannur",
            "Pincode": "686573",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thodanal",
            "Pincode": "686573",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arunapuram",
            "Pincode": "686574",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chakampuzha",
            "Pincode": "686574",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadapattoor",
            "Pincode": "686574",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhathadiyoor",
            "Pincode": "686574",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundankal",
            "Pincode": "686574",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nechipuzoor",
            "Pincode": "686574",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velliapally",
            "Pincode": "686574",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palai",
            "Pincode": "686575",
            "City": "Palai",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amanakara.",
            "Pincode": "686576",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Idiyanal",
            "Pincode": "686576",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhithiri",
            "Pincode": "686576",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koodapalam",
            "Pincode": "686576",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurinji",
            "Pincode": "686576",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mediri",
            "Pincode": "686576",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramapuram Bazar",
            "Pincode": "686576",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elikulam",
            "Pincode": "686577",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madukkakunnu",
            "Pincode": "686577",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mallikasseri",
            "Pincode": "686577",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Njandupara",
            "Pincode": "686577",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovarani",
            "Pincode": "686577",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bharanaganam",
            "Pincode": "686578",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edapady",
            "Pincode": "686578",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhaparayar",
            "Pincode": "686578",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anjoottimangalam",
            "Pincode": "686579",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalathukadavu",
            "Pincode": "686579",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narianganam",
            "Pincode": "686579",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Plassanal",
            "Pincode": "686579",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adukom",
            "Pincode": "686580",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Teekoy",
            "Pincode": "686580",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalanad",
            "Pincode": "686580",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velathusseri",
            "Pincode": "686580",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellikulam",
            "Pincode": "686580",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chennad",
            "Pincode": "686581",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poonjar",
            "Pincode": "686581",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adivaram",
            "Pincode": "686582",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cholathadam P.O",
            "Pincode": "686582",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kainoor",
            "Pincode": "686582",
            "City": "Thrissur",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnam",
            "Pincode": "686582",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringalam",
            "Pincode": "686582",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poonjar Thekkekra",
            "Pincode": "686582",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kidangoor South",
            "Pincode": "686583",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnahtura",
            "Pincode": "686583",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chempilavu",
            "Pincode": "686584",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherpunkal",
            "Pincode": "686584",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhavankulam",
            "Pincode": "686584",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengalam",
            "Pincode": "686585",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjiramattom Kottaym",
            "Pincode": "686585",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chovvoor",
            "Pincode": "686586",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mechal",
            "Pincode": "686586",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moonnilavu",
            "Pincode": "686586",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayala",
            "Pincode": "686587",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Idamattom Edso",
            "Pincode": "686588",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velliamattom",
            "Pincode": "686588",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meenachil",
            "Pincode": "686589",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponad Karur",
            "Pincode": "686590",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramapuram Edso",
            "Pincode": "686591",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallichira Edso",
            "Pincode": "686592",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melampara Edso",
            "Pincode": "686594",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koodallur Edso",
            "Pincode": "686595",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattukulam Edso",
            "Pincode": "686596",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mutholy",
            "Pincode": "686597",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathampuzha Edso",
            "Pincode": "686600",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moozhikulangara",
            "Pincode": "686601",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neendoor",
            "Pincode": "686601",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaipuzha",
            "Pincode": "686602",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Onamthuruthu",
            "Pincode": "686602",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chamakala",
            "Pincode": "686603",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjirathanam",
            "Pincode": "686603",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuruppanthara",
            "Pincode": "686603",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjoor",
            "Pincode": "686603",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjoor South",
            "Pincode": "686603",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arunoottimangalam",
            "Pincode": "686604",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaduthuruthy",
            "Pincode": "686604",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puzhikol",
            "Pincode": "686604",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edavattom",
            "Pincode": "686605",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irumpayam",
            "Pincode": "686605",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karipadam",
            "Pincode": "686605",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezhoor",
            "Pincode": "686605",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Midayikunnu",
            "Pincode": "686605",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thaayolaparambu",
            "Pincode": "686605",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakara",
            "Pincode": "686605",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadayar",
            "Pincode": "686605",
            "City": "Vaikom",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemmanattukara",
            "Pincode": "686606",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallipurathussery",
            "Pincode": "686606",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirumonivenkitapuram",
            "Pincode": "686606",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kothavara",
            "Pincode": "686607",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalayazhom",
            "Pincode": "686607",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Enadi",
            "Pincode": "686608",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulasekharamangalam",
            "Pincode": "686608",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maravanthuruthu",
            "Pincode": "686608",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mevalloor",
            "Pincode": "686609",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikode",
            "Pincode": "686610",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulakulam South",
            "Pincode": "686610",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peruva",
            "Pincode": "686610",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallara Kottayam",
            "Pincode": "686611",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallara South",
            "Pincode": "686611",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumthuruthu",
            "Pincode": "686611",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattampauk",
            "Pincode": "686612",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marangoli",
            "Pincode": "686612",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Njizhoor",
            "Pincode": "686612",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvambadi",
            "Pincode": "686612",
            "City": "Kozhikode",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkenirappu",
            "Pincode": "686612",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayamkudi",
            "Pincode": "686613",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ezhumanthuruthu",
            "Pincode": "686613",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kappumthala",
            "Pincode": "686613",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttuchira",
            "Pincode": "686613",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chempu Edso",
            "Pincode": "686615",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Newsprint Nagar",
            "Pincode": "686616",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Memuri Edso",
            "Pincode": "686617",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mevada",
            "Pincode": "686620",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattithanam",
            "Pincode": "686631",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnahtura West",
            "Pincode": "686631",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettimukal",
            "Pincode": "686631",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanakari",
            "Pincode": "686632",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kothanalloor",
            "Pincode": "686632",
            "City": "Vaikom",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumallur Edso",
            "Pincode": "686632",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalathur",
            "Pincode": "686633",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuravilangad",
            "Pincode": "686633",
            "City": "#N/A",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannackanad",
            "Pincode": "686633",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nazareth Hill",
            "Pincode": "686633",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vempally",
            "Pincode": "686633",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurichithanam",
            "Pincode": "686634",
            "City": "Meenachil",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ozhavur",
            "Pincode": "686634",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ozhavur East",
            "Pincode": "686634",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadukachira",
            "Pincode": "686635",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marangattupally",
            "Pincode": "686635",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakkattumala",
            "Pincode": "686635",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valavoor",
            "Pincode": "686635",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurianad",
            "Pincode": "686636",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Monipally",
            "Pincode": "686636",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pius Mount",
            "Pincode": "686636",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vakkad",
            "Pincode": "686636",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliyannur Edso",
            "Pincode": "686638",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozha Edso",
            "Pincode": "686640",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthuveli Edso",
            "Pincode": "686641",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pakalomattom",
            "Pincode": "686642",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alanad",
            "Pincode": "686651",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anthinad",
            "Pincode": "686651",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayoor",
            "Pincode": "686651",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodumpidi",
            "Pincode": "686651",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mattathipara",
            "Pincode": "686651",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neeloor",
            "Pincode": "686651",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payappar",
            "Pincode": "686651",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pravithanam",
            "Pincode": "686651",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ullanad",
            "Pincode": "686651",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhakkanmattom",
            "Pincode": "686652",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konipadu",
            "Pincode": "686652",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maryland",
            "Pincode": "686652",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melukavu",
            "Pincode": "686652",
            "City": "Meenachil",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melukavumattom",
            "Pincode": "686652",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadanad Meenachil",
            "Pincode": "686653",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumannu Edso",
            "Pincode": "686654",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pizhaku",
            "Pincode": "686655",
            "City": "Kottayam",
            "District": "Kottayam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muvattupuzha",
            "Pincode": "686661",
            "City": "Muvattupuzha",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edayar",
            "Pincode": "686662",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkoor",
            "Pincode": "686662",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karamala",
            "Pincode": "686662",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimpana",
            "Pincode": "686662",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhakombu",
            "Pincode": "686662",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koothattukulam",
            "Pincode": "686662",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhmuri",
            "Pincode": "686663",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mamalassery",
            "Pincode": "686663",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ramangalam",
            "Pincode": "686663",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkad Piravom",
            "Pincode": "686664",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalampoor",
            "Pincode": "686664",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulakulam",
            "Pincode": "686664",
            "City": "Vaikom",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nechoor",
            "Pincode": "686664",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhoor",
            "Pincode": "686664",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Piravom",
            "Pincode": "686664",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elanji",
            "Pincode": "686665",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mutholapuram",
            "Pincode": "686665",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumpadavam",
            "Pincode": "686665",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kothamangalam College",
            "Pincode": "686666",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anchalpetty",
            "Pincode": "686667",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avoli Edso",
            "Pincode": "686667",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Onakkoor",
            "Pincode": "686667",
            "City": "Muvattupuzha",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pampakuda",
            "Pincode": "686667",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parapuram",
            "Pincode": "686667",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Periapuram",
            "Pincode": "686667",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalloorkad",
            "Pincode": "686668",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaloor",
            "Pincode": "686668",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavakkad",
            "Pincode": "686668",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nagapuzha",
            "Pincode": "686668",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thazhavankunnam",
            "Pincode": "686668",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mazhuvannur South",
            "Pincode": "686669",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudavoor",
            "Pincode": "686669",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadalikad",
            "Pincode": "686670",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madakkathanam",
            "Pincode": "686670",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mullapuzhachal",
            "Pincode": "686670",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadacode-Vazhakulam",
            "Pincode": "686670",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhakulam",
            "Pincode": "686670",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadavoor",
            "Pincode": "686671",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koovallur",
            "Pincode": "686671",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padinjarekara Edso",
            "Pincode": "686671",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paingattoor",
            "Pincode": "686671",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallrimangalam Edso",
            "Pincode": "686671",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pothanicaud",
            "Pincode": "686671",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulinthanam",
            "Pincode": "686671",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arakuzha",
            "Pincode": "686672",
            "City": "#N/A",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meenkunnam",
            "Pincode": "686672",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Memadangu",
            "Pincode": "686672",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandapilly",
            "Pincode": "686672",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Enanalloor",
            "Pincode": "686673",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manary",
            "Pincode": "686673",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maradi East",
            "Pincode": "686673",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulavoor",
            "Pincode": "686673",
            "City": "Muvattupuzha",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muvattupuzha Market",
            "Pincode": "686673",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nirmala",
            "Pincode": "686673",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumballoor",
            "Pincode": "686673",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthupady",
            "Pincode": "686673",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Randar",
            "Pincode": "686673",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkenmarady",
            "Pincode": "686673",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhapilly East",
            "Pincode": "686673",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pezhakapally Edso",
            "Pincode": "686674",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayavana",
            "Pincode": "686676",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Oliyapuram Edso",
            "Pincode": "686679",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelad Jn. Edso",
            "Pincode": "686681",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palakuzha Edso",
            "Pincode": "686686",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirumaradi Edso",
            "Pincode": "686687",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mazhuvannur Edso",
            "Pincode": "686689",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bhoothathankettu",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheryvattoor",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Inchathotty",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iramallur",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karukadam",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kohippilly",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koovappara",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kothamangalam",
            "Pincode": "686691",
            "City": "Kothamangalam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuthukuzhi",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttampuzha",
            "Pincode": "686691",
            "City": "Kothamangalam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malipara",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mamalakandam",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nadukani",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellikuzhi",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pooyamkutty",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattekkad",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Urulanthanny",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varapetty Edso",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettampara",
            "Pincode": "686691",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayrooppadam",
            "Pincode": "686692",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panipra",
            "Pincode": "686692",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Plamudy",
            "Pincode": "686692",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrikariyoor",
            "Pincode": "686692",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manikinar",
            "Pincode": "686693",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellimattom",
            "Pincode": "686693",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neriamangalam",
            "Pincode": "686693",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Oonnukal",
            "Pincode": "686693",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pareekanni",
            "Pincode": "686693",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumanoor-Kothamangalam",
            "Pincode": "686693",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalacode Kgm",
            "Pincode": "686693",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Idamalyar",
            "Pincode": "686694",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadattupara",
            "Pincode": "686694",
            "City": "Iduki",
            "District": "Iduki",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottapadi Edso",
            "Pincode": "686695",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Njayapally",
            "Pincode": "686696",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thazhekkad Edso",
            "Pincode": "686697",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pindimana Edso",
            "Pincode": "686698",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellad Edso",
            "Pincode": "686721",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannathur",
            "Pincode": "686723",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manidu",
            "Pincode": "686726",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ooramana",
            "Pincode": "686730",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alappuzha",
            "Pincode": "688001",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvambadi Jn",
            "Pincode": "688002",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sanathanapuram",
            "Pincode": "688003",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadackal",
            "Pincode": "688003",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnapara",
            "Pincode": "688004",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alappuzha Medical College",
            "Pincode": "688005",
            "City": "Alleppey",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjipadam",
            "Pincode": "688005",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avalookunnu",
            "Pincode": "688006",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vembanad Kayal",
            "Pincode": "688006",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alappuzha North",
            "Pincode": "688007",
            "City": "Alleppey",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thumpoly",
            "Pincode": "688008",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhaveedu",
            "Pincode": "688009",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alappuzha Iron Bridge",
            "Pincode": "688011",
            "City": "Alleppey",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuppapuram",
            "Pincode": "688011",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alappuzha Bazar",
            "Pincode": "688012",
            "City": "Alleppey",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thathapalli",
            "Pincode": "688013",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnapra North",
            "Pincode": "688014",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chennamkary",
            "Pincode": "688501",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kainakary",
            "Pincode": "688501",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kainakary East",
            "Pincode": "688501",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttamangalam",
            "Pincode": "688501",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thotuvathala",
            "Pincode": "688501",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thotuvathala",
            "Pincode": "688501",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moncombu",
            "Pincode": "688502",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moncombu Thekkekara",
            "Pincode": "688503",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannadi West",
            "Pincode": "688504",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulincunnu",
            "Pincode": "688504",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnakkunnathussery",
            "Pincode": "688504",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Champakulam",
            "Pincode": "688505",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chempumpuram",
            "Pincode": "688505",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullengadi",
            "Pincode": "688505",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vysambhagom",
            "Pincode": "688505",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chennamkary East",
            "Pincode": "688506",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukara Kuttanad",
            "Pincode": "688506",
            "City": "Alleppey",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavalam",
            "Pincode": "688506",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavalam North",
            "Pincode": "688506",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narakathara",
            "Pincode": "688506",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannadi Edso",
            "Pincode": "688507",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumudi",
            "Pincode": "688508",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chathurthiakary Edso",
            "Pincode": "688511",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponga Edso",
            "Pincode": "688512",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathirapally",
            "Pincode": "688521",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalavoor",
            "Pincode": "688522",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sethulekshmipuram",
            "Pincode": "688523",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherthala",
            "Pincode": "688524",
            "City": "Cherthala",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherthala South",
            "Pincode": "688524",
            "City": "Alleppey",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muhamma",
            "Pincode": "688525",
            "City": "Muhamma",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olavaipu",
            "Pincode": "688526",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poochakkal",
            "Pincode": "688526",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannankara",
            "Pincode": "688527",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikad",
            "Pincode": "688527",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttathiparambu",
            "Pincode": "688527",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thannermukkom",
            "Pincode": "688527",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thycattussery",
            "Pincode": "688528",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadakkarapally",
            "Pincode": "688529",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arthinkal",
            "Pincode": "688530",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chethy",
            "Pincode": "688530",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Andhakaranazhi",
            "Pincode": "688531",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattanacaud",
            "Pincode": "688531",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuravoor",
            "Pincode": "688532",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valamangalam",
            "Pincode": "688532",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuthiathode",
            "Pincode": "688533",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aroor",
            "Pincode": "688534",
            "City": "Aroor",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arookutty",
            "Pincode": "688535",
            "City": "Arookutty",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaduthala Jetty",
            "Pincode": "688535",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayalar",
            "Pincode": "688536",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iramallur",
            "Pincode": "688537",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannamchery",
            "Pincode": "688538",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponnad",
            "Pincode": "688538",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuruppankulangara",
            "Pincode": "688539",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mayithara Market",
            "Pincode": "688539",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parayakad",
            "Pincode": "688540",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirumalabhagom",
            "Pincode": "688540",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aryad North Edso",
            "Pincode": "688542",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varanad Edso",
            "Pincode": "688543",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanichukulangara Edso",
            "Pincode": "688544",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maruthovattom",
            "Pincode": "688545",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattoor Kalavoor Edso",
            "Pincode": "688546",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chandiroor Edso",
            "Pincode": "688547",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ezhupunna Edso",
            "Pincode": "688548",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mararikulam North",
            "Pincode": "688549",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ezhupunna South Edso",
            "Pincode": "688550",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thaickal Edso",
            "Pincode": "688554",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varanam",
            "Pincode": "688555",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochuramapuram Edso",
            "Pincode": "688556",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirunallur Edso",
            "Pincode": "688557",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manapuram",
            "Pincode": "688558",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naduvathunagar Edso",
            "Pincode": "688559",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambalapuzha",
            "Pincode": "688561",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Illichira",
            "Pincode": "688561",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chirayakom",
            "Pincode": "688562",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kelambalam",
            "Pincode": "688562",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnumma Thakazhi",
            "Pincode": "688562",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thakazhy",
            "Pincode": "688562",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottapaly Edso",
            "Pincode": "688563",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottapaly Edso",
            "Pincode": "688563",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karumadi",
            "Pincode": "688564",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panavally Edso",
            "Pincode": "688566",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pollathai Edso",
            "Pincode": "688567",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumbalam",
            "Pincode": "688570",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trichattukulam",
            "Pincode": "688581",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sreenarayanapuram",
            "Pincode": "688582",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kokothamangalam Edso",
            "Pincode": "688583",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalavancodam Edso",
            "Pincode": "688586",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallithode Edso",
            "Pincode": "688586",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettackal Edso",
            "Pincode": "688587",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pushpagiri-Tirivalla.",
            "Pincode": "689101",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvalla",
            "Pincode": "689101",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallumkal",
            "Pincode": "689102",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavumbhagom Tla",
            "Pincode": "689102",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chumitra",
            "Pincode": "689103",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttapuzha",
            "Pincode": "689103",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valanjavattom",
            "Pincode": "689104",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valanjavattom East",
            "Pincode": "689104",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattode",
            "Pincode": "689105",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjadi Jn.",
            "Pincode": "689105",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttur",
            "Pincode": "689106",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thengely",
            "Pincode": "689106",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthur",
            "Pincode": "689107",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumthuruthy",
            "Pincode": "689107",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karakkal Edso",
            "Pincode": "689108",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringara",
            "Pincode": "689108",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eramallikara",
            "Pincode": "689109",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirunvanvandoor",
            "Pincode": "689109",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Podiyadi",
            "Pincode": "689110",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvalla R S",
            "Pincode": "689111",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tiruvalla R S",
            "Pincode": "689111",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alamthuruthi",
            "Pincode": "689113",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azhiyidathuchira",
            "Pincode": "689113",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vempala Edso",
            "Pincode": "689114",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thirumoolapuram",
            "Pincode": "689115",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengannur",
            "Pincode": "689121",
            "City": "Chengannur",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perissery Edso",
            "Pincode": "689121",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angadical Chengannur",
            "Pincode": "689122",
            "City": "Alleppey",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neervilakom",
            "Pincode": "689122",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Piralasseri",
            "Pincode": "689122",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arattupuzha Chengannur",
            "Pincode": "689123",
            "City": "Pathanamthitta",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthencave",
            "Pincode": "689123",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallisseri",
            "Pincode": "689124",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandanad North",
            "Pincode": "689124",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhamangalam Edso",
            "Pincode": "689125",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ala",
            "Pincode": "689126",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurampala South",
            "Pincode": "689501",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannam Sugar Mills",
            "Pincode": "689501",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannamnagar",
            "Pincode": "689501",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandalam",
            "Pincode": "689501",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keerukuzhi Edso",
            "Pincode": "689502",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttom Thumpamon",
            "Pincode": "689502",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thumpamon",
            "Pincode": "689502",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaipuzha North",
            "Pincode": "689503",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulanada",
            "Pincode": "689503",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panangad Kulanda",
            "Pincode": "689503",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthala Edso Kulanada",
            "Pincode": "689503",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ulanad",
            "Pincode": "689503",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ullannur",
            "Pincode": "689503",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karakkad",
            "Pincode": "689504",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kotta",
            "Pincode": "689504",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Areekara",
            "Pincode": "689505",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulakuzha",
            "Pincode": "689505",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringala",
            "Pincode": "689505",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandanad",
            "Pincode": "689506",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandanad West",
            "Pincode": "689506",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karithotta",
            "Pincode": "689507",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karithotta",
            "Pincode": "689507",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mezhuvelli",
            "Pincode": "689507",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodukulanji",
            "Pincode": "689508",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mampara",
            "Pincode": "689508",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neduvarancode",
            "Pincode": "689508",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venmony",
            "Pincode": "689509",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bhudhanoor",
            "Pincode": "689510",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puliyoor",
            "Pincode": "689510",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherianad",
            "Pincode": "689511",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elanjimel",
            "Pincode": "689511",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thonnakkad",
            "Pincode": "689511",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudassanad",
            "Pincode": "689512",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mammoodu",
            "Pincode": "689513",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nariapuram",
            "Pincode": "689513",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kidangannur",
            "Pincode": "689514",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayiranikudi Edso",
            "Pincode": "689515",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudiyoorkonam Edso",
            "Pincode": "689516",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chenneerkara Edso",
            "Pincode": "689517",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paranthal Edso",
            "Pincode": "689518",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manthuka",
            "Pincode": "689519",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pennukara",
            "Pincode": "689520",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozhuvallur",
            "Pincode": "689521",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koipuram",
            "Pincode": "689531",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovathoor",
            "Pincode": "689531",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edayaranmula",
            "Pincode": "689532",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edayaranmula West",
            "Pincode": "689532",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malakara",
            "Pincode": "689532",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aranmula",
            "Pincode": "689533",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nalkalikal Edso",
            "Pincode": "689533",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozimala",
            "Pincode": "689541",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottabhagom",
            "Pincode": "689541",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottabhagom",
            "Pincode": "689541",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallamkulam",
            "Pincode": "689541",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallamkulam East",
            "Pincode": "689541",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellimala",
            "Pincode": "689542",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavumgam Prayar",
            "Pincode": "689543",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madathumbhagom North",
            "Pincode": "689543",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundamala",
            "Pincode": "689543",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puramattom",
            "Pincode": "689543",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narakathani",
            "Pincode": "689544",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paduthode",
            "Pincode": "689544",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thelliyoor Edso",
            "Pincode": "689544",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valakuzhy",
            "Pincode": "689544",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vennikulam",
            "Pincode": "689544",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kolabhagom Jn.",
            "Pincode": "689545",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thadiyoor",
            "Pincode": "689545",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Othara",
            "Pincode": "689546",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadapra Kumbanad Edso",
            "Pincode": "689547",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbanad",
            "Pincode": "689547",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurungazhabhagom Edso",
            "Pincode": "689548",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullad",
            "Pincode": "689548",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maramon",
            "Pincode": "689549",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurianoor",
            "Pincode": "689550",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Othara West",
            "Pincode": "689551",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varayannur Edso",
            "Pincode": "689552",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amichakari",
            "Pincode": "689571",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikuzhy",
            "Pincode": "689571",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neerattupuram",
            "Pincode": "689571",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalavady",
            "Pincode": "689572",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chekkidikad",
            "Pincode": "689573",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edathua",
            "Pincode": "689573",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttar",
            "Pincode": "689574",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunthirickal Edso",
            "Pincode": "689575",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anaparambal Edso",
            "Pincode": "689576",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anapparambal North Edso",
            "Pincode": "689577",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumapram Edso",
            "Pincode": "689578",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnamthanam",
            "Pincode": "689581",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manthanam",
            "Pincode": "689581",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palackal Thakady",
            "Pincode": "689581",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anjilithanam Edso",
            "Pincode": "689582",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaviyur",
            "Pincode": "689582",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottoor",
            "Pincode": "689582",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalloopara",
            "Pincode": "689583",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mallapally East",
            "Pincode": "689584",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anickad Mallappally Edso",
            "Pincode": "689585",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mallapally West",
            "Pincode": "689585",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chalapally",
            "Pincode": "689586",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ezhumattoor",
            "Pincode": "689586",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezhvaipur",
            "Pincode": "689587",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padimon",
            "Pincode": "689587",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumparamavu",
            "Pincode": "689587",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulathur Tla",
            "Pincode": "689588",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vaipur",
            "Pincode": "689588",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Noorommavu Edso",
            "Pincode": "689589",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnaveli",
            "Pincode": "689589",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudayathur",
            "Pincode": "689590",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliyanad",
            "Pincode": "689590",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliyanad North",
            "Pincode": "689590",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliyanad West",
            "Pincode": "689590",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mepral",
            "Pincode": "689591",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumpatty",
            "Pincode": "689592",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundiappalli Edso",
            "Pincode": "689593",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengaroor",
            "Pincode": "689594",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mallapally North",
            "Pincode": "689594",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodupunna",
            "Pincode": "689595",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Rmankary",
            "Pincode": "689595",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Urukary",
            "Pincode": "689595",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pariyaram Edso",
            "Pincode": "689596",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuruthicad",
            "Pincode": "689597",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mithrakari Edso",
            "Pincode": "689598",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vezhapra Edso",
            "Pincode": "689600",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthusserri South",
            "Pincode": "689602",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadamankulam Edso",
            "Pincode": "689603",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayroor South",
            "Pincode": "689611",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayroor North",
            "Pincode": "689612",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velliyara",
            "Pincode": "689612",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Theodical",
            "Pincode": "689613",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellayil",
            "Pincode": "689613",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edappavur",
            "Pincode": "689614",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaithakody",
            "Pincode": "689614",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottathur",
            "Pincode": "689614",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkumkal",
            "Pincode": "689614",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kariyamplavu",
            "Pincode": "689615",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottanad",
            "Pincode": "689615",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjettukara Edso",
            "Pincode": "689616",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhakkumbhagom Edso",
            "Pincode": "689620",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Niranam",
            "Pincode": "689621",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkumbhagom",
            "Pincode": "689621",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Eramathoor",
            "Pincode": "689622",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannar Alp",
            "Pincode": "689622",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pavukkara",
            "Pincode": "689622",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttamperoor",
            "Pincode": "689623",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ennakad",
            "Pincode": "689624",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringalipuram",
            "Pincode": "689624",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elavanthitta",
            "Pincode": "689625",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttathukonam",
            "Pincode": "689625",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thumpamon North",
            "Pincode": "689625",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parumala",
            "Pincode": "689626",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melpadam",
            "Pincode": "689627",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nirnam West Edso",
            "Pincode": "689629",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadapra Mannar Edso",
            "Pincode": "689630",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurichimuttom",
            "Pincode": "689632",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thumpamonthazham",
            "Pincode": "689632",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozhencherry East",
            "Pincode": "689641",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naranganam",
            "Pincode": "689642",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naranganam North",
            "Pincode": "689642",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naranganam West",
            "Pincode": "689642",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elanthur",
            "Pincode": "689643",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elanthur East",
            "Pincode": "689643",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elanthur Pariyaram",
            "Pincode": "689643",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karamvely",
            "Pincode": "689643",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellikala Edso",
            "Pincode": "689643",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Prakkanam Edso",
            "Pincode": "689643",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuzhikala",
            "Pincode": "689644",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angamoozhi Edso",
            "Pincode": "689645",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathanamthitta",
            "Pincode": "689645",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uthimoodu Edso",
            "Pincode": "689645",
            "City": "Malapuram",
            "District": "Malapuram",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mallassery",
            "Pincode": "689646",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maloor",
            "Pincode": "689646",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thengumkavu",
            "Pincode": "689646",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhamuttom East",
            "Pincode": "689646",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Omallur Kla",
            "Pincode": "689647",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Oonukal Quilon",
            "Pincode": "689647",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhamuttom",
            "Pincode": "689647",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angadical North",
            "Pincode": "689648",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chandanapally Edso",
            "Pincode": "689648",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaipattur",
            "Pincode": "689648",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anthiyalankavu",
            "Pincode": "689649",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadammanitta",
            "Pincode": "689649",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundukottakkal",
            "Pincode": "689649",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukole Kozhenchery",
            "Pincode": "689650",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattoor Kozhencherry",
            "Pincode": "689650",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnakkad",
            "Pincode": "689652",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhakkumpuram",
            "Pincode": "689653",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbazhamuri",
            "Pincode": "689653",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettur Kumhazha",
            "Pincode": "689653",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kozhencherry Thekkemala",
            "Pincode": "689654",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallikode-Kottayam",
            "Pincode": "689656",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Njakkunnilam",
            "Pincode": "689656",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallicode Kottayam",
            "Pincode": "689656",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathur Edso",
            "Pincode": "689657",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallicode Edso",
            "Pincode": "689659",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayalathala Edso",
            "Pincode": "689660",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbalampoika",
            "Pincode": "689661",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumaramperoor Thekkekara",
            "Pincode": "689662",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lahai",
            "Pincode": "689662",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maniyar",
            "Pincode": "689662",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mozhiyar",
            "Pincode": "689662",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pamba Triveni",
            "Pincode": "689662",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pezhumpara",
            "Pincode": "689662",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadasserikara",
            "Pincode": "689662",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittar",
            "Pincode": "689663",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikayam",
            "Pincode": "689663",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neeliplavu",
            "Pincode": "689663",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayyattupuzha",
            "Pincode": "689663",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengara",
            "Pincode": "689664",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malyalapuzha Eram",
            "Pincode": "689664",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalachira Eram",
            "Pincode": "689664",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madamon Edso",
            "Pincode": "689665",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malayalapuzha Thazham",
            "Pincode": "689666",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Gurunathamannu",
            "Pincode": "689667",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kochukoickal",
            "Pincode": "689667",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottamonpara",
            "Pincode": "689667",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Seethathode",
            "Pincode": "689667",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Churulicode",
            "Pincode": "689668",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thonniamala",
            "Pincode": "689668",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengalthadam",
            "Pincode": "689671",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mylapra",
            "Pincode": "689671",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keekozhur Edso",
            "Pincode": "689672",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mandiram Jn.Ranny",
            "Pincode": "689672",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthusserimala",
            "Pincode": "689672",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ranny",
            "Pincode": "689672",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukulanji",
            "Pincode": "689673",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iyethala Ranni",
            "Pincode": "689673",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ranny Pazhavangadi",
            "Pincode": "689673",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angadi",
            "Pincode": "689674",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Oonakkavu",
            "Pincode": "689674",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullopuram",
            "Pincode": "689674",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiakavu",
            "Pincode": "689675",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Makkapuzha",
            "Pincode": "689676",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thombikandam",
            "Pincode": "689676",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chellakad",
            "Pincode": "689677",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chethakkal",
            "Pincode": "689677",
            "City": "Ranni",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannarakulanji",
            "Pincode": "689678",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mekkozhur",
            "Pincode": "689678",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mylappa Town",
            "Pincode": "689678",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellikamon Edso",
            "Pincode": "689680",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ranny Edamon Edso",
            "Pincode": "689681",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikulam Edso",
            "Pincode": "689682",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aruvappulam",
            "Pincode": "689691",
            "City": "Kozhenchery",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayravan",
            "Pincode": "689691",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallely",
            "Pincode": "689691",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallely Thottam",
            "Pincode": "689691",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keerampara Kothamangalam",
            "Pincode": "689691",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kokkathode",
            "Pincode": "689691",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konny",
            "Pincode": "689691",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kummannur",
            "Pincode": "689691",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthupezhumkal",
            "Pincode": "689691",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ottupura",
            "Pincode": "689691",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adumpankulam",
            "Pincode": "689692",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Attachakkal",
            "Pincode": "689692",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elimullumplackal",
            "Pincode": "689692",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payyanamon",
            "Pincode": "689692",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perinjattakkal",
            "Pincode": "689692",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koodal",
            "Pincode": "689693",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulathumon",
            "Pincode": "689693",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Murinjakal",
            "Pincode": "689693",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumoncavu",
            "Pincode": "689693",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nirathupara",
            "Pincode": "689693",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalanjoor",
            "Pincode": "689694",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mancode",
            "Pincode": "689694",
            "City": "Kottarakkara",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandam",
            "Pincode": "689694",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kundayam",
            "Pincode": "689695",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumbakara",
            "Pincode": "689695",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maloor College",
            "Pincode": "689695",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathanapuram",
            "Pincode": "689695",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathirickal",
            "Pincode": "689695",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poomkulanji",
            "Pincode": "689695",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chembanaruvi",
            "Pincode": "689696",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elikkattoor",
            "Pincode": "689696",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kamukumcherry",
            "Pincode": "689696",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karavoor",
            "Pincode": "689696",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumaramkudy",
            "Pincode": "689696",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Piravanthur",
            "Pincode": "689696",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettithitta",
            "Pincode": "689696",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vakayar",
            "Pincode": "689698",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannera",
            "Pincode": "689699",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thannothode",
            "Pincode": "689699",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkuthode",
            "Pincode": "689699",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Illakollur Edso",
            "Pincode": "689703",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellappara Edso",
            "Pincode": "689705",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnala Edso",
            "Pincode": "689706",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adichipuzha",
            "Pincode": "689711",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkudumon",
            "Pincode": "689711",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koonamkara",
            "Pincode": "689711",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudamurutty",
            "Pincode": "689711",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mampara",
            "Pincode": "689711",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naranamoozhi",
            "Pincode": "689711",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ranny Perinad",
            "Pincode": "689711",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sabarimala",
            "Pincode": "689713",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandankary Edso",
            "Pincode": "689721",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thayamkari Edso",
            "Pincode": "689722",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalavady South Edso",
            "Pincode": "689723",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mavelikara",
            "Pincode": "690101",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punnamood",
            "Pincode": "690101",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arnoorttimangalam",
            "Pincode": "690102",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthiakavu",
            "Pincode": "690102",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thazhakara",
            "Pincode": "690102",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pela",
            "Pincode": "690103",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattarambalam",
            "Pincode": "690103",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukole",
            "Pincode": "690104",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiakulangara",
            "Pincode": "690104",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chennithala",
            "Pincode": "690105",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Triperumthura",
            "Pincode": "690105",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chettikulangara",
            "Pincode": "690106",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannamangalam Mavelikara",
            "Pincode": "690106",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnamangalam",
            "Pincode": "690106",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallarimangalam",
            "Pincode": "690107",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkekara",
            "Pincode": "690107",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnam",
            "Pincode": "690108",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karipuzha Edso",
            "Pincode": "690109",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallumala",
            "Pincode": "690110",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaduvinal",
            "Pincode": "690501",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenchantha-Mavelikara",
            "Pincode": "690501",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallikunnam",
            "Pincode": "690501",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambaluthumbhagom",
            "Pincode": "690502",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kayamkulam",
            "Pincode": "690502",
            "City": "Kayamkulam",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Illippakulam",
            "Pincode": "690503",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallickal Naduvilemuri",
            "Pincode": "690503",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettikode Edso",
            "Pincode": "690503",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athikattukulangara",
            "Pincode": "690504",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Noornad",
            "Pincode": "690504",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallickal Nooranad",
            "Pincode": "690504",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panayil",
            "Pincode": "690504",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannanakuzhi",
            "Pincode": "690505",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadaraplavu",
            "Pincode": "690505",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Choolatheruvu",
            "Pincode": "690506",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthukulam South",
            "Pincode": "690506",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheppaud",
            "Pincode": "690507",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keerikad",
            "Pincode": "690508",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olattiambalam",
            "Pincode": "690510",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttom",
            "Pincode": "690511",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Naduvattom Pallippad",
            "Pincode": "690512",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallipad",
            "Pincode": "690512",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Akamkudi",
            "Pincode": "690513",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nangiarkulangara",
            "Pincode": "690513",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Haripad",
            "Pincode": "690514",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thamalakkal North",
            "Pincode": "690514",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veeyapuam",
            "Pincode": "690514",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arattupuzha",
            "Pincode": "690515",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arattupuzha North",
            "Pincode": "690515",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mangalam",
            "Pincode": "690515",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallana",
            "Pincode": "690515",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Trikkunnapuzha",
            "Pincode": "690515",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karthikapally",
            "Pincode": "690516",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayaparambu",
            "Pincode": "690517",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvatta",
            "Pincode": "690517",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandy",
            "Pincode": "690517",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karunagapally",
            "Pincode": "690518",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karunagapally North",
            "Pincode": "690518",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mynagappally",
            "Pincode": "690519",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mynagappally North",
            "Pincode": "690519",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottumukhom",
            "Pincode": "690519",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottumukhom",
            "Pincode": "690519",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimthottuva",
            "Pincode": "690520",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnathur East",
            "Pincode": "690520",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthupilakad",
            "Pincode": "690520",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poruvazhi",
            "Pincode": "690520",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuruthikara",
            "Pincode": "690520",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallisserical",
            "Pincode": "690521",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sasthamcottah",
            "Pincode": "690521",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilanthara Jn.B.O",
            "Pincode": "690521",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anayadi",
            "Pincode": "690522",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkakunnu",
            "Pincode": "690522",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parakadavu Sooranadu",
            "Pincode": "690522",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sooranad",
            "Pincode": "690522",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thengamom",
            "Pincode": "690522",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadathur Ward",
            "Pincode": "690523",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuthirapanthi",
            "Pincode": "690523",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thazhava",
            "Pincode": "690523",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thodiyoor North",
            "Pincode": "690523",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padinjattekara",
            "Pincode": "690524",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thevalakkara",
            "Pincode": "690524",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Clappana",
            "Pincode": "690525",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madathilkaranma",
            "Pincode": "690526",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ochira",
            "Pincode": "690526",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Govindamuttam",
            "Pincode": "690527",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthupally",
            "Pincode": "690527",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varavila",
            "Pincode": "690528",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vavvakkavu",
            "Pincode": "690528",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padanilam",
            "Pincode": "690529",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattoor",
            "Pincode": "690529",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thamarakulam",
            "Pincode": "690530",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattoli Market",
            "Pincode": "690531",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthiyavila",
            "Pincode": "690531",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chingoli",
            "Pincode": "690532",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kappil East",
            "Pincode": "690533",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Krishanapuram",
            "Pincode": "690533",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Njakanal",
            "Pincode": "690533",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chunakara",
            "Pincode": "690534",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kandallur",
            "Pincode": "690535",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiazheekal",
            "Pincode": "690535",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kollaka",
            "Pincode": "690536",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkumthala East",
            "Pincode": "690536",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullikanakku",
            "Pincode": "690537",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arinallur",
            "Pincode": "690538",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arinallur South",
            "Pincode": "690538",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perungalam",
            "Pincode": "690538",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sree Ramapuram Market",
            "Pincode": "690539",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bharanicavu Edso",
            "Pincode": "690541",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Athinad North",
            "Pincode": "690542",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattilkadavu",
            "Pincode": "690542",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuzhithura",
            "Pincode": "690542",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karali Jn.Edso",
            "Pincode": "690543",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulasekharapuram",
            "Pincode": "690544",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallelibhagom",
            "Pincode": "690546",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alumpeedika Edso",
            "Pincode": "690547",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azheekalthura",
            "Pincode": "690547",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Prayar",
            "Pincode": "690547",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattakkatu Market",
            "Pincode": "690547",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumarapuram",
            "Pincode": "690548",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thamallakkal",
            "Pincode": "690549",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannarasala Edso",
            "Pincode": "690550",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Purakad Edso",
            "Pincode": "690551",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pathyoor Edso",
            "Pincode": "690552",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvatta North Edso",
            "Pincode": "690554",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mahadevicaud Edso",
            "Pincode": "690555",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payipad",
            "Pincode": "690556",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettiyar",
            "Pincode": "690557",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankamkuzhy",
            "Pincode": "690558",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perungala",
            "Pincode": "690559",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthukulam Edso",
            "Pincode": "690560",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Soornad North",
            "Pincode": "690561",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruthana Edso",
            "Pincode": "690563",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallickal",
            "Pincode": "690563",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiaparambu Edso",
            "Pincode": "690566",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Patharam Edso",
            "Pincode": "690567",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thodiyoor Edso",
            "Pincode": "690568",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venga Edso",
            "Pincode": "690569",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallimel",
            "Pincode": "690570",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Noornad Sanatorium",
            "Pincode": "690571",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kareelakulangara",
            "Pincode": "690572",
            "City": "Alappuzha",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alumkadavu",
            "Pincode": "690573",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheriyazheekal",
            "Pincode": "690573",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "S.V Market",
            "Pincode": "690573",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manapally North",
            "Pincode": "690574",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pavumba Edso",
            "Pincode": "690574",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kollam",
            "Pincode": "691001",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundakkal",
            "Pincode": "691001",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Asramom",
            "Pincode": "691002",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavanad",
            "Pincode": "691003",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalllumthazham",
            "Pincode": "691004",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilikollur",
            "Pincode": "691004",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "T.K.M.College",
            "Pincode": "691005",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattarkonam",
            "Pincode": "691005",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallithottam",
            "Pincode": "691006",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thangasseri",
            "Pincode": "691007",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadappakada",
            "Pincode": "691008",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thevally",
            "Pincode": "691009",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkevila",
            "Pincode": "691010",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirumullavaram",
            "Pincode": "691012",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kollam Cutcherry",
            "Pincode": "691013",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chandanathope",
            "Pincode": "691014",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mangad",
            "Pincode": "691015",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayathil Edso",
            "Pincode": "691017",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valathungal Edso",
            "Pincode": "691018",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uliyakovil",
            "Pincode": "691019",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kootikada",
            "Pincode": "691020",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattamala",
            "Pincode": "691020",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattathanam",
            "Pincode": "691021",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paravur Kollam",
            "Pincode": "691301",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pozhikara",
            "Pincode": "691301",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bhoothakulam",
            "Pincode": "691302",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalakode",
            "Pincode": "691302",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mayyanad",
            "Pincode": "691303",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullichira",
            "Pincode": "691304",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellipally",
            "Pincode": "691305",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punalur",
            "Pincode": "691305",
            "City": "Punalur",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Shaliacary Estatate",
            "Pincode": "691305",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilakkuvattom",
            "Pincode": "691305",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anchal",
            "Pincode": "691306",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherukulam",
            "Pincode": "691306",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nediyara",
            "Pincode": "691306",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thadicaud",
            "Pincode": "691306",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadamon",
            "Pincode": "691306",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayala",
            "Pincode": "691306",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anapettakongal",
            "Pincode": "691307",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayiranallur",
            "Pincode": "691307",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mampazhathara",
            "Pincode": "691307",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallada Irrig. Project",
            "Pincode": "691308",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ottakal",
            "Pincode": "691308",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thenmala",
            "Pincode": "691308",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edapalayam",
            "Pincode": "691309",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalthuruthy",
            "Pincode": "691309",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venture",
            "Pincode": "691309",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Dally",
            "Pincode": "691310",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koovakkad",
            "Pincode": "691310",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulathupuzha",
            "Pincode": "691310",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sam Nagar",
            "Pincode": "691310",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thingalkarikom",
            "Pincode": "691310",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Villumala",
            "Pincode": "691310",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakulam Channapetta",
            "Pincode": "691311",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannur Anchal",
            "Pincode": "691311",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayilara",
            "Pincode": "691312",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadamancode",
            "Pincode": "691312",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manali",
            "Pincode": "691312",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marthandankara",
            "Pincode": "691312",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilakupara",
            "Pincode": "691312",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karavaloor Edso",
            "Pincode": "691314",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathra Edso",
            "Pincode": "691315",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aryancave Edso",
            "Pincode": "691316",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chozhiakode Edso",
            "Pincode": "691317",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkumbhagam",
            "Pincode": "691319",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alayamon Edso",
            "Pincode": "691320",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elampal",
            "Pincode": "691322",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karukone Edso",
            "Pincode": "691324",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maniyar Pnr Edso",
            "Pincode": "691325",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narikkal Edso",
            "Pincode": "691326",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Urukunnu Esdo",
            "Pincode": "691329",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bharatheepuram Edso",
            "Pincode": "691330",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkode",
            "Pincode": "691331",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Placherry",
            "Pincode": "691331",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valacode",
            "Pincode": "691331",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kariyara",
            "Pincode": "691332",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punalur Paper Mills",
            "Pincode": "691332",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Areeplachy",
            "Pincode": "691333",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tholicode Punalur",
            "Pincode": "691333",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venchembu Edso",
            "Pincode": "691333",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumgolam",
            "Pincode": "691334",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Polachira",
            "Pincode": "691334",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "West Kallada",
            "Pincode": "691500",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambipoika",
            "Pincode": "691501",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kundara",
            "Pincode": "691501",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "East Kallada",
            "Pincode": "691502",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koduvila",
            "Pincode": "691502",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Munroethuruthu",
            "Pincode": "691502",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muppathadam East Kallada",
            "Pincode": "691502",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peruvelikara",
            "Pincode": "691502",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "West Kallada",
            "Pincode": "691502",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjiracode",
            "Pincode": "691503",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kumbalam Mulavana",
            "Pincode": "691503",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukkodu",
            "Pincode": "691503",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulavana",
            "Pincode": "691503",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Padappakkara",
            "Pincode": "691503",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumpuzha",
            "Pincode": "691504",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambalathumkala",
            "Pincode": "691505",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakottoor",
            "Pincode": "691505",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Idakkadom",
            "Pincode": "691505",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irumpanagad",
            "Pincode": "691505",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadakkode",
            "Pincode": "691505",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvelil",
            "Pincode": "691505",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maranad",
            "Pincode": "691505",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalayapuram",
            "Pincode": "691506",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottarakara",
            "Pincode": "691506",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neeleswaram Edso",
            "Pincode": "691506",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallikal Kottarakara Edso",
            "Pincode": "691506",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherupoika",
            "Pincode": "691507",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iverkala East",
            "Pincode": "691507",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mavadi Edso",
            "Pincode": "691507",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthur-Quilon",
            "Pincode": "691507",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thevalapuram",
            "Pincode": "691507",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vendar",
            "Pincode": "691507",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anbalathinparappu",
            "Pincode": "691508",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avaneeswaram",
            "Pincode": "691508",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chakkuvarakkal",
            "Pincode": "691508",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottavattom",
            "Pincode": "691508",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnicode",
            "Pincode": "691508",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjakala",
            "Pincode": "691508",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melila",
            "Pincode": "691508",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilakudy",
            "Pincode": "691508",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuzhimathicaud",
            "Pincode": "691509",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumancavu",
            "Pincode": "691509",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellimukku",
            "Pincode": "691509",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thripalazhikom",
            "Pincode": "691509",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vakkanad",
            "Pincode": "691509",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Akkal",
            "Pincode": "691510",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chenkulam",
            "Pincode": "691510",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheriya Velinallur",
            "Pincode": "691510",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meeyana",
            "Pincode": "691510",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Oyur",
            "Pincode": "691510",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellimon",
            "Pincode": "691511",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellimon West",
            "Pincode": "691511",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheppara",
            "Pincode": "691512",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudavattor",
            "Pincode": "691512",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttara",
            "Pincode": "691512",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Odanavattom",
            "Pincode": "691512",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiyode",
            "Pincode": "691512",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimpinpuzha Edso",
            "Pincode": "691513",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalavoor Edso",
            "Pincode": "691514",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nallila",
            "Pincode": "691515",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karingannur",
            "Pincode": "691516",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avaneeswaram R.S Edso",
            "Pincode": "691517",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottathala Edso",
            "Pincode": "691518",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulakada",
            "Pincode": "691521",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulakada East",
            "Pincode": "691521",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulakada Tazhath",
            "Pincode": "691521",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panathaplavu",
            "Pincode": "691522",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattazhy",
            "Pincode": "691522",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekketheri",
            "Pincode": "691522",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adur Kla",
            "Pincode": "691523",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anandhapalli Edso",
            "Pincode": "691523",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karuvatta",
            "Pincode": "691523",
            "City": "Karthikappally",
            "District": "Alappuzha",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melood",
            "Pincode": "691523",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elamannur",
            "Pincode": "691524",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marur",
            "Pincode": "691524",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parakara",
            "Pincode": "691525",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattayil",
            "Pincode": "691525",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Enathu",
            "Pincode": "691526",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaithaparambu",
            "Pincode": "691526",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thazhathu Vadakku",
            "Pincode": "691526",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhakulam Edso",
            "Pincode": "691527",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringanad Edso",
            "Pincode": "691528",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkadathukavu Jn.Edso",
            "Pincode": "691529",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannady",
            "Pincode": "691530",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikom",
            "Pincode": "691531",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Plappally",
            "Pincode": "691531",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulamon",
            "Pincode": "691531",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thrikkannamangal",
            "Pincode": "691531",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambalakara",
            "Pincode": "691532",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Andoor",
            "Pincode": "691532",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Podiyattuvila",
            "Pincode": "691532",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valakom",
            "Pincode": "691532",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arkannur",
            "Pincode": "691533",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayur",
            "Pincode": "691533",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruvakkal",
            "Pincode": "691533",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjappara",
            "Pincode": "691533",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ozhukuparackal",
            "Pincode": "691533",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thevannur",
            "Pincode": "691533",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayyanam",
            "Pincode": "691533",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chadayamangalam",
            "Pincode": "691534",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elampazhannur",
            "Pincode": "691534",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuriyod",
            "Pincode": "691534",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poredom Edso",
            "Pincode": "691534",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaithode",
            "Pincode": "691535",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nilamel",
            "Pincode": "691535",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edathara Kadakkal",
            "Pincode": "691536",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadakkal",
            "Pincode": "691536",
            "City": "#N/A",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kummil",
            "Pincode": "691536",
            "City": "Kottarakkara",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttikkadu",
            "Pincode": "691536",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathira",
            "Pincode": "691536",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulippara Jn",
            "Pincode": "691536",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullipara",
            "Pincode": "691536",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullu",
            "Pincode": "691536",
            "City": "Thrissur",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thudayannur",
            "Pincode": "691536",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattathamara",
            "Pincode": "691536",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattadi Jn",
            "Pincode": "691537",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mailode",
            "Pincode": "691537",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Miyannur",
            "Pincode": "691537",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nettayam",
            "Pincode": "691537",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pooyapally",
            "Pincode": "691537",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliyam West",
            "Pincode": "691537",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kokkad",
            "Pincode": "691538",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettikavala",
            "Pincode": "691538",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elamad Edso",
            "Pincode": "691539",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Illamadu Edso",
            "Pincode": "691539",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliyam",
            "Pincode": "691540",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kollayil",
            "Pincode": "691541",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madathara",
            "Pincode": "691541",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhakketheruvu Jn. Edso",
            "Pincode": "691542",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaithakode",
            "Pincode": "691543",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panaveli Edso",
            "Pincode": "691544",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumannur Edso",
            "Pincode": "691545",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalachira Edso",
            "Pincode": "691546",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ummannur Edso",
            "Pincode": "691547",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayakkal Edso",
            "Pincode": "691548",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Choorakode Manakala",
            "Pincode": "691551",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manakala",
            "Pincode": "691551",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellimukal",
            "Pincode": "691551",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parakootam",
            "Pincode": "691551",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sadanandapuram Edso",
            "Pincode": "691551",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadambanad",
            "Pincode": "691552",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthennabalam Edso",
            "Pincode": "691552",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuvayoor South",
            "Pincode": "691552",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadambanad South",
            "Pincode": "691553",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manampuzha",
            "Pincode": "691553",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parakode",
            "Pincode": "691554",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthumala",
            "Pincode": "691554",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Theppupara",
            "Pincode": "691554",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vayala Parakode Edso",
            "Pincode": "691554",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Angadical South Edso",
            "Pincode": "691555",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edathitta",
            "Pincode": "691555",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodumon",
            "Pincode": "691555",
            "City": "#N/A",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodumon East",
            "Pincode": "691555",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chayalode",
            "Pincode": "691556",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chelikuzhi",
            "Pincode": "691556",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumon",
            "Pincode": "691556",
            "City": "Pathanamthitta",
            "District": "Pathanamthitta",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chengamanad Jn",
            "Pincode": "691557",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kura",
            "Pincode": "691557",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayirakuzhi",
            "Pincode": "691559",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chithara",
            "Pincode": "691559",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mankode Kadakkal",
            "Pincode": "691559",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valavupacha",
            "Pincode": "691559",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mailom",
            "Pincode": "691560",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thamarakudi",
            "Pincode": "691560",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallikkal",
            "Pincode": "691566",
            "City": "#N/A",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottiyam",
            "Pincode": "691571",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mylakad",
            "Pincode": "691571",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chathannur",
            "Pincode": "691572",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adichanallur",
            "Pincode": "691573",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velichikala",
            "Pincode": "691573",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhakkanela",
            "Pincode": "691574",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paripally",
            "Pincode": "691574",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Velamanur",
            "Pincode": "691574",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kannanallur",
            "Pincode": "691576",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallimon",
            "Pincode": "691576",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alummoodu",
            "Pincode": "691577",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Decent Jn",
            "Pincode": "691577",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukhathala",
            "Pincode": "691577",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chirakkara",
            "Pincode": "691578",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalluvathukkal",
            "Pincode": "691578",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilavoorkonam",
            "Pincode": "691578",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aduthala",
            "Pincode": "691579",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karamcode",
            "Pincode": "691579",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumpana Edso",
            "Pincode": "691580",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sakthikulangara",
            "Pincode": "691581",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neendakara",
            "Pincode": "691582",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chavara",
            "Pincode": "691583",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edapallicotta",
            "Pincode": "691583",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panmana Edso",
            "Pincode": "691583",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panmana Puthenchanta Edso",
            "Pincode": "691583",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponmana Edso",
            "Pincode": "691583",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chavara South",
            "Pincode": "691584",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadakkumbhagam",
            "Pincode": "691584",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukundapuram",
            "Pincode": "691585",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pudukkadukara",
            "Pincode": "691585",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenthura Edso",
            "Pincode": "691588",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Umayanallur Ind Estate",
            "Pincode": "691589",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koivila",
            "Pincode": "691590",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Inchavila",
            "Pincode": "691601",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mathilil",
            "Pincode": "691601",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panayam",
            "Pincode": "691601",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattom Thuruthu",
            "Pincode": "691601",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perinad",
            "Pincode": "691601",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumkulam",
            "Pincode": "691601",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumon",
            "Pincode": "691601",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ashtamudi",
            "Pincode": "691602",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjaveli",
            "Pincode": "691602",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Prakulam",
            "Pincode": "691602",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chemmakkad",
            "Pincode": "691603",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kureepuzha Edso",
            "Pincode": "691604",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellikunnam Edso",
            "Pincode": "691623",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pavithreeswaram",
            "Pincode": "691624",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pidavoor Edso",
            "Pincode": "691625",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvananthapuram G.P.O.",
            "Pincode": "695001",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karamana",
            "Pincode": "695002",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karumam",
            "Pincode": "695002",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karumon",
            "Pincode": "695002",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaudiar",
            "Pincode": "695003",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuravankonam",
            "Pincode": "695003",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Goureesapattam",
            "Pincode": "695004",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "M G College",
            "Pincode": "695004",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattom",
            "Pincode": "695004",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pattom Palace",
            "Pincode": "695004",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallayam",
            "Pincode": "695005",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Oolampara",
            "Pincode": "695005",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perurkada",
            "Pincode": "695005",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirumala",
            "Pincode": "695006",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiavila",
            "Pincode": "695006",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tvm Beach",
            "Pincode": "695007",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perunthanni",
            "Pincode": "695008",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thope",
            "Pincode": "695008",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiathura",
            "Pincode": "695008",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vallakkadavoo",
            "Pincode": "695008",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayiranimuttom",
            "Pincode": "695009",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manacaud",
            "Pincode": "695009",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sasthamangalam",
            "Pincode": "695010",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheruvikkal",
            "Pincode": "695011",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tvm Medical College",
            "Pincode": "695011",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ulloor",
            "Pincode": "695011",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poojapura",
            "Pincode": "695012",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thamalam",
            "Pincode": "695012",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheriyakonni",
            "Pincode": "695013",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kachani",
            "Pincode": "695013",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodunganur Edso",
            "Pincode": "695013",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manikanteswaram",
            "Pincode": "695013",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattiyoorkavu",
            "Pincode": "695013",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thycaud",
            "Pincode": "695014",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannanthala",
            "Pincode": "695015",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nalanchira",
            "Pincode": "695015",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tvm Engg College",
            "Pincode": "695016",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sreekariyam",
            "Pincode": "695017",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pappanamcode",
            "Pincode": "695018",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Industrial Estate Tvm",
            "Pincode": "695019",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Narimamoodu",
            "Pincode": "695020",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nemom",
            "Pincode": "695020",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ookode",
            "Pincode": "695020",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallichal Edso",
            "Pincode": "695020",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pravachambalam",
            "Pincode": "695020",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Titanium",
            "Pincode": "695021",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiaveli",
            "Pincode": "695021",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tvm Isro",
            "Pincode": "695022",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tvm Fort",
            "Pincode": "695023",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tvm Pettah",
            "Pincode": "695024",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttada",
            "Pincode": "695025",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poonthura",
            "Pincode": "695026",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pachallur Edso",
            "Pincode": "695027",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thiruvallam",
            "Pincode": "695027",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pandalakode",
            "Pincode": "695028",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattapara",
            "Pincode": "695028",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venkode",
            "Pincode": "695028",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anayara",
            "Pincode": "695029",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjirampara",
            "Pincode": "695030",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thuruvikkal Edso",
            "Pincode": "695031",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aramada",
            "Pincode": "695032",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vikas Bhavan",
            "Pincode": "695033",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tvm University",
            "Pincode": "695034",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vanchiyur",
            "Pincode": "695035",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tvm Chalai",
            "Pincode": "695036",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnukuzhi",
            "Pincode": "695037",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "P.T.P Nagar",
            "Pincode": "695038",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tvm Ag S Office",
            "Pincode": "695039",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaimanam",
            "Pincode": "695040",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Jawahar Nagar",
            "Pincode": "695041",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tvm Jawahar Nagar",
            "Pincode": "695041",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalliyur",
            "Pincode": "695042",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudappanakunnu",
            "Pincode": "695043",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukkolakkal",
            "Pincode": "695044",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukkolakkal Edso",
            "Pincode": "695044",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kerala Governor S Camp",
            "Pincode": "695099",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Attingal",
            "Pincode": "695101",
            "City": "Attingal",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezhatthungal",
            "Pincode": "695101",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alamcode",
            "Pincode": "695102",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Altharamoodu",
            "Pincode": "695102",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumparambu",
            "Pincode": "695102",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumkulam",
            "Pincode": "695102",
            "City": "Nedumangad",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vanchiyur",
            "Pincode": "695102",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Avanavancherry",
            "Pincode": "695103",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayilam",
            "Pincode": "695103",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ilamba Edso",
            "Pincode": "695103",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudakkal",
            "Pincode": "695103",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poikamukku",
            "Pincode": "695103",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kizhuvalam",
            "Pincode": "695104",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurakada",
            "Pincode": "695104",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Oorupoika",
            "Pincode": "695104",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Prayathukonam",
            "Pincode": "695104",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neyyattinkara",
            "Pincode": "695121",
            "City": "Neyyattinkara",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amaravila",
            "Pincode": "695122",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Arayur",
            "Pincode": "695122",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chaikottukonam",
            "Pincode": "695122",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aralummoodu",
            "Pincode": "695123",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodungavilla",
            "Pincode": "695123",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thannimoodu",
            "Pincode": "695123",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venpakal",
            "Pincode": "695123",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anavoor",
            "Pincode": "695124",
            "City": "Neyyattinkara",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottakkal",
            "Pincode": "695124",
            "City": "Tirur",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumkadavila",
            "Pincode": "695124",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Dalmugham",
            "Pincode": "695125",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manchamcode",
            "Pincode": "695125",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannamconam",
            "Pincode": "695125",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ottasekhara Mangalam",
            "Pincode": "695125",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poozhanad",
            "Pincode": "695125",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vazhichal",
            "Pincode": "695125",
            "City": "Neyyattinkara",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aruvipuram",
            "Pincode": "695126",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumpazhuthur",
            "Pincode": "695126",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mariapuram Edso",
            "Pincode": "695127",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Plamoottukada Edso",
            "Pincode": "695128",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Keezharur Edso",
            "Pincode": "695130",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marayamuttom Edso",
            "Pincode": "695131",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chenkal",
            "Pincode": "695132",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattavila",
            "Pincode": "695132",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulluvila",
            "Pincode": "695133",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Olathanni",
            "Pincode": "695133",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tirupuram",
            "Pincode": "695133",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chilakur",
            "Pincode": "695141",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Varkala",
            "Pincode": "695141",
            "City": "Varkala",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cherunniyur",
            "Pincode": "695142",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palachira",
            "Pincode": "695143",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thokkad",
            "Pincode": "695143",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vadasserikonam",
            "Pincode": "695143",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kavalyur",
            "Pincode": "695144",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulamuttom",
            "Pincode": "695144",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moongode",
            "Pincode": "695144",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttappalam",
            "Pincode": "695145",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panayara",
            "Pincode": "695145",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sreenivasapuram",
            "Pincode": "695145",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthana",
            "Pincode": "695146",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palayamkunnu",
            "Pincode": "695146",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaniyapuram",
            "Pincode": "695301",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Murukkumpuzha",
            "Pincode": "695302",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellattil",
            "Pincode": "695302",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumathura",
            "Pincode": "695303",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenkurichy",
            "Pincode": "695303",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chiranyinkeezh",
            "Pincode": "695304",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Katakam",
            "Pincode": "695304",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Azhur Market",
            "Pincode": "695305",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perunguzhi",
            "Pincode": "695305",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sasthavattom",
            "Pincode": "695305",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anathalavattom",
            "Pincode": "695306",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kadakkavur",
            "Pincode": "695306",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melkadakkavur",
            "Pincode": "695306",
            "City": "Kollam",
            "District": "Kollam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kaikkara",
            "Pincode": "695307",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedungada",
            "Pincode": "695307",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vakkom",
            "Pincode": "695308",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anjengo",
            "Pincode": "695309",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poothura",
            "Pincode": "695309",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayroor Varkala",
            "Pincode": "695310",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elakamon",
            "Pincode": "695310",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Haritharapuram",
            "Pincode": "695310",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Edava",
            "Pincode": "695311",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kappil Edava",
            "Pincode": "695311",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullanicode",
            "Pincode": "695311",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Melvettoor",
            "Pincode": "695312",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettoor",
            "Pincode": "695312",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudavoor",
            "Pincode": "695313",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manjamala",
            "Pincode": "695313",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudappuram Edso",
            "Pincode": "695314",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mudapuraam",
            "Pincode": "695314",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallipuram Tvm",
            "Pincode": "695316",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thonnakkal",
            "Pincode": "695317",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vennicode",
            "Pincode": "695318",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Badaje",
            "Pincode": "695323",
            "City": "Kasaragod",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Balaramapuram",
            "Pincode": "695501",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bhagavathinada",
            "Pincode": "695501",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chowara Trivandrum",
            "Pincode": "695501",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottukal",
            "Pincode": "695501",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Payattuvila",
            "Pincode": "695501",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Russelpuram",
            "Pincode": "695501",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vedivechancoil",
            "Pincode": "695501",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ayira",
            "Pincode": "695502",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parassala",
            "Pincode": "695502",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Dhanuvachapuram",
            "Pincode": "695503",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manchavilakom",
            "Pincode": "695503",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheriakolla",
            "Pincode": "695504",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elluvilla",
            "Pincode": "695504",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karakonam",
            "Pincode": "695504",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kunnathukal",
            "Pincode": "695504",
            "City": "Neyyattinkara",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amboori Edso",
            "Pincode": "695505",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karikuzhi Vellarada",
            "Pincode": "695505",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koothali",
            "Pincode": "695505",
            "City": "Quilandy",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudayal",
            "Pincode": "695505",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttamala",
            "Pincode": "695505",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manali Vellarada",
            "Pincode": "695505",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mayam",
            "Pincode": "695505",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panachamoodu",
            "Pincode": "695505",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thekkupara",
            "Pincode": "695505",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellarada",
            "Pincode": "695505",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kakkavila B",
            "Pincode": "695506",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karode",
            "Pincode": "695506",
            "City": "Neyyattinkara",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uchakada",
            "Pincode": "695506",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venkadambu",
            "Pincode": "695506",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ooruttambalam",
            "Pincode": "695507",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parasuvaikal",
            "Pincode": "695508",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattachalkuzhi Edso",
            "Pincode": "695509",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kudappanamoodu Edso",
            "Pincode": "695510",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kandakai",
            "Pincode": "695512",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuvalssery",
            "Pincode": "695512",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliamcode",
            "Pincode": "695512",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pozhiyur Edso",
            "Pincode": "695513",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottapuram",
            "Pincode": "695521",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mullur",
            "Pincode": "695521",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vizhinjam",
            "Pincode": "695521",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellayani",
            "Pincode": "695522",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muttakadu",
            "Pincode": "695523",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellivila",
            "Pincode": "695523",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venganur",
            "Pincode": "695523",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjiramkulam",
            "Pincode": "695524",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellimmodu",
            "Pincode": "695524",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanjampazhanji",
            "Pincode": "695525",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puvar",
            "Pincode": "695525",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kazhavoor",
            "Pincode": "695526",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Lourdupuram",
            "Pincode": "695526",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthiyathura",
            "Pincode": "695526",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kovalam",
            "Pincode": "695527",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chullimanur Edso",
            "Pincode": "695541",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karipur",
            "Pincode": "695541",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karupur",
            "Pincode": "695541",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mancha",
            "Pincode": "695541",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mannurkonam",
            "Pincode": "695541",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nedumangad",
            "Pincode": "695541",
            "City": "Nedumangad",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paruthikuzhi",
            "Pincode": "695541",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perumala",
            "Pincode": "695541",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthukulangara",
            "Pincode": "695541",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tholicode Edso",
            "Pincode": "695541",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aryanad",
            "Pincode": "695542",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kokottella",
            "Pincode": "695542",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottakkakom",
            "Pincode": "695542",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kullapada",
            "Pincode": "695542",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Marangad",
            "Pincode": "695542",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meenankal",
            "Pincode": "695542",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panacode",
            "Pincode": "695542",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parancode",
            "Pincode": "695542",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vinibhanikethen",
            "Pincode": "695542",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuthirakulam Vellanad",
            "Pincode": "695543",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mithranikethan",
            "Pincode": "695543",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulayara",
            "Pincode": "695543",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mundela",
            "Pincode": "695543",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Uriakode",
            "Pincode": "695543",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veliyannur",
            "Pincode": "695543",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellanad",
            "Pincode": "695543",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anad Edso",
            "Pincode": "695544",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valiamala Pslv Project",
            "Pincode": "695547",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anappara",
            "Pincode": "695551",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bonaccord Edso",
            "Pincode": "695551",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chettachal",
            "Pincode": "695551",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallar Tvm",
            "Pincode": "695551",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maruthamala",
            "Pincode": "695551",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Memala",
            "Pincode": "695551",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parappara",
            "Pincode": "695551",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peppara Dam",
            "Pincode": "695551",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponmudi",
            "Pincode": "695551",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vithura",
            "Pincode": "695551",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irinava",
            "Pincode": "695561",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panayamuttom",
            "Pincode": "695561",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pazhakutty",
            "Pincode": "695561",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovathoor Nedumangad",
            "Pincode": "695561",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Elavattom",
            "Pincode": "695562",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimancode",
            "Pincode": "695562",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Meenmutty",
            "Pincode": "695562",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pacha",
            "Pincode": "695562",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paluvally",
            "Pincode": "695562",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palode",
            "Pincode": "695562",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perayam",
            "Pincode": "695562",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vattakarikkakom",
            "Pincode": "695562",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Daivapura",
            "Pincode": "695563",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Idinjar",
            "Pincode": "695563",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ilanchiyam",
            "Pincode": "695563",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panangod",
            "Pincode": "695563",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peringamala",
            "Pincode": "695563",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thennur",
            "Pincode": "695563",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aruvikara",
            "Pincode": "695564",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chekkakonam",
            "Pincode": "695564",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karakulam",
            "Pincode": "695564",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koonanvenga",
            "Pincode": "695568",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panavoor",
            "Pincode": "695568",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kollode",
            "Pincode": "695571",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Machel",
            "Pincode": "695571",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malayam",
            "Pincode": "695571",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malayinkil",
            "Pincode": "695571",
            "City": "Ernakulam",
            "District": "Ernakulam",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Amachal",
            "Pincode": "695572",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ambalathumkala",
            "Pincode": "695572",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattacode",
            "Pincode": "695572",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattakada",
            "Pincode": "695572",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuruthamcode",
            "Pincode": "695572",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mylakkara Edso",
            "Pincode": "695572",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neyyar Dam",
            "Pincode": "695572",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pantha",
            "Pincode": "695572",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Veeranakavu",
            "Pincode": "695572",
            "City": "Nedumangad",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moongode",
            "Pincode": "695573",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Perukavu",
            "Pincode": "695573",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peyad",
            "Pincode": "695573",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puliyarakonam",
            "Pincode": "695573",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vilappilsala",
            "Pincode": "695573",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalliyal",
            "Pincode": "695574",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottoor Tvm",
            "Pincode": "695574",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuttichal",
            "Pincode": "695574",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Paruthupally",
            "Pincode": "695574",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Panniyyode",
            "Pincode": "695575",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Poovachal",
            "Pincode": "695575",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Punalal",
            "Pincode": "695575",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Alinera",
            "Pincode": "695581",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Irinchayam",
            "Pincode": "695581",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kariyavattom",
            "Pincode": "695581",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pangappara",
            "Pincode": "695581",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kazhakuttom",
            "Pincode": "695582",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimanal",
            "Pincode": "695583",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kulathur",
            "Pincode": "695583",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Andoorkonam",
            "Pincode": "695584",
            "City": "Thiruvananthapuram",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Iroopara",
            "Pincode": "695584",
            "City": "Thiruvananthapuram",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattaikonam",
            "Pincode": "695584",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koithoorkonam",
            "Pincode": "695584",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pothencode",
            "Pincode": "695584",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Sainik School",
            "Pincode": "695585",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pallithura",
            "Pincode": "695586",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthenthope",
            "Pincode": "695586",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "St.Xavier S College",
            "Pincode": "695586",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chempazhanthi",
            "Pincode": "695587",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Powdikonam",
            "Pincode": "695587",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Chittattumukku Edso",
            "Pincode": "695588",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilimanur",
            "Pincode": "695601",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kilimanur Palace",
            "Pincode": "695601",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Peroor",
            "Pincode": "695601",
            "City": "Kottayam",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ponganad",
            "Pincode": "695601",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullayil",
            "Pincode": "695601",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellalur",
            "Pincode": "695601",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Madavoor Pallickal",
            "Pincode": "695602",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Malakkal",
            "Pincode": "695602",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Njarayilkonam",
            "Pincode": "695602",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Maruthikunnu",
            "Pincode": "695603",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Navaikulam",
            "Pincode": "695603",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Parakunnu",
            "Pincode": "695603",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vettiyara",
            "Pincode": "695603",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kokattukonam",
            "Pincode": "695604",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moothala",
            "Pincode": "695604",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pakalkuri",
            "Pincode": "695604",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puliyarakinam",
            "Pincode": "695604",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallambalam",
            "Pincode": "695605",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karavaram",
            "Pincode": "695605",
            "City": "Chirayinkeezhu",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Puthussermukku Edso",
            "Pincode": "695605",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakkad",
            "Pincode": "695605",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thottakkad",
            "Pincode": "695605",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Anakudi",
            "Pincode": "695606",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kalamachal",
            "Pincode": "695606",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Karimkuttikara",
            "Pincode": "695606",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kottukunnam",
            "Pincode": "695606",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nellanad",
            "Pincode": "695606",
            "City": "Nedumangad",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Valluvambram Edso",
            "Pincode": "695606",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vamanapuram",
            "Pincode": "695606",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Aliyadu",
            "Pincode": "695607",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mukkudil",
            "Pincode": "695607",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Palamkonam",
            "Pincode": "695607",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pirappancode",
            "Pincode": "695607",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pullapara",
            "Pincode": "695607",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vellumannady",
            "Pincode": "695607",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Venjaramoodu",
            "Pincode": "695607",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kallara",
            "Pincode": "695608",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kattumpuram",
            "Pincode": "695608",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kodithookiyakunnu",
            "Pincode": "695608",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kurumbayam",
            "Pincode": "695608",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kanchinada",
            "Pincode": "695609",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moonnumukku",
            "Pincode": "695609",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mylamode",
            "Pincode": "695609",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pangode",
            "Pincode": "695609",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mithirmala",
            "Pincode": "695610",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Muthuvila",
            "Pincode": "695610",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Neeramankadavu",
            "Pincode": "695610",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Manambur",
            "Pincode": "695611",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Koduvazhannur",
            "Pincode": "695612",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Pulimath",
            "Pincode": "695612",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thalikuzhi",
            "Pincode": "695612",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Adayamon",
            "Pincode": "695614",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Mulakkalthukavu",
            "Pincode": "695614",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Thattathumala",
            "Pincode": "695614",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Tulakkalathukavu",
            "Pincode": "695614",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Cheeranikara",
            "Pincode": "695615",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Konchira",
            "Pincode": "695615",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Kuthirakulam",
            "Pincode": "695615",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Moonnanakuzhy",
            "Pincode": "695615",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Vembayam",
            "Pincode": "695615",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Bharathannur",
            "Pincode": "695616",
            "City": "Trivandrum",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Nagaroor",
            "Pincode": "695618",
            "City": "#N/A",
            "District": "Trivandrum",
            "State": "Kerala"
        },
        {
            "PostOfficeName": "Ananda Bazar Patrika",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Braborne Road",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Calcutta G P O",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Council House Street",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Custom House",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khangrapatti",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lalbazar",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "New Secretariate Bldg",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "R N Mukherjee Road",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Radha Bazar",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Reserve Bank Building",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Telephone Bhavan",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Treasury Building",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "W B Assembly",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Writers Building",
            "Pincode": "700001",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Cossipore Gun Factory",
            "Pincode": "700002",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Cossipore H O",
            "Pincode": "700002",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Indian Research",
            "Pincode": "700002",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paikpara",
            "Pincode": "700002",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Postal Stores Depot",
            "Pincode": "700002",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Satchasipara",
            "Pincode": "700002",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tala",
            "Pincode": "700002",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amrita Bazar",
            "Pincode": "700003",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagh Bazar",
            "Pincode": "700003",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Girish Avenue",
            "Pincode": "700003",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Patrika",
            "Pincode": "700003",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "R G Kar M C Hospital",
            "Pincode": "700004",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyambazar",
            "Pincode": "700004",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyambazar Market",
            "Pincode": "700004",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ultadanga",
            "Pincode": "700004",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ahiritola",
            "Pincode": "700005",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hatkhola",
            "Pincode": "700005",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Beadon Street",
            "Pincode": "700006",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bidhan Sarani",
            "Pincode": "700006",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jorasanko",
            "Pincode": "700006",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Maniktala",
            "Pincode": "700006",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pathuriaghata",
            "Pincode": "700006",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sahitya Parisad",
            "Pincode": "700006",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Simla",
            "Pincode": "700006",
            "City": "Simla",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Archana",
            "Pincode": "700007",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barabazar H O",
            "Pincode": "700007",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "College Squire",
            "Pincode": "700007",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalaker Street",
            "Pincode": "700007",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Strand Road",
            "Pincode": "700007",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Vishyasabha",
            "Pincode": "700007",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barisha",
            "Pincode": "700008",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barisha",
            "Pincode": "700008",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barisha",
            "Pincode": "700008",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purba Barisha",
            "Pincode": "700008",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarani Rarsibagan",
            "Pincode": "700009",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Beleghata H O",
            "Pincode": "700010",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Joranandir",
            "Pincode": "700010",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Subhas Sarobar",
            "Pincode": "700010",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Narkeldanga",
            "Pincode": "700011",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bow Bazar",
            "Pincode": "700012",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sankaritala",
            "Pincode": "700012",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dharamtala",
            "Pincode": "700013",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mott Lane",
            "Pincode": "700013",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bamboovilla",
            "Pincode": "700014",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Intally",
            "Pincode": "700014",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Linton Street",
            "Pincode": "700014",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sealdah",
            "Pincode": "700014",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Taltala",
            "Pincode": "700014",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sales Tax Building",
            "Pincode": "700015",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Seal Lane",
            "Pincode": "700015",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tengra",
            "Pincode": "700015",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Elliot Road",
            "Pincode": "700016",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Madrassa",
            "Pincode": "700016",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Park Street H O",
            "Pincode": "700016",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Circus Avenue",
            "Pincode": "700017",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jhowtala",
            "Pincode": "700017",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Park Circus",
            "Pincode": "700017",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shakespeare Sarani",
            "Pincode": "700017",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bartala",
            "Pincode": "700018",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bartala",
            "Pincode": "700018",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rabindranagar",
            "Pincode": "700018",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ballygunge",
            "Pincode": "700019",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ballygunge R S",
            "Pincode": "700019",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ballygunge Science College",
            "Pincode": "700019",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garcha Road",
            "Pincode": "700019",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gariahat Market",
            "Pincode": "700019",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gol Park",
            "Pincode": "700019",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Archarya Jagadish",
            "Pincode": "700020",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chandra Bose Road",
            "Pincode": "700020",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gokhale Road",
            "Pincode": "700020",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Karnani Memorial Hospial",
            "Pincode": "700020",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lajpat Rai Sarani",
            "Pincode": "700020",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Fort Willium",
            "Pincode": "700021",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bakery Road",
            "Pincode": "700022",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hastings",
            "Pincode": "700022",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kidderpore",
            "Pincode": "700023",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Manstala",
            "Pincode": "700023",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Market",
            "Pincode": "700023",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raja Janakinath",
            "Pincode": "700023",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Watgunge",
            "Pincode": "700023",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garden Reach",
            "Pincode": "700024",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Keshoram Cotton Mills",
            "Pincode": "700024",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paharpur Garden",
            "Pincode": "700024",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Reach",
            "Pincode": "700024",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Trenching Grand Road",
            "Pincode": "700024",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhawanipore",
            "Pincode": "700025",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lansdown Market",
            "Pincode": "700025",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramkrishna Park",
            "Pincode": "700025",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranshet Wadi",
            "Pincode": "700025",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalighat",
            "Pincode": "700026",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalimandir",
            "Pincode": "700026",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Keoratala",
            "Pincode": "700026",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Protisthan",
            "Pincode": "700026",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramkrishna Seva",
            "Pincode": "700026",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sahannagar",
            "Pincode": "700026",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Southern Market",
            "Pincode": "700026",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alipore Bodyguard Line",
            "Pincode": "700027",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alipore Civil Court",
            "Pincode": "700027",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alipore District Board",
            "Pincode": "700027",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alipore H O",
            "Pincode": "700027",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alipore Store Yard",
            "Pincode": "700027",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chetla",
            "Pincode": "700027",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mominpore",
            "Pincode": "700027",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "National Library",
            "Pincode": "700027",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dum Dum",
            "Pincode": "700028",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dum Dum",
            "Pincode": "700028",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dum Dum",
            "Pincode": "700028",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dum Dum",
            "Pincode": "700028",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dum Dum",
            "Pincode": "700028",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dum Dum",
            "Pincode": "700028",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dum Dum",
            "Pincode": "700028",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dum Dum",
            "Pincode": "700028",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jugipara Satgachi",
            "Pincode": "700028",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jungipara Salgs Nager Bzr",
            "Pincode": "700028",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamalapur",
            "Pincode": "700028",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kumarpare",
            "Pincode": "700028",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ordnance Factory",
            "Pincode": "700028",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajabagan",
            "Pincode": "700028",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dover Lane",
            "Pincode": "700029",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lake Market",
            "Pincode": "700029",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rash Behari Avenue",
            "Pincode": "700029",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarat Bose Road",
            "Pincode": "700029",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghughudanga",
            "Pincode": "700030",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghughudanga",
            "Pincode": "700030",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghughudanga",
            "Pincode": "700030",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purbe Sinthee",
            "Pincode": "700030",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sethbagan",
            "Pincode": "700030",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhakuria",
            "Pincode": "700031",
            "City": "Dhakuria",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "K P Roy Lane",
            "Pincode": "700031",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bejoy Garh",
            "Pincode": "700032",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hossain Road",
            "Pincode": "700032",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jadavpur University",
            "Pincode": "700032",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jadavpur University",
            "Pincode": "700032",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jadavpur University",
            "Pincode": "700032",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Prince Golam",
            "Pincode": "700032",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Indrani Park",
            "Pincode": "700033",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tallygunge H O",
            "Pincode": "700033",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tollygunge Circular Road",
            "Pincode": "700033",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Behala",
            "Pincode": "700034",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Behala",
            "Pincode": "700034",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Behala",
            "Pincode": "700034",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Behala",
            "Pincode": "700034",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Behala",
            "Pincode": "700034",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Behala",
            "Pincode": "700034",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Behala Municipal Market",
            "Pincode": "700034",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Brahma Samaj Road",
            "Pincode": "700034",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jayasree Park",
            "Pincode": "700034",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Parchanantala",
            "Pincode": "700034",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Serhati",
            "Pincode": "700034",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alam Bazar",
            "Pincode": "700035",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alam Bazar",
            "Pincode": "700035",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alam Bazar",
            "Pincode": "700035",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alam Bazar",
            "Pincode": "700035",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alambazar",
            "Pincode": "700035",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ashokegarh",
            "Pincode": "700035",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bon Hooghly",
            "Pincode": "700035",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Desh Bandhu Road",
            "Pincode": "700035",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Indian Statistical Institute",
            "Pincode": "700035",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bara Nagar",
            "Pincode": "700036",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baranagar",
            "Pincode": "700036",
            "City": "Baranagar",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bengal Immunity",
            "Pincode": "700036",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgachia",
            "Pincode": "700037",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgachia Road",
            "Pincode": "700037",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Northern Avenue",
            "Pincode": "700037",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sahapur",
            "Pincode": "700038",
            "City": "Sahapur",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sahapur",
            "Pincode": "700038",
            "City": "Sahapur",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bediadanga",
            "Pincode": "700039",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Picnic Garden",
            "Pincode": "700039",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tiljala",
            "Pincode": "700039",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tiljalabazar",
            "Pincode": "700039",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Topsia",
            "Pincode": "700039",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Netajinagar",
            "Pincode": "700040",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Regent Park",
            "Pincode": "700040",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Regent Park",
            "Pincode": "700040",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Regent Park",
            "Pincode": "700040",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Russa",
            "Pincode": "700040",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paschim Putiary",
            "Pincode": "700041",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paschim Putuary",
            "Pincode": "700041",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bose Pukur Road",
            "Pincode": "700042",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kasba",
            "Pincode": "700042",
            "City": "Kasba",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kasha",
            "Pincode": "700042",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Coal Dock Road",
            "Pincode": "700043",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonai",
            "Pincode": "700043",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "South Eastern Rly",
            "Pincode": "700043",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Badartala",
            "Pincode": "700044",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Badartala",
            "Pincode": "700044",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barasahebs Hat",
            "Pincode": "700044",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barasahib S Hat",
            "Pincode": "700044",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajabagan Dok Yeard",
            "Pincode": "700044",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "La Gardens",
            "Pincode": "700045",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lake Gardens",
            "Pincode": "700045",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Abinash Choudhury Lane",
            "Pincode": "700046",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gobinda Khatik Road",
            "Pincode": "700046",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ganguly Bagan",
            "Pincode": "700047",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garia Bus Terminus",
            "Pincode": "700047",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Naktala",
            "Pincode": "700047",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Naktala",
            "Pincode": "700047",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Naktala",
            "Pincode": "700047",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Basak Bagan",
            "Pincode": "700048",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Patipukur",
            "Pincode": "700048",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sadhana Aushadhalaya Road",
            "Pincode": "700048",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shree Bhumi",
            "Pincode": "700048",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shree Bhumi",
            "Pincode": "700048",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shree Bhumi",
            "Pincode": "700048",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sree Bhumi",
            "Pincode": "700048",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nimta",
            "Pincode": "700049",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nimta",
            "Pincode": "700049",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Udaipur",
            "Pincode": "700049",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sinithee",
            "Pincode": "700050",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sinthee",
            "Pincode": "700050",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "South Sinthee",
            "Pincode": "700050",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Birati",
            "Pincode": "700051",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Birati",
            "Pincode": "700051",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Calcutta Air Port",
            "Pincode": "700052",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Calcutta Air Port N T B",
            "Pincode": "700052",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "K R Bose Sarani",
            "Pincode": "700052",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalabagan",
            "Pincode": "700053",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nalini Ranjan Avenue",
            "Pincode": "700053",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "New Alipore",
            "Pincode": "700053",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bengal Chemical",
            "Pincode": "700054",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kankurgachi",
            "Pincode": "700054",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Phulbagan",
            "Pincode": "700054",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ram Krishna Samadhi Rd",
            "Pincode": "700054",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bangur Avenue",
            "Pincode": "700055",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bangur Avenue",
            "Pincode": "700055",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bangur Avenue",
            "Pincode": "700055",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dum Dum Park",
            "Pincode": "700055",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyamnagar Dum Dum",
            "Pincode": "700055",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Basudevpur",
            "Pincode": "700056",
            "City": "Raigung",
            "District": "Uttar Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgharia H O",
            "Pincode": "700056",
            "City": "Balurghat",
            "District": "Dakshin Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgharia Ho.",
            "Pincode": "700056",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgharia Ho.",
            "Pincode": "700056",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgharia Ho.",
            "Pincode": "700056",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgharia Ho.",
            "Pincode": "700056",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgharia Ho.",
            "Pincode": "700056",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgharia Ho.",
            "Pincode": "700056",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgharia Ho.",
            "Pincode": "700056",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgharia Mohini Mills",
            "Pincode": "700056",
            "City": "Balurghat",
            "District": "Dakshin Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bidhan Nagar A E Block",
            "Pincode": "700056",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Deshapriya Nagar",
            "Pincode": "700056",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "East Belgharia",
            "Pincode": "700056",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Labony Estate",
            "Pincode": "700056",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rathtala",
            "Pincode": "700056",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "South Belgharia",
            "Pincode": "700056",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Texmaco",
            "Pincode": "700056",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ariadaha",
            "Pincode": "700057",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ariadaha",
            "Pincode": "700057",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nawadapara",
            "Pincode": "700057",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Elias Road",
            "Pincode": "700058",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamarhati",
            "Pincode": "700058",
            "City": "Kamarhati",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamarhati",
            "Pincode": "700058",
            "City": "Kamarhati",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamarhati",
            "Pincode": "700058",
            "City": "Kamarhati",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamarhati Mills",
            "Pincode": "700058",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baguiati Super Market",
            "Pincode": "700059",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Deshbandhu Nagar",
            "Pincode": "700059",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Deshbandhu Nagar",
            "Pincode": "700059",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahendra Banerjee Road",
            "Pincode": "700060",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Parnasripally",
            "Pincode": "700060",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Parnasripally",
            "Pincode": "700060",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jairampur",
            "Pincode": "700061",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kastodanga",
            "Pincode": "700061",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarsoona",
            "Pincode": "700061",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarsoona",
            "Pincode": "700061",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarsoona",
            "Pincode": "700061",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "W B G S Camp",
            "Pincode": "700062",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paschim Barisha",
            "Pincode": "700063",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Thakurpukur",
            "Pincode": "700063",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Thakurpukur",
            "Pincode": "700063",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bidhan Nagar",
            "Pincode": "700064",
            "City": "Bidhan Nagar",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bidhan Nagar",
            "Pincode": "700064",
            "City": "Bidhan Nagar",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bidhan Nagar",
            "Pincode": "700064",
            "City": "Bidhan Nagar",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bidhan Nagar",
            "Pincode": "700064",
            "City": "Bidhan Nagar",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Health Institute",
            "Pincode": "700065",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rabindra Nagar",
            "Pincode": "700065",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rabindra Nagar",
            "Pincode": "700065",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rabindranagar",
            "Pincode": "700065",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Subhas Nagar",
            "Pincode": "700065",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bidhangarh",
            "Pincode": "700066",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bidhangarh",
            "Pincode": "700066",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lily Biscuit",
            "Pincode": "700067",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ultadanga Main Road",
            "Pincode": "700067",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jodhpur Park",
            "Pincode": "700068",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jodhpur Park",
            "Pincode": "700068",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Esplanade",
            "Pincode": "700069",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Great Eastern Hotel",
            "Pincode": "700069",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Income Tax Building",
            "Pincode": "700069",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bansdroni",
            "Pincode": "700070",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Little Russel St",
            "Pincode": "700071",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Middleton Row",
            "Pincode": "700071",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Russel Street",
            "Pincode": "700071",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hindustan Building",
            "Pincode": "700072",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Princeep Street",
            "Pincode": "700072",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sooterkeen Street",
            "Pincode": "700072",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Calcutta University",
            "Pincode": "700073",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chittaranjan Avenue",
            "Pincode": "700073",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Colootola",
            "Pincode": "700073",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tiretta Bazar",
            "Pincode": "700073",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dum Dum Road",
            "Pincode": "700074",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jawpore",
            "Pincode": "700074",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Motijheel",
            "Pincode": "700074",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Motijheel",
            "Pincode": "700074",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Motijheel",
            "Pincode": "700074",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garfa",
            "Pincode": "700075",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santoshpur",
            "Pincode": "700075",
            "City": "Santoshpur",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santoshpur",
            "Pincode": "700075",
            "City": "Santoshpur",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santoshpur",
            "Pincode": "700075",
            "City": "Santoshpur",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santoshpur",
            "Pincode": "700075",
            "City": "Santoshpur",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santoshpur Avenue",
            "Pincode": "700075",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Viviekanagar",
            "Pincode": "700075",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dakshineswar",
            "Pincode": "700076",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bediapara",
            "Pincode": "700077",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haltu",
            "Pincode": "700078",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haltu",
            "Pincode": "700078",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jadavgarh",
            "Pincode": "700078",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Italgacha",
            "Pincode": "700079",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jessore Road",
            "Pincode": "700080",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mall Road",
            "Pincode": "700080",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mall Road",
            "Pincode": "700080",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajbari Colony",
            "Pincode": "700081",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajbari Colony",
            "Pincode": "700081",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haridebpur",
            "Pincode": "700082",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haridevpur",
            "Pincode": "700082",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haridevpur",
            "Pincode": "700082",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Keorapukur Bazar",
            "Pincode": "700082",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nandan Nagar",
            "Pincode": "700083",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nandannagar",
            "Pincode": "700083",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garia",
            "Pincode": "700084",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garia",
            "Pincode": "700084",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garia",
            "Pincode": "700084",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garia Garden",
            "Pincode": "700084",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamdahari",
            "Pincode": "700084",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarani",
            "Pincode": "700085",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagha Jain",
            "Pincode": "700086",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagha Jatin",
            "Pincode": "700086",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "New Market",
            "Pincode": "700087",
            "City": "Kolkata",
            "District": "Calcutta",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Brace Bridge",
            "Pincode": "700088",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Brace Bridge",
            "Pincode": "700088",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Brace Bridge",
            "Pincode": "700088",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Brace Bridge",
            "Pincode": "700088",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Brace Bridge",
            "Pincode": "700088",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Calcutta Mint",
            "Pincode": "700088",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hyderabad Road",
            "Pincode": "700088",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Taratala Road",
            "Pincode": "700088",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Telecom Factory",
            "Pincode": "700088",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalindi Housing Estate",
            "Pincode": "700089",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lake Town",
            "Pincode": "700089",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lake Town",
            "Pincode": "700089",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Netaji Colony",
            "Pincode": "700090",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Noapara",
            "Pincode": "700090",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sech Bhavan",
            "Pincode": "700091",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sech Bhawan",
            "Pincode": "700091",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Regent Estate",
            "Pincode": "700092",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Regent Estate",
            "Pincode": "700092",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purba Pitiary",
            "Pincode": "700093",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Howrah H O",
            "Pincode": "711101",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Howrah R S",
            "Pincode": "711101",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kadamtala",
            "Pincode": "711101",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khurut Road",
            "Pincode": "711101",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pachal Bazar",
            "Pincode": "711101",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchanastala",
            "Pincode": "711101",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramkrishnapur",
            "Pincode": "711101",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rosa Road",
            "Pincode": "711101",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baisnabpara Bazar",
            "Pincode": "711102",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Cows Ghat Road",
            "Pincode": "711102",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "D B Institution",
            "Pincode": "711102",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garden Lane",
            "Pincode": "711102",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Keorapara",
            "Pincode": "711102",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shibpur",
            "Pincode": "711102",
            "City": "Ghatal",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tulsi Mitra",
            "Pincode": "711102",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Andul Road",
            "Pincode": "711103",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Batiatala",
            "Pincode": "711103",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Botanic Garden",
            "Pincode": "711103",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Debendra Ganguly Road",
            "Pincode": "711103",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shalimar",
            "Pincode": "711103",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chakraberia",
            "Pincode": "711104",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chatterjeehat",
            "Pincode": "711104",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Circular Road",
            "Pincode": "711104",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ichapur Road",
            "Pincode": "711104",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Olabibitala",
            "Pincode": "711104",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramrajatala",
            "Pincode": "711104",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santragachi",
            "Pincode": "711104",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarat Chatterjee Road",
            "Pincode": "711104",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgachia Manshatala",
            "Pincode": "711105",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dasnagar",
            "Pincode": "711105",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "A Road",
            "Pincode": "711106",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bandhaghat",
            "Pincode": "711106",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhairb Dutta Lane",
            "Pincode": "711106",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bomangachi",
            "Pincode": "711106",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dharmatala Road",
            "Pincode": "711106",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hooghly Dock",
            "Pincode": "711106",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Howrah Loco Depot",
            "Pincode": "711106",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jag Ariti",
            "Pincode": "711106",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Qumaresh",
            "Pincode": "711106",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Salka H O",
            "Pincode": "711106",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghusuri",
            "Pincode": "711107",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "V C Mills",
            "Pincode": "711107",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Netaji Subhas",
            "Pincode": "711108",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Netajigarh",
            "Pincode": "711108",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bakultala",
            "Pincode": "711109",
            "City": "Canning - II",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Danesh Sk Lane",
            "Pincode": "711109",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Goaberia",
            "Pincode": "711109",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bally",
            "Pincode": "711201",
            "City": "Bally",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bally Gosamipara Road",
            "Pincode": "711201",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Daws Temple Road",
            "Pincode": "711201",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mohanlal Bhalwala Road",
            "Pincode": "711201",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belu Bazar",
            "Pincode": "711202",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belurmath",
            "Pincode": "711202",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhatta Nagar",
            "Pincode": "711203",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Abhoy Guha Road",
            "Pincode": "711204",
            "City": "kolkata",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Liluah",
            "Pincode": "711204",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shibtala",
            "Pincode": "711204",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sambay Pallay",
            "Pincode": "711205",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dankuni",
            "Pincode": "711224",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pancharule",
            "Pincode": "711225",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Udayanarayanpur",
            "Pincode": "711226",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghoshpara",
            "Pincode": "711227",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Anantapur",
            "Pincode": "711301",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Andul Mauri",
            "Pincode": "711302",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagnan",
            "Pincode": "711303",
            "City": "Bagnan",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Banipur Howrah",
            "Pincode": "711304",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bauria",
            "Pincode": "711305",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Buxarah",
            "Pincode": "711306",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chakashi",
            "Pincode": "711307",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chengail",
            "Pincode": "711308",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jogadishpurhat",
            "Pincode": "711308",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Delta Mills",
            "Pincode": "711309",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Fort Gloster",
            "Pincode": "711310",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jagaeha",
            "Pincode": "711311",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Old Jagacha",
            "Pincode": "711311",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mugkalyan",
            "Pincode": "711312",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sankrail",
            "Pincode": "711313",
            "City": "Sankrail",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyampur",
            "Pincode": "711314",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Uluberia",
            "Pincode": "711315",
            "City": "Uluberia",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Uluberia R S",
            "Pincode": "711315",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "G I Press Colony",
            "Pincode": "711321",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Old Jagacha",
            "Pincode": "711321",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchla",
            "Pincode": "711322",
            "City": "Panchla",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kona",
            "Pincode": "711323",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Samta",
            "Pincode": "711324",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panitras",
            "Pincode": "711325",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sasoti",
            "Pincode": "711326",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Howrah",
            "Pincode": "711327",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amta",
            "Pincode": "711401",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baltikuri",
            "Pincode": "711402",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bank",
            "Pincode": "711403",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bargachia",
            "Pincode": "711404",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Domjur",
            "Pincode": "711405",
            "City": "Domjur",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garalgacha",
            "Pincode": "711406",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jagatballavpur",
            "Pincode": "711408",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Makardah",
            "Pincode": "711409",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Munshirhat",
            "Pincode": "711410",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Begri",
            "Pincode": "711411",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chitrasenpur",
            "Pincode": "711412",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gazipur",
            "Pincode": "711413",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Maju",
            "Pincode": "711414",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pantihal",
            "Pincode": "711415",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Manikura",
            "Pincode": "711416",
            "City": "Howrah",
            "District": "Howrah",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chandra",
            "Pincode": "712101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chinsura Bazar",
            "Pincode": "712101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chinsura Court",
            "Pincode": "712101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chinsura H O",
            "Pincode": "712101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamarpara Bazar",
            "Pincode": "712101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pratappur",
            "Pincode": "712101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sandeswartola Jatis",
            "Pincode": "712101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chinsura Rs",
            "Pincode": "712102",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bazar Colony",
            "Pincode": "712103",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bikram Nagar Palli",
            "Pincode": "712103",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hooghly",
            "Pincode": "712103",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kapasdanga Ray",
            "Pincode": "712103",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pipulpati",
            "Pincode": "712103",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tumlipara",
            "Pincode": "712103",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Keota Lat Bagan",
            "Pincode": "712104",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sahaganj",
            "Pincode": "712104",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Buro Shibiala",
            "Pincode": "712105",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Adconagar",
            "Pincode": "712121",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Badenganj",
            "Pincode": "712122",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bandel Junction",
            "Pincode": "712123",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhadreswar",
            "Pincode": "712124",
            "City": "Bhadreswar",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajabazar",
            "Pincode": "712125",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Telinipara",
            "Pincode": "712125",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Boinehi",
            "Pincode": "712134",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Boinchi Gram",
            "Pincode": "712135",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barasat",
            "Pincode": "712136",
            "City": "Barasat",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Borai Chanditala",
            "Pincode": "712136",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chandan Nagar",
            "Pincode": "712136",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chandan Nagar R S",
            "Pincode": "712136",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kundughat",
            "Pincode": "712136",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Palpara",
            "Pincode": "712136",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Temata",
            "Pincode": "712136",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gondalpara",
            "Pincode": "712137",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khalisani",
            "Pincode": "712138",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Llsoba Mondlai",
            "Pincode": "712146",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Itachuna",
            "Pincode": "712147",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Magra",
            "Pincode": "712148",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pandua",
            "Pincode": "712149",
            "City": "Pandua",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pravashnagar",
            "Pincode": "712149",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rabindranagar",
            "Pincode": "712150",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raijamna",
            "Pincode": "712151",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rameswarpur",
            "Pincode": "712152",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kantradih",
            "Pincode": "712153",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramnathpur",
            "Pincode": "712153",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Polba",
            "Pincode": "712154",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ayemanawabpur",
            "Pincode": "712155",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Beloon",
            "Pincode": "712156",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khanyan",
            "Pincode": "712157",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Simlagarh",
            "Pincode": "712158",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalbazar",
            "Pincode": "712201",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Manicktala Bazar",
            "Pincode": "712201",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Serampore Court",
            "Pincode": "712201",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Serampore H O",
            "Pincode": "712201",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahes-I",
            "Pincode": "712202",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mallickpara",
            "Pincode": "712203",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chatra Hooghly",
            "Pincode": "712204",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Morepukur",
            "Pincode": "712205",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Alloy Steel",
            "Pincode": "712208",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Asp Sb",
            "Pincode": "712208",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Briek Field",
            "Pincode": "712221",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baidvabati",
            "Pincode": "712222",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Champdani",
            "Pincode": "712222",
            "City": "Champdani",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kumarpara",
            "Pincode": "712222",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sheoraphuli",
            "Pincode": "712223",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhadrakali",
            "Pincode": "712232",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hind Motor",
            "Pincode": "712233",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanaipur",
            "Pincode": "712234",
            "City": "Kanaipur",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Cripar Road",
            "Pincode": "712235",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Konnagar",
            "Pincode": "712235",
            "City": "Konnagar",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Makhla",
            "Pincode": "712245",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabagram",
            "Pincode": "712246",
            "City": "Nabagram",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raghunathpur",
            "Pincode": "712247",
            "City": "Raghunathpur",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bangurpark",
            "Pincode": "712248",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gandhisarak",
            "Pincode": "712248",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahesh-Ii",
            "Pincode": "712248",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Masjidlane",
            "Pincode": "712248",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rishra",
            "Pincode": "712248",
            "City": "Rishra",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raiendra Avenue",
            "Pincode": "712258",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Uttarpara",
            "Pincode": "712258",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Uttarpara Bazar",
            "Pincode": "712258",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhanderhati",
            "Pincode": "712301",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhaniakhali",
            "Pincode": "712302",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gurup",
            "Pincode": "712303",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Janai",
            "Pincode": "712304",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Puinan",
            "Pincode": "712305",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Begampur",
            "Pincode": "712306",
            "City": "Begampur",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pownan",
            "Pincode": "712307",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khanpur",
            "Pincode": "712308",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belmuri",
            "Pincode": "712309",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chittaranjan Township",
            "Pincode": "712365",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Champadanga",
            "Pincode": "712401",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dasghara",
            "Pincode": "712402",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haripal",
            "Pincode": "712403",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jangipara",
            "Pincode": "712404",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khamar Chandi",
            "Pincode": "712405",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khanakul",
            "Pincode": "712406",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lllahipur",
            "Pincode": "712407",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nalikul",
            "Pincode": "712407",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajbalhat",
            "Pincode": "712408",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Singur",
            "Pincode": "712409",
            "City": "Singur",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "712411",
            "City": "Ramnagar",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Helan",
            "Pincode": "712412",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mayapur",
            "Pincode": "712413",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Deulpara",
            "Pincode": "712414",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Saidpur",
            "Pincode": "712415",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Natibpur",
            "Pincode": "712416",
            "City": "Natibpur",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajhati Bandar",
            "Pincode": "712417",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pargopalnagar",
            "Pincode": "712418",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jangalpara",
            "Pincode": "712419",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Molcypur",
            "Pincode": "712420",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mainan",
            "Pincode": "712421",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Minnan",
            "Pincode": "712421",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pratapnagar",
            "Pincode": "712422",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gopinagar",
            "Pincode": "712423",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Antpar",
            "Pincode": "712424",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishnagar",
            "Pincode": "712425",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Prasadpur",
            "Pincode": "712426",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Keshabpur",
            "Pincode": "712428",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rauth Khana",
            "Pincode": "712429",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balagarh",
            "Pincode": "712501",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bansberia",
            "Pincode": "712502",
            "City": "Bansberia",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bansberia Bazar",
            "Pincode": "712502",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shibpur Bansberia",
            "Pincode": "712502",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tribeni",
            "Pincode": "712503",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chandrahati",
            "Pincode": "712504",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Guptipara",
            "Pincode": "712512",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nayasarai",
            "Pincode": "712513",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sripur Bazar",
            "Pincode": "712514",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khamar Gachi",
            "Pincode": "712515",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arambagh Court",
            "Pincode": "712601",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arambagh H O",
            "Pincode": "712601",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bishnupur",
            "Pincode": "712601",
            "City": "Bishnupur",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishnapur",
            "Pincode": "712601",
            "City": "Krishnapur",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nutanbazar",
            "Pincode": "712601",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bengai",
            "Pincode": "712611",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamarpukur",
            "Pincode": "712612",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gourhati",
            "Pincode": "712613",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Goghat",
            "Pincode": "712614",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Batanal",
            "Pincode": "712615",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balidiwanganj",
            "Pincode": "712616",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baradangal",
            "Pincode": "712617",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mosat",
            "Pincode": "712701",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chanditala",
            "Pincode": "712702",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nawabpur",
            "Pincode": "712703",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kumirmora",
            "Pincode": "712704",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kristorampur",
            "Pincode": "712705",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sheekhala",
            "Pincode": "712706",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pappakudi",
            "Pincode": "712906",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Agricultural Firm",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bajepratappur",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Burdwan Bar Library",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Burdwan District",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Burdwan H O",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Burdwan Medical College",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Burdwan R S",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Burdwan University",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khalui Bill",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nutanpalli",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranisayar",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sadhanpur",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "School Board",
            "Pincode": "713101",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamalakanta Kalibari",
            "Pincode": "713102",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kotalhat",
            "Pincode": "713102",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nutanganj",
            "Pincode": "713102",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chotonilpur",
            "Pincode": "713103",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghordourchati",
            "Pincode": "713103",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ichlabad",
            "Pincode": "713103",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sadarghat",
            "Pincode": "713103",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sripalli",
            "Pincode": "713103",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Burdwan Rajbati",
            "Pincode": "713104",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Golapbag",
            "Pincode": "713104",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Harisava",
            "Pincode": "713104",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sankaripukur",
            "Pincode": "713104",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarbamangalabari",
            "Pincode": "713104",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Aruar",
            "Pincode": "713121",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baidyapur",
            "Pincode": "713122",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Banwaribad Raj",
            "Pincode": "713123",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barsul Unnayani",
            "Pincode": "713124",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhatar",
            "Pincode": "713125",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhedia",
            "Pincode": "713126",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bonpas",
            "Pincode": "713127",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghuskara",
            "Pincode": "713128",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghuskara New Town",
            "Pincode": "713128",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kandra",
            "Pincode": "713129",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Atuhatpara",
            "Pincode": "713130",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Katwa Bazar",
            "Pincode": "713130",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Katwa College",
            "Pincode": "713130",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Katwa H O",
            "Pincode": "713130",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Katwa Station Bazar",
            "Pincode": "713130",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ketugram",
            "Pincode": "713140",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khana Jn",
            "Pincode": "713141",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khandaghosh",
            "Pincode": "713142",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Koychar",
            "Pincode": "713143",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mankar",
            "Pincode": "713144",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Manteswar",
            "Pincode": "713145",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bamunpara",
            "Pincode": "713146",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Memari",
            "Pincode": "713146",
            "City": "Memari",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Memari Bazar",
            "Pincode": "713146",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nutanhat",
            "Pincode": "713147",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panagarh Bazar",
            "Pincode": "713148",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Saktigarh",
            "Pincode": "713149",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Srikhanda",
            "Pincode": "713150",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rasulpur",
            "Pincode": "713151",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bannabagram",
            "Pincode": "713152",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhatkunda",
            "Pincode": "713153",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amadpur",
            "Pincode": "713154",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amarargarh",
            "Pincode": "713155",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Aushgram",
            "Pincode": "713156",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Akalpoush",
            "Pincode": "713157",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barabelun",
            "Pincode": "713158",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gonpur",
            "Pincode": "713160",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Galatun",
            "Pincode": "713161",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hatkriti Nagar",
            "Pincode": "713162",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khano",
            "Pincode": "713164",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nasigram",
            "Pincode": "713165",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabagram",
            "Pincode": "713166",
            "City": "Nabagram",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Orgram",
            "Pincode": "713167",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hargram",
            "Pincode": "713168",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paharhati",
            "Pincode": "713168",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shilampur",
            "Pincode": "713169",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Singerkone",
            "Pincode": "713170",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Suata",
            "Pincode": "713171",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Uniatatarpur",
            "Pincode": "713173",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mangalkote",
            "Pincode": "713174",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur C",
            "Pincode": "713201",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur H O",
            "Pincode": "713201",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Rs",
            "Pincode": "713201",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Zone Colony",
            "Pincode": "713201",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dakshin Dhadka",
            "Pincode": "713202",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur B Zone",
            "Pincode": "713202",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Coke Oven",
            "Pincode": "713202",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jhingrimahalla",
            "Pincode": "713202",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Palas Bagan",
            "Pincode": "713202",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Railpar",
            "Pincode": "713202",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Steel Project",
            "Pincode": "713203",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Steel Project St",
            "Pincode": "713203",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Benachity Market",
            "Pincode": "713204",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Steel Town West",
            "Pincode": "713204",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Steel Town East",
            "Pincode": "713205",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "A B V Township Durgapur",
            "Pincode": "713206",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Thermal Power Stn",
            "Pincode": "713207",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur City Centre",
            "Pincode": "713209",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Regional Engg College",
            "Pincode": "713209",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "M G Avenue",
            "Pincode": "713209",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Plant Durgapur",
            "Pincode": "713210",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "V K Nagar",
            "Pincode": "713210",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur",
            "Pincode": "713211",
            "City": "Durgapur",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bidhan Nagar Bdn",
            "Pincode": "713212",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Benachiti",
            "Pincode": "713213",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amravati",
            "Pincode": "713214",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur C R P F Camp",
            "Pincode": "713214",
            "City": "Medinipur",
            "District": "Medinipur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Angadpur",
            "Pincode": "713215",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgapur Chemical",
            "Pincode": "713215",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Asansol Bazar",
            "Pincode": "713301",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Asansol H O",
            "Pincode": "713301",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hotton Road",
            "Pincode": "713301",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "S B Gorai Road",
            "Pincode": "713301",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mohisila Colony",
            "Pincode": "713303",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rambandhutala",
            "Pincode": "713303",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "S D Hospital",
            "Pincode": "713303",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ushagram",
            "Pincode": "713303",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Asansol Court",
            "Pincode": "713304",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hill View",
            "Pincode": "713304",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kumarpur",
            "Pincode": "713304",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Upper Chellidanga",
            "Pincode": "713304",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Andal",
            "Pincode": "713321",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Andal South Bazar",
            "Pincode": "713321",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bahula",
            "Pincode": "713322",
            "City": "Bahula",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ballavpur",
            "Pincode": "713323",
            "City": "Ballavpur",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barakar",
            "Pincode": "713324",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Begunia Bazar",
            "Pincode": "713324",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Burnpur",
            "Pincode": "713325",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Burnpur Market",
            "Pincode": "713325",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Burnpur Works",
            "Pincode": "713325",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Narsinghbandh",
            "Pincode": "713325",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rahamatdanga",
            "Pincode": "713325",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rambandh",
            "Pincode": "713325",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santinagar",
            "Pincode": "713325",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Choto Dighari",
            "Pincode": "713326",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Charanpur",
            "Pincode": "713330",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amladehi",
            "Pincode": "713331",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chittaranjan",
            "Pincode": "713331",
            "City": "Chittaranjan",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sinjuri",
            "Pincode": "713331",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Debchand Nagar",
            "Pincode": "713332",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Disergarh",
            "Pincode": "713333",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Domohan Bazar",
            "Pincode": "713334",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hindustan Cable",
            "Pincode": "713335",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jamuriahat",
            "Pincode": "713336",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jaykaynagar",
            "Pincode": "713337",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kajoragram",
            "Pincode": "713338",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalipahari",
            "Pincode": "713339",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalla Cent Hospital",
            "Pincode": "713340",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanyapur",
            "Pincode": "713341",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kendra",
            "Pincode": "713342",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kendua",
            "Pincode": "713343",
            "City": "Kendua",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kulti",
            "Pincode": "713343",
            "City": "Kulti",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nandi",
            "Pincode": "713344",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Oyaria",
            "Pincode": "713345",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pandaveswar",
            "Pincode": "713346",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Karsuli Bazar",
            "Pincode": "713347",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raniganj H O",
            "Pincode": "713347",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Salanpur",
            "Pincode": "713357",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amarasota",
            "Pincode": "713358",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Searsol Rajbari",
            "Pincode": "713358",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Neamatpur",
            "Pincode": "713359",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sitarampur",
            "Pincode": "713359",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sundarchak",
            "Pincode": "713360",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Surjanagar",
            "Pincode": "713361",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Toposi",
            "Pincode": "713362",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ukhra",
            "Pincode": "713363",
            "City": "Ukhra",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ukhra Puratan Hattala",
            "Pincode": "713363",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rupnarayanpur Bazar",
            "Pincode": "713364",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barabani",
            "Pincode": "713366",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baradhemo",
            "Pincode": "713367",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Churulia",
            "Pincode": "713368",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalyaneswari",
            "Pincode": "713369",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nengha",
            "Pincode": "713370",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Niramay Sanatorium",
            "Pincode": "713370",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mithani",
            "Pincode": "713371",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Radhanagar Rly Colony",
            "Pincode": "713372",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sripur Bazar",
            "Pincode": "713373",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhadurpur",
            "Pincode": "713374",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Benali",
            "Pincode": "713375",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhandadihi",
            "Pincode": "713376",
            "City": "Dhandadihi",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gour Bazar",
            "Pincode": "713377",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haripur",
            "Pincode": "713378",
            "City": "Haripur",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jemahari",
            "Pincode": "713379",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kendra",
            "Pincode": "713380",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nutandanga",
            "Pincode": "713381",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Parascole",
            "Pincode": "713382",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Satgram",
            "Pincode": "713383",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Parasea",
            "Pincode": "713384",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Landoha",
            "Pincode": "713385",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gopinathpur Asansol",
            "Pincode": "713386",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nadiha",
            "Pincode": "713387",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ajhapur",
            "Pincode": "713401",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arjunpur Bdn",
            "Pincode": "713402",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Budbud",
            "Pincode": "713403",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chakdighi",
            "Pincode": "713404",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhatrigram",
            "Pincode": "713405",
            "City": "Dhatrigram",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Galsi",
            "Pincode": "713406",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hatgobindapur",
            "Pincode": "713407",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jamalpur",
            "Pincode": "713408",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baramitrapara",
            "Pincode": "713409",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhaduriapara",
            "Pincode": "713409",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalna",
            "Pincode": "713409",
            "City": "Kalna",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalna Court",
            "Pincode": "713409",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Muraripur",
            "Pincode": "713419",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panagarh",
            "Pincode": "713420",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raina",
            "Pincode": "713421",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Satgachia",
            "Pincode": "713422",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sehara",
            "Pincode": "713423",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyamsundar",
            "Pincode": "713424",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyamsundarpur",
            "Pincode": "713424",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Simlon",
            "Pincode": "713425",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mandalgram",
            "Pincode": "713426",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Uchalon",
            "Pincode": "713427",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Adrahati",
            "Pincode": "713428",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barapalason",
            "Pincode": "713429",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bohar",
            "Pincode": "713430",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bakta",
            "Pincode": "713431",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhuri",
            "Pincode": "713432",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ura",
            "Pincode": "713433",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nibhuji Bazar",
            "Pincode": "713434",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagnapara",
            "Pincode": "713501",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dainhat",
            "Pincode": "713502",
            "City": "Dainhat",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Narayanpur",
            "Pincode": "713512",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Petuli",
            "Pincode": "713512",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purbasthali",
            "Pincode": "713513",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Singhi",
            "Pincode": "713514",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gangatikuri",
            "Pincode": "713515",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panuhat",
            "Pincode": "713516",
            "City": "Panuhat",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sudpur",
            "Pincode": "713517",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khajurdihi",
            "Pincode": "713518",
            "City": "Bardhaman",
            "District": "Bardhaman",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bibiganj",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Boxibazar",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Habibpur",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapore Collectorate",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapore Court",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapore Dist",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapore H O",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapore Sitala",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapur Ho.",
            "Pincode": "721101",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapur Ho.",
            "Pincode": "721101",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapur Ho.",
            "Pincode": "721101",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapur Ho.",
            "Pincode": "721101",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapur Ho.",
            "Pincode": "721101",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapur Ho.",
            "Pincode": "721101",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapur Ho.",
            "Pincode": "721101",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Midnapur Ho.",
            "Pincode": "721101",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nutan Bazar",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "School Board",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tantigeria",
            "Pincode": "721101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Vidyasagar University",
            "Pincode": "721102",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amlagora",
            "Pincode": "721121",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amlagord",
            "Pincode": "721121",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Anandapur",
            "Pincode": "721122",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagri Krishnagar",
            "Pincode": "721123",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balichak",
            "Pincode": "721124",
            "City": "Balichak",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baligeria",
            "Pincode": "721125",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Debra Bazar",
            "Pincode": "721126",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garhbeta",
            "Pincode": "721127",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Goaltore",
            "Pincode": "721128",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Godapeasal",
            "Pincode": "721129",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gopal Nagar",
            "Pincode": "721130",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Keshfary",
            "Pincode": "721133",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Keshiary",
            "Pincode": "721133",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kolaghat",
            "Pincode": "721134",
            "City": "Kolaghat",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kolaghat",
            "Pincode": "721134",
            "City": "Kolaghat",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kolaghat",
            "Pincode": "721134",
            "City": "Kolaghat",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kolaghat",
            "Pincode": "721134",
            "City": "Kolaghat",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kolaghat",
            "Pincode": "721134",
            "City": "Kolaghat",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kolaghat Nutan Bazar",
            "Pincode": "721134",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kolaghat Rly Station",
            "Pincode": "721134",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kolghat Thermal",
            "Pincode": "721134",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paikpari",
            "Pincode": "721134",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Power Project",
            "Pincode": "721134",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kultikri",
            "Pincode": "721135",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lowada",
            "Pincode": "721136",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lowada",
            "Pincode": "721136",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "K T P P",
            "Pincode": "721137",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Machada",
            "Pincode": "721137",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Macheda",
            "Pincode": "721137",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nayagram",
            "Pincode": "721138",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nayagram",
            "Pincode": "721138",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balidangri",
            "Pincode": "721139",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panskura",
            "Pincode": "721139",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pingla",
            "Pincode": "721140",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pingla",
            "Pincode": "721140",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramgarh",
            "Pincode": "721141",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramgarh",
            "Pincode": "721141",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramtarakhat",
            "Pincode": "721142",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramtarakhat",
            "Pincode": "721142",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sabong",
            "Pincode": "721144",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Subeng",
            "Pincode": "721144",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Salua",
            "Pincode": "721145",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sekandari",
            "Pincode": "721146",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sekandari",
            "Pincode": "721146",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Salbani",
            "Pincode": "721147",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Salbani",
            "Pincode": "721147",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Uttar Santan Chak",
            "Pincode": "721147",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kheput",
            "Pincode": "721148",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kheput",
            "Pincode": "721148",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rohini",
            "Pincode": "721148",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rohini",
            "Pincode": "721148",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Madpur",
            "Pincode": "721149",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Keshpur",
            "Pincode": "721150",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Keshpur",
            "Pincode": "721150",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhogpur",
            "Pincode": "721151",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhogpur",
            "Pincode": "721151",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panskura R S",
            "Pincode": "721152",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panskurah R.S.",
            "Pincode": "721152",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Joteghanashyam",
            "Pincode": "721153",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pulrita",
            "Pincode": "721154",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pulsita",
            "Pincode": "721154",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalchak",
            "Pincode": "721155",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalchak",
            "Pincode": "721155",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Marhtala",
            "Pincode": "721156",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Marhtala",
            "Pincode": "721156",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hoomgarh",
            "Pincode": "721157",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hoomgarh",
            "Pincode": "721157",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baishnabchak",
            "Pincode": "721158",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baishnali Chak",
            "Pincode": "721158",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharika Mathani",
            "Pincode": "721159",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharikamathani",
            "Pincode": "721159",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Radhamohanpur",
            "Pincode": "721160",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Radhmohanpur",
            "Pincode": "721160",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jamna",
            "Pincode": "721161",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mohar",
            "Pincode": "721161",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chakoor Singha",
            "Pincode": "721162",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Brahmansasan",
            "Pincode": "721163",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arjuni",
            "Pincode": "721164",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharkusma",
            "Pincode": "721165",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lutunia",
            "Pincode": "721166",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dalpara",
            "Pincode": "721167",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Palpara",
            "Pincode": "721167",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Siddha",
            "Pincode": "721168",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyamsundar Patna",
            "Pincode": "721169",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonakhali",
            "Pincode": "721170",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonakhali",
            "Pincode": "721170",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kolaghat",
            "Pincode": "721171",
            "City": "Kolaghat",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chandrakonda",
            "Pincode": "721201",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dapur",
            "Pincode": "721211",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghatal",
            "Pincode": "721212",
            "City": "Ghatal",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharar",
            "Pincode": "721222",
            "City": "Kharar",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khirpal",
            "Pincode": "721232",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramjibanpur",
            "Pincode": "721242",
            "City": "Ramjibanpur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sanatorium Digri",
            "Pincode": "721252",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sat Bankura",
            "Pincode": "721253",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jhakra",
            "Pincode": "721254",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Birsingha",
            "Pincode": "721256",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nayabasat",
            "Pincode": "721257",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Guidaha",
            "Pincode": "721258",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nolbana",
            "Pincode": "721259",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Neradaul",
            "Pincode": "721260",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharagpur",
            "Pincode": "721301",
            "City": "Kharagpur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharagpur",
            "Pincode": "721301",
            "City": "Kharagpur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharagpur",
            "Pincode": "721301",
            "City": "Kharagpur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharagpur",
            "Pincode": "721301",
            "City": "Kharagpur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharagpur Technology",
            "Pincode": "721302",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalaikunda A.F.",
            "Pincode": "721303",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nimpura",
            "Pincode": "721304",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Inda",
            "Pincode": "721305",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hilli",
            "Pincode": "721306",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mathurakati",
            "Pincode": "721306",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Old Khargtpur",
            "Pincode": "721307",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Contai Ho.",
            "Pincode": "721401",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Contai Ho.",
            "Pincode": "721401",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Contai Ho.",
            "Pincode": "721401",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Contai Ho.",
            "Pincode": "721401",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Contai Ho.",
            "Pincode": "721401",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Contai Ho.",
            "Pincode": "721401",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Contai Ho.",
            "Pincode": "721401",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baita Bazar",
            "Pincode": "721421",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balishai",
            "Pincode": "721423",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belda",
            "Pincode": "721424",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khukurdaha",
            "Pincode": "721424",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhupatai Nagar",
            "Pincode": "721425",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Danton",
            "Pincode": "721426",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Deulpara",
            "Pincode": "721427",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Digha",
            "Pincode": "721428",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Egra",
            "Pincode": "721429",
            "City": "Egra",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haria",
            "Pincode": "721430",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Janka",
            "Pincode": "721431",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalagachia",
            "Pincode": "721432",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khalisha Bhanga",
            "Pincode": "721433",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mangalamaro",
            "Pincode": "721434",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Menkapur",
            "Pincode": "721435",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mohanpur",
            "Pincode": "721436",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Narayanagarh",
            "Pincode": "721437",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchetgarh",
            "Pincode": "721438",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pataspur",
            "Pincode": "721439",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pratapdighi",
            "Pincode": "721440",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "721441",
            "City": "Ramnagar",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balighai",
            "Pincode": "721442",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Basantia",
            "Pincode": "721442",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jahalda",
            "Pincode": "721443",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nacginda Bazar",
            "Pincode": "721444",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Naoginda Bazar",
            "Pincode": "721444",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khakurda",
            "Pincode": "721445",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sagareswar",
            "Pincode": "721446",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchrol",
            "Pincode": "721447",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paniparul",
            "Pincode": "721448",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Marisda",
            "Pincode": "721449",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Juneput",
            "Pincode": "721450",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nekursini",
            "Pincode": "721451",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Satmite",
            "Pincode": "721452",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Depal",
            "Pincode": "721453",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amarshi",
            "Pincode": "721454",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chaukola",
            "Pincode": "721455",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Argoal",
            "Pincode": "721456",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gomunda",
            "Pincode": "721457",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonakania",
            "Pincode": "721459",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jamirapalgarh",
            "Pincode": "721460",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barajaballavpur",
            "Pincode": "721462",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Brajaballavpur",
            "Pincode": "721462",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dakshin Danki",
            "Pincode": "721464",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pausi",
            "Pincode": "721465",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sauri",
            "Pincode": "721466",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Daipara",
            "Pincode": "721467",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dasagram",
            "Pincode": "721467",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balpahari",
            "Pincode": "721501",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Binpur",
            "Pincode": "721502",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chilkigarh",
            "Pincode": "721503",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gidni",
            "Pincode": "721505",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gopiballavpur",
            "Pincode": "721506",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jhargram Ho.",
            "Pincode": "721507",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jhargram Ho.",
            "Pincode": "721507",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Manikpara",
            "Pincode": "721513",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sevayatan",
            "Pincode": "721514",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Silda",
            "Pincode": "721515",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lalgarh",
            "Pincode": "721516",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garh Salbari",
            "Pincode": "721518",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Andharia",
            "Pincode": "721519",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Topsia",
            "Pincode": "721577",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhagwanpur",
            "Pincode": "721601",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgachak",
            "Pincode": "721602",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgachak",
            "Pincode": "721602",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Geonkhali",
            "Pincode": "721603",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haldia",
            "Pincode": "721604",
            "City": "Haldia",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haldia Port",
            "Pincode": "721605",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haldia Oil Refinery",
            "Pincode": "721606",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haldia Oil Refinery",
            "Pincode": "721606",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haldia Township",
            "Pincode": "721607",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hanschora",
            "Pincode": "721625",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kajligarh",
            "Pincode": "721626",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kelornal",
            "Pincode": "721627",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahishadal",
            "Pincode": "721628",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Moyna",
            "Pincode": "721629",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Naikuri",
            "Pincode": "721630",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nandigram",
            "Pincode": "721631",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nandakumar",
            "Pincode": "721632",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Narghat",
            "Pincode": "721633",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raghunathbari",
            "Pincode": "721634",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sutahata",
            "Pincode": "721635",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tamluk Ho.",
            "Pincode": "721636",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tamluk Ho.",
            "Pincode": "721636",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tamluk Ho.",
            "Pincode": "721636",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tamluk Ho.",
            "Pincode": "721636",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tamluk Ho.",
            "Pincode": "721636",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tamluk Ho.",
            "Pincode": "721636",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalindi",
            "Pincode": "721641",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arangiklarana",
            "Pincode": "721642",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khanchi",
            "Pincode": "721643",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paramanandapur",
            "Pincode": "721644",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chaitanyapur",
            "Pincode": "721645",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tekhali Bazar",
            "Pincode": "721646",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramchandrapur",
            "Pincode": "721647",
            "City": "Ramchandrapur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bybattarhat",
            "Pincode": "721648",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mirikpur",
            "Pincode": "721649",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Reapara",
            "Pincode": "721650",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sri Rampur Midnapur",
            "Pincode": "721651",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kumar Chak",
            "Pincode": "721652",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chanserpur",
            "Pincode": "721653",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lakhya",
            "Pincode": "721654",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kismat Bajkul",
            "Pincode": "721655",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Terapakhia",
            "Pincode": "721656",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Debhog",
            "Pincode": "721657",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kukrahati",
            "Pincode": "721658",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mathchandipur",
            "Pincode": "721659",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Natsal",
            "Pincode": "721660",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gopinathpur",
            "Pincode": "721661",
            "City": "Gopinathpur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Taj Nagr",
            "Pincode": "721662",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dudkumrahat",
            "Pincode": "721663",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Norghat",
            "Pincode": "721663",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalyan Chak",
            "Pincode": "721665",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chak Dwipa",
            "Pincode": "721666",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paichak",
            "Pincode": "721667",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raichak",
            "Pincode": "721667",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Demorihat",
            "Pincode": "721668",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Narghat L/S",
            "Pincode": "721669",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Deulpota",
            "Pincode": "721670",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bankura District",
            "Pincode": "722101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bankura H O",
            "Pincode": "722101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Feeder Road",
            "Pincode": "722101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lalbazar",
            "Pincode": "722101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lokepur",
            "Pincode": "722101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nutanchati",
            "Pincode": "722101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pilgrim Road",
            "Pincode": "722101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "School Board",
            "Pincode": "722101",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kenduadihi",
            "Pincode": "722102",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lakshmi Sagar",
            "Pincode": "722107",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bheduasole",
            "Pincode": "722121",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bishnupur Bankura",
            "Pincode": "722122",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bishnupur Station Road",
            "Pincode": "722122",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lalbandh",
            "Pincode": "722122",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rasikganj",
            "Pincode": "722122",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chatna",
            "Pincode": "722132",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ganga Jalghati",
            "Pincode": "722133",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Indpur",
            "Pincode": "722133",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garh Raipur",
            "Pincode": "722134",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gorabari",
            "Pincode": "722135",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jhanti Pahari",
            "Pincode": "722137",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Joypur",
            "Pincode": "722138",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kenjakura",
            "Pincode": "722139",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khatra",
            "Pincode": "722140",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kotalpur",
            "Pincode": "722141",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Maliara",
            "Pincode": "722142",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Majia",
            "Pincode": "722143",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mejia",
            "Pincode": "722143",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Onda",
            "Pincode": "722144",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Peardola",
            "Pincode": "722145",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Salua",
            "Pincode": "722145",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajagram",
            "Pincode": "722146",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nischintapur",
            "Pincode": "722147",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramesagar",
            "Pincode": "722147",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mogra",
            "Pincode": "722148",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranibandh",
            "Pincode": "722148",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sabrakone",
            "Pincode": "722149",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sagar Bhanga Colony",
            "Pincode": "722149",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarenga",
            "Pincode": "722150",
            "City": "Sarenga",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Simlapal",
            "Pincode": "722151",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Taldangra",
            "Pincode": "722152",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tiluri",
            "Pincode": "722153",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Galia",
            "Pincode": "722154",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kesiakole",
            "Pincode": "722155",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchmura",
            "Pincode": "722156",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bon Radhanagar",
            "Pincode": "722157",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Saltora",
            "Pincode": "722158",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamalpur",
            "Pincode": "722159",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Akui",
            "Pincode": "722201",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Borjora",
            "Pincode": "722202",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Beliatore",
            "Pincode": "722203",
            "City": "Beliatore",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hatasuria",
            "Pincode": "722204",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Indas",
            "Pincode": "722205",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Patrasayer",
            "Pincode": "722206",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonamukhi",
            "Pincode": "722207",
            "City": "Sonamukhi",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonamukhi Rathtala",
            "Pincode": "722207",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pakhanna",
            "Pincode": "722208",
            "City": "Bankura",
            "District": "Bankura",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jindaru",
            "Pincode": "722213",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purulia Ho.",
            "Pincode": "723101",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purulia Ho.",
            "Pincode": "723101",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purulia Ho.",
            "Pincode": "723101",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purulia Ho.",
            "Pincode": "723101",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purulia Ho.",
            "Pincode": "723101",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dulminadiha",
            "Pincode": "723102",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Namopara",
            "Pincode": "723103",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Adra",
            "Pincode": "723121",
            "City": "Adra",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Anara Rs",
            "Pincode": "723126",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barabhu",
            "Pincode": "723127",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balakdih",
            "Pincode": "723128",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bundwan",
            "Pincode": "723129",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hura",
            "Pincode": "723130",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Man Bazar",
            "Pincode": "723131",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchakotraj",
            "Pincode": "723132",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raghunathpur",
            "Pincode": "723133",
            "City": "Raghunathpur",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rangadip",
            "Pincode": "723143",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramachandrapur Ashram",
            "Pincode": "723144",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santaldoh",
            "Pincode": "723145",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santaldih Thermal Plant",
            "Pincode": "723146",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hutmura",
            "Pincode": "723148",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mangria",
            "Pincode": "723149",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Neturia",
            "Pincode": "723150",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Puncha",
            "Pincode": "723151",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagh Mandi",
            "Pincode": "723152",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sirkabad",
            "Pincode": "723154",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Para",
            "Pincode": "723155",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Muradi",
            "Pincode": "723156",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santuri",
            "Pincode": "723157",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chelyama",
            "Pincode": "723158",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gariphusra",
            "Pincode": "723159",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramkanali",
            "Pincode": "723160",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bargola",
            "Pincode": "723161",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dubra",
            "Pincode": "723162",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chharrah",
            "Pincode": "723163",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalapathar",
            "Pincode": "723164",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lakshanpur",
            "Pincode": "723165",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arrah",
            "Pincode": "723166",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lagda",
            "Pincode": "723167",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Manihara",
            "Pincode": "723168",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garhi Jaipur",
            "Pincode": "723201",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jhalda",
            "Pincode": "723202",
            "City": "Jhalda",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tulin",
            "Pincode": "723212",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Begunkodar",
            "Pincode": "723214",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arsha",
            "Pincode": "723216",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Iloo",
            "Pincode": "723315",
            "City": "Puruliya",
            "District": "Purulia",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baruipara",
            "Pincode": "731101",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Birbhum Collectorate",
            "Pincode": "731101",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pranabanandapalli",
            "Pincode": "731101",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonatore",
            "Pincode": "731101",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Suri Bazar",
            "Pincode": "731101",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Suri College",
            "Pincode": "731101",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Suri H O",
            "Pincode": "731101",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Surl D S B",
            "Pincode": "731101",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hatjan Bazar",
            "Pincode": "731102",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barabagan",
            "Pincode": "731103",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Abinashpur",
            "Pincode": "731121",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barhra",
            "Pincode": "731122",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dubrajpur",
            "Pincode": "731123",
            "City": "Dubrajpur",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jangal Dubrajpur",
            "Pincode": "731123",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hetampur Rajbati",
            "Pincode": "731124",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khoyrasole",
            "Pincode": "731125",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Karidhya",
            "Pincode": "731126",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mohammad Bazar",
            "Pincode": "731127",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Giridanga",
            "Pincode": "731128",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purandarpur",
            "Pincode": "731129",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajnagar",
            "Pincode": "731130",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tantipara",
            "Pincode": "731131",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Township",
            "Pincode": "731132",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchrahat",
            "Pincode": "731133",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bakreswar",
            "Pincode": "731134",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panuria",
            "Pincode": "731135",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baidyanathpur",
            "Pincode": "731136",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nagari",
            "Pincode": "731137",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paigara",
            "Pincode": "731138",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Patadanga",
            "Pincode": "731139",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Putadanga",
            "Pincode": "731139",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchhiara",
            "Pincode": "731140",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabasan",
            "Pincode": "731141",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhabanipur",
            "Pincode": "731142",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gargaria",
            "Pincode": "731143",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baralunda",
            "Pincode": "731144",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Deucha",
            "Pincode": "731145",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Itagaria",
            "Pincode": "731146",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Batikar",
            "Pincode": "731147",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ahmedpur",
            "Pincode": "731201",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Iswarpur",
            "Pincode": "731201",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baswa",
            "Pincode": "731202",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhadrapur",
            "Pincode": "731203",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bolpur",
            "Pincode": "731204",
            "City": "Bolpur",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bolpur Bazar",
            "Pincode": "731204",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bolpur Court",
            "Pincode": "731204",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bolpur Trisulapatti",
            "Pincode": "731204",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bolpur Ukilpatty",
            "Pincode": "731204",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Llam Bazar",
            "Pincode": "731214",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khujutipara",
            "Pincode": "731215",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mallarpur",
            "Pincode": "731216",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Margram",
            "Pincode": "731217",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mayureswar",
            "Pincode": "731218",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Murarai",
            "Pincode": "731219",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nalhati",
            "Pincode": "731220",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paikar",
            "Pincode": "731221",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajgaon",
            "Pincode": "731222",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mukundapally",
            "Pincode": "731223",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ram Krishan Sikshapith",
            "Pincode": "731223",
            "City": "Medinipur",
            "District": "Midnapur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahajanpatti",
            "Pincode": "731224",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rampurhat H O",
            "Pincode": "731224",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rampurhat Railpur",
            "Pincode": "731224",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chandipur Tarapith",
            "Pincode": "731233",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sainthia",
            "Pincode": "731234",
            "City": "Sainthia",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sainthia Bazar",
            "Pincode": "731234",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sainthia Rakshakalitala",
            "Pincode": "731234",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sriniketan",
            "Pincode": "731236",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lohapur",
            "Pincode": "731237",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chatra Birbhum",
            "Pincode": "731238",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Narayanpur",
            "Pincode": "731239",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bahiri",
            "Pincode": "731240",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chandpara",
            "Pincode": "731241",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kurumgram",
            "Pincode": "731242",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nalhati Township",
            "Pincode": "731243",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bishnupur Birbhum",
            "Pincode": "731244",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dakshingram",
            "Pincode": "731245",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kundala",
            "Pincode": "731246",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chawhatta",
            "Pincode": "731247",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhatra Bhabanipur",
            "Pincode": "731249",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahula",
            "Pincode": "731250",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bautia",
            "Pincode": "731251",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kumuri",
            "Pincode": "731252",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagdola",
            "Pincode": "731253",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kotasur",
            "Pincode": "731254",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchsowa",
            "Pincode": "731255",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hatia",
            "Pincode": "731284",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chandidas Nanoor",
            "Pincode": "731301",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kirmahar",
            "Pincode": "731302",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Labpur",
            "Pincode": "731303",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Labpur Mastali",
            "Pincode": "731303",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagdowara",
            "Pincode": "731304",
            "City": "Suri",
            "District": "Birbhum",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Malda Ho.",
            "Pincode": "732101",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Malda Ho.",
            "Pincode": "732101",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Malda Ho.",
            "Pincode": "732101",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Malda Ho.",
            "Pincode": "732101",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Malda Ho.",
            "Pincode": "732101",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Malda Ho.",
            "Pincode": "732101",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Malda Ho.",
            "Pincode": "732101",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Malda Ho.",
            "Pincode": "732101",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Malda Ho.",
            "Pincode": "732101",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jhalghalia Rly Colony",
            "Pincode": "732102",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mukdumpur",
            "Pincode": "732103",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bansbari",
            "Pincode": "732104",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Aiho",
            "Pincode": "732121",
            "City": "Aiho",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bulbulchandi",
            "Pincode": "732122",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chanchal",
            "Pincode": "732123",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Harishchandrapur",
            "Pincode": "732125",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kaligaon",
            "Pincode": "732126",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khejuria Ghat",
            "Pincode": "732127",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Old Malda",
            "Pincode": "732128",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paknahat",
            "Pincode": "732138",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Samssi",
            "Pincode": "732139",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tulsihata",
            "Pincode": "732140",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Narayanpur",
            "Pincode": "732141",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Magalbari",
            "Pincode": "732142",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arapur",
            "Pincode": "732143",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Habibpur",
            "Pincode": "732145",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kutubsahar",
            "Pincode": "732146",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bamangola",
            "Pincode": "732147",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Singabd",
            "Pincode": "732148",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Malatipur",
            "Pincode": "732149",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharba",
            "Pincode": "732150",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barduary",
            "Pincode": "732151",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kushida",
            "Pincode": "732152",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Agra Harish Chandrapura",
            "Pincode": "732153",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhato Chandipur",
            "Pincode": "732154",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Miahat",
            "Pincode": "732155",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Milangarh",
            "Pincode": "732156",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Daultnagar",
            "Pincode": "732157",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Debiganj",
            "Pincode": "732158",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "New Sadlichak",
            "Pincode": "732159",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sultan Nagar",
            "Pincode": "732160",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Singhia",
            "Pincode": "732161",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhingole",
            "Pincode": "732162",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Patkabari",
            "Pincode": "732162",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Choralmani",
            "Pincode": "732163",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kaliachak",
            "Pincode": "732201",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Manik Chak",
            "Pincode": "732202",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mathurapur",
            "Pincode": "732203",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paranpur",
            "Pincode": "732204",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ratna",
            "Pincode": "732205",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sujapur",
            "Pincode": "732206",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mothabari",
            "Pincode": "732207",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amrity",
            "Pincode": "732208",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sova Nagar",
            "Pincode": "732209",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baishnab Nagar",
            "Pincode": "732210",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Milki",
            "Pincode": "732211",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jadupur",
            "Pincode": "732212",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pakhuria",
            "Pincode": "732213",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Aradanga",
            "Pincode": "732214",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pubrun",
            "Pincode": "732215",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balurghat Ho.",
            "Pincode": "733101",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balurghat Ho.",
            "Pincode": "733101",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balurghat Ho.",
            "Pincode": "733101",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balurghat Ho.",
            "Pincode": "733101",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balurghat Ho.",
            "Pincode": "733101",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balurghat Ho.",
            "Pincode": "733101",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chakvrigu",
            "Pincode": "733102",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belatala Park",
            "Pincode": "733103",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Beltala Park",
            "Pincode": "733103",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Buniadpur",
            "Pincode": "733121",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Debinagar",
            "Pincode": "733123",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gangarampur",
            "Pincode": "733124",
            "City": "Gangarampur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Harirampur",
            "Pincode": "733125",
            "City": "Balurghat",
            "District": "Dakshin Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hili",
            "Pincode": "733126",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tapan",
            "Pincode": "733127",
            "City": "Balurghat",
            "District": "Dakshin Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Itahar",
            "Pincode": "733128",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kaliyaganj",
            "Pincode": "733129",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kaliyaganj",
            "Pincode": "733129",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kaliyaganj",
            "Pincode": "733129",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Karanjora",
            "Pincode": "733130",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kumarganj",
            "Pincode": "733131",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kushmandi",
            "Pincode": "733132",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Patiram",
            "Pincode": "733133",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raiganj",
            "Pincode": "733134",
            "City": "Raiganj",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "733140",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gopal Ganj",
            "Pincode": "733141",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Narayan Bazar",
            "Pincode": "733142",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhupalpur",
            "Pincode": "733143",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hemtabad",
            "Pincode": "733144",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Teor",
            "Pincode": "733145",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Daulatpur",
            "Pincode": "733146",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Banshibari",
            "Pincode": "733147",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Champatali",
            "Pincode": "733148",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kardah",
            "Pincode": "733149",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khardah",
            "Pincode": "733149",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Majihoir",
            "Pincode": "733150",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Thakur Pukurhat",
            "Pincode": "733151",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamarpara",
            "Pincode": "733153",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bolla",
            "Pincode": "733154",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bindole",
            "Pincode": "733156",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bahin",
            "Pincode": "733157",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dalkola",
            "Pincode": "733201",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Islampur",
            "Pincode": "733202",
            "City": "Islampur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramganj",
            "Pincode": "733207",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panjipara",
            "Pincode": "733208",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanki",
            "Pincode": "733209",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Goalpukhar",
            "Pincode": "733210",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chakkuliahat",
            "Pincode": "733211",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rashkhwahat",
            "Pincode": "733212",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhantola",
            "Pincode": "733213",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonarpurhat",
            "Pincode": "733214",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Karandighi",
            "Pincode": "733215",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chopra",
            "Pincode": "733216",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhanuegram",
            "Pincode": "734101",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhutia Busty",
            "Pincode": "734101",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Darjeeling Bazar",
            "Pincode": "734101",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Darjeeling Court",
            "Pincode": "734101",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Darjeeling H O",
            "Pincode": "734101",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mount Eagle Villa",
            "Pincode": "734101",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rose Bank",
            "Pincode": "734101",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghoom",
            "Pincode": "734102",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "North Point",
            "Pincode": "734103",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalapahar",
            "Pincode": "734104",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lebong",
            "Pincode": "734105",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bijanbari",
            "Pincode": "734201",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Domaram Busty",
            "Pincode": "734203",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kurseong",
            "Pincode": "734203",
            "City": "Kurseong",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dow Hill",
            "Pincode": "734204",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lopchu",
            "Pincode": "734213",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mirik",
            "Pincode": "734214",
            "City": "Mirik",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nagrispur",
            "Pincode": "734215",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pokhriabong",
            "Pincode": "734216",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pankhabari",
            "Pincode": "734217",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Phuguri",
            "Pincode": "734218",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonada",
            "Pincode": "734219",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "St Marys Hill",
            "Pincode": "734220",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sukhia Pokhri",
            "Pincode": "734221",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Takdah",
            "Pincode": "734222",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tindharia",
            "Pincode": "734223",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tung",
            "Pincode": "734224",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sukna",
            "Pincode": "734225",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rangli Rangliot",
            "Pincode": "734226",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bankim Park",
            "Pincode": "734301",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bong Busty",
            "Pincode": "734301",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalimpong",
            "Pincode": "734301",
            "City": "Kalimpong",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalimpong Bazar",
            "Pincode": "734301",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Seventh Mile",
            "Pincode": "734301",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pedong",
            "Pincode": "734311",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tista Bridge",
            "Pincode": "734312",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mangpoo",
            "Pincode": "734313",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Algarah",
            "Pincode": "734314",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mussung",
            "Pincode": "734315",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Topkhana",
            "Pincode": "734316",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Echhey",
            "Pincode": "734317",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahananda Bridge",
            "Pincode": "734401",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rathkhola",
            "Pincode": "734401",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Seyoke Road",
            "Pincode": "734401",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Siliguri H O",
            "Pincode": "734401",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Siliguri Junction",
            "Pincode": "734401",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Siliguri New Market",
            "Pincode": "734401",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Siliguri Road",
            "Pincode": "734401",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Subhaspally",
            "Pincode": "734401",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Vivekananda Pally",
            "Pincode": "734401",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pradhannagar",
            "Pincode": "734403",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Deshbandhu Para",
            "Pincode": "734404",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lake Town",
            "Pincode": "734404",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Siliguri Town",
            "Pincode": "734404",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Saktigarh",
            "Pincode": "734405",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Siliguri Bazar",
            "Pincode": "734405",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rabindra Sarani",
            "Pincode": "734406",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "A P Bagdogra",
            "Pincode": "734421",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagdogra Air Port",
            "Pincode": "734421",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagdogra",
            "Pincode": "734422",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belgachi",
            "Pincode": "734423",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bengdubi",
            "Pincode": "734424",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhakti Nagar",
            "Pincode": "734425",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamalabagan",
            "Pincode": "734426",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharibari",
            "Pincode": "734427",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Matigara",
            "Pincode": "734428",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Naksalbari",
            "Pincode": "734429",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "North Bengal University",
            "Pincode": "734430",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sahabad",
            "Pincode": "734431",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sushrutanagar",
            "Pincode": "734432",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kadamtala",
            "Pincode": "734433",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Phansidewa",
            "Pincode": "734434",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahanada Project",
            "Pincode": "734435",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagrakote",
            "Pincode": "734501",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gairibas",
            "Pincode": "734502",
            "City": "Darjiling",
            "District": "Darjeeling",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Adarpara",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bow Bazar",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Din Bazar",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalpaiguri",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalpaiguri Bank",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalpaiguri Court",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalpaiguri D S Board",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalpaiguri Govt",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalpaiguri H O",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalpaiguri Hind Ins",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalpaiguri Kadamtala",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalpaiguri Silpa",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mohantapara",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panpara",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Racecoursepara",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajharipara",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Samitipara",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonpara",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "West Congresspara",
            "Pincode": "735101",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Engineering College",
            "Pincode": "735102",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Danguajhar",
            "Pincode": "735121",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haldibari",
            "Pincode": "735122",
            "City": "Haldibari",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pandapra Kalibari",
            "Pincode": "735132",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Prasannanagar",
            "Pincode": "735133",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamarvita",
            "Pincode": "735135",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharika Berubari",
            "Pincode": "735136",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Berubari",
            "Pincode": "735137",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chaulhati",
            "Pincode": "735138",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mandalghat",
            "Pincode": "735139",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Goralbari",
            "Pincode": "735140",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kunnior",
            "Pincode": "735152",
            "City": "West Dinajpur",
            "District": "West Dinajpur",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ambari Bagan",
            "Pincode": "735201",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Banarhat",
            "Pincode": "735202",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Binnaguri",
            "Pincode": "735203",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Birpara",
            "Pincode": "735204",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Birpara Bazar",
            "Pincode": "735204",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Carron",
            "Pincode": "735205",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chalsa",
            "Pincode": "735206",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chamurchi",
            "Pincode": "735207",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dalsingpara",
            "Pincode": "735208",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dam Dim",
            "Pincode": "735209",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhupgrui",
            "Pincode": "735210",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krantihat",
            "Pincode": "735210",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishi Viswa",
            "Pincode": "735210",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Falakata",
            "Pincode": "735211",
            "City": "Falakata",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gairkata",
            "Pincode": "735212",
            "City": "Gairkata",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gairkata",
            "Pincode": "735212",
            "City": "Gairkata",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gopal Bagan",
            "Pincode": "735213",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hamiltonganj",
            "Pincode": "735214",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hasimara",
            "Pincode": "735215",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jateswar",
            "Pincode": "735216",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalchini",
            "Pincode": "735217",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lataguri",
            "Pincode": "735219",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Madarihat",
            "Pincode": "735220",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mal H O",
            "Pincode": "735221",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panwarbasti",
            "Pincode": "735221",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Taigole Bazar",
            "Pincode": "735221",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Manabari",
            "Pincode": "735222",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Matehi",
            "Pincode": "735223",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Maynaguri",
            "Pincode": "735224",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nutan Bazar",
            "Pincode": "735224",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nagrakata",
            "Pincode": "735225",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panabasti",
            "Pincode": "735226",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raja Bhat Khawa",
            "Pincode": "735227",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramjhora",
            "Pincode": "735228",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sallihat",
            "Pincode": "735229",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baradighi",
            "Pincode": "735230",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Fagu",
            "Pincode": "735231",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Cantonment",
            "Pincode": "735232",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nathuahat",
            "Pincode": "735233",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gajaldoba",
            "Pincode": "735234",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalpesh Mondir",
            "Pincode": "735235",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranirhat",
            "Pincode": "735236",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sajnapara",
            "Pincode": "735237",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rungamatti",
            "Pincode": "735238",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Changrabandha",
            "Pincode": "735301",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Domohani",
            "Pincode": "735302",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jamaldah",
            "Pincode": "735303",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mekliganj",
            "Pincode": "735304",
            "City": "Mekliganj",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhotepatti",
            "Pincode": "735305",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Helapakri",
            "Pincode": "735306",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dharampur",
            "Pincode": "735307",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jaldhaka Hydel Project",
            "Pincode": "735505",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bongchatra",
            "Pincode": "736101",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Cooch Behar Bazar",
            "Pincode": "736101",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Cooch Behar H O",
            "Pincode": "736101",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Cooch Behar R S",
            "Pincode": "736101",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Durgabari Subhapalli",
            "Pincode": "736101",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gungabari",
            "Pincode": "736101",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kharimalakhagrabari",
            "Pincode": "736101",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Patakura",
            "Pincode": "736101",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Cooch Behar New Town",
            "Pincode": "736102",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alipurduar",
            "Pincode": "736121",
            "City": "Alipurduar",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alipurduar New Town",
            "Pincode": "736121",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Alipurduar Court",
            "Pincode": "736122",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Banchukamari",
            "Pincode": "736122",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghagra",
            "Pincode": "736122",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bakshaduar",
            "Pincode": "736130",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Buxaduar",
            "Pincode": "736130",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bakshirhat",
            "Pincode": "736131",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balairhat",
            "Pincode": "736132",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baneswar",
            "Pincode": "736133",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dewanhat",
            "Pincode": "736134",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dinhata",
            "Pincode": "736135",
            "City": "Dinhata",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dinhata Bazar",
            "Pincode": "736135",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gossanimari",
            "Pincode": "736145",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mathabhanga",
            "Pincode": "736146",
            "City": "Mathabhanga",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nigamnagar",
            "Pincode": "736150",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nilkuthi",
            "Pincode": "736156",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nimpith Ramkrishna",
            "Pincode": "736156",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sitalkuchi",
            "Pincode": "736158",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tuanganj",
            "Pincode": "736159",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tufanganj New Town",
            "Pincode": "736160",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pundibari",
            "Pincode": "736165",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chowdhuri Hat",
            "Pincode": "736166",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sitaihat",
            "Pincode": "736167",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bamanhat",
            "Pincode": "736168",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghugumari",
            "Pincode": "736170",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghokshadanga",
            "Pincode": "736171",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gossairhat Bandar",
            "Pincode": "736172",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chunighora",
            "Pincode": "736201",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hatipotha",
            "Pincode": "736201",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raidak",
            "Pincode": "736201",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamakshyaguri",
            "Pincode": "736202",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "New Lands",
            "Pincode": "736203",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mathurabagan",
            "Pincode": "736204",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kumergramduar",
            "Pincode": "736205",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Saontalpur",
            "Pincode": "736206",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barabisha",
            "Pincode": "736207",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Salsalabari",
            "Pincode": "736208",
            "City": "Jalpaiguri",
            "District": "Jalpaiguri",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Renishiganj",
            "Pincode": "736257",
            "City": "Koch Bihar",
            "District": "Coochbehar",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gangtok",
            "Pincode": "737101",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Gangtok Bazar",
            "Pincode": "737101",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Sincheygoan",
            "Pincode": "737101",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Doorali",
            "Pincode": "737102",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Todong",
            "Pincode": "737102",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Raj Bhavan",
            "Pincode": "737103",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Ramchandrapur",
            "Pincode": "737103",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Tashiling",
            "Pincode": "737103",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Pakyong",
            "Pincode": "737106",
            "City": "Gyalshing",
            "District": "West Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Dikchu",
            "Pincode": "737107",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Gayzing",
            "Pincode": "737111",
            "City": "Gyalshing",
            "District": "West Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Dentam",
            "Pincode": "737112",
            "City": "Gyalshing",
            "District": "West Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Pelling",
            "Pincode": "737113",
            "City": "Gyalshing",
            "District": "West Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Kaluk Bazar",
            "Pincode": "737114",
            "City": "Gyalshing",
            "District": "West Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Magan",
            "Pincode": "737116",
            "City": "Mangan",
            "District": "North Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Kabi",
            "Pincode": "737117",
            "City": "Mangan",
            "District": "North Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Phensong",
            "Pincode": "737118",
            "City": "Mangan",
            "District": "North Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Phodong",
            "Pincode": "737119",
            "City": "Mangan",
            "District": "North Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Chung Thung",
            "Pincode": "737120",
            "City": "Mangan",
            "District": "North Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Nayabazar",
            "Pincode": "737121",
            "City": "Nayabazar",
            "District": "South Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Sombaray",
            "Pincode": "737122",
            "City": "Namchi",
            "District": "South Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Namchi",
            "Pincode": "737126",
            "City": "Namchi",
            "District": "South Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Chakung",
            "Pincode": "737127",
            "City": "Gyalshing",
            "District": "West Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Mallibazar",
            "Pincode": "737128",
            "City": "Namchi",
            "District": "South Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Ranglu Bazar",
            "Pincode": "737131",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Rangpo",
            "Pincode": "737132",
            "City": "Rangpo",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Rhenock",
            "Pincode": "737133",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Singtam",
            "Pincode": "737134",
            "City": "Singtam",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Ranipool",
            "Pincode": "737135",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Dain Thong",
            "Pincode": "737136",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Namthung",
            "Pincode": "737137",
            "City": "Namchi",
            "District": "South Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Makha",
            "Pincode": "737138",
            "City": "Gangtok",
            "District": "East Sikkim",
            "State": "Sikkim"
        },
        {
            "PostOfficeName": "Amin Bazar",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bow Bazar",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Golapati",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kathuripara",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishna Nagar Ho.",
            "Pincode": "741101",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishnagar Court",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishnagar H O",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishnagar R S",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishnagar Road R S",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nadia School Board",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nagendra Nagar",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nutan Bazar",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Roypara",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ukilpara",
            "Pincode": "741101",
            "City": "Chinsurah",
            "District": "Hooghly",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Saktinagar",
            "Pincode": "741102",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghurni",
            "Pincode": "741103",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Radha Nagar",
            "Pincode": "741104",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chakdaha",
            "Pincode": "741111",
            "City": "Chakdaha",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Badkulla",
            "Pincode": "741121",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagchi",
            "Pincode": "741122",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bangal Jhee",
            "Pincode": "741123",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bara Andulia",
            "Pincode": "741124",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Belpukur",
            "Pincode": "741125",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bethuadahari",
            "Pincode": "741126",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Biragar",
            "Pincode": "741127",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Debagram",
            "Pincode": "741137",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dharamada",
            "Pincode": "741138",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhubulia",
            "Pincode": "741139",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhunbulia Tb Hospital",
            "Pincode": "741140",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kaliganj",
            "Pincode": "741150",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dakshinpara",
            "Pincode": "741151",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Karimpur",
            "Pincode": "741152",
            "City": "Karimpur",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Matiari",
            "Pincode": "741153",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Muragacha",
            "Pincode": "741154",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Palashipara",
            "Pincode": "741155",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Plassey",
            "Pincode": "741156",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Plassey Sugar Mill",
            "Pincode": "741157",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shikherejee",
            "Pincode": "741158",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Taherpur",
            "Pincode": "741159",
            "City": "Taherpur",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tehatta",
            "Pincode": "741160",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Asan Nagar",
            "Pincode": "741161",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kasiadanga",
            "Pincode": "741162",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Betai",
            "Pincode": "741163",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Doyer Bazar",
            "Pincode": "741164",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nazipur",
            "Pincode": "741165",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baliadanga Faridpur",
            "Pincode": "741166",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Seema Nagar",
            "Pincode": "741166",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhimpur",
            "Pincode": "741167",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barnia",
            "Pincode": "741168",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chandu Ghat",
            "Pincode": "741169",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Charatala",
            "Pincode": "741170",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kulgachi",
            "Pincode": "741170",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chotoandulia",
            "Pincode": "741171",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dingyel",
            "Pincode": "741171",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kechnadanga",
            "Pincode": "741172",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hanspukuria",
            "Pincode": "741173",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Juranpur",
            "Pincode": "741174",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahatpur",
            "Pincode": "741175",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bara Atagi",
            "Pincode": "741176",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhawapara",
            "Pincode": "741177",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sapjola",
            "Pincode": "741178",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyam Bazar",
            "Pincode": "741179",
            "City": "English Bazar",
            "District": "Malda",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kamari",
            "Pincode": "741180",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Paglachandi",
            "Pincode": "741181",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonadanga",
            "Pincode": "741182",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bahadurpur",
            "Pincode": "741183",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalirhat",
            "Pincode": "741184",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dogachi",
            "Pincode": "741185",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amiyanarayanpur",
            "Pincode": "741186",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baliadanga",
            "Pincode": "741187",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gobrapota",
            "Pincode": "741188",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haripur Chitka",
            "Pincode": "741189",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranabandh",
            "Pincode": "741190",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shibpur",
            "Pincode": "741191",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dakshin Bahirgachi",
            "Pincode": "741192",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Talukhuda",
            "Pincode": "741193",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Asachia",
            "Pincode": "741194",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arpara",
            "Pincode": "741195",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barachand Gaon",
            "Pincode": "741196",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Billagaram",
            "Pincode": "741197",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gopinathpur",
            "Pincode": "741198",
            "City": "Gopinathpur",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haranagar",
            "Pincode": "741199",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranaghat Ho.",
            "Pincode": "741201",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranaghat Ho.",
            "Pincode": "741201",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranaghat Ho.",
            "Pincode": "741201",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranaghat Ho.",
            "Pincode": "741201",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranaghat Ho.",
            "Pincode": "741201",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranaghat Ho.",
            "Pincode": "741201",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ranaghat Ho.",
            "Pincode": "741201",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nasra",
            "Pincode": "741202",
            "City": "Nasra",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barajagulia",
            "Pincode": "741221",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Corpers Camp.",
            "Pincode": "741232",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalyani",
            "Pincode": "741235",
            "City": "Kalyani",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalyani",
            "Pincode": "741235",
            "City": "Kalyani",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalyani",
            "Pincode": "741235",
            "City": "Kalyani",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalyani University",
            "Pincode": "741236",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gangapur",
            "Pincode": "741238",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gayeshpur",
            "Pincode": "741243",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Madanpur",
            "Pincode": "741245",
            "City": "Madanpur",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mohanpur",
            "Pincode": "741246",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Priti Nagar",
            "Pincode": "741247",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Simurali",
            "Pincode": "741248",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Subarnapur",
            "Pincode": "741249",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kataganj",
            "Pincode": "741250",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanchrapara",
            "Pincode": "741251",
            "City": "Kanchrapara",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Netaji Subhas Sanitorium",
            "Pincode": "741251",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishi Viswa Vidyalaya",
            "Pincode": "741252",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Anishmall",
            "Pincode": "741253",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalinarayanpur",
            "Pincode": "741254",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Anulia",
            "Pincode": "741255",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Begopara",
            "Pincode": "741256",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nagaruka",
            "Pincode": "741257",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Charbrahmanagar",
            "Pincode": "741301",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabadwip Ho.",
            "Pincode": "741302",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabadwip Ho.",
            "Pincode": "741302",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabadwip Ho.",
            "Pincode": "741302",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabadwip Ho.",
            "Pincode": "741302",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabadwip Ho.",
            "Pincode": "741302",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabadwip Ho.",
            "Pincode": "741302",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabadwip Ho.",
            "Pincode": "741302",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabadwip Ho.",
            "Pincode": "741302",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabadwip Ho.",
            "Pincode": "741302",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabadwip Ho.",
            "Pincode": "741302",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nandanghat",
            "Pincode": "741312",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sree Mayapur",
            "Pincode": "741313",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Samudragarh",
            "Pincode": "741314",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Swarup Ganj",
            "Pincode": "741315",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sri Rampur",
            "Pincode": "741316",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Joaria Bhaluka",
            "Pincode": "741317",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amghata",
            "Pincode": "741318",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bidyanagar",
            "Pincode": "741319",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dignagar",
            "Pincode": "741401",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Fulia Colony",
            "Pincode": "741402",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Habibpur",
            "Pincode": "741403",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santipur",
            "Pincode": "741404",
            "City": "Santipur",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santipur",
            "Pincode": "741404",
            "City": "Santipur",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santipur",
            "Pincode": "741404",
            "City": "Santipur",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santipur",
            "Pincode": "741404",
            "City": "Santipur",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Aranghata",
            "Pincode": "741501",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagula",
            "Pincode": "741502",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Banpur",
            "Pincode": "741503",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Duttapulia",
            "Pincode": "741504",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hanskhali",
            "Pincode": "741505",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishan Ganj",
            "Pincode": "741506",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Majdia",
            "Pincode": "741507",
            "City": "Krishnagar",
            "District": "Nadiad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Berhampore Ho.",
            "Pincode": "742101",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Berhampore Ho.",
            "Pincode": "742101",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Berhampore Ho.",
            "Pincode": "742101",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Berhampore Ho.",
            "Pincode": "742101",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Berhampore Ho.",
            "Pincode": "742101",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Berhampore Ho.",
            "Pincode": "742101",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Berhampore Ho.",
            "Pincode": "742101",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Berhampore Ho.",
            "Pincode": "742101",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Berhampore Ho.",
            "Pincode": "742101",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khagra",
            "Pincode": "742103",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khagra",
            "Pincode": "742103",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barua",
            "Pincode": "742109",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Amtala",
            "Pincode": "742121",
            "City": "Amtala",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Azimganj",
            "Pincode": "742122",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jiaganj",
            "Pincode": "742123",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Debipur",
            "Pincode": "742124",
            "City": "Debipur",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barwan",
            "Pincode": "742132",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Beleanga",
            "Pincode": "742133",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhabta",
            "Pincode": "742134",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhagabangola",
            "Pincode": "742135",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gokrana",
            "Pincode": "742136",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kandi Ho.",
            "Pincode": "742137",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kandi Ho.",
            "Pincode": "742137",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagdanga",
            "Pincode": "742138",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rasorah",
            "Pincode": "742139",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jemo Rajbati",
            "Pincode": "742140",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khargam",
            "Pincode": "742147",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Lalgola",
            "Pincode": "742148",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kurmitala",
            "Pincode": "742150",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajarampur",
            "Pincode": "742151",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nashipur Rajbati",
            "Pincode": "742160",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchthupai",
            "Pincode": "742161",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Saktipur",
            "Pincode": "742163",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rosanbagh",
            "Pincode": "742164",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baruipara",
            "Pincode": "742165",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Harishaarpura",
            "Pincode": "742166",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Goplilam",
            "Pincode": "742167",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Andi",
            "Pincode": "742168",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nashipur Balagachi",
            "Pincode": "742169",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Satitara",
            "Pincode": "742170",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Purandarpur",
            "Pincode": "742171",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahadebnati",
            "Pincode": "742172",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ekgharia Khangna",
            "Pincode": "742173",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarbangapur",
            "Pincode": "742174",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sabdarnagar",
            "Pincode": "742175",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Madda",
            "Pincode": "742176",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Harek Nagar",
            "Pincode": "742177",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahisasthali",
            "Pincode": "742178",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Habaspur",
            "Pincode": "742179",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahalandi",
            "Pincode": "742180",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hazarpur Nabagaram",
            "Pincode": "742181",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Choa",
            "Pincode": "742182",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Noada",
            "Pincode": "742183",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabagram",
            "Pincode": "742184",
            "City": "Nabagram",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Krishnapur",
            "Pincode": "742185",
            "City": "Krishnapur",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Greamsalika",
            "Pincode": "742186",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Radharghat",
            "Pincode": "742187",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Goaljan",
            "Pincode": "742188",
            "City": "Goaljan",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mirzapur",
            "Pincode": "742190",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kashipur",
            "Pincode": "742191",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "742201",
            "City": "Aurangabad",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhulian",
            "Pincode": "742202",
            "City": "Dhulian",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Farakka Barrage",
            "Pincode": "742212",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jangipur",
            "Pincode": "742213",
            "City": "Jangipur",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jangipur Barrage",
            "Pincode": "742223",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nimtita",
            "Pincode": "742224",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raghunathganj Ho.",
            "Pincode": "742225",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raghunathganj Ho.",
            "Pincode": "742225",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raghunathganj Ho.",
            "Pincode": "742225",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sagardighi",
            "Pincode": "742226",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ganker",
            "Pincode": "742227",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pundi",
            "Pincode": "742228",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghorsala",
            "Pincode": "742229",
            "City": "Ghorsala",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Giria",
            "Pincode": "742230",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arunpur",
            "Pincode": "742231",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahadebnagar",
            "Pincode": "742232",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kuli",
            "Pincode": "742233",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ahirah",
            "Pincode": "742234",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barale",
            "Pincode": "742235",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nabarun",
            "Pincode": "742236",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Manigram",
            "Pincode": "742237",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bharatpur",
            "Pincode": "742301",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Daultabad",
            "Pincode": "742302",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dumkal",
            "Pincode": "742303",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Islampur Msd",
            "Pincode": "742304",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalangi",
            "Pincode": "742305",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sagarpara",
            "Pincode": "742306",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chhoyghari",
            "Pincode": "742307",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raninagar",
            "Pincode": "742308",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Salar",
            "Pincode": "742401",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Talibpur",
            "Pincode": "742402",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kagram",
            "Pincode": "742403",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Satni",
            "Pincode": "742405",
            "City": "Berhampore",
            "District": "Murshidabad",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barrackpore Ho.",
            "Pincode": "743101",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barrackpore Ho.",
            "Pincode": "743101",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barrackpore Ho.",
            "Pincode": "743101",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barrackpore Ho.",
            "Pincode": "743101",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barrackpore Ho.",
            "Pincode": "743101",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nanachandanpukur",
            "Pincode": "743102",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nanachandanpukur",
            "Pincode": "743102",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Niganj Bazar",
            "Pincode": "743120",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Balaram Dharma Sopan",
            "Pincode": "743121",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bengal Enamel",
            "Pincode": "743122",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhatoli",
            "Pincode": "743123",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jagatdal",
            "Pincode": "743125",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jagatdal",
            "Pincode": "743125",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanknara",
            "Pincode": "743126",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyam Bazar",
            "Pincode": "743127",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyam Bazar",
            "Pincode": "743127",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Shyam Bazar",
            "Pincode": "743127",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Athpur",
            "Pincode": "743128",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Fingapara",
            "Pincode": "743129",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gurulia",
            "Pincode": "743133",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Halisahar",
            "Pincode": "743134",
            "City": "Halisahar",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hazi Nagar",
            "Pincode": "743135",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hazi Nagar",
            "Pincode": "743135",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Naba Nagar",
            "Pincode": "743136",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ichapur Nawabganj",
            "Pincode": "743144",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ichapur Nawabganj",
            "Pincode": "743144",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ichapur Nawabganj",
            "Pincode": "743144",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ichapur Nawabganj",
            "Pincode": "743144",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ichapur Nawabganj",
            "Pincode": "743144",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ichapur Nawabganj",
            "Pincode": "743144",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ichapur Nawabganj",
            "Pincode": "743144",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanchrapara",
            "Pincode": "743145",
            "City": "Kanchrapara",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanchrapara",
            "Pincode": "743145",
            "City": "Kanchrapara",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanchrapara",
            "Pincode": "743145",
            "City": "Kanchrapara",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanchrapara",
            "Pincode": "743145",
            "City": "Kanchrapara",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanchrapara",
            "Pincode": "743145",
            "City": "Kanchrapara",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khardah",
            "Pincode": "743155",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khardah",
            "Pincode": "743155",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Naihati",
            "Pincode": "743164",
            "City": "Naihati",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Naihati",
            "Pincode": "743165",
            "City": "Naihati",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garifa",
            "Pincode": "743166",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghola Bazar",
            "Pincode": "743170",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Natagarh",
            "Pincode": "743175",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panihati",
            "Pincode": "743176",
            "City": "Panihati",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panihati",
            "Pincode": "743176",
            "City": "Panihati",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Agarpara",
            "Pincode": "743177",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sodepur",
            "Pincode": "743178",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sodepur",
            "Pincode": "743178",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sodepur",
            "Pincode": "743178",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sodepur",
            "Pincode": "743178",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sodepur",
            "Pincode": "743178",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sukchar",
            "Pincode": "743179",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pansila",
            "Pincode": "743180",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rahara",
            "Pincode": "743186",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Talupukur",
            "Pincode": "743187",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Titagarh",
            "Pincode": "743188",
            "City": "Titagarh",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Titagarh",
            "Pincode": "743188",
            "City": "Titagarh",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Titagarh",
            "Pincode": "743188",
            "City": "Titagarh",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kampa",
            "Pincode": "743193",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramlakhi Basti Lane",
            "Pincode": "743194",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barasar Ho.",
            "Pincode": "743201",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Barasar Ho.",
            "Pincode": "743201",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Badu",
            "Pincode": "743202",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Noanpara Barasat",
            "Pincode": "743202",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Navapalli",
            "Pincode": "743203",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hridayper",
            "Pincode": "743204",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arkhali Amdanga",
            "Pincode": "743221",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "743222",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ashok Nagar",
            "Pincode": "743222",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bagdah",
            "Pincode": "743232",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Banipur",
            "Pincode": "743233",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Beraballavpara",
            "Pincode": "743234",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bongaon",
            "Pincode": "743235",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bongaon",
            "Pincode": "743235",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bongaon",
            "Pincode": "743235",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bongaon",
            "Pincode": "743235",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bongaon",
            "Pincode": "743235",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bongaon",
            "Pincode": "743235",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chand Para Bazar",
            "Pincode": "743245",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mandalpara",
            "Pincode": "743245",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhakuria Kalibari",
            "Pincode": "743246",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dakshin Chatra",
            "Pincode": "743247",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Duttapukur",
            "Pincode": "743248",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gaighat",
            "Pincode": "743249",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ganganagar",
            "Pincode": "743250",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ganrapota",
            "Pincode": "743251",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gobardanga",
            "Pincode": "743252",
            "City": "Gobardanga",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mahestala",
            "Pincode": "743252",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gopal Nagar",
            "Pincode": "743262",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Harba",
            "Pincode": "743263",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Harba Prafulla Nagar",
            "Pincode": "743268",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hattuba",
            "Pincode": "743269",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Helancha Colony",
            "Pincode": "743270",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hijal Pukuria",
            "Pincode": "743271",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kalyan Durg Bazar",
            "Pincode": "743272",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Khantura",
            "Pincode": "743273",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kumra Kashipur",
            "Pincode": "743274",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Madhyam Gram",
            "Pincode": "743275",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "New Barrackpore",
            "Pincode": "743276",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Swarup Nagar",
            "Pincode": "743286",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Thakur Nagar",
            "Pincode": "743287",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Janaphul",
            "Pincode": "743288",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Maslandapur",
            "Pincode": "743289",
            "City": "Maslandapur",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nahta",
            "Pincode": "743290",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Champaukur",
            "Pincode": "743291",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Itinda",
            "Pincode": "743292",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jadurhati",
            "Pincode": "743293",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Choto Jagulia",
            "Pincode": "743294",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sabdalpur",
            "Pincode": "743295",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mecheal Nagar",
            "Pincode": "743296",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sindrani",
            "Pincode": "743297",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Madhyam Gram Bazar",
            "Pincode": "743298",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Achipur",
            "Pincode": "743301",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baruipur Ho.",
            "Pincode": "743302",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Basanti",
            "Pincode": "743312",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bata Nagar",
            "Pincode": "743313",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hero Bhanga",
            "Pincode": "743316",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Birlapur",
            "Pincode": "743318",
            "City": "Birlapur",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Budge Budge",
            "Pincode": "743319",
            "City": "Budge Budge",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Canning Town",
            "Pincode": "743329",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Champahati",
            "Pincode": "743330",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dimond Harbour Ho.",
            "Pincode": "743331",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dimond Harbour Ho.",
            "Pincode": "743331",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dimond Harbour Ho.",
            "Pincode": "743331",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dimond Harbour Ho.",
            "Pincode": "743331",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dimond Harbour Ho.",
            "Pincode": "743331",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hatuganj",
            "Pincode": "743332",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ghateswar",
            "Pincode": "743336",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Joy Nagar Mazilpur",
            "Pincode": "743337",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Joy Nagar Mazilpur Telepara",
            "Pincode": "743337",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nimpith Ramakrishna Mission Ashram",
            "Pincode": "743338",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bijoyganj Bazar",
            "Pincode": "743343",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kakdwip",
            "Pincode": "743347",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Karanjali",
            "Pincode": "743348",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kashi Nagar",
            "Pincode": "743349",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kulpi",
            "Pincode": "743351",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mathurapur Rs",
            "Pincode": "743354",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Magrahat",
            "Pincode": "743355",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mograhat",
            "Pincode": "743355",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mudpoint",
            "Pincode": "743356",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Namkhana",
            "Pincode": "743357",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "743358",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "743358",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kultali",
            "Pincode": "743360",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarisha",
            "Pincode": "743368",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sonarpur",
            "Pincode": "743369",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gosaba",
            "Pincode": "743370",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pathar Pratima",
            "Pincode": "743371",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dakshin Barasa",
            "Pincode": "743372",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rudra Nagar",
            "Pincode": "743373",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nischintapur",
            "Pincode": "743374",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Usthi",
            "Pincode": "743375",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Taldi",
            "Pincode": "743376",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bakrahat",
            "Pincode": "743377",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Choto Mollakhali",
            "Pincode": "743378",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dakshin Jagatdal",
            "Pincode": "743379",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jadavpurhat",
            "Pincode": "743380",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Ramkanta Nagar",
            "Pincode": "743381",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarkarpool",
            "Pincode": "743382",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Raidighi",
            "Pincode": "743383",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bowali",
            "Pincode": "743384",
            "City": "Bowali",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Sarberia",
            "Pincode": "743385",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Piyali Town",
            "Pincode": "743387",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Maydah",
            "Pincode": "743388",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Uttar Raipur",
            "Pincode": "743389",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mansadwip",
            "Pincode": "743390",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gocharan",
            "Pincode": "743391",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Freser Ganj",
            "Pincode": "743393",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Mandir Bazar",
            "Pincode": "743394",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "South Bishnupur",
            "Pincode": "743395",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhosa",
            "Pincode": "743396",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hotar",
            "Pincode": "743397",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kanya Nagar",
            "Pincode": "743398",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dholahat",
            "Pincode": "743399",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Baduria",
            "Pincode": "743401",
            "City": "Baduria",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Arbelia",
            "Pincode": "743402",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Basiriat Ho.",
            "Pincode": "743411",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Basiriat College",
            "Pincode": "743412",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Basiriat Rs",
            "Pincode": "743412",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Badartala",
            "Pincode": "743413",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhebia",
            "Pincode": "743422",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Deganga",
            "Pincode": "743423",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Devalaya",
            "Pincode": "743424",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Haria",
            "Pincode": "743425",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hasnabad",
            "Pincode": "743426",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Katiahat",
            "Pincode": "743427",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kholapota",
            "Pincode": "743428",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Taki",
            "Pincode": "743429",
            "City": "Taki",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hindgalganj",
            "Pincode": "743435",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhabla",
            "Pincode": "743436",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhaniya Kuria",
            "Pincode": "743437",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kolsur",
            "Pincode": "743438",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Metia",
            "Pincode": "743440",
            "City": "24 Parganas",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Metia",
            "Pincode": "743440",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Minakhan",
            "Pincode": "743441",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nazathkhola",
            "Pincode": "743442",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hadipur",
            "Pincode": "743443",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bhangar",
            "Pincode": "743502",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Falta",
            "Pincode": "743504",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Boral",
            "Pincode": "743505",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Dhapa",
            "Pincode": "743506",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jairampur",
            "Pincode": "743507",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Narendrapur",
            "Pincode": "743508",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajarhat",
            "Pincode": "743510",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Prafullakhanan",
            "Pincode": "743511",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Joka",
            "Pincode": "743512",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Fatehepur",
            "Pincode": "743513",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Chaberia",
            "Pincode": "743514",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Laskarpur",
            "Pincode": "743515",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Panchpota",
            "Pincode": "743516",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bodra",
            "Pincode": "743517",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajarhat Gopalpur",
            "Pincode": "743518",
            "City": "Rajarhat Gopalpur",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gokarnee",
            "Pincode": "743601",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rangabelia",
            "Pincode": "743602",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Kautala",
            "Pincode": "743603",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gilarchat",
            "Pincode": "743604",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Nalna",
            "Pincode": "743605",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gangasagar",
            "Pincode": "743606",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Jalaberia",
            "Pincode": "743607",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Bakultala",
            "Pincode": "743608",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Hansuri",
            "Pincode": "743609",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Madarhat",
            "Pincode": "743610",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Pathankhali",
            "Pincode": "743611",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Santoshpur",
            "Pincode": "743612",
            "City": "Santoshpur",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "South Garia",
            "Pincode": "743613",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Palla",
            "Pincode": "743701",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Rajibpur",
            "Pincode": "743702",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Tentulia",
            "Pincode": "743703",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Gurna",
            "Pincode": "743704",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Petrapole",
            "Pincode": "743705",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Noanpara",
            "Pincode": "743707",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Garibpur",
            "Pincode": "743710",
            "City": "Alipore",
            "District": "North 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Marine Jetty",
            "Pincode": "744101",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "N S Building",
            "Pincode": "744101",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Port Blair",
            "Pincode": "744101",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Haddo",
            "Pincode": "744102",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Jangli Ghat",
            "Pincode": "744103",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Aberdeen Bazar",
            "Pincode": "744104",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Neel Island",
            "Pincode": "744104",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "New Secretariate Bldg",
            "Pincode": "744105",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Shadipur",
            "Pincode": "744106",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Bambooflat",
            "Pincode": "744107",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Betapur",
            "Pincode": "744201",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Diglipur",
            "Pincode": "744202",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Long Island",
            "Pincode": "744203",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Mayabunder",
            "Pincode": "744204",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Ranghat",
            "Pincode": "744205",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Wimberlygunji",
            "Pincode": "744206",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Hut Bay",
            "Pincode": "744207",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Bakultala",
            "Pincode": "744208",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Kadamtala A & N",
            "Pincode": "744209",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Oralkatcha",
            "Pincode": "744210",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Havelock",
            "Pincode": "744211",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Car Nicobar",
            "Pincode": "744301",
            "City": "Car Nicobar",
            "District": "Car Nicobar",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Campbell Bay",
            "Pincode": "744302",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Nancowrie",
            "Pincode": "744303",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "Kapanga",
            "Pincode": "744304",
            "City": "Port Blair",
            "District": "A&N Islands",
            "State": "Andaman Nicobar"
        },
        {
            "PostOfficeName": "A G Office",
            "Pincode": "751001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhubaneswar",
            "Pincode": "751001",
            "City": "Bhubaneswar",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhubaneswar G P O",
            "Pincode": "751001",
            "City": "Bhubaneswar",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhubaneswar R S",
            "Pincode": "751001",
            "City": "Bhubaneswar",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "C G Colony",
            "Pincode": "751001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kharabelnagar",
            "Pincode": "751001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Orissa Assembly",
            "Pincode": "751001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Secretariat",
            "Pincode": "751001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Harachandi Sahi",
            "Pincode": "751002",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kapileswar",
            "Pincode": "751002",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kedargouri",
            "Pincode": "751002",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Old Bhubaneswar",
            "Pincode": "751002",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Santarpur",
            "Pincode": "751002",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baramunda Colony",
            "Pincode": "751003",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ganga Nagar",
            "Pincode": "751003",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Suryanagar",
            "Pincode": "751003",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Acharya Vihar",
            "Pincode": "751004",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Utkal University",
            "Pincode": "751004",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Veer Surendra Sai Nagar",
            "Pincode": "751004",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sainik School",
            "Pincode": "751005",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Budheswari Colony",
            "Pincode": "751006",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhoinagar",
            "Pincode": "751007",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madhusudan Nagar",
            "Pincode": "751007",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sahidnagar",
            "Pincode": "751007",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Satyanagar",
            "Pincode": "751007",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajbhawan",
            "Pincode": "751008",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ashoka Nagar",
            "Pincode": "751009",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bapuji Nagar",
            "Pincode": "751009",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhubaneswar Air Port",
            "Pincode": "751009",
            "City": "Bhubaneswar",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Udyanmarg",
            "Pincode": "751009",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gada Gopinathprasad",
            "Pincode": "751010",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rasulgarh",
            "Pincode": "751010",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Regional Research",
            "Pincode": "751010",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "C R P Line",
            "Pincode": "751011",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nayapalli",
            "Pincode": "751012",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Laboratory",
            "Pincode": "751013",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "B J B Nagar",
            "Pincode": "751014",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khandagiri",
            "Pincode": "751030",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Patia",
            "Pincode": "751031",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balisahi",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jagannathballv",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalikadevi Sahi",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Labanikhiachhak",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mahodadhi",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Manikarnika",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Markendeswar Sahi",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Puri",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Puri Sea Beach",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "S C S College",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Singhdwar",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Swargadwar",
            "Pincode": "752001",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balikhand Chakratirsh",
            "Pincode": "752002",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "D A G Office",
            "Pincode": "752002",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kundheibenstsahi",
            "Pincode": "752002",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Police Line",
            "Pincode": "752002",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Puri Station Road",
            "Pincode": "752002",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajsunakhala",
            "Pincode": "752006",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Brahmagiri",
            "Pincode": "752011",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Basudebpur",
            "Pincode": "752013",
            "City": "Basudebpur",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sakhigopal",
            "Pincode": "752014",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Delang",
            "Pincode": "752015",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Berboi",
            "Pincode": "752016",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kanas",
            "Pincode": "752017",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Narangarh",
            "Pincode": "752018",
            "City": "Kendrapara",
            "District": "Kendrapara",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nirakarpur",
            "Pincode": "752019",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jankia",
            "Pincode": "752020",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Singipur",
            "Pincode": "752021",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalupuraghat",
            "Pincode": "752022",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tangi",
            "Pincode": "752023",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandpur",
            "Pincode": "752024",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gopalpur",
            "Pincode": "752025",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajranpur",
            "Pincode": "752026",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kuhuri",
            "Pincode": "752027",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nachuni",
            "Pincode": "752028",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nairi",
            "Pincode": "752029",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balugaon",
            "Pincode": "752030",
            "City": "Balugaon",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balugaon Bazar",
            "Pincode": "752030",
            "City": "Balugaon",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Banpur",
            "Pincode": "752031",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pavikud",
            "Pincode": "752032",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chilika Nuapada",
            "Pincode": "752033",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gangadharpur",
            "Pincode": "752034",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gambharimunda",
            "Pincode": "752035",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhusandpur",
            "Pincode": "752036",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "N T C Chilika",
            "Pincode": "752037",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Siko",
            "Pincode": "752038",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sri Ramachandrapur",
            "Pincode": "752041",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bira Ramchandrapur",
            "Pincode": "752042",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kapileswarpur",
            "Pincode": "752043",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalyanpur",
            "Pincode": "752044",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gabakund",
            "Pincode": "752045",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Satsankha",
            "Pincode": "752046",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jatani",
            "Pincode": "752050",
            "City": "Jatani",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khurda Road R S",
            "Pincode": "752050",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Loco Settlement",
            "Pincode": "752050",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raj Bazar",
            "Pincode": "752050",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Retang Colony",
            "Pincode": "752050",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Janla",
            "Pincode": "752054",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khurda",
            "Pincode": "752055",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pallahat",
            "Pincode": "752056",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khurda College",
            "Pincode": "752057",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Garhsanput",
            "Pincode": "752058",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mendhasal",
            "Pincode": "752059",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bajpur",
            "Pincode": "752060",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baghamari",
            "Pincode": "752061",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Begunia",
            "Pincode": "752062",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhapur",
            "Pincode": "752063",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pichukuli",
            "Pincode": "752064",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bolagarh",
            "Pincode": "752066",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Manikgoda",
            "Pincode": "752067",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Itamati",
            "Pincode": "752068",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nayagarh",
            "Pincode": "752069",
            "City": "Nayagarh",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nayagarh College",
            "Pincode": "752069",
            "City": "Nayagarh",
            "District": "Nayagarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nayagarh Bazar",
            "Pincode": "752070",
            "City": "Nayagarh",
            "District": "Nayagarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khandaparagarh",
            "Pincode": "752077",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kantilo",
            "Pincode": "752078",
            "City": "Kantilo",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mandhatapur",
            "Pincode": "752079",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sarankul",
            "Pincode": "752080",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Odagaon",
            "Pincode": "752081",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bahadajhola",
            "Pincode": "752082",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuagaon Puri",
            "Pincode": "752083",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Daspalla",
            "Pincode": "752084",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gania",
            "Pincode": "752085",
            "City": "Sonapur",
            "District": "Sonapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gediapalli",
            "Pincode": "752086",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Harekrishnapur",
            "Pincode": "752087",
            "City": "Debagarh",
            "District": "Debagarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Fategarh",
            "Pincode": "752088",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Banigochha",
            "Pincode": "752089",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kural",
            "Pincode": "752090",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Satpatna",
            "Pincode": "752091",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Godipada",
            "Pincode": "752092",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mandhyakhand",
            "Pincode": "752093",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mahipur",
            "Pincode": "752094",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balugaon",
            "Pincode": "752095",
            "City": "Balugaon",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khalisahi",
            "Pincode": "752096",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balianta",
            "Pincode": "752101",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balipantna",
            "Pincode": "752102",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Banmalipur",
            "Pincode": "752103",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pipli",
            "Pincode": "752104",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pipli Tahasil Campus",
            "Pincode": "752104",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balanga",
            "Pincode": "752105",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhubanipur",
            "Pincode": "752106",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nimapara",
            "Pincode": "752106",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nayahat",
            "Pincode": "752107",
            "City": "Bhadrak",
            "District": "Bhadrak",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kakatpur",
            "Pincode": "752108",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Astrang",
            "Pincode": "752109",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gop",
            "Pincode": "752110",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Konark",
            "Pincode": "752111",
            "City": "Konark",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dandamukundpur",
            "Pincode": "752112",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Brahmakundi",
            "Pincode": "752113",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rench",
            "Pincode": "752114",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhatapatna",
            "Pincode": "752115",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Birtung",
            "Pincode": "752116",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhanaranijigarh",
            "Pincode": "752117",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bangurigaon",
            "Pincode": "752118",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lataharan",
            "Pincode": "752119",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuapalamhat",
            "Pincode": "752120",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bamanal",
            "Pincode": "752121",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Haldia",
            "Pincode": "752201",
            "City": "Puri",
            "District": "Puri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Brajakabati Road",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Cantonment Road",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Choudhury Bazar",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Cuttack G P O",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dargha Bazar",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dolamundai",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gandhi Bhawan",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kazibazar",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mangalabag",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Meriabazar",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mission Road",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nimasahi Chhak",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Orissa Secretariat",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Patapol",
            "Pincode": "753001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Binodbihari",
            "Pincode": "753002",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandnichouk",
            "Pincode": "753002",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dagarpada",
            "Pincode": "753002",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kafla",
            "Pincode": "753002",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kathjodi",
            "Pincode": "753002",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khatbinsahi",
            "Pincode": "753002",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Manik Ghos Bazar",
            "Pincode": "753002",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Orissa High Court",
            "Pincode": "753002",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Prajatantra",
            "Pincode": "753002",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Swaraja Ashram",
            "Pincode": "753002",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Central Rice Research",
            "Pincode": "753003",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "College Square Cuttack-3",
            "Pincode": "753003",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jobra",
            "Pincode": "753003",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kaliaboda",
            "Pincode": "753003",
            "City": "Bhadrak",
            "District": "Bhadrak",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Malgodown",
            "Pincode": "753003",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Orissa Military Policy",
            "Pincode": "753003",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ravenshaw College",
            "Pincode": "753003",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sikharpur",
            "Pincode": "753003",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nayabazar",
            "Pincode": "753004",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barabati Stadium",
            "Pincode": "753005",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Institute",
            "Pincode": "753006",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Medical College",
            "Pincode": "753007",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bidanasi",
            "Pincode": "753008",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kanika Rajbati",
            "Pincode": "753008",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madhusudan Nagar",
            "Pincode": "753008",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Shelter Chhak",
            "Pincode": "753008",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tulsipur",
            "Pincode": "753008",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajabagicha",
            "Pincode": "753009",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Telenga Bazar",
            "Pincode": "753009",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Industrial Esdtate Orissa Govt",
            "Pincode": "753010",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madhupatna",
            "Pincode": "753010",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Orissa School Of Eng",
            "Pincode": "753010",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gopalpur",
            "Pincode": "753011",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Arunodaya Market",
            "Pincode": "753012",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chhatra Bazar",
            "Pincode": "753012",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khan Nagar",
            "Pincode": "753012",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalyani Nagar",
            "Pincode": "753013",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sri Arobind Marg",
            "Pincode": "753013",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Telengapentha",
            "Pincode": "753051",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sankhatras",
            "Pincode": "753052",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Malancha Mahinagar",
            "Pincode": "753353",
            "City": "Barast",
            "District": "South 24 Parganas",
            "State": "West Bengal"
        },
        {
            "PostOfficeName": "Fulnakhara",
            "Pincode": "754001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sundargram",
            "Pincode": "754002",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Govindapur",
            "Pincode": "754003",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Niali",
            "Pincode": "754004",
            "City": "Rayagada",
            "District": "Rayagada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barang",
            "Pincode": "754005",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mundali Colony",
            "Pincode": "754006",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dompara",
            "Pincode": "754007",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Banki",
            "Pincode": "754008",
            "City": "Banki",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Banki College",
            "Pincode": "754008",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalapathar",
            "Pincode": "754009",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bairoi",
            "Pincode": "754010",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Adaspur",
            "Pincode": "754011",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tulosipur",
            "Pincode": "754012",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nandankanan",
            "Pincode": "754013",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Talabasta",
            "Pincode": "754014",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandaka",
            "Pincode": "754015",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kantapara",
            "Pincode": "754016",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baideswar",
            "Pincode": "754017",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Brahmansailo",
            "Pincode": "754018",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gurudijhatia",
            "Pincode": "754020",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jagatpur",
            "Pincode": "754021",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kotsahi",
            "Pincode": "754022",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chhatia",
            "Pincode": "754023",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dhanmandal",
            "Pincode": "754024",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chaudwar",
            "Pincode": "754025",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chaudwar Bazar",
            "Pincode": "754025",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kapaleswar",
            "Pincode": "754025",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Daulatabad",
            "Pincode": "754026",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chasapara",
            "Pincode": "754027",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Charbatia",
            "Pincode": "754028",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Athgarh",
            "Pincode": "754029",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Athgarh Bazar",
            "Pincode": "754029",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Athgarh College",
            "Pincode": "754029",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tigiria",
            "Pincode": "754030",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barambagarh",
            "Pincode": "754031",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Narsinghpur",
            "Pincode": "754032",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khuntuni",
            "Pincode": "754033",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Maniabandha",
            "Pincode": "754034",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuapatna",
            "Pincode": "754035",
            "City": "Nuapatna",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Subarnapur",
            "Pincode": "754036",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kanpur",
            "Pincode": "754037",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Agrahat",
            "Pincode": "754070",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalingchhak",
            "Pincode": "754071",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhatimunda",
            "Pincode": "754080",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barachana",
            "Pincode": "754081",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Byree",
            "Pincode": "754082",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sidheswarpur",
            "Pincode": "754101",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Anakhia",
            "Pincode": "754102",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chatra",
            "Pincode": "754103",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jagatsinghpur",
            "Pincode": "754103",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jagatsinghpur Bazar",
            "Pincode": "754103",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "S V M College",
            "Pincode": "754103",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nalibar",
            "Pincode": "754104",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kasarda",
            "Pincode": "754105",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kaduapara",
            "Pincode": "754106",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Alanahat",
            "Pincode": "754107",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balikuda",
            "Pincode": "754108",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Debidol",
            "Pincode": "754109",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Borikina",
            "Pincode": "754110",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Biridi Road",
            "Pincode": "754111",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bentkar",
            "Pincode": "754112",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Naugaonhat",
            "Pincode": "754113",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mandasahi",
            "Pincode": "754114",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tarikund",
            "Pincode": "754115",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madhyasasan",
            "Pincode": "754116",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kandarpur",
            "Pincode": "754117",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sarichuan",
            "Pincode": "754118",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Machhagaon",
            "Pincode": "754119",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Somepur",
            "Pincode": "754130",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kishornagar",
            "Pincode": "754131",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raghunathpur",
            "Pincode": "754132",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tarpur",
            "Pincode": "754133",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tyandakura",
            "Pincode": "754134",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Krishnandapur",
            "Pincode": "754135",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kanakpur",
            "Pincode": "754136",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tirtol",
            "Pincode": "754137",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ersama",
            "Pincode": "754139",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tiran",
            "Pincode": "754139",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rahama",
            "Pincode": "754140",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kujang",
            "Pincode": "754141",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madhuban",
            "Pincode": "754142",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Paradeep Port",
            "Pincode": "754142",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sector-21 Paradeep",
            "Pincode": "754143",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Paradeep Lock",
            "Pincode": "754144",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Garadpur",
            "Pincode": "754153",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Antei",
            "Pincode": "754154",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sena Adhanga",
            "Pincode": "754155",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kudanagari",
            "Pincode": "754156",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Godijang",
            "Pincode": "754157",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bodhpur",
            "Pincode": "754158",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Godma",
            "Pincode": "754159",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Manijanga",
            "Pincode": "754160",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaipur Ck",
            "Pincode": "754161",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kolar",
            "Pincode": "754162",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rameswar",
            "Pincode": "754201",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Salipur",
            "Pincode": "754202",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Salipur College",
            "Pincode": "754202",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kendupatna",
            "Pincode": "754203",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kuanpal",
            "Pincode": "754204",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balichandrapur",
            "Pincode": "754205",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Maharga",
            "Pincode": "754206",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nischintakoili",
            "Pincode": "754207",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandol",
            "Pincode": "754208",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Asureswar",
            "Pincode": "754209",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Danpur",
            "Pincode": "754210",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kendrapara",
            "Pincode": "754211",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kendrapara College",
            "Pincode": "754211",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Keshpur Bazar",
            "Pincode": "754211",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tinimuhani",
            "Pincode": "754211",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sribaladevjee",
            "Pincode": "754212",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Marsaghai",
            "Pincode": "754213",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Indupur",
            "Pincode": "754214",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pattamundai",
            "Pincode": "754215",
            "City": "Pattamundai",
            "District": "Kendrapara",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pattamundai College",
            "Pincode": "754215",
            "City": "Pattamundai",
            "District": "Kendrapara",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaria",
            "Pincode": "754216",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Alba",
            "Pincode": "754217",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Batipara",
            "Pincode": "754218",
            "City": "Kendrapara",
            "District": "Kendrapara",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Aul",
            "Pincode": "754219",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajkanika",
            "Pincode": "754220",
            "City": "Kendrapara",
            "District": "Kendrapara",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sungra",
            "Pincode": "754221",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chaudkulat",
            "Pincode": "754222",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kariopatna",
            "Pincode": "754223",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mahakalpara",
            "Pincode": "754224",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajnagar",
            "Pincode": "754225",
            "City": "Kendrapara",
            "District": "Kendrapara",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Damarpur",
            "Pincode": "754226",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Olavar",
            "Pincode": "754227",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Patkura",
            "Pincode": "754228",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ostapur",
            "Pincode": "754229",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ayaba",
            "Pincode": "754230",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Namauza",
            "Pincode": "754231",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Angulai",
            "Pincode": "754232",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Anduli",
            "Pincode": "754233",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhagabatpur",
            "Pincode": "754234",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balikanagopalpur",
            "Pincode": "754235",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ratnagiri",
            "Pincode": "754236",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ayatan",
            "Pincode": "754237",
            "City": "Kendrapara",
            "District": "Kendrapara",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Amruta Manohi",
            "Pincode": "754238",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhuinpur",
            "Pincode": "754239",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dandisahi",
            "Pincode": "754240",
            "City": "Kendrapara",
            "District": "Kendrapara",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balipatna",
            "Pincode": "754241",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Talchuan",
            "Pincode": "754242",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pegarpara",
            "Pincode": "754243",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jampar",
            "Pincode": "754244",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barpara",
            "Pincode": "754245",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madanpur",
            "Pincode": "754246",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bankeswar",
            "Pincode": "754247",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Iswarpur",
            "Pincode": "754248",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Srirampur Palpatna",
            "Pincode": "754249",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Thakurpatna",
            "Pincode": "754250",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barua",
            "Pincode": "754251",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuapara",
            "Pincode": "754252",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bedari",
            "Pincode": "754253",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Padmapur",
            "Pincode": "754260",
            "City": "Padmapur",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Charirakaba",
            "Pincode": "754280",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Badamundai",
            "Pincode": "754281",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khandasahi",
            "Pincode": "754282",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sukarpara",
            "Pincode": "754283",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jignipur",
            "Pincode": "754284",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kusupur",
            "Pincode": "754285",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sukleswar",
            "Pincode": "754286",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kumra Jaipur",
            "Pincode": "754287",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lalitgiri",
            "Pincode": "754288",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Derabis",
            "Pincode": "754289",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mauda",
            "Pincode": "754290",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jhadeswarpur",
            "Pincode": "754291",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Charinangal",
            "Pincode": "754292",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ankula",
            "Pincode": "755001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaipur",
            "Pincode": "755001",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaipur Bazar",
            "Pincode": "755001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaipur College",
            "Pincode": "755001",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bari Cuttack",
            "Pincode": "755003",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Binjharpur",
            "Pincode": "755004",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Brahmabarada",
            "Pincode": "755005",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dasarathpur",
            "Pincode": "755006",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Debidwar",
            "Pincode": "755007",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dharamshala",
            "Pincode": "755008",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kabirpur",
            "Pincode": "755009",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kaipara",
            "Pincode": "755010",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mangalpur",
            "Pincode": "755011",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mashra",
            "Pincode": "755012",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pritipur",
            "Pincode": "755013",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rambagh",
            "Pincode": "755014",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sankhachilla",
            "Pincode": "755015",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Singhpur",
            "Pincode": "755016",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sujanpur",
            "Pincode": "755017",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sukinda",
            "Pincode": "755018",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dolipur",
            "Pincode": "755019",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaipr Road R S",
            "Pincode": "755019",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sobra",
            "Pincode": "755019",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "F C Project",
            "Pincode": "755020",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bainsaria",
            "Pincode": "755021",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Korai",
            "Pincode": "755022",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jenapur",
            "Pincode": "755023",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Haridaspur",
            "Pincode": "755024",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barundai",
            "Pincode": "755025",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dangadi",
            "Pincode": "755026",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Arei",
            "Pincode": "755027",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalaringatta",
            "Pincode": "755028",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kodandapur",
            "Pincode": "755029",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalyanpur",
            "Pincode": "755030",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kamagarh",
            "Pincode": "755031",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rama Chandrapur",
            "Pincode": "755032",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rurhiya",
            "Pincode": "755033",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rasulpur",
            "Pincode": "755034",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Angalo",
            "Pincode": "755035",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ahiyas",
            "Pincode": "755036",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kanikapara",
            "Pincode": "755037",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bamdevpur",
            "Pincode": "755038",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Meradakatia Chhak",
            "Pincode": "755039",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Garhmadhupur",
            "Pincode": "755041",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ragadi",
            "Pincode": "755042",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Panikoili",
            "Pincode": "755043",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandikhol",
            "Pincode": "755044",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kotpur",
            "Pincode": "755045",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hatibari",
            "Pincode": "755046",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaipur",
            "Pincode": "755046",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kaliapani",
            "Pincode": "755047",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dala",
            "Pincode": "755048",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kantigaria",
            "Pincode": "755049",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaraka Bazar",
            "Pincode": "755050",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Govindapur Katchery",
            "Pincode": "755061",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Azimabad",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balasore",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balasore Court",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balasore R S",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "F M College",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Issan Nagar",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nayabazar Balasore",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Reserve Police Line",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sahadevkhunta",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sovarampur",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Srikanthpur",
            "Pincode": "756001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sunhat",
            "Pincode": "756002",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barbati",
            "Pincode": "756003",
            "City": "Nayagarh",
            "District": "Nayagarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Makalpur",
            "Pincode": "756003",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Motiganj Bazar",
            "Pincode": "756003",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sahidpark",
            "Pincode": "756003",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sargaon",
            "Pincode": "756017",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khirchora Gopinath",
            "Pincode": "756018",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mitrapur",
            "Pincode": "756020",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Remuna",
            "Pincode": "756021",
            "City": "Remuna",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Darada",
            "Pincode": "756022",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Singla",
            "Pincode": "756023",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nangaleswar",
            "Pincode": "756024",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandipur",
            "Pincode": "756025",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandipur",
            "Pincode": "756025",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baliapal",
            "Pincode": "756026",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baliapal",
            "Pincode": "756026",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Haldipada",
            "Pincode": "756027",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rupsa",
            "Pincode": "756028",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Basta",
            "Pincode": "756029",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Basta",
            "Pincode": "756029",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Amarda Road",
            "Pincode": "756030",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaleshwar HO",
            "Pincode": "756032",
            "City": "Jaleswar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaleshwar RS",
            "Pincode": "756032",
            "City": "Jaleswar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaleswar",
            "Pincode": "756032",
            "City": "Jaleswar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaleswar R S",
            "Pincode": "756032",
            "City": "Jaleswar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Naya Bazar Jaleshwar",
            "Pincode": "756032",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nayabazar Jaleswar",
            "Pincode": "756032",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hatigarh",
            "Pincode": "756033",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nampo",
            "Pincode": "756034",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kamarda",
            "Pincode": "756035",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dehurda",
            "Pincode": "756036",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Fulbani",
            "Pincode": "756037",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhogarai",
            "Pincode": "756038",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nilgiri College",
            "Pincode": "756040",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajnilgiri",
            "Pincode": "756040",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sanatta",
            "Pincode": "756040",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sajanagarh",
            "Pincode": "756041",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bahanaga",
            "Pincode": "756042",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kakhra",
            "Pincode": "756043",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khantapara",
            "Pincode": "756043",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gopalpur",
            "Pincode": "756044",
            "City": "Gopalpur",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hareswar",
            "Pincode": "756045",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Moharakpur",
            "Pincode": "756045",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Soro",
            "Pincode": "756045",
            "City": "Soro",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Soro Bazar",
            "Pincode": "756045",
            "City": "Soro",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Soro College",
            "Pincode": "756045",
            "City": "Soro",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Anantapur",
            "Pincode": "756046",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Turigaria",
            "Pincode": "756047",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khaira",
            "Pincode": "756048",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khaira",
            "Pincode": "756048",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Oupada",
            "Pincode": "756049",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Oupada",
            "Pincode": "756049",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jugpura",
            "Pincode": "756050",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Avana",
            "Pincode": "756051",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kudeinadi Gaon",
            "Pincode": "756052",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chak Jagannathpur",
            "Pincode": "756053",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chak Barhapur",
            "Pincode": "756054",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhaunriabad",
            "Pincode": "756055",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kurda",
            "Pincode": "756056",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balaramgadi",
            "Pincode": "756057",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raj Berhampur",
            "Pincode": "756058",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kupari",
            "Pincode": "756059",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Seragarh",
            "Pincode": "756060",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sadanandapur",
            "Pincode": "756071",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mandurkula",
            "Pincode": "756072",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Haldiapada",
            "Pincode": "756073",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dandika",
            "Pincode": "756074",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raibania",
            "Pincode": "756075",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raibania",
            "Pincode": "756075",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lakhnnath Road",
            "Pincode": "756076",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sartha",
            "Pincode": "756077",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Vellora",
            "Pincode": "756078",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dahamunda",
            "Pincode": "756079",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Irda",
            "Pincode": "756080",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jamsuli",
            "Pincode": "756081",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Machhadiha",
            "Pincode": "756082",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pratappur",
            "Pincode": "756083",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "D K College",
            "Pincode": "756084",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhadrak R S",
            "Pincode": "756101",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Charampa",
            "Pincode": "756101",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ichhapur",
            "Pincode": "756110",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ranital",
            "Pincode": "756111",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barikpur Bazar",
            "Pincode": "756112",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barpada",
            "Pincode": "756113",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bant",
            "Pincode": "756114",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barhat Trilochanpur",
            "Pincode": "756115",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Arnapal",
            "Pincode": "756116",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dakhinbad",
            "Pincode": "756117",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dham Nagar",
            "Pincode": "756117",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kothar",
            "Pincode": "756118",
            "City": "Bhadrak",
            "District": "Bhadrak",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dhusuri",
            "Pincode": "756119",
            "City": "Bhadrak",
            "District": "Bhadrak",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhandanipokhari",
            "Pincode": "756120",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Manjuri Road",
            "Pincode": "756121",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Akhuapada",
            "Pincode": "756122",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sabrang",
            "Pincode": "756123",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ertal",
            "Pincode": "756124",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Basudevpur",
            "Pincode": "756125",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Basudevpur College",
            "Pincode": "756125",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Prabodhapur",
            "Pincode": "756125",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Simulia",
            "Pincode": "756126",
            "City": "Bhadrak",
            "District": "Bhadrak",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dolasahi",
            "Pincode": "756127",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gujidarada",
            "Pincode": "756128",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ghanteswar",
            "Pincode": "756129",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tihiri",
            "Pincode": "756130",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pirhatbazar",
            "Pincode": "756131",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Motto",
            "Pincode": "756132",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandbali",
            "Pincode": "756133",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandbali Bazar",
            "Pincode": "756133",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ada",
            "Pincode": "756134",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Randiahat",
            "Pincode": "756135",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Churamani",
            "Pincode": "756136",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Asurali",
            "Pincode": "756137",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Arad",
            "Pincode": "756138",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Arsa",
            "Pincode": "756139",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Adhuan",
            "Pincode": "756140",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hatidihi",
            "Pincode": "756141",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kenduapada",
            "Pincode": "756142",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nandigaon",
            "Pincode": "756143",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Basantia",
            "Pincode": "756144",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bidyadharpur",
            "Pincode": "756161",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Eram",
            "Pincode": "756162",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Guamal",
            "Pincode": "756163",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Naikanidihi",
            "Pincode": "756164",
            "City": "Bhadrak",
            "District": "Bhadrak",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Brahmangaon",
            "Pincode": "756165",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balikhand",
            "Pincode": "756166",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Piliabindha",
            "Pincode": "756167",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Betada",
            "Pincode": "756168",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dungura",
            "Pincode": "756169",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madhabnagar",
            "Pincode": "756181",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ambikasahi",
            "Pincode": "757001",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baghra Road",
            "Pincode": "757001",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baripada",
            "Pincode": "757001",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baripada Bazar",
            "Pincode": "757001",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baripada Court",
            "Pincode": "757001",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baripada Hospital",
            "Pincode": "757001",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baripada Municipal Market",
            "Pincode": "757001",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baripada R S",
            "Pincode": "757001",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Deulasahi",
            "Pincode": "757001",
            "City": "Kendrapara",
            "District": "Kendrapara",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Palbamni Chhak",
            "Pincode": "757001",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tulasichaura",
            "Pincode": "757001",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baripada",
            "Pincode": "757002",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Belgaria",
            "Pincode": "757002",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhanjapur",
            "Pincode": "757002",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bijaya Ramchandrapur",
            "Pincode": "757002",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Takatpur",
            "Pincode": "757003",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandua Ashram",
            "Pincode": "757014",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kujidihi",
            "Pincode": "757015",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rasgovindpur",
            "Pincode": "757016",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mantri",
            "Pincode": "757017",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chitrada",
            "Pincode": "757018",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khunta",
            "Pincode": "757019",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Morda",
            "Pincode": "757020",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Deoli",
            "Pincode": "757021",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Garia",
            "Pincode": "757023",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sankerko",
            "Pincode": "757024",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Betnoti",
            "Pincode": "757025",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barsahi",
            "Pincode": "757026",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kuamara",
            "Pincode": "757027",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baisinga",
            "Pincode": "757028",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Krishna Chandrapur",
            "Pincode": "757029",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kuliana",
            "Pincode": "757030",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Shirsa",
            "Pincode": "757031",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bangiriposi",
            "Pincode": "757032",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bisoi",
            "Pincode": "757033",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Joshipur",
            "Pincode": "757034",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raruan",
            "Pincode": "757035",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tato",
            "Pincode": "757036",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Karanjia",
            "Pincode": "757037",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Karanjia Bazar",
            "Pincode": "757037",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Karanjia Court",
            "Pincode": "757037",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Karanjia Golei",
            "Pincode": "757037",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Thakurmunda",
            "Pincode": "757038",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sukruli",
            "Pincode": "757039",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kaptipada",
            "Pincode": "757040",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Udala",
            "Pincode": "757041",
            "City": "Udala",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Udala Bazar",
            "Pincode": "757041",
            "City": "Udala",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Udala College",
            "Pincode": "757041",
            "City": "Udala",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gorumoisani",
            "Pincode": "757042",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Anladuva",
            "Pincode": "757043",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madhuldiha",
            "Pincode": "757043",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rairangpur",
            "Pincode": "757043",
            "City": "Rairangpur",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rairangpur Bazar",
            "Pincode": "757043",
            "City": "Rairangpur",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rairangpur R S",
            "Pincode": "757043",
            "City": "Rairangpur",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jamda",
            "Pincode": "757045",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bahalda",
            "Pincode": "757046",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Badampahar",
            "Pincode": "757047",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bijatala",
            "Pincode": "757048",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Shyamakhunta",
            "Pincode": "757049",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hatbadra",
            "Pincode": "757050",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Saraskana",
            "Pincode": "757051",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kusumi",
            "Pincode": "757052",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bahalda Road R S",
            "Pincode": "757054",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Amarda",
            "Pincode": "757055",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandanpur",
            "Pincode": "757071",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Paiksahi",
            "Pincode": "757072",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nalagaja",
            "Pincode": "757073",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Basipitha",
            "Pincode": "757074",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dukuru",
            "Pincode": "757075",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khaunua",
            "Pincode": "757076",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nudadiha",
            "Pincode": "757077",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Badjod",
            "Pincode": "757078",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sarat",
            "Pincode": "757079",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sridamchandrapur",
            "Pincode": "757080",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kumbhar Mundakata",
            "Pincode": "757081",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Garhdeulia",
            "Pincode": "757082",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhimda",
            "Pincode": "757083",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kostha",
            "Pincode": "757084",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kusalda",
            "Pincode": "757085",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jhadpokhria",
            "Pincode": "757086",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Brundabanchandrapur",
            "Pincode": "757087",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khairi Jashipur",
            "Pincode": "757091",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kusumbandi",
            "Pincode": "757092",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Joka",
            "Pincode": "757093",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Radho",
            "Pincode": "757101",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Puruna Baripada",
            "Pincode": "757102",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pratappur",
            "Pincode": "757103",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bahanada",
            "Pincode": "757104",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kuchei",
            "Pincode": "757105",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Salchua",
            "Pincode": "757106",
            "City": "Baripara",
            "District": "Mayurbhanj",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Keonjhar Atopur",
            "Pincode": "758001",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Keonjhar Court",
            "Pincode": "758001",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Keonjhar New Market",
            "Pincode": "758001",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Keonjhargarh",
            "Pincode": "758001",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Keonjhat Minig School",
            "Pincode": "758001",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Keonjhat S C College",
            "Pincode": "758001",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madhapur",
            "Pincode": "758001",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Keonjhat Bazar",
            "Pincode": "758002",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raisuan",
            "Pincode": "758013",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Naranpur",
            "Pincode": "758014",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ghasipura",
            "Pincode": "758015",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Saharpada",
            "Pincode": "758016",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajnagar",
            "Pincode": "758017",
            "City": "Kendrapara",
            "District": "Kendrapara",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Suakati",
            "Pincode": "758018",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Telkoi",
            "Pincode": "758019",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Salapada",
            "Pincode": "758020",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Anandapur",
            "Pincode": "758021",
            "City": "Anandapur",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Fakirpur",
            "Pincode": "758022",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hadgarh",
            "Pincode": "758023",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kusaleswar",
            "Pincode": "758025",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Talpada",
            "Pincode": "758026",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ghatgaon",
            "Pincode": "758027",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Harichandanpur",
            "Pincode": "758028",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dhenkikote",
            "Pincode": "758029",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Swam Patna",
            "Pincode": "758030",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jhumpura",
            "Pincode": "758031",
            "City": "Jhumpura",
            "District": "Debagarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ukhunda",
            "Pincode": "758032",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baliparbat",
            "Pincode": "758033",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Joda",
            "Pincode": "758034",
            "City": "Joda",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Joda Bazar",
            "Pincode": "758034",
            "City": "Joda",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barbil",
            "Pincode": "758035",
            "City": "Barbil",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barbil Bazar",
            "Pincode": "758035",
            "City": "Barbil",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sundar Shivmandir",
            "Pincode": "758035",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Matkambeda",
            "Pincode": "758036",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bolani",
            "Pincode": "758037",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Banaikela",
            "Pincode": "758038",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kiribur Hill Top",
            "Pincode": "758040",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Champua",
            "Pincode": "758041",
            "City": "Champua",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nalda",
            "Pincode": "758042",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sainkul",
            "Pincode": "758043",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Karanjia",
            "Pincode": "758044",
            "City": "Karanjia",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Udayapur",
            "Pincode": "758045",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Turumunga",
            "Pincode": "758046",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Remuli",
            "Pincode": "758047",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalikaprasad",
            "Pincode": "758048",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dhakota",
            "Pincode": "758049",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhadrasahi",
            "Pincode": "758051",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jajang",
            "Pincode": "758052",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chamakpur",
            "Pincode": "758053",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Palaspanga",
            "Pincode": "758054",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ramachandrapur",
            "Pincode": "758061",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Panchapally",
            "Pincode": "758062",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khaliamenta",
            "Pincode": "758063",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kantipal",
            "Pincode": "758064",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pandapada",
            "Pincode": "758071",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Banspal",
            "Pincode": "758072",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Padmapur",
            "Pincode": "758073",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mandua",
            "Pincode": "758074",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khirei Tangiri",
            "Pincode": "758075",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sirigida",
            "Pincode": "758076",
            "City": "Debagarh",
            "District": "Debagarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kesudurapal",
            "Pincode": "758077",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dhanurjayapur",
            "Pincode": "758078",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Janghira",
            "Pincode": "758079",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhagamunda",
            "Pincode": "758080",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Machhagarh",
            "Pincode": "758081",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baji Chowk",
            "Pincode": "759001",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dhenkanal",
            "Pincode": "759001",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dhenkanal College",
            "Pincode": "759001",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jubilee Town",
            "Pincode": "759001",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dhenkanal R S",
            "Pincode": "759013",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mahimagadi",
            "Pincode": "759014",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhapur",
            "Pincode": "759015",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Goridiapatna",
            "Pincode": "759016",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhuban",
            "Pincode": "759017",
            "City": "Bhuban",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kamakhyanagar",
            "Pincode": "759018",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hindol Road R S",
            "Pincode": "759019",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balimi",
            "Pincode": "759020",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rasol",
            "Pincode": "759021",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hindol",
            "Pincode": "759022",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Marthapur",
            "Pincode": "759023",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mathakargola",
            "Pincode": "759024",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gadasila",
            "Pincode": "759025",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Analabereni",
            "Pincode": "759026",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Govindpur",
            "Pincode": "759027",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kankadahad",
            "Pincode": "759028",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Fulpada",
            "Pincode": "759029",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sadangi",
            "Pincode": "759030",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baulpur",
            "Pincode": "759031",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dhalpur",
            "Pincode": "759032",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Karanda",
            "Pincode": "759033",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balarampur",
            "Pincode": "759034",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kantiokateni",
            "Pincode": "759035",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Badakhamar",
            "Pincode": "759036",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Samal Barrage",
            "Pincode": "759037",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Badasualo",
            "Pincode": "759039",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Talcher Thermal",
            "Pincode": "759101",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Deulbera Colliery",
            "Pincode": "759102",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dera Colliary",
            "Pincode": "759103",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chainpal Colony",
            "Pincode": "759104",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rengali Damsite",
            "Pincode": "759105",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Vikrampur",
            "Pincode": "759106",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Talcher Twon",
            "Pincode": "759107",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balanda",
            "Pincode": "759116",
            "City": "Debagarh",
            "District": "Debagarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kaniha",
            "Pincode": "759117",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khamar",
            "Pincode": "759118",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pallahara",
            "Pincode": "759119",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Parjang",
            "Pincode": "759120",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Meramandali",
            "Pincode": "759121",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Angul",
            "Pincode": "759122",
            "City": "Bargarh",
            "District": "Bargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Angul Bazar",
            "Pincode": "759122",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "P T C Angul",
            "Pincode": "759123",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chhendipada",
            "Pincode": "759124",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Athmallik",
            "Pincode": "759125",
            "City": "Athmallik",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajkisherenagar",
            "Pincode": "759126",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kishoreganj",
            "Pincode": "759127",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Banarpal",
            "Pincode": "759128",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bantala",
            "Pincode": "759129",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kosala",
            "Pincode": "759130",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jagannathpur",
            "Pincode": "759131",
            "City": "Bhadrak",
            "District": "Bhadrak",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hulursinga",
            "Pincode": "759132",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bamur",
            "Pincode": "759133",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Handapa",
            "Pincode": "759134",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gotamara",
            "Pincode": "759135",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raijharan",
            "Pincode": "759136",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kumursinga",
            "Pincode": "759137",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jarapada",
            "Pincode": "759138",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Budhapank",
            "Pincode": "759139",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kumanda",
            "Pincode": "759140",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bagdia",
            "Pincode": "759141",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Thakurgarh",
            "Pincode": "759142",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hakimpada",
            "Pincode": "759143",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tubey",
            "Pincode": "759144",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nalco Nagar",
            "Pincode": "759145",
            "City": "Dhenkanal",
            "District": "Dhenkanal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Badakemundi Street",
            "Pincode": "760001",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Berhampur",
            "Pincode": "760001",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Berumphur HO",
            "Pincode": "760001",
            "City": "Baleshwar",
            "District": "Baleshwar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhapur Bazar",
            "Pincode": "760001",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bijipur",
            "Pincode": "760001",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "760001",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gate Bazar",
            "Pincode": "760001",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Godavarishnagar",
            "Pincode": "760001",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khallikote College",
            "Pincode": "760001",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Military Lines",
            "Pincode": "760001",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Berhampur City",
            "Pincode": "760002",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Park Street",
            "Pincode": "760002",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Preem Nagar",
            "Pincode": "760002",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sriram Nagar",
            "Pincode": "760002",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gosani Nuagaon",
            "Pincode": "760003",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baidyanathpur",
            "Pincode": "760004",
            "City": "Baudh",
            "District": "Baudh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Courtpeta",
            "Pincode": "760004",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Goilundi",
            "Pincode": "760004",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Medical College",
            "Pincode": "760004",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hilpatna",
            "Pincode": "760005",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Haridakhandi",
            "Pincode": "760006",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Panigrahipentha",
            "Pincode": "760006",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sankarpur",
            "Pincode": "760006",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Berhampur",
            "Pincode": "760007",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "University",
            "Pincode": "760007",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Berhampur Industrial Este",
            "Pincode": "760008",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lanjipalli",
            "Pincode": "760008",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nabeen",
            "Pincode": "760009",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Berhampur 10",
            "Pincode": "760010",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Engineering School Berham",
            "Pincode": "760010",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Indrakhi",
            "Pincode": "760031",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bahadurpetta",
            "Pincode": "760032",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Konisi",
            "Pincode": "760033",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Padmapur",
            "Pincode": "760034",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nimakhandi",
            "Pincode": "761001",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gopalpur",
            "Pincode": "761002",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhatkumarda",
            "Pincode": "761003",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Patrapur",
            "Pincode": "761004",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaradagad",
            "Pincode": "761005",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jayantipur",
            "Pincode": "761006",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Padmanbhapur",
            "Pincode": "761007",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Golanthra",
            "Pincode": "761008",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Girisola",
            "Pincode": "761009",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chikati",
            "Pincode": "761010",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuapada",
            "Pincode": "761011",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Digapahandi",
            "Pincode": "761012",
            "City": "Digapahandi",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pattopur",
            "Pincode": "761013",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pudamari",
            "Pincode": "761014",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mohana",
            "Pincode": "761015",
            "City": "Parlakhemundi",
            "District": "Gajapati",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "R Udaigiri",
            "Pincode": "761016",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandragiri",
            "Pincode": "761017",
            "City": "Rayagada",
            "District": "Rayagada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bus Stand",
            "Pincode": "761018",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Purusothampur New",
            "Pincode": "761018",
            "City": "Purusottampur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Purusottampur",
            "Pincode": "761018",
            "City": "Purusottampur",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pratapur",
            "Pincode": "761019",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chatrapur",
            "Pincode": "761020",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chatrapur Bazar",
            "Pincode": "761020",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "New Reserve",
            "Pincode": "761020",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Policeline",
            "Pincode": "761020",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sitarampalli",
            "Pincode": "761020",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Digapahandi Tahasil",
            "Pincode": "761021",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jayasree",
            "Pincode": "761025",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ganjam",
            "Pincode": "761026",
            "City": "Ganjam",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Humma",
            "Pincode": "761027",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Minchinpatna",
            "Pincode": "761028",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rambha",
            "Pincode": "761028",
            "City": "Rambha",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khallikote R S",
            "Pincode": "761029",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khallikote",
            "Pincode": "761030",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Beguniapada",
            "Pincode": "761031",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kodala",
            "Pincode": "761032",
            "City": "Kodala",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kodala Bus Stand",
            "Pincode": "761032",
            "City": "Kodala",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kodala Tahasil Colony",
            "Pincode": "761032",
            "City": "Kodala",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gondala",
            "Pincode": "761033",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mahendragada",
            "Pincode": "761034",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sumandalo",
            "Pincode": "761035",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sabulia",
            "Pincode": "761036",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Surangi",
            "Pincode": "761037",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Phasi",
            "Pincode": "761038",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kanhaipur",
            "Pincode": "761039",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuagam Chikiti",
            "Pincode": "761040",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Badakharida",
            "Pincode": "761041",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bomkei",
            "Pincode": "761042",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pandia",
            "Pincode": "761043",
            "City": "Jagatsinghapur",
            "District": "Jagatsinghapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Athagarh Patna",
            "Pincode": "761044",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Matikhal",
            "Pincode": "761045",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Munshipentha",
            "Pincode": "761046",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Narendrapur",
            "Pincode": "761051",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Golabandh",
            "Pincode": "761052",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Samantipalli",
            "Pincode": "761053",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ballipada",
            "Pincode": "761054",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bissamgiri",
            "Pincode": "761055",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sahapur",
            "Pincode": "761056",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kanchuru",
            "Pincode": "761101",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hinjilicut",
            "Pincode": "761102",
            "City": "Hinjilicut",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hinjilicut College Road",
            "Pincode": "761102",
            "City": "Hinjilicut",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Laxmi Bazar",
            "Pincode": "761102",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pitala",
            "Pincode": "761103",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bandadevipatna",
            "Pincode": "761104",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gopinathpatna",
            "Pincode": "761104",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kavisuryangar",
            "Pincode": "761104",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Polsara",
            "Pincode": "761105",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ranipada",
            "Pincode": "761105",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Seragada",
            "Pincode": "761106",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dharakote",
            "Pincode": "761107",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Suruda",
            "Pincode": "761108",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Suruda Bazar",
            "Pincode": "761108",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bodagada",
            "Pincode": "761109",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Aska",
            "Pincode": "761110",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Aska Junction",
            "Pincode": "761110",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sunambo Street Aska",
            "Pincode": "761110",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Taluk Office Road Aska",
            "Pincode": "761110",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Aska College Square",
            "Pincode": "761111",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuagam Aska College",
            "Pincode": "761111",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mathura",
            "Pincode": "761112",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kaspakaradakona",
            "Pincode": "761113",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mundamarai",
            "Pincode": "761114",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gunthapada",
            "Pincode": "761115",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhetnoi",
            "Pincode": "761116",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ballipadar",
            "Pincode": "761117",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Badadandasahi",
            "Pincode": "761118",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Buguda",
            "Pincode": "761118",
            "City": "Buguda",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Badadanda Sahi",
            "Pincode": "761119",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bellguntha",
            "Pincode": "761119",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bargaon",
            "Pincode": "761120",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaganathprasad",
            "Pincode": "761121",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nimina",
            "Pincode": "761122",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gangapur",
            "Pincode": "761123",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gobara",
            "Pincode": "761124",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Badakodanda",
            "Pincode": "761125",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhanj Bazar",
            "Pincode": "761126",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhanj Marg",
            "Pincode": "761126",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhanja Nagar",
            "Pincode": "761126",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhanjnagar College",
            "Pincode": "761127",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhejiput",
            "Pincode": "761127",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khukundia Nuagada",
            "Pincode": "761128",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kullada",
            "Pincode": "761131",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mujjagada",
            "Pincode": "761132",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jullundi",
            "Pincode": "761133",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Burupada",
            "Pincode": "761134",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Debabhumi",
            "Pincode": "761135",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "761136",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Subalaya",
            "Pincode": "761136",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baragaon",
            "Pincode": "761137",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tarasinigi",
            "Pincode": "761138",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Panchabhuti",
            "Pincode": "761139",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tanarada",
            "Pincode": "761140",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Galleri",
            "Pincode": "761141",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jhadabhumi",
            "Pincode": "761142",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Karachuli",
            "Pincode": "761143",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Konkarada",
            "Pincode": "761144",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khambeswaripatna",
            "Pincode": "761145",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raghunathnagar",
            "Pincode": "761145",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Asurabandha",
            "Pincode": "761151",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Paralakhemundi",
            "Pincode": "761201",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Paralakhemundi-2",
            "Pincode": "761201",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kashinagar",
            "Pincode": "761206",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gumma",
            "Pincode": "761207",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kharada",
            "Pincode": "761208",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khariaguda",
            "Pincode": "761209",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gurandi",
            "Pincode": "761210",
            "City": "Phulbani",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Upalada",
            "Pincode": "761211",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Narayanpur",
            "Pincode": "761212",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rayagada",
            "Pincode": "761213",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuagada",
            "Pincode": "761214",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Garabandha",
            "Pincode": "761215",
            "City": "Parlakhemundi",
            "District": "Gajapati",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Serango",
            "Pincode": "761216",
            "City": "Parlakhemundi",
            "District": "Gajapati",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Odaba",
            "Pincode": "761217",
            "City": "Chatrapur",
            "District": "Ganjam",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Contractorpada",
            "Pincode": "762001",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madikunda",
            "Pincode": "762001",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Masterpada",
            "Pincode": "762001",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "O B Nagar",
            "Pincode": "762001",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Penjisahi",
            "Pincode": "762001",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Phulbani",
            "Pincode": "762001",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Phulbani Bazar",
            "Pincode": "762001",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tikkabali",
            "Pincode": "762010",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Phiringia",
            "Pincode": "762011",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khajuripada",
            "Pincode": "762012",
            "City": "Parlakhemundi",
            "District": "Gajapati",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Purunakatak",
            "Pincode": "762013",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Boudh Court",
            "Pincode": "762014",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Boudh Nagar",
            "Pincode": "762014",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Boudhraj",
            "Pincode": "762014",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Malisahi",
            "Pincode": "762014",
            "City": "Anugul",
            "District": "Anugul",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baunsuni",
            "Pincode": "762015",
            "City": "Baudh",
            "District": "Baudh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Manmunda",
            "Pincode": "762016",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kantamal",
            "Pincode": "762017",
            "City": "Baudh",
            "District": "Baudh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ghantapara",
            "Pincode": "762018",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sankarkhole",
            "Pincode": "762019",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bamunigaon",
            "Pincode": "762021",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Harbhanga",
            "Pincode": "762021",
            "City": "Baudh",
            "District": "Baudh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalinga",
            "Pincode": "762022",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jhadaragingi",
            "Pincode": "762023",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Biranarsinghpur",
            "Pincode": "762024",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bastingia",
            "Pincode": "762025",
            "City": "Phulbani",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sarasara",
            "Pincode": "762026",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Linepada",
            "Pincode": "762027",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chakapada",
            "Pincode": "762028",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gumagarh",
            "Pincode": "762029",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baghiabahal",
            "Pincode": "762030",
            "City": "Baudh",
            "District": "Baudh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raikia",
            "Pincode": "762101",
            "City": "Phulbani",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuagaon",
            "Pincode": "762102",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balliguda",
            "Pincode": "762103",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuasahi",
            "Pincode": "762103",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Daringabadi",
            "Pincode": "762104",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kotharh",
            "Pincode": "762105",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sarangada",
            "Pincode": "762106",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tumribandh",
            "Pincode": "762107",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rudangia",
            "Pincode": "762108",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kurtumgarh",
            "Pincode": "762109",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barkhama",
            "Pincode": "762110",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mallikapodi",
            "Pincode": "762111",
            "City": "Kandhamal",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Paburia",
            "Pincode": "762112",
            "City": "Phulbani",
            "District": "Kandhamal",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sunabeda I",
            "Pincode": "763001",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sector-Vii Sunabeda",
            "Pincode": "763002",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sunabeda Ii",
            "Pincode": "763002",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "D P Camp Sunabeda-3",
            "Pincode": "763003",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Damanjodi",
            "Pincode": "763008",
            "City": "Damanjodi",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bidyadharpur",
            "Pincode": "764001",
            "City": "Panikoii",
            "District": "Jajapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaypore",
            "Pincode": "764001",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jeypore",
            "Pincode": "764001",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jeypore",
            "Pincode": "764001",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Koraput Road",
            "Pincode": "764001",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jeypore",
            "Pincode": "764002",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jeypore-2",
            "Pincode": "764002",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jeypore",
            "Pincode": "764003",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Prasadraopentha",
            "Pincode": "764003",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jeypore",
            "Pincode": "764004",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jayanagar",
            "Pincode": "764005",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Taragaon",
            "Pincode": "764008",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kolabnagar",
            "Pincode": "764011",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kundra",
            "Pincode": "764012",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Koraput",
            "Pincode": "764020",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Koraput Market",
            "Pincode": "764020",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Koraput R S",
            "Pincode": "764020",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "O M P Line Koraput",
            "Pincode": "764021",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Koraput Collectorate",
            "Pincode": "764022",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bandhugaon",
            "Pincode": "764027",
            "City": "Cuttack",
            "District": "Cuttack",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Similiguda",
            "Pincode": "764036",
            "City": "Malkangiri",
            "District": "Malkangiri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nandapur",
            "Pincode": "764037",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Padwa",
            "Pincode": "764038",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pottangi",
            "Pincode": "764039",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Machkund",
            "Pincode": "764040",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jalput",
            "Pincode": "764041",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Onukadeli",
            "Pincode": "764042",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Boipariguda",
            "Pincode": "764043",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mathili",
            "Pincode": "764044",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Malkangiri",
            "Pincode": "764045",
            "City": "Malkangiri",
            "District": "Malkangiri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Panchabati",
            "Pincode": "764046",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalimela",
            "Pincode": "764047",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Malkangiri Colony",
            "Pincode": "764048",
            "City": "Malkangiri",
            "District": "Malkangiri",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lachipeta",
            "Pincode": "764049",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balimela",
            "Pincode": "764051",
            "City": "Balimela",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chitrakonda",
            "Pincode": "764052",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dyke Iii",
            "Pincode": "764053",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bandhamamidi",
            "Pincode": "764054",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dyke I",
            "Pincode": "764054",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ambaguda",
            "Pincode": "764055",
            "City": "Naupada",
            "District": "Naupada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bandhamamidi",
            "Pincode": "764056",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barigumma",
            "Pincode": "764056",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhairabasinghpur",
            "Pincode": "764057",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kotpad",
            "Pincode": "764058",
            "City": "Kotpad",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nowrangpur",
            "Pincode": "764059",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nowrangpur Bazar",
            "Pincode": "764059",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Batasana",
            "Pincode": "764060",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kosagumuda",
            "Pincode": "764061",
            "City": "Nabarangapur",
            "District": "Nabarangapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bikrampur",
            "Pincode": "764062",
            "City": "Parlakhemundi",
            "District": "Gajapati",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mirganiguda",
            "Pincode": "764063",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Anchalgumma",
            "Pincode": "764069",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tentulikhunti",
            "Pincode": "764070",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Papadahandi",
            "Pincode": "764071",
            "City": "Nabarangapur",
            "District": "Nabarangapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dabugaon",
            "Pincode": "764072",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Umerkota",
            "Pincode": "764073",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Umerkote Bazar",
            "Pincode": "764073",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raighar",
            "Pincode": "764074",
            "City": "Nabarangapur",
            "District": "Nabarangapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kodinga",
            "Pincode": "764075",
            "City": "Nabarangapur",
            "District": "Nabarangapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandahandi",
            "Pincode": "764077",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Danganerbheja",
            "Pincode": "764078",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jharigam",
            "Pincode": "764079",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lamptaput",
            "Pincode": "764081",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Korkonda",
            "Pincode": "764082",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandra Sekhar Prasad",
            "Pincode": "764083",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chattahandi",
            "Pincode": "764083",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hardoli",
            "Pincode": "764084",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Indrapur",
            "Pincode": "764085",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "765001",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rayagada",
            "Pincode": "765001",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rayagada",
            "Pincode": "765001",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rayagada",
            "Pincode": "765001",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rayagada",
            "Pincode": "765001",
            "City": "Parlakhemundi",
            "District": "Gajapati",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rayagada",
            "Pincode": "765002",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rayagada",
            "Pincode": "765002",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kolanara",
            "Pincode": "765012",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lakhmipur",
            "Pincode": "765013",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Narayanpatna",
            "Pincode": "765014",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kashipur",
            "Pincode": "765015",
            "City": "Rayagada",
            "District": "Rayagada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalyansinghpur",
            "Pincode": "765016",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaykaypur",
            "Pincode": "765017",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaykaypur Bazar",
            "Pincode": "765017",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Therubali",
            "Pincode": "765018",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bissam Cuttack",
            "Pincode": "765019",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Muniguda",
            "Pincode": "765020",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ambadola",
            "Pincode": "765021",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gunupur",
            "Pincode": "765022",
            "City": "Gunupur",
            "District": "Rayagada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kujendri",
            "Pincode": "765023",
            "City": "Rayagada",
            "District": "Rayagada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ukkamba",
            "Pincode": "765024",
            "City": "Rayagada",
            "District": "Rayagada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Padmapur",
            "Pincode": "765025",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gudari",
            "Pincode": "765026",
            "City": "Gudari",
            "District": "Rayagada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dasmanthupur",
            "Pincode": "765028",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dungriline",
            "Pincode": "765028",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ramanaguda",
            "Pincode": "765029",
            "City": "Rayagada",
            "District": "Rayagada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kakirigumma",
            "Pincode": "765030",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jemadeipentha",
            "Pincode": "765031",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Naira",
            "Pincode": "765032",
            "City": "Koraput",
            "District": "Koraput",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bahadurbagichapara",
            "Pincode": "766001",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhawanipatna",
            "Pincode": "766001",
            "City": "Bhawanipatna",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhawanipatna",
            "Pincode": "766001",
            "City": "Bhawanipatna",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhawanipatna Clg Square",
            "Pincode": "766001",
            "City": "Bhawanipatna",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhawanipatna Stadium",
            "Pincode": "766001",
            "City": "Bhawanipatna",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "766001",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Naktiguda",
            "Pincode": "766001",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "766002",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Utkela",
            "Pincode": "766011",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jagannathpara",
            "Pincode": "766012",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kesinga",
            "Pincode": "766012",
            "City": "Kesinga",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kesinga R S",
            "Pincode": "766012",
            "City": "Kesinga",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalampur",
            "Pincode": "766013",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Junagarh",
            "Pincode": "766014",
            "City": "Junagarh",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Junagarh Brahminpara",
            "Pincode": "766014",
            "City": "Junagarh",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dharamgarh",
            "Pincode": "766015",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dharamgarh Market",
            "Pincode": "766015",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Deobhog",
            "Pincode": "766016",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Charbahal",
            "Pincode": "766017",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jaipatna",
            "Pincode": "766018",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Koksara",
            "Pincode": "766019",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Biswanathpur",
            "Pincode": "766020",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Pastikudi",
            "Pincode": "766021",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Golamunda",
            "Pincode": "766022",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mahichala",
            "Pincode": "766023",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ladugaon",
            "Pincode": "766024",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kandel",
            "Pincode": "766025",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mukhiguda",
            "Pincode": "766026",
            "City": "Mukhiguda",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lanjigarh",
            "Pincode": "766027",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ampani",
            "Pincode": "766028",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sosia",
            "Pincode": "766029",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rupra Road",
            "Pincode": "766101",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Parla",
            "Pincode": "766103",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gotma",
            "Pincode": "766104",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khariar Road",
            "Pincode": "766104",
            "City": "Naupada",
            "District": "Naupada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khariar Road Town",
            "Pincode": "766104",
            "City": "Naupada",
            "District": "Naupada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nawapara Tanwat",
            "Pincode": "766105",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Komna",
            "Pincode": "766106",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khariar",
            "Pincode": "766107",
            "City": "Khariar",
            "District": "Naupada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khariar Pattnaikpara",
            "Pincode": "766107",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sinhapalli",
            "Pincode": "766108",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Amsena",
            "Pincode": "766109",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Narla Road",
            "Pincode": "766110",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Boden",
            "Pincode": "766111",
            "City": "Naupada",
            "District": "Naupada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kandel Road",
            "Pincode": "766112",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madanpur Rampur",
            "Pincode": "766112",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tukla",
            "Pincode": "766113",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lakhna",
            "Pincode": "766114",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Behera",
            "Pincode": "766115",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Karlamunda",
            "Pincode": "766116",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bargaon",
            "Pincode": "766117",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhawanipatna",
            "Pincode": "766117",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Duajhat",
            "Pincode": "766118",
            "City": "Kalahandi",
            "District": "Kalahandi",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balangir",
            "Pincode": "767001",
            "City": "Balangir",
            "District": "Rayagada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balangir Court",
            "Pincode": "767001",
            "City": "Balangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balangir R S",
            "Pincode": "767001",
            "City": "Balangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "College Square",
            "Pincode": "767001",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gandhi Nagar",
            "Pincode": "767001",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Manoharpur",
            "Pincode": "767001",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Marwaribazar",
            "Pincode": "767001",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rugidipara",
            "Pincode": "767001",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sudpara",
            "Pincode": "767001",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Talpali",
            "Pincode": "767001",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tikrapara",
            "Pincode": "767001",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajendra College",
            "Pincode": "767002",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tarbha Bazar",
            "Pincode": "767016",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tardha",
            "Pincode": "767016",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ghodaghat Para",
            "Pincode": "767017",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sonepur Bazar",
            "Pincode": "767017",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sonepur Spinning Mill",
            "Pincode": "767017",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sonerpur Raj",
            "Pincode": "767017",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Birmaharajpur",
            "Pincode": "767018",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Binka",
            "Pincode": "767019",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Loisinga",
            "Pincode": "767020",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Salebhata",
            "Pincode": "767021",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Agalpur",
            "Pincode": "767022",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dungripalli",
            "Pincode": "767023",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Churapalli",
            "Pincode": "767024",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Patnagarh",
            "Pincode": "767025",
            "City": "Patnagarh",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Patnagarh Bazar",
            "Pincode": "767025",
            "City": "Patnagarh",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Belpara",
            "Pincode": "767026",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jogimunda",
            "Pincode": "767027",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khaprakhol",
            "Pincode": "767028",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Deogaon",
            "Pincode": "767029",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tusra",
            "Pincode": "767030",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Risida",
            "Pincode": "767031",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Saintala",
            "Pincode": "767032",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Titilagarh",
            "Pincode": "767033",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Titilagarh Court",
            "Pincode": "767033",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Titilagarh Hatapara",
            "Pincode": "767033",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ullunda",
            "Pincode": "767034",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sindhekela",
            "Pincode": "767035",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Borda",
            "Pincode": "767036",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Munibahal",
            "Pincode": "767037",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Harisankar Road",
            "Pincode": "767038",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kantabanji",
            "Pincode": "767039",
            "City": "Kantabanji",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kantabanji Bazar",
            "Pincode": "767039",
            "City": "Kantabanji",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kantabanji R S",
            "Pincode": "767039",
            "City": "Kantabanji",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Banganmura",
            "Pincode": "767040",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Patnagarh Rampur",
            "Pincode": "767041",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhatipara",
            "Pincode": "767042",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Turekella",
            "Pincode": "767043",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Maharapadar",
            "Pincode": "767044",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sonepur Rampur",
            "Pincode": "767045",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gudevella",
            "Pincode": "767046",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Belgaon",
            "Pincode": "767047",
            "City": "Naupada",
            "District": "Naupada",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhainsa",
            "Pincode": "767048",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ichhapara",
            "Pincode": "767049",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dumabhata",
            "Pincode": "767050",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Duduka",
            "Pincode": "767061",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sabulia",
            "Pincode": "767062",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mendha",
            "Pincode": "767063",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sukha",
            "Pincode": "767064",
            "City": "Sonapur",
            "District": "Sonapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chandanbhati",
            "Pincode": "767065",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kholan",
            "Pincode": "767066",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jarasinga",
            "Pincode": "767067",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lachhipur",
            "Pincode": "767068",
            "City": "Bolangir",
            "District": "Bolangir",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barbazar",
            "Pincode": "768001",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Birsurendra Sai Nagar",
            "Pincode": "768001",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Golebazar",
            "Pincode": "768001",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jharuapara",
            "Pincode": "768001",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Motijharan",
            "Pincode": "768001",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sakhigopinath",
            "Pincode": "768001",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sambalpur",
            "Pincode": "768001",
            "City": "Baudh",
            "District": "Baudh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sambalpur Court",
            "Pincode": "768001",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Modipara",
            "Pincode": "768002",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khetrajpur",
            "Pincode": "768003",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khetrajpur Market",
            "Pincode": "768003",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ainthapali",
            "Pincode": "768004",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Budharaja",
            "Pincode": "768004",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Alind Colony Hirakud",
            "Pincode": "768016",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hirakud",
            "Pincode": "768016",
            "City": "Hirakud",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Burla",
            "Pincode": "768017",
            "City": "Burla",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Medical College Burla",
            "Pincode": "768017",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Burla",
            "Pincode": "768018",
            "City": "Burla",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Engineering College",
            "Pincode": "768018",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jyoti Vihar",
            "Pincode": "768019",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Chiplima",
            "Pincode": "768026",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Attabira",
            "Pincode": "768027",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baragarh Bazar",
            "Pincode": "768028",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baragarh Court",
            "Pincode": "768028",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baragarh Panchayat Colleg",
            "Pincode": "768028",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baragarh Road R S",
            "Pincode": "768028",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bargarh",
            "Pincode": "768028",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barpali",
            "Pincode": "768029",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barpali Bazar",
            "Pincode": "768029",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhatli",
            "Pincode": "768030",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ambabhona",
            "Pincode": "768031",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bijeipur",
            "Pincode": "768032",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sohella",
            "Pincode": "768033",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ghess",
            "Pincode": "768034",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Melchhamunda",
            "Pincode": "768035",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajbersambar",
            "Pincode": "768036",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gaisilet",
            "Pincode": "768037",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bardol",
            "Pincode": "768038",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Paikamal",
            "Pincode": "768039",
            "City": "Bargarh",
            "District": "Bargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tora",
            "Pincode": "768040",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dungri",
            "Pincode": "768041",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jharbandh",
            "Pincode": "768042",
            "City": "Bargarh",
            "District": "Bargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kumbhari",
            "Pincode": "768043",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kadobahal",
            "Pincode": "768044",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhukta",
            "Pincode": "768045",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baragarh Katapali",
            "Pincode": "768046",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Agalpur",
            "Pincode": "768047",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Laumunda",
            "Pincode": "768048",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jamla",
            "Pincode": "768049",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mandosil",
            "Pincode": "768050",
            "City": "Bargarh",
            "District": "Bargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jagadalpur",
            "Pincode": "768051",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Store Quarry",
            "Pincode": "768052",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lakhanpur",
            "Pincode": "768053",
            "City": "Jharsuguda",
            "District": "Jharsuguda",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Deogaon",
            "Pincode": "768054",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Remed",
            "Pincode": "768101",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Larambha",
            "Pincode": "768102",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Remunda",
            "Pincode": "768103",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bheden",
            "Pincode": "768104",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jujumura",
            "Pincode": "768105",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rairakhole",
            "Pincode": "768106",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jamankira",
            "Pincode": "768107",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Deogarh",
            "Pincode": "768108",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Reamal",
            "Pincode": "768109",
            "City": "Debagarh",
            "District": "Debagarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barkote",
            "Pincode": "768110",
            "City": "Debagarh",
            "District": "Debagarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Godbhaga",
            "Pincode": "768111",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gourpati",
            "Pincode": "768112",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dhama",
            "Pincode": "768113",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gogua",
            "Pincode": "768114",
            "City": "Debagarh",
            "District": "Debagarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gondturum",
            "Pincode": "768115",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Malatigunderpur",
            "Pincode": "768116",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Charmal",
            "Pincode": "768117",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Naktideul",
            "Pincode": "768118",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Purunagarh",
            "Pincode": "768119",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Maneswar",
            "Pincode": "768120",
            "City": "Baudh",
            "District": "Baudh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gohira Damsite",
            "Pincode": "768121",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Baraipali",
            "Pincode": "768150",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "R R I Garmunda",
            "Pincode": "768151",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jharsuguda",
            "Pincode": "768201",
            "City": "Jharsuguda",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jharsuguda",
            "Pincode": "768201",
            "City": "Jharsuguda",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rly Colony Jharsuguda",
            "Pincode": "768201",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sarbahal",
            "Pincode": "768201",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Station Road",
            "Pincode": "768201",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalimandir Road",
            "Pincode": "768203",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "O M P Line",
            "Pincode": "768204",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sambalpur",
            "Pincode": "768205",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Talpatia",
            "Pincode": "768211",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rengali",
            "Pincode": "768212",
            "City": "Jharsuguda",
            "District": "Jharsuguda",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kolabira",
            "Pincode": "768213",
            "City": "Jharsuguda",
            "District": "Jharsuguda",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Loida",
            "Pincode": "768214",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Laikera",
            "Pincode": "768215",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Brajaraj Nagar",
            "Pincode": "768216",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Stn Road Brajaraj Nagar",
            "Pincode": "768216",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Belpahar R S",
            "Pincode": "768217",
            "City": "Belpahar",
            "District": "Jharsuguda",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Belpahar",
            "Pincode": "768218",
            "City": "Belpahar",
            "District": "Jharsuguda",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ainlapada",
            "Pincode": "768219",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bagdehi",
            "Pincode": "768220",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bamra",
            "Pincode": "768221",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bamra Basti",
            "Pincode": "768221",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kuchinda",
            "Pincode": "768222",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhojpur",
            "Pincode": "768223",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Garposh",
            "Pincode": "768224",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rampur Colliery",
            "Pincode": "768225",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Panchagaon",
            "Pincode": "768226",
            "City": "Kordha",
            "District": "Kordha",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kusumi",
            "Pincode": "768227",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kesiabahal",
            "Pincode": "768228",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "768229",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lamptibahal",
            "Pincode": "768230",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mahulpalli",
            "Pincode": "768231",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lapanga",
            "Pincode": "768232",
            "City": "Sambalpur",
            "District": "Sambalpur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Daily Market",
            "Pincode": "769001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Madhusudan Marg",
            "Pincode": "769001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Main Road",
            "Pincode": "769001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rourkela",
            "Pincode": "769001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rourkela-2",
            "Pincode": "769002",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sector-5",
            "Pincode": "769002",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sector-6",
            "Pincode": "769002",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rourkela-3",
            "Pincode": "769003",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sector-15",
            "Pincode": "769003",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sector-16",
            "Pincode": "769003",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sector-7",
            "Pincode": "769003",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "769004",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jail Road",
            "Pincode": "769004",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Panposh",
            "Pincode": "769004",
            "City": "Panposh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Panposh Road",
            "Pincode": "769004",
            "City": "Panposh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rourkela-4",
            "Pincode": "769004",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rourkela-5",
            "Pincode": "769005",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rourkela-6",
            "Pincode": "769006",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sector-2",
            "Pincode": "769006",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rourkela-7",
            "Pincode": "769007",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jagada",
            "Pincode": "769008",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Regional Engg College",
            "Pincode": "769008",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rourkela-8",
            "Pincode": "769008",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rourkela-9",
            "Pincode": "769009",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sector-8",
            "Pincode": "769009",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "O M P Line",
            "Pincode": "769010",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Civil Township",
            "Pincode": "769012",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kacheri Road",
            "Pincode": "769012",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Uditnagar",
            "Pincode": "769012",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Railway Colony",
            "Pincode": "769013",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Saktinagar",
            "Pincode": "769014",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Quairry Siding Panposh",
            "Pincode": "769015",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sonarparbat",
            "Pincode": "769016",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Vedvyas",
            "Pincode": "769041",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jhirpani",
            "Pincode": "769042",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jalda",
            "Pincode": "769043",
            "City": "Jalda",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Dengibhadi",
            "Pincode": "770001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Mahisdihi",
            "Pincode": "770001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ranibagicha",
            "Pincode": "770001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Regent Market",
            "Pincode": "770001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sundargarh",
            "Pincode": "770001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sundargarh College",
            "Pincode": "770001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sundargarh Court",
            "Pincode": "770001",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rangadhipa",
            "Pincode": "770002",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ujaplur",
            "Pincode": "770011",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lephripara",
            "Pincode": "770012",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hemgir",
            "Pincode": "770013",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Subdega",
            "Pincode": "770014",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Balisankara",
            "Pincode": "770015",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bargaon",
            "Pincode": "770016",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Liplay Rajganapur",
            "Pincode": "770017",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Railway Colony",
            "Pincode": "770017",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Rajgangpur",
            "Pincode": "770017",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Ranibandha",
            "Pincode": "770017",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kutra",
            "Pincode": "770018",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kundukela",
            "Pincode": "770019",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sankara",
            "Pincode": "770020",
            "City": "Sonapur",
            "District": "Sonapur",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sargipalli",
            "Pincode": "770021",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lanjiberna",
            "Pincode": "770023",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gopalpur",
            "Pincode": "770024",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhasma",
            "Pincode": "770025",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bhedabahal",
            "Pincode": "770026",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tangarpali",
            "Pincode": "770027",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kiralaga",
            "Pincode": "770028",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Raidihi",
            "Pincode": "770029",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalunga",
            "Pincode": "770031",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Turmura",
            "Pincode": "770031",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bondamunda",
            "Pincode": "770032",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Loco Colony",
            "Pincode": "770032",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Birmitrapur",
            "Pincode": "770033",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "C T D Bureau",
            "Pincode": "770033",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kansbahal",
            "Pincode": "770034",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Purnapani",
            "Pincode": "770035",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bisra",
            "Pincode": "770036",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bisra Road",
            "Pincode": "770036",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lathikata",
            "Pincode": "770037",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Bonaigarth",
            "Pincode": "770038",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kuarmunda",
            "Pincode": "770039",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Lahunipara",
            "Pincode": "770040",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Barsuan",
            "Pincode": "770041",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Tensa",
            "Pincode": "770042",
            "City": "Tensa",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Gurundia",
            "Pincode": "770043",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Khuntagaon",
            "Pincode": "770044",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sarasara Balang",
            "Pincode": "770045",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Banki Bazar",
            "Pincode": "770046",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hatibari",
            "Pincode": "770047",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Koira",
            "Pincode": "770048",
            "City": "Kendujhar",
            "District": "Kendujhar",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kamarposh Balang",
            "Pincode": "770049",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Nuagan",
            "Pincode": "770050",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kenabeta",
            "Pincode": "770051",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalta",
            "Pincode": "770052",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Industrial Estate",
            "Pincode": "770071",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kalunga",
            "Pincode": "770071",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Zink Nagar",
            "Pincode": "770072",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Kirei",
            "Pincode": "770073",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Talsara",
            "Pincode": "770074",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Hemgir Road",
            "Pincode": "770075",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Sahajbahal",
            "Pincode": "770076",
            "City": "Jharsuguda",
            "District": "Jharsuguda",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Jhagarpur",
            "Pincode": "770077",
            "City": "Sundargarh",
            "District": "Sundargarh",
            "State": "Orissa"
        },
        {
            "PostOfficeName": "Athgaon",
            "Pincode": "781001",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Fancy Bazar",
            "Pincode": "781001",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Guwahati",
            "Pincode": "781001",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Assam Engg Institute",
            "Pincode": "781003",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Assam Tribune",
            "Pincode": "781003",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chenikuthi",
            "Pincode": "781003",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Silpukhuri",
            "Pincode": "781003",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kharguli",
            "Pincode": "781004",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dispur",
            "Pincode": "781005",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Assam Sachivalaya",
            "Pincode": "781006",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Ulubari",
            "Pincode": "781007",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Paltanbazar",
            "Pincode": "781008",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rehabari",
            "Pincode": "781008",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bharalumukh",
            "Pincode": "781009",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kamakhya",
            "Pincode": "781010",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Maligaon Rly Hd Qrs",
            "Pincode": "781011",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Pandu",
            "Pincode": "781012",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Pandu Rly Colony",
            "Pincode": "781012",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jhalukbari",
            "Pincode": "781013",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Guwahati University",
            "Pincode": "781014",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Guwahati Airport",
            "Pincode": "781015",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gopinath Nagar",
            "Pincode": "781016",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Azara",
            "Pincode": "781017",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Binova Nagar",
            "Pincode": "781018",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kahilipara",
            "Pincode": "781019",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Noonmati",
            "Pincode": "781020",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bamunimaidan",
            "Pincode": "781021",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Khanapara",
            "Pincode": "781022",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Amerigog",
            "Pincode": "781023",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Ambasi Fatesil",
            "Pincode": "781025",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Narangi",
            "Pincode": "781026",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Satgaon",
            "Pincode": "781027",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Beltala",
            "Pincode": "781028",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "North Guwahati",
            "Pincode": "781030",
            "City": "North Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Amingaon",
            "Pincode": "781031",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Panjabari",
            "Pincode": "781037",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Panjabari",
            "Pincode": "781037",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Changsari",
            "Pincode": "781101",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hajo",
            "Pincode": "781102",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Soalkuchi",
            "Pincode": "781103",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barduar",
            "Pincode": "781120",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bezara",
            "Pincode": "781121",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bijoy Nagar",
            "Pincode": "781122",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Boko",
            "Pincode": "781123",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chhaygaon",
            "Pincode": "781124",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mirza",
            "Pincode": "781125",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mukalmua",
            "Pincode": "781126",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nagarbera",
            "Pincode": "781127",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Palasbari",
            "Pincode": "781128",
            "City": "Palasbari",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hahim Bazar",
            "Pincode": "781129",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Amranga",
            "Pincode": "781130",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rani",
            "Pincode": "781131",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "781132",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dharapur",
            "Pincode": "781133",
            "City": "Dharapur",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kukurmara",
            "Pincode": "781134",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Singra",
            "Pincode": "781135",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Paschimsamaria",
            "Pincode": "781136",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chandrapur",
            "Pincode": "781150",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Maukhuli",
            "Pincode": "781171",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barpeta",
            "Pincode": "781301",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barpeta Bazar",
            "Pincode": "781301",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Thakurbazar",
            "Pincode": "781301",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Baharihat",
            "Pincode": "781302",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Banagram",
            "Pincode": "781303",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Belsore",
            "Pincode": "781304",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chenga",
            "Pincode": "781305",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chamata",
            "Pincode": "781306",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sarthebari",
            "Pincode": "781307",
            "City": "Sarthebari",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mandia",
            "Pincode": "781308",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bhella",
            "Pincode": "781309",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jagara",
            "Pincode": "781310",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Santinagar",
            "Pincode": "781314",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barpeta Road",
            "Pincode": "781315",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Howli",
            "Pincode": "781316",
            "City": "Howli",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sorbhog",
            "Pincode": "781317",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sarupeta",
            "Pincode": "781318",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kalgachia",
            "Pincode": "781319",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Katabari",
            "Pincode": "781319",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chakchaki Bazar",
            "Pincode": "781320",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mainbari",
            "Pincode": "781321",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Pathsala",
            "Pincode": "781325",
            "City": "Pathsala",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Patacharkuchi",
            "Pincode": "781326",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jalaghat",
            "Pincode": "781327",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bagmara Bazar",
            "Pincode": "781328",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nityananda",
            "Pincode": "781329",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kakilabari Farm",
            "Pincode": "781330",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bidyapur",
            "Pincode": "781335",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nalbari",
            "Pincode": "781335",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chandkuchi",
            "Pincode": "781336",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Milonpur",
            "Pincode": "781337",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Solmara",
            "Pincode": "781338",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Koria",
            "Pincode": "781339",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Balilessa",
            "Pincode": "781345",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barama",
            "Pincode": "781346",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kamarkuchi",
            "Pincode": "781347",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Morowa",
            "Pincode": "781348",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nizdhamdhama",
            "Pincode": "781349",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sanekuchi",
            "Pincode": "781350",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kalag",
            "Pincode": "781351",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bhowanipur",
            "Pincode": "781352",
            "City": "Barpeta",
            "District": "Barpeta",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gopal Bazar",
            "Pincode": "781353",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rangia",
            "Pincode": "781354",
            "City": "Rangia",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kumarikata",
            "Pincode": "781360",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Maharipara",
            "Pincode": "781364",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Maharipara",
            "Pincode": "781364",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rangia R S",
            "Pincode": "781365",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gores War",
            "Pincode": "781366",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tambulpur",
            "Pincode": "781367",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nagrijuli",
            "Pincode": "781368",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gograpar",
            "Pincode": "781369",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kaithalkuchi",
            "Pincode": "781370",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tihu",
            "Pincode": "781371",
            "City": "Tihu",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mussalpur",
            "Pincode": "781372",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Doomni",
            "Pincode": "781373",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Makhibaha",
            "Pincode": "781374",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bangaon",
            "Pincode": "781375",
            "City": "Bongaigaon",
            "District": "Bongaigaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Darkuchi",
            "Pincode": "781376",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Thamana",
            "Pincode": "781377",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Haribhanga",
            "Pincode": "781378",
            "City": "Nalbari",
            "District": "Nalbari",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Balhata",
            "Pincode": "781380",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Baihata Charali",
            "Pincode": "781381",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Karara",
            "Pincode": "781382",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kaniha",
            "Pincode": "781385",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Markolong",
            "Pincode": "782001",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Marwari Patty",
            "Pincode": "782001",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nowgong",
            "Pincode": "782001",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nowgong Bazar",
            "Pincode": "782001",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tinali Panigaon",
            "Pincode": "782001",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Haibargaon",
            "Pincode": "782002",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nowgong Girls College",
            "Pincode": "782002",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Senchowa",
            "Pincode": "782010",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nanoi",
            "Pincode": "782101",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Berhampur",
            "Pincode": "782102",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Raha",
            "Pincode": "782103",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jaluguti",
            "Pincode": "782104",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Marigaon",
            "Pincode": "782105",
            "City": "Marigaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Marigaon",
            "Pincode": "782105",
            "City": "Marigaon",
            "District": "Marigaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barapujia",
            "Pincode": "782107",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mikirbheta",
            "Pincode": "782108",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mikirbheta",
            "Pincode": "782108",
            "City": "Marigaon",
            "District": "Marigaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Ambagan",
            "Pincode": "782120",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bhuragaon",
            "Pincode": "782121",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bhuragoan",
            "Pincode": "782121",
            "City": "Marigaon",
            "District": "Marigaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Batadrava",
            "Pincode": "782122",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhing",
            "Pincode": "782123",
            "City": "Dhing",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Juria",
            "Pincode": "782124",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rupahi",
            "Pincode": "782125",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Moirabari",
            "Pincode": "782126",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lahorighat",
            "Pincode": "782127",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Singimari",
            "Pincode": "782130",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chapanalla",
            "Pincode": "782135",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jakhalbandha",
            "Pincode": "782136",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kwaritol",
            "Pincode": "782137",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Missa",
            "Pincode": "782138",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Salana",
            "Pincode": "782139",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Samaguri",
            "Pincode": "782140",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Puranigudam",
            "Pincode": "782141",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bebejia",
            "Pincode": "782142",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Silghat",
            "Pincode": "782143",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Digaru",
            "Pincode": "782401",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sunapur",
            "Pincode": "782402",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Khetri",
            "Pincode": "782403",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jagi Road",
            "Pincode": "782410",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jagibhakatagon",
            "Pincode": "782411",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dharamtul",
            "Pincode": "782412",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chaparmukh",
            "Pincode": "782425",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kampur",
            "Pincode": "782426",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kathiatali",
            "Pincode": "782427",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jamunamukh",
            "Pincode": "782428",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hojai",
            "Pincode": "782435",
            "City": "Hojai",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hojai Bazar",
            "Pincode": "782435",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Murajar Bazar",
            "Pincode": "782439",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Daboka",
            "Pincode": "782440",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nilbagan",
            "Pincode": "782445",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lanka",
            "Pincode": "782446",
            "City": "Lanka",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Harlongpher",
            "Pincode": "782447",
            "City": "Nagaon",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lumding",
            "Pincode": "782447",
            "City": "Lumding",
            "District": "Nagaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kheroni",
            "Pincode": "782448",
            "City": "Diphu",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Baithalangshu",
            "Pincode": "782450",
            "City": "Diphu",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Diphu",
            "Pincode": "782460",
            "City": "Diphu",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Manja",
            "Pincode": "782461",
            "City": "Diphu",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bokajan Cement Factory",
            "Pincode": "782470",
            "City": "Diphu",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhansiripar",
            "Pincode": "782470",
            "City": "Golaghat",
            "District": "Golaghat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chokihola",
            "Pincode": "782475",
            "City": "Diphu",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bokajan",
            "Pincode": "782480",
            "City": "Bokajan",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Howraghat",
            "Pincode": "782481",
            "City": "Howraghat",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bakoliaghat",
            "Pincode": "782482",
            "City": "Diphu",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Donkamukam",
            "Pincode": "782485",
            "City": "Diphu",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hamren",
            "Pincode": "782486",
            "City": "Hamren",
            "District": "Karbi Anglong",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Goalpara",
            "Pincode": "783101",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Agia",
            "Pincode": "783120",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Baladmari",
            "Pincode": "783121",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Damru",
            "Pincode": "783122",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhupdhara",
            "Pincode": "783123",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dudnai",
            "Pincode": "783124",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Matia",
            "Pincode": "783125",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Krishnai",
            "Pincode": "783126",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Salmara South",
            "Pincode": "783127",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lakhipur Goalpara",
            "Pincode": "783129",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rongjuli",
            "Pincode": "783130",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mankachar",
            "Pincode": "783131",
            "City": "Mankachar",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jaleswar",
            "Pincode": "783132",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rajapara",
            "Pincode": "783133",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Darrangiri",
            "Pincode": "783134",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhubri",
            "Pincode": "783301",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhubri Baluchar",
            "Pincode": "783301",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhubri Bazar",
            "Pincode": "783301",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Santinagar",
            "Pincode": "783301",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dharamsala",
            "Pincode": "783325",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Fakirganj",
            "Pincode": "783330",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gouri Pur",
            "Pincode": "783331",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tamarhat",
            "Pincode": "783332",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dingdinga",
            "Pincode": "783333",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Golakganj",
            "Pincode": "783334",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Agamani",
            "Pincode": "783335",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sapatgram",
            "Pincode": "783337",
            "City": "Sapatgram",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Satrasal",
            "Pincode": "783338",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Alamganj",
            "Pincode": "783339",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hospital Road Raniganj",
            "Pincode": "783344",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Fakiragram",
            "Pincode": "783345",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sarfanguri",
            "Pincode": "783346",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Datma",
            "Pincode": "783347",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bilashipara",
            "Pincode": "783348",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bogribari",
            "Pincode": "783349",
            "City": "Dhubri",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kachugaon",
            "Pincode": "783350",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lakhiganj Bazar",
            "Pincode": "783351",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gossain Gaon",
            "Pincode": "783360",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Srirampur",
            "Pincode": "783361",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Garuphela Bazar",
            "Pincode": "783362",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kokrajhar",
            "Pincode": "783370",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chapar",
            "Pincode": "783371",
            "City": "Chapar",
            "District": "Dhubri",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Basugaon",
            "Pincode": "783372",
            "City": "Basugaon",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sidli",
            "Pincode": "783373",
            "City": "Bongaigaon",
            "District": "Bongaigaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sakti Ashram",
            "Pincode": "783374",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Titagur",
            "Pincode": "783374",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bongaigaon",
            "Pincode": "783380",
            "City": "Bongaigaon",
            "District": "Bongaigaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "New Bongaigaon",
            "Pincode": "783381",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jogighopa",
            "Pincode": "783382",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Salmara North",
            "Pincode": "783383",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Abhayapuri",
            "Pincode": "783384",
            "City": "Abhayapuri",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhaligaon",
            "Pincode": "783385",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barghola Srijangram",
            "Pincode": "783386",
            "City": "Bongaigaon",
            "District": "Bongaigaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barabazar",
            "Pincode": "783387",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Ashok Paper Mills",
            "Pincode": "783388",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Boitamari",
            "Pincode": "783389",
            "City": "Goalpara",
            "District": "Goalpara",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bijni",
            "Pincode": "783390",
            "City": "Bijni",
            "District": "Bongaigaon",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Patiladah",
            "Pincode": "783391",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Manikpur",
            "Pincode": "783392",
            "City": "Kokrajhar",
            "District": "Kokrajhar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hazrapara",
            "Pincode": "784001",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kacharigaon",
            "Pincode": "784001",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kalibari",
            "Pincode": "784001",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mahabhairab",
            "Pincode": "784001",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sonitpur",
            "Pincode": "784001",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tezpur",
            "Pincode": "784001",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tezpur Bazar",
            "Pincode": "784001",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Panchmile",
            "Pincode": "784025",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Balipara",
            "Pincode": "784101",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lokra",
            "Pincode": "784102",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Charduar",
            "Pincode": "784103",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Salonibari",
            "Pincode": "784104",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhekiajuli",
            "Pincode": "784110",
            "City": "Dhekiajuli",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Darrangpanbari",
            "Pincode": "784111",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Alisinga",
            "Pincode": "784112",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kopati",
            "Pincode": "784113",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kharupatiaghat",
            "Pincode": "784115",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dalgaon",
            "Pincode": "784116",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sirajuli",
            "Pincode": "784117",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barsola",
            "Pincode": "784118",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Batasipur",
            "Pincode": "784119",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Singri",
            "Pincode": "784120",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mangaldai",
            "Pincode": "784125",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Patharighat",
            "Pincode": "784144",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sipajhar",
            "Pincode": "784145",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Deomarnai",
            "Pincode": "784147",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Thelamara",
            "Pincode": "784149",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Besseria",
            "Pincode": "784150",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bandarmari",
            "Pincode": "784151",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Khelmati",
            "Pincode": "784152",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Ketekibari",
            "Pincode": "784154",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Laluk",
            "Pincode": "784160",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bihupuria",
            "Pincode": "784161",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Badati",
            "Pincode": "784162",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Pathalipahar",
            "Pincode": "784163",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dikrong",
            "Pincode": "784164",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dholepur",
            "Pincode": "784165",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Behali",
            "Pincode": "784166",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "North Bongaigaon Borgong",
            "Pincode": "784167",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gohpur",
            "Pincode": "784168",
            "City": "Gohpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Halem",
            "Pincode": "784170",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tetonbari",
            "Pincode": "784171",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barangabari",
            "Pincode": "784172",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mijikajan",
            "Pincode": "784173",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Paboi",
            "Pincode": "784174",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sootea",
            "Pincode": "784175",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Charali",
            "Pincode": "784176",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Biswanathghat",
            "Pincode": "784177",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kalabari",
            "Pincode": "784178",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bedeti",
            "Pincode": "784179",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jamugurihat",
            "Pincode": "784180",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bakola",
            "Pincode": "784181",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Naharbari",
            "Pincode": "784182",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nagsankar",
            "Pincode": "784183",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gingia",
            "Pincode": "784184",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rangachakua",
            "Pincode": "784185",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Karsontala",
            "Pincode": "784189",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bindukuri",
            "Pincode": "784502",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Thakurbari",
            "Pincode": "784503",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barjuli",
            "Pincode": "784504",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rangapara",
            "Pincode": "784505",
            "City": "Rangapara",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Missamari",
            "Pincode": "784506",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mazbat",
            "Pincode": "784507",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rowta",
            "Pincode": "784508",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Udalguri",
            "Pincode": "784509",
            "City": "Udalguri",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Harisinga",
            "Pincode": "784510",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bhairab Kunda",
            "Pincode": "784513",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lalpur Bazar",
            "Pincode": "784514",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tangla",
            "Pincode": "784521",
            "City": "Tangla",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Khoirabari",
            "Pincode": "784522",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Panerihat",
            "Pincode": "784523",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hatigarh",
            "Pincode": "784524",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kalaigaon",
            "Pincode": "784525",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dimakuchi",
            "Pincode": "784526",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Atterikhat",
            "Pincode": "784527",
            "City": "Mangaldoi",
            "District": "Darranga",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bhogdaimukh",
            "Pincode": "785001",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dholarsatra",
            "Pincode": "785001",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Garali",
            "Pincode": "785001",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jorhat",
            "Pincode": "785001",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Macharhat",
            "Pincode": "785001",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tarajan",
            "Pincode": "785001",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barbheta",
            "Pincode": "785004",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jorhat Air Field",
            "Pincode": "785005",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jorhat Research Laborator",
            "Pincode": "785006",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jorhat Engineering Colleg",
            "Pincode": "785007",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chinnamara",
            "Pincode": "785008",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "No-Ali Dhekiajuli",
            "Pincode": "785009",
            "City": "Tezpur",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chengligaon",
            "Pincode": "785010",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Konwaripukhuri",
            "Pincode": "785011",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Assam Agricultural Unver",
            "Pincode": "785013",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rajabari",
            "Pincode": "785014",
            "City": "Bokakhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Korokatoli",
            "Pincode": "785015",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bahana",
            "Pincode": "785101",
            "City": "Hajo",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dakhinpatsatra",
            "Pincode": "785102",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Fulanibari",
            "Pincode": "785103",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Garmursatra",
            "Pincode": "785104",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jengraimukh",
            "Pincode": "785105",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kamalabari",
            "Pincode": "785106",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kakajan",
            "Pincode": "785107",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kokilamukh",
            "Pincode": "785108",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kaziranga Sanctuary",
            "Pincode": "785109",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Majulibangaon",
            "Pincode": "785110",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Neamatighat",
            "Pincode": "785111",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Teok",
            "Pincode": "785112",
            "City": "Golaghat",
            "District": "Golaghat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhekiakhowa",
            "Pincode": "785113",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sarupathar",
            "Pincode": "785601",
            "City": "Sarupathar",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barpathar",
            "Pincode": "785602",
            "City": "Barpathar",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Oating",
            "Pincode": "785603",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Naojan",
            "Pincode": "785604",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Furkating",
            "Pincode": "785610",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bedlipar",
            "Pincode": "785611",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bokakhat",
            "Pincode": "785612",
            "City": "Bokakhat",
            "District": "Golaghat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Letekujan",
            "Pincode": "785613",
            "City": "Narayanpur",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dergaon",
            "Pincode": "785614",
            "City": "Dergaon",
            "District": "Golaghat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dergaon Charali",
            "Pincode": "785614",
            "City": "Golaghat",
            "District": "Golaghat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Numaligarh",
            "Pincode": "785615",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gatonga",
            "Pincode": "785616",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dohatia",
            "Pincode": "785617",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Baruabamungaon",
            "Pincode": "785618",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kamargaon Charali",
            "Pincode": "785619",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Negheriting",
            "Pincode": "785620",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bengenakhowa",
            "Pincode": "785621",
            "City": "Golaghat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Golaghat",
            "Pincode": "785621",
            "City": "Golaghat",
            "District": "Golaghat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhekhial",
            "Pincode": "785622",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kamarbandha Ali",
            "Pincode": "785625",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Moheema",
            "Pincode": "785626",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Titabar",
            "Pincode": "785630",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barhalla",
            "Pincode": "785631",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Puranaitambar",
            "Pincode": "785632",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kharikatia",
            "Pincode": "785633",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mariani",
            "Pincode": "785634",
            "City": "Mariani",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nakachari",
            "Pincode": "785635",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Selenghat",
            "Pincode": "785636",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Ongc Colony",
            "Pincode": "785640",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Phukan Nagar",
            "Pincode": "785640",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rangpur Nagar",
            "Pincode": "785640",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sibsagar",
            "Pincode": "785640",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Betbari",
            "Pincode": "785660",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Charing",
            "Pincode": "785661",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Demow",
            "Pincode": "785662",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Desangmukh",
            "Pincode": "785663",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gauri Sagar",
            "Pincode": "785664",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Joynagar",
            "Pincode": "785665",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kaloogaon",
            "Pincode": "785666",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kowerpur",
            "Pincode": "785667",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mechagarh",
            "Pincode": "785668",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Moran",
            "Pincode": "785669",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Moranhat",
            "Pincode": "785670",
            "City": "Moranhat",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Netaipukhuri",
            "Pincode": "785671",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rajmai",
            "Pincode": "785672",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sepon",
            "Pincode": "785673",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nemuguri",
            "Pincode": "785674",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Khowang",
            "Pincode": "785675",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Khowangghat",
            "Pincode": "785676",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Amguri",
            "Pincode": "785680",
            "City": "Amguri",
            "District": "Sonitpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Amguri Haloating",
            "Pincode": "785681",
            "City": "Jorhat",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tamulichiga",
            "Pincode": "785682",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jhanji",
            "Pincode": "785683",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Namtidol",
            "Pincode": "785684",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nazira",
            "Pincode": "785685",
            "City": "Nazira",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Simaluguri",
            "Pincode": "785686",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Santak",
            "Pincode": "785687",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lakwah",
            "Pincode": "785688",
            "City": "Guwahati",
            "District": "Kamrup",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Suffry",
            "Pincode": "785689",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sonari",
            "Pincode": "785690",
            "City": "Sonari",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sapekhati",
            "Pincode": "785692",
            "City": "Dhemaji",
            "District": "Dhemaji",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Borhat",
            "Pincode": "785693",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Teokghat",
            "Pincode": "785694",
            "City": "Golaghat",
            "District": "Golaghat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Towkok",
            "Pincode": "785695",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Galeki",
            "Pincode": "785696",
            "City": "Sibsagar",
            "District": "Sibsagar",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hahchara",
            "Pincode": "785701",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chouki Dingee",
            "Pincode": "786001",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dibrugarh",
            "Pincode": "786001",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Graham Bazar",
            "Pincode": "786001",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kadamani",
            "Pincode": "786001",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Panchali",
            "Pincode": "786001",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Assam Medical College",
            "Pincode": "786002",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dibrugarh Central",
            "Pincode": "786003",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Revenue Building",
            "Pincode": "786003",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dibrugarh University",
            "Pincode": "786004",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jalan Nagar",
            "Pincode": "786005",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barbarua",
            "Pincode": "786007",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mohanaghat",
            "Pincode": "786008",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lahoal",
            "Pincode": "786010",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mohanbari Air Field",
            "Pincode": "786012",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tinthengia",
            "Pincode": "786052",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kotona",
            "Pincode": "786053",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lezai",
            "Pincode": "786054",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dikom",
            "Pincode": "786101",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chabua Air Field",
            "Pincode": "786102",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tengakhat",
            "Pincode": "786103",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sissibargaon",
            "Pincode": "786110",
            "City": "Dhemaji",
            "District": "Dhemaji",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Durgabari",
            "Pincode": "786125",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Parbatia",
            "Pincode": "786125",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Prakash Bazar",
            "Pincode": "786125",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Senairam Bazar",
            "Pincode": "786125",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tinsukia",
            "Pincode": "786125",
            "City": "Tinsukia",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tinsukia HO",
            "Pincode": "786125",
            "City": "Tinsukia",
            "District": "Tinsukia",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sripuria",
            "Pincode": "786145",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sukhanpukhuri",
            "Pincode": "786146",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rangagorah",
            "Pincode": "786147",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mankhooli",
            "Pincode": "786148",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barhapjan",
            "Pincode": "786150",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Doomdooma",
            "Pincode": "786151",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Doomdooma",
            "Pincode": "786151",
            "City": "Tinsukia",
            "District": "Tinsukia",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Netaji Road",
            "Pincode": "786151",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kakapathar",
            "Pincode": "786152",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rupai Siding",
            "Pincode": "786153",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Saikhowaghat",
            "Pincode": "786154",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sadiya",
            "Pincode": "786155",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sadiya",
            "Pincode": "786155",
            "City": "Tinsukia",
            "District": "Tinsukia",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chapakhowa",
            "Pincode": "786157",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kundil",
            "Pincode": "786158",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sukreting",
            "Pincode": "786159",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Talap",
            "Pincode": "786159",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Makum Junction",
            "Pincode": "786170",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Digboi",
            "Pincode": "786171",
            "City": "Digboi",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Digboi Charali",
            "Pincode": "786171",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Muliabari",
            "Pincode": "786171",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Powai",
            "Pincode": "786172",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jubilee Digboi",
            "Pincode": "786173",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lekhapani",
            "Pincode": "786180",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Margherita",
            "Pincode": "786181",
            "City": "Margherita",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Margherita",
            "Pincode": "786181",
            "City": "Tinsukia",
            "District": "Tinsukia",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Ledo",
            "Pincode": "786182",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Panitola",
            "Pincode": "786183",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chabua",
            "Pincode": "786184",
            "City": "Chabua",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dinjan",
            "Pincode": "786185",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hatibandha",
            "Pincode": "786186",
            "City": "Kalaigaon",
            "District": "Jorhat",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hoogrijan",
            "Pincode": "786601",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Duliajan",
            "Pincode": "786602",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Naharkatia",
            "Pincode": "786610",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rajgarh",
            "Pincode": "786611",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tingkong",
            "Pincode": "786612",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bamunbari",
            "Pincode": "786613",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jeypore",
            "Pincode": "786614",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kowarigaon",
            "Pincode": "786615",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lengri Bazar",
            "Pincode": "786616",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Namrup",
            "Pincode": "786621",
            "City": "Namrup",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Namrup T P S",
            "Pincode": "786622",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Parbatpur",
            "Pincode": "786623",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barbam",
            "Pincode": "786624",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Khonsa",
            "Pincode": "786630",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Longding",
            "Pincode": "786631",
            "City": "Dibrugarh",
            "District": "Dibrugarh",
            "State": "Assam"
        },
        {
            "PostOfficeName": "North Lakhimpur",
            "Pincode": "787001",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nowboicha",
            "Pincode": "787028",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Moinapara",
            "Pincode": "787029",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Baginadi",
            "Pincode": "787030",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Maidamia",
            "Pincode": "787032",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lilabari Air Field",
            "Pincode": "787051",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Panigaon",
            "Pincode": "787052",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Ghilamara",
            "Pincode": "787053",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Islamgaon",
            "Pincode": "787054",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhakuakhana",
            "Pincode": "787055",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Pathalipam",
            "Pincode": "787056",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dhemaji",
            "Pincode": "787057",
            "City": "Dhemaji",
            "District": "Dhemaji",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Machkhowa",
            "Pincode": "787058",
            "City": "North Lakhimpur",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Silapathar",
            "Pincode": "787059",
            "City": "Silapathar",
            "District": "Lakhimpur",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jonai",
            "Pincode": "787060",
            "City": "Dhemaji",
            "District": "Dhemaji",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dewanji Bazar",
            "Pincode": "788001",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Silchar",
            "Pincode": "788001",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Malugram",
            "Pincode": "788002",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Tarapur",
            "Pincode": "788003",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Gurucharan College",
            "Pincode": "788004",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rangirkhari",
            "Pincode": "788005",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Link Road",
            "Pincode": "788006",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Vivekananda Road",
            "Pincode": "788007",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rongpur",
            "Pincode": "788009",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Engineering College",
            "Pincode": "788010",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kanakpur",
            "Pincode": "788011",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sonabarighat",
            "Pincode": "788013",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Silchar Medical College",
            "Pincode": "788014",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Silchar Regional",
            "Pincode": "788014",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Meherpur",
            "Pincode": "788015",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barkhola",
            "Pincode": "788019",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Arunachal",
            "Pincode": "788025",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Udarbond",
            "Pincode": "788030",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Pailapool",
            "Pincode": "788098",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Matinagar",
            "Pincode": "788099",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bankandi",
            "Pincode": "788101",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dewan",
            "Pincode": "788102",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lakhipur",
            "Pincode": "788103",
            "City": "Lakhipur",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jirighat",
            "Pincode": "788104",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Fulertal",
            "Pincode": "788106",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Joypur Raja Bazar",
            "Pincode": "788107",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kumbhir",
            "Pincode": "788108",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kumbhirgram Air Port",
            "Pincode": "788109",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Borkhola",
            "Pincode": "788110",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dalu",
            "Pincode": "788111",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Derby",
            "Pincode": "788112",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dwarband",
            "Pincode": "788113",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dholai Bazar",
            "Pincode": "788114",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Narsingpur",
            "Pincode": "788115",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Palonghat",
            "Pincode": "788116",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Barjalenga",
            "Pincode": "788117",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rosekandi",
            "Pincode": "788117",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sonaimukh",
            "Pincode": "788119",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bhagabazar",
            "Pincode": "788120",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kabuganjbazar",
            "Pincode": "788121",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Manierkhal",
            "Pincode": "788122",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bekirpar",
            "Pincode": "788123",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Irongmara",
            "Pincode": "788124",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Laboc",
            "Pincode": "788125",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Binnakand",
            "Pincode": "788126",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chiparsangam",
            "Pincode": "788145",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kalibari Bazar",
            "Pincode": "788150",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hailakandi",
            "Pincode": "788151",
            "City": "Hailakandi",
            "District": "Hailakandi",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lakshmishahar",
            "Pincode": "788152",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Ratanpur Road",
            "Pincode": "788155",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Anilgarh",
            "Pincode": "788156",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jaffirband",
            "Pincode": "788160",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Katlacherra",
            "Pincode": "788161",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kukicherra",
            "Pincode": "788162",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lala",
            "Pincode": "788163",
            "City": "Lala",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Monacherra",
            "Pincode": "788164",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Manipurbagan",
            "Pincode": "788165",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Ramkrishnanagar",
            "Pincode": "788166",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Vernerpur",
            "Pincode": "788167",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lalamukh",
            "Pincode": "788169",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bhangabazar",
            "Pincode": "788701",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Srigauri",
            "Pincode": "788702",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Rajartilla",
            "Pincode": "788705",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mahakhal",
            "Pincode": "788706",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chargola Bazar",
            "Pincode": "788708",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Char Bazar",
            "Pincode": "788710",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Karimganj Court",
            "Pincode": "788710",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Karimganj Station Road",
            "Pincode": "788710",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Karinganj",
            "Pincode": "788710",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Subhashnagar",
            "Pincode": "788710",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Karimganj Bazar",
            "Pincode": "788711",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Sadarasi",
            "Pincode": "788716",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kayasthagram",
            "Pincode": "788719",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kaliganj Bazar",
            "Pincode": "788720",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Latu",
            "Pincode": "788721",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Nilambazar",
            "Pincode": "788722",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Baroigram",
            "Pincode": "788723",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Patherkandi",
            "Pincode": "788724",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Chandkhira",
            "Pincode": "788725",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hatikhira",
            "Pincode": "788726",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bazaricherra",
            "Pincode": "788727",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Lakhi Cherra",
            "Pincode": "788729",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kanai Bazar",
            "Pincode": "788731",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bazarghat",
            "Pincode": "788733",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Anipur",
            "Pincode": "788734",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Retabari",
            "Pincode": "788735",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Dullavcherra",
            "Pincode": "788736",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Olivacherra",
            "Pincode": "788737",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Brahmanshasan",
            "Pincode": "788740",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mahishasan",
            "Pincode": "788781",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Manikganj",
            "Pincode": "788790",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kalinagar",
            "Pincode": "788801",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Panchgram",
            "Pincode": "788802",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Badarpurghat",
            "Pincode": "788803",
            "City": "Karimganj",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Katigorah",
            "Pincode": "788805",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Badarpur",
            "Pincode": "788806",
            "City": "Badarpur",
            "District": "Karimganj",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Hilara Colony",
            "Pincode": "788808",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kalaincherra",
            "Pincode": "788812",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Salchopra",
            "Pincode": "788814",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Kalain",
            "Pincode": "788815",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Jalalpur",
            "Pincode": "788816",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Behara Bazar",
            "Pincode": "788817",
            "City": "Silchar",
            "District": "Chacher",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Harangajao",
            "Pincode": "788818",
            "City": "Haflong",
            "District": "North Cacher Hills",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Haflong",
            "Pincode": "788819",
            "City": "Haflong",
            "District": "North Cacher Hills",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Haflong Ptc",
            "Pincode": "788819",
            "City": "Haflong",
            "District": "North Cacher Hills",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Mahur",
            "Pincode": "788830",
            "City": "Mahur",
            "District": "North Cacher Hills",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Maibong",
            "Pincode": "788831",
            "City": "Maibong",
            "District": "North Cacher Hills",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Langting",
            "Pincode": "788832",
            "City": "Haflong",
            "District": "North Cacher Hills",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Khejurbond",
            "Pincode": "788834",
            "City": "Haflong",
            "District": "North Cacher Hills",
            "State": "Assam"
        },
        {
            "PostOfficeName": "Bomdila",
            "Pincode": "790001",
            "City": "Bomdila",
            "District": "West Kameng",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Kalaktang",
            "Pincode": "790002",
            "City": "Bomdila",
            "District": "West Kameng",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Dirang",
            "Pincode": "790101",
            "City": "Bomdila",
            "District": "West Kameng",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Seppa",
            "Pincode": "790102",
            "City": "Seppa",
            "District": "East Kameng",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Seijussa",
            "Pincode": "790103",
            "City": "Seppa",
            "District": "East Kameng",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Towang",
            "Pincode": "790104",
            "City": "Seppa",
            "District": "East Kameng",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Bhalukpong",
            "Pincode": "790114",
            "City": "Bomdila",
            "District": "West Kameng",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "West Kameng",
            "Pincode": "790115",
            "City": "Bomdila",
            "District": "West Kameng",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Along",
            "Pincode": "791001",
            "City": "Along",
            "District": "West Siang",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Yingkiong",
            "Pincode": "791002",
            "City": "Yingkiong",
            "District": "Upper Siang",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Basar",
            "Pincode": "791101",
            "City": "Basar",
            "District": "West Siang",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Pasighat",
            "Pincode": "791102",
            "City": "Pasighat",
            "District": "East Siang",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "East Siang",
            "Pincode": "791103",
            "City": "Pasighat",
            "District": "East Siang",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "East Siang",
            "Pincode": "791104",
            "City": "Pasighat",
            "District": "East Siang",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Itanagar",
            "Pincode": "791111",
            "City": "Ziro",
            "District": "Lower Subansiri",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Itanagar",
            "Pincode": "791111",
            "City": "Itanagar",
            "District": "Papum Pare",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Doimukh",
            "Pincode": "791112",
            "City": "Ziro",
            "District": "Lower Subansiri",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Doimukh",
            "Pincode": "791112",
            "City": "Itanagar",
            "District": "Papum Pare",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Lower Subansiri",
            "Pincode": "791113",
            "City": "Ziro",
            "District": "Lower Subansiri",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Lower Subansiri",
            "Pincode": "791120",
            "City": "Ziro",
            "District": "Lower Subansiri",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Kimin",
            "Pincode": "791121",
            "City": "Ziro",
            "District": "Lower Subansiri",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Upper Subansiri",
            "Pincode": "791122",
            "City": "Daporijo",
            "District": "Upper Subansiri",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Lohit",
            "Pincode": "792001",
            "City": "Tezu",
            "District": "Lohit",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Mechuka",
            "Pincode": "792051",
            "City": "Along",
            "District": "West Siang",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Tuting",
            "Pincode": "792055",
            "City": "Khonsa",
            "District": "Tirap",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Vijoynagar",
            "Pincode": "792055",
            "City": "Khonsa",
            "District": "Tirap",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Vijoynagar",
            "Pincode": "792055",
            "City": "Changlang",
            "District": "Changlang",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Anini",
            "Pincode": "792101",
            "City": "Tezu",
            "District": "Lohit",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Hayuliang",
            "Pincode": "792102",
            "City": "Tezu",
            "District": "Lohit",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Namsai",
            "Pincode": "792103",
            "City": "Namsai",
            "District": "Lohit",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Chowkham",
            "Pincode": "792104",
            "City": "Tezu",
            "District": "Lohit",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Roing",
            "Pincode": "792110",
            "City": "Roing",
            "District": "Dibang Valley",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Sunpura",
            "Pincode": "792111",
            "City": "Tezu",
            "District": "Lohit",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Tirap",
            "Pincode": "792120",
            "City": "Khonsa",
            "District": "Tirap",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Jairampur",
            "Pincode": "792121",
            "City": "Jairampur",
            "District": "Tirap",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Miao",
            "Pincode": "792122",
            "City": "Khonsa",
            "District": "Tirap",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "Nampong",
            "Pincode": "792123",
            "City": "Khonsa",
            "District": "Tirap",
            "State": "Arunachal Pradesh"
        },
        {
            "PostOfficeName": "MeghalayaSectt",
            "Pincode": "793001",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Oakland",
            "Pincode": "793001",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Shillong",
            "Pincode": "793001",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Barabazar",
            "Pincode": "793002",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "HindumissionRoad",
            "Pincode": "793002",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Jaiaw",
            "Pincode": "793002",
            "City": "Jaiaw",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Banasree",
            "Pincode": "793003",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Laitumkhrah",
            "Pincode": "793003",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Motinagar",
            "Pincode": "793003",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Bishnupur",
            "Pincode": "793004",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Laban",
            "Pincode": "793004",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "UpperShillong",
            "Pincode": "793005",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Umpling",
            "Pincode": "793006",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "HappyValley",
            "Pincode": "793007",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "PhudmawriMawlai",
            "Pincode": "793008",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Nonglyer",
            "Pincode": "793009",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "LaitkorPeak",
            "Pincode": "793010",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "AssamRifles",
            "Pincode": "793011",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Mawpat",
            "Pincode": "793012",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Rilbong",
            "Pincode": "793013",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Nongthymmai",
            "Pincode": "793014",
            "City": "Nongthymmai",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "MadanRitting",
            "Pincode": "793021",
            "City": "MadanRitting",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "GovernorsCamp",
            "Pincode": "793025",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Burnihat",
            "Pincode": "793101",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Nongpoh",
            "Pincode": "793102",
            "City": "Nongpoh",
            "District": "Ri Bhoi",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Barapani",
            "Pincode": "793103",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Sumer",
            "Pincode": "793104",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Nayabunglow",
            "Pincode": "793105",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Balat",
            "Pincode": "793106",
            "City": "Jowai",
            "District": "Jaintia Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Bholaganjbazar",
            "Pincode": "793107",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Cherrapunjee",
            "Pincode": "793108",
            "City": "Cherrapunjee",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Dawki",
            "Pincode": "793109",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Pynursla",
            "Pincode": "793110",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Cherrabazar",
            "Pincode": "793111",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Shella",
            "Pincode": "793112",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Mawsynram",
            "Pincode": "793113",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Nongstoin",
            "Pincode": "793119",
            "City": "Nongstoin",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Moirang",
            "Pincode": "793120",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Mawphlang",
            "Pincode": "793121",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "UnionChristianCollege",
            "Pincode": "793122",
            "City": "Shillong",
            "District": "East Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Jowai",
            "Pincode": "793150",
            "City": "Jowai",
            "District": "Jaintia Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Tura",
            "Pincode": "794001",
            "City": "Tura",
            "District": "West Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "LowerChandmari",
            "Pincode": "794002",
            "City": "Tura",
            "District": "West Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Dobasipara",
            "Pincode": "794005",
            "City": "Tura",
            "District": "West Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Araimail",
            "Pincode": "794101",
            "City": "Nongstoin",
            "District": "West Khasi Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Baghmara",
            "Pincode": "794102",
            "City": "Baghmara",
            "District": "South Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Barengapara",
            "Pincode": "794103",
            "City": "Tura",
            "District": "West Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Fulbari",
            "Pincode": "794104",
            "City": "Tura",
            "District": "West Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Garobandha",
            "Pincode": "794105",
            "City": "Tura",
            "District": "West Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Mahendraganj",
            "Pincode": "794106",
            "City": "Tura",
            "District": "West Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Nangalbibra",
            "Pincode": "794107",
            "City": "Williamnagar",
            "District": "East Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Nangalbibra",
            "Pincode": "794107",
            "City": "Williamnagar",
            "District": "East Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Resubelpara",
            "Pincode": "794108",
            "City": "Resubelpara",
            "District": "East Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Resubelpara",
            "Pincode": "794108",
            "City": "Resubelpara",
            "District": "East Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Tikrikilla",
            "Pincode": "794109",
            "City": "Tura",
            "District": "West Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Rongjeng",
            "Pincode": "794110",
            "City": "Williamnagar",
            "District": "East Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Rongjeng",
            "Pincode": "794110",
            "City": "Williamnagar",
            "District": "East Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Simsanggiri",
            "Pincode": "794111",
            "City": "Williamnagar",
            "District": "East Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Simsangiri",
            "Pincode": "794111",
            "City": "Williamnagar",
            "District": "East Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Mandiparhar",
            "Pincode": "794112",
            "City": "Williamnagar",
            "District": "East Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "Mandipathar",
            "Pincode": "794112",
            "City": "Williamnagar",
            "District": "East Garo Hills",
            "State": "Meghalaya"
        },
        {
            "PostOfficeName": "D M College",
            "Pincode": "795001",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Imphal",
            "Pincode": "795001",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Imphal Bazar",
            "Pincode": "795001",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Mantripukhri",
            "Pincode": "795002",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "J N University",
            "Pincode": "795003",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Lamphelpat",
            "Pincode": "795004",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Samdol",
            "Pincode": "795010",
            "City": "Ukhrul",
            "District": "Ukhrul",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Swombung",
            "Pincode": "795011",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Sugnu",
            "Pincode": "795101",
            "City": "Sugnu",
            "District": "Chandel",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Chakpikarong",
            "Pincode": "795102",
            "City": "Chandel",
            "District": "Chandel",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Kakching Bazar",
            "Pincode": "795103",
            "City": "Thoubal",
            "District": "Thoubal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Tadubi",
            "Pincode": "795104",
            "City": "Senapati",
            "District": "Senapati",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Maram",
            "Pincode": "795105",
            "City": "Senapati",
            "District": "Senapati",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Karong",
            "Pincode": "795106",
            "City": "Senapati",
            "District": "Senapati",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Gulerthal",
            "Pincode": "795115",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Jiribam",
            "Pincode": "795116",
            "City": "Jiribam",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Hiyangthang",
            "Pincode": "795120",
            "City": "Senapati",
            "District": "Senapati",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "K K Prampat",
            "Pincode": "795121",
            "City": "Senapati",
            "District": "Senapati",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Kalapahar",
            "Pincode": "795122",
            "City": "Senapati",
            "District": "Senapati",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Wongoi",
            "Pincode": "795123",
            "City": "Thoubal",
            "District": "Thoubal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Loktak Project",
            "Pincode": "795124",
            "City": "Churachandpur",
            "District": "Churachandpur",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Tamel",
            "Pincode": "795125",
            "City": "Tamenglong",
            "District": "Tamenglong",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Bishenpur",
            "Pincode": "795126",
            "City": "Bishenpur",
            "District": "Bishenpur",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Bishenpur",
            "Pincode": "795126",
            "City": "Chandel",
            "District": "Chandel",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Chendel",
            "Pincode": "795127",
            "City": "Chandel",
            "District": "Chandel",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Churachandpur",
            "Pincode": "795128",
            "City": "Churachandpur",
            "District": "Churachandpur",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Kongpokpi",
            "Pincode": "795129",
            "City": "Senapati",
            "District": "Senapati",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Lilong",
            "Pincode": "795130",
            "City": "Thoubal",
            "District": "Thoubal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Moreh",
            "Pincode": "795131",
            "City": "Moreh",
            "District": "Chandel",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Marjang Imphal",
            "Pincode": "795132",
            "City": "Bishenpur",
            "District": "Bishenpur",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Mayang Imphal",
            "Pincode": "795132",
            "City": "Mayang Imphal",
            "District": "Chandel",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Moirang",
            "Pincode": "795133",
            "City": "Moirang",
            "District": "BISHENPUR",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Moirang",
            "Pincode": "795133",
            "City": "Chandel",
            "District": "Chandel",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Nambal",
            "Pincode": "795134",
            "City": "Bishenpur",
            "District": "Bishenpur",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Nambol",
            "Pincode": "795134",
            "City": "Nambol",
            "District": "Chandel",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Parrel",
            "Pincode": "795135",
            "City": "Chandel",
            "District": "Chandel",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Sekmai",
            "Pincode": "795136",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Singjamaibazar",
            "Pincode": "795137",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Thoubal",
            "Pincode": "795138",
            "City": "Thoubal",
            "District": "Thoubal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Thingat",
            "Pincode": "795139",
            "City": "Churachandpur",
            "District": "Churachandpur",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Tulihal",
            "Pincode": "795140",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Tamenglong",
            "Pincode": "795141",
            "City": "Tamenglong",
            "District": "Tamenglong",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Ukhrul",
            "Pincode": "795142",
            "City": "Ukhrul",
            "District": "Ukhrul",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Thanlon",
            "Pincode": "795143",
            "City": "Churachandpur",
            "District": "Churachandpur",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Tengnoupal",
            "Pincode": "795144",
            "City": "Churachandpur",
            "District": "Churachandpur",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Tusen",
            "Pincode": "795145",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Lumsung",
            "Pincode": "795146",
            "City": "Imphal",
            "District": "Imphal",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Nungba",
            "Pincode": "795147",
            "City": "Tamenglong",
            "District": "Tamenglong",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Mao",
            "Pincode": "795150",
            "City": "Senapati",
            "District": "Senapati",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Kangla Tongbi",
            "Pincode": "795151",
            "City": "Senapati",
            "District": "Senapati",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Ching Kompong",
            "Pincode": "795158",
            "City": "Senapati",
            "District": "Senapati",
            "State": "Manipur"
        },
        {
            "PostOfficeName": "Aizawl",
            "Pincode": "796001",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Kulikawn",
            "Pincode": "796005",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Chandmari",
            "Pincode": "796007",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Vaivakaan",
            "Pincode": "796009",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Ramhlun",
            "Pincode": "796012",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Tlaingnuam",
            "Pincode": "796015",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Zemabawk",
            "Pincode": "796017",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Dustlang",
            "Pincode": "796025",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Sihphir",
            "Pincode": "796031",
            "City": "Kolasib",
            "District": "Kolasib",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Kawnpur",
            "Pincode": "796070",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Kolasib",
            "Pincode": "796081",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Vairengte",
            "Pincode": "796101",
            "City": "Vairengte",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Darlawn",
            "Pincode": "796111",
            "City": "Darlawn",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Thingsulthliah",
            "Pincode": "796161",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Thingsulthliah",
            "Pincode": "796161",
            "City": "Sherchip",
            "District": "Sherchip",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Serchhip",
            "Pincode": "796181",
            "City": "Serchhip",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Serchip",
            "Pincode": "796181",
            "City": "Sherchip",
            "District": "Sherchip",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Aibawk",
            "Pincode": "796190",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Sialsuk",
            "Pincode": "796230",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Saitual",
            "Pincode": "796261",
            "City": "Saitual",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Ngopa",
            "Pincode": "796290",
            "City": "Champhai",
            "District": "Champhai",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Khawzawl",
            "Pincode": "796310",
            "City": "Khawzawl",
            "District": "Champhai",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Champai",
            "Pincode": "796321",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Lungdar",
            "Pincode": "796370",
            "City": "Saiha",
            "District": "Saiha",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Lungdar",
            "Pincode": "796370",
            "City": "Sherchip",
            "District": "Sherchip",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Sairang",
            "Pincode": "796410",
            "City": "Sairang",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Mumit",
            "Pincode": "796441",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Lakhicherra",
            "Pincode": "796471",
            "City": "Aizwal",
            "District": "Aizwal",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Hnahthial",
            "Pincode": "796571",
            "City": "Hnahthial",
            "District": "Lungleh",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Deomali",
            "Pincode": "796629",
            "City": "Lungleh",
            "District": "Lungleh",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Zotlang",
            "Pincode": "796691",
            "City": "Lungleh",
            "District": "Lungleh",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Lunglei",
            "Pincode": "796701",
            "City": "Lunglei",
            "District": "Lungleh",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Bunghmun",
            "Pincode": "796710",
            "City": "Lungleh",
            "District": "Lungleh",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Lungsen",
            "Pincode": "796730",
            "City": "Lungsen",
            "District": "Lungleh",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Demagiri",
            "Pincode": "796751",
            "City": "Lungleh",
            "District": "Lungleh",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Chawngte",
            "Pincode": "796770",
            "City": "Lawngtlai",
            "District": "Lawngtlai",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Saiha",
            "Pincode": "796901",
            "City": "Lungleh",
            "District": "Lungleh",
            "State": "Mizoram"
        },
        {
            "PostOfficeName": "Kohima",
            "Pincode": "797001",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Kohima Pwd",
            "Pincode": "797001",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Birema",
            "Pincode": "797101",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Chizami",
            "Pincode": "797102",
            "City": "Phek",
            "District": "Phek",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Chumukhedima",
            "Pincode": "797103",
            "City": "Chumukhedima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Chazouba",
            "Pincode": "797104",
            "City": "Phek",
            "District": "Phek",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Cheichema",
            "Pincode": "797105",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Ghaspani",
            "Pincode": "797106",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Pfutserro",
            "Pincode": "797107",
            "City": "Phek",
            "District": "Phek",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Phek",
            "Pincode": "797108",
            "City": "Phek",
            "District": "Phek",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Tseminyu",
            "Pincode": "797109",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Zalukei",
            "Pincode": "797110",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Wokha",
            "Pincode": "797111",
            "City": "Wokha",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Circular Road",
            "Pincode": "797112",
            "City": "Dimapur",
            "District": "Dimapur",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Dimapur",
            "Pincode": "797112",
            "City": "Dimapur",
            "District": "Dimapur",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Dimapur Bazar",
            "Pincode": "797112",
            "City": "Dimapur",
            "District": "Dimapur",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Piphema",
            "Pincode": "797121",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Pherima",
            "Pincode": "797122",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Rangapahar",
            "Pincode": "797123",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Sugar Mill Project",
            "Pincode": "797124",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Zakhama",
            "Pincode": "797125",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Zubza",
            "Pincode": "797126",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Viswama",
            "Pincode": "797127",
            "City": "Kohima",
            "District": "Kohima",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Mokokchung",
            "Pincode": "798601",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Kiphira",
            "Pincode": "798611",
            "City": "Tuengsang",
            "District": "Tuengsang",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Tuensang",
            "Pincode": "798612",
            "City": "Tuengsang",
            "District": "Tuengsang",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Changtongia",
            "Pincode": "798613",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Chuchyemlong",
            "Pincode": "798614",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Impur",
            "Pincode": "798615",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Longkhim",
            "Pincode": "798616",
            "City": "Tuengsang",
            "District": "Tuengsang",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Ongpangkong",
            "Pincode": "798617",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Tuli",
            "Pincode": "798618",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Akolato",
            "Pincode": "798619",
            "City": "Zunehboto",
            "District": "Zunehboto",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Zunheboto",
            "Pincode": "798620",
            "City": "Zunehboto",
            "District": "Zunehboto",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Mon",
            "Pincode": "798621",
            "City": "Mon",
            "District": "Mon",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Naginamara",
            "Pincode": "798622",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Paper Nagar Tuli",
            "Pincode": "798623",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Aghunoto",
            "Pincode": "798626",
            "City": "Zunehboto",
            "District": "Zunehboto",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Atoizu",
            "Pincode": "798627",
            "City": "Zunehboto",
            "District": "Zunehboto",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Meraring",
            "Pincode": "798628",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Sutakha",
            "Pincode": "798629",
            "City": "Zunehboto",
            "District": "Zunehboto",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Kobulong",
            "Pincode": "798630",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Chukitong",
            "Pincode": "798631",
            "City": "Chukitong",
            "District": "Wokha",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Sungra",
            "Pincode": "798632",
            "City": "Mokokchung",
            "District": "Mokokchung",
            "State": "Nagaland"
        },
        {
            "PostOfficeName": "Agartala",
            "Pincode": "799001",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Agartala Bazar",
            "Pincode": "799001",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Agartala Court",
            "Pincode": "799001",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Agartala Secretariat",
            "Pincode": "799001",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Badarghat",
            "Pincode": "799001",
            "City": "Badarghat",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Bankas",
            "Pincode": "799001",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Bartala Bazar",
            "Pincode": "799001",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Jagan Nath Bari",
            "Pincode": "799001",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Tripura Terminal Council",
            "Pincode": "799001",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Tripura Vidhan Sabha",
            "Pincode": "799001",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "799002",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Arundhuti Nagar",
            "Pincode": "799003",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Agartala College",
            "Pincode": "799004",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Abhaynagar",
            "Pincode": "799005",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kunjaban",
            "Pincode": "799006",
            "City": "Kunjaban",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Dhaleswar",
            "Pincode": "799007",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Khayaspur",
            "Pincode": "799008",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Agartala Aerodrome",
            "Pincode": "799009",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Agartala Airport",
            "Pincode": "799009",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Jogendranagar",
            "Pincode": "799010",
            "City": "Jogendranagar",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Barjala",
            "Pincode": "799011",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Salbagan",
            "Pincode": "799012",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Bimangarh",
            "Pincode": "799015",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Ranirbazar",
            "Pincode": "799035",
            "City": "Ranirbazar",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Birendra Nagar",
            "Pincode": "799045",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Tripura Engg College",
            "Pincode": "799055",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Amarpur",
            "Pincode": "799101",
            "City": "Amarpur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Bishalgarh",
            "Pincode": "799102",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Bisramaganj",
            "Pincode": "799103",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Gumti Project",
            "Pincode": "799104",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kakraban",
            "Pincode": "799105",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Boxa Nagar",
            "Pincode": "799106",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Charilam",
            "Pincode": "799107",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Ampinagar",
            "Pincode": "799108",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Zirjhamukha",
            "Pincode": "799109",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Melagarh",
            "Pincode": "799115",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Bagma",
            "Pincode": "799119",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Radhakishorepur",
            "Pincode": "799120",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Udaipur Court",
            "Pincode": "799120",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Maharani",
            "Pincode": "799121",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Matabari",
            "Pincode": "799122",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Jamjuri",
            "Pincode": "799123",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Garjee",
            "Pincode": "799125",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Salgarh",
            "Pincode": "799125",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Sekerkote",
            "Pincode": "799130",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Sunamura",
            "Pincode": "799131",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kathalia",
            "Pincode": "799132",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Jolaibari",
            "Pincode": "799141",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Muhuripur",
            "Pincode": "799142",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Manubazar",
            "Pincode": "799143",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Santirbazar",
            "Pincode": "799144",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Sabroom",
            "Pincode": "799145",
            "City": "Sabroom",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kalsibazar",
            "Pincode": "799146",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Jalefa Bazar",
            "Pincode": "799147",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Baikara",
            "Pincode": "799148",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Satchand",
            "Pincode": "799149",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Radhanagar",
            "Pincode": "799153",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Beloniya",
            "Pincode": "799155",
            "City": "Beloniya",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Rishyamukh",
            "Pincode": "799156",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Anandapur",
            "Pincode": "799157",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Rajnagar",
            "Pincode": "799158",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Ramnagar",
            "Pincode": "799158",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Matai",
            "Pincode": "799159",
            "City": "Udaipur",
            "District": "South Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Khowai",
            "Pincode": "799201",
            "City": "Khowai",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Khowai Court",
            "Pincode": "799202",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kalyanpur",
            "Pincode": "799203",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kulaibazar",
            "Pincode": "799204",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Teliamura",
            "Pincode": "799205",
            "City": "Teliamura",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Bachaibari",
            "Pincode": "799206",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kamalghat",
            "Pincode": "799210",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Mohanpur",
            "Pincode": "799211",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Sidhai",
            "Pincode": "799212",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Simna",
            "Pincode": "799213",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Fatikcherra",
            "Pincode": "799214",
            "City": "Agartala",
            "District": "West Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Dharma Nagar",
            "Pincode": "799250",
            "City": "Dharma Nagar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Chandrap",
            "Pincode": "799251",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Bagbassa",
            "Pincode": "799252",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Panisagar",
            "Pincode": "799260",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kadamtala",
            "Pincode": "799261",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Churaib",
            "Pincode": "799262",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Pecharthal",
            "Pincode": "799263",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kumarghat",
            "Pincode": "799264",
            "City": "Kumarghat",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Machmara",
            "Pincode": "799265",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Jampuri",
            "Pincode": "799269",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kanchanpur",
            "Pincode": "799270",
            "City": "Kanchanpur",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Dasdabazar",
            "Pincode": "799271",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Chaileng",
            "Pincode": "799273",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Manughat",
            "Pincode": "799275",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kailashahar",
            "Pincode": "799277",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Panichouki Bazar",
            "Pincode": "799277",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Salema",
            "Pincode": "799278",
            "City": "Ambassa",
            "District": "Dhalai",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Paiturbazar",
            "Pincode": "799279",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kamalpur",
            "Pincode": "799285",
            "City": "Kamalpur",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Halahali",
            "Pincode": "799286",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Manikbhandar",
            "Pincode": "799287",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Kanchanbari",
            "Pincode": "799288",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Ambassa",
            "Pincode": "799289",
            "City": "Ambassa",
            "District": "Dhalai",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Fatikroy",
            "Pincode": "799290",
            "City": "Kailashahar",
            "District": "North Tripura",
            "State": "Tripura"
        },
        {
            "PostOfficeName": "Bank Road",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihar Public",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Boaring Canal Road",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Central R Bldg",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chiraiyatand",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darul Mallick",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Distt Supdt Education",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hotel Republic",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Indian Nation",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamal Road",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Judges Court Rd",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khadi Board",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kidwaipuri",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lic Patna",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mithapur",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Navarashtra",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Navashakti",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ncc Directorate",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "New Jakkanpur",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patna",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patna",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patna Aerodrame",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patna Collectorate",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patna High Court",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Postal Park",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raja Pur Mainpura",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Searchlight",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Service Comm",
            "Pincode": "800001",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Anisabad",
            "Pincode": "800002",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gardanibagh",
            "Pincode": "800002",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kadamkuan",
            "Pincode": "800003",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lohanipur",
            "Pincode": "800003",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bankipur",
            "Pincode": "800004",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Machuatoli",
            "Pincode": "800004",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nayatola",
            "Pincode": "800004",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patna M C Hospital",
            "Pincode": "800004",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patna University",
            "Pincode": "800005",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahendru",
            "Pincode": "800006",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mussallehpur Hat Nanmuhia",
            "Pincode": "800006",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dental College",
            "Pincode": "800007",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gulzarbagh",
            "Pincode": "800007",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mangla Devi",
            "Pincode": "800007",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pachhim Darwaza",
            "Pincode": "800007",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chaughara",
            "Pincode": "800008",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chowk Shikarpur",
            "Pincode": "800008",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Diwan Mahalla",
            "Pincode": "800008",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gurhatta",
            "Pincode": "800008",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katra Bazar",
            "Pincode": "800008",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Machharhatta",
            "Pincode": "800008",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahabir Asthan",
            "Pincode": "800008",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Marufganj",
            "Pincode": "800008",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patnacity",
            "Pincode": "800008",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "S M Mills",
            "Pincode": "800008",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Begampur",
            "Pincode": "800009",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sadaquat Ashram",
            "Pincode": "800010",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Digha Ghat",
            "Pincode": "800011",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sanjiwan Press",
            "Pincode": "800011",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Digha",
            "Pincode": "800012",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pataliputra",
            "Pincode": "800013",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihar Veterinary College",
            "Pincode": "800014",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sheikhpura",
            "Pincode": "800014",
            "City": "Sheikhpura",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sheikhpura",
            "Pincode": "800014",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patna Secretariat",
            "Pincode": "800015",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "K Sector",
            "Pincode": "800016",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kumhrar",
            "Pincode": "800016",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajendranagar",
            "Pincode": "800016",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihar School Exam Board",
            "Pincode": "800017",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bataganj",
            "Pincode": "800018",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Accounts Patna",
            "Pincode": "800019",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ashok Nagar L West",
            "Pincode": "800020",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lohianagar",
            "Pincode": "800020",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Vidyut Parishad",
            "Pincode": "800021",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihar Governers Camp",
            "Pincode": "800022",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lal Bahadur Shastri Nagar",
            "Pincode": "800023",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Punaichak",
            "Pincode": "800023",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Anandpur Homeguard Centre",
            "Pincode": "801101",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belhauri",
            "Pincode": "801102",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihta",
            "Pincode": "801103",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihta",
            "Pincode": "801103",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bikram",
            "Pincode": "801104",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bikram",
            "Pincode": "801104",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khagaul",
            "Pincode": "801105",
            "City": "Khagaul",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khagaul Bazar",
            "Pincode": "801105",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Maner",
            "Pincode": "801108",
            "City": "Maner",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naubatpur",
            "Pincode": "801109",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naubatpur",
            "Pincode": "801109",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Paliganj",
            "Pincode": "801110",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sadisopur",
            "Pincode": "801111",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lai",
            "Pincode": "801112",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Neora",
            "Pincode": "801113",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Neori Vikash",
            "Pincode": "801113",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandaos",
            "Pincode": "801114",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Datiana",
            "Pincode": "801115",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kita Chouhatar",
            "Pincode": "801116",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amarpura",
            "Pincode": "801117",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amhara",
            "Pincode": "801118",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kamla Gopalpur",
            "Pincode": "801119",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ekangersarai",
            "Pincode": "801301",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hilsa",
            "Pincode": "801302",
            "City": "Hilsa",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Islampur",
            "Pincode": "801303",
            "City": "Islampur",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Islampur",
            "Pincode": "801303",
            "City": "Islampur",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karaiparsarai",
            "Pincode": "801304",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nagarnausa",
            "Pincode": "801305",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Telhara",
            "Pincode": "801306",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhathar",
            "Pincode": "801307",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ekangerdih",
            "Pincode": "801309",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khodaganj",
            "Pincode": "801310",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahmuda",
            "Pincode": "801311",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Daudpur",
            "Pincode": "801502",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihar Regimental Centre",
            "Pincode": "801503",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dalwar Chemical",
            "Pincode": "801503",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dinapur Bazar",
            "Pincode": "801503",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dinapur Cantt",
            "Pincode": "801503",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Phulwarisharif",
            "Pincode": "801505",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahaynagar",
            "Pincode": "801506",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ganghara",
            "Pincode": "801507",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dilipchak",
            "Pincode": "801508",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sherpur",
            "Pincode": "801509",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Buxar",
            "Pincode": "802101",
            "City": "Buxar",
            "District": "Buxar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nai Bazar",
            "Pincode": "802101",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sohanipatti",
            "Pincode": "802101",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Buxar Jail",
            "Pincode": "802102",
            "City": "Buxar",
            "District": "Buxar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Buxar Gajadhargani",
            "Pincode": "802103",
            "City": "Buxar",
            "District": "Buxar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Arak",
            "Pincode": "802111",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barhampur",
            "Pincode": "802112",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barhampur",
            "Pincode": "802112",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barhampur Chausasta",
            "Pincode": "802112",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barkarajpur",
            "Pincode": "802113",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chausa",
            "Pincode": "802114",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chausa",
            "Pincode": "802114",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chaugain",
            "Pincode": "802115",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chaugain",
            "Pincode": "802115",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Churamanpur",
            "Pincode": "802116",
            "City": "Buxar",
            "District": "Buxar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Civil Aerodrome",
            "Pincode": "802116",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhansoi",
            "Pincode": "802117",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dullahpur",
            "Pincode": "802118",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumraoh",
            "Pincode": "802119",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumri",
            "Pincode": "802120",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Itarhi",
            "Pincode": "802123",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Itarhi",
            "Pincode": "802123",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kesath",
            "Pincode": "802125",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Koransarai",
            "Pincode": "802126",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Murar",
            "Pincode": "802127",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhojpur",
            "Pincode": "802128",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nawanagar",
            "Pincode": "802129",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nawanagar",
            "Pincode": "802129",
            "City": "Bhagwanpur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nimez",
            "Pincode": "802130",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Neajipur",
            "Pincode": "802131",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Noan",
            "Pincode": "802132",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purana Bhojpur",
            "Pincode": "802133",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raghunathpur",
            "Pincode": "802134",
            "City": "Raghunathpur",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raghunathpur",
            "Pincode": "802134",
            "City": "Raghunathpur",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Simri",
            "Pincode": "802135",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumraon Textile",
            "Pincode": "802136",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Benwalia",
            "Pincode": "802151",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Behea",
            "Pincode": "802152",
            "City": "Behea",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Behea Bazar",
            "Pincode": "802152",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chaurasta Behea",
            "Pincode": "802154",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dalippur",
            "Pincode": "802155",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhamar",
            "Pincode": "802156",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gajgajganj",
            "Pincode": "802157",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jagdishpur Arrah",
            "Pincode": "802158",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jitaura",
            "Pincode": "802159",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Koilwar",
            "Pincode": "802160",
            "City": "Koilwar",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narhi Chandi",
            "Pincode": "802161",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nawadahben",
            "Pincode": "802162",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naya Mohammadpur",
            "Pincode": "802163",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sandesh",
            "Pincode": "802164",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sandesh",
            "Pincode": "802164",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahpur Patti",
            "Pincode": "802165",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Umraoganj",
            "Pincode": "802166",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaighat",
            "Pincode": "802169",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaighat",
            "Pincode": "802169",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarenja",
            "Pincode": "802171",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Babura",
            "Pincode": "802172",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jalpura",
            "Pincode": "802173",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamira",
            "Pincode": "802174",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhojpur",
            "Pincode": "802178",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tar",
            "Pincode": "802182",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaudarh Rudranagar",
            "Pincode": "802183",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Agion",
            "Pincode": "802201",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Agion Bazar",
            "Pincode": "802202",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garhani",
            "Pincode": "802203",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garhani",
            "Pincode": "802203",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hasan Bazar",
            "Pincode": "802204",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karath",
            "Pincode": "802205",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kasap",
            "Pincode": "802206",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahar",
            "Pincode": "802208",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahar",
            "Pincode": "802208",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tarari",
            "Pincode": "802209",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tarari",
            "Pincode": "802209",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Udwantnagar",
            "Pincode": "802210",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Banbhnaul",
            "Pincode": "802211",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bikramganj",
            "Pincode": "802212",
            "City": "Bikramganj",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tenduni Chowk",
            "Pincode": "802212",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dinara",
            "Pincode": "802213",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dinara",
            "Pincode": "802213",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garh Nokha",
            "Pincode": "802215",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Koath",
            "Pincode": "802216",
            "City": "Koath",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Meari Bazar",
            "Pincode": "802217",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Natwar",
            "Pincode": "802218",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "802219",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "802219",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sanjhauli",
            "Pincode": "802220",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Surajpura",
            "Pincode": "802221",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khutahan",
            "Pincode": "802222",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Charpokhri",
            "Pincode": "802223",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chhatauna",
            "Pincode": "802225",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dawath",
            "Pincode": "802226",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dawath",
            "Pincode": "802226",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tarar",
            "Pincode": "802230",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhojpur",
            "Pincode": "802231",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barkagaon",
            "Pincode": "802237",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Arrah",
            "Pincode": "802301",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Arrah Chowk",
            "Pincode": "802301",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Arrah Kutchery",
            "Pincode": "802301",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hd Jain College",
            "Pincode": "802301",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Maharaja College",
            "Pincode": "802301",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Shahabad Dist Bd",
            "Pincode": "802301",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sheoganj",
            "Pincode": "802301",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barhara",
            "Pincode": "802311",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barhara",
            "Pincode": "802311",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandwa",
            "Pincode": "802312",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gunri",
            "Pincode": "802313",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kayamnagar",
            "Pincode": "802314",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lauhar Farna",
            "Pincode": "802315",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sinha",
            "Pincode": "802316",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ganghar",
            "Pincode": "802317",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saraiya",
            "Pincode": "802318",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saraiya",
            "Pincode": "802318",
            "City": "Arrah",
            "District": "Bhojpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Alinagar",
            "Pincode": "803101",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Alinagar",
            "Pincode": "803101",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amber",
            "Pincode": "803101",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Biharsharif",
            "Pincode": "803101",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahalpar",
            "Pincode": "803101",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nalanda College",
            "Pincode": "803101",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Asthawan",
            "Pincode": "803107",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandi",
            "Pincode": "803108",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandi",
            "Pincode": "803108",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Giriak",
            "Pincode": "803109",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Harnaut",
            "Pincode": "803110",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nalanda R S",
            "Pincode": "803111",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Noorsarai",
            "Pincode": "803113",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pawapuri",
            "Pincode": "803115",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajgir",
            "Pincode": "803116",
            "City": "Rajgir",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajgir Kund",
            "Pincode": "803116",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Silao",
            "Pincode": "803117",
            "City": "Silao",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ashanagar",
            "Pincode": "803118",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Moghalkuan",
            "Pincode": "803118",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sohsarai",
            "Pincode": "803118",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rahui",
            "Pincode": "803119",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rahui",
            "Pincode": "803119",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Asta",
            "Pincode": "803120",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Veerayatan",
            "Pincode": "803124",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tetrawan",
            "Pincode": "803129",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tungi",
            "Pincode": "803130",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rukhai",
            "Pincode": "803131",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Fatwa",
            "Pincode": "803201",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khusrupur",
            "Pincode": "803202",
            "City": "Khusrupur",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Alawalpur",
            "Pincode": "803203",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Telmar",
            "Pincode": "803204",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baikathpur",
            "Pincode": "803205",
            "City": "Sheikhpura",
            "District": "Sheikhpura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patna",
            "Pincode": "803206",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Athmalgola",
            "Pincode": "803211",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Athmalgola",
            "Pincode": "803211",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bakhtiarpur",
            "Pincode": "803212",
            "City": "Bakhtiarpur",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bakhtiarpur",
            "Pincode": "803212",
            "City": "Bakhtiarpur",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barh",
            "Pincode": "803213",
            "City": "Barh",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barh College",
            "Pincode": "803213",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barh Court",
            "Pincode": "803213",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barh R S",
            "Pincode": "803214",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pandarak",
            "Pincode": "803221",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "More",
            "Pincode": "803232",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hathidah",
            "Pincode": "803301",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mokameh Chowk",
            "Pincode": "803302",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mokamesh",
            "Pincode": "803302",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mokameh Ghat",
            "Pincode": "803303",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Samyagarh",
            "Pincode": "803306",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhadaur",
            "Pincode": "803307",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Arwal",
            "Pincode": "804401",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baidrabad",
            "Pincode": "804402",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belaganj",
            "Pincode": "804403",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belaganj",
            "Pincode": "804403",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chakan",
            "Pincode": "804404",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dharaut",
            "Pincode": "804405",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ghosi",
            "Pincode": "804406",
            "City": "Hilsa",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hulashganj",
            "Pincode": "804407",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jahanabad",
            "Pincode": "804408",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jahanabad Kutchery",
            "Pincode": "804408",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jahanabad R S",
            "Pincode": "804417",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kako",
            "Pincode": "804418",
            "City": "Afzalpur",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kako",
            "Pincode": "804418",
            "City": "Jhanjharpur",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karpi",
            "Pincode": "804419",
            "City": "Abgila",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karpi",
            "Pincode": "804419",
            "City": "Karpi",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kazisarai",
            "Pincode": "804420",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kurtha",
            "Pincode": "804421",
            "City": "Ahmadpur Harna",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kurtha",
            "Pincode": "804421",
            "City": "Hilsa",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Makhdumpur",
            "Pincode": "804422",
            "City": "Makhdumpur",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Makhdumpur",
            "Pincode": "804422",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naglakinjar",
            "Pincode": "804423",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Paibigha",
            "Pincode": "804424",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sakurabad",
            "Pincode": "804425",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Shankarpur Imamganj",
            "Pincode": "804426",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tehta",
            "Pincode": "804427",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Usri",
            "Pincode": "804428",
            "City": "Baikunthpur",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nehalpur",
            "Pincode": "804429",
            "City": "Bahadurpur",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Koil Bhupat",
            "Pincode": "804430",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nowan",
            "Pincode": "804431",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bandhuganj",
            "Pincode": "804432",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pandooi",
            "Pincode": "804433",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lakhawar",
            "Pincode": "804434",
            "City": "Ghoshi",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Keyal",
            "Pincode": "804435",
            "City": "Jahanabad",
            "District": "Jahanabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hazaratsian",
            "Pincode": "804451",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Masaurhi",
            "Pincode": "804452",
            "City": "Masaurhi",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Punpun",
            "Pincode": "804453",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mithanchak",
            "Pincode": "804457",
            "City": "Patna",
            "District": "Patna",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhamaul",
            "Pincode": "805101",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gobindpur",
            "Pincode": "805102",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hasua",
            "Pincode": "805103",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kadirganj",
            "Pincode": "805104",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kawakol",
            "Pincode": "805106",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kosi",
            "Pincode": "805107",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kosi College",
            "Pincode": "805107",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lalbigha",
            "Pincode": "805108",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nardiganj",
            "Pincode": "805109",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nardiganj",
            "Pincode": "805109",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nawadah",
            "Pincode": "805110",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nawadah Kutchery",
            "Pincode": "805110",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Par Nawadah",
            "Pincode": "805110",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nemdarganj",
            "Pincode": "805121",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nurhat",
            "Pincode": "805122",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Orhanpur",
            "Pincode": "805123",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pakribarwan",
            "Pincode": "805124",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajauli",
            "Pincode": "805125",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajauli",
            "Pincode": "805125",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajhat",
            "Pincode": "805126",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sirdalla",
            "Pincode": "805127",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tarwan",
            "Pincode": "805128",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nawada",
            "Pincode": "805129",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Warisaliganj",
            "Pincode": "805130",
            "City": "Warisaliganj",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Orro",
            "Pincode": "805131",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Wazirganj",
            "Pincode": "805131",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Satgawan",
            "Pincode": "805132",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Satgawan",
            "Pincode": "805132",
            "City": "Kodarma",
            "District": "Kodarma",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tetar",
            "Pincode": "805134",
            "City": "Nawada",
            "District": "Nawada",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ayer",
            "Pincode": "805135",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jethian",
            "Pincode": "805136",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manjhway",
            "Pincode": "805137",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katauna",
            "Pincode": "805138",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sambay",
            "Pincode": "805139",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bansgopal",
            "Pincode": "805140",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khalsa Dhibri",
            "Pincode": "805141",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Marui",
            "Pincode": "805141",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Roh",
            "Pincode": "805143",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Roh",
            "Pincode": "805143",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kahuara",
            "Pincode": "805144",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarh Manjhiawan",
            "Pincode": "805145",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barbigha College Roadd Barbi",
            "Pincode": "811101",
            "City": "Sheikhpura",
            "District": "Sheikhpura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mehus",
            "Pincode": "811102",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nimi",
            "Pincode": "811103",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarmera",
            "Pincode": "811104",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarmera",
            "Pincode": "811104",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sheikhpura",
            "Pincode": "811105",
            "City": "Sheikhpura",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sheikhpura",
            "Pincode": "811105",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sheikhpura Bazar",
            "Pincode": "811105",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sheikhpura R S",
            "Pincode": "811105",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Surajgarha",
            "Pincode": "811106",
            "City": "Lakhisarai",
            "District": "Lakhisarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sirari",
            "Pincode": "811107",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bind",
            "Pincode": "811108",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bind",
            "Pincode": "811108",
            "City": "Biharsharif",
            "District": "Nalanda",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hathiawan",
            "Pincode": "811109",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katari",
            "Pincode": "811110",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Teus",
            "Pincode": "811111",
            "City": "Sheikhpura",
            "District": "Sheikhpura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bellan Bazar",
            "Pincode": "811201",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lal Darwaza",
            "Pincode": "811201",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Monghry",
            "Pincode": "811201",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Monghry Town",
            "Pincode": "811201",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Monghyr College",
            "Pincode": "811201",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Monghyr Fort",
            "Pincode": "811201",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narain Das Rd",
            "Pincode": "811201",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purabsarai",
            "Pincode": "811201",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basdeopur",
            "Pincode": "811202",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bariarpur",
            "Pincode": "811211",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dharhara",
            "Pincode": "811212",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Havelikharagpur",
            "Pincode": "811213",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamalpur",
            "Pincode": "811214",
            "City": "Jamalpur",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamalpur",
            "Pincode": "811214",
            "City": "Jamalpur",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamalpur Sadar Bazar",
            "Pincode": "811214",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamalpur Workshop",
            "Pincode": "811214",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aliganj",
            "Pincode": "811301",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barahiya",
            "Pincode": "811302",
            "City": "Barahiya",
            "District": "Lakhisarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barahiya",
            "Pincode": "811302",
            "City": "Barahiya",
            "District": "Lakhisarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chakar",
            "Pincode": "811303",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chewara",
            "Pincode": "811304",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chewara",
            "Pincode": "811304",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gidhaur",
            "Pincode": "811305",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamui",
            "Pincode": "811307",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamui",
            "Pincode": "811307",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamui Court",
            "Pincode": "811307",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jhaha Bazar",
            "Pincode": "811308",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jhajha",
            "Pincode": "811308",
            "City": "Jhajha",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jhajha",
            "Pincode": "811308",
            "City": "Jhajha",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kajra",
            "Pincode": "811309",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kiul R S",
            "Pincode": "811310",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Balika Vidyapith",
            "Pincode": "811311",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chittaranjan Rd",
            "Pincode": "811311",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lakhisarai",
            "Pincode": "811311",
            "City": "Lakhisarai",
            "District": "Lakhisarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lakhisarai",
            "Pincode": "811311",
            "City": "Lakhisarai",
            "District": "Lakhisarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purani Bazar",
            "Pincode": "811311",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lakshmipur",
            "Pincode": "811312",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lakshmipur",
            "Pincode": "811312",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mallehpur",
            "Pincode": "811313",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sono",
            "Pincode": "811314",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sikandra",
            "Pincode": "811315",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sikandra",
            "Pincode": "811315",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Simultala",
            "Pincode": "811316",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khaira",
            "Pincode": "811317",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khaira",
            "Pincode": "811317",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Adampur",
            "Pincode": "812001",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhagalpur",
            "Pincode": "812001",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhagalpur Dist Bd",
            "Pincode": "812001",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhaglpur Central Jail",
            "Pincode": "812001",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Brahpura",
            "Pincode": "812001",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ishaquchak",
            "Pincode": "812001",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kharmanchak",
            "Pincode": "812001",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mayaganj",
            "Pincode": "812001",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tilkamanjhi",
            "Pincode": "812001",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhagalpur City",
            "Pincode": "812002",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sujaganj Bazar",
            "Pincode": "812002",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tatarpur",
            "Pincode": "812002",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barari",
            "Pincode": "812003",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barari",
            "Pincode": "812003",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Champanagar",
            "Pincode": "812004",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahibganj",
            "Pincode": "812004",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aliganj",
            "Pincode": "812005",
            "City": "Dighalbank",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mirjanhat",
            "Pincode": "812005",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nathnagar",
            "Pincode": "812006",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "T N B College",
            "Pincode": "812007",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amarpur",
            "Pincode": "813101",
            "City": "Amarpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amarpur",
            "Pincode": "813101",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Banka",
            "Pincode": "813102",
            "City": "Banka",
            "District": "Banka",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Banka",
            "Pincode": "813102",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barahat",
            "Pincode": "813103",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baunsi",
            "Pincode": "813104",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jagdishpur",
            "Pincode": "813105",
            "City": "Jagdishpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jagdishpur",
            "Pincode": "813105",
            "City": "Jagdishpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jagdishpur Bhagalpur",
            "Pincode": "813105",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katoria",
            "Pincode": "813106",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katoria",
            "Pincode": "813106",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raja Un",
            "Pincode": "813107",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Shahkund",
            "Pincode": "813108",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Punsia",
            "Pincode": "813109",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Panjwara",
            "Pincode": "813110",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khutaha",
            "Pincode": "813111",
            "City": "Barahiya",
            "District": "Lakhisarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baijani",
            "Pincode": "813112",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Habidpur",
            "Pincode": "813113",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Auria",
            "Pincode": "813114",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pathra",
            "Pincode": "813115",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kojhi",
            "Pincode": "813116",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bagduma",
            "Pincode": "813117",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kakwara",
            "Pincode": "813118",
            "City": "Banka",
            "District": "Banka",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhurna",
            "Pincode": "813119",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumramah",
            "Pincode": "813120",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kharhara",
            "Pincode": "813121",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Salempur",
            "Pincode": "813122",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Soniha Babhangama",
            "Pincode": "813123",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sobhanpur Katoria",
            "Pincode": "813124",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pawai",
            "Pincode": "813125",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bharkho",
            "Pincode": "813126",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Laxmipur Chiraiya",
            "Pincode": "813127",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dahua",
            "Pincode": "813128",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Semaria",
            "Pincode": "813129",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Asarganj",
            "Pincode": "813201",
            "City": "Asarganj",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belhar",
            "Pincode": "813202",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belhar",
            "Pincode": "813202",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Colgong",
            "Pincode": "813203",
            "City": "Colgong",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Colgong",
            "Pincode": "813203",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Controller Of Defence",
            "Pincode": "813203",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ekchari",
            "Pincode": "813204",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ghogha",
            "Pincode": "813205",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ishipur",
            "Pincode": "813206",
            "City": "Durgawati",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khesar",
            "Pincode": "813207",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pirpainti",
            "Pincode": "813209",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pirpainti",
            "Pincode": "813209",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhagalpur Eng College",
            "Pincode": "813210",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "S S College",
            "Pincode": "813210",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sabour",
            "Pincode": "813210",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sabour",
            "Pincode": "813210",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Shambhuganj",
            "Pincode": "813211",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sangrampur",
            "Pincode": "813212",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sangrampur",
            "Pincode": "813212",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Station Rd Sultanganj",
            "Pincode": "813213",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sultanganj",
            "Pincode": "813213",
            "City": "Sultanganj",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sultanganj",
            "Pincode": "813213",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tarapur",
            "Pincode": "813221",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tarapur",
            "Pincode": "813221",
            "City": "Munger",
            "District": "Munger",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mathurapur",
            "Pincode": "813222",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Akbar Nagar",
            "Pincode": "813223",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tarar",
            "Pincode": "813226",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tilakpur",
            "Pincode": "813228",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manikpur",
            "Pincode": "813229",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Maheshmunda",
            "Pincode": "813231",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Fatehpur",
            "Pincode": "813233",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dudhani",
            "Pincode": "814101",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumka",
            "Pincode": "814101",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purana Dumka",
            "Pincode": "814101",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "S P College",
            "Pincode": "814101",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Shivpahar",
            "Pincode": "814101",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tin Bazar",
            "Pincode": "814101",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumka Ho.",
            "Pincode": "814101",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dumka Ho.",
            "Pincode": "814101",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dumka Ho.",
            "Pincode": "814101",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dumka Ho.",
            "Pincode": "814101",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dumka Ho.",
            "Pincode": "814101",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dumka Ho.",
            "Pincode": "814101",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ramgarh",
            "Pincode": "814102",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kathikund",
            "Pincode": "814103",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Amrapara",
            "Pincode": "814111",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Amrapara",
            "Pincode": "814111",
            "City": "Pakaur",
            "District": "Pakaur",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Baidyanath Deoghar Ho.",
            "Pincode": "814112",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Baidyanath Deoghar Ho.",
            "Pincode": "814112",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Deoghar College",
            "Pincode": "814113",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Deo Sang Bompas Tower",
            "Pincode": "814114",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Satsang",
            "Pincode": "814116",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Talisman Bilasi",
            "Pincode": "814117",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Basukinath Dham",
            "Pincode": "814118",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kurwa",
            "Pincode": "814119",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ghorawal",
            "Pincode": "814120",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chandan",
            "Pincode": "814131",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Godda",
            "Pincode": "814133",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jarmundi",
            "Pincode": "814141",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jarmundi",
            "Pincode": "814141",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jasidih",
            "Pincode": "814142",
            "City": "Jasidih",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kunda",
            "Pincode": "814143",
            "City": "Chatra",
            "District": "Chatra",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Massanjore",
            "Pincode": "814144",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Nunihat",
            "Pincode": "814145",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Palojori",
            "Pincode": "814146",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Pathargama",
            "Pincode": "814147",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raghunathpur",
            "Pincode": "814148",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sarwan",
            "Pincode": "814150",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Saraiyahat",
            "Pincode": "814151",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rohini",
            "Pincode": "814152",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mahagama",
            "Pincode": "814154",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basantrai",
            "Pincode": "814155",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarauni Bazar",
            "Pincode": "814156",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Guhiajore",
            "Pincode": "814158",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jama",
            "Pincode": "814162",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Lalmatia Colleiry",
            "Pincode": "814165",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Fatehpur",
            "Pincode": "814166",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhandaridah",
            "Pincode": "815301",
            "City": "Grahwa",
            "District": "Grahwa",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Giridih Ho.",
            "Pincode": "815301",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Giridih Ho.",
            "Pincode": "815301",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Giridih Ho.",
            "Pincode": "815301",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Giridih Ho.",
            "Pincode": "815301",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Beniadih",
            "Pincode": "815311",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bengabad",
            "Pincode": "815312",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ganwan",
            "Pincode": "815313",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kharagdiha",
            "Pincode": "815314",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jamua",
            "Pincode": "815315",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mirzaganj",
            "Pincode": "815315",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Pachamba",
            "Pincode": "815316",
            "City": "Chatra",
            "District": "Chatra",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tisri",
            "Pincode": "815317",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jamtara",
            "Pincode": "815351",
            "City": "Jamtara",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Karmatand",
            "Pincode": "815352",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Madhupur",
            "Pincode": "815353",
            "City": "Madhupur",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mihijam",
            "Pincode": "815354",
            "City": "Mihijam",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Nala",
            "Pincode": "815355",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sarath",
            "Pincode": "815356",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Karogram",
            "Pincode": "815357",
            "City": "Deoghar",
            "District": "Deoghar",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kundhait",
            "Pincode": "815359",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Barharwa",
            "Pincode": "816101",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Barahait",
            "Pincode": "816102",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Benagaria",
            "Pincode": "816103",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hiranpur",
            "Pincode": "816104",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hiranpur",
            "Pincode": "816104",
            "City": "Pakaur",
            "District": "Pakaur",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kotalpakur",
            "Pincode": "816105",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Maheshpurraj",
            "Pincode": "816106",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Maheshpurraj",
            "Pincode": "816106",
            "City": "Pakaur",
            "District": "Pakaur",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Pakaur",
            "Pincode": "816107",
            "City": "Pakaur",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rajmahal",
            "Pincode": "816108",
            "City": "Rajmahal",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sahibganj",
            "Pincode": "816109",
            "City": "Sahibganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sakrigalighat",
            "Pincode": "816115",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tinpahar Rs",
            "Pincode": "816116",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Pakuria",
            "Pincode": "816117",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Pakuria",
            "Pincode": "816117",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Pathana",
            "Pincode": "816119",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Boria",
            "Pincode": "816120",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Littipara",
            "Pincode": "816121",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jhikarhatti",
            "Pincode": "816122",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Asanbani",
            "Pincode": "816123",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mohulpahari",
            "Pincode": "816124",
            "City": "Dumka",
            "District": "Dumka",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Haripur Barikadarjua",
            "Pincode": "816125",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Talijhari",
            "Pincode": "816129",
            "City": "Sahebganj",
            "District": "Sahebganj",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhabua",
            "Pincode": "821101",
            "City": "Bhabua",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhagwanpur",
            "Pincode": "821102",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chainpur",
            "Pincode": "821103",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chenari",
            "Pincode": "821104",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Durgawati",
            "Pincode": "821105",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hatta",
            "Pincode": "821106",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kudra",
            "Pincode": "821106",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kudra Bazar",
            "Pincode": "821106",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khargarh",
            "Pincode": "821107",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohania",
            "Pincode": "821109",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohania",
            "Pincode": "821109",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ramgarh",
            "Pincode": "821110",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ramgarh",
            "Pincode": "821110",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sheosagar",
            "Pincode": "821111",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Takia",
            "Pincode": "821113",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gandhi Path",
            "Pincode": "821115",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gorakshni Sasaram",
            "Pincode": "821115",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sasaram",
            "Pincode": "821115",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sasaram Bazar",
            "Pincode": "821115",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sasaram L Board",
            "Pincode": "821115",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Adhaura",
            "Pincode": "821116",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Adhaura",
            "Pincode": "821116",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basahi",
            "Pincode": "821117",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darigaon",
            "Pincode": "821118",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darouli",
            "Pincode": "821119",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chand",
            "Pincode": "821120",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chand",
            "Pincode": "821120",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amaon",
            "Pincode": "821121",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Telari",
            "Pincode": "821122",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raipur Chore",
            "Pincode": "821123",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Akhlaspur",
            "Pincode": "821124",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nauhatta",
            "Pincode": "821125",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nauhatta",
            "Pincode": "821125",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Akhouri Bazar",
            "Pincode": "821301",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amjhore",
            "Pincode": "821302",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Banjari",
            "Pincode": "821303",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baulia",
            "Pincode": "821304",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dalmianagar",
            "Pincode": "821305",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dehri R S",
            "Pincode": "821305",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darihat",
            "Pincode": "821306",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "B M P Camp",
            "Pincode": "821307",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dehri On",
            "Pincode": "821307",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Indrapuri",
            "Pincode": "821308",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kachwa",
            "Pincode": "821309",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Haiharganj",
            "Pincode": "821310",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nasriganj",
            "Pincode": "821310",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nasriganj",
            "Pincode": "821310",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rohtas",
            "Pincode": "821311",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rohtas",
            "Pincode": "821311",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tilouthu",
            "Pincode": "821312",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Danwar",
            "Pincode": "821313",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mangraon",
            "Pincode": "821314",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nahauna",
            "Pincode": "821315",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karwandia",
            "Pincode": "821316",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nauhatta",
            "Pincode": "821317",
            "City": "Sasara",
            "District": "Rohtas",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Daltonganj Ho.",
            "Pincode": "822101",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Daltonganj Ho.",
            "Pincode": "822101",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Daltonganj Ho.",
            "Pincode": "822101",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Daltonganj Ho.",
            "Pincode": "822101",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Daltonganj College",
            "Pincode": "822102",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rajchainpur",
            "Pincode": "822110",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Barwadih",
            "Pincode": "822111",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhawnathpur",
            "Pincode": "822112",
            "City": "Grahwa",
            "District": "Grahwa",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chhatarpur",
            "Pincode": "822113",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Garhwa",
            "Pincode": "822114",
            "City": "Garhwa",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hyder Nagar",
            "Pincode": "822115",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Japla",
            "Pincode": "822116",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Japla Cement Factory",
            "Pincode": "822116",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Lestinganj",
            "Pincode": "822118",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mahuadand",
            "Pincode": "822119",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mohammedganj",
            "Pincode": "822120",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Nagaruntari",
            "Pincode": "822121",
            "City": "Grahwa",
            "District": "Grahwa",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Panki",
            "Pincode": "822122",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Patan",
            "Pincode": "822123",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rahala",
            "Pincode": "822124",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rankaraj",
            "Pincode": "822125",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Satbarwa",
            "Pincode": "822126",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mandal",
            "Pincode": "822127",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ramna",
            "Pincode": "822128",
            "City": "Chatra",
            "District": "Chatra",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhawnathpur Township",
            "Pincode": "822129",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Palamu",
            "Pincode": "822131",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chinanki",
            "Pincode": "822133",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Manjhiaon",
            "Pincode": "822138",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rajhara",
            "Pincode": "822141",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Anugrahpuri Colony",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandauti",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandchaura",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chowk Gaya",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Civil Lines",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaya",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaya Distt Board",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaya Jail",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karimganj",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "New Godown",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Polytechnic",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purani Godown",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Vishnupad",
            "Pincode": "823001",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bairagi",
            "Pincode": "823002",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Delha",
            "Pincode": "823002",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaya R S",
            "Pincode": "823002",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Buniadganj",
            "Pincode": "823003",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Durga Asthan",
            "Pincode": "823003",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaya",
            "Pincode": "823004",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Asc Centre",
            "Pincode": "823005",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "824101",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "824101",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aurangabad Kutchery",
            "Pincode": "824101",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "824102",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aurangabad",
            "Pincode": "824102",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amba",
            "Pincode": "824111",
            "City": "Banka",
            "District": "Banka",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barun",
            "Pincode": "824112",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barun",
            "Pincode": "824112",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Daudnagar",
            "Pincode": "824113",
            "City": "Daudnagar",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Daudnagar",
            "Pincode": "824113",
            "City": "Daudnagar",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Fort Daudnagar",
            "Pincode": "824113",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Deohara",
            "Pincode": "824114",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sihari",
            "Pincode": "824115",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Guraru Mills",
            "Pincode": "824118",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Harihar Ganj",
            "Pincode": "824119",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Haspura",
            "Pincode": "824120",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Haspura",
            "Pincode": "824120",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamhore",
            "Pincode": "824121",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamira",
            "Pincode": "824121",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jakhim",
            "Pincode": "824122",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kutumba",
            "Pincode": "824123",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Obra",
            "Pincode": "824124",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Obra",
            "Pincode": "824124",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rafiganj",
            "Pincode": "824125",
            "City": "Rafiganj",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Anti",
            "Pincode": "824126",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kaler",
            "Pincode": "824127",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kaler",
            "Pincode": "824127",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kerki",
            "Pincode": "824128",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rukuldi Jhikatia",
            "Pincode": "824129",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dihra",
            "Pincode": "824130",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barachatti",
            "Pincode": "824201",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Deo",
            "Pincode": "824202",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Deo",
            "Pincode": "824202",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Goh",
            "Pincode": "824203",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Goh",
            "Pincode": "824203",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gurua",
            "Pincode": "824205",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gurua",
            "Pincode": "824205",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Imamganj",
            "Pincode": "824206",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Imamganj",
            "Pincode": "824206",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Konch",
            "Pincode": "824207",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Konch",
            "Pincode": "824207",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madanpur",
            "Pincode": "824208",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Paraiya",
            "Pincode": "824209",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Paraiya",
            "Pincode": "824209",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raniganj",
            "Pincode": "824210",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raniganj",
            "Pincode": "824210",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gola Bazar Sherghati",
            "Pincode": "824211",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sherghati",
            "Pincode": "824211",
            "City": "Sherghati",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amas",
            "Pincode": "824212",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amas",
            "Pincode": "824212",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Umga",
            "Pincode": "824213",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumaria",
            "Pincode": "824214",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumaria",
            "Pincode": "824214",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Araura",
            "Pincode": "824215",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ketaki",
            "Pincode": "824216",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bankey Bazar",
            "Pincode": "824217",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Berikheriawan",
            "Pincode": "824218",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bodh Gaya",
            "Pincode": "824231",
            "City": "Bodh Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Fatehpur",
            "Pincode": "824232",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khizersarai",
            "Pincode": "824233",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Magadh University",
            "Pincode": "824234",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mow",
            "Pincode": "824235",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tekari",
            "Pincode": "824236",
            "City": "Tekari",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Cherki",
            "Pincode": "824237",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lodhway",
            "Pincode": "824238",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarbahda",
            "Pincode": "824239",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nabinagar",
            "Pincode": "824301",
            "City": "Nabinagar",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nabinagar",
            "Pincode": "824301",
            "City": "Nabinagar",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tandwa",
            "Pincode": "824302",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nabinagar Rd",
            "Pincode": "824303",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chitarpur",
            "Pincode": "825101",
            "City": "Aurangabad",
            "District": "Aurangabad",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chitarpur",
            "Pincode": "825101",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhori",
            "Pincode": "825102",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Simaria",
            "Pincode": "825103",
            "City": "Gidhaur",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Simaria",
            "Pincode": "825103",
            "City": "Chatra",
            "District": "Chatra",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ishri Bazar",
            "Pincode": "825107",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Pirtand",
            "Pincode": "825108",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Barkatha",
            "Pincode": "825223",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hazaribagh Ho.",
            "Pincode": "825301",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hazaribagh Ho.",
            "Pincode": "825301",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hazaribagh Ho.",
            "Pincode": "825301",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hazaribagh Ho.",
            "Pincode": "825301",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hazaribagh Ho.",
            "Pincode": "825301",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hazaribagh Ho.",
            "Pincode": "825301",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Daroo",
            "Pincode": "825313",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ghatotand",
            "Pincode": "825314",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Konar Dam",
            "Pincode": "825315",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kuju",
            "Pincode": "825316",
            "City": "Kuju",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bsf Meerut",
            "Pincode": "825317",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Palaunjia",
            "Pincode": "825318",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Reformatory School",
            "Pincode": "825319",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Suriya",
            "Pincode": "825320",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tandwa",
            "Pincode": "825321",
            "City": "Chatra",
            "District": "Chatra",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jai Nagar",
            "Pincode": "825324",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kedla",
            "Pincode": "825325",
            "City": "Kedla",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jharpo",
            "Pincode": "825327",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Shikohabad",
            "Pincode": "825329",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Topa",
            "Pincode": "825330",
            "City": "Topa",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bagodar",
            "Pincode": "825332",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Pelawal",
            "Pincode": "825335",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Charhi",
            "Pincode": "825336",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chatra",
            "Pincode": "825401",
            "City": "Chatra",
            "District": "Chatra",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ichak",
            "Pincode": "825402",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jori",
            "Pincode": "825403",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Pratappur",
            "Pincode": "825404",
            "City": "Chatra",
            "District": "Chatra",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Barhi",
            "Pincode": "825405",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chauparan",
            "Pincode": "825406",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Domchanch",
            "Pincode": "825407",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Itkhori",
            "Pincode": "825408",
            "City": "Chatra",
            "District": "Chatra",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jhumri Tilaiya",
            "Pincode": "825409",
            "City": "Jhumri Tilaiya",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kodarama",
            "Pincode": "825410",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kodarama",
            "Pincode": "825410",
            "City": "Kodarma",
            "District": "Kodarma",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Padma",
            "Pincode": "825411",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rajdhanwar",
            "Pincode": "825412",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tilaiyadam",
            "Pincode": "825413",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Domchanch Bazar",
            "Pincode": "825418",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hunerganj",
            "Pincode": "825420",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chandwara",
            "Pincode": "825421",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhanbad Ho.",
            "Pincode": "826001",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhanbad Ho.",
            "Pincode": "826001",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhanbad Ho.",
            "Pincode": "826001",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhanbad Ho.",
            "Pincode": "826001",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhanbad Ho.",
            "Pincode": "826001",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhanbad Ho.",
            "Pincode": "826001",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhanbad Ho.",
            "Pincode": "826001",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhanbad Ho.",
            "Pincode": "826001",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jagjivan Nagar",
            "Pincode": "826003",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Indian School Of Mines",
            "Pincode": "826004",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bokaro Steel City Ho.",
            "Pincode": "827001",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Herla Sector Iii",
            "Pincode": "827003",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sector Iv Dhanbad",
            "Pincode": "827004",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sector Ix Dhanbad",
            "Pincode": "827009",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bokaro Steel City Rs",
            "Pincode": "827010",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bokaro Steel City So",
            "Pincode": "827011",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bokaro Steel City",
            "Pincode": "827012",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bokaro Steel City",
            "Pincode": "827012",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chas",
            "Pincode": "827013",
            "City": "Chas",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Balidih",
            "Pincode": "827014",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Baliapur",
            "Pincode": "828101",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bansjora",
            "Pincode": "828101",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gomoh",
            "Pincode": "828101",
            "City": "Gomoh",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhagabandh",
            "Pincode": "828102",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhelatand",
            "Pincode": "828103",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Acc Colony",
            "Pincode": "828104",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhuli",
            "Pincode": "828104",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhansar",
            "Pincode": "828106",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Domgarh",
            "Pincode": "828107",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Fuel Research Institute",
            "Pincode": "828108",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gobindpur",
            "Pincode": "828109",
            "City": "Gobindpur",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jealgora",
            "Pincode": "828110",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jharia",
            "Pincode": "828111",
            "City": "Jharia",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jharia",
            "Pincode": "828111",
            "City": "Jharia",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jharia",
            "Pincode": "828111",
            "City": "Jharia",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jamadoba",
            "Pincode": "828112",
            "City": "Jamadoba",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Katras Garh",
            "Pincode": "828113",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Katras Bazar",
            "Pincode": "828114",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Khasjeenagora",
            "Pincode": "828115",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kusunda",
            "Pincode": "828116",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kustone",
            "Pincode": "828117",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Patherdih",
            "Pincode": "828119",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Moti Nagar",
            "Pincode": "828120",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sijua",
            "Pincode": "828121",
            "City": "Sijua",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sindri",
            "Pincode": "828122",
            "City": "Sindri",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sindri Institute",
            "Pincode": "828123",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sonardih",
            "Pincode": "828125",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sudamadih",
            "Pincode": "828126",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sarai Dhela",
            "Pincode": "828127",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tundu",
            "Pincode": "828128",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Munidih",
            "Pincode": "828129",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Lodna",
            "Pincode": "828131",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhulan Barari",
            "Pincode": "828133",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chandankiari",
            "Pincode": "828134",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chasnala",
            "Pincode": "828135",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tundi",
            "Pincode": "828142",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tisra",
            "Pincode": "828144",
            "City": "Tisra",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chirkunda",
            "Pincode": "828202",
            "City": "Chirkunda",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kumardhubi",
            "Pincode": "828203",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Muhamma",
            "Pincode": "828204",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Nisachatti",
            "Pincode": "828205",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Pancher Dam",
            "Pincode": "828206",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Maithandam",
            "Pincode": "828207",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhaga",
            "Pincode": "828301",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhowra",
            "Pincode": "828302",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhojudih",
            "Pincode": "828303",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Malkera",
            "Pincode": "828304",
            "City": "Malkera",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mohuda",
            "Pincode": "828305",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Nawagarh",
            "Pincode": "828306",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Nudkhurkee",
            "Pincode": "828307",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhatdih",
            "Pincode": "828308",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Amlabad Colliery",
            "Pincode": "828311",
            "City": "Dhanbad",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Topchanchi",
            "Pincode": "828402",
            "City": "Topchanchi",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chandrapura",
            "Pincode": "828403",
            "City": "Chandrapura",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dugda Coal Washery",
            "Pincode": "828404",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mugma",
            "Pincode": "828504",
            "City": "Mugma",
            "District": "Dhanbad",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Argada",
            "Pincode": "829101",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Barkakhana",
            "Pincode": "829102",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Barkakhana Nt",
            "Pincode": "829103",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhadani Nagar",
            "Pincode": "829105",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhurkunda Bazar",
            "Pincode": "829106",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bokaro Thermal",
            "Pincode": "829107",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Giddi",
            "Pincode": "829108",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Giddi Colliery",
            "Pincode": "829109",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gola",
            "Pincode": "829110",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Indian Explosive Gomia",
            "Pincode": "829112",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jarangdih Colliery",
            "Pincode": "829113",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jaridih Bazar",
            "Pincode": "829114",
            "City": "Jaridih Bazar",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kasmar",
            "Pincode": "829115",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kathara",
            "Pincode": "829116",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Marar",
            "Pincode": "829117",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Patratu",
            "Pincode": "829118",
            "City": "Patratu",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Patratu Thermal Power",
            "Pincode": "829119",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Patratu Diesal Colony",
            "Pincode": "829120",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Peterbar",
            "Pincode": "829121",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ramgarh Cantt. Ho.",
            "Pincode": "829122",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ramgarh Cantt. Ho.",
            "Pincode": "829122",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Religarha",
            "Pincode": "829124",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sayal",
            "Pincode": "829125",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sounda Colliery",
            "Pincode": "829126",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sunday Bazar",
            "Pincode": "829127",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Swang Colliery",
            "Pincode": "829128",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tenughat Dam Project",
            "Pincode": "829129",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Punjab Regimental Centre",
            "Pincode": "829130",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sikh Regimental Centre",
            "Pincode": "829131",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "\"Sounda \"\"D\"\" Colliery\"",
            "Pincode": "829133",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sarubera",
            "Pincode": "829134",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhurkunda",
            "Pincode": "829135",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tantri",
            "Pincode": "829138",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Champi",
            "Pincode": "829141",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Balkudra",
            "Pincode": "829143",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Phusru Bazar",
            "Pincode": "829144",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sirka",
            "Pincode": "829145",
            "City": "Sirka",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhareet Nagar",
            "Pincode": "829146",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "T.T.P.S. Lalpani",
            "Pincode": "829149",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bachra",
            "Pincode": "829201",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Balunmath",
            "Pincode": "829202",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chandwa",
            "Pincode": "829203",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chipadohar",
            "Pincode": "829204",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Khalari",
            "Pincode": "829205",
            "City": "Chatra",
            "District": "Chatra",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Latehar",
            "Pincode": "829206",
            "City": "Latehar",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Latehar R.S.",
            "Pincode": "829207",
            "City": "Palamu",
            "District": "Palamu",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mecluskie Ganj",
            "Pincode": "829208",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ray",
            "Pincode": "829209",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dakra Colliery",
            "Pincode": "829210",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gomia",
            "Pincode": "829211",
            "City": "Giridih",
            "District": "Giridih",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Karma",
            "Pincode": "829317",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bistupur Bazar",
            "Pincode": "831001",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bistupur Gate",
            "Pincode": "831001",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jamshedpur",
            "Pincode": "831001",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jamshedpur Ho.",
            "Pincode": "831001",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jamshedpur Ho.",
            "Pincode": "831001",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jamshedpur Ho.",
            "Pincode": "831001",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jamshedpur Ho.",
            "Pincode": "831001",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jamshedpur Ho.",
            "Pincode": "831001",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sakchi Court",
            "Pincode": "831001",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tata Nagar",
            "Pincode": "831002",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tatanagar",
            "Pincode": "831002",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Cable Township",
            "Pincode": "831003",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Golmuri",
            "Pincode": "831003",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Golmuri",
            "Pincode": "831003",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Palaza Market",
            "Pincode": "831004",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Telco Works",
            "Pincode": "831004",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Telco Works",
            "Pincode": "831004",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Telco Works",
            "Pincode": "831004",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kadma",
            "Pincode": "831005",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kadma",
            "Pincode": "831005",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jugsalai",
            "Pincode": "831006",
            "City": "Jugsalai",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jugsalai",
            "Pincode": "831006",
            "City": "Jugsalai",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Burma Mines",
            "Pincode": "831007",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Burma Mines",
            "Pincode": "831007",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Burma Mines",
            "Pincode": "831007",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Foundry Works",
            "Pincode": "831007",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kalimati Market",
            "Pincode": "831007",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "N M Laboratory",
            "Pincode": "831007",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Indra Nagar",
            "Pincode": "831008",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Indra Nagar",
            "Pincode": "831008",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Agrico",
            "Pincode": "831009",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Agrico",
            "Pincode": "831009",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Telco G Ms Office",
            "Pincode": "831010",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Telco Gm S Office",
            "Pincode": "831010",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sonari",
            "Pincode": "831011",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sonari",
            "Pincode": "831011",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sonbarsa",
            "Pincode": "831011",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mango",
            "Pincode": "831012",
            "City": "Mango",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mango",
            "Pincode": "831012",
            "City": "Mango",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Adityapur",
            "Pincode": "831013",
            "City": "Adityapur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Adityapur",
            "Pincode": "831013",
            "City": "Adityapur",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "R I T Jamshedpur",
            "Pincode": "831014",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "R.G.F. Tahi",
            "Pincode": "831014",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "R.I.T. Jamshedpur",
            "Pincode": "831014",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gobindpur Housing Colony",
            "Pincode": "831015",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gobindpur Housing Colony",
            "Pincode": "831015",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rahragora",
            "Pincode": "831016",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rahragora",
            "Pincode": "831016",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Baridhi Colony",
            "Pincode": "831017",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Baridih Colony",
            "Pincode": "831017",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "M.G. College",
            "Pincode": "831018",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Baharagora",
            "Pincode": "832101",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Baharagora",
            "Pincode": "832101",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jaduguda Mines",
            "Pincode": "832101",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Daltonganj College",
            "Pincode": "832102",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jaduguda Mines",
            "Pincode": "832102",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Maubhandar",
            "Pincode": "832103",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Moubhandar",
            "Pincode": "832103",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mosabani Mines",
            "Pincode": "832104",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mosabani Mines",
            "Pincode": "832104",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Patamda",
            "Pincode": "832105",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Patamda",
            "Pincode": "832105",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rakha Copper Project",
            "Pincode": "832106",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rakha Copper Project",
            "Pincode": "832106",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sundernagar",
            "Pincode": "832107",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sundernagar",
            "Pincode": "832107",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gamharia",
            "Pincode": "832108",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gamharia",
            "Pincode": "832108",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Adityapur Industrial Area",
            "Pincode": "832109",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Adityapura Ind. Area",
            "Pincode": "832109",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Azad Nagar",
            "Pincode": "832110",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Azad Nagar",
            "Pincode": "832110",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dumuria",
            "Pincode": "832111",
            "City": "Jamshedpur",
            "District": "Purbi Singbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Singhbhum",
            "Pincode": "832112",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Rajnagar",
            "Pincode": "832113",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chakkulia",
            "Pincode": "832301",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhalbhum Garh",
            "Pincode": "832302",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ghatshila",
            "Pincode": "832303",
            "City": "Ghatshila",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mahulia",
            "Pincode": "832304",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chandil",
            "Pincode": "832401",
            "City": "Chandil",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kandra",
            "Pincode": "832402",
            "City": "Kandra",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tirukdih",
            "Pincode": "832403",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Amda",
            "Pincode": "833101",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chakradharpur",
            "Pincode": "833102",
            "City": "Chakradharpur",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chakradharpur",
            "Pincode": "833102",
            "City": "Chakradharpur",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Goilkera",
            "Pincode": "833103",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Manoharpur",
            "Pincode": "833104",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sonua",
            "Pincode": "833105",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chiria",
            "Pincode": "833106",
            "City": "Chiria",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chaibasa Ho.",
            "Pincode": "833201",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chaibasa Ho.",
            "Pincode": "833201",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chaibasa Ho.",
            "Pincode": "833201",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tata College Chaibasa",
            "Pincode": "833202",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jagannathpur",
            "Pincode": "833203",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Danguaposi",
            "Pincode": "833212",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gua",
            "Pincode": "833213",
            "City": "Gua",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hatgamharia",
            "Pincode": "833214",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Jhinkpani",
            "Pincode": "833215",
            "City": "Jhinkpani",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kharswagarh",
            "Pincode": "833216",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Noamundi",
            "Pincode": "833217",
            "City": "Noamundi",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Noamundi Bazar",
            "Pincode": "833218",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sarai Kela",
            "Pincode": "833219",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sini",
            "Pincode": "833220",
            "City": "Sini",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Barajamda",
            "Pincode": "833221",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kriburu Base Camp",
            "Pincode": "833222",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Meghahatuburu",
            "Pincode": "833233",
            "City": "Paschimi Singhbhum",
            "District": "Paschimi Singhbhum",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tapin",
            "Pincode": "833326",
            "City": "Hazaribagh",
            "District": "Hazaribagh",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Court",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Ho.",
            "Pincode": "834001",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Aerodrome",
            "Pincode": "834002",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hinoo Ho.",
            "Pincode": "834002",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hinoo Ho.",
            "Pincode": "834002",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hinoo Ho.",
            "Pincode": "834002",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hinoo Ho.",
            "Pincode": "834002",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hinoo Ho.",
            "Pincode": "834002",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hinoo Ho.",
            "Pincode": "834002",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hatia",
            "Pincode": "834003",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhurwa",
            "Pincode": "834004",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhurwa",
            "Pincode": "834004",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhurwa",
            "Pincode": "834004",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhurwa",
            "Pincode": "834004",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhurwa",
            "Pincode": "834004",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhurwa",
            "Pincode": "834004",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Dhurwa",
            "Pincode": "834004",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hehal",
            "Pincode": "834005",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Agri College",
            "Pincode": "834006",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kanke",
            "Pincode": "834006",
            "City": "Kanke",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Veterinary College",
            "Pincode": "834007",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Veternary College",
            "Pincode": "834007",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Medical College C",
            "Pincode": "834008",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi University",
            "Pincode": "834008",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi University",
            "Pincode": "834008",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi University",
            "Pincode": "834008",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Medical College",
            "Pincode": "834009",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ranchi Medical College",
            "Pincode": "834009",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Namkum",
            "Pincode": "834010",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Hatia Railway Colony",
            "Pincode": "834011",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Harmu Housing Colony",
            "Pincode": "834012",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chotamuri",
            "Pincode": "835101",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Silli",
            "Pincode": "835102",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Silli",
            "Pincode": "835102",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Silli",
            "Pincode": "835102",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Silli",
            "Pincode": "835102",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Silli",
            "Pincode": "835102",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tatisilwai",
            "Pincode": "835103",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bermo",
            "Pincode": "835104",
            "City": "Bermo",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Banmore",
            "Pincode": "835201",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bano",
            "Pincode": "835201",
            "City": "Bokaro",
            "District": "Bokaro",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bero",
            "Pincode": "835202",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bundu",
            "Pincode": "835204",
            "City": "Bundu",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Brambe",
            "Pincode": "835205",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chainpur",
            "Pincode": "835206",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chainpur",
            "Pincode": "835206",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gumla Ho.",
            "Pincode": "835207",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ghagra",
            "Pincode": "835208",
            "City": "Gaya",
            "District": "Gaya",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karra",
            "Pincode": "835209",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Karra",
            "Pincode": "835209",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Khunti",
            "Pincode": "835210",
            "City": "Khunti",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kolebira",
            "Pincode": "835211",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kurdeg",
            "Pincode": "835212",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kuru",
            "Pincode": "835213",
            "City": "Lohardaga",
            "District": "Lohardaga",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mandar",
            "Pincode": "835214",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Mesra",
            "Pincode": "835215",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Murhu",
            "Pincode": "835216",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Neoria Vikas Vidyalaya",
            "Pincode": "835217",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Netarhat",
            "Pincode": "835218",
            "City": "Lohardaga",
            "District": "Lohardaga",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Ormanjhi",
            "Pincode": "835219",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Palkot",
            "Pincode": "835220",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "R K Mission",
            "Pincode": "835221",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ratu",
            "Pincode": "835222",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Simdega",
            "Pincode": "835223",
            "City": "Simdega",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sisai",
            "Pincode": "835224",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Tamar",
            "Pincode": "835225",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Thethaitanagar",
            "Pincode": "835226",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Torpa",
            "Pincode": "835227",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Biru",
            "Pincode": "835228",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Basia",
            "Pincode": "835229",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Noadih",
            "Pincode": "835230",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Nawagarh",
            "Pincode": "835232",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Toto",
            "Pincode": "835233",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gobindpur Ranchi",
            "Pincode": "835234",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gobindpur",
            "Pincode": "835234",
            "City": "Gobindpur",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Gotra",
            "Pincode": "835235",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Irba",
            "Pincode": "835235",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sikidiri",
            "Pincode": "835236",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Irba",
            "Pincode": "835238",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Chanho",
            "Pincode": "835239",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Boreya",
            "Pincode": "835240",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Nagar",
            "Pincode": "835242",
            "City": "Gumla",
            "District": "Gumla",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Lapung",
            "Pincode": "835244",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Itki",
            "Pincode": "835301",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Lohardaga",
            "Pincode": "835302",
            "City": "Lohardaga",
            "District": "Lohardaga",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Piskangri",
            "Pincode": "835303",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Senha",
            "Pincode": "835304",
            "City": "Lohardaga",
            "District": "Lohardaga",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Senha",
            "Pincode": "835304",
            "City": "Lohardaga",
            "District": "Lohardaga",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Kisko",
            "Pincode": "835305",
            "City": "Lohardaga",
            "District": "Lohardaga",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhandra",
            "Pincode": "835306",
            "City": "Ranchi",
            "District": "Ranchi",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Bhandra",
            "Pincode": "835306",
            "City": "Lohardaga",
            "District": "Lohardaga",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Sonepur",
            "Pincode": "841101",
            "City": "Sonepur",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sonepur",
            "Pincode": "841101",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tarwa Mangarpal",
            "Pincode": "841105",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bareja",
            "Pincode": "841201",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basant",
            "Pincode": "841202",
            "City": "Sheikhpura",
            "District": "Sheikhpura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chainpur",
            "Pincode": "841203",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chainwa",
            "Pincode": "841204",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Daudpur",
            "Pincode": "841205",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dayalpur",
            "Pincode": "841206",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dighwara",
            "Pincode": "841207",
            "City": "Dighwara",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ekma",
            "Pincode": "841208",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ekma",
            "Pincode": "841208",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gangpur Siswan",
            "Pincode": "841210",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gultenganj",
            "Pincode": "841211",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jogia",
            "Pincode": "841212",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kopa Samhota",
            "Pincode": "841213",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kopa Bazar",
            "Pincode": "841214",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Maker",
            "Pincode": "841215",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naraon",
            "Pincode": "841216",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nayagaon",
            "Pincode": "841217",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Paiga",
            "Pincode": "841218",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parsa",
            "Pincode": "841219",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parsa",
            "Pincode": "841219",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parsagarh",
            "Pincode": "841220",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sitalpur",
            "Pincode": "841221",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sutihar",
            "Pincode": "841222",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohammadpur",
            "Pincode": "841223",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Panditpur",
            "Pincode": "841224",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pratappur",
            "Pincode": "841225",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Agrawaltoli",
            "Pincode": "841226",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chapra Rd Siwan",
            "Pincode": "841226",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Makhdamsarai",
            "Pincode": "841226",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Siwan",
            "Pincode": "841226",
            "City": "Siwan",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Siwan",
            "Pincode": "841226",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Siwan Chowk Bazar",
            "Pincode": "841226",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "St Rd Siwan",
            "Pincode": "841226",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Andar",
            "Pincode": "841231",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Andar",
            "Pincode": "841231",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barharia",
            "Pincode": "841232",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barharia",
            "Pincode": "841232",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Daronda",
            "Pincode": "841233",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darouli",
            "Pincode": "841234",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Done",
            "Pincode": "841235",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hasanpura",
            "Pincode": "841236",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hasanpura",
            "Pincode": "841236",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hussainganj",
            "Pincode": "841237",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Maharajganj",
            "Pincode": "841238",
            "City": "Maharajganj",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Maharajganj",
            "Pincode": "841238",
            "City": "Banka",
            "District": "Banka",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mairwa",
            "Pincode": "841239",
            "City": "Mairwa",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mairwa",
            "Pincode": "841239",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahual Mahal",
            "Pincode": "841240",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pachrukhi",
            "Pincode": "841241",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pachrukhi",
            "Pincode": "841241",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patarhi",
            "Pincode": "841242",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahpur",
            "Pincode": "841243",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Takipur",
            "Pincode": "841244",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Zeradei",
            "Pincode": "841245",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bakerganj",
            "Pincode": "841246",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darihara",
            "Pincode": "841247",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Haraji",
            "Pincode": "841248",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basti Jalal",
            "Pincode": "841249",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kotheya",
            "Pincode": "841250",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ami",
            "Pincode": "841251",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumari Buzrang",
            "Pincode": "841252",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Enaitpur",
            "Pincode": "841253",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jaintpur Bharwalia",
            "Pincode": "841254",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jalalpur Bishunpura",
            "Pincode": "841255",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Maney",
            "Pincode": "841256",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Abas Store",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhagwanbazar Distt Board",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chapra",
            "Pincode": "841301",
            "City": "Chapra",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chapra",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gandhi Chowk",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jagdam College",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katra",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katra",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lokmannagar",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mauna",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nabiganj",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajendra College",
            "Pincode": "841301",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garkha",
            "Pincode": "841311",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garkha",
            "Pincode": "841311",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garibtola",
            "Pincode": "841312",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manjhi",
            "Pincode": "841313",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manjhi",
            "Pincode": "841313",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Enai",
            "Pincode": "841314",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Revelganj",
            "Pincode": "841315",
            "City": "Revelganj",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naini",
            "Pincode": "841316",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Fakuli",
            "Pincode": "841317",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohammadpur",
            "Pincode": "841318",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sanraha",
            "Pincode": "841339",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amnour",
            "Pincode": "841401",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aphar",
            "Pincode": "841402",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baniapur",
            "Pincode": "841403",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baniapur",
            "Pincode": "841403",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bagaura",
            "Pincode": "841404",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barouli",
            "Pincode": "841405",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basantpur",
            "Pincode": "841405",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bishunpura",
            "Pincode": "841407",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhagwanpur",
            "Pincode": "841408",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dighwa Dubauli",
            "Pincode": "841409",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumarsan Bangra",
            "Pincode": "841410",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ichwapur",
            "Pincode": "841411",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Indian Explosive",
            "Pincode": "841411",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jalalpur Bazar",
            "Pincode": "841412",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamo Bazar",
            "Pincode": "841413",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khaira",
            "Pincode": "841414",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khodabagh",
            "Pincode": "841415",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kishanpura",
            "Pincode": "841416",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mashrakh",
            "Pincode": "841417",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Marhowrah",
            "Pincode": "841418",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mirjapur",
            "Pincode": "841419",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajapatti",
            "Pincode": "841420",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarharwa",
            "Pincode": "841421",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahajitpur",
            "Pincode": "841422",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sidhwalia",
            "Pincode": "841423",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sidhwalia",
            "Pincode": "841423",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Taraiya",
            "Pincode": "841424",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bathua Bazar",
            "Pincode": "841425",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhore",
            "Pincode": "841426",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garh Manjha",
            "Pincode": "841427",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gopalganj",
            "Pincode": "841428",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gopalganj",
            "Pincode": "841428",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gopalganj College",
            "Pincode": "841428",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chappia",
            "Pincode": "841429",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gawandri",
            "Pincode": "841430",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pachraur",
            "Pincode": "841431",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jhakhra",
            "Pincode": "841432",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rasauli",
            "Pincode": "841433",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Goriakothi",
            "Pincode": "841434",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Guthni",
            "Pincode": "841435",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hathwa",
            "Pincode": "841436",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kateya",
            "Pincode": "841437",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mirganj",
            "Pincode": "841438",
            "City": "Mirganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mustafabad",
            "Pincode": "841439",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Thawe",
            "Pincode": "841440",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Thawe",
            "Pincode": "841440",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nagra",
            "Pincode": "841442",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nagra",
            "Pincode": "841442",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaura",
            "Pincode": "841443",
            "City": "Saran",
            "District": "Saran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kuchaikot",
            "Pincode": "841501",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khujwa",
            "Pincode": "841502",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nechua Jalalpur",
            "Pincode": "841503",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raghunathpur",
            "Pincode": "841504",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sasamusa",
            "Pincode": "841505",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tarwara",
            "Pincode": "841506",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mora",
            "Pincode": "841507",
            "City": "Siwan",
            "District": "Siwan",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bijaipur",
            "Pincode": "841508",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bijaipur",
            "Pincode": "841508",
            "City": "Gopalganj",
            "District": "Gopalganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihar University",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chhata Bazar",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Collectorate",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Imalichatti",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kalyani",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "L S College",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Molighat",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Motijheel",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Muzaffarpur",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Muzaffarpur",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Muzaffarpur Court",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nayatola",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pakkisarai",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saraiyaganj",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sikanarpur",
            "Pincode": "842001",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amgola",
            "Pincode": "842002",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "B M P Vi",
            "Pincode": "842002",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kachchi Sarai",
            "Pincode": "842002",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kanhauli Azara",
            "Pincode": "842002",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "R D S College",
            "Pincode": "842002",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ramna",
            "Pincode": "842002",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Muzaffarpur Inst Of Tech",
            "Pincode": "842003",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Umanagar",
            "Pincode": "842004",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Muzaffarpur Inds Complex",
            "Pincode": "842005",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bakhra",
            "Pincode": "843101",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bariarpur",
            "Pincode": "843102",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bochaha",
            "Pincode": "843103",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bochaha",
            "Pincode": "843103",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandanpatti",
            "Pincode": "843104",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhuli",
            "Pincode": "843105",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gidha",
            "Pincode": "843106",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gayaspur",
            "Pincode": "843107",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kalwari",
            "Pincode": "843108",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kanti",
            "Pincode": "843109",
            "City": "Kanti",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kanti",
            "Pincode": "843109",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kumar Bajitpur",
            "Pincode": "843110",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Motipur",
            "Pincode": "843111",
            "City": "Motipur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Paro",
            "Pincode": "843112",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patahi",
            "Pincode": "843113",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patahi",
            "Pincode": "843113",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patepur",
            "Pincode": "843114",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patepur",
            "Pincode": "843114",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Piar",
            "Pincode": "843115",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "R K Ashram",
            "Pincode": "843116",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampurhari",
            "Pincode": "843117",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sherfuddinpur",
            "Pincode": "843118",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Silaut",
            "Pincode": "843119",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Deoria",
            "Pincode": "843120",
            "City": "Araria",
            "District": "Araria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhuli Agricultural College",
            "Pincode": "843121",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hardi",
            "Pincode": "843122",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jaintpur Est",
            "Pincode": "843123",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kathaiya",
            "Pincode": "843124",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kurnawl",
            "Pincode": "843125",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saraiya Factory",
            "Pincode": "843126",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Birhima Bazar",
            "Pincode": "843127",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Minapur",
            "Pincode": "843128",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Minapur",
            "Pincode": "843128",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narma",
            "Pincode": "843129",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kanti Thermal Power",
            "Pincode": "843130",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ahiyapur",
            "Pincode": "843131",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baruraj",
            "Pincode": "843132",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bharwari",
            "Pincode": "843133",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chhajam",
            "Pincode": "843134",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chapra Megh",
            "Pincode": "843135",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dubaha Buzrug",
            "Pincode": "843136",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dharfari",
            "Pincode": "843137",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ghosaut",
            "Pincode": "843138",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baghnagri",
            "Pincode": "843139",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamalbad",
            "Pincode": "843140",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jasauli",
            "Pincode": "843141",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jhapaha",
            "Pincode": "843142",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karja",
            "Pincode": "843143",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katesar",
            "Pincode": "843144",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kerma",
            "Pincode": "843145",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khabra",
            "Pincode": "843146",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahanth Maniari",
            "Pincode": "843147",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manika",
            "Pincode": "843148",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mirapur",
            "Pincode": "843149",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohammadpur Badal",
            "Pincode": "843150",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohammadpur Balmi",
            "Pincode": "843151",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Momain",
            "Pincode": "843152",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Morsandi",
            "Pincode": "843153",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mushahari Farm",
            "Pincode": "843154",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mustafaganj",
            "Pincode": "843155",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narairpur Panapur",
            "Pincode": "843156",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patsara",
            "Pincode": "843157",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Prahladpur",
            "Pincode": "843158",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampur Bishwanth",
            "Pincode": "843159",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sandha Jahangirpur",
            "Pincode": "843160",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Singar",
            "Pincode": "843161",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Singhaila",
            "Pincode": "843162",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sonkarsa Barkagaon",
            "Pincode": "843163",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tepri",
            "Pincode": "843164",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Turki Khararu",
            "Pincode": "843165",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Janki Asthan",
            "Pincode": "843301",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kota Bazar",
            "Pincode": "843301",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sitamarhi",
            "Pincode": "843301",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sitamarhi Court",
            "Pincode": "843302",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Athari",
            "Pincode": "843311",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aurai",
            "Pincode": "843312",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aurai",
            "Pincode": "843312",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bairagana",
            "Pincode": "843313",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bairagania Bazar",
            "Pincode": "843313",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bajpatti",
            "Pincode": "843314",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barharwa",
            "Pincode": "843315",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belsand",
            "Pincode": "843316",
            "City": "Belsand",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belsand",
            "Pincode": "843316",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhutahi",
            "Pincode": "843317",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Budhnagra Deorhi",
            "Pincode": "843318",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chorout",
            "Pincode": "843319",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Janakpur Road",
            "Pincode": "843320",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pupri Bazar",
            "Pincode": "843320",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katra",
            "Pincode": "843321",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katra",
            "Pincode": "843321",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Majhaulia Estate",
            "Pincode": "843322",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manik Chowk",
            "Pincode": "843323",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parihar",
            "Pincode": "843324",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parihar",
            "Pincode": "843324",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parsauni",
            "Pincode": "843325",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parsauni",
            "Pincode": "843325",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raipur",
            "Pincode": "843326",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Righa",
            "Pincode": "843327",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Runisaidpur",
            "Pincode": "843328",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sheohar",
            "Pincode": "843329",
            "City": "Sheohar",
            "District": "Sheohar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sonbarsa",
            "Pincode": "843330",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sonbarsa",
            "Pincode": "843330",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sursand",
            "Pincode": "843331",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Majorganj",
            "Pincode": "843332",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nanpur",
            "Pincode": "843333",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nanpur",
            "Pincode": "843333",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Piprahi",
            "Pincode": "843334",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhasarmachha",
            "Pincode": "843335",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garha",
            "Pincode": "843335",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Righa Colony",
            "Pincode": "843336",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amua",
            "Pincode": "843337",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basantpatti",
            "Pincode": "843338",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Babhangawa",
            "Pincode": "843339",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampur Ganguli",
            "Pincode": "843340",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rasalpur Gosain",
            "Pincode": "843341",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parshurampur",
            "Pincode": "843342",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barari Bihta",
            "Pincode": "843343",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhitha Dharampur",
            "Pincode": "843344",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rasalpur Balha",
            "Pincode": "843346",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naranga",
            "Pincode": "843347",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhuban Basaha",
            "Pincode": "843348",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Janipur",
            "Pincode": "843349",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohini Mandal",
            "Pincode": "843350",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Akhta",
            "Pincode": "843351",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bathnaha",
            "Pincode": "843352",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belamuchhpakauni",
            "Pincode": "843353",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhakurhar",
            "Pincode": "843354",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chakmahila",
            "Pincode": "843355",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhankaul",
            "Pincode": "843356",
            "City": "Sheikhpura",
            "District": "Sheikhpura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumri",
            "Pincode": "843357",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Phulkaha",
            "Pincode": "843358",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hirauta Dumma",
            "Pincode": "843359",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jajuar",
            "Pincode": "843360",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamua",
            "Pincode": "843361",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nayagaon",
            "Pincode": "843362",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pota Tajpur",
            "Pincode": "843363",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Punaura",
            "Pincode": "843364",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rewasi",
            "Pincode": "843365",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sirauli",
            "Pincode": "843366",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Srikhand Bhitha",
            "Pincode": "843367",
            "City": "Sitamarhi",
            "District": "Sitamarhi",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tariani Chapra",
            "Pincode": "843368",
            "City": "Sheohar",
            "District": "Sheohar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chauhatta",
            "Pincode": "844101",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hajipur",
            "Pincode": "844101",
            "City": "Hajipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hajipur",
            "Pincode": "844101",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hajipur Chowk",
            "Pincode": "844101",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Anirudh Belsar",
            "Pincode": "844111",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baghi",
            "Pincode": "844112",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Balukaram",
            "Pincode": "844113",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhagwanpur",
            "Pincode": "844114",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chaksikandar",
            "Pincode": "844115",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumri",
            "Pincode": "844116",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dharahara",
            "Pincode": "844117",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garaul",
            "Pincode": "844118",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ghataro",
            "Pincode": "844119",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kurhani",
            "Pincode": "844120",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kurhani",
            "Pincode": "844120",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lalganj",
            "Pincode": "844121",
            "City": "Lalganj",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lalganj",
            "Pincode": "844121",
            "City": "Lalganj",
            "District": "Buxar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahua",
            "Pincode": "844122",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahua",
            "Pincode": "844122",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parta Ptand",
            "Pincode": "844123",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajapakar",
            "Pincode": "844124",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarai",
            "Pincode": "844125",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Singhara",
            "Pincode": "844126",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Turki",
            "Pincode": "844127",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Vaishali",
            "Pincode": "844128",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahtha",
            "Pincode": "844129",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kiratpur Rajaram",
            "Pincode": "844130",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hansikewal",
            "Pincode": "844131",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bahilwara Gobind",
            "Pincode": "844132",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sain",
            "Pincode": "844133",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sondho",
            "Pincode": "844134",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Birana Lakhansen",
            "Pincode": "844135",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dighi Kalan",
            "Pincode": "844136",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhairopour Deorhi",
            "Pincode": "844137",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jaintipur",
            "Pincode": "844138",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mirjanagar",
            "Pincode": "844139",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampur Ratnakar",
            "Pincode": "844140",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tisiauta Dharampur",
            "Pincode": "844141",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basdeopur Chandel",
            "Pincode": "844501",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bidhupur R S",
            "Pincode": "844502",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bidhupur Bazar",
            "Pincode": "844503",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Desri",
            "Pincode": "844504",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jhandaba",
            "Pincode": "844505",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahnar",
            "Pincode": "844506",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahnar Rd R S",
            "Pincode": "844507",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raghopur",
            "Pincode": "844508",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raghopur",
            "Pincode": "844508",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahdei Buzrug",
            "Pincode": "844509",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bahuara",
            "Pincode": "844510",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baidalpur",
            "Pincode": "844510",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chamarhara Mamsai",
            "Pincode": "844511",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chechar",
            "Pincode": "844512",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dayalpurgarh",
            "Pincode": "844513",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhamaon",
            "Pincode": "844514",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hasanpur Gurda",
            "Pincode": "844515",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khilout",
            "Pincode": "844516",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kutubpur Saidpur",
            "Pincode": "844517",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lawapur Mahnar",
            "Pincode": "844518",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lawapur Narain",
            "Pincode": "844519",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhurapur",
            "Pincode": "844520",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mathura Sultan",
            "Pincode": "844521",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Salha",
            "Pincode": "844522",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sultanpur",
            "Pincode": "844532",
            "City": "Hazipur",
            "District": "Vaishali",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bagaha",
            "Pincode": "845101",
            "City": "Bagaha",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bagaha",
            "Pincode": "845101",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaunaha",
            "Pincode": "845102",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hari Nagar",
            "Pincode": "845103",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhubani",
            "Pincode": "845104",
            "City": "Madhubani",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhubani",
            "Pincode": "845104",
            "City": "Madhubani",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naraipur",
            "Pincode": "845105",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ramnagan",
            "Pincode": "845106",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Vaimikinagar",
            "Pincode": "845107",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bahera",
            "Pincode": "845108",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dain Marwa",
            "Pincode": "845109",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dumaria Bazar",
            "Pincode": "845110",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahuli",
            "Pincode": "845112",
            "City": "Sheikhpura",
            "District": "Sheikhpura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mathia Kathia",
            "Pincode": "845113",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Malkauni",
            "Pincode": "845114",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patilarh",
            "Pincode": "845115",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampurwa",
            "Pincode": "845116",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajwatia",
            "Pincode": "845117",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sidhaw",
            "Pincode": "845118",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tinpheria",
            "Pincode": "845119",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Telpur",
            "Pincode": "845120",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chiraiya",
            "Pincode": "845145",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Adapur",
            "Pincode": "845301",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chauradano",
            "Pincode": "845302",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ghorasahan",
            "Pincode": "845303",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chainpur",
            "Pincode": "845304",
            "City": "Adapur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chainpur",
            "Pincode": "845304",
            "City": "Amawan",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raxaul",
            "Pincode": "845305",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mainatar",
            "Pincode": "845306",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sikta",
            "Pincode": "845307",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sikta",
            "Pincode": "845307",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Haripur",
            "Pincode": "845308",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sikarpur",
            "Pincode": "845309",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Auraiya",
            "Pincode": "845310",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhelahi",
            "Pincode": "845311",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandanbara",
            "Pincode": "845312",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patni",
            "Pincode": "845312",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jokiari",
            "Pincode": "845313",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Noneya Dih",
            "Pincode": "845314",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Birnagar",
            "Pincode": "845363",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Agarwa",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chhatavni Chowk",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Henry Bazar",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Magharia",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Motihari",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Motihari",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Motihari Chowk",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Motihari City",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Motihari College",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Motihari Court",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Motihari Dist Board",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Teliapatti",
            "Pincode": "845401",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajepur Champaran",
            "Pincode": "845406",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Areraj",
            "Pincode": "845411",
            "City": "Areraj",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jogia",
            "Pincode": "845411",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barachakia",
            "Pincode": "845412",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bakarpur Jagat",
            "Pincode": "845413",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chaita",
            "Pincode": "845414",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Damodarpur",
            "Pincode": "845416",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dariapur",
            "Pincode": "845417",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dariapur",
            "Pincode": "845417",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhaka",
            "Pincode": "845418",
            "City": "Dhaka",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhaka",
            "Pincode": "845418",
            "City": "Banka",
            "District": "Banka",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gobindganj",
            "Pincode": "845419",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gulwara Madhuban",
            "Pincode": "845420",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Telgu",
            "Pincode": "845420",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hanuman Sugar Mills",
            "Pincode": "845421",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Harsidhi",
            "Pincode": "845422",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hussaini",
            "Pincode": "845423",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kesaria",
            "Pincode": "845424",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kesaria",
            "Pincode": "845424",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Malahi",
            "Pincode": "845425",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Malhipatti",
            "Pincode": "845425",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mehsi",
            "Pincode": "845426",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mehsi",
            "Pincode": "845426",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pachpakri",
            "Pincode": "845427",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pakridayal",
            "Pincode": "845428",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pipra Factory",
            "Pincode": "845429",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Phenhara",
            "Pincode": "845430",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Phenhara",
            "Pincode": "845430",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raghunathpur Bazar",
            "Pincode": "845431",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "845432",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajpur",
            "Pincode": "845432",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ramgarhwa",
            "Pincode": "845433",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ramgarhwa",
            "Pincode": "845433",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sangrampur",
            "Pincode": "845434",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sangrampur",
            "Pincode": "845434",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Semra",
            "Pincode": "845435",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tetaria Factory",
            "Pincode": "845436",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Turkaulia",
            "Pincode": "845437",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Turkaulia",
            "Pincode": "845437",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belbagh Bettiah",
            "Pincode": "845438",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bettiah",
            "Pincode": "845438",
            "City": "Bettiah",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bettiah City",
            "Pincode": "845438",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bettiah R S",
            "Pincode": "845438",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mina Bazar Bettiah",
            "Pincode": "845438",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nayatola Bettiah",
            "Pincode": "845438",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jaitpur Lankaria",
            "Pincode": "845440",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chanpatia",
            "Pincode": "845449",
            "City": "Chanpatia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chanpatia",
            "Pincode": "845449",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chanpatia Bazar",
            "Pincode": "845449",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chuhari",
            "Pincode": "845450",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Diwanjike Shikarpur",
            "Pincode": "845451",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jogapatti",
            "Pincode": "845452",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lauria",
            "Pincode": "845453",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Majhaulia R S",
            "Pincode": "845454",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narkatiaganj",
            "Pincode": "845455",
            "City": "Narkatiaganj",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sugauli",
            "Pincode": "845456",
            "City": "Sugauli",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sugauli",
            "Pincode": "845456",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patahi",
            "Pincode": "845457",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patahi",
            "Pincode": "845457",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manguraha",
            "Pincode": "845458",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jagdishpur Motihari",
            "Pincode": "845459",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bettiah Dih",
            "Pincode": "845460",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bagahi Ratanpura",
            "Pincode": "845461",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barwat Pasrain",
            "Pincode": "845462",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baswaria",
            "Pincode": "845463",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bishunpurwa",
            "Pincode": "845464",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barwat Sena",
            "Pincode": "845465",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bairia",
            "Pincode": "845466",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bairia",
            "Pincode": "845466",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chaumukha",
            "Pincode": "845467",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhumnagar",
            "Pincode": "845468",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Harpur Tola",
            "Pincode": "845469",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jhakhra",
            "Pincode": "845470",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kurwa Mathie",
            "Pincode": "845471",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mali",
            "Pincode": "845472",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nawalpur",
            "Pincode": "845473",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purania Gosain",
            "Pincode": "845474",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parsa",
            "Pincode": "845475",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parsa",
            "Pincode": "845475",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patijirwa",
            "Pincode": "845476",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampurwa Mahanwa",
            "Pincode": "845477",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sukulpakar",
            "Pincode": "845478",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sugaon",
            "Pincode": "845479",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sripur",
            "Pincode": "845480",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Turhapatti",
            "Pincode": "845481",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Victoria Mission",
            "Pincode": "845483",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amolwa",
            "Pincode": "845484",
            "City": "Betia",
            "District": "West Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ajagari",
            "Pincode": "845485",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barharwa Kala",
            "Pincode": "845486",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amodai",
            "Pincode": "845487",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bariarpur",
            "Pincode": "845488",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bela",
            "Pincode": "845489",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhuwan Chapra",
            "Pincode": "845490",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bokaney Kala",
            "Pincode": "845491",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chapra Bahas",
            "Pincode": "845492",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gavendra",
            "Pincode": "845494",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kalyanpur",
            "Pincode": "845495",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kalyanpur",
            "Pincode": "845495",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kaswa Mehsi",
            "Pincode": "845496",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khartari",
            "Pincode": "845497",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kuawan",
            "Pincode": "845498",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barmania",
            "Pincode": "845499",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chatia",
            "Pincode": "845501",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Koila Belwa",
            "Pincode": "845502",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Laukaria",
            "Pincode": "845503",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhuban Bediban",
            "Pincode": "845504",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhubani Ghat",
            "Pincode": "845505",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahuawan",
            "Pincode": "845506",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mirpur",
            "Pincode": "845507",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Noneya",
            "Pincode": "845508",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Palanwa",
            "Pincode": "845509",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parsauni Tapsi",
            "Pincode": "845511",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "845513",
            "City": "Ahirawan",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "845513",
            "City": "Akbarpur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rulani",
            "Pincode": "845514",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sagar",
            "Pincode": "845515",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Singhasani",
            "Pincode": "845516",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sirha",
            "Pincode": "845517",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Siswa",
            "Pincode": "845518",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sitapur",
            "Pincode": "845519",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Olha Madhubani",
            "Pincode": "845520",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarotar",
            "Pincode": "845521",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sirauna",
            "Pincode": "845522",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jihuli",
            "Pincode": "845523",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purendra",
            "Pincode": "845524",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chintamanpur",
            "Pincode": "845525",
            "City": "Motihari",
            "District": "Purba Champaran",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Banta South",
            "Pincode": "846001",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Imambari",
            "Pincode": "846001",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Laheriasarai",
            "Pincode": "846001",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Laheriasarai Court",
            "Pincode": "846001",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pustak Bhandar",
            "Pincode": "846001",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sinha Homoe Med College",
            "Pincode": "846002",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darbhanga Medical College",
            "Pincode": "846003",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Cm College",
            "Pincode": "846004",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darbhanga",
            "Pincode": "846004",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darbhanga",
            "Pincode": "846004",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darbhanga Bara Bazar",
            "Pincode": "846004",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darbhanga Chowk",
            "Pincode": "846004",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Darbhanga City",
            "Pincode": "846004",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kathalbari",
            "Pincode": "846004",
            "City": "Bahadurganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katki Bazar",
            "Pincode": "846004",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kds University",
            "Pincode": "846004",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kilaghat",
            "Pincode": "846004",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Quadirabad",
            "Pincode": "846004",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "P Training C Darbhanga",
            "Pincode": "846005",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Subhankarpur",
            "Pincode": "846006",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sara Mohanpur",
            "Pincode": "846007",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Anandpur",
            "Pincode": "847101",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basaith Chanpura",
            "Pincode": "847102",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Benipur",
            "Pincode": "847103",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Benipur",
            "Pincode": "847103",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bharwara",
            "Pincode": "847104",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baheri",
            "Pincode": "847105",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baheri",
            "Pincode": "847105",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kansi Simri",
            "Pincode": "847106",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Keotsa Baruary",
            "Pincode": "847107",
            "City": "Muzaffarpur",
            "District": "Muzaffarpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narahia",
            "Pincode": "847108",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tulapatganj",
            "Pincode": "847109",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kansi",
            "Pincode": "847110",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Korthu",
            "Pincode": "847111",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahinam",
            "Pincode": "847112",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bahadurpur",
            "Pincode": "847113",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bahadurpur",
            "Pincode": "847113",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manikauli",
            "Pincode": "847114",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Muria",
            "Pincode": "847115",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Panchobh",
            "Pincode": "847116",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patore",
            "Pincode": "847117",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pohaddi",
            "Pincode": "847118",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Singhwara",
            "Pincode": "847119",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Singhwara",
            "Pincode": "847119",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sirnia",
            "Pincode": "847120",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Keotirunway",
            "Pincode": "847121",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basauli",
            "Pincode": "847122",
            "City": "Buxar",
            "District": "Buxar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bisfi",
            "Pincode": "847123",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bisfi",
            "Pincode": "847123",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Noorchak",
            "Pincode": "847124",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ughra",
            "Pincode": "847125",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Massa",
            "Pincode": "847126",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bahera",
            "Pincode": "847201",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Biroul",
            "Pincode": "847203",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Habidih",
            "Pincode": "847204",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pokhram Buzrug",
            "Pincode": "847205",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gandhi Bazar",
            "Pincode": "847211",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhubani",
            "Pincode": "847211",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhubani",
            "Pincode": "847211",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhubani Barabazar",
            "Pincode": "847211",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhubani Court",
            "Pincode": "847211",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "R K College",
            "Pincode": "847211",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhowra",
            "Pincode": "847212",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mangrauni",
            "Pincode": "847213",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Arehat",
            "Pincode": "847222",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Benipatti",
            "Pincode": "847223",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Benipatti",
            "Pincode": "847223",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Babubarhi",
            "Pincode": "847224",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Haubagar Bazar",
            "Pincode": "847226",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jainagar",
            "Pincode": "847226",
            "City": "Jainagar",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jainagar (Madhubani)",
            "Pincode": "847226",
            "City": "Kodarma",
            "District": "Kodarma",
            "State": "Jharkhand"
        },
        {
            "PostOfficeName": "Khutana",
            "Pincode": "847227",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khajouli",
            "Pincode": "847228",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kaluahi",
            "Pincode": "847229",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kaluahi",
            "Pincode": "847229",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khirhar",
            "Pincode": "847230",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lohat",
            "Pincode": "847231",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ladania",
            "Pincode": "847232",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ladania",
            "Pincode": "847232",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nehru",
            "Pincode": "847233",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pandaul",
            "Pincode": "847234",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pandaul",
            "Pincode": "847234",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajnagar",
            "Pincode": "847235",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampatti",
            "Pincode": "847236",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ryam Factory",
            "Pincode": "847237",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rohika",
            "Pincode": "847238",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sakri",
            "Pincode": "847239",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Birpur",
            "Pincode": "847240",
            "City": "Birpur",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhaur",
            "Pincode": "847241",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Deodha",
            "Pincode": "847242",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dahaur",
            "Pincode": "847243",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dullipatti",
            "Pincode": "847244",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Harlakhi",
            "Pincode": "847245",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Harlakhi",
            "Pincode": "847245",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Haripur Dihtol",
            "Pincode": "847246",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kumarkhat",
            "Pincode": "847247",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kakrail",
            "Pincode": "847248",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kalikapur",
            "Pincode": "847249",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karahia Balha",
            "Pincode": "847250",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Maksida",
            "Pincode": "847251",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narar",
            "Pincode": "847252",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pariharpur",
            "Pincode": "847253",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patwara",
            "Pincode": "847254",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parwa",
            "Pincode": "847255",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raghopur Deorhi",
            "Pincode": "847256",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sidhapkala",
            "Pincode": "847257",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hayaghat Bilaspur",
            "Pincode": "847301",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jogiara",
            "Pincode": "847303",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kamtaul",
            "Pincode": "847304",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhwarpur",
            "Pincode": "847305",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pindaruch",
            "Pincode": "847306",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ratanpur",
            "Pincode": "847307",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saharghat",
            "Pincode": "847308",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ahiari",
            "Pincode": "847309",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hariharpur",
            "Pincode": "847310",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hathouri",
            "Pincode": "847311",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Muraitha",
            "Pincode": "847312",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rari",
            "Pincode": "847313",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Andhra",
            "Pincode": "847401",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ghoghardiha",
            "Pincode": "847402",
            "City": "Ghoghardiha",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jhanjharpur R S",
            "Pincode": "847403",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jhanjharpur",
            "Pincode": "847404",
            "City": "Jhanjharpur",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kurso Nadiami",
            "Pincode": "847405",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Laukahi",
            "Pincode": "847406",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Laukahi",
            "Pincode": "847406",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lohna Road",
            "Pincode": "847407",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhepur",
            "Pincode": "847408",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhepur",
            "Pincode": "847408",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Phulparas",
            "Pincode": "847409",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Phulparas",
            "Pincode": "847409",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tamuria",
            "Pincode": "847410",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Haripur",
            "Pincode": "847411",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naruar",
            "Pincode": "847412",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Deep",
            "Pincode": "847413",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jageshwar Asthan",
            "Pincode": "847414",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kachhua",
            "Pincode": "847415",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kachwi",
            "Pincode": "847416",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lakhnaur",
            "Pincode": "847417",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lakhnaur",
            "Pincode": "847417",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahrail",
            "Pincode": "847418",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parsa",
            "Pincode": "847419",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parsa",
            "Pincode": "847419",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rataul",
            "Pincode": "847420",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Laukahi",
            "Pincode": "847421",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Laukahi",
            "Pincode": "847421",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manigachi",
            "Pincode": "847422",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Putai",
            "Pincode": "847423",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarsopahi",
            "Pincode": "847424",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karmegh",
            "Pincode": "847425",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raje",
            "Pincode": "847426",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kanhauli Bazar",
            "Pincode": "847451",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nirmali",
            "Pincode": "847452",
            "City": "Nirmali",
            "District": "Saupal",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nirmali",
            "Pincode": "847452",
            "City": "Supaul",
            "District": "Saupal",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kashipur",
            "Pincode": "848101",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Magardahi",
            "Pincode": "848101",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Samastipur",
            "Pincode": "848101",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Samastipur",
            "Pincode": "848101",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Samastipur Bazar",
            "Pincode": "848101",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Samastipur R S",
            "Pincode": "848101",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nauranga",
            "Pincode": "848102",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lagunia Raghukanth",
            "Pincode": "848109",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Harpur Ailith",
            "Pincode": "848110",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Akhtiarpur",
            "Pincode": "848111",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Angarghat",
            "Pincode": "848112",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Birouli Rural Institute",
            "Pincode": "848113",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dalsingsarai",
            "Pincode": "848114",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dighra",
            "Pincode": "848115",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Banghara",
            "Pincode": "848116",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ilmasnagar",
            "Pincode": "848117",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belamegh",
            "Pincode": "848118",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chand Chaur",
            "Pincode": "848119",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chaknawada",
            "Pincode": "848120",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chakradharpur Bazar",
            "Pincode": "848120",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chakradharpur Colony",
            "Pincode": "848120",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Morwa",
            "Pincode": "848121",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Morwa",
            "Pincode": "848121",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhepur Dighra",
            "Pincode": "848122",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhepura",
            "Pincode": "848123",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gangapur",
            "Pincode": "848124",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pusa",
            "Pincode": "848125",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kamraon",
            "Pincode": "848126",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarairanjan",
            "Pincode": "848127",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Keota",
            "Pincode": "848128",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Shambhupatti",
            "Pincode": "848129",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tajpur",
            "Pincode": "848130",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tajpur",
            "Pincode": "848130",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Waini",
            "Pincode": "848131",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ujairpur",
            "Pincode": "848132",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Warisnagar",
            "Pincode": "848133",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Warisnagar",
            "Pincode": "848133",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jitwarpur",
            "Pincode": "848134",
            "City": "Araria",
            "District": "Araria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhagwatpur",
            "Pincode": "848135",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bathua Buzrug",
            "Pincode": "848136",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belari",
            "Pincode": "848137",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barbatta",
            "Pincode": "848138",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chaita",
            "Pincode": "848139",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gaopur",
            "Pincode": "848140",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Musapur",
            "Pincode": "848142",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pataili",
            "Pincode": "848144",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Panbasaria",
            "Pincode": "848145",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pagra",
            "Pincode": "848146",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampur Jalalpur",
            "Pincode": "848147",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rupouli",
            "Pincode": "848148",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Satanpur",
            "Pincode": "848149",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhagwanpur Desua",
            "Pincode": "848150",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ball Jainarain",
            "Pincode": "848151",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandauli",
            "Pincode": "848152",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chatauna",
            "Pincode": "848153",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Fatehpur Bela",
            "Pincode": "848154",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Harpur Rewari",
            "Pincode": "848155",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Harpur Pusa",
            "Pincode": "848156",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karian",
            "Pincode": "848157",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pitaunjia",
            "Pincode": "848158",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bishanpur Bathua",
            "Pincode": "848159",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lat Basepura",
            "Pincode": "848160",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kerari",
            "Pincode": "848161",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mehsi",
            "Pincode": "848162",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mehsi",
            "Pincode": "848162",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohammadpur Sakra",
            "Pincode": "848163",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Paroria",
            "Pincode": "848183",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bakhri Bazar",
            "Pincode": "848201",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Meghaul",
            "Pincode": "848202",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sakarpura",
            "Pincode": "848203",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garhpura",
            "Pincode": "848204",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garhpura",
            "Pincode": "848204",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hasanpur Sugar Mills",
            "Pincode": "848205",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kundal",
            "Pincode": "848206",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bithan",
            "Pincode": "848207",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bithan",
            "Pincode": "848207",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mangalgarh",
            "Pincode": "848208",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Singhia",
            "Pincode": "848209",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Singhia",
            "Pincode": "848209",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rusera",
            "Pincode": "848210",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rusera Thana",
            "Pincode": "848210",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narahan R S",
            "Pincode": "848211",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narhan",
            "Pincode": "848211",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kuseshwar Asthan",
            "Pincode": "848213",
            "City": "Darbhanga",
            "District": "Darbhanga",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khodawanpur",
            "Pincode": "848214",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhirha",
            "Pincode": "848216",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aura",
            "Pincode": "848217",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bharwari",
            "Pincode": "848218",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belsandi",
            "Pincode": "848219",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhuswar",
            "Pincode": "848220",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chakthat",
            "Pincode": "848221",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Choratabhaka",
            "Pincode": "848222",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Desri",
            "Pincode": "848223",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gajpatti",
            "Pincode": "848224",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lilhaul",
            "Pincode": "848225",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Meghauna",
            "Pincode": "848225",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahthi",
            "Pincode": "848226",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nayanagar",
            "Pincode": "848227",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pusaho",
            "Pincode": "848228",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sumbha Deorhi",
            "Pincode": "848229",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sankhmohan",
            "Pincode": "848230",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Surauli",
            "Pincode": "848231",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sohma",
            "Pincode": "848233",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ugan",
            "Pincode": "848234",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Wari",
            "Pincode": "848235",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Singhiaghat",
            "Pincode": "848236",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belsandi Tara",
            "Pincode": "848237",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bharpura",
            "Pincode": "848238",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jhakhra",
            "Pincode": "848239",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kishanpur",
            "Pincode": "848301",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kishanpur",
            "Pincode": "848301",
            "City": "Lakhisarai",
            "District": "Lakhisarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kalyanpur Chowk",
            "Pincode": "848302",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhobgama",
            "Pincode": "848303",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohiuddinagar",
            "Pincode": "848501",
            "City": "Mohiuddinagar",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohiuddinagar R S",
            "Pincode": "848502",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mow Bazidpur",
            "Pincode": "848503",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Patory",
            "Pincode": "848504",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purshottampur Halai",
            "Pincode": "848505",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baghra",
            "Pincode": "848506",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ahmadpur",
            "Pincode": "848507",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barhauna",
            "Pincode": "848508",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bajitpur",
            "Pincode": "848509",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bajitpur Karnail",
            "Pincode": "848510",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garh Sisai",
            "Pincode": "848511",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jorpura",
            "Pincode": "848512",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mow Dhaneshpur",
            "Pincode": "848513",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Raspur Patasia",
            "Pincode": "848514",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sultanpur West",
            "Pincode": "848515",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Simri",
            "Pincode": "848516",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarangpur",
            "Pincode": "848517",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahpur Undi",
            "Pincode": "848518",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Seora",
            "Pincode": "848519",
            "City": "Samastipur",
            "District": "Samastipur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Begusarai",
            "Pincode": "851101",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Begusarai Court",
            "Pincode": "851101",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "G D College Road",
            "Pincode": "851101",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Shriram Press",
            "Pincode": "851101",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gogri",
            "Pincode": "851102",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gogri",
            "Pincode": "851102",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bachwara",
            "Pincode": "851111",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barauni",
            "Pincode": "851112",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barauni",
            "Pincode": "851112",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barauni Deorhi",
            "Pincode": "851113",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barauni Oil Refinery",
            "Pincode": "851114",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barauni Urvaraknagar",
            "Pincode": "851115",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barauni Thermal Power Project",
            "Pincode": "851116",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Refinary Township",
            "Pincode": "851117",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baro",
            "Pincode": "851118",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mehdauli",
            "Pincode": "851119",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Neola",
            "Pincode": "851120",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rarhi",
            "Pincode": "851121",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tilrath",
            "Pincode": "851122",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garhara",
            "Pincode": "851126",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manjhor",
            "Pincode": "851127",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mansoorchak",
            "Pincode": "851128",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mirzapur Banduar",
            "Pincode": "851129",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naokothi",
            "Pincode": "851130",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naokothi",
            "Pincode": "851130",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajaura",
            "Pincode": "851131",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Siripur",
            "Pincode": "851132",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Teghra",
            "Pincode": "851133",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Teghra",
            "Pincode": "851133",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ulao",
            "Pincode": "851134",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihat",
            "Pincode": "851135",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandpura",
            "Pincode": "851136",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katarmala",
            "Pincode": "851137",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ramdiri",
            "Pincode": "851138",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Matihani",
            "Pincode": "851139",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Matihani",
            "Pincode": "851139",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chautham",
            "Pincode": "851201",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chautham",
            "Pincode": "851201",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jamalpur Gogri",
            "Pincode": "851203",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khagaria",
            "Pincode": "851204",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khagaria Bazar",
            "Pincode": "851204",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khagaria",
            "Pincode": "851205",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lakhimnia",
            "Pincode": "851211",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mohaddipur",
            "Pincode": "851212",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Maheshkhunt",
            "Pincode": "851213",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mansi",
            "Pincode": "851214",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mansi",
            "Pincode": "851214",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nayagaon",
            "Pincode": "851215",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parbatta",
            "Pincode": "851216",
            "City": "Araria",
            "District": "Araria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parbatta",
            "Pincode": "851216",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sahebpur Kamal",
            "Pincode": "851217",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Suhridnagar",
            "Pincode": "851218",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Balha",
            "Pincode": "851219",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sanha",
            "Pincode": "851219",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bari Ballia",
            "Pincode": "851220",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhadas",
            "Pincode": "851221",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jalkaura",
            "Pincode": "851222",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kulharia",
            "Pincode": "851223",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Marar",
            "Pincode": "851224",
            "City": "Begusarai",
            "District": "Begusarai",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Parihara",
            "Pincode": "851225",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pasraha",
            "Pincode": "851226",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pipra Latif",
            "Pincode": "851227",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rahimpur",
            "Pincode": "851228",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Behariganj",
            "Pincode": "852101",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhaptiahi Bazar",
            "Pincode": "852105",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chupraon",
            "Pincode": "852106",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhabauli",
            "Pincode": "852107",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gamharia",
            "Pincode": "852108",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gamharia",
            "Pincode": "852108",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ganpatganj",
            "Pincode": "852109",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garh Baruai",
            "Pincode": "852110",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jiaram Raghopur",
            "Pincode": "852111",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kumarkhand",
            "Pincode": "852112",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhepura",
            "Pincode": "852113",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhepura",
            "Pincode": "852113",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madhepura College",
            "Pincode": "852113",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Budhama",
            "Pincode": "852114",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Murliganj",
            "Pincode": "852122",
            "City": "Murliganj",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nauhatta",
            "Pincode": "852123",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nauhatta",
            "Pincode": "852123",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Panhgachia",
            "Pincode": "852124",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pratapganj",
            "Pincode": "852125",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Salkhua Bazar",
            "Pincode": "852126",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Simri Bakhtiarpur",
            "Pincode": "852127",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Singheshwar",
            "Pincode": "852128",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sonbarsa Raj",
            "Pincode": "852129",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sukhpur",
            "Pincode": "852130",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Supaul",
            "Pincode": "852131",
            "City": "Supaul",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Supaul",
            "Pincode": "852131",
            "City": "Supaul",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Supaul Bazar",
            "Pincode": "852131",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Surpatganj",
            "Pincode": "852137",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tharbitta",
            "Pincode": "852138",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tribeniganj",
            "Pincode": "852139",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jaraila",
            "Pincode": "852140",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Golma",
            "Pincode": "852141",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Israin",
            "Pincode": "852142",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhirkhi",
            "Pincode": "852143",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gamail",
            "Pincode": "852144",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Daharia",
            "Pincode": "852145",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarbela",
            "Pincode": "852146",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajni Babhangawa",
            "Pincode": "852147",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bina",
            "Pincode": "852148",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khamauti",
            "Pincode": "852149",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Lokaha",
            "Pincode": "852150",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belari",
            "Pincode": "852151",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tamaul Parsa",
            "Pincode": "852152",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jirwa",
            "Pincode": "852153",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Babhni Bhelwa",
            "Pincode": "852154",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gahumani",
            "Pincode": "852155",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Piprahi",
            "Pincode": "852156",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sukhasan",
            "Pincode": "852157",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Daparkha",
            "Pincode": "852158",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Thumha",
            "Pincode": "852159",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basbitti",
            "Pincode": "852160",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belari Milki",
            "Pincode": "852161",
            "City": "Khagaria",
            "District": "Khagaria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saharsa",
            "Pincode": "852201",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saharsa Bazar",
            "Pincode": "852201",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saharsa Collectorate",
            "Pincode": "852201",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saharsa Distt Bd",
            "Pincode": "852201",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saharsa Purani Bazar",
            "Pincode": "852201",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bangaon",
            "Pincode": "852212",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chausa",
            "Pincode": "852213",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jadia",
            "Pincode": "852214",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Karzan Bazar",
            "Pincode": "852215",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahisi",
            "Pincode": "852216",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mangwar",
            "Pincode": "852217",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pipra Bazar",
            "Pincode": "852218",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Shah Alamnagar",
            "Pincode": "852219",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Udakishanganj",
            "Pincode": "852220",
            "City": "Madhepura",
            "District": "Madhepura",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sour Bazar",
            "Pincode": "852221",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ganeshpur",
            "Pincode": "852233",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Hardi",
            "Pincode": "852235",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihpur",
            "Pincode": "853201",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bihpur",
            "Pincode": "853201",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kharik Bazar",
            "Pincode": "853202",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narayanpur",
            "Pincode": "853203",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narayanpur",
            "Pincode": "853203",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Naugachia",
            "Pincode": "853204",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Saidpur Tola Goriar",
            "Pincode": "853205",
            "City": "Bhagalpur",
            "District": "Bhagalpur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhawanipur",
            "Pincode": "853206",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhawanipur",
            "Pincode": "853206",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Panhgachia Bazar",
            "Pincode": "853207",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pratapnagar",
            "Pincode": "853208",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ayodhyaganj Bazar",
            "Pincode": "854101",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chopra Ram Nagar",
            "Pincode": "854102",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Daharia Mills",
            "Pincode": "854103",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Guru Bazar",
            "Pincode": "854104",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Durgapur",
            "Pincode": "854105",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katihar",
            "Pincode": "854105",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katihar",
            "Pincode": "854105",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katihar Barabazar",
            "Pincode": "854105",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katihar Colony",
            "Pincode": "854105",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katihar R S",
            "Pincode": "854105",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katihar Bmp Camp",
            "Pincode": "854106",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katihar Mills",
            "Pincode": "854107",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Korha",
            "Pincode": "854108",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Korha",
            "Pincode": "854108",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manihari",
            "Pincode": "854113",
            "City": "Manihari",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Manihari",
            "Pincode": "854113",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pothia",
            "Pincode": "854114",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pothia",
            "Pincode": "854114",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Semapur Factory",
            "Pincode": "854115",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mahadeopur",
            "Pincode": "854116",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Roshna",
            "Pincode": "854117",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Falka",
            "Pincode": "854118",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chandpur",
            "Pincode": "854119",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Goriar",
            "Pincode": "854120",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Musapur",
            "Pincode": "854121",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kantakosh",
            "Pincode": "854122",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amdabad",
            "Pincode": "854123",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pranpur",
            "Pincode": "854124",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pranpur",
            "Pincode": "854124",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhandartal",
            "Pincode": "854125",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sirnia",
            "Pincode": "854126",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dalan",
            "Pincode": "854127",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Banaili",
            "Pincode": "854201",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Banmankhi",
            "Pincode": "854202",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Banmankhi",
            "Pincode": "854202",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barhara Kothi",
            "Pincode": "854203",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rajdham",
            "Pincode": "854204",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhamdaha",
            "Pincode": "854205",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dhamdaha",
            "Pincode": "854205",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sarsi",
            "Pincode": "854206",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bishunpur",
            "Pincode": "854207",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bishunpur Deorhi",
            "Pincode": "854207",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ballia",
            "Pincode": "854208",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rupouli",
            "Pincode": "854209",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhatta Bazar",
            "Pincode": "854301",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purnea",
            "Pincode": "854301",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purnea Chowk",
            "Pincode": "854301",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purnea Court",
            "Pincode": "854301",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purnea Distt Bd",
            "Pincode": "854301",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purnea City",
            "Pincode": "854302",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Purnea Polytechnic",
            "Pincode": "854303",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khuskibagh",
            "Pincode": "854305",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Araria",
            "Pincode": "854311",
            "City": "Araria",
            "District": "Araria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Araria",
            "Pincode": "854311",
            "City": "Araria",
            "District": "Araria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Araria R S",
            "Pincode": "854312",
            "City": "Araria",
            "District": "Araria",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baisi",
            "Pincode": "854315",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Baisi",
            "Pincode": "854315",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bathnaha",
            "Pincode": "854316",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barsoighat",
            "Pincode": "854317",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Forbesganj",
            "Pincode": "854318",
            "City": "Forbesganj",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Station Rd Forbesganj",
            "Pincode": "854318",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amour",
            "Pincode": "854319",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amour",
            "Pincode": "854319",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Garh Banaili",
            "Pincode": "854325",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Gulabbagh",
            "Pincode": "854326",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jalalgarh",
            "Pincode": "854327",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jalalgarh",
            "Pincode": "854327",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jogbani",
            "Pincode": "854328",
            "City": "Jogbani",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jokihat",
            "Pincode": "854329",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Jokihat",
            "Pincode": "854329",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kasba",
            "Pincode": "854330",
            "City": "Kasba",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kasba",
            "Pincode": "854330",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kursa Kanta",
            "Pincode": "854331",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kuari",
            "Pincode": "854332",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madanpur Purnia",
            "Pincode": "854333",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Maryganj",
            "Pincode": "854334",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Narpalganj",
            "Pincode": "854335",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nawabganj",
            "Pincode": "854336",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nawada",
            "Pincode": "854336",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Nawada",
            "Pincode": "854336",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ranipatra",
            "Pincode": "854337",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhimnagar Barrage",
            "Pincode": "854338",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Balua Bazar",
            "Pincode": "854339",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Birpur",
            "Pincode": "854340",
            "City": "Birpur",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kursail",
            "Pincode": "854341",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Chakai Hat",
            "Pincode": "854342",
            "City": "Jamui",
            "District": "Jamui",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khagarah",
            "Pincode": "854343",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dholbazza",
            "Pincode": "854344",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khairkhan",
            "Pincode": "854345",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Aurahihinjua",
            "Pincode": "854346",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "854347",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampur",
            "Pincode": "854347",
            "City": "Kaimur",
            "District": "Kaimur",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Palsichakardaha",
            "Pincode": "854349",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Koskapur",
            "Pincode": "854350",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tamganj",
            "Pincode": "854351",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Majhua",
            "Pincode": "854352",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Haripurdak",
            "Pincode": "854353",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bhangahi",
            "Pincode": "854354",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rampur Kodarkati",
            "Pincode": "854355",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Mirzapur Kothi",
            "Pincode": "854356",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Amhara",
            "Pincode": "854357",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Madarghat",
            "Pincode": "854358",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sonapur Bazar",
            "Pincode": "854360",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Khawaspur",
            "Pincode": "854362",
            "City": "Banka",
            "District": "Banka",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Ganeshpur",
            "Pincode": "854364",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kajha",
            "Pincode": "854365",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kakan",
            "Pincode": "854366",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Belwa",
            "Pincode": "854367",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Rautahat",
            "Pincode": "854368",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basantpur",
            "Pincode": "854369",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basantpur",
            "Pincode": "854369",
            "City": "Saharsa",
            "District": "Saharsa",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bahadurganj",
            "Pincode": "855101",
            "City": "Bahadurganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Barsoi",
            "Pincode": "855102",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Durgaganj",
            "Pincode": "855105",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Galgalia",
            "Pincode": "855106",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kishanganj",
            "Pincode": "855107",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Kishanganj",
            "Pincode": "855107",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Salmari",
            "Pincode": "855113",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sonali",
            "Pincode": "855114",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Sontha",
            "Pincode": "855115",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Taiyabpur",
            "Pincode": "855117",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Terhagachi",
            "Pincode": "855119",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Dighal Bank",
            "Pincode": "855120",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Balarampur",
            "Pincode": "855121",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Azam Nagar",
            "Pincode": "855122",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Katihar",
            "Pincode": "855124",
            "City": "Katihar",
            "District": "Katihar",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Tulsia",
            "Pincode": "855126",
            "City": "Purnia",
            "District": "Purnia",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Pothia R S",
            "Pincode": "855128",
            "City": "Kishanganj",
            "District": "Kishanganj",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basopatti",
            "Pincode": "857225",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Basopatti",
            "Pincode": "857225",
            "City": "Madhubani",
            "District": "Madhubani",
            "State": "Bihar"
        },
        {
            "PostOfficeName": "Bilaspur",
            "Pincode": "95221",
            "City": "Bilaspur",
            "District": "Bilaspur",
            "State": "Himachal Pradesh"
        }
    ]